// This file was auto-generated. Do not hand edit.
angular.module('tmr').factory('RouteData', ['User', function (User) {
    let areaData = {
        "seqts": {
            "bus": {
                "routes": [
                    "19: Rocklea - PA Hospital StationLink",
                    "26: Upper Mt Gravatt - RBWH via Fortitude Valley",
                    "29: Woolloongabba - UQ Lakes Shuttle",
                    "30: Spring Hill Loop",
                    "40: City Loop (Clockwise)",
                    "50: City Loop (Anti-Clockwise)",
                    "60: West End - Teneriffe Ferry via City/Valley",
                    "61: Ashgrove Shops - Coorparoo via City",
                    "77: Eight Mile Plains - Chermside via CLEM7",
                    "100: Forest Lake/Inala - City",
                    "101: Forest Lake - Oxley station via Inala and Durack",
                    "102: Inala - Oxley",
                    "103: Centenary - Inala Plaza",
                    "104: Corinda High - PA Hospital",
                    "105: Indooroopilly - PA Hospital via Yeronga",
                    "106: Mt Ommaney - Indooroopilly via Corinda",
                    "107: Yeerongpilly - City",
                    "109: Acacia Ridge - City Rocket",
                    "110: Inala - City",
                    "112: Griffith Uni Mt Gravatt - PA Hospital",
                    "113: Mt Gravatt Central - City",
                    "114: Tarragindi - City",
                    "115: Griffith University - Sunnybank Hills",
                    "116: Upper Mt Gravatt - City",
                    "118: Forest Lake - City",
                    "119: QEII Hospital - City Rocket",
                    "120: Garden City - City via Tarragindi",
                    "121: Salisbury - City",
                    "122: Inala - Garden City",
                    "123: Griffith University - Garden City via Sunnybank",
                    "125: Garden City - City/Valley via Salisbury",
                    "126: Heathwood - Sunnybank Plaza",
                    "127: Indooroopilly - Fairfield",
                    "130: Parkinson - City",
                    "131: Parkinson - City via Hellawell Rd",
                    "132: Parkinson/Algester - Garden City",
                    "134: Griffith University - City Rocket",
                    "135: Parkinson - Griffith Uni busway Express",
                    "137: Sunnybank Hills - City Rocket",
                    "138: Algester - City",
                    "139: Sunnybank Hills - UQ Lakes",
                    "140: Browns Plains - City Express via Mains Road",
                    "141: Browns Plains - City Rocket",
                    "142: Browns Plains - City Bullet",
                    "150: Browns Plains - City Express via Runcorn",
                    "152: Stretton - Garden City",
                    "153: Drewvale - City Rocket",
                    "155: Eight Mile Plains - Griffith Uni via Sunnybank",
                    "156: Stretton - City Rocket",
                    "161: Wishart Outlook - Griffith University busway",
                    "162: Eight Mile Plains - City Rocket",
                    "169: Eight Mile Plains - UQ Lakes",
                    "171: Garden City - City Rocket via Newnham Road",
                    "172: Garden City - PA Hospital via Greenslopes",
                    "175: Garden City - City via Logan Rd",
                    "176: Garden City - City Rocket via Logan Road",
                    "177: Carindale - Griffith Uni Mt Gravatt",
                    "179: Garden City - UQ Express via Newnham Rd",
                    "180: Garden City - City Express via Mansfield",
                    "181: Carindale Heights - City Rocket",
                    "182: Garden City - Holland Park",
                    "183: Wishart - City Rocket via Mansfield",
                    "185: Garden City - City/Valley",
                    "186: Wishart - City Rocket",
                    "189: Holland Park - City Express",
                    "192: Yeronga - City via UQ Lakes and Highgate Hill",
                    "195: New Farm - City",
                    "196: Fairfield Gardens - Merthyr via City/Valley",
                    "197: City - South Brisbane Loop",
                    "198: Highgate Hill Hail 'n' Ride",
                    "199: West End - Teneriffe Ferry via City/Valley",
                    "200: Carindale Heights - City Express",
                    "201: Carindale Heights - City Rocket",
                    "202: Carindale - PA Hospital",
                    "203: Carindale - PA Hospital",
                    "204: Carindale - City/Valley",
                    "205: Carindale Heights - City Express",
                    "206: Carindale - City Rocket",
                    "208: Carina - City Rocket",
                    "209: Carindale - UQ Lakes",
                    "210: Cannon Hill - City/Valley",
                    "211: Cannon Hill - City Rocket",
                    "212: Carindale - City/Valley via Seven Hills",
                    "213: Cannon Hill - Carindale",
                    "214: Cannon Hill - City Express",
                    "215: Carindale - City Express via Tingalpa",
                    "216: Tingalpa - City Rocket",
                    "217: Carindale - City Rocket",
                    "220: Wynnum - City Express",
                    "221: Wynnum - City Rocket",
                    "222: Carindale - City Express via Eastern Busway",
                    "223: Wynnum Loop Clockwise",
                    "224: Wynnum Loop Anti-Clockwise",
                    "225: Wynnum - Carindale",
                    "227: Wynnum - City",
                    "228: Cannon Hill - City Rocket",
                    "230: Balmoral - City via Riding Road",
                    "231: Balmoral - City Express via Riding Road",
                    "232: Cannon Hill - City",
                    "234: Woolloongabba - City Loop",
                    "235: Balmoral - City/Valley via Thynne Road",
                    "236: Balmoral - City Express via Thynne Road",
                    "240: Capalaba - Wynnum",
                    "242: Wakerley - Carindale (Loop)",
                    "243: Capalaba - Brisbane City",
                    "250: Redland Bay - Carindale",
                    "251: Ormiston - Brisbane City",
                    "252: Capalaba - Cleveland via Alexandra Hills (Loop)",
                    "253: Capalaba - Thorneside",
                    "254: Capalaba - Wellington Point",
                    "255: Cleveland - Birkdale",
                    "261: Mackenzie - Brisbane City",
                    "262: Capalaba - Griffith University via Mackenzie",
                    "263: Capalaba - Sheldon (Avalon Rd)",
                    "264: Capalaba - Alexandra Hills via Maridale Park",
                    "265: Maridale Park - Brisbane City",
                    "266: Capalaba - Alexandra Hills (Loop)",
                    "267: Alexandra Hills - Brisbane City",
                    "270: Victoria Point Jetty - Carindale",
                    "271: Toondah Harbour - Redlands",
                    "272: Redland Bay - Redland Hospital via Thornlands",
                    "273: Cleveland - Brisbane City via Redland Bay Rd",
                    "274: Victoria Pt Jetty - Cleveland via Thornlands",
                    "275: Thornlands - Brisbane City via Finucane Rd",
                    "276: Victoria Point - Brisbane City",
                    "277: Victoria Point - Point Halloran (Loop)",
                    "279: Victoria Point Jetty - Brisbane City",
                    "280: Shoreline Ave Redland Bay - Griffith Uni",
                    "281: Shoreline Ave Redland Bay - Brisbane City",
                    "282: Victoria Pt - Logan Hyperdome",
                    "299: Rochedale - Brisbane City",
                    "300: Toombul - City via Hamilton",
                    "301: Toombul - City via Hendra",
                    "302: Pinkenba - City",
                    "303: Pinkenba - Doomben via Myrtletown",
                    "304: Northshore Hamilton Loop via Racecourse Rd",
                    "305: Hamilton - City",
                    "306: Nudgee/Toombul - City",
                    "307: Northgate East - Toombul Loop",
                    "308: Toombul - Chermside Loop",
                    "309: RBWH - City via Teneriffe",
                    "310: Brighton - City Express",
                    "311: Brighton - Sandgate (Community Bus 1)",
                    "312: Sandgate - Brighton (Community Bus 2)",
                    "313: Shorncliffe (Community Bus)",
                    "314: Sandgate - Deagon & Shorncliffe (Community Bus)",
                    "320: Chermside - City via Wavell Heights",
                    "321: Toombul - City via Kalinga",
                    "322: Chermside - City via Toombul",
                    "325: Boondall - City Express",
                    "326: Carseldine - Toombul via Sandgate, Geebung",
                    "327: Strathpine - Bracken Ridge & Toombul",
                    "329: Bracken Ridge - Carseldine via Lacey Road",
                    "330: Bracken Ridge - City Express",
                    "331: Bracken Ridge - City Rocket",
                    "332: Zillmere - City Rocket via Spring Hill",
                    "333: Chermside - Woolloongabba via City",
                    "334: Chermside - City via Kedron",
                    "335: Sandgate - City Express via Kirby Road",
                    "336: Chermside Clockwise Loop",
                    "337: Chermside Anti-Clockwise Loop",
                    "338: City - Chermside",
                    "340: Carseldine - Woolloongabba Express via City",
                    "341: Taigum - City Rocket",
                    "344: Carseldine - City Precincts Express",
                    "345: Aspley - City Express via Maundrell Terrace",
                    "346: Aspley - City",
                    "347: Stafford - City via Grange",
                    "348: Stafford - City via Gordon Park",
                    "349: Stafford - City Express",
                    "350: Aspley - City Express via Bridgeman Downs",
                    "351: Aspley - City Rocket via Bridgeman Downs",
                    "352: McDowall - City Express",
                    "353: Chermside - City via McDowall",
                    "354: Mitchelton - Chermside",
                    "357: Brendale - City Express",
                    "358: Strathpine - Chermside",
                    "359: Eatonvale - City Express via Albany Village",
                    "360: Brookside - City via Everton Park",
                    "361: Mitchelton - City",
                    "362: Ashgrove - Brookside",
                    "363: Herston - City",
                    "364: Herston - City",
                    "367: Great Western SC - Upper Kedron via Ferny Grove",
                    "369: Mitchelton - Toombul via Stafford",
                    "372: Ashgrove - City",
                    "373: Ashgrove - City via Ashgrove Avenue",
                    "375: Bardon - City",
                    "377: Ashgrove - City via Kennedy Terrace",
                    "378: Ashgrove - City via Arthur Terrace",
                    "379: Ashgrove - City",
                    "380: The Gap - City via Hilder Road",
                    "381: The Gap - City via Payne Road",
                    "382: The Gap - City Rocket via Settlement Road",
                    "383: The Gap - City Rocket via Payne Road",
                    "384: The Gap - City Precincts Rocket",
                    "385: The Gap - City Express",
                    "390: Mitchelton - City",
                    "396: Mitchelton - Arana Hills",
                    "397: Ferny Grove - Mitchelton",
                    "398: Mitchelton - Ferny Grove",
                    "399: Samford - Ferny Grove Station (Hail & Ride)",
                    "402: Toowong - University of Qld",
                    "411: University of Qld - City via Hawken Drive",
                    "412: University of Qld - City Express",
                    "414: Indooroopilly - University of Qld via Taringa",
                    "415: Indooroopilly - City via Taringa",
                    "416: Duke Street - City",
                    "417: Long Pocket - City",
                    "425: Chapel Hill - City Express",
                    "426: Kenmore - City Rocket via Chapel Hill",
                    "427: Chapel Hill - University of Qld Express",
                    "428: Chapel Hill - University of Qld",
                    "430: Fig Tree Pocket - City Express",
                    "431: Kenmore South - City Rocket",
                    "432: Kenmore - University of Qld Express",
                    "433: Kenmore South - City",
                    "435: Brookfield - City Express",
                    "443: Moggil - City Rocket",
                    "444: Moggill - City Express",
                    "445: Fig Tree Pocket - City",
                    "446: Kenmore - City Rocket",
                    "450: Riverhills - City Express via Mt Ommaney",
                    "451: Sinnamon Park - Darra Station",
                    "452: Riverhills West - Darra Station",
                    "453: Mt Ommaney - City Express",
                    "454: Riverhills - City Express",
                    "455: Riverhills - City Rocket",
                    "456: Mt Ommaney - City Rocket",
                    "460: Heathwood - City Express",
                    "463: Forest Lake Village - Goodna Station",
                    "467: Oxley Station - Mt Ommaney via Sinnamon Park",
                    "468: Oxley Station - Indooroopilly",
                    "470: Toowong - City",
                    "471: Mt Coot-tha Lookout - City",
                    "475: Rainworth - City",
                    "476: Rainworth - City",
                    "500: Riverlink Shopping Centre - Goodna Station",
                    "501: Springfield Central station - Bell Street",
                    "502: Bundamba - Riverlink via Blackstone",
                    "503: Bundamba - Riverlink via Eastern Heights",
                    "506: Riverlink Shopping Centre - Leichhardt & One Mile",
                    "509: Yamanto - Riverlink Shopping Centre",
                    "512: Brassall - Riverlink Shopping Centre",
                    "514: Tivoli - Booval Fair",
                    "515: Brassall - Yamanto & Willowbank",
                    "520: Goodna station - Eden's Crossing",
                    "522: Redbank station - Springfield Central station",
                    "523: Mountview shops - Springfield Central station",
                    "524: Redbank Plains - Goodna Station",
                    "525: Goodna Station - Redbank Square",
                    "526: Orion Springfield Central - Redbank Station",
                    "527: Orion - Goodna Station via Camira",
                    "528: Orion - Springfield Station via Springfield Lakes",
                    "529: Toogoolawah - Ipswich",
                    "531: Springfield - Yamanto via Ripley Valley",
                    "533: Spring Mountain Loop",
                    "534: Browns Plains - Orion Springfield Central",
                    "535: Flagstone - Browns Plains",
                    "539: Helidon - Rosewood",
                    "540: Beaudesert - Browns Plains",
                    "541: Greenbank - Browns Plains via Boronia Heights",
                    "542: Browns Plains - Park Ridge",
                    "543: Browns Plains - Heritage Park",
                    "545: Browns Plains - Griffiths University",
                    "546: Park Ridge - City via Greenbank & Griffith Uni",
                    "547: Browns Plains - Woodridge",
                    "550: Springwood - Browns Plains",
                    "551: Brisbane City - Crestmead",
                    "552: Kingston - Loganholme",
                    "553: Trinder Park - Beenleigh",
                    "554: Griffith Uni - Logan Central",
                    "555: Brisbane City - Loganholme",
                    "560: Browns Plains - Loganholme",
                    "561: Brisbane City - Crestmead",
                    "562: Loganholme - Beenleigh",
                    "563: Holmview Central - Loganholme",
                    "565: Loganholme - Windaroo",
                    "567: Beenleigh station - Holmview loop",
                    "569: Brisbane City - Loganholme",
                    "570: Loganholme - Cornubia (Loop)",
                    "572: Springwood - Loganholme",
                    "573: Brisbane City - Loganholme via Daisy Hill",
                    "574: Loganholme - Springwood",
                    "575: Brisbane City - Loganholme via Daisy Hill",
                    "576: Griffith Uni - Springwood",
                    "577: Brisbane City - Springwood via Rochedale South",
                    "578: Springwood - Griffith Uni",
                    "579: Brisbane City - Springwood via Rochedale South",
                    "580: Springwood - Meadowbrook",
                    "581: Brisbane City - Slacks Creek",
                    "587: Yarrabilba - Loganlea Station, Hospital and Tafe",
                    "590: Garden City - Toombul via Carindale",
                    "598: Great Circle Line Anti-Clockwise",
                    "599: Great Circle Line Clockwise",
                    "600: Caloundra - Maroochydore via Mooloolaba, Kawana",
                    "602: Caloundra - Maroochydore via Mountain Creek",
                    "603: Little Mountain - Caloundra",
                    "604: Caloundra - Bellvista Loop",
                    "605: Caloundra - Landsborough",
                    "606: Baringa - Caloundra",
                    "607: Caloundra - University via SCUH and Kawana",
                    "608: Caloundra - Nirimba",
                    "609: Pelican Waters - Caloundra",
                    "610: Nambour - Maroochydore via Kunda Park",
                    "611: Maroochydore - SCUH via Mooloolaba and Kawana",
                    "612: Nambour - Maroochydore via Bli Bli",
                    "613: Maroochydore - Alexandra Headland Loop",
                    "614: Kawana - Maroochydore via Mountain Creek",
                    "615: Maroochydore - Landsborough via University",
                    "616: Maroochydore - University via Alexandra Headland",
                    "617: Maroochydore - Sippy Downs via University",
                    "618: Sippy Downs - Kawana via University",
                    "619: Kawana - Maroochydore via Alexandra Headland",
                    "620: Noosa Heads - Maroochydore via Peregian Beach",
                    "622: Maroochydore - Noosa Junction via Airport, Coolum",
                    "626: Tewantin - Sunrise Beach via Noosa Heads",
                    "627: Tewantin - Sunshine Beach via Noosa Heads",
                    "628: Parklands - Noosa Junction via Noosa Civic",
                    "629: Tewantin - Noosa Junction via Noosa Civic",
                    "630: Noosa - Nambour via Eumundi",
                    "631: Noosa - Nambour via Cooroy and Eumundi",
                    "632: Noosa - Cooran via Cooroy and Pomona",
                    "636: Nambour - University via Buderim",
                    "637: Nambour local loop",
                    "638: Nambour - Palmwoods loop",
                    "640: Bribie Island - Caboolture station",
                    "641: Banksia Beach - Bongaree (Loop)",
                    "642: Bribie Island PnR - Bongaree via Bellara",
                    "643: Bribie Island - Caboolture via Sandstone Point",
                    "644: Sandstone Point - Bribie Island park 'n' ride",
                    "649: Caboolture Station - Nambour Station (Rail Bus)",
                    "651: Morayfield station - West Caboolture (Loop)",
                    "652: Caboolture Square - Beachmere (Loop)",
                    "653: Caboolture stn - Morayfield stn via Bellmere",
                    "654: Morayfield stn - Caboolture stn via Bellmere",
                    "655: Caboolture station - Hospital-TAFE-UniSC (Loop)",
                    "656: Morayfield station - Upper Caboolture (Loop)",
                    "657: Caboolture station - Caboolture North (Loop)",
                    "660: Caboolture Station - Redcliffe via Kippa-Ring",
                    "662: Moreton Downs - Rothwell Station",
                    "663: Narangba Local Service (Loop)",
                    "664: Burpengary Local Service (Loop)",
                    "665: Deception Bay - Rothwell Station",
                    "667: Morayfield Local Service (Loop)",
                    "668: Narangba Station - North Lakes",
                    "669: Strathpine - Warner via Lawnton",
                    "670: Strathpine - Warner via Warner Lakes",
                    "671: Strathpine - Warner",
                    "672: Strathpine - Warner Lakes",
                    "673: Strathpine - Joyner",
                    "674: Strathpine - Warner via Bells Pocket",
                    "676: North Lakes - Murrumba Downs via Kallangur",
                    "679: North Lakes - Murrumba Downs via Griffin",
                    "680: Redcliffe - Chermside via North Lakes and Petrie",
                    "681: North Lakes - Mango Hill (Morning Loop)",
                    "682: North Lakes - Mango Hill (Afternoon Loop)",
                    "683: Dakabin - Kallangur Station (Loop)",
                    "684: North Lakes - Kallangur East",
                    "685: North Lakes - Kallangur West",
                    "686: French's Forest - Petrie Station (Loop)",
                    "687: North Lakes - Mango Hill Station",
                    "688: North Lakes (Clockwise Loop)",
                    "689: North Lakes (Anti-Clockwise Loop)",
                    "690: Kippa-Ring - Sandgate via Redcliffe",
                    "691: Redcliffe - Sandgate Station",
                    "694: Kippa-Ring - Redcliffe via Woody Point",
                    "696: Kippa-Ring - Kippa Ring Loop",
                    "698: Redcliffe - Kippa-Ring via Scarborough",
                    "699: Redcliffe - Kippa Ring Station",
                    "700: Tweed Heads - Broadbeach via Burleigh Heads",
                    "704: Sea World - Helensvale via Harbour Town",
                    "705: Broadbeach - Seaworld & Main Beach via Surfers",
                    "709: Helensvale station - Hope Island",
                    "710: Uni-Hospital - Helensvale via Parkwood",
                    "711: Sanctuary Cove - Southport via Runaway Bay",
                    "712: Southport - Coombabah via Harbour Town",
                    "713: Paradise Point - Southport via Harbour Town",
                    "714: Uni-Hospital - Helensvale via Pacific Pines",
                    "715: Southport - Helensvale via Arundel, Pacific Pines",
                    "716: Studio Village - Helensvale Station (Loop)",
                    "717: Pacific Pines - Helensvale Station",
                    "718: Santa Barbara - Helensvale via Oyster Cove",
                    "719: Paradise Point - Southport via Uni-Hospital",
                    "720: Pimpama City - Coomera Station",
                    "721: Coomera - Ormeau via Coomera Springs, Pimpama",
                    "722: Coomera - Pimpama via Coomera Rivers, Dixon",
                    "723: Coomera - Helensvale via Oxenford",
                    "724: Pimpama Sports Hub - Coomera Station",
                    "725: Coomera - Helensvale via Upper Coomera",
                    "726: Coomera - Coomera Waters",
                    "727: Coomera - Helensvale via Upper Coomera",
                    "728: Beenleigh - Ormeau via Yatala, Jacobs Ridge",
                    "729: Beenleigh - Ormeau via Yatala, Ormeau Hills",
                    "731: Broadbeach - Southport via Isle Capri",
                    "732: Coomera Station - Pimpama Station via Pimpama",
                    "733: Pimpama Station - Jacobs Well(interim Ormeau Stn)",
                    "735: Southport - Nerang Station via Ashmore",
                    "736: Broadbeach - Nerang via Highland Park",
                    "737: Ashmore - Southport via Southport Park",
                    "738: Broadbeach - Uni-Hospital via Ashmore",
                    "739: Uni-Hospital - Nerang via Ashmore",
                    "740: Surfers Paradise - Nerang via Ashmore",
                    "741: Broadbeach - Southport via Ashmore, Keebra Park",
                    "742: Molendinar - Southport via Ashmore",
                    "743: Broadbeach - Nerang via Carrara",
                    "744: Broadbeach - Nerang via Highland Park",
                    "745: Broadbeach - Nerang Station",
                    "746: Nerang West - Nerang station",
                    "747: Southport - Robina via Bundall",
                    "748: Nerang - Robina via Gilston,Worongary, Mudgeeraba",
                    "749: Clearwater - Nerang Station",
                    "750: Robina - Broadbeach via Bond University",
                    "751: Broadbeach - Robina via Mermaid Waters",
                    "752: Broadbeach South station - Robina via Robina Wood",
                    "753: Broadbeach - Burleigh Heads via Robina",
                    "754: Broadbeach - Burleigh Heads via Mermaid Waters",
                    "755: Broadbeach - Robina via Merrimac",
                    "756: Broadbeach - West Burleigh via Miami",
                    "757: Reedy Creek - Burleigh Heads via Varsity Lakes",
                    "758: Merrimac - Robina via Mudgeeraba",
                    "759: Robina - Reedy Creek via Varsity Lakes Station",
                    "760: Tweed Heads - Robina via Airport, Varsity Lakes",
                    "763: Lakewoods - The Pines via Elanora",
                    "764: Burleigh Heads - Currumbin Park via The Pines",
                    "765: The Pines - Robina via Burleigh Heads",
                    "766: Currumbin Waters - The Pines",
                    "767: Tugun - The Pines via Currumbin",
                    "768: Tweed Heads - The Pines via John Flynn Hospital",
                    "777: Airport - Broadbeach South via Burleigh Heads",
                    "9999: Toorbul - Donnybrook (Shopper Service)",
                    "M1: Eight Mile Plains - City",
                    "M2: RBWH - UQ Lakes via City",
                    "N100: Valley - Forest Lake NightLink",
                    "N130: Valley - Algester/Parkinson NightLink",
                    "N154: City/Valley - Browns Plains NightLink",
                    "N184: Valley - Garden City NightLink via Cavendish Road",
                    "N199: West End - Teneriffe Ferry NightLink",
                    "N200: Valley - Carindale Heights NightLink",
                    "N226: City/Valley - Wynnum NightLink via Bulimba",
                    "N250: Fortitude Valley - Victoria Pt",
                    "N310: City - Sandgate NightLink",
                    "N339: City/Valley - Bracken Ridge NightLink",
                    "N345: Aspley - Valley NightLink",
                    "N385: Valley - The Gap NightLink",
                    "N392: Valley - Ferny Grove NightLink",
                    "N413: Valley - St Lucia NightLink",
                    "N449: Valley - Riverhills NightLink via Indooroopilly",
                    "N555: Fortitude Valley - Loganholme",
                    "R346: Sandgate - Shorncliffe station Loop",
                    "R348: Shorncliffe - Northgate",
                    "R395: Ferny Grove - Roma Street",
                    "R581: Cleveland Line - All Stations",
                    "R583: Airport - Southern Corridor (Express)",
                    "R584: City - Southern Corridor (Limited Express)",
                    "R585: City - Albion - Park Road (All Stations)",
                    "R591: City - Southern Corridor (All Stations)",
                    "R592: Western - Ipswich (All Stations)",
                    "R594: City - Western Corridor (Limited Express)",
                    "R595: City - Albion - Milton (All Stations)",
                    "R596: Western - Springfield (EXPRESS)",
                    "R597: Western - Springfield Central (ALL STOPS)",
                    "R598: Western - Rosewood (All Stations)",
                    "R599: City - Western Corridor (All Stations)",
                    "R600: Caboolture - Bowen Hills",
                    "R601: Petrie - Bowen Hills",
                    "R603: Northgate - Bowen Hills",
                    "R604: Northgate - City",
                    "R605: Petrie - Northgate",
                    "R609: Landsborough - Caboolture",
                    "R610: Caboolture - Landsborough",
                    "R612: Caboolture - Gympie North",
                    "R613: Bowen Hills - Gympie North",
                    "R616: Nambour, Landsborough, Bowen Hills",
                    "R701: Airport Train",
                    "TX7: Coomera - Helensvale via Theme Parks"
                ],
                "stops": {
                    "100: Forest Lake/Inala - City": [
                        "Ipswich Rd at Moorooka station, stop 38/39",
                        "Forest Lake Shops",
                        "Ipswich Rd near Michlin St, stop 37",
                        "Forest Lake Bvd at Forest Lake Shops",
                        "Forest Lake Bvd at Kensington Way",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Grand Ave East near Ascot Ave",
                        "Ipswich Rd at Chardons Corner",
                        "Grand Ave at Grand Avenue Cascade",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Grand Ave at Grand Avenue Lake",
                        "Ipswich Rd at Victoria Terrace, stop 17",
                        "Grand Ave at Grand Avenue School",
                        "Ipswich Rd at PA Hospital, stop 14",
                        "Grand Ave West near Centennial Way",
                        "Woolloongabba station, platform 1",
                        "Lochwood Ave at Woogaroo St",
                        "Mater Hill station, platform 1",
                        "Lochwood Ave at Jindabyne Cct",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Lochwood Ave at Lochwood Broadwater",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Queen Street station",
                        "Joseph Banks Ave near Leichhardt Cct",
                        "Woodland Ave near Laricina Cct",
                        "Partridge St near Tang St",
                        "Partridge St at Partridge North, stop 72",
                        "Inala station, platform B",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Hyacinth St, stop 77",
                        "Durella St at Durella West, stop 76",
                        "Durella St at Durella East, stop 75",
                        "Akama Rd at Akama South Stop 74",
                        "Akama Rd at Akama Central Stop 73",
                        "Glenala Rd at Glenala East, stop 71",
                        "Blunder Rd at Glenala Rd, stop 71a",
                        "Blunder Rd at Forest Place South, stop 70",
                        "Blunder Rd at Forest Place North, stop 69",
                        "Blunder Rd at Freeman Rd, stop 68",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Cordelia St at Brisbane State High, stop 3",
                        "Queen Street station, 1a",
                        "Cultural Centre station, platform 2",
                        "Stephens Rd near Brook St",
                        "Stephens Rd at St Laurences College, stop 7",
                        "South Bank busway station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Mater Hill station, platform 2",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ipswich Rd at Chardons Corner, stop 25",
                        "Ipswich Rd at Clifton Hill near Beaudesert Rd",
                        "Ipswich Rd at Michlin Street, stop 37",
                        "Ipswich Rd at Moorooka station, stop 39",
                        "Blunder Rd at Blunder - Freeman, stop 68",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Inala station, platform A",
                        "Woodland Ave near Joseph Banks Ave",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Lochwood Ave at Broadwater Way",
                        "Woogaroo St at Lochwood Ave"
                    ],
                    "101: Forest Lake - Oxley station via Inala and Durack": [
                        "Forest Lake Shops",
                        "College Ave at Hillbrook",
                        "College Ave at Halifax Court",
                        "Joseph Banks Ave near Hillbrook Wy",
                        "Blunder Rd near Crossacres St",
                        "Wallaroo Way near Brushtail Cr, stop 61",
                        "Blunder Rd at Doolandella North, stop 61a",
                        "Blunder Rd at Lorikeet St",
                        "Blunder Road near Rosella St",
                        "Inala Ave at Sherrington Park",
                        "Inala Ave at Skylark",
                        "Skylark St at Skylark Shops, stop 67",
                        "Skylark St at Skylark South, stop 68",
                        "Sittella St at Sittella East, stop 69",
                        "Sittella St at Sittella West, stop 70",
                        "Shelduck St near Swallow St, stop 71",
                        "Partridge St at Partridge North, stop 72",
                        "Inala station, platform D",
                        "Inala Ave at Gannett Street, stop 79/57",
                        "Inala Ave at Poinsettia Street, stop 78/58",
                        "Poinsettia St at Richlands Campus, stop 77/59",
                        "Poinsettia St near Mira St, stop 76",
                        "Archerfield Rd at Court House",
                        "Pine Rd near Orchard Rd",
                        "Pine Rd at Lions",
                        "Richlands bus station, stop B",
                        "Archerfield Rd at McEwan Park",
                        "Archerfield Rd near Littleton Rd",
                        "Archerfield Rd near Freeman Rd, stop 71",
                        "Archerfield Rd near West Link Pl",
                        "Boundary Rd near Archerfield Rd",
                        "Boundary Rd near Acanthus St",
                        "Boundary Rd at Oxley Pines, stop 70",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Oxley Rd at Oxley School, stop 65",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Cook St at Nixon Park, stop 62",
                        "Cook St near Lincoln St, stop 62a",
                        "Oxley station, stop A",
                        "Oxley Station Rd at Davies Street, stop 63a",
                        "Oxley Station Rd at Englefield East, stop 64a",
                        "Poinsettia St near Archerfield Rd, stop 76",
                        "Poinsettia St at Richlands Campus, stop 59/77",
                        "Poinsettia St at Gannett Street, stop 78/79",
                        "Shelduck St near Swallow St",
                        "Sittella St near Petrel St",
                        "Sittella St near Plover St",
                        "Skylark St near Finch St",
                        "Skylark St near Bittern St",
                        "Inala Ave at Avocet Ave, stop 59",
                        "Blunder Rd near Rosella St, stop 60A",
                        "Blunder Rd at Flamingo Street Stop 60b",
                        "Blunder Rd near Wallaroo Wy",
                        "Crossacres near Blunder Rd",
                        "Joseph Banks Ave at Hillbrook Wy",
                        "College Ave near Oxley Place"
                    ],
                    "102: Inala - Oxley": [
                        "Inala station, platform D",
                        "Inala Ave at Gannett Street, stop 79/57",
                        "Inala Ave at Poinsettia Street, stop 78/58",
                        "Hydrangea St near Frangipani St, stop 59",
                        "Poinciana St at Laburnum St, stop 60",
                        "Poinciana St at Punica St, stop 61",
                        "Poinciana St at Poinciana - Azalea, stop 62",
                        "Azalea St at Tecoma St, stop 63",
                        "Azalea St at Eugenia St, stop 64",
                        "Azalea St at Barberry St, stop 65",
                        "Azalea St at Balsa St, stop 66",
                        "Balsa St at Biota St, stop 67",
                        "Balsa St at Balsa - Ebony, stop 68",
                        "Balsa St at Clematis St, stop 69",
                        "Balsa St at Apricot St, stop 70",
                        "Balsa St at Begonia St, stop 71",
                        "Begonia St at Yulan St, stop 71a",
                        "Begonia St at Rosemary St, stop 72",
                        "Rudd St at Police Academy",
                        "Douglas St at Douglas St South",
                        "Douglas St at Douglas St Central",
                        "Douglas St at Douglas Street North",
                        "Englefield Rd at Englefield West",
                        "Englefield Rd at Lucock Street",
                        "Englefield Rd at Idriess Street",
                        "Oxley Station Rd at Davies Street, stop 63a",
                        "Oxley station, stop A",
                        "Balsa St at Ebony St, stop 68",
                        "Poinsettia St at Gannett Street, stop 78/79",
                        "Inala Plaza"
                    ],
                    "103: Centenary - Inala Plaza": [
                        "Inala station, platform C",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Hyacinth St, stop 77",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Rosemary St at Rosemary South, stop 75A",
                        "Rosemary St at Inala School, stop 75",
                        "Rosemary St at Rosemary - Holly, stop 74",
                        "Rosemary St at Fir St, stop 73",
                        "Rosemary St at Rosemary North, stop 71",
                        "Boundary Rd at Oxley Pines, stop 70",
                        "Acanthus Street Stop 69 near Boundary Rd",
                        "Winslow St at Rowe Tce, stop 67/68",
                        "Winslow St at Scotts Rd, stop 66",
                        "Scotts Rd at Scotts - Balfour, stop 65",
                        "Railway Pde at Darra station, stop A",
                        "Kokoda St near Wau Rd",
                        "Railway Pde at Darra Railway Parade, stop 62",
                        "Wau Rd near Ramu St",
                        "Harcourt Rd at Cardiff Road South, stop 61",
                        "Markham Street near Sanadanda St",
                        "Cardiff Rd at Cardiff Road North, stop 60",
                        "Monier Rd at Monier Road Shops",
                        "Bellwood St near Glen Ross Rd, stop 54a",
                        "Glen Ross Rd at Glen Ross - Bellwood, stop 54",
                        "McPherson Rd at McPherson South, stop 55A",
                        "McPherson Rd at Malia St, stop 55",
                        "McPherson Rd at McPherson Park, stop 56",
                        "Oldfield Rd at Oldfield Shops, stop 57a",
                        "Oldfield Rd at Homebush Cr, stop 57b",
                        "Northbrook St at Northbrook - Oldfield, stop 58",
                        "Northbrook St at Cityview Rd, stop 59",
                        "Avondale Rd at Avondale - Northbrook, stop 60",
                        "Avondale Rd at Avondale - Glen Ross, stop 61",
                        "Mount Ommaney Shopping Centre",
                        "Yallambee Rd at Centenary High School",
                        "Glen Ross Rd at Sinnamon Park",
                        "Yallambee Rd at Mt Ommaney",
                        "Endeavour St near Macarthur Ct",
                        "Endeavour St near Flinders Ct",
                        "Northbrook St at Kobble Ct",
                        "Northbrooke St near Allamanda Ct, stop 59",
                        "Northbrooke St near Drummond St, stop 58",
                        "Oldfield Rd at Oldfield - Homebush, stop 57B",
                        "McPherson Rd at McPherson Cityview, stop 56a",
                        "Glen Ross Rd at Bellwood St, stop 54",
                        "Cardiff Rd at Cardiff Road South, stop 61",
                        "Darra Shops",
                        "Scotts Rd at Winslow St, stop 66",
                        "Acanthus St near Boundary Rd, stop 69",
                        "Rosemary St at Rosemary - Fir, stop 73",
                        "Rosemary St at Holly St, stop 74",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Inala Plaza"
                    ],
                    "104: Corinda High - PA Hospital": [
                        "Browne St at Corinda station",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Oxley Rd near Coyne St, stop 57",
                        "Oxley Rd at Sherwood, stop 56",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Oxley Rd at Graceville Fiveways, stop 50",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Graceville Ave at Oxley Rd, stop 48",
                        "Oxley Rd at Lynne Grove, stop 60",
                        "Graceville Ave near Erroll St, stop 47",
                        "Oxley Rd near Hassall St",
                        "Graceville Ave near Erroll St, stop 46",
                        "Graceville Ave at Riverside Village, stop 45",
                        "Graceville Ave at Graceville - Nadine, stop 44",
                        "King Arthur Tce at King Arthur - Oxley Ck, stop 43",
                        "King Arthur Tce at Merlin Street, stop 41/40",
                        "King Arthur Tce at Dexter Street, stop 39",
                        "Softstone St near Myla Tce, stop 38",
                        "Tennyson Memorial Ave near Walker St, stop 37",
                        "Tennyson Memorial Ave at Varley Street, stop 35",
                        "Fairfield Rd at Ortive St, stop 33",
                        "Wilkie St near Cardross St, stop 32",
                        "Wilkie St near Crichton St, stop 31",
                        "Green St at Yeerongpilly station, stop 30",
                        "Green St near Biarra St, stop 29",
                        "Wingarra St near Crichton St, stop 28",
                        "Crichton St near Park Rd, stop 27",
                        "Park Rd at Park - Oloan, stop 26",
                        "Park Rd at School Rd, stop 25",
                        "Park Rd at Yeronga State School, stop 23/24",
                        "Park Rd at Memorial Park",
                        "Park Rd near Fairfield Rd, stop 21",
                        "Fairfield Rd at Fairfield - Venner, stop 20",
                        "Fairfield Rd near Ashby St, stop 18a",
                        "Home St at Brougham Street, stop 17A",
                        "Home St at Victoria Street, stop 16A",
                        "Home St at Fairfield Park, stop 15a",
                        "Fairfield Rd at Fenton Street, stop 14a",
                        "Fairfield Rd at Princess Street, stop 13a",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Boggo Road station, platform 5",
                        "Lower Level at PA Hospital station",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Fairfield Rd at Fairfield - Ortive, stop 33",
                        "Noble St at Princess Street, stop 13a",
                        "Varley St near Pulle St, stop 35",
                        "Tennyson Memorial Ave at Brisbane Golf, stop 36",
                        "Noble St at Fenton Street, stop 14a",
                        "Fairfield Rd at Fairfield Park, stop 15a",
                        "Softstone St near King Arthur Tce, stop 38",
                        "Fairfield Rd at Victoria Street, stop 16a",
                        "Fairfield Rd at Brougham Street, stop 17A",
                        "Fairfield Rd near Ashby St, stop 19",
                        "Park Rd near Christensen St",
                        "Graceville Ave at Graceville - Oxley, stop 48",
                        "Park Rd near OLoan St, stop 26",
                        "Park Rd at Park - Chrichton, stop 27",
                        "Wingarra St at Crichton St, stop 28",
                        "Green St at Biarra St, stop 29",
                        "Clewley St near Oxley Rd, stop 59",
                        "Clara St at Clewley St, stop 60",
                        "Clara St at Clara - Nelson, stop 61",
                        "Clara St at Clara - Grey, stop 62"
                    ],
                    "105: Indooroopilly - PA Hospital via Yeronga": [
                        "Honour Ave at Chelmer station",
                        "Station Rd at Indooroopilly Shopping Ctr, stop D",
                        "Honour Ave at Graceville near Verney Rd",
                        "Coonan St at Indooroopilly station, stop 53",
                        "Wharf St near Bridge St, stop 52",
                        "Honour Ave at Sherwood Forest",
                        "Oxley Rd at Milpera, stop 51",
                        "Sherwood Rd near Hedges St",
                        "Oxley Rd at Graceville State School, stop 50",
                        "Oxley Rd at Graceville Fiveways, stop 50",
                        "Graceville Ave at Oxley Rd, stop 48",
                        "Oxley Rd at Graceville Uniting Church, stop 49",
                        "Graceville Ave near Erroll St, stop 47",
                        "Graceville Ave near Erroll St, stop 46",
                        "Graceville Ave at Riverside Village, stop 45",
                        "Graceville Ave at Graceville - Nadine, stop 44",
                        "King Arthur Tce at King Arthur - Oxley Ck, stop 43",
                        "King Arthur Tce at Merlin Street, stop 41/40",
                        "King Arthur Tce at Dexter Street, stop 39",
                        "Softstone St near Myla Tce, stop 38",
                        "Tennyson Memorial Ave near Walker St, stop 37",
                        "Tennyson Memorial Ave at Varley Street, stop 35",
                        "Fairfield Rd at Ortive St, stop 33",
                        "Wilkie St near Cardross St, stop 32",
                        "Wilkie St near Crichton St, stop 31",
                        "Green St at Yeerongpilly station, stop 30",
                        "Green St near Biarra St, stop 29",
                        "Wingarra St near Crichton St, stop 28",
                        "Park Rd at Park - Oloan, stop 26",
                        "Park Rd at School Rd, stop 25",
                        "Park Rd at Yeronga State School, stop 23/24",
                        "Park Rd at Memorial Park",
                        "Park Rd near Fairfield Rd, stop 21",
                        "Fairfield Rd at Fairfield - Venner, stop 20",
                        "Fairfield Rd near Ashby St, stop 18a",
                        "Home St at Brougham Street, stop 17A",
                        "Home St at Victoria Street, stop 16A",
                        "Home St at Fairfield Park, stop 15a",
                        "Fairfield Rd at Fenton Street, stop 14a",
                        "Fairfield Rd at Princess Street, stop 13a",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Boggo Road station, platform 5",
                        "Lower Level at PA Hospital station",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Noble St at Princess Street, stop 13a",
                        "Noble St at Fenton Street, stop 14a",
                        "Fairfield Rd at Fairfield Park, stop 15a",
                        "Fairfield Rd at Victoria Street, stop 16a",
                        "Fairfield Rd at Brougham Street, stop 17A",
                        "Fairfield Rd near Ashby St, stop 19",
                        "Park Rd near Christensen St",
                        "Park Rd near OLoan St, stop 26",
                        "Park Rd at Park - Chrichton, stop 27",
                        "Wingarra St at Crichton St, stop 28",
                        "Green St at Biarra St, stop 29",
                        "Fairfield Rd at Fairfield - Ortive, stop 33",
                        "Varley St near Pulle St, stop 35",
                        "Tennyson Memorial Ave at Brisbane Golf, stop 36",
                        "Softstone St near King Arthur Tce, stop 38",
                        "Graceville Ave at Graceville - Oxley, stop 48",
                        "Coonan St near Belgrave Rd, stop 21",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly interchange"
                    ],
                    "106: Mt Ommaney - Indooroopilly via Corinda": [
                        "Mount Ommaney Shopping Centre",
                        "Glen Ross Rd at Sinnamon Park",
                        "Avondale Rd at Avondale - Glen Ross, stop 61",
                        "Avondale Rd at Avondale - Northbrook, stop 60",
                        "Northbrook St at Kobble Ct",
                        "Northbrooke St near Allamanda Ct, stop 59",
                        "Northbrooke St near Drummond St, stop 58",
                        "Oldfield Rd at Oldfield - Homebush, stop 57B",
                        "Oldfield Rd at Oldfield Shops, stop 57a",
                        "Oldfield Rd near McPherson Rd, stop 57",
                        "Seventeen Mile Rocks Rd at Arygle, stop 73",
                        "Seventeen Mile Rocks Rd at Edenbrooke, stop 72",
                        "Seventeen Mile Rocks Rd at Pannard St",
                        "Canossa Private Hospital, stop 70",
                        "Seventeen Mile Rocks Rd at Kingsgate St, stop 69",
                        "Ardoyne Rd at Oxley station, stop 68",
                        "Ardoyne Rd near Sheffield St, stop 67",
                        "Cliveden Ave at Lyon Ave, stop 66",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Pratten St near Edmondson St, stop 64",
                        "Pratten St at Corinda High School, stop 63",
                        "Clara St at Clara - Grey, stop 62",
                        "Clara St at Nelson St, stop 61",
                        "Clara St near Clewley St, stop 60",
                        "Clewley St near Oxley Rd, stop 59",
                        "Oxley Rd near Coyne St, stop 57",
                        "Oxley Rd at Sherwood, stop 56",
                        "Thomas St near Oxley Rd, stop 55",
                        "Thomas St near Blackwood St, stop 54",
                        "Plumer St near Blackwood St, stop 53",
                        "Long St at Haldane Street, stop 52",
                        "Long St at Long Street East, stop 51",
                        "Oxley Rd at Graceville Fiveways, stop 50",
                        "Oxley Rd at Oxley - Graceville, stop 49B",
                        "Oxley Rd at Graceville Uniting Church, stop 49",
                        "Oxley Rd at Graceville State School, stop 50",
                        "Oxley Rd at Milpera, stop 51",
                        "Wharf St near Bridge St, stop 52",
                        "Honour Ave at Chelmer station",
                        "Coonan St at Indooroopilly station, stop 53",
                        "Honour Ave at Graceville near Verney Rd",
                        "Coonan St near Belgrave Rd, stop 21",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly interchange",
                        "Station Rd at Indooroopilly Shopping Ctr, stop D",
                        "Honour Ave at Sherwood Forest",
                        "Sherwood Rd near Hedges St",
                        "Plumer St near Tainton St, stop 53",
                        "Clara St at Clewley St, stop 60",
                        "Clara St at Clara - Nelson, stop 61",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Ardoyne Rd near Lyon Ave, stop 67",
                        "Ardoyne Rd at Oxley station, stop B",
                        "Seventeen Mile Rocks Rd at Arygle Street, stop 73",
                        "Oldfield Rd at Homebush Cr, stop 57b",
                        "Northbrook St at Northbrook - Oldfield, stop 58",
                        "Northbrook St at Cityview Rd, stop 59"
                    ],
                    "107: Yeerongpilly - City": [
                        "Fairfield Rd at Ortive St, stop 33",
                        "Fairfield Rd at Yeronga station",
                        "Fairfield Rd at Ovendean Street, stop 21",
                        "Hyde Rd at Fairfield Rd, stop 22",
                        "Hyde Rd at Hyde - Manson, stop 23",
                        "Hyde Rd near Kingsley Pde, stop 24",
                        "Hyde Rd at Cansdale St, stop 26",
                        "Hyde Rd at Rome Street North, stop 27",
                        "Hyde Rd near Utzon St, stop 31",
                        "Orsova Rd near Orontes Rd, stop 32",
                        "Orsova Rd near Brisbane Corso, stop 33",
                        "Brisbane Corso at Wanganui Gardens, stop 35",
                        "Orlando Rd near Orama Rd, stop 34s/30",
                        "Orestes Rd near Rhyndarra St, stop 29",
                        "Rhyndarra St at Kadumba St, stop 28",
                        "Kadumba St at Kadumba-Rome St South, stop 27",
                        "Kadumba St at St Sebastians School, stop 26",
                        "Kadumba St at Colevale Lane, stop 25",
                        "Kadumba St near Eversley Tce, stop 23",
                        "Kadumba St near Fairfield Rd, stop 22",
                        "Fairfield Rd at Fairfield - Venner, stop 20",
                        "Fairfield Rd near Ashby St, stop 18a",
                        "Ashby St near Newcastle St, stop 18",
                        "Turner Ave near Brougham St, stop 17",
                        "Brisbane Corso at Newcastle Street, stop 16",
                        "Brisbane Corso at Turley Street, stop 15",
                        "Stimpson St at Stimpson - Luya, stop 14B",
                        "Fairfield Rd at Fenton Street, stop 14a",
                        "Fairfield Rd at Princess Street, stop 13a",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Boggo Road station, platform 5",
                        "PA Hospital station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 27 near Creek St",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 45 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Noble St at Princess Street, stop 13a",
                        "Noble St at Fenton Street, stop 14a",
                        "Stimpson St near Glengregory St, stop 14A",
                        "Ashby St at Fairfield Rd, stop 19",
                        "Kadumba St at Kadumba - Colevale, stop 25",
                        "Kadumba St at Kadumba - Douglas, stop 26A",
                        "Kadumba St at Kadumba - Rhyndarra, stop 28",
                        "Orlando Rd near Orama Rd, stop 34/30",
                        "Orlando Rd at Wanganui Gardens, stop 35",
                        "Brisbane Corso near Ormuz Rd, stop 34",
                        "Orsova Rd at Orsova-Brisbane Corso, stop 33",
                        "Orsova Rd near Orvieto Rd, stop 32/31",
                        "Hyde Rd near Cansdale St, stop 26/24",
                        "Hyde Rd near Manson Pde, stop 23A",
                        "Fairfield Rd at Fairfield - Ortive, stop 33"
                    ],
                    "109: Acacia Ridge - City Rocket": [
                        "Watson Rd at Learoyd Road",
                        "Bellamy St at Acacia Ridge South near Benton St",
                        "Bellamy St near Marnham St",
                        "Mitchell St at Marnham St",
                        "Mitchell St at Acacia Ridge East",
                        "Elizabeth St at Kilkenny",
                        "Watson Rd at Acacia Ridge",
                        "Watson Rd at Acacia Ridge North, stop 59",
                        "Mortimer Rd at Acacia Ridge West, stop 53",
                        "Beatty Rd at Archerfield Aerodrome",
                        "Beatty Rd at Archerfield North",
                        "Marshall Rd at Rocklea South, stop 41",
                        "Beaudesert Rd at Salisbury station",
                        "Beaudesert Rd at Moorooka South, stop 38",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Moorvale, stop 32",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Ipswich Rd at Chardons Corner",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Ipswich Rd at Victoria Terrace, stop 17",
                        "Elizabeth Street Stop 82",
                        "Edward Street Stop 146 at Stamford Plaza",
                        "Alice Street Stop 102 at George St",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ipswich Rd at Chardons Corner, stop 25",
                        "Beatty Rd at Archerfield North, stop 43",
                        "Mortimer Rd at Acacia Ridge North, stop 59",
                        "Bellamy St near Limerick St"
                    ],
                    "110: Inala - City": [
                        "Inala station, platform B",
                        "Inala Ave at Skylark",
                        "Inala Ave at Sherrington Park",
                        "Inala Ave at Linacre",
                        "King Ave near Sherbrooke Rd",
                        "Learoyd Rd near Gooderham Rd",
                        "Watson Rd at Learoyd Road",
                        "Bellamy St at Acacia Ridge South near Benton St",
                        "Bellamy St near Marnham St",
                        "Mitchell St at Acacia Ridge East",
                        "Elizabeth St at Kilkenny",
                        "Watson Rd at Acacia Ridge",
                        "Watson Rd at Acacia Ridge North, stop 59",
                        "Mortimer Rd at Acacia Ridge West, stop 53",
                        "Beatty Rd at Archerfield Aerodrome",
                        "Beatty Rd at Archerfield North",
                        "Marshall Rd at Rocklea South, stop 41",
                        "Beaudesert Rd at Salisbury station",
                        "Beaudesert Rd at Moorooka South, stop 38",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Moorvale, stop 32",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Ipswich Rd at Chardons Corner",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Boggo Road station, platform 5",
                        "Lower Level at PA Hospital station",
                        "PA Hospital station, platform 2",
                        "Villa St at Yeronga High School",
                        "Boggo Road station, platform 6",
                        "Park Rd near Christensen St",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Park Rd at School Rd, stop 25",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ipswich Rd at Chardons Corner, stop 25",
                        "Beatty Rd at Archerfield North, stop 43",
                        "Mortimer Rd at Acacia Ridge North, stop 59",
                        "Bellamy St near Limerick St",
                        "Mitchell St at Marnham St",
                        "Inala Plaza"
                    ],
                    "112: Griffith Uni Mt Gravatt - PA Hospital": [
                        "Griffith University Sports Rd",
                        "Circular Dr at Griffith University, stop B",
                        "Messines Ridge Rd at Algona Street, stop 59",
                        "Messines Ridge Rd at Messines Bushland, stop 58",
                        "Monash Rd at Monash Park, stop 56",
                        "Monash Rd at Monash Bushland, stop 55",
                        "Monash Rd at Craigmont Street, stop 54",
                        "Monash Rd at Aldora Street, stop 53",
                        "Monash Rd at Ferrand Street, stop 52",
                        "Monash Rd near Kaypee St, stop 51",
                        "Monash Rd at Monash Road Shops, stop 49",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Prior St at Windmill Street, stop 43",
                        "Windmill St at Pring Street, stop 42",
                        "Bramston St near Andrew Ave, stop 41",
                        "Andrew Ave at Pope Street, stop 40",
                        "Andrew Ave at Elliot Street, stop 39",
                        "Andrew Ave near Fernvale Rd, stop 38",
                        "Andrew Ave at Tarragindi Bowls, stop 38a",
                        "Tarragindi Rd at Bailey Street, stop 37",
                        "Tarragindi Rd at Kenneth Street, stop 36",
                        "Tarragindi Rd at Cosker Street, stop 34",
                        "Ekibin Rd at Ekibin Road East, stop 33",
                        "Ekibin Rd at Ferndale Street, stop 32",
                        "Ekibin Rd at Rigby Street, stop 31a",
                        "Ekibin Rd at Chester Street, stop 31",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Ekibin Rd at Ekibin Park South, stop 28",
                        "Ekibin Rd at Bower Street, stop 27",
                        "Ekibin Rd at Lambton Street stop 25",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Ipswich Rd at Annerley RSL, stop 21a",
                        "Annerley Rd at Portland Street, stop 21",
                        "Annerley Rd at Herbert Street, stop 20",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Carville Street, stop 20/19",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Boggo Road station, platform 5",
                        "Lower Level at PA Hospital station",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Annerley Rd at Hefferan Park, stop 19",
                        "Annerley Rd at Carville Street, stop 20",
                        "Annerley Rd at Herbert Street, stop 20b",
                        "Annerley Rd at Annerley RSL, stop 21a",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ekibin Rd at Lambton Street, stop 25",
                        "Ekibin Rd at Lothian Street, stop 26",
                        "Ekibin Rd at Chester Road, stop 31",
                        "Andrew Ave at Bailey Street, stop 37",
                        "Bramston St at Pring Street, stop 41a",
                        "Windmill St near Prior St, stop 42/43",
                        "Prior St at Tarragindi, stop 44/48",
                        "Monash Rd near Ferrand St, stop 51",
                        "Monash Rd at Monash Bushlands, stop 55",
                        "Messines Ridge Rd at Messines Bushland, stop 57/58",
                        "Messines Ridge Rd at Carloch Street, stop 60"
                    ],
                    "113: Mt Gravatt Central - City": [
                        "Mt Gravatt Central Fair",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Springwood St at Troubridge Street, stop 37a",
                        "Grenfell St at Springwood Street, stop 38",
                        "Clausen St near Bakewell St, stop 39",
                        "Clausen St at Chester Park Reserve, stop 40",
                        "Camlet St near Kentish St, stop 57/41",
                        "Dunbar St at Oakfield Street, stop 56",
                        "Dunbar St near Boambillee St, stop 54",
                        "Carrara St at Yarranabbe Street, stop 53",
                        "Carrara St at Carrara Shops, stop 52",
                        "Nursery Rd at Crewe Street, stop 51",
                        "Nursery Rd at Eric Road, stop 50",
                        "Nursery Rd at View Street, stop 49",
                        "Nursery Rd at Nursery-Logan Stop 48",
                        "Nursery Rd at Iris Street, stop 67",
                        "Nursery Rd at Marvin Street, stop 66",
                        "Nursery Rd at Flynn Street, stop 65",
                        "Nursery Rd at Gaza Road, stop 64",
                        "Bapaume Rd at Dobbs Street, stop 63",
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Bapaume Rd at Marshall Road, stop 55",
                        "Kuring-Gai Ave near Nurinda Lane, stop 54",
                        "Pozieres Rd at Coromandel Street, stop 53a",
                        "Pozieres Rd at Messines Ridge Road, stop 53",
                        "Pozieres Rd at Belvedere Street, stop 52",
                        "Garioch St near Marieander St, stop 51",
                        "Marshall Rd at Heathwhite Street, stop 50",
                        "Marshall Rd at Hexham Street, stop 49",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Toohey Rd at Bramston Terrace, stop 47",
                        "Toohey Rd at Chamberlain Street, stop 46a",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Denham Tce at Denham Shops, stop 44",
                        "Toohey Rd at Denham Terrace, stop 44/41",
                        "Denham Tce at Vantage Street, stop 43",
                        "Cracknell Rd at Toohey Road, stop 40",
                        "Amulree St near Cracknell Rd, stop 42",
                        "Cracknell Rd at Ellington Street, stop 38",
                        "Cracknell Rd at Weal Street, stop 41",
                        "Cracknell Rd at Laura Street, stop 37",
                        "Cracknell Rd at Esther Street, stop 36",
                        "Cracknell Rd near Benbow St, stop 34",
                        "Ekibin Rd at Ekibin Road East, stop 33",
                        "Ekibin Rd at Ferndale Street, stop 32",
                        "Ekibin Rd at Rigby Street, stop 31a",
                        "Ekibin Rd at Chester Street, stop 31",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Ekibin Rd at Ekibin Park South, stop 28",
                        "Ekibin Rd at Bower Street, stop 27",
                        "Ekibin Rd at Lambton Street stop 25",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Ipswich Rd at Annerley RSL, stop 21a",
                        "Annerley Rd at Portland Street, stop 21",
                        "Annerley Rd at Herbert Street, stop 20",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Carville Street, stop 20/19",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Boggo Road station, platform 5",
                        "Lower Level at PA Hospital station",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Annerley Rd at Hefferan Park, stop 19",
                        "Annerley Rd at Carville Street, stop 20",
                        "Annerley Rd at Herbert Street, stop 20b",
                        "Annerley Rd at Annerley RSL, stop 21a",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ekibin Rd at Lambton Street, stop 25",
                        "Ekibin Rd at Lothian Street, stop 26",
                        "Ekibin Rd at Chester Road, stop 31",
                        "Cracknell Rd at Fingal Street, stop 39",
                        "Amulree St near Pemberton St, stop 42",
                        "Marshall Rd at Chamberlain Street, stop 49",
                        "Garioch St near Pozieres Rd, stop 51",
                        "Coromandel St at Kuring-Gai Avenue, stop 54",
                        "Cannes St at Marshall Road, stop 55",
                        "Cannes St at Holland Park West",
                        "Bapaume Rd near Mulsanne Rd, stop 61/57",
                        "Nursery Rd at Miriam Street, stop 68",
                        "Clausen St at Blackpool Street, stop 40",
                        "Clausen St near Eyre St, stop 39",
                        "Springwood St near Grenfell St, stop 38"
                    ],
                    "114: Tarragindi - City": [
                        "Monash Rd at Monash Park, stop 56",
                        "Monash Rd at Monash Bushland, stop 55",
                        "Monash Rd at Craigmont Street, stop 54",
                        "Monash Rd at Aldora Street, stop 53",
                        "Monash Rd at Ferrand Street, stop 52",
                        "Monash Rd near Kaypee St, stop 51",
                        "Monash Rd at Monash Road Shops, stop 49",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Prior St at Windmill Street, stop 43",
                        "Windmill St at Pring Street, stop 42",
                        "Bramston St near Andrew Ave, stop 41",
                        "Andrew Ave at Pope Street, stop 40",
                        "Andrew Ave at Elliot Street, stop 39",
                        "Andrew Ave near Fernvale Rd, stop 38",
                        "Andrew Ave at Tarragindi Bowls, stop 38a",
                        "Tarragindi Rd at Bailey Street, stop 37",
                        "Tarragindi Rd at Kenneth Street, stop 36",
                        "Tarragindi Rd at Cosker Street, stop 34",
                        "Ekibin Rd at Ekibin Road East, stop 33",
                        "Ekibin Rd at Ferndale Street, stop 32",
                        "Ekibin Rd at Rigby Street, stop 31a",
                        "Ekibin Rd at Chester Street, stop 31",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Earl St at Thompson Estate, stop 17",
                        "Buranda busway, platform 1",
                        "George Street Stop 115 near Charlotte St",
                        "George Street Stop 116",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 27 near Creek St",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 45 near City Hall",
                        "William Street Stop 105 near Margaret St",
                        "Buranda busway, platform 2",
                        "Ekibin Rd at Chester Road, stop 31",
                        "Andrew Ave at Bailey Street, stop 37",
                        "Bramston St at Pring Street, stop 41a",
                        "Windmill St near Prior St, stop 42/43",
                        "Prior St at Tarragindi, stop 44/48",
                        "Monash Rd near Ferrand St, stop 51",
                        "Monash Rd at Monash Bushlands, stop 55"
                    ],
                    "115: Griffith University - Sunnybank Hills": [
                        "Gowan Rd at The Parks",
                        "Gowan Rd at Parkside",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd at Calam North, stop 35",
                        "Compton Rd near Chateau St, stop 25",
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Hellawell Rd near Hillcrest St, stop 73/16",
                        "Hellawell Rd at Signata Street",
                        "Hellawell Rd at Stringybark Street, stop 75",
                        "Hellawell Rd at Cazna Gardens",
                        "Learoyd Rd at Range View",
                        "Learoyd Rd at Paradise",
                        "Watson Rd at Learoyd Road",
                        "Bellamy St at Acacia Ridge South near Benton St",
                        "Bellamy St near Marnham St",
                        "Mitchell St at Marnham St",
                        "Mitchell St at Acacia Ridge East",
                        "Elizabeth St at Kilkenny",
                        "Watson St at Chardean Street, stop 65",
                        "Watson Rd at Acacia Ridge",
                        "Sussex Rd at Harden Street, stop 58",
                        "Sussex Rd at Chifley Street, stop 57",
                        "Beaudesert Rd at Whittingham Street, stop 56",
                        "Beaudesert Rd at A & IICS, stop 55/56",
                        "Beaudesert Rd at Mortimer Road, stop 54",
                        "Beaudesert Rd at Acacia Market Place, stop 53",
                        "Beaudesert Rd at Kerry Rd, stop 52",
                        "Kerry Road East",
                        "Desgrand St at Spowers Street, stop 50",
                        "Desgrand St at Janzoon Street, stop 49",
                        "Desgrand St at Boundary Rd, stop 48",
                        "Beatty Rd at Archerfield North",
                        "Griffith Rd at Recreation Road, stop 55a",
                        "Griffith University stop A",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University station, platform 1",
                        "Griffith University station, platform 2",
                        "Griffith University stop B",
                        "Kessels Rd near Troughton Rd, stop 55",
                        "Beatty Rd at Archerfield North, stop 43",
                        "Beaudesert Rd near Kerry Rd, stop 53",
                        "Bellamy St near Limerick St",
                        "Hellawell Rd at Hillcrest Street, stop 72a",
                        "Pinelands Rd at Hellawell",
                        "Calam Rd near Honeywood St",
                        "Compton Rd near Chateau St, stop 84",
                        "Gowan Rd at Gowan and Compton"
                    ],
                    "116: Upper Mt Gravatt - City": [
                        "Upper Mt Gravatt station, platform 1",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University stop B",
                        "Kessels Rd near Troughton Rd, stop 55",
                        "Kessels Rd near Orange Grove Rd",
                        "Orange Grove Rd at Salisbury East, stop 51",
                        "Henson Rd at Salisbury East, stop 50",
                        "Henson Rd at Meynell Street, stop 49a",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Henson Rd at Ainger Street, stop 48",
                        "Cripps St at Ness Road, stop 47",
                        "Cripps St at Douglas Rd, stop 45/46",
                        "McCarthy Rd near Cubitt St, stop 44",
                        "Evans Rd at Pentex Street, stop 43",
                        "Evans Rd at Industries Street, stop 42/41",
                        "Evans Rd at Standish Street, stop 40",
                        "Evans Rd at Nettleton Crescent, stop 39/38",
                        "Anson St near Muriel Ave, stop 46",
                        "Abel Street Stop 45 near Robinson St",
                        "Robinson St near Hamilton Rd, stop 44a",
                        "Hawtree St near Hamilton Rd, stop 44",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Keats St near Brier St, stop 43",
                        "Beaudesert Rd at Keats Street, stop 35",
                        "Keats St at Holmes Street, stop 42",
                        "Hamilton Rd near Blackburn St, stop 58",
                        "Ipswich Rd at Moorooka station, stop 38/39",
                        "Ipswich Rd near Michlin St, stop 37",
                        "Durack St near Ipswich Rd, stop 36/35",
                        "Durack St at Vale Street, stop 34/33",
                        "Beaudesert Rd at Moorvale, stop 32",
                        "Mayfield Rd at Kipling Street, stop 31a",
                        "Mayfield Rd at Harlock Street, stop 31",
                        "Mayfield Rd at Hermes Street, stop 30d",
                        "Tarragindi Rd at Moresby Street, stop 30c",
                        "Tarragindi Rd at La Monte Street, stop 30b",
                        "Homestead St near Kine St, stop 30a",
                        "Woodridge St at Woodlea Street, stop 30",
                        "Nicholls St near Millicent St, stop 29",
                        "Beverley Hill St near Millicent St, stop 28",
                        "Glendale Gr near Moorland St, stop 27a",
                        "Glendale Gr at MacKenzie Place, stop 27",
                        "Sarah St at Hamlet Street, stop 26",
                        "Cracknell Rd at Juster Street, stop 25A",
                        "Ekibin Rd at Ekibin Road East, stop 33",
                        "Ekibin Rd at Ferndale Street, stop 32",
                        "Ekibin Rd at Rigby Street, stop 31a",
                        "Ekibin Rd at Chester Street, stop 31",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Ekibin Rd at Ekibin Park South, stop 28",
                        "Ekibin Rd at Bower Street, stop 27",
                        "Ekibin Rd at Lambton Street stop 25",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Ipswich Rd at Annerley RSL, stop 21a",
                        "Annerley Rd at Portland Street, stop 21",
                        "Annerley Rd at Herbert Street, stop 20",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Carville Street, stop 20/19",
                        "Annerley Rd at Dutton Park, stop 17/12",
                        "Annerley Rd at Boggo Road, stop 11",
                        "Annerley Rd at Dutton Park Primary, stop 10",
                        "Annerley Rd at Lockhart Street, stop 8",
                        "Annerley Rd at Clarence Street, stop 7",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 27 near Creek St",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 45 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Annerley Rd at Dutton Park, stop 11/17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Annerley Rd at Hefferan Park, stop 19",
                        "Annerley Rd at Carville Street, stop 20",
                        "Annerley Rd at Herbert Street, stop 20b",
                        "Annerley Rd at Annerley RSL, stop 21a",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ekibin Rd at Lambton Street, stop 25",
                        "Ekibin Rd at Lothian Street, stop 26",
                        "Ekibin Rd at Chester Road, stop 31",
                        "Sarah St at MacKenzie Place, stop 27",
                        "Nicholls St near Citrus St, stop 29",
                        "Durack St at Vale Street, stop 33/34",
                        "Durack St near Ipswich Rd, stop 35",
                        "Ipswich Rd at Lyon Street, stop 36",
                        "Ipswich Rd at Michlin Street, stop 37",
                        "Ipswich Rd at Gainsborough Street, stop 38",
                        "Ipswich Rd at Moorooka station, stop 39",
                        "Hamilton Rd near Blackburn St, stop 40",
                        "Holmes St near Keats St, stop 42",
                        "Keats St near Piers St, stop 43",
                        "Hawtree St near Keats St, stop 44",
                        "Hamilton Rd at Robinson Street, stop 44a",
                        "Evans Rd at Nettleton Crescent, stop 38/39",
                        "Evans Rd at Industries Street, stop 41/42",
                        "McCarthy Rd at Russ Hall Park, stop 45",
                        "Cripps St at Douglas Rd, stop 46",
                        "Henson Rd near Ainger St, stop 48",
                        "Henson Rd at Meynell Street, stop 49A",
                        "Orange Grove Rd at Aldi, stop 52",
                        "Griffith Rd at Recreation Road, stop 55a",
                        "Griffith University stop A",
                        "Upper Mt Gravatt station, platform 2"
                    ],
                    "118: Forest Lake - City": [
                        "College Ave at Halifax Court",
                        "College Ave at Hillbrook",
                        "Lochwood Ave at Broadwater Way",
                        "Lochwood Ave at Jindabyne Cct",
                        "Woogaroo St at Lochwood Ave",
                        "Grand Ave West near Centennial Way",
                        "Grand Ave at Grand Avenue School",
                        "Grand Ave at Grand Avenue Lake",
                        "Grand Ave at Grand Avenue Cascade",
                        "Grand Ave East near Ascot Ave",
                        "Forest Lake Bvd at Kensington Way",
                        "Wadeville St Heathwood Rise",
                        "Wadeville St at Wadeville West",
                        "Parkwood Dr North near Beech St",
                        "Parkwood Dr near Coolibah St",
                        "Parkwood Dr at Parkwood Drive South",
                        "Parkwood Dr near Juniper St",
                        "Eight Mile Plains routing stop",
                        "Upper Mt Gravatt station, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Upper Mt Gravatt station, platform 2",
                        "Parkwood Dr near Acacia St",
                        "Parkwood Dr North near Laurel St",
                        "Lochwood Ave at Woogaroo St",
                        "Lochwood Ave at Lochwood Broadwater",
                        "Forest Lake Bvd at Forest Lake, stop A"
                    ],
                    "119: QEII Hospital - City Rocket": [
                        "Troughton Rd at QEII Hospital",
                        "Musgrave Rd at Musgrave Road, stop 53",
                        "Musgrave Rd at Boundary Street, stop 54a",
                        "Orange Grove Rd at QG Laboratory",
                        "Orange Grove Rd at Salisbury East, stop 51",
                        "Orange Grove Rd at Dulcie Street, stop 52",
                        "Toohey Rd at Toohey Forest, stop 53",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Denham Terrace, stop 44/41",
                        "Sexton St near Effingham St",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Earl St at Thompson Estate, stop 17",
                        "Buranda busway, platform 1",
                        "Queen Street station",
                        "Queen Street station, 3b",
                        "Buranda busway, platform 2",
                        "Musgrave Rd at Boundary Street",
                        "Troughton Rd at Musgrave Road, stop 39",
                        "Troughton Rd at QEII Hospital, stop 37"
                    ],
                    "120: Garden City - City via Tarragindi": [
                        "Garden City Shopping Centre station, stop D",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Klumpp Rd at Klumpp-Dawson",
                        "Klumpp Rd at Hibiscus",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University stop B",
                        "Troughton Rd at QEII Hospital",
                        "Musgrave Rd at Musgrave Road, stop 53",
                        "Musgrave Rd at Boundary Street, stop 54a",
                        "Orange Grove Rd at QG Laboratory",
                        "Orange Grove Rd at Salisbury East, stop 51",
                        "Orange Grove Rd at Dulcie Street, stop 52",
                        "Toohey Rd at Toohey Forest, stop 53",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Denham Terrace, stop 44/41",
                        "Sexton St near Effingham St",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Earl St at Thompson Estate, stop 17",
                        "Buranda busway, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Queen Street station",
                        "Queen Street station, 3b",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Buranda busway, platform 2",
                        "Musgrave Rd at Boundary Street",
                        "Troughton Rd at Musgrave Road, stop 39",
                        "Troughton Rd at QEII Hospital, stop 37",
                        "Griffith University stop A",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Garden City Shopping Centre station"
                    ],
                    "121: Salisbury - City": [
                        "Henson Rd at Salisbury East, stop 50",
                        "Henson Rd at Meynell Street, stop 49a",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Henson Rd at Ainger Street, stop 48",
                        "Cripps St at Ness Road, stop 47",
                        "Cripps St at Douglas Rd, stop 45/46",
                        "McCarthy Rd near Cubitt St, stop 44",
                        "Evans Rd at Pentex Street, stop 43",
                        "Tarragindi Rd at Evans Rd, stop 42",
                        "Tarragindi Rd at Davey Street, stop 40",
                        "Tarragindi Rd at Charmaine Street, stop 39",
                        "Tarragindi Rd at Moresby Street, stop 30c",
                        "Tarragindi Rd at La Monte Street, stop 30b",
                        "Tarragindi Rd at Tarragindi Hill Reserve, stop 29a",
                        "Beverley Hill St near Millicent St, stop 28",
                        "Glendale Gr near Moorland St, stop 27a",
                        "Glendale Gr at MacKenzie Place, stop 27",
                        "Sarah St at Hamlet Street, stop 26",
                        "Cracknell Rd at Juster Street, stop 25A",
                        "Ekibin Rd at Ekibin Road East, stop 33",
                        "Ekibin Rd at Ferndale Street, stop 32",
                        "Ekibin Rd at Rigby Street, stop 31a",
                        "Ekibin Rd at Chester Street, stop 31",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Earl St at Thompson Estate, stop 17",
                        "Buranda busway, platform 1",
                        "George Street Stop 115 near Charlotte St",
                        "George Street Stop 116",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 27 near Creek St",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 45 near City Hall",
                        "William Street Stop 105 near Margaret St",
                        "Buranda busway, platform 2",
                        "Ekibin Rd at Chester Road, stop 31",
                        "Sarah St at MacKenzie Place, stop 27",
                        "Tarragindi Rd at Barford Street, stop 38",
                        "McCarthy Rd at Russ Hall Park, stop 45",
                        "Cripps St at Douglas Rd, stop 46",
                        "Henson Rd near Ainger St, stop 48",
                        "Henson Rd at Meynell Street, stop 49A"
                    ],
                    "122: Inala - Garden City": [
                        "Inala station, platform C",
                        "Inala Ave at Gannett Street, stop 79/57",
                        "Inala Ave at Poinsettia Street, stop 78/58",
                        "Poinsettia St at Richlands Campus, stop 77/59",
                        "Eridanus St at Mira Street, stop 60",
                        "Eridanus St near Draco St, stop 61",
                        "Delphinus St near Altair St, stop 62",
                        "Virgo St near Bellatrix St, stop 63",
                        "Bootes St near Aldebaran St, stop 64",
                        "Centaurus St near Apus St, stop 65",
                        "Centaurus St at Centaurus West, stop 66",
                        "Archerfield Rd at Argo Street, stop 67",
                        "Monoceros St at Monoceros West, stop 68",
                        "Monoceros St at Hydra Street, stop 69",
                        "Polaris St near Monoceros St, stop 70",
                        "Andromeda St near Capricorn St, stop 71",
                        "Clipper St near Andromeda St, stop 72",
                        "Brolga St near Parakeet St, stop 73",
                        "Inala station, platform E",
                        "Inala Plaza",
                        "Inala Ave at Thrush Street, stop 57",
                        "Inala Ave at Sycamore Street, stop 58",
                        "Inala Ave at Skylark",
                        "Inala Ave at Sherrington Park",
                        "Inala Ave at Linacre",
                        "King Ave near Sherbrooke Rd",
                        "Learoyd Rd near Gooderham Rd",
                        "Watson Rd at Learoyd Road",
                        "Bellamy St at Acacia Ridge South near Benton St",
                        "Bellamy St near Marnham St",
                        "Mitchell St at Marnham St",
                        "Mitchell St at Acacia Ridge East",
                        "Elizabeth St at Kilkenny",
                        "Watson St at Chardean Street, stop 65",
                        "Watson Rd at Acacia Ridge",
                        "Watson Rd near Agnes St, stop 56a/59",
                        "Watson Rd at Acacia Ridge North, stop 59",
                        "Mortimer Rd at Brandon Park, stop 54",
                        "Mortimer Rd at Acacia Ridge West, stop 53",
                        "Kerry Rd at Beatty Rd, stop 52",
                        "Kerry Rd near Desgrand St, stop 51",
                        "Desgrand St at Spowers Street, stop 50",
                        "Desgrand St at Janzoon Street, stop 49",
                        "Desgrand St at Boundary Rd, stop 48",
                        "Boundary Rd at Postle Street, stop 47",
                        "Boundary Rd at Halt Street, stop 46",
                        "Boundary Rd at Rosedale Street, stop 45",
                        "Orange Grove Rd at Joyce Street, stop 57",
                        "Orange Grove Rd at Rookwood Avenue, stop 56",
                        "Orange Grove Rd at Bosworth Street, stop 55",
                        "Musgrave Rd at Orange Grove Road, stop 54b",
                        "Musgrave Rd at Boundary Street",
                        "Musgrave Rd at Mandarin Street, stop 54",
                        "Troughton Rd at Musgrave Road, stop 39",
                        "Troughton Rd at QEII Hospital, stop 37",
                        "Kessels Rd at Griffith Road, stop 55",
                        "Kessels Rd at Estoril Street, stop 56",
                        "Kessels Rd at QEII Stadium, stop 57",
                        "Omeo St near Trood St, stop 76",
                        "Tora St near Akora St, stop 77",
                        "Meckiff St at Sobers Street, stop 78",
                        "Nagle St at Bolger Street, stop 80",
                        "Nagle St at Pickworth Street, stop 81",
                        "Garden City Shopping Centre station",
                        "Garden City Shopping Centre station, stop E",
                        "Nagle St near Pickworth St, stop 79",
                        "Tora St near Ilya St, stop 77",
                        "Omeo St near Ilya St, stop 76",
                        "Troughton Rd at QEII Hospital",
                        "Musgrave Rd at Musgrave Road, stop 53",
                        "Musgrave Rd at Mossop Street, stop 54",
                        "Musgrave Rd at Boundary Street, stop 54a",
                        "Boundary Rd at Rosedale Street, stop 45/",
                        "Mortimer Rd at Acacia Ridge North, stop 59",
                        "Watson Rd near Sussex St, stop 56a/59",
                        "Bellamy St near Limerick St"
                    ],
                    "123: Griffith University - Garden City via Sunnybank": [
                        "Griffith University station, platform 2",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University stop B",
                        "Troughton Rd at QEII Hospital",
                        "Middle St near Troughton Rd, stop 53",
                        "Mandarin St at Highgate Street, stop 53b",
                        "Musgrave Rd at Mossop Street, stop 54",
                        "Musgrave Rd at Boundary Street, stop 54a",
                        "Musgrave Rd at Orange Grove Road, stop 54b",
                        "Orange Grove Rd at Bosworth Street, stop 55",
                        "Orange Grove Rd at Rookwood Avenue, stop 56",
                        "Orange Grove Rd at Joyce Street, stop 57",
                        "Boundary Rd at Rosedale Street, stop 45/",
                        "Lensworth St near Selhurst St, stop 59",
                        "Beenleigh Rd at Morden Road, stop 60",
                        "Ditton Rd at Cromer Street, stop 62",
                        "Goman St near Ditton Rd, stop 63/64",
                        "Goman St at Exton Street, stop 65",
                        "Findon St near Midholm St, stop 67",
                        "Lang St near Debenham St, stop 68",
                        "Stones Rd near Lang St, stop 69",
                        "Stones Rd at Stones Road Reservoir, stop 70",
                        "Chilton St at Janina Street, stop 71",
                        "Chilton St at Garro Street, stop 72",
                        "Chilton St near Wynne St, stop 73",
                        "Wynne St at Torbey Street, stop 74",
                        "Wynne St near Garro St, stop 75",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Elva Street, stop 81",
                        "Zamia St at Sunnybank Plaza",
                        "McCullough St at Matt Street, stop 81",
                        "Station Rd at Wen Place, stop 80",
                        "Station Rd at Oasis Gardens, stop 79",
                        "Station Rd at Oasis, stop 78a",
                        "Station Rd at Young Street, stop 78",
                        "Lister St at Gager St, stop 77",
                        "Lister St at Boorman Street, stop 76",
                        "Selvage St near Mains Rd, stop 75/70",
                        "Kylie St near Norinda St, stop 71",
                        "Arcoona St at Jundal Street, stop 72",
                        "Arcoona St at Hedina Street, stop 73",
                        "Arcoona St near Valhalla St, stop 74",
                        "Comley St near Melaleuca St, stop 75",
                        "Granadilla St at Sunderland Street, stop 76",
                        "Granadilla St at Henderson Park, stop 77",
                        "Granadilla St at Ceriman Street, stop 78",
                        "Granadilla St at Mimosa Creek, stop 79",
                        "Parkway St near Springfield St, stop 80",
                        "Springfield St at Shirland Street, stop 81",
                        "Turnmill St near Wadley St, stop 82",
                        "Turnmill St at Dolphin Street, stop 83",
                        "Turnmill St at Freesia Street, stop 84",
                        "Freesia St at Muirfield Street, stop 85",
                        "Portulaca St near Gordonia St, stop 86",
                        "Garden City Shopping Centre station",
                        "Garden City Shopping Centre station, stop E",
                        "Endsleigh St near Nandina St, stop 87",
                        "Turnmill St near Springfield St, stop 82",
                        "Granadilla St near Darlington St, stop 7",
                        "Comley St near Delafield St, stop 75",
                        "Comley St at Arcoona Street, stop 74",
                        "Lister St at Selwyn Street, stop 75a",
                        "McCullough St at Station Road, stop 80a",
                        "Zamia St at Sunnybank Plaza, stop 82",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Lampson Street",
                        "Chilton St near Taminga St, stop 73",
                        "Lang St near Newcombe St, stop 68",
                        "Findon St near Jackson Rd, stop 67",
                        "Goman St near Ditton Rd, stop 64/63",
                        "Ditton Rd near Beaudesert Rd, stop 61",
                        "Boundary Rd at Rosedale Street, stop 45",
                        "Musgrave Rd at Boundary Street",
                        "Mandarin St at Nyleta Street, stop 53",
                        "Middle St near Troughton Rd, stop 54",
                        "Troughton Rd at QEII Hospital, stop 37",
                        "Griffith Rd at Recreation Road, stop 55a",
                        "Griffith University stop A",
                        "Griffith University station, platform 1"
                    ],
                    "125: Garden City - City/Valley via Salisbury": [
                        "MacGregor St at Garden City Depot",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 2",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University stop B",
                        "Kessels Rd near Troughton Rd, stop 55",
                        "Kessels Rd near Orange Grove Rd",
                        "Orange Grove Rd at Salisbury East, stop 51",
                        "Henson Rd at Salisbury East, stop 50",
                        "Henson Rd at Meynell Street, stop 49a",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Henson Rd at Ainger Street, stop 48",
                        "Cripps St at Salisbury Interchange",
                        "Lillian Ave at Tuckett Road, stop 49",
                        "Lillian Ave at Salisbury station",
                        "Beaudesert Rd at Moorooka South, stop 38",
                        "Beaudesert Rd at Muriel - Evans, stop 37",
                        "Beaudesert Rd at Fegan Drive, stop 36",
                        "Beaudesert Rd at Keats Street, stop 35",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Dora Street, stop 33",
                        "Beaudesert Rd at Moorvale, stop 32",
                        "Beaudesert Rd at Helles Street, stop 31",
                        "Beaudesert Rd at Colebrook - Wharton, stop 30",
                        "Beaudesert Rd at Stimpson Park, stop 29",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Ipswich Rd at School Road, stop 27",
                        "Ipswich Rd at Yeronga Park, stop 26",
                        "Ipswich Rd at Chardons Corner",
                        "Ipswich Rd at Venner - Waterton, stop 24",
                        "Ipswich Rd at Ekibin Road, stop 23",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Ipswich Rd at Victoria Terrace, stop 17",
                        "Ipswich Rd at Juliette Street, stop 16",
                        "Ipswich Rd at Cornwall Street, stop 15",
                        "Ipswich Rd at PA Hospital, stop 14",
                        "Ipswich Rd at OKeefe Street, stop 13",
                        "Ipswich Rd at Broadway, stop 10a",
                        "Ipswich Rd at Balaclava Street, stop 10",
                        "Woolloongabba station, platform 1",
                        "Margaret Street Stop 95 at Albert St",
                        "Eagle St near Eagle Lane (Stop 63)",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Wickham Street Stop 228 near Brunswick",
                        "Ballow St near Wickham Street Zone C",
                        "Ballow Street Stop 206 near Ann St",
                        "Ann Street Stop 218 at All Hallows",
                        "Eagle Street Stop 152 at Riverside Centre",
                        "Mary Street Stop 50 near Albert St",
                        "Woolloongabba station, platform 2",
                        "Jurgens St at Woolloongabba, stop E",
                        "Jurgens St at Balaclava Street, stop 10",
                        "Ipswich Rd at PA Hospital Citybus, stop 14A",
                        "Ipswich Rd at Juliette Street, stop 15/16",
                        "Ipswich Rd at Waldheim Street, stop 18/21",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ipswich Rd at Chardons Corner, stop 25",
                        "Ipswich Rd at Yeronga Park, stop 26/27",
                        "Fairlie Tce at Nyanda, stop 41",
                        "Lillian Ave at Kellett Road, stop 50L",
                        "Lillian Ave at Salisbury Interchange, zone A",
                        "Henson Rd at Meynell Street, stop 49A",
                        "Orange Grove Rd at Aldi, stop 52",
                        "Griffith Rd at Recreation Road, stop 55a",
                        "Griffith University stop A",
                        "Griffith University station, platform 1",
                        "Upper Mt Gravatt station, platform 2"
                    ],
                    "126: Heathwood - Sunnybank Plaza": [
                        "Parkwood Dr near Watergum St",
                        "Parkwood Dr near Acacia St",
                        "Parkwood Dr near Coolibah St",
                        "Parkwood Dr North near Laurel St",
                        "Ritchie Rd near Falkland St",
                        "Ritchie Rd near Kraft Rd",
                        "Brookbent Rd near Ivory Cres",
                        "Pallara Ave near Pipet Cr",
                        "Pallara Ave at Gooderham Rd",
                        "Watson Rd at Learoyd Road",
                        "Bellamy St at Acacia Ridge South near Benton St",
                        "Bellamy St near Marnham St",
                        "Mitchell St at Marnham St",
                        "Mitchell St at Acacia Ridge East",
                        "Beaudesert Rd at Durbell Street, stop 73",
                        "Bradman St at Overlord Street",
                        "Bradman St at Acacia Ridge Skills College",
                        "Bradman St at Bellrick Street",
                        "Beenleigh Rd at Morden Road, stop 60",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Elva Street, stop 81",
                        "Zamia St at Sunnybank Plaza",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Lampson Street",
                        "Bradman St at Acacia Ridge TAFE",
                        "Beaudesert Rd near Paradise Rd, stop 72",
                        "Bellamy St near Limerick St",
                        "Pallara Ave near Brookbent Rd",
                        "Brookbent Rd at Gooderham Rd",
                        "Richie Rd near Falkland St",
                        "Parkwood Dr North near Beech St",
                        "Parkwood Dr at Parkwood Drive South"
                    ],
                    "127: Indooroopilly - Fairfield": [
                        "Honour Ave at Chelmer station",
                        "Station Rd at Indooroopilly Shopping Ctr, stop D",
                        "Honour Ave at Graceville near Verney Rd",
                        "Coonan St at Indooroopilly station, stop 53",
                        "Wharf St near Bridge St, stop 52",
                        "Honour Ave at Sherwood Forest",
                        "Oxley Rd at Milpera, stop 51",
                        "Sherwood Rd near Hedges St",
                        "Oxley Rd at Graceville State School, stop 50",
                        "Graceville Ave at Oxley Rd, stop 48",
                        "Graceville Ave near Erroll St, stop 47",
                        "Oxley Rd at Graceville Uniting Church, stop 49",
                        "Graceville Ave near Erroll St, stop 46",
                        "Graceville Ave at Riverside Village, stop 45",
                        "Graceville Ave at Graceville - Nadine, stop 44",
                        "King Arthur Tce at King Arthur - Oxley Ck, stop 43",
                        "King Arthur Tce at Merlin Street, stop 41/40",
                        "King Arthur Tce at Dexter Street, stop 39",
                        "Softstone St near Myla Tce, stop 38",
                        "Tennyson Memorial Ave near Walker St, stop 37",
                        "Tennyson Memorial Ave at Varley Street, stop 35",
                        "Fairfield Rd at Ortive St, stop 33",
                        "Wilkie St near Cardross St, stop 32",
                        "Wilkie St near Crichton St, stop 31",
                        "Green St at Yeerongpilly station, stop 30",
                        "Green St near Biarra St, stop 29",
                        "Wingarra St near Crichton St, stop 28",
                        "Crichton St near Park Rd, stop 27",
                        "Park Rd at Park - Oloan, stop 26",
                        "Park Rd at School Rd, stop 25",
                        "Park Rd at Yeronga State School, stop 23/24",
                        "Park Rd at Memorial Park",
                        "Park Rd near Fairfield Rd, stop 21",
                        "Fairfield Rd at Ovendean Street, stop 21",
                        "Kadumba St near Eversley Tce, stop 23",
                        "Kadumba St at Kadumba - Colevale, stop 25",
                        "Kadumba St at Kadumba - Douglas, stop 26A",
                        "Kadumba St at St Sebastians School, stop 26",
                        "Kadumba St at Kadumba-Rome St South, stop 27",
                        "Kadumba St at Kadumba - Rhyndarra, stop 28",
                        "Orestes Rd near Rhyndarra St, stop 29",
                        "Orlando Rd near Orama Rd, stop 34/30",
                        "Orlando Rd at Wanganui Gardens, stop 35",
                        "Brisbane Corso near Ormuz Rd, stop 34",
                        "Orsova Rd at Orsova-Brisbane Corso, stop 33",
                        "Orsova Rd near Orvieto Rd, stop 32/31",
                        "Hyde Rd near Utzon St, stop 31",
                        "Hyde Rd at Rome Street North, stop 27",
                        "Hyde Rd near Cansdale St, stop 26/24",
                        "Cansdale St near Hyde Rd, stop 23a",
                        "Brisbane Corso near William Pde, stop 24/17",
                        "Turner Ave near Brougham St, stop 17",
                        "Ashby St near Newcastle St, stop 18",
                        "Ashby St at Fairfield Rd, stop 19",
                        "Fairfield Rd at Brougham Street, stop 17A",
                        "Brougham St near Fairfield Rd, stop 18",
                        "Ashby St near Sydney St, stop 19",
                        "Brisbane Corso near William Pde, stop 17/24",
                        "Cansdale St near Venner Rd, stop 23A",
                        "Hyde Rd at Cansdale St, stop 26",
                        "Orsova Rd near Orontes Rd, stop 32",
                        "Orsova Rd near Brisbane Corso, stop 33",
                        "Brisbane Corso at Wanganui Gardens, stop 35",
                        "Orlando Rd near Orama Rd, stop 34s/30",
                        "Rhyndarra St at Kadumba St, stop 28",
                        "Kadumba St at Colevale Lane, stop 25",
                        "Kadumba St near Fairfield Rd, stop 22",
                        "Park Rd near Christensen St",
                        "Park Rd near OLoan St, stop 26",
                        "Park Rd at Park - Chrichton, stop 27",
                        "Wingarra St at Crichton St, stop 28",
                        "Green St at Biarra St, stop 29",
                        "Fairfield Rd at Fairfield - Ortive, stop 33",
                        "Varley St near Pulle St, stop 35",
                        "Tennyson Memorial Ave at Brisbane Golf, stop 36",
                        "Softstone St near King Arthur Tce, stop 38",
                        "Graceville Ave at Graceville - Oxley, stop 48",
                        "Station Rd at Indooroopilly Shopping Ctr, stop E"
                    ],
                    "130: Parkinson - City": [
                        "Illaweena St at Stretton Gardens",
                        "Calam Rd near Lear St",
                        "Illaweena St at Waterstone",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Illaweena St at Tamarisk Way",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Algester Rd at Lichfield Place, stop 93",
                        "Algester Rd at Parkinson East, stop 92",
                        "Pinelands",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Mains Rd at Altandi, stop 68",
                        "Algester Rd at Parkinson, stop 90",
                        "Mains Rd at Turton Street, stop 80",
                        "Algester Rd at Glenfield",
                        "Mains Rd at Sunnybank",
                        "Algester Rd at Nottingham",
                        "Mains Rd at Robertson",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Mains Road park 'n' ride",
                        "Griffith University station, platform 1",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Mater Hill station, platform 1",
                        "Ridgewood Rd at Algester",
                        "South Bank busway station, platform 1",
                        "Algester Rd at Algester East Stop 79",
                        "Cultural Centre station, platform 1",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Beaudesert Rd at Highlands Drive",
                        "Queen Street station",
                        "Queen Street station, 1e",
                        "Cordelia St at Brisbane State High, stop 3",
                        "Stephens Rd at St Laurences College, stop 7",
                        "Griffith University station, platform 2",
                        "Cultural Centre station, platform 2",
                        "Stephens Rd near Brook St",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Calam Rd near Honeywood St",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Algester Rd at Injune Cct, stop 93",
                        "Gowan Rd at Stretton State College"
                    ],
                    "131: Parkinson - City via Hellawell Rd": [
                        "Algester Rd at Parkinson East, stop 92",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Laurel Oak Drive Stop 90A",
                        "Algester Rd at Crestone Street Stop 90/89",
                        "Algester Rd at Formby Street Stop 88A",
                        "Endiandra St at Macaranga Street, stop 88",
                        "Endiandra St near Macaranga St, stop 87",
                        "Endiandra St at Bonewood Street, stop 86/85",
                        "Ridgewood Rd at Algester",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Hellawell Rd at Cazna Gardens",
                        "Hellawell Rd at Signata Street",
                        "Pinelands Rd at Hellawell",
                        "Pinelands",
                        "Mains Rd at Sunnybank",
                        "Mains Road park 'n' ride",
                        "Griffith University station, platform 1",
                        "Elizabeth Street Stop 82",
                        "Edward Street Stop 146 at Stamford Plaza",
                        "Alice Street Stop 102 at George St",
                        "Griffith University station, platform 2",
                        "Hellawell Rd near Hillcrest St, stop 73/16",
                        "Ridgewood Rd at Algester, stop 83",
                        "Endiandra St at Bonewood Street, stop 85/86",
                        "Endiandra St near Satinash St, stop 87",
                        "Algester Rd at Formby Street Stop 89"
                    ],
                    "132: Parkinson/Algester - Garden City": [
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Nottingham",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Algester",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Hellawell Rd at Cazna Gardens",
                        "Hellawell Rd at Stringybark Street, stop 75",
                        "Hellawell Rd at Signata Street",
                        "Hellawell Rd at Hillcrest Street, stop 72a",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "McCullough St near Mains Rd",
                        "McCullough St at Granadilla",
                        "Padstow Rd at Devonlea",
                        "Warrigal Road Green Link",
                        "MacGregor St at Garden City Depot",
                        "Garden City Shopping Centre station",
                        "Garden City Shopping Centre station, stop E",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Hellawell Rd near Hillcrest St, stop 73/16",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Ridgewood Park near Yorrell"
                    ],
                    "134: Griffith University - City Rocket": [
                        "Griffith University stop A",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "George Street Stop 116",
                        "Roma Street busway, platform 1",
                        "Roma Street busway, platform 2",
                        "Queen Street station, 1f",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Griffith University stop B"
                    ],
                    "135: Parkinson - Griffith Uni busway Express": [
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Nottingham",
                        "Nottingham Rd near Algester Rd",
                        "Nottingham Rd at Avondale",
                        "Holyrood St near Benhiam St",
                        "Benhian St at Fatima Place",
                        "Hamish St near Murphy St",
                        "Beaudesert Rd at Benhiam Street",
                        "Beaudesert Rd at Highlands Drive",
                        "Hellawell Rd at Cazna Gardens",
                        "Hellawell Rd at Signata Street",
                        "Borella Rd at Bendell Park",
                        "Wynne St at Chilton Street East, stop 74",
                        "Wynne St near Garro St, stop 75",
                        "Mains Rd at Altandi, stop 68",
                        "Lister St at Gager St, stop 77",
                        "Station Rd at Oasis, stop 78a",
                        "Turton St at Sunnybank State School",
                        "Troughton Rd at Banoon",
                        "Troughton Rd at Brittain Park",
                        "Troughton Rd at Musgrave Road, stop 39",
                        "Troughton Rd at QEII Hospital, stop 37",
                        "Griffith University stop A",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University station, platform 1",
                        "Griffith University station, platform 2",
                        "Griffith University stop B",
                        "Troughton Rd at QEII Hospital",
                        "Troughton Rd at Musgrave Road",
                        "Troughton Rd at Banoon near Turton St",
                        "Ormskirk St near Riley St",
                        "Hamish St at Murphy St"
                    ],
                    "137: Sunnybank Hills - City Rocket": [
                        "Beaudesert Rd at Highlands Drive",
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Robertson",
                        "Mains Road park 'n' ride",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Elizabeth Street Stop 82",
                        "Edward Street Stop 146 at Stamford Plaza",
                        "Alice Street Stop 102 at George St",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Calam Rd near Honeywood St"
                    ],
                    "138: Algester - City": [
                        "Nottingham Rd at Lakewood",
                        "Holyrood St near Benhiam St",
                        "Benhian St at Fatima Place",
                        "Hamish St near Murphy St",
                        "Beaudesert Rd at Benhiam Street",
                        "Compton Rd near Chateau St, stop 84",
                        "Compton Rd at Frizzell Street, stop 85",
                        "Compton Rd at Kyabra Street, stop 86",
                        "Compton Rd at Piccadilly Way, stop 28",
                        "Eight Mile Plains routing stop",
                        "Upper Mt Gravatt station, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Upper Mt Gravatt station, platform 2",
                        "Compton Rd near Kyabra Street, stop 86",
                        "Compton Rd near Chateau St, stop 25",
                        "Ormskirk St near Riley St",
                        "Hamish St at Murphy St"
                    ],
                    "139: Sunnybank Hills - UQ Lakes": [
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Robertson",
                        "Mains Road park 'n' ride",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Dutton Park Place",
                        "UQ Lakes station",
                        "UQ Lakes stop D",
                        "Boggo Road station, platform 5",
                        "PA Hospital station, platform 1",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Calam Rd near Honeywood St"
                    ],
                    "140: Browns Plains - City Express via Mains Road": [
                        "Beaudesert Rd at Illaweena Street",
                        "Browns Plains station, stop 3A",
                        "Greenbank RSL park 'n' ride",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd at Benhiam Street",
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Robertson",
                        "Mains Road park 'n' ride",
                        "Griffith University station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Queen Street station",
                        "Queen Street station, 1d",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Griffith University station, platform 2",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd at Honeysuckle Way"
                    ],
                    "141: Browns Plains - City Rocket": [
                        "Greenbank RSL park 'n' ride",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 3A",
                        "Beaudesert Rd at Illaweena Street",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd at Benhiam Street",
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands",
                        "Mains Rd at Sunnybank",
                        "Mains Road park 'n' ride",
                        "Griffith University station, platform 1",
                        "Elizabeth Street Stop 82",
                        "Edward Street Stop 146 at Stamford Plaza",
                        "Alice Street Stop 102 at George St",
                        "Griffith University station, platform 2",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd at Honeysuckle Way"
                    ],
                    "142: Browns Plains - City Bullet": [
                        "Greenbank RSL park 'n' ride",
                        "Eight Mile Plains routing stop",
                        "Elizabeth Street Stop 82",
                        "Edward Street Stop 146 at Stamford Plaza",
                        "Alice Street Stop 102 at George St",
                        "Browns Plains station"
                    ],
                    "150: Browns Plains - City Express via Runcorn": [
                        "Gowan Rd at Gowan and Compton",
                        "Browns Plains station, stop 3B",
                        "Beaudesert Rd at Illaweena Street",
                        "Gowan Rd near Blackbean St",
                        "Honeysuckle Way at Sunflower",
                        "Nemies Rd at Runcorn West",
                        "Honeysuckle Way at Calamvale",
                        "Nemies Rd at Runcorn Heights",
                        "Gowan Rd at The Parks",
                        "Nursery Ave at Runcorn",
                        "Gowan Rd at Parkside",
                        "Nursery Ave near Marika St",
                        "Beenleigh Rd at Fruitgrove station",
                        "Gowan Rd at Pennant Hills",
                        "Warrigal Rd at Fruitgrove",
                        "Gowan Rd at Calam North, stop 35",
                        "Warrigal Rd at Runcorn North",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Padstow Views",
                        "Warrigal Road Green Link",
                        "MacGregor St at Garden City Depot",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Queen Street station",
                        "Griffith University station, platform 2",
                        "Cordelia St at Brisbane State High, stop 3",
                        "Stephens Rd at St Laurences College, stop 7",
                        "Queen Street station, 1c",
                        "Upper Mt Gravatt station, platform 2",
                        "Cultural Centre station, platform 2",
                        "Stephens Rd near Brook St",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Nursery Ave at Runcorn near Silkyoak St",
                        "Nemies Rd at Runcorn Heights near Basking St",
                        "Nemies Rd at Runcorn West near Belyando St",
                        "Honeysuckle Way at The Parks",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station"
                    ],
                    "152: Stretton - Garden City": [
                        "Harrison St at Washington Place, stop 90",
                        "Penson St near Cleveland Pl, stop 91",
                        "Roosevelt Dr near Penson St, stop 88",
                        "Ian Lynas Memorial Park",
                        "Compton Rd near Kyabra Street, stop 86",
                        "Compton Rd at Frizzell Street, stop 85",
                        "Compton Rd near Chateau St, stop 25",
                        "Honeywood St near Calam Rd, stop 81",
                        "Honeywood St at Honeywood Street Park, stop 80",
                        "Gowan Rd near Blackbean St",
                        "Nemies Rd at Runcorn West",
                        "Brandon Rd near Impala Street, stop 77",
                        "Brandon Rd near Winston St, stop 76",
                        "Brandon Rd at Ellen Street, stop 75",
                        "Gowan Rd near Coori Street, stop 74",
                        "Gowan Rd near Darnell Street, stop 73",
                        "Beenleigh Rd at Runcorn Railway, stop 72",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Bonemill Rd near Abercorn St, stop 70",
                        "Bonemill Rd at Bill Ardill Field, stop 69",
                        "Leopardwood St at Zinnia Court, stop 68",
                        "Leopardwood St near Allamanda St, stop 67",
                        "Daw Rd at Diamond Place, stop 66",
                        "Daw Rd at Hill Road, stop 65",
                        "Daw Rd near Warrigal Rd, stop 64",
                        "Underwood Rd near Warrigal Rd, stop 89",
                        "Underwood Rd at Mapleleaf Street, stop 88",
                        "Gaskell St near Underwood Rd, stop 87",
                        "Gaskell St at Alan Crescent, stop 86",
                        "Gaskell St at Angel Street, stop 85",
                        "Gaskell St at The Glen, stop 84",
                        "Logan Rd at Brandl Street, stop 83",
                        "Logan Rd at Miles Platting Road, stop 82",
                        "Logan Rd near Liverpool St, stop 81",
                        "MacGregor St at Garden City Depot",
                        "Garden City Shopping Centre station",
                        "Garden City Shopping Centre station, stop E",
                        "Daw Rd near Runcorn Plaza Shopping Centre",
                        "Gowan Rd at Darnell Street, stop 73",
                        "Brandon Rd at Impala Street, stop 77",
                        "Nemies Rd at Runcorn West near Belyando St",
                        "Gowan Rd at Calliope Street, stop 79",
                        "Honeywood St near Cherrywood St, stop 79a",
                        "Calam Rd near Honeywood St",
                        "Compton Rd near Chateau St, stop 84",
                        "Compton Rd at Kyabra Street, stop 86",
                        "Eisenhower St at Park, stop 87",
                        "Eisenhower St near Hoover Ct, stop 88",
                        "Harrison St at Truman Court, stop 89"
                    ],
                    "153: Drewvale - City Rocket": [
                        "Trinity Way at Mirthwood Drive",
                        "Trinity Way at Westcott St",
                        "MacQuarie Way at Lockyer Place",
                        "MacQuarie Way near Buckley Drive",
                        "MacQuarie Way near Wembley Rd",
                        "Illaweena St at Stretton Gardens",
                        "Illaweena St at Waterstone",
                        "Illaweena St at Tamarisk Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Honeysuckle Way at Sunflower",
                        "Honeysuckle Way at Calamvale",
                        "Gowan Rd at The Parks",
                        "Gowan Rd at Parkside",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd near Blackbean St",
                        "Nemies Rd at Runcorn West",
                        "Nemies Rd at Runcorn Heights",
                        "Persse Rd at The Oaks",
                        "Persse Rd near Gumtree St",
                        "Upper Mt Gravatt station, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains routing stop",
                        "Nemies Rd at Runcorn Heights near Basking St",
                        "Nemies Rd at Runcorn West near Belyando St",
                        "Honeysuckle Way at The Parks",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Algester Rd at Injune Cct, stop 93",
                        "MacQuarie Way at Buckley Drive"
                    ],
                    "155: Eight Mile Plains - Griffith Uni via Sunnybank": [
                        "Eight Mile Plains station, platform 2",
                        "Miles Platting Rd at McKechnie Dr",
                        "Logan Rd at Miles Platting Road, stop 82",
                        "Logan Rd at Brandl Street, stop 83",
                        "Gaskell St at The Glen, stop 84",
                        "Gaskell St at Alan Crescent, stop 86",
                        "Gaskell St near Underwood Rd, stop 87",
                        "Underwood Rd at Mapleleaf Street, stop 88",
                        "Underwood Rd near Warrigal Rd, stop 89",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Padstow Views",
                        "Padstow Rd at Devonlea",
                        "McCullough St at Granadilla",
                        "Zamia St at Sunnybank Plaza",
                        "McCullough St at Matt Street, stop 81",
                        "McCullough St at Brooklands",
                        "Boundary Rd at Beechcroft Street",
                        "Augstein St near Comer St, stop 59",
                        "Orange Grove Rd at Joyce Street, stop 57",
                        "Orange Grove Rd at Rookwood Avenue, stop 56",
                        "Orange Grove Rd at Bosworth Street, stop 55",
                        "Orange Grove Rd at QG Laboratory",
                        "Orange Grove Rd at Aldi, stop 52",
                        "Griffith Rd at Recreation Road, stop 55a",
                        "Griffith University stop A",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University station, platform 1",
                        "Griffith University station, platform 2",
                        "Griffith University stop B",
                        "Kessels Rd near Troughton Rd, stop 55",
                        "Kessels Rd near Orange Grove Rd",
                        "Boundary Rd at Babbidge Street, stop 44/58",
                        "Boundary Rd at Augstein Street, stop 59",
                        "McCullough St at Station Road, stop 80a",
                        "Zamia St at Sunnybank Plaza, stop 82",
                        "McCullough St at Sunnybank Plaza",
                        "McCullough St near Mains Rd",
                        "Gaskell St at Angel Street, stop 85",
                        "Brandl St near Logan Rd",
                        "McKechnie Dr near Electronics St",
                        "Miles Platting Rd at Brisbane Technology Park",
                        "Eight Mile Plains station, platform 1"
                    ],
                    "156: Stretton - City Rocket": [
                        "Compton Rd at Piccadilly Way, stop 28",
                        "Eisenhower St at Park, stop 87",
                        "Eisenhower St near Hoover Ct, stop 88",
                        "Harrison St at Truman Court, stop 89",
                        "Harrison St at Washington Place, stop 90",
                        "Penson St near Cleveland Pl, stop 91",
                        "Roosevelt Dr near Penson St, stop 88",
                        "Ian Lynas Memorial Park",
                        "Compton Rd near Kyabra Street, stop 86",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd near Blackbean St",
                        "Nemies Rd at Runcorn West",
                        "Nemies Rd at Runcorn Heights",
                        "Nursery Ave at Runcorn",
                        "Nursery Ave near Marika St",
                        "Beenleigh Rd at Fruitgrove station",
                        "Warrigal Rd at Fruitgrove",
                        "Warrigal Rd at Runcorn North",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Padstow Views",
                        "Warrigal Road Green Link",
                        "Upper Mt Gravatt station, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Upper Mt Gravatt station, platform 2",
                        "Nursery Ave at Runcorn near Silkyoak St",
                        "Nemies Rd at Runcorn Heights near Basking St",
                        "Nemies Rd at Runcorn West near Belyando St",
                        "Compton Rd at Frizzell Street, stop 85",
                        "Compton Rd at Kyabra Street, stop 86"
                    ],
                    "161: Wishart Outlook - Griffith University busway": [
                        "Griffith University station, platform 2",
                        "Holmead Rd at Brisbane Holiday Village",
                        "Holmead Rd at Nardie St",
                        "Klumpp Rd at Hibiscus",
                        "Klumpp Rd at Klumpp-Dawson",
                        "Nardie St at Goorari St",
                        "Nardie St at Blue Grass Cr",
                        "Dawson Rd at Gerty Street, stop 79",
                        "Nardie St at Vanderbilt St",
                        "Dawson Rd at Gurney Street, stop 78",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Holmead Rd near Brampton St",
                        "Wemvern St at Lumley Street, stop 76a",
                        "Holmead Rd at Wishart Lookout",
                        "Wemvern St at Zetland Street, stop 76",
                        "Wemvern St at Wanda Street, stop 75",
                        "MacGregor St at Garden City Depot",
                        "Garden City Shopping Centre station, stop L",
                        "Wishart Rd at Newnham Road, stop 44/74",
                        "Wishart Rd near Pasley St, stop 75",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Wishart Rd near Elkana Pl, stop 76",
                        "Mt Gravatt Capalaba Rd at Agaton",
                        "Wishart Rd near Ham Rd, stop 77",
                        "Mt Gravatt Capalaba Rd at Ham Road South",
                        "Ham Rd at Koola Street, stop 78",
                        "Wishart Rd near Hibiscus Cl, stop 77",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Wishart Rd at Newnham Road, stop 74/44",
                        "Garden City Shopping Centre station, stop J",
                        "Cale St near Dawson Rd, stop 76b",
                        "Griffith University station, platform 1"
                    ],
                    "162: Eight Mile Plains - City Rocket": [
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2"
                    ],
                    "169: Eight Mile Plains - UQ Lakes": [
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Dutton Park Place",
                        "UQ Lakes station",
                        "UQ Lakes stop C",
                        "Boggo Road station, platform 5",
                        "PA Hospital station, platform 1",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2"
                    ],
                    "171: Garden City - City Rocket via Newnham Road": [
                        "Garden City Shopping Centre station, stop F",
                        "Newnham Rd near Tryon St, stop 79",
                        "Newnham Rd at Delavan, stop 78",
                        "Newnham Rd at Montreal Street, stop 77a",
                        "Newnham Rd at Arila Street, stop 77",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Tolson Street, stop 75",
                        "Newnham Rd at Civic Fair, stop 73",
                        "Newnham Rd at Broadwater Rd, stop 72",
                        "Newnham Rd at Westbrooke Street, stop 71",
                        "Newnham Rd at Condong Street, stop 70/63",
                        "Newnham Rd at Enderby Street, stop 62",
                        "Mt Gravatt East School - 61",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Creek Rd at Greek Memorial, stop 59b",
                        "Creek Rd at Fairland Street",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Glindemann Park, stop 33",
                        "Logan Rd at Boronia Street, stop 32",
                        "Logan Rd at Holland Park South, stop 31",
                        "Birdwood Rd at Wellers Hill, stop 2",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Charlotte Street Stop 52 near Edward St",
                        "George Street Stop 123 near Alice St",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Birdwood Rd at Wellers Hill",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Newnham Rd at Condong Street, stop 63/70",
                        "Newnham Rd at Montreal Street, stop 77A",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "172: Garden City - PA Hospital via Greenslopes": [
                        "Garden City Shopping Centre station, stop F",
                        "Logan Rd at Marada Street, stop 79b",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Dawson Rd at Gerty Street, stop 79",
                        "Dawson Rd at Gurney Street, stop 78",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Wemvern St at Lumley Street, stop 76a",
                        "Wemvern St at Zetland Street, stop 76",
                        "Wemvern St at Wanda Street, stop 75",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Wishart Rd at Exmoor Street, stop 42",
                        "Hillgrove St at Kingsway Street, stop 41",
                        "Broadwater Rd at Hillgrove, stop 40",
                        "Broadwater Rd at Wardle Street, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Fairland Street",
                        "Kentish St at Canterbury Street, stop 59",
                        "Kentish St at Pond Street, stop 58",
                        "Camlet St near Kentish St, stop 57/41",
                        "Dunbar St at Oakfield Street, stop 56",
                        "Dunbar St near Boambillee St, stop 54",
                        "Carrara St at Yarranabbe Street, stop 53",
                        "Carrara St at Carrara Shops, stop 52",
                        "Nursery Rd at Crewe Street, stop 51",
                        "David Rd near Oates Ave, stop 50",
                        "Cradock St at Mar Street, stop 49",
                        "Seville Rd at Seville Shops, stop 48",
                        "Seville Rd near Glindemann Dr, stop 47c",
                        "Glindemann Dr near Seville Rd, stop 47b",
                        "Elgar St near Olroy St, stop 47a",
                        "Elgar St at Macklin St",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Holland Rd at Greenmount Avenue, stop 45",
                        "Holland Rd near Rita St, stop 44",
                        "Holland Rd at Lamette Avenue, stop 43A",
                        "Logan Rd at Holland Park, stop 29",
                        "Logan Rd at Harold Street, stop 28",
                        "Logan Rd at Swain Street, stop 27",
                        "Logan Rd at CB Mott Park, stop 26",
                        "Logan Rd at Greenslopes Mall, stop 25/24",
                        "Nicholson St near Hunter St, stop 23b",
                        "Headfort St near Newdegate St, stop 23a",
                        "Newdegate St at Greenslopes Hospital, stop 23",
                        "Newdegate St near Denman St, stop 22",
                        "Ridge St near Cedar St, stop 21a",
                        "Barnsdale Pl near Ridge St",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Lower Level at PA Hospital station",
                        "PA Hospital station, platform 1",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Ridge St near Henry St, stop 21a",
                        "Newdegate St near Denham St, stop 22",
                        "Headfort St near Nicholson St, stop 23a",
                        "Logan Rd at Greenslopes Mall, stop 24",
                        "Logan Rd at Raff Ave, stop 25",
                        "Logan Rd at Barter St, stop 30",
                        "Holland Rd near Stewart St, stop 44",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Elgar St at Rowton Street, stop 47",
                        "Seville Rd near Dobbie St, stop 47c",
                        "Cradock St near Beddoes St, stop 48a",
                        "David Rd near Wollombi Pl, stop 50",
                        "Hillgrove St at Exmoor Street, stop 42",
                        "Cale St near Dawson Rd, stop 76b",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "175: Garden City - City via Logan Rd": [
                        "Garden City Shopping Centre station, stop C",
                        "Logan Rd at Marada Street, stop 79b",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Glindemann Park, stop 33",
                        "Logan Rd at Boronia Street, stop 32",
                        "Logan Rd at Holland Park South, stop 31",
                        "Logan Rd at Barter Street, stop 30",
                        "Logan Rd at Holland Park, stop 29",
                        "Logan Rd at Harold Street, stop 28",
                        "Logan Rd at Swain Street, stop 27",
                        "Logan Rd at CB Mott Park, stop 26",
                        "Logan Rd at Greenslopes Mall, stop 25/24",
                        "Logan Rd at Donaldson Street, stop 23",
                        "Logan Rd at Greenslopes, stop 22",
                        "Logan Rd at Greenslopes School, stop 21",
                        "Logan Rd at Bardsley Avenue, stop 20",
                        "Logan Rd at Logan Rd North, stop 19",
                        "Logan Rd at Vine Street, stop 18",
                        "Logan Rd at Stones Corner Shops, stop 17",
                        "Old Cleveland Rd at Stones Corner Library, stop 17",
                        "Logan Rd at Buranda Railway, stop 16/14",
                        "Logan Rd at Vanda Street, stop 13",
                        "Logan Rd at Buranda Street, stop 12",
                        "Logan Rd at Lewis Street, stop 11",
                        "Logan Rd at Walker Street, stop 10a",
                        "Stanley St at Jurgens Street, stop F",
                        "Woolloongabba station, platform 1",
                        "Margaret Street Stop 95 at Albert St",
                        "Eagle St near Eagle Lane (Stop 63)",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Warner Street Stop 203 near Wickham St",
                        "Warner Street Stop 204 near Ann St",
                        "Ann Street Stop 218 at All Hallows",
                        "Eagle Street Stop 152 at Riverside Centre",
                        "Mary Street Stop 50 near Albert St",
                        "Woolloongabba station, platform 2",
                        "Jurgens St at Woolloongabba, stop E",
                        "Logan Rd at Lotus Street, stop 10a",
                        "Logan Rd at Lewis Street, stop 11/12",
                        "Logan Rd at Buranda Railway, stop 14/16",
                        "Logan Rd at Stones Corner Shops, stop 17a",
                        "Logan Rd at Greenslopes Mall, stop 24",
                        "Logan Rd at Raff Ave, stop 25",
                        "Logan Rd at Barter St, stop 30",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "176: Garden City - City Rocket via Logan Road": [
                        "Garden City Shopping Centre station, stop C",
                        "Logan Rd at Marada Street, stop 79b",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Nursery Rd at Iris Street, stop 67",
                        "Nursery Rd at Marvin Street, stop 66",
                        "Nursery Rd at Flynn Street, stop 65",
                        "Nursery Rd at Gaza Road, stop 64",
                        "Birdwood Rd at Wellers Hill, stop 2",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Charlotte Street Stop 52 near Edward St",
                        "George Street Stop 123 near Alice St",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Birdwood Rd at Wellers Hill",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "177: Carindale - Griffith Uni Mt Gravatt": [
                        "Carindale Shopping Centre station, platform E",
                        "Donnington St at Donnington, stop 53",
                        "Donnington St at Stanmere, stop 52",
                        "Creek Rd near Donnington St, stop 70",
                        "Creek Rd at Salvin Park, stop 69",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Greenmeadow Rd near Cornflower St, stop 66",
                        "Greenmeadow Rd near Harvest St, stop 65",
                        "Greenmeadow Rd near Bluebell St, stop 64",
                        "Greenmeadow Rd near Canter St, stop 63",
                        "Greenmeadow Rd near Raintree St, stop 62",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Creek Rd at Greek Memorial, stop 59b",
                        "Creek Rd at Fairland Street",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Nursery Rd at Iris Street, stop 67",
                        "Nursery Rd at Marvin Street, stop 66",
                        "Fielding St near Middleton St, stop 65",
                        "Greening St near Vaughan St, stop 64",
                        "Gaynesford St near Stanhope St, stop 63",
                        "Gaynesford St near Donfern St, stop 62",
                        "Gaynesford St near Bartels St, stop 61",
                        "Gaynesford St at Gaynesford Street South, stop 60",
                        "Circular Dr at Griffith University, stop B",
                        "Griffith University Sports Rd",
                        "Gaynesford St near Clough St, stop 62",
                        "Gaynesford St near Greening St, stop 63",
                        "Fielding St near Rockingham St, stop 66",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Greenmeadow Rd near Honeysuckle St, stop 61",
                        "Greenmeadow Rd at Greenmeadows",
                        "Greenmeadow Rd near Creek Rd, stop 66",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "179: Garden City - UQ Express via Newnham Rd": [
                        "Garden City Shopping Centre station, stop H",
                        "Newnham Rd at Delavan, stop 78",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Civic Fair, stop 73",
                        "Broadwater Rd at Hillgrove, stop 40",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Holland Park South, stop 31",
                        "Birdwood Rd at Wellers Hill, stop 2",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Dutton Park Place",
                        "UQ Lakes station",
                        "UQ Lakes stop D",
                        "Boggo Road station, platform 5",
                        "PA Hospital station, platform 1",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Birdwood Rd at Wellers Hill",
                        "Garden City Shopping Centre station"
                    ],
                    "180: Garden City - City Express via Mansfield": [
                        "Garden City Shopping Centre station, stop H",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Mt Gravatt Capalaba Rd at Agaton",
                        "Mt Gravatt Capalaba Rd at Ham Road South",
                        "Mt Gravatt Capalaba Rd at Wishart East",
                        "Broadwater Rd at Mansfield Park",
                        "Broadwater Rd near Ham Rd",
                        "Cresthaven Dr at Cresthaven, stop 74",
                        "Aminya St at Mansfield, stop 67a",
                        "Luprena St at Mansfield North near Amoria St",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Holland Rd near Rita St, stop 44",
                        "Logan Rd at Holland Park, stop 29",
                        "Logan Rd at Greenslopes Mall, stop 25/24",
                        "Logan Rd at Greenslopes, stop 22",
                        "Buranda busway, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Queen Street station",
                        "Queen Street station, 3a",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Buranda busway, platform 2",
                        "Logan Rd at Greenslopes Mall, stop 24",
                        "Holland Rd near Stewart St, stop 44",
                        "Garden City Shopping Centre station"
                    ],
                    "181: Carindale Heights - City Rocket": [
                        "Greendale Way at Ridgeview St",
                        "Greendale Way at Empress Drive",
                        "Pine Mountain Rd near Gretna St",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Greenmeadow Rd near Cornflower St, stop 66",
                        "Greenmeadow Rd near Harvest St, stop 65",
                        "Greenmeadow Rd near Bluebell St, stop 64",
                        "Greenmeadow Rd near Canter St, stop 63",
                        "Greenmeadow Rd near Raintree St, stop 62",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Cavendish Rd at Seton College stop 59/56",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Turquoise Street, stop 49/43",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Chatsworth Rd at Stirrat Street, stop 31",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Charlotte Street Stop 51 near Albert St",
                        "George Street Stop 123 near Alice St",
                        "Buranda busway, platform 2",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Greenmeadow Rd near Honeysuckle St, stop 61",
                        "Greenmeadow Rd at Greenmeadows",
                        "Greenmeadow Rd near Creek Rd, stop 66",
                        "Pine Mountain Rd near Brechin St",
                        "Pine Mountain Rd near Flame Tree Cr",
                        "Pine Mountain Rd near Linwood St",
                        "Pine Mountain Rd at Greendale Village"
                    ],
                    "182: Garden City - Holland Park": [
                        "Garden City Shopping Centre station, stop I",
                        "Tryon St at Mascar Street, stop 81",
                        "Tryon St at Centre Tryon Street, stop 80",
                        "Tryon St at Greenleaves Village, stop 79",
                        "Delavan St at Delavan Terminus, stop 78/87",
                        "Delavan St at Wolcott Street, stop 86",
                        "Delavan St at Delavan Street Park, stop 85",
                        "Cummin St near Monte Carlo St, stop 84",
                        "Mannetto St near Matincock St, stop 83",
                        "Mannetto St at Gilgo Street, stop 82",
                        "Greenwood St near Kavanagh Rd, stop 81",
                        "Mindona St at Mindona Park, stop 80",
                        "Boyanda St near Tyrrell St, stop 79",
                        "Ham Rd at Koola Street, stop 78",
                        "Ham Rd at Adnar Street, stop 77",
                        "Broadwater Rd near Ham Rd",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Cresthaven Dr at Cresthaven, stop 74",
                        "Cresthaven Dr at Salandra Street, stop 67c/73",
                        "Aminya St at Mansfield, stop 67a",
                        "Olivella St near Luprena St, stop 66",
                        "Luprena St at Arura Street, stop 65",
                        "Linfield St near Morialta St, stop 64d",
                        "Ham Rd at Banika Street, stop 64c",
                        "Wecker St at Eastwood Drive, stop 64b",
                        "Wecker Rd at Dividend Street, stop 64a",
                        "Wecker Rd at Wecker Rd Business Center, stop 63",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Creek Rd at Greek Memorial, stop 59b",
                        "Creek Rd at Fairland Street",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Nursery Rd at Iris Street, stop 67",
                        "Nursery Rd at Marvin Street, stop 66",
                        "Nursery Rd at Flynn Street, stop 65",
                        "Nursery Rd at Gaza Road, stop 64",
                        "Bapaume Rd at Dobbs Street, stop 63",
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Wecker Rd at Eastwood Drive, stop 64b",
                        "Ham Rd at Linfield Street, stop 64d",
                        "Olivella St near Balamara St, stop 66",
                        "Ham Rd at Toulon Street, stop 76",
                        "Mannetto St near Cummin St, stop 83",
                        "Delavan St at Delavan Terminus, stop 87/78",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station"
                    ],
                    "183: Wishart - City Rocket via Mansfield": [
                        "Wishart Rd near Hibiscus Cl, stop 77",
                        "Wishart Rd near Elkana Pl, stop 76",
                        "Wishart Rd near Pasley St, stop 75",
                        "Wishart Rd at Newnham Road, stop 74/44",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Wishart Rd at Exmoor Street, stop 42",
                        "Hillgrove St at Kingsway Street, stop 41",
                        "Cresthaven Dr at Cresthaven, stop 74",
                        "Aminya St at Mansfield, stop 67a",
                        "Luprena St at Mansfield North near Amoria St",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Holland Rd near Rita St, stop 44",
                        "Birdwood Rd at Wellers Hill, stop 2",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Queen Street station",
                        "Queen Street station, 3a",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Birdwood Rd at Wellers Hill",
                        "Holland Rd near Stewart St, stop 44"
                    ],
                    "185: Garden City - City/Valley": [
                        "Garden City Shopping Centre station, stop G",
                        "Newnham Rd near Tryon St, stop 79",
                        "Newnham Rd at Delavan, stop 78",
                        "Newnham Rd at Montreal Street, stop 77a",
                        "Newnham Rd at Arila Street, stop 77",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Tolson Street, stop 75",
                        "Newnham Rd at Civic Fair, stop 73",
                        "Newnham Rd at Broadwater Rd, stop 72",
                        "Newnham Rd at Westbrooke Street, stop 71",
                        "Newnham Rd at Condong Street, stop 70/63",
                        "Newnham Rd at Enderby Street, stop 62",
                        "Mt Gravatt East School - 61",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Cavendish Rd at Seton College stop 59/56",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Turquoise Street, stop 49/43",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Emlyn Street, stop 31/30",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Shire Street, stop 28/27",
                        "Cavendish Rd at Coorparoo Shops, stop 26",
                        "Cavendish Rd at Wakefield Street, stop 25/21",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Milsom St, stop 19",
                        "Stanley St East at Edgar Street, stop 18",
                        "Stanley St E at Didsbury Street, stop 17",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Fisher Street, stop 15/11",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Margaret Street Stop 95 at Albert St",
                        "Eagle St near Eagle Lane (Stop 63)",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Warner Street Stop 203 near Wickham St",
                        "Warner Street Stop 204 near Ann St",
                        "Ann Street Stop 218 at All Hallows",
                        "Eagle Street Stop 152 at Riverside Centre",
                        "Mary Street Stop 50 near Albert St",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Vulture St at Kennedy Street, stop 11",
                        "Vulture St at Rosslyn Street, stop 12/15",
                        "Vulture St at Withington Street, stop 16",
                        "Vulture St at Didsbury Street, stop 17",
                        "Cavendish Rd at Coorparoo College, stop 19",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at Coorparoo Shops, stop 26s",
                        "Cavendish Rd at Shire Street, stop 27/28",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Newnham Rd at Condong Street, stop 63/70",
                        "Newnham Rd at Montreal Street, stop 77A",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "186: Wishart - City Rocket": [
                        "Delavan St at Delavan Terminus, stop 78/87",
                        "Delavan St at Wolcott Street, stop 86",
                        "Delavan St at Delavan Street Park, stop 85",
                        "Cummin St near Monte Carlo St, stop 84",
                        "Mannetto St near Matincock St, stop 83",
                        "Mannetto St at Gilgo Street, stop 82",
                        "Greenwood St near Kavanagh Rd, stop 81",
                        "Mindona St at Mindona Park, stop 80",
                        "Boyanda St near Tyrrell St, stop 79",
                        "Mt Gravatt Capalaba Rd at Ham Road South",
                        "Mt Gravatt Capalaba Rd at Agaton",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Dawson Rd at Gurney Street, stop 78",
                        "Dawson Rd at Gerty Street, stop 79",
                        "Klumpp Rd at Klumpp-Dawson",
                        "Klumpp Rd at Hibiscus",
                        "Griffith University station, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Charlotte Street Stop 51 near Albert St",
                        "George Street Stop 123 near Alice St",
                        "Griffith University station, platform 2",
                        "Mannetto St near Cummin St, stop 83",
                        "Delavan St at Delavan Terminus, stop 87/78"
                    ],
                    "189: Holland Park - City Express": [
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Glindemann Park, stop 33",
                        "Logan Rd at Boronia Street, stop 32",
                        "Logan Rd at Holland Park South, stop 31",
                        "Logan Rd at Barter Street, stop 30",
                        "Logan Rd at Holland Park, stop 29",
                        "Logan Rd at Harold Street, stop 28",
                        "Logan Rd at Swain Street, stop 27",
                        "Logan Rd at CB Mott Park, stop 26",
                        "Logan Rd at Greenslopes Mall, stop 25/24",
                        "Logan Rd at Donaldson Street, stop 23",
                        "Logan Rd at Greenslopes, stop 22",
                        "Logan Rd at Greenslopes School, stop 21",
                        "Juliette St at Beatrice Street, stop 19",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Charlotte Street Stop 52 near Edward St",
                        "George Street Stop 123 near Alice St",
                        "Buranda busway, platform 2",
                        "Cornwall St at Baron Street, stop 18",
                        "Cornwall St at Cleveland Street, stop 18a",
                        "Logan Rd at Logan Rd North, stop 19",
                        "Logan Rd at Bardsley Avenue, stop 20",
                        "Logan Rd at Greenslopes Mall, stop 24",
                        "Logan Rd at Raff Ave, stop 25",
                        "Logan Rd at Barter St, stop 30"
                    ],
                    "192: Yeronga - City via UQ Lakes and Highgate Hill": [
                        "King Arthur Tce - Tennyson",
                        "Fairfield Rd at Ortive St, stop 33",
                        "Fairfield Rd at Yeronga station",
                        "Fairfield Rd at Ovendean Street, stop 21",
                        "Fairfield Rd at Fairfield - Venner, stop 20",
                        "Fairfield Rd near Ashby St, stop 18a",
                        "Home St at Brougham Street, stop 17A",
                        "Home St at Victoria Street, stop 16A",
                        "Home St at Fairfield Park, stop 15a",
                        "Fairfield Rd at Fenton Street, stop 14a",
                        "Fairfield Rd at Princess Street, stop 13a",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Dutton Park Place",
                        "UQ Lakes stop E",
                        "Gladstone Rd at Gair Park, stop 17",
                        "Gladstone Rd at Dutton Park, stop 16",
                        "Gladstone Rd at Pope Street, stop 15",
                        "Gladstone Rd at Wahcumba Street, stop 14",
                        "Gladstone Rd at Ampthill Street, stop 13",
                        "Gladstone Rd at Dornoch Terrace, stop 11",
                        "Dornoch Tce at Hampstead Road, stop 21",
                        "Dornoch Tce at Sankey Street, stop 20",
                        "Dornoch Tce at Katrine Street, stop 18",
                        "Dornoch Tce at Doris Street, stop 17",
                        "Ganges St near Hoogley St, stop 13",
                        "Hoogley St at Yumba, stop 14",
                        "Orleigh St at West End Ferry, stop 15",
                        "Montague Rd at Cordeaux Street, stop 30/14",
                        "Montague Rd at Raven Street, stop 12",
                        "Montague Rd at Kurilpa Street, stop 11",
                        "Montague Rd near Victoria St, stop 10",
                        "Montague Rd at Ashington Street, stop 9",
                        "Montague Rd at Davies Park, stop 8",
                        "Montague Rd at Donkin Street, stop 7",
                        "Hardgrave Rd near Vulture St, stop 9C",
                        "Montague Rd at Mollison Street, stop 6",
                        "Mollison St near Melbourne St, stop 5",
                        "Melbourne St at Manning Street, stop 4",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 27 near Creek St",
                        "Adelaide Street Stop 33 near Wharf St",
                        "Adelaide Street Stop 36 near Anzac Square",
                        "Adelaide Street Stop 42 near Albert St",
                        "Cultural Centre station, platform 3",
                        "Mollison St near Boundary St, stop 5",
                        "Montague Rd at Cordeaux Street, stop 14",
                        "Morry St near Cordeaux St, stop 15a",
                        "Gray Rd at Yumba, stop 15",
                        "Hoogley St at Leitch Lane, stop 13/19",
                        "Dornoch Tce near Hampstead Road, stop 21",
                        "Dornoch Tce near Gladstone Rd, stop 21a",
                        "UQ Lakes stop F",
                        "Noble St at Princess Street, stop 13a",
                        "Noble St at Fenton Street, stop 14a",
                        "Fairfield Rd at Fairfield Park, stop 15a",
                        "Fairfield Rd at Victoria Street, stop 16a",
                        "Fairfield Rd at Brougham Street, stop 17A",
                        "Fairfield Rd near Ashby St, stop 19"
                    ],
                    "195: New Farm - City": [
                        "Sydney St near Griffith St",
                        "Sydney St at Llewellyn Street, stop 23",
                        "Moray St near Sydney St",
                        "Mountford Rd near Turner Ave, stop 24/21",
                        "Mark St near Elystan Rd, stop 23",
                        "Brunswick St at Bowls Club, stop 16",
                        "Brunswick St at Sydney Street, stop 15",
                        "Brunswick St at New Farm Junction, stop 14",
                        "Brunswick St at Langshaw Street, stop 10",
                        "Brunswick St at Barker St, stop 9",
                        "Brunswick St at Heal Street, stop 8",
                        "Brunswick St at Harcourt Street, stop 6",
                        "Brunswick St at Robertson Street, stop 5",
                        "Adelaide Street Stop 33 near Wharf St",
                        "Adelaide Street Stop 37 near Anzac Square",
                        "Adelaide Street Stop 43 near City Hall",
                        "William Street Stop 105 near Margaret St",
                        "George Street Stop 114 near Alice St",
                        "George Street Stop 115 near Charlotte St",
                        "Adelaide Street Stop 19 at City Hall",
                        "Adelaide Street Stop 25 near Edward St",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Adelaide Street Stop 30 near Macrossan St",
                        "Brunswick St at Kent Street, stop 7/8",
                        "Brunswick St at Barker Street, stop 9",
                        "Mountford Rd near Moray St, stop 24",
                        "Moray St near Sydney St, stop 21",
                        "Sydney St at Llewellyn Street",
                        "Oxlade Dr at Merthyr, stop 1"
                    ],
                    "196: Fairfield Gardens - Merthyr via City/Valley": [
                        "Brougham St near Fairfield Rd, stop 18",
                        "Home St at Brougham Street, stop 17A",
                        "Home St at Victoria Street, stop 16A",
                        "Home St at Fairfield Park, stop 15a",
                        "Fairfield Rd at Fenton Street, stop 14a",
                        "Fairfield Rd at Princess Street, stop 13a",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Gladstone Rd at Gair Park, stop 17",
                        "Gladstone Rd at Dutton Park, stop 16",
                        "Gladstone Rd at Pope Street, stop 15",
                        "Gladstone Rd at Wahcumba Street, stop 14",
                        "Gladstone Rd at Ampthill Street, stop 13",
                        "Gladstone Rd at Dornoch Terrace, stop 11",
                        "Gladstone Rd at Morris Street, stop 10",
                        "Vulture St at State High, stop 8",
                        "Browning St at Besant Street, stop 7",
                        "Browning St at Russell Street, stop 6",
                        "Browning St near Boundary St, stop 5",
                        "Melbourne St at Manning Street, stop 4",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 19 at City Hall",
                        "Adelaide Street Stop 25 near Edward St",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Adelaide Street Stop 30 near Macrossan St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Brunswick St at Robertson Street, stop 5",
                        "Warner Street Stop 205 near Ann St",
                        "Brunswick St at Harcourt Street, stop 6",
                        "Brunswick Street Stop 207 near McLachlan St",
                        "Brunswick St at Kent Street, stop 7/8",
                        "Brunswick St at Barker Street, stop 9",
                        "Barker St at Oxley Lane, stop 9",
                        "Moray St at Locke Street, stop 10",
                        "Moray St at Langshaw Street, stop 11",
                        "Moray St at Roundabout, stop 12",
                        "Merthyr Rd at Mark Street, stop 13",
                        "Brunswick St at New Farm Junction, stop 14",
                        "Brunswick St at Sydney Street, stop 15",
                        "Brunswick St at Bowls Club, stop 16",
                        "Brunswick St at Parkview, stop 17",
                        "Oxlade Dr near Brunswick St, stop 19",
                        "Oxlade Dr at Riverside, stop 25",
                        "Oxlade Dr at River Path, stop 25a",
                        "Oxlade Dr at Sargent Street, stop 26",
                        "Sydney St near Griffith St",
                        "Sydney St at Llewellyn Street, stop 23",
                        "Moray St near Sydney St",
                        "Mountford Rd near Sargent St",
                        "Oxlade Dr at Merthyr, stop 1",
                        "Oxlade Dr at Hazelwood Street, stop 27/24a",
                        "Oxlade Dr at River Path, stop 25",
                        "Oxlade Dr at Lower Bowen Terrace, stop 19",
                        "Brunswick St at Oxlade Drive, stop 17",
                        "Merthyr Rd at Roundabout, stop 12",
                        "Brunswick St at Heal Street, stop 8",
                        "Brunswick St near Ann St Stop 210",
                        "Adelaide St Stop 31 near Macrossan St",
                        "Ann Street Stop 218 at All Hallows",
                        "Adelaide Street Stop 33 near Wharf St",
                        "Adelaide Street Stop 37 near Anzac Square",
                        "Adelaide Street Stop 43 near City Hall",
                        "Cultural Centre station, platform 3",
                        "Browning St near Boundary Rd, stop 5",
                        "Gladstone Rd at Dorchester Street, stop 8",
                        "TJ Doyle Memorial Park Dr at Gair Park, stop 17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Noble St at Princess Street, stop 13a",
                        "Noble St at Fenton Street, stop 14a",
                        "Fairfield Rd at Fairfield Park, stop 15a",
                        "Fairfield Rd at Victoria Street, stop 16a",
                        "Fairfield Rd at Brougham Street, stop 17A"
                    ],
                    "197: City - South Brisbane Loop": [
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 45 near City Hall",
                        "Cultural Centre station, platform 3",
                        "Merivale St near Russell St, stop 2A",
                        "Ernest St at Brisbane State High, stop 3",
                        "Gladstone Rd at Dorchester Street, stop 8",
                        "Dorchester St at Somerville House, stop 5",
                        "Stephens Rd at St Laurences College, stop 7",
                        "Stephens Rd near Annerley Rd, stop 8",
                        "Annerley Rd at Lockhart Street, stop 8",
                        "Annerley Rd at Clarence Street, stop 7",
                        "Stanley St near Raymond Tce, stop 6",
                        "Vulture St near Grey St, stop 4",
                        "Cordelia St at Brisbane State High, stop 3",
                        "Cordelia St at Musgrave Park, stop 2A",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 27 near Creek St"
                    ],
                    "198: Highgate Hill Hail 'n' Ride": [
                        "Mollison St near Melbourne St, stop 5",
                        "Boundary St at West End Junction, stop 5",
                        "Boundary St at Jane Street, stop 6",
                        "Jane near Amersham Street",
                        "Jane Street",
                        "Jane St at West End State School",
                        "Hardgrave Rd near Vulture St, stop 9C",
                        "Hardgrave Rd at Rialto, stop 10",
                        "Hardgrave Rd at Whynot St, stop 11",
                        "Hardgrave Rd at Hill End, stop 12",
                        "Dornoch Tce at Doris Street, stop 17",
                        "Dornoch Terrace Hail 'n' Ride",
                        "Dornoch Tce at Katrine Street, stop 18",
                        "Dornoch Tce at Sankey Street, stop 20",
                        "Saint James St near Paradise St, stop 21",
                        "Paradise St near Athens St, stop 22",
                        "Athens St near Dudley St, stop 23",
                        "Dudley St at Boundary Street, stop 24",
                        "Boundary Street Hail 'n' Ride",
                        "Boundary near Bristol Street Hail 'n' Ride",
                        "Boundary at Whynot Street Hail 'n' Ride",
                        "Boundary at Granville Street Hail 'n' Ride",
                        "Boundary near Vulture Street Hail 'n' Ride",
                        "Vulture Street Hail 'n' Ride",
                        "Sussex Street Hail 'n' Ride",
                        "Brighton at Franklin Street Hail 'n' Ride",
                        "Brighton Road Hail 'n' Ride",
                        "Hampstead Rd near Blakeney St",
                        "Hampstead near Bellevue Street Hail 'n' Ride",
                        "Dornoch Tce near Hampstead Road, stop 21",
                        "Dornoch Tce near Gladstone Rd, stop 21a",
                        "Gladstone Rd at Dornoch Terrace, stop 11",
                        "Gladstone Rd at Ampthill Street, stop 13",
                        "Gladstone Rd at Wahcumba Street, stop 14",
                        "Gladstone Rd at Pope Street, stop 15",
                        "Gladstone Rd at Dutton Park, stop 16",
                        "TJ Doyle Memorial Park Dr at Gair Park, stop 17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Cornwall St at Rusk Street, stop 14a",
                        "Cornwall St at Ayr Street, stop 14",
                        "Cornwall St at PA Hospital South, stop 1",
                        "Ipswich Rd at PA Hospital, stop 14",
                        "Ipswich Rd at OKeefe Street, stop 13",
                        "Ipswich Rd at Broadway, stop 10a",
                        "Ipswich Rd at Balaclava Street, stop 10",
                        "Stanley St near Gibbon St, stop 9A",
                        "Stanley St near Raymond Tce, stop 6",
                        "Vulture St near Grey St, stop 4",
                        "Vulture near Gladstone Rd Hail 'n' Ride",
                        "Edmondstone near Vulture Street Hail 'n' Ride",
                        "Edmondstone Street at Musgrave Park",
                        "Edmondstone St near Melbourne St hail 'n' ride",
                        "Montague Rd near Brereton St, stop 5",
                        "Montague Rd near Mollison St, stop 6"
                    ],
                    "199: West End - Teneriffe Ferry via City/Valley": [
                        "Orleigh St at West End Ferry, stop 15",
                        "Morry St near Cordeaux St, stop 15a",
                        "Gray Rd at Yumba, stop 15",
                        "Hoogley St at Leitch Lane, stop 13/19",
                        "Hardgrave Rd at Hill End, stop 12",
                        "Hardgrave Rd at Whynot St, stop 11",
                        "Hardgrave Rd at Rialto, stop 10",
                        "Vulture St at West End School, stop 9",
                        "Vulture St at Cambridge Street, stop 8",
                        "Vulture St at West End, stop 7",
                        "Boundary St at Jane Street, stop 6",
                        "Boundary St at West End Junction, stop 5",
                        "Melbourne St at Manning Street, stop 4",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 19 at City Hall",
                        "Adelaide Street Stop 26 at Anzac Square",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Adelaide Street Stop 30 near Macrossan St",
                        "Brunswick St at Robertson Street, stop 5",
                        "Brunswick St at Harcourt Street, stop 6",
                        "Brunswick St at Kent Street, stop 7/8",
                        "Brunswick St at Barker Street, stop 9",
                        "Brunswick St at Langshaw Street, stop 10",
                        "Merthyr Rd at Merthyr Central, stop 11",
                        "Merthyr Rd at Alford Street, stop 12",
                        "Merthyr Rd at Hawthorne Street, stop 13",
                        "Macquarie St at Saratoga, stop 13A",
                        "Macquarie St at Mercantile Place, stop 14",
                        "Macquarie St at Vernon Terrace, stop 15",
                        "Commercial Rd near Vernon Tce",
                        "Teneriffe Ferry Skyring Tce",
                        "Vernon Tce near Florence St, stop 15",
                        "Brunswick St at Barker St, stop 9",
                        "Brunswick St at Heal Street, stop 8",
                        "Adelaide Street Stop 33 near Wharf St",
                        "Adelaide St Stop 31 near Macrossan St",
                        "Adelaide Street Stop 37 near Anzac Square",
                        "Adelaide Street Stop 43 near City Hall",
                        "Cultural Centre station, platform 3",
                        "Boundary St at West End, stop 7",
                        "Ganges St near Hoogley St, stop 13",
                        "Hoogley St at Yumba, stop 14"
                    ],
                    "19: Rocklea - PA Hospital StationLink": [
                        "Brooke St at Rocklea Railway, stop 47",
                        "Ipswich Rd at Moorooka station, stop 38/39",
                        "Green St at Yeerongpilly station, stop 30",
                        "Park Rd at Memorial Park",
                        "Fairfield Rd near Ashby St, stop 18a",
                        "Home St at Brougham Street, stop 17A",
                        "Home St at Victoria Street, stop 16A",
                        "Fairfield Rd at Fenton Street, stop 14a",
                        "Fairfield Rd at Princess Street, stop 13a",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Boggo Road station, platform 5",
                        "Lower Level at PA Hospital station",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Noble St at Princess Street, stop 13a",
                        "Noble St at Fenton Street, stop 14a",
                        "Fairfield Rd at Victoria Street, stop 16a",
                        "Fairfield Rd at Brougham Street, stop 17A",
                        "Fairfield Rd near Ashby St, stop 19",
                        "Ipswich Rd at Gainsborough Street, stop 38",
                        "Ipswich Rd at Moorooka station, stop 39"
                    ],
                    "200: Carindale Heights - City Express": [
                        "Cribb Rd at Cribb Road East",
                        "Cribb Rd near Oakwood Way",
                        "Scrub Rd at Carindale Heights",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Scrub Rd at Winstanley East",
                        "Bridgnorth St at Belmont School",
                        "Bridgnorth St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Carindale Shopping Centre station, platform G",
                        "Old Cleveland Rd at Carina, stop 35",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Easts Leagues",
                        "Kingfisher Creek at Railway St",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Queen Street station",
                        "Queen Street station, 2a",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Kingfisher Creek near Norman St",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Carindale Shopping Centre station, platform A",
                        "Winstanley St near Firmiston St",
                        "Cribb Rd near Cowell St",
                        "Cribb Road at Cribb Road East"
                    ],
                    "201: Carindale Heights - City Rocket": [
                        "Cribb Rd at Cribb Road East",
                        "Cribb Rd near Oakwood Way",
                        "Scrub Rd at Carindale Heights",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Scrub Rd at Winstanley East",
                        "Bridgnorth St at Belmont School",
                        "Bridgnorth St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Martha St at Tarana Street, stop 37",
                        "Leicester St near Rutland St",
                        "Langlands Park station, platform 1",
                        "Stones Corner station, platform 1",
                        "Buranda busway, platform 1",
                        "George Street Stop 108",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Queen Street Stop 76 near Creek St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 102 at George St",
                        "Buranda busway, platform 2",
                        "Stones Corner station, platform 2",
                        "Langlands Park station, platform 2",
                        "Leicester St near York St",
                        "Newman Ave at Lavington Street, stop 37",
                        "Winstanley St near Firmiston St",
                        "Cribb Rd near Cowell St",
                        "Cribb Road at Cribb Road East"
                    ],
                    "202: Carindale - PA Hospital": [
                        "Carindale Shopping Centre station, platform C",
                        "Donnington St at Donnington, stop 53",
                        "Donnington St at Stanmere, stop 52",
                        "Gallipoli Rd at Tirrabella Street, stop 51",
                        "Gallipoli Rd at Gallipoli, stop 50",
                        "Gallipoli Rd at Gallipoli Road Bushlands, stop 49",
                        "Gallipoli Rd at Warenda Street, stop 48",
                        "Chataway St near Gallipoli Rd, stop 47",
                        "Chataway St at Rea Street, stop 46",
                        "McGahan St near Chataway St, stop 45",
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Chatsworth Rd at Arc Street, stop 40",
                        "Buena Vista Ave at Sector Street, stop 3",
                        "Buena Vista Ave near Spica St, stop 37",
                        "Buena Vista Ave at Crucis Street, stop 36",
                        "Orion St at Sirius Street, stop 36",
                        "Orion St near Satellite St, stop 35",
                        "Eva St near Glyn St, stop 34",
                        "Chatsworth Rd at Gristock Street, stop 33",
                        "Chatsworth Rd at Rossmore Ave, stop 32",
                        "Chatsworth Rd at Stirrat Street, stop 31",
                        "Chatsworth Rd at Trundle Street, stop 30",
                        "Upper Cornwall St at Upper Cornwall, stop 29",
                        "Upper Cornwall St at Pembroke Rd, stop 28",
                        "Cornwall St at Rialto Street, stop 19a",
                        "Cornwall St at Darreen St, stop 19",
                        "Logan St near Juliette St, stop 21",
                        "Juliette St at Beatrice Street, stop 19",
                        "Buranda busway, platform 1",
                        "OKeefe St near Wolseley St",
                        "Cornwall St at PA Hospital South, stop 1",
                        "Cornwall St at Ayr Street, stop 14",
                        "Cornwall St at Rusk Street, stop 14a",
                        "Buranda busway, platform 2",
                        "Cornwall St at Baron Street, stop 18",
                        "Cornwall St at Cleveland Street, stop 18a",
                        "Cornwall St at Darreen Street, stop 19",
                        "Cornwall St at Raby Street, stop 19b",
                        "Upper Cornwall St at Pembroke Street, stop 20/28",
                        "Eva St near Chatsworth Rd, stop 33",
                        "Satellite St at Orion Street, stop 34",
                        "Buena Vista Ave at Crucis Street, stop 37",
                        "Buena Vista Ave near Spica St, stop 38",
                        "Spica St near Chatsworth Rd, stop 38",
                        "Chatsworth Rd at Greens Road, stop 39",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "203: Carindale - PA Hospital": [
                        "Carindale Shopping Centre station, platform C",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Buckley St near Winstanley St, stop 48B",
                        "Gallipoli Rd at Buzacott Street, stop 48a",
                        "Summerville St near Chataway St, stop 48",
                        "Gallipoli Rd at Maughan Street, stop 46",
                        "Birdwood Rd at Mons Road, stop 44/40",
                        "Birdwood Rd at Birdwood Road Park",
                        "Osterley Rd near Birdwood Rd",
                        "Jones Rd at Hill Crescent, stop 35/36",
                        "Jones Rd at Maranoa Street, stop 37a",
                        "Jones Rd near Mons Rd, stop 38/44",
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Burn St near Fred St, stop 42a",
                        "Abbott Street Stop 42/34 near Brooks St",
                        "Prout St at Raven Street, stop 41/35",
                        "Prout St near Boundary Rd, stop 40/36",
                        "Martha St at Tarana Street, stop 37",
                        "Martha St at Grant Street, stop 36/38",
                        "Martha St near Combles Rd, stop 35/39",
                        "Leicester St near Rutland St",
                        "Leicester St at Halstead Street",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Old Cleveland Rd at Macauly Street, stop 22",
                        "Old Cleveland Rd at Saint Leonards Street Stop 21",
                        "Old Cleveland Rd at Dowar Street Stop 20",
                        "Langlands Park station, platform 1",
                        "Stones Corner station, platform 1",
                        "Buranda busway, platform 1",
                        "Lower Level at PA Hospital station",
                        "PA Hospital station, platform 1",
                        "Buranda busway, platform 2",
                        "Stones Corner station, platform 2",
                        "Langlands Park station, platform 2",
                        "Old Cleveland Rd at Coorparoo West Stop 19",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Leicester St near York St",
                        "Newman Ave at Kelsey Street, stop 35",
                        "Newman Ave near Lavington St, stop 36",
                        "Newman Ave at Lavington Street, stop 37",
                        "Newman Ave at Boundary Road, stop 38/39",
                        "Prout St near Wotton St, stop 40/36",
                        "Abbott Street Stop 42/34 near Burn St",
                        "Burn St near Samuel St, stop 42a",
                        "Jones Rd at Maranoa Street, stop 37A",
                        "Birdwood Rd at Mons Road",
                        "Summerville St near Buzacott St, stop 48",
                        "Buzacott St near Buckley St, stop 48a",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "204: Carindale - City/Valley": [
                        "Zahel St at Clem Jones Centre, stop 39",
                        "Zahel St at Williams Field, stop 40",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Hilltop Court, stop 57",
                        "Meadowlands Rd at Epala Street, stop 56",
                        "Baynes St near Stevenson Ct, stop 55",
                        "Cadogan St at Cadogan Park, stop 65/54a",
                        "Cadogan St at Whitecastle Street, stop 66/54",
                        "Cadogan St at Bamburgh Street, stop 67/53",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Carindale Shopping Centre station, platform B",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Winstanley St at Laurie Street, stop 48/47",
                        "Winstanley St at Willard Street, stop 46",
                        "Gallipoli Rd at Carina Heights, stop 45/40",
                        "Gallipoli Rd at Salonica Street, stop 39",
                        "Gallipoli Rd at Hecklemann Street, stop 38",
                        "Old Cleveland Rd at Orana Street, stop 37",
                        "Old Cleveland Rd at Pembroke Street, stop 36",
                        "Old Cleveland Rd at Carina, stop 35",
                        "Old Cleveland Rd at Wonersh Street, stop 34",
                        "Old Cleveland Rd at Orwell Street, stop 33",
                        "Old Cleveland Rd at Camp Hill Primary",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Pampling Street, stop 29",
                        "Old Cleveland Rd at Madeline Street, stop 27",
                        "Old Cleveland Rd at Kismet Street, stop 26",
                        "Old Cleveland Rd at Burke Street, stop 25",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Old Cleveland Rd at Macauly Street, stop 22",
                        "Old Cleveland Rd at Saint Leonards Street Stop 21",
                        "Old Cleveland Rd at Dowar Street Stop 20",
                        "Old Cleveland Rd at Knowsley Street Stop 19",
                        "Old Cleveland Rd at Panitya Street, stop 18",
                        "Old Cleveland Rd at Stones Corner Library, stop 17",
                        "Logan Rd at Buranda Railway, stop 16/14",
                        "Logan Rd at Vanda Street, stop 13",
                        "Logan Rd at Buranda Street, stop 12",
                        "Logan Rd at Lewis Street, stop 11",
                        "Logan Rd at Walker Street, stop 10a",
                        "Stanley St at Jurgens Street, stop F",
                        "Woolloongabba station, platform 1",
                        "Margaret Street Stop 95 at Albert St",
                        "Eagle St near Eagle Lane (Stop 63)",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Warner Street Stop 203 near Wickham St",
                        "Warner Street Stop 204 near Ann St",
                        "Ann Street Stop 218 at All Hallows",
                        "Eagle Street Stop 152 at Riverside Centre",
                        "Mary Street Stop 50 near Albert St",
                        "Woolloongabba station, platform 2",
                        "Jurgens St at Woolloongabba, stop E",
                        "Logan Rd at Lotus Street, stop 10a",
                        "Logan Rd at Lewis Street, stop 11/12",
                        "Logan Rd at Buranda Railway, stop 14/16",
                        "Old Cleveland Rd at Stones Corner Library",
                        "Old Cleveland Rd at Edith Street, stop 17a",
                        "Old Cleveland Rd at Coorparoo West Stop 19",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Burke Street Stop 25",
                        "Old Cleveland Rd at Kismet Street Stop 26",
                        "Old Cleveland Rd at Madeline Street Stop 27",
                        "Old Cleveland Rd at Dorothy Lane Stop 28",
                        "Old Cleveland Rd at Pampling Street Stop 29",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Orwell Street Stop 33",
                        "Old Cleveland Rd at Wonersh Street Stop 34",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Gallipoli Rd at Orana Street, stop 37",
                        "Gallipoli Rd at Carina Heights, stop 40/45",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Carindale Shopping Centre station, platform H",
                        "Cadogan St at Whitecastle Street, stop 65/54",
                        "Baynes St near Sherborne St, stop 55",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Adelaide St at Stanley Road Stop 39"
                    ],
                    "205: Carindale Heights - City Express": [
                        "Scrub Road South at Aspen St",
                        "Kirra - Scrub Rd South",
                        "Berkley - Scrub Rd South",
                        "Scrub Rd at Carindale Heights",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Winstanley St at Firmiston",
                        "Carindale Shopping Centre station, platform C",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Winstanley St at Willard Street, stop 46",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Chatsworth Rd at Gristock Street, stop 33",
                        "Chatsworth Rd at Stirrat Street, stop 31",
                        "Chatsworth Rd near Henzell Tce, stop 25",
                        "Juliette St at Beatrice Street, stop 19",
                        "Buranda busway, platform 1",
                        "George Street Stop 116",
                        "Roma Street busway, platform 1",
                        "Roma Street busway, platform 2",
                        "Queen Street station, 2c",
                        "Buranda busway, platform 2",
                        "Cornwall St at Cleveland Street, stop 18a",
                        "Upper Cornwall St at Upper Cornwall, stop 29",
                        "Chatsworth Rd near Jerome St",
                        "Carindale Shopping Centre station, platform A",
                        "Winstanley St near Firmiston St",
                        "Scrub Rd at Winstanley East",
                        "Scrub Rd South near Oakley St"
                    ],
                    "206: Carindale - City Rocket": [
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Meadowlands Rd near Bedivere St",
                        "Bedivere St at Lindisfarne Street",
                        "Bedivere St near Cadogan St",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Carindale Shopping Centre station, platform B",
                        "Donnington St at Donnington, stop 53",
                        "Donnington St at Stanmere, stop 52",
                        "Gallipoli Rd at Tirrabella Street, stop 51",
                        "Gallipoli Rd at Gallipoli, stop 50",
                        "Gallipoli Rd at Gallipoli Road Bushlands, stop 49",
                        "Gallipoli Rd at Warenda Street, stop 48",
                        "Gallipoli Rd at Maughan Street, stop 46",
                        "Gallipoli Rd at Carina Heights, stop 45/40",
                        "Gallipoli Rd at Salonica Street, stop 39",
                        "Gallipoli Rd at Hecklemann Street, stop 38",
                        "Old Cleveland Rd at Orana Street, stop 37",
                        "Old Cleveland Rd at Pembroke Street, stop 36",
                        "Old Cleveland Rd at Carina, stop 35",
                        "Old Cleveland Rd at Wonersh Street, stop 34",
                        "Old Cleveland Rd at Orwell Street, stop 33",
                        "Old Cleveland Rd at Camp Hill Primary",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Langlands Park station, platform 1",
                        "Stones Corner station, platform 1",
                        "Buranda busway, platform 1",
                        "Margaret Street Stop 94 near George St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Queen Street Stop 76 near Creek St",
                        "Edward Street Stop 146 at Stamford Plaza",
                        "Alice Street Stop 102 at George St",
                        "Buranda busway, platform 2",
                        "Stones Corner station, platform 2",
                        "Langlands Park station, platform 2",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Orwell Street Stop 33",
                        "Old Cleveland Rd at Wonersh Street Stop 34",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Gallipoli Rd at Orana Street, stop 37",
                        "Gallipoli Rd at Carina Heights, stop 40/45",
                        "Carindale Shopping Centre station, platform H",
                        "Bedivere St near Agravain St"
                    ],
                    "208: Carina - City Rocket": [
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Chatsworth Rd at Arc Street, stop 40",
                        "Buena Vista Ave at Sector Street, stop 3",
                        "Buena Vista Ave near Spica St, stop 37",
                        "Buena Vista Ave at Crucis Street, stop 36",
                        "Orion St at Sirius Street, stop 36",
                        "Orion St near Satellite St, stop 35",
                        "Eva St near Glyn St, stop 34",
                        "Chatsworth Rd at Gristock Street, stop 33",
                        "Chatsworth Rd at Rossmore Ave, stop 32",
                        "Chatsworth Rd at Stirrat Street, stop 31",
                        "Chatsworth Rd at Trundle Street, stop 30",
                        "Upper Cornwall St at Upper Cornwall, stop 29",
                        "Upper Cornwall St at Pembroke Rd, stop 28",
                        "Cornwall St at Rialto Street, stop 19a",
                        "Cornwall St at Darreen St, stop 19",
                        "Logan St near Juliette St, stop 21",
                        "Juliette St at Beatrice Street, stop 19",
                        "Buranda busway, platform 1",
                        "George Street Stop 108",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Queen Street Stop 76 near Creek St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 102 at George St",
                        "Buranda busway, platform 2",
                        "Cornwall St at Baron Street, stop 18",
                        "Cornwall St at Cleveland Street, stop 18a",
                        "Cornwall St at Darreen Street, stop 19",
                        "Cornwall St at Raby Street, stop 19b",
                        "Upper Cornwall St at Pembroke Street, stop 20/28",
                        "Eva St near Chatsworth Rd, stop 33",
                        "Satellite St at Orion Street, stop 34",
                        "Buena Vista Ave at Crucis Street, stop 37",
                        "Buena Vista Ave near Spica St, stop 38",
                        "Spica St near Chatsworth Rd, stop 38",
                        "Chatsworth Rd at Greens Road, stop 39"
                    ],
                    "209: Carindale - UQ Lakes": [
                        "Carindale Shopping Centre station, platform H",
                        "Old Cleveland Rd at Carina, stop 35",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Langlands Park station, platform 1",
                        "Stones Corner station, platform 1",
                        "Buranda busway, platform 1",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Dutton Park Place",
                        "UQ Lakes station",
                        "UQ Lakes stop E",
                        "Boggo Road station, platform 5",
                        "PA Hospital station, platform 1",
                        "Buranda busway, platform 2",
                        "Stones Corner station, platform 2",
                        "Langlands Park station, platform 2",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "210: Cannon Hill - City/Valley": [
                        "Cannon Hill Shopping Centre B",
                        "Creek Rd at Old Stockyards, stop 66a",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Foxmont Drive, stop 49",
                        "Creek Rd at Carina North near Billan St",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Lunga Street, stop 40",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Perth St near Wiles St, stop 34/35",
                        "Perth St at Perth Street Park, stop 33",
                        "Perth St at St Thomas Primary, stop 31",
                        "Joseph St near McIlwraith Ave, stop 30",
                        "McIlwraith Ave at Hume Street, stop 29",
                        "McIlwraith Ave at Katherine Street, stop 28",
                        "McIlwraith Ave near Bennetts Rd, stop 26",
                        "Milsom St near Adina St, stop 24",
                        "Milsom St at Bottomley Park, stop 22/23",
                        "Milsom St at Thomas Street, stop 21",
                        "Stanley St E at Coorparoo Secondary College",
                        "Stanley St East at Edgar Street, stop 18",
                        "Stanley St E at Didsbury Street, stop 17",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Fisher Street, stop 15/11",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Wickham Street Stop 228 near Brunswick",
                        "Ballow St near Wickham Street Zone C",
                        "Ballow Street Stop 206 near Ann St",
                        "Ann Street Stop 220 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Vulture St at Kennedy Street, stop 11",
                        "Vulture St at Rosslyn Street, stop 12/15",
                        "Vulture St at Withington Street, stop 16",
                        "Vulture St at Didsbury Street, stop 17",
                        "Thomas St near Milsom St, stop 21",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Stanley Rd at Lunga Street, stop 39/40",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Old Stockyards",
                        "Cannon Hill Shopping Centre"
                    ],
                    "211: Cannon Hill - City Rocket": [
                        "Cannon Hill Shopping Centre B",
                        "Creek Rd at Old Stockyards, stop 66a",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Foxmont Drive, stop 49",
                        "Creek Rd at Carina North near Billan St",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Lunga Street, stop 40",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Perth St near Wiles St, stop 34/35",
                        "Perth St at Perth Street Park, stop 33",
                        "Perth St at St Thomas Primary, stop 31",
                        "Joseph St near McIlwraith Ave, stop 30",
                        "McIlwraith Ave at Hume Street, stop 29",
                        "McIlwraith Ave at Katherine Street, stop 28",
                        "McIlwraith Ave near Bennetts Rd, stop 26",
                        "Milsom St near Adina St, stop 24",
                        "Milsom St at Bottomley Park, stop 22/23",
                        "Woolloongabba station, platform 1",
                        "George Street Stop 115 near Charlotte St",
                        "George Street Stop 116",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 27 near Creek St",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "William Street Stop 105 near Margaret St",
                        "Woolloongabba station, platform 2",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Stanley Rd at Lunga Street, stop 39/40",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Old Stockyards",
                        "Cannon Hill Shopping Centre"
                    ],
                    "212: Carindale - City/Valley via Seven Hills": [
                        "Carindale Shopping Centre station, platform D",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Tristan St at Cuthred Street, stop 53",
                        "Tristan St at Gorlois Court, stop 54",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Lunga Street, stop 40",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Ferguson Rd at Camp Hill Bowls, stop 35s",
                        "Oateson Skyline Dr at Ursus Street, stop 36/37",
                        "Oateson Skyline Dr at Servius Street, stop 38",
                        "Oateson Skyline Dr at Claudia Avenue, stop 38a",
                        "Oateson Skyline Dr at Quirinal Crescent, stop 39",
                        "Oateson Skyline Dr at Darcy Road, stop 40",
                        "Kensington Ave at Kensingston Avenue, stop 40/41",
                        "Agnew St at Seven Hills Stop 42",
                        "Agnew St at Norman Park North",
                        "Bennetts Rd at Bennetts Bushland, stop 29",
                        "Bennetts Rd at Pattison Avenue, stop 27",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Tiber St at Rome Street, stop 25",
                        "Stanley St E at Coorparoo Secondary College",
                        "Stanley St East at Edgar Street, stop 18",
                        "Stanley St E at Didsbury Street, stop 17",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Fisher Street, stop 15/11",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Wickham Street Stop 228 near Brunswick",
                        "Ballow St near Wickham Street Zone C",
                        "Ballow Street Stop 206 near Ann St",
                        "Ann Street Stop 220 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Vulture St at Kennedy Street, stop 11",
                        "Vulture St at Rosslyn Street, stop 12/15",
                        "Vulture St at Withington Street, stop 16",
                        "Vulture St at Didsbury Street, stop 17",
                        "Bennetts Rd at Acfold Street, stop 28",
                        "Kensington Ave near Marshall Ave, stop 41/40",
                        "Oateson Skyline Dr at Caelian Street, stop 37",
                        "Oateson Skyline Dr at Ursus Street, stop 36",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Stanley Rd at Lunga Street, stop 39/40",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "213: Cannon Hill - Carindale": [
                        "Carindale Shopping Centre station, platform D",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Cadogan St at Bamburgh Street, stop 67/53",
                        "Cadogan St at Whitecastle Street, stop 65/54",
                        "Cadogan St at Cadogan Park, stop 65/54a",
                        "Baynes St near Sherborne St, stop 55",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Cannon Hill",
                        "Cannon Hill Shopping Centre",
                        "Cannon Hill Shopping Centre D",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd near Thornlake Ct",
                        "Baynes St near Stevenson Ct, stop 55",
                        "Cadogan St at Whitecastle Street, stop 66/54",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "214: Cannon Hill - City Express": [
                        "Cannon Hill Shopping Centre A",
                        "Richmond Rd at Richmond East",
                        "Richmond Rd at Molloy Road",
                        "Richmond Rd at Morningside East near Bonar St",
                        "Wickham St at Morningside",
                        "Agnew St at Seven Hills Stop 42",
                        "Agnew St at Norman Park North",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Stanley St E at Coorparoo Secondary College",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 27 near Creek St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Ann Street Stop 220 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Vulture St at Withington Street, stop 16",
                        "Richmond Rd at Morningside East",
                        "Cannon Hill Shopping Centre"
                    ],
                    "215: Carindale - City Express via Tingalpa": [
                        "Carindale Shopping Centre station, platform D",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Cadogan St at Bamburgh Street, stop 67/53",
                        "Cadogan St at Whitecastle Street, stop 65/54",
                        "Cadogan St at Cadogan Park, stop 65/54a",
                        "Cadogan St at Breadsell Street, stop 64/63",
                        "Cadogan St at Rolls Court, stop 62",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Annette St at Cahia Street, stop 50/46",
                        "Annette St at Jarrow Street, stop 49/45",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Cannon Hill",
                        "Cannon Hill Shopping Centre A",
                        "Richmond Rd at Richmond East",
                        "Richmond Rd at Molloy Road",
                        "Richmond Rd at Morningside East near Bonar St",
                        "Wickham St at Morningside",
                        "Agnew St at Seven Hills Stop 42",
                        "Agnew St at Norman Park North",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Stanley St E at Coorparoo Secondary College",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 27 near Creek St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Ann Street Stop 220 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Vulture St at Withington Street, stop 16",
                        "Richmond Rd at Morningside East",
                        "Cannon Hill Shopping Centre D",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd near Thornlake Ct",
                        "Thurston St at McCorkell Street, stop 53/49",
                        "Cadogan St at Breadsell Street, stop 63/64",
                        "Cadogan St at Whitecastle Street, stop 66/54",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "216: Tingalpa - City Rocket": [
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Hilltop Court, stop 57",
                        "Meadowlands Rd at Epala Street, stop 56",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Annette St at Cahia Street, stop 50/46",
                        "Annette St at Jarrow Street, stop 49/45",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Shafston Ave at Connor Street, stop 10/6",
                        "Ann Street Stop 219 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "William Street Stop 105 near Margaret St",
                        "George Street Stop 108",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Eagle St near Eagle Lane (Stop 64)",
                        "Adelaide Street Stop 30 near Macrossan St",
                        "Shafston Ave at Connor Street, stop 7/10",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Thurston St at McCorkell Street, stop 53/49"
                    ],
                    "217: Carindale - City Rocket": [
                        "Carindale Shopping Centre station, platform F",
                        "Old Cleveland Rd at Carina, stop 35",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Kismet Street, stop 26",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Langlands Park station, platform 1",
                        "Stones Corner station, platform 1",
                        "Margaret Street Stop 94 near George St",
                        "Creek Street Stop 148 at Riverside Centre",
                        "Queen Street Stop 76 near Creek St",
                        "Edward Street Stop 146 at Stamford Plaza",
                        "Alice Street Stop 102 at George St",
                        "Stones Corner station, platform 2",
                        "Langlands Park station, platform 2",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Kismet Street Stop 26",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "220: Wynnum - City Express": [
                        "Wynnum Esp near Florence St",
                        "Florence St at Wynnum Central Stop 97",
                        "Tingal Rd at Wynnum RSL, stop 99",
                        "Tingal Rd at Wynnum, stop 3",
                        "Wynnum Rd at Stradbroke Avenue",
                        "Wynnum Rd at Sibley Road",
                        "Wynnum Rd at Wynnum Golf, stop 54",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Preston Rd near Wynnum Rd",
                        "Preston Rd at Corner House, stop 74/66",
                        "Preston Rd at Seabreeze, stop 72/68",
                        "Manly Rd at Whites Road",
                        "Manly Rd at Manly West near Delsia St",
                        "Manly Rd at Silky Oaks",
                        "Caloundra St at Janoah Gardens",
                        "Radford Rd at Manly Vista",
                        "Radford Rd near Wondall Rd",
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd near Manly Rd",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Manly Rd near Castlerea St",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Wynnum Rd at Murarrie Road",
                        "Cannon Hill Shopping Centre A",
                        "Richmond Rd at Richmond East",
                        "Richmond Rd at Molloy Road",
                        "Richmond Rd at Morningside East near Bonar St",
                        "Wickham St at Morningside",
                        "Agnew St at Seven Hills Stop 42",
                        "Agnew St at Norman Park North",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Stanley St E at Coorparoo Secondary College",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 27 near Creek St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Ann Street Stop 220 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Vulture St at Withington Street, stop 16",
                        "Richmond Rd at Morningside East",
                        "Cannon Hill Shopping Centre D",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd near Thornlake Ct",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Radford Rd near Lewis Neibling Pl",
                        "Manly Rd at Manly West near Stannard Rd",
                        "Manly Rd at Whites Rd",
                        "Preston Rd at Seabreeze",
                        "Preston Rd at Corner House",
                        "Preston Rd near Randall Rd",
                        "Wynnum Rd at Wynnum Golf",
                        "Tingal Rd at Wynnum near Wilde St",
                        "Tingal Rd at Wynnum RSL",
                        "Florence St at Wynnum Central, stop 97"
                    ],
                    "221: Wynnum - City Rocket": [
                        "Wynnum Esp near Florence St",
                        "Florence St at Wynnum Central Stop 97",
                        "Tingal Rd at Wynnum RSL, stop 99",
                        "Tingal Rd at Wynnum, stop 3",
                        "Wynnum Rd at Stradbroke Avenue",
                        "Wynnum Rd at Sibley Road",
                        "Wynnum Rd at Wynnum Golf, stop 54",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Preston Rd near Wynnum Rd",
                        "Preston Rd at Corner House, stop 74/66",
                        "Preston Rd at Seabreeze, stop 72/68",
                        "Manly Rd at Whites Road",
                        "Manly Rd at Manly West near Delsia St",
                        "Manly Rd at Silky Oaks",
                        "Caloundra St at Janoah Gardens",
                        "Radford Rd at Manly Vista",
                        "Radford Rd near Wondall Rd",
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd near Manly Rd",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Manly Rd near Castlerea St",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Shafston Ave at Connor Street, stop 10/6",
                        "Ann Street Stop 219 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "William Street Stop 105 near Margaret St",
                        "George Street Stop 108",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Eagle St near Eagle Lane (Stop 64)",
                        "Adelaide Street Stop 30 near Macrossan St",
                        "Shafston Ave at Connor Street, stop 7/10",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd near Thornlake Ct",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Radford Rd near Lewis Neibling Pl",
                        "Manly Rd at Manly West near Stannard Rd",
                        "Manly Rd at Whites Rd",
                        "Preston Rd at Seabreeze",
                        "Preston Rd at Corner House",
                        "Preston Rd near Randall Rd",
                        "Wynnum Rd at Wynnum Golf",
                        "Tingal Rd at Wynnum near Wilde St",
                        "Tingal Rd at Wynnum RSL",
                        "Florence St at Wynnum Central, stop 97"
                    ],
                    "222: Carindale - City Express via Eastern Busway": [
                        "Carindale Shopping Centre station, platform F",
                        "Old Cleveland Rd at Carina, stop 35",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Kismet Street, stop 26",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Langlands Park station, platform 1",
                        "Stones Corner station, platform 1",
                        "Buranda busway, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "King George Square, 1b",
                        "Roma Street busway, platform 1",
                        "Roma Street busway, platform 2",
                        "King George Square, 2b",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Buranda busway, platform 2",
                        "Stones Corner station, platform 2",
                        "Langlands Park station, platform 2",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Kismet Street Stop 26",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "223: Wynnum Loop Clockwise": [
                        "Wynnum Rd at Wynnum Plaza, stop 58",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58",
                        "Wynnum Rd at Wynnum West State School, stop 58A",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "New Lindum Rd at Moreton Bay",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Wynnum Rd at Wynnum Golf",
                        "New Lindum Rd at Health",
                        "Federation St at Federation Park",
                        "Brierty St near Malabar St, stop 53",
                        "Federation St near School Rd",
                        "Malabar St at Nemarra Street, stop 51",
                        "School Rd near New Lindum Rd",
                        "Malabar St at Lyones Street, stop 50",
                        "Crawford Rd at Balnave St",
                        "Malabar St at Meron Street, stop 49",
                        "Crawford Rd at Pecan St",
                        "Malabar St at Birru Street, stop 48",
                        "Crawford Rd near Kanawah Rd",
                        "Malabar St at Talegalla Street, stop 47",
                        "Kianawah Rd at Evelyn Rd",
                        "Sibley Rd at Lindum Rail, stop 44/45",
                        "Kianawah Rd at Youngs Rd",
                        "Sibley Rd at Pleasantville, stop 42",
                        "Kianawah Rd at Vikings",
                        "Sibley Rd at Florabelle Court, stop 41",
                        "Kianawah Rd at Glenwood Pl",
                        "Sibley Rd at Regent Street, stop 40/39",
                        "Wynnum Rd at BMX, stop 50/56",
                        "Wynnum North Rd at Sibley Road, stop 38",
                        "Wynnum Rd at Plaza Street, stop 57",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Wynnum North Rd at Wynnum North Rail, stop 36/17",
                        "Wynnum North Rd at Ryder Street, stop 15",
                        "Wynnum North Rd at Nazareth House, stop 14",
                        "Wynnum North Rd at Constellation Way, stop 13",
                        "Tingal Rd at Tingal - Ure, stop 13A",
                        "Tingal Rd at Shepherd Street, stop 12",
                        "Tingal Rd at Warra Street, stop 11",
                        "Tingal Rd at Wynnum North State School, stop 10/5",
                        "Tingal Rd at Alkoomie Street, stop 4",
                        "Tingal Rd at Wynnum near Wilde St",
                        "Tingal Rd at Leisure Centre, stop 2",
                        "Tingal Rd at Berrima Street, stop 1",
                        "Tingal Rd at Wynnum RSL",
                        "Florence St at Wynnum Library",
                        "Florence St at Wynnum Central, stop 97",
                        "Bay Tce at Clara Street Stop 96",
                        "Bay Tce at Guardian Angels School Stop 95",
                        "Bay Tce at Walnut Street, stop 94/93",
                        "Kingsley Tce at Picton Parade, stop 91",
                        "Nelson Pde at Kingsley Tce, stop 89",
                        "Nelson Pde at Boswell Terrace, stop 88",
                        "Esplanade at Manly Baths, stop 87A",
                        "Cambridge Pde at Manly Village, stop 87",
                        "Ferguson St at Richard Russell Park, stop 86",
                        "Manly station, stop 85",
                        "Ernest St at St John Vianneys School, stop 84",
                        "Ernest St at Parramatta Street, stop 83",
                        "Britannia St near Oceana Tce, stop 82",
                        "Oceana Tce at Lota House, stop 81",
                        "MacDonald St near Ernest St, stop 79",
                        "Alexander St at Lota PCYC Stop 78",
                        "Hindes St at Lota State School, stop 77",
                        "Hindes St at Bay Brooke, stop 76",
                        "Whites Rd at Hindes Street, stop 75",
                        "Whites Rd at Muriel Ave",
                        "Whites Rd at Manly Gardens, stop 73",
                        "Whites Rd at Gannon Avenue, stop 72",
                        "Whites Rd at Curtis Street, stop 71",
                        "Manly Rd at Whites Road",
                        "Manly Rd at Daisy Road Stop 68",
                        "Stannard Rd at Milfoil Street, stop 67",
                        "Stannard Rd at Stannard Road Park, stop 66",
                        "Stannard Rd at Lenora Street, stop 65",
                        "Stannard Rd at Aphrodite Street, stop 64",
                        "Stannard Rd at Stannard Road Creek, stop 63",
                        "Wondall Rd at Heers Park, stop 62",
                        "Wondall Rd at Wondall Heights State School,stop 61",
                        "Randall Rd at Network Drive, stop 60",
                        "Randall Rd at Stockyard Street, stop 59a",
                        "Randall Rd at Natasha Street, stop 59"
                    ],
                    "224: Wynnum Loop Anti-Clockwise": [
                        "Wynnum Rd at Wynnum Plaza, stop 58",
                        "Randall Rd at Natasha Street, stop 59",
                        "Randall Rd at Stockyard Street, stop 59a",
                        "Randall Rd at Network Drive, stop 60",
                        "Wondall Rd at Wondall Heights State School,stop 61",
                        "Wondall Rd at Heers Park, stop 62",
                        "Stannard Rd at Stannard Road Creek, stop 63",
                        "Stannard Rd at Aphrodite Street, stop 64",
                        "Stannard Rd at Lenora Street, stop 65",
                        "Stannard Rd at Stannard Road Park, stop 66",
                        "Stannard Rd at Milfoil Street, stop 67",
                        "Manly Rd at Daisy Road Stop 68",
                        "Manly Rd at Whites Rd",
                        "Whites Rd at Curtis Street, stop 71",
                        "Whites Rd at Gannon Avenue, stop 72",
                        "Whites Rd at Manly Gardens, stop 73",
                        "Whites Rd at Muriel Ave",
                        "Whites Rd at Hindes Street, stop 75",
                        "Hindes St at Bay Brooke, stop 76",
                        "Hindes St at Lota State School, stop 77",
                        "Alexander St at Lota PCYC Stop 78",
                        "MacDonald St near Ernest St, stop 79",
                        "Oceana Tce at Lota House, stop 81",
                        "Oceana Tce at Britannia Street, stop 82",
                        "Ernest St at Parramatta Street, stop 83",
                        "Ernest St at St John Vianneys School, stop 84",
                        "Manly station, stop 85",
                        "Ferguson St at Richard Russell Park, stop 86",
                        "Cambridge Pde at Manly Village, stop 87",
                        "Royal Esp at Manly Baths, stop 87a",
                        "Nelson Pde at Boswell Terrace, stop 88",
                        "Kingsley Tce at Nelson Parade, stop 89",
                        "Kingsley Tce at Picton Parade, stop 91",
                        "Bay Tce at Walnut Street, stop 93/94",
                        "Bay Tce at Guardian Angels School Stop 95",
                        "Bay Tce at Clara Street Stop 96",
                        "Florence St at Wynnum Central Stop 97",
                        "Florence St at Wynnum Library",
                        "Tingal Rd at Wynnum RSL, stop 99",
                        "Tingal Rd at Berrima Street, stop 1",
                        "Tingal Rd at Leisure Centre, stop 2",
                        "Tingal Rd at Wynnum, stop 3",
                        "Tingal Rd at Alkoomie Street, stop 11",
                        "Tingal Rd at Wynnum North State School, stop 10/5",
                        "Tingal Rd at Warra Street, stop 11",
                        "Tingal Rd at Shepherd Street, stop 12",
                        "Tingal Rd at Tingal - Ure, stop 13A",
                        "Wynnum North Rd at Constellation Way, st",
                        "Wynnum North Rd at Nazareth House, stop 14",
                        "Wynnum North Rd at Prospect Street, stop 15/16",
                        "Wynnum North Rd at Wynnum North Rail, stop 36/17",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Wynnum North Rd at Sibley Road, stop 38",
                        "Sibley Rd at Regent Street, stop 39/40",
                        "Sibley Rd at Florabelle Court, stop 41",
                        "Sibley Rd at Pleasantville, stop 42",
                        "Sibley Rd at Lindum Rail, stop 45/44",
                        "Malabar St at Cabanda Street, stop 46",
                        "Malabar St at Talegalla Street, stop 47",
                        "Malabar St at Birru Street, stop 48",
                        "Malabar St at Meron Street, stop 49",
                        "Malabar St at Lyones Street, stop 50",
                        "Malabar St at Nemarra Street, stop 50",
                        "Brierty St near Alex St, stop 53",
                        "Wynnum Rd at Wynnum Golf, stop 54",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58",
                        "Wynnum Rd at Plaza Street, stop 57",
                        "Wynnum Rd at BMX, stop 56/50",
                        "Kianawah Rd at Glenwood Pl",
                        "Kianawah Rd at Vikings",
                        "Kianawah Rd at Youngs Rd",
                        "Kianawah Rd at Evelyn Rd",
                        "Crawford Rd near Kanawah Rd",
                        "Crawford Rd at Pecan St",
                        "Crawford Rd at Balnave St",
                        "School Rd near New Lindum Rd",
                        "Federation St near School Rd",
                        "Federation St at Federation Park",
                        "New Lindum Rd at Health",
                        "New Lindum Rd at Moreton Bay"
                    ],
                    "225: Wynnum - Carindale": [
                        "Wynnum Esp near Florence St",
                        "Florence St at Wynnum Central Stop 97",
                        "Florence St at Wynnum Library",
                        "Dibar St near West Ave, stop 99",
                        "Stradbroke Ave at Kitchener Park",
                        "Stradbroke Ave at Golf Club",
                        "Stradbroke Ave at Carnation Street",
                        "Stradbroke Ave at Davidson Street",
                        "Stradbroke Ave at Targorin St",
                        "Wynnum Rd at Stradbroke Avenue",
                        "Wynnum Rd at Primrose Park",
                        "Wynnum Rd at Sibley Road",
                        "Wynnum Rd at Wynnum Golf, stop 54",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58",
                        "Wynnum Rd at Wynnum Plaza, stop 58",
                        "Wynnum Rd at Plaza Street, stop 57",
                        "Wynnum Rd at BMX, stop 56/50",
                        "Wynnum Rd at Kianawah Rd, stop 49/46",
                        "Wynnum Rd at Bognor Road, stop 45",
                        "Wynnum Rd at Hemmant Cemetery, stop 44",
                        "Wynnum Rd at Arena, stop 43",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Annette St at Jarrow Street, stop 49/45",
                        "Annette St at Cahia Street, stop 50/46",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Thurston St at McCorkell Street, stop 53/49",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Meadowlands Rd at Epala Street, stop 56",
                        "Meadowlands Rd at Hilltop Court, stop 57",
                        "Bedivere St at Lindisfarne Street",
                        "Bedivere St near Cadogan St",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Carindale Shopping Centre Interchange",
                        "Carindale Shopping Centre station, platform D",
                        "Bedivere St near Agravain St",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Wynnum Rd at Kianawah Rd, stop 46/49",
                        "Wynnum Rd at BMX, stop 50/56",
                        "Plaza St at Dasyure Place",
                        "Wynnum Rd at Wynnum West State School, stop 58A",
                        "Wynnum Rd at Wynnum Golf",
                        "Stradbroke Ave at Tragorin St",
                        "Andrew St near Ronald St Stop 100",
                        "Florence St at Wynnum Central, stop 97"
                    ],
                    "227: Wynnum - City": [
                        "Wynnum Rd at Wynnum Plaza, stop 58",
                        "Randall Rd at Natasha Street, stop 59",
                        "Randall Rd at Stockyard Street, stop 59a",
                        "Randall Rd at Network Drive, stop 60",
                        "Wondall Rd at Wondall Heights State School,stop 61",
                        "Wondall Rd at Heers Park, stop 62",
                        "Stannard Rd at Stannard Road Creek, stop 63",
                        "Stannard Rd at Aphrodite Street, stop 64",
                        "Stannard Rd at Lenora Street, stop 65",
                        "Stannard Rd at Stannard Road Park, stop 66",
                        "Stannard Rd at Milfoil Street, stop 67",
                        "Manly Rd at Manly West near Delsia St",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Silky Oaks",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Barramundi, stop 62",
                        "Manly Rd at Amberjack Stop 61/56",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Manly Rd at Lockwood Crescent, stop 53",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Leon, stop 43",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Shops, stop 28",
                        "Wynnum Rd at School of Arts, stop 27",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Wynnum Rd at Balmoral Street, stop 21",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Wynnum Rd at Canning Bridge, stop 17",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Lytton Rd at Mowbray Park",
                        "Shafston Ave at Salstone Street, stop 11",
                        "Shafston Ave at Connor Street, stop 10/6",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Edward Street Stop 142 near Queen St",
                        "Eagle St near Eagle Lane (Stop 64)",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Wickham Street Stop 228 near Brunswick",
                        "Main St at Story Bridge East, stop 6",
                        "Shafston Ave at Connor Street, stop 7/10",
                        "Wynnum Rd at Walter Avenue, stop 16",
                        "Wynnum Rd at Norman Creek Bridge, stop 17",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Wynnum Rd at Balmoral Cemetery, stop 23",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd near Thornlake Ct",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Manly Rd at Amberjack Stop 56/61",
                        "Manly Rd at Barramundi Stop 62",
                        "Manly Rd at Manly West near Stannard Rd"
                    ],
                    "228: Cannon Hill - City Rocket": [
                        "Cannon Hill Shopping Centre E",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Morningside Shops, stop 28",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Wynnum Rd at Balmoral Street, stop 21",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Lytton Rd at Mowbray Park",
                        "Shafston Ave at Salstone Street, stop 11",
                        "Shafston Ave at Connor Street, stop 10/6",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Edward Street Stop 142 near Queen St",
                        "Eagle St near Eagle Lane (Stop 64)",
                        "Adelaide Street Stop 30 near Macrossan St",
                        "Shafston Ave at Connor Street, stop 7/10",
                        "Wynnum Rd at Walter Avenue, stop 16",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Balmoral St near Philip St, stop 21",
                        "Cannon Hill Shopping Centre"
                    ],
                    "230: Balmoral - City via Riding Road": [
                        "Wynnum Rd at Balmoral Cemetery, stop 23",
                        "Apollo Rd near Byron St, stop 41",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Cowper St at Tennyson Street, stop 40b",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "McConnell St near Banya St",
                        "Bulimba St at Merry Street",
                        "Thynne Rd at Ison Street, stop 26",
                        "Thynne Rd at Morningside Park, stop 27",
                        "Brisbane St near Bulimba St, stop 35",
                        "Brisbane St at Coutts Street, stop 34",
                        "Thynne Rd at Morningside Police, stop 27a",
                        "Oxford St at Bulimba Ferry, stop 33",
                        "Thynne Rd at Belgrave Street, stop 28",
                        "Oxford St at Bulimba Memorial Park, stop 32",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Oxford St at Wambool Street, stop 31",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Riding Rd at Bulimba Preschool, stop 35/41",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Riding Rd near Fifth Ave, stop 34/42",
                        "Walkers Dr at Balmoral High School, stop 32",
                        "Riding Rd at Main Avenue, stop 33/43",
                        "Walkers Dr near Fifth Ave, stop 32a",
                        "Riding Rd at Victoria Street, stop 32/44",
                        "Fifth Ave near Lytton Rd, stop 33",
                        "Riding Rd at Grosvenor Street, stop 31/45",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Riding Rd at Hawthorne Park, stop 30/25",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Riding Rd at Miles Street, stop 24",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Apollo Rd at Tugulawa Park, stop 37/39",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Apollo Rd near Henderson St, stop 38",
                        "Wynnum Rd at Balmoral Street, stop 21",
                        "Apollo Rd at Shakespeare Street, stop 39",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Wynnum Rd at Canning Bridge, stop 17",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Heidelberg St at Heath Street, stop 15",
                        "Heidelberg St near Mowbray Tce, stop 14",
                        "Mowbray Tce near Northcote St, stop 13",
                        "Elfin St near Mowbray Tce, stop 12",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 27 near Creek St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Ann Street Stop 220 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Wellington Rd at Linton Street, stop 11",
                        "Mowbray Tce at Elfin Street, stop 12",
                        "Wynnum Rd at Walter Avenue, stop 16",
                        "Wynnum Rd at Norman Creek Bridge, stop 17",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Riding Rd near Sixth Ave, stop 34/42",
                        "McConnell St near Johnston St"
                    ],
                    "231: Balmoral - City Express via Riding Road": [
                        "Apollo Rd near Byron St, stop 41",
                        "Cowper St at Tennyson Street, stop 40b",
                        "McConnell St near Banya St",
                        "Bulimba St at Merry Street",
                        "Brisbane St near Bulimba St, stop 35",
                        "Brisbane St at Coutts Street, stop 34",
                        "Oxford St at Bulimba Ferry, stop 33",
                        "Oxford St at Bulimba Memorial Park, stop 32",
                        "Oxford St at Wambool Street, stop 31",
                        "Riding Rd at Bulimba Preschool, stop 35/41",
                        "Riding Rd near Fifth Ave, stop 34/42",
                        "Riding Rd at Main Avenue, stop 33/43",
                        "Riding Rd at Victoria Street, stop 32/44",
                        "Riding Rd at Grosvenor Street, stop 31/45",
                        "Riding Rd at Hawthorne Park, stop 30/25",
                        "Riding Rd at Miles Street, stop 24",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Shafston Ave at Salstone Street, stop 11",
                        "Shafston Ave at Connor Street, stop 10/6",
                        "Ann Street Stop 219 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "William Street Stop 105 near Margaret St",
                        "George Street Stop 108",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Eagle St near Eagle Lane (Stop 64)",
                        "Adelaide Street Stop 30 near Macrossan St",
                        "Shafston Ave at Connor Street, stop 7/10",
                        "Riding Rd near Sixth Ave, stop 34/42",
                        "McConnell St near Johnston St"
                    ],
                    "232: Cannon Hill - City": [
                        "Cannon Hill Shopping Centre E",
                        "Dorothea St near Richmond Rd, stop 65",
                        "Dahlia St at Delsie Street, stop 64",
                        "Dahlia St at Marsh Street, stop 62",
                        "Muir St near Beauvardia Street Stop 61",
                        "Barrack Rd near Bombery St, stop 60",
                        "Grenade St near Barrack Rd, stop 59",
                        "Grenade St at Bent Street, stop 58",
                        "Whitworth Rd near Moncrief Road Stop 57",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Junction Rd at Beelarong Street, stop 55",
                        "Junction Rd at Algoori Street, stop 54",
                        "Junction Rd at Colmslie, stop 53",
                        "Kates St at Beverley Street, stop 52",
                        "Kates St at Coates Street, stop 50",
                        "Pashen St near Thynne Rd, stop 49",
                        "Pashen St at Talma Street, stop 48",
                        "Pashen St at Morningside State School, stop 47",
                        "Pashen St at Hawthorne Park, stop 46",
                        "Riding Rd at Grosvenor Street, stop 31/45",
                        "Riding Rd at Victoria Street, stop 32/44",
                        "Riding Rd at Main Avenue, stop 33/43",
                        "Riding Rd near Sixth Ave, stop 34/42",
                        "Riding Rd at Bulimba Preschool, stop 35/41",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Apollo Rd at Tugulawa Park, stop 37/39",
                        "Apollo Rd near Henderson St, stop 38",
                        "Henderson St at Pine Street, stop 38a",
                        "Henderson St at Princess Street, stop 37",
                        "Henderson St at Bulimba Street, stop 36",
                        "Brisbane St near Bulimba St, stop 35",
                        "Brisbane St at Coutts Street, stop 34",
                        "Oxford St at Bulimba Ferry, stop 33",
                        "Oxford St at Bulimba Memorial Park, stop 32",
                        "Oxford St at Wambool Street, stop 31",
                        "Smallman St at Eton Street, stop 30",
                        "Smallman St near Carr St, stop 29",
                        "Carr St near Stuart St, stop 28",
                        "Stuart St at Leura Avenue, stop 27",
                        "Govett Ave near Jenolan Ave, stop 26",
                        "Barton Rd at Blackheath Avenue, stop 25",
                        "Gordon St at Gordon - Elliott, stop 24",
                        "Gordon St at Hawthorne Ferry, stop 23a",
                        "Lindsay St at Barton Street, stop 22b",
                        "Uhlmann St near Harris Street, stop 22a",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Wynnum Rd at Canning Bridge, stop 17",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Lytton Rd at Mowbray Park",
                        "Shafston Ave at Salstone Street, stop 11",
                        "Shafston Ave at Connor Street, stop 10/6",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Edward Street Stop 142 near Queen St",
                        "Eagle St near Eagle Lane (Stop 64)",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Riding Rd near Fifth Ave, stop 34/42",
                        "Wickham Street Stop 228 near Brunswick",
                        "Main St at Story Bridge East, stop 6",
                        "Shafston Ave at Connor Street, stop 7/10",
                        "Wynnum Rd at Walter Avenue, stop 16",
                        "Wynnum Rd at Norman Creek Bridge, stop 17",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Uhlmann St at Amy Street Stop 21c",
                        "Harris St at Uhlmann Street, stop 22",
                        "Whitworth Rd near Grenade Street Stop 57",
                        "Lindsay St at Virginia Avenue, stop 23",
                        "Lindsay St at Hawthorn Ferry, stop 23a",
                        "Gordon St at Elliott St, stop 24",
                        "Muir St near Beauvardia St, stop 61",
                        "Barton Rd at Blackheath Avenue, stop 25/26",
                        "Govett Ave at Leura Avenue, stop 27",
                        "Richmond Rd at Ludwick Street, stop 66",
                        "Cannon Hill Shopping Centre",
                        "Smallman St at Wambool Street, stop 31",
                        "Apollo Rd near Brisbane St, stop 38"
                    ],
                    "234: Woolloongabba - City Loop": [
                        "Woolloongabba station, platform 2",
                        "Main St at The Fiveways, stop 9",
                        "Main St at Linton Street, stop 8C",
                        "Main St at Llewellyn Street, stop 8B",
                        "Main St at Sinclair Street, stop 8A",
                        "Main St at River Terrace, stop 8",
                        "Main St at St Vincent's, stop 7",
                        "Main St at Thornton St",
                        "Baildon St at Story Bridge Hotel",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Edward Street Stop 142 near Queen St",
                        "Eagle St near Eagle Lane (Stop 64)",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Wickham Street Stop 228 near Brunswick",
                        "Main St at Story Bridge East, stop 6",
                        "Main St at Quinton Street, stop 7",
                        "Main St at Pearson St, stop 8",
                        "Main St at Baines Street, stop 8B",
                        "Woolloongabba station, platform 1"
                    ],
                    "235: Balmoral - City/Valley via Thynne Road": [
                        "Apollo Rd near Byron St, stop 41",
                        "Apollo Rd at Shakespeare Street, stop 39",
                        "Apollo Rd near Brisbane St, stop 38",
                        "Apollo Rd at Tugulawa Park, stop 37/39",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Fifth Avenue, stop 33",
                        "Fifth Ave at Walkers Drive, stop 32a",
                        "Walkers Dr at Balmoral High School, stop 32",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Thynne Rd at Morningside Police, stop 28",
                        "Thynne Rd at Morningside Park, stop 27",
                        "Thynne Rd at Ison Street, stop 26",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Wynnum Rd at Balmoral Street, stop 21",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Wynnum Rd at Canning Bridge, stop 17",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Heidelberg St at Heath Street, stop 15",
                        "Heidelberg St near Mowbray Tce, stop 14",
                        "Mowbray Tce near Northcote St, stop 13",
                        "Elfin St near Mowbray Tce, stop 12",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 27 near Creek St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Ann Street Stop 220 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Wellington Rd at Linton Street, stop 11",
                        "Mowbray Tce at Elfin Street, stop 12",
                        "Wynnum Rd at Walter Avenue, stop 16",
                        "Wynnum Rd at Norman Creek Bridge, stop 17",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Wynnum Rd at Balmoral Cemetery, stop 23",
                        "Thynne Rd at Morningside Police, stop 27a",
                        "Thynne Rd at Belgrave Street, stop 28",
                        "Walkers Dr near Fifth Ave, stop 32a",
                        "Fifth Ave near Lytton Rd, stop 33",
                        "Apollo Rd near Henderson St, stop 38",
                        "Cowper St at Tennyson Street, stop 40b",
                        "McConnell St near Banya St",
                        "Bulimba St at Merry Street",
                        "Brisbane St near Bulimba St, stop 35",
                        "Brisbane St at Coutts Street, stop 34",
                        "Oxford St at Bulimba Ferry, stop 33",
                        "Oxford St at Bulimba Memorial Park, stop 32",
                        "Oxford St at Wambool Street, stop 31",
                        "Riding Rd at Bulimba Preschool, stop 35/41",
                        "Riding Rd near Fifth Ave, stop 34/42",
                        "Riding Rd at Main Avenue, stop 33/43",
                        "Riding Rd at Victoria Street, stop 32/44",
                        "Riding Rd at Grosvenor Street, stop 31/45",
                        "Riding Rd at Hawthorne Park, stop 30/25",
                        "Riding Rd at Miles Street, stop 24",
                        "Riding Rd at Goulburn Street, stop 23"
                    ],
                    "236: Balmoral - City Express via Thynne Road": [
                        "Apollo Rd near Byron St, stop 41",
                        "Apollo Rd at Shakespeare Street, stop 39",
                        "Apollo Rd near Brisbane St, stop 38",
                        "Apollo Rd at Tugulawa Park, stop 37/39",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Fifth Avenue, stop 33",
                        "Fifth Ave at Walkers Drive, stop 32a",
                        "Walkers Dr at Balmoral High School, stop 32",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Thynne Rd at Morningside Police, stop 28",
                        "Thynne Rd at Morningside Park, stop 27",
                        "Thynne Rd at Ison Street, stop 26",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Shafston Ave at Salstone Street, stop 11",
                        "Shafston Ave at Connor Street, stop 10/6",
                        "Ann Street Stop 219 at All Hallows",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall",
                        "William Street Stop 105 near Margaret St",
                        "George Street Stop 108",
                        "Elizabeth Street Stop 84 near Edward St",
                        "Eagle St near Eagle Lane (Stop 64)",
                        "Adelaide Street Stop 30 near Macrossan St",
                        "Shafston Ave at Connor Street, stop 7/10",
                        "Wynnum Rd at Balmoral Cemetery, stop 23",
                        "Thynne Rd at Morningside Police, stop 27a",
                        "Thynne Rd at Belgrave Street, stop 28",
                        "Walkers Dr near Fifth Ave, stop 32a",
                        "Fifth Ave near Lytton Rd, stop 33",
                        "Apollo Rd near Henderson St, stop 38",
                        "Cowper St at Tennyson Street, stop 40b"
                    ],
                    "240: Capalaba - Wynnum": [
                        "Florence St at Wynnum Central Stop 97",
                        "Florence St at Wynnum Library",
                        "Bay Tce at Clara Street Stop 96",
                        "Bay Tce at Guardian Angels School Stop 95",
                        "Mountjoy Tce near Irene St",
                        "Gordon Pde near Oakley St",
                        "Manly Rd at Preston Rd",
                        "Manly Rd at Whites Road",
                        "Manly Rd at Daisy Road Stop 68",
                        "Manly Rd at Manly West near Delsia St",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Silky Oaks",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Amberjack Stop 61/56",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "New Cleveland Rd at Eastside Village",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Green Camp Rd",
                        "New Cleveland Rd near Old Cleveland Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station arrival stop 2",
                        "Capalaba bus station, stop A",
                        "Old Cleveland Rd near Tinchborne St",
                        "New Cleveland Rd near Archer St",
                        "Arenga St near Lexey Cres",
                        "Manly Rd at Amberjack Stop 56/61",
                        "Manly Rd at Barramundi Stop 62",
                        "Manly Rd at Manly West near Stannard Rd",
                        "Manly Rd at Whites Rd",
                        "Manly Rd near Fisher St Stop 70",
                        "Gordon Pde near Haylock St",
                        "Mountjoy Tce near Wolsey Pde"
                    ],
                    "242: Wakerley - Carindale (Loop)": [
                        "New Cleveland Rd at Eastside Village",
                        "Carindale Shopping Centre station, platform J",
                        "New Cleveland Rd near Judd St",
                        "Old Cleveland Rd near Scrub Rd",
                        "Old Cleveland Rd near Adley St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Green Camp Rd",
                        "Wright St at Melaleuca Place",
                        "Green Camp Rd near Gumdale St",
                        "Grassdale Rd near Belmont Rd",
                        "Green Camp Rd at Habitat Drive",
                        "Grassdale Rd at Stanbrough Rd",
                        "Manly Rd at Catamaran Stop 55",
                        "Stanbrough Rd near Grassdale Rd",
                        "Manly Rd at Moss Road Stop 54",
                        "Stanbrough Rd near Formosa St",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "Stanbrough Rd at Formosa St",
                        "Grassdale Rd near Stanbrough Rd",
                        "Old Cleveland Rd at Belmont Primary School"
                    ],
                    "243: Capalaba - Brisbane City": [
                        "Capalaba park 'n' ride, platform 1",
                        "Capalaba bus station, stop E",
                        "Old Cleveland Rd near Tinchborne St",
                        "New Cleveland Rd near Old Cleveland Rd",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "New Cleveland Rd at Eastside Village",
                        "Tilley Rd at New Cleveland Road",
                        "Tilley Rd near Grassdale Rd",
                        "Tilley Rd near London Rd",
                        "The Sleeman Centre, stop C",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "The Sleeman Centre, stop D",
                        "Tilley Rd at London Road",
                        "Arenga St near Lexey Cres",
                        "Green Camp Rd near New Cleveland Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station, stop D",
                        "Capalaba park 'n' ride, platform 2"
                    ],
                    "250: Redland Bay - Carindale": [
                        "Redland Bay Marina, platform 1",
                        "Hamilton St at Pitt Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Cleveland Redland Bay Rd at Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near Melanie St",
                        "Cleveland Redland Bay Rd near South St",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Long St",
                        "Bloomfield St at Long Street",
                        "Bloomfield St at Princess Street",
                        "Bloomfield St at Donald Simpson Park",
                        "Bloomfield St near Russell St",
                        "Middle Street, stop A",
                        "Cleveland station",
                        "Shore St at Black Swamp Wetlands",
                        "Shore St at RACQ",
                        "Shore St at Grant Street",
                        "Finucane Rd at Redland Research Station",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Vienna Road",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Finucane Rd at Alexandra Hills High School",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Finucane Rd at Willard Road",
                        "Moreton Bay Rd at Dan St",
                        "Capalaba park 'n' ride, platform 1",
                        "Capalaba bus station, stop E",
                        "Old Cleveland Rd near Tinchborne St",
                        "Old Cleveland Rd near Swinton St",
                        "Old Cleveland Rd near Bacton Rd",
                        "The Sleeman Centre, stop A",
                        "Old Cleveland Rd at Belmont Shooting Complex",
                        "Old Cleveland Rd near Scrub Rd",
                        "Old Cleveland Rd at Belmont Primary School",
                        "Carindale Shopping Centre station, platform J",
                        "Old Cleveland Rd near Adley St",
                        "Old Cleveland Rd at Barbeque St",
                        "Old Cleveland Rd near Stanbrough Rd",
                        "The Sleeman Centre, stop B",
                        "Old Cleveland Rd near Archer St",
                        "Old Cleveland Rd near New Cleveland Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station, stop D",
                        "Capalaba park 'n' ride, platform 2",
                        "Finucane Rd at Old Cleveland Rd",
                        "Finucane Rd at Keith Surridge Park",
                        "Finucane Rd at Dawson Road",
                        "Middle Street, stop B",
                        "Bloomfield St near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Victoria Point Central, platform 2",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street"
                    ],
                    "251: Ormiston - Brisbane City": [
                        "Rose St near Hilliard St",
                        "McCartney St near Wellington St",
                        "Wellington St near Oak St",
                        "Wellington St at Clearwater St",
                        "Wellington St at Counihan St",
                        "Sturgeon St near Delancey St",
                        "Delancey St near Freeth St",
                        "Finucane Rd at Redland Research Station",
                        "Finucane Rd at McDonald Road",
                        "McDonald Rd at McMillan Rd",
                        "McDonald Rd at MacDonald Road Park",
                        "McDonald Rd at Montgomery Drive",
                        "Allenby Rd near Balmoral St",
                        "Allenby Rd at Monarch St",
                        "Allenby Rd near Topaz St",
                        "Edinburgh Rd at Ogilvie St",
                        "Edinburgh Rd near Act Ct",
                        "Edinburgh Rd at Snowdon St",
                        "Reign St near George St",
                        "Princeton Ave near Garter St",
                        "Jasmine St at Alpinia St",
                        "Bluebell St at Celosia St",
                        "Bluebell St near Gerbera St",
                        "Abelia St near Amarylis St",
                        "Abelia St near Armando St",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Finucane Rd at Willard Road",
                        "Moreton Bay Rd at Dan St",
                        "Capalaba park 'n' ride, platform 1",
                        "Old Cleveland Rd near Bacton Rd",
                        "The Sleeman Centre, stop C",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "The Sleeman Centre, stop D",
                        "Old Cleveland Rd near Archer St",
                        "Capalaba park 'n' ride, platform 2",
                        "Finucane Rd at Old Cleveland Rd",
                        "Abelia St near Ellora St",
                        "Abelia St near Babiana St",
                        "Bluebell St near Celosia St",
                        "Jasmine St near Alpinia St",
                        "Princeton Ave at Garter St",
                        "Reign St at George St",
                        "Edinburgh Rd at Act Ct",
                        "Allenby Rd near Monarch St",
                        "McDonald Rd near Montgomery Dr",
                        "Finucane Rd at Dawson Road",
                        "Delancey St near Sturgeon St",
                        "Sturgeon St at Delancey St",
                        "Wellington St near Counihan St"
                    ],
                    "252: Capalaba - Cleveland via Alexandra Hills (Loop)": [
                        "Cleveland station",
                        "Capalaba bus station, stop B",
                        "Middle Street, stop A",
                        "Old Cleveland Rd at Sam Sciacca Sportsfield",
                        "Old Cleveland Rd at Anderson Street",
                        "Shore St at Black Swamp Wetlands",
                        "Finucane Rd at Old Cleveland Rd",
                        "Gordon St near Cowley St",
                        "Finucane Rd at Willard Road",
                        "Gordon St at Ormiston Primary School",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Sturgeon St near Wellington St",
                        "Abelia St near Ellora St",
                        "Sturgeon St near Delancey St",
                        "Abelia St near Babiana St",
                        "Old Cleveland Rd near Starkey St",
                        "Bluebell St near Gerbera St",
                        "Old Cleveland Rd at Kefford St",
                        "Bluebell St near Celosia St",
                        "Old Cleveland Rd near McDonald Rd",
                        "Jasmine St near Alpinia St",
                        "Allenby Rd near Montgomery Dr",
                        "Princeton Ave at Garter St",
                        "Allenby Rd near Balmoral St",
                        "Allenby Rd at Monarch St",
                        "Reign St at George St",
                        "Allenby Rd near Topaz St",
                        "Edinburgh Rd at Snowdon St",
                        "Edinburgh Rd at Act Ct",
                        "Edinburgh Rd at Ogilvie St",
                        "Edinburgh Rd near Act Ct",
                        "Allenby Rd near Monarch St",
                        "Reign St near George St",
                        "Princeton Ave near Garter St",
                        "Allenby Rd at Montgomery Drive",
                        "Jasmine St at Alpinia St",
                        "Old Cleveland Rd near Main Rd",
                        "Bluebell St at Celosia St",
                        "Old Cleveland Rd East at Kefford St",
                        "Sturgeon St near Starkey St",
                        "Abelia St near Amarylis St",
                        "Sturgeon St at Delancey St",
                        "Abelia St near Armando St",
                        "Gordon St near Bainbridge St",
                        "Old Cleveland Rd at Capalaba Central",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "253: Capalaba - Thorneside": [
                        "Thorneside station",
                        "Ferry Rd near Thorneside Rd",
                        "Thorneside Rd near Bayside Ct",
                        "Thorneside Rd at Fisher Rd",
                        "Thorneside Rd at Leon St",
                        "Thorneside Rd near jean St",
                        "Jean St near Mooroondu Rd",
                        "Mooroondu Rd near Nora St",
                        "Mooroondu Rd near Saul St",
                        "Mooroondu Rd at Ethel St",
                        "Mooroondu Rd near Marlin St",
                        "Thorne Rd near Mary St",
                        "Mary Pleasant Dr near Dorsal Dr",
                        "Birkdale Rd at Birkdale Fair",
                        "Birkdale Rd near Napier St",
                        "Clive Rd near Bandiera St",
                        "Byng Rd near Mecoli Ct",
                        "Byng Rd near Marcos St",
                        "Byng Rd near Almond Ave",
                        "Collingwood Rd at Redlands Mobile Village",
                        "Prins Willem Alexander Village",
                        "Collingwood Dr at Serendipity Close",
                        "Spoonbill St near Sunnybay Dr",
                        "Spoonbill St near Burbank Rd",
                        "Spoonbill St near Finch St",
                        "Old Cleveland Rd near Randall Rd",
                        "Old Cleveland Rd near Rossinton St",
                        "Old Cleveland Rd near Carinyan Dr",
                        "Old Cleveland Rd at Robinson Park",
                        "Old Cleveland Rd at Buckingham Street",
                        "Old Cleveland Rd at Daveson Road",
                        "Old Cleveland Rd at Brewer Street",
                        "Old Cleveland Rd at Anderson Street",
                        "Old Cleveland Rd at Capalaba Central",
                        "Old Cleveland Rd at Sam Sciacca Sportsfield",
                        "Capalaba bus station arrival stop 2",
                        "Capalaba bus station, stop A",
                        "Old Cleveland Rd near Buckingham St",
                        "Old Cleveland Rd East at Birkdale South SS",
                        "Old Cleveland Rd near Currawong Dr",
                        "Old Cleveland Rd East at Randall Rd",
                        "Spoonbill St near Peacock Ct",
                        "Collingwood Rd at Serendipity Close",
                        "Collingwood Road at Redland Mobile Village",
                        "Byng Rd at Almond Ave",
                        "Quarry Rd near Rosewood St",
                        "Birkdale Rd at Birkdale Primary School",
                        "Mary Pleasant Dr at Dorsal Dr",
                        "Thorne Rd at Mary St",
                        "Mooroondu Rd near Thorne Rd",
                        "Mooroondu Rd near Alma St",
                        "Mooroondu Rd near Fisher Rd",
                        "Mooroondu Rd at John St",
                        "Thorneside Rd at Helen Street",
                        "Thorneside Rd near John St",
                        "Thorneside Rd at Hugh Street",
                        "Thorneside Rd at Queens Esplanade",
                        "Thorneside Rd at Bayside Ct"
                    ],
                    "254: Capalaba - Wellington Point": [
                        "Birkdale station",
                        "Reserve Esplanade at Wellington Point Jetty",
                        "Birkdale Rd at Collingwood Road",
                        "Main Rd near Esplanade",
                        "Birkdale Rd at Creek Road",
                        "Main Rd at Bayview Street",
                        "Birkdale Rd at Wellington Point Shops",
                        "Old Cleveland Rd East at Birkdale South SS",
                        "Barron Rd at Birkdale South Primary School",
                        "Birkdale Rd at EGW Wood Sportsfield",
                        "Birkdale Rd at Wellington Point High School",
                        "Valantine Rd at Bailey Rd",
                        "Birkdale Rd at Wellington Manor Village",
                        "Valantine Rd near Bluebell St",
                        "Birkdale Rd at Edwardson Court",
                        "Abelia St near Amarylis St",
                        "Birkdale Rd at Birkdale Fair",
                        "Abelia St near Armando St",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Birkdale Rd near Napier St",
                        "Finucane Rd at Willard Road",
                        "Old Cleveland Rd at Anderson Street",
                        "Old Cleveland Rd at Capalaba Central",
                        "Old Cleveland Rd at Sam Sciacca Sportsfield",
                        "Capalaba bus station arrival stop 2",
                        "Capalaba bus station, stop A",
                        "Finucane Rd at Old Cleveland Rd",
                        "Abelia St near Ellora St",
                        "Abelia St near Babiana St",
                        "Valantine Rd near Leith St",
                        "Valantine Rd near Bailey Rd",
                        "Old Cleveland Rd near Carinyan Dr",
                        "Birkdale Rd at Birkdale Primary School",
                        "Main Rd near Jellicoe St",
                        "Main Rd at Marshall Lane"
                    ],
                    "255: Cleveland - Birkdale": [
                        "Middle Street, stop A",
                        "Queen St near Haggup St",
                        "Queen St near Wellington St",
                        "Wellington St near Queen St",
                        "Freeth St W at Wellington Street",
                        "Finucane Rd at Redland Research Station",
                        "Finucane Rd at McDonald Road",
                        "McDonald Rd at McMillan Rd",
                        "McDonald Rd at MacDonald Road Park",
                        "McDonald Rd at Montgomery Drive",
                        "Allenby Rd at Montgomery Drive",
                        "Old Cleveland Rd near McDonald Rd",
                        "Tulloch Dr near Riverton St",
                        "Tulloch Dr at Redgrove Avenue",
                        "Hardy Rd near Collingwood Rd",
                        "Marlborough Rd near Bayfields Ave",
                        "Marlborough Rd at Bella Street",
                        "Main Rd at Whepstead Manor",
                        "Main Rd near Crossley Dr",
                        "Main Rd near Courtice St",
                        "Main Rd at Apsley Street",
                        "Birkdale Rd at Wellington Point Shops",
                        "Birkdale Rd at EGW Wood Sportsfield",
                        "Birkdale Rd at Wellington Point High School",
                        "Birkdale Rd at Wellington Manor Village",
                        "Birkdale Rd at Edwardson Court",
                        "Birkdale Rd at Birkdale Fair",
                        "Birkdale Rd near Napier St",
                        "Birkdale station",
                        "Birkdale Rd at Birkdale Primary School",
                        "Main Rd near Station St",
                        "Marlborough Rd near Crossley Dr",
                        "Tulloch Dr at Redgrove Ave",
                        "Tulloch Dr near Biscay St",
                        "Old Cleveland Rd near Main Rd",
                        "Allenby Rd near Montgomery Dr",
                        "McDonald Rd near Montgomery Dr",
                        "Finucane Rd at Dawson Road",
                        "Cleveland station"
                    ],
                    "261: Mackenzie - Brisbane City": [
                        "Grieve Rd near Ford Rd",
                        "Grieve Rd",
                        "Grieve Rd near Pillinger Rd",
                        "Grieve Rd near Rochedale Rd",
                        "Mackenzie State Primary School",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Gainsborough Ave near Monet Cr",
                        "Rembrandt Way at Gainsborough Park",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Gardner Rd at Arise Boulevard",
                        "Miles Platting Rd at Gardner Rd",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Gardner Road at Prebble Street",
                        "Grieve Rd at Mt Gravatt Capalaba Rd"
                    ],
                    "262: Capalaba - Griffith University via Mackenzie": [
                        "Capalaba bus station, stop B",
                        "Capalaba park 'n' ride, platform 2",
                        "Finucane Rd at Old Cleveland Rd",
                        "Finucane Rd at Willard Road",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Windemere Rd at Keith Surridge Park",
                        "Windemere Rd at Sophia Place",
                        "Windemere Rd at Stovold Pl",
                        "Redland Bay Rd at Ney Road",
                        "Ney Rd at Jeffrey Street",
                        "Ney Rd at Callaghan Way",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Coolnwynpin Primary School",
                        "Ney Rd near Coolnwynpin Way",
                        "Degen Rd near St Lukes Ct",
                        "Mount Cotton Rd at Alperton Rd",
                        "Mount Cotton Rd near Moxon Rd",
                        "Mount Cotton Rd at Daymar Street",
                        "Mt Gravatt Capalaba Rd at Gateway Baptist",
                        "Mackenzie State Primary School",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Gainsborough Ave near Monet Cr",
                        "Rembrandt Way at Gainsborough Park",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Gardner Rd at Arise Boulevard",
                        "Miles Platting Rd at Gardner Rd",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Griffith University station, platform 2",
                        "Degen Rd at St Lukes Catholic Primary School",
                        "Upper Mt Gravatt station, platform 2",
                        "Ney Rd at Capalaba Sports Club",
                        "Eight Mile Plains station, platform 2",
                        "Redland Bay Rd at Coolnwynpin Creek",
                        "Gardner Road at Prebble Street",
                        "Windemere Rd at Alexandra Hills High School",
                        "Finucane Rd at Alexandra Hills High School",
                        "Moreton Bay Rd at Dan St",
                        "Capalaba park 'n' ride, platform 1",
                        "Capalaba bus station, stop A"
                    ],
                    "263: Capalaba - Sheldon (Avalon Rd)": [
                        "Kiwi St near Campbell Rd",
                        "Capalaba bus station, stop C",
                        "Mount Cotton Road at Pittwin Road North",
                        "Kiwi St near Emu St",
                        "Mount Cotton Rd at Winter Memorial Park",
                        "Emu St near Avalon Rd",
                        "Mount Cotton Rd at Killarney Crescent",
                        "Avalon Rd near Campbell Rd",
                        "Pioneer Rd near Summit St",
                        "School Rd at Capalaba State College",
                        "Avalon Rd near Summit St",
                        "Ney Rd near Koala Pl",
                        "School Rd at Gandarra Street",
                        "Ney Rd at Capalaba Sports Club",
                        "School Rd at Balandra Street",
                        "Ney Rd at Jeffrey Street",
                        "Macquarie St near Ney Rd",
                        "Macquarie St near Jacaranda Rd",
                        "Wentworth Dr near Bute Street",
                        "Mount Cotton Rd near Jacaranda Rd",
                        "Wentworth Dr near Wills Lane",
                        "Wentworth Dr near Blaxland St",
                        "Wentworth Dr near Cunningham St",
                        "Wentworth Dr near Bute St",
                        "Ney Rd near Coolnwynpin Way",
                        "School Rd at Toni Street",
                        "Ney Rd at Koala Place",
                        "School Rd near Gandarra St",
                        "Avalon Rd at Summit Street",
                        "Mount Cotton Rd near Killarney Cr",
                        "Mount Cotton Rd near Pittwin Rd",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "264: Capalaba - Alexandra Hills via Maridale Park": [
                        "Cambridge Dr at Alexandra Hills Shops",
                        "Cumberland Dr at Lorton Ct",
                        "Cumberland Dr near Thirlmere Rd",
                        "Cumberland Dr near Sherington St",
                        "Cumberland Dr near Henley St",
                        "Cumberland Dr near Vienna Rd",
                        "Vienna Rd near Winchester Rd",
                        "Vienna Rd near Canterbury St",
                        "Vienna Rd at Alexandra Circuit",
                        "Vienna Rd near Wimborne Rd",
                        "Vienna Rd at Burwood Road",
                        "Lyndon Rd near Korawal St",
                        "Korawal St near Timbarra Ct",
                        "Montana Dr at Ivana Ct",
                        "Spirit Dr at Sunburst Ct",
                        "Callaghan Way near Telaska Ct",
                        "Callaghan Way near Brosnan Dr",
                        "Callaghan Way at Greenup St",
                        "Wentworth Dr near Bute Street",
                        "Wentworth Dr near Wills Lane",
                        "Wentworth Dr near Blaxland St",
                        "Mount Cotton Rd near Howlett Rd",
                        "Mount Cotton Rd near Larbonya Cr",
                        "School Rd at Capalaba State College",
                        "School Rd at Gandarra Street",
                        "School Rd at Balandra Street",
                        "Redland Bay Rd at Andrew Street",
                        "Redland Bay Rd at Merritt Street",
                        "Redland Bay Rd at Smith Street",
                        "Capalaba bus station arrival stop 1",
                        "Capalaba bus station, stop C",
                        "School Rd at Toni Street",
                        "School Rd near Gandarra St",
                        "Mount Cotton Rd near School Rd",
                        "Wentworth Dr near Cunningham St",
                        "Wentworth Dr near Bute St",
                        "Callaghan Way near Greenup St",
                        "Callaghan Way at Brosnan Drive",
                        "Callaghan Way near Frost St",
                        "Montana Dr near Riley Dr",
                        "Vienna Rd at Wimborne Road",
                        "Vienna Rd near Redruth Rd",
                        "Vienna Rd near Cumberland Dr",
                        "Cumberland Dr at Henly St",
                        "Cumberland Dr at Sherrington Street",
                        "Windemere Rd at Alexandra Hills High School",
                        "Finucane Rd at Keith Surridge Park"
                    ],
                    "265: Maridale Park - Brisbane City": [
                        "Lyndon Rd near Mount Cotton Rd",
                        "Lyndon Rd near Firtree St",
                        "Lyndon Rd near Kurrajong St",
                        "Lyndon Rd near Honeymyrtle Ct",
                        "Korawal St near Timbarra Ct",
                        "Montana Dr at Ivana Ct",
                        "Spirit Dr at Sunburst Ct",
                        "Callaghan Way near Telaska Ct",
                        "Callaghan Way near Brosnan Dr",
                        "Callaghan Way at Greenup St",
                        "Ney Rd at Callaghan Way",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Macquarie St near Ney Rd",
                        "Macquarie St near Jacaranda Rd",
                        "Macquarie St near Simpson St",
                        "Wentworth Dr near Bute Street",
                        "Wentworth Dr near Wills Lane",
                        "Wentworth Dr near Blaxland St",
                        "Mount Cotton Rd near Howlett Rd",
                        "Mount Cotton Rd near Larbonya Cr",
                        "Mount Cotton Rd near Killarney Cr",
                        "Mount Cotton Rd at Winter Memorial Park",
                        "Old Cleveland Rd near Bacton Rd",
                        "The Sleeman Centre, stop C",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "The Sleeman Centre, stop D",
                        "Old Cleveland Rd near Archer St",
                        "Mount Cotton Rd at Killarney Crescent",
                        "Mount Cotton Rd near School Rd",
                        "Wentworth Dr near Cunningham St",
                        "Wentworth Dr near Bute St",
                        "Macquarie St at Mitchell Street",
                        "Callaghan Way near Greenup St",
                        "Callaghan Way at Brosnan Drive",
                        "Callaghan Way near Frost St",
                        "Montana Dr near Riley Dr",
                        "Lyndon Rd near Mahogany St",
                        "Lyndon Rd near Duncan Rd"
                    ],
                    "266: Capalaba - Alexandra Hills (Loop)": [
                        "Capalaba bus station, stop C",
                        "Old Cleveland Rd at Sam Sciacca Sportsfield",
                        "Old Cleveland Rd at Anderson Street",
                        "Finucane Rd at Old Cleveland Rd",
                        "Elmhurst St near Sutphin St",
                        "Elmhurst St near Crotona Rd",
                        "Crotona Rd at Randwick St",
                        "Crotona Rd near Draycott St",
                        "Crotona Rd near Wicks Ct",
                        "Crotona Rd at Windemere Road",
                        "Windemere Rd at Sophia Place",
                        "Brompton St near Workington St",
                        "Brompton St near Kenton St",
                        "Brompton St near Cumberland Dr",
                        "Cumberland Dr near Thirlmere Rd",
                        "Cumberland Dr at Lorton Ct",
                        "Cambridge Dr at Charles Court",
                        "Vienna Rd near Cambridge Dr",
                        "Heffernan Rd near OGorman St",
                        "Winchester Rd at Osmond Ct",
                        "Winchester Rd near Nandeebie Care Centre",
                        "Winchester Rd near Belgravia St",
                        "Winchester Rd near Suthurst Ct",
                        "Vienna Rd near Canterbury St",
                        "Vienna Rd at Alexandra Circuit",
                        "Alexandra Cct near Keynsham St",
                        "Hanover Dr near Garden St",
                        "Hanover Dr near Glenella Ct",
                        "Hanover Dr near Nanette Ct",
                        "Alexandra Cct at Hilliard Primary School",
                        "Alexandra Cct near Goorawin St",
                        "Vienna Rd near Redruth Rd",
                        "Winchester Rd at Payne Ct",
                        "Winchester Rd near Osmond Ct",
                        "Heffernan Rd near Lawrence Ct",
                        "Brompton St near Carrock St",
                        "Brompton St near Liddel Ct",
                        "Finucane Rd at Willard Road",
                        "Old Cleveland Rd at Capalaba Central",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "267: Alexandra Hills - Brisbane City": [
                        "Vienna Rd at Burwood Road",
                        "Vienna Rd at Wimborne Road",
                        "Hanover Dr at Hilliard Primary School",
                        "Hanover Dr near Nanette Ct",
                        "Hanover Dr near Palana Dr",
                        "Hanover Dr near Garden St",
                        "Alexandra Cct near Chiseldon St",
                        "Vienna Rd at Alexandra Circuit",
                        "Vienna Rd near Canterbury St",
                        "Vienna Rd near Cumberland Dr",
                        "Cumberland Dr near Vienna Rd",
                        "Cumberland Dr at Henly St",
                        "Cumberland Dr at Sherrington Street",
                        "Brompton St near Carrock St",
                        "Brompton St near Kenton St",
                        "Brompton St near Liddel Ct",
                        "Windemere Rd at Sophia Place",
                        "Crotona Rd at Windemere Road",
                        "Crotona Rd near Wicks Ct",
                        "Crotona Rd near Draycott St",
                        "Crotona Rd at Randwick St",
                        "Elmhurst St near Crotona Rd",
                        "Elmhurst St near Sutphin St",
                        "Finucane Rd at Willard Road",
                        "Moreton Bay Rd at Dan St",
                        "Capalaba park 'n' ride, platform 1",
                        "Capalaba bus station, stop E",
                        "Old Cleveland Rd near Tinchborne St",
                        "Old Cleveland Rd near Swinton St",
                        "Old Cleveland Rd near Bacton Rd",
                        "The Sleeman Centre, stop C",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "The Sleeman Centre, stop D",
                        "Old Cleveland Rd near Archer St",
                        "Old Cleveland Rd near New Cleveland Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station, stop D",
                        "Capalaba park 'n' ride, platform 2",
                        "Finucane Rd at Old Cleveland Rd",
                        "Brompton St near Workington St",
                        "Brompton St near Cumberland Dr",
                        "Cumberland Dr near Sherington St",
                        "Cumberland Dr near Henley St",
                        "Vienna Rd near Winchester Rd",
                        "Alexandra Cct near Keynsham St",
                        "Hanover Dr near Glenella Ct",
                        "Alexandra Cct at Hilliard Primary School",
                        "Alexandra Cct near Goorawin St",
                        "Vienna Rd near Wimborne Rd"
                    ],
                    "26: Upper Mt Gravatt - RBWH via Fortitude Valley": [
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Woolloongabba station, platform 2",
                        "Main St at The Fiveways, stop 9",
                        "Main St at Linton Street, stop 8C",
                        "Main St at Llewellyn Street, stop 8B",
                        "Main St at Sinclair Street, stop 8A",
                        "Main St at River Terrace, stop 8",
                        "Main St at St Vincent's, stop 7",
                        "Main St at Thornton St",
                        "Brunswick Street Stop 211",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "Brunswick St at Water Street, stop 6",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "RBWH station, platform 2",
                        "RBWH station, platform 1",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Main St at Quinton Street, stop 7",
                        "Main St at Pearson St, stop 8",
                        "Main St at Baines Street, stop 8B",
                        "Woolloongabba station, platform 1",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2"
                    ],
                    "270: Victoria Point Jetty - Carindale": [
                        "Victoria Point Jetty",
                        "Colburn Av at White Street",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at Thompson Street",
                        "Link Rd at Fryar Street",
                        "Link Rd at Salford Waters Retirement Estate",
                        "Benfer Rd at Bangalow Street",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Poinciana Avenue",
                        "Benfer Rd near Prescoter Dr",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Boundary Rd at Kinross Road",
                        "Boundary Rd at Taylor Rd",
                        "Redland Bay Rd near Parkwood Dr",
                        "Redland Bay Rd near Teesdale Rd",
                        "Redland Bay Rd near Seven Oaks St",
                        "Redland Bay Rd at Lyndon Road",
                        "Redland Bay Rd at Runnymede Road",
                        "Redland Bay Rd near Number 273",
                        "Redland Bay Rd at Windemere Rd",
                        "Redland Bay Rd at Ney Road",
                        "Redland Bay Rd at Andrew Street",
                        "Redland Bay Rd at Merritt Street",
                        "Redland Bay Rd at Smith Street",
                        "Capalaba bus station, stop E",
                        "Old Cleveland Rd near Tinchborne St",
                        "Old Cleveland Rd near Swinton St",
                        "Old Cleveland Rd near Bacton Rd",
                        "The Sleeman Centre, stop A",
                        "Old Cleveland Rd at Belmont Shooting Complex",
                        "Old Cleveland Rd near Scrub Rd",
                        "Old Cleveland Rd at Belmont Primary School",
                        "Carindale Shopping Centre station, platform J",
                        "Capalaba bus station, stop D",
                        "Old Cleveland Rd near Adley St",
                        "Old Cleveland Rd at Barbeque St",
                        "Old Cleveland Rd near Stanbrough Rd",
                        "The Sleeman Centre, stop B",
                        "Redland Bay Rd at Coolnwynpin Creek",
                        "Old Cleveland Rd near Archer St",
                        "Old Cleveland Rd near New Cleveland Rd",
                        "Redland Bay Rd at Greater Glider C.A",
                        "Redland Bay Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Redland Bay Rd at Vienna Road",
                        "Boundary Rd at Panorama Drive",
                        "Boundary Rd at Springacre Road",
                        "Victoria Point Central, platform 2",
                        "Colburn Ave at Thompson Street"
                    ],
                    "271: Toondah Harbour - Redlands": [
                        "Emmett Drive at Toondah Harbour Ferry",
                        "Emmett Drive near Middle St",
                        "Middle St at Redlands RSL Services",
                        "Middle St at Island Street",
                        "Middle Street, stop A",
                        "Cleveland station",
                        "Queen St near Haggup St",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Smith St near Long St",
                        "Smith St near Bay St",
                        "Bay St near Olympus Dr",
                        "Weippin St at Redland Private Hospital",
                        "Weippin St at Redland Hospital",
                        "Bay St near Wellington St",
                        "Middle Street, stop B"
                    ],
                    "272: Redland Bay - Redland Hospital via Thornlands": [
                        "Redland Bay Marina, platform 1",
                        "Hamilton St at Pitt Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Dinwoodie Rd near Pinecone Pl",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Ziegenfusz Rd near Tuna Ct",
                        "Vintage Dr at Bayview State School",
                        "Vintage Dr near Abalone Cr",
                        "Vintage Dr near Noir Ct",
                        "Island Outlook Ave at Vintage Drive",
                        "Cleveland Redland Bay near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near Melanie St",
                        "Cleveland Redland Bay Rd near South St",
                        "South St at Redlands District Special School",
                        "South St at Osprey Drive",
                        "Wellington St near Enterprise St",
                        "Weippin St at Redland Private Hospital",
                        "Weippin St at Redland Hospital",
                        "Wellington St near South St",
                        "South St near Osprey Dr",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Island Outlook Ave at Sylvie Street",
                        "Vintage Dr near Touriga St",
                        "Ziegenfusz Rd near Doull Pl",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Victoria Point Central, platform 2",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street"
                    ],
                    "273: Cleveland - Brisbane City via Redland Bay Rd": [
                        "Sunshine Dr near Coburg Cl",
                        "Sunshine Dr near Gretel Pl",
                        "Sunshine Dr near Admiralty Ct",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Long St at Topatig Street",
                        "Bloomfield St near Long St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near South St",
                        "Panorama Dr near Laurette Ave",
                        "Panorama Dr at Robert Mackie Park",
                        "Panorama Dr at Abbotsleigh Street",
                        "Panorama Dr at Manhattan Avenue",
                        "Moselle Dr near Cabernet Cr",
                        "Moselle Dr near Chateau St",
                        "Moselle Dr near Ziegenfusz Rd",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Panorama Dr near Milner Pl",
                        "Panorama Dr near Boundary Road",
                        "Boundary Rd at Woodlands Drive",
                        "Boundary Rd at Kinross Road",
                        "Boundary Rd at Taylor Rd",
                        "Redland Bay Rd near Parkwood Dr",
                        "Redland Bay Rd near Teesdale Rd",
                        "Redland Bay Rd near Seven Oaks St",
                        "Redland Bay Rd at Lyndon Road",
                        "Redland Bay Rd at Runnymede Road",
                        "Redland Bay Rd near Number 273",
                        "Redland Bay Rd at Windemere Rd",
                        "Redland Bay Rd at Ney Road",
                        "Redland Bay Rd at Andrew Street",
                        "Redland Bay Rd at Merritt Street",
                        "Redland Bay Rd at Smith Street",
                        "Capalaba bus station, stop E",
                        "Old Cleveland Rd near Tinchborne St",
                        "Old Cleveland Rd near Swinton St",
                        "Old Cleveland Rd near Bacton Rd",
                        "The Sleeman Centre, stop C",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "The Sleeman Centre, stop D",
                        "Old Cleveland Rd near Archer St",
                        "Old Cleveland Rd near New Cleveland Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station, stop D",
                        "Redland Bay Rd at Coolnwynpin Creek",
                        "Redland Bay Rd at Greater Glider C.A",
                        "Redland Bay Rd",
                        "Redland Bay Rd at Vienna Road",
                        "Panorama Drive near Boundary Rd",
                        "Moselle Dr near Hermitage Cr",
                        "Panorama Dr near Manhattan Ave",
                        "Bloomfield St at South Street",
                        "Smith St near Long St"
                    ],
                    "274: Victoria Pt Jetty - Cleveland via Thornlands": [
                        "Victoria Point Jetty",
                        "Colburn Av at White Street",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at Thompson Street",
                        "Colburn Ave near Daysland St",
                        "Colburn Ave at Point O'Halloran Road",
                        "Colburn Ave near Link Rd",
                        "Town Centre at Victoria Point",
                        "Victoria Point Central, platform 1",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Panorama Drive near Boundary Rd",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Moselle Dr near Hermitage Cr",
                        "Moselle Dr near Chateau St",
                        "Moselle Dr near Cabernet Cr",
                        "Panorama Dr near Manhattan Ave",
                        "Panorama Dr at Robert Mackie Park",
                        "Panorama Dr near Laurette Ave",
                        "South St near Fitzroy St",
                        "South St near Langdon St",
                        "McLeod St near Beach St",
                        "Beach St at Goleby Esp",
                        "Beach St near Cleary St",
                        "Fitzroy St near Tarcutta St",
                        "Fitzroy St near Baypark Ct",
                        "Fitzroy St near Sturt St",
                        "Fitzroy St near Princess St",
                        "Princess St near Blake St",
                        "Passage St near Jacaranda Ct",
                        "Passage St near Russell St",
                        "Passage St near Queen St",
                        "Middle St at Redlands RSL Services",
                        "Middle St at Island Street",
                        "Middle Street, stop A",
                        "Cleveland station",
                        "Middle Street, stop B",
                        "McLeod St near Goleby Esp",
                        "South St near Manning Esp",
                        "South St near Clifford Perske Dr",
                        "Panorama Dr at Abbotsleigh Street",
                        "Panorama Dr at Manhattan Avenue",
                        "Moselle Dr near Ziegenfusz Rd",
                        "Panorama Dr near Milner Pl",
                        "Panorama Dr near Boundary Road",
                        "Boundary Rd at Panorama Drive",
                        "Boundary Rd at Springacre Road",
                        "Victoria Point Central, platform 2",
                        "Colburn Ave near School Rd",
                        "Colburn Ave near Point O'Halloran Rd",
                        "Colburn Ave at Thompson Street"
                    ],
                    "275: Thornlands - Brisbane City via Finucane Rd": [
                        "Thornlands Rd near Ribbonwood St",
                        "Clifford Perske Dr near Thornlands Rd",
                        "Clifford Perske Dr near Kriskyle Pl",
                        "South St near Langdon St",
                        "McLeod St near Beach St",
                        "Beach St at Goleby Esp",
                        "Beach St near Cleary St",
                        "Fitzroy St near Tarcutta St",
                        "Fitzroy St near Baypark Ct",
                        "Fitzroy St near Sturt St",
                        "Fitzroy St near Princess St",
                        "Princess St near Blake St",
                        "Passage St near Jacaranda Ct",
                        "Passage St near Russell St",
                        "Passage St near Queen St",
                        "Shore St at Passage Street",
                        "Shore St at Fitzroy Street",
                        "Cleveland station",
                        "Shore St at Black Swamp Wetlands",
                        "Shore St at RACQ",
                        "Shore St at Grant Street",
                        "Finucane Rd at Redland Research Station",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Vienna Road",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Finucane Rd at Alexandra Hills High School",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Finucane Rd at Willard Road",
                        "Moreton Bay Rd at Dan St",
                        "Capalaba park 'n' ride, platform 1",
                        "Old Cleveland Rd near Bacton Rd",
                        "The Sleeman Centre, stop C",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "The Sleeman Centre, stop D",
                        "Old Cleveland Rd near Archer St",
                        "Capalaba park 'n' ride, platform 2",
                        "Finucane Rd at Old Cleveland Rd",
                        "Finucane Rd at Keith Surridge Park",
                        "Finucane Rd at Dawson Road",
                        "Shore St West at Fitzroy Street",
                        "McLeod St near Goleby Esp",
                        "South St near Manning Esp"
                    ],
                    "276: Victoria Point - Brisbane City": [
                        "Point O'Halloran Rd near Orana St",
                        "Orana Esp near Kianga Ct",
                        "Orana Esp near Kianca Ct",
                        "Orana Esp near Bayswater Dr",
                        "Point O'Halloran Rd near Cooba St",
                        "Nottingham Dr near Regency St",
                        "School Rd near Parklane Rd",
                        "School Rd near Aspect Dr",
                        "Colburn Ave near Link Rd",
                        "Link Rd near Jeanne Dr",
                        "Sycamore Pde near Wisteria Ct",
                        "Sycamore Pde near Peppermint Dr",
                        "Poinciana Ave at Peppercorn Crescent",
                        "Poinciana Ave at Pin Oak Crescent",
                        "Magnolia Pde at Willow Street",
                        "Victoria Point Central, platform 1",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Boundary Rd at Kinross Road",
                        "Boundary Rd at Taylor Rd",
                        "Duncan Road Sports Fields",
                        "Mount Cotton Rd at Henderson Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Road near Broadwater Rd",
                        "Mount Cotton Rd at Alperton Rd",
                        "Mount Cotton Rd near Moxon Rd",
                        "Mount Cotton Rd at Daymar Street",
                        "Mt Gravatt Capalaba Rd at Gateway Baptist",
                        "Mackenzie State Primary School",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Gardner Rd at Arise Boulevard",
                        "Miles Platting Rd at Gardner Rd",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Gardner Road at Prebble Street",
                        "Mount Cotton Rd at Ney Road",
                        "Duncan Rd at Duncan Road Sports Fields",
                        "Boundary Rd at Panorama Drive",
                        "Boundary Rd at Springacre Road",
                        "Victoria Point Central, platform 2",
                        "Peppermint Dr near Mulberry Ct",
                        "Colburn Ave near School Rd",
                        "Nottingham Dr at Regency Street"
                    ],
                    "277: Victoria Point - Point Halloran (Loop)": [
                        "Bunker Rd at High St, stop B",
                        "Bunker Rd near Sandy Dr",
                        "Bunker Rd at Brendan Way",
                        "Bunker Rd at Brookvale Drive",
                        "Intrepid Dr near Kurrewa Ct",
                        "Intrepid Dr near Ondine Ct",
                        "Bunker Rd at High St, stop D",
                        "Victoria Point Central, platform 2",
                        "Magnolia Pde at Willow Street",
                        "Poinciana Ave at Pin Oak Crescent",
                        "Poinciana Ave at Peppercorn Crescent",
                        "Peppermint Dr near Mulberry Ct",
                        "Sycamore Pde near Wisteria Ct",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near School Rd",
                        "School Rd near Aspect Dr",
                        "School Rd near Parklane Rd",
                        "Nottingham Dr at Regency Street",
                        "Point O'Halloran Rd near Cooba St",
                        "Point O'Halloran Rd near Orana St",
                        "Orana Esp near Kianga Ct",
                        "Orana Esp near Kianca Ct",
                        "Orana Esp near Bayswater Dr",
                        "Nottingham Dr near Regency St",
                        "Colburn Ave near Link Rd",
                        "Sycamore Pde near Peppermint Dr",
                        "Victoria Point Central, platform 1"
                    ],
                    "279: Victoria Point Jetty - Brisbane City": [
                        "Victoria Point Jetty",
                        "Colburn Av at White Street",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at Thompson Street",
                        "Link Rd at Fryar Street",
                        "Link Rd at Salford Waters Retirement Estate",
                        "Benfer Rd at Bangalow Street",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Poinciana Avenue",
                        "Benfer Rd near Prescoter Dr",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Boundary Rd at Kinross Road",
                        "Boundary Rd at Taylor Rd",
                        "Duncan Road Sports Fields",
                        "Mount Cotton Rd at Henderson Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Road near Broadwater Rd",
                        "Mount Cotton Rd at Alperton Rd",
                        "Mount Cotton Rd near Moxon Rd",
                        "Mount Cotton Rd at Daymar Street",
                        "Mt Gravatt Capalaba Rd at Gateway Baptist",
                        "Mackenzie State Primary School",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Gardner Rd at Arise Boulevard",
                        "Miles Platting Rd at Gardner Rd",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Gardner Road at Prebble Street",
                        "Mount Cotton Rd at Ney Road",
                        "Duncan Rd at Duncan Road Sports Fields",
                        "Boundary Rd at Panorama Drive",
                        "Boundary Rd at Springacre Road",
                        "Victoria Point Central, platform 2",
                        "Colburn Ave at Thompson Street"
                    ],
                    "280: Shoreline Ave Redland Bay - Griffith Uni": [
                        "Shoreline Ave at Hydrangea Ave",
                        "Serpentine Creek Rd near Christopher St",
                        "Phillip St near Wilkie St",
                        "McWilliam St at Phillip St",
                        "Torquay Rd East near Jania St",
                        "Collins St at Donald Road",
                        "School of Arts Rd near Fielding Rd",
                        "Queen St near School of Arts Rd",
                        "Queen St at Keirnan Street",
                        "Government Rd at Queen St",
                        "Redlands Satellite Health Centre",
                        "Redland Bay Marina, platform 1",
                        "Hamilton St at Pitt Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Boundary Rd at Kinross Road",
                        "Boundary Rd at Taylor Rd",
                        "Duncan Road Sports Fields",
                        "Mount Cotton Rd at Henderson Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Road near Broadwater Rd",
                        "Mount Cotton Rd at Alperton Rd",
                        "Mount Cotton Rd near Moxon Rd",
                        "Mount Cotton Rd at Daymar Street",
                        "Mt Gravatt Capalaba Rd at Gateway Baptist",
                        "Mackenzie State Primary School",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Gardner Rd at Arise Boulevard",
                        "Miles Platting Rd at Gardner Rd",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Gardner Road at Prebble Street",
                        "Mount Cotton Rd at Ney Road",
                        "Duncan Rd at Duncan Road Sports Fields",
                        "Boundary Rd at Panorama Drive",
                        "Boundary Rd at Springacre Road",
                        "Victoria Point Central, platform 2",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Queen St at School of Arts Road",
                        "Collins St at Torquay Road",
                        "McWilliam St at Phillip Street",
                        "Serpentine Creek Rd at Christopher St",
                        "Shoreline Ave at Jingeri St"
                    ],
                    "281: Shoreline Ave Redland Bay - Brisbane City": [
                        "Shoreline Ave at Hydrangea Ave",
                        "Serpentine Creek Rd near Christopher St",
                        "Phillip St near Wilkie St",
                        "McWilliam St at Phillip St",
                        "Torquay Rd East near Jania St",
                        "Collins St at Donald Road",
                        "School of Arts Rd near Fielding Rd",
                        "Queen St near School of Arts Rd",
                        "Queen St at Keirnan Street",
                        "Government Rd at Queen St",
                        "Redlands Satellite Health Centre",
                        "Redland Bay Marina, platform 1",
                        "Hamilton St at Pitt Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Boundary Rd at Kinross Road",
                        "Boundary Rd at Taylor Rd",
                        "Duncan Road Sports Fields",
                        "Mount Cotton Rd at Henderson Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Road near Broadwater Rd",
                        "Mount Cotton Rd at Alperton Rd",
                        "Mount Cotton Rd near Moxon Rd",
                        "Mount Cotton Rd at Daymar Street",
                        "Mt Gravatt Capalaba Rd at Gateway Baptist",
                        "Mackenzie State Primary School",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Gardner Rd at Arise Boulevard",
                        "Miles Platting Rd at Gardner Rd",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Gardner Road at Prebble Street",
                        "Mount Cotton Rd at Ney Road",
                        "Duncan Rd at Duncan Road Sports Fields",
                        "Boundary Rd at Panorama Drive",
                        "Boundary Rd at Springacre Road",
                        "Victoria Point Central, platform 2",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Queen St at School of Arts Road",
                        "Collins St at Torquay Road",
                        "McWilliam St at Phillip Street",
                        "Serpentine Creek Rd at Christopher St",
                        "Shoreline Ave at Jingeri St"
                    ],
                    "282: Victoria Pt - Logan Hyperdome": [
                        "Bunker Rd at High St, stop A",
                        "Victoria Point Central, platform 2",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Redland Bay Primary School",
                        "Main St at Gordon Road",
                        "Peel St near Mill St",
                        "Peel St near James St",
                        "Hamilton St at Pitt Street",
                        "Redland Bay Marina, platform 1",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Watsonia St",
                        "German Church Rd near Days Rd",
                        "Valley Way at Village Drive",
                        "Valley Way near Hardwood Dr",
                        "Carissa St near Begonia Cr",
                        "Orchid Dr near Flindersia Dr",
                        "Orchid Dr at Durian Street",
                        "Papaya St near Valley Way",
                        "Valley Way near Mount Cotton Rd",
                        "Mount Cotton Rd near Gramzow Rd",
                        "Wuduru Rd near Woodhaven Pl",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd near Plantain Rd",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Belbora Rd",
                        "Loganholme station arrival stop 1",
                        "Loganholme, stop E",
                        "Orchid Dr near Durian Cr",
                        "Papaya St near Carissa St",
                        "Valley Way at Seeana Dr",
                        "Bryants Rd at Torres Street",
                        "Valley Way near Taffeta Dr",
                        "Queen St near School of Arts Rd",
                        "Gordon Rd at Redland Bay Primary School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Victoria Point Central, platform 1",
                        "Bunker Rd at High St Arrival Stop hail 'n' ride"
                    ],
                    "299: Rochedale - Brisbane City": [
                        "Priestdale Rd opp Rochedale High School",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Miles Platting Rd near Rochedale Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at McKechnie Dr",
                        "Logan Rd at Miles Platting Road, stop 82",
                        "Logan Rd at Brandl Street, stop 83",
                        "Brandl St near Logan Rd",
                        "McKechnie Dr near Electronics St",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 83 near Albert St",
                        "Elizabeth Street Stop 85",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 10 at King George Square",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "School Rd near Priestdale Rd"
                    ],
                    "29: Woolloongabba - UQ Lakes Shuttle": [
                        "Woolloongabba station, platform 1",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "Dutton Park Place",
                        "UQ Lakes stop C",
                        "Boggo Road station, platform 5",
                        "PA Hospital station, platform 1",
                        "Woolloongabba station, platform 2"
                    ],
                    "300: Toombul - City via Hamilton": [
                        "Toombul Shopping Centre station, platform C",
                        "Lancaster Rd at Ascot Rail, stop 24/12",
                        "Sandgate Rd at Noble Street, stop 31",
                        "Racecourse Rd at Beatrice Street, stop 22",
                        "Noble St at Noble - Sandgate, stop 39/45",
                        "Racecourse Rd at Kent Street, stop 21",
                        "Noble St near Widdop St, stop 38/44",
                        "Racecourse Rd at Hamilton Central, stop 20",
                        "Widdop St at Eliza Street, stop 37/43",
                        "Kingsford Smith Dr at Bretts Wharf, stop 19",
                        "Gellibrand St near Zillman Rd, stop 36/4",
                        "Kingsford Smith Dr at Crescent Road, stop 16",
                        "Zillman Rd at Junction Road, stop 35a/42",
                        "Kingsford Smith Dr at Cooksley Street, stop 14",
                        "Breakfast Creek Rd at Newstead House, stop 12",
                        "Zillman Rd at Union Street, stop 35/6",
                        "Breakfast Creek Rd at Evelyn Street, stop 10",
                        "Zillman Rd at Bowley Street, stop 34/33",
                        "Breakfast Creek Rd at Riverpark Stop 9",
                        "Zillman Rd at Hendra Rail, stop 32/8",
                        "Sefton Rd at Marie Street, stop 31",
                        "Ann St at Chester Street, stop 7",
                        "Sefton Rd near Alexandra Rd, stop 30",
                        "Ann St at James Street, stop 6",
                        "Alexandra Rd at Florence Street Stop 29",
                        "Ann St at Bridge Street, stop 5",
                        "Ann Street Stop 216 at Valley Island",
                        "Alexandra Rd at Oriel Road Stop 28",
                        "Adelaide St app Wharf St Stop 32",
                        "Alexandra Rd at Reeve Street Stop 27",
                        "Adelaide Street Stop 35 near Creek St",
                        "Lancaster Rd at Ormond Street, stop 26",
                        "Lancaster Rd at Kitchener Road, stop 25",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 46 near George St",
                        "Cultural Centre station, platform 3",
                        "Merivale St at Queensland Theatre",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 226 near Gotha St",
                        "Wickham Street Stop 229 near Warner St",
                        "Wickham St at Bridge Street, stop 5",
                        "Wickham St at East Street Stop 6",
                        "Wickham St at Light Street, stop 7",
                        "Wickham St at Knapp Street Stop 8",
                        "Breakfast Creek Rd at Evelyn Street Stop 10",
                        "Kingsford Smith Dr at Cooksley Street, stop 13/14",
                        "Racecourse Rd at Beatrice Terrace, stop 22",
                        "Lancaster Rd at Ascot Rail, stop 24/13",
                        "Alexandra Rd at Palm Avenue Stop 29",
                        "Alexandra Rd at Sefton Road Stop 30",
                        "Zillman Rd at Bowley Street, stop 33/34",
                        "Widdop St at Noble Street, stop 38/44",
                        "Widdop St at Walkers Way, stop 39/45",
                        "Kreutzer St near Grace St, stop 40/46",
                        "Toombul Interchange"
                    ],
                    "301: Toombul - City via Hendra": [
                        "Toombul Shopping Centre station, platform C",
                        "Sandgate Rd at Noble Street, stop 31",
                        "Noble St at Noble - Sandgate, stop 39/45",
                        "Noble St near Widdop St, stop 38/44",
                        "Widdop St at Eliza Street, stop 37/43",
                        "Gellibrand St near Zillman Rd, stop 36/4",
                        "Zillman Rd at Junction Road, stop 35a/42",
                        "Gerler Rd at Zillman Road, stop 36/38",
                        "Gerler Rd at Doncaster Street, stop 39/40",
                        "Burilda St at Derby Street, stop 45",
                        "Gerler Rd at TC Beirne Park, stop 40/39",
                        "Manson St at Goodwood Street, stop 44",
                        "Gerler Rd at Dorames Street, stop 37/36",
                        "Golden Sq at Bulli Street, stop 47",
                        "Newmarket St at Manson Road, stop 43",
                        "Bulli St at Webster Avenue, stop 46a",
                        "Newmarket St at Flemington Street, stop 42",
                        "Pleystowe Cr near Nudgee Rd, stop 46",
                        "Newmarket St near Gerler Rd, stop 41",
                        "Nudgee Rd at Long Street, stop 35a/42",
                        "Nudgee Rd near Lilley St, stop 34",
                        "Nudgee Rd at Hampden Street, stop 33",
                        "Hampden St at St Ledger, stop 29",
                        "Silva St near Lamington Ave, stop 28",
                        "Lamington Ave at Doomben Rail, stop 27",
                        "Lamington Ave at Brassey Street, stop 26/31",
                        "Lancaster Rd at Norman Street, stop 25/15",
                        "Lancaster Rd at Napier Street, stop 24/14",
                        "Lancaster Rd at Ascot Rail, stop 24/13",
                        "Lancaster Rd at Kitchener Road, stop 25",
                        "Lancaster Rd at Ormond Street, stop 26",
                        "Upper Lancaster Rd near Wren Street, stop 25",
                        "Anthony St at Tower Street, stop 24",
                        "Anthony St at Ascot School, stop 23",
                        "Crosby Rd at Hipwood Street, stop 22",
                        "Crosby Rd at Bushview, stop 21",
                        "Crosby Rd at Comus Avenue, stop 20",
                        "Crosby Rd at Brothers, stop 19",
                        "Crosby Rd at Albion Road, stop 18",
                        "Abbotsford Rd at Bus Depot, stop 17",
                        "Abbotsford Rd at Allison Street Stop 16",
                        "Abbotsford Rd at Bowen Hills near Folkestone St",
                        "Abbotsford Rd at Montpelier Road Stop 12/13",
                        "Saint Pauls Tce at Alexandria Street Stop 11",
                        "St Pauls Terrace at Fortitude Valley Stop 240",
                        "St Pauls Terrace Stop 238 near Quarry St",
                        "St Pauls Terrace Stop 235 near Union St",
                        "Wharf Street Stop 166 near Turbot St",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 47 near North Quay",
                        "William St near Elizabeth St stop 103",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 162 near Ann St",
                        "Wharf Street Stop 163 near Leichhardt St",
                        "St Pauls Terrace Stop 237 near Union St",
                        "St Pauls Terrace Stop 239 near Quarry St",
                        "St Pauls Terrace at Fortitude Valley Stop 232",
                        "Saint Pauls Tce at Constance Street Stop 6/10",
                        "Abbotsford Rd at Bowen Hills",
                        "Abbotsford Rd at Bus Depot, stop 17/18",
                        "Crosby Rd near Dover St, stop 18",
                        "Lancaster Rd at Ascot Rail, stop 24/12",
                        "Lamington Ave at Brassey Street, stop 26",
                        "Hampden St at Hopetoun Street, stop 30",
                        "Nudgee Rd at Lilley Street, stop 34",
                        "Nudgee Rd at Long Street, stop 35/45",
                        "Nudgee Rd at Flemington Street, stop 36/46",
                        "Gerler Rd at Newmarket Street, stop 41/38",
                        "Gerler Rd at TC Beirne Park, stop 39/40",
                        "Gerler Rd at Doncaster Street, stop 40/39",
                        "Burilda St at St Johns, stop 44",
                        "Gerler Rd at Zillman Road, stop 38/36",
                        "Burilda St near Derby St, stop 45",
                        "Widdop St at Noble Street, stop 38/44",
                        "Widdop St at Walkers Way, stop 39/45",
                        "Kreutzer St near Grace St, stop 40/46",
                        "Toombul Interchange"
                    ],
                    "302: Pinkenba - City": [
                        "Fison Ave at Fison Community Stop 43C",
                        "Fison Ave at Fison Avenue East, stop 43D",
                        "Holt St at Lavarack Ave",
                        "Holt St at Kingsford Smith Drive",
                        "Kingsford Smith Dr at Holt St, stop 43",
                        "Kingsford Smith Dr at Bunour, stop 42",
                        "Kingsford Smith Dr at French St, stop 40",
                        "Kingsford Smith Dr at Bridgeway, stop 38",
                        "Schneider Rd at Tradecoast Dr",
                        "Schneider Rd at Amy Johnson Pl",
                        "Kingsford Smith Dr at Violet St, stop 35",
                        "Kingsford Smith Dr at Theodore St, stop 33",
                        "Theodore St at MacArthur Av",
                        "Remora Rd at Portside",
                        "Kingsford Smith Dr at Remora Road, stop 29",
                        "Kingsford Smith Dr at Bretts Wharf, stop 19",
                        "Kingsford Smith Dr at Crescent Road, stop 16",
                        "Kingsford Smith Dr at Cooksley Street, stop 14",
                        "Breakfast Creek Rd at Newstead House, stop 12",
                        "Breakfast Creek Rd at Evelyn Street, stop 10",
                        "Breakfast Creek Rd at Riverpark Stop 9",
                        "Ann St at Chester Street, stop 7",
                        "Ann St at James Street, stop 6",
                        "Ann St at Bridge Street, stop 5",
                        "Ann Street Stop 216 at Valley Island",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 47 near North Quay",
                        "William St near Elizabeth St stop 103",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 226 near Gotha St",
                        "Wickham Street Stop 229 near Warner St",
                        "Wickham St at Bridge Street, stop 5",
                        "Wickham St at East Street Stop 6",
                        "Wickham St at Light Street, stop 7",
                        "Wickham St at Knapp Street Stop 8",
                        "Breakfast Creek Rd at Evelyn Street Stop 10",
                        "Kingsford Smith Dr at Cooksley Street, stop 13/14",
                        "Macarthur Ave at Portside",
                        "Kingsford Smith Dr at Violet Street, stop 35",
                        "Kingsford Smith Dr at Schneider Rd, stop 37",
                        "Holt St at Lavarack Ave, stop 43A",
                        "Fison Ave at Fison Avenue East, stop 43B"
                    ],
                    "303: Pinkenba - Doomben via Myrtletown": [
                        "Lamington Ave at Doomben Rail, stop 27",
                        "Lamington Ave at Brassey Street, stop 26/31",
                        "Nudgee Rd near Hants St, stop 31/16",
                        "Nudgee Rd near Stevenson St, stop 30",
                        "Kingsford Smith Dr at Remora Road, stop 29",
                        "Remora Rd at Portside",
                        "Kingsford Smith Dr at Remora Rd, stop 29",
                        "Kingsford Smith Dr at College Street, stop 31",
                        "Kingsford Smith Dr at Theodore St, stop 33",
                        "Kingsford Smith Dr at Violet Street, stop 35",
                        "Kingsford Smith Dr at Schneider Rd, stop 37",
                        "Kingsford Smith Dr at Bridgeway, stop 38",
                        "Kingsford Smith Dr at French St, stop 40",
                        "Kingsford Smith Dr at Bunour, stop 42",
                        "Kingsford Smith Dr at Holt St, stop 43",
                        "Kingsford Smith Dr at Meeandah, stop 45",
                        "Kingsford Smith Dr at Southern Cross, stop 46",
                        "Eagle Farm Rd at Orient Ave, stop 49",
                        "Eagle Farm Rd at Pinkenba, stop 50",
                        "Mcbride Rd at Neill St, stop 51",
                        "McBride Rd at Hopper Street, stop 52",
                        "McBride Rd at Esker Street, stop 53",
                        "Pinkenba School Serpintine Rd",
                        "Serpentine Rd at Pinkenba Primary, stop 55",
                        "QANTAS Hangar",
                        "Pandanus Ave at Pandanus South",
                        "Pandanus North",
                        "Marine Rd at Main Beach Rd",
                        "Pinkenba at Bancroft Road",
                        "McBride Rd at Hopper St, stop 52",
                        "McBride Rd at Neill St, stop 51",
                        "Kingsford Smith Dr at Violet St, stop 35",
                        "Kingsford Smith Dr at Oxford St, stop 30",
                        "Nudgee Rd near Allen St, stop 29",
                        "Nudgee Rd near Dobson St, stop 30",
                        "Lamington Ave at Brassey Street, stop 26",
                        "Hampden St at St Ledger, stop 29"
                    ],
                    "304: Northshore Hamilton Loop via Racecourse Rd": [
                        "Macarthur Ave at Northshore Ferry",
                        "Macarthur Ave at Old Shoreline",
                        "Theodore St at MacArthur Av",
                        "Remora Rd at Portside",
                        "Nudgee Rd near Allen St, stop 29",
                        "Racecourse Rd at Kent Street, stop 21",
                        "Racecourse Rd at Hamilton Central, stop 20",
                        "Macarthur Ave at Portside"
                    ],
                    "305: Hamilton - City": [
                        "Macarthur Ave at Northshore Ferry",
                        "Macarthur Ave at Old Shoreline",
                        "Theodore St at MacArthur Av",
                        "Remora Rd at Portside",
                        "Nudgee Rd near Allen St, stop 29",
                        "Nudgee Rd near Dobson St, stop 30",
                        "Nudgee Rd near Hants St, stop 31/16",
                        "Lancaster Rd at Norman Street, stop 25/15",
                        "Lancaster Rd at Napier Street, stop 24/14",
                        "Racecourse Rd at Beatrice Street, stop 22",
                        "Racecourse Rd at Kent Street, stop 21",
                        "Racecourse Rd at Hamilton Central, stop 20",
                        "Kingsford Smith Dr at Bretts Wharf, stop 19",
                        "Kingsford Smith Dr at Crescent Road, stop 16",
                        "Kingsford Smith Dr at Cooksley Street, stop 14",
                        "Breakfast Creek Rd at Newstead House, stop 12",
                        "Breakfast Creek Rd at Evelyn Street, stop 10",
                        "Breakfast Creek Rd at Riverpark Stop 9",
                        "Ann St at Chester Street, stop 7",
                        "Ann St at James Street, stop 6",
                        "Ann St at Bridge Street, stop 5",
                        "Ann Street Stop 216 at Valley Island",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 46 near George St",
                        "William Street Stop 105 near Margaret St",
                        "George Street Stop 114 near Alice St",
                        "George Street Stop 115 near Charlotte St",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 226 near Gotha St",
                        "Wickham Street Stop 229 near Warner St",
                        "Wickham St at Bridge Street, stop 5",
                        "Wickham St at East Street Stop 6",
                        "Wickham St at Light Street, stop 7",
                        "Wickham St at Knapp Street Stop 8",
                        "Breakfast Creek Rd at Evelyn Street Stop 10",
                        "Kingsford Smith Dr at Cooksley Street, stop 13/14",
                        "Racecourse Rd at Beatrice Terrace, stop 22",
                        "Nudgee Rd near Stevenson St, stop 30",
                        "Macarthur Ave at Portside"
                    ],
                    "306: Nudgee/Toombul - City": [
                        "Toombul Shopping Centre station, platform A",
                        "OQuinn St at Nudgee Beach, stop 39",
                        "Saint Vincents Rd near Queens Rd, stop 39a",
                        "Sandgate Rd at Virginia School, stop 21/20",
                        "Sandgate Rd at Noble Street, stop 31",
                        "OQuinn St at Chaseley Street, stop 38",
                        "Saint Vincents Rd at Childs Road, stop 38",
                        "Sandgate Rd at Royal Street, stop 19a",
                        "Saint Vincents Rd near Ridge St, stop 19",
                        "Sandgate Rd at Eliza Street, stop 30",
                        "OQuinn St near Nudgee Rd, stop 37",
                        "Saint Vincents Rd at Hayden Street, stop 37",
                        "Nudgee Rd at Golf Course, stop 32/35",
                        "Ridge St at Scott Street, stop 18",
                        "Sandgate Rd at Collins Street, stop 28",
                        "Saint Vincents Rd at Oakmere Street, stop 36",
                        "Sandgate Rd at Clayfield",
                        "Childs Rd at Parkland, stop 32/38",
                        "Saint Vincents Rd at Petunia Street, stop 35",
                        "Ridge St near Northgate Rd, stop 17/16",
                        "Sandgate Rd at London Road",
                        "Saint Vincents Rd at Hilltop, stop 34",
                        "Northgate Rd at Flower St, stop 14",
                        "Red Hill Rd at Overlea Street, stop 33b",
                        "Sandgate Rd at Adelaide Street, stop 25",
                        "Flower St at Surrey Street, stop 13",
                        "Red Hill Rd near Earnshaw Rd, stop 33a",
                        "Sandgate Rd at Botany Street, stop 24",
                        "Flower St at Hall Street, stop 12",
                        "Approach Rd at ACU, stop 34",
                        "Sandgate Rd at Clayfield South, stop 23",
                        "Ryans Rd near Cavendish St, stop 11",
                        "Sandgate Rd at Hutton Street, stop 21",
                        "Approach Rd near Kilcooly St, stop 30",
                        "Cavendish St near Cameron St, stop 10",
                        "Sandgate Rd at Camden Street, stop 20",
                        "Cameron St near London St, stop 4",
                        "Approach Rd near Mellifont St, stop 31",
                        "Sandgate Rd at Albion Central, stop 19",
                        "Nudgee Rd at Armada Pl",
                        "Sandgate Rd at Nundah - Rode Road, stop 4",
                        "Sandgate Rd at Nundah, stop 3",
                        "Sandgate Rd at Albion Road, stop 18",
                        "Tufnell Rd at Rossa Street, stop 23",
                        "Sandgate Rd at Collingwood Street, stop 17",
                        "Tufnell Rd at Bilambil Street, stop 24",
                        "Sandgate Rd at Nundah, stop 2",
                        "Sandgate Rd at Greg Chappell Street, stop 16",
                        "Tufnell Rd at Kelyndar Street, stop 25",
                        "Sandgate Rd near Buckland Rd, stop 1",
                        "Tufnell Rd at Earnshaw Road, stop 27",
                        "Sandgate Rd at Yowoggera Park, stop 15",
                        "Edmondstone Rd at Parkview, stop 14",
                        "Tufnell Rd at Langton Street, stop 31",
                        "Breakfast Creek Rd at Evelyn Street, stop 10",
                        "Tufnell Rd near St Vincents Rd, stop 31a",
                        "Breakfast Creek Rd at Riverpark Stop 9",
                        "Royal Pde at Banyo, stop 30",
                        "Saint Vincents Rd at Chapel Street, stop 28",
                        "Ann St at Chester Street, stop 7",
                        "Saint Vincents Rd at Blinzinger Road, stop 27",
                        "Ann St at James Street, stop 6",
                        "Saint Vincents Rd at George Street, stop 26",
                        "Ann St at Bridge Street, stop 5",
                        "Ann Street Stop 216 at Valley Island",
                        "Saint Vincents Rd at First Street, stop 25",
                        "Adelaide St app Wharf St Stop 32",
                        "Saint Vincents Rd at Meadfoot Road, stop 24",
                        "Adelaide Street Stop 35 near Creek St",
                        "Toombul Rd near Wellington St, stop 23/22",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 47 near North Quay",
                        "William St near Elizabeth St stop 103",
                        "Toombul Rd at Nixon Lane, stop 22",
                        "Adelaide Street Stop 24 near Edward St",
                        "Saint Vincents Rd at Toombul Road, stop 23",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 226 near Gotha St",
                        "Wickham Street Stop 229 near Warner St",
                        "Wickham St at Bridge Street, stop 5",
                        "Saint Vincents Rd at Banyo, stop 30",
                        "Wickham St at East Street Stop 6",
                        "Wickham St at Light Street, stop 7",
                        "Wickham St at Knapp Street Stop 8",
                        "Breakfast Creek Rd at Evelyn Street Stop 10",
                        "Abbotsford Rd at Albion Road Stop 18",
                        "Approach Rd at Kilcooly Street, stop 30",
                        "Abbotsford Rd at Albion Central Stop 19",
                        "Approach Rd at Mellifont Street, stop 29",
                        "Red Hill Rd near Langton St, stop 33a",
                        "Sandgate Rd at Clayfield, stop 27",
                        "Childs Rd at Parkland",
                        "Nudgee Rd at Golf Course, stop 35/32",
                        "Toombul Shopping Centre station, platform D",
                        "Cameron St near Sandgate Rd, stop 4",
                        "Cavendish St at Ryans Road, stop 11",
                        "Northgate Rd at Cook St, stop 15",
                        "Ridge St near Northgate Rd, stop 16/17",
                        "Ridge St at St Vincents, stop 19",
                        "Gympie St near Sandgate Rd, stop 20",
                        "Sandgate Rd at Virginia School, stop 21"
                    ],
                    "307: Northgate East - Toombul Loop": [
                        "Toombul Shopping Centre station, platform D",
                        "Day Rd near Oates Rd",
                        "Buckland Rd near Danby Lane, stop 1",
                        "Day Rd near Lang Tce, stop 17",
                        "Buckland Rd at Union Street, stop 2",
                        "Nudgee Rd at Cooper Road, stop 18",
                        "Buckland Rd at Melton Road, stop 3",
                        "Nudgee Rd at Oates Parade, stop 19",
                        "Buckland Rd at Hedley Avenue, stop 4",
                        "Oates Pde near Stark Rd, stop 18",
                        "Hedley Ave near York St, stop 5",
                        "Oates Pde near Day Rd, stop 17",
                        "York St near Killeen St, stop 7",
                        "Melton Rd near Allworth St, stop 15",
                        "Amelia St near York St, stop 8",
                        "Melton Rd at Elwyn Street, stop 14",
                        "Amelia St near Little Jenner St, stop 9",
                        "Melton Rd near New Ivo St, stop 12",
                        "Nellie St near Bligh St, stop 10",
                        "Nellie St near Melton Rd, stop 11",
                        "Nellie St near Wally St, stop 10",
                        "York St near Hedley Ave, stop 6",
                        "Hedley Ave near Buckland Rd, stop 5",
                        "Buckland Rd at Melton Road, stop 4/3",
                        "Tufnell Rd at Rossa Street, stop 23",
                        "Park Rd near Buckland Rd, stop 38",
                        "Tufnell Rd at Bilambil Street, stop 24",
                        "Buckland Rd at Nundah State School, stop 38A",
                        "Tufnell Rd at Kelyndar Street, stop 25",
                        "Sandgate Rd near Buckland Rd, stop 1",
                        "Toombul Interchange",
                        "Approach Rd at ACU, stop 34",
                        "Approach Rd near Kilcooly St, stop 30",
                        "Approach Rd near Mellifont St, stop 31",
                        "Nudgee Rd at Armada Pl"
                    ],
                    "308: Toombul - Chermside Loop": [
                        "Toombul Shopping Centre station, platform D",
                        "Sandgate Rd at Nundah, stop 3",
                        "Hamilton Rd at Nundah North near Bayview Tce",
                        "Hamilton Rd at Wavell Heights North near Bilsen Rd",
                        "Hamilton Rd at Albar Street, stop 49",
                        "Hamilton Rd at Chermside East near Pfingst Rd",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Chermside Shopping Centre interchange H",
                        "Gympie Rd near Wallace Street",
                        "Rode Rd near Gympie Rd",
                        "Rode Rd at Telopia Street, stop 46",
                        "Rode Rd at Pfingst - Warraba, stop 45",
                        "Rode Rd near Deloraine St, stop 37A",
                        "Rode Rd near Bayview Tce, stop 42/43",
                        "Toombul Interchange"
                    ],
                    "309: RBWH - City via Teneriffe": [
                        "RBWH station, platform 1",
                        "Sneyd St near Oconnell Tce",
                        "Hamilton Pl near Jeays St",
                        "Abbotsford Rd at Bowen Hills",
                        "Edmondstone Rd at Parkview, stop 14",
                        "Breakfast Creek Rd at Evelyn Street, stop 10",
                        "Breakfast Creek Rd at Riverpark Stop 9",
                        "Commercial Rd near Stratton St, stop 12",
                        "Teneriffe Ferry Skyring Tce",
                        "Harcourt St at Hough Lane",
                        "Harcourt St at Chester Street, stop 111",
                        "Chester St at Teneriffe Hill, stop 12",
                        "Gibbon St near Dawson Lane, stop 10",
                        "James St near Harcourt St, stop 9",
                        "Ann St at Bridge Street, stop 5",
                        "Ann Street Stop 216 at Valley Island",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 47 near North Quay",
                        "William St near Elizabeth St stop 103",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 226 near Gotha St",
                        "Wickham Street Stop 229 near Warner St",
                        "Wickham St at Bridge Street, stop 5",
                        "Brookes St near Ann Street Stop 10",
                        "James St near Arthur St, stop 9",
                        "James St near Gibbon St, stop 10",
                        "Gibbon St at Teneriffe Hill, stop 12",
                        "Chester St near Harcourt St, stop 11",
                        "Commercial Rd near Skyring Tce",
                        "Commercial Rd near Leopold St, stop 12",
                        "Wickham St at Knapp Street Stop 8",
                        "Breakfast Creek Rd at Evelyn Street Stop 10",
                        "Abbotsford Rd at Bowen Hills near Folkestone St",
                        "Oconnell Tce at Hamilton Place",
                        "OConnell Terrace near Bowen Bridge Rd",
                        "RBWH station, platform 2"
                    ],
                    "30: Spring Hill Loop": [
                        "Queen Street Stop 57 near Edward St",
                        "Upper Edward Street Stop 135 near Wickham Tce",
                        "Leichhardt Street Stop 178 near Little Edward St",
                        "Boundary St Stop 172 at St Andrews",
                        "Wickham Terrace Stop 174 at Albert Park",
                        "Wickham Terrace at Chancellor Stop 131",
                        "Wickham Terrace Stop 132 near Albert St",
                        "Wickham Terrace Stop 133 at Brisbane Private Hospital",
                        "Wickham Tce at Windmill stop 134",
                        "Edward Street Stop 141 near Ann St"
                    ],
                    "310: Brighton - City Express": [
                        "Hornibrook Hwy at Eventide",
                        "North Rd at Bayview",
                        "North Rd at Brighton North near Prince St",
                        "North Rd at St Kieran",
                        "North Rd at Brighton School, stop 58",
                        "Lascelles St at Brighton, stop 56a",
                        "Lascelles St at Brighton South, stop 54a",
                        "Craig St at Nashville",
                        "Baskerville St at Nashville School",
                        "Baskerville St at Peace Park",
                        "Baskerville St at Sandgate North, stop 39",
                        "Wakefield St at Freemasons",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Rainbow St at Sandgate station, stop 33",
                        "Board St at Deagon Racecourse, stop 29",
                        "Braun St at Sandgate High, stop 27",
                        "Sandgate Rd at Iceworld, stop 24",
                        "Sandgate Rd at Boondall School, stop 20/21",
                        "Sandgate Rd at Sues Corner, stop 18",
                        "Sandgate Rd at Nudgee College, stop 17",
                        "Sandgate Rd at Boondall South, stop 15",
                        "Sandgate Rd at Virginia",
                        "Sandgate Rd at Pritchard Road",
                        "Sandgate Rd at Virginia School, stop 21/20",
                        "Sandgate Rd at Goss Road",
                        "Sandgate Rd at Nundah North, stop 6",
                        "Sandgate Rd at Nundah, stop 3",
                        "Sandgate Rd at Toombul, stop 32",
                        "RBWH station, platform 1",
                        "Gotha Street Stop 231 near Wickham St",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Edward Street Stop 142 near Queen St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 227 near Little St",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "RBWH station, platform 2",
                        "Sandgate Rd at Nundah North, stop 7/6",
                        "Sandgate Rd at Goss Road, stop 8",
                        "Sandgate Rd at Virginia School, stop 21",
                        "Sandgate Rd near Ferric St",
                        "Sandgate Rd at Boondall South Stop 15",
                        "Sandgate Rd at Boondall School, stop 20",
                        "Sandgate Rd at Iceworld, stop 23/24",
                        "Sandgate Central, stop 33",
                        "Lascelles St at Brighton near Hall St",
                        "North Rd at Brighton North, stop 62",
                        "North Rd at Bayview, stop 63"
                    ],
                    "311: Brighton - Sandgate (Community Bus 1)": [
                        "Sandgate bus station, stop 1",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate, stop 34",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Deagon St near Southerden St, stop 37",
                        "Wakefield St at Freemasons",
                        "Dunne St at Bernard St, stop 3",
                        "Dunne St at Northcote St, stop 2",
                        "Dunne St at Easter St, stop 1",
                        "Nathan St near Sunwell St, stop 50",
                        "Douglas St near Sandown St, stop 51",
                        "Douglas St near Gordon St, stop 52",
                        "Barfoot St near Cedarwood St",
                        "Cedarwood St at Evergreen St",
                        "Evergreen St at Forestlea St, stop 1",
                        "Forestlea St at Claredale St",
                        "Evergreen St at Rainwood St, stop 2",
                        "Barfoot St at Bracken Ridge High School",
                        "Lascelles St near Lebanon St, stop 53",
                        "Lascelles St near Craig St, stop 54",
                        "Lascelles St at Brighton South, stop 54a",
                        "Wickham St at Ellora St, stop 1",
                        "Wickham St at Gordon St, stop 2",
                        "Nathan St near Saul St, stop 49",
                        "Nathan St near Speight St, stop 48",
                        "Nathan St near Queens Pde, stop 47",
                        "Queens Pde near Morcombe St, stop 46",
                        "Queens Pde near Northcote St, stop 45",
                        "Queens Pde near Gladstone St, stop 44",
                        "Regency St at Hamilton St",
                        "Ward St near Paul St, stop 41",
                        "Paul St near Beaumetz St, stop 40",
                        "Baskerville St at Sandgate North, stop 39",
                        "Deagon St near Albion St, stop 38",
                        "Deagon St near Brisbane St, stop 37",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate Central, stop 34/33"
                    ],
                    "312: Sandgate - Brighton (Community Bus 2)": [
                        "Sandgate bus station, stop 1",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate, stop 34",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Deagon St near Southerden St, stop 37",
                        "Deagon Devn at Deagon Street, stop 38",
                        "Baskerville St at Sandgate North, stop 39",
                        "Paul St near Beaumetz St, stop 40",
                        "Ward St near Paul St, stop 41",
                        "Regency St at Hamilton St",
                        "Queens Pde near Gladstone St, stop 44",
                        "Queens Pde near Nundah St, stop 45",
                        "Queens Pde near Seaview St, stop 46",
                        "Nathan St near Queens Pde, stop 47",
                        "Nathan St near Speight St, stop 48",
                        "Nathan St near Wickham St, stop 49",
                        "Wickham St at Gordon St, stop 2",
                        "Wickham St at Ellora St, stop 1",
                        "Lascelles St at Brighton South, stop 54a",
                        "Lascelles St near Mary Ellen St, stop 54",
                        "Lascelles St near Palina St, stop 53",
                        "Douglas St near Gordon St, stop 52",
                        "Douglas St near Sandown St, stop 51",
                        "Nathan St near Sunwell St, stop 50",
                        "Dunne St at Easter St, stop 1",
                        "Dunne St at Northcote St, stop 2",
                        "Dunne St at Bernard St , stop 3",
                        "Wakefield St at Freemasons",
                        "Deagon St near Brisbane St, stop 37",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate Central, stop 34/33"
                    ],
                    "313: Shorncliffe (Community Bus)": [
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Eagle Tce near Yundah St",
                        "Yundah St at Shorncliffe State School",
                        "Pier Ave at Saint Patricks College",
                        "Park Pde near Swan St",
                        "Cotton St near Yundah St",
                        "Friday St at Kate St",
                        "Kate St near Palm Ave",
                        "Sandgate bus station, stop 1"
                    ],
                    "314: Sandgate - Deagon & Shorncliffe (Community Bus)": [
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Braun St at Sandgate High, stop 27",
                        "Sandgate bus station, stop 1",
                        "Board St near Ibis Ave, stop 28",
                        "Adams St near Albury St hail 'n' ride",
                        "Bungama St near Silvan Rd",
                        "Stockham Rd near Finnie Rd",
                        "Stockham Rd near Blackwood Rd",
                        "Bungama St near Station Rd",
                        "Adams St near Finnie Rd",
                        "Sandgate Central, stop 33",
                        "Wharf St near Ashford St",
                        "Yundah St near Pier Ave",
                        "Allpass Pde near Jetty St",
                        "Shorncliffe Pde near Swan St",
                        "Park Pde near Swan St",
                        "Eagle Tce near Yundah St",
                        "Yundah St near Allpass Pde",
                        "Pier Ave near Collins Lane",
                        "Kate St near Palm Ave"
                    ],
                    "320: Chermside - City via Wavell Heights": [
                        "Chermside Shopping Centre interchange C",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Unmack Street, stop 50",
                        "Pfingst Rd near Hamilton Rd, stop 49",
                        "Pfingst Rd near Gumbrae St, stop 48",
                        "Pfingst Rd near Wirega St, stop 47",
                        "Pfingst Rd near Highcrest Ave, stop 46",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near White St, stop 44",
                        "Brae St near Pfingst Rd, stop 43",
                        "Edinburgh Castle Rd at Zeehan Street, stop 42",
                        "Edinburgh Castle Rd at Deloraine Street, stop 41",
                        "Shaw Rd near Villeroy St, stop 39",
                        "Shaw Rd near Sylvan Ave, stop 38",
                        "Shaw Rd near Buckland Rd, stop 37",
                        "Shaw Rd at Parklands, stop 36",
                        "Shaw Rd near Henry St, stop 35",
                        "Lodge Rd at Clark Street, stop 34",
                        "Kent Rd near Judge St, stop 32",
                        "Kent Rd near Melrose Lane, stop 31",
                        "Kent Rd near Rose St, stop 30",
                        "Rose St near Dawson St, stop 29",
                        "Junction Rd at Eagle Junction station, stop 28/1",
                        "Morrison Rd near Norman Pde, stop 27",
                        "Norman Pde at Adamson Street, stop 26",
                        "Bonney Ave at Bayview Terrace, stop 25",
                        "Bonney Ave at Victoria Parade, stop 24",
                        "Bonney Ave near Lisson Gr, stop 23",
                        "Bonney Ave at Rees Avenue, stop 22",
                        "Bonney Ave near Sandgate Rd, stop 21",
                        "Frodsham St near Ellen St, stop 19",
                        "Abbotsford Rd at Bus Depot, stop 17",
                        "Abbotsford Rd at Allison Street Stop 16",
                        "Abbotsford Rd at Bowen Hills near Folkestone St",
                        "Abbotsford Rd at Montpelier Road Stop 12/13",
                        "Saint Pauls Tce at Alexandria Street Stop 11",
                        "St Pauls Terrace at Fortitude Valley Stop 240",
                        "St Pauls Terrace Stop 238 near Quarry St",
                        "St Pauls Terrace Stop 235 near Union St",
                        "Wharf Street Stop 166 near Turbot St",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 47 near North Quay",
                        "William St near Elizabeth St stop 103",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 162 near Ann St",
                        "Wharf Street Stop 163 near Leichhardt St",
                        "St Pauls Terrace Stop 237 near Union St",
                        "St Pauls Terrace Stop 239 near Quarry St",
                        "St Pauls Terrace at Fortitude Valley Stop 232",
                        "Saint Pauls Tce at Constance Street Stop 6/10",
                        "Abbotsford Rd at Bowen Hills",
                        "Abbotsford Rd at Bus Depot, stop 17/18",
                        "Abbotsford Rd at Albion Road Stop 18",
                        "Abbotsford Rd at Albion Central Stop 19",
                        "Sandgate Rd at Camden Street, stop 20",
                        "Bonney Ave near Batman St, stop 23",
                        "Bonney Ave at Adamson Street, stop 26",
                        "Norman Pde at Morrison Road, stop 27",
                        "Junction Rd at Eagle Junction station, stop 28",
                        "Shaw Rd near Emma St, stop 35",
                        "Shaw Rd near Cressey Rd, stop 37",
                        "Shaw Rd near Vale St, stop 39",
                        "Edinburgh Castle Rd near Shaw Rd, stop 40",
                        "Pfingst Rd at Brae Street, stop 43",
                        "Pfingst Rd near Taylor St, stop 44",
                        "Pfingst Rd near Gurley St, stop 46",
                        "Pfingst Rd near Calga St, stop 47",
                        "Pfingst Rd near Miller St, stop 48",
                        "Pfingst Rd near Norla St, stop 49",
                        "Hamilton Rd at Playfield Street, stop 37a",
                        "Chermside interchange"
                    ],
                    "321: Toombul - City via Kalinga": [
                        "Toombul Shopping Centre station, platform F",
                        "Sandgate Rd at Noble Street, stop 31",
                        "Sandgate Rd at Eliza Street, stop 30",
                        "Junction Rd at Stuckey Street, stop 28/2",
                        "Park Ave at Sydney Street, stop 27",
                        "Park Ave near Lodge Rd, stop 29",
                        "Emma St near Park Rd, stop 30",
                        "Emma St at Bertha Street, stop 31",
                        "Emma St near Shaw Rd, stop 32",
                        "Lodge Rd at Clark Street, stop 34",
                        "Kent Rd near Judge St, stop 32",
                        "Kent Rd near Melrose Lane, stop 31",
                        "Kent Rd near Rose St, stop 30",
                        "Park Rd at Rose Street, stop 29",
                        "Park Rd at Gorman Street, stop 28",
                        "Park Rd near Kedron Park Rd, stop 27",
                        "Kedron Park Rd near Lutwyche Rd, stop 26/25",
                        "Lutwyche Rd at Wooloowin State School, stop 22",
                        "Lutwyche Rd at Norman Street, stop 21",
                        "Lutwyche Rd at Lutwyche, stop 20",
                        "Chalk St near Challis Lane, stop 20",
                        "McLennan St near Chalk St, stop 19",
                        "Lutwyche Rd at East Street, stop 19/18",
                        "McLennan St at Marne Street, stop 17",
                        "Truro Street, platform 1",
                        "McLennan St near Bale St, stop 16",
                        "Roblane St at Windsor Park stop 15",
                        "Albion Rd at Haddock Street Stop 15",
                        "Lutwyche Rd at Bowen Street, stop 14",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "Lutwyche Rd near Bryden St, stop 11",
                        "Federation Street, platform 1",
                        "RBWH station, platform 1",
                        "Gregory Tce near Brunswick St, stop 10",
                        "Gregory Tce near Park St, stop 9",
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "Boundary St near Torrington St, stop 3",
                        "Boundary St at Fortescue Street, stop 2",
                        "Little Edward St near Upper Edward St, stop 1",
                        "Upper Edward Street Stop 140 near Wickham Tce",
                        "Edward Street Stop 141 near Ann St",
                        "Queen Street Stop 58 near Pedestrian Crossing",
                        "Upper Edward Street Stop 135 near Wickham Tce",
                        "Leichhardt Street Stop 178 near Little Edward St",
                        "Boundary St Stop 172 at St Andrews",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Kennigo St, stop 9",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "RBWH station, platform 2",
                        "Federation Street, platform 2",
                        "Lutwyche Rd near Taylor St, stop 11",
                        "Lutwyche Rd near Newmarket Rd, stop 12",
                        "Lutwyche Rd at Windsor Rail",
                        "Lutwyche Rd at Windsor State School, stop 15",
                        "Lutwyche Rd at Old Council Chambers, stop 16",
                        "Lutwyche Rd at Maygar Street, stop 17",
                        "McLennan St near Storkey St, stop 16",
                        "Lutwyche Rd at East Street, stop 19",
                        "Norman St near Lutwyche Rd, stop 24/25",
                        "Kedron Park Rd near Kent St, stop 26",
                        "Park Ave near Lewis St, stop 29",
                        "Park Ave near Stewart St, stop 28",
                        "Toombul Interchange"
                    ],
                    "322: Chermside - City via Toombul": [
                        "Chermside Shopping Centre interchange C",
                        "Kingsmill St at Playfield Street, stop 37a",
                        "Kingsmill St at Miller Street",
                        "Kingsmill St near Hall St",
                        "Kuran St near Kinka St, stop 49",
                        "Thornton Pde at Bowd Pde, stop 48",
                        "Barker St near Thornton Pde, stop 47",
                        "Rode Rd at Telopia Street, stop 46",
                        "Rode Rd at Pfingst - Warraba, stop 45",
                        "Pfingst Rd near White St, stop 44",
                        "Brae St near Pfingst Rd, stop 43",
                        "Edinburgh Castle Rd at Zeehan Street, stop 42",
                        "Edinburgh Castle Rd at Deloraine Street, stop 41",
                        "Edinburgh Castle Rd near Shaw Rd, stop 40",
                        "Shaw Rd at Westwood Street, stop 36",
                        "Rode Rd at ODonnell Street, stop 37",
                        "Spence Rd near Sunny Ave, stop 38",
                        "Spence Rd near Rilatt St, stop 39/40",
                        "Spence Rd at Gardenia Street, stop 41",
                        "Spence Rd near Hamilton Rd, stop 42",
                        "Hamilton Rd at Albar Street, stop 49",
                        "Stadcor St near Kotara St, stop 53",
                        "Stadcor St at Corowa Street, stop 52",
                        "Main Ave near Stadcor St, stop 51",
                        "Bilsen Rd near Main Ave, stop 50",
                        "Bilsen Rd at Kuppa Street, stop 49",
                        "Bilsen Rd at Halcyon Street, stop 48",
                        "Bilsen Rd near Hamilton Rd, stop 47",
                        "Bilsen Rd at Rilatt Street, stop 46",
                        "Bilsen Rd near Norman St, stop 45",
                        "Bilsen Rd near Rode Rd, stop 44",
                        "Rode Rd near Bayview Tce, stop 42/43",
                        "Windsor St at Rode Road, stop 41",
                        "Windsor St near Eton St, stop 40/33",
                        "Park Rd at Boyd Road, stop 39",
                        "Park Rd near Buckland Rd, stop 38",
                        "Buckland Rd at Nundah State School, stop 38A",
                        "Sandgate Rd near Buckland Rd, stop 1",
                        "Toombul Shopping Centre station, platform A",
                        "Sandgate Rd at Noble Street, stop 31",
                        "Sandgate Rd at Eliza Street, stop 30",
                        "Sandgate Rd at Collins Street, stop 28",
                        "Sandgate Rd at Clayfield",
                        "Sandgate Rd at London Road",
                        "Sandgate Rd at Adelaide Street, stop 25",
                        "Sandgate Rd at Botany Street, stop 24",
                        "Sandgate Rd at Clayfield South, stop 23",
                        "Sandgate Rd at Hutton Street, stop 21",
                        "Sandgate Rd at Camden Street, stop 20",
                        "Sandgate Rd at Albion Central, stop 19",
                        "Sandgate Rd at Albion Road, stop 18",
                        "Sandgate Rd at Collingwood Street, stop 17",
                        "Sandgate Rd at Greg Chappell Street, stop 16",
                        "Sandgate Rd at Yowoggera Park, stop 15",
                        "Edmondstone Rd at Parkview, stop 14",
                        "Breakfast Creek Rd at Evelyn Street, stop 10",
                        "Breakfast Creek Rd at Riverpark Stop 9",
                        "Ann St at Chester Street, stop 7",
                        "Ann St at James Street, stop 6",
                        "Ann St at Bridge Street, stop 5",
                        "Ann Street Stop 216 at Valley Island",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 40 near Broadway",
                        "Adelaide Street Stop 47 near North Quay",
                        "William St near Elizabeth St stop 103",
                        "Toombul Shopping Centre station, platform D",
                        "Adelaide Street Stop 24 near Edward St",
                        "Buckland Rd near Bage Street, stop 37",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Buckland Rd at Leslie Street, stop 38",
                        "Park Rd near Boyd Road, stop 39",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 226 near Gotha St",
                        "Park Rd at Windsor Street, stop 40",
                        "Wickham Street Stop 229 near Warner St",
                        "Rode Rd near Kinmond Ave, stop 41",
                        "Rode Rd near Sugarloaf St, stop 42/43",
                        "Wickham St at Bridge Street, stop 5",
                        "Bilsen Rd near Joppa Lane, stop 45",
                        "Wickham St at East Street Stop 6",
                        "Wickham St at Light Street, stop 7",
                        "Wickham St at Knapp Street Stop 8",
                        "Breakfast Creek Rd at Evelyn Street Stop 10",
                        "Stadcor St near Main Ave, stop 51",
                        "Stadcor St near Millcan St, stop 53",
                        "Abbotsford Rd at Albion Road Stop 18",
                        "Abbotsford Rd at Albion Central Stop 19",
                        "Spence Rd near Highlands St, stop 40/39",
                        "Spence Rd near Rode Rd, stop 38",
                        "Rode Rd near Deloraine St, stop 37A",
                        "Sandgate Rd at Clayfield, stop 27",
                        "Pfingst Rd at Brae Street, stop 43",
                        "Pfingst Rd near Taylor St, stop 44",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Rode Rd near Telopia Ave, stop 46",
                        "Kuran St at Burradoo Street, stop 48",
                        "Kuran St near Kingsmill St, stop 49A",
                        "Kingsmill St near Kuran St",
                        "Hamilton Rd at Playfield Street, stop 37a",
                        "Chermside interchange"
                    ],
                    "325: Boondall - City Express": [
                        "Aberdeen Pde at Boondall station",
                        "Northumbria Rd near Boondall St",
                        "Landsboro Ave at Landsboro, stop 20a",
                        "College Way near Frensham Cr",
                        "Roscommon Rd at Roscommon East, stop 19/64",
                        "College Way near Lourdes Pl",
                        "Sandgate Rd at Boondall School, stop 20",
                        "College Way near Thoms Ave",
                        "Roghan Rd at Roghan East near Sovereign Pl",
                        "College Way near Frawley St",
                        "Muller Rd at Boondall West near Hayman St",
                        "Holme Ave near Roundabout",
                        "Muller Rd at Taigum, stop 60",
                        "Beams Rd at Taigum Shopping Centre",
                        "Church Rd at Church-Battersby",
                        "Church Rd at Church Road South",
                        "Zillmere Rd at Zillmere South",
                        "Newman Rd at Newman North, stop 52a",
                        "Railway Pde at Geebung station",
                        "Newman Rd at Geebung School, stop 48",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Newman South, stop 45",
                        "Hamilton Rd at Chermside East near Pfingst Rd",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Chermside Shopping Centre interchange H",
                        "Hamilton Rd at Farnell Street, stop 39",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Webster Rd at Wilgarning Street",
                        "Webster Rd at Stafford, stop 30",
                        "Webster Rd at Lindley Street, stop 29",
                        "Grange Rd at Raymont Road, stop 27",
                        "Grange Rd at Grange - Days, stop 25b",
                        "Thomas St at Grange near Carberry St",
                        "Wilston Rd at Newmarket station, stop 16",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Edward Street Stop 141 near Ann St",
                        "Queen Street Stop 56 near Edward St",
                        "Ann Street Stop 9 near King George Square",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Edmondstone St at Newmarket",
                        "Wilston Rd at Newmarket station",
                        "Thomas St at Grange, stop 25/26",
                        "Webster Rd at Wilgarning Street, stop 31",
                        "Chermside Shopping Centre interchange F",
                        "Hamilton Rd at Chermside East near Newman Rd",
                        "Newman Rd at Geebung School, stop 49",
                        "Newman Rd at Geebung station, stop 51",
                        "Taigum Shopping Centre, stop 52/57",
                        "Muller Rd at Taigum, stop 60a",
                        "Muller Rd at Boondall West near Futuna St",
                        "Roghan Rd at Roghan East",
                        "Sandgate Rd at Boondall School, stop 20/21",
                        "Roscommon Rd at Roscommon East, stop 64/19",
                        "Holme Ave near Eton Ave",
                        "College Way at Thoms Ave",
                        "College Way near Northumbria Rd",
                        "Northumbria Rd at Northumbria"
                    ],
                    "326: Carseldine - Toombul via Sandgate, Geebung": [
                        "Carseldine station east, stop 1",
                        "Carselgrove Ave near Carnarvon Cr",
                        "Carselgrove Ave near Roghan Rd",
                        "Norris Rd at Cape Arid Park",
                        "Norris Rd at Bracken Ridge Plaza",
                        "Norris Rd near Barbour Rd, stop 46",
                        "Norris Rd near Barbour Rd",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Norris Rd at Greenore Street, stop 45",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Gawain East, stop 42",
                        "Cramb St near McKeering St, stop 39",
                        "McKeering St at Shane Street, stop 38",
                        "Barrett St near Tallara St, stop 37",
                        "Tallara St near Tarwarri St, stop 36",
                        "Tomah Rd near Binburra St, stop 34",
                        "Denham St at Childs Street, stop 33",
                        "Denham St near Phillips St, stop 32",
                        "Denham St at Warra, stop 31",
                        "Depot Rd at Quinlan Street South, stop 30",
                        "Depot Rd at Braun Street, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St at Kift Street, stop 30",
                        "Rainbow St near Lunn St, stop 31",
                        "Rainbow St at Hancock Street, stop 32",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Sandgate bus station, stop 1",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St near Racecourse Rd, stop 29a",
                        "Braun St at Desmond Street, stop 27A",
                        "Braun St at Sandgate High, stop 27",
                        "Braun St at Smith Street, stop 26",
                        "Braun St at Burralong Street, stop 25",
                        "Sandgate Rd at Iceworld, stop 24",
                        "Roghan Rd at Roghan East near Sovereign Pl",
                        "Roghan Rd near Lindeman St",
                        "Muller Rd at Boondall West near Hayman St",
                        "Muller Rd near Bambrook St, stop 61",
                        "Muller Rd at Taigum, stop 60",
                        "Muller Rd at Hirschfield Street, stop 59",
                        "Hirschfield St near Dulendella Street, stop 58",
                        "Tedman St at Fahey Street, stop 57",
                        "Taigum Shopping Centre, stop 52/57",
                        "Church Rd at Keyatta Street",
                        "Battersby St near Church Rd",
                        "Battersby St near Birdwood St",
                        "Handford Rd at Kolberg Street, stop 47A",
                        "Handford Rd at Grasspan Street, stop 47",
                        "Handford Rd at Zillmere station",
                        "Murphy Rd at Dunsford Street, stop 45",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Robinson Rd West, stop 43",
                        "Robinson Rd West near Fisher Pde",
                        "Robinson Rd at Bassano Street",
                        "Railway Pde at Geebung station",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung School, stop 48",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Mylne Street, stop 44",
                        "Hamilton Rd at Lochrae Street, stop 43",
                        "Spence Rd near Hamilton Rd, stop 42",
                        "Spence Rd at Gardenia Street, stop 41",
                        "Spence Rd near Highlands St, stop 40/39",
                        "Spence Rd near Rode Rd, stop 38",
                        "Rode Rd near Deloraine St, stop 37A",
                        "Rode Rd near Bayview Tce, stop 42/43",
                        "Rode Rd near Eliza Ln",
                        "Rode Rd near Sandgate Rd",
                        "Sandgate Rd at Nundah, stop 3",
                        "Sandgate Rd at Nundah, stop 2",
                        "Sandgate Rd near Buckland Rd, stop 1",
                        "Toombul Interchange",
                        "Toombul Shopping Centre station, platform F",
                        "Rode Rd near Kinmond Ave, stop 41",
                        "Rode Rd near Sugarloaf St, stop 42/43",
                        "Rode Rd at ODonnell Street, stop 37",
                        "Spence Rd near Sunny Ave, stop 38",
                        "Spence Rd near Rilatt St, stop 39/40",
                        "Hamilton Rd near Lochrae Street, stop 43",
                        "Newman Rd at Geebung School, stop 49",
                        "Newman Rd at Geebung station, stop 51",
                        "Railway Pde near Bayview Tce",
                        "Robinson Rd West at Fisher Parade",
                        "Handford Rd at Kolberg Street, stop 47a",
                        "Battersby St near Victory St",
                        "Battersby St at Church Road",
                        "Church Rd near Keyatta St",
                        "Hirschfield St at Dulendella Street, stop 58",
                        "Muller Rd at Taigum, stop 60a",
                        "Muller Rd at Boondall West near Futuna St",
                        "Roghan Rd at Roghan East",
                        "Sandgate Rd at Iceworld, stop 23/24",
                        "Denham St at Warra",
                        "Denham St near Childs St, stop 33",
                        "Tallara St near Tulee St, stop 36",
                        "Barrett St at Bracken Ridge Library, stop 37",
                        "Norris Rd at Greenore Street"
                    ],
                    "327: Strathpine - Bracken Ridge & Toombul": [
                        "Strathpine bus station, stop D",
                        "Kluver St near Bracken Ridge Rd",
                        "Arnica Cr near Korina St, stop 57",
                        "Strathpine Rd at Adair Street",
                        "Strathpine Rd near Bald Hills Rd",
                        "Arnica Cr near Mantias Street, stop 56",
                        "Hoyland St near Kluver St",
                        "Charlock Rd near Arnica Cr, stop 55",
                        "Coriander St near Kluver St, stop 60",
                        "Charlock Rd near Gladdon St",
                        "Bracken Ridge Rd at Wetlands",
                        "Taragon St near Chervil St",
                        "Ballynde St at Glenealy Street, stop 54",
                        "Ballynde St at Portumna Street, stop 53",
                        "Ballynde St at Toormore Street, stop 52",
                        "Ballynde St near Bungowla St, stop 51",
                        "Killare St near Wickfield Cr, stop 50",
                        "Wickfield St near Rosa Cr, stop 49",
                        "Wickfield St near Sophy Cr, stop 48",
                        "Barbour Rd near Wickfield St, stop 47",
                        "Norris Rd near Barbour Rd, stop 46",
                        "Norris Rd at Bracken Ridge Plaza",
                        "Telegraph Rd near Mustang St",
                        "Mustang St near Telegraph Rd",
                        "Enbrook St near Mustang St",
                        "Enbrook St near Appledore St",
                        "Phillips St near Tomah Rd",
                        "Denham St at Warra, stop 31",
                        "Lemke Rd at Sandgate AFC Ground",
                        "Handford Rd at Songbird Way",
                        "Handford Rd at Handford - Roghan",
                        "Handford Rd at Symes Grove, stop 49",
                        "Handford Rd at Liberty Dr",
                        "Beams Rd at Caravan Park, stop 49",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd near Church Rd, stop 51",
                        "Taigum Shopping Centre, stop 52/57",
                        "Tedman St at Fahey Street, stop 57",
                        "Tedman St at Hodgson Street, stop 57",
                        "Macansh St near Gledson St, stop 56",
                        "Percy St near Ewing St, stop 55",
                        "Harold St near Charlie St, stop 54",
                        "Church Rd at Church Road South",
                        "Zillmere Rd near Halcomb St",
                        "Zillmere Rd near Handford Rd",
                        "Murphy Rd at Dunsford Street, stop 45",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Robinson Rd West, stop 43",
                        "Robinson Rd West near Fisher Pde",
                        "Robinson Rd at Bassano Street",
                        "Railway Pde at Geebung station",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung School, stop 48",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Mylne Street, stop 44",
                        "Hamilton Rd at Lochrae Street, stop 43",
                        "Spence Rd near Hamilton Rd, stop 42",
                        "Spence Rd at Gardenia Street, stop 41",
                        "Spence Rd near Highlands St, stop 40/39",
                        "Spence Rd near Rode Rd, stop 38",
                        "Rode Rd near Deloraine St, stop 37A",
                        "Shaw Rd at Westwood Street, stop 36",
                        "Shaw Rd near Villeroy St, stop 39",
                        "Shaw Rd near Sylvan Ave, stop 38",
                        "Buckland Rd near Shaw Rd, stop 34",
                        "Buckland Rd at Imbros Street, stop 35/36",
                        "Buckland Rd at Bishop Street, stop 37",
                        "Buckland Rd at Park Road, stop 38",
                        "Buckland Rd at Nundah State School, stop 38A",
                        "Sandgate Rd near Buckland Rd, stop 1",
                        "Toombul Interchange",
                        "Toombul Shopping Centre station, platform F",
                        "Buckland Rd near Bage Street, stop 37",
                        "Buckland Rd at Leslie Street, stop 38",
                        "Buckland Rd at Toombul Terrace, stop 38C",
                        "Buckland Rd at Imbros Street, stop 35",
                        "Shaw Rd near Cressey Rd, stop 37",
                        "Shaw Rd near Vale St, stop 39",
                        "Rode Rd at ODonnell Street, stop 37",
                        "Spence Rd near Sunny Ave, stop 38",
                        "Spence Rd near Rilatt St, stop 39/40",
                        "Hamilton Rd near Lochrae Street, stop 43",
                        "Newman Rd at Geebung School, stop 49",
                        "Newman Rd at Geebung station, stop 51",
                        "Railway Pde near Bayview Tce",
                        "Robinson Rd West at Fisher Parade",
                        "Handford Rd at Symes Grove",
                        "Denham St at Warra",
                        "Phillips St at Tomah Street",
                        "Barbour Rd at Caulfield Street, stop 47A",
                        "Wickfield St near Rosa Cr, stop 47",
                        "Wickfield St at Rosa Crescent, stop 49",
                        "Killare St near Wickfield St, stop 50",
                        "Ballynde St near Portumna Street, stop 53",
                        "Arnica Cr at Mantias Street, stop 56",
                        "Coriander St near Kluver St",
                        "Hoyland St near Dresden St",
                        "Strathpine Rd near Lucy St",
                        "Strathpine Rd at Adair St"
                    ],
                    "329: Bracken Ridge - Carseldine via Lacey Road": [
                        "Norris Rd near Barbour Rd, stop 46",
                        "Norris Rd at Bracken Ridge Plaza",
                        "Telegraph Rd near Langer Pl",
                        "Lacey Rd near Highbridge Cct",
                        "Lacey Rd near Macaranga Cr",
                        "Beams Rd at Bangalore Street",
                        "Beams Rd at Carseldine Campus",
                        "Balcara Ave at Beams - Balcara",
                        "Carseldine station"
                    ],
                    "330: Bracken Ridge - City Express": [
                        "Quinlan St at Bracken Ridge near Barrett St",
                        "Barrett St at McKeering-Barrett",
                        "Bracken St at Bracken Ridge Library",
                        "Gawain Rd at Gawain East, stop 42",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Norris Rd at Greenore Street",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Barbour Rd near Phillips St",
                        "Phillips St at St Josephs",
                        "Phillips St at Enbrook Street",
                        "Denham St at Warra, stop 31",
                        "Lemke Rd at Sandgate AFC Ground",
                        "Handford Rd at Handford - Roghan",
                        "Handford Rd at Symes Grove, stop 49",
                        "Handford Rd at Liberty Dr",
                        "Handford Rd at St Flannans School",
                        "Handford Rd at Handford - Battersby, stop 49",
                        "Handford Rd at Zillmere station",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Butt Street",
                        "Murphy Rd at Ellison Road, stop 41",
                        "Gympie Rd at The Gardens, stop 38A",
                        "Gympie Rd at Chermside, stop 37/38",
                        "RBWH station, platform 1",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Queen Street station",
                        "Queen Street station, 1b",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "Chermside Shopping Centre interchange E",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Handford Rd at Handford - Battersby, stop 48",
                        "Handford Rd at Symes Grove",
                        "Denham St at Warra",
                        "Norris Rd at Greenore Street, stop 45",
                        "Barrett St at Bracken Ridge Library, stop 37"
                    ],
                    "331: Bracken Ridge - City Rocket": [
                        "Barrett St at McKeering-Barrett",
                        "Bracken St at Bracken Ridge Library",
                        "Gawain Rd at Gawain East, stop 42",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Norris Rd at Greenore Street",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Barbour Rd near Phillips St",
                        "Phillips St at St Josephs",
                        "Phillips St at Enbrook Street",
                        "Denham St at Warra, stop 31",
                        "Lemke Rd at Sandgate AFC Ground",
                        "Handford Rd at Handford - Roghan",
                        "Handford Rd at Symes Grove, stop 49",
                        "Handford Rd at Liberty Dr",
                        "Handford Rd at St Flannans School",
                        "Handford Rd at Handford - Battersby, stop 49",
                        "Handford Rd at Zillmere station",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Butt Street",
                        "Murphy Rd at Ellison Road, stop 41",
                        "Gympie Rd at The Gardens, stop 38A",
                        "Gympie Rd at Chermside, stop 37/38",
                        "RBWH station, platform 1",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 91 near Edward St",
                        "George Street Stop 116",
                        "Turbot St stop 130 at Magistrates Court",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "Gympie Rd at Chermside, stop 38",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Handford Rd at Handford - Battersby, stop 48",
                        "Handford Rd at Symes Grove",
                        "Denham St at Warra",
                        "Norris Rd at Greenore Street, stop 45",
                        "Barrett St at Bracken Ridge Library, stop 37"
                    ],
                    "332: Zillmere - City Rocket via Spring Hill": [
                        "Handford Rd at St Flannans School",
                        "Handford Rd at Handford - Battersby, stop 49",
                        "Handford Rd at Zillmere station",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Butt Street",
                        "Murphy Rd at Ellison Road, stop 41",
                        "Gympie Rd at The Gardens, stop 38A",
                        "Gympie Rd at Chermside, stop 37/38",
                        "Gympie Rd at Rode Road",
                        "Gympie Rd near Kitchener Road",
                        "Gympie Rd near Strathmore Street",
                        "Gympie Rd at Sadlier Street",
                        "Kedron Brook station, platform 1",
                        "Lutwyche station, platform 1",
                        "Truro Street, platform 1",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "RBWH station, platform 1",
                        "Water Street Stop 186 near Dickens St",
                        "Wharf Street Stop 166 near Turbot St",
                        "Eagle Street Stop 152 at Riverside Centre",
                        "Charlotte Street Stop 52 near Edward St",
                        "George Street Stop 123 near Alice St",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St app Queen St (Stop 65)",
                        "Turbot Street Stop 4 near Wharf St",
                        "Fortescue Street Stop 185 near Boundary St",
                        "RBWH station, platform 2",
                        "Lutwyche Rd at Windsor Rail",
                        "Truro Street, platform 2",
                        "Lutwyche station, platform 2",
                        "Kedron Brook station, platform 2",
                        "Gympie Rd at Cremorne Rd",
                        "Gympie Rd at Strathmore Street",
                        "Gympie Rd at Kitchener Road",
                        "Gympie Rd at Chermside, stop 38",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Handford Rd at Handford - Battersby, stop 48"
                    ],
                    "333: Chermside - Woolloongabba via City": [
                        "Chermside Shopping Centre interchange A",
                        "Gympie Rd at Chermside, stop 37/38",
                        "Gympie Rd at Rode Road",
                        "Gympie Rd near Kitchener Road",
                        "Gympie Rd near Strathmore Street",
                        "Gympie Rd at Sadlier Street",
                        "Kedron Brook station, platform 1",
                        "Lutwyche station, platform 1",
                        "Truro Street, platform 1",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "RBWH station, platform 1",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "King George Square, 2c",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "King George Square, 1a",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "Lutwyche Rd at Windsor Rail",
                        "Truro Street, platform 2",
                        "Lutwyche station, platform 2",
                        "Kedron Brook station, platform 2",
                        "Gympie Rd at Cremorne Rd",
                        "Gympie Rd at Strathmore Street",
                        "Gympie Rd at Kitchener Road",
                        "Chermside interchange"
                    ],
                    "334: Chermside - City via Kedron": [
                        "Chermside Shopping Centre interchange D",
                        "Kingsmill St at Playfield Street, stop 37a",
                        "Kingsmill St at Miller Street",
                        "Kingsmill St near Hall St",
                        "Wallace St at Kuran - Gympie, stop 36",
                        "Wallace St at Davenport Street, stop 35a",
                        "Wallace St at Prince Charles Hospital, stop 35",
                        "Hilltop Ave at Ethel Street, stop 34c",
                        "Hilltop Ave near Rainey St, stop 34b",
                        "Parkdale St at Parkdale - Rode, stop 52/34",
                        "Parkdale St at Eltham Street, stop 51",
                        "Parkdale St near Exley St, stop 50",
                        "Bohland St at Allan Street, stop 49",
                        "Bohland St near Araluen St, stop 48",
                        "Kitchener Rd at North Street, stop 47",
                        "Turner Rd at East Street, stop 46",
                        "Mawson St near Shackleton St, stop 45",
                        "Mawson St at Oates Street",
                        "Mawson St near Bayview St, stop 34",
                        "Clifford St at Dorrigo Street, stop 33",
                        "Moree St at View Street, stop 42",
                        "Moree St at Dawn Street, stop 43",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Strathmore St near Goodall St",
                        "Castle St near Seabrook St",
                        "Castle St near Leckie Rd",
                        "Leckie Rd near Sadlier St",
                        "Leckie Rd near Fifth Ave",
                        "Gympie Rd at Leckie Road, stop 26/24",
                        "Lutwyche Rd at Wooloowin State School, stop 22",
                        "Lutwyche Rd at Norman Street, stop 21",
                        "Lutwyche Rd at Lutwyche, stop 20",
                        "Lutwyche Rd at East Street, stop 19/18",
                        "Truro Street, platform 1",
                        "Roblane St at Windsor Park stop 15",
                        "Lutwyche Rd at Bowen Street, stop 14",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "Lutwyche Rd near Bryden St, stop 11",
                        "Federation Street, platform 1",
                        "RBWH station, platform 1",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Queen Street Stop 58 near Pedestrian Crossing",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 211",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "RBWH station, platform 2",
                        "Federation Street, platform 2",
                        "Lutwyche Rd near Taylor St, stop 11",
                        "Lutwyche Rd near Newmarket Rd, stop 12",
                        "Lutwyche Rd at Windsor Rail",
                        "Lutwyche Rd at Windsor State School, stop 15",
                        "Lutwyche Rd at Old Council Chambers, stop 16",
                        "Lutwyche Rd at Maygar Street, stop 17",
                        "Lutwyche Rd at East Street, stop 19",
                        "Lutwyche Rd at Norman Street, stop 22",
                        "Sadlier St near Leckie Rd",
                        "Leckie Rd near Eleventh Ave",
                        "Strathmore St near Caithness St",
                        "Strathmore St near Connolly St",
                        "Moree St at Dawn St, stop 43",
                        "Bayview St near Mawson St, stop 34",
                        "Mawson St near Turner Rd, stop 45",
                        "Parkdale St at Rode Rd, stop 52/34",
                        "Hilltop Ave at Prince Charles Hospital, stop 35",
                        "Wallace St near Farnell St",
                        "Kuran St at Gympie Rd",
                        "Kingsmill St near Kuran St",
                        "Hamilton Rd at Playfield Street, stop 37a",
                        "Chermside interchange"
                    ],
                    "335: Sandgate - City Express via Kirby Road": [
                        "Sandgate bus station, stop 4",
                        "Board St at Deagon Racecourse, stop 29",
                        "Braun St at Sandgate High, stop 27",
                        "Sandgate Rd at Iceworld, stop 24",
                        "Sandgate Rd at Boondall School, stop 20/21",
                        "Beams Rd near Jalomy St, stop 25A",
                        "Beams Rd near Groth Rd",
                        "Beams Rd at Taigum Shopping Centre",
                        "Taigum Shopping Centre, stop 52/57",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd at St Flannans",
                        "Beams Rd at Golden Downs",
                        "Balcara Ave at Beams - Balcara",
                        "Balcara Ave near Allira Cr",
                        "Dorville Rd at Dorville North",
                        "Dorville Rd at Denver East",
                        "Zillmere Rd at Aspley High School",
                        "Kirby Rd at Funnell Street, stop 52",
                        "Kirby Rd at Aspley East, stop 50",
                        "Kirby Rd near Robinson Rd, stop 48",
                        "Kirby Rd at Ailsa Street, stop 47/46",
                        "Kirby Rd at Kirby South, stop 45",
                        "Webster Rd at Ellison West, stop 44",
                        "Gympie Rd at Marchant Park, stop 40",
                        "Chermside Shopping Centre interchange H",
                        "Hamilton Rd at Farnell Street, stop 39",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Webster Rd at Wilgarning Street",
                        "Webster Rd at Stafford, stop 30",
                        "Webster Rd at Lindley Street, stop 29",
                        "Grange Rd at Raymont Road, stop 27",
                        "Grange Rd at Grange - Days, stop 25b",
                        "Kedron Brook Rd at Wilston Village, stop 20",
                        "Newmarket Rd at Oakwal Lane, stop 16",
                        "Federation Street, platform 1",
                        "RBWH station, platform 1",
                        "Gotha Street Stop 231 near Wickham St",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Queen Street Stop 56 near Edward St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 227 near Little St",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "RBWH station, platform 2",
                        "Federation Street, platform 2",
                        "Days Rd at Grange - Days",
                        "Webster Rd at Wilgarning Street, stop 31",
                        "Chermside Shopping Centre interchange F",
                        "Gympie Rd at Marchant Park, stop 40 - CLOSED",
                        "Kirby Rd at Ailsa Street, stop 46/47",
                        "Beams Rd at Holy Spirit College",
                        "Sandgate Rd at Sues Corner, stop 18",
                        "Sandgate Rd at Boondall School, stop 20",
                        "Sandgate Rd at Iceworld, stop 23/24",
                        "Sandgate station"
                    ],
                    "336: Chermside Clockwise Loop": [
                        "Chermside Shopping Centre interchange D",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Murphy Rd at Marchant Park, stop 40",
                        "Ellison Rd near Marathon St",
                        "Ellison Rd near Boulter St",
                        "Webster Rd at Ellison West, stop 44",
                        "Webster Rd at Chermside Markets",
                        "Webster Rd at Ronmack Street, stop 41",
                        "Webster Rd at Milburn Street, stop 40/3",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Maundrell Tce at St Gerards, stop 45/46",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Aspley Hypermarket station, platform D",
                        "Gympie Rd at Aspley",
                        "Gympie Rd at Gayford Street, stop 44",
                        "Zillmere Rd at Homebase",
                        "Zillmere Rd at Aspley High School",
                        "Kirby Rd near Zillmere Rd, stop 52A",
                        "Kirby Rd at Funnell Street, stop 52",
                        "Kirby Rd at Aspley East, stop 50",
                        "Robinson Rd near Cornish Place, stop 50",
                        "Robinson Rd at Lerida Street, stop 52A",
                        "Robinson Rd at Priscilla Street, stop 53",
                        "Robinson Rd West near Fisher Pde",
                        "Robinson Rd at Bassano Street",
                        "Railway Pde at Geebung station",
                        "Copperfield St near Warrina St, stop 49",
                        "Piccadilly St at Haymarket Street, stop 48",
                        "Ellison Rd at Piccadilly Street, stop 46",
                        "Halsmere St near Danette St",
                        "Willcott St near Sunbury St",
                        "Ellison Rd near Jeenly St",
                        "Ellison Rd near Marmont St",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Beor St at Unmack Street, stop 43",
                        "Beor St near Corrie St, stop 42",
                        "Corrie St near Hodgkinson St, stop 41",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Playfield Street, stop 37a",
                        "Chermside interchange"
                    ],
                    "337: Chermside Anti-Clockwise Loop": [
                        "Chermside Shopping Centre interchange C",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Corrie St near Pechey St, stop 41",
                        "Beor St near Corrie St, stop 42",
                        "Beor St at Unmack Street, stop 43",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Ellison Rd at Marmont Street",
                        "Ellison Rd near Jeenly St",
                        "Willcott St near Sunbury St",
                        "Halsmere St near Danette St",
                        "Ellison Rd near Piccadilly St",
                        "Piccadilly St near Sandra St",
                        "Piccadilly St near Haymarket St",
                        "Copperfield St near Ossian St",
                        "Newman Rd at Geebung station, stop 51",
                        "Railway Pde near Bayview Tce",
                        "Robinson Rd at Bassano Street",
                        "Robinson Rd West at Fisher Parade",
                        "Robinson Rd at Priscilla Street, stop 53",
                        "Robinson Rd at Lerida Street, stop 52A",
                        "Robinson Rd near Cornish Place, stop 50",
                        "Kirby Rd at Aspley East, stop 50",
                        "Kirby Rd at Funnell Street, stop 52",
                        "Kirby Rd near Zillmere Rd, stop 52a",
                        "Zillmere Rd at Aspley High School",
                        "Zillmere Rd at Homebase",
                        "Gympie Rd at Brickfield Street, stop 45/44",
                        "Gympie Rd at Aspley",
                        "Aspley Hypermarket station, platform C",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Maundrell Tce at Darwin Street, stop 50",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Chermside West, stop 48/11",
                        "Maundrell Tce at John Goss Reserve, stop 47/12",
                        "Maundrell Tce at St Gerards, stop 46",
                        "Hamilton Rd at Maundrell Tce, stop 43a",
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Webster Rd at Milburn Street, stop 40",
                        "Webster Rd at Ronmack Street, stop 41",
                        "Webster Rd at Chermside Markets, stop 43",
                        "Webster Rd at Ellison West, stop 44",
                        "Ellison Rd near Eustace St",
                        "Ellison Rd near Marathon St",
                        "Murphy Rd at Ellison Road, stop 41",
                        "Murphy Rd at Marchant Park, stop 40",
                        "Gympie Rd at The Gardens, stop 38A",
                        "Chermside interchange"
                    ],
                    "338: City - Chermside": [
                        "Chermside Shopping Centre interchange B",
                        "Gympie Rd at Chermside, stop 37/38",
                        "Gympie Rd near Wallace Street",
                        "Gympie Rd at Rode Road",
                        "Gympie Rd near Kitchener Road",
                        "Gympie Rd near Strathmore Street",
                        "Gympie Rd at Sadlier Street",
                        "Gympie Rd at Leckie Road, stop 26/24",
                        "Lutwyche Rd at Wooloowin State School, stop 22",
                        "Lutwyche Rd at Norman Street, stop 21",
                        "Lutwyche Rd at Lutwyche, stop 20",
                        "Lutwyche Rd at East Street, stop 19/18",
                        "Truro Street, platform 1",
                        "Roblane St at Windsor Park stop 15",
                        "Lutwyche Rd at Bowen Street, stop 14",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "Lutwyche Rd near Bryden St, stop 11",
                        "Federation Street, platform 1",
                        "RBWH station, platform 1",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Brunswick Street Stop 201 near Alfred St CLOSED",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Queen Street Stop 59 near Creek St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 211",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "RBWH station, platform 2",
                        "Federation Street, platform 2",
                        "Lutwyche Rd near Taylor St, stop 11",
                        "Lutwyche Rd near Newmarket Rd, stop 12",
                        "Lutwyche Rd at Windsor Rail",
                        "Lutwyche Rd at Windsor State School, stop 15",
                        "Lutwyche Rd at Old Council Chambers, stop 16",
                        "Lutwyche Rd at Maygar Street, stop 17",
                        "Lutwyche Rd at East Street, stop 19",
                        "Lutwyche Rd at Norman Street, stop 22",
                        "Lutwyche Rd at Leckie Road, stop 25",
                        "Gympie Rd at Cremorne Rd",
                        "Gympie Rd at Strathmore Street",
                        "Gympie Rd at Kitchener Road",
                        "Gympie Rd at Wallace Street",
                        "Chermside interchange"
                    ],
                    "340: Carseldine - Woolloongabba Express via City": [
                        "Carseldine station",
                        "Balcara Ave at Beams - Balcara",
                        "Beams Rd at Carseldine Campus",
                        "Beams Rd at Bangalore Street",
                        "Beams Rd near Tintara St",
                        "Ridley Rd near Centurion St",
                        "Ridley Rd at Ridley Road South",
                        "Graham Rd at Carseldine West near Kentia St",
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Gympie Rd at Aspley",
                        "Gympie Rd at Aspley South, stop 41",
                        "Webster Rd at Chermside Markets",
                        "Webster Rd at Milburn Street, stop 40/3",
                        "Hamilton Rd at Farnell Street, stop 39",
                        "Gympie Rd at Chermside, stop 37/38",
                        "Gympie Rd at Rode Road",
                        "Gympie Rd near Kitchener Road",
                        "Gympie Rd near Strathmore Street",
                        "Gympie Rd at Sadlier Street",
                        "Kedron Brook station, platform 1",
                        "Lutwyche station, platform 1",
                        "Truro Street, platform 1",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "RBWH station, platform 1",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "King George Square, 2c",
                        "Woolloongabba station, platform 2",
                        "Woolloongabba station, platform 1",
                        "King George Square, 1a",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "Lutwyche Rd at Windsor Rail",
                        "Truro Street, platform 2",
                        "Lutwyche station, platform 2",
                        "Kedron Brook station, platform 2",
                        "Gympie Rd at Cremorne Rd",
                        "Gympie Rd at Strathmore Street",
                        "Gympie Rd at Kitchener Road",
                        "Chermside Shopping Centre interchange E",
                        "Webster Rd at Milburn Street, stop 40",
                        "Webster Rd at Chermside Markets, stop 43"
                    ],
                    "341: Taigum - City Rocket": [
                        "Taigum Shopping Centre, stop 52/57",
                        "Church Rd near Quarrion Street",
                        "Roghan Rd at Lemke Rd",
                        "Roghan Rd near Springbok Street",
                        "Carselgrove Ave near Roghan Rd",
                        "Carselgrove Ave near Carnarvon Cr",
                        "Carseldine station east",
                        "Beams Rd at Carseldine Campus",
                        "Beams Rd at Bangalore Street",
                        "Beams Rd near Tintara St",
                        "Ridley Rd near Centurion St",
                        "Ridley Rd at Ridley Road South",
                        "Graham Rd at Carseldine West near Kentia St",
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Gympie Rd at Aspley",
                        "Gympie Rd at Aspley South, stop 41",
                        "Gympie Rd at Marchant Park, stop 40",
                        "Gympie Rd at The Gardens, stop 38A",
                        "Gympie Rd at Chermside, stop 37/38",
                        "RBWH station, platform 1",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 91 near Edward St",
                        "George Street Stop 116",
                        "Turbot St stop 130 at Magistrates Court",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "Gympie Rd at Chermside, stop 38",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Gympie Rd at Marchant Park, stop 40 - CLOSED",
                        "Carseldine station east, stop 1",
                        "Roghan Rd near Lemke Rd"
                    ],
                    "344: Carseldine - City Precincts Express": [
                        "Carseldine station",
                        "Beams Rd at Carseldine Campus",
                        "Beams Rd at Bangalore Street",
                        "Beams Rd near Tintara St",
                        "Ridley Rd near Centurion St",
                        "Ridley Rd at Ridley Road South",
                        "Graham Rd at Carseldine West near Kentia St",
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Gympie Rd at Aspley",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Chermside West, stop 48/11",
                        "Maundrell Tce at John Goss Reserve, stop 47/12",
                        "Maundrell Tce at Craigslea, stop 44/15",
                        "Appleby Rd at Stafford Heights",
                        "Appleby Rd at Stafford Heights South",
                        "Wilgarning St at Mumbil St",
                        "Wilgarning St near Webster Rd",
                        "Webster Rd at Stafford, stop 30",
                        "Thomas St at Grange near Carberry St",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Kelvin Grove Rd at Normanby",
                        "Leichhardt Street Stop 165 at The Ridge",
                        "Wharf Street Stop 166 near Turbot St",
                        "Eagle Street Stop 152 at Riverside Centre",
                        "Charlotte Street Stop 52 near Edward St",
                        "George Street Stop 123 near Alice St",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St app Queen St (Stop 65)",
                        "Wharf Street Stop 162 near Ann St",
                        "Leichhardt Street Stop 164 at The Ridge",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Thomas St at Grange, stop 25/26",
                        "Wilgarning St near Canonbar St",
                        "Stafford Heights South, Appleby Road",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Craigslea, stop 44",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48"
                    ],
                    "345: Aspley - City Express via Maundrell Terrace": [
                        "Aspley Hypermarket station, platform A",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Chermside West, stop 48/11",
                        "Maundrell Tce at John Goss Reserve, stop 47/12",
                        "Maundrell Tce at Craigslea, stop 44/15",
                        "Appleby Rd at Stafford Heights",
                        "Appleby Rd at Stafford Heights South",
                        "Appleby Rd at Stafford North, stop 34a",
                        "Shand St at Sparkes Hill",
                        "Shand St at Sicklefield Rd, stop 31",
                        "South Pine Rd at Alderley, stop 26",
                        "Enoggera Rd at Banks Street, stop 22",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Queen Street station",
                        "Queen Street station, 1h",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "South Pine Rd at Alderley, stop 27",
                        "Stafford Heights South, Appleby Road",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Craigslea, stop 44",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Aspley Hypermarket"
                    ],
                    "346: Aspley - City": [
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Graham Rd at Nemira Street, stop 48",
                        "Champagne St near Marsala St, stop 60",
                        "Sauterne St near Claret St, stop 61",
                        "Riesling St near Marsala St, stop 62",
                        "Hawbridge St near Quantum St, stop 63",
                        "Graham Rd at Gympie Rd, stop 56a",
                        "Gympie Rd at Brickfield Street, stop 45/44",
                        "Gympie Rd at Aspley",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Aspley Hypermarket station, platform C",
                        "Maundrell Tce at Darwin Street, stop 50",
                        "Horn Rd at Candlebark Street, stop 50a",
                        "Horn Rd at Muneera Crescent, stop 49",
                        "Stringybark Dr near Horn Rd, stop 48",
                        "Stringybark Dr at Martindale Street, stop 47",
                        "Kenna St near Whites Rd, stop 46",
                        "Hamilton Rd at Backford Street, stop 45",
                        "Hamilton Rd at Delan Street, stop 44a",
                        "Maundrell Tce at Craigslea, stop 44/15",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Maundrell Tce at Risdon Street, stop 42",
                        "Appleby Rd at Stafford Heights",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Appleby Rd at Ringrose Street, stop 38",
                        "Appleby Rd at Stafford Heights South",
                        "Appleby Rd at Redwood Street, stop 35",
                        "Appleby Rd at Stafford North, stop 34a",
                        "Minimine St at Dunedoo Street, stop 33",
                        "Minimine St at Barokee Street, stop 32",
                        "Minimine St near Canonbar St, stop 31",
                        "Webster Rd at Stafford, stop 30",
                        "Collier St near Webster Rd, stop 30",
                        "Webster Rd at Sayers Street, stop 30",
                        "Webster Rd at Lindley Street, stop 29",
                        "Clifford St near Stafford Rd, stop 30",
                        "Stafford Rd at Webster Rd, stop 30",
                        "Webster Rd at Wulfrunian, stop 28",
                        "Grange Rd at Raymont Road, stop 27",
                        "Grange Rd at Myrtle Street, stop 26",
                        "Grange Rd at Grange - Days, stop 25b",
                        "Days Rd near Grange Rd, stop 1",
                        "Days Rd at Carroll Cr, stop 25A",
                        "Kedron Brook Rd at Antill Street, stop 25/22",
                        "Kedron Brook Rd at Olney Street, stop 21",
                        "Kedron Brook Rd at Wilston Village, stop 20",
                        "Kedron Brook Rd at York Street, stop 19",
                        "Kedron Brook Rd at Ada Street, stop 18",
                        "Newmarket Rd at Oakwal Lane, stop 16",
                        "Green Tce near Newmarket Rd, stop 15",
                        "Green Tce at Table Tennis Complex, stop 14",
                        "Northey St near Allom St, stop 12",
                        "RBWH station, platform 1",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Gotha Street Stop 231 near Wickham St",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Queen Street Stop 56 near Edward St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 212",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "RBWH station, platform 2",
                        "Northey St near Allom St",
                        "Green Tce at Downey Park, stop 13a",
                        "Kedron Brook Rd at Antill Street, stop 22/25",
                        "Days Rd at Grange - Days",
                        "Appleby Rd at Allowrie Street, stop 35",
                        "Stafford Heights South, Appleby Road",
                        "Appleby Rd at Maryland Street, stop 40",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Craigslea, stop 44",
                        "Whites St at Kenna Street, stop 46",
                        "Horn Rd at Muneera Street, stop 49",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Aspley Hypermarket station, platform D",
                        "Gympie Rd at Gayford Street, stop 44",
                        "Gympie Rd at Brickfield Street, stop 45"
                    ],
                    "347: Stafford - City via Grange": [
                        "Stafford City",
                        "Webster Rd at Sayers Street, stop 30",
                        "Webster Rd at Lindley Street, stop 29",
                        "Webster Rd at Wulfrunian, stop 28",
                        "Grange Rd at Raymont Road, stop 27",
                        "Raymont Rd at Chermside Street, stop 8A",
                        "Raymont Rd at Grange Forest Park, stop 7A",
                        "Raymont Rd at Billington Street, stop 6A",
                        "Raymont Rd at Beatson Terrace, stop 5A",
                        "Sidney St near David St, stop 4A",
                        "Progress Pde near Gawler St, stop 3A",
                        "Days Rd at Yarradale Street, stop 2A",
                        "Days Rd at Wilston Road, stop 1A",
                        "Days Rd near Grange Rd, stop 1",
                        "Days Rd at Carroll Cr, stop 25A",
                        "Days Rd at Uxbridge Street, stop 25",
                        "Days Rd at Eighth Ave, stop 24",
                        "Days Rd at Paling Ave, stop 23",
                        "Maygar St at Bank Street, stop 22",
                        "Maygar St at Anderson Street, stop 21",
                        "Maygar St at Whish Street, stop 20",
                        "Maygar St at McKenzie Street, stop 19",
                        "Roblane St at Windsor Park stop 15",
                        "Lutwyche Rd at Bowen Street, stop 14",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "Lutwyche Rd near Bryden St, stop 11",
                        "Federation Street, platform 1",
                        "RBWH station, platform 1",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Brunswick Street Stop 201 near Alfred St CLOSED",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Queen Street Stop 58 near Pedestrian Crossing",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 211",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "RBWH station, platform 2",
                        "Federation Street, platform 2",
                        "Lutwyche Rd near Taylor St, stop 11",
                        "Lutwyche Rd near Newmarket Rd, stop 12",
                        "Lutwyche Rd at Windsor Rail",
                        "Lutwyche Rd at Windsor State School, stop 15",
                        "Lutwyche Rd at Old Council Chambers, stop 16",
                        "Lutwyche Rd at Maygar Street, stop 17",
                        "Days Rd at Grange - Days",
                        "Sidney St near Beatson Tce, stop 4A",
                        "Beatson Tce near Raymont Rd, stop 5",
                        "Raymont Rd at Alderley Grove, stop 5A"
                    ],
                    "348: Stafford - City via Gordon Park": [
                        "Stafford City",
                        "Stafford Rd at Willowie Street, stop 30a",
                        "Stafford Rd at Webster Rd, stop 30",
                        "Stafford Rd at Stafford Central",
                        "Stafford Rd at Turner Road, stop 29",
                        "Richmond St near Haig St, stop 28",
                        "Richmond St at Cowper Street, stop 27",
                        "Richmond St at Lennox Street, stop 26",
                        "Richmond St at Aberdeen Terrace, stop 25A",
                        "Thistle St at Khartoum Street, stop 25",
                        "Thistle St at Gordon Street, stop 24",
                        "Thistle St at Shamrock St, stop 23",
                        "Bradshaw St near Lamington Ave, stop 22a",
                        "Lutwyche station, platform 1",
                        "Truro Street, platform 1",
                        "Roblane St at Windsor Park stop 15",
                        "Lutwyche Rd at Bowen Street, stop 14",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "Lutwyche Rd near Bryden St, stop 11",
                        "Federation Street, platform 1",
                        "RBWH station, platform 1",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Brunswick Street Stop 201 near Alfred St CLOSED",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Queen Street Stop 59 near Creek St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 211",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "RBWH station, platform 2",
                        "Federation Street, platform 2",
                        "Lutwyche Rd near Taylor St, stop 11",
                        "Lutwyche Rd near Newmarket Rd, stop 12",
                        "Lutwyche Rd at Windsor Rail",
                        "Lutwyche Rd at Windsor State School, stop 15",
                        "Lutwyche Rd at Old Council Chambers, stop 16",
                        "Truro Street, platform 2",
                        "Lutwyche station, platform 2",
                        "Bradshaw St near Lucas St, stop 22a",
                        "Richmond St at Aberdeen Terrace, stop 25a",
                        "Richmond St near Stafford Rd, stop 28",
                        "Webster Rd at Sayers Street, stop 30",
                        "Webster Rd at Lindley Street, stop 29"
                    ],
                    "349: Stafford - City Express": [
                        "Stafford City",
                        "Stafford Rd at Willowie Street, stop 30a",
                        "Stafford Rd at Webster Rd, stop 30",
                        "Stafford Rd at Stafford Central",
                        "Stafford Rd at Turner Road, stop 29",
                        "Richmond St near Haig St, stop 28",
                        "Richmond St at Cowper Street, stop 27",
                        "Richmond St at Lennox Street, stop 26",
                        "Richmond St at Aberdeen Terrace, stop 25A",
                        "Thistle St at Khartoum Street, stop 25",
                        "Thistle St at Gordon Street, stop 24",
                        "Thistle St at Shamrock St, stop 23",
                        "Bradshaw St near Lamington Ave, stop 22a",
                        "Lutwyche station, platform 1",
                        "Truro Street, platform 1",
                        "RBWH station, platform 1",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 91 near Edward St",
                        "George Street Stop 116",
                        "Turbot St stop 130 at Magistrates Court",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "Truro Street, platform 2",
                        "Lutwyche station, platform 2",
                        "Bradshaw St near Lucas St, stop 22a",
                        "Richmond St at Aberdeen Terrace, stop 25a",
                        "Richmond St near Stafford Rd, stop 28",
                        "Webster Rd at Sayers Street, stop 30",
                        "Webster Rd at Lindley Street, stop 29"
                    ],
                    "350: Aspley - City Express via Bridgeman Downs": [
                        "Albany Creek Rd opp Aspley Hypermarket",
                        "Aspley Hypermarket station, platform B",
                        "Albany Creek Rd at Aspley Bowl",
                        "Albany Creek Rd at Bangalow Street",
                        "Graham Rd at Pinnaroo",
                        "Beckett Rd at Bridgeman Downs",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Bridgeman near Althorp Rd",
                        "Beckett Rd at Paramount Chase",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Old Northern Rd at Everton Hills near Rode Rd",
                        "Old Northern Rd at Everton Park North",
                        "South Pine Rd at Everton Junction, stop 40",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at Marcellin Stop 34",
                        "Wardell St at Enoggera, stop 1/30",
                        "Wardell St at Enoggera South, stop 31",
                        "Wardell St at Dorrington near Stark St",
                        "Stewart Rd at Frasers Bridge, stop 42",
                        "Stewart Rd at Ashgrove near Devoy St",
                        "Waterworks Rd at Glenrosa Road, stop 11",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Roma Street Stop 125 at Transit Centre",
                        "Edward Street Stop 141 near Ann St",
                        "Queen Street Stop 60 near Creek St",
                        "Ann Street Stop 9 near King George Square",
                        "Roma Street busway, platform 1",
                        "Petrie Tce at Normanby Fiveways, stop 4",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Stewart Rd at Ashgrove, stop 46",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St at Enoggera near Samford Rd",
                        "Old Northern Rd at Everton Junction",
                        "Beckett Rd at McDowall North",
                        "Beckett Rd at Bridgeman near Saturn Cr",
                        "Albany Creek Rd at Pinnaroo",
                        "Keong Rd at Preston Point",
                        "Keong Rd at Leitchs Road",
                        "Wruck Cr at Albany Village",
                        "Aspley Hypermarket",
                        "Albany Creek Rd at Leitchs Road",
                        "Albany Creek Rd at Preston Point"
                    ],
                    "351: Aspley - City Rocket via Bridgeman Downs": [
                        "Albany Creek Rd opp Aspley Hypermarket",
                        "Albany Creek Rd at Aspley Bowl",
                        "Albany Creek Rd at Bangalow Street",
                        "Beckett Rd at Bridgeman Downs",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Bridgeman near Althorp Rd",
                        "Beckett Rd at Paramount Chase",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Old Northern Rd at Everton Hills near Rode Rd",
                        "Old Northern Rd at Everton Park North",
                        "South Pine Rd at Everton Junction, stop 40",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at Marcellin Stop 34",
                        "Wardell St at Enoggera, stop 1/30",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Edward Street Stop 141 near Ann St",
                        "Queen Street Stop 60 near Creek St",
                        "Ann Street Stop 9 near King George Square",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Wardell St at Enoggera near Samford Rd",
                        "Old Northern Rd at Everton Junction",
                        "Beckett Rd at McDowall North",
                        "Beckett Rd at Bridgeman near Saturn Cr",
                        "Aspley Hypermarket"
                    ],
                    "352: McDowall - City Express": [
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Voigt Street, stop 46",
                        "Brynner St at Macnee Street, stop 48",
                        "Hoffman St at Brynner St, stop 49",
                        "Hoffman St at Ifield St, stop 48",
                        "Ifield St at Brando Street, stop 47",
                        "Rode Rd near Cilento St, stop 44a",
                        "Parton St at Costello Place, stop 44",
                        "Trouts Rd at Flockton St, stop 43",
                        "Trouts Rd at Disney Street, stop 42",
                        "Trouts Rd at Redgrave Street, stop 41",
                        "Trouts Rd at Redwood St, stop 40",
                        "Trouts Rd near Castling St, stop 8",
                        "Trouts Rd near Midson St, stop 7",
                        "Stafford Rd at Mountbridge Street, stop 6",
                        "Stafford Rd at Cutbush Rd, stop 5",
                        "South Pine Rd at Marcellin Stop 34",
                        "Wardell St at Enoggera, stop 1/30",
                        "Wardell St at Enoggera South, stop 31",
                        "Wardell St at Dorrington near Stark St",
                        "Stewart Rd at Frasers Bridge, stop 42",
                        "Stewart Rd at Ashgrove near Devoy St",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Roma Street Stop 125 at Transit Centre",
                        "Edward Street Stop 141 near Ann St",
                        "Queen Street Stop 60 near Creek St",
                        "Ann Street Stop 9 near King George Square",
                        "Roma Street busway, platform 1",
                        "Petrie Tce at Normanby Fiveways, stop 4",
                        "Stewart Rd at Ashgrove, stop 46",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St at Enoggera near Samford Rd",
                        "Trouts Rd near Leach St, stop 7",
                        "Trouts Rd at Trouts - Redwood, stop 40",
                        "Trouts Rd at Flockton Street, stop 43",
                        "Rode Rd at Cilento Street, stop 44a"
                    ],
                    "353: Chermside - City via McDowall": [
                        "Chermside Shopping Centre interchange D",
                        "Hamilton Rd at Farnell Street, stop 39",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Hamilton Rd at Delan Street, stop 44a",
                        "Hamilton Rd at Backford Street, stop 45",
                        "Hamilton Rd at Trouts Rd, stop 46",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Brynner St at Macnee Street, stop 48",
                        "Hoffman St at Brynner St, stop 49",
                        "Hoffman St at Ifield St, stop 48",
                        "Ifield St at Brando Street, stop 47",
                        "Rode Rd at Trouts Road",
                        "Rode Rd near Cilento St, stop 44a",
                        "Parton St at Costello Place, stop 44",
                        "Trouts Rd at Flockton St, stop 43",
                        "Trouts Rd at Disney Street, stop 42",
                        "Trouts Rd at Redgrave Street, stop 41",
                        "Trouts Rd at Redwood St, stop 40",
                        "Armfield St at Ferricks Street, stop 39",
                        "Kidgell St near Bertram St, stop 38",
                        "Kidgell St at Boles Street, stop 37",
                        "Kidgell St at Midson Street, stop 36",
                        "Midson St at Ogden Street, stop 35",
                        "Stafford Rd at MacNaughton Street, stop 34",
                        "Stafford Rd at Shand Street, stop 33",
                        "Stafford Rd at Victor Street, stop 32",
                        "Stafford Rd at Windorah Street, stop 31",
                        "Webster Rd at Sayers Street, stop 30",
                        "Stafford Rd at Willowie Street, stop 30a",
                        "Webster Rd at Lindley Street, stop 29",
                        "Stafford Rd at Webster Rd, stop 30",
                        "Clifford St near Stafford Rd, stop 30",
                        "Webster Rd at Wulfrunian, stop 28",
                        "Grange Rd at Raymont Road, stop 27",
                        "Grange Rd at Myrtle Street, stop 26",
                        "Grange Rd at Grange - Days, stop 25b",
                        "Thomas St at Grange near Carberry St",
                        "Thomas St near Montpelier St, stop 24",
                        "Montpelier St at Inglis Street, stop 23",
                        "Montpelier St at Vale Street, stop 22",
                        "Lamont Rd at Ruth Street, stop 20",
                        "Lamont Rd at Abuklea Street, stop 19",
                        "Newmarket Rd at Wilston station, stop 18",
                        "Newmarket Rd at Granville Street, stop 17",
                        "Newmarket Rd at Oakwal Lane, stop 16",
                        "Green Tce near Newmarket Rd, stop 15",
                        "Green Tce at Table Tennis Complex, stop 14",
                        "Northey St near Allom St, stop 12",
                        "RBWH station, platform 1",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Gotha Street Stop 231 near Wickham St",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Queen Street Stop 56 near Edward St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 212",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "RBWH station, platform 2",
                        "Northey St near Allom St",
                        "Green Tce at Downey Park, stop 13a",
                        "Lamont Rd at Ruth Street, stop 20/21",
                        "Montpelier St at Thomas Street, stop 24",
                        "Thomas St at Primrose Street, stop 24a",
                        "Thomas St at Grange, stop 25/26",
                        "Stafford Rd near Windorah Street, stop 31",
                        "Stafford Rd at Cockle Street, stop 35",
                        "Armfield St at Kidgell Street, stop 38",
                        "Trouts Rd at Trouts - Redwood, stop 40",
                        "Trouts Rd at Flockton Street, stop 43",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Voigt Street, stop 46",
                        "Rode Rd at McDowall near Metro St",
                        "Beckett Rd at McDowall North",
                        "Hamilton Rd at Paramount Circuit, stop 47",
                        "Hamilton Rd at Maundrell Tce, stop 43a",
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Chermside interchange"
                    ],
                    "354: Mitchelton - Chermside": [
                        "Brookside Shopping Centre station, platform A",
                        "Griffith St at Burwood Street, stop 20/6",
                        "Griffith St at Brook Street, stop 19/5",
                        "Griffith St near South Pine Rd, stop 18/4",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at White Street, stop 38",
                        "South Pine Rd at Nitawill Street, stop 3",
                        "South Pine Rd at Pullen Road, stop 40",
                        "Old Northern Rd at Everton Junction",
                        "Dargie St at Murch Street",
                        "Felstead St at Sizer Street",
                        "Felstead St at Heflin Street",
                        "Redwood St at Lalor Street",
                        "Redwood St at Falkirk Street",
                        "Redwood St at Farrant Street",
                        "Jarvis St near Appleby Rd",
                        "Wilgarning St at Kingaroy Street, stop 3",
                        "Wilgarning St at Mumbil St",
                        "Wilgarning St near Webster Rd",
                        "Minimine St near Canonbar St, stop 31",
                        "Minimine St at Barokee Street, stop 32",
                        "Minimine St at Dunedoo Street, stop 33",
                        "Appleby Rd at Quandeine Street, stop 34",
                        "Appleby Rd at Reuben Street, stop 33",
                        "Stafford Rd at Victor Street, stop 32",
                        "Stafford Rd at Windorah Street, stop 31",
                        "Stafford Rd at Willowie Street, stop 30a",
                        "Stafford Rd at Webster Rd, stop 30",
                        "Clifford St near Stafford Rd, stop 30",
                        "Clifford St at Leiper Street, stop 31",
                        "Clifford St at Jardine Street, stop 32",
                        "Moree St at View Street, stop 42",
                        "Moree St at Dawn Street, stop 43",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Scott St near Evans St",
                        "Wattle St near Mawson St, stop 35",
                        "Mawson St near Glenhaven St, stop 34",
                        "Mawson St at Oates Street",
                        "Kitchener Rd at North Street, stop 47",
                        "Bohland St near Araluen St, stop 48",
                        "Bohland St at Allan Street, stop 49",
                        "Parkdale St near Exley St, stop 50",
                        "Parkdale St at Eltham Street, stop 51",
                        "Parkdale St at Rode Rd, stop 52/34",
                        "Main Rd at Prince Charles Hospital",
                        "Hilltop Ave near Rainey St, stop 34b",
                        "Hilltop Ave at Ethel Street, stop 34c",
                        "Hilltop Ave at Prince Charles Hospital, stop 35",
                        "Wallace St near Farnell St",
                        "Wallace St at Davenport Street, stop 35a",
                        "Kuran St at Gympie Rd",
                        "Kingsmill St near Kuran St",
                        "Kingsmill St at Miller Street",
                        "Hamilton Rd at Playfield Street, stop 37a",
                        "Chermside interchange",
                        "Chermside Shopping Centre interchange D",
                        "Kingsmill St at Playfield Street, stop 37a",
                        "Kingsmill St near Hall St",
                        "Wallace St at Kuran - Gympie, stop 36",
                        "Wallace St at Prince Charles Hospital, stop 35",
                        "Parkdale St at Parkdale - Rode, stop 52/34",
                        "Mawson St near Bayview St, stop 34",
                        "Mawson St at Wattle Street, stop 35",
                        "Scott St near Oates St",
                        "Moree St at Dawn St, stop 43",
                        "Stafford Rd near Windorah Street, stop 31",
                        "Webster Rd at Wilgarning Street, stop 31",
                        "Wilgarning St near Canonbar St",
                        "Farrant St at Jarvis Street",
                        "Redwood St at Gunn Street",
                        "Old Northern Rd at Deakin Street",
                        "South Pine Rd at Everton Junction, stop 40",
                        "South Pine Rd at Nitawill Street, stop 39",
                        "Griffith St at Everton Park, stop 4/18",
                        "Griffith St at Brook Street, stop 5/19",
                        "Griffith St at Burwood Street, stop 6/20",
                        "Brookside Shopping Centre"
                    ],
                    "357: Brendale - City Express": [
                        "Queen Elizabeth Dr at Eatonvale",
                        "Brendale St at Doonside Pde",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "Brendale St near Gowrie St",
                        "Queen Elizabeth Dr at Corso Street",
                        "Queen Elizabeth Dr at Hero",
                        "Eatons Hill at Queen Elizabeth Drive",
                        "South Pine Rd at Bunya Park",
                        "Albany Creek Rd at Hylacola",
                        "Wruck Cr at Albany Village",
                        "Old Northern Rd at Retirement Village",
                        "Old Northern Rd at Leisure Centre",
                        "Old Northern Rd at Albany Creek High",
                        "Old Northern Rd at Keong Road",
                        "Old Northern Rd at The Boulevard",
                        "Old Northern Rd at Allamanda Crescent",
                        "Old Northern Rd at Hamilton Road",
                        "Old Northern Rd at Chinook",
                        "Old Northern Rd at Everton Park North",
                        "South Pine Rd at Everton Junction, stop 40",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at Marcellin Stop 34",
                        "Wardell St at Enoggera, stop 1/30",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Edward Street Stop 141 near Ann St",
                        "Queen Street Stop 60 near Creek St",
                        "Ann Street Stop 9 near King George Square",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Wardell St at Enoggera near Samford Rd",
                        "Old Northern Rd at Everton Junction",
                        "South Pine Rd at Hylacola",
                        "Queen Elizabeth Dr at Eatons Hill",
                        "Queen Elizabeth Dr at Hero Street"
                    ],
                    "358: Strathpine - Chermside": [
                        "Queen Elizabeth Dr at Eatons Hill",
                        "Strathpine bus station, stop D",
                        "Brendale St at Doonside Pde",
                        "Queen Elizabeth Dr at Hero Street",
                        "South Pine Rd near Station St",
                        "Brendale St near Gowrie St",
                        "Queen Elizabeth Dr at Corso Street",
                        "South Pine Rd near Kremzow Rd",
                        "Karena St near Heatherlea St",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "South Pine Rd near Johnstone Rd",
                        "South Pine Rd near Deakin St",
                        "Saraband Dr near Talisman Ct",
                        "South Pine Rd near Leitchs Rd",
                        "Saraband Dr near Grenada Dr",
                        "Saraband Drive near Pascali Crescent",
                        "Eatons Hill at Queen Elizabeth Drive",
                        "South Pine Rd at Bunya Park",
                        "Albany Creek Rd at Hylacola",
                        "Albany Creek Rd near Old Northern Rd",
                        "Marylin Tce at Eatons Hill State School",
                        "Wruck Cr at Albany Village",
                        "Old Northern Rd at Retirement Village",
                        "Old Northern Rd at Leisure Centre",
                        "Old Northern Rd at Albany Creek High",
                        "Keong Rd near Hampshire Tce",
                        "Keong Rd near Dawn Rd",
                        "Aveo Albany Creek",
                        "Albany Forest Dr at Explorer",
                        "Keong Rd near Jambaroo St",
                        "Keong Rd near Essex Dr",
                        "Keong Rd near Malvern Rd",
                        "Keong Rd at Preston Point",
                        "Keong Rd at Leitchs Road",
                        "Albany Creek Rd at Albany Creek State School",
                        "Albany Creek Rd at Leitchs Road",
                        "Albany Creek Rd at Preston Point",
                        "Albany Creek Rd at Pinnaroo",
                        "Albany Creek Rd at Bangalow Street",
                        "Albany Creek Rd at Aspley Bowl",
                        "Aspley Hypermarket station, platform C",
                        "Gympie Rd at Aspley South, stop 41",
                        "Gympie Rd at Marchant Park, stop 40",
                        "Gympie Rd at The Gardens, stop 38A",
                        "Chermside interchange",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Maundrell Tce at Darwin Street, stop 50",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Chermside West, stop 48/11",
                        "Maundrell Tce at John Goss Reserve, stop 47/12",
                        "Maundrell Tce at St Gerards, stop 46",
                        "Hamilton Rd at Maundrell Tce, stop 43a",
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Farnell Street, stop 39",
                        "Chermside Shopping Centre interchange B",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Gympie Rd at Marchant Park, stop 40 - CLOSED",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Maundrell Tce at St Gerards, stop 45/46",
                        "Albany Creek Rd opp Aspley Hypermarket",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Keong Rd near Seligan St",
                        "Keong Rd near Crofty St",
                        "Keong Rd near Rafter Ave",
                        "Old Northern Rd near Albany Forest Dr",
                        "South Pine Rd at Hylacola",
                        "Brendale St near Currajon St",
                        "South Pine Rd near Hinkler Ct",
                        "South Pine Rd near Mott St"
                    ],
                    "359: Eatonvale - City Express via Albany Village": [
                        "Queen Elizabeth Dr at Eatonvale",
                        "Wruck Cr at Albany Village",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "Flamingo Dr near Chickowee St",
                        "Queen Elizabeth Dr at Corso Street",
                        "Faheys Rd West at Kingfisher",
                        "Queen Elizabeth Dr at Hero",
                        "Morgan Rd at Morgan",
                        "Albany Forest Dr at Dove",
                        "Eatons Hill at Queen Elizabeth Drive",
                        "Albany Forest Dr at Explorer",
                        "South Pine Rd at Bunya Park",
                        "Narrabeen Dr near Yellowjack Cr",
                        "Albany Creek Rd at Hylacola",
                        "Thiess Dr near Mahogany Dr",
                        "Thiess Dr at Jagora",
                        "Thiess Dr at Challinor",
                        "Jinker Track near Allamanda Cr",
                        "Old Northern Rd at The Boulevard",
                        "Old Northern Rd at Allamanda Crescent",
                        "Old Northern Rd at Hamilton Road",
                        "Old Northern Rd at Chinook",
                        "Old Northern Rd at Everton Park North",
                        "South Pine Rd at Everton Junction, stop 40",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at Marcellin Stop 34",
                        "Wardell St at Enoggera, stop 1/30",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Edward Street Stop 141 near Ann St",
                        "Queen Street Stop 60 near Creek St",
                        "Ann Street Stop 9 near King George Square",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Wardell St at Enoggera near Samford Rd",
                        "Old Northern Rd at Everton Junction",
                        "Thiess Dr at Narrabeen",
                        "Flamingo Dr near Garganey St",
                        "South Pine Rd at Hylacola",
                        "Queen Elizabeth Dr at Eatons Hill",
                        "Queen Elizabeth Dr at Hero Street"
                    ],
                    "360: Brookside - City via Everton Park": [
                        "Brookside Shopping Centre station, platform B",
                        "Osborne Rd near Northmore St, stop 52",
                        "Osborne Rd at Osborne North, stop 51",
                        "Camelia Ave at Camelia - Galeola, stop 50",
                        "Camelia Ave at Violet St, stop 49",
                        "Camelia Ave at Camelia/Nymphaea, stop 48",
                        "Camelia Ave at Mirbelia St, stop 47",
                        "South Pine Rd at Buckland Rd Stop 46",
                        "South Pine Rd at Queens Rd, stop 45",
                        "South Pine Rd at Rogers Pde W, stop 44",
                        "South Pine Rd at South Pine Bend, stop 43",
                        "South Pine Rd near Ballinderry St, stop 42",
                        "South Pine Rd at Barton West, stop 41",
                        "Barton St at Pullen Road, stop 40",
                        "South Pine Rd at Nitawill Street, stop 39",
                        "South Pine Rd at White Street, stop 38",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd Rd at South Pine North, stop 36",
                        "South Pine Rd at Southpine-Elkhorn Stop 35",
                        "South Pine Rd at Marcellin Stop 34",
                        "Enoggera interchange, platform B1",
                        "Pickering St at Pickering - Magura, stop 32",
                        "South Pine Rd at Farrington Street, stop 30",
                        "South Pine Rd at Alderley Crossing, stop 27",
                        "South Pine Rd at Alderley, stop 26",
                        "Enoggera Rd at Lloyd Street, stop 25",
                        "Enoggera Rd at Beaufort Street, stop 24",
                        "Enoggera Rd at Sedgley Park, stop 23",
                        "Enoggera Rd at Banks Street, stop 22",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "McComb St - 15",
                        "Herston Rd at Picot Street, stop 14a",
                        "Herston Rd near Ballymore St, stop 14",
                        "Scott Rd near Herston Rd, stop 13",
                        "Clyde Rd near Hunter St, stop 12a",
                        "Butterfield St at Ballymore, stop 12",
                        "Butterfield St at Butterfield Preschool, stop 11a",
                        "Butterfield St at Aberleigh Road, stop 11",
                        "Butterfield St near Bramston Tce, stop 10a",
                        "Bramston Tce at Garrick Terrace, stop 10",
                        "Bramston Tce at McLeod Street, stop 9a",
                        "Bramston Tce at Weightman Street, stop 9",
                        "Herston Rd near Bramston Tce",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Brunswick Street Stop 201 near Alfred St CLOSED",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Elizabeth Street Stop 87 near Edward St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 212",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "Butterfield St at Butterfield PreSchool, stop 11A",
                        "Lestrange Tce near Victoria Park Rd, stop 20",
                        "Herston Rd at Herston Corner, stop 15a",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "South Pine Rd at Alderley, stop 27",
                        "Pickering St at Bowling St, stop 32",
                        "Enoggera interchange, platform C",
                        "Wardell St at Enoggera near Samford Rd",
                        "South Pine Rd at South Pine North, stop 36",
                        "South Pine Rd at Nitawill Street, stop 3",
                        "South Pine Rd at Pullen Road, stop 40",
                        "Barton St at South Pine Bend, stop 42",
                        "South Pine Rd near Lily St, stop 44",
                        "Camelia Ave at Camelia - Mirbelia, stop 47",
                        "Camelia Ave at Camelia - Nymphaea, stop 48",
                        "Camelia Ave at Galeola Street, stop 50",
                        "Pullen Rd at Hornby Street, stop 51A",
                        "Brookside Shopping Centre"
                    ],
                    "361: Mitchelton - City": [
                        "Brookside Shopping Centre station, platform B",
                        "Ruby Rd near Blackwood St, stop 35",
                        "Blackwood St at Ruby St, stop 16",
                        "Blackwood St near Northmore St, stop 17",
                        "Northmore St near Pascoe St, stop 18",
                        "Glenholm St at Glenholm Corner, stop 19",
                        "Glenholm St at Glenholm Crossing, stop 20",
                        "Glenholm St near Grovely Tce, stop 21",
                        "Blackwood St at Mitchelton, stop 34",
                        "Samford Rd at Fenwick Park, stop 23",
                        "Glen Retreat Rd at Cross St",
                        "Frasers Rd near Hicks St",
                        "Frasers Rd at Irvine St",
                        "Suez St at Suez A, stop 11",
                        "Suez St near Gizerah St, stop 12",
                        "Gizerah St near Mashobra St, stop 11",
                        "Gizerah St at Mitchelton Library, stop 10",
                        "Taylors Rd at Taylors A, stop 7",
                        "Taylors Rd at Gray Rd, stop 9/7",
                        "Grays Rd near Newman St",
                        "Gaythorne Rd at Church, stop 5",
                        "Taylors Rd near Mitcham St",
                        "Pickering St at Pickering Rail",
                        "Pickering St at Pickering West",
                        "Pickering St at Tunba Street",
                        "Wardell St at Enoggera, stop 1/30",
                        "Lloyd St at Lloyd - North, stop 30",
                        "Lloyd St near Girton St, stop 29",
                        "Cole St at Cole - Lloyd, stop 28",
                        "Cole St near Elfreda St, stop 27",
                        "Bowral St at Goskar Avenue, stop 29",
                        "Bowral St near Milford St, stop 28",
                        "Banks St at Gifford Street, stop 27",
                        "Banks St near Lexington St, stop 26",
                        "Banks St at Banks Bend, stop 25",
                        "Banks St at Banks View, stop 24",
                        "Banks St at Banks - Laurence, stop 23",
                        "Banks St at Banks - School, stop 22",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "McComb St - 15",
                        "Herston Rd at Picot Street, stop 14a",
                        "Herston Rd near Ballymore St, stop 14",
                        "Scott Rd near Herston Rd, stop 13",
                        "Clyde Rd near Hunter St, stop 12a",
                        "Butterfield St at Ballymore, stop 12",
                        "Butterfield St at Butterfield Preschool, stop 11a",
                        "Butterfield St at Aberleigh Road, stop 11",
                        "Butterfield St near Bramston Tce, stop 10a",
                        "Bramston Tce at Garrick Terrace, stop 10",
                        "Bramston Tce at McLeod Street, stop 9a",
                        "Bramston Tce at Weightman Street, stop 9",
                        "Herston Rd near Bramston Tce",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Brunswick Street Stop 201 near Alfred St CLOSED",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Elizabeth Street Stop 87 near Edward St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 212",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "Butterfield St at Butterfield PreSchool, stop 11A",
                        "Herston Rd at Herston Corner, stop 15a",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "Banks St at Banks Reserve, stop 25a",
                        "Bowral St near Banks St, stop 28",
                        "Cole St near Hilda St, stop 27",
                        "Wardell St at Lloyd - Wardell, stop 30A",
                        "Wardell St at Enoggera near Samford Rd",
                        "Taylors Rd at Gray Rd, stop 7/9",
                        "Taylors Rd near Lucy St, stop 6",
                        "Suez St at Suez A, stop 11a",
                        "Frasers Rd near Lily St",
                        "Glen Retreat Rd at Glen - Hay",
                        "Samford Rd at Fenwick Park, stop 23/22",
                        "Ruby Rd near McConahgy St, stop 35",
                        "Brookside Shopping Centre"
                    ],
                    "362: Ashgrove - Brookside": [
                        "Royal Pde near Gresham St, stop 26",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Settlement Rd near Kaloma Rd",
                        "Settlement Rd near Tingward St",
                        "Great Western Shopping Centre",
                        "Mungarie St near Keryn Pl",
                        "Mungarie St at Cobalt St",
                        "Cobalt St at Balvenie St",
                        "Cobalt St at Kindilan Place",
                        "Cobalt St at Onyx St",
                        "Camoola St at Bowyer St, stop 36a",
                        "Camoola St near Avington St, stop 37",
                        "Eidsvold St near Camoola St, stop 36",
                        "Eidsvold St at Welford St, stop 35",
                        "Eidsvold St at Calen St, stop 34",
                        "Glenmorgan St near Keperra St, stop 33",
                        "Keperra St at Samford Rd",
                        "Samford Rd at Blackbutt St",
                        "Blackbutt St near Alpine St, stop 31",
                        "Blackbutt St at Keperra station, stop 30",
                        "Gilston St at Gilston Center, stop 29",
                        "Gilston St at Gilston I, stop 27A",
                        "Gilston St near Samford Rd, stop 27",
                        "Samford Rd at Samford - Dawson, stop 26",
                        "Samford Rd at Melrick St, stop 25",
                        "Samford Rd at Crestway Street, stop 24",
                        "Glen Retreat Rd near Andover St",
                        "Samford Rd at Fenwick Park, stop 23/22",
                        "Glen Retreat Rd at Cross St",
                        "Blackwood St at Mitchelton, stop 34",
                        "Frasers Rd near Hicks St",
                        "Frasers Rd at Irvine St",
                        "Ruby Rd near McConahgy St, stop 35",
                        "Suez St at Suez A, stop 11",
                        "Brookside Shopping Centre",
                        "Suez St near Gizerah St, stop 12",
                        "Suez St near Samford Rd, stop 13",
                        "Brookside Shopping Centre station, platform B",
                        "Ruby Rd near Blackwood St, stop 35",
                        "Suez St at Suez - Samford, stop 13",
                        "Samford Rd at Fenwick Park, stop 23",
                        "Suez St at Suez A, stop 11a",
                        "Samford Rd at Samford - Crestway, stop 24",
                        "Samford Rd at Samford - Melrick, stop 25",
                        "Frasers Rd near Lily St",
                        "Glen Retreat Rd at Glen - Hay",
                        "Gilston St at Gilston A, stop 28",
                        "Silvertop St at Keperra station, stop 30",
                        "Satinay St at Samford - Blackbutt",
                        "Glenmorgan St near Aramac St, stop 33",
                        "Eidsvold St at Eidsvold - Welford, stop 35",
                        "Camoola St at Camoola - Bowyer, stop 36A",
                        "Gilliat St near Camoola St, stop 36b",
                        "Cobalt St at Mungarie St",
                        "Settlement Rd at Kaloma Rd",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at Kilmaine Street, stop 29",
                        "Waterworks Rd at Greenlanes Road, stop 28/27"
                    ],
                    "363: Herston - City": [
                        "McComb St - 15",
                        "Herston Rd at Picot Street, stop 14a",
                        "Herston Rd near Ballymore St, stop 14",
                        "Scott Rd near Herston Rd, stop 13",
                        "Clyde Rd near Hunter St, stop 12a",
                        "Butterfield St at Ballymore, stop 12",
                        "Butterfield St at Butterfield Preschool, stop 11a",
                        "Butterfield St at Aberleigh Road, stop 11",
                        "Butterfield St near Bramston Tce, stop 10a",
                        "RBWH station, platform 1",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 91 near Edward St",
                        "George Street Stop 116",
                        "Turbot St stop 130 at Magistrates Court",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "Butterfield St at Butterfield PreSchool, stop 11A"
                    ],
                    "364: Herston - City": [
                        "Victoria Park Rd at QUT Victoria Park Rd",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "McComb St - 15",
                        "Herston Rd at Picot Street, stop 14a",
                        "Herston Rd near Ballymore St, stop 14",
                        "Scott Rd near Herston Rd, stop 13",
                        "Clyde Rd near Hunter St, stop 12a",
                        "Butterfield St at Ballymore, stop 12",
                        "Butterfield St at Butterfield Preschool, stop 11a",
                        "Butterfield St at Aberleigh Road, stop 11",
                        "Butterfield St near Bramston Tce, stop 10a",
                        "Bramston Tce at Garrick Terrace, stop 10",
                        "Bramston Tce at McLeod Street, stop 9a",
                        "Bramston Tce at Weightman Street, stop 9",
                        "Herston Rd near Bramston Tce",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Brunswick St at Water Street, stop 6",
                        "Brunswick Street Stop 201 near Alfred St CLOSED",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 6",
                        "Ann Street Stop 8",
                        "Elizabeth Street Stop 87 near Edward St",
                        "Queen Street Stop 66 near Adelaide St",
                        "Wickham Street Stop 226 near Gotha St",
                        "Brunswick Street Stop 212",
                        "Brunswick St at St Pauls Terrace, stop 5",
                        "Butterfield St at Butterfield PreSchool, stop 11A",
                        "Herston Rd at Herston Corner, stop 15a",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Kelvin Grove Rd at School Street, stop 13"
                    ],
                    "367: Great Western SC - Upper Kedron via Ferny Grove": [
                        "Great Western Shopping Centre",
                        "Ferny Grove station, stop D",
                        "Canvey Rd near Brockman",
                        "Archdale Rd near Ballylin St",
                        "Canvey Rd near Kingfisher Dr",
                        "Samford Rd at Cobalt St",
                        "Canvey Rd near Wagtail St",
                        "Samford Rd near Warrong St",
                        "McGinn Rd near Hogarth Rd",
                        "McAlroy Rd near McGinn Rd",
                        "Canvey Rd near Incline St",
                        "Samford Rd near Claverton St",
                        "Tramway St near Arbor St",
                        "McGregor Way at Glencoe Cl",
                        "Charolais Cr at Wyellan Pl",
                        "McGregor Way near McAlroy Rd",
                        "Charolais Cr near Kirralee Cr",
                        "McAlroy Rd at McAlroy - Upper Kedron",
                        "Cemetery Rd at Cemetery - Upper Kedron",
                        "McGinn Rd at McAlroy Rd",
                        "McGinn Rd at Archdale Rd",
                        "Archdale Rd at Coleraine St",
                        "Ferny Grove station, stop C",
                        "Samford Rd near Tramway St",
                        "Samford Rd near Cobalt St"
                    ],
                    "369: Mitchelton - Toombul via Stafford": [
                        "Mitchelton Rail station",
                        "Brookside Shopping Centre station, platform A",
                        "Griffith St at Burwood Street, stop 20/6",
                        "Griffith St near South Pine Rd, stop 18/4",
                        "Stafford Rd at Cutbush Rd, stop 5",
                        "Stafford Rd at Trouts Road, stop 7",
                        "Stafford Rd at Cockle Street, stop 35",
                        "Stafford Rd at Shand Street, stop 33",
                        "Stafford Rd at Windorah Street, stop 31",
                        "Stafford Rd at Webster Rd, stop 30",
                        "Stafford Rd at Stafford Central",
                        "Stafford Rd at Beaconsfield Terrace, stop 28a",
                        "Stafford Rd at Clarence Road, stop 27",
                        "Kedron Brook station, platform 1",
                        "Norman St near Lutwyche Rd, stop 24/25",
                        "Kedron Park Rd near Kent St, stop 26",
                        "Park Rd at Gorman Street, stop 28",
                        "Park Rd at Rose Street, stop 29",
                        "Junction Rd at Eagle Junction station, stop 28/1",
                        "Junction Rd at Stuckey Street, stop 28/2",
                        "Sandgate Rd at Eliza Street, stop 30",
                        "Toombul Interchange",
                        "Toombul Shopping Centre station, platform B",
                        "Junction Rd at Eagle Junction station, stop 28",
                        "Kedron Park Rd near Lutwyche Rd, stop 26/25",
                        "Kedron Brook Stop 3",
                        "Stafford Rd near Windorah Street, stop 31",
                        "Griffith St at Everton Park, stop 4/18",
                        "Griffith St at Burwood Street, stop 6/20",
                        "Brookside Shopping Centre station, platform C"
                    ],
                    "372: Ashgrove - City": [
                        "Ashgrove Ave at Ashgrove Marketplace",
                        "Arinya Rd near Mirrabooka Rd, stop 39",
                        "Arinya Rd near Moola Rd, stop 38",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Frasers Rd near Nimmo Rd, stop 37",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Canberra Dr near Frasers Rd, stop 36",
                        "Waterworks Rd at Girraween Grove, stop 21/22",
                        "Canberra Dr near Tweed St, stop 35",
                        "Glenlyon Dr near Marist Lane, stop 39C",
                        "Victoria St near Ashbourne St, stop 33",
                        "Grevillea Rd near Glenlyon Dr, stop 39B",
                        "Wardell St near Banks St, stop 32",
                        "Girraween Gr near Oleander Dr, stop 39A",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St near Edith St, stop 30a",
                        "Lloyd St at Lloyd - North, stop 30",
                        "Lloyd St near Girton St, stop 29",
                        "Cole St at Cole - Lloyd, stop 28",
                        "Cole St near Elfreda St, stop 27",
                        "Bowral St at Goskar Avenue, stop 29",
                        "Bowral St near Milford St, stop 28",
                        "Banks St at Gifford Street, stop 27",
                        "Banks St near Lexington St, stop 26",
                        "Banks St at Banks Bend, stop 25",
                        "Banks St at Banks View, stop 24",
                        "Banks St at Banks - Laurence, stop 23",
                        "Banks St at Banks - School, stop 22",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Kelvin Grove Rd at School Street, stop 13",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Kelvin Grove Rd at Normanby",
                        "College Rd near Kelvin Grove Rd, stop 3b",
                        "Wickham Terrace Stop 174 at Albert Park",
                        "Leichhardt St at Allenby St, stop 2",
                        "Leichhardt St at Fortescue Street - 1",
                        "Upper Edward Street Stop 140 near Wickham Tce",
                        "Edward Street Stop 141 near Ann St",
                        "Elizabeth Street Stop 87 near Edward St",
                        "Creek Street Stop 149 near Adelaide St",
                        "Upper Edward Street Stop 135 near Wickham Tce",
                        "Wickham Tce near Bradley St, stop 3",
                        "Wickham Tce near Dark St, stop 3a",
                        "College Rd near Countess St, stop 3b",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Kelvin Grove Rd at Victoria Street, stop 12",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "Banks St at Banks Reserve, stop 25a",
                        "Bowral St near Banks St, stop 28",
                        "Cole St near Hilda St, stop 27",
                        "Wardell St at Enoggera South, stop 31",
                        "Wardell St at Lloyd - Wardell, stop 30A",
                        "Enoggera interchange, platform C",
                        "Wardell St near Yates Ave, stop 32",
                        "Tweed St near Victoria St",
                        "Victoria St near Tweed St, stop 34",
                        "Moola Rd at Marist Brothers",
                        "Glenlyon Dr near Cypress Dr, stop 39c",
                        "Waterworks Rd at Myagh Road, stop 23/22",
                        "Waterworks Rd at Girraween Grove, stop 21",
                        "Waterworks Rd at Ashgrove, stop 17"
                    ],
                    "373: Ashgrove - City via Ashgrove Avenue": [
                        "Ashgrove Ave at Ashgrove Marketplace",
                        "Ashgrove Ave near Holmesbrook St, stop 26",
                        "Ashgrove Ave near Lindsay St, stop 25",
                        "Ashgrove Ave near Lovekin St, stop 24",
                        "Ashgrove Ave near Raleigh Pde, stop 23",
                        "Ashgrove Ave near Somme St, stop 21",
                        "Ashgrove Ave near Caravan Park, stop 20",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Windsor Rd near Guildford St, stop 13",
                        "Windsor Rd at Windsor - Gebbie, stop 11",
                        "Windsor Rd at Windsor - Jones, stop 10",
                        "Windsor Rd at Windsor - Prospect, stop 9",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Musgrave Rd at Normanby Hotel, stop 4",
                        "College Rd near Kelvin Grove Rd, stop 3b",
                        "Wickham Terrace Stop 174 at Albert Park",
                        "Leichhardt St at Allenby St, stop 2",
                        "Leichhardt St at Fortescue Street - 1",
                        "Upper Edward Street Stop 140 near Wickham Tce",
                        "Edward Street Stop 141 near Ann St",
                        "Elizabeth Street Stop 87 near Edward St",
                        "Creek Street Stop 149 near Adelaide St",
                        "Upper Edward Street Stop 135 near Wickham Tce",
                        "Wickham Tce near Bradley St, stop 3",
                        "Wickham Tce near Dark St, stop 3a",
                        "College Rd near Countess St, stop 3b",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Musgrave Rd at St Brigid's - Red Hill, stop 5",
                        "Windsor Rd at Red Hill, stop 8",
                        "Kelvin Grove Rd at Victoria Street, stop 12",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Windsor Rd near Errard St, stop 12",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Ashgrove Ave near Vaux St, stop 21",
                        "Ashgrove Ave near Gailey St, stop 24",
                        "Ashgrove Ave near Bott St, stop 25"
                    ],
                    "375: Bardon - City": [
                        "Carwoola St at Bardon, stop 22",
                        "Simpsons Rd at Bardon Treetops, stop 22a",
                        "Simpsons Rd at Bardon School, stop 21",
                        "Simpsons Rd at Bowman Park, stop 20",
                        "Chiswick Rd at Chiswick Road West, stop 19",
                        "Simpsons Rd at The Drive, stop 17",
                        "Simpsons Rd at Greer Street, stop 17a",
                        "Simpsons Rd at Bardon, stop 16",
                        "MacGregor Tce at Bardon, stop 15",
                        "MacGregor St at Tooth Ave, stop 14",
                        "Latrobe Tce at Perrott Street, stop 13",
                        "Latrobe Tce at Gilday Street, stop 12",
                        "Latrobe Tce at Trammies Corner, stop 11",
                        "Latrobe Tce at Paddington Central, stop 10",
                        "Latrobe Tce at Old Ithaca Fire Station, stop 9",
                        "Given Tce at Great George, stop 7",
                        "Given Tce at Paddo Tavern, stop 6",
                        "Given Tce at Paddington, stop 5",
                        "Caxton St near Chapel St, stop 4",
                        "Upper Roma St near Quay St, stop 3",
                        "Roma Street Stop 125 at Transit Centre",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 41 at Broadway",
                        "George Street Stop 118 near Turbot St",
                        "Roma Street Stop 121 at Police HQ",
                        "Roma St at Upper Roma Street, stop 3",
                        "Petrie Tce at Windmill Cafe, stop 3",
                        "Latrobe Tce at Old Paddo Post Office, stop 8",
                        "Latrobe Tce at Perrott Street , stop 13",
                        "MacGregor Tce near Tooth Ave, stop 14",
                        "Simpsons Rd at Bardon, stop 16a",
                        "Simpsons Rd at Greer Street, stop 16"
                    ],
                    "377: Ashgrove - City via Kennedy Terrace": [
                        "Ashgrove Ave at Ashgrove Marketplace",
                        "Accession Street Stop 21 near Coronation St",
                        "Accession Street Stop 20 near Empress Tce",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Kennedy Tce near Lizzie St, stop 18",
                        "Jubilee Tce at Ithaca near The Esplanade",
                        "Kennedy Tce near Sorrel St, stop 17",
                        "Coronation St near Jubilee Tce, stop 22",
                        "Kennedy Tce near Primrose Tce, stop 15/16",
                        "Kennedy Tce near Grove St, stop 14",
                        "Kennedy Tce near Thomas St, stop 13",
                        "Enoggera Tce near Otis Lane, stop 10",
                        "Latrobe Tce at Old Ithaca Fire Station, stop 9",
                        "Given Tce at Great George, stop 7",
                        "Given Tce at Paddo Tavern, stop 6",
                        "Given Tce at Paddington, stop 5",
                        "Caxton St near Chapel St, stop 4",
                        "Upper Roma St near Quay St, stop 3",
                        "Roma Street Stop 125 at Transit Centre",
                        "Turbot Street Stop 3 near Albert St",
                        "Edward Street Stop 141 near Ann St",
                        "Elizabeth Street Stop 87 near Edward St",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 9 near King George Square",
                        "George Street Stop 118 near Turbot St",
                        "Roma Street Stop 121 at Police HQ",
                        "Roma St at Upper Roma Street, stop 3",
                        "Petrie Tce at Windmill Cafe, stop 3",
                        "Latrobe Tce at Old Paddo Post Office, stop 8",
                        "Enoggera Tce near Kennedy Tce, stop 10",
                        "Kennedy Tce near Warmington St, stop 13",
                        "Kennedy Tce near Morris St, stop 13A",
                        "Kennedy Tce near Wake St, stop 14",
                        "Kennedy Tce near Brindle St, stop 17",
                        "Kennedy Tce near Jubilee Tce, stop 18",
                        "Jubilee Tce near Accession St, stop 19",
                        "Jubilee Tce at Ithaca near Fletcher Pde",
                        "Waterworks Rd at Ashgrove, stop 17"
                    ],
                    "378: Ashgrove - City via Arthur Terrace": [
                        "Ashgrove Ave at Ashgrove Marketplace",
                        "Dawn St near Kamber St, stop 30",
                        "Coopers Camp Rd at Coopers Camp Road, stop 29",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Coopers Camp Rd near Callum Lane, stop 28",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Coopers Camp Rd near Cecil Rd, stop 27",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Waterworks Rd at Girraween Grove, stop 21/22",
                        "Lewin St near Empress Tce, stop 25",
                        "Lewin St near Coronation St, stop 24",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Lewin St near Coronation St, stop 23/22",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Glory St at West Ashgrove, stop 24",
                        "Fletcher Pde near Leslie St, stop 21",
                        "Coopers Camp Rd near Jaloon St, stop 36A",
                        "Davies Rd near View Pde, stop 35",
                        "Leslie St near Glenda St, stop 20/19",
                        "Davies Rd near Barnett Rd, stop 34",
                        "Leslie St near Jubilee Tce, stop 18",
                        "Davies Rd near Coolibah St, stop 33",
                        "Arthur Tce near Lugg St, stop 17",
                        "Stephenson St near Bowman Pde, stop 32",
                        "Arthur Tce near Jason St, stop 16",
                        "Arthur Tce near Dean St, stop 15A",
                        "Dawn St near Moonya St, stop 31",
                        "Arthur Tce near Fairfax St, stop 15",
                        "Arthur Tce near Vowles St, stop 14",
                        "Arthur Tce near Fred St, stop 13",
                        "Arthur Tce near Glassey St, stop 12",
                        "Enoggera Tce near Jay St, stop 11",
                        "Cochrane St near Nott St, stop 8",
                        "Cochrane St near Carlyle St, stop 7B",
                        "Lower Cairns Tce at Hayward St, stop 7A",
                        "Hayward St near Charlotte St, stop 7",
                        "Charlotte St near Martha St, stop 6A",
                        "Charlotte St near Princess St, stop 6",
                        "Dowse St near Charlotte St, stop 5",
                        "Caxton St near Chapel St, stop 4",
                        "Upper Roma St near Quay St, stop 3",
                        "Roma Street Stop 125 at Transit Centre",
                        "Turbot Street Stop 3 near Albert St",
                        "Edward Street Stop 141 near Ann St",
                        "Elizabeth Street Stop 87 near Edward St",
                        "Creek Street Stop 149 near Adelaide St",
                        "Ann Street Stop 9 near King George Square",
                        "George Street Stop 118 near Turbot St",
                        "Roma Street Stop 121 at Police HQ",
                        "Roma St at Upper Roma Street, stop 3",
                        "Petrie Tce at Windmill Cafe, stop 3",
                        "Charlotte St near Martha St, stop 6a",
                        "Hayward St near Plunkett St, stop 7",
                        "Cochrane St near Broadway St, stop 8",
                        "Waterworks Rd at Mannion Street, stop 9",
                        "Arthur Tce near Mornington St, stop 12",
                        "Arthur Tce near Kent St, stop 13",
                        "Arthur Tce near Primrose Tce, stop 15A",
                        "Arthur Tce near Dacca St, stop 16",
                        "Leslie St near Glenda St, stop 19/20",
                        "Fletcher Pde near Beatrice St, stop 21",
                        "Lewin St near Coronation St, stop 23",
                        "Dawn St near Sunrise St, stop 30",
                        "Davies Rd near Coolibah St, stop 34",
                        "Coopers Camp Rd at West Ashgrove",
                        "Waterworks Rd at Myagh Road, stop 23/22",
                        "Waterworks Rd at Girraween Grove, stop 21",
                        "Waterworks Rd at Ashgrove, stop 17"
                    ],
                    "379: Ashgrove - City": [
                        "Royal Pde near Gresham St, stop 26",
                        "Gresham St near Royal Pde, stop 25a",
                        "Piddington St near Laird St, stop 25b",
                        "Laird St near Buckingham St, stop 25c",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Glory St at West Ashgrove, stop 24",
                        "Waterworks Rd at Myagh Road, stop 23/22",
                        "Waterworks Rd at Girraween Grove, stop 21",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Waterworks Rd at Ashgrove, stop 17",
                        "Waterworks Rd at St Finbarr's - Ashgrove, stop 16",
                        "Waterworks Rd at Woodland Street, stop 15",
                        "Waterworks Rd at Boon Street, stop 14",
                        "Waterworks Rd at Mossvale Street, stop 13",
                        "Waterworks Rd at Whitta Street, stop 12",
                        "Waterworks Rd at Glenrosa Road, stop 11",
                        "Waterworks Rd at Cairns Street, stop 10",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Musgrave Rd at Normanby Hotel, stop 4",
                        "Countess St at Normanby Fiveways",
                        "Roma Street Stop 125 at Transit Centre",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Ann Street Stop 220 at All Hallows",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 41 at Broadway",
                        "George Street Stop 118 near Turbot St",
                        "Roma Street Stop 121 at Police HQ",
                        "Roma St at Upper Roma Street, stop 3",
                        "Petrie Tce near Menzies St, stop 3A",
                        "Petrie Tce near Wellington St, stop 3b",
                        "Petrie Tce at Normanby Fiveways, stop 4",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Musgrave Rd at St Brigid's - Red Hill, stop 5",
                        "Waterworks Rd at Mannion Street, stop 9",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Waterworks Rd at Girraween Grove, stop 21/22",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Waterworks Rd at West Ashgrove, stop 24"
                    ],
                    "380: The Gap - City via Hilder Road": [
                        "Waterworks Rd at Hilder Road, stop 46",
                        "Waterworks Rd at Petmar St, stop 45",
                        "Petmar St at Petmar Street South, stop 44",
                        "Petmar St at Petmar Street North, stop 43",
                        "Hilder Rd at Wittonga Park, stop 42",
                        "Kaloma Rd at Hilder Rd, stop 41",
                        "Kaloma Rd at Hilder Road School, stop 40",
                        "Kaloma Rd at Woorama Rd, stop 39",
                        "Kaloma Rd at Harward St, stop 38",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Kilmaine Street, stop 29",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Glory St at West Ashgrove, stop 24",
                        "Waterworks Rd at Myagh Road, stop 23/22",
                        "Waterworks Rd at Girraween Grove, stop 21",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Waterworks Rd at Ashgrove, stop 17",
                        "Waterworks Rd at St Finbarr's - Ashgrove, stop 16",
                        "Waterworks Rd at Woodland Street, stop 15",
                        "Waterworks Rd at Boon Street, stop 14",
                        "Waterworks Rd at Mossvale Street, stop 13",
                        "Waterworks Rd at Whitta Street, stop 12",
                        "Waterworks Rd at Glenrosa Road, stop 11",
                        "Waterworks Rd at Cairns Street, stop 10",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Musgrave Rd at Normanby Hotel, stop 4",
                        "Countess St at Normanby Fiveways",
                        "Roma Street Stop 125 at Transit Centre",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Ann Street Stop 219 at All Hallows",
                        "Adelaide Street Stop 35 near Creek St",
                        "Adelaide Street Stop 41 at Broadway",
                        "George Street Stop 118 near Turbot St",
                        "Roma Street Stop 121 at Police HQ",
                        "Roma St at Upper Roma Street, stop 3",
                        "Petrie Tce near Menzies St, stop 3A",
                        "Petrie Tce near Wellington St, stop 3b",
                        "Petrie Tce at Normanby Fiveways, stop 4",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Musgrave Rd at St Brigid's - Red Hill, stop 5",
                        "Waterworks Rd at Mannion Street, stop 9",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Waterworks Rd at Girraween Grove, stop 21/22",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Kaloma Rd at Kaloma - Harward, stop 38",
                        "Hilder Rd at Kaloma - Hilder, stop 41",
                        "Waterworks Rd at Hilder Rd, stop 46",
                        "School Rd at Bogunda St, stop 45",
                        "School Rd at Woongarra St, stop 44",
                        "Payne Rd at Glen Rd, stop 44a",
                        "Payne Rd at Kays Rd, stop 44b",
                        "Payne Rd at Dillon Rd, stop 44c",
                        "Payne Rd at Glen Rd, stop 44d",
                        "Payne Rd at Payne - DAguilar, stop 43",
                        "Payne Rd at Gymea St, stop 42",
                        "Payne Rd at Whitehead Rd, stop 41",
                        "Whitehead Rd near Fairearth St, stop 40",
                        "Pindari St near Palana St, stop 39",
                        "Devonhill St near Paraka St, stop 38",
                        "Devonhill St at Koorong St, stop 37",
                        "Bombala St at Glenbrae Street, stop 36",
                        "Grenoble St at Woodside St, stop 35",
                        "Grenoble St at Paten Rd, stop 34",
                        "Paten Rd at Paten Park, stop 33a",
                        "Payne Rd at Paten Rd, stop 33",
                        "Payne Rd at Glenmore St, stop 32"
                    ],
                    "381: The Gap - City via Payne Road": [
                        "Waterworks Rd at Hilder Rd, stop 46",
                        "Waterworks Rd at Payne Road, stop 31",
                        "School Rd at Bogunda St, stop 45",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "School Rd at Woongarra St, stop 44",
                        "Payne Rd at Glen Rd, stop 44a",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Payne Rd at Kays Rd, stop 44b",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Payne Rd at Dillon Rd, stop 44c",
                        "Payne Rd at Glen Rd, stop 44d",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Kaloma Rd at Kaloma - Harward, stop 38",
                        "Payne Rd at Payne - DAguilar, stop 43",
                        "Kaloma Rd at Woorama Rd, stop 39",
                        "Payne Rd at Gymea St, stop 42",
                        "Kaloma Rd at Hilder Road School, stop 40",
                        "Payne Rd at Whitehead Rd, stop 41",
                        "Hilder Rd at Kaloma - Hilder, stop 41",
                        "Whitehead Rd near Fairearth St, stop 40",
                        "Hilder Rd at Wittonga Park, stop 42",
                        "Pindari St near Palana St, stop 39",
                        "Petmar St at Petmar Street North, stop 43",
                        "Devonhill St near Paraka St, stop 38",
                        "Petmar St at Petmar Street South, stop 44",
                        "Devonhill St at Koorong St, stop 37",
                        "Waterworks Rd at Petmar St, stop 45",
                        "Bombala St at Glenbrae Street, stop 36",
                        "Grenoble St at Woodside St, stop 35",
                        "Grenoble St at Paten Rd, stop 34",
                        "Paten Rd at Paten Park, stop 33a",
                        "Payne Rd at Paten Rd, stop 33",
                        "Payne Rd at Glenmore St, stop 32",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Kilmaine Street, stop 29",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Glory St at West Ashgrove, stop 24",
                        "Waterworks Rd at Myagh Road, stop 23/22",
                        "Waterworks Rd at Girraween Grove, stop 21",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Waterworks Rd at Ashgrove, stop 17",
                        "Waterworks Rd at St Finbarr's - Ashgrove, stop 16",
                        "Waterworks Rd at Woodland Street, stop 15",
                        "Waterworks Rd at Boon Street, stop 14",
                        "Waterworks Rd at Mossvale Street, stop 13",
                        "Waterworks Rd at Whitta Street, stop 12",
                        "Waterworks Rd at Glenrosa Road, stop 11",
                        "Waterworks Rd at Cairns Street, stop 10",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Musgrave Rd at Normanby Hotel, stop 4",
                        "Countess St at Normanby Fiveways",
                        "Roma Street Stop 125 at Transit Centre",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 23 near David Jones",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Gregory Tce at St Josephs, stop 7",
                        "Adelaide Street Stop 35 near Creek St",
                        "Brunswick St at Water Street, stop 6",
                        "Brunswick Street Stop 201 near Alfred St CLOSED",
                        "Adelaide Street Stop 41 at Broadway",
                        "George Street Stop 118 near Turbot St",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Roma Street Stop 121 at Police HQ",
                        "Ann Street Stop 219 at All Hallows",
                        "Roma St at Upper Roma Street, stop 3",
                        "Petrie Tce near Menzies St, stop 3A",
                        "Petrie Tce near Wellington St, stop 3b",
                        "Petrie Tce at Normanby Fiveways, stop 4",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Musgrave Rd at St Brigid's - Red Hill, stop 5",
                        "Waterworks Rd at Mannion Street, stop 9",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Waterworks Rd at Girraween Grove, stop 21/22",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Payne Rd at Payne - Glenmore, stop 32",
                        "Grenoble St at Grenoble - Woodside, stop 35",
                        "Glenbrae St near Bombala St, stop 36",
                        "Koorong St at Devonhill St, stop 37",
                        "Payne Rd at Payne - Gymea, stop 42",
                        "Waterworks Rd at Hilder Road, stop 46",
                        "Kaloma Rd at Hilder Rd, stop 41",
                        "Kaloma Rd at Harward St, stop 38",
                        "Waterworks Rd at Settlement Road, stop 36"
                    ],
                    "382: The Gap - City Rocket via Settlement Road": [
                        "Waterworks Rd at Hilder Road, stop 46",
                        "Petmar St at Petmar Street South, stop 44",
                        "Petmar St at Petmar Street North, stop 43",
                        "Hilder Rd at Wittonga Park, stop 42",
                        "Kaloma Rd at Hilder Road School, stop 40",
                        "Kaloma Rd at Harward St, stop 38",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Coopers Camp Rd at West Ashgrove, stop 24",
                        "Coopers Camp Rd at Coopers Camp Road, stop 29",
                        "MacGregor Tce at Bardon, stop 15",
                        "Given Tce at Paddington, stop 5",
                        "Roma Street Stop 125 at Transit Centre",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "George Street Stop 118 near Turbot St",
                        "Roma Street Stop 121 at Police HQ",
                        "Coopers Camp Rd at West Ashgrove",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Kaloma Rd at Woorama Rd, stop 39",
                        "Waterworks Rd at Hilder Rd, stop 46"
                    ],
                    "383: The Gap - City Rocket via Payne Road": [
                        "School Rd at Woongarra St, stop 44",
                        "Payne Rd at Glen Rd, stop 44a",
                        "Payne Rd at Kays Rd, stop 44b",
                        "Payne Rd at Dillon Rd, stop 44c",
                        "Payne Rd at Glen Rd, stop 44d",
                        "Payne Rd at Gymea St, stop 42",
                        "Payne Rd at Paten Rd, stop 33",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Coopers Camp Rd at West Ashgrove, stop 24",
                        "Coopers Camp Rd at Coopers Camp Road, stop 29",
                        "MacGregor Tce at Bardon, stop 15",
                        "Given Tce at Paddington, stop 5",
                        "Roma Street Stop 125 at Transit Centre",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "George Street Stop 118 near Turbot St",
                        "Roma Street Stop 121 at Police HQ",
                        "Coopers Camp Rd at West Ashgrove",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Payne Rd at Payne - Gymea, stop 42"
                    ],
                    "384: The Gap - City Precincts Rocket": [
                        "The Gap park 'n' ride",
                        "Waterworks Rd at Parkdale near Petmar St",
                        "Waterworks Rd at Hilder Rd, stop 46",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Glory St at West Ashgrove, stop 24",
                        "Waterworks Rd at Ashgrove, stop 17",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Musgrave Rd at Normanby Hotel, stop 4",
                        "Leichhardt Street Stop 165 at The Ridge",
                        "Wharf Street Stop 166 near Turbot St",
                        "Eagle Street Stop 152 at Riverside Centre",
                        "Charlotte Street Stop 52 near Edward St",
                        "George Street Stop 123 near Alice St",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St app Queen St (Stop 65)",
                        "Wharf Street Stop 162 near Ann St",
                        "Leichhardt Street Stop 164 at The Ridge",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Waterworks Rd at Hilder Road, stop 46"
                    ],
                    "385: The Gap - City Express": [
                        "The Gap park 'n' ride",
                        "Waterworks Rd at Parkdale near Petmar St",
                        "Waterworks Rd at Hilder Rd, stop 46",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Coopers Camp Rd at West Ashgrove, stop 24",
                        "Coopers Camp Rd at Coopers Camp Road, stop 29",
                        "MacGregor Tce at Bardon, stop 15",
                        "Roma Street busway, platform 2",
                        "Latrobe Tce at Paddington Central, stop 10",
                        "Given Tce at Paddington, stop 5",
                        "Queen Street station",
                        "Queen Street station, 1g",
                        "Roma Street busway, platform 1",
                        "Coopers Camp Rd at West Ashgrove",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Waterworks Rd at Hilder Road, stop 46"
                    ],
                    "390: Mitchelton - City": [
                        "Enoggera Rd at Newmarket, stop 20",
                        "Brookside Shopping Centre station, platform B",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Ruby Rd near Blackwood St, stop 35",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Blackwood St at Mitchelton, stop 34",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Samford Rd at Gaythorne RSL, stop 33",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Samford Rd at Gaythorne station, stop 32",
                        "Samford Rd at Norman Terrace, stop 31",
                        "Kelvin Grove Rd at School Street, stop 13",
                        "Samford Rd at Wardell Street, stop 30",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Samford Rd at Bond Street, stop 29",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Samford Rd at Camborne Street, stop 28",
                        "Ann Street Stop 12 at City Hall",
                        "Samford Rd at Musgrave Terrace, stop 27",
                        "Adelaide Street Stop 22 near City Hall",
                        "Samford Rd at Alderley Junction, stop 26",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Enoggera Rd at Lloyd Street, stop 25",
                        "Enoggera Rd at Beaufort Street, stop 24",
                        "Queen Street Stop 74 near Creek St",
                        "Enoggera Rd at Sedgley Park, stop 23",
                        "Enoggera Rd at Banks Street, stop 22",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Ann Street Stop 9 near King George Square",
                        "Roma Street busway, platform 1",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "College Rd near Countess St, stop 3b",
                        "Normanby station, platform 2",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Kelvin Grove Rd at Normanby, stop 11",
                        "Kelvin Grove Rd at Victoria Street, stop 12",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "Enoggera interchange, platform B1",
                        "Ruby Rd near McConahgy St, stop 35",
                        "Brookside Shopping Centre"
                    ],
                    "396: Mitchelton - Arana Hills": [
                        "Collins Rd near Hawkes Ave",
                        "Collins Rd at Hillenvale, stop 1",
                        "Collins Rd at Hillenvale, stop 2",
                        "Bunya Rd at Blackwood",
                        "Bunya Rd near Arlington Dr",
                        "Bunya Rd at Francis Road",
                        "South Pine Rd at Plucks Rd",
                        "South Pine Rd near Henderson Rd",
                        "South Pine Rd near Pimelea St",
                        "Camelia Ave at Camelia - Mirbelia, stop 47",
                        "Camelia Ave at Camelia - Nymphaea, stop 48",
                        "Camelia Ave at Violet St, stop 49",
                        "Camelia Ave at Galeola Street, stop 50",
                        "Pullen Rd at Hornby Street, stop 51A",
                        "Osborne Rd at Osborne North, stop 51",
                        "Osborne Rd near Northmore St, stop 52",
                        "Brookside Shopping Centre station, platform C",
                        "Mitchelton Rail station",
                        "Brookside Shopping Centre station, platform B",
                        "Camelia Ave at Camelia - Galeola, stop 50",
                        "Camelia Ave at Camelia/Nymphaea, stop 48",
                        "Camelia Ave at Mirbelia St, stop 47",
                        "South Pine Rd near Basand St",
                        "South Pine Rd near Plucks Rd"
                    ],
                    "397: Ferny Grove - Mitchelton": [
                        "Ferny Grove station, stop B (Temporary)",
                        "Ferny Grove High School",
                        "Gordon Rd near Owarra Ave",
                        "Ferny Grove Primary School",
                        "Ferny Grove station, stop C",
                        "Gordon Rd near Andina Cr",
                        "Tarnook Dr at Barber Rd",
                        "England Rd near Pylara Cr",
                        "Tarnook Dr at Ukamirra Ct",
                        "Hutton Rd at Yalamba Ct",
                        "Patricks Rd at Patricks Road State School",
                        "Hutton Rd near Yingally Dr",
                        "Patricks Rd near Quinnia Ct",
                        "View Cr near Plucks Rd",
                        "View Cr near Eveleigh St",
                        "View Cr near Floyd Ct",
                        "Bunya Rd near Arlington Dr",
                        "Bunya Rd at Francis Road",
                        "South Pine Rd at Plucks Rd",
                        "Plucks Rd near South Pine Rd",
                        "Plucks Rd near Tetragona Dr",
                        "Yanderra Ave near Onslow St",
                        "Bringelly St at Onslow St",
                        "Bringelly St near Narellan St",
                        "Patricks Rd at Nepean Ave",
                        "Pimelea St near Hobbs St",
                        "Pimelea St near Capsella St",
                        "Camelia Ave at Camelia - Mirbelia, stop 47",
                        "Camelia Ave at Camelia - Nymphaea, stop 48",
                        "Camelia Ave at Violet St, stop 49",
                        "Camelia Ave at Galeola Street, stop 50",
                        "Pullen Rd at Hornby Street, stop 51A",
                        "Osborne Rd at Osborne North, stop 51",
                        "Osborne Rd near Northmore St, stop 52",
                        "Brookside Shopping Centre station, platform C",
                        "Mitchelton Rail station",
                        "Brookside Shopping Centre station, platform B",
                        "Camelia Ave at Camelia - Galeola, stop 50",
                        "Camelia Ave at Camelia/Nymphaea, stop 48",
                        "Hutton Rd at Yalamba Court",
                        "Tarnook Dr near Ukamirra Ct",
                        "Camelia Ave at Mirbelia St, stop 47",
                        "Pimelea St near Olearia St West",
                        "Patricks Rd at Arana Hills K Mart",
                        "Gordon Rd near Anora Cr",
                        "Plucks Rd near Barney St",
                        "South Pine Rd near Plucks Rd",
                        "Bunya Rd near South Pine Rd",
                        "McGinn Rd near Hogarth Rd",
                        "McAlroy Rd near McGinn Rd",
                        "McAlroy Rd at McAlroy - Upper Kedron",
                        "Hogarth Rd District Stop"
                    ],
                    "398: Mitchelton - Ferny Grove": [
                        "Ferny Grove station, stop B (Temporary)",
                        "Ferny Grove High School",
                        "Ferny Way near Monaro Cr",
                        "Ferny Grove Primary School",
                        "Ferny Way near Langura Cr",
                        "Archdale Rd at Coleraine St",
                        "Illuta Ave near Langura Cr",
                        "Ferny Grove station, stop C",
                        "Kolora Cr near Joalah Cr",
                        "Kolora Cr near Ilga Gr",
                        "Dinterra Ave near Dunbil Ave",
                        "Dinterra Ave near Derrima Cr",
                        "Bunora Ave near Bundar Cr",
                        "Patricks Rd near Bunora Ave",
                        "Patricks Rd near Ferny Way",
                        "Patricks Rd near Cycas St",
                        "Patricks Rd near Leslie St",
                        "Patricks Rd at Nepean Ave",
                        "Dawson Pde at Leagues Club",
                        "Dawson Pde near Madsen St",
                        "Dawson Pde at Grovely station",
                        "Dawson Pde near Link Rd",
                        "Dawson Pde near Crampton St",
                        "Samford Rd at Samford - Dawson, stop 26",
                        "Samford Rd at Melrick St, stop 25",
                        "Samford Rd at Crestway Street, stop 24",
                        "Samford Rd at Fenwick Park, stop 23/22",
                        "Blackwood St at Mitchelton, stop 34",
                        "Ruby Rd near McConahgy St, stop 35",
                        "Brookside Shopping Centre station, platform B",
                        "Mitchelton Rail station",
                        "Patricks Rd at Arana Hills K Mart",
                        "Patricks Rd near Bargo St",
                        "Ruby Rd near Blackwood St, stop 35",
                        "Samford Rd at Fenwick Park, stop 23",
                        "Patricks Rd near Wingara Gr",
                        "Bunora Ave near Coolibah Cr",
                        "Samford Rd at Samford - Crestway, stop 24",
                        "Dinterra Ave near Irruka Cr",
                        "Samford Rd at Samford - Melrick, stop 25",
                        "Dawson Pde at Crampton St",
                        "Kolora Cr near Kootangal Cr",
                        "Joalah Cr near Kolora Cr",
                        "Langura Cr near Lurneah Cr",
                        "Dawson Pde near Casey St",
                        "McGinn Rd near Hogarth Rd",
                        "McAlroy Rd near McGinn Rd",
                        "McAlroy Rd at McAlroy - Upper Kedron",
                        "Hogarth Rd District Stop"
                    ],
                    "399: Samford - Ferny Grove Station (Hail & Ride)": [
                        "Ferny Grove station, stop B (Temporary)",
                        "Mt Glorious Rd near Mt OReilly Rd hail 'n' ride",
                        "Samford Rd at Camp Mountain Road",
                        "Mt Glorious Rd near Parkwood Dr hail 'n' ride",
                        "Mount Glorious Rd near Mary Ring Dr",
                        "Mt Glorious Rd near Hulcombe Rd hail 'n' ride",
                        "Showgrounds Dr near Norwood Ct hail 'n' ride",
                        "Mt Glorious Rd near Greggs Rd hail 'n' ride",
                        "Westwood Dr near Showgrounds Dr hail 'n' ride",
                        "Westwood Dr near Stavewood Ct hail 'n' ride",
                        "Westwood Dr near Woodville Ct hail 'n' ride",
                        "Mt OReilly Rd near Cosgrove Rd hail 'n' ride",
                        "Mt OReilly Rd near Brushwood Rd hail 'n' ride",
                        "Mt Glorious Rd near Navillus Pde hail 'n' ride",
                        "Samford Rd near Camp Mountain Rd"
                    ],
                    "402: Toowong - University of Qld": [
                        "UQ Chancellor's Place, zone D",
                        "Carmody Rd near Boomerang Rd, stop 24",
                        "Coldridge St near Carmody Rd, stop 23a",
                        "Coldridge St at Field Street, stop 23",
                        "Sir Fred Schonell Dr at St Lucia Ferry, stop 21",
                        "Sir Fred Schonell Dr at St Lucia West, stop 19",
                        "Sir Fred Schonell Dr at Gailey Road, stop 17",
                        "Gailey Rd at Brisbane Street, stop 16",
                        "Benson St at Toowong, stop 14",
                        "Brisbane St at Kayes Rocks, stop 15",
                        "University of Queensland"
                    ],
                    "40: City Loop (Clockwise)": [
                        "Alice St Stop 99 at Albert St",
                        "George Street Stop 114 near Alice St",
                        "George Street Stop 115 near Charlotte St",
                        "George Street Stop 116",
                        "Adelaide Street Stop 20 at City Hall",
                        "Adelaide Street Stop 26 at Anzac Square",
                        "Wharf Street Stop 168 near Adelaide St",
                        "Eagle Street Stop 152 at Riverside Centre",
                        "Edward Street Stop 146 at Stamford Plaza"
                    ],
                    "411: University of Qld - City via Hawken Drive": [
                        "UQ Chancellor's Place, zone C",
                        "Hawken Dr at Picardy Street, stop 31",
                        "Hawken Dr at Hawken Villiage, stop 30",
                        "Hawken Dr near Highland Tce, stop 29",
                        "Hawken Dr at Highland Terrace, stop 28",
                        "Hawken Dr at Tarcoola Street, stop 27",
                        "Hawken Dr at Tenth Avenue, stop 26",
                        "Roundabout at Hawken Shops, stop 25",
                        "Hawken Dr at Ironside School, stop 23/24",
                        "Swann Rd at Hutton Lane, stop 21",
                        "Swann Rd at Bonvale Lane, stop 21",
                        "Gailey Rd at Gailey Fiveways, stop 20",
                        "Gailey Rd at Gailey North, stop 19",
                        "Gailey Rd at Gailey Park, stop 18",
                        "Gailey Rd at Gailey - SFSD, stop 17",
                        "Gailey Rd at Brisbane Street, stop 16",
                        "Benson St at Toowong, stop 14",
                        "Coronation Dr at Regatta, stop 12",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Chasely Street, stop 8",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Park Road, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Gregory Tce at St Josephs, stop 7",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Gregory Tce near Hill St, stop 8",
                        "Coronation Dr at Regatta",
                        "Brisbane St at Kayes Rocks, stop 15",
                        "Swann Rd at Hutton Lane, stop 22",
                        "Swann Rd at Ironside School, stop 23/24",
                        "Hawken Dr at Hawken Shops, stop 25",
                        "University of Queensland"
                    ],
                    "412: University of Qld - City Express": [
                        "Boomerang Rd W at St Lucia South near Hawken Dr",
                        "UQ Chancellor's Place, zone D",
                        "Coldridge St near Carmody Rd, stop 23a",
                        "Coldridge St at Field Street, stop 23",
                        "Sir Fred Schonell Dr at St Lucia Ferry, stop 21",
                        "Sir Fred Schonell Dr at St Lucia West, stop 19",
                        "Sir Fred Schonell Dr at Gailey Road, stop 17",
                        "Benson St at Toowong, stop 14",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "Roma Street Stop 125 at Transit Centre",
                        "Roma Street Stop 138 near Ann St",
                        "Coronation Dr at Cribb Street, stop 4",
                        "UQ Chancellor's Place, zone E"
                    ],
                    "414: Indooroopilly - University of Qld via Taringa": [
                        "Oxford Tce near Lucinda St, stop 16/22",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Disraeli St near Stanley St, stop 27",
                        "Westerham St at Sundridge Street, stop 23",
                        "Westerham St near Indooroopilly Rd, stop 22",
                        "Disraeli St at Gordon Terrace, stop 28",
                        "Indooroopilly Rd at Jack Cook Park, stop 18/19",
                        "Waverley Rd at Taringa Parade, stop 27",
                        "Waverley Rd near Hillsdon Rd, stop 26",
                        "Gailey Rd at Gailey Park, stop 18",
                        "Hillsdon Rd at Hillsdon Shops, stop 25",
                        "Gailey Rd at Gailey North, stop 19",
                        "Hillsdon Rd near Stanley Tce, stop 24",
                        "Swann Rd at Bonvale Lane, stop 21",
                        "Stanley Tce at Gower Street, stop 23",
                        "Swann Rd at Hutton Lane, stop 22",
                        "Carmody Rd near Raven St, stop 21",
                        "Stanley Tce at Camp Street, stop 22",
                        "Carmody Rd at Munro Street, stop 22",
                        "Stanley Tce at Bywong Street, stop 21",
                        "Walker St at Frederick Street, stop 18",
                        "University of Queensland",
                        "UQ Chancellor's Place, zone C",
                        "Carmody Rd near Boomerang Rd, stop 24",
                        "Carmody Rd near Baty St, stop 21",
                        "Swann Rd at Hutton Lane, stop 21",
                        "Gailey Rd at Gailey Fiveways, stop 20",
                        "Oxford Tce near Lucinda St, stop 22/16",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Hillsdon Rd near Gregory St, stop 24a",
                        "Indooroopilly interchange"
                    ],
                    "415: Indooroopilly - City via Taringa": [
                        "Lambert Rd - 26",
                        "Manchester Tce near Waverley Rd, stop 24",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Lambert Rd near Martin Lane, stop 27/36",
                        "Payne St near Nelson Pde, stop 25",
                        "Moggill Rd at Payne Street, stop 20",
                        "Lambert Rd at Central Ave, stop 35",
                        "Stanley St near Payne St, stop 26",
                        "Central Ave at Forest Lodge, stop 34",
                        "Disraeli St near Stanley St, stop 27",
                        "Central Ave at Holy Family, stop 33",
                        "Disraeli St at Gordon Terrace, stop 28",
                        "York St near Prince St, stop 29",
                        "Waverley Rd near Taringa Pde, stop 29",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Coverdale St near Waverley Rd, stop 30",
                        "Coverdale Terminus, stop 31",
                        "Waverley Rd at Taringa Parade, stop 27",
                        "Waverley Rd near Hillsdon Rd, stop 26",
                        "Hillsdon Rd at Hillsdon Shops, stop 25",
                        "Hillsdon Rd near Stanley Tce, stop 24",
                        "Stanley Tce at Gower Street, stop 23",
                        "Stanley Tce at Camp Street, stop 22",
                        "Stanley Tce at Bywong Street, stop 21",
                        "Stanley Tce at Moorak Street, stop 20",
                        "Stanley Tce at Mossman Street, stop 19",
                        "Stanley Tce at Harrys Road, stop 18",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Regatta, stop 12",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Chasely Street, stop 8",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Park Road, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Coronation Dr at Regatta",
                        "High St at Toowong, stop 14A",
                        "Hillsdon Rd near Gregory St, stop 24a",
                        "Payne St near Woolley St, stop 25",
                        "Rokeby Tce near Moggill Rd, stop 23",
                        "Indooroopilly interchange"
                    ],
                    "416: Duke Street - City": [
                        "Market St near Duke St, stop 28",
                        "Orchard St at Lower Orchard St, stop 27/26",
                        "Orchard St at Upper Orchard St, stop 25",
                        "Soudan St near Bent St, stop 24",
                        "Ivy St near Mount St, stop 23",
                        "Dean St at Woodstock Rd, stop 19/21",
                        "Woodstock Rd near Miskin St, stop 20",
                        "Ascog Tce at Norwood Street, stop 19",
                        "Ascog Tce at Quinn Street, stop 17",
                        "Ascog Tce near Jephson St, stop 16",
                        "Sherwood Rd at Jephson St, stop 22/15",
                        "Jephson St near Ventnor St, stop 14",
                        "Sylvan Rd at Bulldogs, stop 13",
                        "Coronation Dr at Regatta, stop 12",
                        "Coronation Dr at Chasely Street, stop 8",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Park Road, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Sylvan Rd",
                        "Woodstock Rd near Pioneer St, stop 20",
                        "Elizabeth St at Lodge St, stop 21",
                        "Elizabeth St at Ivy St, stop 22",
                        "Soudan St near Orchard St, stop 24",
                        "Orchard St near Bywong St, stop 25",
                        "Exmouth St near Camp St, stop 26",
                        "Camp St near Market St, stop 27"
                    ],
                    "417: Long Pocket - City": [
                        "Meiers Rd at Long Pocket Terminus, stop 44",
                        "Meiers Rd at Fisheries, stop 43",
                        "Meiers Rd at BSES, stop 42",
                        "Harts Rd at Castile Street, stop 41",
                        "Harts Rd near Indooroopilly Rd, stop 40",
                        "Harts Rd at Thomas Park, stop 39",
                        "Harts Rd at Marston Avenue, stop 38",
                        "Harts Rd at Lutheran College, stop 37",
                        "Harts Rd at Dennis Street, stop 36",
                        "Lambert Rd at Central Ave, stop 35",
                        "Central Ave at Forest Lodge, stop 34",
                        "Central Ave at Holy Family, stop 33",
                        "Central Ave at Newcross Street, stop 32",
                        "Central Ave at Rennie Street, stop 31",
                        "Central Ave near Clarence Rd, stop 30",
                        "York St near Prince St, stop 29",
                        "Swann Rd at Swann - Clarence, stop 29",
                        "Swann Rd near Queens Rd, stop 28",
                        "Swann Rd at Burns Street, stop 27",
                        "Swann Rd at Saunders Street, stop 26",
                        "Swann Rd at Victoria Street, stop 25",
                        "Whitmore St near Seven Oaks St, stop 24a",
                        "Whitmore St at Norman Street, stop 24",
                        "Westerham St at Sundridge Street, stop 23",
                        "Westerham St near Indooroopilly Rd, stop 22",
                        "Bellevue Pde near Indooroopilly Rd, stop 21/20",
                        "Bellevue Pde at Bellevue - Burns, stop 19",
                        "Josling St at Perrin Park, stop 18",
                        "Josling St near Mayne Street, stop 17",
                        "Josling St near Herbert St, stop 16",
                        "Benson St at Toowong, stop 14",
                        "Coronation Dr at Regatta, stop 12",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Chasely Street, stop 8",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Park Road, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Coronation Dr at Regatta",
                        "Josling St at Mayne Street, stop 17",
                        "Bellevue Pde near Ellerslie Cr, stop 20/21",
                        "Whitmore St near Seven Oaks St, stop 24A",
                        "Central Ave near Lambert Rd, stop 35",
                        "Harts Rd near Glencairn Ave, stop 40"
                    ],
                    "425: Chapel Hill - City Express": [
                        "Bielby Rd at Kenmore Woods",
                        "Cedarleigh Rd at Kenmore Village",
                        "Goolman St at Bielby Road",
                        "Goolman St near Keil Pl",
                        "Goolman St at Chapel Hill School",
                        "Ironbark Rd near Birchley St",
                        "Dillingen St near Diamantina St",
                        "Mukurta St near Binyara St",
                        "Bielby Rd at Bielby Rise",
                        "Greenford St at Merri Merri Park",
                        "Tillbrook St near Halmore Pl",
                        "Fleming Rd at Chapel Woods",
                        "Fleming Rd at Chapel Crest",
                        "Burbong St at Burbong West",
                        "Burbong St at Burbong East",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Walker St at Taringa, stop 19",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Coronation Dr at Cribb Street, stop 4",
                        "High St at Toowong, stop 14A",
                        "Tillbrook St near Chatburn St",
                        "Moggill Rd at Taringa, stop 19",
                        "Dillingen St near Ironbark Rd",
                        "Goolman St near Juberra St",
                        "Bielby Rd near Goolman St"
                    ],
                    "426: Kenmore - City Rocket via Chapel Hill": [
                        "Bielby Rd at Kenmore Woods",
                        "Goolman St at Bielby Road",
                        "Goolman St near Keil Pl",
                        "Goolman St at Chapel Hill School",
                        "Ironbark Rd near Birchley St",
                        "Dillingen St near Diamantina St",
                        "Mukurta St near Binyara St",
                        "Bielby Rd at Bielby Rise",
                        "Greenford St at Merri Merri Park",
                        "Tillbrook St near Halmore Pl",
                        "Fleming Rd at Chapel Woods",
                        "Fleming Rd at Chapel Crest",
                        "Burbong St at Burbong West",
                        "Burbong St at Burbong East",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Rogers St, stop 8",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "Tillbrook St near Chatburn St",
                        "Dillingen St near Ironbark Rd",
                        "Goolman St near Juberra St",
                        "Bielby Rd near Goolman St"
                    ],
                    "427: Chapel Hill - University of Qld Express": [
                        "Market St near Moggill Rd, stop 28",
                        "Indooroopilly Shopping Centre station, stop C",
                        "Witton Rd near Market St, stop 28A",
                        "Lambert Rd near Central Ave, stop 35",
                        "Witton Rd near Kate St, stop 29",
                        "Central Ave at Forest Lodge, stop 34",
                        "Kate St near Boundary Rd, stop 30",
                        "Central Ave at Holy Family, stop 33",
                        "York St near Prince St, stop 29",
                        "Jerrang St near Jainba St, stop 31",
                        "Jerrang St at Market St, stop 32",
                        "Swann Rd at Swann - Clarence, stop 29",
                        "Fig Tree Pocket Rd near Bredden St, stop 32A",
                        "Swann Rd at Ironside School, stop 23/24",
                        "Chapel Hill Rd near Neptune St, stop 1",
                        "University of Queensland",
                        "Chapel Hill Rd near Ludlow St, stop 2",
                        "Chapel Hill Rd near Ludlow St, stop 3",
                        "Chapel Hill Rd near Fuelling St, stop 4",
                        "Chapel Hill Rd near Fleming Rd, stop 5",
                        "Burbong St at Burbong West",
                        "Burbong St near Merrilyn St, stop 7",
                        "Burbong St at Burbong East",
                        "Burbong St near Moggill Rd, stop 9c",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "UQ Chancellor's Place, zone B",
                        "Hawken Dr at Ironside School, stop 23/24",
                        "Central Ave near Lambert Rd, stop 35",
                        "Clarence Rd near Railway Ave, stop 36",
                        "Station Rd at Indooroopilly Shopping Ctr, stop E",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27"
                    ],
                    "428: Chapel Hill - University of Qld": [
                        "Market St near Moggill Rd, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly Shopping Centre station, stop C",
                        "Witton Rd near Market St, stop 28A",
                        "Lambert Rd near Central Ave, stop 35",
                        "Witton Rd near Kate St, stop 29",
                        "Central Ave at Forest Lodge, stop 34",
                        "Kate St near Boundary Rd, stop 30",
                        "Central Ave at Holy Family, stop 33",
                        "Jerrang St near Jainba St, stop 31",
                        "Central Ave at Newcross Street, stop 32",
                        "Jerrang St at Market St, stop 32",
                        "Central Ave at Rennie Street, stop 31",
                        "Fig Tree Pocket Rd near Bredden St, stop 32A",
                        "Central Ave near Clarence Rd, stop 30",
                        "Chapel Hill Rd near Neptune St, stop 1",
                        "York St near Prince St, stop 29",
                        "Swann Rd at Swann - Clarence, stop 29",
                        "Chapel Hill Rd near Ludlow St, stop 2",
                        "Swann Rd near Queens Rd, stop 28",
                        "Chapel Hill Rd near Ludlow St, stop 3",
                        "Swann Rd at Burns Street, stop 27",
                        "Chapel Hill Rd near Fuelling St, stop 4",
                        "Swann Rd at Saunders Street, stop 26",
                        "Chapel Hill Rd near Fleming Rd, stop 5",
                        "Swann Rd at Victoria Street, stop 25",
                        "Burbong St at Burbong West",
                        "Burbong St near Merrilyn St, stop 7",
                        "Swann Rd near Kobada St, stop 24",
                        "Burbong St at Burbong East",
                        "Swann Rd near Indooroopilly Rd, stop 23",
                        "Burbong St near Moggill Rd, stop 9c",
                        "Swann Rd at Bonvale Lane, stop 21",
                        "Swann Rd at Hutton Lane, stop 22",
                        "Swann Rd at Ironside School, stop 23/24",
                        "Hawken Dr at Hawken Shops, stop 25",
                        "Hawken Dr at Tenth Avenue, stop 26",
                        "Hawken Dr at Tarcoola Street, stop 27",
                        "Hawken Dr at Highland Terrace, stop 28",
                        "Hawken Dr near Highland Tce, stop 29",
                        "Hawken Dr at Hawken Villiage, stop 30",
                        "Hawken Dr at Picardy Street, stop 31",
                        "University of Queensland",
                        "UQ Chancellor's Place, zone A",
                        "Roundabout at Hawken Shops, stop 25",
                        "Hawken Dr at Ironside School, stop 23/24",
                        "Swann Rd at Hutton Lane, stop 21",
                        "Central Ave near Lambert Rd, stop 35",
                        "Clarence Rd near Railway Ave, stop 36",
                        "Station Rd at Indooroopilly Shopping Ctr, stop E",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27"
                    ],
                    "430: Fig Tree Pocket - City Express": [
                        "Fig Tree Pocket Rd at Mandalay, stop 44",
                        "Fig Tree Pocket Rd near Mactier St, stop 41",
                        "Lone Pine Koala Sanctuary at Lone Pine, stop 42",
                        "Fig Tree Pocket Rd at Cubberla Street, stop 40",
                        "Gunnin St near Tandawanna Lane, stop 41",
                        "Fig Tree Pocket Rd at Thiesfield Street, stop 38",
                        "Kenmore Rd at Norman Street",
                        "Gunnin St near Jesmond Rd, stop 41A",
                        "Kenmore Rd at Sunset Road, stop 45",
                        "Kenmore Rd at Kenmore South, stop 44",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Kenmore Rd at OLR, stop 39/37a",
                        "Moggill Rd at Kenmore Central, stop 37",
                        "Moggill Rd at Kenmore Churches, stop 35",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Walker St at Taringa, stop 19",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Coronation Dr at Cribb Street, stop 4",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at Taringa, stop 19",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd at Kenmore Central, stop 35",
                        "Kenmore Rd at OLR, stop 38/39",
                        "Kenmore Rd at Sunset Road"
                    ],
                    "431: Kenmore South - City Rocket": [
                        "Moggill Rd at Kenmore Central, stop 35",
                        "Kenmore Rd at OLR, stop 38/39",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Gem Rd at Wyndarra near Rialanna St",
                        "Gem Rd near Wyndarra St",
                        "Gem Rd at Annabel Street",
                        "Sunset Rd at Sunset West",
                        "Sunset Rd near West Ct",
                        "Sunset Rd near Moonlight St, stop 46",
                        "Kenmore Rd at Sunset Road, stop 45",
                        "Kenmore Rd at Kenmore South, stop 44",
                        "Gilruth Rd near Kenmore Rd, stop 40",
                        "Gilruth Rd near Acworth St, stop 39",
                        "Gilruth Rd near Cornhill St, stop 38",
                        "Gilruth Rd near Sophia St, stop 37",
                        "Marshall Lane near Gilruth Rd, stop 36",
                        "Marshall Lane near Kowhai St, stop 35",
                        "Marshall Lane near Wongabel St, stop 34",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Gilruth Rd near Marshall Lane, stop 36"
                    ],
                    "432: Kenmore - University of Qld Express": [
                        "Moggill Rd at Kenmore Central, stop 35",
                        "Indooroopilly Shopping Centre station, stop C",
                        "Lambert Rd near Central Ave, stop 35",
                        "Kilkivan Ave near Rothesay St, stop 38",
                        "Lambert Rd near Carnarvon Rd, stop 36/27",
                        "Kilkivan Ave at Pentlay Street, stop 39",
                        "Lambert Rd near Nawarra St, stop 25",
                        "Kilkivan Ave at Dumbarton Drive, stop 39a",
                        "Lambert Rd near Indooroopilly Rd, stop 24",
                        "Kingussie St at Kingussie Street, stop 40",
                        "Lanark St near Kilkivan Ave, stop 39a",
                        "Indooroopilly Rd near Iona Tce, stop 23A",
                        "Indooroopilly Rd near McCaul St, stop 23",
                        "Swann Rd at Bonvale Lane, stop 21",
                        "Kilkivan Ave near Skerry St, stop 38",
                        "Swann Rd at Ironside School, stop 23/24",
                        "Kenmore Rd at OLR, stop 38/39",
                        "University of Queensland",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Kenmore Rd near Gem Rd, stop 43",
                        "Kenmore Rd at Kenmore South, stop 44",
                        "Kersley Rd near Marshall Lane",
                        "Marshall Lane near Akuna St",
                        "Marshall Lane near Gilruth Rd, stop 36",
                        "Marshall Lane near Kowhai St, stop 35",
                        "Marshall Lane near Wongabel St, stop 34",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Bob Lynne Street, stop 32a",
                        "Moggill Rd at Fig Tree Pocket Road, stop 31",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Kennewell Park, stop 29",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "UQ Chancellor's Place, zone B",
                        "Hawken Dr at Ironside School, stop 23/24",
                        "Lambert Rd near Bowaga St, stop 25",
                        "Lambert Rd - 26",
                        "Lambert Rd near Martin Lane, stop 27/36",
                        "Lambert Rd at Central Ave, stop 35",
                        "Clarence Rd near Railway Ave, stop 36",
                        "Station Rd at Indooroopilly Shopping Ctr, stop E",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd near Marshall Lane, stop 34",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Kilkivan Ave at Moggill Road, stop 37a"
                    ],
                    "433: Kenmore South - City": [
                        "Kilkivan Ave at Dumbarton Drive, stop 39a",
                        "Kingussie St at Kingussie Street, stop 40",
                        "Lanark St near Kilkivan Ave, stop 39a",
                        "Kenmore Rd at OLR, stop 38/39",
                        "Kilkivan Ave at Pentlay Street, stop 39",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Kilkivan Ave near Skerry St, stop 38",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Gem Rd at Wyndarra near Rialanna St",
                        "Gem Rd near Wyndarra St",
                        "Gem Rd at Annabel Street",
                        "Sunset Rd at Sunset West",
                        "Sunset Rd near West Ct",
                        "Sunset Rd near Moonlight St, stop 46",
                        "Kenmore Rd at Sunset Road, stop 45",
                        "Kenmore Rd at Kenmore South, stop 44",
                        "Kenmore Rd near Piari St, stop 43",
                        "Gilruth Rd near Kenmore Rd, stop 40",
                        "Gilruth Rd near Acworth St, stop 39",
                        "Gilruth Rd near Cornhill St, stop 38",
                        "Gilruth Rd near Sophia St, stop 37",
                        "Marshall Lane near Gilruth Rd, stop 36",
                        "Marshall Lane near Kowhai St, stop 35",
                        "Marshall Lane near Wongabel St, stop 34",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Bob Lynne Street, stop 32a",
                        "Moggill Rd at Fig Tree Pocket Road, stop 31",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Kennewell Park, stop 29",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Station Rd at Indooroopilly Shopping Ctr, stop D",
                        "Coonan St near Belgrave Rd, stop 21",
                        "Moggill Rd at Payne Street, stop 20",
                        "Walker St at Taringa, stop 19",
                        "Walker St at Frederick Street, stop 18",
                        "Moggill Rd at Morrow Street, stop 17",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Regatta, stop 12",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Chasely Street, stop 8",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Park Road, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 162 near Ann St",
                        "Wharf Street Stop 163 near Leichhardt St",
                        "Leichhardt Street Stop 164 at The Ridge",
                        "Leichhardt St at Fortescue Street - 1",
                        "Leichhardt St at Allenby St, stop 2",
                        "Wickham Tce near Bradley St, stop 3",
                        "Wickham Tce near Dark St, stop 3a",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Coronation Dr at Regatta",
                        "High St at Toowong, stop 14A",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Coonan St near Allwood St",
                        "Station Rd at Indooroopilly Shopping Ctr, stop E",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Gilruth Rd near Marshall Lane, stop 36",
                        "Kenmore Rd at OLR, stop 39/37a",
                        "Kilkivan Ave at Moggill Road, stop 37a",
                        "Kilkivan Ave near Rothesay St, stop 38"
                    ],
                    "435: Brookfield - City Express": [
                        "Kailua St near Tangy St",
                        "Winrock St near Rafting Ground Rd",
                        "Rafting Ground Rd at Rees Way",
                        "Rafting Ground Rd at Rafting Ground West",
                        "Gold Creek Rd near Brookfield Rd",
                        "Brookfield Rd at Brookfield, stop 47",
                        "Gold Creek Rd at Brookfield Village",
                        "Brookfield Rd at Boscombe Road, stop 45",
                        "Brookfield Rd at Jacaranda Avenue, stop 43",
                        "Jacaranda Ave at Greentrees West, stop 42a",
                        "Greentrees Ave at Valleybrook",
                        "Greentrees Ave at Greentrees East, stop 42",
                        "Brookfield Rd at Gap Creek Road, stop 40",
                        "Brookfield Rd at Friary, stop 39",
                        "Brookfield Rd at Iona, stop 38",
                        "Brookfield Rd at Kenmore West, stop 37",
                        "Moggill Rd at Kenmore Village",
                        "Moggill Rd at Kenmore Churches, stop 35",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Walker St at Taringa, stop 19",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Indooroopilly interchange",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 162 near Ann St",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Rogers St, stop 8",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "High St at Toowong, stop 14A",
                        "Brookfield Rd at Kenmore Village, stop 36",
                        "Moggill Rd at Taringa, stop 19",
                        "Greentrees Ave at Greentrees West, stop 42a",
                        "Brookfield Rd at Brookfield, stop 46"
                    ],
                    "443: Moggil - City Rocket": [
                        "Moggill Rd at Moggill",
                        "Church Rd near Pine County Pl",
                        "Pioneer Cr at Pioneer West",
                        "Pioneer Cr at Pioneer East",
                        "Kangaroo Gully Rd at Bellbowrie Chase",
                        "Montanus Dr at Kangaroo Gully",
                        "Montanus Dr at Montanus East",
                        "Moggill Rd at Bellbowrie",
                        "Moggill Rd at Sugars Road",
                        "Moggill Rd at Mt Crosby Road",
                        "Moggill Rd at Grandview Road",
                        "Moggill Rd at QCAT",
                        "Moggill Rd at Diggers Rest",
                        "Moggill Rd at Rafting Ground Park",
                        "Moggill Rd at Kenmore park 'n' ride",
                        "Moggill Rd at Kenmore Central, stop 37",
                        "Moggill Rd at Kenmore Churches, stop 35",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Turbot St stop 130 at Magistrates Court",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd at Kenmore Central, stop 35"
                    ],
                    "444: Moggill - City Express": [
                        "Moggill Rd at Moggill",
                        "Church Rd near Pine County Pl",
                        "Pioneer Cr at Pioneer West",
                        "Pioneer Cr at Pioneer East",
                        "Kangaroo Gully Rd at Bellbowrie Chase",
                        "Montanus Dr at Kangaroo Gully",
                        "Montanus Dr at Montanus East",
                        "Moggill Rd at Bellbowrie",
                        "Moggill Rd at Sugars Road",
                        "Moggill Rd at Mt Crosby Road",
                        "Moggill Rd at Grandview Road",
                        "Moggill Rd at QCAT",
                        "Moggill Rd at Diggers Rest",
                        "Moggill Rd at Rafting Ground Park",
                        "Moggill Rd at Kenmore park 'n' ride",
                        "Moggill Rd at Kenmore Central, stop 37",
                        "Moggill Rd at Kenmore Churches, stop 35",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Walker St at Taringa, stop 19",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Roma Street busway, platform 2",
                        "King George Square, 2c",
                        "Cultural Centre station, platform 3",
                        "Merivale St at Queensland Theatre",
                        "Cultural Centre station, platform 1",
                        "King George Square, 1b",
                        "Roma Street busway, platform 1",
                        "Coronation Dr at Cribb Street, stop 4",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at Taringa, stop 19",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd at Kenmore Central, stop 35"
                    ],
                    "445: Fig Tree Pocket - City": [
                        "Fig Tree Pocket Rd near Botticelli St, stop 42A",
                        "Fig Tree Pocket Rd at Mandalay, stop 44",
                        "Kenny St near Ormsby St, stop 45a",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41a",
                        "Fig Tree Pocket Rd near Mactier St, stop 41",
                        "Gunnin St near Tandawanna Lane, stop 41",
                        "Fig Tree Pocket Rd at Cubberla Street, stop 40",
                        "Gunnin St near Jesmond Rd, stop 41A",
                        "Fig Tree Pocket Rd at Thiesfield Street, stop 38",
                        "Lone Pine Koala Sanctuary at Lone Pine, stop 42",
                        "Fig Tree Pocket Rd near Kenmore Rd, stop 37",
                        "Fig Tree Pocket Rd near Sprenger St, stop 36",
                        "Fig Tree Pocket Rd near Aylesbury St, stop 35",
                        "Fig Tree Pocket Rd at Kenmore Rugby Club - Stop 34",
                        "Fig Tree Pocket Rd near Jerrang St, stop 33",
                        "Jerrang St near Market St, stop 32",
                        "Jerrang St near Jainba St, stop 31",
                        "Kate St near Boundary Rd, stop 30",
                        "Witton Rd near Kate St, stop 29",
                        "Witton Rd near Rennies Rd, stop 28A",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Station Rd at Indooroopilly Shopping Ctr, stop D",
                        "Coonan St near Belgrave Rd, stop 21",
                        "Moggill Rd at Payne Street, stop 20",
                        "Walker St at Taringa, stop 19",
                        "Walker St at Frederick Street, stop 18",
                        "Moggill Rd at Morrow Street, stop 17",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Regatta, stop 12",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Chasely Street, stop 8",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Park Road, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 162 near Ann St",
                        "Wickham Tce near Dark St, stop 3a",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Coronation Dr at Regatta",
                        "High St at Toowong, stop 14A",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Coonan St near Allwood St",
                        "Station Rd at Indooroopilly Shopping Ctr, stop E",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Market St near Moggill Rd, stop 28",
                        "Witton Rd near Market St, stop 28A",
                        "Jerrang St at Market St, stop 32",
                        "Fig Tree Pocket Rd near Fawkner St, stop 33",
                        "Fig Tree Pocket Rd near Winking St, stop 33A",
                        "Fig Tree Pocket Rd near Kenmore Rugby Club Stop 34",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41",
                        "Cubberla St near Thiesfield St",
                        "Kenmore Rd at Norman Street",
                        "Kenmore Rd at Sunset Road, stop 45",
                        "Kenmore Rd at Kenmore South, stop 44",
                        "Kenmore Rd near Piari St, stop 43",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Kenmore Rd at OLR, stop 39/37a",
                        "Kilkivan Ave at Moggill Road, stop 37a",
                        "Kilkivan Ave near Rothesay St, stop 38",
                        "Kilkivan Ave at Pentlay Street, stop 39",
                        "Kilkivan Ave at Dumbarton Drive, stop 39a",
                        "Kingussie St at Kingussie Street, stop 40"
                    ],
                    "446: Kenmore - City Rocket": [
                        "Fig Tree Pocket Rd at Mandalay, stop 44",
                        "Fig Tree Pocket Rd at Cubberla Street, stop 40",
                        "Fig Tree Pocket Rd at Thiesfield Street, stop 38",
                        "Kenmore Rd at Norman Street",
                        "Kenmore Rd at Sunset Road, stop 45",
                        "Kenmore Rd at Kenmore South, stop 44",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Kenmore Rd at OLR, stop 39/37a",
                        "Moggill Rd at Kenmore Central, stop 37",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Ann Street Stop 5 at Orient Hotel",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd at Kenmore Central, stop 35",
                        "Kenmore Rd at OLR, stop 38/39",
                        "Kenmore Rd at Sunset Road"
                    ],
                    "450: Riverhills - City Express via Mt Ommaney": [
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills East near Macfarlane St",
                        "Horizon Dr at Westlake South near Riverhills Rd",
                        "Horizon Dr at Westlake near Nisbet St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Dandenong Rd at Jamboree",
                        "Mount Ommaney Shopping Centre",
                        "Arrabri Ave at Mt Ommaney South near Bowles St",
                        "Arrabri Ave at Explorer",
                        "Yallambee Rd at Mt Ommaney",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd at Jindalee Place",
                        "Burrendah Rd at Jindalee State School",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd at Jindalee park 'n' ride",
                        "Fig Tree Pocket on Centenary Highway siding",
                        "Sinnamon Village",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Walker St at Taringa, stop 19",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Roma Street busway, platform 2",
                        "Queen Street station",
                        "Queen Street station, 2b",
                        "Roma Street busway, platform 1",
                        "Coronation Dr at Cribb Street, stop 4",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at Taringa, stop 19",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Sinnamon Rd at Windermere",
                        "Goggs Rd at Windermere Village Shopping",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Bounty St at Explorer",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr at Westlake South near Buffalo St"
                    ],
                    "451: Sinnamon Park - Darra Station": [
                        "Glen Ross Rd near Dove Tree Cr, stop 52",
                        "Glen Ross Rd at St Amand Street, stop 53",
                        "Glen Ross Rd at Wanata Street, stop 54",
                        "Avondale Rd at Avondale - Glen Ross, stop 61",
                        "Avondale Rd at Avondale - Northbrook, stop 60",
                        "Northbrook St at Kobble Ct",
                        "Northbrooke St near Allamanda Ct, stop 59",
                        "Northbrooke St near Drummond St, stop 58",
                        "Oldfield Rd at Oldfield - Homebush, stop 57B",
                        "Oldfield Rd at Oldfield Shops, stop 57a",
                        "McPherson Rd at McPherson Park, stop 56",
                        "McPherson Rd at McPherson Cityview, stop 56a",
                        "McPherson Rd at Malia St, stop 55",
                        "McPherson Rd at McPherson South, stop 55A",
                        "Glen Ross Rd at Bellwood St, stop 54",
                        "Bellwood St near Glen Ross Rd, stop 54a",
                        "Manburgh Tce at Darra station, stop B"
                    ],
                    "452: Riverhills West - Darra Station": [
                        "Manburgh Tce at Darra station, stop B",
                        "Westcombe St near Gravel Pit Rd, stop 62",
                        "Sumners Rd at Spine St",
                        "Sumners Rd at Sumner Tavern",
                        "Sumners Rd at Brumby Circuit",
                        "Sumners Rd at Tompkins Road",
                        "Sumners Rd at Macfarlane Street",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Horizon Dr at Tigris Street",
                        "Riverhills Rd near Horizon Dr",
                        "Riverhills Rd at Wirilda",
                        "Horizon Dr near Gertrude McLeod Cr",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Dandenong Rd near Horizon Dr",
                        "Westcombe St near Perivale St, stop 62",
                        "Horizon Dr at Westlake South near Buffalo St",
                        "Sumners Rd at Riverhills East near Macfarlane St"
                    ],
                    "453: Mt Ommaney - City Express": [
                        "Mount Ommaney Shopping Centre",
                        "Arrabri Ave at Mt Ommaney South near Bowles St",
                        "Arrabri Ave at Explorer",
                        "Yallambee Rd at Mt Ommaney",
                        "Yallambee Rd at Centenary High School",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd at Jindalee Place",
                        "Burrendah Rd at Jindalee State School",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd at Jindalee park 'n' ride",
                        "Fig Tree Pocket on Centenary Highway siding",
                        "Sinnamon Village",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Walker St at Taringa, stop 19",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Roma Street busway, platform 2",
                        "Queen Street station",
                        "Queen Street station, 2b",
                        "Roma Street busway, platform 1",
                        "Coronation Dr at Cribb Street, stop 4",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at Taringa, stop 19",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Sinnamon Rd at Windermere",
                        "Goggs Rd at Windermere Village Shopping",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Bounty St at Explorer"
                    ],
                    "454: Riverhills - City Express": [
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills East near Macfarlane St",
                        "Horizon Dr at Westlake South near Riverhills Rd",
                        "Horizon Dr at Westlake near Nisbet St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Dandenong Rd at Jamboree",
                        "Mount Ommaney Shopping Centre",
                        "Glen Ross Rd at Sinnamon Park",
                        "Fig Tree Pocket on Centenary Highway siding",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Walker St at Taringa, stop 19",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Roma Street busway, platform 2",
                        "Queen Street station",
                        "Queen Street station, 2b",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Roma Street busway, platform 1",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Coronation Dr at Cribb Street, stop 4",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at Taringa, stop 19",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr at Westlake South near Buffalo St"
                    ],
                    "455: Riverhills - City Rocket": [
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills East near Macfarlane St",
                        "Horizon Dr at Westlake South near Riverhills Rd",
                        "Horizon Dr at Westlake near Nisbet St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Dandenong Rd at Jamboree",
                        "Mount Ommaney Shopping Centre",
                        "Glen Ross Rd at Sinnamon Park",
                        "Fig Tree Pocket on Centenary Highway siding",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Turbot St stop 130 at Magistrates Court",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr at Westlake South near Buffalo St"
                    ],
                    "456: Mt Ommaney - City Rocket": [
                        "Mount Ommaney Shopping Centre",
                        "Arrabri Ave at Mt Ommaney South near Bowles St",
                        "Arrabri Ave at Explorer",
                        "Yallambee Rd at Mt Ommaney",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd at Jindalee Place",
                        "Burrendah Rd at Jindalee State School",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd at Jindalee park 'n' ride",
                        "Fig Tree Pocket on Centenary Highway siding",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Margaret Street Stop 94 near George St",
                        "Eagle St near Creek St, stop 62",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Turbot St stop 130 at Magistrates Court",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "Sinnamon Rd at Windermere",
                        "Goggs Rd at Windermere Village Shopping",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Bounty St at Explorer"
                    ],
                    "460: Heathwood - City Express": [
                        "Parkwood Dr near Watergum St",
                        "Parkwood Dr near Acacia St",
                        "Parkwood Dr near Coolibah St",
                        "Parkwood Dr North near Laurel St",
                        "Wadeville St at Wadeville West",
                        "Wadeville St Heathwood Rise",
                        "Forest Lake Bvd at Kensington Way",
                        "Forest Lake Shops",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Garden Rd at Government Road",
                        "Richlands bus station, stop B",
                        "Dandenong Rd near Horizon Dr",
                        "Dandenong Rd at Jamboree",
                        "Mount Ommaney Shopping Centre",
                        "Glen Ross Rd at Sinnamon Park",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Moggill Rd at Indooroopilly, stop 25",
                        "Indooroopilly Shopping Centre station, stop B",
                        "Walker St at Taringa, stop 19",
                        "Moggill Rd at BBC, stop 16",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Roma Street busway, platform 2",
                        "Queen Street station",
                        "Queen Street station, 2b",
                        "Richlands bus station, stop A",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Roma Street busway, platform 1",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Coronation Dr at Cribb Street, stop 4",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at Taringa, stop 19",
                        "Forest Lake Bvd at Forest Lake Shops",
                        "Parkwood Dr North near Beech St",
                        "Parkwood Dr at Parkwood Drive South"
                    ],
                    "463: Forest Lake Village - Goodna Station": [
                        "Goodna station, stop A",
                        "Brisbane Tce at Lowe Street",
                        "Wilruna St at Gailes station",
                        "Wilruna St near Wuriga St",
                        "Wilruna St at Wilga St",
                        "Wilruna St at Wacol train station",
                        "Progress Rd near Industrial Ave",
                        "Boundary Rd at Campbell Avenue",
                        "Boundary Rd near Coulson St",
                        "Waterford Rd at Carole Park Primary School",
                        "David St at Stephen Street",
                        "John Street near Skepper St",
                        "Southampton Rd at Sinclair Drive",
                        "Doreen Cr near Southampton Rd",
                        "Southampton Rd near Sinclair Dr",
                        "Sinclair Dr at Julie Road",
                        "Roxwell Street at Roxwell Street",
                        "Roxwell St at Lovat Street",
                        "Grand Ave West near Centennial Way",
                        "Grand Ave at Grand Avenue School",
                        "Grand Ave at Grand Avenue Lake",
                        "Grand Ave at Grand Avenue Cascade",
                        "Grand Ave East near Ascot Ave",
                        "Forest Lake Shops",
                        "Forest Lake Bvd at Forest Lake Shops",
                        "Roxwell Street near Bagnall St",
                        "Doreen Crescent near Southampton Rd",
                        "Doreen Cr at Southampton Road",
                        "Southampton Rd at Doreen Crescent",
                        "John Street near Julie Rd",
                        "Muriel Ave at Stephen Street",
                        "Boundary Rd at Formation Street",
                        "Wilruna St at Wilga Street",
                        "Wilruna St at Wuriga St",
                        "Brisbane Tce near Layard St"
                    ],
                    "467: Oxley Station - Mt Ommaney via Sinnamon Park": [
                        "Mount Ommaney Shopping Centre",
                        "Arrabri Ave at Mt Ommaney South near Bowles St",
                        "Arrabri Ave at Explorer",
                        "Yallambee Rd at Mt Ommaney",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd at Jindalee Place",
                        "Burrendah Rd at Jindalee State School",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd at Jindalee park 'n' ride",
                        "Goggs Rd near Seventeen Mile Rocks Rd",
                        "Sinnamon Rd at Windermere",
                        "Sinnamon Rd at Windermere Estate stop 78",
                        "Windermere Ave at Ellerwood Place, stop 77",
                        "Seventeen Mile Rocks Rd at Mosman Court, stop 76",
                        "Rocks Riverside Park, stop 75",
                        "Seventeen Mile Rocks Rd at Arygle, stop 73",
                        "Seventeen Mile Rocks Rd at Edenbrooke, stop 72",
                        "Seventeen Mile Rocks Rd at Pannard St",
                        "Canossa Private Hospital, stop 70",
                        "Seventeen Mile Rocks Rd at Kingsgate St, stop 69",
                        "Oxley station, stop A",
                        "Seventeen Mile Rocks Rd at Arygle Street, stop 73",
                        "Goggs Rd at Windermere Village Shopping",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Bounty St at Explorer"
                    ],
                    "468: Oxley Station - Indooroopilly": [
                        "Oxley station, stop A",
                        "Seventeen Mile Rocks Rd at Kingsgate St, stop 69",
                        "Canossa Private Hospital, stop 70",
                        "Seventeen Mile Rocks Rd at Pannard St",
                        "Seventeen Mile Rocks Rd at Edenbrooke, stop 72",
                        "Duporth Rd near Seventeen Mile Rocks Rd, stop 59",
                        "Monier Rd at Monier Road Shops",
                        "Bellwood St near Glen Ross Rd, stop 54a",
                        "Glen Ross Rd at Glen Ross - Bellwood, stop 54",
                        "McPherson Rd at McPherson South, stop 55A",
                        "McPherson Rd at Malia St, stop 55",
                        "McPherson Rd at McPherson Park, stop 56",
                        "Oldfield Rd near McPherson Rd, stop 57",
                        "Rocks Riverside Park, stop 75",
                        "Seventeen Mile Rocks Rd at Mosman Court, stop 76",
                        "Windermere Ave at Ellerwood Place, stop 77",
                        "Sinnamon Rd at Windermere Estate stop 78",
                        "Sinnamon Rd at Windermere",
                        "Goggs Rd at Windermere Village Shopping",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Station Rd at Indooroopilly Shopping Ctr, stop D",
                        "Station Rd near Coonan St, stop 23",
                        "Station Rd at Indooroopilly Shopping Ctr, stop E",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Goggs Rd near Seventeen Mile Rocks Rd",
                        "McPherson Rd at McPherson Cityview, stop 56a",
                        "Glen Ross Rd at Bellwood St, stop 54",
                        "Duporth Rd near Loyal St, stop 59"
                    ],
                    "470: Toowong - City": [
                        "High St at Toowong Village, stop 23",
                        "Sherwood Rd at Jephson St, stop 15/22",
                        "Sherwood Rd at Kensington Terrace, stop 21",
                        "Sherwood Rd at Toowong West, stop 22",
                        "Elizabeth St at Lodge St, stop 21",
                        "Dean St at Elizabeth St, stop 19/18",
                        "Dean St at Toowong Depot, stop 17",
                        "Elizabeth St at Ivy St, stop 22",
                        "Soudan St near Orchard St, stop 24",
                        "Miskin St at Toowong Cemetery, stop 15/16",
                        "Orchard St near Bywong St, stop 25",
                        "Milton Rd at Milton - Sylvan, stop 14",
                        "Exmouth St near Camp St, stop 26",
                        "Milton Rd at Morley Street, stop 13",
                        "Camp St near Market St, stop 27",
                        "Milton Rd at Markwell Street, stop 12",
                        "Market St near Duke St, stop 28",
                        "Milton Rd at Park Avenue, stop 11",
                        "Orchard St at Lower Orchard St, stop 27/26",
                        "Milton Rd at Auchenflower Shops, stop 10",
                        "Orchard St at Upper Orchard St, stop 25",
                        "Milton Rd at Hobbs Street, stop 9",
                        "Soudan St near Bent St, stop 24",
                        "Milton Rd at Torwood St, stop 8",
                        "Ivy St near Mount St, stop 23",
                        "Milton Rd at Milton, stop 7",
                        "Milton Rd at Cribb St, stop 5",
                        "Upper Roma St near Quay St, stop 3",
                        "Milton Rd at Suncorp, stop 4",
                        "Roma Street Stop 124 at Roma Street station",
                        "Herschel Street Stop 1 near North Quay",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "George St Stop 119 near Tank St",
                        "Roma Street Stop 122 near Garrick St",
                        "Roma St at Upper Roma Street, stop 3",
                        "Milton Rd at Suncorp, stop 3/4",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Milton Rd at Milton - Torwood, stop 8",
                        "Mt Coot-tha St at Toowong Cemetery",
                        "Dean St near Elizabeth St, stop 18",
                        "Dean St at Woodstock Rd, stop 19/21",
                        "Sherwood Rd at Toowong West, stop 20",
                        "Dean St at Dovercourt Rd, stop 20a",
                        "Sherwood Rd at Jephson St, stop 22/15"
                    ],
                    "471: Mt Coot-tha Lookout - City": [
                        "Stuartholme Rd at Stuartholme College, stop 32",
                        "Sir Samuel Griffith Dr at Mount Coot-tha",
                        "Birdwood Tce at Stuartholme, stop 31",
                        "Mt Coot-tha Rd at Botanic Gardens, stop 19",
                        "Birdwood Tce at Birdwood View, stop 30",
                        "Couldrey St near Tristania Dr, stop 29",
                        "Main Ave near Haining St, stop 28",
                        "Harwood St near Birdwood Tce, stop 28a",
                        "Birdwood Tce at Ennever Street, stop 27",
                        "Birdwood Tce at Birdwood Corner, stop 19",
                        "Birdwood Tce at Fairseat Street, stop 18",
                        "Birdwood Tce at Hume Street, stop 16/17",
                        "Birdwood Tce at Hope Street, stop 15",
                        "Birdwood Tce at Wienholt Street, stop 14",
                        "Haig Rd at Payne Street, stop 13",
                        "Haig Rd at Torwood Park, stop 12",
                        "Haig Rd at Torwood Street, stop 11",
                        "Baroona Rd at Baroona - Haig, stop 8",
                        "Baroona Rd at Baroona Shops, stop 7",
                        "Park Rd near Fort Lane, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "Baroona Rd at Haig St, stop 8",
                        "Birdwood Tce at Hume Street, stop 16",
                        "Birdwood Tce at Gregory Street, stop 17",
                        "Harwood St at Main Avenue, stop 28"
                    ],
                    "475: Rainworth - City": [
                        "Leworthy St near Nestor Ave, stop 20",
                        "Leworthy St at Leworthy Shops, stop 19",
                        "Sixth Ave at Stokes St, stop 20/18",
                        "Boundary Rd at St Mary's - Rainworth, stop 17",
                        "Boundary Rd at Rainworth School, stop 16",
                        "Boundary Rd near Brown St, stop 15",
                        "Rainworth Rd at Norm Buchan Park West, stop 14",
                        "Rainworth Rd at Norm Buchan Park Central, stop 13",
                        "Rainworth Rd at Norm Buchan Park East, stop 12",
                        "Elizabeth St at Murruba St, stop 11",
                        "Elizabeth St at Nash Street, stop 10",
                        "Baroona Rd at Rosalie Shops, stop 9",
                        "Baroona Rd at Baroona - Haig, stop 8",
                        "Baroona Rd at Baroona Shops, stop 7",
                        "Milton Rd at Cribb St, stop 5",
                        "Upper Roma St near Quay St, stop 3",
                        "Milton Rd at Suncorp, stop 4",
                        "Roma Street Stop 124 at Roma Street station",
                        "Herschel Street Stop 1 near North Quay",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Ann Street Stop 219 at All Hallows",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "George St Stop 119 near Tank St",
                        "Roma Street Stop 122 near Garrick St",
                        "Roma St at Upper Roma Street, stop 3",
                        "Milton Rd at Suncorp, stop 3/4",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Baroona Rd at Haig St, stop 8",
                        "Nash St near Elizabeth St, stop 10",
                        "Elizabeth St at Rosalie, stop 10a",
                        "Boundary Rd at Mackay Terrace, stop 18"
                    ],
                    "476: Rainworth - City": [
                        "Warburton St near Rosalie St, stop 16",
                        "Hebe St at Mahara St, stop 15c",
                        "Gerler St at Gerler - Hebe, stop 15B",
                        "Selby St near Gerler St, stop 15",
                        "Boundary Rd near Brown St, stop 15",
                        "Rainworth Rd at Norm Buchan Park West, stop 14",
                        "Rainworth Rd at Norm Buchan Park Central, stop 13",
                        "Rainworth Rd at Norm Buchan Park East, stop 12",
                        "Elizabeth St at Murruba St, stop 11",
                        "Elizabeth St at Nash Street, stop 10",
                        "Baroona Rd at Rosalie Shops, stop 9",
                        "Heussler Tce at Heussler - Fernberg, stop 8",
                        "Heussler Tce at Heussler - Park, stop 7",
                        "Heussler Tce near Patrick St, stop 6",
                        "Heussler Tce at Heussler - Suncorp, stop 5",
                        "Caxton St near Chapel St, stop 4",
                        "Upper Roma St near Quay St, stop 3",
                        "Roma Street Stop 124 at Roma Street station",
                        "Herschel Street Stop 1 near North Quay",
                        "Adelaide Street Stop 22 near City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wharf Street Stop 156 near Ann St",
                        "Wickham Terrace Stop 158 Stand A near Turbot St",
                        "Ann Street Stop 7 at Anzac Square",
                        "Ann Street Stop 11 at King George Square",
                        "George St Stop 119 near Tank St",
                        "Roma Street Stop 122 near Garrick St",
                        "Roma St at Upper Roma Street, stop 3",
                        "Heussler Tce at Heussler, stop 6",
                        "Nash St near Elizabeth St, stop 10",
                        "Elizabeth St at Rosalie, stop 10a",
                        "Gerler St near Selby St, stop 15"
                    ],
                    "500: Riverlink Shopping Centre - Goodna Station": [
                        "Goodna station, stop A",
                        "Redbank station, stop B",
                        "Brisbane Tce at RJ Richardson Park",
                        "Mine Street at Brisbane Road",
                        "Brisbane Tce at Lower Stuart Street",
                        "Redbank Plaza",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Brisbane Tce at Brisbane River Terraces",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at Maxwell Street",
                        "Old Ipswich Rd at Ipswich Street",
                        "Old Ipswich Rd near Riverview Primary School",
                        "Old Ipswich Rd near Laura St",
                        "Valerie St near Child St",
                        "Diamond St near Gibbs St",
                        "Price St at Hayden Street",
                        "Mitchell St at Tessman Street",
                        "Endeavour Rd at Riverview Gardens",
                        "Riverview Rd at Maryanne Street",
                        "Riverview Rd at Kenneth Street",
                        "River Rd at Richard Street",
                        "River Rd at Dinmore station",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Ebbw Vale Station",
                        "Brisbane Rd at Railway Street",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at McCormack Street",
                        "Brisbane Rd at Coal Street",
                        "Brisbane Rd at Bundamba Primary",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Brisbane Rd at Hamilton Street",
                        "Booval Fair",
                        "Brisbane Rd at Swifts Sports Club",
                        "Brisbane Rd at Bright Street",
                        "Brisbane Rd at Montauban Street",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Ellenborough St at Ellenborough Street",
                        "Ipswich station, stop A",
                        "Riverlink, Stop A",
                        "Ipswich station, stop C",
                        "Brisbane St at Marsden Parade",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Brisbane Rd at Watson Street",
                        "Brisbane Rd at Eileen Street",
                        "Brisbane Rd at Nimmo Street",
                        "Brisbane Rd at Vowles Street",
                        "Brisbane Rd at Bundamba Swimming Centre",
                        "Brisbane Rd at Bundamba Uniting Church",
                        "Brisbane Rd at TAFE Queensland Ipswich campus",
                        "Brisbane Rd at Ebbw Vale station",
                        "River Rd at King Street",
                        "Tessman St near Brian St",
                        "Price St near Hayden St",
                        "Gibbs St near Diamond St",
                        "Diamond St near Valerie St",
                        "Old Ipswich Rd at Anderson Street",
                        "Redbank station, stop A",
                        "Brisbane Tce at Layard Street"
                    ],
                    "501: Springfield Central station - Bell Street": [
                        "Ipswich station, stop C",
                        "Brisbane St at Marsden Parade",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Whitehill Rd near Raff St",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Church St",
                        "Thomas St at Queen Street",
                        "Mary St near Hill Street",
                        "Redbank Plains Rd at Mullins Street",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop C",
                        "Jones Rd near Augusta Pkwy",
                        "Augusta Pkwy at Forester Avenue",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Springfield Central station, stop E",
                        "Springfield Central station, stop A",
                        "Augusta Pkwy at Eden Station Drive",
                        "Redbank Plains Town Square, stop D",
                        "Redbank Plains Rd at Brennan Park",
                        "Redbank Plains Rd at Bronzewing Street",
                        "Mary St at Blackstone Primary School",
                        "Blackstone Rd near Cothill Rd",
                        "Blackstone Rd near Whitehill Rd",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza"
                    ],
                    "502: Bundamba - Riverlink via Blackstone": [
                        "Byrne St at TAFE Queensland Ipswich campus",
                        "Brisbane Rd at Coal Street",
                        "Lindsay St at Bergins Hill Road",
                        "Braeside Rd near Tibbits St",
                        "Naomai St at Oak Street",
                        "Naomai St near John St",
                        "Naomai St at Innes Crescent",
                        "Naomai St at Alice Street",
                        "William St near Charlotte St",
                        "Mary St at Blackstone Primary School",
                        "Mary St near Hill Street",
                        "Thomas St at Queen Street",
                        "Blackstone Rd near Johnston St",
                        "Blackstone Rd near Cothill Rd",
                        "Thompson St near Glebe Rd",
                        "Booval Fair",
                        "South Station Rd at Ivory Street",
                        "South Station Rd at Long Lane",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Whitehill Rd near Raff St",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Ellenborough St at Ellenborough Street",
                        "Ipswich station, stop A",
                        "Riverlink, Stop A",
                        "Ipswich station, stop C",
                        "Brisbane St at Marsden Parade",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Glebe Rd near Brisbane Rd",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Blackstone Rd near Church St",
                        "Charlotte St near Short St",
                        "Naomai St near Alice St",
                        "Naomai St at Bundamba Secondary College",
                        "Brisbane Rd at Bundamba Uniting Church",
                        "Brisbane Rd at TAFE Queensland Ipswich campus"
                    ],
                    "503: Bundamba - Riverlink via Eastern Heights": [
                        "Byrne St at TAFE Queensland Ipswich campus",
                        "Mary St near Bryant St",
                        "Jeffrey Street at Mary Street",
                        "Cullen St near Jeffrey St",
                        "Burgoyne St near Eclipse Ct",
                        "Stubbin St near Burgoyne St",
                        "Stubbin St at Wade Street",
                        "River Rd near TAFE Queensland Ipswich campus",
                        "Creek St at Bundamba station",
                        "Gledson St at Jack Barkley Park",
                        "Gledson St at Bergin Street",
                        "North Station Rd at Booval station",
                        "Dudleigh St near Clifton St",
                        "Booval station",
                        "South Station Rd at Sloman Street",
                        "South Station Rd at Ivory Street",
                        "South Station Rd at Long Lane",
                        "South Station Rd near Auld St",
                        "South Station Rd near Morris St",
                        "South Station Rd near Robertson Rd",
                        "Wildey St at Brothers Leagues Club",
                        "Wildey St near Nolan St",
                        "Nolan St near South Station Rd",
                        "South Station Rd near Harding St",
                        "Cascade St near South Station Rd",
                        "Wildey St at Raceview Primary School",
                        "Wildey St near Rumsey Dr",
                        "Edwards St near Thornton St",
                        "Edwards St near Rockman Dr",
                        "Raceview St at Westminster Crescent",
                        "Raceview St at Rockman Drive",
                        "Raceview St at Hayes Street",
                        "Raceview St at Taylor Street",
                        "Grange Rd near Robertson Rd",
                        "Grange Rd near Edwards St",
                        "Marvin St near Grange Rd",
                        "Marvin St near Olmai Ave",
                        "Chermside Rd at Fifer Street",
                        "Salisbury Rd near Jackes St",
                        "Salisbury Rd at Thorn Street",
                        "Warwick Rd at Showground North",
                        "Warwick Rd at Park Street",
                        "Ipswich Hospital, Stop A",
                        "Pring St at St Andrews Hospital",
                        "East St at South Street",
                        "Limestone St at Foote Lane",
                        "Ellenborough St at Ellenborough Street",
                        "Ipswich station, stop A",
                        "Riverlink, Stop A",
                        "Ipswich station, stop C",
                        "Warwick Rd at Short Street",
                        "Salisbury Rd near Briggs Rd",
                        "Robertson Rd near France St",
                        "Raceview St near Taylor St",
                        "Raceview St at Carlita Place",
                        "Raceview St at Westminister Crescent",
                        "Cascade St near Wildey St",
                        "South Station Rd at Harding Street",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Ivory St",
                        "North Station Rd at Bridge Street",
                        "Gledson St near Bergin St"
                    ],
                    "506: Riverlink Shopping Centre - Leichhardt & One Mile": [
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Toongarra St at Birrell Street",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Chubb St at Woodford Street",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Leichhardt and One Mile Community Centre",
                        "Brisbane St at Hooper Street",
                        "Brisbane St at Tiger Street",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Waghorn Street",
                        "Brisbane St at Ipswich City Square",
                        "Ipswich station, stop A",
                        "Riverlink, Stop A",
                        "Ipswich station, stop C",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Limestone St at Waghorn Street",
                        "Brisbane St at Keogh Street",
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Gilmore St near Watsonia Dr",
                        "Avon St at Larsen St",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street"
                    ],
                    "509: Yamanto - Riverlink Shopping Centre": [
                        "Jacaranda Dr near Aloe St",
                        "Nuala St near Jacaranda Dr",
                        "Tristania St near Ruthven Ct",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Hall Street",
                        "Deebing Creek Rd at Amberley State School",
                        "Deebing Creek Rd near Quando Cl",
                        "Equestrian Dr near Mustang St",
                        "Equestrian Dr near Arabian Cl",
                        "Bladon St near Blenheim Ct",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Reif St at Fairview Park",
                        "Reif St at Plover Street",
                        "Reif St at Wallace St",
                        "Ripley Rd at Kingston Drive",
                        "Ripley Rd at Hibiscus Street",
                        "Ripley Rd at Edwards Street",
                        "Raceview St at Westminster Crescent",
                        "Raceview St at Rockman Drive",
                        "Cascade St at Cascade Gardens",
                        "Whitehill Rd near McGill St",
                        "Cemetery Rd near Whitehill Rd",
                        "Cemetery Rd near Warner St",
                        "Cemetery Rd at Briggs Road",
                        "Carr St at Warwick Road",
                        "Warwick Rd at Showground North",
                        "Warwick Rd at Park Street",
                        "East St at South Street",
                        "Limestone St at Foote Lane",
                        "Ellenborough St at Ellenborough Street",
                        "Ipswich station, stop A",
                        "Riverlink, Stop A",
                        "Ipswich station, stop C",
                        "Ipswich Hospital, Stop C",
                        "Warwick Rd at Short Street",
                        "Carr St at Thorn Street",
                        "Cemetery Rd at Vernon Street",
                        "Cemetery Rd near Orchard St",
                        "Raceview St at Westminister Crescent",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Bladon St near Blenheim Cr",
                        "Deebing Creek Rd near Sandalwood Dr",
                        "Warwick Rd at Ash Street",
                        "Jacaranda Dr near Rose St"
                    ],
                    "50: City Loop (Anti-Clockwise)": [
                        "Margaret St stop 93 at George St",
                        "Margaret Street Stop 96 at Edward St",
                        "Eagle Street Stop 155 near Charlotte St",
                        "Eagle St app Queen St (Stop 65)",
                        "Adelaide Street Stop 36 near Anzac Square",
                        "Adelaide Street Stop 42 near Albert St",
                        "William St near Elizabeth St stop 103",
                        "William Street Stop 105 near Margaret St"
                    ],
                    "512: Brassall - Riverlink Shopping Centre": [
                        "Fernvale Rd at Vaughan Hill",
                        "Ipswich Warrego Hwy at North High Street",
                        "Bourke St near Fernvale Rd",
                        "Bourke St near Hayes St",
                        "Haig St at Charles Street",
                        "Charles St at Brassall Retirement Village",
                        "Bradfield Dr at Calder Court",
                        "Bradfield Dr at Backhouse Court",
                        "Clune St at Vogel Road",
                        "Vogel Rd at Sharpe Street",
                        "Workshops St at Sutton Park",
                        "Albion St at Workshops Street",
                        "Kingsmill Rd at Robin Street",
                        "Woodend Rd near Macrae St",
                        "Waghorn St near Arthur St",
                        "Ipswich station, stop A",
                        "Riverlink, Stop A",
                        "Ipswich station, stop C",
                        "Waghorn St near Ipswich Boys Grammar School",
                        "Haig St near Theodore St",
                        "Fernvale Rd at Bourke Street",
                        "Fernvale Rd at North High Street"
                    ],
                    "514: Tivoli - Booval Fair": [
                        "Moores Pocket Rd at Bremer Waters Resort",
                        "Moores Pocket Rd at Bremer Waters",
                        "Moores Pocket Rd at Tivoli Gardens",
                        "Moores Pocket Rd near Wood St",
                        "Mount Crosby Rd at Ipswich Caravan Village",
                        "Mount Crosby Rd at Tivoli State School",
                        "Hutchins St near Mt Crosby Rd",
                        "Mount Crosby Rd near Church St",
                        "Mount Crosby Rd near Croydon St",
                        "Mount Crosby Rd near Greasley St",
                        "Hill St near Phie St",
                        "Hill St at Cyprus Street",
                        "Cyprus St at Hefferan St",
                        "Cyprus St near Simmons Rd",
                        "Allen St near Francis St",
                        "Holdsworth Rd near Roberts St",
                        "Holdsworth Rd near Paten St",
                        "Holdsworth Rd near Holmes St",
                        "Holmes St at Holdsworth Road",
                        "Waterworks Rd at Simmons Road",
                        "Pine Mountain Rd at Cushing Street",
                        "Pine Mountain Rd near Carter St",
                        "Pine Mountain Rd near McLean St",
                        "Pine St near Wyndham St",
                        "Pine St near Eastwood St",
                        "Pine St at Lawrence Street",
                        "Pine St near Lennon Lane",
                        "Pine St near Flint St",
                        "Riverlink, Stop B",
                        "Ipswich station, stop B",
                        "Brisbane St at Marsden Parade",
                        "Blackall St near Barry St",
                        "Blackall St near Northcote St",
                        "Blackall St at Norman Street",
                        "Blackall St near Davidson St",
                        "Charlotte St at Blackall Street",
                        "Charlotte St near Springall St",
                        "Springall St near Charlotte St",
                        "McGill St near Battye St",
                        "McGill St near Howard St",
                        "Chermside Rd near Goodwin St",
                        "Chermside Rd near Jacaranda St",
                        "Jacaranda St at Ipswich East Primary School",
                        "Jacaranda St at Nathan Street",
                        "Jacaranda St near Spengler St",
                        "Jacaranda St near Burton St",
                        "Jacaranda St near Welsby St",
                        "Dudleigh St near Clifton St",
                        "Booval station",
                        "South Station Rd at Sloman Street",
                        "Booval Fair",
                        "Jacaranda St near Tuggerah St",
                        "Jacaranda St near Cook St",
                        "Jacaranda St near Nathan St",
                        "Jacaranda St near Cotton St",
                        "Chermside Rd near Countess St",
                        "Chermside Rd near McGill St",
                        "Charlotte St near Bowers St",
                        "Charlotte St near Blackall St",
                        "Blackall St near Goodwin St",
                        "Blackall St near Norman St",
                        "Ipswich station, stop A",
                        "Pine St at Browns Park",
                        "Pine St near Canning St",
                        "Pine St near Bank St",
                        "Pine St at Wyndham Street",
                        "Pine Mountain Rd at Birdwood Street",
                        "Holmes St near Holdsworth St hail 'n' ride",
                        "Cyprus St at Allen Street",
                        "Cyprus St at Hefferan Street",
                        "Moores Pocket Rd at Bremer Waters Village"
                    ],
                    "515: Brassall - Yamanto & Willowbank": [
                        "UniSQ Ipswich",
                        "Coopers Rd at Willowbank Caravan Park",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Showground North",
                        "Warwick Rd at Hall Street",
                        "ONeills Rd near Willowbank Shopping Village",
                        "Warwick Rd at Park Street",
                        "Warwick Rd at Meadow Street",
                        "Wigmore St near Tinworth St",
                        "Ipswich Hospital, Stop A",
                        "Warwick Rd at Fitzroy Street",
                        "Sancroft St near Melbury St",
                        "Warwick Rd at Brisbane Street",
                        "East St at South Street",
                        "Warwick Rd at Sheehan Lane",
                        "Limestone St at Foote Lane",
                        "Warwick Rd at Perry Street",
                        "Ellenborough St at Ellenborough Street",
                        "Warwick Rd at Bremer High",
                        "Ipswich station, stop A",
                        "Riverlink, Stop B",
                        "Warwick Rd at Showground",
                        "Downs St at Browns Park",
                        "Downs St at Fitzgibbon Street",
                        "Downs St at Ferguson Street",
                        "North St at Workshop Museum",
                        "Pine Mountain Rd near McLean St",
                        "Pine Mountain Rd at Birdwood Street",
                        "Pine Mountain Rd at Cushing Street",
                        "Pine Mountain Rd at Glossop Street",
                        "Pine Mountain Rd at Brassall Primary School",
                        "Hunter St at Ipswich State High School",
                        "Hunter St at Brassall Shopping Village",
                        "Workshops St near Tunstall Pl",
                        "Workshops St at Collins Street",
                        "Pine Mountain Rd near Carter St",
                        "Ipswich station, stop B",
                        "Warwick Rd at Short Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Ash Street",
                        "Yamanto Shopping Centre",
                        "Cunningham Hwy at Amberley Caravan Park",
                        "Coopers Rd near Willowbank Dr",
                        "Coopers Rd near Palm Meadows Home Village"
                    ],
                    "520: Goodna station - Eden's Crossing": [
                        "Mt Juillerat Dr at Eden's Village Shopping Centre",
                        "Mt Juillerat Dr at Pioneer Street",
                        "School Rd near Fernbrooke Bvd",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop C",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd at Kingsford Street",
                        "Goodna station, stop A",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd at Brennan Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop D",
                        "Redbank Plains Rd at Brennan Park",
                        "School Rd near Alawoona St hail 'n' ride",
                        "School Road at Fernbrooke Boulevard"
                    ],
                    "522: Redbank station - Springfield Central station": [
                        "Springfield Central station, stop A",
                        "Augusta Pkwy at Eden Station Drive",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Forester Avenue",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop D",
                        "Redbank Plains Rd at Brennan Park",
                        "Collingwood Dr at Br Ted Magee Drive",
                        "Collingwood Dr at Palaszczuk Avenue",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Collingwood Dr at Gibbs Avenue",
                        "Collingwood Dr at Jamboree Park hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Redbank Plaza",
                        "Redbank station, stop A",
                        "Redbank station, stop B",
                        "Mine Street at Brisbane Road",
                        "Collingwood Dr at Jamboree Park",
                        "Palaszczuk Av at Neumann Drive hail 'n' ride",
                        "Redbank Plains Rd at Mullins Street",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop C",
                        "Springfield Central station, stop E"
                    ],
                    "523: Mountview shops - Springfield Central station": [
                        "School Rd at Mountview Shopping Centre",
                        "Sunbird Dr at Oakleigh Park hail 'n' ride",
                        "Sunbird Dr at Coolabah Drive",
                        "Regents Dr at Fantail Avenue",
                        "Ingles Dr at McNamara Place",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Cedar Rd near Orana St hail 'n' ride",
                        "Kanangra St at Cedar Road",
                        "Kanangra St at Lemana Street",
                        "Kanangra St at Keidges Road",
                        "Keidges Rd near Orana St hail 'n' ride",
                        "Redbank Plains Town Square, stop A",
                        "Argyle St at Price Close",
                        "Henty Dr at Barnes Street",
                        "Redbank Plains Town Square, stop C",
                        "Jones Rd near Augusta Pkwy",
                        "Cardena Dr at Quinn Close",
                        "Brittains Rd at Augusta State School",
                        "Cadoc St at Zamma Street hail 'n' ride",
                        "Santa Monica Dr near Hallow Cr",
                        "Santa Monica Dr near Oudeman St",
                        "Santa Monica Dr near Ambrose Dr",
                        "Santa Monica Dr at Oudeman Street",
                        "Santa Monica Dr near Mcauley Cr",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Springfield Central station, stop E",
                        "Springfield Central station, stop A",
                        "Augusta Pkwy at Eden Station Drive",
                        "Santa Monica Dr near McAuley Cr",
                        "Cadoc St at Zamma Street",
                        "Cardena Dr at Cornelius Drive",
                        "Keidges Rd at Harry Street",
                        "Kanangra St at Balook Street",
                        "Kanangra St near Lemana St",
                        "Cedar Rd at Orana Street",
                        "Vicki St at Jane Street hail 'n' ride",
                        "Alawoona St at Ingles Drive",
                        "Sunbird Dr at Mallee Drive"
                    ],
                    "524: Redbank Plains - Goodna Station": [
                        "Redbank Plains Town Square, stop C",
                        "Jones Rd near Augusta Pkwy",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Redbank Plains Rd at Kingsford Street",
                        "Curnow St near Howard St",
                        "Stuart St near Bellevue Rd",
                        "Cross St at Bellevue Road",
                        "Gorry St at Kilner Street",
                        "Gorry St at Dowden Street",
                        "Smiths Rd near Stephen Cr",
                        "Smiths Rd at Arne Street",
                        "Goodna Shopping Centre",
                        "Goodna station, stop A",
                        "Mill St at McVeigh Court",
                        "Gorry St at Killner Street",
                        "Cross St near Hamar St",
                        "Stuart St at Bellevue Road",
                        "Kingsford St at Howard Street",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Town Square, stop D"
                    ],
                    "525: Goodna Station - Redbank Square": [
                        "Goodna station, stop A",
                        "Mill St at McVeigh Court",
                        "Goodna Shopping Centre",
                        "Smiths Rd at Arne Street",
                        "Smiths Rd at Smiths Road",
                        "Smiths Rd at Redbank Collingwood Park Sports Complex",
                        "Redbank Plaza",
                        "Collingwood Dr at Old Ipswich Road",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Lawrie Dr near Whitlam Dr hail 'n' ride",
                        "Goss Dr at Jo Ann Miller Dr hail 'n' ride",
                        "Goss Dr at Hawke Avenue hail 'n' ride",
                        "Gibbs Ave at Hunt Court",
                        "Gibbs Ave near Genoa Pl",
                        "Gibbs Ave near Avoca Ct",
                        "Gibbs Ave near TJ Ryan Ave",
                        "Eagle St near Bassili Dr",
                        "Eagle St near TJ Ryan Ave",
                        "Neumann Dr at Alabaster Street",
                        "Redbank Plains Rd at Mullins Street",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop C",
                        "Redbank Plains Town Square, stop D",
                        "Redbank Plains Rd at Brennan Park",
                        "Collingwood Dr at Br Ted Magee Drive",
                        "Palaszczuk Av at Neumann Drive hail 'n' ride",
                        "Neumann Dr at Elder Parade",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Smiths Rd near Stephen Cr"
                    ],
                    "526: Orion Springfield Central - Redbank Station": [
                        "Orion Springfield Central",
                        "Springfield Central station, stop A",
                        "Brookwater Dr at Greg Norman Circuit",
                        "Brookwater Dr at Scoparia Drive",
                        "Brookwater Dr at Oakview Circuit hail 'n' ride",
                        "Brookwater Dr at Forester Avenue hail 'n' ride",
                        "Augusta Pkwy at Forester Avenue",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop D",
                        "Henty Dr at Barnes Street",
                        "Henty Dr near Knight St",
                        "Henty Dr near Martin Pl",
                        "Highbury Dr near Llewellyn St",
                        "Russell Dr at Kerwin Street",
                        "Josey St at Neal Street",
                        "Josey St at Kennedy Drive",
                        "Batman Dr at Nigel Street",
                        "Henty Dr at Batman Drive",
                        "Henty Dr at Kruger Parade",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Redbank Palms",
                        "Collingwood Dr at Old Ipswich Road",
                        "Redbank station, stop A",
                        "Redbank Plaza",
                        "Redbank station, stop B",
                        "Mine Street at Brisbane Road",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Josey St at Flinders Street",
                        "Russell Dr near Llewellyn St",
                        "Highbury Dr at Llewellyn Street",
                        "Henty Dr at Ropati Street",
                        "Redbank Plains Town Square, stop C",
                        "Brookwater Dr near Scoparia Dr"
                    ],
                    "527: Orion - Goodna Station via Camira": [
                        "Orion Springfield Central",
                        "Springfield Greenfield Art at Springfield College",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Karamea Ave near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Woodcrest Way near Millwood Tce",
                        "Springfield Station",
                        "Woodcrest Way at Nev Smith Drive",
                        "Topaz Rd at Springfield Fair",
                        "Topaz Rd near Sharpless Rd",
                        "Sharpless Rd near Tourmaline St",
                        "Mur Bvd near Old Logan Rd",
                        "Kertes Rd at Pharoah Street",
                        "Fran St near Jean Rd",
                        "Angela St near Moss Rd",
                        "Ishmael Rd near Dale Rd",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Cochrane St near Ishmael Rd",
                        "Cochrane St near Barbara St",
                        "Old Logan Rd near Hallett Ave",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd near Vanessa Ct",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Julieanne Street",
                        "Brisbane Tce near Layard St",
                        "Goodna station, stop A",
                        "William St at Smiths Road",
                        "Goodna Shopping Centre",
                        "St Francis Xavier Catholic Primary School",
                        "Brisbane Tce at Lowe Street",
                        "Old Logan Rd at Vanessa Court",
                        "Old Logan Rd at Hallett Avenue",
                        "Ishmael Rd near Moss Rd",
                        "Fran St near Steven St",
                        "Kertes Rd near Pharoah St",
                        "Mur Bvd near Sharpless Rd",
                        "Sharpless Rd near Zircon St",
                        "Woodcrest Way near Woodcrest College",
                        "Woodcrest Way near Bridgewater Rd",
                        "Springfield Greenbank Art at Springfield College",
                        "Lakes Entrance Dr near Foreshore Dr",
                        "Lakes Entrance Dr near Riverside Cr"
                    ],
                    "528: Orion - Springfield Station via Springfield Lakes": [
                        "Springfield Station",
                        "Woodcrest Way at Nev Smith Drive",
                        "Springfield Pkwy at Panorama Drive",
                        "Springfield Pwy at Escarpment Drive",
                        "Spring Lake Village 1",
                        "Lakeside Ave near Burlington Tce",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Janus Gr",
                        "Lakeside Ave near Coventina Cr",
                        "Summit Dr near Lakeside Ave",
                        "Summit Dr near Liberty Cr",
                        "Springfield Lakes Bvd near The Promenade",
                        "Springfield Lakes Bvd near Parkview Dr",
                        "Springfield Lakes Bvd near Lakes Entrance Drive",
                        "Lakes Entrance Dr near Foreshore Dr",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Grande Ave near Oak Leaf Dr",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave at Angelica Avenue",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Parkland Dr near Wellness Way",
                        "Wellness Way at Health Care Dr",
                        "Sinnathamby Bvd at UniSQ",
                        "Sinnathamby Bvd at Parkside Business Park",
                        "Springfield Central station, stop A",
                        "Orion Springfield Central",
                        "Health Care Dr at UniSQ",
                        "Lakes Entrance Drive at Shearwater Tce",
                        "Springfield Lakes Bvd at Lakes Entrance Drive",
                        "Springfield Lakes Bvd at Parkview Drive",
                        "Springfield Lakes Bvd near Greentrees Tce",
                        "Lakeside Ave near Diana St",
                        "Spring Lake Village 4",
                        "Springfield Pkwy at Springfield Greenbank Arterial",
                        "Woodcrest Way near Woodcrest College"
                    ],
                    "529: Toogoolawah - Ipswich": [
                        "Railway St at Station Street",
                        "Cressbrook St at Toogoolawah History Museum",
                        "Ipswich St at Lars Andersen Place",
                        "Brisbane Valley Hwy at Fernvale Futures Complex",
                        "Ipswich St at St Agnes' Church",
                        "Brisbane Valley Hwy at Wanora",
                        "Brisbane Valley Hwy at Glamorgan Vale Road",
                        "Coominya Connection Rd at McLean Road",
                        "Brisbane Valley Hwy at Borallon, James Road",
                        "West Rd at Gutteridge Road",
                        "Railway St at Coominya Memorial Park",
                        "Brisbane Valley Hwy at Bayley Road",
                        "Riverlink, Stop A",
                        "Ipswich station, stop C",
                        "Brisbane Valley Hwy at Wanora, Leshkes Rd"
                    ],
                    "531: Springfield - Yamanto via Ripley Valley": [
                        "Yamanto Shopping Centre",
                        "Ripley Rd at Trigona Drive",
                        "Ripley Rd at Canary St",
                        "Parkview Pde at Lillypilly Drive",
                        "Main St at Ripley Town Centre",
                        "Providence Pde at Splendid Drive",
                        "Harmony Cr at Greenview Avenue",
                        "Providence Pde at Ripley Hospital",
                        "Barrams Rd at Olympus Drive",
                        "Sandstone Boulevard",
                        "Springfield Central station, stop A",
                        "Orion Springfield Central",
                        "Ripley Rd at Wensley Rd",
                        "Warwick Rd at Yamanto Shopping Centre"
                    ],
                    "533: Spring Mountain Loop": [
                        "Orion Springfield Central",
                        "Springfield Central station, stop A",
                        "Education City",
                        "Health Care Dr at UniSQ",
                        "Health Care Dr at Mater Private Hospital",
                        "Health Care Dr at Nightingale Avenue",
                        "Parkland Dr near Wellness Way",
                        "Grande Ave at Woodline Dr",
                        "Grande Ave at Dublin Ave",
                        "Grand Ave at Applecross Cct",
                        "Grande Ave at Sierra Drive",
                        "Spring Mountain Bvd at Grande Ave",
                        "Spring Mountain Bvd at London Avenue",
                        "Grande Ave at Applecross Cct",
                        "Grande Ave at Woodline Drive"
                    ],
                    "534: Browns Plains - Orion Springfield Central": [
                        "Orion Springfield Central",
                        "Springfield Central station, stop A",
                        "Sinnathamby Bvd at Parkside Business Park",
                        "Sinnathamby Bvd at UniSQ",
                        "Education City",
                        "Springfield Greenfield Art at Springfield College",
                        "Springfield Pwy at Escarpment Drive",
                        "Waterford Rd at Carole Park Primary School",
                        "David St at Stephen Street",
                        "John Street near Skepper St",
                        "Southampton Rd at Sinclair Drive",
                        "Doreen Cr near Southampton Rd",
                        "Southampton Rd near Sinclair Dr",
                        "Sinclair Dr at Julie Road",
                        "Roxwell Street at Roxwell Street",
                        "Roxwell St at Lovat Street",
                        "Grand Ave West near Centennial Way",
                        "Grand Ave at Grand Avenue School",
                        "Grand Ave at Grand Avenue Lake",
                        "Grand Ave at Grand Avenue Cascade",
                        "Grand Ave East near Ascot Ave",
                        "Forest Lake Shops",
                        "Forest Lake Bvd at Forest Lake Shops",
                        "Forest Lake Bvd at Kensington Way",
                        "Wadeville St Heathwood Rise",
                        "Wadeville St at Wadeville West",
                        "Parkwood Dr North near Beech St",
                        "Parkwood Dr near Coolibah St",
                        "Parkwood Dr at Parkwood Drive South",
                        "Parkwood Dr near Juniper St",
                        "Stapylton Rd near Stradbroke St",
                        "Johnson Rd near Paradise Rd",
                        "Peverell St near Newburn St",
                        "Peverell St near Clabon St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Silvertop St near Hoop St",
                        "Silvertop St at Silvertop Park",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 1A",
                        "Browns Plains station, stop 2A",
                        "Conifer St near Ponderosa St",
                        "Conifer St at Cosway St",
                        "Johnson Rd near Dickman Rd",
                        "Parkwood Dr near Acacia St",
                        "Parkwood Dr North near Laurel St",
                        "Roxwell Street near Bagnall St",
                        "Doreen Crescent near Southampton Rd",
                        "Doreen Cr at Southampton Road",
                        "Southampton Rd at Doreen Crescent",
                        "John Street near Julie Rd",
                        "Muriel Ave at Stephen Street"
                    ],
                    "535: Flagstone - Browns Plains": [
                        "Gateway Dr at Elizabeth Drive",
                        "Trailblazer Dr at Meeds Lane",
                        "Flagstonian Dr at Trailblazer Dr",
                        "Homestead Dr at Gates Rd",
                        "Poinciana Dr at Flagstone Schools",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Hives Rd",
                        "Pub Lane at Greenbank Shopping Centre",
                        "Greenbank RSL park 'n' ride",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2A"
                    ],
                    "539: Helidon - Rosewood": [
                        "Lake Apex Dr at Gatton Apex Park",
                        "Turner St at Helidon",
                        "William St at Laidley",
                        "William St at Larkin Street",
                        "Anzac Ave at Grantham",
                        "William St at Laidley District Hospital",
                        "Gatton station",
                        "Mary St at Mary Street Community Centre",
                        "Spencer St at Old College Road",
                        "Drayton St at Laidley Pioneer Village",
                        "Ipswich St at Grandchester",
                        "Main Dr at UQ Gatton Campus",
                        "Victoria St at Forest Hill",
                        "Rosewood Laidley Rd at Alfred Street",
                        "Rosewood Laidley Rd at Calvert",
                        "Rosewood Laidley Rd at Lanefield",
                        "Lanefield Rd at Rosewood High School",
                        "Railway St at Rosewood station",
                        "Western Dr at Gatton Apex Park"
                    ],
                    "540: Beaudesert - Browns Plains": [
                        "Anna St at William Street",
                        "Brisbane St at Beaudesert Central Shopping Centre",
                        "Brisbane St at Turbot Street",
                        "Mount Lindesay Hwy at Dick Westerman Park",
                        "Mount Lindesay Hwy at Gleneagle School",
                        "Mount Lindesay Hwy at Woodhill School",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Brisbane St near Mount Lindesay Hwy",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Trace Road at Wearing Rd",
                        "Service Rd at St Aldwyn Rd",
                        "Stanley Ct at Crowson Lane",
                        "Granger Rd near Eastern Service Rd",
                        "Park Ridge park 'n' ride stop B",
                        "Mount Lindesay Hwy at Greenbank Gardens",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 1A",
                        "Browns Plains station, stop 2B",
                        "Trace Rd at Wearing Rd",
                        "Mount Lindesay Hwy near South St",
                        "Mount Lindesay Hwy at Beaudesert High"
                    ],
                    "541: Greenbank - Browns Plains via Boronia Heights": [
                        "Park Ridge park 'n' ride stop B",
                        "Vinyard Drv at Colville St",
                        "Andrew Rd near Mount Lindesay Hwy",
                        "Andrew Rd at Baratt Dr",
                        "Birdsville St near Andrew Rd",
                        "Lennons Rd near Birdsville St",
                        "Carlton Rd near Middle Rd",
                        "Wild St near Cunningham Dr",
                        "Wilton Cr near Flinders Cr",
                        "Wilton Cr near Parklands Dr",
                        "Parklands Dr near Samantha St",
                        "Tovey Rd near Mitchell St",
                        "Tovey Rd at Macquarie Street",
                        "Middle Rd near Tovey Rd",
                        "Middle Rd at Parklands Dr",
                        "Mackellar Dr near Rick Ct",
                        "Eugene St near Yvonne Dr",
                        "Eugene St near Coronation Rd",
                        "Middle Rd at Federation Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Wineglass Dr",
                        "Greenbank RSL park 'n' ride",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 1A",
                        "Browns Plains station, stop 2B",
                        "Middle Rd at Coronation Rd",
                        "Eugene St near Barry St",
                        "Tovey Rd near Macquarie St",
                        "Tovey Rd near Tasman Ct",
                        "Parklands Dr near Titan Ct",
                        "Hilton Rd near Lennons Rd",
                        "Hilton Rd near Kallioota St",
                        "Kallioota St near Kamarga Ct",
                        "Kallioota St near Birdsville St"
                    ],
                    "542: Browns Plains - Park Ridge": [
                        "Park Ridge park 'n' ride stop B",
                        "Crest Rd at Boulia St",
                        "Crest Rd near Lennons Rd",
                        "Short St near Moreton St",
                        "Short St near Whetton Ct",
                        "Short St near Parklands Dr",
                        "Short St near Kadlunga Ct",
                        "Fedrick St near Short St",
                        "Fedrick St at Tenielle Street",
                        "Fedrick St near Foxhall St",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Lamberth Rd near Great Ct",
                        "Lamberth Rd near Regal Dr",
                        "Lamberth Rd at Leis Way",
                        "Lamberth Rd at Bushland Drive",
                        "Lamberth Rd near Waller Rd",
                        "Waller Rd near Lamberth Rd",
                        "Waller Rd near Renee St",
                        "Waller Rd near Vansittart Rd",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Browns Plains Rd",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 1A",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Waller Rd near Ammons St",
                        "Waller Rd near Rossmore St",
                        "Waller Rd near Widewood Ct",
                        "Waller Rd near Lamberth Rd East",
                        "Lamberth Rd near Pinnacle Cl",
                        "Emerald Dr at Green Rd",
                        "Green Rd near Emerald Dr",
                        "Fedrick St near Tenielle St",
                        "Crest Rd at Punter St"
                    ],
                    "543: Browns Plains - Heritage Park": [
                        "Browns Plains station, stop 2B",
                        "Vansittart Rd near Estramina Rd",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Widewood Ct",
                        "Waller Rd near Lamberth Rd East",
                        "Waller Rd near Charlton Pl",
                        "Green Rd at Isle of Ely Drive",
                        "Bayliss Rd near Green Rd",
                        "Bayliss Rd near Heritage Bvd",
                        "Hawthorn St near Taylor St",
                        "Grier Dr near Montgomery Ct",
                        "Bayliss Rd near Grier Dr",
                        "Bayliss Rd near Volstead Rd",
                        "Bayliss Rd near Hawthorn St",
                        "Bayliss Rd at Heritage Boulevard Park",
                        "Waller Rd near Lamberth Rd",
                        "Waller Rd near Renee St",
                        "Vansittart Rd near Volant St",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 1A"
                    ],
                    "545: Browns Plains - Griffiths University": [
                        "Browns Plains station, stop 2A",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Browns Plains Rd at Forestglen Park",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Campden Street",
                        "Logan Metro Sports Complex",
                        "Browns Plains Rd at Magnesium Drive",
                        "Browns Plains Rd at Fifth Avenue",
                        "Browns Plains Rd at Third Avenue",
                        "Browns Plains Rd at Second Avenue",
                        "Browns Plains Rd at Pedder Street",
                        "Browns Plains Rd at Emerald Street",
                        "Browns Plains Rd at Birch Street",
                        "Browns Plains Rd at Blue Gum Drive",
                        "Browns Plains Rd at Havenbah Park",
                        "Chambers Flat Rd at Mark Lane",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Lancaster Park",
                        "Kingston Rd at Monash Road",
                        "Kingston Rd at Station Road",
                        "Kingston Rd at Gould Adams Park",
                        "Kingston Rd at Augustus Street",
                        "Kingston Rd at Edith Street",
                        "Kingston Rd at Market Square",
                        "Wembley Rd at Logan City Centre",
                        "Logan Central station, platform 1",
                        "Wembley Rd at Wilbur Street",
                        "Woodridge station",
                        "North Rd at Defiance Road",
                        "North Rd at Albert Park",
                        "North Rd at Bruce Road",
                        "Smith Rd at Lindley Street",
                        "Smith Rd at Andella Street",
                        "Smith Rd at Ewing Road",
                        "Smith Rd at Harrisfields Primary School",
                        "Kingston Rd at Park Road",
                        "Kingston Rd at Rudge Street",
                        "Kingston Rd at Booran Drive",
                        "Kingston Rd at Kenway Drive",
                        "Kingston Rd near Parramatta Rd",
                        "Kingston Rd at Curban Street",
                        "Logan Rd at Celia Street",
                        "Logan Rd at Harris Road",
                        "Eight Mile Plains Primary School",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Logan Rd at Underwood Villas",
                        "Kingston Rd at Ferguson Street",
                        "Kingston Rd at Compton Rd",
                        "Kingston Rd at Monte Street",
                        "Wembley Rd at Ewing Road",
                        "Logan Central station, platform 2",
                        "Browns Plains Rd near Campden St",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 1A"
                    ],
                    "546: Park Ridge - City via Greenbank & Griffith Uni": [
                        "Park Ridge park 'n' ride stop A",
                        "Greenbank RSL park 'n' ride",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 82",
                        "Edward Street Stop 146 at Stamford Plaza",
                        "Alice Street Stop 102 at George St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2"
                    ],
                    "547: Browns Plains - Woodridge": [
                        "Browns Plains station, stop 2A",
                        "Trinity Way at Mirthwood Drive",
                        "Trinity Way at Westcott St",
                        "MacQuarie Way at Lockyer Place",
                        "MacQuarie Way near Buckley Drive",
                        "MacQuarie Way near Wembley Rd",
                        "Anderson St at Freshwater Dr",
                        "Cedarwood St at Equinox St",
                        "Attewood Ave at Demeio Rd",
                        "Gilmore Rd at Third Ave",
                        "Bardon Rd at Pope Street",
                        "Bardon Rd at Rudduck Street",
                        "Wembley Rd at Lennox Ct",
                        "Woodridge station",
                        "Blackwood Rd near Croydon Rd",
                        "Bardon Rd at Sycamore Ct",
                        "Cedarwood St at Fairweather St",
                        "MacQuarie Way at Buckley Drive",
                        "Browns Plains station, stop 1A"
                    ],
                    "550: Springwood - Browns Plains": [
                        "Kingston station",
                        "Browns Plains station, stop 1B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Jacaranda Ave at Daisy Court",
                        "Browns Plains Rd at Forestglen Park",
                        "Jacaranda Ave at Ashton Street",
                        "Browns Plains Rd at Oakdale Park",
                        "Jacaranda Ave at Lillie Avenue",
                        "Browns Plains Rd at Wembley Road",
                        "Jacaranda Ave at Brownhill Street",
                        "Browns Plains Rd at Campden Street",
                        "Jacaranda Ave at Administration Centre",
                        "Wembley Rd at Ewing Road",
                        "Logan Metro Sports Complex",
                        "Browns Plains Rd at Magnesium Drive",
                        "Logan Central station, platform 2",
                        "Fifth Ave at Christina Way",
                        "Kingston Rd at Jean Street",
                        "Fifth Ave at Robinson Court",
                        "Kingston Rd near Pilbi St",
                        "Macarthy Rd at Devine Street",
                        "Kingston Rd at Woodridge Adventure Park",
                        "Park Rd at Kookaburra Park",
                        "Macarthy Rd near Third Av",
                        "Park Rd at Logan Palms",
                        "Macarthy Rd near Chasbet St",
                        "Coolmunda St at Ari Street",
                        "Pacific Hwy at Park Road",
                        "Coolmunda St at Kinchant Park",
                        "Pacific Hwy at Moss Street",
                        "Coolmunda St at First Avenue",
                        "Springwood station, platform 2",
                        "Homestead St near Galahad St",
                        "Homestead St at Pauline Street",
                        "Pauline St at Lynelle Street",
                        "Pauline St at Princess Street",
                        "Kurrajong Dr at Blue Gum Drive",
                        "Tamarind St at Marsden Park Shops",
                        "Chambers Flat Rd at Mark Lane",
                        "Muchow Rd near Moffatt Rd",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd at Clearview Street",
                        "Logan Reserve Rd near Hydrangea St",
                        "Beutel St at Lexham St",
                        "Beutel St at Tygum Road",
                        "Kingston Rd at Waterford West Primary",
                        "Allora St at John St",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd at Haig Street",
                        "Station Rd near Montecarlo Cl",
                        "Station Rd near Jellicoe St",
                        "Kingston Rd at Gould Adams Park",
                        "Station Rd at Jellicoe Street",
                        "Park Rd at Watland Street",
                        "Station Rd at Haig Road",
                        "Kingston Rd at Akora Street",
                        "Kingston Rd near Paradise Rd",
                        "Wembley Rd at Logan City Centre",
                        "Logan Central station, platform 1",
                        "Wembley Rd at Wilbur Street",
                        "Short St at Allora St",
                        "Jacaranda Ave at Huntress Park",
                        "Jacaranda Ave at Poincettia Street",
                        "Muchow Rd near Clearview St",
                        "Pauline St near Leanne St",
                        "Macarthy Rd at Kurilpa Street",
                        "Macarthy Rd at Fifth Avenue",
                        "Browns Plains Rd near Campden St",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 1A"
                    ],
                    "551: Brisbane City - Crestmead": [
                        "Bumstead Rd at Wisdom Way",
                        "Julie St at Bumstead Road",
                        "Julie St at Brabham Park",
                        "Julie St at Wallace Street",
                        "Augusta St at Pinnington Park",
                        "Trulson Dr near Limerick Dr",
                        "Third Ave near Macarthy Rd",
                        "Macarthy Rd near Chasbet St",
                        "Coolmunda St at Ari Street",
                        "Coolmunda St at Kinchant Park",
                        "Coolmunda St at First Avenue",
                        "Homestead St near Galahad St",
                        "Homestead St at Pauline Street",
                        "Pauline St at Lynelle Street",
                        "Pauline St at Princess Street",
                        "Kurrajong Dr at Blue Gum Drive",
                        "Tamarind St at Marsden Park Shops",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Lancaster Park",
                        "Kingston Rd at Monash Road",
                        "Kingston Rd at Station Road",
                        "Kingston Rd at Gould Adams Park",
                        "Kingston Rd at Augustus Street",
                        "Kingston Rd at Edith Street",
                        "Kingston Rd at Market Square",
                        "Kingston Rd at Jean Street",
                        "Kingston Rd near Pilbi St",
                        "Kingston Rd at Woodridge Adventure Park",
                        "Park Rd at Kookaburra Park",
                        "Park Rd at Logan Palms",
                        "Pacific Hwy at Park Road",
                        "Pacific Hwy at Moss Street",
                        "Springwood station, platform 1",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Park Rd at Watland Street",
                        "Kingston Rd at Akora Street",
                        "Kingston Rd near Paradise Rd",
                        "Pauline St near Leanne St",
                        "Third Ave at Burrows School",
                        "Trulson Dr near Coachwood St",
                        "Trulson Dr near Brushbox St"
                    ],
                    "552: Kingston - Loganholme": [
                        "Kingston station",
                        "Jacaranda Ave at Daisy Court",
                        "Attunga St near Poincettia St",
                        "Attunga St near Karabil St",
                        "Juers St near Polaris Ave",
                        "Polaris Ave near Sapium St",
                        "West Bega Rd near Polaris Ave",
                        "Velorum Dr near Antares Ave",
                        "Velorum Dr near Cabernet Ct",
                        "Velorum Dr near Anchusa St",
                        "Velorum Dr near Cognac Ct",
                        "Apodis St near Aquarius Dr",
                        "Juers St near Bellatrix Dr",
                        "Juers St near Rigel St",
                        "Lyngrove St near Alderbaran Dr",
                        "Bardon Rd near Ashton St",
                        "Bardon Rd at Pope Street",
                        "Bardon Rd at Rudduck Street",
                        "Wembley Rd at Lennox Ct",
                        "Wembley Rd at Ewing Road",
                        "Logan Central station, platform 1",
                        "Wembley Rd at Wilbur Street",
                        "Woodridge station",
                        "North Rd at Defiance Road",
                        "North Rd at Albert Park",
                        "North Rd at Bruce Road",
                        "North Rd near Victoria St",
                        "Parkdale St near Deodar St",
                        "Cypress St near Hunter St",
                        "Hunter St near Ormesby St",
                        "Avoca St near Ormesby St",
                        "Fairdale St near Ewing Rd",
                        "Ewing Rd near Monash St",
                        "Ewing Rd near Karen St",
                        "Smith Rd at Harrisfields Primary School",
                        "Kingston Rd at Woodridge Adventure Park",
                        "Reserve Rd near Gomana St",
                        "Lake Rd near Endota St",
                        "Lake Rd near Carribean Dr",
                        "Pacific Hwy at IKEA",
                        "Pacific Hwy at Segovia Way",
                        "Winnetts Rd near Dahlia St",
                        "Shailer Rd at Hester St",
                        "Shailer Rd near Oregon Dr",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop F",
                        "Mandew St at Hyperdome",
                        "Plantain Rd at Mandew Street",
                        "Shailer Rd near Hester St",
                        "Shailer Rd near Francis Rd",
                        "Lake Rd near Reserve Rd",
                        "Reserve Rd near Kunari St",
                        "Avoca St near Avoca Lane",
                        "Willow St at Cypress St",
                        "Parkdale St near North Rd",
                        "North Rd at Smith Rd",
                        "Bardon Rd at Sycamore Ct",
                        "Lyngrove St near Ariel Ave",
                        "Velorum Dr at Cognac Court",
                        "Attunga St near Poinciana St",
                        "Attunga St near Ewinga St",
                        "Jacaranda Ave at Poincettia Street"
                    ],
                    "553: Trinder Park - Beenleigh": [
                        "Beenleigh station, stop A",
                        "Alamein St at Beenleigh High School",
                        "Alamein St near Lae St",
                        "Alamein St near Juniper Ct",
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Drews Rd near Barokee Dr",
                        "Jalan St near Murrami Ct",
                        "Pintu Dr near Tanah Merah Ave",
                        "Loganholme, stop F",
                        "Mandew St at Hyperdome",
                        "Mandew St at Plantain Road",
                        "Pacific Hwy at Alfred Street",
                        "Pacific Hwy at Springlands Drive",
                        "Pacific Hwy at Centenary Road",
                        "Slacks Creek park 'n' ride stop B",
                        "Queens Rd near Meakin Rd",
                        "Meakin Rd near Plain St",
                        "Veldt St near Rowanda St",
                        "Veldt St near Lowry St",
                        "Wagensveldt St near Renita St",
                        "Wagensveldt St near Evelyn St",
                        "Wagensveldt St near Atikinson St",
                        "Windsor St near Balmoral St",
                        "Windsor St near Crown St",
                        "Windsor St near Andrew St",
                        "Royal Pde near Queens Rd",
                        "Queens Rd near Arch St",
                        "Adelaide St near Queens Rd",
                        "George St at Clare Road",
                        "Clare Rd near Brisbane St",
                        "Clare Rd near Kingston Rd",
                        "Kingston Rd at Augustus Street",
                        "Mayes Ave near Kingston Rd",
                        "Mayes Ave near Veryan St",
                        "Mayes Ave near David St",
                        "Mayes Ave near Huntress Ct",
                        "Mayes Ave near Heather St",
                        "Mayes Ave near Leichardt St",
                        "Logan Central station, platform 1",
                        "Wembley Rd at Wilbur Street",
                        "Wembley Rd at Ewing Road",
                        "Railway Pde near Flinders St",
                        "Railway Pde near Garfield Rd",
                        "Railway Pde near Muller Rd",
                        "Railway Pde at Pamela Cr",
                        "Railway Pde near Elizabeth St",
                        "Railway Parade at Trinder Street",
                        "Trinder Park Retirement Village",
                        "Loganholme, stop H",
                        "Laurel St near Railway Pde",
                        "Jalan St near Nandala Dr",
                        "Railway Pde near Pamela Cr",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Clarks Rd near Dewar Drive",
                        "Mayes Ave near Curry St",
                        "Clarks Rd near Corndale St",
                        "River Hills Rd near Eagle Dr",
                        "Mayes Ave near Horton St",
                        "George St near Augustus St",
                        "Queens Rd near Royal Pde",
                        "Royal Pde near Duke St",
                        "Windsor St near Snowdon St",
                        "Wagensveldt St near Magill Rd",
                        "Meakin Rd at Plain Street",
                        "Loganlea Rd near Golf Course Dr",
                        "Slacks Creek park 'n' ride stop A",
                        "Murrays Road near Mandew St",
                        "Mandew St at Mandew Park"
                    ],
                    "554: Griffith Uni - Logan Central": [
                        "Beenleigh Rd at Kuraby station, stop 92",
                        "Logan Central station, platform 1",
                        "Beenleigh Rd at Kuraby Primary School",
                        "Wembley Rd at Wilbur Street",
                        "Stiller Dr at Beenleigh Rd, stop 90",
                        "Woodridge station",
                        "Stiller Dr at Balmoral St, stop 89",
                        "Blackwood Rd near Croydon Rd",
                        "Stiller Dr at Crestwood St, stop 88",
                        "Ewing Rd near Albert St",
                        "Stiller Dr at Redland Close, stop 87",
                        "Ewing Rd near Defiance Rd",
                        "Franquin Cr at Underwood Rd, stop 86",
                        "Ewing Rd near Orchid St",
                        "Underwood Rd at Levington, stop 85",
                        "Ewing Rd near Smith Rd",
                        "Smith Rd at Ewing Road",
                        "Levington Rd at Settler Street",
                        "Levington Rd at RACQ, stop 84",
                        "Smith Rd at Andella Street",
                        "Eight Mile Plains station, platform 1",
                        "Smith Rd at Lindley Street",
                        "Upper Mt Gravatt station, platform 1",
                        "Smith Rd near Douglas St",
                        "Griffith University station, platform 1",
                        "Station Rd near Victoria St",
                        "Nyanza St near Nydia St",
                        "Nyanza St near Mikaga Ct",
                        "Compton Rd near North Rd",
                        "Compton Rd near Pendrey Ct",
                        "Springwood station, platform 1",
                        "Springwood Rd at Sports Drive",
                        "Logan Rd near Kingston Rd",
                        "Beenleigh Rd at Logan Road",
                        "Strathmore St at Kuraby station, stop 92",
                        "Winifred St near Chesterfield Cr",
                        "Donegal St at Beenleigh Rd, stop 93",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Levington Rd at Settler St",
                        "Underwood Rd at Levington Rd, stop 85",
                        "Stiller Dr at Woodglen St, stop 87",
                        "Beenleigh Rd near Stiller Dr",
                        "Springwood station, platform 2",
                        "Compton Rd near Allgas St",
                        "Smith Rd near Plunkett St",
                        "Ewing Rd near Burrigan St",
                        "Wembley Rd at Ewing Road"
                    ],
                    "555: Brisbane City - Loganholme": [
                        "Loganholme, stop B",
                        "Springwood station, platform 1",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Queen Street Stop 72 near Eagle Lane",
                        "Cordelia St at Brisbane State High, stop 3",
                        "Stephens Rd near Brook St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Stephens Rd at St Laurences College, stop 7",
                        "Adelaide Street Stop 46 near George St",
                        "Buranda busway, platform 2",
                        "Cultural Centre station, platform 2",
                        "Greenslopes station, platform 2",
                        "South Bank busway station, platform 2",
                        "Holland Park West station, platform 2",
                        "Mater Hill station, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Springwood station, platform 2"
                    ],
                    "560: Browns Plains - Loganholme": [
                        "Browns Plains station, stop 1B",
                        "Vansittart Rd near Estramina Rd",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd at Solandra Circuit",
                        "Green Rd at Sunrise Court",
                        "Green Rd at Isle of Ely Drive",
                        "Green Rd near Heritage Bvd",
                        "Green Rd near Cockatoo Court",
                        "Green Rd at Blue Wren Place",
                        "Green Rd near Venture St",
                        "Bumstead Rd near Clarke Rd",
                        "Julie St at Bumstead Road",
                        "Julie St at Brabham Park",
                        "Julie St at Wallace Street",
                        "Augusta St at Pinnington Park",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Crestmead Park",
                        "Waratah Dr at Ramin Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Whiteman Street",
                        "Chambers Flat Rd at Marsden Works Depot",
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Mark Lane",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Lancaster Park",
                        "Monash Rd at Rellam Road",
                        "Monash Rd at Jellicoe Street",
                        "Monash Rd at Knight Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station",
                        "Armstrong Rd at Logan Hospital",
                        "Armstrong Rd at Loganlea TAFE",
                        "Edenlea Dr at Berendt Court",
                        "Edenlea Dr at Kilsay Crescent",
                        "Edenlea Dr at Edenlea Park",
                        "Edenlea Dr at Meadowbrook Shopping Centre",
                        "University Dr at Griffith Uni Logan Campus",
                        "University Dr at Griffith University Logan",
                        "Loganlea Rd near Ellerslie Rd",
                        "Loganlea Rd near Golf Course Dr",
                        "Slacks Creek park 'n' ride stop A",
                        "Pacific Hwy at Centenary Road",
                        "Pacific Hwy at Alfred Street",
                        "Murrays Road near Mandew St",
                        "Mandew St at Plantain Road",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop A",
                        "Mandew St at Hyperdome",
                        "Pacific Hwy at Springlands Drive",
                        "Slacks Creek park 'n' ride stop B",
                        "Monash Rd near Rellam Rd",
                        "Chambers Flat Rd at Oakwood Drive",
                        "Green Rd at Cockatoo Court",
                        "Emerald Dr at Green Road",
                        "Emerald Dr near Colisa Cr",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 1A"
                    ],
                    "561: Brisbane City - Crestmead": [
                        "Bumstead Rd at Wisdom Way",
                        "Bumstead Rd near Judith St",
                        "Julie St at Bumstead Road",
                        "Julie St at Brabham Park",
                        "Julie St at Wallace Street",
                        "Augusta St at Pinnington Park",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Crestmead Park",
                        "Waratah Dr at Ramin Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Whiteman Street",
                        "Chambers Flat Rd at Marsden Works Depot",
                        "Muchow Rd near Moffatt Rd",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd at Clearview Street",
                        "Logan Reserve Rd near Hydrangea St",
                        "Beutel St at Lexham St",
                        "Beutel St at Tygum Road",
                        "Kingston Rd at Waterford West Primary",
                        "Allora St at John St",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd at Haig Street",
                        "Station Rd near Montecarlo Cl",
                        "Station Rd near Jellicoe St",
                        "Kingston Rd at Gould Adams Park",
                        "Kingston Rd at Augustus Street",
                        "Kingston Rd at Edith Street",
                        "Kingston Rd at Market Square",
                        "Kingston Rd at Jean Street",
                        "Kingston Rd near Pilbi St",
                        "Kingston Rd at Woodridge Adventure Park",
                        "Park Rd at Kookaburra Park",
                        "Park Rd at Logan Palms",
                        "Pacific Hwy at Park Road",
                        "Pacific Hwy at Moss Street",
                        "Springwood station, platform 1",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Park Rd at Watland Street",
                        "Kingston Rd at Akora Street",
                        "Kingston Rd near Paradise Rd",
                        "Station Rd at Jellicoe Street",
                        "Station Rd at Haig Road",
                        "Short St at Allora St",
                        "Muchow Rd near Clearview St",
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Oakwood Drive"
                    ],
                    "562: Loganholme - Beenleigh": [
                        "Beenleigh station, stop A",
                        "Alamein St at Beenleigh High School",
                        "Kokoda St near City Rd",
                        "Kokoda St near Bougainville St",
                        "Kokoda St near Boundary St",
                        "Oval St near Catherine St",
                        "Tweedvale St at Meadow Crescent",
                        "Tweedvale St near Lehmans Rd",
                        "Sunrise St near Sunnyview St",
                        "Sunrise St near Sunland St",
                        "Logan River Rd near Harburg Dr",
                        "Holmview Rd near Logan River Rd",
                        "Holmview Rd near Logan Rd",
                        "Holmview Rd near Jarvis St",
                        "Grove Rd near Lima St",
                        "Grove Rd near Dendy Ct",
                        "Avonmore St near Auburn St",
                        "Avonmore St near Melton Ct",
                        "Castile Cr near Avonmore St",
                        "Castile Cr at Edens Parkland",
                        "Loane Dr near Brooke Cl",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Montrose Ave near Clarendon Ave",
                        "Montrose Ave near Mathews St",
                        "Station Rd near Federation Dr",
                        "Bethania station",
                        "Federation Dr near Hayden St",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Copper Dr",
                        "Edinburgh Dr near Fadden Ct",
                        "Edinburgh Rd near Mathews St",
                        "Clarendon Ave at Hinchinbrook Ave",
                        "Goodooga Dr near Albert St",
                        "Allora St at John St",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station",
                        "Armstrong Rd at Logan Hospital",
                        "Armstrong Rd at Loganlea TAFE",
                        "Edenlea Dr at Berendt Court",
                        "Edenlea Dr at Kilsay Crescent",
                        "Edenlea Dr at Edenlea Park",
                        "Edenlea Dr at Meadowbrook Shopping Centre",
                        "Loganlea Rd near Ellerslie Rd",
                        "Loganlea Rd near Golf Course Dr",
                        "Slacks Creek park 'n' ride stop A",
                        "Pacific Hwy at Centenary Road",
                        "Pacific Hwy at Alfred Street",
                        "Murrays Road near Mandew St",
                        "Mandew St at Plantain Road",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop A",
                        "Loganholme, stop D",
                        "Mandew St at Hyperdome",
                        "Pacific Hwy at Springlands Drive",
                        "Slacks Creek park 'n' ride stop B",
                        "Short St at Allora St",
                        "Kingston Rd at Waterford West Shops",
                        "Edinburgh Rd near Fadden Ct",
                        "Federation Dr near Snedden St",
                        "Mathews St near Station Rd",
                        "Montrose Ave near Eastbourne Rd",
                        "King Arthur Bvd near Lynette Ct",
                        "Castile Cr at Overland Dr",
                        "Castile Cr at Clayton Drive",
                        "Avonmore St at Auburn Street",
                        "Grove Rd near Hanby Ct",
                        "Holmview Rd near Jeetho St",
                        "Logan River Rd near Alexandra St",
                        "Sunrise St near Tweedland Cr",
                        "Tweedvale St near Crest St",
                        "Tweedvale St near Meadow Cr",
                        "Oval St near Boundary St",
                        "Kokoda St near Darwin St",
                        "Kokoda St near Cameron St",
                        "Kokoda St near York St"
                    ],
                    "563: Holmview Central - Loganholme": [
                        "Holmview Shops",
                        "Rosella Drv at Menora Rd",
                        "Bahrs Scrub Rd at Hein Rd",
                        "Bahrs Scrub Rd at Prangley Rd",
                        "Prangley Rd at Brookhaven Bvd",
                        "Harburg Dr near Horizon Dr",
                        "Harburg Drive near Benjul Dr",
                        "Harburg Dr near Carrie Cr",
                        "Tallagandra Rd near Nyah St",
                        "Mount Warren Bvd near Lance Dr",
                        "Mount Warren Bvd near Shields St",
                        "Mount Warren Bvd near Honeyman St",
                        "Rochester Dr near Willshire St",
                        "Rochester Dr near Guyra Cl",
                        "Main St near Lubach St",
                        "Main St near Church St",
                        "Beenleigh station, stop A",
                        "George St near Macs Lane",
                        "Fryar Rd near Albert St",
                        "Logan St near Boyd St",
                        "Logan St near Lemongrove St",
                        "Oliver St near Greenfield St",
                        "Oliver St near Shirley St",
                        "Temma St near Magra Ct",
                        "Temma St near River Hills Rd",
                        "River Hills Rd near Thornside St",
                        "Eagleby Shopping Plaza",
                        "Fryar Rd near Beetson Ct",
                        "Fryar Rd at Balmoral Street",
                        "Halliday St at Vautin Way",
                        "Herses Rd near Dion Dr",
                        "Herses Rd at Tarlo Street",
                        "Herses Rd near Copperfield Dr",
                        "Copperfield Dr near Paroo Ct",
                        "Copperfield Dr near Burrum Ct",
                        "Bower Rd near Calliope St",
                        "Swallow St near Finch St",
                        "Swallow St near Lyre St",
                        "River Hills Rd near Laing St",
                        "Cowper Ave near Dryandra Dr",
                        "Sirus St near Roebuck Ave",
                        "River Hills Rd near Eagle Dr",
                        "Burchill St near Riverland Dr",
                        "Burchill St near Chetwynd St",
                        "Chetwynd St near Henry St",
                        "Pacific Hwy near Beenleigh Redland Bay Rd",
                        "Pacific Hwy near Fels St",
                        "Loganholme, stop C",
                        "Swallows St near Dove St",
                        "Herses Rd near Westray Ct",
                        "Herses Rd near Paddington Lane",
                        "Halliday St at Devron Court",
                        "Fryar Rd near Sunscape Dr",
                        "River Hills Rd near Monmouth St",
                        "Main St near Gona St",
                        "Mount Warren Bvd near Ben Lexcen Ct",
                        "Mount Warren Bvd at Shields St",
                        "Harburg Dr near Rogers Ave",
                        "Harburg Dr near Benjul Dr"
                    ],
                    "565: Loganholme - Windaroo": [
                        "Beenleigh station, stop A",
                        "Carl Heck Bvd near Bannockburn Rd",
                        "Alamein St at Beenleigh High School",
                        "Carl Heck Bvd near Hendrix St",
                        "Alamein St near Lae St",
                        "Kaiser Dr near Ernest St",
                        "Alamein St near Juniper Ct",
                        "Kaiser Dr near Lena Pl",
                        "Clarks Rd at Corndale Street",
                        "Kaiser Dr near Carl Heck Bvd",
                        "Clarks Rd near Dewar Dr",
                        "Carl Heck Bvd near Mewing Ct",
                        "Drews Rd near Hampton St",
                        "Windaroo Primary School",
                        "Mount Warren Bvd near Gaynor Ct",
                        "Drews Rd near Wandilla Cr",
                        "Mount Warren Bvd near Magenta Ct",
                        "Drews Rd near Boeing St",
                        "Mount Warren Bvd near Shea Ct",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Robert Stanley Dr near Merrow St",
                        "Drews Rd near Barokee Dr",
                        "Robert Stanley Dr near Doveton Cr",
                        "Jalan St near Murrami Ct",
                        "Vermont Cr near Rochester Dr",
                        "Pintu Dr near Tanah Merah Ave",
                        "Main St near Lubach St",
                        "Loganholme, stop H",
                        "Main St near Church St",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St",
                        "River Hills Rd near Eagle Dr",
                        "Main St near Gona St",
                        "Mount Warren Bvd near Robert Stanley Dr",
                        "Mount Warren Bvd near Yvonne Cr",
                        "Mount Warren Bvd at Windaroo Primary School",
                        "Kaiser Dr near Gustav Way",
                        "Kaiser Dr near Schonwerder Dr",
                        "Carl Heck Bvd near Lennon Dr"
                    ],
                    "567: Beenleigh station - Holmview loop": [
                        "Beenleigh station, stop A",
                        "Holmview Shops",
                        "Glasson Dr at High Rd",
                        "Logan River Rd at Crest St",
                        "Logan River Rd near Harburg Dr",
                        "High Rd at Sabre St",
                        "Jarvis Rd near Woodlands Bvd",
                        "Jarvis Rd at Grand Tce",
                        "Grand Tce at Willow Rise Dr",
                        "Ridgevale Bvd near Amari St",
                        "Tallagandra Rd at Ridgevale Bvd",
                        "Tallagandra Rd at Rockford St",
                        "Pepper Tree Dr at Stoneleigh Way",
                        "Logan River Rd near Alexandra St",
                        "Logan River Rd at Spanns Rd"
                    ],
                    "569: Brisbane City - Loganholme": [
                        "Loganholme, stop D",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2"
                    ],
                    "570: Loganholme - Cornubia (Loop)": [
                        "Loganholme, stop H",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Plantain Rd",
                        "Plantain Rd near Jasmine Cr",
                        "Plantain Rd near Lissadell St",
                        "Parkview Rd near Gyles Ct",
                        "Parkview Cr near Aster Ct",
                        "Blackbutt St at Verbena Street",
                        "Glenvale St near Kilkenny St",
                        "Kilkenny St near Surrey St",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd at California Creek Road",
                        "Logandale Bvd near Beenleigh Redland Bay Rd",
                        "Beenleigh Redland Bay Rd near California Creek Rd",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd near Belbora Rd"
                    ],
                    "572: Springwood - Loganholme": [
                        "Loganholme, stop G",
                        "Mandew St at Hyperdome",
                        "Plantain Rd at Mandew Street",
                        "Plantain Rd at Blackthorn Crescent",
                        "Plantain Rd at Narcamus Crescent",
                        "Kimberley Dr near Chatswood Rd",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Chatswood Rd near Voltaire St",
                        "Chatswood Rd at Koolan Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Chatswood Rd at John Paul College",
                        "Chatswood Rd near Evenwood St",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at Brentwood Drive",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Hawkins Street",
                        "Barbaralla Dr at Burgallby Road",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Wenlock Cr at Wyclif Avenue",
                        "Rochedale Rd at Springwood Plaza",
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "Kimberley Dr at Chatswood Rd",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park"
                    ],
                    "573: Brisbane City - Loganholme via Daisy Hill": [
                        "Loganholme, stop G",
                        "Mandew St at Hyperdome",
                        "Plantain Rd at Mandew Street",
                        "Plantain Rd at Blackthorn Crescent",
                        "Plantain Rd at Narcamus Crescent",
                        "Kimberley Dr near Chatswood Rd",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Chatswood Rd near Voltaire St",
                        "Chatswood Rd at Koolan Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Chatswood Rd at John Paul College",
                        "Chatswood Rd near Evenwood St",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at Brentwood Drive",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Hawkins Street",
                        "Barbaralla Dr at Burgallby Road",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Wenlock Cr at Wyclif Avenue",
                        "Rochedale Rd at Springwood Plaza",
                        "Springwood station, platform 1",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "Kimberley Dr at Chatswood Rd",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park"
                    ],
                    "574: Loganholme - Springwood": [
                        "Loganholme, stop G",
                        "Borambil Rd at Feluga Street",
                        "Borambil Rd at Porang Street",
                        "Alba Street near Borambil Rd",
                        "Blackthorn Cr at Adelong Road",
                        "Plantain Rd at Blackthorn Crescent",
                        "Roselea St at Cooba Court",
                        "Roselea St at Hailar Street",
                        "Roselea St at Roselea Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Clivia Crescent at Lyndale Street",
                        "Allamanda Dr at Usher Park",
                        "Allamanda Dr at Allamanda Drive Shops",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Highview Terrace",
                        "Springwood Rd at Kinloch Road",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Dennis Road",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at McCormack Court",
                        "Springwood Road State School",
                        "Springwood Rd at Pannikin Street",
                        "Cinderella Dr at Collene Grove",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood station, platform 3",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd near Knox Ct",
                        "Roselea St at Kimberley Plaza"
                    ],
                    "575: Brisbane City - Loganholme via Daisy Hill": [
                        "Loganholme, stop G",
                        "Borambil Rd at Feluga Street",
                        "Borambil Rd at Porang Street",
                        "Alba Street near Borambil Rd",
                        "Blackthorn Cr at Adelong Road",
                        "Plantain Rd at Blackthorn Crescent",
                        "Roselea St at Cooba Court",
                        "Roselea St at Hailar Street",
                        "Roselea St at Roselea Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Clivia Crescent at Lyndale Street",
                        "Allamanda Dr at Usher Park",
                        "Allamanda Dr at Allamanda Drive Shops",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Highview Terrace",
                        "Springwood Rd at Kinloch Road",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Dennis Road",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at McCormack Court",
                        "Springwood Road State School",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Rd at Cinderella Drive",
                        "Springwood Rd at Sports Drive",
                        "Springwood station, platform 1",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Springwood Rd near Knox Ct",
                        "Roselea St at Kimberley Plaza"
                    ],
                    "576: Griffith Uni - Springwood": [
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Parkwood St",
                        "Stellaris Way near Atra Ct",
                        "Belmore Dr near Kallista Rd",
                        "Pandeen Rd near Neerim St",
                        "Milperra Rd near Ranbini St",
                        "Gallang St near Glengala Dr",
                        "Glengala Dr near Kala St",
                        "Glengala Dr at Morbani Road",
                        "Priestdale Rd at William Street",
                        "William St near Cunningham St",
                        "Woodlands Dr near Stirling St",
                        "Devon St near Woodlands Dr",
                        "Devon St near Boskenne St",
                        "Somerset St near Devon St",
                        "Somerset St near Amanda St",
                        "Underwood Rd near Somerset St",
                        "Underwood Rd near Dalhouse Ct",
                        "Underwood Rd near Gerrans St",
                        "Underwood Rd near Centre Pl",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Underwood Rd near Rochedale Rd",
                        "Underwood Rd at Graham Hogg Park",
                        "Devon St near Trevelloe St",
                        "Woodlands Dr near Hindmarsh Ct",
                        "William St near Landsborough St",
                        "Glengala Dr near Morbani Rd",
                        "Glengala Dr near Gilandra St",
                        "Gallang St near Milperra Rd",
                        "Milperra Rd near Kancoona St",
                        "Stellaris Way near Parfrey Rd",
                        "Parfrey Rd near Lancefield Pl",
                        "Springwood Rd at McCormack Court",
                        "Cinderella Dr at Collene Grove"
                    ],
                    "577: Brisbane City - Springwood via Rochedale South": [
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Parkwood St",
                        "Stellaris Way near Atra Ct",
                        "Belmore Dr near Kallista Rd",
                        "Pandeen Rd near Neerim St",
                        "Milperra Rd near Ranbini St",
                        "Gallang St near Glengala Dr",
                        "Glengala Dr near Kala St",
                        "Glengala Dr at Morbani Road",
                        "Priestdale Rd at William Street",
                        "William St near Cunningham St",
                        "Woodlands Dr near Stirling St",
                        "Devon St near Woodlands Dr",
                        "Devon St near Boskenne St",
                        "Somerset St near Devon St",
                        "Somerset St near Amanda St",
                        "Underwood Rd near Somerset St",
                        "Underwood Rd near Dalhouse Ct",
                        "Underwood Rd near Gerrans St",
                        "Underwood Rd near Centre Pl",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Underwood Rd near Rochedale Rd",
                        "Underwood Rd at Graham Hogg Park",
                        "Devon St near Trevelloe St",
                        "Woodlands Dr near Hindmarsh Ct",
                        "William St near Landsborough St",
                        "Glengala Dr near Morbani Rd",
                        "Glengala Dr near Gilandra St",
                        "Gallang St near Milperra Rd",
                        "Milperra Rd near Kancoona St",
                        "Stellaris Way near Parfrey Rd",
                        "Parfrey Rd near Lancefield Pl",
                        "Springwood Rd at McCormack Court",
                        "Cinderella Dr at Collene Grove"
                    ],
                    "578: Springwood - Griffith Uni": [
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at Dennis Road",
                        "Dennis Rd near Springwood Rd",
                        "Exilis St near York Cl",
                        "Exilis St near Hush Pl",
                        "Exilis St near Jules Ave",
                        "Exilis St near Minutus St",
                        "Exilis St near Nule St",
                        "Exilis St near Underwood Rd",
                        "Chung Tian Temple",
                        "Underwood Rd near Belmore Dr",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Cilla Ct",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Koobil St",
                        "Koobil St near Sunningdale Ave",
                        "Koobil St near Greenview Ave",
                        "Greenview Ave near Justora St",
                        "Justora St near Rangeview St",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Miles Platting Rd near Rochedale Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Miles Platting Rd at Gardner Rd",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd near Underwood Rd",
                        "Greenview Ave near Esma St",
                        "Koobil St near Esma St",
                        "Koobil St near Binnalong St",
                        "Underwood Rd near Winston St",
                        "Underwood Rd near Lancelot St",
                        "Exilis St near Finfoot St",
                        "Exilis St near Evette Cl",
                        "Exilis St near Kent Cl",
                        "Springwood Rd at McCormack Court",
                        "Cinderella Dr at Collene Grove"
                    ],
                    "579: Brisbane City - Springwood via Rochedale South": [
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Parfrey Rd near Dorset Dr",
                        "Dorset Dr near Lea Ct",
                        "Dorset Dr near Flanagan Ct",
                        "Exilis St near Hush Pl",
                        "Exilis St near Jules Ave",
                        "Exilis St near Minutus St",
                        "Exilis St near Nule St",
                        "Exilis St near Underwood Rd",
                        "Underwood Rd near Belmore Dr",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Cilla Ct",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Koobil St",
                        "Koobil St near Sunningdale Ave",
                        "Koobil St near Greenview Ave",
                        "Greenview Ave near Justora St",
                        "Justora St near Rangeview St",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Miles Platting Rd near Rochedale Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Miles Platting Rd at Gardner Rd",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd near Underwood Rd",
                        "Greenview Ave near Esma St",
                        "Koobil St near Esma St",
                        "Koobil St near Binnalong St",
                        "Underwood Rd near Winston St",
                        "Underwood Rd near Lancelot St",
                        "Exilis St near Finfoot St",
                        "Exilis St near Evette Cl",
                        "Dorset Dr near Cornwall Cl",
                        "Springwood Rd at McCormack Court",
                        "Cinderella Dr at Collene Grove"
                    ],
                    "580: Springwood - Meadowbrook": [
                        "Armstrong Rd at Logan Hospital",
                        "Armstrong Rd at Loganlea TAFE",
                        "Edenlea Dr at Berendt Court",
                        "Edenlea Dr at Kilsay Crescent",
                        "Edenlea Dr at Edenlea Park",
                        "Edenlea Dr at Meadowbrook Shopping Centre",
                        "University Dr at Griffith Uni Logan Campus",
                        "University Dr at Griffith University Logan",
                        "Loganlea Rd near Ellerslie Rd",
                        "Loganlea Rd near Golf Course Dr",
                        "Slacks Creek park 'n' ride stop A",
                        "Slacks Creek park 'n' ride stop B",
                        "Pacific Hwy at Segovia Way",
                        "Pacific Hwy at Park Road",
                        "Pacific Hwy at Moss Street",
                        "Springwood station, platform 1",
                        "Springwood station, platform 2",
                        "Park Rd at Watland Street"
                    ],
                    "581: Brisbane City - Slacks Creek": [
                        "Slacks Creek park 'n' ride stop A",
                        "Springwood station, platform 1",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Buranda busway, platform 1",
                        "Elizabeth Street Stop 81 near George St",
                        "Edward Street Stop 145",
                        "Alice Street Stop 100 at Albert St",
                        "Buranda busway, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2"
                    ],
                    "587: Yarrabilba - Loganlea Station, Hospital and Tafe": [
                        "Wentland av at South Rock State School",
                        "Yarrabilba Dr at Fauna Way",
                        "Yarrabilba Dr at Woodward Ave",
                        "Yarrabilba Dr at Yarrabilba State School",
                        "Yarrabilba Dr at Combs St",
                        "Yarrabilba Dr at Darlington Dr",
                        "Yarrabilba Dr Shopping Precinct",
                        "Waterford Tamborine Rd at Hotz Rd",
                        "Waterford Tamborine Rd at Pioneer Dr",
                        "Waterford Tamborine Rd at Stockleigh Rd",
                        "Waterford Tamborine Rd at Anzac Ave",
                        "Albert St at Logan Village",
                        "Allora St at John St",
                        "Haig Rd at Sarah Street",
                        "Loganlea station",
                        "Armstrong Rd at Logan Hospital",
                        "Armstrong Rd at Loganlea TAFE",
                        "Albert St at North St"
                    ],
                    "590: Garden City - Toombul via Carindale": [
                        "Garden City Shopping Centre station, stop I",
                        "Newnham Rd at Delavan, stop 78",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Civic Fair, stop 73",
                        "Newnham Rd at Condong Street, stop 70/63",
                        "Mt Gravatt East School - 61",
                        "Creek Rd at Greenmeadows South",
                        "Creek Rd at Greenmeadow",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd at Salvin Park, stop 69",
                        "Donnington St at Donnington, stop 53",
                        "Carindale Shopping Centre station, platform I",
                        "Bedivere St near Agravain St",
                        "Meadowlands Rd near Bedivere St",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd at Old Stockyards",
                        "Cannon Hill Shopping Centre F",
                        "Creek Rd near Miller St",
                        "Metroplex South",
                        "Kingsford Smith Dr at French St, stop 40",
                        "Kingsford Smith Dr at Holt St, stop 43",
                        "Boronia Rd at Aviation School",
                        "Boronia Rd at DHL",
                        "Lomandra Dr near Viola Pl",
                        "Lomandra Dr near Qantas Dr",
                        "Ninth Ave at Skygate, stop 1",
                        "East West Arterial Rd at Nudgee Rd",
                        "Toombul Interchange",
                        "Toombul Shopping Centre station, platform B",
                        "Ninth Ave at Skygate, stop 2",
                        "Lakeside Dr",
                        "Cannon Hill Shopping Centre C",
                        "Creek Rd at Old Stockyards, stop 66a",
                        "Creek Rd at Carina North near Billan St",
                        "Bedivere St near Cadogan St",
                        "Carindale Shopping Centre station, platform E",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Newnham Rd at Condong Street, stop 63/70",
                        "Garden City Shopping Centre station"
                    ],
                    "598: Great Circle Line Anti-Clockwise": [
                        "Toombul Shopping Centre station, platform E",
                        "Honour Ave at Chelmer station",
                        "Garden City Shopping Centre station, stop K",
                        "Dean St at Toowong Depot, stop 17",
                        "Indooroopilly Shopping Centre station, stop C",
                        "Chermside Shopping Centre interchange D",
                        "Creek Rd at Carina Bus Depot",
                        "Honour Ave at Graceville near Verney Rd",
                        "Coonan St at Indooroopilly station, stop 53",
                        "Sherwood Rd at Toowong West, stop 20",
                        "Wallace St at Prince Charles Hospital, stop 35",
                        "Sandgate Rd at Nundah, stop 2",
                        "Creek Rd at Carina North, stop 49",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Jephson St at Toowong",
                        "Honour Ave at Sherwood Forest",
                        "Rode Rd at Rode Road Hospital, stop 36",
                        "Sandgate Rd at Nundah, Rode Road stop 4",
                        "Creek Rd at Old Stockyards",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Moggill Rd at BBC, stop 16",
                        "Rode Rd at Webster Road, stop 37",
                        "Hamilton Rd at Nundah North near Bayview Tce",
                        "Sherwood Rd near Hedges St",
                        "Cannon Hill Shopping Centre F",
                        "Logan Rd at Wishart Road, stop 39",
                        "Moggill Rd at Taringa, stop 19",
                        "Hamilton Rd at Wavell Heights North near Bilsen Rd",
                        "Rode Rd at Stafford Heights near Maundrell Tce",
                        "Sherwood Rd at Sherwood State School",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Rode Rd at Downfall Creek",
                        "Hamilton Rd at Chermside East near Pfingst Rd",
                        "Railway Tce at Murarrie South near Herbert St",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Sherwood Depot",
                        "Chermside interchange",
                        "Rode Rd at Trouts Road",
                        "Sherwood Rd at Markets",
                        "Queensport Rd at Murarrie near Railway Tce",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Creek Rd at Greenmeadows South",
                        "Rode Rd at McDowall near Metro St",
                        "Sherwood Rd at Rocklea near Melbourne St",
                        "Queensport Rd at Murarrie North near Ives St",
                        "Queensport Rd at Queensport North",
                        "Old Northern Rd at Everton Hills near Rode Rd",
                        "Muriel Ave near Anson St, stop 43",
                        "Creek Rd at Greenmeadow",
                        "Gladstone St at Moorooka South",
                        "Old Northern Rd at Everton Park North",
                        "Fison St at Gateway TAFE",
                        "Creek Rd at Pacific Golf, stop 68",
                        "South Pine Rd at Everton Junction, stop 40",
                        "East West Arterial Rd at Nudgee Rd",
                        "Lillian Ave at Salisbury station",
                        "Creek Rd at Salvin Park, stop 69",
                        "Toombul Interchange",
                        "Griffith St at Everton Park, stop 4/18",
                        "Lillian Ave at Salisbury Interchange, zone A",
                        "Donnington St at Donnington, stop 53",
                        "Brookside Shopping Centre",
                        "Henson Rd at Salisbury East, stop 50",
                        "Carindale Shopping Centre station, platform I",
                        "Troughton Rd at QEII Hospital",
                        "Brookside Shopping Centre station, platform B",
                        "Bedivere St near Agravain St",
                        "Meadowlands Rd near Bedivere St",
                        "Blackwood St at Mitchelton, stop 34",
                        "Troughton Rd at Musgrave Road",
                        "Samford Rd at Gaythorne RSL, stop 33",
                        "Troughton Rd at Brittain Park",
                        "Pickering St at Pickering West",
                        "Troughton Rd at Banoon near Turton St",
                        "Turton St at Sunnybank State School",
                        "Wardell St at Enoggera, stop 1/30",
                        "Wardell St at Enoggera South, stop 31",
                        "Turton St at Oasis",
                        "Wardell St at Dorrington near Stark St",
                        "Turton St near Mains Rd",
                        "Stewart Rd at Frasers Bridge, stop 42",
                        "Mains Rd at Sunnybank",
                        "Stewart Rd at Ashgrove near Devoy St",
                        "Mains Rd at Robertson",
                        "Jubilee Tce at Ithaca near The Esplanade",
                        "Kessels Rd at Grout Street, stop 2/58",
                        "Jubilee Tce near Effie St",
                        "Kessels Rd at MacGregor, stop 59",
                        "Simpsons Rd at Bardon, stop 16a",
                        "Stuartholme Rd at Rainworth near Sixth Ave",
                        "Birdwood Tce at Stuartholme, stop 31",
                        "Mt Coot-tha Rd at Botanic Gardens, stop 19",
                        "Mt Coot-tha Rd at Botanic Gardens, stop 17",
                        "Dean St at Toowong Depot"
                    ],
                    "599: Great Circle Line Clockwise": [
                        "Dean St at Toowong Depot, stop 17",
                        "Garden City Shopping Centre station, stop M",
                        "Coonan St at Indooroopilly station, stop 53",
                        "Station Rd at Indooroopilly Shopping Ctr, stop E",
                        "Chermside Shopping Centre interchange F",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Cannon Hill Shopping Centre C",
                        "Meadowlands Rd near Bedivere St",
                        "Mt Coot-tha Rd at Botanic Gardens, stop 19",
                        "Walker St at Taringa, stop 19",
                        "Hamilton Rd at Chermside East near Newman Rd",
                        "Kessels Rd at MacGregor, stop 59",
                        "Creek Rd at Old Stockyards, stop 66a",
                        "Birdwood Tce at Stuartholme, stop 31",
                        "Moggill Rd at BBC, stop 16",
                        "Hamilton Rd at Wavell Heights North",
                        "Kessels Rd at Grout Street, stop 58",
                        "Creek Rd at Carina North near Billan St",
                        "Bedivere St near Cadogan St",
                        "Stuartholme Rd at Rainworth near Leworthy St",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Hamilton Rd at Nundah North near Beeby St",
                        "Mains Rd at Robertson",
                        "Creek Rd at Carina Bus Depot",
                        "Carindale Shopping Centre station, platform E",
                        "Simpsons Rd at Bardon, stop 16",
                        "Sherwood Rd at Toowong West, stop 22",
                        "Sandgate Rd at Nundah - Rode Road, stop 4",
                        "Mains Rd at Sunnybank",
                        "Donnington St at Donnington, stop 53",
                        "Jubilee Tce near Effie St",
                        "Turton St near Mains Rd",
                        "Sandgate Rd at Nundah, stop 2",
                        "Creek Rd at Salvin Park, stop 69",
                        "Toombul Interchange",
                        "Jubilee Tce at Ithaca near Fletcher Pde",
                        "Turton St at Oasis",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd at Greenmeadow",
                        "Toombul Shopping Centre station, platform E",
                        "Turton St at Sunnybank State School",
                        "Stewart Rd at Ashgrove, stop 46",
                        "Troughton Rd at Banoon",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "East West Arterial Rd at Nudgee Rd",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Links Ave Exit Ramp at Gateway TAFE",
                        "Wardell St at Dorrington near Stark St",
                        "Troughton Rd at Brittain Park",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Queensport Rd at Queensport North",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Troughton Rd at Musgrave Road, stop 39",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Troughton Rd at QEII Hospital",
                        "Wardell St at Enoggera near Samford Rd",
                        "Queensport Rd at Murarrie North near Ives St",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Pickering St at Pickering West",
                        "Henson Rd at Salisbury East, stop 50",
                        "Queensport Rd at Murarrie near Railway Tce",
                        "Logan Rd at Wishart Road, stop 39",
                        "Samford Rd at Gaythorne RSL, stop 33",
                        "Cripps St at Salisbury Interchange",
                        "Railway Tce at Murarrie South near Herbert St",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Blackwood St at Mitchelton, stop 34",
                        "Lillian Ave at Salisbury station",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Beaudesert Rd at Moorooka South, stop 38",
                        "Brookside Shopping Centre",
                        "Brookside Shopping Centre station, platform A",
                        "Muriel Ave near Anson St",
                        "South Pine Rd at Everton Park, stop 37",
                        "Sherwood Rd at Rocklea near Melbourne St",
                        "Old Northern Rd at Everton Junction",
                        "Sherwood Rd at Markets",
                        "Old Northern Rd at Everton Park North",
                        "Sherwood Depot",
                        "Old Northern Rd at Everton Hills near Rode Rd",
                        "Sherwood Rd at Sherwood State School",
                        "Oxley Rd at Graceville Fiveways, stop 50",
                        "Rode Rd at McDowall near Brynner St",
                        "Sherwood Rd near Thallon St",
                        "Honour Ave at Sherwood Forest",
                        "Oxley Rd at Oxley - Graceville, stop 49B",
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Downfall Creek",
                        "Honour Ave at Graceville near Verney Rd",
                        "Oxley Rd at Graceville Uniting Church, stop 49",
                        "Honour Ave at Chelmer station",
                        "Oxley Rd at Graceville State School, stop 50",
                        "Rode Rd at Stafford Heights near Cranbourne St",
                        "Oxley Rd at Milpera, stop 51",
                        "Rode Rd at Webster Road, stop 37",
                        "Wharf St near Bridge St, stop 52",
                        "Indooroopilly interchange",
                        "Rode Rd at Rode Road Hospital, stop 36",
                        "Hilltop Ave at Prince Charles Hospital, stop 35",
                        "Chermside Shopping Centre",
                        "Sherwood Rd near Hedges St"
                    ],
                    "600: Caloundra - Maroochydore via Mooloolaba, Kawana": [
                        "Caloundra station",
                        "Mooloolaba Wharf",
                        "Bulcock St at Canberra Terrace",
                        "Walan St near Bahlaka St",
                        "Mooloolaba Esp at Meta Street",
                        "Moreton Pde at Mahia Terrace",
                        "Alexandra Pde at Alexandra Headland",
                        "Moreton Pde at Saltair Street",
                        "Alexandra Pde at Wilkes Family Park",
                        "Edmund St at Caloundra Catholic Church",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Edmund St at Russell Street",
                        "Alexandra Pde at Okinja Road",
                        "Rinaldi St at Moffat Beach",
                        "Sixth Ave at Sea Breeze Caravan Park",
                        "Buccleugh St at Bryce Street",
                        "Beerburrum St at Dicky Beach",
                        "Sixth Ave at Maroochy Library",
                        "Cotton Tree Pde at Cotton Tree Caravan Park",
                        "Cooroy St near Coochin St CLOSED 9/2 - 1/5",
                        "Buderim St at Currimundi Hotel",
                        "First Ave near George St",
                        "The Esplanade at First Avenue",
                        "Buderim St at Coryule Street",
                        "Maroochydore station, platform 2",
                        "Nicklin Way at Coora Crescent",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Mooloolaba, River Esplanade",
                        "Maroochydore Rd at Beach Road",
                        "Maroochydore station, platform 1",
                        "First Ave near Memorial Ave",
                        "Second Ave at Memorial Ave",
                        "King St at Cotton Tree Caravan Park",
                        "Walan St near Smith St",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Brisbane Rd at Woomba Place",
                        "Nicklin Way at Jessica Park",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Beach Drive",
                        "Moreton Pde at Levuka Avenue",
                        "Moreton Pde at Canberra Terrace"
                    ],
                    "602: Caloundra - Maroochydore via Mountain Creek": [
                        "Caloundra station",
                        "Ormuz Ave at Bingera Terrace",
                        "Mary St near Arthur St",
                        "George St at Caloundra State School",
                        "Queen St near Ulm St",
                        "Ulm St Sth near William St",
                        "William St near Buccleugh St",
                        "Buccleugh St at Bryce Street",
                        "Beerburrum St at Dicky Beach",
                        "Cooroora St near James St",
                        "Cooroora St near Ulm St Nth",
                        "Cooroora St near Coonowrin St",
                        "Coonowrin St near Trundle St",
                        "Beerburrum St at Caloundra Private Hospital",
                        "Beerburrum St near Albatross Ave",
                        "Curlew St near Cassowary St",
                        "Kalana Rd near Talara St",
                        "Saffron Dr near Burnsall St",
                        "Saffron Dr near Bluebell St",
                        "Erang St at Alstonville Way",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Karawatha Dr near Satinay St",
                        "Karawatha Dr near Saratoga Dr",
                        "Karawatha Dr near Molakai Dr",
                        "Karawatha Dr near Kapilano Cr",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha St near Alfriston Dr",
                        "Oakmont Dr near Alfriston Dr",
                        "Oakmont Dr near Buderim Pines South Park",
                        "Buderim Pines Dr near Treefern Ct",
                        "Buderim Private Hospital",
                        "Mooloolaba Rd at Buderim Garden Village",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Maroochy Bvd at Sunrise Drive",
                        "Plaza Pde at Southern Drive",
                        "Maroochydore station, platform 2",
                        "Maroochydore station, platform 1",
                        "Plaza Pde at King Street",
                        "Karawatha Dr near Golf Links Rd",
                        "Nicklin Way at Jessica Park",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Beach Drive",
                        "Erang St near Alstonville Way",
                        "Saffron Dr at Burnsall St",
                        "Curlew St near Beerburrum St",
                        "Beerburrum St near Sanderling St",
                        "Cooroora St at Ulm Street North",
                        "Cooroora St near Tinbeerwah St",
                        "Buccleugh St near Nothling St",
                        "William St near Maltman St Nth",
                        "William St near Ulm St Sth",
                        "Orsova Tce near Osterley Ave"
                    ],
                    "603: Little Mountain - Caloundra": [
                        "Pierce Ave at Corbould Park",
                        "Parklands Bvd near Village Way",
                        "Parklands Bvd at Little Mountain Drive",
                        "Parklands Bvd at Liekefett Way",
                        "Parklands Bvd at Sunset Drive",
                        "Saffron Dr near Burnsall St",
                        "Saffron Dr near Bluebell St",
                        "Erang St at Alstonville Way",
                        "Nicklin Way at Coora Crescent",
                        "Bellara St at Currimundi Marketplace",
                        "Talara St at Talara Primary College",
                        "Curlew St near Beerburrum St",
                        "Beerburrum St near Sanderling St",
                        "Albatross Ave near Miranda St",
                        "Seagull Ave near Sugarbag Rd",
                        "Queen St at Caloundra State High School",
                        "Queen St near Ulm St",
                        "Orsova Tce near Osterley Ave",
                        "Ormuz Ave at Bingera Terrace",
                        "Caloundra station",
                        "Mary St near Arthur St",
                        "George St at Caloundra State School",
                        "Seagull Ave near Albatross Ave",
                        "Albatross Ave near Beerburrum St",
                        "Beerburrum St near Albatross Ave",
                        "Curlew St near Cassowary St",
                        "Erang St near Alstonville Way",
                        "Saffron Dr at Burnsall St",
                        "Parklands Bvd at Meridan State College",
                        "Parklands Bvd near Liekefett Way"
                    ],
                    "604: Caloundra - Bellvista Loop": [
                        "Caloundra station",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Ormuz Ave at Bingera Terrace",
                        "Indigo Rd at Sunshine Crescent",
                        "Suller St near Nutley St",
                        "Bells Beach Dr at Indigo Road",
                        "Oval Ave near First Ave",
                        "Stornaway Ave at Shannon Crescent",
                        "West Tce near Oval Ave",
                        "Lomond Cr at Balmoral Boulevard",
                        "Caloundra Rd at Caloundra Police Station",
                        "OReilly Dr at Gillies Close",
                        "Caloundra Rd at Palm Village Caravan Park",
                        "OReilly Dr at Maroon Court",
                        "Bellvista Bvd at Bellcarra Place",
                        "Caloundra Rd at Industrial Avenue",
                        "Oval Ave near Gosling St"
                    ],
                    "605: Caloundra - Landsborough": [
                        "Landsborough station, stop A",
                        "Steve Irwin Way at Mooloolah Connection Rd",
                        "Steve Irwin Way at Mooloolah Cemetery",
                        "Caloundra Rd at Parklands Boulevard",
                        "Caloundra Rd at Ridgewood Road",
                        "Caloundra Rd at Sugarbag Road",
                        "Caloundra Rd at Stradbroke Drive",
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Caloundra Rd at Industrial Avenue",
                        "Caloundra Rd at Caloundra Police Station",
                        "Bowman Rd near First Ave",
                        "Caloundra station"
                    ],
                    "606: Baringa - Caloundra": [
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Bellvista Bvd at Bellcarra Place",
                        "Stradbroke Dr near Snapper St",
                        "Mark Road West near Cheviot Ct",
                        "Latcham Dr near Mark Rd",
                        "Mark Rd at Daniel Street",
                        "Enterprise St near Mark Rd",
                        "Industrial Ave near Enterprise St",
                        "Caloundra Rd at Caloundra Police Station",
                        "West Tce near Oval Ave",
                        "First Ave near Mayes Ave",
                        "Oval Ave near Gosling St",
                        "Suller St near Nutley St",
                        "Ormuz Ave at Bingera Terrace",
                        "Caloundra station",
                        "Oval Ave near First Ave",
                        "Enterprise St near Industrial Ave",
                        "Mark Rd near Daniel St",
                        "Mark Rd near Cheviot Ct",
                        "Bellvista Bvd at Emerald Drive",
                        "Aura Bvd at Baringa Shopping Centre stop B",
                        "McArthur Pde at Meredith Crescent",
                        "McArthur Pde at Paddington Circuit",
                        "Baringa Dr at Marybell Drive",
                        "Baringa Dr at Baringa Secondary College",
                        "Baringa Dr at Emerson Street",
                        "Baringa Dr at Baringa State Primary School"
                    ],
                    "607: Caloundra - University via SCUH and Kawana": [
                        "Caloundra station",
                        "Bulcock St at Canberra Terrace",
                        "Moreton Pde at Mahia Terrace",
                        "Moreton Pde at Saltair Street",
                        "Edmund St at Caloundra Catholic Church",
                        "Edmund St at Russell Street",
                        "Rinaldi St at Moffat Beach",
                        "Buccleugh St at Bryce Street",
                        "Beerburrum St at Dicky Beach",
                        "Cooroy St near Coochin St CLOSED 9/2 - 1/5",
                        "Buderim St at Currimundi Hotel",
                        "Currimundi Rd near Ilya St",
                        "Gothic Pde near Edna St",
                        "Erang St near Alstonville Way",
                        "Creekside Bvd near Snapdragon St",
                        "Creekside Bvd near Mimosa Cr",
                        "Creekside Bvd near Brushwood St",
                        "Creekside Bvd near Oakdale Cct",
                        "Sunshine Coast University Hospital, platform 2",
                        "Kawana Way at Central Boulevard",
                        "Innovation Pkwy at Capital Place",
                        "Innovation Pkwy near Metier Linkway",
                        "Kawana Island Bvd at Grand Parade",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "UniSC station, platform 1",
                        "UniSC station, platform 2",
                        "Nicklin Way at Jessica Park",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Kawana Way at Lake Kawana",
                        "Sunshine Coast University Hospital, platform 1",
                        "Creekside Bvd near Sycamore Dr",
                        "Creekside Bvd near Lakeside Cr",
                        "Erang St at Alstonville Way",
                        "Moreton Pde at Levuka Avenue",
                        "Moreton Pde at Canberra Terrace"
                    ],
                    "608: Caloundra - Nirimba": [
                        "Aura Bvd at Park Avenue",
                        "Aura Bvd at Central Avenue",
                        "Aura Bvd at Graf Drive",
                        "Aura Bvd at McArthur Parade",
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Bellvista Bvd at Bellcarra Place",
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Caloundra Rd at Industrial Avenue",
                        "Caloundra Rd at Caloundra Police Station",
                        "West Tce near Oval Ave",
                        "Oval Ave near Gosling St",
                        "Suller St near Nutley St",
                        "Ormuz Ave at Bingera Terrace",
                        "Caloundra station",
                        "Oval Ave near First Ave",
                        "Bellvista Bvd at Emerald Drive",
                        "Aura Bvd at Baringa Shopping Centre stop B",
                        "Aura Bvd at Eden Dr",
                        "Aura Bvd at Annalise Circuit Park"
                    ],
                    "609: Pelican Waters - Caloundra": [
                        "Nelson St near Palmer Ave",
                        "Nelson St near Caldwell St",
                        "Pelican Waters Bvd near Agincourt St",
                        "Pelican Waters Bvd near The Corso",
                        "Pelican Waters Bvd near Kalowendha Ave",
                        "Pelican Waters Shopping Centre",
                        "Verdon St near Catherine St",
                        "Catherine St near Maryann St",
                        "Anning Ave near Maryann St",
                        "Anning Ave near Roy St",
                        "Landsborough Pde near Churchill St",
                        "Landsborough Pde near Monash St",
                        "Landsborough Pde near Onslow St",
                        "Landsborough Pde near Nelson St",
                        "Landsborough Pde at Golden Beach Shops",
                        "Beattie St near Taylor Ave",
                        "Westminster Ave near McLean St",
                        "Blaxland St near Gregory St",
                        "Blaxland St near Burke St",
                        "Baldwin St near Ambako Pl",
                        "Baldwin St near North St",
                        "West Tce near Oval Ave",
                        "First Ave near Mayes Ave",
                        "Oval Ave near Gosling St",
                        "Suller St near Nutley St",
                        "Ormuz Ave at Bingera Terrace",
                        "Caloundra station",
                        "Oval Ave near First Ave",
                        "Baldwin St near Pumicestone Pl",
                        "Catherine St near Judy St",
                        "Pelican Waters Bvd near Bledisloe Bvd",
                        "Nelson St near Palmer Ave hail 'n' ride"
                    ],
                    "60: West End - Teneriffe Ferry via City/Valley": [
                        "West End Cityglider terminus",
                        "Montague Rd at Cordeaux Street, stop 30/14",
                        "Montague Rd at Raven Street, stop 12",
                        "Montague Rd near Victoria St, stop 10",
                        "Montague Rd at Donkin Street, stop 7",
                        "Montague Rd at Davies Park, stop 8",
                        "Mollison St near Melbourne St, stop 5",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 20 at City Hall",
                        "Adelaide Street Stop 28 near Hutton Lane",
                        "Wickham Street Stop 226 near Gotha St",
                        "Wickham Street Stop 229 near Warner St",
                        "Wickham St at Light Street, stop 7",
                        "Skyring Tce near Cunningham St",
                        "Commercial Rd at Teneriffe Ferry, stop 16",
                        "Ann St at James Street, stop 6",
                        "Ann Street Stop 216 at Valley Island",
                        "Adelaide Street Stop 36 near Anzac Square",
                        "Adelaide Street Stop 42 near Albert St",
                        "Cultural Centre station, platform 3",
                        "Mollison St near Boundary St, stop 5",
                        "Montague Rd at Cordeaux Street, stop 14"
                    ],
                    "610: Nambour - Maroochydore via Kunda Park": [
                        "Windsor Rd at Nambour TAFE",
                        "Burnside State High School",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Doolan St near Sunhaven Ct",
                        "Nambour General Hospital",
                        "Webster Rd at Cope Street",
                        "Price St near Hospital Rd",
                        "Nambour station",
                        "Currie St at Nambour Library",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Wakefield St near Blackall St",
                        "Dinmore St near Wakefield St",
                        "Pine Grove Rd at Woombye State School",
                        "Nambour Connection Rd at Woombye Gardens",
                        "Nambour Connection Rd at Big Pineapple",
                        "Stark Lane at Vyner Court",
                        "Old Maroochydore Rd at Stark Lane",
                        "Old Maroochydore Rd at Vise Road",
                        "Old Maroochydore Rd near Whites Rd",
                        "Maroochydore Rd near Pike St",
                        "Maroochydore Rd at Robert Street",
                        "Main Rd near Ghost Gum Ave",
                        "Main Rd near Advance Rd",
                        "Main Rd near Elkhorn St",
                        "Main Rd near Tallow Wood Dr",
                        "Main Rd near Pindari St",
                        "Main Rd near Radiata Dr",
                        "Maroochydore Rd at Maroochydore High",
                        "Maroochydore Rd at Homemaker Centre",
                        "Maroochydore station, platform 1",
                        "Maroochydore station, platform 2",
                        "Main Rd near Daintree Cl",
                        "Main Rd near Renison Dr",
                        "Maroochydore Rd at Pike Street",
                        "Pine Grove Rd near Junee Ct",
                        "Lamington Tce near Magnolia St",
                        "Blaxland Rd near Windsor Rd",
                        "Windsor Rd at Rotary Garden Village"
                    ],
                    "611: Maroochydore - SCUH via Mooloolaba and Kawana": [
                        "Sunshine Coast University Hospital, platform 1",
                        "Woodlands Bvd at Forest Park Street",
                        "Florey Bvd at Prosperity Drive",
                        "Kawana Bvd at The Decks Lake Kawana",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Mooloolaba, River Esplanade",
                        "Walan St near Bahlaka St",
                        "Mooloolaba Esp at Meta Street",
                        "Alexandra Pde at Alexandra Headland",
                        "Alexandra Pde at Wilkes Family Park",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Alexandra Pde at Okinja Road",
                        "Aerodrome Rd at Rose Street",
                        "Aerodrome Rd at Maud Street",
                        "Maroochydore station, platform 2",
                        "Maroochydore station, platform 1",
                        "Walan St near Smith St",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Brisbane Rd at Woomba Place",
                        "Nicklin Way at Jessica Park",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Beach Drive",
                        "Sunshine Coast University Hospital, platform 2",
                        "Woodlands Bvd at Pacific Lutheran College"
                    ],
                    "612: Nambour - Maroochydore via Bli Bli": [
                        "Nambour General Hospital",
                        "Webster Rd at Cope Street",
                        "Price St near Hospital Rd",
                        "Lowe St at Nambour Central",
                        "Nambour station",
                        "Coronation Ave at Show and Sportsgrounds",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Parklakes Dr at Bottlebrush Avenue",
                        "Parklakes Dr at Clarence Avenue",
                        "Parklakes Dr at Camp Flat Road",
                        "Parklakes Dr at Agnes Place",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Harbourside Holiday Resort",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Bradman Ave at Minti Street",
                        "Bradman Ave at Chambers Island",
                        "Duporth Ave at Picnic Point",
                        "Maroochydore station, platform 1",
                        "Maroochydore station, platform 2",
                        "Bradman Ave near Denna St",
                        "David Low Way at Bli Bli Castle",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Coronation Ave at Matthew Street"
                    ],
                    "613: Maroochydore - Alexandra Headland Loop": [
                        "Sunrise Drive near Sunshine Cove Park",
                        "Maroochy Bvd at Sunrise Drive",
                        "Plaza Pde at Southern Drive",
                        "Aerodrome Rd at Maud Street",
                        "Aerodrome Rd at Rose Street",
                        "Alexandra Pde at Okinja Road",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Alexandra Pde at Wilkes Family Park",
                        "Alexandra Pde at Alexandra Headland",
                        "Buderim Ave at Douglas Street",
                        "Mooloolaba Rd near Mary St",
                        "Buderim Av at Janet Street",
                        "Mooloolaba Rd near Correa Pl",
                        "Sugar Rd near Centenary Cr",
                        "Dalton Dr at Newspaper Place",
                        "Dalton Dr at Maroochydore Community Health",
                        "Sunshine Cove Way near Sunrise Dr"
                    ],
                    "614: Kawana - Maroochydore via Mountain Creek": [
                        "Kawana Shoppingworld",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Glenfields Bvd at Greenway Place",
                        "Glenfields Bvd near Lacebark St",
                        "Glenfields Bvd near Escolar Dr",
                        "Glenfields Bvd at Sailfish Drive",
                        "Lady Musgrave Dr at Mooloolaba TAFE",
                        "Lady Musgrave Dr at Mountain Creek High School",
                        "Molakai Dr near Hermosa St",
                        "Karawatha Dr near Kapilano Cr",
                        "Mooloolaba Rd at Golf Links Drive",
                        "Deloraine Dr near Whitehaven Dr",
                        "Cumberland Way near Glen Kyle Dr",
                        "Wises Rd near Glen Kyle Dr",
                        "Sugar Rd near Centenary Cr",
                        "Maud St at Coghlan Court",
                        "Maud St near Gloria St",
                        "First Av at Future Way",
                        "Maroochydore station, platform 2",
                        "Maroochydore station, platform 1",
                        "Cumberland Way near Keswick Pl",
                        "Deloraine Dr near Lindeman Ave",
                        "Nicklin Way at Jessica Park"
                    ],
                    "615: Maroochydore - Landsborough via University": [
                        "Australia Zoo",
                        "Landsborough station, stop A",
                        "Steve Irwin Way at Mooloolah Connection Rd",
                        "Steve Irwin Way at Mooloolah Cemetery",
                        "Frizzo Rd at Glenview Road",
                        "Frizzo Rd at Aussie World",
                        "Frizzo Rd at Sippy Creek Road",
                        "Frizzo Rd near Cunning Rd",
                        "University Way at Chancellor Park Marketplace",
                        "University Dr at Hibiscus Resort",
                        "University Way at Chancellor Park",
                        "UniSC station, platform 2",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Ochre Way",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Mooloolaba, River Esplanade",
                        "Walan St near Bahlaka St",
                        "Mooloolaba Esp at Meta Street",
                        "Alexandra Pde at Alexandra Headland",
                        "Alexandra Pde at Wilkes Family Park",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Alexandra Pde at Okinja Road",
                        "Aerodrome Rd at Rose Street",
                        "Aerodrome Rd at Maud Street",
                        "Maroochydore station, platform 2",
                        "Maroochydore station, platform 1",
                        "Walan St near Smith St",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Brisbane Rd at Woomba Place",
                        "UniSC station, platform 1",
                        "University Way at Hibiscus Resort"
                    ],
                    "616: Maroochydore - University via Alexandra Headland": [
                        "Flintwood Cr at Elation Street",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Peter Crosby Way at Village Green Bvd",
                        "University Way near Claymore Rd",
                        "Sippy Downs Dr at Claymore Road",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Siena Catholic College",
                        "University Way at Chancellor Park Marketplace",
                        "University Dr at Hibiscus Resort",
                        "University Way at Chancellor Park",
                        "UniSC station, platform 2",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Main St at Buderim Mountain Primary School",
                        "King St at Water Street",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Mooloolaba Rd at Foote Avenue",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Mooloolaba Rd at Golf Links Drive",
                        "Mooloolaba Rd at Buderim Garden Village",
                        "Mooloolaba Rd near Correa Pl",
                        "Buderim Av at Janet Street",
                        "Buderim Ave at Mary Street",
                        "Buderim Ave at Douglas Street",
                        "Alexandra Pde at Alexandra Headland",
                        "Mooloolaba Esp at Meta Street",
                        "Alexandra Pde at Wilkes Family Park",
                        "Walan St near Smith St",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Mooloolaba, River Esplanade",
                        "Alexandra Pde at Okinja Road",
                        "Walan St near Bahlaka St",
                        "Aerodrome Rd at Rose Street",
                        "Aerodrome Rd at Maud Street",
                        "Maroochydore station, platform 2",
                        "Maroochydore Rd at Beach Road",
                        "Maroochydore station, platform 1",
                        "Mooloolaba Rd near Mary St",
                        "Ballinger Rd near Ballinger Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "UniSC station, platform 1",
                        "University Way at Hibiscus Resort",
                        "Sippy Downs Dr at High St",
                        "University Way at Claymore Rd",
                        "Tranquility Way at Greenview Terrace"
                    ],
                    "617: Maroochydore - Sippy Downs via University": [
                        "University Way near Bateman St",
                        "University Way near Claymore Rd",
                        "Albany St near Windermere Way",
                        "Albany St near Trinity Cr",
                        "Albany St near Bronte Ct",
                        "UniSC station, platform 2",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Burnett St at Buderim Marketplace",
                        "Burnett St near Townsend Rd",
                        "Townsend Rd at Sage Street",
                        "Tulip Lane near Royal Dr",
                        "Lindsay Rd near Attunga Cr",
                        "Lindsay Rd near Feeley St",
                        "Main St at Buderim Mountain Primary School",
                        "Gloucester Rd at Fielding Street",
                        "Jones Rd at Horseshoe Bend",
                        "Pittards Rd near Jewel Ct",
                        "Pittards Rd near Cammeray Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "Wises Rd near Bluebush Ave",
                        "Wises Rd near Forestwood Drive",
                        "Maroochy Bvd at Sunrise Drive",
                        "Plaza Pde at Southern Drive",
                        "Maroochydore station, platform 2",
                        "Maroochydore station, platform 1",
                        "Plaza Pde at King Street",
                        "North Buderim Bvd near Pittards Rd",
                        "Pittards Rd near Jones Rd",
                        "Lindsay Rd near Tulip Lane",
                        "Tulip Lane at Royal Drive",
                        "Ballinger Rd near Ballinger Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "UniSC station, platform 1",
                        "University Way at Claymore Rd"
                    ],
                    "618: Sippy Downs - Kawana via University": [
                        "Springhill Dr near Edgewater Pl",
                        "Springhill Dr near Lacewing Dr",
                        "Bellflower Rd near Peppermint Cr",
                        "Bellflower Rd near Creekside Dr",
                        "Bellflower Rd at Lakehead Drive",
                        "Chancellor Village Bvd at Chancellor Village",
                        "University Dr at Hibiscus Resort",
                        "University Way at Chancellor Park",
                        "UniSC station, platform 2",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Claymore Road",
                        "Dixon Road at Power Road",
                        "Karawatha Dr near Dixon Rd",
                        "Karawatha Dr near Jingellic Dr",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Golf Links Rd",
                        "Karawatha Dr near Kapilano Cr",
                        "Molakai Dr near Hermosa St",
                        "Lady Musgrave Dr at Mountain Creek High School",
                        "Lady Musgrave Dr at Mooloolaba TAFE",
                        "Bundilla Bvd at Cootamundra Drive",
                        "Manatunga Pde at Lady Elliot Dr",
                        "Manatunga Pde at Brightwater Bvd",
                        "Attenuata Dr at Crayfish Street",
                        "Attenuata Dr at Amberjack Street",
                        "Brightwater Bvd at Holloway Street",
                        "Kawana Way at Island Point Villas",
                        "Jamaica Way near Providence St",
                        "Grand Pde near Maldives Pl",
                        "Grand Pde near Kawana Island Bvd",
                        "Kawana Island Bvd at Grand Parade",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana Shoppingworld",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr near Brianna Cl",
                        "UniSC station, platform 1",
                        "University Way at Hibiscus Resort",
                        "Chancellor Village Bvd near Lakehead Dr",
                        "Bellflower Rd at Bellflower Retirement Resort"
                    ],
                    "619: Kawana - Maroochydore via Alexandra Headland": [
                        "Kawana Shoppingworld",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Amarina Ave near Darrung St",
                        "Amarina Ave near Admirals Ct",
                        "Amarina Ave near Goonawarra Dr",
                        "Goonawarra Dr near Yallanga Pl",
                        "Palm Dr near Brentwood Ave",
                        "Ocean View Ave near Aruma Ct",
                        "Pettigrew St near Kalinda Ave",
                        "Mooloolaba Rd near Mary St",
                        "Mary St near Kate St",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Okinja Rd at Wirraway Street",
                        "Maroubra St near Wrigley St",
                        "Bungama St near May St",
                        "Second Ave near Parker St",
                        "Aerodrome Rd at Maud Street",
                        "Maroochydore station, platform 2",
                        "Maroochydore station, platform 1",
                        "Maroubra St near Wirraway St",
                        "Wirraway St near Okinja Rd",
                        "Mary St near William St",
                        "Buderim Ave at Mary Street",
                        "Pettigrew St near Marjorie St",
                        "Ocean View Ave near Warrina Ct",
                        "Goonawarra Dr near Yuruga St",
                        "Amarina Ave near Kononda Ct",
                        "Brisbane Rd at Neerim Drive",
                        "Nicklin Way at Jessica Park"
                    ],
                    "61: Ashgrove Shops - Coorparoo via City": [
                        "Stewart Rd at Ashgrove Village",
                        "Jubilee Tce near Effie St",
                        "MacGregor Tce at Bardon, stop 15",
                        "Latrobe Tce at Gilday Street, stop 12",
                        "Latrobe Tce at Paddington Central, stop 10",
                        "Given Tce at Old Paddo Post Office, stop 8",
                        "Given Tce at Paddo Tavern, stop 6",
                        "Caxton St near Chapel St, stop 4",
                        "Roma Street busway, platform 2",
                        "King George Square, 2b",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Logan Rd at Lewis Street, stop 11/12",
                        "Stones Corner station, platform 2",
                        "Langlands Park station, platform 2",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Coorparoo Square - Holdsworth St",
                        "Langlands Park station, platform 1",
                        "Stones Corner station, platform 1",
                        "Logan Rd at Lewis Street, stop 11",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Queen Street station, 1f",
                        "King George Square, 1b",
                        "Roma Street busway, platform 1",
                        "Latrobe Tce at Old Paddo Post Office, stop 8",
                        "MacGregor Tce at Bardon"
                    ],
                    "620: Noosa Heads - Maroochydore via Peregian Beach": [
                        "Maroochydore station, platform 2",
                        "Duporth Ave at Picnic Point",
                        "Bradman Ave at Chambers Island",
                        "Bradman Ave at Minti Street",
                        "Bradman Ave near Denna St",
                        "Diura St near Bradman Ave",
                        "David Low Way at Kowonga Street",
                        "David Low Way at Namba Street",
                        "David Low Way at Pacific Paradise Primary",
                        "Mudjimba Beach Rd at Pacific Pines",
                        "Mudjimba Beach Rd near Conebush St",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Esp near David Low Way",
                        "David Low Way at Sunset Strip",
                        "David Low Way at Petrie Avenue",
                        "David Low Way at Lorraine Avenue",
                        "David Low Way at Seaside Boulevard",
                        "David Low Way at Mount Coolum",
                        "David Low Way at Tanah Street",
                        "David Low Way at Warran Road",
                        "David Low Way at Yaroomba Beach",
                        "David Low Way at Point Arkwright",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Coolum Beach",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum High School",
                        "David Low Way at Peregian South",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Peregian North",
                        "David Low Way at Marcus Beach",
                        "David Low Way at Mahogany Drive",
                        "David Low Way at Castaways Creek",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Sunrise Beach",
                        "David Low Way at Vernon Street",
                        "Pacific Ave near Wildflower St",
                        "Pacific Ave near Ferguson St",
                        "Pacific Ave near Edwards St",
                        "David Low Way at Sunshine Beach Primary",
                        "Noosa Junction station, stop A",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Noosa Dr at Hibiscus Avenue",
                        "Noosa Heads station, platform 1",
                        "Noosa Pde at Witta Circle",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at William Street",
                        "Weyba Rd at Pelican Beach Park",
                        "Gympie Tce at Massoud Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at James Duke Bridge",
                        "Hilton Tce at Tewantin Noosa Bowls Club",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin Central",
                        "Noosa Heads station, platform 2",
                        "Hilton Tce at Earl Street",
                        "Noosa Junction station, stop B",
                        "David Low Way at Pacific Paradise",
                        "Pacific Ave near Weyba St",
                        "Pacific Ave near Ferguson Ave",
                        "Pacific Ave near Elanda St",
                        "Denna St near Bradman Avenue",
                        "Maroochydore station, platform 1",
                        "David Low Way near Goongilla St",
                        "David Low Way at Keith Royal Drive"
                    ],
                    "622: Maroochydore - Noosa Junction via Airport, Coolum": [
                        "Maroochydore station, platform 2",
                        "Duporth Ave at Picnic Point",
                        "Bradman Ave at Chambers Island",
                        "Bradman Ave at Minti Street",
                        "Bradman Ave near Denna St",
                        "Diura St near Bradman Ave",
                        "David Low Way at Kowonga Street",
                        "David Low Way at Namba Street",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way at Pacific Paradise",
                        "Sunshine Coast Airport",
                        "David Low Way at Friendship Avenue",
                        "David Low Way at Fourth Avenue",
                        "David Low Way at Sunset Strip",
                        "Petrie Ave near Begonia Way",
                        "Petrie Ave at Marcoola",
                        "Marcoola Esp at Marcoola SLSC",
                        "Tamarindus St near Cycas St",
                        "David Low Way at Seaside Boulevard",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Jarnahill Dr near Quinn Ct",
                        "Toolga St near Carrock Ct",
                        "South Coolum Rd near Wandaa Ct",
                        "South Coolum Rd near Green Oaks Dr",
                        "Yandina Coolum Rd near Park Cr",
                        "Central Ave near Pandanus Ave",
                        "Banksia Ave near Tradewinds Ave",
                        "Banksia Ave near Perry St",
                        "Birtwill St near Heathfield Rd",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum High School",
                        "Ridgeview Dr at Peregian Springs Drive",
                        "Ridgeview Dr at North Ridge Avenue",
                        "Ridgeview Dr at The Avenue",
                        "Ridgeview Dr at Laurina Way",
                        "Ridges Bvd at Mallee Street",
                        "Ridges Bvd at Kurrajong Circuit",
                        "Ridges Bvd at Peregian Springs State School",
                        "Peregian Springs Dr near Longwood Dr",
                        "Peregian Springs Dr near Crestview Dr",
                        "Peregian Springs Dr near The Avenue",
                        "Peregian Springs Dr near Glen Abby Ave",
                        "Noosa Civic Shopping Centre",
                        "Cooyar St near Elanora Tce",
                        "Noosa Junction station, stop A",
                        "Noosa Junction station, stop B",
                        "Cooyar St near Langura St",
                        "Peregian Springs Dr near Balgownie Dr",
                        "Peregian Springs Dr near Gracemere Bvd",
                        "Ridges Bvd at Tea Tree Grove",
                        "Birtwill St near David Low Way",
                        "Banksia Ave at Tradewinds Avenue",
                        "Central Ave near Palm Ave",
                        "Toolga St near Warrack St",
                        "David Low Way at Mount Coolum",
                        "Tamarindus St near Willow Cr",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "Denna St near Bradman Avenue",
                        "Maroochydore station, platform 1"
                    ],
                    "626: Tewantin - Sunrise Beach via Noosa Heads": [
                        "St Andrews Dr at Hibiscus Retirement Resort",
                        "Saint Andrews Dr near Furness Dr",
                        "Furness Dr near Portrush Ct",
                        "Furness Dr near Blackheath Dr",
                        "Furness Dr near Felsted Ct",
                        "Fairway Dr near Thompson Cr",
                        "Tewantin Noosa Golf Club",
                        "Butler St at Noosa Crematorium",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Poinciana Ave at Poinciana Place",
                        "Tewantin Central",
                        "Hilton Tce at Earl Street",
                        "Hilton Tce at Tewantin Noosa Bowls Club",
                        "Gympie Tce at James Duke Bridge",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Massoud Park",
                        "Weyba Rd at Pelican Beach Park",
                        "Noosa Pde at William Street",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Witta Circle",
                        "Noosa Heads station, platform 2",
                        "Noosa Dr at Hibiscus Avenue",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Noosa Junction station, stop B",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Ben Lexcen Dr near Lipton St",
                        "Dame Patti Dr near Southern Cross Pde",
                        "Orient Dr at Newfield St",
                        "Orient Dr at Corsair Cr",
                        "Orient Dr near Wollomia Way",
                        "Wollomia Way near Victory Cr",
                        "Wollomia Way near Comet Dr",
                        "Dame Patti Dr near Ben Lexcen Dr",
                        "Ben Lexcen Dr near Grasstree Ct",
                        "Noosa Junction station, stop A",
                        "Noosa Heads station, platform 1",
                        "Hilton Tce at Noosa Convention Centre",
                        "Cooroy Noosa Rd at Ross Court",
                        "Saint Andrews Dr at William Street",
                        "Saint Andrews Dr at Wattle Street"
                    ],
                    "627: Tewantin - Sunshine Beach via Noosa Heads": [
                        "Tewantin Central",
                        "Hilton Tce at Earl Street",
                        "Hilton Tce at Tewantin Noosa Bowls Club",
                        "Gympie Tce at James Duke Bridge",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Massoud Park",
                        "Weyba Rd at Pelican Beach Park",
                        "Noosa Pde at William Street",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Witta Circle",
                        "Noosa Heads station, platform 2",
                        "Noosa Dr at Hibiscus Avenue",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Noosa Junction station, stop B",
                        "David Low Way at Sunshine Beach Primary",
                        "Solway Dr near Surf St",
                        "Bryan St near Ferris St",
                        "Belmore Tce near Stevens St",
                        "Duke St at Ed Webb Park",
                        "Noosa Junction station, stop A",
                        "Noosa Heads station, platform 1",
                        "Hilton Tce at Noosa Convention Centre"
                    ],
                    "628: Parklands - Noosa Junction via Noosa Civic": [
                        "Golf Course Dr near Daintree Way",
                        "Griffith Ave near Club Ct",
                        "Griffith Ave near Parkview Ct",
                        "Griffith Ave near Cedarleigh Dr",
                        "Griffith Ave at Palmer Crescent",
                        "Cooroy Noosa Rd at Carramar Noosa Homes",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Tewantin Noosa Golf Club",
                        "Butler St at Noosa Crematorium",
                        "Werin St at Crank Street",
                        "Moorindil St near George St",
                        "Moorindil St near Cobham St",
                        "Moorindil St near Read St",
                        "Moorindil St near Gympie St",
                        "Moorindil St near Toolar St",
                        "Poinciana Ave at Ward Park",
                        "Poinciana Ave at Poinciana Place",
                        "Tewantin Central",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Walter Hay Dr at Selkirk Drive",
                        "Noosa Civic Shopping Centre",
                        "Eumundi Rd at Goodchap Street",
                        "Wallace Dr at Noosa Leisure Centre",
                        "Gibson Rd near Portside Ct",
                        "Gibson Rd at The Cockleshell",
                        "Mary St near Albert St",
                        "Mary St near Edward St",
                        "Weyba Rd near Anchor St",
                        "Lake Weyba Dr near Creek Rd",
                        "Lake Weyba Dr near Nannygai St",
                        "Weyba Rd near Swan St",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St",
                        "Cooyar St near Elanora Tce",
                        "Noosa Junction station, stop A",
                        "Noosa Junction station, stop B",
                        "Cooyar St near Langura St",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Mary St near George St",
                        "Hilton Tce at Noosa Convention Centre",
                        "Cooroy Noosa Rd at Ross Court",
                        "Cooroy Noosa Rd at Heritage Park",
                        "Griffith Ave near Harlow Cr",
                        "Griffith Ave near Golf Course Dr"
                    ],
                    "629: Tewantin - Noosa Junction via Noosa Civic": [
                        "Tewantin Central",
                        "Poinciana Ave at Ward Park",
                        "Moorindil St near Toolar St",
                        "Moorindil St near Gympie St",
                        "Moorindil St near George St",
                        "Moorindil St near Cobham St",
                        "Moorindil St near Read St",
                        "Werin St at Crank Street",
                        "Butler St at Noosa Crematorium",
                        "Cooroy Noosa Rd at Ross Court",
                        "Saint Andrews Dr at William Street",
                        "Outlook Dr near Buchanan Cr",
                        "Outlook Dr near Talara Ct",
                        "Outlook Dr near Freeman Ct",
                        "Outlook Dr at Clarey Road",
                        "Saint Andrews Dr near Furness Dr",
                        "Sea Eagle Drive at Noosaville State School",
                        "Bushlands Dr near Satinwood St",
                        "Bushlands Dr at Rose Ash Crescent",
                        "Swanbourne Way near Beckmans Rd",
                        "Eumundi Rd at Rene Street",
                        "Noosa Civic Shopping Centre",
                        "Noosa Pde at William Street",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Witta Circle",
                        "Noosa Heads station, platform 2",
                        "Noosa Dr at Hibiscus Avenue",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Noosa Junction station, stop B",
                        "Noosa Junction station, stop A",
                        "Noosa Heads station, platform 1",
                        "Outlook Dr near Gooloi Ct",
                        "Saint Andrews Dr near William St",
                        "Poinciana Ave at Poinciana Place"
                    ],
                    "630: Noosa - Nambour via Eumundi": [
                        "Nambour station",
                        "Memorial Dr at Eumundi Markets",
                        "Coronation Ave at Show and Sportsgrounds",
                        "Eumundi Rd at Rene Street",
                        "Memorial Dr at Eumundi Aquatic Centre",
                        "Eumundi Rd at Goodchap Street",
                        "Gympie Tce at James Duke Bridge",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Massoud Park",
                        "Weyba Rd at Pelican Beach Park",
                        "Noosa Pde at William Street",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Witta Circle",
                        "Noosa Heads station, platform 2",
                        "Noosa Dr at Hibiscus Avenue",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Noosa Junction station, stop B",
                        "David Low Way at Sunshine Beach Primary",
                        "Pacific Ave near Weyba St",
                        "Pacific Ave near Ferguson Ave",
                        "Pacific Ave near Elanda St",
                        "David Low Way at Vernon Street",
                        "David Low Way at Sunrise Beach",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Castaways Creek",
                        "David Low Way at Mahogany Drive",
                        "David Low Way at Marcus Beach",
                        "David Low Way at Peregian North",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Peregian South",
                        "David Low Way at Coolum High School",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Beach",
                        "Noosa Junction station, stop A",
                        "Noosa Heads station, platform 1",
                        "Pacific Ave near Wildflower St",
                        "Pacific Ave near Ferguson St",
                        "Pacific Ave near Edwards St",
                        "Coronation Ave at Matthew Street"
                    ],
                    "631: Noosa - Nambour via Cooroy and Eumundi": [
                        "Nambour station",
                        "Nambour General Hospital",
                        "Netherton St at Sapphire Drive",
                        "National Park Rd near Zealey Rd",
                        "Nambour Connection Rd near Boronia St",
                        "Nambour Connection Rd near Oleander Dr",
                        "Nambour Connection Rd at Nambour Caravan Park",
                        "Old Bruce Hwy near Ayrshire Rd",
                        "Old Bruce Hwy at Yandina Caravan Park",
                        "Farrell St near Stevens St",
                        "Railway St at Yandina station",
                        "Fleming Street at School Road",
                        "Pioneer Rd at The Ginger Factory",
                        "Memorial Dr at Eumundi Aquatic Centre",
                        "Memorial Dr at Eumundi Markets",
                        "Memorial Dr at Eerwah Vale Overpass",
                        "Ferrells Rd near Overlander Ave",
                        "Maple St near Tulip St",
                        "Maple St at Victory Lane",
                        "Elm St at Cooroy station",
                        "Tewantin Rd near Olivine St",
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Jack Hasset Dr at Heritage Park",
                        "Cooroy Noosa Rd at Carramar Noosa Homes",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Tewantin Noosa Golf Club",
                        "Butler St at Noosa Crematorium",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Poinciana Ave at Poinciana Place",
                        "Tewantin Central",
                        "Hilton Tce at Earl Street",
                        "Hilton Tce at Tewantin Noosa Bowls Club",
                        "Gympie Tce at James Duke Bridge",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Massoud Park",
                        "Weyba Rd at Pelican Beach Park",
                        "Noosa Pde at William Street",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Witta Circle",
                        "Noosa Heads station, platform 2",
                        "Noosa Dr at Hibiscus Avenue",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Noosa Junction station, stop B",
                        "Noosa Junction station, stop A",
                        "Noosa Heads station, platform 1",
                        "Hilton Tce at Noosa Convention Centre",
                        "Cooroy Noosa Rd at Ross Court",
                        "Cooroy Noosa Rd at Heritage Park",
                        "Tewantin Rd near Miva St",
                        "Elm St opp Cooroy station",
                        "Overlander Ave near Maple St",
                        "Ferrells Rd near Myall St",
                        "Nambour Connection Rd at Nambour Park",
                        "National Park Rd near Rigby St",
                        "Price St near Hospital Rd"
                    ],
                    "632: Noosa - Cooran via Cooroy and Pomona": [
                        "King St at Prince Street",
                        "Greenbridge Pinbarren Rd at Kin Kin Road",
                        "Reserve St at Station St",
                        "Factory St near Reserve St",
                        "Elm St at Pearsons Rd",
                        "Elm St opp Cooroy station",
                        "Emerald St near Maple Lane",
                        "Garnet St near Wattle St",
                        "Elm St at Cooroy station",
                        "Tewantin Rd near Olivine St",
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Jack Hasset Dr at Heritage Park",
                        "Cooroy Noosa Rd at Carramar Noosa Homes",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Tewantin Noosa Golf Club",
                        "Butler St at Noosa Crematorium",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Poinciana Ave at Poinciana Place",
                        "Tewantin Central",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Walter Hay Dr at Selkirk Drive",
                        "Noosa Civic Shopping Centre",
                        "Eumundi Rd at Goodchap Street",
                        "Gibson Rd near Portside Ct",
                        "Gibson Rd at The Cockleshell",
                        "Mary St near Albert St",
                        "Mary St near Edward St",
                        "Weyba Rd near Anchor St",
                        "Weyba Rd near Swan St",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St",
                        "Cooyar St near Elanora Tce",
                        "Noosa Junction station, stop A",
                        "Noosa Junction station, stop B",
                        "Cooyar St near Langura St",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Mary St near George St",
                        "Greenridge Pinbarren Rd near Kin Kin Rd",
                        "Hilton Tce at Noosa Convention Centre",
                        "Cooroy Noosa Rd at Ross Court",
                        "Cooroy Noosa Rd at Heritage Park",
                        "Tewantin Rd near Miva St"
                    ],
                    "636: Nambour - University via Buderim": [
                        "UniSC station, platform 2",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Burnett St at Buderim Marketplace",
                        "Burnett St near Townsend Rd",
                        "Townsend Rd at Sage Street",
                        "Besley St near Townsend Rd",
                        "William St near Mons Rd",
                        "Mons Rd near Twin Ridges Rd",
                        "Mons Rd near Owen Creek Rd",
                        "Nambour Connection Rd at Big Pineapple",
                        "Nambour Connection Rd at Woombye Gardens",
                        "Pine Grove Rd near Junee Ct",
                        "Dinmore St near Wakefield St",
                        "Wakefield St near Blackall St",
                        "Lamington Tce near Magnolia St",
                        "Reilly Rd at Palm St",
                        "Aspland St at Little Bade Street",
                        "Howard St at Smith Street",
                        "Howard St at Sydney Street",
                        "Nambour station",
                        "Lowe St at Nambour Central",
                        "Aspland St at Bade Street",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Pine Grove Rd at Woombye State School",
                        "Mons Rd at Forest Glen",
                        "Mons Rd near Mons School Rd",
                        "Mons Rd near Wilguy Cr",
                        "Ballinger Rd near Ballinger Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "UniSC station, platform 1"
                    ],
                    "637: Nambour local loop": [
                        "Nambour station",
                        "Lowe St at Nambour Central",
                        "Nambour General Hospital",
                        "Mapleton Rd at Isabella Avenue",
                        "Mapleton Rd at Windsor Road",
                        "Magpie St at Swallow Street",
                        "Highview Ave at Hillcrest Avenue",
                        "Isabella Av at Albatross Avenue",
                        "Mapleton Rd at Range Street",
                        "Image Flat at Imagination Drive",
                        "Price St near Hospital Rd",
                        "Mill Lane at Nambour Mill Village",
                        "Coes Creek Rd at Judith Street",
                        "Perwillowen Road at Valley View Street",
                        "Robertson Dr at Heritage Way"
                    ],
                    "638: Nambour - Palmwoods loop": [
                        "Mill Lane at Nambour Mill Village",
                        "Nambour station",
                        "Lowe St at Nambour Central",
                        "Currie St at Nambour Library",
                        "Cobbs Rd near Paynter Park Dr hail 'n' ride",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Wakefield St near Blackall St",
                        "Dinmore St near Wakefield St",
                        "Pine Grove Rd at Woombye State School",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Main St at Palmwoods Railway Station",
                        "Dunning St at Jane Street",
                        "Montville Rd at Palmwoods Primary",
                        "Palmwoods School Rd at Cobb and Co Lane",
                        "Petigrain Ave at Old Orchard Drive",
                        "Landershute Rd at Petigrain Avenue",
                        "Montville Rd near Dunning St",
                        "Jubilee Dr at Palmwoods Garden Village",
                        "Jubilee Dr near Woombye Palmwoods Rd",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Pine Grove Rd near Junee Ct",
                        "Lamington Tce near Magnolia St"
                    ],
                    "640: Bribie Island - Caboolture station": [
                        "Caboolture station, stop C",
                        "Lower King St at Charles Street",
                        "Bribie Island Rd at Aerodrome Road",
                        "Bribie Island Rd at Pasturage Road",
                        "Bribie Island Rd at Old Toorbul Point Rd",
                        "Bribie Island Rd at Lee Road",
                        "Bribie Island Rd at Aylward Road",
                        "Bribie Island Rd at Pinelands Way",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd near Rebecca Ave",
                        "Bribie Island Rd near Rowan Lane",
                        "Bribie Island Rd near Ruby Ave",
                        "Bribie Island Rd at Redondo Street",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Benabrow Ave near Verdoni St",
                        "Fortune Ave at Bribie Island Central",
                        "Bribie Island park 'n' ride",
                        "Goodwin Dr near Coolgarra Ave",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Drive at Ian Fairweather Park",
                        "First Ave at Bribie Island Recreation Grounds",
                        "First Ave at McMahon Street",
                        "First Ave near Bracken St",
                        "Arcadia Ave near Box St",
                        "Arcadia Ave near Broom St",
                        "Arcadia Ave near Heron St",
                        "Arcadia Ave near Boyd St",
                        "Boyd St near Curlew St",
                        "Boyd St near Benny St",
                        "Boyd St near Ottiwell St",
                        "Jacana Ave at Cypress Lane",
                        "North St near Fourth Ave",
                        "Eighth Ave near Clement St",
                        "Eighth Ave near Sixth Ave",
                        "Sixth Ave near Longland Ct",
                        "Sixth Ave near Clement St",
                        "Clement St near Seventh Ave",
                        "North St near Seventh Ave",
                        "North St at Second Avenue",
                        "First Ave at Jacana Avenue",
                        "First Ave near Arcadia Ave",
                        "First Ave at Ian Fairweather Park",
                        "Benabrow Ave near Gidya Ave",
                        "Benabrow Ave at Ferguson Avenue",
                        "Bribie Island Rd near Bestmann Rd East",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Bribie Island Rd near Robert Ave",
                        "Bribie Island Rd at Peel Road"
                    ],
                    "641: Banksia Beach - Bongaree (Loop)": [
                        "Bribie Island park 'n' ride",
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Endeavour Dr near Headsail Dr",
                        "Endeavour Dr near Marlin Ct",
                        "Endeavour Dr near Swallow St",
                        "Endeavour Dr near Carl Ct",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Fortune Ave at Bribie Island Central",
                        "Goodwin Dr near Coolgarra Ave",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Kangaroo Ave at Doomba Drive",
                        "Kangaroo Ave at Welsby Parade",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Welsby Pde at First Avenue",
                        "First Ave near Cumming St",
                        "Goodwin Dr at Cotterill Avenue",
                        "Jasmin Dr near Goodwin Dr",
                        "Jasmin Dr near Lawn St",
                        "Jasmin Dr near Protea Dr",
                        "Protea Dr near Melia St",
                        "Protea Dr near Tamala Ct",
                        "Cotterill Ave near Barklya Cr",
                        "Cotterill Ave near Goodwin Dr"
                    ],
                    "642: Bribie Island PnR - Bongaree via Bellara": [
                        "Toorbul St at Bribie Island RSL",
                        "Toorbul St at Bribie Island Sports Club",
                        "Welsby Pde at First Avenue",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Wattle Ave",
                        "Welsby Pde near Palm Ave",
                        "Eucalypt St near Melrose Ave",
                        "Eucalypt St near Karee Dv",
                        "Elkhorn Ave near Oorooba Ave",
                        "Jabiru St near Bellara St",
                        "Boronia Dr near Pandanus St",
                        "Boronia Dr near Orchid St",
                        "Boronia Dr near Wistaria St",
                        "Verdoni St near Bellara St",
                        "Verdoni St near Faraday St",
                        "Fortune Ave at Bribie Island Central",
                        "Bribie Island park 'n' ride",
                        "Verdoni St near Currong Cres",
                        "Boronia Dr near Hovea St",
                        "Boronia Dr near Eucalypt St",
                        "Boronia Dr near Warrigal St",
                        "Eucalypt St near Karee Dr",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Welsby Pde near Charlotte Ave"
                    ],
                    "643: Bribie Island - Caboolture via Sandstone Point": [
                        "Caboolture station, stop C",
                        "Lower King St at Charles Street",
                        "Bribie Island Rd at Aerodrome Road",
                        "Bribie Island Rd at Pasturage Road",
                        "Bribie Island Rd at Old Toorbul Point Rd",
                        "Bribie Island Rd at Lee Road",
                        "Bribie Island Rd at Aylward Road",
                        "Bribie Island Rd at Pinelands Way",
                        "Bestmann Rd near Lever Ct",
                        "Bestmann Rd near Greygum Ct",
                        "Bestmann Rd at Sunny Court",
                        "Bestmann Rd near Fairhaven Dr",
                        "Bestmann Rd near Rose St",
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Bestmann Rd East near Mackerel St",
                        "Bestmann Rd East at Dylan Court",
                        "Bestmann Rd East near Clark Tce",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Benabrow Ave near Verdoni St",
                        "Fortune Ave at Bribie Island Central",
                        "Bribie Island park 'n' ride",
                        "Benabrow Ave near Gidya Ave",
                        "Benabrow Ave at Ferguson Avenue",
                        "Bestmann Rd East near Bribie Island Rd",
                        "Bestmann Rd East at Lachlan Cresent",
                        "Bestmann Rd East at Oxley Place",
                        "Bestmann Rd near Mackerel St",
                        "Bestmann Rd near Regina Ave",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd at Peel Road"
                    ],
                    "644: Sandstone Point - Bribie Island park 'n' ride": [
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Peerless Way near Smout Ct",
                        "Carpenter Way near Loftus Pl",
                        "Carpenter Way near Bayswater Ct",
                        "Bestmann Rd East at Dylan Court",
                        "Lachlan Cr at Day Place",
                        "Lachlan Cr near Nelson St",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Benabrow Ave near Verdoni St",
                        "Fortune Ave at Bribie Island Central",
                        "Bribie Island park 'n' ride",
                        "Benabrow Ave near Gidya Ave",
                        "Benabrow Ave at Ferguson Avenue",
                        "Bestmann Rd East near Bribie Island Rd",
                        "Bestmann Rd East at Lachlan Cresent",
                        "Lachlan Cr near Day Pl"
                    ],
                    "649: Caboolture Station - Nambour Station (Rail Bus)": [
                        "Nambour station",
                        "Landsborough station, stop B",
                        "Woombye station",
                        "Caboolture station, stop A",
                        "Main St at Palmwoods Railway Station",
                        "Eudlo station",
                        "Mooloolah station",
                        "Beerwah station",
                        "Australia Zoo",
                        "Glass House Mountains station",
                        "Beerburrum station",
                        "Elimbah station"
                    ],
                    "651: Morayfield station - West Caboolture (Loop)": [
                        "Caboolture station, stop C",
                        "Morayfield station",
                        "Morayfield Shops bus station, platform 1",
                        "Caboolture Square Shopping Centre",
                        "Morayfield Rd at Domnick Street",
                        "George St at Caboolture State School",
                        "Market Dr near Suter Dr",
                        "George St near Toohey St",
                        "Watt St near Jade St",
                        "Warner St near Conondale Ave",
                        "Lynfield Dr near Yaldara Ave",
                        "Lynfield Dr near Dawson St",
                        "Lynfield Dr near Smiths Rd",
                        "King St at Lesley Avenue",
                        "Lesley Ave near Jennifer Ct",
                        "Lesley Ave near King St",
                        "Belcher St near Lindner St",
                        "Lindner St near Miles St",
                        "Miles St near Meninga Ct",
                        "Bluebell St near Hancock St",
                        "Honeysuckle St near Bluebell St",
                        "Smiths Rd near Afton St",
                        "Lynfield Dr at Yaldara Avenue",
                        "Warner St near Watt St",
                        "Watt St near Pearl Cr",
                        "Caboolture Hub",
                        "Morayfield Rd at John Street",
                        "Morayfield Rd at Caboolture River Road"
                    ],
                    "652: Caboolture Square - Beachmere (Loop)": [
                        "Caboolture Square Shopping Centre",
                        "Moreton Tce near Main St",
                        "Moreton Tce near Second Ave",
                        "Hasking St near Beerburrum Rd",
                        "Caboolture station, stop C",
                        "Moreton Tce near Dorunda Ave",
                        "Lower King St at Charles Street",
                        "Moreton Tce near Hodgson St",
                        "Bryant St near Dwyer St",
                        "Beachmere Rd near Ann Maree Dr",
                        "Beachmere Rd near Moreton Tce",
                        "Dwyer St near Hodgson St",
                        "Kunde St near Gretel Dr",
                        "Biggs Ave near Huntley St",
                        "Biggs Ave near Second Ave",
                        "Main St near Moreton Tce",
                        "Bishop Rd near Margaret St",
                        "Bishop Rd near McGregor Tce",
                        "Blaney St near Bishop Rd",
                        "Randolph St at Palm Lake Resort",
                        "Savage St near Rogers St",
                        "Beachmere Rd near James Rd",
                        "Beachmere Rd at Riversleigh Rd"
                    ],
                    "653: Caboolture stn - Morayfield stn via Bellmere": [
                        "Caboolture station, stop C",
                        "Caboolture Square Shopping Centre",
                        "King St at Caboolture RSL Care",
                        "King St at Maple Lane",
                        "King St at Caboolture Swimming Pool",
                        "Ulster Dr near Kendall Rd",
                        "Will St near Colburn Way",
                        "Kendall Rd near Whimbrel Ct",
                        "Piggott Rd near Bellmere Rd",
                        "Bellemere Rd near River Dr",
                        "Bellmere Rd near Bishop Lane",
                        "Belle Air Dr near Riverwood Dr",
                        "Belle Air Dr near Riverside Cct",
                        "Bishop Lane near Bellmere Rd",
                        "River Dr at Lotus Ave",
                        "Torrens Rd near Dorset Dr",
                        "Torrens Rd near Grant Rd",
                        "Grant Rd at Julie Drive",
                        "Matthew Flinders Dr near Bongaree Ave",
                        "Matthew Flinders Dr near Investigator Dr",
                        "Mingaye St near Queen St",
                        "Mingaye St near Domnick St",
                        "Torrens Rd near Adelaide Dr",
                        "Macadamia St near Torrens Rd",
                        "Macadamia St near Michael Ave",
                        "Michael Ave near Lorebury Dr",
                        "Michael Ave near Adelaide Dr",
                        "Morayfield Shops bus station, platform 1",
                        "Morayfield Rd at Caboolture River Road",
                        "Morayfield station"
                    ],
                    "654: Morayfield stn - Caboolture stn via Bellmere": [
                        "Morayfield station",
                        "Morayfield Shops bus station, platform 1",
                        "Michael Ave near Adelaide Dr",
                        "Michael Ave near Lorebury Dr",
                        "Macadamia St near Michael Ave",
                        "Macadamia St near Torrens Rd",
                        "Torrens Rd near Moon St",
                        "Mingaye St near Domnick St",
                        "Mingaye St near Queen St",
                        "Matthew Flinders Dr near Investigator Dr",
                        "Matthew Flinders Dr near Bongaree Ave",
                        "Grant Rd at Julie Drive",
                        "Torrens Rd near Grant Rd",
                        "Torrens Rd near Dorset Dr",
                        "River Dr at Lotus Avenue",
                        "Bellemere Rd near River Dr",
                        "Bellmere Rd near Bishop Lane",
                        "Belle Air Dr near Riverwood Dr",
                        "Belle Air Dr near Riverside Cct",
                        "Bishop Lane near Bellmere Rd",
                        "Piggott Rd near Daintree St",
                        "Kendall Rd near Whimbrel Ct",
                        "Will St near Colburn Way",
                        "Ulster Dr near Hamyln St",
                        "King St at Caboolture Swimming Pool",
                        "King St at Maple Lane",
                        "King St at Arthur Street",
                        "King St at Caboolture RSL Care",
                        "Caboolture Hub",
                        "Caboolture station, stop C"
                    ],
                    "655: Caboolture station - Hospital-TAFE-UniSC (Loop)": [
                        "Caboolture station, stop C",
                        "Lee St at Lee Street State Special School",
                        "Summerfields Dr near Twilight Ct",
                        "Morningview Dr near Breeze Ct",
                        "Central Lakes Dr near St Columbans Ct",
                        "Lethem St near Moorhead St",
                        "McKean St at Caboolture Hospital",
                        "Manley St at Caboolture East State School",
                        "Tallon St at Caboolture TAFE/UniSC",
                        "Tallon St near Mackay St",
                        "Wallace St Nth near Carseldine St"
                    ],
                    "656: Morayfield station - Upper Caboolture (Loop)": [
                        "Morayfield station",
                        "Morayfield Shops bus station, platform 1",
                        "Caboolture River Rd at Kenneth Street",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd near Ben St",
                        "Beacon St near Grant St",
                        "Beacon St near Ronald Ct",
                        "Beacon St near Caboolture River Rd",
                        "Caboolture River Rd near Maple Dr",
                        "Parkridge Ave near Newfarm St",
                        "Parkridge Ave near Olympic Ct",
                        "Parkridge Ave near Kensington Ct",
                        "Cresthaven Dr near Crestwood Ave",
                        "Minimbah State School",
                        "Beacon St near Cox St",
                        "Morayfield Rd at Caboolture River Road"
                    ],
                    "657: Caboolture station - Caboolture North (Loop)": [
                        "Caboolture station, stop C",
                        "Beerburrum Rd near Nursery Rd",
                        "Cowie St near Ruby St",
                        "Jensen Rd near Winterbrook Ct",
                        "Brown St at Jensen Road",
                        "Pettigrew St at Baptisia Cct",
                        "Pettigrew St at Caboolture PCYC",
                        "Elof Rd near Riccardo St",
                        "Van Beelan St near Linwood Ct",
                        "Van Beelan St near Hook Ct",
                        "Male Rd near Van Beelan St",
                        "Male Rd near Granger St",
                        "Granger St near Elof Rd",
                        "Herd St near Sabin St",
                        "Male Rd at Herd Street",
                        "Water Fern Dr near Scribbly Gum Cct",
                        "Racemosa St near Silica St",
                        "Pumicestone State School",
                        "Pumicestone Rd near Cowie St"
                    ],
                    "660: Caboolture Station - Redcliffe via Kippa-Ring": [
                        "Humpybong Esplanade",
                        "Mall Way",
                        "Bluewater Square",
                        "Anzac Ave at Sutton Street",
                        "Anzac Ave at Museum and Historical Society",
                        "Anzac Ave at Redcliffe Hospital",
                        "Anzac Ave at Ashmole Road",
                        "Anzac Ave at Lindel Street",
                        "Peninsula Fair, stop C",
                        "Kippa-Ring station, stop A",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Mewes Road",
                        "Gynther Road",
                        "Deception Bay Rd at Morris Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay bus station",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay Rd at Tallagon Court",
                        "Deception Bay Rd at Krause Street",
                        "Deception Bay Rd at Wayper Way",
                        "Eastern Service Rd at Creek Road",
                        "Station Road at North Shore Drive",
                        "Burpengary Plaza",
                        "Morayfield Rd at Burpengary Pine Village",
                        "Morayfield Rd at Paradise Rd",
                        "Morayfield Rd at Lindsay Road",
                        "Morayfield Rd at Supacentre Shopping Centre",
                        "Morayfield Rd at Oakey Flat Road",
                        "Morayfield Shops bus station, platform 2",
                        "Morayfield Rd at Domnick Street",
                        "Caboolture station, stop B",
                        "Morayfield Rd at John Street",
                        "Deception Bay Rd at Eastern Service Rd",
                        "Deception Bay Rd at Zammit Street",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Peninsula Fair, stop B",
                        "Anzac Avenue near Recreation St",
                        "Settlement Cove Lagoon",
                        "Charlish Park",
                        "Redcliffe Jetty"
                    ],
                    "662: Moreton Downs - Rothwell Station": [
                        "Rothwell station",
                        "Anzac Ave at Finnegan Street",
                        "Deception Bay Rd at Morris Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Webster Road",
                        "Embassy St at Major Street",
                        "Kate Ave near Moreton Downs Dr",
                        "Moreton Downs Dr near Felicity Ct",
                        "Phillip Pde near Bundaberg St",
                        "Bundaberg St near Clair Ave",
                        "Parsons Bvd near Cairns Cr",
                        "Mariner Bvd near Parsons Bvd",
                        "Lipscombe Rd at Leyland Avenue",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay bus station",
                        "Mariner Bvd near Lipscombe St",
                        "Parsons Bvd near Mariner Bvd",
                        "Moreton Downs Dr near Alexandra Ct"
                    ],
                    "663: Narangba Local Service (Loop)": [
                        "Narangba station",
                        "Oakey Flat Rd near Main St",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd near Dorothy St",
                        "Oakey Flat Rd near Pioneer Rd",
                        "Pioneer Dr near Oakey Flat Dr",
                        "Pioneer Dr near Eliza Ct",
                        "Pioneer Dr near Harry Mac Ct",
                        "Rifle Range Rd near Lilly Mac Ct",
                        "Rifle Range Rd near Florence Ct",
                        "Forest Ridge Rd near New Settlement Rd",
                        "Forest Ridge Dr near Tuckeroo St",
                        "Forest Ridge Rd near Rokeby St",
                        "Forest Ridge Rd near Outlook Pl",
                        "Young Rd at Golden Wattle Drive",
                        "Young Rd at Ridge View Drive",
                        "Young Rd at Cottonwood Street",
                        "Hickory Dr near Banyan St",
                        "Hickory Dr near Manuka Rd",
                        "Hickory Dr near Karalla Ct",
                        "Oakey Flat Rd near Duncombe Dr",
                        "Oakey Flat Rd near Stark Dr",
                        "Oakey Flat Rd at Windemere Avenue"
                    ],
                    "664: Burpengary Local Service (Loop)": [
                        "Burpengary Plaza",
                        "Station Road at North Shore Drive",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Station Rd at Burpengary State School",
                        "Burpengary station",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Bellini Rd near Weber Ct",
                        "Bellini Rd near Northshore Dr",
                        "Bellini Rd near Neri Place",
                        "Bellini Rd near Ravel St",
                        "Pitt Rd near Henderson Rd",
                        "Pitt Rd at Claudia St",
                        "Pitt Rd at Pendula Drive",
                        "Station Rd near Hewson St",
                        "Station Rd near David St"
                    ],
                    "665: Deception Bay - Rothwell Station": [
                        "Rothwell station",
                        "Anzac Ave at Finnegan Street",
                        "Deception Bay Rd at Morris Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay bus station",
                        "Maine Tce near Union St",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Ewart St near Raymond Tce",
                        "Ewart St near Thompson St",
                        "Bancroft Tce near Airlie Ave",
                        "Bermuda Ave near St George Cl",
                        "Bermuda Ave near Surfrey Ct",
                        "Bancroft Tce near Moore St",
                        "Thompson St near Elna Ct",
                        "Old Bay Rd near Warroo Dr",
                        "Claverton Dr near Aberfoyle Dr",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd at Krause Street",
                        "Warroo Dr near Kippah St",
                        "Bucknor Dr near Kerwalli St",
                        "Park Rd near Deception Bay Rd",
                        "Deception Bay Rd at Bailey Road"
                    ],
                    "667: Morayfield Local Service (Loop)": [
                        "Hargrave St near Sturt St",
                        "Morayfield Shops bus station, platform 2",
                        "Morayfield station",
                        "Glenwood Dr near Avondale St",
                        "Graham Rd near Parer Cr",
                        "Graham Rd at Hargrave Street",
                        "Glenwood Dr near Glenmay Ct",
                        "Laver Rd near Emerson Dr",
                        "Grogan Rd at Grigg Dr",
                        "Wimbledon Dr near Keneally Ct",
                        "Grigg Dr at Evert Court",
                        "Evert Ct near Denson St",
                        "Coach Rd West at Laver St",
                        "Coach Rd West near Lomandra Dr",
                        "Lomandra Dr near Redcedar Pl",
                        "Glenwood Dr near Cotswold St",
                        "Morayfield Rd at Caboolture River Road",
                        "Graham Road near Morayfield Road hail 'n' ride",
                        "Morayfield Rd at Paradise Rd",
                        "Morayfield Rd at Burpengary Pine Village",
                        "Station Road at North Shore Drive",
                        "Burpengary Plaza"
                    ],
                    "668: Narangba Station - North Lakes": [
                        "North Lakes station, platform 2",
                        "Endeavour Bvd near Bergin St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Astley Pde",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Bounty Bvd",
                        "Bounty Bvd near Astley Pde",
                        "Boundary Rd at Narangba Depot",
                        "Potassium St at Boundary Road",
                        "Potassium St near Krypton St",
                        "Potassium St near Silicon St",
                        "Sodium St at Potassium Street",
                        "Mackie Rd near Ryder Ct",
                        "Mackie Rd near Hall Rd",
                        "Narangba station",
                        "Mackie Rd at Hall Road",
                        "Mackie Rd near Ferrier Rd",
                        "Potassium St near Boundary Rd",
                        "Bounty Bvd near Chrysler Pde"
                    ],
                    "669: Strathpine - Warner via Lawnton": [
                        "Samsonvale Rd near Dundee St",
                        "Samsonvale Rd near Elmwood Dr",
                        "Samsonvale Rd near Kentwood Dr",
                        "Gillam Cr near Carruthers Ct",
                        "Gillam Cr near Auster Ave",
                        "Baker St near De Havilland Dr",
                        "Nightingale Dr near Slack Ct",
                        "Nightingale Dr near Darcy Way",
                        "Todds Rd at Lawnton Primary School",
                        "Lawnton station",
                        "Ellis St near Brown St CLOSED 1 Sept 2025 - June 2026",
                        "Sparkes Rd near Gerard St",
                        "Sparks Rd near Hopetoun St",
                        "Kensington Way near Gloucester Cr",
                        "Kensington Way near Sovereign Ave",
                        "Kensington Ave near Cheltenham St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Bray Park station",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station",
                        "Strathpine bus station, stop B",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Kensington Way near Buckingham St East",
                        "Sparks Rd near Alcira St",
                        "Sparkes Rd near Panorama St",
                        "Ellis St at Brown Street",
                        "Ellis St near Brett St",
                        "Nightingale Dr near Loane Ct",
                        "Gillam Cr near Fortress Ct"
                    ],
                    "670: Strathpine - Warner via Warner Lakes": [
                        "Old North Rd at Warner Shops",
                        "Brisbane Rd near Solomon Pde",
                        "Pallas Pde near Brisbane Rd",
                        "Pallas Pde at Ballyalla Crescent",
                        "Russet Burbank Pde near Swan Pde",
                        "Russet Burbank Pde near Delawar Rd",
                        "Lavarack Rd at Bray Park High School",
                        "Nanbaree Dr near Quiamong Ct",
                        "Nanbaree Dr near Old North Rd",
                        "Windrest St near Garbala Dr",
                        "Ellerdale St near Tecoma St",
                        "Navua St near Bygrave St",
                        "Stanley Street near Navua St",
                        "Leitchs Rd near Avalon Ct",
                        "Nicol Way near Stevens Dr",
                        "Nicol Way near Turner Dr",
                        "Leitchs Rd near Bult Dr",
                        "South Pine Rd near Hinkler Ct",
                        "South Pine Rd near Mott St",
                        "Strathpine station",
                        "Strathpine bus station",
                        "Strathpine bus station, stop A",
                        "South Pine Rd near Station St",
                        "South Pine Rd near Kremzow Rd",
                        "Leitchs Rd near French Ave",
                        "Stanley St near Leitchs Rd",
                        "Stanley St near Livingstone St",
                        "Navua St near Torelliana Dr",
                        "Ellerdale St near Centre St",
                        "Windrest St near Acland Dr",
                        "Strathpine West Primary School",
                        "Pallas Pde near Russett Burbank Pde",
                        "Brisbane Rd near Old North Rd",
                        "Old North Rd at Brisbane Rd"
                    ],
                    "671: Strathpine - Warner": [
                        "Samsonvale Rd near Regent St",
                        "Samsonvale Rd at Kurrajong Drive",
                        "Samsonvale Rd near Youngs Crossing Rd",
                        "Samsonvale Rd near Dundee St",
                        "Samsonvale Rd near Elmwood Dr",
                        "Samsonvale Rd near Kentwood Dr",
                        "Samsonvale Rd near Evergreen Ave",
                        "Casuarina Dr S near Taedi Ave",
                        "Holy Spirit Catholic Primary School",
                        "Kensington Way near Gloucester Cr",
                        "Kensington Way near Sovereign Ave",
                        "Kensington Ave near Cheltenham St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Bray Park station",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station",
                        "Strathpine bus station, stop A",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Kensington Way near Buckingham St East",
                        "Sparkes Rd near Nottingham Pde",
                        "Sparkes Rd near Cedrela Cr",
                        "Samsonvale Rd near Gum St",
                        "Samsonvale Rd near Kurrajong Dr",
                        "Kurrajong Dr near Sassafras Ct",
                        "Kurrajong Ave near Sonata Dr",
                        "Kurrajong Dr near Mondial Dr",
                        "Oakwood Rd near Plover Ct",
                        "Ira Buckby Rd near Hayward Ave",
                        "Ira Buckby Rd near Franzin Dr"
                    ],
                    "672: Strathpine - Warner Lakes": [
                        "Russet Burbank Pde near Delawar Rd",
                        "Pallas Pde near Russett Burbank Pde",
                        "Pallas Pde near Brisbane Rd",
                        "Brisbane Rd near Old North Rd",
                        "Old North Rd at Brisbane Rd",
                        "Old North Rd at Warner Shops",
                        "Youngs Crossing Rd near Oxford St",
                        "Francis Rd near Ebony Ct",
                        "Francis Rd near Colonial Dr",
                        "Aaron St near Francis Rd",
                        "Aaron St near Mitze St",
                        "Mitze St near Aaron St",
                        "Mitze St near Clayton Ct",
                        "Dean St near Shirley St",
                        "Dean St near Lester St",
                        "Samsonvale Rd near Kentwood Dr",
                        "Samsonvale Rd near Evergreen Ave",
                        "Samsonvale Rd near Windrest St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Bray Park station",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station",
                        "Strathpine bus station, stop A",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Dean St near Lockyer Dr",
                        "Francis Rd near Havana Lane",
                        "Brisbane Rd near Solomon Pde",
                        "Pallas Pde at Ballyalla Crescent",
                        "Russet Burbank Pde near Swan Pde"
                    ],
                    "673: Strathpine - Joyner": [
                        "Strathpine bus station, stop B",
                        "Bray Park station",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Kensington Way near Buckingham St East",
                        "Kensington Way near Sovereign Ave",
                        "Sovereign Ave near Ulster St",
                        "Gaurds St near Grenadier St",
                        "Viscount St near Welsh St",
                        "Kumbari St near Tarandi St",
                        "Tarandi St near Jilba St",
                        "Tarandi St near Francis Rd",
                        "Francis Rd near Mitchell St",
                        "Francis Rd near Nightingale Dr",
                        "Francis Rd near Granville Dr",
                        "Francis Rd near Colonial Dr",
                        "Francis Rd near Havana Lane",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd at Todds Road",
                        "Youngs Crossing Rd near Fairlane St",
                        "Francis Rd near Ebony Ct",
                        "Tarandi St near Yenara St",
                        "Kumbari St near Leone St",
                        "Guards St near Grenadier St",
                        "Sovereign Ave near Durham Cr",
                        "Kensington Ave near Cheltenham St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station"
                    ],
                    "674: Strathpine - Warner via Bells Pocket": [
                        "Old North Rd at Warner Shops",
                        "Youngs Crossing Rd near Oxford St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Todds Rd at Youngs Crossing Road",
                        "Todds Rd near Sandown Ct",
                        "Todds Rd at Oxbow Crescent hail 'n' ride",
                        "Todds Rd at Wattlebird Court",
                        "Todds Rd at Lawnton Primary School",
                        "Spencer St near Todds Rd",
                        "Tulip St near Spencer St",
                        "Tulip St near Colleen St",
                        "Rose St near Bray Rd",
                        "Bray Rd near Pinelands St",
                        "Slater Avenue at Lawnton",
                        "Lawnton station",
                        "Lawnton Pocket Rd near Paisley Dr",
                        "Shakespeare Pde near Bells Pocket Rd",
                        "Shakespeare Pde near Browning Ct",
                        "Eliott St near Grahams Rd",
                        "Grahams Rd near Peter St",
                        "Bells Pocket Rd near Lancaster St",
                        "Bells Pocket Rd near Bateman St",
                        "Bells Pocket Rd near Robel St",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station",
                        "Strathpine bus station, stop A",
                        "Bells Pocket Rd near Wirraway St",
                        "Slater Ave near Spencer St",
                        "Bray Rd near Rose St",
                        "Todds Rd near Oxbow Rd",
                        "Todds Rd at Sandown Ct",
                        "Todds Rd near Youngs Crossing Rd"
                    ],
                    "676: North Lakes - Murrumba Downs via Kallangur": [
                        "Murrumba Downs Shopping Centre",
                        "Castle Hill Dr near Pine River Dr",
                        "Pine River Dr near Paroo Pl",
                        "Pine River Dr near Drysdale Ct",
                        "Pine River Dr near Neales St",
                        "Pine River Dr near Yaraki Ct",
                        "Castle Hill Dr near Nottinghill Rd",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Winchcombe Ave",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Dohles Rocks Rd near Chestnut Dr",
                        "Kallangur station, stop A",
                        "Duffield Rd near Winter Rd",
                        "Duffield Rd at Azalea Ct",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "North lakes arrivals stop",
                        "North Lakes station, platform 1",
                        "Anzac Ave at Halpine Drive",
                        "Kallangur station, stop B",
                        "Dohles Rocks Rd near Chestnut Drive",
                        "Castle Hill Dr near Cherington Way",
                        "Castle Hill Dr near Farrington Dr"
                    ],
                    "679: North Lakes - Murrumba Downs via Griffin": [
                        "Murrumba Downs Shopping Centre",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Ogg Rd at Undurba Primary School",
                        "Brays Rd near Burnett Dr",
                        "Brays Rd near Tesch Rd (CLOSED FROM 13/4/26 - 31/7/26)",
                        "Cairns Rd at Vermilion Avenue",
                        "Vermillion Ave near Grandview Pde",
                        "Lavender Dr near Vanilla Ave",
                        "Vanilla Ave near Basil Street",
                        "Dandelion St at Sorrel Street",
                        "Brays Rd at Henry Road",
                        "Brays Rd near Tesch Rd",
                        "Brays Rd near Cairns Rd (Closed from 10 Nov 2025 - 31 July 2026)",
                        "Brays Rd near Moreton St",
                        "Murrumba Downs station, stop A",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "North lakes arrivals stop",
                        "North Lakes station, platform 1",
                        "Anzac Ave at Halpine Drive",
                        "Murrumba Downs station, stop B",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Dohles Rocks Rd at McClintock Drive"
                    ],
                    "680: Redcliffe - Chermside via North Lakes and Petrie": [
                        "Humpybong Esplanade",
                        "Mall Way",
                        "Bluewater Square",
                        "Anzac Ave at Sutton Street",
                        "Anzac Ave at Museum and Historical Society",
                        "Anzac Ave at Redcliffe Hospital",
                        "Anzac Ave at Ashmole Road",
                        "Anzac Ave at Lindel Street",
                        "Peninsula Fair, stop C",
                        "Kippa-Ring station, stop A",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Mewes Road",
                        "Gynther Road",
                        "Anzac Ave at Finnegan Street",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Capestone Boulevard",
                        "Anzac Ave at Kinsellas Road",
                        "Anzac Ave at Halpine Drive",
                        "North Lakes station, platform 2",
                        "Endeavour Bvd near Bergin St",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Anzac Ave at Whites Road",
                        "Gympie Rd at Station Road",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Paisley Park",
                        "Gympie Rd at Pine Rivers High School",
                        "Gympie Rd at Bray Park station",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station, stop C",
                        "Gympie Rd near Duncan Ave",
                        "Gympie Rd near Bald Hills Rd",
                        "Gympie Rd near Dickson St",
                        "Gympie Rd near Telegraph Rd",
                        "Gympie Rd near Roghan Rd",
                        "Roghan Rd near Gympie Rd",
                        "Ridley Rd at Gardenia Place",
                        "Ridley Rd near Retreat St",
                        "Beams Rd near Tintara St",
                        "Gympie Rd at Brickfield Street, stop 45/44",
                        "Gympie Rd at Aspley",
                        "Gympie Rd near Nevin St, stop 42",
                        "Gympie Rd at Aspley South, stop 41",
                        "Gympie Rd at Marchant Park, stop 40",
                        "Gympie Rd near Murphy Rd, stop 39",
                        "Gympie Rd at The Gardens, stop 38A",
                        "Chermside Shopping Centre",
                        "Chermside Shopping Centre interchange F",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Gympie Rd at Marchant Park, stop 40 - CLOSED",
                        "Gympie Rd near Albany Creek Rd, stop 42",
                        "Gympie Rd at Gayford Street, stop 44",
                        "Gympie Rd at Brickfield Street, stop 45",
                        "Ridley Rd at Retreat Street",
                        "Roghan Rd at Ridley Rd",
                        "Gympie Rd near Griffiths St",
                        "Gympie Rd at Saint Pauls School",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Westfield North Lakes",
                        "Anzac Ave at Discovery Drive",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Peninsula Fair, stop B",
                        "Anzac Avenue near Recreation St",
                        "Settlement Cove Lagoon",
                        "Charlish Park",
                        "Redcliffe Jetty"
                    ],
                    "681: North Lakes - Mango Hill (Morning Loop)": [
                        "North Lakes station, platform 2",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "Kinsellas Rd at Ruby Street",
                        "Capestone Bvd at Campbell Drive",
                        "Freshwater Creek Rd near Tattler St",
                        "Freshwater Creek Rd near Jabiru Dr hail 'n' ride",
                        "Halpine Dr near Talara Way",
                        "Mango Hill station",
                        "Halpine Dr at Mango Hill Shopping Centre",
                        "Endeavour Bvd at North Lakes Health Precinct"
                    ],
                    "682: North Lakes - Mango Hill (Afternoon Loop)": [
                        "North Lakes station, platform 2",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "Halpine Dr at Mango Hill Shopping Centre",
                        "Mango Hill station",
                        "Freshwater Creek Rd near Brushwood Crt",
                        "Freshwater Creek Rd near Tattler St",
                        "Capestone Bvd at Campbell Drive",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "Kinsellas Rd at Ruby Street"
                    ],
                    "683: Dakabin - Kallangur Station (Loop)": [
                        "Kallangur station, stop B",
                        "Dohles Rocks Rd near School Rd",
                        "Dohles Rocks Rd near Evelyn St",
                        "Marsden Rd near Narangba Rd",
                        "Marsden Rd near Sylvester Dr",
                        "Marsden Rd at Ballara Street",
                        "Marsden Rd near Whitehorse Rd",
                        "Alma Rd at Essencia Avenue",
                        "Alma Rd at Conquest Boulevard",
                        "Old Gympie Rd at Plantation Road",
                        "Whitehorse Rd near Cootha Dr",
                        "Sheaves Rd at Purnell Street",
                        "Sheaves Rd near Olivia Dr",
                        "Ann St at Blazey Street",
                        "Sylvester Dr at Lauder Street",
                        "Lerose Ave at Gail Street",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Goodfellows Rd at School Road"
                    ],
                    "684: North Lakes - Kallangur East": [
                        "Kallangur station, stop B",
                        "Dohles Rocks Rd near Chestnut Drive",
                        "Alana St near Blatchford Dr",
                        "Goodfellows Rd near Alana St",
                        "Goodfellows Rd near Buse Ct",
                        "Duffield Rd near Winter Rd",
                        "Duffield Rd at Azalea Ct",
                        "Anzac Ave at Kallangur Fair",
                        "Kent St near Holborn St",
                        "Brickworks Rd near Galway Dr",
                        "Duffield Rd near Brickworks Rd",
                        "Duffield Rd near Wyena St",
                        "Lavercombe Dr near Lintone St",
                        "Balstrup Rd near Olsen Cct",
                        "Plantation Rd at Kerr Road",
                        "Plantation Rd at Balstrup Road",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Bergin St",
                        "North Lakes station, platform 1"
                    ],
                    "685: North Lakes - Kallangur West": [
                        "Kallangur station, stop A",
                        "Goodfellows Rd near Blatchford Dr",
                        "Alana St at Blatchford Drive",
                        "Dohles Rocks Rd near Chestnut Dr",
                        "School Rd near Scotts Ct",
                        "School Rd near Ann St",
                        "School Rd near Brickworks Rd",
                        "Old Gympie Rd at Whitehorse Road",
                        "Old Gympie Road at Whitehorse Road",
                        "Plantation Rd at Kerr Road",
                        "Plantation Rd at Balstrup Road",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Bergin St",
                        "North Lakes station, platform 1",
                        "Old Gympie Rd at Plantation Road",
                        "Old Gympie Rd at Butterfly Drive",
                        "School Rd near Doon St",
                        "Dohles Rocks Rd near Clyde St"
                    ],
                    "686: French's Forest - Petrie Station (Loop)": [
                        "Petrie station, stop B",
                        "Anzac Ave at Whites Road",
                        "Dayboro Rd near Baldwin St",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Joora Ave",
                        "Affleck Ave at Washbrook Crescent",
                        "Affleck Ave at Homestead Place",
                        "D'Aguilar St at Hunter Circuit",
                        "Andrew Petrie Dr at Affleck Avenue",
                        "Beeville Rd at Oleron Tce",
                        "Beeville Rd at Frenchs Rd",
                        "Beeville Rd near Mona Vale Way",
                        "Kurwongbah Dr near Beeville Rd",
                        "Kurwongbah Dr near Carwell Ave",
                        "Macquarie Dr at Colac Court",
                        "Eucumbene Dr near Burrumbeet St",
                        "Burrumbeet St at Brewster Court",
                        "Eucumbene Dr near Frenchs Rd",
                        "Frenchs Rd at Macquarie Drive",
                        "Belrose Ave near Rue Montaigne",
                        "Woonara Dr near Joora Ave"
                    ],
                    "687: North Lakes - Mango Hill Station": [
                        "Mango Hill station",
                        "Halpine Dr at Mango Hill Shopping Centre",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "North Lakes station, platform 2",
                        "Endeavour Bvd near Bergin St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Astley Pde",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Bounty Bvd",
                        "Bounty Bvd near Aurora Bvd",
                        "Bounty Bvd near Possum Pde",
                        "Bounty Bvd near Brumby Pde",
                        "Bounty Bvd near Wombat Pde",
                        "Discovery Dr near Tuckeroo Pde",
                        "Discovery Dr near Gardenia Pde",
                        "Discovery Dr near Peron Cr",
                        "Discovery Dr near Willandra Pde",
                        "Discovery Dr near Springsure Pde",
                        "Discovery Dr near College St"
                    ],
                    "688: North Lakes (Clockwise Loop)": [
                        "North Lakes station, platform 2",
                        "North Lakes Shopping Centre, stop A",
                        "Endeavour Bvd near Bergin St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Astley Pde",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Bounty Bvd",
                        "Bounty Bvd near Astley Pde",
                        "Aurora Bvd near Magnetic Tce",
                        "Bounty Bvd near Possum Pde",
                        "Bounty Bvd near Brumby Pde",
                        "Bounty Bvd near Wombat Pde",
                        "Discovery Dr near Tuckeroo Pde",
                        "Discovery Dr near Gardenia Pde",
                        "Discovery Dr near Peron Cr",
                        "Discovery Dr near Willandra Pde",
                        "Discovery Dr near Springsure Pde",
                        "Discovery Dr near College St",
                        "Endeavour Bvd at North Lakes Health Precinct"
                    ],
                    "689: North Lakes (Anti-Clockwise Loop)": [
                        "North Lakes station, platform 2",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "Discovery Dr near Southerden Dr",
                        "Discovery Dr near Davenport Pde",
                        "Discovery Dr near Otway Pde",
                        "Discovery Dr near Bridgeport Dr",
                        "Discovery Dr near Marsh St",
                        "Discovery Dr near Tuckeroo Pde",
                        "Bounty Bvd near Trevino Pde",
                        "Bounty Bvd near Montgomerie Pde",
                        "Bounty Bvd near Garcia Pde",
                        "Aurora Bvd near Bounty Bvd",
                        "Aurora Bvd near Magnetic Tce",
                        "Bounty Bvd near Chrysler Pde",
                        "Endeavour Bvd near Bounty Bvd",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Astley Pde",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Bergin St",
                        "North Lakes Shopping Centre, stop B"
                    ],
                    "690: Kippa-Ring - Sandgate via Redcliffe": [
                        "Duffield Rd near Elizabeth Ave",
                        "Elizabeth Ave near Nerida Ct",
                        "Elizabeth Ave near Pamrick Cr",
                        "Elizabeth Ave at Korsch Street",
                        "Elizabeth Ave at Grimley Street",
                        "Kippa-Ring station, stop A",
                        "Boardman Rd at Susan Avenue",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd at Marsala Street",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Pinewood Street",
                        "Scarborough Rd at Klinger Road",
                        "Scarborough Rd at Shields Street",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Scarborough Rd at Anderson Street",
                        "Scarborough Rd at Jeays Street",
                        "Scarborough Rd at Fifth Avenue",
                        "Fifth Ave at Moffatt Street",
                        "Landsborough Ave at Warde Street",
                        "Landsborough Ave at Rock Street",
                        "Landsborough Ave at Kennedy Esplanade",
                        "Landsborough Ave at Murphy Street",
                        "Oxley Ave at Adams Street",
                        "Oxley Ave at Pearl Street",
                        "Oxley Ave at Eversleigh Road",
                        "Oxley Ave at Shields Street",
                        "Klingner Rd at Redcliffe State High School",
                        "Prince Edward Pde at Captain Cook Park",
                        "Humpybong Esplanade",
                        "Mall Way",
                        "Bluewater Square",
                        "Anzac Ave at Sutton Street",
                        "Anzac Ave at Museum and Historical Society",
                        "Oxley Ave at Humpybong Park",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Margate Shopping Centre",
                        "Oxley Ave at Langdon Park",
                        "Oxley Ave at King Street",
                        "Oxley Ave at Westbrook Street",
                        "Oxley Ave at Annie Street",
                        "Oxley Ave at Alfred Street",
                        "Hornibrook Esp at Woody Point Park",
                        "Hornibrook Esp at Victoria Avenue",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Hornibrook Esp at Clontarf Beach West",
                        "Hornibrook Hwy at Eventide Aged Home",
                        "Beaconsfield Tce near Duke St",
                        "Beaconsfield Tce near Shepherd St",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Twelfth Ave",
                        "Brighton Tce near Tenth Ave",
                        "Brighton Tce near Wakefield St",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Sandgate bus station, stop 2",
                        "Sandgate Central, stop 33",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Brighton Tce near Twelfth Ave",
                        "Beaconsfield Tce near Princess St",
                        "Hornibrook Hwy at Eventide",
                        "Hornibrook Hwy at Brighton Bayside Park",
                        "Hornibrook Esp at Bramble Bay Bowls Club",
                        "Settlement Cove Lagoon",
                        "Charlish Park",
                        "Klingner Rd at Redcliffe High School",
                        "Redcliffe Jetty",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave near Adams St",
                        "Landsborough Ave at Bunton Street",
                        "Fifth Ave at Moffat Street",
                        "Klingner Rd at Longland Street",
                        "Klingner Rd at OConnell Street",
                        "Boardman Rd at McGregor Street",
                        "Elizabeth Ave near Macdonnell Rd",
                        "Elizabeth Ave near Gardenia St"
                    ],
                    "691: Redcliffe - Sandgate Station": [
                        "Scarborough Rd at Fifth Avenue",
                        "Scarborough Rd at Jeays Street",
                        "Scarborough Rd at Anderson Street",
                        "Scarborough Rd at Southern Cross College",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Shields Street",
                        "Scarborough Rd at Klinger Road",
                        "Scarborough Rd at Redcliffe Showgrounds",
                        "Recreation St at Redcliffe Hospital",
                        "Victoria Ave at Anzac Avenue",
                        "Victoria Ave at Bradley Park",
                        "Victoria Ave at Macdonnell Road",
                        "Victoria Ave at Barry Bolton Park",
                        "Duffield Rd at Edith Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd at Beedham Street",
                        "Maine Rd near Tainton St",
                        "Maine Rd near Gerald Ave",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Hornibrook Esp at Clontarf Beach West",
                        "Hornibrook Hwy at Eventide Aged Home",
                        "Beaconsfield Tce near Duke St",
                        "Beaconsfield Tce near Shepherd St",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Twelfth Ave",
                        "Brighton Tce near Tenth Ave",
                        "Brighton Tce near Wakefield St",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Sandgate bus station, stop 3",
                        "Sandgate Central, stop 33",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Brighton Tce near Twelfth Ave",
                        "Beaconsfield Tce near Princess St",
                        "Hornibrook Hwy at Eventide",
                        "Hornibrook Hwy at Brighton Bayside Park",
                        "Maine Rd near Isobel St",
                        "Victoria Ave at Duffield Road"
                    ],
                    "694: Kippa-Ring - Redcliffe via Woody Point": [
                        "Humpybong Esplanade",
                        "Mall Way",
                        "Bluewater Square",
                        "Anzac Ave at Sutton Street",
                        "Anzac Ave at Museum and Historical Society",
                        "Oxley Ave at Humpybong Park",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Margate Shopping Centre",
                        "Oxley Ave at Langdon Park",
                        "Oxley Ave at King Street",
                        "Oxley Ave at Westbrook Street",
                        "Oxley Ave at Annie Street",
                        "Oxley Ave at Alfred Street",
                        "Hornibrook Esp at Woody Point Park",
                        "Hornibrook Esp at Victoria Avenue",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Elizabeth Ave near Handsworth St",
                        "Elizabeth Ave near Roland St",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Alice St",
                        "Maine Rd at Beedham Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd near Duffield Rd hail 'n' ride",
                        "Maine Rd at Gardenia Street",
                        "Macdonnell Rd at Kingsford Street",
                        "Trilby St near Macdonnell Rd",
                        "Trilby St near Highland St",
                        "Trilby St near George St",
                        "George St at Jentz St",
                        "George St near Lindel St",
                        "Peninsula Fair, stop C",
                        "Kippa-Ring station, stop A",
                        "Kippa-Ring stations, stop B",
                        "Peninsula Fair, stop A",
                        "George St near Kappella St",
                        "Trilby St at George Street",
                        "Trilby St near Centaur St",
                        "Macdonnell Rd at Trilby Street",
                        "Maine Rd at Windsor Street",
                        "Elizabeth Ave near Long St",
                        "Elizabeth Ave near Angus St",
                        "Hornibrook Esp at Clontarf Beach West",
                        "Hornibrook Esp at Bramble Bay Bowls Club",
                        "Settlement Cove Lagoon",
                        "Charlish Park",
                        "Redcliffe Jetty"
                    ],
                    "696: Kippa-Ring - Kippa Ring Loop": [
                        "Kippa-Ring stations, stop B",
                        "Boardman Rd at Susan Avenue",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd at Marsala Street",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Pinewood Street",
                        "Klingner Rd at Redcliffe State High School",
                        "Prince Edward Pde at Captain Cook Park",
                        "Humpybong Esplanade",
                        "Mall Way",
                        "Bluewater Square",
                        "Marine Pde near Sydney St",
                        "Marine Pde near Macdonnell Rd",
                        "Margate Pde at McCulloch Ave",
                        "Margate Pde at Beaconsfield Street",
                        "Margate Pde at Humpybong State School",
                        "Whytecliffe Pde at Arthur Street",
                        "Gayundah Esp near Georgina St",
                        "Gayundah Esp near Alfred St",
                        "Lilla St near Oxley Ave",
                        "Oxley Ave near Hornibrook Esp",
                        "Hornibrook Esp at Woody Point Park",
                        "Victoria Avenue near Hornibrook Esp",
                        "Victoria Ave at Clifford Street",
                        "Victoria Ave at King Street",
                        "Victoria Ave at Dunbar Street",
                        "Victoria Ave at Duffield Road",
                        "Victoria Ave at Barry Bolton Park",
                        "Victoria Ave at Macdonnell Road",
                        "Victoria Ave at Bradley Park",
                        "Anzac Ave at Redcliffe Hospital",
                        "Anzac Ave at Ashmole Road",
                        "Anzac Ave at Lindel Street",
                        "Peninsula Fair, stop C",
                        "Kippa-Ring station, stop A",
                        "Peninsula Fair, stop B",
                        "Victoria Ave at Anzac Avenue",
                        "Hornibrook Esp at Bramble Bay Bowls Club",
                        "Gayundah Esp near Ellen St",
                        "Whytecliffe Pde at King Street",
                        "Settlement Cove Lagoon",
                        "Charlish Park",
                        "Klingner Rd at Redcliffe High School",
                        "Redcliffe Jetty",
                        "Klingner Rd at Longland Street",
                        "Klingner Rd at OConnell Street",
                        "Boardman Rd at McGregor Street"
                    ],
                    "698: Redcliffe - Kippa-Ring via Scarborough": [
                        "Rothwell station",
                        "Gynther Rd near Eton St",
                        "Morris Rd near Gynther Rd",
                        "Morris Rd near Melaleuca Cr",
                        "Morris Rd near Lynanda Ct",
                        "Morris Rd near Taronga St",
                        "Morris Rd near Kirribilli St",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Susan Avenue",
                        "Kippa-Ring station, stop A",
                        "Kippa-Ring stations, stop B",
                        "Klingner Rd near Brunel St",
                        "Anzac Avenue at Regency Street",
                        "Nathan Rd near Napier St",
                        "Morris Rd at Summerfield Street",
                        "Morris Rd at Lynanda Court",
                        "Morris Rd at Bertie Dow Park"
                    ],
                    "699: Redcliffe - Kippa Ring Station": [
                        "Humpybong Esplanade",
                        "Prince Edward Pde at Captain Cook Park",
                        "Prince Edward Pde near Shields St",
                        "Prince Edward Pde near Josephine St",
                        "Prince Edward Pde near Osbourne St",
                        "Prince Edward Pde near Herbert St",
                        "Prince Edward Pde near Donkin St",
                        "Landsborough Ave at Murphy Street",
                        "Landsborough Ave at Bunton Street",
                        "Landsborough Ave at Rock Street",
                        "Landsborough Ave at Warde Street",
                        "Fifth Ave at Moffat Street",
                        "Thurecht Pde at Thurecht Park",
                        "Jeays St at Palmtree Avenue",
                        "Scarborough Rd at Jeays Street",
                        "Scarborough Rd at Anderson Street",
                        "Sunnyside Rd at Central Avenue",
                        "Sunnyside Rd at Fernlea Avenue",
                        "Endeavour Esp at Dolphin Street",
                        "Newport Dr near Southern Cross Dr",
                        "Newport Drive near Griffith Rd",
                        "Griffith Rd at Newport Marina",
                        "Griffith Rd at Volunteer Street",
                        "Boardman Rd at Arcadia Crescent",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Susan Avenue",
                        "Kippa-Ring station, stop A",
                        "Kippa-Ring stations, stop B",
                        "Boardman Rd at Talobilla Park",
                        "Newport Dr at Southern Cross Drive",
                        "Sunnyside Rd near Oyster Point Esp",
                        "Fifth Ave at Moffatt Street",
                        "Landsborough Ave at Kennedy Esplanade",
                        "Prince Edward Pde near Griffith Rd",
                        "Prince Edward Pde near Eversleigh Rd"
                    ],
                    "700: Tweed Heads - Broadbeach via Burleigh Heads": [
                        "Wharf St at Tweed Heads",
                        "Twin Towns Services Club",
                        "Griffith St at Coolangatta East",
                        "Coolangatta Central",
                        "Marine Pde at Kirra Beach",
                        "Marine Pde at Kirra Beach Hotel",
                        "Musgrave St at Kirra shops",
                        "Musgrave St at Coyne Street",
                        "Golden Four Dr at North Kirra Beach",
                        "Johnston Street",
                        "Golden Four Dr at George Street",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Shell Street",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Teemangum St at Kropp Park",
                        "Currumbin Wildlife Sanctuary",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Gold Coast Hwy at Thrower Drive",
                        "Gold Coast Hwy at Palm Beach Police Station",
                        "Gold Coast Hwy at Fourth Avenue",
                        "Palm Beach",
                        "Gold Coast Hwy at Eighth Avenue",
                        "Gold Coast Hwy at Tenth Avenue",
                        "Gold Coast Hwy at Fifteenth Avenue",
                        "Nineteenth Avenue",
                        "Gold Coast Hwy at Twenty First Avenue",
                        "Gold Coast Hwy at Twenty Fifth Avenue",
                        "Twenty Seventh Avenue",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Burleigh Heads National Park",
                        "Tweed St at George St",
                        "Burleigh Heads station",
                        "Gold Coast Hwy at Second Avenue station",
                        "Gold Coast Hwy at Christine Avenue station",
                        "Gold Coast Hwy at Miami station",
                        "Gold Coast Hwy at Miami North station",
                        "Gold Coast Hwy at Nobby Beach station",
                        "Gold Coast Hwy at Mermaid Beach South station",
                        "Gold Coast Hwy at Mermaid Beach station",
                        "Broadbeach South station, stop C",
                        "Broadbeach South station",
                        "Broadbeach North station",
                        "Gold Coast Hwy at Florida Gardens station",
                        "Remembrance Drive at Surfers Paradise Bvd",
                        "Remembrance Dr at Markwell Avenue",
                        "Surfers Paradise",
                        "Ferny Ave at Palm Avenue",
                        "Ferny Ave at Ocean Avenue",
                        "Main Beach station",
                        "Ada Bell Way at Broadwater Parklands station",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B",
                        "Southport Medical Precinct",
                        "Queen Street station (Southport)",
                        "Griffith University, platform 3",
                        "GCUH, platform 3",
                        "GCUH, platform 4",
                        "Broadbeach South station, stop A",
                        "Griffith University, platform 4",
                        "Southport bus station, stop A",
                        "Tweed St at George Street",
                        "Gold Coast Hwy at Thirteenth Avenue",
                        "Cahill Street",
                        "Golden Four Dr at Archer Street",
                        "McLean St at Queen Elizabeth Park",
                        "Wharf St at Tweed Mall"
                    ],
                    "704: Sea World - Helensvale via Harbour Town": [
                        "Helensvale stop D",
                        "Town Centre Drive",
                        "Gold Coast Hwy at Discovery Drive",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Gold Coast Hwy at Arundel Drive",
                        "Brisbane Rd at Computer Street",
                        "Brisbane Rd at Pine Ridge Road",
                        "Brisbane Rd at Centre View Drive",
                        "Harbour Town, stop A",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Labrador Park Shopping Centre",
                        "Brisbane Rd at Billington Street",
                        "Brisbane Rd at Loder Street",
                        "Marine Pde at Parker Street",
                        "Gold Coast Hwy at Grand Hotel",
                        "Gold Coast Hwy at Whiting Street",
                        "Gold Coast Hwy at Central Street",
                        "Gold Coast Hwy at Southport Tourist Park",
                        "Gold Coast Hwy at Broadwater Tourist Park",
                        "North St at Norman Street",
                        "Scarborough St at Southport Transit Centre",
                        "Scarborough St at Marshall Lane",
                        "Southport bus station, stop A",
                        "Scarborough St at White Street",
                        "Tedder Avenue at Cronin Avenue",
                        "Tedder Ave at Montgomery Avenue",
                        "Main Beach Pde near Stafford Ave",
                        "Seaworld Dr at Southport Yacht Club",
                        "Seaworld Dr at Mariners Cove",
                        "Sea World",
                        "Seaworld Dr at Sheraton Mirage",
                        "Tedder Ave at Lennie Avenue",
                        "Southport bus station, stop B",
                        "Frank St at Whiting Street",
                        "Gold Coast Hwy at Labrador Senior Citizens",
                        "Brisbane Rd at Turpin Road",
                        "Harbour Town, stop B",
                        "Helensvale station"
                    ],
                    "705: Broadbeach - Seaworld & Main Beach via Surfers": [
                        "Broadbeach South station, stop C",
                        "Pacific Fair, stop C",
                        "Surf Pde at Broadbeach Mall",
                        "Elizabeth Av at Oracle Boulevard",
                        "Old Burleigh Rd at Kurrawa SLSC",
                        "Old Burleigh Rd at Queensland Avenue",
                        "Old Burleigh Rd at Britannia Avenue",
                        "Armrick Av at Broadbeach Boulevard",
                        "Old Burleigh Rd at First Avenue",
                        "Old Burleigh Rd at Fern Street",
                        "Remembrance Drive at Surfers Paradise Bvd",
                        "Remembrance Dr at Markwell Avenue",
                        "Remembrance Dr at Bruce Bishop Car Park",
                        "Surfers Paradise",
                        "Ferny Ave at Palm Avenue",
                        "Ferny Ave at Ocean Avenue",
                        "Main Beach Pde at Esplanade Surfers Paradise",
                        "Main Beach Pde at Cable Street",
                        "Main Beach Pde at Woodroffe Avenue",
                        "Main Beach Pde at Main Beach Tourist Park",
                        "Seaworld Dr at Southport Yacht Club",
                        "Seaworld Dr at Mariners Cove",
                        "Sea World",
                        "Seaworld Dr at Sheraton Mirage",
                        "Main Beach Pde at Breaker Street",
                        "Ocean Av at Surfers Paradise North station",
                        "Pacific Fair, stop B",
                        "Broadbeach South station"
                    ],
                    "709: Helensvale station - Hope Island": [
                        "Helensvale stop A",
                        "Town Centre Drive",
                        "Sir John Overall Dr at Helensvale Plaza",
                        "Lindfield Rd near Latrobe Ave",
                        "Lindfield Rd near Brookton Ct",
                        "Discovery Dr at Lindfield Road Shops",
                        "Discovery Dr at Hession Oval",
                        "Discovery Dr at Eugenia Reserve",
                        "Discovery Dr at Ashford Road",
                        "Discovery Dr at Kingaroy Avenue",
                        "Helensvale State High School",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr near Creekwood Pl",
                        "Hope Island station, stop B",
                        "Hope Island / Hope Island",
                        "Cova Bvd at Hope Island Rd",
                        "Marina Quays Bvd at Mervyn Thomas Dr",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Sheehan Av at Harbour Rise",
                        "Sickle Ave at Ballybunyon Cr",
                        "Hope Island Rd near Magnolia Dr hail 'n' ride",
                        "Hope Island station, stop A",
                        "Monterey Keys Dr at Creekwood Place",
                        "Lindfield Rd at Helensvale Plaza",
                        "Helensvale station"
                    ],
                    "710: Uni-Hospital - Helensvale via Parkwood": [
                        "Helensvale stop B",
                        "Town Centre Drive",
                        "Gold Coast Hwy at Discovery Drive",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Arundel Dr near Maltravers Dr",
                        "Arundel Dr near Arun Dr",
                        "Arundel Dr near Neri Cr",
                        "Napper Rd at Arundel Primary School",
                        "Parkwood Bvd near Peter Thomson Dr",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Gary Player Cr",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr near Suncrest Ct",
                        "Wintergreen Dr near Ballybunion Dr",
                        "GCUH, platform 4",
                        "Griffith University, platform 4",
                        "Griffith University, platform 3",
                        "GCUH, platform 3",
                        "Henry Cotton Dr near Wintergreen Dr",
                        "Henry Cotton Dr near Hazeltine Pl",
                        "Parkwood Bvd near Davis Ct",
                        "Parkwood Bvd near Kel Nagle Ct",
                        "Arundel Dr near Arundel Pl",
                        "Arundel Dr near Paterson Dr",
                        "Helensvale station"
                    ],
                    "711: Sanctuary Cove - Southport via Runaway Bay": [
                        "Runaway Bay Centre",
                        "Southport bus station, stop B",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Scarborough St at Marshall Lane",
                        "Bayview St at Karema Crescent",
                        "Scarborough St at Southport Transit Centre",
                        "Bayview St at Runaway Bay Marina",
                        "North St at Norman Street",
                        "Gold Coast Hwy at Broadwater Tourist Park",
                        "Bayview St near Salvia St",
                        "Gold Coast Hwy at Southport Tourist Park",
                        "Bayview St at Columbus Drive",
                        "Gold Coast Hwy at Central Street",
                        "Bayview St near Sapphire St",
                        "Frank St at Whiting Street",
                        "Bayview St near Falkinder Ave",
                        "Gold Coast Hwy at Labrador Senior Citizens",
                        "Paradise Pde at Errol Ave",
                        "Marine Pde at Parker Street",
                        "Oxley Dr at Blaxland Avenue",
                        "Broadwater Ave at Crescent Avenue",
                        "Brisbane Rd at Turpin Road",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Hollywell Rd near Thelma Ave",
                        "Burrows St at Oleander Ave",
                        "Marina Quays Bvd at Mervyn Thomas Dr",
                        "Burrows St at Back St",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Marine Pde at Lands End",
                        "Hope Island Rd near Magnolia Dr hail 'n' ride",
                        "Bayview St at Clam Street",
                        "Hope Island station",
                        "Bayview St at Oatland Esplanade",
                        "Bayview St at Madang Crescent",
                        "Runaway Bay Retirement Village",
                        "Masthead Way at Sanctuary Cove",
                        "Hope Island station, stop B",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Bayview St at Sapphire Street",
                        "Bayview St at Jasmine Avenue",
                        "Bayview St at Cassia Street",
                        "Burrows St near Back St",
                        "Hollywell Rd near Parr St",
                        "Brisbane Rd at Billington Street",
                        "Brisbane Rd at Loder Street",
                        "Gold Coast Hwy at Grand Hotel",
                        "Gold Coast Hwy at Whiting Street",
                        "Southport bus station, stop A"
                    ],
                    "712: Southport - Coombabah via Harbour Town": [
                        "Southport bus station, stop B",
                        "Scarborough St at Marshall Lane",
                        "Scarborough St at Southport Transit Centre",
                        "Scarborough St near High St",
                        "Walton St near Worendo St",
                        "Stevens St near William St",
                        "Clayton St near Musgrave Ave",
                        "Ernest St near Robert St",
                        "Robert St near Muir St",
                        "Ahern St near Robert St",
                        "Ahern St near Central St",
                        "Central St near Proud St",
                        "Muir St near Grace Ave",
                        "Imperial Pde near Coral Ave",
                        "Imperial Pde near Turpin Rd",
                        "Government Rd at Labrador State School",
                        "Government Rd near Brookside Rd",
                        "Labrador Park Shopping Centre",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Harbour Town, stop B",
                        "Oxley Dr at Limetree Parade",
                        "Oxley Dr at Thyme Court",
                        "Oxley Dr at Cayman Court",
                        "Lae Dr at The Runaway Brace",
                        "Lae Dr at Morala Avenue",
                        "Runaway Bay Centre",
                        "Oxley Dr at Paradise Lake Resort",
                        "Marsupial Dr near Kangaroo Ave",
                        "Kangaroo Ave at Kangaroo Park",
                        "Kangaroo Ave near Possum Ct",
                        "Oxley Dr at Lae Drive",
                        "Harbour Town, stop A",
                        "Government Rd near Ashton St",
                        "Government Rd near Ferguson Ave",
                        "Government Rd near Gordon St",
                        "Ahern St near Bradford St",
                        "Ernest St near Walter St",
                        "Worendo St near Walton St",
                        "Southport bus station, stop A"
                    ],
                    "713: Paradise Point - Southport via Harbour Town": [
                        "Southport bus station, stop B",
                        "Scarborough St at Marshall Lane",
                        "Nind St near Davenport St",
                        "Johnston St near Kate St",
                        "Johnston St near Maid St",
                        "Johnston St at Beale Street",
                        "Beale St near Dowling Dr",
                        "Brooke Ave at Mole Avenue",
                        "Brooke Ave near Deakin Ave",
                        "Brooke Ave at Musgrave Avenue",
                        "Wilson St at Jimmieson Avenue",
                        "Wilson St at Robert Street",
                        "Wilson St at Stoke Avenue",
                        "Wilson St near Heydon Ave",
                        "Wilson St near Pengana St",
                        "Whiting St at Government Road",
                        "Whiting St at Brown Street",
                        "Whiting St at Usher Avenue",
                        "Usher Ave at Vona Place",
                        "Central St at Central Street",
                        "Central St near Davebill Ct",
                        "Olsen Ave at Central Street Shops",
                        "Olsen Ave at Paul Sharratt Park",
                        "Olsen Ave at Allied Drive",
                        "Olsen Ave at Blanford Street",
                        "Harbour Town, stop B",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Labrador Park Shopping Centre",
                        "Hollywell Rd near Thelma Ave",
                        "Morala Ave at Biggera Waters School",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Limetree Pde",
                        "Morala Ave at Folkstone Place",
                        "Lae Dr at Morala Avenue",
                        "Runaway Bay Centre",
                        "Lae Dr at The Runaway Brace",
                        "Oxley Dr at Paradise Lake Resort",
                        "Oxley Dr at Crystal Reef Drive",
                        "Oxley Dr at Hansford Road",
                        "Hansford Rd near Doreen Dr",
                        "Hansford Rd at Numbat Ct",
                        "Hansford Dr near Sanctuary Ct",
                        "Hansford Rd near Citie Dr",
                        "Myola Ct at Georgia Street",
                        "Esplanade at Tarni St",
                        "Hansford Rd near Sanctuary Ct",
                        "Argyll Ave near Wendoree Way",
                        "Brady Dr near Burrendong Rd",
                        "Oxley Dr at Coombabah State Primary School",
                        "Oxley Dr at Daisy Elms Park",
                        "Matthew Flinders Dr at Magellan Avenue",
                        "Bayview St near Falkinder Ave",
                        "Argyll Ave near Burrinjuck Drive",
                        "Oxley Dr at Marsupial Drive",
                        "Oxley Dr at Lae Drive",
                        "Morala Ave near Broadwater St",
                        "Morala Ave near Kropp St",
                        "Hollywell Rd near Parr St",
                        "Harbour Town, stop A",
                        "Central St at Central Street Shops",
                        "Central St near Usher Ave",
                        "Usher Ave at Whiting Street",
                        "Wilson St near Saltash St",
                        "Wilson St near First Ave",
                        "Brooke Ave at Southport State High School",
                        "Nind St near Chapel St",
                        "Southport bus station, stop A"
                    ],
                    "714: Uni-Hospital - Helensvale via Pacific Pines": [
                        "Helensvale stop E",
                        "Town Centre Drive",
                        "Binstead Way at Pacific Pines Boulevard",
                        "Binstead Way at Studio Drive",
                        "Binstead Way at Jubilee Primary School",
                        "Binstead Way at Palmerston Drive",
                        "Pitcairn Way near Norris St",
                        "Pitcairn Way at McAuley Parade",
                        "Pitcairn Way near Sangster Cr",
                        "Pitcairn Way at Lennox Street",
                        "Pitcairn Way near Belongil St",
                        "Pitcairn Way near Yaldara St",
                        "Pitcairn Way near Easter Cr",
                        "Pitcairn Way at Pacific Pines Town Centre",
                        "Smith St near Hammond Dr",
                        "Napper Rd at Daintree Drive",
                        "Daintree Dr near Highview Pl",
                        "Daintree Dr near Wardley Dr",
                        "Napper Rd at Arundel Plaza",
                        "Napper Rd at Tee Trees Boulevard",
                        "Napper Rd at Arundel Primary School",
                        "Napper Rd at Allied Drive",
                        "Olsen Ave at Southport Lawn Cemetery",
                        "GCUH, platform 4",
                        "Griffith University, platform 4",
                        "Griffith University, platform 3",
                        "GCUH, platform 3",
                        "Napper Rd near Benalla Ct",
                        "Smith St near Banyula Dr",
                        "Pitcairn Way near Beerwah St",
                        "Pitcairn Way near Springwood Ave",
                        "Pitcairn Way at Blackheath Terrace",
                        "Binstead Way at Universal Street",
                        "Helensvale station"
                    ],
                    "715: Southport - Helensvale via Arundel, Pacific Pines": [
                        "Helensvale stop E",
                        "Town Centre Drive",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Pacific Pines Bvd near Papara St",
                        "Pacific Pines Bvd near Glade Dr",
                        "Santa Isobel Bvd near Mussau St",
                        "Archipelago St near Hotham Dr",
                        "Pitcairn Way at Pacific Pines Town Centre",
                        "Smith St near Hammond Dr",
                        "Greenacre Dr at Parkwood station",
                        "Greenacre Dr at Fairview Ct",
                        "Greenacre Dr at Jamieson Drive",
                        "Uplands Dr at Greenacre Drive",
                        "Uplands Dr at Woodlands Way",
                        "Uplands Dr at Brushwood Ridge Reserve",
                        "Napper Rd at Arundel Primary School",
                        "Allied Dr at Carnoustie Ct",
                        "Allied Dr near Range Ct",
                        "Central St near Allied Dr",
                        "Central St near Carrumbella Dr",
                        "Central St at Central Street Shops",
                        "Central St near Usher Ave",
                        "Usher Ave near Tanias Pl",
                        "Government Rd near Morinda Way",
                        "Government Rd at Galaxy Court",
                        "Olsen Ave at Boea Street",
                        "Musgrave Ave near Botanical Dr",
                        "Musgrave Ave at Keith Hunt Park",
                        "Kumbari Ave near Nakina St",
                        "Johnston St at Ewan Street",
                        "Johnston St at Beale Street",
                        "Johnston St near Maid St",
                        "Johnston St near Kate St",
                        "Nind St near Chapel St",
                        "Scarborough St at Marshall Lane",
                        "Southport bus station, stop A",
                        "Southport bus station, stop B",
                        "Nind St near Davenport St",
                        "Kumbari Ave near Smith Street Mwy",
                        "Government Rd near Jupiter Cl",
                        "Usher Ave near McMillan St",
                        "Central St at Central Street",
                        "Central St near Davebill Ct",
                        "Central St at Carrumbella Dr",
                        "Allied Dr at Central St",
                        "Allied Dr at Spikes Ct",
                        "Allied Dr near Carnoustie Ct",
                        "Greenacre Dr at Jamieson Dr",
                        "Greenacre Dr at Fairview Court",
                        "Smith St near Banyula Dr",
                        "Archipelago St near Penrhyn St",
                        "Pacific Pines Bvd near Nandi Tce",
                        "Helensvale station"
                    ],
                    "716: Studio Village - Helensvale Station (Loop)": [
                        "Helensvale stop F",
                        "Town Centre Drive",
                        "Binstead Way at Pacific Pines Boulevard",
                        "Binstead Way at Studio Drive",
                        "Village Way near Studio Dr",
                        "Village Way near Drama St",
                        "Village Way near Mews Ct",
                        "Studio Dr near Hepburn Ct",
                        "Studio Dr near Village Way",
                        "Binstead Way at Universal Street",
                        "Helensvale station"
                    ],
                    "717: Pacific Pines - Helensvale Station": [
                        "Helensvale stop F",
                        "Town Centre Drive",
                        "Binstead Way at Pacific Pines Boulevard",
                        "Binstead Way at Studio Drive",
                        "Binstead Way at Jubilee Primary School",
                        "Palmerston Dr near Maui Cr",
                        "Pinevale Dr near Hiva Ct",
                        "Pinehill Dr near Universal St",
                        "Universal St near Crestridge Cr",
                        "Universal St near Pinevale Dr",
                        "Gaven Primary School",
                        "Universal St near Buchanan Ct",
                        "Greenway Bvd near Brissendon St",
                        "McAuley Pde near Matthews Dr",
                        "McAuley Pde near Diamantina Cct",
                        "Harmsworth Rd near Wunburra Ccl",
                        "Brockman Way near Bowley St",
                        "Santa Isobel Bvd near Pitcairn Way",
                        "Santa Isobel Bvd near Chatham Ave",
                        "Archipelago St near Hotham Dr",
                        "Pitcairn Way at Pacific Pines Town Centre",
                        "Archipelago St near Penrhyn St",
                        "Santa Isobel Bvd near Amanu Cr",
                        "Universal St near Guy Lane",
                        "Universal St near Takahe St",
                        "Pinevale Dr near Palmerston Dr",
                        "Palmerston Dr near Laysan Cr",
                        "Binstead Way at Universal Street",
                        "Helensvale station"
                    ],
                    "718: Santa Barbara - Helensvale via Oyster Cove": [
                        "Helensvale stop A",
                        "Helensvale stop B",
                        "Town Centre Drive",
                        "Helensvale Community Centre",
                        "Discovery Dr at Ridgevale Drive",
                        "Discovery Dr at Helensvale Primary School",
                        "Discovery Dr at Lindfield Road Shops",
                        "Discovery Dr at Hession Oval",
                        "Discovery Dr at Eugenia Reserve",
                        "Discovery Dr at Ashford Road",
                        "Discovery Dr at Kingaroy Avenue",
                        "Helensvale State High School",
                        "Helensvale Rd at Monterey Keys Drive",
                        "Helensvale Rd at Dalley Park Dr",
                        "Helensvale Rd at Calmwater Crescent",
                        "Helensvale Rd at Sabrina Avenue",
                        "Helensvale Rd at Saltwater Park",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Marina Quays Bvd at Mervyn Thomas Dr",
                        "Santa Barbara Rd near Chindrina St",
                        "Cova Bvd at Hope Island Rd",
                        "Akoonah St near Eingana St",
                        "Pinnaroo St near Mungala St",
                        "Akoonah St near Mungala St",
                        "Buddeh St near Santa Barbara Rd",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Helensvale Road at Dalley Park Drive",
                        "Helensvale State Primary School",
                        "Helensvale station"
                    ],
                    "719: Paradise Point - Southport via Uni-Hospital": [
                        "Southport bus station, stop B",
                        "Scarborough St at Marshall Lane",
                        "Scarborough St at Southport Transit Centre",
                        "Smith St at High Street",
                        "Smith St at Southport State High School",
                        "Smith St at Shillington Avenue",
                        "Smith St at Kumbari Avenue",
                        "Griffith University, platform 3",
                        "GCUH, platform 3",
                        "Olsen Ave at Southport Lawn Cemetery",
                        "Olsen Ave at Boea Street",
                        "Olsen Ave at McMillan Street",
                        "Olsen Ave at Central Street Shops",
                        "Olsen Ave at Paul Sharratt Park",
                        "Olsen Ave at Allied Drive",
                        "Olsen Ave at Blanford Street",
                        "Harbour Town, stop B",
                        "Brisbane Rd at Centre View Drive",
                        "Brisbane Rd at Pine Ridge Road",
                        "Pine Ridge Rd at Lensgate Road",
                        "Pine Ridge Rd at Pine Ridge Caravan Park",
                        "Pine Ridge Rd at Coombabah High School",
                        "Pine Ridge Rd at Coombabah Road",
                        "Pine Ridge Rd at Siena Place",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Lae Dr at The Runaway Brace",
                        "Lae Dr at Morala Avenue",
                        "Runaway Bay Centre",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Bayview St at Karema Crescent",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St near Salvia St",
                        "Bayview St at Columbus Drive",
                        "Bayview St near Sapphire St",
                        "Bayview St near Falkinder Ave",
                        "Paradise Pde near Sunbird Ave",
                        "Paradise Pde near Nankeen Ave",
                        "Paradise Pde near Mallard Ave",
                        "Paradise Pde at Donald Avenue",
                        "Paradise Pde at Sunbird Avenue",
                        "Bayview St at Sapphire Street",
                        "Bayview St at Jasmine Avenue",
                        "Bayview St at Cassia Street",
                        "Pine Ridge Rd near Siena Pl",
                        "Harbour Town, stop A",
                        "GCUH, platform 4",
                        "Griffith University, platform 4",
                        "Smith St at Curtin Avenue",
                        "Southport bus station, stop A"
                    ],
                    "720: Pimpama City - Coomera Station": [
                        "Coomera station, stop D",
                        "Foxwell Rd at Coomera Town Centre",
                        "Days Rd at Coomera Anglican College",
                        "Days Rd at City Centre Drive",
                        "Days Rd near Coomera Grand Drive",
                        "NightJar Dr at Gecko Crescent",
                        "Nightjar Dr at Butcher Bird Circuit",
                        "Coomera Springs Bvd at Sandpiper Court",
                        "Coomera Springs Bvd at Dayflower Street",
                        "Coomera Springs Bvd at Rainlily Crescent",
                        "The Heights Bvd at McCabe Avenue",
                        "The Heights Bvd at Hill Drive",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Pimpama Sports Hub",
                        "Rifle Range Rd at Bull Road",
                        "Waverly Dr at Rifle Range Road",
                        "Waverly Dr at Persimmon Street",
                        "Bella Bvd at Deepak Drive",
                        "Waverley Dr at Bella Boulevard",
                        "Depot Rd near Pimpama Jacobs Well Rd",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Ormeau station",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Days Rd at Coomera Grand Drive",
                        "Coomera station"
                    ],
                    "721: Coomera - Ormeau via Coomera Springs, Pimpama": [
                        "Coomera station, stop D",
                        "Days Rd at Coomera Anglican College",
                        "Days Rd at City Centre Drive",
                        "Old Coach Rd at Days Road",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Rifle Range Rd at Bull Road",
                        "Pimpama station, stop B",
                        "Depot Rd near Pimpama Jacobs Well Rd",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Pimpama station, stop A",
                        "Coomera station"
                    ],
                    "722: Coomera - Pimpama via Coomera Rivers, Dixon": [
                        "Coomera station, stop C",
                        "Finnegan Way at Felix Entrance",
                        "Finnegan Way at Lily Avenue",
                        "Finnegan Way at Cirrus Way",
                        "Cunningham Dr at William Boulevard",
                        "Dixon Dr at Pimpama State Primary College",
                        "Dixon Drive at Pimpama State Secondary College",
                        "Dixon Dr at Pimpama Junction",
                        "Yawalpah Rd at Gainsborough State School",
                        "Yawalpah Rd at Swan Road",
                        "Nexus Dr at Home Focus Shopping Mall",
                        "Pimpama station",
                        "Pimpama station, stop A",
                        "Yawalpah Rd at Salzburg Rd hail 'n' ride",
                        "Dixon Dr at Pimpama State Secondary College",
                        "Coomera station"
                    ],
                    "723: Coomera - Helensvale via Oxenford": [
                        "Helensvale stop A",
                        "Town Centre Drive",
                        "Helensvale Community Centre",
                        "Mildura Dr at Burdekin Ave",
                        "Mildura Dr near Halbury Ct",
                        "Mildura Dr near Pentland Ct",
                        "Ridgevale Dr near Mildura Dr",
                        "Ridgevale Dr at Kiandra Place",
                        "Ridgevale Dr near Armidale Cr",
                        "Discovery Dr at Ridgevale Drive",
                        "Discovery Dr at Helensvale Primary School",
                        "Discovery Dr at Lindfield Road Shops",
                        "Discovery Dr at Hession Oval",
                        "Discovery Dr at Eugenia Reserve",
                        "Discovery Dr at Ashford Road",
                        "Discovery Dr at Kingaroy Avenue",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale Rd at Woodside Place",
                        "Entertainment Dr at Movie World",
                        "California Dr near Michigan Dr",
                        "Califorina Dr near Riversdale Rd",
                        "California Dr near Oregon Way",
                        "Oregon Way near Emerson Way",
                        "Michigan Dr near Swindon Pl",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Regatta Ave near Essen Pl",
                        "Leo Graham Way near Cottonwood Pl",
                        "Dreamworld Parkway at Boathouse Tavern",
                        "Yaun St at Sena Street",
                        "Lorenzo Dr at Beattie Road",
                        "Beattie Rd at Ford Road",
                        "Waterway Dr at McPhail Rd",
                        "Waterway Dr at Shipper Drive",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Coomera station",
                        "Coomera station, stop D",
                        "Yaun St near Sena St",
                        "Yaun St near Jowett St",
                        "California Dr near Riversdale Rd",
                        "California Dr near Nevada Pl",
                        "Helensvale State Primary School",
                        "Ridgevale Dr at Dubbo Court",
                        "Ridgevale Dr at Mildura Drive",
                        "Mildura Dr at Pentland Court",
                        "Mildura Dr at Halbury Court",
                        "Mildura Dr near Burdekin Ave",
                        "Helensvale station"
                    ],
                    "724: Pimpama Sports Hub - Coomera Station": [
                        "Coomera station, stop A",
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Amity Rd at Daintree Drive",
                        "Amity Rd at Picnic Creek State School",
                        "Kerkin Rd South at St Josephs College",
                        "Kerkin Rd South at St Joseph's College",
                        "Kerkin Rd S at Vanes Street",
                        "Cunningham Dr at Arcadia Boulevard",
                        "William Bvd at Carnarvon Court",
                        "William Bvd at Tierney Way",
                        "Augusta Bvd at Cascade Street",
                        "Gawthern Dr at Gainsborough State School",
                        "Swan Rd at Aquila Reserve",
                        "Gainsborough Dr at Greenmount Street",
                        "Gainsborough Dr at Flinders Street",
                        "Sarabah Way at Kosciuszko Circuit",
                        "Pimpama station, stop B",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Village Bvd at Chisolm Way",
                        "Village Bvd at Dorset Street",
                        "Rifle Range Rd at Bull Road",
                        "Pimpama Sports Hub",
                        "Pimpama station, stop A",
                        "Gawthem Dr at Gainsborough State School",
                        "Gawthern Dr at Karingal Dr",
                        "Augusta Bvd at Brookfield Street",
                        "Foxwell Rd at Oakey Creek Road",
                        "Foxwell Rd at Oakey Creek Rd",
                        "Coomera station"
                    ],
                    "725: Coomera - Helensvale via Upper Coomera": [
                        "Helensvale stop A",
                        "Coomera station, stop D",
                        "Town Centre Drive",
                        "Foxwell Rd at Coomera Town Centre",
                        "Sir John Overall Dr at Helensvale Plaza",
                        "Days Rd at Coomera Anglican College",
                        "Williamson Rd near Billinghurst Cr",
                        "Lindfield Rd near Latrobe Ave",
                        "Billinghurst Cr near Turnbull Dr",
                        "Lindfield Rd near Brookton Ct",
                        "Discovery Dr at Lindfield Road Shops",
                        "Billinghurst Cr near Godden Dr",
                        "Discovery Dr at Hession Oval",
                        "Billinghurst Cr near Jessica Dr",
                        "Discovery Dr at Eugenia Reserve",
                        "Billinghurst Cr at Livingstone Street",
                        "Discovery Dr at Ashford Road",
                        "Old Coach Rd at Low Drive",
                        "Discovery Dr at Kingaroy Avenue",
                        "Reserve Rd near Jessica Dr",
                        "Helensvale State High School",
                        "Brygon Creek Dr near Ascendancy Way",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Roe St at Brygon Creek Drive",
                        "Monterey Keys Dr at Parkgate Street",
                        "Roe St at Con Brio Boulevard",
                        "Monterey Keys Dr at Glengate Street",
                        "Roe St near Tutor St",
                        "Monterey Keys Dr at Greengate Street",
                        "Hargraves Rd at Caribou Crescent",
                        "Reserve Road at Abraham Rd",
                        "Monterey Keys Dr near Creekwood Pl",
                        "Hope Island Rd at Anaheim Drive",
                        "Reserve Rd at Dreamtime Zone",
                        "Heathwood Dr near Koala Town Rd",
                        "Reserve Road at Hargraves Rd",
                        "Hope Island station, stop A",
                        "Hope Island / Hope Island",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Roe St near Prefect Cl",
                        "Roe St near Con Brio Bvd",
                        "Masthead Way at Sanctuary Cove",
                        "Brygon Creek Dr near Mockingbird Dr",
                        "Reserve Rd near Goldcrest Dr",
                        "Coomera station",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Monterey Keys Dr at Creekwood Place",
                        "Lindfield Rd at Helensvale Plaza",
                        "Helensvale station"
                    ],
                    "726: Coomera - Coomera Waters": [
                        "Coomera station, stop A",
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Colman Rd near Ragamuffin Dr W",
                        "Colman Rd near Brilliant Lane",
                        "Colman Rd near Ragamuffin Dr East",
                        "Colman Rd near Ragamuffin Dr",
                        "Foxwell Road at Colman Road",
                        "Foxwell Rd near Ragamuffin Dr",
                        "Foxwell Rd at Oakey Creek Road",
                        "Foxwell Rd at Oakey Creek Rd",
                        "Coomera station"
                    ],
                    "727: Coomera - Helensvale via Upper Coomera": [
                        "Helensvale stop F",
                        "Town Centre Drive",
                        "Capricorn Dr near Windward Rise",
                        "Mitaro Rise near Manra Way",
                        "Victoria Dr near Buffalo Cr",
                        "Victoria Dr near Hawker St",
                        "Pitcairn Way near Norris St",
                        "Gaven Arterial Rd at Felling Drive",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Cobb and Co Dr near Appollo Pl",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Reserve Rd near Jemima Pl",
                        "Reserve Rd near Amelia St",
                        "Rose Valley Dr at Lysterfield Rise",
                        "Reserve Rd near Lawson St",
                        "Lauren Gr at Ghostgum Gr",
                        "Old Coach Rd at Low Drive",
                        "Lauren Gr at Ferngrove Av",
                        "Old Coach Rd near Billinghurst Cr",
                        "Hargraves Rd at Con Brio Bvd",
                        "Hargraves Rd at Caribou Crescent",
                        "Days Rd at City Centre Drive",
                        "Reserve Rd at Pandanus Place",
                        "Reserve Rd near Goldcrest Dr",
                        "Days Rd at Coomera Anglican College",
                        "Coomera station",
                        "Coomera station, stop D",
                        "Reserve Rd near Herbert St",
                        "Reserve Rd near Jessica Dr",
                        "Reserve Rd at Upper Coomera Village",
                        "Victoria Dr near Feathertop Cr",
                        "Manra Way near Mitaro Rise",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Helensvale station"
                    ],
                    "728: Beenleigh - Ormeau via Yatala, Jacobs Ridge": [
                        "Ormeau station",
                        "Mirambeena Dr near Lumeah Ave",
                        "River Run Cct at Landsdowne Drive",
                        "River Run Cct at Beaufort Crescent",
                        "Ellenborough Ave near Terania Ave",
                        "Ormeau Ridge Rd near Sir Charles Holme Dr",
                        "Ormeau Ridge Rd near Johnson Pde",
                        "Eggersdorf Rd at Ormeau Village",
                        "Eggersdorf Rd at Jacobs Ridge Road",
                        "Eggersdorf Rd at Mother Teresa Primary School",
                        "Maidenwell Road at Appadene Street",
                        "Kilkivan Drive at Maidenwell Road",
                        "Kilkivan Dr near Eumundi St",
                        "Rockwood Dr near Goldmine Rd",
                        "Goldmine Rd near Jonquil St",
                        "Goldmine Rd near Lahrs Rd",
                        "Lahrs Rd near Motorway Circuit",
                        "Lahrs Rd near Mark Porter Pl",
                        "Lahrs Rd near Notar Dr Sth",
                        "Lahrs Rd near Notar Dr Nth",
                        "Eastern Service Rd near Elliot Dr hail 'n' ride",
                        "Christensen Rd near Jacobs Well Rd",
                        "Old Pacific Hwy near Kaycee Pl",
                        "Old Pacific Hwy at MacPherson Road",
                        "Martens St near Main St",
                        "Main St near Lubach St",
                        "Main St near Church St",
                        "Beenleigh station, stop B",
                        "Main St near Gona St",
                        "Old Pacific Hwy near Jacobs Well Rd",
                        "Eastern Service Rd near Home Hardware HnR",
                        "Kilkivan Dr near Tarella Ct",
                        "Maidenwell Road at Millicent Street",
                        "Eggersdorf Rd at Riverside Sanctuary Terrace",
                        "Ormeau Ridge Rd near Yarwood",
                        "Mirambeena Dr near Umbango Dr"
                    ],
                    "729: Beenleigh - Ormeau via Yatala, Ormeau Hills": [
                        "Ormeau station",
                        "Mirambeena Dr at Ormeau School",
                        "Mirambeena Dr near Lumeah Ave",
                        "Reedmans Rd near Arthur Way",
                        "Gawain Dr near Bedivere Dr",
                        "Gawain Dr near Lahey Ct",
                        "Arthur Way near Gawain Dr",
                        "Peachey Rd at Doherty Ct",
                        "Peachey Rd near Caswell Ct",
                        "Peachey Rd near Vaughan Dr",
                        "Philben Dr near Peachey Rd",
                        "Philben Dr near Winfield Rd",
                        "Philben Dr near Citrinus Ct",
                        "Doolan St near Philben Dr",
                        "Doolan St near Karall St",
                        "Doolan St near Colane St",
                        "Pascoe Rd near Solanum St",
                        "Pascoe Rd at Halfway Drive",
                        "Cuthbert Dr near Brookside Cct",
                        "Old Pacific Hwy near Kaycee Pl",
                        "Computer Rd at Progress Street",
                        "Old Pacific Hwy at MacPherson Road",
                        "Martens St near Main St",
                        "Main St near Lubach St",
                        "Main St near Church St",
                        "Beenleigh station, stop B",
                        "Main St near Gona St",
                        "Old Pacific Hwy near Jacobs Well Rd",
                        "Darlington Dr near Cuthbert Dr",
                        "Computer Rd near Byte St",
                        "Computer Rd near Progress St",
                        "Computer Rd near Program St",
                        "Doolan St near Halfway Dr",
                        "Peachey Rd at Doherty Court",
                        "Gawain Dr near Sugarmill St",
                        "Mirambeena Dr near Umbango Dr"
                    ],
                    "731: Broadbeach - Southport via Isle Capri": [
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Bermuda St at Hooker Boulevard",
                        "Bermuda St at Sophie Ave",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Salerno Street",
                        "Salerno St at Salerno Street",
                        "Salerno St at Fiesta Avenue",
                        "Via Roma near Hobgen St",
                        "Via Roma at Verona Avenue",
                        "Remembrance Dr at Markwell Avenue",
                        "Remembrance Dr at Bruce Bishop Car Park",
                        "Surfers Paradise",
                        "Thomas Dr near Burra St",
                        "Thomas Dr near Anembo St",
                        "Home Of The Arts (HOTA)",
                        "Bundall Rd at City of Gold Coast",
                        "Ferry Rd at Southport Golf Club",
                        "Ferry Rd at York Street",
                        "Ferry Rd at The Southport School",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B",
                        "Southport bus station, stop A",
                        "Thomas Dr near Parnoo St",
                        "Via Roma near Salerno St",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Bermuda St at Rudd Street",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Pacific Fair, stop B",
                        "Broadbeach South station"
                    ],
                    "732: Coomera Station - Pimpama Station via Pimpama": [
                        "Coomera station, stop C",
                        "George Alexander Wy near Bloom Avenue",
                        "Celestial Wy at Azure Way",
                        "Orlando Dr near Jackson Street",
                        "Picnic Creek State School",
                        "Edwardson Dr near Amity Rd hail 'n' ride",
                        "Amity Rd at Picnic Creek State School",
                        "Kerkin Rd South at St Josephs College",
                        "Kerkin Rd South at St Joseph's College",
                        "Kerkin Rd S at Vanes Street",
                        "Gainsborough Dr at Melville Drive",
                        "Gainsborough Dr at Danbulla Street",
                        "Gainsborough Dr at Terrace Street",
                        "Halcyon Dr near Gainsborough Dr",
                        "Gainsborough Dr at Kinglake Crescent",
                        "Gainsborough Dr at Greenmount Street",
                        "Gainsborough Dr at Flinders Street",
                        "Pimpama station, stop B",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Pimpama station, stop A",
                        "Edwardson Dr at Picnic Creek State School",
                        "George Alexander Wy at Bloom Avenue",
                        "Coomera station"
                    ],
                    "733: Pimpama Station - Jacobs Well(interim Ormeau Stn)": [
                        "Harrigans Ln at Calypso Bay Marina",
                        "Harbour Bvd at Moreton Drive",
                        "Helmore Rd at Samuel Court",
                        "Kumgum St at Lions Park",
                        "Stapylton Jacobs Well Rd Riesenweber Park",
                        "Pelican Pde at Woodswallow St",
                        "Cormorant Cr at Ibis Pde",
                        "Pimpama Jacobs Well Rd at King's Christian College",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Pimpama station",
                        "Pimpama station, stop B"
                    ],
                    "735: Southport - Nerang Station via Ashmore": [
                        "Nerang station, stop E",
                        "Nerang Broadbeach Rd at Allambe Gardens",
                        "Nerang Broadbeach Rd at Paradise Street",
                        "Price St at Nerang State School",
                        "City of Gold Coast, Nerang",
                        "Southport Nerang Rd at Parkridge Drive",
                        "Southport Nerang Rd at Central Park Plaza",
                        "Southport Nerang Rd at BP Central Park",
                        "Southport Nerang Rd at Ashmore Road",
                        "Trinity Lutheran School",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Ashmore City Shopping Centre",
                        "Nerang Rd at Aquinas Catholic College",
                        "Nerang Rd at Wardoo Street",
                        "Nerang Rd at Orana Avenue",
                        "Nerang St at Falconer Street",
                        "Nerang St at West End Shops",
                        "Southport Medical Precinct",
                        "Southport bus station, stop A",
                        "Southport bus station, stop B",
                        "Nerang Rd at Bailey Crescent",
                        "Southport Nerang Rd at Stewart Parade",
                        "Southport Nerang Rd at Bellara Street",
                        "Nerang station"
                    ],
                    "736: Broadbeach - Nerang via Highland Park": [
                        "Nerang Bicentennial Centre",
                        "Price St at Nerang State School",
                        "Price St at Earle Plaza",
                        "Birribi Ave near Nerang River Dr",
                        "Weedons Rd at Nerang High School",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "McLeod St at Aberdeen Court",
                        "William Duncan Primary School",
                        "Alexander Dr near Richard Cr",
                        "Alexander Dr at Kahlua Court",
                        "Bonooroo Park Shopping Centre",
                        "Nielsens Rd at Hickey Way",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop C",
                        "Pacific Fair, stop A",
                        "Gooding Dr at Merrimac Golf Course",
                        "Alexander Dr at Sue Court",
                        "McLeod St at Balfour Crescent",
                        "Mortensen Rd near The Linkway"
                    ],
                    "737: Ashmore - Southport via Southport Park": [
                        "Glenmore Dr near Lochinvar Ct",
                        "Ashmore Rd at Reed Street",
                        "Ashmore Rd at Boree Street",
                        "Allchurch Ave at Benowa Primary School",
                        "Saint Kevins Ave at Paradise Palms hail 'n' ride",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at Sapium Road",
                        "Wardoo St at Petra Street",
                        "Wardoo St at Lilli Pilli Drive",
                        "Anne St at Pilliga Street",
                        "Blake St at Anne Street",
                        "Blake St at Alicia Street",
                        "Eileen Ave near Beryl St",
                        "Ridgeway Ave near Gayle St",
                        "Benowa Rd at Golden Crescent",
                        "Benowa Rd at Drury Avenue",
                        "Centro Southport",
                        "Benowa Rd at Centro Southport",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Queen St at Garden Street",
                        "Bauer St near Chester Tce",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B",
                        "Southport bus station, stop A",
                        "Eileen Ave at Beryl Street",
                        "Blake St near Alicia St",
                        "Anne St at Jane Street",
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Benowa Rd at Benowa Gardens"
                    ],
                    "738: Broadbeach - Uni-Hospital via Ashmore": [
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Sunshine Bvd at Merrimac Boulevard",
                        "Sunshine Bvd at Sonder Street",
                        "TE Peters Dr at Summerland Key",
                        "Rio Vista Bvd near Grant Pl",
                        "Rio Vista Bvd at Cristobel Court",
                        "Rio Vista Bvd at Sheridan Park Avenue",
                        "Monaco St at Rio Vista Boulevard",
                        "Monaco St at Pacific Boulevard",
                        "Monaco St at Bill Compton Park",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Bundall Rd at Pisa Court",
                        "Bundall Rd at City of Gold Coast",
                        "Slatyer Ave at Corporate Court",
                        "Slatyer Ave at Bronberg Plaza",
                        "Benowa Rd at Sapium Road",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Heeb St at The Crescent",
                        "Ashmore Rd at Boree Street",
                        "Warrungen Way near Mowla Dr",
                        "Warrungen Way near Yangoora Cr",
                        "Numeralla Ave near Talofa St",
                        "Numeralla Ave near Yarran Dr",
                        "Girral Ave near Tibor Ct",
                        "Southport Nerang Rd at Ashmore Road",
                        "Mitchell Ave at Coachwood Drive",
                        "Macquarie Ave at Lachlan Avenue",
                        "Breakspear Rd at Mahogany Hill Park",
                        "Crestwood Dr at Watergum Parade",
                        "Crestwood Dr at Crestwood Plaza",
                        "Olsen Ave at Crestwood Plaza",
                        "Griffith University, platform 3",
                        "Griffith University, platform 4",
                        "Mitchell Ave near Sturt St",
                        "Numeralla Ave near Maloo Pl",
                        "Warrungen Way near Merrina Dr",
                        "Warrungen Way near Mowla Drive",
                        "Slatyer Ave at Ferry Road",
                        "Fremar St at Fremar Street",
                        "Rio Vista Bvd at Grant Place",
                        "TE Peters Dr at Andrea Avenue",
                        "Pacific Fair, stop B",
                        "Broadbeach South station"
                    ],
                    "739: Uni-Hospital - Nerang via Ashmore": [
                        "Nerang station, stop D",
                        "Nerang Broadbeach Rd at Allambe Gardens",
                        "Nerang Broadbeach Rd at Paradise Street",
                        "Railway Pde at View Street",
                        "Station St at Centro Nerang",
                        "New St at Nerang Mall",
                        "Cayuga St at PCYC Nerang",
                        "McLeod St at Aberdeen Court",
                        "William Duncan Primary School",
                        "Alexander Dr near Richard Cr",
                        "Alexander Dr at Kahlua Court",
                        "Bonooroo Park Shopping Centre",
                        "Nielsens Rd at Hickey Way",
                        "Birmingham Rd near The Boulevard",
                        "Birmingham Rd at Emerald Lakes Drive",
                        "Ross St at Royal Pines",
                        "Ross St at Benowa Village",
                        "Currumburra Rd at Tangerine Row",
                        "Currumburra Rd at Mualla Drive",
                        "Currumburra Rd at Ashmore Primary School",
                        "Currumburra Rd near Cotlew St",
                        "Currumburra Rd near Koonan Ct",
                        "Currumburra Rd at Green Glen Road",
                        "Olsen Ave at Crestwood Plaza",
                        "Griffith University, platform 3",
                        "Griffith University, platform 4",
                        "Currumburra Rd at Corporation Drive",
                        "Currumburra Rd near Mualla Dr",
                        "Currumburra Rd near Tangerine Row",
                        "Currumburra Rd at Milparinka Terrace",
                        "Birmingham Rd at The Boulevard",
                        "Alexander Dr at Sue Court",
                        "McLeod St at Balfour Crescent",
                        "Cayuga St at Onslow Street",
                        "Nerang station"
                    ],
                    "740: Surfers Paradise - Nerang via Ashmore": [
                        "Nerang Bicentennial Centre",
                        "Nerang station, stop A",
                        "Price St at Nerang State School",
                        "Nerang Broadbeach Rd at Lakeview Drive",
                        "Ross St at Royal Pines",
                        "Nerang Broadbeach Rd at Paradise Street",
                        "Ashmore Rd at Boree Street",
                        "Heeb St at The Crescent",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Benowa Rd at Sapium Road",
                        "Slatyer Ave at Bronberg Plaza",
                        "Slatyer Ave at Ferry Road",
                        "Thomas Dr near Anembo St",
                        "Thomas Dr near Parnoo St",
                        "Surfers Paradise Bvd at Cypress Ave",
                        "Thomas Dr near Burra St",
                        "Slatyer Ave at Corporate Court",
                        "Nerang station, stop E",
                        "Nerang station",
                        "Nerang Broadbeach Rd at Allambe Gardens"
                    ],
                    "741: Broadbeach - Southport via Ashmore, Keebra Park": [
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Sunshine Bvd at Merrimac Boulevard",
                        "Sunshine Bvd at Sonder Street",
                        "TE Peters Dr at Summerland Key",
                        "Rio Vista Bvd at Rudd Street",
                        "Rudd St at Wyuna Street",
                        "Bermuda St at Sophie Ave",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Ashmore Rd at Upton Street",
                        "Ashmore Rd at Campbell Street",
                        "Ashmore Road Commercial Precinct",
                        "Ashmore Rd at Sir Bruce Small Park",
                        "Benowa Gardens Shopping Centre",
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at Collins Crescent",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Heeb St at The Crescent",
                        "Ashmore Rd at Boree Street",
                        "Warrungen Way near Mowla Dr",
                        "Warrungen Way near Yangoora Cr",
                        "Numeralla Ave near Talofa St",
                        "Numeralla Ave near Yarran Dr",
                        "Girral Ave near Tibor Ct",
                        "Southport Nerang Rd at Ashmore Road",
                        "Cotlew St at McCowan St",
                        "Cotlew St near Patonga St",
                        "Cotlew St at Ashmore Plaza",
                        "Cotlew St at Parkleigh Court",
                        "Cotlew St at Hermitage Close",
                        "Cotlew St at Tecoma Street",
                        "Coolibah St at Sussex Drive Park",
                        "Coolibah St near Lilli Pilli Dr",
                        "Kindra Ave at Lara Avenue",
                        "Kindra Ave near Larwon Tce",
                        "Shirley St at Anne Street",
                        "Shirley St near Caroline Ave",
                        "Shirley St near Melinda St",
                        "Ridgeway Ave near Gayle St",
                        "Benowa Rd at Golden Crescent",
                        "Benowa Rd at Drury Avenue",
                        "Centro Southport",
                        "Benowa Rd at Centro Southport",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B",
                        "Southport State School",
                        "Southport bus station, stop A",
                        "Tongarra St near Lilli Pilli Dr",
                        "Cotlew St near McCowan St",
                        "Numeralla Ave near Maloo Pl",
                        "Warrungen Way near Merrina Dr",
                        "Warrungen Way near Mowla Drive",
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Benowa Rd at Benowa Gardens",
                        "Bermuda St at Rudd Street",
                        "Rudd St at Rosemont Avenue",
                        "TE Peters Dr at Andrea Avenue",
                        "Pacific Fair, stop B",
                        "Broadbeach South station"
                    ],
                    "742: Molendinar - Southport via Ashmore": [
                        "Production Ave near Mercantile Ct hail 'n' ride",
                        "Activity Cres at Production Avenue",
                        "Macquarie Ave at Lachlan Avenue",
                        "Mitchell Ave near Sturt St",
                        "Trinity Lutheran School",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Ashmore City Shopping Centre",
                        "Currumburra Rd at Corporation Drive",
                        "Currumburra Rd near Cotlew St",
                        "Currumburra Rd near Mualla Dr",
                        "Currumburra Rd at Mualla Drive",
                        "Currumburra Rd near Tangerine Row",
                        "Heeb St at The Crescent",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at Golden Crescent",
                        "Benowa Rd at Drury Avenue",
                        "Centro Southport",
                        "Benowa Rd at Centro Southport",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B",
                        "Southport bus station, stop A",
                        "Currumburra Rd at Tangerine Row",
                        "Currumburra Rd at Ashmore Primary School",
                        "Currumburra Rd near Koonan Ct",
                        "Currumburra Rd at Green Glen Road",
                        "Mitchell Ave at Coachwood Drive"
                    ],
                    "743: Broadbeach - Nerang via Carrara": [
                        "Nerang station, stop B",
                        "Nerang Broadbeach Rd at Allambe Gardens",
                        "Lawrence Dr near Leagues Club Dr",
                        "Brendan Dr near OShea Dr",
                        "Station St at Centro Nerang",
                        "New St at Nerang Mall",
                        "Cayuga St at PCYC Nerang",
                        "McKenzie Dr at Monopoly Boulevard",
                        "Pappas Way near Dawnann Ct",
                        "Pappas Way near Remount Pl",
                        "Pappas Way near Cambridge Ct",
                        "Pappas Way near Dearne Pl",
                        "Murev Way near Alzino Pl",
                        "Michelmore Rd near Woolmere St",
                        "Michelmore Rd near Hickey Way",
                        "Nielsens Rd at Hickey Way",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop C",
                        "Pacific Fair, stop A",
                        "Gooding Dr at Merrimac Golf Course",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Cayuga St at Onslow Street",
                        "Lawrence Dr near Tropical Dr",
                        "Nerang station"
                    ],
                    "744: Broadbeach - Nerang via Highland Park": [
                        "Nerang station, stop B",
                        "Nerang Broadbeach Rd at Allambe Gardens",
                        "Nerang Broadbeach Rd at Paradise Street",
                        "Railway Pde at View Street",
                        "Station St at Centro Nerang",
                        "New St at Nerang Mall",
                        "Cayuga St at PCYC Nerang",
                        "McLeod St at Aberdeen Court",
                        "William Duncan Primary School",
                        "Explorers Way at Garvie Place",
                        "Explorers Way at Cozens Way",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Wy near Delta Cove Dr",
                        "Nabarlek Dr near Explorers Wy",
                        "Mataranka Dr near Barrine Dr",
                        "Hinkler Dr near Explorers Way",
                        "Bonooroo Park Shopping Centre",
                        "Nielsens Rd at Hickey Way",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop C",
                        "Pacific Fair, stop A",
                        "Gooding Dr at Merrimac Golf Course",
                        "McLeod St at Balfour Crescent",
                        "Cayuga St at Onslow Street",
                        "Nerang station"
                    ],
                    "745: Broadbeach - Nerang Station": [
                        "Nerang station, stop C",
                        "Nerang Broadbeach Rd at Lakeview Drive",
                        "Riverside Home Caravan Park",
                        "Nerang Broadbeach Rd at Garden Grove",
                        "Nerang Broadbeach Rd at Nielsens Road",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop C",
                        "Pacific Fair, stop A",
                        "Gooding Dr at Merrimac Golf Course",
                        "Nerang station"
                    ],
                    "746: Nerang West - Nerang station": [
                        "Yarraowee Drive near McLaren Rd",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Beaudesert Nerang Rd at Billabirra Crescent",
                        "Beaudesert Nerang Rd at Oak Street",
                        "Price St at Earle Plaza",
                        "Price St at Nerang State School",
                        "Nerang St at Nerang State School",
                        "Station St at Centro Nerang",
                        "New St at Nerang Mall",
                        "Brendan Dr near OShea Dr",
                        "Lawrence Dr near Tropical Dr",
                        "Nerang station",
                        "Nerang station, stop D",
                        "Nerang Broadbeach Rd at Allambe Gardens",
                        "Lawrence Dr near Leagues Club Dr"
                    ],
                    "747: Southport - Robina via Bundall": [
                        "Robina station, stop B",
                        "Robina Town Centre",
                        "Robina Town Centre Dr at Christine Avenue",
                        "Robina Town Centre Drive at Scottsdale Dr",
                        "Robina Town Centre Dr at Eastlake Apartments",
                        "Robina Town Centre Dr at Leabrook Crescent",
                        "Cheltenham Dr near Glenside Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Cheltenham Dr near Bellmore Cl",
                        "Ron Penhaligon Way near Commerce Dr",
                        "Manly Dr near Pipers Pt",
                        "Manly Dr near Sandringham Dr",
                        "Pyrmont St near Cottesloe Dr",
                        "Cottesloe Dr near Manly Dr",
                        "Cottesloe Dr near Vancouver Dr",
                        "Bermuda St at Hooker Boulevard",
                        "Bermuda St at Sophie Ave",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Bundall Rd at Pisa Court",
                        "Bundall Rd at City of Gold Coast",
                        "Ferry Rd at Southport Golf Club",
                        "Ferry Rd at York Street",
                        "Ferry Rd at The Southport School",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B",
                        "Southport bus station, stop A",
                        "Bermuda St at Rudd Street",
                        "Cottesloe Dr near University Dr",
                        "Ron Penhaligon Way near Tennyson Pl",
                        "Cheltenham Dr near Belmore Cl",
                        "Cheltenham Dr near Thorngate Dr",
                        "Robina station"
                    ],
                    "748: Nerang - Robina via Gilston,Worongary, Mudgeeraba": [
                        "Robina Town Centre",
                        "Robina station, stop A",
                        "Railway Street at Robert St",
                        "Mudgereeba Shopping Centre",
                        "Old Coach Rd at Wallandra Road",
                        "Rainbow Dr near Cobai Dr",
                        "Rainbow Dr at Universe Court",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Sid Bigg Park",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Worongary Rd near Harry Mills Dr hail 'n' ride",
                        "Worongary Rd near Glenrowan Dr hail 'n' ride",
                        "Worongary Rd near Gilston Rd hail 'n' ride",
                        "Gilston Rd near Hinde Rd hail 'n' ride",
                        "Gilston Rd at Longhill Road",
                        "Gilston Rd at Worley Drive",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "Cayuga St at Onslow Street",
                        "New St at Nerang Mall",
                        "Station St at Centro Nerang",
                        "Brendan Dr near OShea Dr",
                        "Lawrence Dr near Tropical Dr",
                        "Nerang station",
                        "Nerang station, stop F",
                        "Nerang Broadbeach Rd at Allambe Gardens",
                        "Lawrence Dr near Leagues Club Dr",
                        "Cayuga St at PCYC Nerang",
                        "Mortensen Rd near The Linkway",
                        "Worongary Rd near Kookaburra Dr hail 'n' ride",
                        "Worongary Rd near Glenrowan Rd hail 'n' ride",
                        "Worongary Rd near Random Way hail 'n' ride",
                        "Cobai Dr at Chippewa Circuit",
                        "Railway Street near The Link Way",
                        "Robina station, stop D"
                    ],
                    "749: Clearwater - Nerang Station": [
                        "Dugandan St at Burra Street",
                        "Dugandan St at Teasdale Drive",
                        "Dugandan St at Bent Street",
                        "Dugandan St at Merloo Drive",
                        "McLaren Rd near Oakdale Ave",
                        "McLaren Rd at Beltana Way",
                        "McLaren Road at Crusader Way",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Price St at Earle Plaza",
                        "Price St at Nerang State School",
                        "Nerang St at Nerang State School",
                        "Station St at Centro Nerang",
                        "New St at Nerang Mall",
                        "Brendan Dr near OShea Dr",
                        "Lawrence Dr near Tropical Dr",
                        "Nerang station",
                        "Nerang station, stop F",
                        "Nerang Broadbeach Rd at Allambe Gardens",
                        "Lawrence Dr near Leagues Club Dr",
                        "McLaren Rd near Winchester Dr"
                    ],
                    "750: Robina - Broadbeach via Bond University": [
                        "Robina station, stop C",
                        "Robina Town Centre",
                        "Christine Ave at The Crestway",
                        "Christine Ave at Olympus Drive",
                        "Christine Ave at Konda Way",
                        "Varsity Pde near University Dr",
                        "Varsity Pde at Lakefront Crescent",
                        "Varsity Pde at Assembly Drive",
                        "Lake St near Central Park Dr",
                        "Bond University",
                        "University Dr near Cottesloe Dr",
                        "Cottesloe Dr near Manly Dr",
                        "Cottesloe Dr near Vancouver Dr",
                        "Cottesloe Dr near Bermuda St",
                        "Rio Vista Bvd near Karabella Ct",
                        "Rio Vista Bvd near Crestmore Ct",
                        "Rio Vista Bvd near Barrier Reef Dr",
                        "Rio Vista Bvd near Wayfarer Ave",
                        "Rio Vista Bvd near Southerly St",
                        "Rio Vista Bvd near Dunlop Ct",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Rio Vista Bvd near Pilot Ct",
                        "Rio Vista Bvd near Compass Ct",
                        "Rio Vista Bvd near Cottesloe Dr",
                        "Cottesloe Dr near Kirup St",
                        "Cottesloe Dr near University Dr",
                        "Christine Ave at Goldwater Drive",
                        "Christine Ave at Scottsdale Drive",
                        "Robina station"
                    ],
                    "751: Broadbeach - Robina via Mermaid Waters": [
                        "Robina station, stop D",
                        "Robina Town Centre",
                        "Robina Town Centre Dr at Christine Avenue",
                        "Robina Town Centre Drive at Scottsdale Dr",
                        "Robina Town Centre Dr at Eastlake Apartments",
                        "Robina Town Centre Dr at Leabrook Crescent",
                        "Cheltenham Dr near Glenside Dr",
                        "Tullamarine Dr near Glen Iris Pl",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Camberwell Cct near Caulfield Street",
                        "Camberwell Cct near Kensington St",
                        "Yarraville St at Camberwell Circuit",
                        "Yarraville St near Bentleigh Ct",
                        "Markeri St at Ron Penhaligon Way",
                        "Markeri St near Allandale Ent",
                        "Markeri St near Drayton Tce",
                        "Rio Vista Bvd near Dunlop Ct",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Markeri St near Orpheus Rd",
                        "Markeri St near Ron Penhaligon Way",
                        "Yarraville St near Markeri St",
                        "Yarraville St near Altona Cl",
                        "Camberwell Cct at Caulfield Street",
                        "Tullamarine Dr near Cheltenham Dr",
                        "Cheltenham Dr near Thorngate Dr",
                        "Robina station"
                    ],
                    "752: Broadbeach South station - Robina via Robina Wood": [
                        "Robina Town Centre",
                        "Robina station, stop D",
                        "Cheltenham Dr at Woody Views Way",
                        "Cheltenham Dr near Glenside Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Killarney Ave near Huntingdale Cr",
                        "Killarney Ave at Robina State School",
                        "Glen Eagles Dr near Dundee Ct",
                        "Glen Eagles Dr near Karrinyup Pl",
                        "Glen Eagles Dr near Firestone Ct",
                        "Ron Penhaligon Way at Banff Court",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way near Bothwell St",
                        "Ron Penhaligon Way near Commerce Dr",
                        "Ron Penhaligon Way near Vaucluse Pl",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Markeri St at Ron Penhaligon Way",
                        "Markeri St near Allandale Ent",
                        "Markeri St near Drayton Tce",
                        "Markeri St near Intrepid Dr",
                        "Markeri St near Rumrunner St",
                        "Markeri St near Sunshine Bvd",
                        "Sunshine Bvd near Markeri St",
                        "Sunshine Bvd at Gooding Park",
                        "Sunshine Bvd at Bordeaux Street",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Sunshine Bvd at Surfers Avenue",
                        "Sunshine Bvd at Lindon Park",
                        "Markeri St near Southerly St",
                        "Markeri St near Orpheus Rd",
                        "Ron Penhaligon Way near Markeri St",
                        "Ron Penhaligon Way near Homebush Dr",
                        "Ron Penhaligon Way near Tennyson Pl",
                        "Ron Penhaligon Way near Kentwood Dr",
                        "Glen Eagles Dr near Oakmont St",
                        "Glen Eagles Dr near Federal Pl",
                        "Glen Eagles Dr near Princeville Ct",
                        "Glen Eagles Dr near Killarney Ave",
                        "Killarney Ave near Turnberry Ct",
                        "Cheltenham Dr near Thorngate Dr"
                    ],
                    "753: Broadbeach - Burleigh Heads via Robina": [
                        "Burleigh Heads station",
                        "West Burleigh Rd at Stanley Street",
                        "West Burleigh Rd at George Street West",
                        "West Burleigh Rd at Dunlin Drive",
                        "Stockland Burleigh Heads",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Classic Way at Treetops Plaza",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Varsity Lakes station",
                        "Varsity Sound Ave near Azzurra Dr",
                        "Varsity Pde near University Dr",
                        "University Dr near Hillridge Cr",
                        "University Dr near Shore Ave",
                        "Bond University",
                        "University Dr near Cottesloe Dr",
                        "Pyrmont St near Cottesloe Dr",
                        "Manly Dr near Sandringham Dr",
                        "Manly Dr near Pipers Pt",
                        "Ron Penhaligon Way near Vaucluse Pl",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Markeri St at Ron Penhaligon Way",
                        "Markeri St near Allandale Ent",
                        "Markeri St near Drayton Tce",
                        "Rio Vista Bvd near Dunlop Ct",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Markeri St near Orpheus Rd",
                        "Ron Penhaligon Way near Markeri St",
                        "Ron Penhaligon Way near Homebush Dr",
                        "University Dr near Varsity Pde",
                        "Marymount Catholic College"
                    ],
                    "754: Broadbeach - Burleigh Heads via Mermaid Waters": [
                        "Burleigh Heads station",
                        "West Burleigh Rd at Stanley Street",
                        "West Burleigh Rd at George Street West",
                        "West Burleigh Rd at Dunlin Drive",
                        "Stockland Burleigh Heads",
                        "Classic Way at Treetops Plaza",
                        "Coolibah Cr near Willow St",
                        "Willow St near Eucalyptus Ave",
                        "Yodelay St at Tracey Crescent",
                        "Yodelay St near Gainsborough Dr",
                        "Cumberland Dr near Silvabank Dr",
                        "Christine Ave at Silvabank Drive",
                        "Christine Ave at Bermuda Street",
                        "Bermuda St at Lake Orr",
                        "Cottesloe Dr near Bermuda St",
                        "Rio Vista Bvd near Karabella Ct",
                        "Rio Vista Bvd near Crestmore Ct",
                        "Rio Vista Bvd near Barrier Reef Dr",
                        "Barrier Reef Dr near Deloraine Ct",
                        "Barrier Reef Dr near Halborne Dr",
                        "Barrier Reef Dr near Henning Ct",
                        "Barrier Reef Dr near Orpheus Rd",
                        "Barrier Reef Dr near Rio Vista Bvd",
                        "Markeri St near Intrepid Dr",
                        "Markeri St near Rumrunner St",
                        "Markeri St near Sunshine Bvd",
                        "Sunshine Bvd near Markeri St",
                        "Sunshine Bvd at Gooding Park",
                        "Sunshine Bvd at Bordeaux Street",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Sunshine Bvd at Surfers Avenue",
                        "Sunshine Bvd at Lindon Park",
                        "Markeri St near Southerly St",
                        "Barrier Reef Dr near Wild Duck Dr",
                        "Barrier Reef Dr near Normanby St",
                        "Barrier Reef Dr near Hayman Ct",
                        "Barrier Reef Dr near Peninsula Ct",
                        "Rio Vista Bvd near Pilot Ct",
                        "Rio Vista Bvd near Compass Ct",
                        "Rio Vista Bvd near Cottesloe Dr",
                        "Cottesloe Dr near Kirup St",
                        "Cumberland Dr near Yodelay St",
                        "Yodelay St near Gainborough Dr",
                        "Yodelay St near Babu St",
                        "Willow St near Wattle St",
                        "Mattocks Rd at Viburnum Street",
                        "Reedy Creek Rd at Executive Drive",
                        "Marymount Catholic College"
                    ],
                    "755: Broadbeach - Robina via Merrimac": [
                        "Robina Town Centre",
                        "Robina station, stop A",
                        "Highfield Dr near Breakwater Rd",
                        "Highfield Dr near Outriggers Drive Reserve",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Cabot Ct",
                        "Bourton Rd near Willunga Pl",
                        "Gooding Dr at Bourton Road",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop C",
                        "Pacific Fair, stop A",
                        "Gooding Dr at Merrimac Golf Course",
                        "Highfield Dr near Breakwater Road",
                        "Robina station, stop C"
                    ],
                    "756: Broadbeach - West Burleigh via Miami": [
                        "Township Dr near Tsipura Dr",
                        "Tallebudgera Creek Rd at Tsipura Drive",
                        "Stockland Burleigh Heads",
                        "West Burleigh Rd at Dunlin Drive",
                        "Burleigh St near Acanthus Ave",
                        "Burleigh St at Sandpiper Dr",
                        "Burleigh St at Avocet Ave",
                        "Burleigh St near Jabiru Ave",
                        "Burleigh St at Carwell Dr",
                        "Christine Ave at Spoonbill Court",
                        "Christine Ave at Barbet Place",
                        "Dunlin Dr at Courser Ct",
                        "Dunlin Dr near Razorbill St",
                        "Auk Ave at Dunlin Drive",
                        "Whistler Dr near Cuckoo Cr",
                        "Christine Ave at Caningeraba State School",
                        "Cassowary Dr at Christine Avenue",
                        "Honeyeater Dr at Thornbill Place",
                        "Honeyeater Dr near Manakin Ave",
                        "Honeyeater Dr at Quail Ct",
                        "Mountain View Ave near Doggett Dr",
                        "Mountain View Ave near Russell Ct",
                        "Lutana Ave near Anthony Dr",
                        "Bardon Ave near Landau Ct",
                        "Miami Retirement Village",
                        "Dawn Pde near Lesley Ave",
                        "Hillcrest Pde near Paradise Ave",
                        "Pacific Ave at Pizzey Park Sporting Complex",
                        "Oceanic Dr at Miami School",
                        "Sunshine Bvd near Arcadia Dr",
                        "Sunshine Bvd near Markeri St",
                        "Sunshine Bvd at Gooding Park",
                        "Sunshine Bvd at Bordeaux Street",
                        "Pacific Fair, stop B",
                        "Broadbeach South station",
                        "Broadbeach South station, stop D",
                        "Pacific Fair, stop A",
                        "Sunshine Bvd at Surfers Avenue",
                        "Sunshine Bvd at Lindon Park",
                        "Sunshine Bvd near Cadence Ave",
                        "Oceanic Dr near Bowline Rd",
                        "Sunshine Bvd near Pacific Ave",
                        "Pacific Ave near Sonia St",
                        "Hillcrest Pde near Cantala Ave",
                        "Dawn Pde near Albion Ave",
                        "Mountain View Ave near Joeith Ct",
                        "Honeyeater Dr near Quail Ct",
                        "Honeyeater Dr near Nuthatch St",
                        "Whistler Dr near Caningeraba State School",
                        "Dunlin Dr at Courser Court",
                        "Christine Ave at Hillstar Avenue",
                        "Burleigh St near Omoa Ave",
                        "Burleigh St near Corella Ave",
                        "Burleigh St near Sandpiper Dr",
                        "Burleigh St at Acanthus Ave",
                        "West Burleigh Rd at Stanley Street",
                        "West Burleigh Rd at George Street West",
                        "Tsipura Dr at Tallebudgera Creek Road"
                    ],
                    "757: Reedy Creek - Burleigh Heads via Varsity Lakes": [
                        "Observatory Dr near Palomar St",
                        "Observatory Dr near Southern Skies Dr",
                        "Observatory Dr near Golden Grove Bvd",
                        "Observatory Dr near Grove Creek Cl",
                        "Wyllie Way at Gordonia Dr",
                        "Kingsmore Bvd near Tuckeroo Pl",
                        "Old Coach Rd near Bridgman Dr",
                        "Varsity Lakes station",
                        "Varsity Sound Ave near Azzurra Dr",
                        "Christine Ave at Varsity Sound Avenue",
                        "Christine Ave at Varsity College",
                        "Christine Ave at Regensberg Close",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Silvabank Drive",
                        "Mattocks Rd near Bluemoon Cl",
                        "Treeview Dr at Treetop Court",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Oakland Court",
                        "Treeview Dr near Whipbird Ct",
                        "Mattocks Rd at Bushtree Ct",
                        "Mattocks Rd at Viburnum Street",
                        "Reedy Creek Rd at Executive Drive",
                        "Classic Way at Treetops Plaza",
                        "Marymount Catholic College",
                        "Stockland Burleigh Heads",
                        "West Burleigh Rd at Dunlin Drive",
                        "Burleigh Heads station",
                        "West Burleigh Rd at Stanley Street",
                        "West Burleigh Rd at George Street West",
                        "Mattocks Rd near Bushtree Ct",
                        "Treeview Dr near Redleaf Ct",
                        "Treeview Dr near Oakland Ct",
                        "Mattocks Rd at Bluemoon Cl",
                        "Wyllie Way near Gordonia Dr",
                        "Observatory Dr near Willow Tree Dr"
                    ],
                    "758: Merrimac - Robina via Mudgeeraba": [
                        "Robina Town Centre",
                        "Robina station, stop A",
                        "Railway Street at Robert St",
                        "Mudgereeba Shopping Centre",
                        "Railway Street near The Link Way",
                        "Mudgeeraba Rd near Scullin St",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Mudgeeraba Rd near Quambone St",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "Gooding Dr at Bourton Road",
                        "Ghilgai Rd near Entry Dr",
                        "Ghilgai Rd near Griffon St",
                        "Robina station, stop C"
                    ],
                    "759: Robina - Reedy Creek via Varsity Lakes Station": [
                        "Varsity Lakes station",
                        "Bridgman Dr near Old Coach Rd",
                        "Bridgman Dr near Heulan Ct",
                        "Bridgman Dr near Royston Cr",
                        "Bridgman Dr near Woodland Dr",
                        "Woodland Dr near Navars St",
                        "Old Coach Rd near Bridgman Dr",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gemvale Rd at Kings Christian College",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Somerset Dr",
                        "Somerset Dr at Clover Hill Drive",
                        "Somerset Dr at Somerset College",
                        "Swanton Dr near Somerset Dr",
                        "Swanton Dr near Springsure Dr",
                        "Swanton Dr near Chute St",
                        "Robina Town Centre",
                        "Robina station",
                        "Robina station, stop D"
                    ],
                    "760: Tweed Heads - Robina via Airport, Varsity Lakes": [
                        "Wharf St at Tweed Heads",
                        "Twin Towns Services Club",
                        "Griffith St at Coolangatta East",
                        "Coolangatta Central",
                        "Marine Pde at Kirra Beach",
                        "Marine Pde at Kirra Beach Hotel",
                        "Musgrave St at Kirra shops",
                        "Musgrave St at Coyne Street",
                        "Gold Coast Airport",
                        "Johnston Street",
                        "Golden Four Dr at George Street",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Shell Street",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Teemangum St at Kropp Park",
                        "Currumbin Wildlife Sanctuary",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Gold Coast Hwy at Thrower Drive",
                        "Thrower Dr near Luzon Pde",
                        "Palm Beach Currumbin High School",
                        "Sarawak Ave at Salk Oval",
                        "The Pines Shopping Centre, stop B",
                        "KP McGrath Dr at Elanora State School",
                        "KP McGrath Dr near Murtha Dr",
                        "KP McGrath Dr near Seaview Pde",
                        "KP McGrath Dr near Angelica St",
                        "Old Coach Rd near Bridgman Dr",
                        "Varsity Lakes station",
                        "Varsity Sound Ave near Azzurra Dr",
                        "Christine Ave at Konda Way",
                        "Christine Ave at Goldwater Drive",
                        "Christine Ave at Scottsdale Drive",
                        "Christine Ave at The Crestway",
                        "Robina Town Centre",
                        "Christine Ave at Olympus Drive",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "KP McGrath Dr near Exmouth Cr",
                        "KP McGrath Dr at Seaview Parade",
                        "KP McGrath Dr at Murtha Drive",
                        "The Pines Shopping Centre, stop A",
                        "Cahill Street",
                        "McLean St at Queen Elizabeth Park",
                        "Wharf St at Tweed Mall"
                    ],
                    "763: Lakewoods - The Pines via Elanora": [
                        "Silver Glade Dr at Typha Place",
                        "Casuarina Dr near Silver Glade Dr",
                        "Casuarina Dr near Ottelia Dr",
                        "Nineteenth Ave at Kalmia Court",
                        "Saffron St at Maranta Street",
                        "Saffron St near Amadeus St",
                        "Hop St at Avocado Street",
                        "Avocado St at Jarrahdale Dr",
                        "Doubleview Dr at Swanbourne Way",
                        "Doubleview Dr at Attadale Court",
                        "Guineas Creek Rd at Doubleview Drive",
                        "Guineas Creek Rd at Riverside Drive",
                        "The Pines Shopping Centre, stop A",
                        "Avocado St near Doubleview Dr",
                        "Hop St at Seabrook Street",
                        "Saffron St near Cowal Ct",
                        "Saffron St near Maranta St",
                        "Casuarina Dr at Ottelia Drive",
                        "Casuarina Dr at Silver Glade Drive",
                        "Silver Glade Dr at Laurina Court"
                    ],
                    "764: Burleigh Heads - Currumbin Park via The Pines": [
                        "Cannon Dr near The Cross Rd",
                        "Bienvenue Dr near Border Dr",
                        "Clives Cct at Bernoth St",
                        "Clives Cct near Robinson Pl",
                        "Clives Cct at Hoffschildt Dr",
                        "Currumbin Creek Rd near Mainsail St",
                        "Currumbin Creek Rd at Nuban St",
                        "Currumbin Creek Rd near Traders Way",
                        "Currumbin Creek Rd at Love Street",
                        "Currumbin Creek Rd at Currumbin RSL",
                        "Thrower Dr near Sarawak Ave",
                        "Sarawak Ave at Salk Oval",
                        "The Pines Shopping Centre, stop B",
                        "KP McGrath Dr at Elanora State School",
                        "KP McGrath Dr near Murtha Dr",
                        "KP McGrath Dr near Seaview Pde",
                        "Avocado St near Doubleview Dr",
                        "Ironbark St near Avocado St",
                        "Ironbark St near Kaffia Ct",
                        "Ironbark St near Angelica St",
                        "Nineteenth Ave near Chesnut St",
                        "Nineteenth Ave near Melaleuca Dr",
                        "Nineteenth Ave near Townson Ave",
                        "Townson Ave near Nineteenth Ave",
                        "Townson Ave near Twentyfourth Ave",
                        "Townson Ave near Tallebudgera Dr",
                        "Tallebudgera Dr near Tarni Ave",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Burleigh Heads National Park",
                        "Tweed St at George St",
                        "Burleigh Heads station",
                        "Tweed St at George Street",
                        "Tallebudgera Dr near Nyrang Ave",
                        "Townson Ave near Boodera St",
                        "Nineteenth Ave near Mallawa Dr",
                        "Nineteenth Ave near Coolibah Dr",
                        "Nineteenth Ave at Angelica Street",
                        "Ironbark St at Angelica Street",
                        "Ironbark St near Daisy St",
                        "Ironbark St at Boab Street",
                        "Avocado St at Jarrahdale Dr",
                        "KP McGrath Dr at Seaview Parade",
                        "KP McGrath Dr at Murtha Drive",
                        "The Pines Shopping Centre, stop A",
                        "Thrower Dr near Sarawak Dr",
                        "Currumbin Creek Rd near Teatree Ave",
                        "Currumbin Creek Rd near Villiers Dr",
                        "Currumbin Creek Rd near Bienvenue Dr",
                        "Clives Cct at Hoffschildt Drive",
                        "Clives Cct near Bernoth St"
                    ],
                    "765: The Pines - Robina via Burleigh Heads": [
                        "The Pines Shopping Centre, stop A",
                        "Sarawak Ave at Salk Oval",
                        "Palm Beach Currumbin High School",
                        "Thrower Dr near Luzon Pde",
                        "Gold Coast Hwy at Palm Beach Police Station",
                        "Gold Coast Hwy at Fourth Avenue",
                        "Palm Beach",
                        "Gold Coast Hwy at Eighth Avenue",
                        "Gold Coast Hwy at Tenth Avenue",
                        "Gold Coast Hwy at Fifteenth Avenue",
                        "Nineteenth Avenue",
                        "Gold Coast Hwy at Twenty First Avenue",
                        "Gold Coast Hwy at Twenty Fifth Avenue",
                        "Twenty Seventh Avenue",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Burleigh Heads National Park",
                        "Tweed St at George St",
                        "Burleigh Heads station",
                        "Gold Coast Hwy at Second Avenue station",
                        "Christine Ave at Hibiscus Haven",
                        "Christine Ave at Spoonbill Court",
                        "Christine Ave at Barbet Place",
                        "Christine Ave at Burleigh Waters Library",
                        "Christine Ave at Caningeraba State School",
                        "Christine Ave at Bermuda Street",
                        "Christine Ave at Silvabank Drive",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Regensberg Close",
                        "Christine Ave at Varsity College",
                        "Christine Ave at Varsity Sound Avenue",
                        "Varsity Sound Ave near Azzurra Dr",
                        "Varsity Lakes station",
                        "Scottsdale Dr at Firebird Street",
                        "Scottsdale Dr at Laurel Oak Drive",
                        "Scottsdale Dr at Christine Avenue",
                        "Christine Ave at Scottsdale Drive",
                        "Christine Ave at The Crestway",
                        "Robina Town Centre",
                        "Christine Ave at Hillstar Avenue",
                        "Christine Avenue station",
                        "Tweed St at George Street",
                        "Gold Coast Hwy at Thirteenth Avenue"
                    ],
                    "766: Currumbin Waters - The Pines": [
                        "The Pines Shopping Centre, stop A",
                        "KP McGrath Dr at Elanora State School",
                        "Murtha Dr at Boya Court",
                        "Murtha Dr at Dongarra Close",
                        "Murtha Dr at Swanbourne Way",
                        "Murtha Dr at Myco Court",
                        "Galleon Way at Aegean Way",
                        "Ware Dr near Aethalia St",
                        "Ware Dr near Tudor St",
                        "Galleon Way near Billabong Ct",
                        "Galleon Way at Brigantine Court",
                        "Galleon Way near Keegan Cct",
                        "Galleon Way near Jutland Pl",
                        "Galleon Way at Tierney Drive",
                        "Galleon Way at Jutland Place",
                        "Galleon Way near Casey Cl",
                        "Galleon Way near Brigantine Ct",
                        "Galleon Way at Billabong Court",
                        "Galleon Way at Ware Drive",
                        "Ware Dr at Hillier St",
                        "Galleon Way near Tate Ct",
                        "Murtha Dr near Foothill St",
                        "Murtha Dr near Dongarra Cl",
                        "Murtha Dr at KP McGrath Drive"
                    ],
                    "767: Tugun - The Pines via Currumbin": [
                        "The Pines Shopping Centre, stop A",
                        "Sarawak Ave at Salk Oval",
                        "Thrower Dr near Sarawak Dr",
                        "Duringan St at Fielding Street",
                        "Duringan St at Panorama Drive",
                        "Duringan St near Woodgee St",
                        "Pacific Pde at Wallace Nicoll Park",
                        "Pacific Pde at Currumbin Beach",
                        "Currumbin Wildlife Sanctuary",
                        "Teemangum St at Kropp Park",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Golden Four Dr at Tugun Beach shops",
                        "Coolangatta Rd near Cabarita Ave",
                        "Kitchener St near Morshead St",
                        "Cabarita Ave near Kallena St",
                        "Cabarita Ave near Mirreen Dr",
                        "Alinjarra Dr near Clancy Ct",
                        "Mirreen Dr near Cocararra Ct",
                        "Taperell Dr near Wickham Cr",
                        "Toolona St near Durran St",
                        "Duringan St at Woodgee Street",
                        "Thrower Dr near Sarawak Ave"
                    ],
                    "768: Tweed Heads - The Pines via John Flynn Hospital": [
                        "Wharf St at Tweed Heads",
                        "Twin Towns Services Club",
                        "Griffith St at Coolangatta East",
                        "Coolangatta Central",
                        "Marine Pde at Kirra Beach",
                        "Marine Pde at Kirra Beach Hotel",
                        "Musgrave St at Kirra shops",
                        "Musgrave St at Coyne Street",
                        "Golden Four Dr at North Kirra Beach",
                        "Johnston Street",
                        "Golden Four Dr at George Street",
                        "Coolangatta Rd at Kirribin Street",
                        "Coolangatta Rd near Loongana Ave",
                        "Coolangatta Rd near Kiewa Ave",
                        "Boyd St near Morshead St",
                        "Inland Dr near Boyd St",
                        "Inland Dr at John Flynn Hospital",
                        "Inland Dr at Triton Parade",
                        "Kaleena St near Cabarita Ave",
                        "Toolona St near Durran St",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Teemangum St at Kropp Park",
                        "Currumbin Wildlife Sanctuary",
                        "Pacific Pde at Currumbin Beach",
                        "Pacific Pde at Wallace Nicoll Park",
                        "Duringan St at Woodgee Street",
                        "Duringan St at Panorama Drive",
                        "Duringan St at Fielding Street",
                        "Thrower Dr near Sarawak Ave",
                        "Sarawak Ave at Salk Oval",
                        "The Pines Shopping Centre, stop A",
                        "Thrower Dr near Sarawak Dr",
                        "Duringan St near Woodgee St",
                        "Toolona St near Atkin St",
                        "Chaffey St near Narrane St hail 'n' ride",
                        "Boyd St near Tugun St",
                        "Cahill Street",
                        "Golden Four Dr at Archer Street",
                        "McLean St at Queen Elizabeth Park",
                        "Wharf St at Tweed Mall"
                    ],
                    "777: Airport - Broadbeach South via Burleigh Heads": [
                        "Gold Coast Airport",
                        "Palm Beach",
                        "Nineteenth Avenue",
                        "Twenty Seventh Avenue",
                        "Burleigh Heads station",
                        "Gold Coast Hwy at Christine Avenue station",
                        "Gold Coast Hwy at Nobby Beach station",
                        "Gold Coast Hwy at Miami station",
                        "Gold Coast Hwy at Mermaid Beach South station",
                        "Gold Coast Hwy at Miami North station",
                        "Gold Coast Hwy at Mermaid Beach station",
                        "Broadbeach South station",
                        "Broadbeach South station, stop B"
                    ],
                    "77: Eight Mile Plains - Chermside via CLEM7": [
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "OKeefe St near Wolseley St",
                        "Lutwyche Rd at Windsor Rail",
                        "Truro Street, platform 2",
                        "Lutwyche station, platform 2",
                        "Kedron Brook station, platform 2",
                        "Gympie Rd at Cremorne Rd",
                        "Gympie Rd at Strathmore Street",
                        "Gympie Rd at Kitchener Road",
                        "Gympie Rd at Rode Road",
                        "Kingsmill St at Miller Street",
                        "Chermside Shopping Centre interchange H",
                        "Gympie Rd near Kitchener Road",
                        "Gympie Rd near Strathmore Street",
                        "Gympie Rd at Sadlier Street",
                        "Kedron Brook station, platform 1",
                        "Lutwyche station, platform 1",
                        "Truro Street, platform 1",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2"
                    ],
                    "9999: Toorbul - Donnybrook (Shopper Service)": [
                        "Morayfield Shops bus station, platform 1",
                        "Morayfield Rd at Domnick Street",
                        "Caboolture Square Shopping Centre",
                        "Caboolture station, stop C",
                        "Donnybrook Community Library hail 'n' ride",
                        "Pumicestone Rd near Elimbah Ave hail 'n' ride",
                        "Pumicestone Rd near Kleise St hail 'n' ride",
                        "Pumicestone Rd near Perry Rd hail 'n' ride",
                        "Pumicestone Rd at Freeman Rd hail 'n' ride",
                        "Willmer Rd near Marxsen St hail 'n' ride",
                        "Delisser Ave near The Esplanade hail 'n' ride",
                        "Carnegie St near The Crescent hail 'n' ride",
                        "Freeman Rd near The Esplanade hail 'n' ride",
                        "Pumicestone Rd near Cowie St",
                        "St Peter's Primary School",
                        "Hasking St near Beerburrum Rd",
                        "Morayfield Rd at John Street"
                    ],
                    "M1: Eight Mile Plains - City": [
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Holland Park West station, platform 1",
                        "Greenslopes station, platform 1",
                        "Buranda busway, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "King George Square, 1c",
                        "Roma Street busway station",
                        "Roma Street busway, platform 2",
                        "King George Square, 2a",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2"
                    ],
                    "M2: RBWH - UQ Lakes via City": [
                        "UQ Lakes stop A",
                        "Boggo Road station, platform 5",
                        "PA Hospital station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "King George Square, 1c",
                        "Roma Street busway, platform 1",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "RBWH station, platform 1",
                        "Herston station, platform 1",
                        "QUT Kelvin Grove station, platform 1",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "King George Square, 2a",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "PA Hospital station, platform 2",
                        "Boggo Road station, platform 6",
                        "UQ Lakes station"
                    ],
                    "N100: Valley - Forest Lake NightLink": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Ipswich Rd at Broadway, stop 10a",
                        "Ipswich Rd at PA Hospital Citybus, stop 14A",
                        "Ipswich Rd at PA Hospital, stop 14",
                        "Ipswich Rd at Juliette Street, stop 15/16",
                        "Ipswich Rd at Victoria Terrace, stop 17",
                        "Ipswich Rd at Waldheim Street, stop 18/21",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ipswich Rd at Ekibin Road, stop 23",
                        "Ipswich Rd at Venner - Waterton, stop 24",
                        "Ipswich Rd at Chardons Corner, stop 25",
                        "Ipswich Rd at Yeronga Park, stop 26/27",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Ipswich Rd at Clifton Hill near Beaudesert Rd",
                        "Ipswich Rd at Lyon Street, stop 36",
                        "Ipswich Rd at Michlin Street, stop 37",
                        "Ipswich Rd at Gainsborough Street, stop 38",
                        "Ipswich Rd at Moorooka station, stop 39",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Blunder Rd at Blunder - Freeman, stop 68",
                        "Blunder Rd at Forest Place North, stop 69",
                        "Blunder Rd at Forest Place South, stop 70",
                        "Glenala Rd at Glenala East, stop 71",
                        "Akama Rd at Akama Central Stop 73",
                        "Akama Rd at Akama South Stop 74",
                        "Durella St at Durella East, stop 75",
                        "Durella St at Durella West, stop 76",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Inala station, platform A",
                        "Partridge St at Partridge North, stop 72",
                        "Partridge St near Tang St",
                        "Woodland Ave near Joseph Banks Ave",
                        "Joseph Banks Ave near Leichhardt Cct",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Lochwood Ave at Broadwater Way",
                        "Lochwood Ave at Jindabyne Cct",
                        "Woogaroo St at Lochwood Ave",
                        "Grand Ave West near Centennial Way",
                        "Grand Ave at Grand Avenue School",
                        "Grand Ave at Grand Avenue Lake",
                        "Grand Ave at Grand Avenue Cascade",
                        "Grand Ave East near Ascot Ave",
                        "Forest Lake Bvd at Kensington Way",
                        "Forest Lake Shops",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Garden Rd at Government Road",
                        "Richlands bus station, stop B"
                    ],
                    "N130: Valley - Algester/Parkinson NightLink": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Griffith University station, platform 2",
                        "Mains Road park 'n' ride",
                        "Mains Rd at Robertson",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd at Highlands Drive",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Algester Rd at Parkinson East, stop 92",
                        "Algester Rd at Injune Cct, stop 93",
                        "Illaweena St at Tamarisk Way",
                        "Illaweena St at Waterstone",
                        "Gowan Rd at Stretton State College"
                    ],
                    "N154: City/Valley - Browns Plains NightLink": [
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Wickham Street Stop 227 near Little St",
                        "Main St at Quinton Street, stop 7",
                        "Main St at Pearson St, stop 8",
                        "Main St at Sinclair Street, stop 8A",
                        "Main St at Baines Street, stop 8B",
                        "Main St at Linton Street, stop 8C",
                        "Woolloongabba station, platform 1",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "University Rd at Mt Gravatt Cemetery",
                        "Griffith University stop B",
                        "Kessels Rd at Griffith Road, stop 55",
                        "Kessels Rd at Estoril Street, stop 56",
                        "Kessels Rd at Grout Street, stop 2/58",
                        "Kessels Rd at MacGregor, stop 59",
                        "Garden City Shopping Centre station, stop B",
                        "MacGregor St at Garden City Depot",
                        "Warrigal Road Green Link",
                        "Warrigal Rd at Padstow Views",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Runcorn North",
                        "Warrigal Rd at Fruitgrove",
                        "Beenleigh Rd at Fruitgrove station",
                        "Nursery Ave near Marika St",
                        "Nursery Ave at Runcorn near Silkyoak St",
                        "Nemies Rd at Runcorn Heights near Basking St",
                        "Nemies Rd at Runcorn West near Belyando St",
                        "Gowan Rd near Blackbean St",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd at Parkside",
                        "Honeysuckle Way at The Parks",
                        "Honeysuckle Way at Calamvale",
                        "Honeysuckle Way at Sunflower",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station"
                    ],
                    "N184: Valley - Garden City NightLink via Cavendish Road": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Vulture St at Kennedy Street, stop 11",
                        "Vulture St at Rosslyn Street, stop 12/15",
                        "Vulture St at Withington Street, stop 16",
                        "Vulture St at Didsbury Street, stop 17",
                        "Cavendish Rd at Coorparoo College, stop 19",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at Coorparoo Shops, stop 26s",
                        "Cavendish Rd at Shire Street, stop 27/28",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Camlet St at Little Cavendish Rd, stop 55",
                        "Camlet St at Mapleton Street, stop 56",
                        "Camlet St near Kentish St, stop 57/41",
                        "Kentish St at Pond Street, stop 58",
                        "Kentish St at Canterbury Street, stop 59",
                        "Creek Rd at Fairland Street",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Logan Rd at Rover Street, stop 38",
                        "Broadwater Rd at Wardle Street, stop 39",
                        "Broadwater Rd at Hillgrove, stop 40",
                        "Hillgrove St at Kingsway Street, stop 41",
                        "Hillgrove St at Exmoor Street, stop 42",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Wemvern St at Wanda Street, stop 75",
                        "Wemvern St at Zetland Street, stop 76",
                        "Wemvern St at Lumley Street, stop 76a",
                        "Cale St near Dawson Rd, stop 76b",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Dawson Rd at Gurney Street, stop 78",
                        "Dawson Rd at Gerty Street, stop 79",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "N199: West End - Teneriffe Ferry NightLink": [
                        "Orleigh St at West End Ferry, stop 15",
                        "Morry St near Cordeaux St, stop 15a",
                        "Gray Rd at Yumba, stop 15",
                        "Hoogley St at Leitch Lane, stop 13/19",
                        "Hardgrave Rd at Hill End, stop 12",
                        "Hardgrave Rd at Whynot St, stop 11",
                        "Hardgrave Rd at Rialto, stop 10",
                        "Vulture St at West End School, stop 9",
                        "Vulture St at Cambridge Street, stop 8",
                        "Vulture St at West End, stop 7",
                        "Boundary St at Jane Street, stop 6",
                        "Boundary St at West End Junction, stop 5",
                        "Melbourne St at Manning Street, stop 4",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 20 at City Hall",
                        "Adelaide Street Stop 26 at Anzac Square",
                        "Adelaide Street Stop 29 near Wharf St",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Brunswick St at Robertson Street, stop 5",
                        "Brunswick St at Harcourt Street, stop 6",
                        "Brunswick St at Kent Street, stop 7/8",
                        "Brunswick St at Barker Street, stop 9",
                        "Brunswick St at Langshaw Street, stop 10",
                        "Merthyr Rd at Merthyr Central, stop 11",
                        "Merthyr Rd at Alford Street, stop 12",
                        "Merthyr Rd at Hawthorne Street, stop 13",
                        "Macquarie St at Saratoga, stop 13A",
                        "Macquarie St at Mercantile Place, stop 14",
                        "Macquarie St at Vernon Terrace, stop 15",
                        "Commercial Rd at Teneriffe Ferry, stop 16",
                        "Vernon Tce near Florence St, stop 15",
                        "Brunswick St at Barker St, stop 9",
                        "Brunswick St at Heal Street, stop 8",
                        "Ann Street Stop 216 at Valley Island",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 3",
                        "Boundary St at West End, stop 7",
                        "Ganges St near Hoogley St, stop 13",
                        "Hoogley St at Yumba, stop 14"
                    ],
                    "N200: Valley - Carindale Heights NightLink": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Logan Rd at Lotus Street, stop 10a",
                        "Kingfisher Creek near Norman St",
                        "Easts Leagues",
                        "Old Cleveland Rd at Coorparoo West Stop 19",
                        "Old Cleveland Rd at Saint Leonards Street Stop 21",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Burke Street Stop 25",
                        "Old Cleveland Rd at Kismet Street Stop 26",
                        "Old Cleveland Rd at Madeline Street Stop 27",
                        "Old Cleveland Rd at Dorothy Lane Stop 28",
                        "Old Cleveland Rd at Pampling Street Stop 29",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Camp Hill Primary",
                        "Old Cleveland Rd at Orwell Street Stop 33",
                        "Old Cleveland Rd at Wonersh Street Stop 34",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Old Cleveland Rd near Gallipoli Rd Stop 37",
                        "Carindale Shopping Centre station, platform B",
                        "Winstanley St near Firmiston St",
                        "Bridgnorth St near Boynedale St",
                        "Bridgnorth St at Belmont School",
                        "Scrub Rd at Winstanley East",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Cribb Rd near Cowell St",
                        "Cribb Road at Cribb Road East"
                    ],
                    "N226: City/Valley - Wynnum NightLink via Bulimba": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Wellington Rd at Linton Street, stop 11",
                        "Lytton Rd at Mowbray Park",
                        "Wynnum Rd at Walter Avenue, stop 16",
                        "Wynnum Rd at Norman Creek Bridge, stop 17",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Fifth Avenue, stop 33",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Thynne Rd at Morningside Police, stop 28",
                        "Thynne Rd at Morningside Park, stop 27",
                        "Thynne Rd at Ison Street, stop 26",
                        "Wynnum Rd at School of Arts, stop 27",
                        "Wynnum Rd at Morningside Shops, stop 28",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd near Thornlake Ct",
                        "Manly Rd at Leon, stop 43",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Wondall Rd near Manly Rd",
                        "Wondall Rd at Moreton Bay College",
                        "Radford Rd near Lewis Neibling Pl",
                        "Radford Rd at Manly Vista",
                        "Caloundra St at Janoah Gardens",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Silky Oaks",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Manly West near Stannard Rd",
                        "Manly Rd at Daisy Road Stop 68",
                        "Manly Rd at Whites Rd",
                        "Manly Rd near Fisher St Stop 70",
                        "Ernest St near Curtis St, stop 71/84",
                        "Ferguson St at Richard Russell Park, stop 86",
                        "Cambridge Pde at Manly Village, stop 87",
                        "Royal Esp at Manly Baths, stop 87a",
                        "Nelson Pde at Boswell Terrace, stop 88",
                        "Kingsley Tce at Nelson Parade, stop 89",
                        "Kingsley Tce at Picton Parade, stop 91",
                        "Bay Tce at Walnut Street, stop 93/94",
                        "Bay Tce at Guardian Angels School Stop 95",
                        "Bay Tce at Clara Street Stop 96",
                        "Florence St at Wynnum Central Stop 97",
                        "Florence St at Wynnum Library",
                        "Tingal Rd at Wynnum RSL, stop 99",
                        "Tingal Rd at Berrima Street, stop 1",
                        "Tingal Rd at Leisure Centre, stop 2",
                        "Tingal Rd at Wynnum, stop 3",
                        "Cameron Pde at Wynnum North station",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Wynnum North Rd at Sibley Road, stop 38",
                        "Wynnum Rd at Sibley Road",
                        "Wynnum Rd at Wynnum Golf, stop 54",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58"
                    ],
                    "N250: Fortitude Valley - Victoria Pt": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Buranda busway, platform 2",
                        "Stones Corner station, platform 2",
                        "Langlands Park station, platform 2",
                        "Old Cleveland Rd at Coorparoo West Stop 19",
                        "Old Cleveland Rd at Saint Leonards Street Stop 21",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Burke Street Stop 25",
                        "Old Cleveland Rd at Kismet Street Stop 26",
                        "Old Cleveland Rd at Madeline Street Stop 27",
                        "Old Cleveland Rd at Dorothy Lane Stop 28",
                        "Old Cleveland Rd at Pampling Street Stop 29",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Camp Hill Primary",
                        "Old Cleveland Rd at Orwell Street Stop 33",
                        "Old Cleveland Rd at Wonersh Street Stop 34",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Old Cleveland Rd near Gallipoli Rd Stop 37",
                        "Old Cleveland Rd near Adley St",
                        "Old Cleveland Rd near Stanbrough Rd",
                        "The Sleeman Centre, stop B",
                        "Old Cleveland Rd near Archer St",
                        "Old Cleveland Rd near New Cleveland Rd",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station, stop D",
                        "Finucane Rd at Old Cleveland Rd",
                        "Finucane Rd at Willard Road",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Finucane Rd at Keith Surridge Park",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Finucane Rd at Vienna Road",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Dawson Road",
                        "Finucane Rd at Redland Research Station",
                        "Shore St at Grant Street",
                        "Shore St at RACQ",
                        "Shore St at Black Swamp Wetlands",
                        "Cleveland station",
                        "Middle Street, stop B",
                        "Bloomfield St near Russell St",
                        "Bloomfield St at Donald Simpson Park",
                        "Bloomfield St at Princess Street",
                        "Bloomfield St at Long Street",
                        "Bloomfield St near Long St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Beach St",
                        "Cleveland Redland Bay Rd near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Victoria Point Central, platform 2",
                        "Town Centre at Victoria Point",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Boundary Rd at Kinross Road",
                        "Boundary Rd at Taylor Rd",
                        "Redland Bay Rd near Parkwood Dr",
                        "Redland Bay Rd near Teesdale Rd",
                        "Redland Bay Rd near Seven Oaks St",
                        "Redland Bay Rd at Lyndon Road",
                        "Redland Bay Rd at Runnymede Road",
                        "Redland Bay Rd near Number 273",
                        "Redland Bay Rd at Windemere Rd",
                        "Redland Bay Rd at Ney Road",
                        "Redland Bay Rd at Andrew Street",
                        "Redland Bay Rd at Merritt Street",
                        "Redland Bay Rd at Smith Street",
                        "Capalaba bus station arrival stop 3"
                    ],
                    "N310: City - Sandgate NightLink": [
                        "George Street Stop 116",
                        "Wickham Street Stop 227 near Little St",
                        "Abbotsford Rd at Bowen Hills",
                        "Sandgate Rd at Clayfield South, stop 23",
                        "Sandgate Rd at Clayfield, stop 27",
                        "Sandgate Rd at Toombul, stop 32",
                        "Sandgate Rd at Nundah, stop 3",
                        "Sandgate Rd at Nundah North, stop 7/6",
                        "Sandgate Rd at Goss Road, stop 8",
                        "Sandgate Rd at Virginia School, stop 21",
                        "Sandgate Rd at Pritchard Road",
                        "Sandgate Rd at Virginia",
                        "Sandgate Rd near Ferric St",
                        "Sandgate Rd at Boondall South Stop 15",
                        "Sandgate Rd at Nudgee College, stop 17",
                        "Sandgate Rd at Sues Corner, stop 18",
                        "Sandgate Rd at Boondall School, stop 20",
                        "Sandgate Rd at Iceworld, stop 23/24",
                        "Braun St at Sandgate High, stop 27",
                        "Board St at Deagon Racecourse, stop 29",
                        "Sandgate bus station, stop 2"
                    ],
                    "N339: City/Valley - Bracken Ridge NightLink": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 3",
                        "Normanby station, platform 2",
                        "QUT Kelvin Grove station, platform 2",
                        "Herston station, platform 2",
                        "RBWH station, platform 2",
                        "Federation Street, platform 2",
                        "Lutwyche Rd near Taylor St, stop 11",
                        "Lutwyche Rd near Newmarket Rd, stop 12",
                        "Lutwyche Rd at Windsor Rail",
                        "Lutwyche Rd at Windsor State School, stop 15",
                        "Lutwyche Rd at Old Council Chambers, stop 16",
                        "Truro Street, platform 2",
                        "Lutwyche station, platform 2",
                        "Kedron Brook station, platform 2",
                        "Gympie Rd at Cremorne Rd",
                        "Gympie Rd at Strathmore Street",
                        "Gympie Rd at Kitchener Road",
                        "Gympie Rd at Rode Road",
                        "Gympie Rd at Wallace Street",
                        "Chermside Shopping Centre interchange E",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Murphy Rd at Marchant Park, stop 40",
                        "Murphy Rd at Ellison Road, stop 41",
                        "Murphy Rd at Butt Street",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Dunsford Street, stop 45",
                        "Handford Rd at Zillmere station",
                        "Handford Rd at Kolberg Street, stop 47a",
                        "Handford Rd at Handford - Battersby, stop 48",
                        "Handford Rd at St Flannans School",
                        "Handford Rd at Liberty Dr",
                        "Handford Rd at Symes Grove",
                        "Handford Rd at Handford - Roghan",
                        "Handford Rd at Songbird Way",
                        "Lemke Rd at Sandgate AFC Ground",
                        "Denham St at Warra",
                        "Phillips St at Tomah Street",
                        "Phillips St at Enbrook Street",
                        "Phillips St at St Josephs",
                        "Barbour Rd near Phillips St",
                        "Norris Rd near Barbour Rd",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Norris Rd at Greenore Street, stop 45",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Gawain East, stop 42",
                        "Barrett St at Bracken Ridge Library, stop 37",
                        "Barrett St at McKeering-Barrett"
                    ],
                    "N345: Aspley - Valley NightLink": [
                        "Aspley Hypermarket station, platform B",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Maundrell Tce at Darwin Street, stop 50",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Chermside West, stop 48/11",
                        "Maundrell Tce at John Goss Reserve, stop 47/12",
                        "Maundrell Tce at St Gerards, stop 46",
                        "Maundrell Tce at Craigslea, stop 44/15",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Maundrell Tce at Risdon Street, stop 42",
                        "Appleby Rd at Stafford Heights",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Appleby Rd at Ringrose Street, stop 38",
                        "Appleby Rd at Stafford Heights South",
                        "Appleby Rd at Redwood Street, stop 35",
                        "Appleby Rd at Stafford North, stop 34a",
                        "Appleby Rd at Quandeine Street, stop 34",
                        "Appleby Rd at Reuben Street, stop 33",
                        "Shand St at Sparkes Hill",
                        "Shand St at Sicklefield Rd, stop 31",
                        "South Pine Rd at Farrington Street, stop 30",
                        "South Pine Rd at Alderley Crossing, stop 27",
                        "South Pine Rd at Alderley, stop 26",
                        "Enoggera Rd at Lloyd Street, stop 25",
                        "Enoggera Rd at Beaufort Street, stop 24",
                        "Enoggera Rd at Sedgley Park, stop 23",
                        "Enoggera Rd at Banks Street, stop 22",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Kelvin Grove Rd at School Street, stop 13",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Normanby station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 20 at City Hall",
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 3",
                        "Normanby station, platform 2",
                        "Kelvin Grove Rd at Normanby, stop 11",
                        "Kelvin Grove Rd at Victoria Street, stop 12",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "South Pine Rd at Alderley, stop 27",
                        "Appleby Rd at Allowrie Street, stop 35",
                        "Stafford Heights South, Appleby Road",
                        "Appleby Rd at Maryland Street, stop 40",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Craigslea, stop 44",
                        "Maundrell Tce at St Gerards, stop 45/46",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Aspley Hypermarket"
                    ],
                    "N385: Valley - The Gap NightLink": [
                        "The Gap park 'n' ride",
                        "Waterworks Rd at Parkdale near Petmar St",
                        "Waterworks Rd at Petmar St, stop 45",
                        "Waterworks Rd at Hilder Rd, stop 46",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Kilmaine Street, stop 29",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Coopers Camp Rd at West Ashgrove, stop 24",
                        "Coopers Camp Rd near Jaloon St, stop 36A",
                        "Coopers Camp Rd at Coopers Camp Road, stop 29",
                        "Coopers Camp Rd near Callum Lane, stop 28",
                        "Coopers Camp Rd near Cecil Rd, stop 27",
                        "MacGregor Tce at Bardon, stop 15",
                        "MacGregor St at Tooth Ave, stop 14",
                        "Latrobe Tce at Perrott Street, stop 13",
                        "Latrobe Tce at Gilday Street, stop 12",
                        "Latrobe Tce at Trammies Corner, stop 11",
                        "Latrobe Tce at Paddington Central, stop 10",
                        "Latrobe Tce at Old Ithaca Fire Station, stop 9",
                        "Given Tce at Old Paddo Post Office, stop 8",
                        "Given Tce at Great George, stop 7",
                        "Given Tce at Paddo Tavern, stop 6",
                        "Given Tce at Paddington, stop 5",
                        "Caxton St near Chapel St, stop 4",
                        "Upper Roma St near Quay St, stop 3",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 20 at City Hall",
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 3",
                        "Latrobe Tce at Old Paddo Post Office, stop 8",
                        "Latrobe Tce at Perrott Street , stop 13",
                        "MacGregor Tce near Tooth Ave, stop 14",
                        "Coopers Camp Rd at West Ashgrove",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Waterworks Rd at Hilder Road, stop 46"
                    ],
                    "N392: Valley - Ferny Grove NightLink": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Roma Street Stop 121 at Police HQ",
                        "Roma St at Upper Roma Street, stop 3",
                        "Petrie Tce at Windmill Cafe, stop 3",
                        "Petrie Tce near Menzies St, stop 3A",
                        "Petrie Tce near Wellington St, stop 3b",
                        "Petrie Tce at Normanby Fiveways, stop 4",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Musgrave Rd at St Brigid's - Red Hill, stop 5",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Waterworks Rd at Mannion Street, stop 9",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Waterworks Rd at Whitta Street, stop 12",
                        "Waterworks Rd at Mossvale Street, stop 13",
                        "Waterworks Rd at Boon Street, stop 14",
                        "Waterworks Rd at St Finbarr's - Ashgrove, stop 16",
                        "Stewart Rd at Ashgrove, stop 46",
                        "Stewart Rd near Devoy St, stop 44",
                        "Stewart Rd near Celia St, stop 43",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "Wardell St at Dorrington near Stark St",
                        "Wardell St near Banks St, stop 32",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St near Edith St, stop 30a",
                        "Wardell St at Lloyd - Wardell, stop 30A",
                        "Samford Rd at Wardell Street, stop 30",
                        "Samford Rd at Norman Terrace, stop 31",
                        "Samford Rd at Gaythorne station, stop 32",
                        "Samford Rd at Gaythorne RSL, stop 33",
                        "Brookside Shopping Centre station, platform B",
                        "Samford Rd at Fenwick Park, stop 23",
                        "Samford Rd at Samford - Crestway, stop 24",
                        "Samford Rd at Samford - Melrick, stop 25",
                        "Samford Rd at Samford - Dawson, stop 26",
                        "Samford Rd at Cobalt St",
                        "Samford Rd near Warrong St",
                        "Samford Rd near Claverton St",
                        "Ferny Grove station, stop B (Temporary)"
                    ],
                    "N413: Valley - St Lucia NightLink": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Regatta",
                        "Benson St at Toowong, stop 14",
                        "Brisbane St at Kayes Rocks, stop 15",
                        "Gailey Rd at Brisbane Street, stop 16",
                        "Sir Fred Schonell Dr at Gailey Road, stop 17",
                        "Sir Fred Schonell Dr at St Lucia West, stop 19",
                        "Sir Fred Schonell Dr at St Lucia Ferry, stop 21",
                        "Coldridge St at Field Street, stop 23",
                        "Coldridge St near Carmody Rd, stop 23a",
                        "UQ Chancellor's Place, zone E",
                        "Hawken Dr at Picardy Street, stop 31",
                        "Hawken Dr at Hawken Villiage, stop 30",
                        "Hawken Dr near Highland Tce, stop 29",
                        "Hawken Dr at Highland Terrace, stop 28",
                        "Hawken Dr at Tarcoola Street, stop 27",
                        "Hawken Dr at Tenth Avenue, stop 26",
                        "Roundabout at Hawken Shops, stop 25",
                        "Hawken Dr at Ironside School, stop 23/24",
                        "Swann Rd at Hutton Lane, stop 21",
                        "Swann Rd at Bonvale Lane, stop 21",
                        "Gailey Rd at Gailey Fiveways, stop 20",
                        "Gailey Rd at Gailey North, stop 19",
                        "Gailey Rd at Gailey Park, stop 18",
                        "Gailey Rd at Gailey - SFSD, stop 17",
                        "Coronation Dr at Regatta, stop 12",
                        "Coronation Dr at Chasely Street, stop 8",
                        "Coronation Dr at Park Road, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Coronation Dr at Boomerang St, stop 3",
                        "North Quay Stop 106 near Herschel St",
                        "Adelaide Street Stop 20 at City Hall"
                    ],
                    "N449: Valley - Riverhills NightLink via Indooroopilly": [
                        "Wickham Street Stop 227 near Little St",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Roma St at Upper Roma Street, stop 3",
                        "Milton Rd at Suncorp, stop 3/4",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Milton Rd at Milton, stop 7",
                        "Milton Rd at Milton - Torwood, stop 8",
                        "Milton Rd at Hobbs Street, stop 9",
                        "Milton Rd at Auchenflower Shops, stop 10",
                        "Milton Rd at Park Avenue, stop 11",
                        "Milton Rd at Markwell Street, stop 12",
                        "Sylvan Rd at Bulldogs, stop 13",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at BBC, stop 16",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Fig Tree Pocket on Centenary Highway siding",
                        "Sinnamon Rd at Windermere",
                        "Goggs Rd at Windermere Village Shopping",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Yallambee Rd near Capitol Dr",
                        "Yallambee Rd at Mt Ommaney",
                        "Endeavour St near Macarthur Ct",
                        "Endeavour St near Flinders Ct",
                        "Mount Ommaney Shopping Centre",
                        "Dandenong Rd at Jamboree",
                        "Dandenong Rd near Spinnaker St",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr near Gertrude McLeod Cr",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr near Dewsbury St",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr near Congo St",
                        "Horizon Dr at Westlake South near Buffalo St",
                        "Horizon Dr at Tigris Street",
                        "Sumners Rd at Riverhills East near Macfarlane St",
                        "Sumners Rd at Tompkins Road",
                        "Sumners Rd at Brumby Circuit",
                        "Sumners Rd at Sumner Tavern",
                        "Sumners Rd at Spine St"
                    ],
                    "N555: Fortitude Valley - Loganholme": [
                        "Loganholme, stop G",
                        "Mandew St at Hyperdome",
                        "Springwood station, platform 1",
                        "Plantain Rd at Mandew Street",
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Plantain Rd at Blackthorn Crescent",
                        "Upper Mt Gravatt station, platform 1",
                        "Plantain Rd at Narcamus Crescent",
                        "Griffith University station, platform 1",
                        "Kimberley Dr near Chatswood Rd",
                        "Holland Park West station, platform 1",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Greenslopes station, platform 1",
                        "Chatswood Rd near Voltaire St",
                        "Buranda busway, platform 1",
                        "Chatswood Rd at Koolan Park",
                        "Mater Hill station, platform 1",
                        "Upper Lyndale St at Arnold Street",
                        "South Bank busway station, platform 1",
                        "Lyndale St at Trinette Street",
                        "Cultural Centre station, platform 1",
                        "Lyndale St at Davina Street",
                        "Adelaide Street Stop 20 at City Hall",
                        "Lyndale St at Elita Street",
                        "Adelaide Street Stop 26 at Anzac Square",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Queen Street Stop 67 near Ann St (Orient)",
                        "Wickham Street Stop 227 near Little St",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Chatswood Rd at John Paul College",
                        "Chatswood Rd near Evenwood St",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at Brentwood Drive",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Hawkins Street",
                        "Barbaralla Dr at Burgallby Road",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Wenlock Cr at Wyclif Avenue",
                        "Rochedale Rd at Springwood Plaza",
                        "Charlotte Street Stop 90 near Market St",
                        "George Street Stop 116",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Mater Hill station, platform 2",
                        "Buranda busway, platform 2",
                        "Greenslopes station, platform 2",
                        "Holland Park West station, platform 2",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "Kimberley Dr at Chatswood Rd",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park"
                    ],
                    "R346: Sandgate - Shorncliffe station Loop": [
                        "Sandgate bus station, stop 1",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Eagle Tce near Yundah St",
                        "Yundah St at Shorncliffe State School",
                        "Pier Ave at Saint Patricks College",
                        "Park Pde near Swan St",
                        "Friday St at Kate St",
                        "Kate St near Palm Ave"
                    ],
                    "R348: Shorncliffe - Northgate": [
                        "Friday St at Kate St",
                        "Shorncliffe station - Railway Pde",
                        "Sandgate bus station, stop 4",
                        "Deagon station - Albury St",
                        "North Boondall station - Peacock St",
                        "Aberdeen Pde at Boondall station",
                        "Saint Vincents Rd at Oakmere Street, stop 36",
                        "Royal Pde at Banyo, stop 30",
                        "Saint Vincents Rd at First Street, stop 25",
                        "Holland St at Northgate station",
                        "Abbotsford Rd at Bowen Hills",
                        "Saint Vincents Rd at Banyo, stop 30",
                        "North Boondall station - Lyndhurst Rd"
                    ],
                    "R395: Ferny Grove - Roma Street": [
                        "Ferny Grove station, stop B (Temporary)",
                        "Blackbutt St at Keperra station, stop 30",
                        "Grovely station - Blaker Rd",
                        "Oxford Park station - Blaker Rd",
                        "Mitchelton station - McConaghy St",
                        "Samford Rd at Gaythorne station, stop 32",
                        "Enoggera interchange, platform C",
                        "South Pine Rd at Alderley, stop 26",
                        "Wilston Rd at Newmarket station, stop 16",
                        "Newmarket Rd at Wilston station, stop 18",
                        "Windsor station - Prospect Rd",
                        "Abbotsford Rd at Bowen Hills",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 7 at Anzac Square",
                        "Roma Street busway, platform 1",
                        "Roma Street Stop 125 at Transit Centre",
                        "Edward Street Stop 141 near Ann St",
                        "Brunswick Street Stop 212",
                        "Wilston Rd at Newmarket station",
                        "South Pine Rd at Alderley, stop 27",
                        "Silvertop St at Keperra station, stop 30"
                    ],
                    "R581: Cleveland Line - All Stations": [
                        "Roma Street busway, platform 1",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Boggo Road station, platform 5",
                        "Buranda busway, platform 2",
                        "OKeefe St near Wolseley St",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Barrack Rd near Bombery St, stop 60",
                        "Buranda busway, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Roma Street Stop 125 at Transit Centre"
                    ],
                    "R583: Airport - Southern Corridor (Express)": [
                        "Junction Rd at Eagle Junction station, stop 28",
                        "Breton St at Banoon station"
                    ],
                    "R584: City - Southern Corridor (Limited Express)": [
                        "Roma Street busway, platform 1",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Breton St at Banoon station",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Roma Street Stop 125 at Transit Centre"
                    ],
                    "R585: City - Albion - Park Road (All Stations)": [
                        "Albion station",
                        "Abbotsford Rd at Bowen Hills",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 7 at Anzac Square",
                        "Roma Street busway, platform 1",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Boggo Road station, platform 6",
                        "Boggo Road station, platform 5",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Roma Street Stop 125 at Transit Centre",
                        "Edward Street Stop 141 near Ann St",
                        "Brunswick Street Stop 212"
                    ],
                    "R591: City - Southern Corridor (All Stations)": [
                        "Roma Street busway, platform 1",
                        "Cultural Centre station, platform 2",
                        "South Bank busway station, platform 2",
                        "Boggo Road station, platform 6",
                        "Noble St at Princess Street, stop 13a",
                        "Fairfield Rd near Ashby St, stop 19",
                        "Fairfield Rd at Yeronga station",
                        "Green St at Yeerongpilly station, stop 30",
                        "Ipswich Rd at Gainsborough Street, stop 38",
                        "Lillian Ave at Salisbury station",
                        "Orange Grove Rd at Rookwood Avenue, stop 56",
                        "Breton St at Banoon station",
                        "Beenleigh station, stop B",
                        "Ipswich Rd at Moorooka station, stop 38/39",
                        "Wilkie St at Yeerongpilly station",
                        "Fairfield Rd near Ashby St, stop 18a",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Boggo Road station, platform 5",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Roma Street Stop 125 at Transit Centre"
                    ],
                    "R592: Western - Ipswich (All Stations)": [
                        "Manburgh Tce at Darra station, stop B",
                        "Wilruna St at Wacol train station",
                        "Wilruna St at Gailes station",
                        "Goodna station, stop A",
                        "Redbank station, stop B",
                        "Riverview station - McEwan St",
                        "River Rd at Dinmore station",
                        "Brisbane Rd at Ebbw Vale Station",
                        "Brisbane Rd at Bundamba Primary",
                        "Booval station",
                        "Brisbane Rd at Montauban Street",
                        "Ipswich station - Bell St",
                        "Brisbane Rd at Ebbw Vale station",
                        "Redbank station, stop A"
                    ],
                    "R594: City - Western Corridor (Limited Express)": [
                        "Roma Street busway, platform 1",
                        "Manburgh Tce at Darra station, stop B",
                        "Redbank station, stop B",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Ipswich station - Bell St",
                        "Railway St at Rosewood station",
                        "Redbank station, stop A",
                        "Milton Rd at Cribb St, stop 5",
                        "Roma Street Stop 125 at Transit Centre"
                    ],
                    "R595: City - Albion - Milton (All Stations)": [
                        "Albion station",
                        "Abbotsford Rd at Bowen Hills",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 7 at Anzac Square",
                        "Roma Street busway, platform 1",
                        "Milton station - Railway Tce",
                        "Roma Street Stop 125 at Transit Centre",
                        "Edward Street Stop 141 near Ann St",
                        "Brunswick Street Stop 212"
                    ],
                    "R596: Western - Springfield (EXPRESS)": [
                        "Roma Street busway, platform 1",
                        "Manburgh Tce at Darra station, stop B",
                        "Richlands bus station, stop A",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Springfield Central station, stop A",
                        "Springfield Station",
                        "Richlands bus station, stop B",
                        "Milton Rd at Cribb St, stop 5",
                        "Roma Street Stop 125 at Transit Centre"
                    ],
                    "R597: Western - Springfield Central (ALL STOPS)": [
                        "Roma Street busway, platform 1",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Auchenflower station - Auchenflower Tce",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at Taringa, stop 19",
                        "Coonan St at Indooroopilly station, stop 53",
                        "Honour Ave at Chelmer station",
                        "Honour Ave at Graceville near Verney Rd",
                        "Sherwood Rd near Hedges St",
                        "Browne St at Corinda station",
                        "Oxley station, stop A",
                        "Manburgh Tce at Darra station, stop B",
                        "Richlands bus station, stop A",
                        "Springfield Central station, stop A",
                        "Springfield Station",
                        "Richlands bus station, stop B",
                        "Sherwood Rd near Thallon St",
                        "Walker St at Frederick Street, stop 18",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Milton Rd at Cribb St, stop 5",
                        "Roma Street Stop 125 at Transit Centre"
                    ],
                    "R598: Western - Rosewood (All Stations)": [
                        "Ipswich station - Bell St",
                        "Thomas Street station - Tallon St",
                        "Wulkuraka station",
                        "Karrabin station",
                        "Walloon station - Queen St",
                        "Thagoona station",
                        "Railway St at Rosewood station"
                    ],
                    "R599: City - Western Corridor (All Stations)": [
                        "Roma Street busway, platform 1",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Auchenflower station - Auchenflower Tce",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at Taringa, stop 19",
                        "Coonan St at Indooroopilly station, stop 53",
                        "Honour Ave at Chelmer station",
                        "Honour Ave at Graceville near Verney Rd",
                        "Sherwood Rd near Hedges St",
                        "Browne St at Corinda station",
                        "Oxley station, stop A",
                        "Manburgh Tce at Darra station, stop B",
                        "Wilruna St at Wacol train station",
                        "Wilruna St at Gailes station",
                        "Goodna station, stop A",
                        "Redbank station, stop B",
                        "Riverview station - McEwan St",
                        "River Rd at Dinmore station",
                        "Brisbane Rd at Ebbw Vale Station",
                        "Brisbane Rd at Bundamba Primary",
                        "Booval station",
                        "Brisbane Rd at Montauban Street",
                        "Ipswich station - Bell St",
                        "Sherwood Rd near Thallon St",
                        "Brisbane Rd at Ebbw Vale station",
                        "Walker St at Frederick Street, stop 18",
                        "Redbank station, stop A",
                        "High St at Toowong, stop 14 (temp relocation)",
                        "Milton Rd at Cribb St, stop 5",
                        "Roma Street Stop 125 at Transit Centre"
                    ],
                    "R600: Caboolture - Bowen Hills": [
                        "Caboolture station, stop A",
                        "Morayfield station",
                        "Burpengary station",
                        "Narangba station",
                        "Dakabin station",
                        "Petrie station, stop A",
                        "Abbotsford Rd at Bowen Hills",
                        "Petrie station, stop B",
                        "Caboolture station"
                    ],
                    "R601: Petrie - Bowen Hills": [
                        "Kippa-Ring stations, stop B",
                        "Rothwell station",
                        "Mango Hill East station",
                        "Mango Hill station",
                        "Murrumba Downs station, stop B",
                        "Kallangur station, stop B",
                        "Petrie station, stop A",
                        "Abbotsford Rd at Bowen Hills",
                        "Petrie station, stop B",
                        "Kallangur station, stop A"
                    ],
                    "R603: Northgate - Bowen Hills": [
                        "Holland St at Northgate station",
                        "Buckland Rd at Union Street, stop 2",
                        "Sandgate Rd at Toombul, stop 32",
                        "Junction Rd at Eagle Junction station, stop 28",
                        "Wooloowin station - Bridge St",
                        "Albion station",
                        "Abbotsford Rd at Bowen Hills",
                        "Wooloowin station - Chalk St",
                        "Junction Rd at Eagle Junction station, stop 28/1"
                    ],
                    "R604: Northgate - City": [
                        "Holland St at Northgate station",
                        "Sandgate Rd at Nundah, stop 2",
                        "Buckland Rd at Union Street, stop 2",
                        "Sandgate Rd at Toombul, stop 32",
                        "Junction Rd at Eagle Junction station, stop 28",
                        "Wooloowin station - Bridge St",
                        "Albion station",
                        "Abbotsford Rd at Bowen Hills",
                        "Brunswick Street Stop 202 near Wickham St",
                        "Ann Street Stop 7 at Anzac Square",
                        "Roma Street busway, platform 1",
                        "Roma Street Stop 125 at Transit Centre",
                        "Edward Street Stop 141 near Ann St",
                        "Brunswick Street Stop 212",
                        "Wooloowin station - Chalk St",
                        "Junction Rd at Eagle Junction station, stop 28/1",
                        "Saint Vincents Rd at First Street, stop 25",
                        "Saint Vincents Rd at Banyo, stop 30",
                        "Nudgee station - St Achs St",
                        "Aberdeen Pde at Boondall station",
                        "North Boondall station - Lyndhurst Rd",
                        "Deagon station - Albury St",
                        "Sandgate bus station, stop 4",
                        "Shorncliffe station - Railway Pde"
                    ],
                    "R605: Petrie - Northgate": [
                        "Petrie station, stop B",
                        "Lawnton station",
                        "Bray Park station",
                        "Strathpine station - ATS",
                        "Strathpine Rd near Bald Hills Rd",
                        "Carseldine station east",
                        "Handford Rd at Zillmere station",
                        "Geebung station - Fossil St",
                        "Sunshine station - Bilsen Rd",
                        "Toombul Rd at Nixon Lane, stop 22",
                        "Holland St at Northgate station",
                        "Abbotsford Rd at Bowen Hills",
                        "Albion station",
                        "Toombul Rd near Wellington St, stop 23/22",
                        "Wooloowin station - Chalk St",
                        "Junction Rd at Eagle Junction station, stop 28/1",
                        "Sandgate Rd at Toombul, stop 32",
                        "Carseldine station east, stop 1",
                        "Buckland Rd at Union Street, stop 2",
                        "Strathpine Rd near Lucy St"
                    ],
                    "R609: Landsborough - Caboolture": [
                        "Landsborough station, stop B",
                        "Nambour station",
                        "Beerwah station",
                        "Woombye station",
                        "Caboolture station, stop B",
                        "Glass House Mountains station",
                        "Main St at Palmwoods Railway Station",
                        "Beerburrum station",
                        "Eudlo station",
                        "Mooloolah station",
                        "Elimbah station",
                        "Caboolture station, stop A",
                        "Ipswich station - Bell St",
                        "Caboolture station"
                    ],
                    "R610: Caboolture - Landsborough": [
                        "Nambour station",
                        "Landsborough station, stop B",
                        "Woombye station",
                        "Caboolture station, stop D",
                        "Main St at Palmwoods Railway Station",
                        "Eudlo station",
                        "Mooloolah station",
                        "Caboolture station, stop A"
                    ],
                    "R612: Caboolture - Gympie North": [
                        "Gympie North station - Station Rd",
                        "Traveston station",
                        "Elm St at Cooroy station",
                        "Eumundi station",
                        "Cooran Station rail replacement",
                        "Railway St at Yandina station",
                        "Factory St near Reserve St",
                        "Nambour station",
                        "Elm St opp Cooroy station",
                        "Abbotsford Rd at Bowen Hills",
                        "Caboolture station, stop C",
                        "Caboolture station, stop A",
                        "King St at Prince Street"
                    ],
                    "R613: Bowen Hills - Gympie North": [
                        "Abbotsford Rd at Bowen Hills",
                        "Holland St at Northgate station",
                        "Petrie station, stop A",
                        "Caboolture station, stop A",
                        "Nambour station",
                        "Railway St at Yandina station",
                        "Eumundi station",
                        "Elm St opp Cooroy station",
                        "Gympie North station - Station Rd"
                    ],
                    "R616: Nambour, Landsborough, Bowen Hills": [
                        "Nambour station",
                        "Landsborough station, stop B",
                        "Caboolture station, stop A",
                        "Abbotsford Rd at Bowen Hills"
                    ],
                    "R701: Airport Train": [
                        "Junction Rd at Eagle Junction station, stop 28",
                        "Roma Street Stop 125 at Transit Centre"
                    ],
                    "TX7: Coomera - Helensvale via Theme Parks": [
                        "Helensvale stop C",
                        "Town Centre Drive",
                        "Wet 'n' Wild",
                        "Movie World",
                        "Siganto Dr near Grey Gum St",
                        "Siganto Dr at Tradewinds Street",
                        "Dreamworld Parkway at Boathouse Tavern",
                        "Dreamworld",
                        "Coomera station",
                        "Coomera station, stop B",
                        "Dreamworld Pkwy at Foxwell Rd",
                        "Helensvale station"
                    ]
                }
            },
            "ferry": {
                "stops": [
                    "Apollo Road ferry terminal",
                    "Bretts Wharf ferry terminal",
                    "Bulimba ferry terminal",
                    "Coochiemudlo Island ferry terminal",
                    "Dockside ferry terminal",
                    "Dunwich ferry terminal",
                    "Guyatt Park ferry terminal",
                    "Hawthorne ferry terminal",
                    "Holman Street ferry terminal",
                    "Howard Smith Wharves ferry terminal",
                    "Karragarra Island ferry terminal",
                    "Lamb Island ferry terminal",
                    "Macleay Island ferry terminal",
                    "Maritime Museum ferry terminal",
                    "Maximillian Road Wharf (Noosa North Shore) ferry terminal",
                    "Milton ferry terminal",
                    "Moggill Ferry East ferry terminal",
                    "Moggill Ferry West ferry terminal",
                    "Moorindil Street Wharf (Tewantin) ferry terminal",
                    "Mowbray Park ferry terminal",
                    "New Farm Park ferry terminal",
                    "North Quay ferry terminal",
                    "Northshore Hamilton ferry terminal",
                    "Port of Brisbane ferry terminal",
                    "QUT Gardens Point ferry terminal",
                    "Redland Bay Marina ferry terminal",
                    "Reeders Point, Kooringal ferry terminal",
                    "Regatta ferry terminal",
                    "Riverside ferry terminal",
                    "Russell Island ferry terminal",
                    "South Bank ferry terminal",
                    "Sydney Street ferry terminal",
                    "Tangalooma Wrecks ferry terminal",
                    "Teneriffe ferry terminal",
                    "Toondah Harbour (Cleveland) ferry terminal",
                    "UQ St Lucia ferry terminal",
                    "Victoria Point Jetty ferry terminal",
                    "West End ferry terminal"
                ]
            },
            "lightrail": {
                "stops": [
                    "Broadbeach North station",
                    "Broadbeach South station",
                    "Broadwater Parklands station",
                    "Cavill Avenue station",
                    "Cypress Avenue station",
                    "Florida Gardens station",
                    "GCS relief point",
                    "Gold Coast University Hospital station",
                    "Griffith University station",
                    "Helensvale station",
                    "Main Beach station",
                    "Nerang Street station",
                    "Northcliffe station",
                    "Parkwood East station",
                    "Parkwood station",
                    "Queen Street station",
                    "Southport South station",
                    "Southport station",
                    "Surfers Paradise North station",
                    "Surfers Paradise station"
                ]
            },
            "schoolbus": {
                "routes": [
                    "800: Yeronga High - Inala Plaza",
                    "801: Learoyd Rd (Willawong) - Calamvale College",
                    "802: MacGregor High - Coopers Plains",
                    "803: Heathwood Estate - Pallara State School",
                    "804: Pallara - Pallara State School (via Heathwood)",
                    "805: Algester - Calamvale Community College",
                    "806: Upper Mt Gravatt - Woolloongabba",
                    "807: Balmoral High - Murrarie (Cannon Hill)",
                    "808: Balmoral High - Cannon Hill",
                    "809: Stretton College - Algester",
                    "810: MacGregor - Salisbury",
                    "811: Belmont - Gumdale - Balmoral High",
                    "812: Cavendish Rd High - Murrarie",
                    "813: St Bernards - Murrarie",
                    "814: Cavendish Road High - Carindale",
                    "815: Iona College - Wynnum State School",
                    "816: Wishart State School - Garden City",
                    "817: Villanova - Cannon Hill station",
                    "819: Carindale - Iona College",
                    "820: Garden City - Mansfield High",
                    "821: Mansfield High School - Garden City",
                    "822: BSSSC - Tarragindi",
                    "823: Woollongabba - Garden City",
                    "824: Mansfield High School - Garden City",
                    "825: Mansfield High - Garden City",
                    "826: Mansfield High School - Carina",
                    "827: Meadowlands - St Catherines School",
                    "828: Cavendish Rd High - Holland Park",
                    "829: Logan Rd - Parkinson",
                    "830: Klumpp Rd - Parkinson",
                    "831: Lourdes Hill - Cannon Hill",
                    "832: MacGregror High - Parkinson",
                    "833: Annerley - Holland Park High - Cavendish Rd High",
                    "834: Holland Park High - Nathan",
                    "835: Moorvale - Holland Park High",
                    "836: Holland Park High - Moorvale",
                    "837: Holland Park School - Garden City",
                    "838: Vulture St - Seton College",
                    "839: Glenala High - Acacia Ridge",
                    "840: Heathwood - Sunnybank",
                    "843: Brisbane State High - Yeerongpilly",
                    "844: Brisbane South Secondary College - Mt Gravatt Cent",
                    "845: Annerley Rd - Holland Park High",
                    "846: Tarragindi - Cavendish Rd High",
                    "847: Annerley - Holland Park - Mt Gravatt",
                    "849: Tarragindi - Cavendish Rd High",
                    "850: Clairvaux-Mackillop - Calamvale",
                    "851: St Thomas More - The Parks",
                    "852: Sunnybank Hills - Garden City",
                    "853: Carindale - Hawthorne Rd",
                    "854: Creek & Stanley Rds - Lourdes Hill",
                    "855: Algester Rd - St Thomas More College",
                    "856: Wakerley - Whites Hill College",
                    "857: Sunnybank High - Salisbury",
                    "858: Acacia Ridge - Garden City",
                    "859: Lourdes Hill - Murarrie",
                    "860: Carindale - Stephens Rd",
                    "861: Runcorn High - Algester Rd",
                    "863: Acacia Ridge - Algester - Runcorn High School",
                    "864: Runcorn High - Parkinson",
                    "865: Calam Rd - Runcorn High",
                    "866: St Thomas More - Algester Rd",
                    "867: St Thomas More - Pallara",
                    "868: Anglican Church Grammar - Adelaide St",
                    "869: Mansfield High - Carindale",
                    "870: Coorparoo - Garden City",
                    "871: Cavendish Rd High - Cannon Hill",
                    "872: Cavendish Rd High - Queen St bus station",
                    "873: St Laurences College - Balmoral",
                    "874: Camp Hill - Cavendish Rd High",
                    "875: Lourdes Hill - City, Adelaide St",
                    "876: Samuel St - All Hallows",
                    "877: Cavendish Road High - Garden City",
                    "878: Churchie - Camp Hill",
                    "879: Loreto - Eastside Village",
                    "880: Mansfield State High - Carindale",
                    "881: San Sisto Convent - Murarrie",
                    "882: Cavendish Rd High - Loreto - Fortitude Valley",
                    "883: Cavendish Rd High - Cannon Hill",
                    "884: Balmoral High - Mt Gravatt Central",
                    "886: Cavendish Rd - Woolloongabba",
                    "887: Carindale - Garden City",
                    "888: Lourdes Hill College - Eastside Village",
                    "889: Carindale - Garden City",
                    "890: Garden City - Mt Gravatt High",
                    "891: Parkinson - Garden City",
                    "892: Mt Gravatt High - Garden City - The Parks",
                    "893: Browns Plains - Garden City",
                    "894: Sixth Ave - Cribb Rd",
                    "895: Villanova - Carindale",
                    "896: Mt Gravatt High - Garden City",
                    "897: Wishart SS - Clairvaux Mac - Wishart Outlook",
                    "898: Garden City - Newnham Rd",
                    "899: Lourdes Hill College - Wynnum",
                    "901: Albany Creek - Padua/Mt Alvernia",
                    "904: Ferny Hills - Ferny Grove High and Primary",
                    "905: Ferny Grove - St Pauls & Strathpine",
                    "906: Ferny Grove - Padua - Craigslea",
                    "908: Albany Creek - Padua College - Wavell High",
                    "911: Padua - Albany Creek",
                    "912: Mitchelton State High - Arana Hills",
                    "913: Padua - Albany Creek",
                    "915: Craigslea High - Brookside",
                    "918: Wavell High - Brookside via Padua College",
                    "920: Padua College - Ferny Grove Station",
                    "921: Kelvin Grove - Mitchelton",
                    "922: Brisbane Grammar - RBWH - Grange",
                    "923: Spring Hill - City",
                    "924: Ascot - Gregory Tce",
                    "925: Toombul - Spring Hill",
                    "926: All Hallows - Stafford",
                    "928: Gregory Tce - Toombul",
                    "929: Gregory Tce - Toombul",
                    "930: New Farm - Spring Hill",
                    "931: New Farm - Fortitide Valley",
                    "934: L'Estrange Tce - Waterworks Rd",
                    "935: L'Estrange Tce - Taigum",
                    "936: Kelvin Grove High - Aspley Hypermarket",
                    "937: Kelvin Grove High - Stafford",
                    "938: Kelvin Grove High - Grange",
                    "939: Padua College - Geebung Station",
                    "940: Padua College - Carseldine",
                    "941: Padua College - Boondall Station",
                    "944: Boondall - Padua",
                    "945: St Anthonys - Carseldine",
                    "946: Mitchelton - Kedron High",
                    "947: Kedron High - McDowall",
                    "948: Kedron High - Maundrell Tce",
                    "950: Kedron High - Enoggera",
                    "951: Mitchelton - Albany Village",
                    "952: Mitchelton station - Eatons Hill",
                    "953: Albany Creek SHS - Eatons Hill",
                    "955: Gregory Tce - Aspley via Everton Park",
                    "956: Bracken Ridge - Padua College",
                    "957: McDowall - Wavell High",
                    "958: Craigslea - Albany Creek",
                    "959: Craigslea High - Carseldine station",
                    "962: Aspley High - Bracken Ridge",
                    "963: Aspley High - Taigum Shopping Centre",
                    "964: Bracken Ridge - Aspley High",
                    "966: Zillmere - Wavell High",
                    "968: Nudgee College - Wavell High",
                    "970: Wavell High - Chermside",
                    "971: Wavell High - Toombul",
                    "972: Wavell High - Geebung Station",
                    "973: Wavell High - Trouts Rd",
                    "974: Wavell High - Geebung - Taigum - Carseldine",
                    "975: Wavell High - Boondall station",
                    "976: Sandgate High - Chermside",
                    "977: Carseldine - Toombul",
                    "978: Aspley - Nudgee College - Wavell High",
                    "979: Stafford Heights - Aspley High",
                    "980: Wavell High - Boondall station",
                    "982: Wavell High - Chermside",
                    "983: Wavell High - Chermside",
                    "984: Wavell State High - Geebung station",
                    "985: Aviation High - Doomben station via Ascot",
                    "986: Wavell State High - Everton Park",
                    "987: Aviation High - Northgate station",
                    "988: Bracken Ridge High - Carseldine station",
                    "990: Boondall - St John Fisher",
                    "991: Bald Hills, St Patricks",
                    "992: Boondall - St John Fisher - Bracken Ridge",
                    "993: Sandgate High - Bracken Ridge",
                    "994: St John Fisher - Bracken Ridge TAFE",
                    "995: Sandgate High - Carseldine station",
                    "996: Sandgate High - Brighton",
                    "997: Brighton - Sandgate High",
                    "998: Strathpine - Bracken Ridge",
                    "999: Kippa-Ring, Sandgate, Nudgee, Clayfield",
                    "3002: Reedy Creek - Miami High",
                    "3003: Scenic Dr Bus Shelter - All Saints",
                    "3004: Bourton Rd - Mudgeraba Primary",
                    "3005: Currumbin Creek Rd - Merrimac Primary",
                    "3006: Tweed Heads - Marymount via Townson Ave",
                    "3007: Ourimbah Rd - Elanora High",
                    "3008: Elanora High - Elanora Primary",
                    "3009: Ourimbah Rd - Currumbin Primary",
                    "3010: Tweed Heads - Tallebudgera Primary",
                    "3011: Simpsons Rd - Marymount via Elanora & Tallebudger",
                    "3012: Nerang Rail - Keebra",
                    "3013: The Observatory - Robina High",
                    "3014: McAuley Pde - Pacific Pines High",
                    "3015: The Observatory - Mudgeeraba Creek Primary",
                    "3016: Oxenford - Helensvale High",
                    "3017: Numinbah Valley - Gilston",
                    "3018: Canugra, Mt Nathan, Nerang Int, Benowa, Surfers",
                    "3019: Mudgeeraba, Robina Waters - Aquinas via Ferry Rd",
                    "3020: Oxley Dr - Helensvale",
                    "3021: Maudsland - Coomera Primary",
                    "3022: Gilston - Miami via Cararra & Merrimac",
                    "3023: Riverstone - Helensvale High",
                    "3024: Main Beach - Merrimac",
                    "3025: Guanaba - Pacific Pines",
                    "3026: Robina - Varsity Lakes",
                    "3027: Upper Coomera - Labrador Primary",
                    "3028: Hinkler Dr - Marymount via Mudgeeraba",
                    "3029: Mattocks Dr - Merrimac High",
                    "3030: Reedy Creek - Miami",
                    "3031: Pacific Pines - Park Lake",
                    "3032: Santa Isobel - Park Lake Primary",
                    "3033: Reedy Creek - Miami",
                    "3034: Nerang Rail - Keebra",
                    "3035: Broadbeach Waters - Marymount via Mermaid Waters",
                    "3036: Sunshine Blvd - Surfers Paradise Primary",
                    "3037: Tuxedo Junction - Pacific Pines",
                    "3038: Oxley Dr - Helensvale",
                    "3039: Coombabah - Southport",
                    "3040: Nerang High - Merrimac",
                    "3041: Highfield Dr - Nerang High",
                    "3042: Wintergreen - Upper Coomera",
                    "3043: Molendinar - Benowa",
                    "3044: Hickey Way - Nerang",
                    "3045: Arthur Way - Windaroo",
                    "3046: Central St - Nerang",
                    "3047: Bronberg Plaza - All Saints",
                    "3048: Gooding Dr - Nerang High",
                    "3049: Hickey Way - Benowa",
                    "3050: Molendinar - Ashmore Primary",
                    "3051: Molendinar - Worongary Primary",
                    "3052: Kumbari Ave - Nerang",
                    "3053: Nerang Rail - Keebra",
                    "3054: Nerang Rail - Keebra",
                    "3055: Nerang Interchange - Assisi",
                    "3056: Bundall Rd - Ashmore Primary",
                    "3057: Labrador - Upper Coomera",
                    "3058: Reserve Rd - Assisi",
                    "3059: Coomera Springs Bvd - Pimpama Colleges",
                    "3060: Wongawallan - Uppera Coomera",
                    "3061: Sir Charles Holm Dr - OWHS",
                    "3062: Harbour Town - Upper Coomera",
                    "3063: Upper Ormeau Rd - OWHS",
                    "3064: Goldmine Rd - Ormeau Primary",
                    "3065: Ormeau - Rivermount",
                    "3066: Coomera Sports Park - Pimpama Colleges",
                    "3067: Daintree Dr - Helensvale",
                    "3068: Winfield Rd - Helensvale",
                    "3069: Coomera Waters - Coomera Primary",
                    "3070: Coomera Waters - Helensvale",
                    "3071: Pascoe Rd - OWHS",
                    "3072: Goldmine Rd - Ormeau Primary",
                    "3073: Coomera Waters - Upper Coomera College",
                    "3074: Ruffles Creek - Coomera Primary",
                    "3075: Willowvale - Pimpama Colleges",
                    "3076: Dixon Dr - Pimpama Primary",
                    "3077: Mirambeena - OWHS",
                    "3078: Nerang - Marymount College via Robina Waters",
                    "3079: Coomera Waters - Upper Coomera",
                    "3080: Philben Rd - OWHS",
                    "3081: Arthur Way - OWHS",
                    "3082: Wintergreen - Coombabah",
                    "3083: Bella Bvd - Pimpama Colleges",
                    "3084: Ourimbah Rd - Currumbin Primary",
                    "3085: Currumbin Waters - Marymount via Mallawa Dr",
                    "3086: Currumbin Creek Rd - Elanora High",
                    "3087: Simpson Rd - Tallebudgera Primary",
                    "3088: Molendinar - Southport",
                    "3089: Bonogin - Merrimac High",
                    "3090: Surfers Paradise - Benowa",
                    "3091: Peachy Rd - OWHS",
                    "3092: Canungra - Nerang",
                    "3093: Nerang - Merrimac High",
                    "3094: Wintergreen - Coombabah",
                    "3095: Foxwell Rd - Pimpama Colleges",
                    "3096: Nerang High - Robina",
                    "3098: Mermaid Waters - Benowa",
                    "3099: Helensvale - Pacific Pines School via Universal",
                    "3100: Robina Primary - Robina High",
                    "3101: Pacific Pines - Helensvale",
                    "3102: Monterey Keys - Coombabah",
                    "3103: Hickey Way - Keebra",
                    "3104: Bronberg Plaza - Surfers Paradise Primary",
                    "3105: Christine Ave - Marymount via Mattocks Rd",
                    "3106: Mattocks Rd - Burleigh Heads",
                    "3107: Dreamworld Parkway - Helensvale",
                    "3108: Mudgeeraba - Robina High",
                    "3109: Mudgeeraba - Robina High",
                    "3110: Finnegan Way - Pimpama Colleges",
                    "3111: Guineas Creek Rd - Currumbin Primary",
                    "3112: Village Blvd - Pimpama Colleges",
                    "3113: The Heights - Pimpama Primary",
                    "3114: Miami - Tallebudgera via Burleigh Waters",
                    "3115: Halfway Dr - OWHS",
                    "3116: Molendinar - Sommerset College",
                    "3117: Molendinar - Broadbeach",
                    "3119: Hardys Rd - Marymount via Bridgeman & Bonogin",
                    "3122: Nerang Interchange - Merrimac Primary",
                    "3123: Explorers Way - Merrimac High",
                    "3124: Crestwood Dr - Benowa",
                    "3125: Nerang rail - Keebra Park High",
                    "3126: Reserve Rd - Trinity College",
                    "3127: Southport Station - Keebra",
                    "3128: Oxenford - Helensvale High",
                    "3153: Nerang Rail - Keebra Park High school (express)",
                    "3154: Mermaid Waters - Marymount College via GC Hwy",
                    "3160: Coomera Springs - Foxwell Secondary College",
                    "3161: Coomera Rivers & Picnic Creek - Foxwell Secondary",
                    "3174: Halfway Dr - OWHS",
                    "3177: Molendinar - Benowa",
                    "3179: Finnegan Way - Pimpama Colleges",
                    "3180: Pimpama Colleges - Upper Coomera",
                    "3181: Southport - Labrador",
                    "3182: Coomera Waters - Pimpama Colleges",
                    "3184: Waverly Dr - Pimpama Colleges",
                    "3185: Varsity Lakes - Robina Primary",
                    "3197: The Observatory - Marymount via Golden Grove",
                    "3301: Currumbin Primary - Kennedy Dr",
                    "3302: Palm Beach Primary - Golden Four Dr",
                    "3303: Marymount - Simpsons Rd via Tallebudgera & Elanor",
                    "3304: Tallebudgera Primary - Golden Four Dr",
                    "3305: Robina High - Mattocks Rd",
                    "3306: Somerset College - Currumbin Creek Rd",
                    "3307: Merrimac Primary - Bilambil",
                    "3308: Marymount - Tweed Heads via Townson Ave",
                    "3309: Miami High - Christine Ave",
                    "3310: Mudgeeraba Primary - Bonogin Rd",
                    "3311: Hillcrest College - Banora Point",
                    "3312: Merrimac High - Dormello Dr",
                    "3313: Helensvale High - Studio Dr",
                    "3314: Pacific Pines - Abraham Rd",
                    "3315: Miami - Nerang West via Broadbeach Waters",
                    "3316: Nerang - Highfield Dr",
                    "3317: St Michaels - Nerang Broadbeach Rd",
                    "3318: Merrimac High - Hinklers Dr",
                    "3319: Robina High - Benowa",
                    "3320: Merrimac Primary - Carrara",
                    "3321: Robina High - Gilston",
                    "3322: Arundel Primary - Wintergreen",
                    "3323: Aquinas - Arundel",
                    "3324: Robina Primary - Robina",
                    "3325: OWHS - Sir Charles Holm Dr",
                    "3326: Southport - Ashmore",
                    "3327: Helensvale High - Guanaba",
                    "3328: Helensvale - Pacific Pines",
                    "3329: Nerang - Bonogin",
                    "3330: Merrimac High - Gilston",
                    "3331: Marymount - Miami via Burleigh Waters",
                    "3332: UCSC - Willowvale & Pimpama",
                    "3333: Varsity - Sommerset Dr",
                    "3334: Helensvale High - Willowvale",
                    "3335: Coomera Rivers Primary - Coomera Waters",
                    "3336: Pimpama Colleges - Coomera Waters",
                    "3337: Caningeraba Primary - Marymount",
                    "3338: Robina High - Main Beach",
                    "3339: Beenleigh - Ormeau",
                    "3340: Robina High - Canungra",
                    "3341: Marymount - Currumbin Waters via Mallawa Dr",
                    "3342: Keebra - Surfers Paradise",
                    "3343: Southport - Gilston",
                    "3344: OWHS - Halfway Dr",
                    "3345: Marymount - Hardys Rd via Bridgeman & Bonogin",
                    "3346: UCSC & CPS - Oxenford, Riverstone & Clagriaba",
                    "3347: William Duncan - Numbinbah",
                    "3348: Keebra - Nerang Rail",
                    "3349: Assisi - Coomera Waters",
                    "3350: Upper Coomera College - Oxenford",
                    "3351: Upper Coomera - Coomera Waters",
                    "3352: Southport - Reserve Rd",
                    "3353: Helensvale High - Oxenford",
                    "3354: St Stephens - Upper Ormeau Rd",
                    "3355: Upper Coomera - Timberview Dr",
                    "3356: Pimpama Colleges - Bella Bvd",
                    "3357: Ormeau Primary - Peachy Rd",
                    "3358: Robina High - Cayuga St",
                    "3359: Upper Coomera - Guanaba",
                    "3360: Helensvale - Timberview Dr",
                    "3361: Upper Coomera College - Coomera Waters",
                    "3362: Assisi - Wintergreen",
                    "3363: OWHS - Philben Dr",
                    "3364: Benowa Schools - Crestwood via Cotlew St",
                    "3365: Rivermount College - Upper Coomera",
                    "3366: Keebra - Nerang Rail",
                    "3367: Merrimac High - Nerang West",
                    "3368: OWHS - River Run Cir",
                    "3369: Varsity Lakes - Robina",
                    "3370: Upper Coomera - Pacific Pines",
                    "3371: OWHS - Arthur Way",
                    "3372: OWHS - Philben St",
                    "3373: Keebra Park - Nerang (express)",
                    "3374: Gilston - Nerang",
                    "3375: Keebra - Nerang Rail",
                    "3376: Upper Coomera - Coomera Springs",
                    "3377: Assisi - The Oval",
                    "3378: Helensvale PS - Monteray Keys Dr",
                    "3379: Upper Coomera - Broadwater Ave",
                    "3380: Keebra Park, Southport PS - Ashmore, Molendinar",
                    "3381: Helensvale High - Oxenford",
                    "3382: Elanora Primary - Currumbin Waters",
                    "3383: Currumbin Primary - Somerset Dr",
                    "3384: Currumbin Primary - Tugun Shops",
                    "3385: Mudgeeraba Creek Primary - Ashmore Rd",
                    "3386: St Michaels - Mudgeeraba",
                    "3387: Worongary Primary - Nerang West",
                    "3388: Keebra - Southport Station",
                    "3389: Aquinas - Runaway Bay",
                    "3390: Coombabah - Southport",
                    "3391: Merrimac High - Mattocks Rd",
                    "3392: Keebra - Nerang Rail",
                    "3393: Emmanuel College - Robina Waters",
                    "3394: OWHS - Peachy Rd",
                    "3395: Ormeau Primary - Arthur Way",
                    "3397: Nerang - Upper Coomera via Canungra",
                    "3398: Ashmore Primary - Molendinar",
                    "3399: Pacific Pines - Riverstone Crossing",
                    "3400: Benowa School - Pappas Way",
                    "3401: Coomera Rivers - Daintree Dr",
                    "3402: Coombabah - Paradise Point",
                    "3403: AB Patterson - Paradise Point",
                    "3404: Varsity - Robina Waters",
                    "3405: PBCH - Simpson Dr Bus Shelter",
                    "3407: Currumbin Primary - PBCH",
                    "3408: PBCH - Pacific Fair",
                    "3409: Elanora High - Ourimbah Rd",
                    "3410: Marymount - Broadbeach Waters via Mermaid Waters",
                    "3411: Pimpama Colleges - Abraham Rd",
                    "3412: Helensvale High - Finnegan Way",
                    "3413: Pimpama Colleges - Pimpama City",
                    "3414: Foxwell Hight - Coomera Sports Park",
                    "3415: Southport Primary - Ashmore Plaza",
                    "3416: Pimpama Primary School - Hotham Creek",
                    "3417: Pimpama Primary - The Heights",
                    "3418: OWHS - Ormeau Station",
                    "3419: Gainsborough School - Depot Rd",
                    "3420: Elanora - Burleigh Heads",
                    "3421: PBCH - Kingscliff Boat Ramp",
                    "3422: Robina High - The Observatory",
                    "3423: Miami - Palm Beach",
                    "3424: Mudgeeraba Primary - Robina Station",
                    "3425: Miami High - Pacific Fair",
                    "3426: Marymount - Christine Ave via Mattocks Rd",
                    "3427: Coolangatta Primary - Thrower Dr",
                    "3428: Marymount - Highland Park via Robina",
                    "3429: Nerang - Pacific Pines",
                    "3430: Surfers Paradise - Molendinar",
                    "3431: Foxwell Secondary - Coomera Waters",
                    "3432: Benowa High - Molendinar",
                    "3432: Benowa Schools - Molendainr",
                    "3433: Southport - Wintergreen Dr",
                    "3434: Benowa High - Southport station",
                    "3435: Robina High - Nerang",
                    "3436: Ashmore Primary - Nerang Interchange",
                    "3437: Robina HS - Old Coach Rd near Wallandra",
                    "3438: Benowa High - Ashmore City",
                    "3439: Marymount - Hinkler Dr via Mudgeeraba",
                    "3440: Broadbeach Primary - Nerang",
                    "3441: Keebra Park High - Nerang Rail",
                    "3442: Merrimac High - Hardys Rd",
                    "3443: Foxwell College - Coomera Waters via Amity Rd",
                    "3444: St Michaels - Pacific Fair",
                    "3445: Surfers Paradise Primary - Main Beach",
                    "3446: Benowa Schools - Pacific Fair",
                    "3447: Benowa High - Southport station",
                    "3448: Labrador Primary - Labrador",
                    "3449: Keebra Park - Southport Station",
                    "3450: William Duncan Primary - Parkwood Blvd",
                    "3451: Pimpama Colleges - Finnegan Way",
                    "3452: Helensvale - Coombabah",
                    "3453: Trinity College - Upper Coomera",
                    "3454: Biggera Waters - Helensvale Rd",
                    "3455: Helensvale High - Coomera Waters",
                    "3456: Upper Coomera College - Hope Island",
                    "3457: Arundel Primary - Kumbari Ave",
                    "3458: St Hildas - Sanctuary Cove",
                    "3459: Gaven Primary - Village Way",
                    "3460: Foxwell High - Upper Coomera & Coomera Springs",
                    "3461: Emmanuel College - Gilston",
                    "3462: Nerang High - Hickey Way",
                    "3463: Gaven - Universal Dr",
                    "3464: Southport High - Paradise Point",
                    "3465: Helensvale - Hope Island",
                    "3466: Helensvale Schools - Helensvale station",
                    "3467: Helensvale - Paradise Point",
                    "3468: Elanora High - The Pines",
                    "3469: Coomera Anglican - Oxley Dr",
                    "3470: Merrimac High - Cayuga St",
                    "3471: Pacific Pines - Riverstone",
                    "3472: Helensvale - Arundel",
                    "3473: Oxenford - Ormeau",
                    "3474: OWHS - Pascoe Rd",
                    "3475: Elanora High - Currumbin Waters",
                    "3476: Pimpama Colleges - Coomera Sports Park",
                    "3477: Elanora High School - Burleigh via Townson Ave",
                    "3478: Pacific Pines - Helensvale Rail",
                    "3479: Assisi College - Arundel",
                    "3482: OWHS - PSPC via Pimpama",
                    "3483: Pimpama Colleges - Foxwell Rd",
                    "3484: Marymount - Mermaid Waters via GC Hwy & Miami",
                    "3485: Pimpama PS - Gainsborough & Yawalapah Rd",
                    "3486: Pimpama Colleges - Coomera Springs",
                    "3487: Picnic Creek State School - Coomera Waters",
                    "3488: Pacific Pines - Riverstone Crossing",
                    "3489: Pimpama College - Finnegan Way",
                    "3490: OWHS - Halfway Dr",
                    "3491: Pimpama Colleges - Abraham Rd",
                    "3492: Foxwell State Secondary College - Coomera Rail",
                    "3493: Foxwell State Secondary College - Coomera Rail",
                    "3494: Foxwell Secondary College - Coomera Springs",
                    "3495: Foxwell Secondary College - Coomera Springs",
                    "3496: Ormeau Woods High - Ormeau Station via Reedmans",
                    "3497: Marymount - The Observatory via Golden Grove",
                    "3499: Pacific Pines Schools - Helensvale via Universal",
                    "4100: Daisy Hill - Mansfield High",
                    "4102: Springwood - Clairvaux Mackillop College",
                    "4110: Underwood - Rochedale Primary",
                    "4111: Beenleigh - Rochedale South Primary",
                    "4112: Loganholme - Rochedale High",
                    "4113: Waterford West - Rochedale High",
                    "4114: Daisy Hill - Rochedale High",
                    "4115: Edens Landing - Rochedale High",
                    "4116: Springwood - Rochedale High",
                    "4117: Springwood - Rochedale High",
                    "4120: Loganholme - Springwood Rd Primary",
                    "4121: Loganlea - Springwood High",
                    "4127: Logandale - Kimberley Park Primary",
                    "4128: Loganholme - Shailer Park High",
                    "4130: Rochedale South - Kimberley College",
                    "4131: Springwood - Chisholm College",
                    "4132: Loganholme - Chisholm College",
                    "4133: Loganholme - Kimberley College",
                    "4134: Beenleigh - Shailer Park High",
                    "4135: Loganholme - Shailer Park High",
                    "4136: Loganholme - Shailer Park High",
                    "4140: Browns Plains - Kingston College",
                    "4141: Springwood - Kingston College",
                    "4142: Kingston - St Francis College",
                    "4149: Crestmead - Waterford Primary",
                    "4150: Edens Landing - Marsden High",
                    "4152: Loganlea - Marsden High",
                    "4160: Loganholme - Edens Landing Primary",
                    "4161: Holmview - Loganlea High",
                    "4162: Browns Plains - Loganlea High",
                    "4163: Waterford West - Loganlea High",
                    "4170: Eagleby - Beenleigh High",
                    "4171: Eagleby - Beenleigh Primary",
                    "4173: Windaroo - Beenleigh Primary",
                    "4180: Cornubia - Rivermount College",
                    "4181: Springwood - Windaroo Valley High",
                    "4182: Waterford West - Windaroo Valley High",
                    "4183: Bethania - Windaroo Valley High",
                    "4184: Marsden - Windaroo Valley High",
                    "4185: Eagleby - Windaroo Valley High",
                    "4200: Mansfield High - Daisy Hill",
                    "4201: Mansfield High - Underwood",
                    "4202: Clairvaux Mackillop College - Waterford West",
                    "4203: Clairvaux Mackillop College - Cornubia",
                    "4204: Mansfield High - Rochedale",
                    "4209: Eight Mile Plains Primary - Mt Gravatt",
                    "4210: Rochedale Primary - Springwood",
                    "4211: Rochedale South Primary - Loganholme",
                    "4212: Rochedale High - Loganholme",
                    "4213: Rochedale High - Waterford West",
                    "4214: St Peters Primary - Daisy Hill",
                    "4215: Rochedale High - Edens Landing",
                    "4216: Rochedale South Primary - Springwood",
                    "4217: Rochedale High - Loganholme",
                    "4218: Rochedale High - Loganholme",
                    "4220: Springwood Rd Primary - Loganholme",
                    "4221: Springwood Rd Primary - Loganlea",
                    "4227: Kimberley Park Primary - Logandale",
                    "4229: Shailer Park Primary - Loganholme",
                    "4230: Chisholm College - Rochedale South",
                    "4231: St Matthews Primary - Springwood",
                    "4232: St Matthews Primary - Loganholme",
                    "4233: Chisholm College - Loganholme",
                    "4234: Shailer Park Primary - Beenleigh",
                    "4235: Shailer Park Primary - Loganholme",
                    "4236: Shailer Park Primary - Loganholme",
                    "4237: Shailer Park Primary - Loganholme",
                    "4238: Chisholm College - Loganholme",
                    "4239: Chisholm College - Loganholme",
                    "4240: Kingston Primary - Browns Plains",
                    "4241: Kingston Primary - Springwood",
                    "4242: St Francis College - Woodridge",
                    "4244: Mabel Park High - Woodridge",
                    "4245: Mabel Park High - Kingston",
                    "4246: Mabel Park High - Logan Central",
                    "4247: Woodridge High - Woodridge",
                    "4249: Waterford Primary - Browns Plains",
                    "4250: Marsden High - Edens Landing",
                    "4252: Marsden High To Loganlea",
                    "4253: Marsden High - Crestmead",
                    "4254: Marsden High - Crestmead",
                    "4255: Marsden High - Browns Plains",
                    "4256: Marsden High - Loganlea",
                    "4257: Marsden High - Marsden",
                    "4258: Marsden High - Crestmead",
                    "4259: Marsden High - Loganlea",
                    "4260: Edens Landing Primary - Loganholme",
                    "4261: Loganlea High - Holmview",
                    "4262: Loganlea High - Browns Plains",
                    "4263: Loganlea High - Waterford West",
                    "4264: Loganlea High - Beenleigh",
                    "4265: Loganlea High - Waterford West",
                    "4270: Beenleigh High - Eagleby",
                    "4271: Beenleigh Primary - Eagleby",
                    "4272: Beenleigh High - Eagleby",
                    "4273: Beenleigh Primary - Windaroo",
                    "4274: Beenleigh High - Bethania",
                    "4275: Beenleigh Station - Eagleby",
                    "4280: Rivermount College - Cornubia",
                    "4281: Windaroo Valley High - Springwood",
                    "4282: Windaroo Valley High - Crestmead",
                    "4283: Windaroo Valley High - Bethania",
                    "4284: Windaroo Valley High - Marsden",
                    "4285: Windaroo Valley High - Underwood",
                    "4286: Windaroo Valley High - Loganlea",
                    "4287: Windaroo Valley High - Bannockburn",
                    "5001: St Anthonys, Cleveland",
                    "5005: Anglican Snr & Jnr, Loretto, Capalaba",
                    "5006: Anglican Snr & Jnr, Carindale, Capalaba",
                    "5007: Kimberley, Carbrook, Vic Point",
                    "5009: Chisholm, Kimberley, Victoria Point",
                    "5010: Kimberley College, Redland Bay",
                    "5011: Kimberley, Carbook, Hyperdome",
                    "5012: Kimberley College, Carbrook, Mt Cotton",
                    "5013: Maridale Park, Gumdale, Cannon Hill Ang",
                    "5014: Capalaba, Manly, Cannon Hill Anglican",
                    "5015: Gumdale, Cannon Hill",
                    "5025: Capalaba, Cleveland, Vic Pt",
                    "5031: Gumdale, Carmel College",
                    "5032: Capalaba, Maridale Park, Carmel",
                    "5033: Carmel, Cleveland, Ormiston, Carindale",
                    "5034: Carmel, Ormiston & Redlands Colleges",
                    "5035: Carmel College, Wakerley",
                    "5036: Carmel, Alexandra Hills, Capalaba",
                    "5037: Bayview, Carmel, Thornlands, Cleveland",
                    "5038: Carmel, Cleveland, Alexandra Hills",
                    "5040: Bayview, Carmel, Faith Snr, Mt Cotton",
                    "5041: Redland Bay, Mt Cotton, Carmel College",
                    "5042: Bayview, Victoria Pt High, St Ritas",
                    "5046: Victoria Pt, Kimberley, Carbrook, Chisholm",
                    "5047: Mt Cotton, Kimberley, Calvary, Chisholm",
                    "5050: Cleveland High, Victoria Pt, Redland Bay",
                    "5051: Redland Bay, Victoria Point, Cleveland",
                    "5052: Rocky Passage, Redland Bay, Victoria Pt",
                    "5053: Pt Talburpin, Victoria Pt & Cleveland",
                    "5054: Pt Talburpin, Mt Cotton, Cleveland",
                    "5055: Redland Bay Primary, Marina, Victoria Pt High",
                    "5058: Cleveland, Thornlands, Vic Pt, Redland Bay",
                    "5062: Mount Cotton, Victoria Point High",
                    "5064: Faith & Victoria Point Pmy, Pt O'Hallora",
                    "5065: Carmel College, Victoria Point, St Ritas",
                    "5069: Ormiston, Cleveland High, Carmel, Faith",
                    "5075: Gumdale, Iona College",
                    "5076: Maridale Park, Capalaba, Iona College",
                    "5077: Brisbane Bayside, Iona College, Capalaba",
                    "5078: Iona College, Wynnum, Manly",
                    "5081: Lourdes Hill College, San Sisto College",
                    "5082: Carindale, Capalaba, Gumdale, LourdesHill",
                    "5088: Capalaba, Wynnum, Moreton Bay Colleges",
                    "5089: Moreton Bay, Thorneside, Cleveland",
                    "5090: Brisbane Bayside, Moreton Bay, Carindale",
                    "5091: Capalaba, Moreton Bay Colleges & Lourdes",
                    "5092: Moreton Bay Girls, Capalaba, Cleveland",
                    "5101: Cleveland, Victoria Point, Mt Cotton",
                    "5102: Sheldon College, Mt Cotton Primary",
                    "5103: Mt Cotton Primary, Cotton Ridge, Bayview",
                    "5110: Cleveland State, Cleveland High",
                    "5113: Toondah Harbour, Cleveland Primary & High",
                    "5114: Redland Bay, Cleveland, Ormiston",
                    "5118: Redland Bay Primary, Redland Bay Rusbrook",
                    "5119: Redland Bay, Victoria Pt Schools",
                    "5131: Carmel College, Faith, Sheldon College",
                    "5134: Carmel College, Bayview State",
                    "5137: St Anthonys, Alexandra Hills High",
                    "5138: St Anthonys, Alexandra Hills, Birkdale",
                    "5153: Victoria Pt Schools, Faith Snr, Cleveland",
                    "5154: Cleveland, Victoria Point, Redland Bay",
                    "5155: Victoria Point High, Redland Bay Marina",
                    "5156: Victoria Point High, Rocky Passage",
                    "5158: Cleveland, Victoria Point, Redland Bay",
                    "5165: San Sisto College, Carindale",
                    "5172: Capalaba, Birkdale, Wellington Point",
                    "5173: Tingalpa - Wellington Point High",
                    "5174: Brisbane Bayside SC Local Loop",
                    "5175: Scenic Shores Primary School",
                    "5176: Cleveland High, Vic Pt High, Redland Bay Primary",
                    "5177: Cleveland State High, Cleveland Primary School",
                    "5178: Victoria Point High - Serpentine Creek Rd",
                    "5179: Iona College Express - Mayfair then Eastside Vill",
                    "5180: Sheldon - Capalaba SS and Coolnwynpin SS",
                    "5201: Redbank, Kruger, Goodna, St Francis",
                    "5202: Kruger, StPeter Clavier, Bundamba, Bremer",
                    "5204: Raceview, Sacred Heart, Collingwood Park",
                    "5205: Redbank Plains, St Francis, Goodna",
                    "5206: Bremer, Silkstone, Bethany, Raceview",
                    "5207: Bundamba, Bremer, Riverview, Redbank",
                    "5208: East Ipswich, St Marys, Bremer, Bundamba",
                    "5210: Ipswich Grammar, St Marys, Redbank",
                    "5211: Redbank Plains, St Peter Claver, Bundamba",
                    "5212: St Marys, Ipswich Grammar, West Moreton",
                    "5213: Kruger, Redbank Plains, St Francis Xavier",
                    "5214: Ipswich, StMarys, West Moreton",
                    "5215: Bremer, Churchill, Blair, Ipswich",
                    "5216: Bundamba Primary, Bundamba High",
                    "5217: Ipswich, St Marys, Bremer, Blair",
                    "5218: St Marys, Ipswich High, Amberley",
                    "5220: St Marys, Churchill, Raceview, Silkstone",
                    "5221: St Marys, Bremer, Raceview, Silkstone",
                    "5223: West Moreton Anglican College",
                    "5226: Camira, Ipswich Grammar, St Marys",
                    "5227: Goodna, Springfield, Springfield Central",
                    "5228: St Augustine, Redbank, Camira, Woodcrest",
                    "5229: Redbank Plains, St Augustine, Woodcrest",
                    "5231: StAugustines, Redbank Plains, Springfield",
                    "5232: Grand Ave, Forest Lake, St Marks, Glenala",
                    "5233: Camira State School, Woodcrest College",
                    "5234: Kruger, Redbank Plains High",
                    "5235: Forest Lake, St Augustines College",
                    "5236: Redbank Shops, Orion, Springfield Central",
                    "5237: Brassall, Ipswich, Churchill, Bremer",
                    "5238: Ipswich Boys Grammar, St Marys",
                    "5239: Bremer, Ipswich Boys Grammar, St Marys",
                    "5240: Gailes, Springfield",
                    "5241: Ipswich West, Ipswich Central, Silkstone",
                    "5245: Yamanto, Bundamba State High",
                    "5246: Yamanto, Ripley Valley schools",
                    "5247: Bremer, Silkstone, Churchill",
                    "5248: Redbank Stn - Bellbrd Pk Coll - Redbank",
                    "5249: Collingwood Park, Woodlinks SS",
                    "5250: Redbank Stn , Bellbird Park",
                    "5251: Redbank Stn, Goodna Stn, Bellbird Park",
                    "5252: Redbank Stn , Kruger Pde, Bellbird Park",
                    "5253: Goodna Stn, Springfield Schools",
                    "5254: Leichhardt, One Mile, Bremer",
                    "5255: Goodna, Camira, Springfield SS, SHS, Orion",
                    "5257: Collingwood Park State SC",
                    "5258: Goodna State PreSchool-Collingwood Park State SC",
                    "5260: Yamanto, Ripley Valley schools",
                    "5265: Deebing Heights and Ripley Valley Schools",
                    "5267: Kruger SS, Bellbird Park SHS, FernbrookSS",
                    "5268: Goodna Stn, Kruger SS, Bellbird Park SHS",
                    "5269: Ipswich, West Moreton, Silkstone",
                    "5270: Amberley, Amberley State Primary",
                    "5271: Rebank Plains, Belbird Park College",
                    "5273: Ripley Valley",
                    "5274: Redbank Stn - Bellrd Pk Coll - Redbank",
                    "5276: Redbank Plains SHS, Bellbird Park SSC",
                    "5277: Ripley Valley schools, Deebing Heights",
                    "5501: Little Mountain - Caloundra High",
                    "5502: Bellvista - Caloundra High",
                    "5503: Banya/Baringa - Our Lady of Rosary Primary",
                    "5504: Little Mountain/Talara SS - Caloundra High",
                    "5505: Kawana/Talara SS - Caloundra High",
                    "5511: Dicky Beach/Pelican Waters - Unity College",
                    "5512: Kings Beach/Pelican Waters - Notre Dame College",
                    "5513: Kawana/Currimundi - Notre Dame College",
                    "5521: Banya - Nirimba SS",
                    "5522: Unity College - Nirimba SS",
                    "5523: From Banya - Baringa SHS",
                    "5531: Glenview - Glasshouse Christian College",
                    "5541: Pelican Waters/Golden Beach - Unity College",
                    "5550: Nirimba - Meridan College",
                    "5551: Kawana/Baringa - Meridan College",
                    "5552: Nirimba/Baringa - Meridan College",
                    "5553: Little Mountain/Bellvista - Meridan College",
                    "5554: Mooloolah/Glenview - Meridan College",
                    "5561: Nirimba/Baringa - Kawana College",
                    "5562: Brightwater/Kawana - Kawana College",
                    "5571: Talara SS - Meridan College via PLC",
                    "5572: Talara SS - Meridan College via Aroona",
                    "5600: Maroochydore High - Buderim",
                    "5601: Alexandra Headland/Mooloolaba - Maroochydore High",
                    "5602: Buderim - Maroochydore High",
                    "5603: Mons/Buderim - Maroochydore High",
                    "5604: Eudlo Flats - Maroochydore High",
                    "5605: Bli Bli - Maroochydore High",
                    "5606: Bli Bli - Maroochydore High",
                    "5607: Mudjimba - Maroochydore High",
                    "5608: Marcoola - Maroochydore High",
                    "5609: Mount Coolum - Maroochydore High",
                    "5610: Pacific Paradise - Maroochydore High",
                    "5611: Bli Bli - Maroochydore High",
                    "5612: Buderim - Maroochydore High",
                    "5616: Express from MSHS - GSC",
                    "5631: Kawana - Mountain Creek High",
                    "5632: Caloundra/Dicky Beach - Mountain Creek High",
                    "5633: Brightwater - Mountain Creek High",
                    "5634: Sippy Downs - Mountain Creek High",
                    "5635: Buderim - Mountain Creek High",
                    "5636: North Buderim - Mountain Creek High",
                    "5637: Kuuin/Maroochydore - Mountain Creek High",
                    "5638: Palmview - Mountain Creek High",
                    "5700: Kuluin - St John's College",
                    "5701: Sunshine Cove/Maroochydore - St John's College",
                    "5702: Golden Beach/Caloundra - Montessori College",
                    "5704: Meridan Plans - Siena College",
                    "5705: Mountain Creek - St Joseph's Primary",
                    "5708: Pacific Paradise/Bli Bli - Burnside High",
                    "5710: Tanawha/Mons/Buderim - Chancellor College",
                    "5711: Buderim - Chancellor College",
                    "5712: Pelican Waters - Immanuel Lutheran College",
                    "5715: Marcoola - Good Samaritan College",
                    "5716: Buderim Meadows - Stella Maris Primary",
                    "5717: Caloundra - Siena College",
                    "5718: Maroochydore/Alexandra Headland - Siena College",
                    "5719: Bli Bli - Siena College",
                    "5723: Pacific Paradise - Peregian Springs Primary",
                    "5724: South Coolum - Burnside High",
                    "5725: Coolum Beach - Stella Maris Primary",
                    "5726: Coolum Beach - St John's College",
                    "5727: Buderim - Chancellor College",
                    "5728: Cotton Tree/Maroochydore - St Joseph's Primary",
                    "5729: North Buderim - Sunshine Coast Grammar",
                    "5732: Marcus Beach - Good Samaritan College",
                    "5735: North Buderim - Siena College",
                    "5739: Sunshine Cove - Good Samaritan College",
                    "5740: Forest Glen - Good Samaritan College",
                    "5741: Kuluin - St Joseph's Primary",
                    "5742: Eudlo Flats - St John's College",
                    "5743: West Woombye - Burnside High",
                    "5744: Chevallum - Palmwoods Primary",
                    "5745: Palmwoods - Siena College",
                    "5746: Kunda Park - Burnside High",
                    "5747: Brightwater - Burnside High",
                    "5748: Palmwoods - St Johns College",
                    "5749: Palmwoods - St Joseph's Primary",
                    "5750: Palmwoods - Burnside High",
                    "5751: Mount Coolum - Good Samaritan College",
                    "5752: Eudlo/Chevallum - Burnside High",
                    "5753: Maroochydore/Kuluin - Siena College",
                    "5754: Nambour - Siena College",
                    "5756: Woombye - Chancellor Primary",
                    "5761: Palmview - Maroochydore Primary",
                    "5762: Mooloolah/Glenview - Palmview Primary",
                    "5763: Mooloolah/Glenview - Chancellor Primary",
                    "5764: Palmview (Harmony) - Chancellor SS",
                    "5765: Caloundra - St Johns College",
                    "5766: Mooloolah/Glenview - Siena College",
                    "5768: Brightwater - Matthew Flinders/Siena Colleges",
                    "5769: Caloundra - Siena College",
                    "5772: Eudlo Flats - Bli Bli Primary",
                    "5773: Kuluin/Bli Bli - St Johns College",
                    "5774: Glenview - Palmview Primary",
                    "5775: Buderim - Chancellor College",
                    "5780: Palmview - Chancellor College",
                    "5782: Maroochydore/Mooloolaba - Sunshine Coast Grammar",
                    "5791: Palmview - Chevallum Primary",
                    "5792: Buderim - Chevallum Primary",
                    "5794: Sippy Downs - Buderim Mountain Primary",
                    "5795: Maroochydore - Mountain Creek Primary",
                    "5797: Landershute/Hunchy - Palmwoods",
                    "5802: Noosaville (Goodchap St) - Sunshine Coast Grammar",
                    "5803: Peregian Springs - Coolum High",
                    "5804: Mt Tinbeerwah - St Andrews College",
                    "5806: Boreen Point - Noosa District High (Pomona)",
                    "5807: Pomona - St Teresa's College",
                    "5808: Noosa Junction - Noosa District High (Cooroy)",
                    "5810: Cooroy - St Teresa's College",
                    "5812: Mount Coolum - Sunshine Beach Primary",
                    "5813: Castaways Beach - Sunshine Beach Primary",
                    "5817: Coolum Beach - Noosaville Primary",
                    "5818: Coolum - St Thomas More Primary",
                    "5819: Cooroibah - St Teresa's College",
                    "5820: Noosaville - St Thomas More Primary",
                    "5821: Tewantin - St Thomas More Primary",
                    "5822: Noosaville SS - Tewantin SS",
                    "5823: Lake Cooroibah - Sunshine Beach High",
                    "5824: CSHS - Mt Coolum",
                    "5825: Pacific Paradise - Coolum High",
                    "5826: Lake Weyba - Sunshine Beach High",
                    "5827: Mt Coolum - Sunshine Beach High",
                    "5828: Noosa Heads - St Thomas More Primary",
                    "5829: Cooroibah - Tewantin Primary",
                    "5830: Noosaville - Sunshine Beach High",
                    "5831: Pomona - St Thomas More Primary",
                    "5832: Noosaville - Sunshine Beach High",
                    "5833: Mt Tinbeerwah - Burnside High",
                    "5834: CSHS - Toolga",
                    "5835: Noosa Junction - Matthew Flinders College",
                    "5836: Noosa Banks - Sunshine Beach High",
                    "5837: Noosaville - St Thomas More Primary",
                    "5838: Pomona - Siena College",
                    "5839: Pacific Paradise - St Andrew's College",
                    "5840: Noosa Bushlands - St Thomas More Primary",
                    "5841: South Coolum - Coolum High",
                    "5842: Tewantin (Bougainvillia) - St Thomas More Primary",
                    "5843: Peregian Springs - Peregian Springs Primary",
                    "5844: Noosa Junction - St Andrew's College",
                    "5845: Noosaville (Goodchap St) - Coolum High",
                    "5846: Mt Coolum - St Teresa's College",
                    "5847: Mt Coolum - Coolum High",
                    "5848: Mt Coolum - Coolum High",
                    "5849: Pacific Paradise - Coolum High",
                    "5850: Noosa Junction - Coolum Primary",
                    "5851: Noosa Springs - Coolum High",
                    "5852: Tewantin - Coolum High",
                    "5853: Noosaville (Goodchap St) - Pacific Paradise SS",
                    "5854: South Coolum - Coolum High",
                    "5855: South Coolum - Sunshine Beach Primary",
                    "5856: Tinbeerwah - Sunshine Beach High",
                    "5857: Tewantin (Carramar Str) - Sunshine Beach SHS",
                    "5858: Tewantin (Bougainvillia) - Sunshine Beach High",
                    "5859: Cooroibah - Sunshine Beach High",
                    "5860: Sunshine Beach - St Teresa's College",
                    "5861: Sunshine Beach - St Teresa's College",
                    "5862: Sunshine Beach - St Teresa's College",
                    "6001: Veresdale, Gleneagle, Beaudesert",
                    "6002: Park Ridge, Flagstone College & Primary",
                    "6003: Jimboomba, Gleneagle, Beaudesert",
                    "6004: Emmaus, Woodhill, Gleneagle, Beaudesert",
                    "6005: Jimboomba, Woodhill Pmy, Beaudesert High",
                    "6006: Flagstone, Jimboomba, Emmaus, Beaudesert",
                    "6007: Jimboomba, Gleneagle, Beaudesert",
                    "6008: Hills College, Jimboomba, Flagstone",
                    "6009: Emmaus, Hills, Jimboomba, Flagstone",
                    "6010: Emmaus, Hills, Jimboomba, Flagstone",
                    "6011: Jimboomba, Emmaus, Beaudesert High",
                    "6012: Jimboomba, Woodhill Pmy, Beaudesert High",
                    "6013: Parklands College, Park Ridge High & Pmy",
                    "6014: Greenbank Pmy, Park Ridge High & Pmy",
                    "6015: St Francis, Park Ridge High & Primary",
                    "6016: Corymbia State School, Park Ridge State High Sch",
                    "6018: Yugumbir, Browns Plains, St Bernadines",
                    "6019: Bumstead Rd, Corymbia State School",
                    "6020: Park Ridge, Regents Park, Browns Plains",
                    "6022: Emmaus, Woodhill, Gleneagle, Beaudesert",
                    "6024: Heathwood, Sunnybank, St Thomas More",
                    "6025: Greenbank, Springfield Central, St August",
                    "6026: Forest Lake Schools & Colleges, Grand Ave",
                    "6027: Flagstone Pmy, Park Ridge High & Pmy",
                    "6028: Park Ridge, Regents Park, Browns Plains",
                    "6029: Browns Plains, Burrowes, St Francis",
                    "6030: Park Ridge, St Bernadines, Browns Plains",
                    "6032: Woodhill, Gleneagle, Beaudesert",
                    "6033: Browns Plains, Canterbury College",
                    "6034: Cedar Vale, Flagstone College & Primary",
                    "6035: Park Ridge, Yugumbir, Boronia Heights",
                    "6036: MacGregor High, Clairvaux Mackillop",
                    "6037: Grand Plaza, Sunnybank High, St Thomas",
                    "6038: Grand Plaza, Runcorn High, MacGregor High",
                    "6040: Flagstone, Jimboomba Primary",
                    "6041: Mundoolun, Emmaus, Jimboomba Pmy",
                    "6042: Munruben, Boronia Heights, Park Ridge",
                    "6043: Greenbank, Munruben, Logan Village SS",
                    "6044: Park Ridge, Hills, Jimboomba, Flagstone",
                    "6046: Greenbank, Sunnybank, Clairvaux",
                    "6047: Jimboomba, Park Ridge, St Laurences",
                    "6048: Regents Park, Park Ridge",
                    "6051: Kagaru, Jimboomba, Flagstone Primary",
                    "6052: Park Ridge, Marsden High, Canterbury",
                    "6053: Berrinba, Parkinson, Stretton Colleges",
                    "6055: Heritage Park, Grand Plaza, Park Ridge",
                    "6060: Regents Park, Forest Lake, Springfield",
                    "6061: Jimboomba, Buccan, Trinity College",
                    "6062: Greenbank, Springfield Central",
                    "6063: Greenbank, Springfield Central SHS",
                    "6066: Browns Plains, Sunnybank, St Thomas More",
                    "6068: Jimboomba, Everleigh SS",
                    "6101: Beaudesert, Gleneagle, Veresdale Scrub",
                    "6102: Flagstone, Jimboomba, Park Ridge",
                    "6103: Beaudesert, Gleneagle, Jimboomba",
                    "6104: Beaudesert, Gleneagle, Woodhill, Emmaus",
                    "6105: Beaudesert, Cedar Vale, Jimboomba",
                    "6106: Beaudesert, Emmaus, Jimboomba, Flagstone",
                    "6107: Beaudesert, Gleneagle, Jimboomba",
                    "6108: Flagstone, Jimboomba, Hills, Munruben",
                    "6109: Flagstone, Jimboomba, Hills, Park Ridge",
                    "6110: Flagstone, Jimboomba, Hills Int, Emmaus",
                    "6111: Flagstone",
                    "6112: Beaudesert High, Woodhill Pmy, Jimboomba",
                    "6113: Park Ridge, Parklands College, Greenbank",
                    "6114: Park Ridge, Greenbank, Boronia Heights",
                    "6115: Yugumbir, Browns Plains, Park Ridge",
                    "6116: Park Ridge, Yugumbir, St Bernadines",
                    "6117: Greenbank, Park Ridge, Boronia Heights",
                    "6118: Yugumbir, Browns Plains, Forestdale",
                    "6119: Corymbia State School, Bumstead Rd",
                    "6120: Browns Plains, Regents Park, Jimboomba",
                    "6121: Browns Plains, Regents Pk, Boronia Hghts",
                    "6122: Gleneagle State School, Cedar Vale",
                    "6123: Emmaus, Greenbank",
                    "6124: St Thomas More Sunnybank, Browns Plains",
                    "6125: St Augustine, Springfield, Boronia Hghts",
                    "6126: Forest Lake, Forestdale, Browns Plains",
                    "6127: Park Ridge, Flagstone Primary, Jimboomba",
                    "6128: Browns Plains, Park Ridge, Maclean",
                    "6129: St Francis, Browns Plains, Greenbank",
                    "6130: Calamvale, Browns Plains, Park Ridge",
                    "6132: Beaudesert, Gleneagle, Jimboomba",
                    "6133: Canterbury College, Marsden, Grand Plaza",
                    "6134: Flagstone, Cedar Vale, Jimboomba",
                    "6135: Park Ridge, Boronia Heights, Grand Plaza",
                    "6136: Clairvaux-Mackillop, Grand Plz, Jimboomba",
                    "6137: St Thomas More, Sunnybank, Grand Plaza",
                    "6138: MacGregor High, Runcorn High, Grand Plaza",
                    "6141: Emmaus, Hills Int, Jimboomba, Mundoolun",
                    "6142: Park Ridge, Boronia Heights, Munruben",
                    "6143: Canterbury College, Munruben, Park Ridge",
                    "6144: Flagstone, Jimboomba, Hills, Regents Park",
                    "6145: Flagstone Schools, Jimboomba, Maclean",
                    "6146: Clairvaux Mackillop, Greenbank",
                    "6147: St Laurence, Brisbane High, Jimboomba",
                    "6150: Stretton Colleges, Browns Plains",
                    "6151: Flagstone Schools, Jimboomba, Kagaru",
                    "6152: Canterbury College, Calamvale, Algester",
                    "6153: Stretton Colleges, Marsden, Browns Plains",
                    "6154: Beaudesert, Gleneagle",
                    "6155: Park Ridge, Grand Plaza, Heritage Park",
                    "6161: Trinity College, Jimboomba, Maclean",
                    "6162: Springfield Central, Greenbank",
                    "6163: Springfield Central SHS, Greenbank",
                    "6165: Marsden HS, Logan Cent, Woodridge GCity",
                    "6166: St Thomas More, Browns Plains",
                    "6167: Marsden High, Crestmead, Browns Plains",
                    "6168: Everleigh State, Sth Maclean, Nth Maclean",
                    "6169: Marsden High, Bumstead Road",
                    "6170: Stretton State College, Macquarie, Browns Plains",
                    "6171: Stretton College - Macquarie - Brown Plains",
                    "6201: Kruger, Goodna, Redbank Plains, Redbank",
                    "6202: Bundamba State, Riverview, Redbank Plaza",
                    "6203: St Marys, St Edmonds, Bremer, Silkstone",
                    "6204: St Peter Claver, Sacred Heart, Silkstone",
                    "6206: St Marys, St Edmonds, Ipswich, Raceview",
                    "6207: Bundamba, Sacred Heart, Bremer",
                    "6208: Bundamba, East Ipswich, Bremer",
                    "6209: Redbank Plains, Redbank",
                    "6210: Ipswich Boys & Girls, StMarys, StEdmonds",
                    "6211: Kruger, Redbank, Collingwood Park",
                    "6212: St Marys, St Edmonds, Redbank Plains",
                    "6213: Redbank Plains, Redbank Station",
                    "6214: Bremer, Bundamba, Redbank",
                    "6215: Bremer, Blair State, Ipswich High",
                    "6216: St Marys, St Edmonds, Raceview, Silkstone",
                    "6217: St Marys, St Edmonds, Ipswich, Amberley",
                    "6218: Immaculate Heart, Ipswich High",
                    "6220: Central, Bremer, Silkstone, Raceview",
                    "6221: St Edmunds, St Marys, Yamanto Deebing Hts",
                    "6223: West Moreton, Ipswich Girls, Booval",
                    "6224: Goodna,St Augustines College, Forest Lake",
                    "6225: Bremer, Bundamba",
                    "6226: Ipswich Boys, Ipswich Girls, St Marys",
                    "6227: Goodna, St Francis Xavier, Camira",
                    "6228: Woodcrest, Springfield Lakes, Redbank",
                    "6229: Woodcrest College, Camira, Goodna Station",
                    "6230: Camira, Woodcrest, Redbank Plains, St Aug",
                    "6231: Augusta, Redbank Plains SHS, St Augustine",
                    "6232: Forest Lake, St Marks, Inala, Glenala",
                    "6233: Redbank Plains, Sprinfield Lakes, Camira",
                    "6234: Redbank Plains, Redbank Plaza, Dinmore",
                    "6235: St Augustine's - Springfield Central",
                    "6236: Springfield Central, Springfield Lakes",
                    "6237: Bremer, Ipswich High, Brassall Primary",
                    "6238: St Marys, St Edmonds, Ips Boys, Churchill",
                    "6239: Bremer, Churchill, Yamanto, Deebing Heights",
                    "6240: Brassall, Ipswich, St Marys, St Edmunds",
                    "6241: Ipswich Central, Bremer, Raceview",
                    "6242: Kruger, Goodna, Redbank Plains, Redbank",
                    "6245: Bundamba College, Silkstone, Bremer",
                    "6246: Ripley Valley SS, Ripley Rd, Rex Hills Dr",
                    "6247: Ipswich High, Bremer State High",
                    "6248: Bellbird Park College - Redbank Station",
                    "6249: Bellbird Park, Woodlinks SS, Redbank",
                    "6250: Bellbird Park, Redbank Stn",
                    "6251: Bellbird Park, Goodna Stn, Redbank Stn",
                    "6252: Bellbird Park, Redbank Stn",
                    "6253: Springfield Schools, Goodna Stn",
                    "6254: Bremer, Leichhardt, One Mile",
                    "6255: Springfield SHS, Camira SS, Goodna",
                    "6256: Orion, Springfield SHS, Camira, Goodna",
                    "6257: Collingwood Park State SC",
                    "6258: Collingwood Park State SC-Goodna State PreSchool",
                    "6260: Ripley Valley schools, Yamanto",
                    "6263: Ripley Valley Schools",
                    "6264: Ripley Valley SS",
                    "6265: Ripley Valley Schools and Deebing Heights",
                    "6267: Fernbrooke, Bellbird Park, Redbank Stn",
                    "6268: Bellbird Park SHS, Kruger SS, Goodna Stn",
                    "6269: West Moreton, Ipswich, Redbank Plains",
                    "6271: Bellbird Park College, Redbank Plains",
                    "6272: Ipswich HS, One Mile, Leichhardt",
                    "6273: Ripley Valley SS, Ripley Rd, Rex Hills Dr",
                    "6274: Bellbird Park College - Redbank Station",
                    "6275: Deebing Heights SS",
                    "6276: Bellbird Park College",
                    "6277: Deebing Heights SS, Ripley Valley schools",
                    "6701: Redcliffe, Scarborough, Humpybong",
                    "6702: Living Faith, Grace Lutheran, Redcliffe",
                    "6703: Redcliffe, Deception Bay, North Lakes",
                    "6704: North Lakes, Deception Bay, St Pauls",
                    "6705: Clontarf, North Lakes, Redcliffe",
                    "6706: Clontarf, Mueller, North Lakes, Redcliffe",
                    "6707: Redcliffe High, Scarborough Primary",
                    "6708: North Lakes, Grace, Redcliffe",
                    "6709: North Lakes, Grace, Clontarf",
                    "6710: Grace Lutheran, Mueller, The Lakes",
                    "6711: Humpybong, Redcliffe, Southern Cross",
                    "6712: Grace, Lutheran, Mueller",
                    "6714: Kallangur, Murrumba Downs, Dakabin",
                    "6715: Southern Cross, Clontarf, Redcliffe",
                    "6716: Rothwell, Kippa-Ring, Clontarf, Sandgate",
                    "6718: North Lakes, Dakabin, Mueller",
                    "6719: Rothwell, North Lakes, Kallangur",
                    "6720: North Lakes, Mango Hill, Rothwell",
                    "6721: Northlakes State College, Mango Hill",
                    "6722: Mango Hill State School",
                    "6723: Mango Hill North Lakes Murrumba College",
                    "6800: Bray Park, Holy Spirit, Kurwongbah, Petrie",
                    "6801: Lawnton, Holy Spirit, Bray Park",
                    "6805: Genesis, Bray Park, Strathpine, Holy Spirit",
                    "6806: Genesis, Bray Park, Pine Rivers",
                    "6807: Genesis, Bray Park, Pine Rivers",
                    "6808: Strathpine West, Bray Park, Holy Spirit",
                    "6811: Eatons Hill, All Saints, Albany Hills, AlbanyCreek",
                    "6812: Eatons Hill, Albany Creek",
                    "6813: Eatons Hill, All Saints, Albany Hills, AlbanyCreek",
                    "6814: Eatons Hill, Albany Creek",
                    "6815: Eatons Hill, Albany Creek",
                    "6820: Murrumba, Unburba, Dakabin",
                    "6821: Genesis, Bray Park, Kurwongbah, Petrie",
                    "6822: Pine Rivers, Bray Park, Kallangur, Dakabin, Petrie",
                    "6823: Undurba, Murrumba",
                    "6824: Undurba, Murrumba",
                    "6825: Undurba, Murrumba",
                    "6830: Mango Hill, St Benedicts, North Lakes High",
                    "6831: Griffin Primary",
                    "6832: Mango Hill, St Benedicts, North Lakes High",
                    "6833: The Lakes College, North Lakes High",
                    "6834: North Lakes High, St Benedicts",
                    "6835: North Lakes High, Bounty Bvd",
                    "6836: St Benedicts",
                    "6840: St Pauls, Craigslea",
                    "6841: Holy Spirit, StJosephs, BrackenRidge, StJohnFisher",
                    "6842: St John Fisher, StPauls, StPatricks, Sandgate High",
                    "6850: St Patricks, Sandgate High, StJohn Fisher, StPauls",
                    "6851: Bald Hills, St Pauls",
                    "6852: St Patricks, Sandgate High, StJohn Fisher, StPauls",
                    "6860: St Patricks, Sandgate High",
                    "6861: St John Fisher, Bracken Ridge",
                    "6863: St Patricks, Sandgate High",
                    "6870: Mount Alvernia, Padua, Craigslea, St Pauls",
                    "6871: Mount Alvernia, Padua, Craigslea, St Pauls",
                    "6872: Mount Alvernia, Padua, Craigslea",
                    "6873: Mount Alvernia, Padua, McDowall",
                    "6874: Mount Alvernia, Padua, McDowall",
                    "6875: Joyner, Craigslea High, Wavell Heights SHS",
                    "6891: Sandgate station - St Patricks",
                    "6892: St Patricks - Sandgate station",
                    "6893: St Patricks - Sandgate station",
                    "6894: St Patricks - Sandgate station",
                    "6895: St Patricks - Sandgate station",
                    "6896: St Patricks - Sandgate station",
                    "7011: Oakey Flat Road Morayfield East SS",
                    "7012: Moorina, St Eugenes, Burpengary College",
                    "7013: Narangba, Burpengary State, St Euguene",
                    "7014: St Eugenes, Burpengary Secondary",
                    "7015: Narangba, Narangba Valley State High",
                    "7016: Grace College, St Peters, St Columbans",
                    "7017: Burpengary, Burpengary Secondary College",
                    "7018: Caboolture High, Minimbah State",
                    "7019: Morayfield Primary & High, Minimbah Primary",
                    "7020: Morayfield High, Minimbah Primary, Tullawong",
                    "7021: Minimbah, Morayfield & Morayfield East",
                    "7022: Morayfield Station, Burpengary Primary, NVSHS",
                    "7023: Morayfield, Morayfield East State",
                    "7024: Morayfield State, St Peters, St Columbans",
                    "7025: Morayfield, Caboolture, St Columbans",
                    "7026: Morayfield, Morayfield East State",
                    "7027: Burpengary State Primary & Meadows",
                    "7028: Petrie Primary, Pine Rivers High",
                    "7029: Burpengary, Narangba Primary, Dakabin High",
                    "7030: Deception Bay, Dakabin High",
                    "7031: Dakabin, Petrie, Pine Rivers State",
                    "7032: Deception Bay State, Moreton Downs",
                    "7033: Clontarf High, Kippa Ring State",
                    "7034: Scarborough State, Grace, Morayfield",
                    "7035: Morayfield, Mueller, Grace",
                    "7036: Burpengary, Deception Bay, Grace",
                    "7037: Excelsior Park, Narangba Valley High",
                    "7038: Minimbah State, Tullawong Primary & High",
                    "7039: Burpengary, Burpengary Secondary College",
                    "7040: Deception Bay, Narangba Valley State High",
                    "7041: Narangba Station, Narangba Valley High",
                    "7042: Burpengary Meadows, Narangba Valley",
                    "7043: Narangba Valley Primary, Jinibara State",
                    "7044: Narangba Station, Narangba Valley High",
                    "7045: Morayfield Station, Burpengary Primary, NVSHS",
                    "7046: Burpengary, St Eugenes, Burpengary State",
                    "7047: Caboolture, Morayfield, Northpine College",
                    "7048: Caboolture, NVSHS, Northpine College",
                    "7050: Burpengary, Clontarf High, Redcliffe",
                    "7051: Burpengary, Narangba Valley State High",
                    "7052: Burpengary, Burpengary Secondary College",
                    "7053: Deception Bay, Clontarf, Kippa Ring",
                    "7054: Morayfield, Deception Bay, Redcliffe High",
                    "7056: Burpengary West, Burpengary Primary, NVSHS",
                    "7058: Burpengary, Narangba Valley State High",
                    "7059: Morayfield, Burpengary, Narangba Valley",
                    "7060: Deception Bay, St Euguene, Burpengary",
                    "7062: Burpengary, Clontarf, Kippa Ring",
                    "7063: Caboolture, Deception Bay, Aust Tech College",
                    "7064: Deception Bay High, Hercules Road",
                    "7065: Petrie, Petrie State, Pine Rivers High",
                    "7066: Deception Bay, Rothwell, Redcliffe High",
                    "7067: Burpengary, Clontarf, Kippa Ring",
                    "7069: Deception Bay, St Euguene, Burpengary",
                    "7111: Oakey Flat Road Morayfield East SS",
                    "7119: Morayfield Primary & High, Minimbah Primary",
                    "7121: Minimbah, Morayfield & Morayfield East",
                    "7123: Morayfield, Morayfield East State",
                    "7124: Morayfield State, St Peters, St Columbans",
                    "7125: Morayfield, Caboolture, St Columbans",
                    "7126: Morayfield, Morayfield East State",
                    "7132: Deception Bay State, Moreton Downs",
                    "7141: Narangba Station, Narangba Valley High",
                    "7153: Deception Bay, Clontarf, Kippa Ring",
                    "7201: Beachmere, Bribie Island State Schools",
                    "7202: Beachmere Primary, Caboolture High",
                    "7203: Bellmere, Tullawong Schools",
                    "7204: Caboolture, Elimbah Primary",
                    "7205: Bellmere, Tullawong Pmy & High, St Pauls",
                    "7206: Caboolture, Elimbah Primary",
                    "7207: Bellmere, Caboolture, Morayfield",
                    "7209: Elimbah, Caboolture High, St Columbans",
                    "7210: Toorbul, Caboolture, Tullawong",
                    "7211: Toorbul, Caboolture High, St Columbans",
                    "7213: Elimbah, Caboolture, St Columbans",
                    "7214: Caboolture Pmy, Caboolture East, StPeters",
                    "7216: Caboolture, Tullawong State High",
                    "7217: Ningi, Beachmere Primary",
                    "7218: Bellmere, Minimbah, Caboolture",
                    "7220: Beachmere, Tullawong, Caboolture",
                    "7221: Caboolture, Tullawong, St Pauls, Grace",
                    "7222: Caboolture, Caboolture East Schools",
                    "7223: Morayfield, Tullawong Schools, St Pauls",
                    "7226: Caboolture & East, StPeters, StColumbans",
                    "7227: Beachmere, Caboolture High",
                    "7228: Beachmere, Caboolture High, St Peters",
                    "7231: Caboolture, Beerburrum, Beerwah High",
                    "7232: Caboolture High, Caboolture East Primary",
                    "7234: Tullawong Pmy & High, St Pauls, Bellmere",
                    "7235: Caboolture Pmy, Tullawong, Grace",
                    "7236: Caboolture, Caboolture High",
                    "7237: Caboolture, Bellmere",
                    "7240: Elimbah, Pumicestone Rd",
                    "7241: Pumicestone Rd School, Caboolture North",
                    "7242: Morayfield, Minimbah, Caboolture",
                    "7243: Morayfield, Caboolture",
                    "7244: Reserve Road - Caboolture High",
                    "7245: Beachmere Bribie Island",
                    "7246: Morayfield High - Upper Caboolture",
                    "7270: Caboolture High - Beachmere",
                    "7271: Caboolture High - Caboolture North & Toorbul",
                    "7276: Caboolture High - Caboolture North",
                    "7277: Caboolture High - Beachmere & Peel Rd",
                    "7280: Tullawong High - Bellmere",
                    "7288: Morayfield High - Upper Caboolture Early Fri svc",
                    "7308: St Columbans - Ningi / Bribie",
                    "7309: Banksia Beach - Tullawong High",
                    "7310: Bribie Ningi - St Michaels St Peters",
                    "7311: Ningi - Banksia Beach Pmy",
                    "7312: Ningi and Sandstone Pt - Banksia Beach",
                    "7313: Banksia Beach Pmy - Woorim",
                    "7314: Sandstone Pt - Bribie Island Pmy",
                    "7315: Banksia Beach - St Columbans",
                    "7317: Sandstone Pt, Ningi - Bribie Island SS",
                    "7318: Bongaree - Caboolture",
                    "7319: Sandstone Pt - Bribie Island State School",
                    "7320: Ningi, Sandstone Pt - Bribie Island SS",
                    "7321: Sandstone Pt - Bribie Island State School",
                    "7322: Woorim - Bribie Island State School",
                    "7324: Bongaree - Bribie Island State School",
                    "7325: Bongaree - Bribie Island State School",
                    "7326: Sandstone Pt - Banksia Beach",
                    "7327: Pac Harbour, Endeavour, Quarterdeck - BBSS",
                    "7360: Ningi - Bribie Island State School",
                    "7361: Woorim - Bribie Island High",
                    "7362: Sandstone Pt - Bribie Island High",
                    "7363: Sandstone Pt - Bribie Island High",
                    "7364: Pinelands, Sandstone Pt - Bribie High",
                    "7365: Sandstone Pt - Bribie Island State School",
                    "7366: Ningi - Bribie Island State School",
                    "7367: Banksia Beach - Bribie Island High",
                    "7368: Banksia Beach - Bribie High School",
                    "7369: White Patch, Banksia Beach - Bribie High",
                    "7370: Bribie Island High - Sandstone Pt, Ningi",
                    "7371: Bellara - Bribie High School",
                    "7372: Bribie High School - Banksia Beach",
                    "7373: Bribie Lakes - Bribie High",
                    "7374: Bribie High - Sandstone Point",
                    "8001: Mt Cotton, Victoria Point, Rochedale",
                    "8003: Mt Cotton, Mackenzie, Loreto College",
                    "8004: Mt Cotton, Capalaba, Mackenzie, Mt Gravatt",
                    "8005: Rochedale - Mansfield SHS",
                    "8010: Mansfield, Loreto, Villanova, Cannon Hill",
                    "8012: Carindale, Cannon Hill",
                    "8013: Rochedale, Coorparoo, Cannon Hill",
                    "8014: Wellers Hill, Holland Park, Cannon Hill",
                    "8015: Sunnybank, Mt Gravatt, Carindale, Moreton Bay Coll",
                    "8016: Salisbury, Wellers Hill, East Brisbane",
                    "8017: Mt Gravatt, Carindale, Cannon Hill",
                    "8018: Wellers Hill, Carindale, Cannon Hill",
                    "8019: Eight Mile Plains, Tarragindi, Coopooroo",
                    "8022: Carindale, Morningside, MBC, MBBC",
                    "8024: Kuraby, Rochedale, Underwood, JPC, Mable Park",
                    "8025: Mt Gravatt, Springwood, Rochedale",
                    "8026: Rochedale South, Sunnybank, John Paul College",
                    "8027: Mable Park - Logan Central, Shailer Park, JPC",
                    "8028: Runcorn, Algester, John Paul College",
                    "8029: Runcorn, Stretton, Calamvale, Redeemer, Rochedale",
                    "8030: Mackenzie, Carindale,Mt Gravatt, John Paul College",
                    "8031: Carindale, Mansfield, Redeemer, Rochedale",
                    "8033: Runcorn, Eight Mile Plains, Rochedale",
                    "8038: Alexandra Hills, Capalaba, Mackenzie",
                    "S700: Fig Tree Pocket - Indooroopilly",
                    "S701: Seventeen Mile Rocks - Corinda High",
                    "S702: Milpera State High - Yeerongpilly station",
                    "S703: Kenmore High - Sumner Park",
                    "S704: St Peters Lutheran - Moggill",
                    "S706: Indooroopilly - Kenmore High",
                    "S709: Kenmore High - Indooroopilly",
                    "S710: Toowong Primary - Indooroopilly",
                    "S713: Kenmore - Mandalay",
                    "S714: Taringa - Indooroopilly State School",
                    "S715: Indooroopilly High - Indooroopilly",
                    "S716: Indooroopilly - Duke St",
                    "S718: St Peters Lutheran - Russell & Moggill Rds",
                    "S722: St Peters Lutheran - Mandalay",
                    "S725: Kenmore High - Indooroopilly",
                    "S726: St Lucia - Qld Academy of Maths,Science and Tech",
                    "S730: Kenmore High - Fig Tree Pocket",
                    "S731: Centenary Pool - Indooroopilly",
                    "S732: Gregory Tce - Indooroopilly",
                    "S733: Gregory Tce - Brookfield",
                    "S734: Centenary Pool - Fig Tree Pocket",
                    "S735: Wickham Tce - Indooroopilly",
                    "S736: Wickham Tce - Kailua St",
                    "S739: Gregory Tce - Royal Pde",
                    "S740: Waterworks Rd - Centenary Pool",
                    "S742: The Gap State High - Brookside",
                    "S744: QASMT - Roma Street",
                    "S746: Kelvin Grove - City",
                    "S747: Kelvin Grove - Brookside",
                    "S750: Gap Village - Hilder Rd",
                    "S758: Corinda High - Inala",
                    "S759: Glenala State High - Inala Plaza",
                    "S760: Ashgrove - Brookside",
                    "S762: Corinda High, Corinda Primary, Forest Lake",
                    "S766: St Josephs - Inala",
                    "S767: The Gap High School - Upper Kedron",
                    "S768: Corinda High - Inala",
                    "S769: Corinda High - Inala",
                    "S770: Corinda High - Forest Lake",
                    "S771: Brisbane Boys College - Enoggera",
                    "S772: St Ignatius - Riverhills West",
                    "S773: Marist Brothers College - Ashgrove Ave",
                    "S774: Everton Park - Brookside",
                    "S775: Bardon - Kelvin Grove High",
                    "S776: Jindalee State School - Windermere",
                    "S777: Pallara - Forest Lake High",
                    "S778: Forest Lake College - Inala",
                    "S779: Forest Lake High - Richlands station",
                    "S780: Centenary High - Centenary Village",
                    "S781: Centenary High - Sumner Park",
                    "S782: Corinda - Sumner Park",
                    "S783: St Finbarrs - Enoggera",
                    "S784: Marist College - Payne Rd",
                    "S785: Mt St Michaels - Enoggera",
                    "S786: Bardon - The Gap High",
                    "S787: Ashgrove - The Gap",
                    "S788: Gap State School - City",
                    "S789: Inala - Corinda Primary",
                    "S790: Corinda High - Inala Plaza",
                    "S791: Corinda High - Inala Plaza - Forest Lake",
                    "S792: Richlands - Corinda Primary",
                    "S793: Richlands - St Josephs - Corinda schools",
                    "S794: Richlands - St Josephs - Corinda schools",
                    "S795: Corinda High - Corinda station",
                    "S797: Richlands - Corinda Primary",
                    "S798: Marist Brothers - Indooroopilly",
                    "S799: Brisbane Boys College - Chermside"
                ],
                "stops": {
                    "3002: Reedy Creek - Miami High": [
                        "Old Coach Rd near Bridgman Dr",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Cassia Dr near Mattocks Dr hail 'n' ride",
                        "Coolibah Cr near Willow St",
                        "Brier Cr near Ficus St hail 'n' ride",
                        "Brier Cr near Hedge Row hail 'n' ride",
                        "Willow St near Eucalyptus Ave",
                        "Mattocks Rd near Bushtree Ct",
                        "Treeview Dr near Redleaf Ct",
                        "Treeview Dr near Oakland Ct",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Treetop Court",
                        "Mattocks Rd at Bluemoon Cl",
                        "Christine Ave at Bermuda Street",
                        "Christine Ave at Caningeraba State School",
                        "Whistler Dr near Caningeraba State School",
                        "Auk Ave at Dunlin Drive",
                        "Dunlin Dr near Razorbill St",
                        "Dunlin Dr at Courser Court",
                        "Christine Ave at Hillstar Avenue",
                        "Christine Ave at Spoonbill Court",
                        "Christine Ave at Hibiscus Haven",
                        "GC Hwy at Miami State High School CLOSED PERMANENTLY"
                    ],
                    "3003: Scenic Dr Bus Shelter - All Saints": [
                        "Simpson Dr near Scenic Dr",
                        "Simpson Dr Bus Shelter",
                        "Scenic Dr near Bilinga Cct",
                        "Scenic Dr near Warringa Dr",
                        "Scenic Dr at Panorama Shops",
                        "Gollan Dr near The Lakes Dr",
                        "Gollan Dr near Inlet Dr",
                        "Kennedy Dr near Limosa Rd",
                        "Kennedy Dr near Gray St",
                        "Kennedy Dr near Rose St",
                        "Kennedy Dr near Ducat St",
                        "Ducat St near Parkes Dr",
                        "Ducat St near Caloola Dr",
                        "Mugga Way near The Quarterdeck",
                        "Quarterdeck opp The Anchorage",
                        "Norman St near Stanley Rd",
                        "Wharf St near Monastery Lane",
                        "Wharf St opp Tweed Bowls",
                        "Wharf St at Tweed Heads",
                        "Twin Towns Services Club",
                        "Griffith St at Coolangatta East",
                        "Coolangatta Central",
                        "Marine Pde at Kirra Beach",
                        "Marine Pde at Kirra Beach Hotel",
                        "Musgrave St at Kirra shops",
                        "Musgrave St at Coyne Street",
                        "Golden Four Dr at North Kirra Beach",
                        "Johnston Street",
                        "Golden Four Dr at George Street",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Shell Street",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Old Coach Rd near Bridgman Dr",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gemvale Rd at Kings Christian College",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Somerset Dr",
                        "Somerset College",
                        "Somerset Dr near Gemvale Rd",
                        "All Saints Anglican School"
                    ],
                    "3004: Bourton Rd - Mudgeraba Primary": [
                        "Bourton Rd near Willunga Pl",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "Ghilgai Rd near Entry Dr",
                        "Ghilgai Rd near Griffon St",
                        "Highfield Dr near Cabot Ct",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Breakwater Road",
                        "Robina State High School",
                        "Old Coach Rd at Mudgeeraba State School"
                    ],
                    "3005: Currumbin Creek Rd - Merrimac Primary": [
                        "Currumbin Creek Rd near Bienvenue Dr",
                        "Galleon Way at Tierney Drive",
                        "Galleon Way at Jutland Place",
                        "Galleon Way near Casey Cl",
                        "Galleon Way near Brigantine Ct",
                        "Galleon Way at Billabong Court",
                        "Galleon Way at Ware Drive",
                        "Galleon Way near Tate Ct",
                        "Murtha Dr near Foothill St",
                        "Murtha Dr at Swanbourne Way",
                        "Murtha Dr near Dongarra Cl",
                        "Murtha Dr at KP McGrath Drive",
                        "KP McGrath Dr near Murtha Dr",
                        "KP McGrath Dr near Seaview Pde",
                        "Avocado St near Doubleview Dr",
                        "Ironbark St near Avocado St",
                        "Ironbark St near Kaffia Ct",
                        "Ironbark St near Angelica St",
                        "Nineteenth Ave near Chesnut St",
                        "Nineteenth Ave near Melaleuca Dr",
                        "Melaleuca Dr near Kingfish Ct hail 'n' ride",
                        "Mallawa Dr near Tallebudgera Dr hail 'n' ride",
                        "Mallawa Dr near Abella St hail 'n' ride",
                        "Mallawa Dr near Nineteenth Av hail 'n' ride",
                        "Townson Ave near Gulai St hail 'n' ride",
                        "Townson Ave near Nineteenth Ave",
                        "Townson Ave near Twentyfourth Ave",
                        "Townson Ave near Tallebudgera Dr",
                        "Tallebudgera Dr near Tarni Ave",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Burleigh Heads National Park",
                        "Tweed St at George St",
                        "Burleigh Heads station",
                        "West Burleigh Rd at Stanley Street",
                        "West Burleigh Rd at George Street West",
                        "West Burleigh Rd at Dunlin Drive",
                        "FUTURE Treetops Plaza stop WESTBOUND",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gemvale Rd at Kings Christian College",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Somerset Dr",
                        "Somerset Dr at Clover Hill Drive",
                        "Somerset College",
                        "Somerset Dr at Somerset College",
                        "Somerset Dr near Bonogin Rd hail 'n' ride",
                        "Franklin Dr near McLachlan Ave hail 'n' ride",
                        "Old Coach Rd at Wallandra Road",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Tallai Rd Bus Shelter HnR",
                        "Mudgeeraba Rd near Scullin St",
                        "Mudgeeraba Rd near Piallingo St hail 'n' ride",
                        "Highfield Dr near Breakwater Rd",
                        "Highfield Dr near Outriggers Drive Reserve",
                        "All Saints Anglican School",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Cabot Ct",
                        "Bourton Rd near Willunga Pl",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "Gooding Dr at Bourton Road",
                        "Jondique Ave at Saint Michaels College",
                        "Gooding Dr at Jondique Avenue",
                        "Merrimac State Primary School"
                    ],
                    "3006: Tweed Heads - Marymount via Townson Ave": [
                        "Wharf St at Tweed Heads",
                        "Twin Towns Services Club",
                        "Griffith St at Coolangatta East",
                        "Coolangatta Central",
                        "Marine Pde at Kirra Beach",
                        "Marine Pde at Kirra Beach Hotel",
                        "Musgrave St at Kirra shops",
                        "Musgrave St at Coyne Street",
                        "Golden Four Dr at North Kirra Beach",
                        "Johnston Street",
                        "Golden Four Dr at George Street",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Shell Street",
                        "Toolona St near Atkin St",
                        "Taperell Dr near Wickham Cr hail 'n' ride",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Teemangum St at Kropp Park",
                        "Currumbin Wildlife Sanctuary",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Gold Coast Hwy at Thrower Drive",
                        "Townson Ave near Kalang St hail 'n' ride",
                        "Townson Ave near Gulai St hail 'n' ride",
                        "Townson Ave near Nineteenth Ave",
                        "Townson Ave near Twentyfourth Ave",
                        "Townson Ave near Tallebudgera Dr",
                        "Tallebudgera Dr near Tarni Ave",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Burleigh Heads National Park",
                        "Tweed St at George St",
                        "Burleigh Heads station",
                        "West Burleigh Rd at Stanley Street",
                        "West Burleigh Rd at George Street West",
                        "Marymount College"
                    ],
                    "3007: Ourimbah Rd - Elanora High": [
                        "Ourimbah Rd",
                        "Miles St near Coolangatta Rd hail 'n' ride",
                        "Coolangatta Rd near Ocean St hail 'n' ride",
                        "Coolangatta Rd at Kirribin Street",
                        "Coolangatta Rd near Loongana Ave",
                        "Coolangatta Rd near Kiewa Ave",
                        "Boyd St near Morshead St",
                        "Monash St near Foch St hail 'n' ride",
                        "Cabarita Ave near Nangana St hail 'n' ride",
                        "Cabarita Ave near Mirreen Dr",
                        "Mireen Dr near Yolanta Dr hail 'n' ride",
                        "Yolanta Dr near Mirreen Dr hail 'n' ride",
                        "Taperell Dr near Wickham Cr",
                        "Toolona St near Durran St",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Gold Coast Hwy at Thrower Drive",
                        "Thrower Dr near Luzon Pde",
                        "Palm Beach Currumbin High School",
                        "Palm Beach Currumbin State High School",
                        "Elanora State Primary School hail 'n' ride",
                        "KP McGrath Dr at Elanora State School",
                        "Murtha Dr at Boya Court",
                        "Murtha Dr at Dongarra Close",
                        "Murtha Dr at Swanbourne Way",
                        "Murtha Dr at Myco Court",
                        "Galleon Way at St Augustines School",
                        "Galleon Way at Billabong Court",
                        "Galleon Way at Ware Drive",
                        "Galleon Way near Tate Ct",
                        "Doubleview Dr at Attadale Court",
                        "Doubleview Dr at Swanbourne Way",
                        "Avocado St near Doubleview Dr",
                        "Nineteenth Ave at Elanora High School"
                    ],
                    "3008: Elanora High - Elanora Primary": [
                        "Nineteenth Ave at Elanora High School",
                        "Nineteenth Ave at Kalmia Court",
                        "Casuarina Dr at Ottelia Drive",
                        "Casuarina Dr at Silver Glade Drive",
                        "Silver Glade Dr at Laurina Court",
                        "Silver Glade Dr at Typha Place",
                        "Casuarina Dr near Silver Glade Dr",
                        "Casuarina Dr near Ottelia Dr",
                        "Saffron St at Maranta Street",
                        "Saffron St near Amadeus St",
                        "Hop St at Avocado Street",
                        "Ironbark St at Angelica Street",
                        "Ironbark St near Daisy St",
                        "Ironbark St at Boab Street",
                        "Avocado St at Jarrahdale Dr",
                        "KP McGrath Dr at Seaview Parade",
                        "KP McGrath Dr at Murtha Drive",
                        "Elanora State Primary School hail 'n' ride"
                    ],
                    "3009: Ourimbah Rd - Currumbin Primary": [
                        "Pearl St at Kingscliff Shopping Mall",
                        "Kingscliff St near Zephyr St",
                        "Kingscliff St near Pacific St",
                        "Kingscliff St near Surf St",
                        "Kingscliff St near Shell St",
                        "Wommin Bay Rd near Sand St",
                        "Wommin Bay Rd App Phillip St",
                        "Chinderah - Jenners Corner",
                        "Chinderah Bay Dr near Waugh St",
                        "Waugh St near Chinderah Bay Dr",
                        "Minjungbal Dr at Tweed Hub",
                        "Minjungbal Dr at Tweed City Shopping Centre",
                        "Minjungbal Dr opp South Tweed Heads Coach Stop",
                        "Minjungbal Dr near Lloyd St",
                        "Minjungbal Dr near Dry Dock Rd",
                        "Kennedy Dr at Kennedy Plaza",
                        "Ducat St near Meridian Way",
                        "Ducat St near Parkes Dr",
                        "Ducat St near Caloola Dr",
                        "Miles St near Kirra Park",
                        "Golden Four Dr at North Kirra Beach",
                        "Johnston Street",
                        "Golden Four Dr at George Street",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Shell Street",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Teemangum St at Kropp Park",
                        "Currumbin Wildlife Sanctuary",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Palm Beach Currumbin State High School",
                        "The Pines Shopping Centre, stop B",
                        "Elanora State Primary School hail 'n' ride",
                        "Nineteenth Ave at Elanora High School",
                        "Ironbark St near Avocado St",
                        "Ironbark St near Kaffia Ct",
                        "Ironbark St near Angelica St",
                        "Nineteenth Ave near Chesnut St",
                        "Nineteenth Ave near Melaleuca Dr",
                        "Nineteenth Ave near Townson Ave",
                        "Nineteenth Av at Palm Beach Primary School",
                        "Gold Coast Hwy at Twenty First Avenue",
                        "Gold Coast Hwy at Twenty Fifth Avenue",
                        "Twenty Seventh Avenue",
                        "Nineteenth Avenue",
                        "Gold Coast Hwy at Fifteenth Avenue",
                        "Gold Coast Hwy at Thirteenth Avenue",
                        "Gold Coast Hwy at Eighth Avenue",
                        "Palm Beach",
                        "Gold Coast Hwy at Palm Beach Police Station",
                        "Thrower Dr near Luzon Pde",
                        "Currumbin State Primary School"
                    ],
                    "3010: Tweed Heads - Tallebudgera Primary": [
                        "Wharf St opp Tweed Bowls",
                        "Wharf St at Tweed Heads",
                        "Twin Towns Services Club",
                        "Griffith St at Coolangatta East",
                        "Coolangatta Central",
                        "Marine Pde at Kirra Beach",
                        "Marine Pde at Kirra Beach Hotel",
                        "Musgrave St at Kirra shops",
                        "Musgrave St at Coyne Street",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Gold Coast Hwy at Thrower Drive",
                        "Thrower Dr near Luzon Pde",
                        "Palm Beach Currumbin High School",
                        "Palm Beach Currumbin State High School",
                        "Thrower Dr near Sarawak Dr",
                        "Currumbin State Primary School",
                        "Currumbin Creek Rd at Currumbin RSL",
                        "Currumbin Creek Rd at Love Street",
                        "Currumbin Creek Rd near Teatree Ave",
                        "Currumbin Creek Rd near Villiers Dr",
                        "Currumbin Creek Rd near Bienvenue Dr",
                        "Clives Cct at Hoffschildt Drive",
                        "Clives Cct near Robinson Pl",
                        "Clives Cct near Bernoth St",
                        "Bienvenue Dr near Border Dr",
                        "Cannon Dr near The Cross Rd",
                        "Galleon Way at Tierney Drive",
                        "Galleon Way at Jutland Place",
                        "Galleon Way near Casey Cl",
                        "Galleon Way near Brigantine Ct",
                        "Galleon Way at Billabong Court",
                        "Galleon Way at Ware Drive",
                        "Ware Dr at Hillier St",
                        "Ware Dr near Aethalia St",
                        "Galleon Way near Tate Ct",
                        "Guineas Creek Rd at Riverside Drive",
                        "Sarawak Ave at Salk Oval",
                        "Elanora State Primary School hail 'n' ride",
                        "KP McGrath Dr at Elanora State School",
                        "KP McGrath Dr near Murtha Dr",
                        "KP McGrath Dr near Seaview Pde",
                        "Avocado St near Doubleview Dr",
                        "Nineteenth Ave at Elanora High School",
                        "Nineteenth Ave at Kalmia Court",
                        "Tallebudgera Primary School"
                    ],
                    "3011: Simpsons Rd - Marymount via Elanora & Tallebudger": [
                        "Westminster Bvd near Cornwall Dr hail 'n' ride",
                        "Cornwall Dr near Cheshire Gr hail 'n' ride",
                        "Simspons Rd near Cornwall Dr hail 'n' ride",
                        "Doubleview Dr at Attadale Court",
                        "Doubleview Dr at Swanbourne Way",
                        "Avocado St near Doubleview Dr",
                        "Nineteenth Ave at Elanora High School",
                        "Nineteenth Ave at Kalmia Court",
                        "Valley Dr near Green Lane hail 'n' ride",
                        "Dudgeon Dr near Jersey Ct hail 'n' ride",
                        "Tallebudgera Connection Rd near Andrews Rd HnR",
                        "St Andrews College",
                        "Tallebudgera Creek Rd at Tsipura Drive",
                        "Marymount College"
                    ],
                    "3012: Nerang Rail - Keebra": [
                        "Nerang station, stop E",
                        "Keebra Park State High School"
                    ],
                    "3013: The Observatory - Robina High": [
                        "Observatory Dr near Barden Ridge Rd hail 'n' ride",
                        "Observatory Dr near Southern Skies Dr",
                        "Observatory Dr near Golden Grove Bvd",
                        "Observatory Dr near Grove Creek Cl",
                        "Wyllie Way at Gordonia Dr",
                        "Kingsmore Bvd near Tuckeroo Pl",
                        "Old Coach Rd near Bridgman Dr",
                        "Bridgman Dr near Old Coach Rd",
                        "Bridgman Dr near Heulan Ct",
                        "Bridgman Dr near Royston Cr",
                        "Bridgman Dr near Woodland Dr",
                        "Woodland Dr near Navars St",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Mattocks Rd at Viburnum Street",
                        "Mattocks Rd near Bushtree Ct",
                        "Mattocks Rd at Bluemoon Cl",
                        "Christine Ave at Silvabank Drive",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Regensberg Close",
                        "Varsity College Junior Campus",
                        "Christine Ave at Varsity College",
                        "Christine Ave at Varsity Sound Avenue",
                        "Varsity Pde near University Dr",
                        "Varsity Pde at Lakefront Crescent",
                        "Varsity Pde at Varsity Lakes College",
                        "University Dr near Shore Ave",
                        "University Dr near Varsity Pde",
                        "Christine Ave at Konda Way",
                        "Christine Ave at Goldwater Drive",
                        "Christine Ave near Scottsdale Dr hail 'n' ride",
                        "Christine Ave at Scottsdale Drive",
                        "Christine Ave at The Crestway",
                        "Robina State High School"
                    ],
                    "3014: McAuley Pde - Pacific Pines High": [
                        "McAuley Pde near Matthews Dr",
                        "McAuley Pde near Shoalhaven Ave hail 'n' ride",
                        "McAuley Pde near Diamantina Cct",
                        "Harmsworth Rd near Wunburra Ccl",
                        "Santa Isobel Bvd near Chatham Ave",
                        "Pacific Pines High School"
                    ],
                    "3015: The Observatory - Mudgeeraba Creek Primary": [
                        "Observatory Dr near Palomar St",
                        "Observatory Dr near Barden Ridge Rd hail 'n' ride",
                        "Observatory Dr near Southern Skies Dr",
                        "Observatory Dr near Golden Grove Bvd",
                        "Observatory Dr near Grove Creek Cl",
                        "Wyllie Way at Gordonia Dr",
                        "Kingsmore Bvd near Tuckeroo Pl",
                        "Old Coach Rd near Bridgman Dr",
                        "Bridgman Dr near Old Coach Rd",
                        "Bridgman Dr near Heulan Ct",
                        "Bridgman Dr near Royston Cr",
                        "Bridgman Dr near Woodland Dr",
                        "Woodland Dr near Navars St",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gemvale Rd at Kings Christian College",
                        "Langport Prd near Wiltshire Dr hail 'n' ride",
                        "Glastonbury Dr near Langport Pde hail 'n' ride",
                        "Glastonbury Dr near Exercise St hail 'n' ride",
                        "Gemvale Rd near Somerset Dr",
                        "Somerset Dr near Gemvale Rd",
                        "Leviathan Dr near Victory Dr hail 'n' ride",
                        "Swanton Dr near Chute St",
                        "Swanton Dr near Springsure Dr",
                        "Swanton Dr near Somerset Dr",
                        "Clover Hill Primary School",
                        "Somerset Dr at Somerset College",
                        "Somerset Dr near Bonogin Rd hail 'n' ride",
                        "Franklin Dr near McLachlan Ave hail 'n' ride",
                        "Gold Coast Springbrook Rd near Hardys Rd HnR",
                        "Berrigans Rd near Wallandra Dr hail 'n' ride",
                        "Wallandra Rd near Baileys Rd hail 'n' ride",
                        "Wallandra Rd near Bendigo Ct hail 'n' ride",
                        "Old Coach Rd at Wallandra Road",
                        "Rainbow Dr near Venus Ct hail 'n' ride",
                        "Rainbow Dr at Universe Court",
                        "Milky Way near Moonbeam Pde hail 'n' ride",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Mudgeeraba Creek Primary School"
                    ],
                    "3016: Oxenford - Helensvale High": [
                        "Oxenford State School",
                        "Helensvale State High School"
                    ],
                    "3017: Numinbah Valley - Gilston": [
                        "Nerang Murwillumbah Rd at Bochow Park HnR",
                        "Numinbah Valley School of Arts",
                        "Nerang Murwillumbah Rd near Pocket Rd HnR",
                        "Nerang Murwillumbah Rd near Springbrook Rd HnR",
                        "Nerang Murwillumbah Rd at Numinbah Valley HnR",
                        "Nerang Murwillumbah Rd near Narrow Leaf Rd HnR",
                        "Nerang Murwillumbah Rd near Tangara Rd HnR",
                        "Latimers Crossing Rd near Gilston Rd hail 'n' ride",
                        "Gilston Rd at Longhill Road",
                        "Gilston Rd at Worley Drive",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "Gilston Rd near Alexander Dr hail 'n' ride",
                        "McLaren Rd near Winchester Dr",
                        "McLaren Rd near Oakdale Ave",
                        "McLaren Rd at Beltana Way",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Price St at Earle Plaza",
                        "Southport Nerang Rd at Nerang interchange",
                        "Beaudesert Nerang Rd at Billabirra Crescent",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Yarrimbah Dr near Goora St hail 'n' ride",
                        "Yarraowee Drive near McLaren Rd",
                        "Yarrimbah Dr near McLaren Rd hail 'n' ride",
                        "Dugandan St at Burra Street",
                        "Dugandan St near Koola Dr hail 'n' ride",
                        "Dugandan St at Teasdale Drive",
                        "Dugandan St at Bent Street",
                        "Dugandan St at Merloo Drive",
                        "Beaudesert Nerang Rd at Oak Street",
                        "Nerang St at Nerang State School",
                        "Price St at Nerang State School",
                        "Nerang High School",
                        "Gilston Rd near Peter Mills Dr hail 'n' ride",
                        "Peter Mills Dr near Honey Eater Ct hail 'n' ride",
                        "Peter Mills Dr near Swagman Rd hail 'n' ride",
                        "Gilston State School"
                    ],
                    "3018: Canugra, Mt Nathan, Nerang Int, Benowa, Surfers": [
                        "Kidston St at DJ Smith Park hail 'n' ride",
                        "Barcoo Ct near Clagiraba Rd hail 'n' ride",
                        "Barcoo Ct at Diamantina Ct hail 'n' ride",
                        "Beaudesert Nerang Rd near Henri Robert Dr HnR",
                        "The Oval Dr near Beaudesert Nerang Rd HnR",
                        "Beaudesert Nerang Rd near Maudsland Rd hail 'n' ride",
                        "Beaudesert Nerang Rd near Arunta Dr hail 'n' ride",
                        "Beaudesert Nerang Rd at Oak Street",
                        "Price St at Earle Plaza",
                        "Price St at Nerang State School",
                        "Southport Nerang Rd at Nerang interchange",
                        "City of Gold Coast, Nerang",
                        "Southport Nerang Rd at Parkridge Drive",
                        "Southport Nerang Rd at Central Park Plaza",
                        "Southport Nerang Rd at BP Central Park",
                        "Trinity Lutheran College",
                        "Ashmore Rd at Reed Street",
                        "Ashmore Rd at Boree Street",
                        "Ashmore Rd near Tambourah Dr hail 'n' ride",
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Benowa Rd at Benowa Gardens",
                        "Ashmore Rd near Benowa Rd hail 'n' ride",
                        "Ashmore Rd at Sir Bruce Small Park",
                        "Ashmore Road Commercial Precinct",
                        "Ashmore Rd at Campbell Street",
                        "Surfers Paradise Primary School"
                    ],
                    "3019: Mudgeeraba, Robina Waters - Aquinas via Ferry Rd": [
                        "Mudgeeraba Rd near Quambone St",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Mudgeeraba Rd near Scullin St",
                        "Cheltenham Dr at Woody Views Way",
                        "Cheltenham Dr near Glenside Dr",
                        "Tullamarine Dr near Glen Iris Pl",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Camberwell Cct near Caulfield Street",
                        "Camberwell Cct near Kensington St",
                        "Yarraville St at Camberwell Circuit",
                        "Yarraville St near Bentleigh Ct",
                        "Markeri St at Ron Penhaligon Way",
                        "Fairway Dr near Santa Cruz Bvd hail 'n' ride",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Bermuda St at Hooker Boulevard",
                        "Bermuda St at Sophie Ave",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Bundall Rd at Pisa Court",
                        "Bundall Rd at City of Gold Coast",
                        "Ferry Rd at Southport Golf Club",
                        "Ferry Rd at York Street",
                        "Ferry Rd at The Southport School",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Southport Medical Precinct",
                        "St Hilda's School",
                        "Nerang St at West End Shops",
                        "Nerang St at Falconer Street",
                        "Aquinas Catholic College",
                        "Guardian Angels Catholic Primary"
                    ],
                    "3020: Oxley Dr - Helensvale": [
                        "Oxley Dr at Paradise Lake Resort",
                        "Oxley Dr at Crystal Reef Drive",
                        "Oxley Dr at Hansford Road",
                        "Oxley Dr at Coombabah State Primary School",
                        "Oxley Dr at Daisy Elms Park",
                        "Oxley Dr at Blaxland Avenue",
                        "Crescent Ave near Broadwater Ave hail 'n' ride",
                        "Bert Hood St near Boykambil Esp hail 'n' ride",
                        "Boykambil Esp near Shoe St hail 'n' ride",
                        "Shoe St near Coombe Ave hail 'n' ride",
                        "Broadwater Ave at Crescent Avenue",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Boykambil Esp near Sheehan Ave hail 'n' ride",
                        "Nelson Ave near Dunnes Ave hail 'n' ride",
                        "Cova Bvd at Hope Island Rd",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Masthead Way at Sanctuary Cove",
                        "Santa Barbara Rd near Chindrina St",
                        "Pinnaroo St near Mungala St",
                        "Akoonah St near Mungala St",
                        "Buddeh St near Santa Barbara Rd",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Hope Island Rd near Magnolia Dr hail 'n' ride",
                        "Monterey Keys Dr at Creekwood Place",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Helensvale Rd at Dalley Park Dr",
                        "Audrey Ave near Dalley Park Dr hail 'n' ride",
                        "Audrey Ave near Calmwater Ct hail 'n' ride",
                        "Helensvale Rd at Calmwater Crescent",
                        "Helensvale Road at Dalley Park Drive",
                        "Helensvale State High School",
                        "Discovery Dr at Kingaroy Avenue",
                        "Discovery Dr at Ashford Road",
                        "Helensvale Primary School"
                    ],
                    "3021: Maudsland - Coomera Primary": [
                        "Arunta Dr near Mount Nathan Rd hail 'n' ride",
                        "Arunta Dr near Pemberton Cl hail 'n' ride",
                        "Clagiraba Rd near Barcoo Ct hail 'n' ride",
                        "Clagiraba Rd near Thendara Dr hail 'n' ride",
                        "Beaudesert Nerang Rd near Canungra Ct HnR",
                        "Beaudesert Nerang Rd near Henri Robert Dr HnR",
                        "Beaudesert Nerang Rd near Riverglen Ct HnR",
                        "Beaudesert Nerang Rd near Darwalla Rd HnR",
                        "Beaudesert Nerang Rd near Crystal Springs Ct HnR",
                        "The Oval Dr near Beaudesert Nerang Rd HnR",
                        "Maudsland Rd near Beaudesert-Nerang Rd HnR",
                        "Maudsland Rd near Guanaba Creek Rd hail 'n' ride",
                        "Maudsland Rd near Birds Rd hail 'n' ride",
                        "Holyrood Rd near Maudsland Rd hail 'n' ride",
                        "Maudsland Rd near Riverstone Rd hail 'n' ride",
                        "Lagoon Park Dr near Meadow Ct hail 'n' ride",
                        "Lagoon Park Dr near Summer Hill Cr hail 'n' ride",
                        "Greenacre Way near Lagoon Park Dr hail 'n' ride",
                        "Riverstone Crsg near Rivermill Tce hail 'n' ride",
                        "Riverstone Crsg near Northern Skies Tce HnR",
                        "Riverstone Crsg near Valley Brook Rise HnR",
                        "Riverstone Crsg near Hibiscus Cr hail 'n' ride",
                        "Riverstone Crsg near Prairie Av hail 'n' ride",
                        "Riverstone Crsg near Mountain View Pde HnR",
                        "Rivermill Tce near Plantation Cr hail 'n' ride",
                        "Rivermill Tce near Settlers Ave hail 'n' ride",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Maudsland Rd near Cobb And Co Dr hail 'n' ride",
                        "Cobb and Co Dr near Appollo Pl",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Gaven Arterial Rd near Yallaroi Rd hail 'n' ride",
                        "California Dr near Queens Park Cct hail 'n' ride",
                        "California Dr near Oregon Way",
                        "Oxenford State School",
                        "Michigan Dr near Swindon Pl",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Regatta Ave near Essen Pl",
                        "Leo Graham Way near Cottonwood Pl",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Heathwood Dr near Koala Town Rd",
                        "Reserve Rd at Dreamtime Zone",
                        "Saint Stephens College",
                        "Reserve Road at Hargraves Rd",
                        "Upper Coomera College",
                        "Billinghurst Cr near Jessica Dr",
                        "Billinghurst Cr near Godden Dr",
                        "Billinghurst Cr near Turnbull Dr",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Assisi Catholic College",
                        "Williamson Rd near Billinghurst Cr",
                        "Beattie Rd at Coomera Primary School"
                    ],
                    "3022: Gilston - Miami via Cararra & Merrimac": [
                        "Gilston State School",
                        "Worongary Rd near Glenrowan Rd hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Harry Mills Dr near Charland Ct hail 'n' ride",
                        "Vince Hinde Dr near Harry Mills Dr hail 'n' ride",
                        "Worongary Rd near Random Way hail 'n' ride",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Rainbow Dr at Universe Court",
                        "Cobai Dr at Chippewa Circuit",
                        "Wallandra Rd near Marcus Way hail 'n' ride",
                        "Wallandra Rd near Tuena St hail 'n' ride",
                        "Old Coach Rd at Tallai Rd Bus Shelter HnR",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Mudgeeraba Rd near Quambone St",
                        "Quambone St near Jeremy Ct hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Alkira Way near Kabra Ct hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near Kurilpa St hail 'n' ride",
                        "Hinkler Dr near Explorers Way",
                        "Pappas Way near Dawnann Ct",
                        "Pappas Way near Remount Pl",
                        "Pappas Way near Cambridge Ct",
                        "Pappas Way near Dearne Pl",
                        "Murev Way near Alzino Pl",
                        "Michelmore Rd near Woolmere St",
                        "Michelmore Rd near Hickey Way",
                        "Nielsens Rd at Hickey Way",
                        "Birmingham Rd near The Boulevard",
                        "Riverside Home Caravan Park",
                        "Nerang Broadbeach Rd at Garden Grove",
                        "Nerang Broadbeach Rd at Nielsens Road",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Dunlop Ct at Merrimac State High School",
                        "Rio Vista Bvd near Dunlop Ct",
                        "Barrier Reef Dr near Wild Duck Dr",
                        "Barrier Reef Dr near Normanby St",
                        "Barrier Reef Dr near Hayman Ct",
                        "Barrier Reef Dr near Peninsula Ct",
                        "Barrier Reef Dr near Deloraine Ct",
                        "Rio Vista Bvd near Pilot Ct",
                        "Rio Vista Bvd near Compass Ct",
                        "Rio Vista Bvd near Cottesloe Dr",
                        "Oceanic Dr near Bowline Rd"
                    ],
                    "3023: Riverstone - Helensvale High": [
                        "Lagoon Park Dr near Meadow Ct hail 'n' ride",
                        "Lagoon Park Dr near Summer Hill Cr hail 'n' ride",
                        "Greenacre Way near Lagoon Park Dr hail 'n' ride",
                        "Riverstone Crsg near Rivermill Tce hail 'n' ride",
                        "Riverstone Crsg near Northern Skies Tce HnR",
                        "Riverstone Crsg near Valley Brook Rise HnR",
                        "Riverstone Crsg near Hibiscus Cr hail 'n' ride",
                        "Riverstone Crsg near Prairie Av hail 'n' ride",
                        "Riverstone Crsg near Mountain View Pde HnR",
                        "Rivermill Tce near Plantation Cr hail 'n' ride",
                        "Rivermill Tce near Settlers Ave hail 'n' ride",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Cobb and Co Dr near Appollo Pl",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Gaven Arterial Rd near Yallaroi Rd hail 'n' ride",
                        "Gaven Arterial Rd at Felling Drive",
                        "Greenway Bvd near Keneally St hail 'n' ride",
                        "Greenway Bvd near Brissendon St",
                        "McAuley Pde opp Park Lake Primary hail 'n' ride",
                        "Pitcairn Way near Salvado Dr hail 'n' ride",
                        "Pitcairn Way near Sangster Cr",
                        "Pitcairn Way at Lennox Street",
                        "Pitcairn Way near Belongil St",
                        "Pitcairn Way near Yaldara St",
                        "Pitcairn Way near Easter Cr",
                        "Pacific Pines High School",
                        "Santa Isobel Bvd near Mussau St",
                        "Pacific Pines Bvd near Nandi Tce",
                        "Pacific Pines Bvd near Papara St",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Helensvale Primary School",
                        "Helensvale State High School"
                    ],
                    "3024: Main Beach - Merrimac": [
                        "Tedder Ave near Main Beach Pde hail 'n' ride",
                        "Tedder Ave at Montgomery Avenue",
                        "Tedder Ave at Lennie Avenue",
                        "Tedder Avenue at Cronin Avenue",
                        "Queen St at Garden Street",
                        "Ferry Rd at Minnie Street",
                        "Ferry Rd at Harvest Court",
                        "Benowa Rd near Ferry Rd hail 'n' ride",
                        "Benowa Rd at Drury Avenue",
                        "Benowa Rd at Golden Crescent",
                        "Cotlew St at Tecoma Street",
                        "Cotlew St at Hermitage Close",
                        "Cotlew St at Parkleigh Court",
                        "Hillview Pde near Tangerine Row hail 'n' ride",
                        "Heeb St at The Crescent",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Benowa Rd near Canara St hail 'n' ride",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Benowa Rd at Benowa Gardens",
                        "Dunkeith St near Glyn St hail 'n' ride",
                        "Ashmore Road Commercial Precinct",
                        "Ashmore Rd at Campbell Street",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Bermuda St at Albert Park",
                        "Bermuda St at Rudd Street",
                        "Bermuda St at Hooker Boulevard",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Gooding Dr at Merrimac Golf Course",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Bourton Road",
                        "Bourton Rd near Willunga Pl",
                        "Highfield Dr near Cabot Ct",
                        "All Saints Anglican School",
                        "Hinkler Dr near Explorers Way",
                        "Explorers Way near Nabarlek Dr hail 'n' ride",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Way at Cozens Way",
                        "Explorers Way at Garvie Place",
                        "Alexander Dr near Richard Cr",
                        "Alexander Dr at Kahlua Court",
                        "Bonooroo Park Shopping Centre",
                        "Nielsens Rd at Hickey Way",
                        "Gooding Rd at Cararra Markets",
                        "Dunlop Ct at Merrimac State High School"
                    ],
                    "3025: Guanaba - Pacific Pines": [
                        "Guanaba Creek Rd near Stewart Rd hail 'n' ride",
                        "Coomera Valley Dr near Stewart St hail 'n' ride",
                        "Coomera Valley Dr near Lynwood Dr hail 'n' ride",
                        "Lynwood Dr near Guanaba Creek Rd hail 'n' ride",
                        "Tarata Rd near Guanaba Creek Rd hail 'n' ride",
                        "Link Rd near Tarata Rd hail 'n' ride",
                        "Birds Rd near Link Rd hail 'n' ride",
                        "Birds Rd near Maudsland Rd hail 'n' ride",
                        "Holyrood Rd near Maudsland Rd hail 'n' ride",
                        "Maudsland Rd near Riverstone Rd hail 'n' ride",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Maudsland Rd near Cobb And Co Dr hail 'n' ride",
                        "Cobb and Co Dr near Appollo Pl",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Gaven Arterial Rd near Yallaroi Rd hail 'n' ride",
                        "Michigan Dr near Maple Ct hail 'n' ride",
                        "Oxenford State School",
                        "Oregon Way near Emerson Way",
                        "California Dr near Oregon Way",
                        "California Dr near Riversdale Rd",
                        "California Dr near Nevada Pl",
                        "Entertainment Dr at Movie World",
                        "Helensvale Rd near Siganto Dr hail 'n' ride",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale State High School",
                        "Helensvale Rd near Discovery Dr hail 'n' ride",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Pacific Pines Bvd near Papara St",
                        "Pacific Pines High School",
                        "Binstead Way at Jubilee Primary School"
                    ],
                    "3026: Robina - Varsity Lakes": [
                        "Scottsdale Dr at Christine Avenue",
                        "Laurel Oak Dr near Scottsdale Dr hail 'n' ride",
                        "Laurel Oak Dr near Lancewood Cct hail 'n' ride",
                        "Lancewood Cct near Applegum Ct hail 'n' ride",
                        "Robina Town Centre Drive at Scottsdale Dr",
                        "Robina Town Centre Dr at Eastlake Apartments",
                        "Robina Town Centre Dr at Leabrook Crescent",
                        "Cheltenham Dr near Glenside Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Killarney Ave near Huntingdale Cr",
                        "Killarney Ave at Robina State School",
                        "Glen Eagles Dr near Dundee Ct",
                        "Glen Eagles Dr near Karrinyup Pl",
                        "Glen Eagles Dr near Firestone Ct",
                        "Ron Penhaligon Way at Banff Court",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way near Bothwell St",
                        "Cheltenham Dr near Belmore Cl",
                        "Tullamarine Dr near Glen Iris Pl",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Camberwell Cct near Caulfield Street",
                        "Camberwell Cct near Kensington St",
                        "Yarraville St at Camberwell Circuit",
                        "Yarraville St near Bentleigh Ct",
                        "Ron Penhaligon Way near Markeri St",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Ron Penhaligon Way near Homebush Dr",
                        "Manly Dr near Pipers Pt",
                        "Manly Dr near Sandringham Dr",
                        "Pyrmont St near Cottesloe Dr",
                        "Bond University",
                        "Varsity Pde at Varsity Lakes College"
                    ],
                    "3027: Upper Coomera - Labrador Primary": [
                        "Upper Coomera College",
                        "Brygon Creek Dr near Ascendancy Way",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Reserve Rd near Herbert St",
                        "Stephens St near Macklin Ct hail 'n' ride",
                        "Stephens St near Farrer Ct hail 'n' ride",
                        "Stanfield Dr near Jullian Rd hail 'n' ride",
                        "Moran Dr near Acton Pl hail 'n' ride",
                        "Reserve Rd at Upper Coomera Village",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Michigan Dr near Swindon Pl",
                        "Michigan Dr near Maple Ct hail 'n' ride",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale State High School",
                        "Helensvale State Primary School",
                        "Discovery Dr at Ridgevale Drive",
                        "Helensvale Community Centre",
                        "Gold Coast Hwy at Discovery Drive",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Arundel Dr near Maltravers Dr",
                        "Arundel Dr near Paterson Dr",
                        "Arundel Dr near Arun Dr",
                        "Arundel Dr near Neri Cr",
                        "Napper Rd near Benalla Ct",
                        "Daintree Dr near Highview Pl",
                        "Napper Rd at Daintree Drive",
                        "Greenacre Dr at Parkwood station",
                        "Greenacre Dr at Fairview Ct",
                        "Greenacre Dr at Jamieson Drive",
                        "Uplands Dr at Greenacre Drive",
                        "Uplands Dr at Woodlands Way",
                        "Arundel State Primary School",
                        "Allied Dr at Carnoustie Ct",
                        "Allied Dr near Range Ct",
                        "Central St near Allied Dr",
                        "Central St near Carrumbella Dr",
                        "Olsen Ave at McMillan Street",
                        "Government Rd at Galaxy Court",
                        "Government Rd near Jupiter Cl",
                        "Usher Ave near McMillan St",
                        "Usher Ave at Vona Place",
                        "Usher Ave at Whiting Street",
                        "Imperial Pde near Turpin Rd"
                    ],
                    "3028: Hinkler Dr - Marymount via Mudgeeraba": [
                        "Hinkler Dr near Explorers Way",
                        "Hinkler Dr near San Fernando Dr hail 'n' ride",
                        "Mudgeeraba Rd near Quambone St",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Worongary Rd near Harry Mills Dr hail 'n' ride",
                        "Vince Hinde Dr near Harry Mills Dr hail 'n' ride",
                        "Vince Hinde Dr near Worongary Rd hail 'n' ride",
                        "Worongary Rd near Random Way hail 'n' ride",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Wallandra Road",
                        "Gold Coast Springbrook Rd near Hardys Rd HnR",
                        "Berrigans Rd near Wallandra Dr hail 'n' ride",
                        "Wallandra Rd near Baileys Rd hail 'n' ride",
                        "Wallandra Rd near Bendigo Ct hail 'n' ride",
                        "Cobai Dr near Rainbow Dr hail 'n' ride",
                        "The Link Way near Swan Lane hail 'n' ride",
                        "Railway Street near The Link Way",
                        "Marymount College"
                    ],
                    "3029: Mattocks Dr - Merrimac High": [
                        "Cassia Dr near Mattocks Dr hail 'n' ride",
                        "Coolibah Cr near Willow St",
                        "Brier Cr near Hedge Row hail 'n' ride",
                        "Willow St near Eucalyptus Ave",
                        "Mattocks Rd near Bushtree Ct",
                        "Treeview Dr near Redleaf Ct",
                        "Treeview Dr near Oakland Ct",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Treetop Court",
                        "Mattocks Rd at Bluemoon Cl",
                        "Christine Ave at Silvabank Drive",
                        "Cumberland Dr near Yodelay St",
                        "Cumberland Dr near Dorothy Pl hail 'n' ride",
                        "Southlake Dr near Cumberland Dr hail 'n' ride",
                        "Cumberland Dr near Silvabank Dr",
                        "Christine Ave at Bermuda Street",
                        "Bermuda St at Lake Orr",
                        "Cottesloe Dr near Bermuda St",
                        "Rio Vista Bvd near Karabella Ct",
                        "Rio Vista Bvd near Crestmore Ct",
                        "Rio Vista Bvd near Barrier Reef Dr",
                        "Barrier Reef Dr near Deloraine Ct",
                        "Barrier Reef Dr near Halborne Dr",
                        "Barrier Reef Dr near Henning Ct",
                        "Barrier Reef Dr near Orpheus Rd",
                        "Barrier Reef Dr near Rio Vista Bvd",
                        "Dunlop Ct at Merrimac State High School"
                    ],
                    "3030: Reedy Creek - Miami": [
                        "Reedy Creek Rd at Ambassador Drive",
                        "Coolibah Cr near Willow St",
                        "Brier Cr near Ficus St hail 'n' ride",
                        "Brier Cr near Hedge Row hail 'n' ride",
                        "Willow St near Eucalyptus Ave",
                        "Mattocks Rd near Bushtree Ct",
                        "Treeview Dr near Redleaf Ct",
                        "Treeview Dr near Oakland Ct",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Treetop Court",
                        "Mattocks Rd at Bluemoon Cl",
                        "Christine Ave at Bermuda Street",
                        "Christine Ave at Caningeraba State School",
                        "Christine Ave at Burleigh Waters Library",
                        "Christine Ave at Hillstar Avenue",
                        "Christine Ave at Spoonbill Court",
                        "Christine Ave at Hibiscus Haven",
                        "Gold Coast Hwy at Christine Avenue station",
                        "GC Hwy at Miami State High School CLOSED PERMANENTLY"
                    ],
                    "3031: Pacific Pines - Park Lake": [
                        "Santa Isobel Bvd near Mussau St",
                        "Pacific Pines Bvd near Nandi Tce",
                        "Pacific Pines Bvd near Papara St",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Village Way near Studio Dr",
                        "Village Way near Drama St",
                        "Village Way near Mews Ct",
                        "Studio Dr near Hepburn Ct",
                        "Studio Dr near Village Way",
                        "Universal St near Crestridge Cr",
                        "Gaven Primary School",
                        "Universal St near Buchanan Ct",
                        "Palmerston Dr near Laysan Cr",
                        "Rimatara Rise near Victoria Dr hail 'n' ride",
                        "Victoria Dr near Buffalo Cr",
                        "Victoria Dr near Hawker St",
                        "Pitcairn Way at McAuley Parade",
                        "Pitcairn Way near Sangster Cr",
                        "Pitcairn Way at Lennox Street",
                        "Pitcairn Way near Belongil St",
                        "Pitcairn Way near Yaldara St",
                        "Pitcairn Way near Easter Cr",
                        "Pacific Pines High School",
                        "Pacific Pines Primary School",
                        "Santa Isobel Bvd near Amanu Cr",
                        "Park Lake Primary School"
                    ],
                    "3032: Santa Isobel - Park Lake Primary": [
                        "Santa Isobel Bvd near Amanu Cr",
                        "Santa Isobel Bvd near Pitcairn Way",
                        "Brockman Way near Bowley St",
                        "Harmsworth Rd near Wunburra Ccl",
                        "Wunburra Cct near Gascoyne St hail 'n' ride",
                        "McAuley Pde near Diamantina Cct",
                        "Park Lake Primary School"
                    ],
                    "3033: Reedy Creek - Miami": [
                        "Gemvale Rd near Somerset Dr",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Bridgman Dr near Old Coach Rd",
                        "Bridgman Dr near Heulan Ct",
                        "Bridgman Dr near Royston Cr",
                        "Bridgman Dr near Woodland Dr",
                        "Woodland Dr near Navars St",
                        "Old Coach Rd near Bridgman Dr",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Cassia Dr near Mattocks Dr hail 'n' ride",
                        "Coolibah Cr near Willow St",
                        "Brier Cr near Hedge Row hail 'n' ride",
                        "Willow St near Eucalyptus Ave",
                        "Mattocks Rd near Bushtree Ct",
                        "Treeview Dr near Redleaf Ct",
                        "Treeview Dr near Oakland Ct",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Treetop Court",
                        "Mattocks Rd at Bluemoon Cl",
                        "Christine Ave at Silvabank Drive",
                        "Cumberland Dr near Yodelay St",
                        "Cumberland Dr near Dorothy Pl hail 'n' ride",
                        "Southlake Dr near Cumberland Dr hail 'n' ride",
                        "Cumberland Dr near Silvabank Dr",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Regensberg Close",
                        "Christine Ave at Varsity College",
                        "Christine Ave at Varsity Sound Avenue",
                        "Varsity Pde near University Dr",
                        "University Dr near Hillridge Cr",
                        "University Dr near Shore Ave",
                        "Varsity Pde at Varsity Lakes College",
                        "Varsity Pde at Assembly Drive",
                        "Lake St near Central Park Dr",
                        "Varsity Pde at Lakefront Crescent",
                        "Christine Ave near Varsity Pde hail 'n' ride",
                        "Christine Ave at Bermuda Street",
                        "Christine Ave at Caningeraba State School",
                        "Christine Ave at Burleigh Waters Library",
                        "Christine Ave at Hillstar Avenue",
                        "Christine Ave at Spoonbill Court",
                        "Christine Ave at Hibiscus Haven",
                        "GC Hwy at Miami State High School CLOSED PERMANENTLY"
                    ],
                    "3034: Nerang Rail - Keebra": [
                        "Nerang station, stop E",
                        "Keebra Park State High School"
                    ],
                    "3035: Broadbeach Waters - Marymount via Mermaid Waters": [
                        "Bundall Rd at Sorrento Shopping Village",
                        "Bermuda St at Albert Park",
                        "Fremar St at Fremar Street",
                        "Monaco St at Pacific Boulevard",
                        "Monaco St at Rio Vista Boulevard",
                        "Rio Vista Bvd at Sheridan Park Avenue",
                        "Rio Vista Bvd at Cristobel Court",
                        "Rio Vista Bvd at Grant Place",
                        "TE Peters Dr at Andrea Avenue",
                        "Sunshine Bvd at Sonder Street",
                        "Sunshine Bvd at Merrimac Boulevard",
                        "Sunshine Bvd at Bordeaux Street",
                        "Sunshine Bvd at Surfers Avenue",
                        "Sunshine Bvd at Lindon Park",
                        "Markeri St near Sunshine Bvd",
                        "Markeri St near Rumrunner St",
                        "Markeri St near Southerly St",
                        "Barrier Reef Dr near Wild Duck Dr",
                        "Barrier Reef Dr near Normanby St",
                        "Barrier Reef Dr near Hayman Ct",
                        "Barrier Reef Dr near Peninsula Ct",
                        "Barrier Reef Dr near Deloraine Ct",
                        "Rio Vista Bvd near Pilot Ct",
                        "Rio Vista Bvd near Compass Ct",
                        "Rio Vista Bvd near Cottesloe Dr",
                        "Cottesloe Dr near Kirup St",
                        "Bermuda St at Lake Orr",
                        "Christine Ave at Bermuda Street",
                        "Mattocks Rd near Bluemoon Cl",
                        "Mattocks Rd at Bushtree Ct",
                        "Mattocks Rd at Viburnum Street",
                        "Marymount Catholic College",
                        "Marymount College"
                    ],
                    "3036: Sunshine Blvd - Surfers Paradise Primary": [
                        "Sunshine Bvd at Merrimac Boulevard",
                        "Sunshine Bvd at Sonder Street",
                        "TE Peters Dr at Summerland Key",
                        "Rio Vista Bvd near Grant Pl",
                        "Rio Vista Bvd at Cristobel Court",
                        "Rio Vista Bvd at Sheridan Park Avenue",
                        "Savoy Dr near Ilkinia Ave hail 'n' ride",
                        "Remembrance Drive at Surfers Paradise Bvd",
                        "Surfers Paradise Primary School"
                    ],
                    "3037: Tuxedo Junction - Pacific Pines": [
                        "Tuxedo Junction Dr near Maudsland Rd hail 'n' ride",
                        "Maudsland Rd near Guanaba Creek Rd hail 'n' ride",
                        "Guanaba Creek Rd near Stewart Rd hail 'n' ride",
                        "Coomera Valley Dr near Lynwood Dr hail 'n' ride",
                        "Lynwood Dr near Guanaba Creek Rd hail 'n' ride",
                        "Link Rd near Tarata Rd hail 'n' ride",
                        "Birds Rd near Link Rd hail 'n' ride",
                        "Birds Rd near Maudsland Rd hail 'n' ride",
                        "Lagoon Park Dr near Meadow Ct hail 'n' ride",
                        "Lagoon Park Dr near Summer Hill Cr hail 'n' ride",
                        "Greenacre Way near Lagoon Park Dr hail 'n' ride",
                        "Riverstone Crsg near Rivermill Tce hail 'n' ride",
                        "Riverstone Crsg near Northern Skies Tce HnR",
                        "Riverstone Crsg near Valley Brook Rise HnR",
                        "Riverstone Crsg near Hibiscus Cr hail 'n' ride",
                        "Riverstone Crsg near Prairie Av hail 'n' ride",
                        "Riverstone Crsg near Mountain View Pde HnR",
                        "Rivermill Tce near Plantation Cr hail 'n' ride",
                        "Rivermill Tce near Settlers Ave hail 'n' ride",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Cobb and Co Dr near Appollo Pl",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Gaven Arterial Rd near Yallaroi Rd hail 'n' ride",
                        "Gaven Arterial Rd at Felling Drive",
                        "Pinevale Dr near Hiva Ct",
                        "Universal St near Pinevale Dr",
                        "Gaven Primary School",
                        "Universal St near Buchanan Ct",
                        "Pitcairn Way near Norris St",
                        "Pitcairn Way at McAuley Parade",
                        "Park Lake Primary School",
                        "Pacific Pines High School",
                        "Pacific Pines Primary School"
                    ],
                    "3038: Oxley Dr - Helensvale": [
                        "Oxley Dr at Daisy Elms Park",
                        "Oxley Dr at Blaxland Avenue",
                        "Paradise Pde near Nankeen Ave",
                        "Paradise Pde near Mallard Ave",
                        "Paradise Pde at Donald Avenue",
                        "Bayview St near Falkinder Ave",
                        "Bayview St at Sapphire Street",
                        "Bayview St at Columbus Drive",
                        "Bayview St at Jasmine Avenue",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St at Cassia Street",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Runaway Bay Retirement Village",
                        "Bayview St at Madang Crescent",
                        "Bayview St at Oatland Esplanade",
                        "Bayview St at Clam Street",
                        "Marine Pde at Lands End",
                        "Burrows St near Back St",
                        "Burrows St at Oleander Ave",
                        "Morala Ave at Biggera Waters School",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Limetree Pde",
                        "Morala Ave at Folkstone Place",
                        "Lae Dr at The Runaway Brace",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd near Siena Pl",
                        "Pine Ridge Rd at Coombabah Road",
                        "Coombabah High School",
                        "Pine Ridge Rd at Pine Ridge Caravan Park",
                        "Pine Ridge Rd at Lensgate Road",
                        "Gold Coast Hwy at Arundel Drive",
                        "Arundel Dr near Paterson Dr",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Gold Coast Hwy at Discovery Drive",
                        "Lindfield Rd at Helensvale Plaza hail 'n' ride",
                        "Lindfield Rd near Latrobe Ave",
                        "Lindfield Rd near Brookton Ct",
                        "Discovery Dr at Lindfield Road Shops",
                        "Helensvale State High School",
                        "Helensvale Rd at Dalley Park Dr",
                        "Audrey Ave near Calmwater Ct hail 'n' ride",
                        "Helensvale Rd at Calmwater Crescent",
                        "Helensvale Primary School"
                    ],
                    "3039: Coombabah - Southport": [
                        "Coombabah High School",
                        "Pine Ridge Rd at Coombabah Road",
                        "Pine Ridge Rd at Siena Place",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Oxley Dr at Paradise Lake Resort",
                        "Oxley Dr at Crystal Reef Drive",
                        "Oxley Dr at Hansford Road",
                        "Brady Dr near Burrendong Rd",
                        "Argyll Ave near Burrinjuck Drive",
                        "Hansford Dr near Sanctuary Ct",
                        "Hansford Rd near Citie Dr",
                        "Myola Ct at Georgia Street",
                        "Esplanade at Tarni St",
                        "Hansford Rd near Sanctuary Ct",
                        "Hansford Rd at Numbat Ct",
                        "Hansford Rd near Doreen Dr",
                        "Oxley Dr at Lae Drive",
                        "Pine Ridge Rd near Siena Pl",
                        "Pine Ridge Rd at Coombabah High School",
                        "Lae Dr at The Runaway Brace",
                        "Morala Ave at Folkstone Place",
                        "Morala Ave near Broadwater St",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Kropp St",
                        "Hollywell Rd near Parr St",
                        "Government Rd near Ashton St",
                        "Government Rd near Ferguson Ave",
                        "Government Rd near Gordon St",
                        "Imperial Pde near Turpin Rd",
                        "Brooke Ave at Musgrave Avenue",
                        "Brooke Ave at Southport State High School"
                    ],
                    "3040: Nerang High - Merrimac": [
                        "Ashmore Rd near Macquarie Ave hail 'n' ride",
                        "Southport Nerang Rd at BP Central Park",
                        "Southport Nerang Rd at Stewart Parade",
                        "Southport Nerang Rd at Bellara Street",
                        "Southport Nerang Rd at Parkridge Drive",
                        "City of Gold Coast, Nerang",
                        "Price St at Nerang State School",
                        "Price St at Earle Plaza",
                        "Birribi Ave near Nerang River Dr",
                        "Nerang High School",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "Cayuga St near Mortensen Rd hail 'n' ride",
                        "William Duncan Primary School",
                        "Explorers Way at Garvie Place",
                        "Explorers Way near Andamooka Ave hail 'n' ride",
                        "Explorers Way near Hinkler Dr hail 'n' ride",
                        "Pappas Way near Dawnann Ct",
                        "Pappas Way near Remount Pl",
                        "Pappas Way near Cambridge Ct",
                        "Pappas Way near Dearne Pl",
                        "Murev Way near Alzino Pl",
                        "Michelmore Rd near Woolmere St",
                        "Michelmore Rd near Hickey Way",
                        "Nielsens Rd at Hickey Way",
                        "Birmingham Rd near The Boulevard",
                        "Riverside Home Caravan Park",
                        "Nerang Broadbeach Rd at Garden Grove",
                        "Nerang Broadbeach Rd at Nielsens Road",
                        "Gooding Dr at Palm Meadows Drive",
                        "Merrimac State Primary School",
                        "Jondique Ave at Saint Michaels College"
                    ],
                    "3041: Highfield Dr - Nerang High": [
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Breakwater Road",
                        "Railway Street at Robert St",
                        "Franklin Dr near McLachlan Ave hail 'n' ride",
                        "Old Coach Rd at Wallandra Road",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Sid Bigg Park",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Vince Hinde Dr near Worongary Rd hail 'n' ride",
                        "Harry Mills Dr near Charland Ct hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Worongary Rd near Glenrowan Dr hail 'n' ride",
                        "Gilston State School",
                        "Worongary Rd near Gilston Rd hail 'n' ride",
                        "Gilston Rd near Hinde Rd hail 'n' ride",
                        "Gilston Rd at Worley Drive",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "Nerang High School"
                    ],
                    "3042: Wintergreen - Upper Coomera": [
                        "Henry Cotton Dr near Wintergreen Dr",
                        "Henry Cotton Dr near Hazeltine Pl",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Parkwood Bvd near Davis Ct",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Kel Nagle Ct",
                        "Napper Rd at Arundel Primary School",
                        "Arundel Dr near Neri Cr",
                        "Arundel Dr near Arundel Pl",
                        "Arundel Dr near Paterson Dr",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Gold Coast Hwy at Discovery Drive",
                        "Helensvale Community Centre",
                        "Mildura Dr at Burdekin Ave",
                        "Mildura Dr near Halbury Ct",
                        "Mildura Dr near Pentland Ct",
                        "Ridgevale Dr near Mildura Dr",
                        "Ridgevale Dr at Kiandra Place",
                        "Ridgevale Dr near Armidale Cr",
                        "Discovery Dr at Ridgevale Drive",
                        "Discovery Dr at Helensvale Primary School",
                        "Discovery Dr at Lindfield Road Shops",
                        "Discovery Dr at Hession Oval",
                        "Discovery Dr at Eugenia Reserve",
                        "Discovery Dr at Ashford Road",
                        "Discovery Dr at Kingaroy Avenue",
                        "Helensvale State High School",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale Rd at Woodside Place",
                        "Siganto Dr near Grey Gum St",
                        "Siganto Dr at Tradewinds Street",
                        "Hope Island Rd at Anaheim Drive",
                        "River Links Bvd near Hope Island Rd hail 'n' ride",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Heathwood Dr near Koala Town Rd",
                        "Reserve Rd at Dreamtime Zone",
                        "Saint Stephens College",
                        "Reserve Road at Hargraves Rd",
                        "Upper Coomera College",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Assisi Catholic College"
                    ],
                    "3043: Molendinar - Benowa": [
                        "Ashmore Rd near Kingsway Dr hail 'n' ride",
                        "Hellman St hail 'n' ride",
                        "Pilar Ct hail 'n' ride",
                        "Ashmore Rd near Macquarie Ave hail 'n' ride",
                        "Macquarie Ave near Watford Crt hail 'n' ride",
                        "Macquarie Ave near Breakspear Rd hail 'n' ride",
                        "Macquarie Ave at Lachlan Avenue",
                        "Panache St near Coachwood Dr hail 'n' ride",
                        "Verdelho Way near Chablis Ct hail 'n' ride",
                        "Coachwood Dr near Cabernet Cl hail 'n' ride",
                        "Mitchell Ave near Sturt St",
                        "Trinity Lutheran School",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Ashmore City Shopping Centre",
                        "Nerang Rd at Aquinas Catholic College",
                        "Lilli Pilli Dr near Dander Dr hail 'n' ride",
                        "Lilli Pilli Dr near Larwon Tce hail 'n' ride",
                        "Keebra Park State High School",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at St Kevins Catholic Primary"
                    ],
                    "3044: Hickey Way - Nerang": [
                        "Nielsens Rd at Hickey Way",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Pappas Way near Dawnann Ct",
                        "Worongary Primary School",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Way at Cozens Way",
                        "Explorers Way at Garvie Place",
                        "William Duncan Primary School",
                        "McLeod St at Balfour Crescent",
                        "Mortensen Rd near The Linkway",
                        "Mortensen Rd near The Domain",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Nerang St at Nerang State School"
                    ],
                    "3045: Arthur Way - Windaroo": [
                        "Attenborough Bvd near Copeland St hail 'n' ride",
                        "Reedmans Rd near Arthur Way hail 'n' ride",
                        "Arthur Way near Gawain Dr",
                        "Eggersdorf Rd near Arthur Way hail 'n' ride",
                        "Peachey Road interchange hail 'n' ride",
                        "Peachey Rd at Doherty Ct",
                        "Peachey Rd near Caswell Ct",
                        "Peachey Rd near Vaughan Dr",
                        "Pascoe Rd near Winfield Rd hail 'n' ride",
                        "Winfield Rd near Metcalf Ct hail 'n' ride",
                        "Philben Dr near Citrinus Ct",
                        "Halfway Dr at Norfolk Village Primary School",
                        "Halfway Dr near Pascoe Rd hail 'n' ride",
                        "Pascoe Rd at Halfway Drive",
                        "Alamein St at Beenleigh High School",
                        "Windaroo Valley High",
                        "Mount Warren Bvd at Windaroo Primary School",
                        "Mt Warren Park Primary School"
                    ],
                    "3046: Central St - Nerang": [
                        "Central St near Davebill Ct",
                        "Central St at Carrumbella Dr",
                        "Allied Dr at Central St",
                        "Allied Dr at Spikes Ct",
                        "Allied Dr near Carnoustie Ct",
                        "Parkwood Bvd near Peter Thomson Dr",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Gary Player Cr",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr near Suncrest Ct",
                        "Wintergreen Dr near Ballybunion Dr",
                        "Olsen Ave at Crestwood Plaza",
                        "Aquinas Catholic College",
                        "Guardian Angels Catholic Primary",
                        "Nerang Rd at Aquinas Catholic College",
                        "Currumburra Rd at Corporation Drive",
                        "Currumburra Rd near Cotlew St",
                        "Currumburra Rd near Mualla Dr",
                        "Currumburra Rd at Mualla Drive",
                        "Currumburra Rd near Tangerine Row",
                        "Currumburra Rd at Milparinka Terrace",
                        "Ross St at Royal Pines",
                        "Birmingham Rd at The Boulevard",
                        "Nielsens Rd at Hickey Way",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Pappas Way near Dawnann Ct",
                        "Nerang High School"
                    ],
                    "3047: Bronberg Plaza - All Saints": [
                        "Slatyer Ave at Bronberg Plaza",
                        "Benowa Rd at Sapium Road",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Heeb St at The Crescent",
                        "Ashmore Rd at Boree Street",
                        "Ashmore Rd near Benowa Rd hail 'n' ride",
                        "Ashmore Rd at Sir Bruce Small Park",
                        "Ashmore Road Commercial Precinct",
                        "Campbell St near Saywell St hail 'n' ride",
                        "Ashmore Rd at Campbell Street",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Bermuda St at Albert Park",
                        "Bermuda St at Rudd Street",
                        "Bermuda St at Hooker Boulevard",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop A",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Gooding Dr at Merrimac Golf Course",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Jondique Avenue",
                        "Jondique Ave at Saint Michaels College",
                        "Gooding Dr at Bourton Road",
                        "Bourton Rd near Willunga Pl",
                        "All Saints Anglican School"
                    ],
                    "3048: Gooding Dr - Nerang High": [
                        "Gooding Dr at Bourton Road",
                        "Quambone St near Jeremy Ct hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Alkira Way near Kabra Ct hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near Kurilpa St hail 'n' ride",
                        "Dormello Dr near San Fernando Dr hail 'n' ride",
                        "Dormello Dr near Hinkler Dr hail 'n' ride",
                        "Mataranka Dr near Barrine Dr",
                        "Worongary Primary School",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Way at Cozens Way",
                        "Explorers Way at Garvie Place",
                        "William Duncan Primary School",
                        "McLeod St at Balfour Crescent",
                        "Nerang High School"
                    ],
                    "3049: Hickey Way - Benowa": [
                        "Nielsens Rd at Hickey Way",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Chisholm Rd near Marble Dr hail 'n' ride",
                        "Nerang Broadbeach Rd at Lakeview Drive",
                        "Ross St at Royal Pines",
                        "Benowa Rd at Benowa State High School"
                    ],
                    "3050: Molendinar - Ashmore Primary": [
                        "Ashmore Rd near Kingsway Dr hail 'n' ride",
                        "Ashmore Rd near Keen St hail 'n' ride",
                        "Hellman St hail 'n' ride",
                        "Pilar Ct hail 'n' ride",
                        "Macquarie Ave near Ashmore Rd hail 'n' ride",
                        "Macquarie Ave near Watford Crt hail 'n' ride",
                        "Macquarie Ave near Breakspear Rd hail 'n' ride",
                        "Macquarie Ave at Lachlan Avenue",
                        "Panache St near Coachwood Dr hail 'n' ride",
                        "Verdelho Way near Chablis Ct hail 'n' ride",
                        "Coachwood Dr near Cabernet Cl hail 'n' ride",
                        "Mitchell Ave near Sturt St",
                        "Cotlew St at McCowan St",
                        "Cotlew St near Patonga St",
                        "Currumburra Rd at Ashmore Primary School"
                    ],
                    "3051: Molendinar - Worongary Primary": [
                        "Ashmore Rd near Macquarie Ave hail 'n' ride",
                        "Southport Nerang Rd at BP Central Park",
                        "Southport Nerang Rd at Stewart Parade",
                        "Southport Nerang Rd at Parkridge Drive",
                        "City of Gold Coast, Nerang",
                        "Price St at Nerang State School",
                        "Price St at Earle Plaza",
                        "Birribi Ave near Beaudesert Nerang Rd HnR",
                        "Beaudesert Nerang Rd near Dell Ct hail 'n' ride",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Yarrimbah Dr near Goora St hail 'n' ride",
                        "Yarraowee Drive near McLaren Rd",
                        "Yarrimbah Dr near McLaren Rd hail 'n' ride",
                        "Dugandan St at Burra Street",
                        "Dugandan St near Koola Dr hail 'n' ride",
                        "Dugandan St at Teasdale Drive",
                        "Dugandan St at Bent Street",
                        "Dugandan St at Merloo Drive",
                        "Southport Nerang Rd at Nerang interchange",
                        "Birribi Ave near Nerang River Dr",
                        "Nerang High School",
                        "Crusader Way near Essex Ct hail 'n' ride",
                        "McLaren Rd at Beltana Way",
                        "McLaren Rd near Winchester Dr",
                        "McLaren Rd near Oakdale Ave",
                        "McLaren Road at Crusader Way",
                        "Gilston Rd near Alexander Dr hail 'n' ride",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "Cayuga St near Mortensen Rd hail 'n' ride",
                        "McLeod St at Aberdeen Court",
                        "William Duncan Primary School",
                        "Explorers Way at Garvie Place",
                        "Worongary Primary School"
                    ],
                    "3052: Kumbari Ave - Nerang": [
                        "Kumbari Ave near Smith Street Mwy",
                        "Musgrave Ave at Keith Hunt Park",
                        "Musgrave Ave near Botanical Dr",
                        "Olsen Ave at Boea Street",
                        "Government Rd at Galaxy Court",
                        "Government Rd near Jupiter Cl",
                        "Central St at Central Street",
                        "Central St near Davebill Ct",
                        "Central St at Carrumbella Dr",
                        "Allied Dr at Central St",
                        "Allied Dr at Spikes Ct",
                        "Allied Dr near Carnoustie Ct",
                        "Napper Rd at Arundel Primary School",
                        "Uplands Dr at Brushwood Ridge Reserve",
                        "Uplands Dr at Woodlands Way",
                        "Uplands Dr at Greenacre Drive",
                        "Greenacre Dr at Jamieson Dr",
                        "Greenacre Dr at Fairview Court",
                        "Greenacre Dr at Parkwood station",
                        "Daintree Dr near Highview Pl",
                        "Daintree Dr near Wardley Dr",
                        "Napper Rd at Daintree Drive",
                        "Smith St near Napper Rd hail 'n' ride",
                        "Smith St near Banyula Dr",
                        "Pacific Pines High School",
                        "Pacific Pines Primary School",
                        "Banyula Dr near Castle Hill Dr hail 'n' ride",
                        "Castle Hill Dr at Arjuna Way hail 'n' ride",
                        "Castle Hill Dr at Gaven hail 'n' ride",
                        "Nerang St at Nerang State School",
                        "Nerang High School"
                    ],
                    "3053: Nerang Rail - Keebra": [
                        "Nerang station, stop E",
                        "Keebra Park State High School"
                    ],
                    "3054: Nerang Rail - Keebra": [
                        "Nerang station, stop E",
                        "Keebra Park State High School"
                    ],
                    "3055: Nerang Interchange - Assisi": [
                        "Southport Nerang Rd at Nerang interchange",
                        "Banyula Dr near Coolibah Rd hail 'n' ride",
                        "Banyula Dr near Castle Hill Dr hail 'n' ride",
                        "Smith St near Banyula Dr",
                        "Pitcairn Way at Pacific Pines Town Centre",
                        "Pacific Pines High School",
                        "Santa Isobel Bvd near Mussau St",
                        "Santa Isobel Bvd near Amanu Cr",
                        "Hillary Cir near Victoria Dr hail 'n' ride",
                        "Rimatara Rise near Manra Way hail 'n' ride",
                        "Palmerston Dr near Maui Cr",
                        "Pinevale Dr near Hiva Ct",
                        "Universal St near Pinevale Dr",
                        "Gaven Primary School",
                        "Universal St near Buchanan Ct",
                        "Gaven Arterial Rd at Felling Drive",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Cobb and Co Dr near Appollo Pl",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Reserve Rd near Jemima Pl",
                        "Highland Reserve Primary School",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Assisi Catholic College"
                    ],
                    "3056: Bundall Rd - Ashmore Primary": [
                        "Bundall Rd at Pisa Court",
                        "Salerno St at Salerno Street",
                        "Salerno St at Fiesta Avenue",
                        "Via Roma near Hobgen St",
                        "Via Roma at Verona Avenue",
                        "Remembrance Dr at Markwell Avenue",
                        "Remembrance Dr at Bruce Bishop Car Park",
                        "Surfers Paradise",
                        "Thomas Dr near Burra St",
                        "Thomas Dr near Anembo St",
                        "Slatyer Ave at Corporate Court",
                        "Slatyer Ave at Bronberg Plaza",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Benowa Rd at Benowa Gardens",
                        "Ashmore Rd at Boree Street",
                        "Currumburra Rd at Tangerine Row",
                        "Currumburra Rd at Ashmore Primary School"
                    ],
                    "3057: Labrador - Upper Coomera": [
                        "Government Rd near Brookside Rd",
                        "Hollywell Rd near Thelma Ave",
                        "Morala Ave at Biggera Waters School",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Limetree Pde",
                        "Morala Ave at Folkstone Place",
                        "Lae Dr at Morala Avenue",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Bayview St at Karema Crescent",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St near Salvia St",
                        "Bayview St at Columbus Drive",
                        "Bayview St near Sapphire St",
                        "Bayview St near Falkinder Ave",
                        "Paradise Pde near Sunbird Ave",
                        "Abalone Ave near Thrush Ave hail 'n' ride",
                        "Crescent Ave near Broadwater Ave hail 'n' ride",
                        "Bert Hood St near Boykambil Esp hail 'n' ride",
                        "Boykambil Esp near Shoe St hail 'n' ride",
                        "Shoe St near Coombe Ave hail 'n' ride",
                        "Broadwater Ave at Crescent Avenue",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Helensvale Rd at Saltwater Park",
                        "Helensvale Rd at Sabrina Avenue",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Boykambil Esp near Sheehan Ave hail 'n' ride",
                        "Nelson Ave near Dunnes Ave hail 'n' ride",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Santa Barbara Rd near Chindrina St",
                        "Pinnaroo St near Mungala St",
                        "Akoonah St near Mungala St",
                        "Buddeh St near Santa Barbara Rd",
                        "Masthead Way at Sanctuary Cove",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Hope Island Rd near Magnolia Dr hail 'n' ride",
                        "Monterey Keys Dr at Creekwood Place",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Helensvale State High School",
                        "Helensvale Rd near Discovery Dr hail 'n' ride",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd near Siganto Dr hail 'n' ride",
                        "Siganto Dr near Grey Gum St",
                        "Siganto Dr at Tradewinds Street",
                        "Heathwood Dr near Koala Town Rd",
                        "Reserve Rd at Dreamtime Zone",
                        "Saint Stephens College",
                        "Reserve Road at Hargraves Rd",
                        "Upper Coomera College",
                        "Billinghurst Cr opp Coomera Anglican College"
                    ],
                    "3058: Reserve Rd - Assisi": [
                        "Reserve Road at Hargraves Rd",
                        "Hargraves Rd at Caribou Crescent",
                        "Roe St near Prefect Cl",
                        "Roe St near Con Brio Bvd",
                        "Roe St at Brygon Creek Drive",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Reserve Rd near Herbert St",
                        "Reserve Rd at Upper Coomera Village",
                        "Tamborine Oxenford Rd near Pinewood St HnR",
                        "Tamborine Oxenford Rd near Glenview Rd HnR",
                        "Tamborine Oxenford Rd near Wongawallan Dr HnR",
                        "Tamborine Oxenford Rd near Otmoor Rd hail 'n' ride",
                        "Tamborine Oxenford Rd near Currey Rd hail 'n' ride",
                        "Tamborine Oxenford Rd near Lok Evyn Ct HnR",
                        "Tamborine Oxenford Rd near Colin Meagher HnR",
                        "Tamborine Oxenford Rd near Timberview Dr HnR",
                        "Timberview Dr near Parkside Pde hail 'n' ride",
                        "Tamborine Oxenford Rd near Lanes Rd hail 'n' ride",
                        "Lanes Rd near Tamborine Oxenford Rd hail 'n' ride",
                        "Lanes Rd at Wongawallan hail 'n' ride",
                        "Lanes Rd near Crest Hill Dr hail 'n' ride",
                        "Tamborine Oxenford Rd near Welches Rd HnR",
                        "Gladrose Crt near Polo Cl hail 'n' ride",
                        "Gladrose Crt near Kriedeman Rd hail 'n' ride",
                        "Kriedeman Rd near Memorial Dr hail 'n' ride",
                        "Kriedeman Rd near Tamborine Oxenford Rd HnR",
                        "Yarrayne Valley Dr near Saddle Back St HnR",
                        "Greenview Rd near Saddle Back St hail 'n' ride",
                        "Greenview Dr near Stony Creek Dr hail 'n' ride",
                        "Pinewood St near Cactus Ct hail 'n' ride",
                        "Tamborine Oxenford Rd near Cemetery Rd HnR",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Reserve Rd near Jemima Pl",
                        "Stephens St near Macklin Ct hail 'n' ride",
                        "Stephens St near Farrer Ct hail 'n' ride",
                        "Stanfield Dr near Jullian Rd hail 'n' ride",
                        "Moran Dr near Acton Pl hail 'n' ride",
                        "Reserve Rd near Stephens St hail 'n' ride",
                        "Reserve Rd near Amelia St",
                        "Garawarra Cr near Rose Valley Dr hail 'n' ride",
                        "Garawarra Cr near Torrington St hail 'n' ride",
                        "Lysterfield Rise near Serendip Lane hail 'n' ride",
                        "Roe St at Con Brio Boulevard",
                        "Roe St near Tutor St",
                        "Hargraves Rd near Reserve Rd hail 'n' ride",
                        "Upper Coomera College",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Assisi Catholic College"
                    ],
                    "3059: Coomera Springs Bvd - Pimpama Colleges": [
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Rifle Range Rd at Bull Road",
                        "Yawalpah Rd at Salzburg Rd hail 'n' ride",
                        "Yawalpah Rd at Swan Road",
                        "Yawalpah Rd near Gawthern Dr hail 'n' ride",
                        "Yawalpah Rd at Gainsborough State School",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3060: Wongawallan - Uppera Coomera": [
                        "Timberview Dr near Parkside Pde hail 'n' ride",
                        "Lanes Rd at Wongawallan hail 'n' ride",
                        "Lanes Rd near Crest Hill Dr hail 'n' ride",
                        "Tamborine Oxenford Rd near Lok Evyn Ct HnR",
                        "Gladrose Crt near Polo Cl hail 'n' ride",
                        "Kriedeman Rd near Memorial Dr hail 'n' ride",
                        "Kriedeman Rd near Tamborine Oxenford Rd HnR",
                        "Greenview Rd near Saddle Back St hail 'n' ride",
                        "Yarrayne Valley Dr near Saddle Back St HnR",
                        "Tamborine Oxenford Rd near Pinewood St HnR",
                        "Pinewood St near Cactus Ct hail 'n' ride",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Reserve Rd near Jemima Pl",
                        "Stephens St near Macklin Ct hail 'n' ride",
                        "Stephens St near Farrer Ct hail 'n' ride",
                        "Stanfield Dr near Jullian Rd hail 'n' ride",
                        "Moran Dr near Acton Pl hail 'n' ride",
                        "Highland Reserve Primary School",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Upper Coomera College"
                    ],
                    "3061: Sir Charles Holm Dr - OWHS": [
                        "Ormeau Ridge Rd near Sir Charles Holme Dr",
                        "Ormeau Ridge Rd near Cardrona Ct hail 'n' ride",
                        "Ormeau Ridge Rd near Sir Charles Holm Dr HnR",
                        "Sir Charles Holm Dr near Islandview Tce HnR",
                        "Sir Charles Holm Dr near Limewood walkway HnR",
                        "Ormeau Ridge Rd near Johnson Pde",
                        "Ormeau Woods High School"
                    ],
                    "3062: Harbour Town - Upper Coomera": [
                        "Harbour Town, stop A",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Labrador Park Shopping Centre",
                        "Hollywell Rd near Thelma Ave",
                        "Morala Ave at Biggera Waters School",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Limetree Pde",
                        "Morala Ave at Folkstone Place",
                        "Lae Dr at Morala Avenue",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Bayview St at Karema Crescent",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St near Salvia St",
                        "Bayview St at Columbus Drive",
                        "Bayview St near Sapphire St",
                        "Bayview St near Falkinder Ave",
                        "Paradise Pde near Sunbird Ave",
                        "Abalone Ave near Thrush Ave hail 'n' ride",
                        "Broadwater Ave at Crescent Avenue",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Boykambil Esp near Sheehan Ave hail 'n' ride",
                        "Nelson Ave near Dunnes Ave hail 'n' ride",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Santa Barbara Rd near Chindrina St",
                        "Pinnaroo St near Mungala St",
                        "Akoonah St near Mungala St",
                        "Buddeh St near Santa Barbara Rd",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Hope Island Rd near Magnolia Dr hail 'n' ride",
                        "Monterey Keys Dr at Creekwood Place",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Helensvale Rd at Dalley Park Dr",
                        "Audrey Ave near Dalley Park Dr hail 'n' ride",
                        "Helensvale Rd at Calmwater Crescent",
                        "Helensvale Rd at Monterey Keys Drive",
                        "Helensvale State High School",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale Rd at Woodside Place",
                        "Siganto Dr near Grey Gum St",
                        "Siganto Dr at Tradewinds Street",
                        "Dreamworld Parkway at Boathouse Tavern",
                        "Beattie Rd at Coomera Primary School",
                        "Assisi Catholic College"
                    ],
                    "3063: Upper Ormeau Rd - OWHS": [
                        "Upper Ormeau Rd near Boral Quarry hail 'n' ride",
                        "Upper Ormeau Rd near Barrenjoey Dr hail 'n' ride",
                        "Thomsons Rd near Upper Ormeau Rd hail 'n' ride",
                        "Thomsons Rd near Stage Coach Dr hail 'n' ride",
                        "Stage Coach Dr at Kingsholme hail 'n' ride",
                        "Upper Ormeau Rd near Thomsons Rd hail 'n' ride",
                        "Upper Ormeau Rd near Montego Hills Dr HnR",
                        "River Run Cct near Lansdowne Dr",
                        "Ellenborough Ave near Terania Ave",
                        "Ormeau Ridge Rd near Sir Charles Holme Dr",
                        "Ormeau Ridge Rd near Johnson Pde",
                        "Peachey Road interchange hail 'n' ride",
                        "Ormeau Woods High School"
                    ],
                    "3064: Goldmine Rd - Ormeau Primary": [
                        "Goldmine Rd near Lahrs Rd",
                        "Peachey Road interchange hail 'n' ride",
                        "Peachey Rd at Doherty Ct",
                        "Vaughan Dr near Wille Ct hail 'n' ride",
                        "Vaughan Dr near Beausang Pl hail 'n' ride",
                        "Peachey Rd near Caswell Ct",
                        "Peachey Rd at Doherty Court",
                        "Ormeau Ridge Rd near Yarwood",
                        "Ormeau Ridge Rd near Watego Cr hail 'n' ride",
                        "Ormeau Ridge Rd near Sir Charles Holme Dr",
                        "Ormeau Ridge Rd near Cardrona Ct hail 'n' ride",
                        "Ormeau Ridge Rd near Sir Charles Holm Dr HnR",
                        "Sir Charles Holm Dr near Islandview Tce HnR",
                        "Ellenborough Ave near Terania Ave",
                        "River Run Cct near Lansdowne Dr",
                        "Lansdowne Dr near Upper Ormeau Rd hail 'n' ride",
                        "Mirambeena Dr near Lumeah Ave",
                        "Lumeah Ave near Oomool Ct hail 'n' ride",
                        "Lumeah Ave near Warrawee Way hail 'n' ride",
                        "Mirambeena Dr at Ormeau School"
                    ],
                    "3065: Ormeau - Rivermount": [
                        "Lumeah Ave near Oomool Ct hail 'n' ride",
                        "Lumeah Ave near Warrawee Way hail 'n' ride",
                        "Mirambeena Dr at Ormeau School",
                        "Mirambeena Dr near Lumeah Ave",
                        "Reedmans Rd near Arthur Way hail 'n' ride",
                        "Arthur Way near Gawain Dr",
                        "Eggersdorf Rd near Arthur Way hail 'n' ride",
                        "Peachey Road interchange hail 'n' ride",
                        "Peachey Rd at Doherty Ct",
                        "Peachey Rd near Caswell Ct",
                        "Peachey Rd near Vaughan Dr",
                        "Philben Dr near Peachey Rd",
                        "Philben Dr near Winfield Rd",
                        "Philben Dr near Citrinus Ct",
                        "Doolan St near Philben Dr",
                        "Doolan St near Karall St",
                        "Doolan St near Colane St",
                        "Pascoe Rd near Hennie Cr hail 'n' ride",
                        "Pascoe Rd near Tristan Ct hail 'n' ride",
                        "Pascoe Rd near Kefferan Pl hail 'n' ride",
                        "Peachey Rd near Pascoe Rd hail 'n' ride",
                        "Rivermount College"
                    ],
                    "3066: Coomera Sports Park - Pimpama Colleges": [
                        "Dreamworld Pkwy at Foxwell Rd",
                        "Yaun St at Sena Street",
                        "Lorenzo Dr at Beattie Road",
                        "Beattie Rd at Ford Road",
                        "Waterway Dr at McPhail Rd",
                        "Waterway Dr at Shipper Drive",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3067: Daintree Dr - Helensvale": [
                        "Daintree Dr near Paradise Dr hail 'n' ride",
                        "Pamplet Lane near Daintree Dr hail 'n' ride",
                        "Orlando Dr near Jackson Street",
                        "Finnegan Way at Cirrus Way",
                        "Kerkin Rd South at St Joseph's College",
                        "Yawalpah Rd near Kerkin Rd hail 'n' ride",
                        "Cunningham Dr at Arcadia Boulevard",
                        "William Bvd at Carnarvon Court",
                        "William Bvd at Tierney Way",
                        "Dixon Dr at Pimpama Junction",
                        "Yawalpah Rd at Salzburg Rd hail 'n' ride",
                        "Depot Rd near Pimpama Jacobs Well Rd",
                        "Bedford Rd near Christopher St hail 'n' ride",
                        "Bedford Rd near Attenborough Rd hail 'n' ride",
                        "Waverly Dr at Persimmon Street",
                        "Waterhouse Dr near McLachlan Cct hail 'n' ride",
                        "Bella Bvd at Deepak Drive",
                        "Bella Bvd near Matthews Cr hail 'n' ride",
                        "Rifle Range Rd near Hotham Creek Rd hail 'n' ride",
                        "Hotham Creek Rd near Fern Hill Dr hail 'n' ride",
                        "Hotham Creek Rd near Blacks Rd hail 'n' ride",
                        "Ruffles Rd near Hotham Creek Rd hail 'n' ride",
                        "Ruffles Rd near Peanba Park Rd hail 'n' ride",
                        "Reserve Rd near Reserve Rd hail 'n' ride",
                        "Reserve Rd near Jessica Dr",
                        "Upper Coomera College",
                        "Brygon Creek Dr near Ascendancy Way",
                        "Roe St at Brygon Creek Drive",
                        "Roe St at Con Brio Boulevard",
                        "Roe St near Tutor St",
                        "Hargraves Rd at Caribou Crescent",
                        "Hargraves Rd near Reserve Rd hail 'n' ride",
                        "Reserve Road at Abraham Rd",
                        "Saint Stephens College",
                        "Reserve Rd at Dreamtime Zone",
                        "Heathwood Dr near Koala Town Rd",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Siganto Dr at Tradewinds Street",
                        "Siganto Dr near Grey Gum St",
                        "Helensvale State High School"
                    ],
                    "3068: Winfield Rd - Helensvale": [
                        "Winfield Rd near Metcalf Ct hail 'n' ride",
                        "Pascoe Rd near Winfield Rd hail 'n' ride",
                        "Pascoe Rd near Solanum St",
                        "Halfway Dr near Evergreen Cct hail 'n' ride",
                        "Karall St near Doolan St hail 'n' ride",
                        "Doolan St near Halfway Dr",
                        "Philben Dr near Citrinus Ct",
                        "Philben Dr near Winfield Rd",
                        "Philben Dr near Peachey Rd",
                        "Peachey Rd near Vaughan Dr",
                        "Peachey Rd near Caswell Ct",
                        "Vaughan Dr near Wille Ct hail 'n' ride",
                        "Vaughan Dr near Beausang Pl hail 'n' ride",
                        "Peachey Rd at Doherty Court",
                        "Peachey Road interchange hail 'n' ride",
                        "Tillyroen Rd near Ormeau Ridge Rd hail 'n' ride",
                        "Rifle Range Rd at Bull Road",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Old Coach Rd at Days Road",
                        "Assisi Catholic College",
                        "Coomera Anglican College",
                        "Billinghurst Cr near Turnbull Dr",
                        "Abraham Rd near Aviation Av hail 'n' ride",
                        "Upper Coomera College",
                        "Reserve Rd near Abraham Rd hail 'n' ride",
                        "Reserve Road at Abraham Rd",
                        "Saint Stephens College",
                        "Reserve Rd at Dreamtime Zone",
                        "Heathwood Dr near Koala Town Rd",
                        "Helensvale State High School"
                    ],
                    "3069: Coomera Waters - Coomera Primary": [
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride",
                        "Ragamuffin Dr West near Foxwell Rd hail 'n' ride",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Oakey Creek Road",
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Finnegan Way at Felix Entrance",
                        "Coomera Rivers Primary School",
                        "Coomera station, stop D",
                        "Williamson Rd near Billinghurst Cr",
                        "Coomera Anglican College",
                        "Billinghurst Cr near Turnbull Dr",
                        "Billinghurst Cr near Godden Dr",
                        "Upper Coomera College",
                        "Brygon Creek Dr near Ascendancy Way",
                        "Roe St at Brygon Creek Drive",
                        "Hargraves Rd at Con Brio Bvd",
                        "Fawn St near River Meadows Dr hail 'n' ride",
                        "Hargraves Rd at Caribou Crescent",
                        "Hargraves Rd near Reserve Rd hail 'n' ride",
                        "Reserve Road at Abraham Rd",
                        "Saint Stephens College",
                        "Reserve Rd at Dreamtime Zone",
                        "Heathwood Dr near Koala Town Rd",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Hope Island Rd at Anaheim Drive",
                        "River Links Bvd near Hope Island Rd hail 'n' ride",
                        "Beattie Rd at Coomera Primary School"
                    ],
                    "3070: Coomera Waters - Helensvale": [
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Finnegan Way near Seagreen Dr hail 'n' ride",
                        "Coomera Rivers Primary School",
                        "Finnegan Way at Felix Entrance",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Waterway Dr at Shipper Drive",
                        "Waterway Dr at McPhail Rd",
                        "Beattie Rd at Ford Road",
                        "Beattie Rd at Coomera Primary School",
                        "Helensvale State High School",
                        "Helensvale Primary School"
                    ],
                    "3071: Pascoe Rd - OWHS": [
                        "Pascoe Rd near Kefferan Pl hail 'n' ride",
                        "Pascoe Rd near Peachy Rd hail 'n' ride",
                        "Philben Dr near Peachey Rd",
                        "Philben Dr near Winfield Rd",
                        "Winfield Rd near Metcalf Ct hail 'n' ride",
                        "Pascoe Rd near Winfield Rd hail 'n' ride",
                        "Pascoe Rd near Hennie Cr hail 'n' ride",
                        "Pascoe Rd near Solanum St",
                        "Pascoe Rd at Halfway Drive",
                        "Cuthbert Dr near Brookside Cct",
                        "Ormeau Woods High School"
                    ],
                    "3072: Goldmine Rd - Ormeau Primary": [
                        "Ormeau Woods High School",
                        "Goldmine Rd near Lahrs Rd",
                        "Arthur Way near Gawain Dr",
                        "Gawain Dr near Sugarmill St",
                        "Gawain Dr near Bedivere Dr",
                        "Reedmans Rd near Arthur Way",
                        "Mirambeena Dr near Lumeah Ave",
                        "Lumeah Ave near Oomool Ct hail 'n' ride",
                        "Lumeah Ave near Warrawee Way hail 'n' ride",
                        "Mirambeena Dr at Ormeau School"
                    ],
                    "3073: Coomera Waters - Upper Coomera College": [
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride",
                        "Edwardson Dr near Amity Rd hail 'n' ride",
                        "Pamplet Lane near Daintree Dr hail 'n' ride",
                        "Daintree Dr near Amity Rd hail 'n' ride",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Finnegan Way at Felix Entrance",
                        "Coomera Rivers Primary School",
                        "Finnegan Way near Trillers Ave hail 'n' ride",
                        "Williamson Rd near Billinghurst Cr",
                        "Assisi Catholic College",
                        "Billinghurst Cr near Turnbull Dr",
                        "Billinghurst Cr near Godden Dr",
                        "Upper Coomera College"
                    ],
                    "3074: Ruffles Creek - Coomera Primary": [
                        "Ruffles Rd near Peanba Park Rd hail 'n' ride",
                        "Ruffles Rd near Hotham Creek Rd hail 'n' ride",
                        "Hotham Creek Rd near Blacks Rd hail 'n' ride",
                        "Pimpama Primary School",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Coomera Springs Bvd at Dayflower Street",
                        "Coomera Springs Bvd at Sandpiper Court",
                        "Nightjar Dr at Butcher Bird Circuit",
                        "Cassinia Link near Nightjar Dr hail 'n' ride",
                        "Bridie Dr near Birley Link hail 'n' ride",
                        "Bridie Dr near Jagera Dr hail 'n' ride",
                        "Days Rd near Bridie Dr hail 'n' ride",
                        "Days Rd near Nightjar Rd hail 'n' ride",
                        "Assisi Catholic College",
                        "Coomera Anglican College",
                        "Billinghurst Cr near Turnbull Dr",
                        "Billinghurst Cr near Godden Dr",
                        "Billinghurst Cr near Jessica Dr",
                        "Billinghurst Cr at Livingstone Street",
                        "Old Coach Rd at Low Drive",
                        "Reserve Rd near Reserve Rd hail 'n' ride",
                        "Reserve Rd near Jessica Dr",
                        "Upper Coomera College",
                        "Abraham Rd near Aquatic Centre hail 'n' ride",
                        "Beattie Rd at Coomera Primary School",
                        "Yaun St near Jowett St hail 'n' ride",
                        "Yaun St at Sena Street",
                        "Lorenzo Dr at Beattie Road",
                        "Beattie Rd at Ford Road",
                        "Waterway Dr at McPhail Rd",
                        "Waterway Dr at Shipper Drive",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Foxwell Rd at Foxwell State Secondary College"
                    ],
                    "3075: Willowvale - Pimpama Colleges": [
                        "Pimpama Primary School",
                        "Hotham Creek Rd near Blacks Rd hail 'n' ride",
                        "Ruffles Rd near Hotham Creek Rd hail 'n' ride",
                        "Ruffles Rd near Peanba Park Rd hail 'n' ride",
                        "Days Rd near Capelily St hail 'n' ride",
                        "Bridie Dr near Jagera Dr hail 'n' ride",
                        "Bridie Rd near Forest Oak Dr hail 'n' ride",
                        "Bridie Dr near Birley Link hail 'n' ride",
                        "Cassinia Link near Nightjar Dr hail 'n' ride",
                        "Nightjar Dr at Butcher Bird Circuit",
                        "Coomera Springs Bvd at Sandpiper Court",
                        "Coomera Springs Bvd at Dayflower Street",
                        "Pimpama State Secondary College Bay 1",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3076: Dixon Dr - Pimpama Primary": [
                        "Dixon Dr at Pimpama State Primary College",
                        "Cunningham Dr at Arcadia Boulevard",
                        "Dixon Dr at Pimpama Junction",
                        "Chrome Dr near Ferngrove St hail 'n' ride",
                        "Chrome Dr near Zinc St hail 'n' ride",
                        "Chrome Dr near Nickel St hail 'n' ride",
                        "Gawthern Dr at Gainsborough State School",
                        "Gainsborough Dr near Swan Rd hail 'n' ride",
                        "Gainsborough Dr near Towarri St hail 'n' ride",
                        "Gainsborough Dr at Flinders Street",
                        "Sarabah Way near Narrien St hail 'n' ride",
                        "Kosciuszko Cct near Sarabah Way hail 'n' ride",
                        "Bedford Rd near Christopher St hail 'n' ride",
                        "Bedford Rd near Attenborough Rd hail 'n' ride",
                        "Village Bvd at Dorset Street",
                        "Village Bvd at Chisolm Way",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Depot Rd near Pimpama Jacobs Well Rd",
                        "Pimpama Primary School"
                    ],
                    "3077: Mirambeena - OWHS": [
                        "Mirambeena Dr near Lumeah Ave",
                        "Lumeah Ave near Oomool Ct hail 'n' ride",
                        "Lumeah Ave near Warrawee Way hail 'n' ride",
                        "Guara Grove at Mirambeena Dr hail 'n' ride",
                        "Ormeau station",
                        "Mirambeena Dr at Ormeau School",
                        "Ormeau Woods High School"
                    ],
                    "3078: Nerang - Marymount College via Robina Waters": [
                        "Cayuga St at PCYC Nerang",
                        "McKenzie Dr at Monopoly Boulevard",
                        "Hinkler Dr near Alexander Dr hail 'n' ride",
                        "Bonooroo Park Shopping Centre",
                        "Nielsens Rd at Hickey Way",
                        "Gooding Dr at Carrara Markets",
                        "Gooding Rd at Cararra Markets",
                        "St Vincents Catholic Primary School",
                        "Fairway Dr near Santa Cruz Bvd hail 'n' ride",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Markeri St near Ron Penhaligon Way",
                        "Yarraville St near Markeri St",
                        "Yarraville St near Altona Cl",
                        "Camberwell Cct near Kensington St",
                        "Camberwell Cct at Caulfield Street",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Tullamarine Dr near Cheltenham Dr",
                        "Cheltenham Dr near Bellmore Cl",
                        "Ron Penhaligon Way near Commerce Dr",
                        "Ron Penhaligon Way near Tennyson Pl",
                        "Ron Penhaligon Way near Kentwood Dr",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way at Banff Court",
                        "Glen Eagles Dr near Oakmont St",
                        "Glen Eagles Dr near Federal Pl",
                        "Glen Eagles Dr near Princeville Ct",
                        "Glen Eagles Dr near Killarney Ave",
                        "Killarney Ave near Turnberry Ct",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Cheltenham Dr near Thorngate Dr",
                        "Robina Town Centre Dr at Leabrook Crescent",
                        "Robina Town Centre Dr at Eastlake Apartments",
                        "Robina Town Centre Drive at Scottsdale Dr",
                        "Scottsdale Dr at Christine Avenue",
                        "Scottsdale Dr at Laurel Oak Drive",
                        "Scottsdale Dr at Firebird Street",
                        "Varsity Lakes station",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Marymount Catholic College",
                        "Marymount College"
                    ],
                    "3079: Coomera Waters - Upper Coomera": [
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride",
                        "Daintree Dr near Paradise Dr hail 'n' ride",
                        "Pamplet Lane near Daintree Dr hail 'n' ride",
                        "Picnic Creek State School",
                        "Edwardson Dr near Amity Rd hail 'n' ride",
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Waterway Dr at Shipper Drive",
                        "Waterway Dr at McPhail Rd",
                        "Beattie Rd at Ford Road",
                        "Beattie Rd at Coomera Primary School",
                        "Dreamworld Pkwy at Foxwell Rd",
                        "Hope Island Rd at Anaheim Drive",
                        "River Links Bvd near Hope Island Rd hail 'n' ride",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Heathwood Dr near Koala Town Rd",
                        "Reserve Rd at Dreamtime Zone",
                        "Reserve Road at Hargraves Rd",
                        "Upper Coomera College",
                        "Assisi Catholic College"
                    ],
                    "3080: Philben Rd - OWHS": [
                        "Philben Dr near Citrinus Ct",
                        "Doolan St near Philben Dr",
                        "Doolan St near Karall St",
                        "Doolan St near Colane St",
                        "Pascoe Rd near Solanum St",
                        "Pascoe Rd at Halfway Drive",
                        "Cuthbert Dr near Brookside Cct",
                        "Ormeau Woods High School"
                    ],
                    "3081: Arthur Way - OWHS": [
                        "Reedmans Rd near Arthur Way",
                        "Gawain Dr near Bedivere Dr",
                        "Gawain Dr near Lahey Ct",
                        "Arthur Way near Gawain Dr",
                        "Eggersdorf Rd near Arthur Way hail 'n' ride",
                        "Ormeau Woods High School"
                    ],
                    "3082: Wintergreen - Coombabah": [
                        "Henry Cotton Dr near Wintergreen Dr",
                        "Henry Cotton Dr near Hazeltine Pl",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Parkwood Bvd near Davis Ct",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Kel Nagle Ct",
                        "Napper Rd at Arundel Primary School",
                        "Napper Rd near Benalla Ct",
                        "Daintree Dr near Highview Pl",
                        "Napper Rd at Daintree Drive",
                        "Greenacre Dr at Parkwood station",
                        "Greenacre Dr at Fairview Ct",
                        "Greenacre Dr at Jamieson Drive",
                        "Uplands Dr at Greenacre Drive",
                        "Uplands Dr at Woodlands Way",
                        "Uplands Dr at Brushwood Ridge Reserve",
                        "Arundel Dr near Neri Cr",
                        "Arundel Dr near Arundel Pl",
                        "Arundel Dr near Paterson Dr",
                        "Gold Coast Hwy at Arundel Drive",
                        "Coombabah High School"
                    ],
                    "3083: Bella Bvd - Pimpama Colleges": [
                        "Bella Bvd at Deepak Drive",
                        "Bella Bvd near Matthews Cr hail 'n' ride",
                        "Yawalpah Rd at Salzburg Rd hail 'n' ride",
                        "Yawalpah Rd at Swan Road",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3084: Ourimbah Rd - Currumbin Primary": [
                        "Ourimbah Rd",
                        "Miles St near Coolangatta Rd hail 'n' ride",
                        "Coolangatta Rd near Ocean St hail 'n' ride",
                        "Golden Four Dr at North Kirra Beach",
                        "Johnston Street",
                        "Golden Four Dr at George Street",
                        "Coolangatta Rd at Kirribin Street",
                        "Coolangatta Rd near Loongana Ave",
                        "Coolangatta Rd near Kiewa Ave",
                        "Boyd St near Morshead St",
                        "Inland Dr near Boyd St",
                        "Inland Dr at Triton Parade",
                        "Monash St near Foch St hail 'n' ride",
                        "Toolona St near Atkin St",
                        "Chaffey St near Narrane St hail 'n' ride",
                        "Kaleena St near Cabarita Ave",
                        "Cabarita Ave near Kallena St",
                        "Cabarita Ave near Nangana St hail 'n' ride",
                        "Cabarita Ave near Mirreen Dr",
                        "Yolanta Dr near Mirreen Dr hail 'n' ride",
                        "Costelloe St near Taperell Dr hail 'n' ride",
                        "Taperell Dr near Wickham Cr",
                        "Toolona St near Durran St",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Teemangum St at Kropp Park",
                        "Currumbin Wildlife Sanctuary",
                        "Pacific Pde at Currumbin Beach",
                        "Pacific Pde at Wallace Nicoll Park",
                        "Currumbin State Primary School"
                    ],
                    "3085: Currumbin Waters - Marymount via Mallawa Dr": [
                        "Palm Beach Currumbin High School",
                        "Thrower Dr near Sarawak Dr",
                        "Currumbin Creek Rd at Currumbin RSL",
                        "Currumbin Creek Rd at Love Street",
                        "Currumbin Creek Rd near Teatree Ave",
                        "Currumbin Creek Rd near Villiers Dr",
                        "Currumbin Creek Rd near Bienvenue Dr",
                        "Galleon Way at Jutland Place",
                        "Galleon Way near Casey Cl",
                        "Galleon Way near Brigantine Ct",
                        "Galleon Way at Billabong Court",
                        "Galleon Way at Ware Drive",
                        "Galleon Way near Tate Ct",
                        "Murtha Dr near Foothill St",
                        "Murtha Dr at Swanbourne Way",
                        "Murtha Dr near Dongarra Cl",
                        "Murtha Dr at KP McGrath Drive",
                        "KP McGrath Dr near Murtha Dr",
                        "KP McGrath Dr near Seaview Pde",
                        "KP McGrath Dr near Angelica St",
                        "Palm Beach Ave near Tahiti Ave",
                        "Mallawa Dr near Nineteenth Av hail 'n' ride",
                        "Mallawa Dr near Abella St hail 'n' ride",
                        "Mallawa Dr near Tallebudgera Dr hail 'n' ride",
                        "Tallebudgera Dr near Murlong Cr hail 'n' ride",
                        "Marymount College"
                    ],
                    "3086: Currumbin Creek Rd - Elanora High": [
                        "Currumbin Creek Rd at Love Street",
                        "Currumbin Creek Rd near Teatree Ave",
                        "Currumbin Creek Rd near Villiers Dr",
                        "Currumbin Creek Rd near Bienvenue Dr",
                        "Valley Dr near Green Lane hail 'n' ride",
                        "Dudgeon Dr near Jersey Ct hail 'n' ride",
                        "Tallebudgera Primary School",
                        "Avocado St opp Elanor State High School"
                    ],
                    "3087: Simpson Rd - Tallebudgera Primary": [
                        "Simpsons Rd near Calcita Ave hail 'n' ride",
                        "Simpsons Rd near Killara St hail 'n' ride",
                        "Simpsons Rd near Buckingham Way hail 'n' ride",
                        "Westminster Bvd near Cornwall Dr hail 'n' ride",
                        "Cornwall Dr near Cheshire Gr hail 'n' ride",
                        "Simspons Rd near Cornwall Dr hail 'n' ride",
                        "Guineas Creek Rd at Doubleview Drive",
                        "Murtha Dr near Foothill St",
                        "Murtha Dr at Swanbourne Way",
                        "Murtha Dr near Dongarra Cl",
                        "Murtha Dr at KP McGrath Drive",
                        "Elanora State Primary School hail 'n' ride",
                        "KP McGrath Dr at Elanora State School",
                        "KP McGrath Dr near Murtha Dr",
                        "KP McGrath Dr near Seaview Pde",
                        "Avocado St near Doubleview Dr",
                        "Ironbark St near Avocado St",
                        "Ironbark St near Kaffia Ct",
                        "Ironbark St near Angelica St",
                        "Nineteenth Ave at Elanora High School",
                        "Nineteenth Ave at Kalmia Court",
                        "Tallebudgera Primary School",
                        "Valley Dr near Green Lane hail 'n' ride",
                        "Dudgeon Dr near Jersey Ct hail 'n' ride",
                        "Dungeon Dr near Valley Dr hail 'n' ride"
                    ],
                    "3088: Molendinar - Southport": [
                        "Ashmore Rd near Macquarie Ave hail 'n' ride",
                        "Macquarie Ave near Watford Crt hail 'n' ride",
                        "Macquarie Ave near Breakspear Rd hail 'n' ride",
                        "Breakspear Rd at Mahogany Hill Park",
                        "Crestwood Dr at Watergum Parade",
                        "Crestwood Dr at Crestwood Plaza",
                        "Olsen Ave at Crestwood Plaza",
                        "Henry Cotton Dr near Wintergreen Dr",
                        "Henry Cotton Dr near Hazeltine Pl",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Parkwood Bvd near Davis Ct",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Kel Nagle Ct",
                        "Arundel State Primary School",
                        "Allied Dr at Carnoustie Ct",
                        "Allied Dr near Range Ct",
                        "Central St near Allied Dr",
                        "Central St near Carrumbella Dr",
                        "Central St at Central Street Shops",
                        "Central St near Usher Ave",
                        "Usher Ave near Tanias Pl",
                        "Government Rd near Morinda Way",
                        "Government Rd at Galaxy Court",
                        "Stephenson St near Government Rd hail 'n' ride",
                        "Stephenson St near Olsen Ave hail 'n' ride",
                        "Olsen Ave at Boea Street",
                        "Musgrave Ave near Botanical Dr",
                        "Musgrave Ave at Keith Hunt Park",
                        "Kumbari Ave near Nakina St",
                        "Smith St at Kumbari Avenue",
                        "Smith St at Curtin Avenue",
                        "Smith St at Southport State High School",
                        "Southport State School"
                    ],
                    "3089: Bonogin - Merrimac High": [
                        "Gold Coast Springbrook Rd near Hardys Rd HnR",
                        "Hardys Rd near Natan Rd hail 'n' ride",
                        "Hardys Rd near Bonogin Rd hail 'n' ride",
                        "Gunsynd Dr near Tulloch Cr hail 'n' ride",
                        "Hardys Rd near Rising Fast Rd hail 'n' ride",
                        "Hardys Rd near Bertana Dr hail 'n' ride",
                        "Franklin Dr near McLachlan Ave hail 'n' ride",
                        "The Link Way near Swan Lane hail 'n' ride",
                        "Railway Street near The Link Way",
                        "Robina State High School",
                        "Robina Town Centre",
                        "Robina Town Centre Dr at Christine Avenue",
                        "Robina Town Centre Drive at Scottsdale Dr",
                        "Robina Town Centre Dr at Eastlake Apartments",
                        "Robina Town Centre Dr at Leabrook Crescent",
                        "Cheltenham Dr near Glenside Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Cheltenham Dr near Bellmore Cl",
                        "Ron Penhaligon Way near Commerce Dr",
                        "Ron Penhaligon Way near Vaucluse Pl",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Dunlop Ct at Merrimac State High School"
                    ],
                    "3090: Surfers Paradise - Benowa": [
                        "Salerno St at Fiesta Avenue",
                        "Via Roma near Hobgen St",
                        "Via Roma at Verona Avenue",
                        "Remembrance Dr at Markwell Avenue",
                        "Remembrance Dr at Bruce Bishop Car Park",
                        "Surfers Paradise",
                        "Ferny Ave at Palm Avenue",
                        "Ferny Ave at Ocean Avenue",
                        "Main Beach station",
                        "Scarborough St at Marshall Lane",
                        "Southport bus station, stop A",
                        "Scarborough St at White Street",
                        "Queen St at Garden Street",
                        "Nerang St at West End Shops",
                        "Nerang St at Falconer Street",
                        "Anne St at Jane Street",
                        "Keebra Park State High School",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at St Kevins Catholic Primary"
                    ],
                    "3091: Peachy Rd - OWHS": [
                        "Peachey Rd near Caswell Ct",
                        "Peachey Rd near Vaughan Dr",
                        "Vaughan Dr near Healy Ct hail 'n' ride",
                        "Vaughan Dr near Renford Ct hail 'n' ride",
                        "Peachey Rd at Doherty Court",
                        "Ormeau Woods High School"
                    ],
                    "3092: Canungra - Nerang": [
                        "Maudsland Rd near Birds Rd hail 'n' ride",
                        "Maudsland Rd near Guanaba Creek Rd hail 'n' ride",
                        "Maudsland Rd near Burley Griffin Dr hail 'n' ride",
                        "Beaudesert Nerang Rd near Cemetery Rd HnR",
                        "Kidston St at DJ Smith Park hail 'n' ride",
                        "Clagiraba Rd near Gerara Ct hail 'n' ride",
                        "Clagiraba Rd near Witheren Rd hail 'n' ride",
                        "Clagiraba Rd near Thendara Dr hail 'n' ride",
                        "Barcoo Ct near Clagiraba Rd hail 'n' ride",
                        "Barcoo Ct at Diamantina Ct hail 'n' ride",
                        "Beaudesert Nerang Rd near Canungra Ct HnR",
                        "Beaudesert Nerang Rd near Henri Robert Dr HnR",
                        "Beaudesert Nerang Rd near Riverglen Ct HnR",
                        "Nathanvale Dr near Pasture Pl hail 'n' ride",
                        "Nathanvale Dr near Mountain View Cr hail 'n' ride",
                        "Beaudesert Nerang Rd near Crystal Springs Ct HnR",
                        "The Oval Dr near Beaudesert Nerang Rd HnR",
                        "Beaudesert Nerang Rd near The Oval Dr HnR",
                        "Beaudesert Nerang Rd near Arunta Dr hail 'n' ride",
                        "McLaren Rd near Oakdale Ave",
                        "McLaren Rd at Beltana Way",
                        "McLaren Road at Crusader Way",
                        "Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Price St at Earle Plaza",
                        "Nerang St at Nerang State School"
                    ],
                    "3093: Nerang - Merrimac High": [
                        "Price St at Earle Plaza",
                        "Birribi Ave near Nerang River Dr",
                        "Weedons Rd at Nerang High School",
                        "Gilston Rd near Alexander Dr hail 'n' ride",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "Gilston Rd at Worley Drive",
                        "Gilston Rd near Peter Mills Dr hail 'n' ride",
                        "Gilston Rd at Longhill Road",
                        "Worongary Rd near Kookaburra Dr hail 'n' ride",
                        "Gilston State School",
                        "Worongary Rd near Glenrowan Rd hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Harry Mills Dr near Charland Ct hail 'n' ride",
                        "Vince Hinde Dr near Harry Mills Dr hail 'n' ride",
                        "Worongary Rd near Random Way hail 'n' ride",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Mudgeeraba Rd near Scullin St",
                        "Robina State High School",
                        "Robina station, stop D",
                        "Highfield Dr near Breakwater Rd",
                        "Highfield Dr near Outriggers Drive Reserve",
                        "All Saints Anglican School",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Cabot Ct",
                        "Bourton Rd near Willunga Pl",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "Gooding Dr at Bourton Road",
                        "Jondique Ave at Saint Michaels College",
                        "Ghilgai Rd near Entry Dr",
                        "Ghilgai Rd near Griffon St",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Rd at Cararra Markets",
                        "Dunlop Ct at Merrimac State High School"
                    ],
                    "3094: Wintergreen - Coombabah": [
                        "Henry Cotton Dr near Wintergreen Dr",
                        "Henry Cotton Dr near Hazeltine Pl",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Parkwood Bvd near Davis Ct",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Kel Nagle Ct",
                        "Napper Rd near Benalla Ct",
                        "Daintree Dr near Highview Pl",
                        "Napper Rd at Daintree Drive",
                        "Greenacre Dr at Parkwood station",
                        "Greenacre Dr at Fairview Ct",
                        "Greenacre Dr at Jamieson Drive",
                        "Uplands Dr at Greenacre Drive",
                        "Uplands Dr at Woodlands Way",
                        "Uplands Dr at Brushwood Ridge Reserve",
                        "Arundel State Primary School",
                        "Arundel Dr near Neri Cr",
                        "Arundel Dr near Arundel Pl",
                        "Arundel Dr near Paterson Dr",
                        "Gold Coast Hwy at Arundel Drive",
                        "Pine Ridge Rd at Lensgate Road",
                        "Pine Ridge Rd at Pine Ridge Caravan Park",
                        "Coombabah High School",
                        "Pine Ridge Rd at Coombabah Road",
                        "Pine Ridge Rd at Siena Place",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Oxley Dr at Paradise Lake Resort",
                        "Marsupial Dr near Kangaroo Ave",
                        "Kangaroo Ave at Kangaroo Park",
                        "Kangaroo Ave near Possum Ct",
                        "Oxley Dr at Crystal Reef Drive",
                        "Hansford Rd near Doreen Dr",
                        "Hansford Rd at Numbat Ct",
                        "Hansford Rd near Citie Dr",
                        "Myola Ct at Georgia Street",
                        "Esplanade at Tarni St",
                        "Hansford Rd near Sanctuary Ct",
                        "Burrinjuck Dr near Taupo Ct hail 'n' ride",
                        "Lefroy Dr near Rason Way hail 'n' ride",
                        "Oxley Dr at Coombabah State Primary School"
                    ],
                    "3095: Foxwell Rd - Pimpama Colleges": [
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Edwardson Dr near Amity Rd hail 'n' ride",
                        "Pamplet Lane near Daintree Dr hail 'n' ride",
                        "Daintree Dr near Amity Rd hail 'n' ride",
                        "Kerkin Rd South at St Joseph's College",
                        "Kerkin Rd S at Vanes Street",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3096: Nerang High - Robina": [
                        "Weedons Rd at Nerang High School",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "Cayuga St near Mortensen Rd hail 'n' ride",
                        "McLeod St at Aberdeen Court",
                        "William Duncan Primary School",
                        "Alexander Dr at Kahlua Court",
                        "Hinkler Dr near Explorers Way",
                        "Dormello Dr near Widden Ct hail 'n' ride",
                        "Hinkler Dr near San Fernando Dr hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Alkira Way near Quambone St hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Hannah Ct hail 'n' ride",
                        "Mudgeeraba Rd near Quambone St",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Worongary Rd near Harry Mills Dr hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Vince Hinde Dr near Harry Mills Dr hail 'n' ride",
                        "Vince Hinde Dr near Worongary Rd hail 'n' ride",
                        "Worongary Rd near Random Way hail 'n' ride",
                        "Worongary Rd near Woodvale Dr hail 'n' ride",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Rainbow Dr near Venus Ct hail 'n' ride",
                        "Rainbow Dr at Universe Court",
                        "Milky Way near Moonbeam Pde hail 'n' ride",
                        "Mudgeeraba Rd near Scullin St",
                        "Mudgeeraba Rd near Piallingo St hail 'n' ride",
                        "Robina State High School"
                    ],
                    "3098: Mermaid Waters - Benowa": [
                        "Rio Vista Bvd near Dunlop Ct",
                        "Rio Vista Bvd near Southerly St",
                        "Rio Vista Bvd near Wayfarer Ave",
                        "Rio Vista Bvd near Pilot Ct",
                        "Rio Vista Bvd near Compass Ct",
                        "Rio Vista Bvd near Cottesloe Dr",
                        "Cottesloe Dr near Kirup St",
                        "Cottesloe Dr near Vancouver Dr",
                        "Cottesloe Dr near University Dr",
                        "Pyrmont St near Cottesloe Dr",
                        "Manly Dr near Sandringham Dr",
                        "Manly Dr near Pipers Pt",
                        "Ron Penhaligon Way near Vaucluse Pl",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Markeri St near Ron Penhaligon Way",
                        "Yarraville St near Markeri St",
                        "Yarraville St near Altona Cl",
                        "Camberwell Cct near Kensington St",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Tullamarine Dr near Cheltenham Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Cheltenham Dr near Bellmore Cl",
                        "Ron Penhaligon Way near Kentwood Dr",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way at Banff Court",
                        "Glen Eagles Dr near Oakmont St",
                        "Glen Eagles Dr near Federal Pl",
                        "Glen Eagles Dr near Princeville Ct",
                        "Glen Eagles Dr near Killarney Ave",
                        "Killarney Ave near Turnberry Ct",
                        "Cheltenham Dr near Thorngate Dr",
                        "Cheltenham Dr at Woody Views Way",
                        "Robina State High School",
                        "Highfield Dr near Breakwater Rd",
                        "Highfield Dr near Outriggers Drive Reserve",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Cabot Ct",
                        "Bourton Rd near Willunga Pl",
                        "Gooding Dr at Bourton Road",
                        "Jondique Ave at Saint Michaels College",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Palm Meadows Drive",
                        "Birmingham Rd near The Boulevard",
                        "Ross St at Royal Pines",
                        "Ross St at Benowa Village",
                        "Ashmore Rd at Boree Street",
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at Sapium Road",
                        "Wardoo St at Petra Street",
                        "Wardoo St at Lilli Pilli Drive",
                        "Keebra Park State High School"
                    ],
                    "3099: Helensvale - Pacific Pines School via Universal": [
                        "Helensvale stop C",
                        "Binstead Way at Pacific Pines Boulevard",
                        "Studio Dr near Monroe Ct hail 'n' ride",
                        "Village Way near Studio Dr",
                        "Village Way near Drama St",
                        "Village Way near Mews Ct",
                        "Studio Dr near Hepburn Ct",
                        "Studio Dr near Village Way",
                        "Universal St near Crestridge Cr",
                        "Universal St near Pinevale Dr",
                        "Gaven Primary School",
                        "Universal St near Buchanan Ct",
                        "Greenway Bvd near Keneally St hail 'n' ride",
                        "Greenway Bvd near Brissendon St",
                        "McAuley Pde near Matthews Dr",
                        "McAuley Pde near Shoalhaven Ave hail 'n' ride",
                        "McAuley Pde near Diamantina Cct",
                        "Pacific Pines Primary School",
                        "Pacific Pines High School"
                    ],
                    "3100: Robina Primary - Robina High": [
                        "Cheltenham Dr at Woody Views Way",
                        "Cheltenham Dr near Glenside Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Killarney Ave near Huntingdale Cr",
                        "Killarney Ave at Robina State School",
                        "Ron Penhaligon Way near Bothwell St",
                        "Pyrmont St near Cottesloe Dr",
                        "Manly Dr near Sandringham Dr",
                        "Manly Dr near Pipers Pt",
                        "Ron Penhaligon Way near Vaucluse Pl",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Markeri St near Ron Penhaligon Way",
                        "Yarraville St near Markeri St",
                        "Yarraville St near Altona Cl",
                        "Camberwell Cct near Kensington St",
                        "Camberwell Cct at Caulfield Street",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Tullamarine Dr near Cheltenham Dr",
                        "Glen Eagles Dr near Dundee Ct",
                        "Cheltenham Dr near Thorngate Dr",
                        "Robina State High School"
                    ],
                    "3101: Pacific Pines - Helensvale": [
                        "Hammond Dr near Rosette Way hail 'n' ride",
                        "Smith St near Banyula Dr",
                        "Pitcairn Way at Pacific Pines Town Centre",
                        "Pitcairn Way near Easter Cr",
                        "Pitcairn Way near Yaldara St",
                        "Santa Isobel Bvd near Pitcairn Way",
                        "Santa Isobel Bvd near Chatham Ave",
                        "Santa Isobel Bvd near Mussau St",
                        "Pacific Pines Bvd near Nandi Tce",
                        "Pacific Pines Bvd near Papara St",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Binstead Way at Studio Drive",
                        "Palmerston Dr near Maui Cr",
                        "Universal St near Buchanan Ct",
                        "Universal St near Guy Lane",
                        "Universal St near Takahe St",
                        "Universal St near Crestridge Cr",
                        "Universal St near Hervey St hail 'n' ride",
                        "Village Way near Studio Dr",
                        "Village Way near Drama St",
                        "Village Way near Mews Ct",
                        "Studio Dr near Hepburn Ct",
                        "Studio Dr near Village Way",
                        "Lindfield Rd at Helensvale Plaza hail 'n' ride",
                        "Helensvale Primary School",
                        "Helensvale State High School"
                    ],
                    "3102: Monterey Keys - Coombabah": [
                        "Helensvale Rd near Monterey Keys Dr hail 'n' ride",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr near Creekwood Pl",
                        "River Links Bvd near Hope Island Rd hail 'n' ride",
                        "Oxenford Southport Rd near The Lakes Dr HnR",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Santa Barbara Rd near Chindrina St",
                        "Pinnaroo St near Mungala St",
                        "Akoonah St near Mungala St",
                        "Buddeh St near Santa Barbara Rd",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Cova Bvd at Hope Island Rd",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Boykambil Esp near Sheehan Ave hail 'n' ride",
                        "Nelson Ave near Dunnes Ave hail 'n' ride",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Broadwater Ave at Crescent Avenue",
                        "Shoe St near Boykambil Esp hail 'n' ride",
                        "Bert Hood St near Coombe Ave hail 'n' ride",
                        "Crescent Ave near Bert Hood St hail 'n' ride",
                        "Oxley Dr at Blaxland Avenue",
                        "Oxley Dr at Daisy Elms Park",
                        "Oxley Dr at Coombabah State Primary School",
                        "Oxley Dr at Hansford Road",
                        "Oxley Dr at Lae Drive",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd near Siena Pl",
                        "Pine Ridge Rd at Coombabah Road",
                        "Coombabah High School"
                    ],
                    "3103: Hickey Way - Keebra": [
                        "Nielsens Rd at Hickey Way",
                        "Hickey Way near Michelmore Rd hail 'n' ride",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Pappas Way near Dawnann Ct",
                        "Hinkler Dr near Alexander Dr hail 'n' ride",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Way at Cozens Way",
                        "Explorers Way at Garvie Place",
                        "William Duncan Primary School",
                        "McLeod St at Balfour Crescent",
                        "Cayuga St near Mortensen Rd hail 'n' ride",
                        "Mortensen Rd near The Linkway",
                        "Mortensen Rd near The Domain",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Price St at Earle Plaza",
                        "Southport Nerang Rd at Nerang interchange",
                        "City of Gold Coast, Nerang",
                        "Southport Nerang Rd at Parkridge Drive",
                        "Southport Nerang Rd at Central Park Plaza",
                        "Southport Nerang Rd at BP Central Park",
                        "Southport Nerang Rd at Ashmore Road",
                        "Trinity Lutheran School",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Ashmore City Shopping Centre",
                        "Aquinas Catholic College",
                        "Guardian Angels Catholic Primary",
                        "Nerang Rd at Wardoo Street",
                        "Keebra Park State High School"
                    ],
                    "3104: Bronberg Plaza - Surfers Paradise Primary": [
                        "Slatyer Ave at Bronberg Plaza",
                        "Slatyer Ave at Ferry Road",
                        "Thomas Dr near Anembo St",
                        "Thomas Dr near Parnoo St",
                        "Ferny Ave at Palm Avenue",
                        "Ferny Ave at Ocean Avenue",
                        "Tedder Avenue at Cronin Avenue",
                        "Tedder Ave at Montgomery Avenue",
                        "Tedder Ave near Main Beach Pde hail 'n' ride",
                        "Main Beach Pde near Stafford Ave",
                        "Main Beach Pde at Main Beach Tourist Park",
                        "Main Beach Pde at Woodroffe Avenue",
                        "Main Beach Pde at Breaker Street",
                        "Ocean Av at Surfers Paradise North station",
                        "Surfers Paradise",
                        "Remembrance Dr at Markwell Avenue",
                        "Surfers Paradise Primary School"
                    ],
                    "3105: Christine Ave - Marymount via Mattocks Rd": [
                        "Christine Ave at Olympus Drive",
                        "Christine Ave at Konda Way",
                        "Varsity Pde near University Dr",
                        "Varsity Pde at Lakefront Crescent",
                        "University Dr near Shore Ave",
                        "University Dr near Varsity Pde",
                        "Christine Ave at Varsity Sound Avenue",
                        "Christine Ave at Varsity College",
                        "Christine Ave at Regensberg Close",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Silvabank Drive",
                        "Mattocks Rd near Bluemoon Cl",
                        "Mattocks Rd at Bushtree Ct",
                        "Mattocks Rd at Viburnum Street",
                        "Marymount College"
                    ],
                    "3106: Mattocks Rd - Burleigh Heads": [
                        "Grevillea Dr near Eucalyptus Ave hail 'n' ride",
                        "Willow St near Wattle St",
                        "Brier Cr near Willow St hail 'n' ride",
                        "Coolibah Cr near Willow St",
                        "Mattocks Rd near Bushtree Ct",
                        "Treeview Dr near Redleaf Ct",
                        "Treeview Dr near Oakland Ct",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Treetop Court",
                        "Mattocks Rd at Bluemoon Cl",
                        "Christine Ave at Silvabank Drive",
                        "Silvabank Dr near Lomond Ct hail 'n' ride",
                        "Silvabank Dr near Yawl Ct hail 'n' ride",
                        "Cumberland Dr near Yodelay St",
                        "Cumberland Dr near Dorothy Pl hail 'n' ride",
                        "Southlake Dr near Cumberland Dr hail 'n' ride",
                        "Cumberland Dr near Silvabank Dr",
                        "Silvabank Dr near Christine Ave hail 'n' ride",
                        "Christine Ave at Bermuda Street",
                        "Whistler Dr near Caningeraba State School",
                        "Auk Ave at Dunlin Drive",
                        "Dunlin Dr near Razorbill St",
                        "Dunlin Dr at Courser Court",
                        "Christine Ave at Hillstar Avenue",
                        "Christine Ave at Spoonbill Court",
                        "Burleigh St near Omoa Ave",
                        "Burleigh St near Omao Ave hail 'n' ride",
                        "Burleigh St near Jabiru Ave",
                        "Burleigh St near Corella Ave",
                        "Acanthus Ave at Burleigh Heads Infants School"
                    ],
                    "3107: Dreamworld Parkway - Helensvale": [
                        "Dreamworld Pkwy at Foxwell Rd",
                        "Hope Island Rd at Anaheim Drive",
                        "River Links Bvd near Hope Island Rd hail 'n' ride",
                        "Monterey Keys Dr at Creekwood Place",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Helensvale State High School",
                        "Discovery Dr at Kingaroy Avenue",
                        "Helensvale Primary School"
                    ],
                    "3108: Mudgeeraba - Robina High": [
                        "Tallai Rd near Cromwell Ct hail 'n' ride",
                        "Baileys Rd near Tallai Rd hail 'n' ride",
                        "Baileys Rd near Underhill Pl hail 'n' ride",
                        "Wallandra Rd near Baileys Rd hail 'n' ride",
                        "Berrigans Rd near Wallandra Dr hail 'n' ride",
                        "Gold Coast Springbrook Rd near Hardys Rd HnR",
                        "Old Coach Rd at Wallandra Road",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Sid Bigg Park",
                        "Mudgeeraba Rd near Scullin St",
                        "Robina State High School"
                    ],
                    "3109: Mudgeeraba - Robina High": [
                        "Railway Street at Robert St",
                        "Franklin Dr near McLachlan Ave hail 'n' ride",
                        "Old Coach Rd at Wallandra Road",
                        "Rainbow Dr near Cobai Dr",
                        "Rainbow Dr at Universe Court",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Sid Bigg Park",
                        "Mudgeeraba Rd near Scullin St",
                        "Leviathan Dr near Victory Dr hail 'n' ride",
                        "Robina State High School"
                    ],
                    "3110: Finnegan Way - Pimpama Colleges": [
                        "Finnegan Way at Felix Entrance",
                        "Finnegan Way at Lily Avenue",
                        "Finnegan Way at Cirrus Way",
                        "Kerkin Rd South at St Joseph's College",
                        "Kerkin Rd S at Vanes Street",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3111: Guineas Creek Rd - Currumbin Primary": [
                        "Guineas Creek Rd at Riverside Drive",
                        "Simpsons Rd near Calcita Ave hail 'n' ride",
                        "Simpsons Rd near Buckingham Way hail 'n' ride",
                        "Westminster Bvd near Cornwall Dr hail 'n' ride",
                        "Guineas Creek Rd at Doubleview Drive",
                        "Galleon Way at Aegean Way",
                        "Ware Dr near Aethalia St",
                        "Ware Dr near Tudor St",
                        "Galleon Way near Billabong Ct",
                        "Galleon Way at St Augustines School",
                        "Galleon Way at Brigantine Court",
                        "Galleon Way near Keegan Cct",
                        "Galleon Way near Jutland Pl",
                        "Clives Cct at Hoffschildt Drive",
                        "Clives Cct near Robinson Pl",
                        "Clives Cct near Bernoth St",
                        "Bienvenue Dr near Border Dr",
                        "Cannon Dr near The Cross Rd",
                        "Currumbin Creek Rd near Mainsail St",
                        "Currumbin Creek Rd at Nuban St",
                        "Currumbin Creek Rd near Traders Way",
                        "Currumbin Creek Rd at Love Street",
                        "Currumbin State Primary School",
                        "Palm Beach Currumbin State High School"
                    ],
                    "3112: Village Blvd - Pimpama Colleges": [
                        "Village Bvd at Dorset Street",
                        "Village Bvd at Chisolm Way",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Depot Rd near Pimpama Jacobs Well Rd",
                        "Bedford Rd near Attenborough Rd hail 'n' ride",
                        "Bedford Rd near Katie St hail 'n' ride",
                        "Sarabah Way near Narrien St hail 'n' ride",
                        "Kosciuszko Cct near Sarabah Way hail 'n' ride",
                        "Gainsborough Dr at Flinders Street",
                        "Gainsborough Dr near Towarri St hail 'n' ride",
                        "Gainsborough Dr near Swan Rd hail 'n' ride",
                        "Swan Rd near Yatala St hail 'n' ride",
                        "Swan Rd at Aquila Reserve",
                        "Gawthem Dr at Gainsborough State School",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3113: The Heights - Pimpama Primary": [
                        "Old Coach Rd near Coomera Springs Bvd",
                        "The Heights Bvd near Song Cr hail 'n' ride",
                        "The Heights Bvd near Peak Cr hail 'n' ride",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Waverly Dr at Persimmon Street",
                        "Waterhouse Dr near McLachlan Cct hail 'n' ride",
                        "Bella Bvd at Deepak Drive",
                        "Bella Bvd near Matthews Cr hail 'n' ride",
                        "Pimpama Primary School"
                    ],
                    "3114: Miami - Tallebudgera via Burleigh Waters": [
                        "Hillcrest Pde near Cantala Ave",
                        "Albion Ave near Dawn Pde",
                        "Dawn Pde near Albion Ave",
                        "Dawn Pde near Tulip St hail 'n' ride",
                        "Mountain View Ave near Joeith Ct",
                        "Mountain View Ave near Doggett Dr",
                        "Honeyeater Dr near Quail Ct",
                        "Honeyeater Dr near Nuthatch St",
                        "Honeyeater Dr at Thornbill Place",
                        "Cassowary Dr at Christine Avenue",
                        "Christine Ave at Caningeraba State School",
                        "Whistler Dr near Caningeraba State School",
                        "Auk Ave at Dunlin Drive",
                        "Dunlin Dr near Razorbill St",
                        "Dunlin Dr at Courser Court",
                        "Christine Ave at Hillstar Avenue",
                        "Christine Ave at Spoonbill Court",
                        "Burleigh St near Omoa Ave",
                        "Burleigh St near Omao Ave hail 'n' ride",
                        "Burleigh St near Jabiru Ave",
                        "Burleigh St near Corella Ave",
                        "Burleigh St near Sandpiper Dr",
                        "Burleigh St at Acanthus Ave",
                        "Acanthus Ave near Dotterel Dr hail 'n' ride",
                        "Marymount College",
                        "West Burleigh Rd near Kabool Rd hail 'n' ride",
                        "Tallebudgera Creek Rd near Tsipura Dr HnR",
                        "Tallebudgera Creek Rd near Heather St HnR",
                        "St Andrews College",
                        "Tallebudgera Primary School"
                    ],
                    "3115: Halfway Dr - OWHS": [
                        "Halfway Dr at Norfolk Village Primary School",
                        "Halfway Dr near Carallia Ct hail 'n' ride",
                        "Halfway Dr near Karall St hail 'n' ride",
                        "Pascoe Rd at Halfway Drive",
                        "Cuthbert Dr near Brookside Cct",
                        "Ormeau Woods High School"
                    ],
                    "3116: Molendinar - Sommerset College": [
                        "Ashmore Rd near Macquarie Ave hail 'n' ride",
                        "Southport Nerang Rd at Ashmore Road",
                        "Numeralla Ave near Yarran Dr",
                        "Ashmore Rd at Reed Street",
                        "Southport Nerang Rd at BP Central Park",
                        "Southport Nerang Rd at Stewart Parade",
                        "Southport Nerang Rd at Bellara Street",
                        "Southport Nerang Rd at Parkridge Drive",
                        "City of Gold Coast, Nerang",
                        "Southport Nerang Rd at Nerang interchange",
                        "All Saints Anglican School",
                        "Robina station, stop D",
                        "Robina State High School",
                        "Somerset College"
                    ],
                    "3117: Molendinar - Broadbeach": [
                        "Ashmore Rd near Macquarie Ave hail 'n' ride",
                        "Southport Nerang Rd at Stewart Parade",
                        "Southport Nerang Rd at Nerang interchange",
                        "Price St at Earle Plaza",
                        "Birribi Ave near Nerang River Dr",
                        "Weedons Rd at Nerang High School",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "Hinkler Dr near Alexander Dr hail 'n' ride",
                        "Bonooroo Park Shopping Centre",
                        "Nielsens Rd at Hickey Way",
                        "Birmingham Rd at The Boulevard",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Dunlop Ct at Merrimac State High School",
                        "Markeri St near Intrepid Dr",
                        "Markeri St near Rumrunner St",
                        "Markeri St near Sunshine Bvd",
                        "Sunshine Bvd near Markeri St",
                        "Sunshine Bvd at Gooding Park",
                        "Sunshine Bvd at Bordeaux Street",
                        "Sunshine Bvd at Merrimac Boulevard",
                        "Sunshine Bvd at Sonder Street",
                        "Broadbeach Primary School"
                    ],
                    "3119: Hardys Rd - Marymount via Bridgeman & Bonogin": [
                        "Gold Coast Springbrook Rd near Hardys Rd HnR",
                        "Hardys Rd near Natan Rd hail 'n' ride",
                        "Hardys Rd near Gunsynd Dr hail 'n' ride",
                        "Glenmore Dr near Bonnie Ct hail 'n' ride",
                        "Glenmore Dr near Leyshon Ct hail 'n' ride",
                        "Glenmore Dr near Davenport Dr hail 'n' ride",
                        "Bonogin Rd near Fairy Wren Ct hail 'n' ride",
                        "Bonogin Rd near Gardenia Dr hail 'n' ride",
                        "Bonogin Rd near Smith Rd hail 'n' ride",
                        "Bonogin Rd near Tulipwood Dr hail 'n' ride",
                        "Bonogin Rd near Warra Ct hail 'n' ride",
                        "Gunsynd Dr near Tulloch Cr hail 'n' ride",
                        "Todman Dr near Comic Ct hail 'n' ride",
                        "Bonogin Rd near Riverina Ct hail 'n' ride",
                        "Swanton Dr near Somerset Dr",
                        "Swanton Dr near Springsure Dr",
                        "Swanton Dr near Chute St",
                        "Leviathan Dr near Victory Dr hail 'n' ride",
                        "Somerset Dr near Leviathan Dr",
                        "Gemvale Rd near Somerset Dr",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Bridgman Dr near Old Coach Rd",
                        "Bridgman Dr near Heulan Ct",
                        "Bridgman Dr near Royston Cr",
                        "Bridgman Dr near Woodland Dr",
                        "Woodland Dr near Navars St",
                        "Old Coach Rd near Bridgman Dr",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Marymount College"
                    ],
                    "3122: Nerang Interchange - Merrimac Primary": [
                        "Southport Nerang Rd at Nerang interchange",
                        "Hinkler Dr near Explorers Way",
                        "Dormello Dr near Widden Ct hail 'n' ride",
                        "Hinkler Dr near San Fernando Dr hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Alkira Way near Quambone St hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Hannah Ct hail 'n' ride",
                        "Gooding Dr at Bourton Road",
                        "Jondique Ave at Saint Michaels College",
                        "Ghilgai Rd near Entry Dr",
                        "Ghilgai Rd near Griffon St",
                        "Merrimac State Primary School"
                    ],
                    "3123: Explorers Way - Merrimac High": [
                        "Hinkler Dr near Explorers Way hail 'n' ride",
                        "Explorers Way near Nabarlek Dr hail 'n' ride",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Way at Cozens Way",
                        "Explorers Way at Garvie Place",
                        "Alexander Dr near Richard Cr",
                        "Alexander Dr at Kahlua Court",
                        "Bonooroo Park Shopping Centre",
                        "Nielsens Rd at Hickey Way",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Dunlop Ct at Merrimac State High School"
                    ],
                    "3124: Crestwood Dr - Benowa": [
                        "Crestwood Dr at Crestwood Plaza",
                        "Crestwood Dr at Watergum Parade",
                        "Breakspear Rd at Mahogany Hill Park",
                        "Macquarie Ave at Lachlan Avenue",
                        "Mitchell Ave near Sturt St",
                        "Cotlew St at McCowan St",
                        "Cotlew St near Patonga St",
                        "Currumburra Rd near Mualla Dr",
                        "Currumburra Rd at Mualla Drive",
                        "Currumburra Rd near Tangerine Row",
                        "Benowa Rd at Benowa State High School"
                    ],
                    "3125: Nerang rail - Keebra Park High": [
                        "Nerang station, stop E",
                        "Keebra Park State High School"
                    ],
                    "3126: Reserve Rd - Trinity College": [
                        "Reserve Road at Hargraves Rd",
                        "Reserve Rd near Goldcrest Dr",
                        "Reserve Rd near Reserve Rd hail 'n' ride",
                        "Baileys Mountain Rd near Courtney Dr hail 'n' ride",
                        "Baileys Mountain Rd near Ruffles Rd hail 'n' ride",
                        "Ruffles Rd near Hotham Creek Rd hail 'n' ride",
                        "Hotham Creek Rd near Fern Hill Dr hail 'n' ride",
                        "Tillyroen Rd near Mirambeena Dr hail 'n' ride",
                        "Lansdowne Dr near Upper Ormeau Rd hail 'n' ride",
                        "River Run Cct near Lansdowne Dr",
                        "Ellenborough Ave near Terania Ave",
                        "Ormeau Ridge Rd near Sir Charles Holme Dr",
                        "Ormeau Ridge Rd near Johnson Pde",
                        "Peachey Road interchange hail 'n' ride",
                        "Peachey Rd at Doherty Ct",
                        "Vaughan Dr near Wille Ct hail 'n' ride",
                        "Vaughan Dr near Beausang Pl hail 'n' ride",
                        "Peachey Rd near Philben Dr hail 'n' ride",
                        "Philben Dr near Peachey Rd",
                        "Philben Dr near Winfield Rd",
                        "Winfield Rd near Metcalf Ct hail 'n' ride",
                        "Winfield Rd near Leaver Ct hail 'n' ride",
                        "Pascoe Rd near Winfield Rd hail 'n' ride",
                        "Pascoe Rd near Hennie Cr hail 'n' ride",
                        "Pascoe Rd near Solanum St",
                        "Pascoe Rd at Halfway Drive",
                        "Cuthbert Dr near Brookside Cct",
                        "Trinity College and St Josephs Primary"
                    ],
                    "3127: Southport Station - Keebra": [
                        "Southport bus station, stop A",
                        "Scarborough St at White Street",
                        "Queen St at Garden Street",
                        "Nerang St at West End Shops",
                        "Nerang St at Falconer Street",
                        "Keebra Park State High School"
                    ],
                    "3128: Oxenford - Helensvale High": [
                        "California Dr near Queens Park Cct hail 'n' ride",
                        "California Dr near Oregon Way",
                        "Oxenford State School",
                        "Michigan Dr near Swindon Pl",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Leo Graham Way near Cottonwood Pl",
                        "Entertainment Dr at Movie World",
                        "Helensvale State High School"
                    ],
                    "3153: Nerang Rail - Keebra Park High school (express)": [
                        "Nerang station, stop E",
                        "Keebra Park State High School"
                    ],
                    "3154: Mermaid Waters - Marymount College via GC Hwy": [
                        "Gold Coast Hwy at Mermaid Beach South station",
                        "Sunshine Bvd near Markeri St",
                        "Sunshine Bvd near Cadence Ave",
                        "Oceanic Dr near Launch Rd",
                        "Oceanic Dr near Cottsloe Dr",
                        "Oceanic Dr near Bowline Rd",
                        "Sunshine Bvd near Pacific Ave",
                        "Pacific Ave near Sonia St",
                        "Gold Coast Hwy at Miami North station",
                        "Gold Coast Hwy at Miami station",
                        "Gold Coast Hwy at Third Avenue CLOSED until 26-04-26",
                        "Marymount College"
                    ],
                    "3160: Coomera Springs - Foxwell Secondary College": [
                        "The Heights Bvd near Pinnacle Way hail 'n' ride",
                        "The Heights Bvd near Song Cr hail 'n' ride",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Coomera Springs Bvd at Dayflower Street",
                        "Coomera Springs Bvd at Sandpiper Court",
                        "Nightjar Dr at Butcher Bird Circuit",
                        "Cassinia Link near Nightjar Dr hail 'n' ride",
                        "Bridie Dr near Birley Link hail 'n' ride",
                        "Bridie Dr near Jagera Dr hail 'n' ride",
                        "Days Rd near Bridie Dr hail 'n' ride",
                        "Days Rd near Nightjar Rd hail 'n' ride",
                        "Old Coach Rd near Days Rd",
                        "Old Coach Rd near Billinghurst Cr",
                        "Billinghurst Cr at Livingstone Street",
                        "Billinghurst Cr near Jessica Dr",
                        "Billinghurst Cr near Godden Dr",
                        "Turnbull Dr near Abraham Rd hail 'n' ride",
                        "Foxwell Rd at Foxwell State Secondary College"
                    ],
                    "3161: Coomera Rivers & Picnic Creek - Foxwell Secondary": [
                        "George Alexander Wy near Bloom Avenue",
                        "George Alexander Way near Hovea Street HnR",
                        "Celestial Way near Carina St hail 'n' ride",
                        "Celestial Way near Azure Way hail 'n' ride",
                        "Orlando Dr near Jackson Street",
                        "Picnic Creek State School",
                        "Edwardson Dr near Amity Rd hail 'n' ride",
                        "Foxwell Rd at Foxwell State Secondary College"
                    ],
                    "3174: Halfway Dr - OWHS": [
                        "Halfway Dr at Norfolk Village Primary School",
                        "Halfway Dr near Carallia Ct hail 'n' ride",
                        "Halfway Dr near Karall St hail 'n' ride",
                        "Halfway Dr near Pascoe Rd hail 'n' ride",
                        "Pascoe Rd at Halfway Drive",
                        "Cuthbert Dr near Brookside Cct",
                        "Ormeau Woods High School"
                    ],
                    "3177: Molendinar - Benowa": [
                        "Ashmore Rd near Macquarie Ave hail 'n' ride",
                        "Glenmore Dr near Lochinvar Ct hail 'n' ride",
                        "Numeralla Ave near Yarran Dr",
                        "Numeralla Ave near Maloo Pl",
                        "Currumburra Rd at Ashmore Primary School",
                        "Currumburra Rd at Ashmore State Primary School",
                        "Cotlew St at Ashmore Plaza",
                        "Cotlew St at Parkleigh Court",
                        "Cotlew St at Hermitage Close",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at St Kevins Catholic Primary"
                    ],
                    "3179: Finnegan Way - Pimpama Colleges": [
                        "Finnegan Way at Felix Entrance",
                        "Finnegan Way at Lily Avenue",
                        "Finnegan Way at Cirrus Way",
                        "Kerkin Rd South at St Joseph's College",
                        "Kerkin Rd S at Vanes Street",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3180: Pimpama Colleges - Upper Coomera": [
                        "Old Coach Rd at Days Road",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3181: Southport - Labrador": [
                        "Southport bus station, stop B",
                        "Scarborough St at Marshall Lane",
                        "Scarborough St at Southport Transit Centre",
                        "Scarborough St near High St",
                        "Walton St near Worendo St",
                        "Stevens St near William St",
                        "Clayton St near Musgrave Ave",
                        "Ernest St near Robert St",
                        "Robert St near Muir St",
                        "Ahern St near Robert St",
                        "Ahern St near Central St",
                        "Central St near Proud St",
                        "Muir St near Grace Ave",
                        "Imperial Pde near Turpin Rd"
                    ],
                    "3182: Coomera Waters - Pimpama Colleges": [
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3184: Waverly Dr - Pimpama Colleges": [
                        "Waverly Dr at Persimmon Street",
                        "Waterhouse Dr near McLachlan Cct hail 'n' ride",
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3185: Varsity Lakes - Robina Primary": [
                        "Varsity Pde at Varsity Lakes College",
                        "University Dr near Shore Ave",
                        "University Dr near Varsity Pde",
                        "Christine Ave at Konda Way",
                        "Christine Ave at Goldwater Drive",
                        "Laurel Oak Dr near Lancewood Cct hail 'n' ride",
                        "Lancewood Cct near Applegum Ct hail 'n' ride",
                        "Laurel Oak Dr near Camphor Wood Ct hail 'n' ride",
                        "Scottsdale Dr at Christine Avenue",
                        "Christine Ave at Olympus Drive",
                        "Varsity Sound Ave near Azzurra Dr",
                        "Varsity College Junior Campus",
                        "Christine Ave at Varsity College",
                        "Varsity Pde near University Dr",
                        "Varsity Pde at Lakefront Crescent",
                        "Christine Ave near Scottsdale Dr hail 'n' ride",
                        "Killarney Ave at Robina State School"
                    ],
                    "3197: The Observatory - Marymount via Golden Grove": [
                        "Observatory Dr near Palomar St",
                        "Barden Ridge Rd near Observatory Dr hail 'n' ride",
                        "Barden Ridge Rd near Willow Tree Dr hail 'n' ride",
                        "Barden Ridge Rd near Lowell St hail 'n' ride",
                        "Barden Ridge Rd near Golden Grove Bvd HnR",
                        "Golden Grove Bvd near Skywatch Cct hail 'n' ride",
                        "Observatory Dr near Golden Grove Bvd",
                        "Observatory Dr near Grove Creek Cl",
                        "Wyllie Way at Gordonia Dr",
                        "Kingsmore Bvd near Tuckeroo Pl",
                        "Marymount College"
                    ],
                    "3301: Currumbin Primary - Kennedy Dr": [
                        "Currumbin State Primary School",
                        "Pacific Pde at Wallace Nicoll Park",
                        "Pacific Pde at Currumbin Beach",
                        "Currumbin Wildlife Sanctuary",
                        "Teemangum St at Kropp Park",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Toolona St near Atkin St",
                        "Chaffey St near Narrane St hail 'n' ride",
                        "Kaleena St near Cabarita Ave",
                        "Cabarita Ave near Kallena St",
                        "Cabarita Ave near Nangana St hail 'n' ride",
                        "Cabarita Ave near Mirreen Dr",
                        "Taperell Dr near Wickham Cr",
                        "Toolona St near Durran St",
                        "Coolangatta Rd near Cabarita Ave",
                        "Kitchener St near Morshead St",
                        "Monash St near Foch St hail 'n' ride",
                        "Inland Dr near Boyd St",
                        "Inland Dr at Triton Parade",
                        "Boyd St near Tugun St",
                        "Coolangatta Rd near Kiewa Ave",
                        "Coolangatta Rd near Loongana Ave",
                        "Coolangatta Rd at Kirribin Street",
                        "Golden Four Dr at George Street",
                        "Cahill Street",
                        "Golden Four Dr at Archer Street",
                        "Golden Four Dr at North Kirra Beach",
                        "Ducat St near Caloola Dr"
                    ],
                    "3302: Palm Beach Primary - Golden Four Dr": [
                        "Townson Ave near Nineteenth Ave",
                        "Nineteenth Ave at Angelica Street",
                        "Avocado St opp Elanor State High School",
                        "Avocado St at Jarrahdale Dr",
                        "KP McGrath Dr at Seaview Parade",
                        "KP McGrath Dr at Murtha Drive",
                        "Elanora State Primary School hail 'n' ride",
                        "The Pines Shopping Centre, stop A",
                        "Sarawak Ave at Salk Oval",
                        "Palm Beach Currumbin State High School",
                        "Palm Beach Currumbin High School",
                        "Thrower Dr near Luzon Pde",
                        "Gold Coast Hwy at Thrower Drive",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Toolona St near Atkin St",
                        "Kaleena St near Cabarita Ave",
                        "Cabarita Ave near Mirreen Dr",
                        "Taperell Dr near Wickham Cr",
                        "Chaffey St near Narrane St hail 'n' ride",
                        "Monash St near Foch St hail 'n' ride",
                        "Boyd St near Tugun St",
                        "Coolangatta Rd near Kiewa Ave",
                        "Coolangatta Rd near Loongana Ave",
                        "Coolangatta Rd at Kirribin Street",
                        "Golden Four Dr at George Street"
                    ],
                    "3303: Marymount - Simpsons Rd via Tallebudgera & Elanor": [
                        "Marymount College",
                        "West Burleigh Rd near Kabool Rd hail 'n' ride",
                        "Skyline Tce near Ladds Ridge Rd hail 'n' ride",
                        "Ladds Ridge Rd at McCubbin Ct hail 'n' ride",
                        "St Andrews College",
                        "Valley Dr near Green Lane hail 'n' ride",
                        "Dudgeon Dr near Jersey Ct hail 'n' ride",
                        "Nineteenth Ave at Kalmia Court",
                        "Ironbark St at Angelica Street",
                        "Ironbark St near Daisy St",
                        "Ironbark St at Boab Street",
                        "Avocado St at Jarrahdale Dr",
                        "Doubleview Dr at Swanbourne Way",
                        "Doubleview Dr at Attadale Court",
                        "Simpsons Rd near Calcita Ave hail 'n' ride",
                        "Simpsons Rd near Killara St hail 'n' ride",
                        "Simpsons Rd near Buckingham Way hail 'n' ride",
                        "Westminster Bvd near Cornwall Dr hail 'n' ride"
                    ],
                    "3304: Tallebudgera Primary - Golden Four Dr": [
                        "Tallebudgera Primary School",
                        "Ironbark St at Angelica Street",
                        "Ironbark St near Daisy St",
                        "Ironbark St at Boab Street",
                        "Avocado St at Jarrahdale Dr",
                        "KP McGrath Dr at Seaview Parade",
                        "KP McGrath Dr at Murtha Drive",
                        "KP McGrath Dr at Elanora State School",
                        "Guineas Creek Rd at Riverside Drive",
                        "Galleon Way at Aegean Way",
                        "Ware Dr near Aethalia St",
                        "Ware Dr near Tudor St",
                        "Galleon Way at St Augustines School",
                        "Galleon Way at Brigantine Court",
                        "Galleon Way near Keegan Cct",
                        "Galleon Way near Jutland Pl",
                        "Clives Cct at Hoffschildt Drive",
                        "Clives Cct near Robinson Pl",
                        "Clives Cct near Bernoth St",
                        "Bienvenue Dr near Border Dr",
                        "Currumbin Creek Rd near Mainsail St",
                        "Currumbin Creek Rd at Nuban St",
                        "Currumbin Creek Rd near Traders Way",
                        "Currumbin Creek Rd at Love Street",
                        "Currumbin Creek Rd at Currumbin RSL",
                        "Duringan St at Fielding Street",
                        "Duringan St at Panorama Drive",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Toolona St near Atkin St",
                        "Kaleena St near Cabarita Ave",
                        "Cabarita Ave near Mirreen Dr",
                        "Mireen Dr near Yolanta Dr hail 'n' ride",
                        "Costelloe St near Taperell Dr hail 'n' ride",
                        "Taperell Dr near Wickham Cr",
                        "Monash St near Foch St hail 'n' ride",
                        "Boyd St near Tugun St",
                        "Coolangatta Rd near Kiewa Ave",
                        "Coolangatta Rd near Loongana Ave",
                        "Coolangatta Rd at Kirribin Street",
                        "Golden Four Dr at George Street"
                    ],
                    "3305: Robina High - Mattocks Rd": [
                        "Robina State High School",
                        "Killarney Ave near Huntingdale Cr",
                        "Killarney Ave at Robina State School",
                        "Glen Eagles Dr near Dundee Ct",
                        "Glen Eagles Dr near Karrinyup Pl",
                        "Glen Eagles Dr near Firestone Ct",
                        "Ron Penhaligon Way at Banff Court",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way near Bothwell St",
                        "Ron Penhaligon Way near Commerce Dr",
                        "Manly Dr near Pipers Pt",
                        "Manly Dr near Sandringham Dr",
                        "Pyrmont St near Cottesloe Dr",
                        "Cottesloe Dr near Manly Dr",
                        "Cottesloe Dr near Vancouver Dr",
                        "Bermuda St at Lake Orr",
                        "Christine Ave at Bermuda Street",
                        "Christine Ave at Silvabank Drive",
                        "Mattocks Rd near Bluemoon Cl",
                        "Mattocks Rd at Bushtree Ct",
                        "Mattocks Rd at Viburnum Street"
                    ],
                    "3306: Somerset College - Currumbin Creek Rd": [
                        "Somerset College",
                        "Nineteenth Ave near Mallawa Dr",
                        "Nineteenth Ave at Angelica Street",
                        "Ironbark St at Angelica Street",
                        "Ironbark St near Daisy St",
                        "Ironbark St at Boab Street",
                        "Avocado St at Jarrahdale Dr",
                        "KP McGrath Dr at Seaview Parade",
                        "KP McGrath Dr at Murtha Drive",
                        "Murtha Dr at Boya Court",
                        "Murtha Dr at Dongarra Close",
                        "Murtha Dr at Swanbourne Way",
                        "Murtha Dr at Myco Court",
                        "Galleon Way at Aegean Way",
                        "Galleon Way near Billabong Ct",
                        "Galleon Way at Brigantine Court",
                        "Galleon Way near Keegan Cct",
                        "Galleon Way near Jutland Pl",
                        "Currumbin Creek Rd near Mainsail St"
                    ],
                    "3307: Merrimac Primary - Bilambil": [
                        "Merrimac State Primary School",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Jondique Avenue",
                        "Ghilgai Rd near Entry Dr",
                        "Ghilgai Rd near Griffon St",
                        "Jondique Ave at Saint Michaels College",
                        "Gooding Dr at Bourton Road",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "Bourton Rd near Willunga Pl",
                        "Highfield Dr near Cabot Ct",
                        "All Saints Anglican School",
                        "Highfield Dr near Breakwater Road",
                        "Robina station, stop D",
                        "Somerset Dr near Leviathan Dr",
                        "Somerset College",
                        "Gemvale Rd near Somerset Dr",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gold Coast Hwy at Palm Beach Police Station",
                        "Gold Coast Hwy at Thrower Drive",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Currumbin Wildlife Sanctuary",
                        "Teemangum St at Kropp Park",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Dr at Shell Street",
                        "Tugun Village Community Centre hail 'n' ride",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Mills St hail 'n' ride",
                        "Golden Four Dr at George Street",
                        "Cahill Street",
                        "Coolangatta State Primary School",
                        "Miles St near Winston St",
                        "Marine Pde at Kirra Beach",
                        "McLean St at Queen Elizabeth Park",
                        "Coolangatta Central",
                        "Griffith St at Coolangatta East",
                        "Wharf St at Tweed Mall",
                        "Wharf St near Florence St",
                        "Wharf St near Monastery Lane",
                        "Minjungbal Dr near Dry Dock Rd",
                        "Minjungbal Dr near Agnes St",
                        "Minjungbal Dr near Lloyd St",
                        "Minjungbal Dr at South Tweed Heads Coach Stop",
                        "Minjungbal Dr at Tweed City Shopping Centre",
                        "Minjungbal Dr near Soorley St",
                        "Minjungbal Dr at Tweed Hub",
                        "Sexton Hill Dr at Pioneer Parade Footbridge",
                        "Terranora Rd at The Pavilions Marketplace",
                        "Bilambil Post Office",
                        "Scenic Dr near Simpson Dr"
                    ],
                    "3308: Marymount - Tweed Heads via Townson Ave": [
                        "Marymount College",
                        "Burleigh Heads station",
                        "Tallebudgera Dr near Townson Av hail 'n' ride",
                        "Mallawa Dr near Tallebudgera Dr hail 'n' ride",
                        "Mallawa Dr near Abella St hail 'n' ride",
                        "Mallawa Dr near Nineteenth Av hail 'n' ride",
                        "Gold Coast Hwy at Thrower Drive",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Currumbin Wildlife Sanctuary",
                        "Teemangum St at Kropp Park",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Toolona St near Atkin St",
                        "Taperell Dr near Wickham Cr hail 'n' ride",
                        "Kitchener St near Morshead St hail 'n' ride",
                        "Coolangatta Rd near Kiewa Ave",
                        "Coolangatta Rd near Loongana Ave",
                        "Coolangatta Rd at Kirribin Street",
                        "Musgrave St at Coyne Street",
                        "Musgrave St at Kirra shops",
                        "Marine Pde at Kirra Beach",
                        "McLean St at Queen Elizabeth Park",
                        "Coolangatta Central",
                        "Griffith St at Coolangatta East",
                        "Wharf St at Tweed Mall"
                    ],
                    "3309: Miami High - Christine Ave": [
                        "Miami State High School",
                        "Christine Ave at Caningeraba State School",
                        "Christine Ave at Bermuda Street",
                        "Christine Ave at Silvabank Drive",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Regensberg Close",
                        "Christine Ave at Varsity College",
                        "Christine Ave at Varsity Sound Avenue",
                        "Christine Ave at Konda Way",
                        "Christine Ave at Goldwater Drive",
                        "Laurel Oak Dr near Lancewood Cct hail 'n' ride",
                        "Lancewood Cct near Cordata Ct",
                        "Lancewood Cct near Eugenia Cct",
                        "Lancewood Cct near Applegum Ct hail 'n' ride",
                        "Laurel Oak Dr near Camphor Wood Ct hail 'n' ride",
                        "Scottsdale Dr at Christine Avenue",
                        "Christine Ave at Olympus Drive"
                    ],
                    "3310: Mudgeeraba Primary - Bonogin Rd": [
                        "Old Coach Rd at Mudgeeraba State School",
                        "Mudgeeraba Creek Primary School",
                        "Somerset Dr at Somerset College",
                        "Somerset Dr at Clover Hill Drive",
                        "Clover Hill Primary School",
                        "Gemvale Rd near Somerset Dr",
                        "Glastonbury Dr near Exercise St hail 'n' ride",
                        "Glastonbury Dr near Langport Pde hail 'n' ride",
                        "Langport Prd near Wiltshire Dr hail 'n' ride",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Bridgman Dr near Old Coach Rd",
                        "Bridgman Dr near Heulan Ct",
                        "Bridgman Dr near Royston Cr",
                        "Bridgman Dr near Woodland Dr",
                        "Woodland Dr near Navars St",
                        "Kingsmore Bvd near Tuckeroo Pl",
                        "Wyllie Way near Gordonia Dr",
                        "Observatory Dr near Grove Creek Cl",
                        "Observatory Dr near Golden Grove Bvd",
                        "Observatory Dr near Willow Tree Dr",
                        "Bonogin Rd near Warra Ct hail 'n' ride",
                        "Bonogin Rd near Somerset Dr hail 'n' ride"
                    ],
                    "3311: Hillcrest College - Banora Point": [
                        "Somerset College",
                        "Gemvale Rd near Somerset Dr",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gold Coast Hwy at Palm Beach Police Station",
                        "Gold Coast Hwy at Thrower Drive",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Currumbin Wildlife Sanctuary",
                        "Teemangum St at Kropp Park",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Dr at Shell Street",
                        "Tugun Village Community Centre hail 'n' ride",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Mills St hail 'n' ride",
                        "Golden Four Dr at George Street",
                        "Cahill Street",
                        "Coolangatta State Primary School",
                        "Miles St near Winston St",
                        "Marine Pde at Kirra Beach",
                        "McLean St at Queen Elizabeth Park",
                        "Coolangatta Central",
                        "Griffith St at Coolangatta East",
                        "Wharf St at Tweed Mall"
                    ],
                    "3312: Merrimac High - Dormello Dr": [
                        "Dunlop Ct at Merrimac State High School",
                        "Gooding Dr at Jondique Avenue",
                        "Jondique Ave at Saint Michaels College",
                        "Ghilgai Rd near Entry Dr",
                        "Ghilgai Rd near Griffon St",
                        "Gooding Dr at Bourton Road",
                        "Bourton Rd near Willunga Pl",
                        "Highfield Dr near Cabot Ct",
                        "All Saints Anglican School",
                        "Highfield Dr near Breakwater Road",
                        "Mudgeeraba Rd near Scullin St",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Mudgeeraba Rd near Quambone St",
                        "Quambone St near Jeremy Ct hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Alkira Way near Kabra Ct hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near Kurilpa St hail 'n' ride",
                        "Dormello Dr near San Fernando Dr hail 'n' ride"
                    ],
                    "3313: Helensvale High - Studio Dr": [
                        "Helensvale State High School",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Pacific Pines Bvd near Papara St",
                        "Pacific Pines Bvd near Glade Dr",
                        "Santa Isobel Bvd near Mussau St",
                        "Santa Isobel Bvd near Archipelago St hail 'n' ride",
                        "Pacific Pines High School",
                        "Pacific Pines Primary School",
                        "Santa Isobel Bvd near Pitcairn Way",
                        "Pitcairn Way near Beerwah St",
                        "Pitcairn Way near Springwood Ave",
                        "Pitcairn Way at Blackheath Terrace",
                        "Pitcairn Way at McAuley Parade",
                        "Pitcairn Way near Norris St",
                        "Universal St near Buchanan Ct",
                        "Universal St near Guy Lane",
                        "Universal St near Takahe St",
                        "Universal St near Crestridge Cr",
                        "Village Way near Studio Dr",
                        "Village Way near Drama St",
                        "Village Way near Mews Ct",
                        "Studio Dr near Hepburn Ct",
                        "Studio Dr near Village Way"
                    ],
                    "3314: Pacific Pines - Abraham Rd": [
                        "Pacific Pines High School",
                        "Helensvale State High School",
                        "Michigan Dr near Maple Ct hail 'n' ride",
                        "Oxenford State School",
                        "Michigan Dr near Swindon Pl",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Tamborine Oxenford Rd near Pinewood St HnR",
                        "Tamborine Oxenford Rd near Glenview Rd HnR",
                        "Greenview Dr near Stony Creek Dr hail 'n' ride",
                        "Greenview Rd near Saddle Back St hail 'n' ride",
                        "Yarrayne Valley Dr near Saddle Back St HnR",
                        "Tamborine Oxenford Rd near Cemetery Rd HnR",
                        "Reserve Rd near Jemima Pl",
                        "Stephens St near Macklin Ct hail 'n' ride",
                        "Stephens St near Farrer Ct hail 'n' ride",
                        "Stanfield Dr near Jullian Rd hail 'n' ride",
                        "Moran Dr near Acton Pl hail 'n' ride",
                        "Reserve Rd near Stephens St hail 'n' ride",
                        "Reserve Rd near Amelia St",
                        "Reserve Rd near Rose Valley Dr hail 'n' ride",
                        "Garawarra Cr near Rose Valley Dr hail 'n' ride",
                        "Garawarra Cr near Torrington St hail 'n' ride",
                        "Lysterfield Rise near Serendip Lane hail 'n' ride",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Reserve Rd near Jessica Dr",
                        "Reserve Rd near Abraham Rd hail 'n' ride"
                    ],
                    "3315: Miami - Nerang West via Broadbeach Waters": [
                        "Oceanic Dr at Miami School",
                        "Rio Vista Bvd near Barrier Reef Dr",
                        "Barrier Reef Dr near Deloraine Ct",
                        "Barrier Reef Dr near Halborne Dr",
                        "Barrier Reef Dr near Henning Ct",
                        "Barrier Reef Dr near Orpheus Rd",
                        "Barrier Reef Dr near Rio Vista Bvd",
                        "Rio Vista Bvd near Dunlop Ct",
                        "Dunlop Ct at Merrimac State High School",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Gooding Dr at Merrimac Golf Course",
                        "Nerang Broadbeach Rd at Nielsens Road",
                        "Birmingham Rd at The Boulevard",
                        "Nielsens Rd at Hickey Way",
                        "Bonooroo Park Shopping Centre",
                        "Alexander Dr at Sue Court",
                        "Alexander Dr near Richard Cr",
                        "William Duncan Primary School",
                        "Mortensen Rd near The Linkway",
                        "Mortensen Rd near The Domain",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Price St at Earle Plaza",
                        "Price St at Nerang State School",
                        "Southport Nerang Rd at Nerang interchange",
                        "Birribi Ave near Beaudesert Nerang Rd HnR",
                        "Gilston Rd at Weedons Rd hail 'n' ride",
                        "McLaren Rd at Beltana Way",
                        "McLaren Rd near Winchester Dr",
                        "Yarrimbah Dr near McLaren Rd hail 'n' ride",
                        "Dugandan St at Burra Street",
                        "Dugandan St near Koola Dr hail 'n' ride",
                        "Dugandan St at Teasdale Drive",
                        "Dugandan St at Bent Street",
                        "Dugandan St at Merloo Drive",
                        "Yarrimbah Dr near Goora St hail 'n' ride",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Billabirra Ct at Beaudesert Nerang Rd HnR",
                        "Beaudesert Nerang Rd at Oak Street"
                    ],
                    "3316: Nerang - Highfield Dr": [
                        "Nerang St at Nerang State School",
                        "Birribi Ave near Nerang River Dr",
                        "Nerang High School",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "Cayuga St near Mortensen Rd hail 'n' ride",
                        "McLeod St at Aberdeen Court",
                        "William Duncan Primary School",
                        "Explorers Way at Garvie Place",
                        "Explorers Way at Cozens Way",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Wy near Delta Cove Dr",
                        "Worongary Primary School",
                        "Explorers Way near Andamooka Ave hail 'n' ride",
                        "Explorers Way near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near Explorers Way",
                        "Barrine Dr near Mataranka Dr hail 'n' ride",
                        "Barrine Dr near Giles Grove hail 'n' ride",
                        "Dormello Dr near Widden Ct hail 'n' ride",
                        "Hinkler Dr near San Fernando Dr hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Alkira Way near Quambone St hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Hannah Ct hail 'n' ride",
                        "Bourton Rd near Willunga Pl",
                        "Highfield Dr near Cabot Ct",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Breakwater Road"
                    ],
                    "3317: St Michaels - Nerang Broadbeach Rd": [
                        "Jondique Ave at Saint Michaels College",
                        "Merrimac State Primary School",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp"
                    ],
                    "3318: Merrimac High - Hinklers Dr": [
                        "Merrimac State Primary School",
                        "Nerang Broadbeach Rd at Nielsens Road",
                        "Nerang Broadbeach Rd at Garden Grove",
                        "Riverside Home Caravan Park",
                        "Birmingham Rd near Nerang Broadbeach Rd hail 'n' ride",
                        "Birmingham Rd at Emerald Lakes Drive",
                        "Birmingham Rd at The Boulevard",
                        "Nielsens Rd near Hickey Way hail 'n' ride",
                        "Nielsens Rd at Hickey Way",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Pappas Way near Dawnann Ct",
                        "Hinkler Dr near Alexander Dr hail 'n' ride",
                        "Hinkler Dr near Explorers Way hail 'n' ride",
                        "Explorers Way near Nabarlek Dr hail 'n' ride",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Way at Cozens Way",
                        "Explorers Way at Garvie Place"
                    ],
                    "3319: Robina High - Benowa": [
                        "Robina State High School",
                        "Mudgeeraba Rd near Scullin St",
                        "Milky Way near Moonbeam Pde hail 'n' ride",
                        "Rainbow Dr at Universe Court",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Sid Bigg Park",
                        "Bourton Rd near Willunga Pl",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "All Saints Anglican School",
                        "Highfield Dr near Breakwater Road",
                        "Cheltenham Dr at Woody Views Way",
                        "Cheltenham Dr near Glenside Dr",
                        "Markeri St at Ron Penhaligon Way",
                        "Bermuda St at Hooker Boulevard",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Campbell St near Saywell St hail 'n' ride",
                        "Panitz St near Campbell St hail 'n' ride",
                        "Slatyer Ave at Bronberg Plaza",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at St Kevins Catholic Primary"
                    ],
                    "3320: Merrimac Primary - Carrara": [
                        "Merrimac State Primary School",
                        "Gooding Dr at Jondique Avenue",
                        "Ghilgai Rd near Entry Dr",
                        "Ghilgai Rd near Griffon St",
                        "Jondique Ave at Saint Michaels College",
                        "Gooding Dr at Bourton Road",
                        "Quambone St near Jeremy Ct hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Alkira Way near Kabra Ct hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near Kurilpa St hail 'n' ride",
                        "Dormello Dr near San Fernando Dr hail 'n' ride",
                        "Dormello Dr near Hinkler Dr hail 'n' ride",
                        "Bourton Rd near Willunga Pl",
                        "Highfield Dr near Cabot Ct",
                        "All Saints Anglican School",
                        "Highfield Dr near Breakwater Road",
                        "Station St at Centro Nerang",
                        "Price St at Nerang State School",
                        "Southport Nerang Rd at Nerang interchange",
                        "Price St at Earle Plaza",
                        "Birribi Ave near Nerang River Dr",
                        "Weedons Rd at Nerang High School",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "Cayuga St near Mortensen Rd hail 'n' ride",
                        "McLeod St at Aberdeen Court",
                        "William Duncan Primary School",
                        "Alexander Dr near Richard Cr",
                        "Alexander Dr at Kahlua Court",
                        "Pappas Way near Dawnann Ct",
                        "DNU Pappas Way near Spencer Rd hail 'n' ride",
                        "Pappas Way near Remount Pl",
                        "Pappas Way near Cambridge Ct",
                        "Pappas Way near Dearne Pl",
                        "Murev Way near Alzino Pl",
                        "Michelmore Rd near Woolmere St",
                        "Michelmore Rd near Hickey Way",
                        "Nielsens Rd at Hickey Way"
                    ],
                    "3321: Robina High - Gilston": [
                        "Robina State High School",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Worongary Rd near Harry Mills Dr hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Harry Mills Dr near Charland Ct hail 'n' ride",
                        "Vince Hinde Dr near Harry Mills Dr hail 'n' ride",
                        "Vince Hinde Dr near Worongary Rd hail 'n' ride",
                        "Worongary Rd near Glenrowan Dr hail 'n' ride",
                        "Worongary Rd at Gilston State School",
                        "Worongary Rd near Gilston Rd hail 'n' ride",
                        "Gilston Rd near Hinde Rd hail 'n' ride",
                        "Gilston Rd at Longhill Road",
                        "Gilston Rd at Worley Drive",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "Gilston Rd near Alexander Dr hail 'n' ride",
                        "McLeod St at Balfour Crescent",
                        "Mortensen Rd near The Linkway",
                        "Mortensen Rd near The Domain"
                    ],
                    "3322: Arundel Primary - Wintergreen": [
                        "Arundel State Primary School",
                        "Uplands Dr at Woodlands Way",
                        "Uplands Dr at Greenacre Drive",
                        "Greenacre Dr at Jamieson Dr",
                        "Greenacre Dr at Fairview Court",
                        "Greenacre Dr at Parkwood station",
                        "Napper Rd at Daintree Drive",
                        "Daintree Dr near Highview Pl",
                        "Wardley Dr at Napper Dr hail 'n' ride",
                        "Napper Rd at Tee Trees Boulevard",
                        "Napper Rd at Arundel Primary School",
                        "Parkwood Bvd near Peter Thomson Dr",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Gary Player Cr",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr near Suncrest Ct",
                        "Wintergreen Dr near Ballybunion Dr"
                    ],
                    "3323: Aquinas - Arundel": [
                        "Aquinas Catholic College",
                        "Guardian Angels Catholic Primary",
                        "Nerang Rd at Aquinas Catholic College",
                        "Henry Cotton Dr near Wintergreen Dr",
                        "Henry Cotton Dr near Hazeltine Pl",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Parkwood Bvd near Davis Ct",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Kel Nagle Ct",
                        "Allied Dr at Carnoustie Ct",
                        "Allied Dr near Range Ct",
                        "Central St near Allied Dr",
                        "Central St near Carrumbella Dr",
                        "Olsen Ave at Central Street Shops",
                        "Olsen Ave at Paul Sharratt Park",
                        "Olsen Ave at Allied Drive",
                        "Allied Dr at Central St",
                        "Allied Dr at Spikes Ct",
                        "Napper Rd at Arundel Primary School",
                        "Napper Rd near Benalla Ct",
                        "Daintree Dr near Highview Pl",
                        "Napper Rd at Daintree Drive",
                        "Greenacre Dr at Parkwood station",
                        "Greenacre Dr at Fairview Ct",
                        "Greenacre Dr at Jamieson Drive",
                        "Uplands Dr at Greenacre Drive",
                        "Uplands Dr at Woodlands Way",
                        "Uplands Dr at Brushwood Ridge Reserve",
                        "Arundel Dr near Neri Cr",
                        "Arundel Dr near Arundel Pl",
                        "Arundel Dr near Paterson Dr"
                    ],
                    "3324: Robina Primary - Robina": [
                        "Killarney Ave at Robina State School",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Tullamarine Dr near Glen Iris Pl",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Camberwell Cct near Caulfield Street",
                        "Camberwell Cct near Kensington St",
                        "Yarraville St at Camberwell Circuit",
                        "Yarraville St near Bentleigh Ct",
                        "Ron Penhaligon Way near Markeri St",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Ron Penhaligon Way near Homebush Dr",
                        "Ron Penhaligon Way near Tennyson Pl",
                        "Cheltenham Dr near Thorngate Dr",
                        "Cheltenham Dr at Woody Views Way",
                        "Investigator Dr at Robina State High hail 'n' ride",
                        "Robina State High School",
                        "Robina Town Centre Dr at Christine Avenue",
                        "Scottsdale Dr at Christine Avenue",
                        "Laurel Oak Dr near Scottsdale Dr hail 'n' ride",
                        "University Dr near Shore Ave",
                        "Bond University",
                        "University Dr near Cottesloe Dr"
                    ],
                    "3325: OWHS - Sir Charles Holm Dr": [
                        "Ormeau Woods High School",
                        "Ormeau Ridge Rd near Yarwood",
                        "Ormeau Ridge Rd near Watego Cr hail 'n' ride",
                        "Sir Charles Holm Dr near Islandview Tce HnR",
                        "Ormeau Ridge Rd near Mullins St hail 'n' ride",
                        "Ellenborough Ave near Terania Ave"
                    ],
                    "3326: Southport - Ashmore": [
                        "Keebra Park State High School",
                        "Southport State School",
                        "Queen Street station (Southport)",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B",
                        "Scarborough St at Marshall Lane",
                        "Scarborough St at Southport Transit Centre",
                        "Scarborough St near High St",
                        "Stevens St near William St",
                        "Brooke Ave at Musgrave Avenue",
                        "Brooke Ave at Southport State High School",
                        "Smith St at Shillington Avenue",
                        "Kumbari Ave near Smith Street Mwy",
                        "Musgrave Ave at Keith Hunt Park",
                        "Musgrave Ave near Botanical Dr",
                        "Olsen Ave at Boea Street",
                        "Government Rd at Galaxy Court",
                        "Government Rd near Jupiter Cl",
                        "Usher Ave near McMillan St",
                        "Central St at Central Street",
                        "Central St near Davebill Ct",
                        "Central St at Carrumbella Dr",
                        "Allied Dr at Central St",
                        "Allied Dr at Spikes Ct",
                        "Napper Rd at Arundel Primary School",
                        "Napper Rd near Benalla Ct",
                        "Daintree Dr near Highview Pl",
                        "Napper Rd at Daintree Drive",
                        "Greenacre Dr at Parkwood station",
                        "Greenacre Dr at Fairview Ct",
                        "Greenacre Dr at Jamieson Drive",
                        "Uplands Dr at Greenacre Drive",
                        "Uplands Dr at Woodlands Way",
                        "Parkwood Bvd near Peter Thomson Dr",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Gary Player Cr",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr near Suncrest Ct",
                        "Wintergreen Dr near Ballybunion Dr",
                        "Olsen Ave near Crestwood Dr hail 'n' ride",
                        "Crestwood Dr at Watergum Parade",
                        "Macquarie Ave near Batchworth Rd hail 'n' ride",
                        "Ashmore Rd near Macquarie Ave hail 'n' ride"
                    ],
                    "3327: Helensvale High - Guanaba": [
                        "Helensvale State High School",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Pacific Pines Bvd near Papara St",
                        "Pacific Pines Bvd near Glade Dr",
                        "Santa Isobel Bvd near Mussau St",
                        "Pacific Pines High School",
                        "Pacific Pines Primary School",
                        "Binstead Way at Pacific Pines Boulevard",
                        "Binstead Way at Studio Drive",
                        "Binstead Way at Jubilee Primary School",
                        "Binstead Way at Palmerston Drive",
                        "Universal St near Buchanan Ct",
                        "Gaven Primary School",
                        "Greenway Bvd near Keneally St hail 'n' ride",
                        "Greenway Bvd near Brissendon St",
                        "Park Lake Primary School",
                        "Matthews Dr near Roberts Dr hail 'n' ride",
                        "Gaven Arterial Rd at Felling Drive",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Cobb and Co Dr near Appollo Pl",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Lagoon Park Dr near Meadow Ct hail 'n' ride",
                        "Lagoon Park Dr near Summer Hill Cr hail 'n' ride",
                        "Greenacre Way near Lagoon Park Dr hail 'n' ride",
                        "Riverstone Crsg near Rivermill Tce hail 'n' ride",
                        "Riverstone Crsg near Northern Skies Tce HnR",
                        "Riverstone Crsg near Valley Brook Rise HnR",
                        "Riverstone Crsg near Hibiscus Cr hail 'n' ride",
                        "Riverstone Crsg near Prairie Av hail 'n' ride",
                        "Riverstone Crsg near Mountain View Pde HnR",
                        "Rivermill Tce near Plantation Cr hail 'n' ride",
                        "Rivermill Tce near Settlers Ave hail 'n' ride",
                        "Tuxedo Junction Dr near Maudsland Rd hail 'n' ride",
                        "Maudsland Rd near Guanaba Creek Rd hail 'n' ride",
                        "Burley Griffin Dr near Nabberu St hail 'n' ride",
                        "Guanaba Creek Rd near Stewart Rd hail 'n' ride",
                        "Coomera Valley Dr near Stewart St hail 'n' ride",
                        "Coomera Valley Dr near Lynwood Dr hail 'n' ride",
                        "Lynwood Dr near Guanaba Creek Rd hail 'n' ride",
                        "Tarata Rd near Guanaba Creek Rd hail 'n' ride",
                        "Link Rd near Tarata Rd hail 'n' ride",
                        "Birds Rd near Link Rd hail 'n' ride",
                        "Birds Rd near Maudsland Rd hail 'n' ride"
                    ],
                    "3328: Helensvale - Pacific Pines": [
                        "Helensvale State High School",
                        "Helensvale Primary School",
                        "Binstead Way at Pacific Pines Boulevard",
                        "Binstead Way at Studio Drive",
                        "Universal St near Hervey St hail 'n' ride",
                        "Universal St near Crestridge Cr",
                        "Universal St near Pinevale Dr",
                        "Gaven Primary School",
                        "Universal St near Buchanan Ct",
                        "Pitcairn Way near Norris St",
                        "Pitcairn Way at McAuley Parade",
                        "Pitcairn Way near Sangster Cr",
                        "Pitcairn Way at Lennox Street",
                        "Pitcairn Way near Belongil St",
                        "Pitcairn Way near Yaldara St",
                        "Pitcairn Way near Easter Cr",
                        "Archipelago St near Penrhyn St",
                        "Santa Isobel Bvd near Mussau St",
                        "Pacific Pines Bvd near Nandi Tce",
                        "Pacific Pines Bvd near Papara St",
                        "Pacific Pines Bvd near Capricorn Dr"
                    ],
                    "3329: Nerang - Bonogin": [
                        "Nerang High School",
                        "Gilston Rd at Worley Drive",
                        "Gilston Rd near Peter Mills Dr hail 'n' ride",
                        "Gilston Rd at Longhill Road",
                        "Worongary Rd near Kookaburra Dr hail 'n' ride",
                        "Gilston State School",
                        "Worongary Rd near Glenrowan Rd hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Harry Mills Dr near Charland Ct hail 'n' ride",
                        "Vince Hinde Dr near Harry Mills Dr hail 'n' ride",
                        "Worongary Rd near Random Way hail 'n' ride",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Worongary Rd near Woodvale Dr hail 'n' ride",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Wallandra Road",
                        "Franklin Dr near McLachlan Ave hail 'n' ride",
                        "Somerset Dr near Bonogin Rd hail 'n' ride",
                        "Robina Town Centre"
                    ],
                    "3330: Merrimac High - Gilston": [
                        "Dunlop Ct at Merrimac State High School",
                        "St Vincents Catholic Primary School",
                        "Gooding Dr at Merrimac Golf Course",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Jondique Avenue",
                        "Jondique Ave at Saint Michaels College",
                        "Gooding Dr at Bourton Road",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "Bourton Rd near Willunga Pl",
                        "Highfield Dr near Cabot Ct",
                        "All Saints Anglican School",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Breakwater Road",
                        "Mudgeeraba Rd near Scullin St",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Rainbow Dr at Universe Court",
                        "Cobai Dr at Chippewa Circuit",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Vince Hinde Dr near Worongary Rd hail 'n' ride",
                        "Harry Mills Dr near Charland Ct hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Worongary Rd near Glenrowan Dr hail 'n' ride",
                        "Gilston State School",
                        "Worongary Rd near Gilston Rd hail 'n' ride",
                        "Gilston Rd near Hinde Rd hail 'n' ride",
                        "Gilston Rd at Longhill Road",
                        "Gilston Rd at Worley Drive",
                        "Gilston Rd near Riverpark Dr hail 'n' ride"
                    ],
                    "3331: Marymount - Miami via Burleigh Waters": [
                        "Marymount College",
                        "Acanthus Ave near Dotterel Dr hail 'n' ride",
                        "Burleigh St near Acanthus Ave",
                        "Burleigh St at Sandpiper Dr",
                        "Burleigh St at Avocet Ave",
                        "Burleigh St near Jabiru Ave",
                        "Burleigh St at Carwell Dr",
                        "Christine Ave at Spoonbill Court",
                        "Christine Ave at Barbet Place",
                        "Dunlin Dr at Courser Ct",
                        "Dunlin Dr near Razorbill St",
                        "Auk Ave at Dunlin Drive",
                        "Whistler Dr near Cuckoo Cr",
                        "Christine Ave at Caningeraba State School",
                        "Cassowary Dr at Christine Avenue",
                        "Honeyeater Dr at Thornbill Place",
                        "Honeyeater Dr near Manakin Ave",
                        "Honeyeater Dr at Quail Ct",
                        "Mountain View Ave near Doggett Dr",
                        "Mountain View Ave near Russell Ct",
                        "Dawn Pde near Tulip St hail 'n' ride",
                        "Dawn Pde near Lesley Ave",
                        "Albion Ave near Bardon Ave",
                        "Hillcrest Pde near Paradise Ave"
                    ],
                    "3332: UCSC - Willowvale & Pimpama": [
                        "Upper Coomera College",
                        "Baileys Mountain Rd near Ruffles Rd hail 'n' ride",
                        "Ruffles Rd near Hotham Creek Rd hail 'n' ride",
                        "Hotham Creek Rd near Blacks Rd hail 'n' ride",
                        "Hotham Creek Rd near Fern Hill Dr hail 'n' ride",
                        "Waverly Dr at Rifle Range Road",
                        "Waverly Dr at Persimmon Street",
                        "Waterhouse Dr near McLachlan Cct hail 'n' ride",
                        "Bella Bvd at Deepak Drive",
                        "Bella Bvd near Matthews Cr hail 'n' ride",
                        "Depot Rd near Pimpama Jacobs Well Rd",
                        "Bedford Rd near Christopher St hail 'n' ride",
                        "Bedford Rd near Attenborough Rd hail 'n' ride",
                        "Yawalpah Rd at Salzburg Rd hail 'n' ride",
                        "Yawalpah Rd at Swan Road",
                        "Dixon Dr at Pimpama Junction",
                        "William Bvd at Tierney Way",
                        "William Bvd at Carnarvon Court",
                        "Cunningham Dr at Arcadia Boulevard",
                        "Kerkin Rd South at St Joseph's College",
                        "Finnegan Way at Cirrus Way",
                        "Finnegan Way at Lily Avenue"
                    ],
                    "3333: Varsity - Sommerset Dr": [
                        "Varsity Pde at Varsity Lakes College",
                        "Christine Ave at Varsity Sound Avenue",
                        "Varsity College Junior Campus",
                        "Christine Ave at Regensberg Close",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Silvabank Drive",
                        "Mattocks Rd near Bluemoon Cl",
                        "Treeview Dr at Treetop Court",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Oakland Court",
                        "Treeview Dr near Whipbird Ct",
                        "Mattocks Rd at Bushtree Ct",
                        "Willow St near Wattle St",
                        "Brier Cr near Willow St hail 'n' ride",
                        "Coolibah Cr near Willow St",
                        "Cassia Dr near Mattocks Rd hail 'n' ride",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Kingsmore Bvd near Tuckeroo Pl",
                        "Wyllie Way near Gordonia Dr",
                        "Observatory Dr near Grove Creek Cl",
                        "Observatory Dr near Golden Grove Bvd",
                        "Observatory Dr near Willow Tree Dr",
                        "Observatory Dr near Palomar St",
                        "Observatory Dr near Southern Skies Dr",
                        "Wyllie Way at Gordonia Dr",
                        "Old Coach Rd near Bridgman Dr",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gemvale Rd at Kings Christian College",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Somerset Dr"
                    ],
                    "3334: Helensvale High - Willowvale": [
                        "Helensvale State High School",
                        "California Dr near Queens Park Cct hail 'n' ride",
                        "California Dr near Oregon Way",
                        "Oxenford State School",
                        "Michigan Dr near Swindon Pl",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Leo Graham Way near Cottonwood Pl",
                        "Heathwood Dr near Koala Town Rd",
                        "Reserve Rd at Dreamtime Zone",
                        "Saint Stephens College",
                        "Reserve Road at Hargraves Rd",
                        "Billinghurst Cr near Turnbull Dr",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Assisi Catholic College",
                        "Days Rd near Coomera Grand Drive",
                        "Days Rd near Nightjar Rd hail 'n' ride",
                        "Bridie Dr near Jagera Dr hail 'n' ride",
                        "Bridie Dr near Birley Link hail 'n' ride",
                        "Cassinia Link near Nightjar Dr hail 'n' ride",
                        "Nightjar Dr at Butcher Bird Circuit",
                        "Coomera Springs Bvd at Sandpiper Court",
                        "Coomera Springs Bvd at Dayflower Street",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Hotham Creek Rd near Blacks Rd hail 'n' ride",
                        "Baileys Mountain Rd near Ruffles Rd hail 'n' ride",
                        "Fairview Dr near Gerrale Dr hail 'n' ride"
                    ],
                    "3335: Coomera Rivers Primary - Coomera Waters": [
                        "Coomera Rivers Primary School",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride"
                    ],
                    "3336: Pimpama Colleges - Coomera Waters": [
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride"
                    ],
                    "3337: Caningeraba Primary - Marymount": [
                        "Whistler Dr near Caningeraba State School",
                        "Christine Ave at Silvabank Drive",
                        "Cumberland Dr near Yodelay St",
                        "Southlake Dr near Cumberland Dr hail 'n' ride",
                        "Mattocks Rd near Bluemoon Cl",
                        "Treeview Dr at Treetop Court",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Oakland Court",
                        "Treeview Dr near Whipbird Ct",
                        "Mattocks Rd at Bushtree Ct",
                        "Willow St near Wattle St",
                        "Brier Cr near Willow St hail 'n' ride",
                        "Brier Cr near Ficus St hail 'n' ride",
                        "Coolibah Cr near Willow St",
                        "Marymount College"
                    ],
                    "3338: Robina High - Main Beach": [
                        "Robina State High School",
                        "Leviathan Dr near Victory Dr hail 'n' ride",
                        "Gemvale Rd near Somerset Dr",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Highfield Dr near Breakwater Rd",
                        "Highfield Dr near Outriggers Drive Reserve",
                        "All Saints Anglican School",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Cabot Ct",
                        "Bourton Rd near Willunga Pl",
                        "Gooding Dr at Bourton Road",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Bermuda St at Hooker Boulevard",
                        "Bermuda St at Sophie Ave",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Ashmore Rd at Upton Street",
                        "Ashmore Rd at Campbell Street",
                        "Ashmore Road Commercial Precinct",
                        "Ashmore Rd at Sir Bruce Small Park",
                        "Dunkeith St near Glyn St hail 'n' ride",
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at Collins Crescent",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Heeb St at The Crescent",
                        "Hillview Pde at Hillview Pde hail 'n' ride",
                        "Cotlew St at Parkleigh Court",
                        "Cotlew St at Tecoma Street",
                        "Benowa Rd at Golden Crescent",
                        "Benowa Rd at Drury Avenue",
                        "Benowa Rd at Centro Southport",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Queen St at Garden Street",
                        "Tedder Avenue at Cronin Avenue",
                        "Tedder Ave at Montgomery Avenue",
                        "Tedder Ave near Main Beach Pde hail 'n' ride"
                    ],
                    "3339: Beenleigh - Ormeau": [
                        "Trinity College and St Josephs Primary",
                        "Beenleigh State High School",
                        "Windaroo Valley High",
                        "Mount Warren Bvd at Windaroo Primary School",
                        "Mt Warren Park Primary School",
                        "Martens St near Main St",
                        "Cuthbert Dr near Brookside Cct",
                        "Pascoe Rd at Halfway Drive",
                        "Halfway Dr near Evergreen Cct hail 'n' ride",
                        "Halfway Dr near Carallia Ct hail 'n' ride",
                        "Halfway Dr at Norfolk Village Primary School",
                        "Philben Dr near Citrinus Ct",
                        "Winfield Rd near Metcalf Ct hail 'n' ride",
                        "Winfield Rd near Leaver Ct hail 'n' ride",
                        "Pascoe Rd near Kefferan Pl hail 'n' ride",
                        "Pascoe Rd near Peachy Rd hail 'n' ride",
                        "Peachey Rd near Vennor Dr hail 'n' ride",
                        "Peachey Rd near Vaughan Dr",
                        "Peachey Rd near Caswell Ct",
                        "Vaughan Dr near Wille Ct hail 'n' ride",
                        "Vaughan Dr near Beausang Pl hail 'n' ride",
                        "Peachey Rd at Doherty Court",
                        "Eggersdorf Rd near Arthur Way hail 'n' ride",
                        "Arthur Way near Gawain Dr",
                        "Mirambeena Dr near Lumeah Ave",
                        "Lumeah Ave near Oomool Ct hail 'n' ride",
                        "Lumeah Ave near Warrawee Way hail 'n' ride",
                        "Guara Grove at Mirambeena Dr hail 'n' ride"
                    ],
                    "3340: Robina High - Canungra": [
                        "Robina State High School",
                        "Mudgeeraba Rd near Scullin St",
                        "Milky Way near Moonbeam Pde hail 'n' ride",
                        "Rainbow Dr at Universe Court",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Sid Bigg Park",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Mudgeeraba Rd near Quambone St",
                        "Gooding Dr at Bourton Road",
                        "Jondique Ave at Saint Michaels College",
                        "Southport Nerang Rd at Nerang interchange",
                        "Price St at Earle Plaza",
                        "Beaudesert Nerang Rd near Dell Ct hail 'n' ride",
                        "Beaudesert Nerang Rd at Billabirra Crescent",
                        "The Oval Dr near Beaudesert Nerang Rd HnR",
                        "Clagiraba Rd near Gerara Ct hail 'n' ride",
                        "Clagiraba Rd near Witheren Rd hail 'n' ride",
                        "Clagiraba Rd near Thendara Dr hail 'n' ride",
                        "Barcoo Ct near Clagiraba Rd hail 'n' ride",
                        "Barcoo Ct at Diamantina Ct hail 'n' ride",
                        "Beaudesert Nerang Rd near Cemetery Rd HnR",
                        "Kidston St at DJ Smith Park hail 'n' ride"
                    ],
                    "3341: Marymount - Currumbin Waters via Mallawa Dr": [
                        "Marymount College",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Tallebudgera Dr near Nyrang Ave",
                        "Townson Ave near Boodera St",
                        "Townson Ave near Twentyfourth Ave",
                        "Townson Ave near Nineteenth Ave",
                        "Townson Ave near Fourteenth Ave hail 'n' ride",
                        "Townson Ave near Tenth Ave hail 'n' ride",
                        "KP McGrath Dr near Exmouth Cr",
                        "KP McGrath Dr at Seaview Parade",
                        "KP McGrath Dr at Murtha Drive",
                        "Murtha Dr at Boya Court",
                        "Murtha Dr at Dongarra Close",
                        "Murtha Dr at Swanbourne Way",
                        "Murtha Dr at Myco Court",
                        "Galleon Way at Aegean Way",
                        "Galleon Way near Billabong Ct",
                        "Galleon Way at Brigantine Court",
                        "Galleon Way near Keegan Cct",
                        "Galleon Way near Jutland Pl",
                        "Currumbin Creek Rd near Mainsail St",
                        "Currumbin Creek Rd at Nuban St",
                        "Currumbin Creek Rd near Traders Way",
                        "Currumbin Creek Rd at Love Street",
                        "Currumbin Creek Rd at Currumbin RSL",
                        "Thrower Dr near Sarawak Ave",
                        "Palm Beach Currumbin High School"
                    ],
                    "3342: Keebra - Surfers Paradise": [
                        "Keebra Park State High School",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd near Canara St hail 'n' ride",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Ashmore Rd at Sir Bruce Small Park",
                        "Ashmore Road Commercial Precinct",
                        "Ashmore Rd at Campbell Street",
                        "Salerno St at Salerno Street",
                        "Salerno St at Fiesta Avenue",
                        "Via Roma near Hobgen St",
                        "Via Roma at Verona Avenue",
                        "Remembrance Dr at Markwell Avenue",
                        "Remembrance Dr at Bruce Bishop Car Park",
                        "Surfers Paradise",
                        "Thomas Dr near Burra St",
                        "Thomas Dr near Anembo St"
                    ],
                    "3343: Southport - Gilston": [
                        "St Hilda's School",
                        "Ferry Rd at The Southport School",
                        "Ferry Rd at York Street",
                        "Ferry Rd at Southport Golf Club",
                        "Bundall Rd at City of Gold Coast",
                        "Bundall Rd at Pisa Court",
                        "Bundall Rd near Elliot St",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Bermuda St at Albert Park",
                        "Bermuda St at Rudd Street",
                        "Bermuda St at Hooker Boulevard",
                        "Nerang Broadbeach Rd at Fairway Drive"
                    ],
                    "3344: OWHS - Halfway Dr": [
                        "Ormeau Woods High School",
                        "Cuthbert Dr near Brookside Cct",
                        "Pascoe Rd at Halfway Drive",
                        "Halfway Dr near Evergreen Cct hail 'n' ride",
                        "Halfway Dr near Carallia Ct hail 'n' ride",
                        "Halfway Dr at Norfolk Village Primary School"
                    ],
                    "3345: Marymount - Hardys Rd via Bridgeman & Bonogin": [
                        "Marymount College",
                        "Bridgman Dr near Old Coach Rd",
                        "Bridgman Dr at Hillcrest Christian College",
                        "Bridgman Dr near Heulan Ct",
                        "Bridgman Dr near Royston Cr",
                        "Bridgman Dr near Woodland Dr",
                        "Woodland Dr near Navars St",
                        "Old Coach Rd near Bridgman Dr",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gemvale Rd at Kings Christian College",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Somerset Dr",
                        "Somerset Dr near Gemvale Rd",
                        "Leviathan Dr near Victory Dr hail 'n' ride",
                        "Swanton Dr near Chute St",
                        "Swanton Dr near Springsure Dr",
                        "Swanton Dr near Somerset Dr",
                        "Gunsynd Dr near Tulloch Cr hail 'n' ride",
                        "Todman Dr near Tulloch Cr hail 'n' ride",
                        "Gunsynd Dr near Todman Dr hail 'n' ride",
                        "Bonogin Rd near Gunsynd Dr hail 'n' ride",
                        "Bonogin Rd near Tulipwood Dr hail 'n' ride",
                        "Bonogin Rd near Smith Rd hail 'n' ride",
                        "Bonogin Rd near Davenport Dr hail 'n' ride",
                        "Bonogin Rd near Fairy Wren Ct hail 'n' ride",
                        "Bonogin Rd near Gardenia Dr hail 'n' ride",
                        "Glenmore Dr near Leyshon Ct hail 'n' ride",
                        "Glenmore Dr near Saunders Dr hail 'n' ride",
                        "Glenmore Dr near Windemere Dr hail 'n' ride",
                        "Hardys Rd near Rising Fast Rd hail 'n' ride",
                        "Hardys Rd near Bertana Dr hail 'n' ride",
                        "Hardys Rd near Natan Rd hail 'n' ride"
                    ],
                    "3346: UCSC & CPS - Oxenford, Riverstone & Clagriaba": [
                        "Upper Coomera College",
                        "Days Rd near Coomera Grand Drive",
                        "Bridie Dr near Jagera Dr hail 'n' ride",
                        "Bridie Rd near Forest Oak Dr hail 'n' ride",
                        "Bridie Dr near Birley Link hail 'n' ride",
                        "Cassinia Link near Nightjar Dr hail 'n' ride",
                        "Beattie Rd at Coomera Primary School",
                        "Dreamworld Pkwy at Foxwell Rd",
                        "Leo Graham Way near Cottonwood Pl",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Michigan Dr near Swindon Pl",
                        "Oxenford State School",
                        "California Dr near Oregon Way",
                        "California Dr near Queens Park Cct hail 'n' ride",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Cobb and Co Dr near Appollo Pl",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Maudsland Rd near Bignells Rd hail 'n' ride",
                        "Maudsland Rd near Guanaba Creek Rd hail 'n' ride",
                        "Maudsland Rd near Burley Griffin Dr hail 'n' ride",
                        "Beaudesert Nerang Rd near Crystal Springs Ct HnR",
                        "The Oval Dr near Beaudesert Nerang Rd HnR",
                        "Clagiraba Rd near Gerara Ct hail 'n' ride",
                        "Clagiraba Rd near Witheren Rd hail 'n' ride",
                        "Clagiraba Rd near Thendara Dr hail 'n' ride",
                        "Arunta Dr near Pemberton Cl hail 'n' ride"
                    ],
                    "3347: William Duncan - Numbinbah": [
                        "William Duncan Primary School",
                        "Mortensen Rd near The Domain",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "Gilston Rd near Alexander Dr hail 'n' ride",
                        "McLaren Rd near Winchester Dr",
                        "McLaren Rd near Oakdale Ave",
                        "McLaren Rd at Beltana Way",
                        "Crusader Way near McLaren Rd hail 'n' ride",
                        "Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Beaudesert Nerang Rd near Dell Ct hail 'n' ride",
                        "Beaudesert Nerang Rd at Billabirra Crescent",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Yarrimbah Dr near Goora St hail 'n' ride",
                        "Yarrimbah Dr near McLaren Rd hail 'n' ride",
                        "Dugandan St at Burra Street",
                        "Dugandan St near Koola Dr hail 'n' ride",
                        "Dugandan St at Teasdale Drive",
                        "Dugandan St at Bent Street",
                        "Dugandan St at Merloo Drive",
                        "Beaudesert Nerang Rd at Oak Street",
                        "Price St at Earle Plaza",
                        "Southport Nerang Rd at Nerang interchange",
                        "Gilston Rd at Worley Drive",
                        "Gilston Rd near Peter Mills Dr hail 'n' ride",
                        "Gilston Rd at Longhill Road",
                        "Latimers Crossing Rd near Gilston Rd hail 'n' ride",
                        "Nerang Murwillumbah Rd near Advancetown Rd HnR",
                        "Nerang Murwillumbah Rd near Narrow Leaf Rd HnR",
                        "Nerang Murwillumbah Rd at Numinbah Valley HnR",
                        "Nerang Murwillumbah Rd near Springbrook Rd HnR",
                        "Nerang Murwillumbah Rd near Pocket Rd HnR",
                        "Nerang Murwillumbah Rd near Staffords Rd HnR",
                        "Nerang Murwillumbah Rd near Natural Arch HnR",
                        "Nerang Murwillumbah Rd at Bochow Park HnR"
                    ],
                    "3348: Keebra - Nerang Rail": [
                        "Keebra Park State High School",
                        "Nerang station"
                    ],
                    "3349: Assisi - Coomera Waters": [
                        "Assisi Catholic College",
                        "Coomera station, stop D",
                        "Finnegan Way near Seagreen Dr hail 'n' ride",
                        "Finnegan Way at Felix Entrance",
                        "Finnegan Way near Trillers Ave hail 'n' ride",
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride"
                    ],
                    "3350: Upper Coomera College - Oxenford": [
                        "Upper Coomera College",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Garawarra Cr near Rose Valley Dr hail 'n' ride",
                        "Garawarra Cr near Torrington St hail 'n' ride",
                        "Lysterfield Rise near Serendip Lane hail 'n' ride",
                        "Reserve Rd near Herbert St",
                        "Reserve Rd at Upper Coomera Village",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Michigan Dr near Swindon Pl",
                        "Michigan Dr near Maple Ct hail 'n' ride"
                    ],
                    "3351: Upper Coomera - Coomera Waters": [
                        "Saint Stephens College",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Coomera station, stop D",
                        "Finnegan Way near Seagreen Dr hail 'n' ride",
                        "Finnegan Way at Felix Entrance",
                        "Finnegan Way near Trillers Ave hail 'n' ride",
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride"
                    ],
                    "3352: Southport - Reserve Rd": [
                        "Brooke Ave at Southport State High School",
                        "Government Rd at Labrador State School",
                        "Government Rd near Brookside Rd",
                        "Hollywell Rd near Thelma Ave",
                        "Morala Ave at Biggera Waters School",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Limetree Pde",
                        "Morala Ave at Folkstone Place",
                        "Lae Dr at The Runaway Brace",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd near Siena Pl",
                        "Pine Ridge Rd at Coombabah Road",
                        "Coombabah High School",
                        "Pine Ridge Rd at Pine Ridge Caravan Park",
                        "Pine Ridge Rd at Lensgate Road",
                        "Gold Coast Hwy at Arundel Drive",
                        "Arundel Dr near Paterson Dr",
                        "Gold Coast Hwy at Discovery Drive",
                        "Helensvale stop F",
                        "Helensvale Community Centre",
                        "Discovery Dr at Ridgevale Drive",
                        "Discovery Dr at Helensvale Primary School",
                        "Discovery Dr at Lindfield Road Shops",
                        "Discovery Dr at Hession Oval",
                        "Discovery Dr at Eugenia Reserve",
                        "Discovery Dr at Ashford Road",
                        "Discovery Dr at Kingaroy Avenue",
                        "Helensvale State High School",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr near Creekwood Pl",
                        "Hope Island Rd near Magnolia Dr hail 'n' ride",
                        "Hope Island Rd at Anaheim Drive",
                        "Old Pacific Hwy near Tamborine Oxenford Rd HnR",
                        "Michigan Dr near Maple Ct hail 'n' ride",
                        "Michigan Dr near Swindon Pl",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Reserve Rd near Jemima Pl",
                        "Reserve Rd near Stephens St hail 'n' ride",
                        "Reserve Rd near Amelia St",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Reserve Rd near Lawson St",
                        "Reserve Rd near Reserve Rd hail 'n' ride"
                    ],
                    "3353: Helensvale High - Oxenford": [
                        "Helensvale State High School",
                        "Michigan Dr near Maple Ct hail 'n' ride",
                        "Oxenford State School",
                        "Michigan Dr near Swindon Pl",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Leo Graham Way near Cottonwood Pl"
                    ],
                    "3354: St Stephens - Upper Ormeau Rd": [
                        "Saint Stephens College",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Assisi Catholic College",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Mirambeena Dr near Lumeah Ave",
                        "Lumeah Ave near Oomool Ct hail 'n' ride",
                        "Lumeah Ave near Warrawee Way hail 'n' ride",
                        "Mirambeena Dr at Ormeau School",
                        "Reedmans Rd near Arthur Way hail 'n' ride",
                        "Arthur Way near Gawain Dr",
                        "Eggersdorf Rd near Arthur Way hail 'n' ride",
                        "Peachey Road interchange hail 'n' ride",
                        "Ormeau Ridge Rd near Yarwood",
                        "Sir Charles Holm Dr near Islandview Tce HnR",
                        "Ormeau Ridge Rd near Mullins St hail 'n' ride",
                        "Ellenborough Ave near Terania Ave",
                        "River Run Cct near Lansdowne Dr",
                        "Upper Ormeau Rd near Thomsons Rd hail 'n' ride",
                        "Barrenjoey Dr near Barrenjoey Dr hail 'n' ride",
                        "Upper Ormeau Rd near Cliff Barrons Rd HnR",
                        "Upper Ormeau Rd near Boral Quarry hail 'n' ride"
                    ],
                    "3355: Upper Coomera - Timberview Dr": [
                        "Upper Coomera College",
                        "Hargraves Rd at Con Brio Bvd",
                        "Roe St near Prefect Cl",
                        "Roe St at Brygon Creek Drive",
                        "Brygon Creek Dr near Reserve Rd hail 'n' ride",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Highland Reserve Primary School",
                        "Reserve Rd near Herbert St",
                        "Moran Dr near Acton Pl hail 'n' ride",
                        "Stanfield Dr near Jullian Rd hail 'n' ride",
                        "Stephens St near Matthewson St hail 'n' ride",
                        "Stephens St near Macklin Ct hail 'n' ride",
                        "Reserve Rd at Upper Coomera Village",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Tamborine Oxenford Rd near Pinewood St HnR",
                        "Tamborine Oxenford Rd near Glenview Rd HnR",
                        "Greenview Dr near Stony Creek Dr hail 'n' ride",
                        "Greenview Rd near Saddle Back St hail 'n' ride",
                        "Yarrayne Valley Dr near Saddle Back St HnR",
                        "Tamborine Oxenford Rd near Wongawallan Dr HnR",
                        "Tamborine Oxenford Rd near Otmoor Rd hail 'n' ride",
                        "Kriedeman Rd near Gladrose Ct hail 'n' ride",
                        "Gladrose Crt near Polo Cl hail 'n' ride",
                        "Gladrose Crt near Kriedeman Rd hail 'n' ride",
                        "Kriedeman Rd near Memorial Dr hail 'n' ride",
                        "Kriedeman Rd near Tamborine Oxenford Rd HnR",
                        "Tamborine Oxenford Rd near Currey Rd hail 'n' ride",
                        "Tamborine Oxenford Rd near Lok Evyn Ct HnR",
                        "Tamborine Oxenford Rd near Colin Meagher HnR",
                        "Tamborine Oxenford Rd near Timberview Dr HnR",
                        "Timberview Dr near Parkside Pde hail 'n' ride",
                        "Tamborine Oxenford Rd near Lanes Rd hail 'n' ride",
                        "Tamborine Oxenford Rd near Welches Rd HnR"
                    ],
                    "3356: Pimpama Colleges - Bella Bvd": [
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Waverly Dr at Rifle Range Road",
                        "Waverly Dr at Persimmon Street",
                        "Waterhouse Dr near McLachlan Cct hail 'n' ride",
                        "Bella Bvd at Deepak Drive",
                        "Bella Bvd near Matthews Cr hail 'n' ride"
                    ],
                    "3357: Ormeau Primary - Peachy Rd": [
                        "Mirambeena Dr at Ormeau School",
                        "Tillyroen Rd near Mirambeena Dr hail 'n' ride",
                        "River Run Cct near Lansdowne Dr",
                        "Ellenborough Ave near Terania Ave",
                        "Ormeau Ridge Rd near Cardrona Ct hail 'n' ride",
                        "Ormeau Ridge Rd near Sir Charles Holm Dr HnR",
                        "Sir Charles Holm Dr near Islandview Tce HnR",
                        "Sir Charles Holm Dr near Limewood walkway HnR",
                        "Ormeau Ridge Rd near Sir Charles Holme Dr",
                        "Ormeau Ridge Rd near Johnson Pde",
                        "Peachey Road interchange hail 'n' ride",
                        "Peachey Rd at Doherty Ct",
                        "Vaughan Dr near Wille Ct hail 'n' ride",
                        "Vaughan Dr near Beausang Pl hail 'n' ride",
                        "Peachey Rd near Philben Dr hail 'n' ride",
                        "Peachey Rd near Vennor Dr hail 'n' ride",
                        "Pascoe Rd near Peachy Rd hail 'n' ride"
                    ],
                    "3358: Robina High - Cayuga St": [
                        "Robina State High School",
                        "Somerset Dr at Clover Hill Drive",
                        "Somerset Dr at Somerset College",
                        "Gunsynd Dr near Todman Dr hail 'n' ride",
                        "Gunsynd Dr near Tulloch Cr hail 'n' ride",
                        "Bonogin Rd near Gunsynd Dr hail 'n' ride",
                        "Hardys Rd near Glenmore Dr hail 'n' ride",
                        "Hardys Rd near Rising Fast Rd hail 'n' ride",
                        "Hardys Rd near Bertana Dr hail 'n' ride",
                        "Hardys Rd near Natan Rd hail 'n' ride",
                        "Berrigans Rd near Wallandra Dr hail 'n' ride",
                        "Wallandra Rd near Baileys Rd hail 'n' ride",
                        "Baileys Rd near Tallai Rd hail 'n' ride",
                        "Tallai Rd near Cromwell Ct hail 'n' ride",
                        "Old Coach Rd at Tallai Rd Bus Shelter HnR",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Mudgeeraba Rd near Quambone St",
                        "Quambone St near Jeremy Ct hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Alkira Way near Kabra Ct hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near Kurilpa St hail 'n' ride",
                        "Dormello Dr near San Fernando Dr hail 'n' ride",
                        "Dormello Dr near Hinkler Dr hail 'n' ride",
                        "Alexander Dr at Sue Court",
                        "Alexander Dr near Richard Cr",
                        "William Duncan Primary School",
                        "McLeod St at Balfour Crescent",
                        "Cayuga St near Mortensen Rd hail 'n' ride"
                    ],
                    "3359: Upper Coomera - Guanaba": [
                        "Beattie Rd at Coomera Primary School",
                        "Days Rd at Coomera Anglican College",
                        "Williamson Rd near Billinghurst Cr",
                        "Coomera Anglican College",
                        "Billinghurst Cr near Turnbull Dr",
                        "Turnbull Dr near Abraham Rd hail 'n' ride",
                        "Abraham Rd near Aviation Av hail 'n' ride",
                        "Abraham Rd opp Aquatic Centre hail 'n' ride",
                        "Hargraves Rd at Caribou Crescent",
                        "Fawn St near River Meadows Dr hail 'n' ride",
                        "Hargraves Rd at Con Brio Bvd",
                        "Roe St at Brygon Creek Drive",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Reserve Rd near Herbert St",
                        "Stephens St near Macklin Ct hail 'n' ride",
                        "Stephens St near Farrer Ct hail 'n' ride",
                        "Stanfield Dr near Jullian Rd hail 'n' ride",
                        "Moran Dr near Acton Pl hail 'n' ride",
                        "Reserve Rd at Upper Coomera Village",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Maudsland Rd near Cobb and Co Dr hail 'n' ride",
                        "Maudsland Rd near Gaven Arterial Rd hail 'n' ride",
                        "Maudsland Rd near Bignells Rd hail 'n' ride",
                        "Maudsland Rd near Guanaba Creek Rd hail 'n' ride",
                        "Guanaba Creek Rd near Stewart Rd hail 'n' ride",
                        "Coomera Valley Dr near Stewart St hail 'n' ride",
                        "Coomera Valley Dr near Lynwood Dr hail 'n' ride",
                        "Lynwood Dr near Guanaba Creek Rd hail 'n' ride",
                        "Tarata Rd near Guanaba Creek Rd hail 'n' ride",
                        "Link Rd near Tarata Rd hail 'n' ride",
                        "Birds Rd near Link Rd hail 'n' ride",
                        "Birds Rd near Maudsland Rd hail 'n' ride",
                        "Maudsland Rd near Riverstone Rd hail 'n' ride",
                        "Gaven Arterial Rd at Felling Drive"
                    ],
                    "3360: Helensvale - Timberview Dr": [
                        "Helensvale Primary School",
                        "Discovery Dr at Kingaroy Avenue",
                        "Helensvale State High School",
                        "River Links Bvd near Hope Island Rd hail 'n' ride",
                        "Hope Island Rd at Anaheim Drive",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Heathwood Dr near Koala Town Rd",
                        "Reserve Rd at Dreamtime Zone",
                        "Saint Stephens College",
                        "Reserve Road at Hargraves Rd",
                        "Abraham Rd near Aquatic Centre hail 'n' ride",
                        "Turnbull Dr near Abraham Rd hail 'n' ride",
                        "Billinghurst Cr near Turnbull Dr",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Assisi Catholic College",
                        "Internal Rd at Assisi Catholic College",
                        "Old Coach Rd near Billinghurst Cr",
                        "Old Coach Rd at Low Drive",
                        "Reserve Rd near Reserve Rd hail 'n' ride",
                        "Reserve Rd near Lawson St",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Reserve Rd near Herbert St",
                        "Stephens St near Macklin Ct hail 'n' ride",
                        "Stephens St near Farrer Ct hail 'n' ride",
                        "Stanfield Dr near Jullian Rd hail 'n' ride",
                        "Moran Dr near Acton Pl hail 'n' ride",
                        "Reserve Rd at Upper Coomera Village",
                        "Tamborine Oxenford Rd near Pinewood St HnR",
                        "Tamborine Oxenford Rd near Glenview Rd HnR",
                        "Greenview Dr near Stony Creek Dr hail 'n' ride",
                        "Greenview Rd near Saddle Back St hail 'n' ride",
                        "Yarrayne Valley Dr near Saddle Back St HnR",
                        "Tamborine Oxenford Rd near Wongawallan Dr HnR",
                        "Tamborine Oxenford Rd near Otmoor Rd hail 'n' ride",
                        "Kriedeman Rd near Gladrose Ct hail 'n' ride",
                        "Gladrose Crt near Polo Cl hail 'n' ride",
                        "Gladrose Crt near Kriedeman Rd hail 'n' ride",
                        "Kriedeman Rd near Memorial Dr hail 'n' ride",
                        "Kriedeman Rd near Tamborine Oxenford Rd HnR",
                        "Tamborine Oxenford Rd near Currey Rd hail 'n' ride",
                        "Tamborine Oxenford Rd near Lok Evyn Ct HnR",
                        "Tamborine Oxenford Rd near Colin Meagher HnR",
                        "Lanes Rd near Tamborine Oxenford Rd hail 'n' ride",
                        "Lanes Rd at Wongawallan hail 'n' ride",
                        "Lanes Rd near Crest Hill Dr hail 'n' ride",
                        "Tamborine Oxenford Rd near Timberview Dr HnR",
                        "Timberview Dr near Parkside Pde hail 'n' ride"
                    ],
                    "3361: Upper Coomera College - Coomera Waters": [
                        "Upper Coomera College",
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Daintree Dr near Paradise Dr hail 'n' ride",
                        "Pamplet Lane near Daintree Dr hail 'n' ride",
                        "Orlando Dr near Jackson Street",
                        "Finnegan Way at Lily Avenue",
                        "Coomera Rivers Primary School",
                        "Finnegan Way at Felix Entrance"
                    ],
                    "3362: Assisi - Wintergreen": [
                        "Assisi Catholic College",
                        "Coomera Anglican College",
                        "Brygon Creek Dr near Ascendancy Way",
                        "Roe St at Brygon Creek Drive",
                        "Roe St at Con Brio Boulevard",
                        "Roe St near Tutor St",
                        "Hargraves Rd at Caribou Crescent",
                        "Hargraves Rd near Reserve Rd hail 'n' ride",
                        "Reserve Road at Abraham Rd",
                        "Saint Stephens College",
                        "Reserve Rd at Dreamtime Zone",
                        "Heathwood Dr near Koala Town Rd",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Hope Island Rd at Anaheim Drive",
                        "Monterey Keys Dr at Creekwood Place",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Helensvale Rd near Monterey Keys Dr hail 'n' ride",
                        "Helensvale State High School",
                        "Discovery Dr near Helensvale Rd hail 'n' ride",
                        "Discovery Dr at Kingaroy Avenue",
                        "Discovery Dr at Ashford Road",
                        "Discovery Dr at Eugenia Reserve",
                        "Discovery Dr at Hession Oval",
                        "Discovery Dr at Lindfield Road Shops",
                        "Helensvale State Primary School",
                        "Discovery Dr at Ridgevale Drive",
                        "Mildura Dr at Pentland Court",
                        "Mildura Dr at Halbury Court",
                        "Mildura Dr near Burdekin Ave",
                        "Helensvale Community Centre",
                        "Gold Coast Hwy at Discovery Drive",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Arundel Dr near Maltravers Dr",
                        "Arundel Dr near Arun Dr",
                        "Arundel Dr near Neri Cr",
                        "Napper Rd at Arundel Primary School",
                        "Parkwood Bvd near Peter Thomson Dr",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Gary Player Cr",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr near Suncrest Ct",
                        "Wintergreen Dr near Ballybunion Dr"
                    ],
                    "3363: OWHS - Philben Dr": [
                        "Ormeau Woods High School",
                        "Cuthbert Dr near Brookside Cct",
                        "Pascoe Rd at Halfway Drive",
                        "Pascoe Rd near Solanum St",
                        "Doolan St near Colane St",
                        "Doolan St near Karall St",
                        "Doolan St near Halfway Dr",
                        "Philben Dr near Citrinus Ct"
                    ],
                    "3364: Benowa Schools - Crestwood via Cotlew St": [
                        "Robina State High School",
                        "Railway Street at Robert St",
                        "The Link Way near Swan Lane",
                        "The Link near Bell Pl hail 'n' ride",
                        "Somerset Dr at Firth Park hail 'n' ride",
                        "Somerset Dr near Bonogin Rd hail 'n' ride",
                        "Swanton Dr near Somerset Dr",
                        "Swanton Dr near Springsure Dr",
                        "Swanton Dr near Chute St"
                    ],
                    "3365: Rivermount College - Upper Coomera": [
                        "Rivermount College",
                        "Peachey Rd near Pascoe Rd hail 'n' ride",
                        "Pascoe Rd near Winfield Rd hail 'n' ride",
                        "Pascoe Rd near Hennie Cr hail 'n' ride",
                        "Doolan St near Colane St",
                        "Doolan St near Karall St",
                        "Doolan St near Halfway Dr",
                        "Philben Dr near Citrinus Ct",
                        "Philben Dr near Winfield Rd",
                        "Philben Dr near Peachey Rd",
                        "Peachey Rd near Vaughan Dr",
                        "Vaughan Dr near Healy Ct hail 'n' ride",
                        "Vaughan Dr near Renford Ct hail 'n' ride",
                        "Peachey Rd at Doherty Court",
                        "Peachey Road interchange hail 'n' ride",
                        "Eggersdorf Rd near Arthur Way hail 'n' ride",
                        "Arthur Way near Gawain Dr",
                        "Mirambeena Dr near Lumeah Ave",
                        "Lumeah Ave near Oomool Ct hail 'n' ride",
                        "Lumeah Ave near Warrawee Way hail 'n' ride",
                        "Mirambeena Dr at Ormeau School",
                        "Abraham Rd near Aviation Av hail 'n' ride",
                        "Reserve Road at Abraham Rd"
                    ],
                    "3366: Keebra - Nerang Rail": [
                        "Keebra Park State High School",
                        "Nerang station"
                    ],
                    "3367: Merrimac High - Nerang West": [
                        "Dunlop Ct at Merrimac State High School",
                        "Gooding Dr at Merrimac Golf Course",
                        "Nielsens Rd at Hickey Way",
                        "Bonooroo Park Shopping Centre",
                        "Alexander Dr at Sue Court",
                        "Explorers Way at Garvie Place",
                        "Explorers Way at Cozens Way",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Way near Andamooka Ave hail 'n' ride",
                        "Explorers Way near Hinkler Dr hail 'n' ride",
                        "William Duncan Primary School",
                        "McLeod St at Balfour Crescent",
                        "Cayuga St near Mortensen Rd hail 'n' ride",
                        "Mortensen Rd near Eureka Cr hail 'n' ride",
                        "Mortensen Rd near The Linkway",
                        "Mortensen Rd near The Domain",
                        "Gilston Rd near Alexander Dr hail 'n' ride",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "McLaren Rd at Beltana Way",
                        "McLaren Rd near Winchester Dr",
                        "McLaren Rd near Oakdale Ave",
                        "McLaren Road at Crusader Way",
                        "Crusader Way near McLaren Rd hail 'n' ride",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Beaudesert Nerang Rd near Dell Ct hail 'n' ride",
                        "Beaudesert Nerang Rd at Billabirra Crescent",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Yarrimbah Dr near Goora St hail 'n' ride",
                        "Yarrimbah Dr near McLaren Rd hail 'n' ride",
                        "Dugandan St at Burra Street",
                        "Dugandan St near Koola Dr hail 'n' ride",
                        "Dugandan St at Teasdale Drive",
                        "Dugandan St at Bent Street",
                        "Dugandan St at Merloo Drive"
                    ],
                    "3368: OWHS - River Run Cir": [
                        "Ormeau Woods High School",
                        "Lansdowne Dr near Upper Ormeau Rd hail 'n' ride",
                        "River Run Cct near Lansdowne Dr",
                        "Ellenborough Ave near Terania Ave"
                    ],
                    "3369: Varsity Lakes - Robina": [
                        "Varsity Pde at Varsity Lakes College",
                        "Christine Ave at Varsity Sound Avenue",
                        "Christine Ave at Varsity College",
                        "Varsity College Junior Campus",
                        "Christine Ave at Bayswater Ave hail 'n' ride",
                        "Christine Ave at Konda Way",
                        "Christine Ave at Goldwater Drive",
                        "Laurel Oak Dr near Lancewood Cct hail 'n' ride",
                        "Lancewood Cct near Applegum Ct hail 'n' ride",
                        "Laurel Oak Dr near Camphor Wood Ct hail 'n' ride",
                        "Scottsdale Dr at Christine Avenue",
                        "Christine Ave at Olympus Drive"
                    ],
                    "3370: Upper Coomera - Pacific Pines": [
                        "Saint Stephens College",
                        "Assisi Catholic College",
                        "Coomera Anglican College",
                        "Binstead Way at Pacific Pines Boulevard",
                        "Binstead Way at Studio Drive",
                        "Universal St near Hervey St hail 'n' ride",
                        "Universal St near Crestridge Cr",
                        "Universal St near Pinevale Dr",
                        "Gaven Primary School",
                        "Universal St near Buchanan Ct",
                        "Binstead Way at Palmerston Drive",
                        "Rimatara Rise near Victoria Dr hail 'n' ride",
                        "Hillary Cir near Victoria Dr hail 'n' ride",
                        "Santa Isobel Bvd near Chatham Ave",
                        "Santa Isobel Bvd near Mussau St",
                        "Smith St near Hammond Dr"
                    ],
                    "3371: OWHS - Arthur Way": [
                        "Ormeau Woods High School",
                        "Arthur Way near Gawain Dr",
                        "Eggersdorf Rd near Arthur Way hail 'n' ride",
                        "Gawain Dr near Sugarmill St",
                        "Gawain Dr near Bedivere Dr",
                        "Reedmans Rd near Arthur Way"
                    ],
                    "3372: OWHS - Philben St": [
                        "Ormeau Woods High School",
                        "Cuthbert Dr near Brookside Cct",
                        "Pascoe Rd at Halfway Drive",
                        "Pascoe Rd near Solanum St",
                        "Doolan St near Colane St",
                        "Doolan St near Karall St",
                        "Doolan St near Halfway Dr",
                        "Philben Dr near Citrinus Ct"
                    ],
                    "3373: Keebra Park - Nerang (express)": [
                        "Keebra Park State High School",
                        "Nerang station"
                    ],
                    "3374: Gilston - Nerang": [
                        "Gilston State School",
                        "Worongary Rd near Gilston Rd hail 'n' ride",
                        "Gilston Rd near Hinde Rd hail 'n' ride",
                        "Peter Mills Dr near Swagman Rd hail 'n' ride",
                        "Peter Mills Dr near Honey Eater Ct hail 'n' ride",
                        "Gilston Rd at Worley Drive",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "Gilston Rd near Alexander Dr hail 'n' ride",
                        "McLaren Rd at Beltana Way",
                        "McLaren Rd near Winchester Dr",
                        "McLaren Rd near Oakdale Ave",
                        "McLaren Road at Crusader Way",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Beaudesert Nerang Rd near Dell Ct hail 'n' ride",
                        "Beaudesert Nerang Rd at Billabirra Crescent",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Yarrimbah Dr near Goora St hail 'n' ride",
                        "Dugandan St at Burra Street",
                        "Dugandan St near Koola Dr hail 'n' ride",
                        "Dugandan St at Teasdale Drive",
                        "Dugandan St at Bent Street",
                        "Dugandan St at Merloo Drive",
                        "Beaudesert Nerang Rd at Oak Street",
                        "Price St at Earle Plaza",
                        "Southport Nerang Rd at Nerang interchange",
                        "Nerang Broadbeach Rd at Paradise Street",
                        "Nerang station, stop F",
                        "Nerang Broadbeach Rd at Lakeview Drive"
                    ],
                    "3375: Keebra - Nerang Rail": [
                        "Keebra Park State High School",
                        "Nerang station"
                    ],
                    "3376: Upper Coomera - Coomera Springs": [
                        "Upper Coomera College",
                        "Coomera Springs Primary School",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Waterclover Dr near Coomera Heights Dr HnR",
                        "Waterclover Dr near Southern Lights Dr HnR",
                        "Rainlily Cr near Nandina Ct hail 'n' ride",
                        "Rosemallow Ave near Coomera Springs Bvd HnR",
                        "Coomera Springs Bvd at Sandpiper Court",
                        "Nightjar Dr at Butcher Bird Circuit",
                        "Cassinia Link near Nightjar Dr hail 'n' ride",
                        "Bridie Dr near Birley Link hail 'n' ride",
                        "Bridie Dr near Jagera Dr hail 'n' ride",
                        "Days Rd near Bridie Dr hail 'n' ride",
                        "Days Rd near Nightjar Rd hail 'n' ride",
                        "Assisi Catholic College"
                    ],
                    "3377: Assisi - The Oval": [
                        "Assisi Catholic College",
                        "Coomera Anglican College",
                        "Saint Stephens College",
                        "Reserve Rd at Dreamtime Zone",
                        "Heathwood Dr near Koala Town Rd",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Old Pacific Hwy near Tamborine Oxenford Rd HnR",
                        "Leo Graham Way near Cottonwood Pl",
                        "Regatta Ave near Essen Pl",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Michigan Dr near Swindon Pl",
                        "Riversdale Rd near Texas Ct hail 'n' ride",
                        "Califorina Dr near Riversdale Rd",
                        "California Dr near Oregon Way",
                        "California Dr near Queens Park Cct hail 'n' ride",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Cobb and Co Dr near Appollo Pl",
                        "Lagoon Park Dr near Meadow Ct hail 'n' ride",
                        "Lagoon Park Dr near Summer Hill Cr hail 'n' ride",
                        "Greenacre Way near Lagoon Park Dr hail 'n' ride",
                        "Riverstone Crsg near Rivermill Tce hail 'n' ride",
                        "Riverstone Crsg near Northern Skies Tce HnR",
                        "Riverstone Crsg near Valley Brook Rise HnR",
                        "Riverstone Crsg near Hibiscus Cr hail 'n' ride",
                        "Riverstone Crsg near Prairie Av hail 'n' ride",
                        "Riverstone Crsg near Mountain View Pde HnR",
                        "Rivermill Tce near Plantation Cr hail 'n' ride",
                        "Rivermill Tce near Settlers Ave hail 'n' ride",
                        "Maudsland Rd near Gaven Arterial Rd hail 'n' ride",
                        "Maudsland Rd near Bignells Rd hail 'n' ride",
                        "Maudsland Rd near Guanaba Creek Rd hail 'n' ride",
                        "Maudsland Rd near Burley Griffin Dr hail 'n' ride",
                        "Beaudesert Nerang Rd near Crystal Springs Ct HnR",
                        "The Oval Dr near Beaudesert Nerang Rd HnR"
                    ],
                    "3378: Helensvale PS - Monteray Keys Dr": [
                        "Helensvale Primary School",
                        "Mildura Dr at Burdekin Ave",
                        "Mildura Dr near Halbury Ct",
                        "Mildura Dr near Pentland Ct",
                        "Ridgevale Dr near Mildura Dr",
                        "Ridgevale Dr at Kiandra Place",
                        "Ridgevale Dr near Armidale Cr",
                        "Clarence Dr near Colo Ct hail 'n' ride",
                        "Riverdowns Crt near Dawson Ct hail 'n' ride",
                        "Derwent Ave near Clarence Dr hail 'n' ride",
                        "Helensvale Rd near Monterey Keys Dr hail 'n' ride",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr near Creekwood Pl"
                    ],
                    "3379: Upper Coomera - Broadwater Ave": [
                        "Saint Stephens College",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Assisi Catholic College",
                        "Hope Island Rd at Anaheim Drive",
                        "Oxenford Southport Rd near The Lakes Dr HnR",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Masthead Way at Sanctuary Cove",
                        "Santa Barbara Rd near Chindrina St",
                        "Akoonah St near Mungala St hail 'n' ride",
                        "Akoonah St near Eingana St",
                        "Pinnaroo St near Akoonah St hail 'n' ride",
                        "Caseys Rd near Sanctuary Gardens hail 'n' ride",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Boykambil Esp near Sheehan Ave hail 'n' ride",
                        "Nelson Ave near Dunnes Ave hail 'n' ride",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Broadwater Ave at Crescent Avenue",
                        "Crescent Ave near Broadwater Ave hail 'n' ride",
                        "Bert Hood St near Boykambil Esp hail 'n' ride",
                        "Boykambil Esp near Shoe St hail 'n' ride",
                        "Shoe St near Coombe Ave hail 'n' ride"
                    ],
                    "3380: Keebra Park, Southport PS - Ashmore, Molendinar": [
                        "Keebra Park State High School",
                        "Southport State School",
                        "Queen Street station (Southport)",
                        "Nerang Rd at Aquinas Catholic College",
                        "Ashmore City Shopping Centre",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Trinity Lutheran School",
                        "Panache St near Coachwood Dr hail 'n' ride",
                        "Verdelho Way near Chablis Ct hail 'n' ride",
                        "Coachwood Dr near Cabernet Cl hail 'n' ride",
                        "Mitchell Ave at Coachwood Drive",
                        "Macquarie Ave at Lachlan Avenue",
                        "Macquarie Ave near Batchworth Rd hail 'n' ride",
                        "Macquarie Ave near Watford Cr hail 'n' ride",
                        "Ashmore Rd near Kingsway Dr hail 'n' ride",
                        "Ashmore Rd near Keen St hail 'n' ride",
                        "Hellman St hail 'n' ride",
                        "Pilar Ct hail 'n' ride"
                    ],
                    "3381: Helensvale High - Oxenford": [
                        "Helensvale State High School",
                        "Entertainment Dr at Movie World",
                        "Michigan Dr near Maple Ct hail 'n' ride",
                        "Oxenford State School",
                        "Michigan Dr near Swindon Pl",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Leo Graham Way near Cottonwood Pl"
                    ],
                    "3382: Elanora Primary - Currumbin Waters": [
                        "Elanora State Primary School hail 'n' ride",
                        "Sarawak Ave at Salk Oval",
                        "Palm Beach Currumbin State High School",
                        "Guineas Creek Rd at Riverside Drive",
                        "Galleon Way at Aegean Way",
                        "Ware Dr near Aethalia St",
                        "Ware Dr near Tudor St",
                        "Galleon Way at St Augustines School",
                        "Galleon Way at Ware Drive",
                        "Galleon Way near Tate Ct",
                        "Simpsons Rd near Calcita Ave hail 'n' ride",
                        "Simpsons Rd near Killara St hail 'n' ride",
                        "Simpsons Rd near Buckingham Way hail 'n' ride",
                        "Westminster Bvd near Cornwall Dr hail 'n' ride",
                        "Cornwall Dr near Cheshire Gr hail 'n' ride",
                        "Simspons Rd near Cornwall Dr hail 'n' ride",
                        "Doubleview Dr at Attadale Court",
                        "Murtha Dr at Swanbourne Way",
                        "Murtha Dr at Myco Court",
                        "KP McGrath Dr at Elanora State School",
                        "KP McGrath Dr near Murtha Dr"
                    ],
                    "3383: Currumbin Primary - Somerset Dr": [
                        "Currumbin State Primary School",
                        "Palm Beach Currumbin State High School",
                        "Elanora State Primary School hail 'n' ride",
                        "KP McGrath Dr near Murtha Dr",
                        "KP McGrath Dr near Seaview Pde",
                        "Avocado St near Doubleview Dr",
                        "Avocado St at Elanora State High School",
                        "Nineteenth Ave at Elanora High School",
                        "Saffron St at Maranta Street",
                        "Saffron St near Amadeus St",
                        "Hop St at Avocado Street",
                        "Ironbark St near Avocado St",
                        "Ironbark St near Kaffia Ct",
                        "Ironbark St near Angelica St",
                        "Nineteenth Ave near Chesnut St",
                        "Nineteenth Ave near Townson Ave",
                        "Townson Ave near Nineteenth Ave",
                        "Townson Ave near Twentyfourth Ave",
                        "Townson Ave near Tallebudgera Dr",
                        "Tallebudgera Dr near Tarni Ave",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Burleigh Heads National Park",
                        "Tweed St at George St",
                        "Burleigh Heads station"
                    ],
                    "3384: Currumbin Primary - Tugun Shops": [
                        "Currumbin State Primary School",
                        "Palm Beach Currumbin State High School",
                        "Elanora State Primary School hail 'n' ride",
                        "Guineas Creek Rd at Riverside Drive",
                        "Galleon Way at Aegean Way",
                        "Ware Dr near Aethalia St",
                        "Ware Dr near Tudor St",
                        "Galleon Way near Billabong Ct",
                        "Galleon Way at Brigantine Court",
                        "Galleon Way near Keegan Cct",
                        "Galleon Way near Jutland Pl",
                        "Clives Cct at Hoffschildt Drive",
                        "Clives Cct near Robinson Pl",
                        "Clives Cct near Bernoth St",
                        "Bienvenue Dr near Border Dr",
                        "Currumbin Creek Rd near Mainsail St",
                        "Currumbin Creek Rd at Nuban St",
                        "Currumbin Creek Rd near Traders Way",
                        "Currumbin Creek Rd at Love Street",
                        "Currumbin Creek Rd at Currumbin RSL",
                        "Duringan St at Fielding Street",
                        "Duringan St at Panorama Drive",
                        "Currumbin Wildlife Sanctuary",
                        "Teemangum St at Kropp Park",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Golden Four Dr at Tugun Beach shops"
                    ],
                    "3385: Mudgeeraba Creek Primary - Ashmore Rd": [
                        "Mudgeeraba Creek Primary School",
                        "Berrigans Rd near Wallandra Dr hail 'n' ride",
                        "Wallandra Rd near Baileys Rd hail 'n' ride",
                        "Wallandra Rd near Bendigo Ct hail 'n' ride",
                        "Old Coach Rd at Wallandra Road",
                        "Rainbow Dr near Cobai Dr",
                        "Milky Way near Moonbeam Pde hail 'n' ride",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Rainbow Dr at Universe Court",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Mudgeeraba Rd near Quambone St",
                        "Quambone St near Jeremy Ct hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Alkira Way near Kabra Ct hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near Kurilpa St hail 'n' ride",
                        "Dormello Dr near San Fernando Dr hail 'n' ride",
                        "Dormello Dr near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near San Fernando Dr hail 'n' ride",
                        "Bourton Rd near Willunga Pl",
                        "Highfield Dr near Cabot Ct",
                        "All Saints Anglican School",
                        "Gooding Dr at Bourton Road",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Rd at Cararra Markets",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop A",
                        "Sunshine Bvd at Merrimac Boulevard",
                        "Sunshine Bvd at Sonder Street",
                        "TE Peters Dr at Summerland Key",
                        "Rio Vista Bvd near Grant Pl",
                        "Rio Vista Bvd at Cristobel Court",
                        "Rio Vista Bvd at Sheridan Park Avenue",
                        "Monaco St at Rio Vista Boulevard",
                        "Monaco St at Pacific Boulevard",
                        "Monaco St at Bill Compton Park",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Sorrento Shopping Village",
                        "Ashmore Rd at Upton Street",
                        "Ashmore Rd at Campbell Street",
                        "Ashmore Road Commercial Precinct",
                        "Ashmore Rd at Sir Bruce Small Park",
                        "Benowa Gardens Shopping Centre",
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at Sapium Road",
                        "Wardoo St near Cotlew St hail 'n' ride",
                        "Cotlew St at Hermitage Close",
                        "Cotlew St at Parkleigh Court",
                        "Cotlew St at Ashmore Plaza",
                        "Currumburra Rd near Mualla Dr",
                        "Currumburra Rd at Mualla Drive",
                        "Currumburra Rd near Tangerine Row",
                        "Ashmore Rd near Warrungen Way hail 'n' ride"
                    ],
                    "3386: St Michaels - Mudgeeraba": [
                        "Jondique Ave at Saint Michaels College",
                        "Camberwell Cct near Kensington St",
                        "Yarraville St at Camberwell Circuit",
                        "Yarraville St near Bentleigh Ct",
                        "Markeri St at Ron Penhaligon Way",
                        "Markeri St near Allandale Ent",
                        "Markeri St near Drayton Tce",
                        "Barrier Reef Dr near Wild Duck Dr",
                        "Markeri St near Orpheus Rd",
                        "Ron Penhaligon Way near Markeri St",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Ron Penhaligon Way near Homebush Dr",
                        "Ron Penhaligon Way near Tennyson Pl",
                        "Cheltenham Dr near Belmore Cl",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Somerset Dr near Leviathan Dr",
                        "Somerset College",
                        "Somerset Dr near Bonogin Rd hail 'n' ride",
                        "Bonogin Rd near Gunsynd Dr hail 'n' ride",
                        "Hardys Rd near Glenmore Dr hail 'n' ride",
                        "Hardys Rd near Rising Fast Rd hail 'n' ride",
                        "Hardys Rd near Bertana Dr hail 'n' ride",
                        "Hardys Rd near Natan Rd hail 'n' ride",
                        "Wallandra Rd near Baileys Rd hail 'n' ride",
                        "Old Coach Rd at Tallai Rd Bus Shelter HnR",
                        "Mudgeeraba Rd near Old Coach Rd hail 'n' ride",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Worongary Rd near Vince Hinde Dr hail 'n' ride"
                    ],
                    "3387: Worongary Primary - Nerang West": [
                        "Worongary Primary School",
                        "William Duncan Primary School",
                        "Cayuga St near Mortensen Rd hail 'n' ride",
                        "Mortensen Rd near The Linkway",
                        "Mortensen Rd near The Domain",
                        "Gilston Rd near Alexander Dr hail 'n' ride",
                        "Gilston Rd near Riverpark Dr hail 'n' ride",
                        "McLaren Rd at Beltana Way",
                        "McLaren Rd near Winchester Dr",
                        "McLaren Rd near Oakdale Ave",
                        "McLaren Road at Crusader Way",
                        "Crusader Way near McLaren Rd hail 'n' ride",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Beaudesert Nerang Rd near Dell Ct hail 'n' ride",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Yarrimbah Dr near Goora St hail 'n' ride",
                        "Yarrimbah Dr near McLaren Rd hail 'n' ride",
                        "Dugandan St at Burra Street",
                        "Dugandan St near Koola Dr hail 'n' ride",
                        "Dugandan St at Teasdale Drive"
                    ],
                    "3388: Keebra - Southport Station": [
                        "Keebra Park State High School",
                        "Nerang St at Falconer Street",
                        "Nerang St at West End Shops",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B"
                    ],
                    "3389: Aquinas - Runaway Bay": [
                        "Aquinas Catholic College",
                        "Guardian Angels Catholic Primary",
                        "Nerang St at Falconer Street",
                        "Nerang St at West End Shops",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B",
                        "Scarborough St at Marshall Lane",
                        "Scarborough St at Southport Transit Centre",
                        "Scarborough St near North St hail 'n' ride",
                        "North St near Scarborough St hail 'n' ride",
                        "North St at Norman Street",
                        "Gold Coast Hwy at Broadwater Tourist Park",
                        "Gold Coast Hwy at Southport Tourist Park",
                        "Gold Coast Hwy at Central Street",
                        "Frank St at Whiting Street",
                        "Gold Coast Hwy at Labrador Senior Citizens",
                        "Marine Pde at Parker Street",
                        "Brisbane Rd at Turpin Road",
                        "Hollywell Rd near Thelma Ave",
                        "Morala Ave at Biggera Waters School",
                        "Morala Ave near Ocean St",
                        "Bayview St at Oatland Esplanade",
                        "Bayview St at Madang Crescent",
                        "Runaway Bay Retirement Village",
                        "Runaway Bay Centre",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Bayview St at Karema Crescent",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St near Salvia St",
                        "Bayview St at Columbus Drive",
                        "Bayview St near Sapphire St",
                        "Oxley Dr at Daisy Elms Park",
                        "Oxley Dr at Coombabah State Primary School",
                        "Oxley Dr at Hansford Road",
                        "Oxley Dr at Lae Drive",
                        "Oxley Dr at Cayman Court",
                        "Oxley Dr at Thyme Court",
                        "Oxley Dr at Limetree Parade"
                    ],
                    "3390: Coombabah - Southport": [
                        "Oxley Dr at Coombabah State Primary School",
                        "Hansford Rd near Doreen Dr",
                        "Hansford Rd at Numbat Ct",
                        "Hansford Dr near Sanctuary Ct",
                        "Hansford Rd near Citie Dr",
                        "Myola Ct at Georgia Street",
                        "Esplanade at Tarni St",
                        "Hansford Rd near Sanctuary Ct",
                        "Oxley Dr at Hansford Road",
                        "Oxley Dr at Lae Drive",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd near Siena Pl",
                        "Pine Ridge Rd at Coombabah Road",
                        "Coombabah High School",
                        "Pine Ridge Rd at Pine Ridge Caravan Park",
                        "Pine Ridge Rd at Lensgate Road",
                        "Brisbane Rd at Pine Ridge Road",
                        "Brisbane Rd at Centre View Drive",
                        "Harbour Town, stop A",
                        "Olsen Ave at Blanford Street",
                        "Olsen Ave at Allied Drive",
                        "Olsen Ave at Paul Sharratt Park",
                        "Central St at Central Street Shops",
                        "Central St near Usher Ave",
                        "Usher Ave at Vona Place",
                        "Usher Ave at Whiting Street",
                        "Whiting St at Brown Street",
                        "Whiting St at Government Road",
                        "Wilson St near Saltash St",
                        "Wilson St near Heydon Ave",
                        "Wilson St near First Ave",
                        "Wilson St at Robert Street",
                        "Wilson St at Jimmieson Avenue",
                        "Brooke Ave at Musgrave Avenue",
                        "Brooke Ave at Southport State High School",
                        "Johnston St at Beale Street",
                        "Johnston St near Maid St",
                        "Johnston St near Kate St",
                        "Nind St near Chapel St",
                        "Scarborough St at Marshall Lane",
                        "Southport bus station, stop A"
                    ],
                    "3391: Merrimac High - Mattocks Rd": [
                        "Dunlop Ct at Merrimac State High School",
                        "Rio Vista Bvd near Cottesloe Dr",
                        "Cottesloe Dr near Kirup St",
                        "Bermuda St at Lake Orr",
                        "Christine Ave at Bermuda Street",
                        "Christine Ave at Silvabank Drive",
                        "Silvabank Dr near Lomond Ct hail 'n' ride",
                        "Cumberland Dr near Yodelay St",
                        "Cumberland Dr near Dorothy Pl hail 'n' ride",
                        "Southlake Dr near Cumberland Dr hail 'n' ride",
                        "Cumberland Dr near Silvabank Dr",
                        "Mattocks Rd near Bluemoon Cl",
                        "Treeview Dr at Treetop Court",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Oakland Court",
                        "Treeview Dr near Whipbird Ct",
                        "Mattocks Rd at Bushtree Ct",
                        "Grevillea Dr near Eucalyptus Ave hail 'n' ride",
                        "Cassia Dr near Grevillea Dr hail 'n' ride",
                        "Cassia Dr near Mattocks Rd hail 'n' ride"
                    ],
                    "3392: Keebra - Nerang Rail": [
                        "Keebra Park State High School",
                        "Nerang station"
                    ],
                    "3393: Emmanuel College - Robina Waters": [
                        "Birmingham Rd at The Boulevard",
                        "All Saints Anglican School",
                        "Highfield Dr near All Saints Anglican School",
                        "Robina Town Centre",
                        "Robina Town Centre Dr at Christine Avenue",
                        "Robina Town Centre Drive at Scottsdale Dr",
                        "Robina Town Centre Dr at Eastlake Apartments",
                        "Robina Town Centre Dr at Leabrook Crescent",
                        "Cheltenham Dr near Glenside Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Killarney Ave near Huntingdale Cr",
                        "Killarney Ave at Robina State School",
                        "Glen Eagles Dr near Dundee Ct",
                        "Glen Eagles Dr near Karrinyup Pl",
                        "Glen Eagles Dr near Firestone Ct",
                        "Ron Penhaligon Way at Banff Court",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way near Bothwell St",
                        "Cheltenham Dr near Belmore Cl",
                        "Tullamarine Dr near Glen Iris Pl",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Camberwell Cct near Caulfield Street",
                        "Camberwell Cct near Kensington St",
                        "Yarraville St at Camberwell Circuit",
                        "Yarraville St near Bentleigh Ct",
                        "Ron Penhaligon Way near Markeri St",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Ron Penhaligon Way near Homebush Dr",
                        "Manly Dr near Pipers Pt",
                        "Manly Dr near Sandringham Dr",
                        "Pyrmont St near Cottesloe Dr",
                        "Bond University"
                    ],
                    "3394: OWHS - Peachy Rd": [
                        "Ormeau Woods High School",
                        "Peachey Road interchange hail 'n' ride",
                        "Peachey Rd at Doherty Ct",
                        "Vaughan Dr near Wille Ct hail 'n' ride",
                        "Vaughan Dr near Beausang Pl hail 'n' ride",
                        "Peachey Rd near Caswell Ct"
                    ],
                    "3395: Ormeau Primary - Arthur Way": [
                        "Mirambeena Dr at Ormeau School",
                        "Reedmans Rd near Arthur Way hail 'n' ride",
                        "Reedmans Rd near Arthur Way",
                        "Gawain Dr near Bedivere Dr",
                        "Gawain Dr near Lahey Ct",
                        "Arthur Way near Gawain Dr",
                        "Eggersdorf Rd near Arthur Way hail 'n' ride",
                        "Tillyroen Rd near Ormeau Ridge Rd hail 'n' ride",
                        "Upper Ormeau Rd near Thomsons Rd hail 'n' ride",
                        "Thomsons Rd near Upper Ormeau Rd hail 'n' ride",
                        "Thomsons Rd near Stage Coach Dr hail 'n' ride",
                        "Stage Coach Dr at Kingsholme hail 'n' ride",
                        "Barrenjoey Dr near Barrenjoey Dr hail 'n' ride",
                        "Upper Ormeau Rd near Cliff Barrons Rd HnR",
                        "Upper Ormeau Rd near Boral Quarry hail 'n' ride"
                    ],
                    "3397: Nerang - Upper Coomera via Canungra": [
                        "Nerang St at Nerang State School",
                        "Birribi Ave near Nerang River Dr",
                        "Nerang High School",
                        "McLaren Rd at Beltana Way",
                        "McLaren Road at Crusader Way",
                        "McLaren Rd near Winchester Dr",
                        "Yarrimbah Dr near Goora St hail 'n' ride",
                        "Yarrimbah Dr at Yalkuri Drive",
                        "Billabirra Ct at Beaudesert Nerang Rd HnR",
                        "Mount Nathan Rd near Arunta Dr hail 'n' ride",
                        "The Oval Dr near Beaudesert Nerang Rd HnR",
                        "Nathanvale Dr near Pasture Pl hail 'n' ride",
                        "Nathanvale Dr near Mountain View Cr hail 'n' ride",
                        "Clagiraba Rd near Gerara Ct hail 'n' ride",
                        "Clagiraba Rd near Witheren Rd hail 'n' ride",
                        "Clagiraba Rd near Thendara Dr hail 'n' ride",
                        "Barcoo Ct near Clagiraba Rd hail 'n' ride",
                        "Barcoo Ct at Diamantina Ct hail 'n' ride",
                        "Beaudesert Nerang Rd near Cemetery Rd HnR",
                        "Kidston St at DJ Smith Park hail 'n' ride",
                        "Beaudesert Nerang Rd near Canungra Ct HnR",
                        "Beaudesert Nerang Rd near Henri Robert Dr HnR",
                        "Beaudesert Nerang Rd near Riverglen Ct HnR",
                        "Maudsland Rd near Beaudesert-Nerang Rd HnR",
                        "Maudsland Rd near Guanaba Creek Rd hail 'n' ride",
                        "Maudsland Rd near Riverstone Rd hail 'n' ride",
                        "Maudsland Rd near Cobb And Co Dr hail 'n' ride",
                        "Tamborine Oxenford Rd near Charlies Xing Rd",
                        "Reserve Rd near Jemima Pl",
                        "Reserve Rd near Amelia St",
                        "Reserve Rd near Greenleaf St hail 'n' ride",
                        "Reserve Rd near Jessica Dr",
                        "Reserve Road at Abraham Rd"
                    ],
                    "3398: Ashmore Primary - Molendinar": [
                        "Currumburra Rd at Ashmore Primary School",
                        "Currumburra Rd at Green Glen Road",
                        "Ashmore City Shopping Centre",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Trinity Lutheran School",
                        "Panache St near Coachwood Dr hail 'n' ride",
                        "Verdelho Way near Chablis Ct hail 'n' ride",
                        "Coachwood Dr near Cabernet Cl hail 'n' ride",
                        "Mitchell Ave at Coachwood Drive",
                        "Macquarie Ave at Lachlan Avenue",
                        "Macquarie Ave near Batchworth Rd hail 'n' ride",
                        "Macquarie Ave near Watford Cr hail 'n' ride",
                        "Ashmore Rd near Kingsway Dr hail 'n' ride",
                        "Ashmore Rd near Keen St hail 'n' ride",
                        "Hellman St hail 'n' ride",
                        "Pilar Ct hail 'n' ride"
                    ],
                    "3399: Pacific Pines - Riverstone Crossing": [
                        "Pacific Pines Primary School",
                        "Park Lake Primary School",
                        "Matthews Dr near Roberts Dr hail 'n' ride",
                        "Greenway Bvd near Brissendon St",
                        "Greenway Bvd near Keneally St hail 'n' ride",
                        "Gaven Arterial Rd at Felling Drive",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Cobb and Co Dr near Appollo Pl",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Lagoon Park Dr near Meadow Ct hail 'n' ride",
                        "Lagoon Park Dr near Summer Hill Cr hail 'n' ride",
                        "Greenacre Way near Lagoon Park Dr hail 'n' ride",
                        "Riverstone Crsg near Rivermill Tce hail 'n' ride",
                        "Riverstone Crsg near Northern Skies Tce HnR",
                        "Riverstone Crsg near Valley Brook Rise HnR",
                        "Riverstone Crsg near Hibiscus Cr hail 'n' ride",
                        "Riverstone Crsg near Prairie Av hail 'n' ride",
                        "Riverstone Crsg near Mountain View Pde HnR",
                        "Rivermill Tce near Plantation Cr hail 'n' ride",
                        "Rivermill Tce near Settlers Ave hail 'n' ride"
                    ],
                    "3400: Benowa School - Pappas Way": [
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Birmingham Rd at The Boulevard",
                        "Nielsens Rd at Hickey Way",
                        "Hickey Way near Michelmore Rd hail 'n' ride",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Chisholm Rd near Marble Dr hail 'n' ride"
                    ],
                    "3401: Coomera Rivers - Daintree Dr": [
                        "Coomera Rivers Primary School",
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Edwardson Dr near Amity Rd hail 'n' ride",
                        "Pamplet Lane near Daintree Dr hail 'n' ride",
                        "Daintree Dr near Amity Rd hail 'n' ride"
                    ],
                    "3402: Coombabah - Paradise Point": [
                        "Coombabah High School",
                        "Oxley Dr at Crystal Reef Drive",
                        "Oxley Dr at Hansford Road",
                        "Hansford Rd near Doreen Dr",
                        "Hansford Rd at Numbat Ct",
                        "Hansford Rd near Citie Dr",
                        "Myola Ct at Georgia Street",
                        "Esplanade at Tarni St",
                        "Hansford Rd near Sanctuary Ct",
                        "Argyll Ave near Wendoree Way",
                        "Lefroy Dr near Rason Way hail 'n' ride",
                        "Brady Dr near Burrendong Rd",
                        "Oxley Dr at Coombabah State Primary School",
                        "Oxley Dr at Daisy Elms Park",
                        "Oxley Dr at Blaxland Avenue",
                        "Paradise Pde near Nankeen Ave",
                        "Paradise Pde near Mallard Ave",
                        "Paradise Pde at Donald Avenue"
                    ],
                    "3403: AB Patterson - Paradise Point": [
                        "Arundel Dr near Paterson Dr",
                        "Coombabah High School",
                        "Pine Ridge Rd at Coombabah High School",
                        "Pine Ridge Rd at Coombabah Road",
                        "Pine Ridge Rd at Siena Place",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Lae Dr at Morala Avenue",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Bayview St at Karema Crescent",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St near Salvia St",
                        "Bayview St at Columbus Drive",
                        "Bayview St near Sapphire St",
                        "Bayview St near Falkinder Ave",
                        "Paradise Pde near Sunbird Ave",
                        "Abalone Ave near Thrush Ave hail 'n' ride",
                        "Sunbird Ave near Oxley Dr hail 'n' ride",
                        "Oxley Dr at Blaxland Avenue",
                        "Oxley Dr at Daisy Elms Park",
                        "Oxley Dr at Coombabah State Primary School",
                        "Oxley Dr at Hansford Road",
                        "Oxley Dr at Marsupial Drive",
                        "Oxley Dr at Lae Drive"
                    ],
                    "3404: Varsity - Robina Waters": [
                        "Varsity Pde at Varsity Lakes College",
                        "Varsity College Junior Campus",
                        "Christine Ave at Varsity Sound Avenue",
                        "Varsity Pde near University Dr",
                        "Varsity Pde at Lakefront Crescent",
                        "Bond University",
                        "University Dr near Cottesloe Dr",
                        "Pyrmont St near Cottesloe Dr",
                        "Manly Dr near Sandringham Dr",
                        "Manly Dr near Pipers Pt",
                        "Ron Penhaligon Way near Vaucluse Pl",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Markeri St near Ron Penhaligon Way",
                        "Yarraville St near Markeri St",
                        "Yarraville St near Altona Cl",
                        "Camberwell Cct near Kensington St",
                        "Camberwell Cct at Caulfield Street",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Tullamarine Dr near Cheltenham Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Cheltenham Dr near Bellmore Cl",
                        "Ron Penhaligon Way near Kentwood Dr",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way at Banff Court",
                        "Glen Eagles Dr near Oakmont St",
                        "Glen Eagles Dr near Federal Pl",
                        "Glen Eagles Dr near Princeville Ct",
                        "Glen Eagles Dr near Killarney Ave",
                        "Killarney Ave near Turnberry Ct"
                    ],
                    "3405: PBCH - Simpson Dr Bus Shelter": [
                        "Palm Beach Currumbin State High School",
                        "Coolangatta Rd near Cabarita Ave",
                        "Kitchener St near Morshead St",
                        "Monash St near Foch St hail 'n' ride",
                        "Boyd St near Tugun St",
                        "Kennedy Dr at Kennedy Plaza",
                        "Norman St - cnr QuarterDeck",
                        "The Quarterdeck near Mugga Way",
                        "Ducat St near Caloola Dr",
                        "Kennedy Dr near Rose St",
                        "Kennedy Dr near Gray St",
                        "Kennedy Dr near Limosa Rd",
                        "Kennedy Dr near Tweed River Regional Museum",
                        "Gollan Dr near The Lakes Dr",
                        "Scenic Dr Opp Panorama Shops",
                        "Scenic Dr near Bilinga Cct",
                        "Simpson Dr near Scenic Dr",
                        "Simpson Dr - cnr Terranora Pde",
                        "Simpson Dr Bus Shelter"
                    ],
                    "3407: Currumbin Primary - PBCH": [
                        "Currumbin State Primary School",
                        "Currumbin Creek Rd near Villiers Dr",
                        "Currumbin Creek Rd near Bienvenue Dr",
                        "Clives Cct at Hoffschildt Drive",
                        "Clives Cct near Robinson Pl",
                        "Clives Cct near Bernoth St",
                        "Bienvenue Dr near Border Dr",
                        "Cannon Dr near The Cross Rd",
                        "Currumbin Creek Rd near Mainsail St",
                        "Currumbin Creek Rd at Nuban St",
                        "Palm Beach Currumbin State High School"
                    ],
                    "3408: PBCH - Pacific Fair": [
                        "Palm Beach Currumbin State High School",
                        "Palm Beach",
                        "Gold Coast Hwy at Eighth Avenue",
                        "Gold Coast Hwy at Tenth Avenue",
                        "Gold Coast Hwy at Fifteenth Avenue",
                        "Nineteenth Avenue",
                        "Gold Coast Hwy at Twenty First Avenue",
                        "Gold Coast Hwy at Twenty Fifth Avenue",
                        "Twenty Seventh Avenue",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Burleigh Heads National Park",
                        "Tweed St at George St",
                        "Burleigh Heads station",
                        "Burleigh Heads Primary School CLOSED",
                        "Gold Coast Hwy at Christine Avenue station",
                        "Gold Coast Hwy at Miami station",
                        "Gold Coast Hwy at Miami North station",
                        "Gold Coast Hwy at Nobby Beach station",
                        "Gold Coast Hwy at Mermaid Beach South station",
                        "Gold Coast Hwy at Mermaid Beach station",
                        "Broadbeach South station"
                    ],
                    "3409: Elanora High - Ourimbah Rd": [
                        "Elanora State Primary School hail 'n' ride",
                        "Sarawak Ave at Salk Oval",
                        "Palm Beach Currumbin State High School",
                        "Palm Beach Currumbin High School",
                        "Thrower Dr near Luzon Pde",
                        "Gold Coast Hwy at Thrower Drive",
                        "Gold Coast Hwy at Currumbin Hill",
                        "Currumbin Wildlife Sanctuary",
                        "Teemangum St at Kropp Park",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Dr at Shell Street",
                        "Tugun Village Community Centre hail 'n' ride",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Mills St hail 'n' ride",
                        "Golden Four Dr at George Street",
                        "Cahill Street",
                        "Golden Four Dr at Archer Street",
                        "Golden Four Dr at North Kirra Beach",
                        "Coolangatta State Primary School",
                        "Miles St near Kirra Park"
                    ],
                    "3410: Marymount - Broadbeach Waters via Mermaid Waters": [
                        "Marymount College",
                        "Bermuda St at Lake Orr",
                        "Cottesloe Dr near Bermuda St",
                        "Rio Vista Bvd near Cottesloe Dr hail 'n' ride",
                        "Rio Vista Bvd near Crestmore Ct",
                        "Rio Vista Bvd near Barrier Reef Dr",
                        "Barrier Reef Dr near Deloraine Ct",
                        "Barrier Reef Dr near Halborne Dr",
                        "Barrier Reef Dr near Henning Ct",
                        "Barrier Reef Dr near Orpheus Rd",
                        "Barrier Reef Dr near Rio Vista Bvd",
                        "Markeri St near Intrepid Dr",
                        "Markeri St near Rumrunner St",
                        "Markeri St near Sunshine Bvd",
                        "Sunshine Bvd near Markeri St",
                        "Sunshine Bvd at Gooding Park",
                        "Sunshine Bvd at Bordeaux Street",
                        "Sunshine Bvd at Merrimac Boulevard",
                        "Sunshine Bvd at Sonder Street",
                        "TE Peters Dr at Summerland Key",
                        "Rio Vista Bvd near Grant Pl",
                        "Rio Vista Bvd at Cristobel Court",
                        "Rio Vista Bvd at Sheridan Park Avenue",
                        "Monaco St at Rio Vista Boulevard",
                        "Monaco St at Pacific Boulevard",
                        "Monaco St at Bill Compton Park",
                        "Bermuda St at Albert Park",
                        "Bundall Rd at Sorrento Shopping Village"
                    ],
                    "3411: Pimpama Colleges - Abraham Rd": [
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Yawalpah Rd at Swan Road",
                        "Yawalpah Rd at Salzburg Rd hail 'n' ride",
                        "Rifle Range Rd at Bull Road",
                        "Pimpama Sports Hub",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Old Coach Rd at Days Road",
                        "Days Rd at City Centre Drive",
                        "Williamson Rd near Billinghurst Cr",
                        "Turnbull Dr near Abraham Rd hail 'n' ride"
                    ],
                    "3412: Helensvale High - Finnegan Way": [
                        "Helensvale State High School",
                        "Siganto Dr at Tradewinds Street",
                        "Dreamworld Parkway at Boathouse Tavern",
                        "Beattie Rd at Ford Road",
                        "Waterway Dr at McPhail Rd",
                        "Waterway Dr at Shipper Drive",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Finnegan Way at Felix Entrance",
                        "Finnegan Way near Trillers Ave hail 'n' ride",
                        "Finnegan Way at Lily Avenue"
                    ],
                    "3413: Pimpama Colleges - Pimpama City": [
                        "Dixon Dr at Pimpama State Primary College",
                        "Dixon Drive at Pimpama State Secondary College",
                        "Swan Rd near Yatala St hail 'n' ride",
                        "Swan Rd at Aquila Reserve",
                        "Gainsborough Dr near Swan Rd hail 'n' ride",
                        "Gainsborough Dr near Towarri St hail 'n' ride",
                        "Gainsborough Dr at Flinders Street",
                        "Sarabah Way near Narrien St hail 'n' ride",
                        "Kosciuszko Cct near Sarabah Way hail 'n' ride",
                        "Village Bvd at Chisolm Way",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Depot Rd near Pimpama Jacobs Well Rd"
                    ],
                    "3414: Foxwell Hight - Coomera Sports Park": [
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Waterway Dr at Shipper Drive",
                        "Waterway Dr at McPhail Rd",
                        "Beattie Rd at Ford Road",
                        "Lorenzo Dr at Beattie Road",
                        "Yaun St near Sena St",
                        "Yaun St near Jowett St"
                    ],
                    "3415: Southport Primary - Ashmore Plaza": [
                        "Southport State School",
                        "Ferry Rd at Minnie Street",
                        "Ferry Rd at Harvest Court",
                        "Benowa Rd at Drury Avenue",
                        "Benowa Rd at Golden Crescent",
                        "Ridgeway Ave near Gayle St",
                        "Shirley St near Melinda St",
                        "Shirley St at Anne Street",
                        "Kindra Ave near Larwon Tce",
                        "Kindra Ave at Lara Avenue",
                        "Tongarra St near Lilli Pilli Dr",
                        "Coolibah St at Sussex Drive Park",
                        "Cotlew St at Tecoma Street",
                        "Cotlew St at Hermitage Close",
                        "Cotlew St at Parkleigh Court",
                        "Cotlew St at Ashmore Plaza"
                    ],
                    "3416: Pimpama Primary School - Hotham Creek": [
                        "Pimpama Primary School",
                        "Waverly Dr at Rifle Range Road",
                        "Hotham Creek Rd near Blacks Rd hail 'n' ride",
                        "Ruffles Rd near Hotham Creek Rd hail 'n' ride",
                        "Waverly Dr at Persimmon Street",
                        "Waterhouse Dr near McLachlan Cct hail 'n' ride",
                        "Ruffles Rd near Peanba Park Rd hail 'n' ride",
                        "Days Rd near Capelily St hail 'n' ride"
                    ],
                    "3417: Pimpama Primary - The Heights": [
                        "Pimpama Primary School",
                        "Bella Bvd at Deepak Drive",
                        "Waverly Dr at Persimmon Street",
                        "Bella Bvd near Matthews Cr hail 'n' ride",
                        "Waterhouse Dr near McLachlan Cct hail 'n' ride",
                        "Waverley Dr at Bella Boulevard",
                        "Rifle Range Rd at Bull Road",
                        "The Heights Bvd near Pinnacle Way hail 'n' ride",
                        "The Heights Bvd near Song Cr hail 'n' ride",
                        "Old Coach Rd near Coomera Springs Bvd"
                    ],
                    "3418: OWHS - Ormeau Station": [
                        "Ormeau Woods High School",
                        "Mirambeena Dr near Lumeah Ave",
                        "Lumeah Ave near Oomool Ct hail 'n' ride",
                        "Lumeah Ave near Warrawee Way hail 'n' ride",
                        "Guara Grove at Mirambeena Dr hail 'n' ride",
                        "Mirambeena Dr at Ormeau School"
                    ],
                    "3419: Gainsborough School - Depot Rd": [
                        "Yawalpah Rd at Gainsborough State School",
                        "Swan Rd near Yatala St hail 'n' ride",
                        "Swan Rd at Aquila Reserve",
                        "Gainsborough Dr near Swan Rd hail 'n' ride",
                        "Gainsborough Dr near Towarri St hail 'n' ride",
                        "Gainsborough Dr at Flinders Street",
                        "Sarabah Way near Narrien St hail 'n' ride",
                        "Kosciuszko Cct near Sarabah Way hail 'n' ride",
                        "Bedford Rd near Christopher St hail 'n' ride",
                        "Bedford Rd near Attenborough Rd hail 'n' ride",
                        "Village Bvd at Dorset Street",
                        "Village Bvd at Chisolm Way",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Depot Rd near Pimpama Jacobs Well Rd"
                    ],
                    "3420: Elanora - Burleigh Heads": [
                        "Elanora State Primary School hail 'n' ride",
                        "Avocado St near Doubleview Dr",
                        "Nineteenth Ave at Elanora High School",
                        "Nineteenth Ave at Kalmia Court",
                        "Casuarina Dr at Ottelia Drive",
                        "Casuarina Dr at Silver Glade Drive",
                        "Silver Glade Dr at Laurina Court",
                        "Silver Glade Dr at Typha Place",
                        "Casuarina Dr near Silver Glade Dr",
                        "Casuarina Dr near Ottelia Dr",
                        "Tallebudgera Primary School",
                        "Valley Dr near Green Lane hail 'n' ride",
                        "Dudgeon Dr near Jersey Ct hail 'n' ride",
                        "Tallebudgera Connection Rd near Andrews Rd HnR",
                        "St Andrews Lutheran Aged Care hail 'n' ride",
                        "Tallebudgera Creek Rd at Tsipura Drive",
                        "West Burleigh Rd at Dunlin Drive",
                        "Burleigh Heads station"
                    ],
                    "3421: PBCH - Kingscliff Boat Ramp": [
                        "Palm Beach Currumbin State High School",
                        "Golden Four Drive at St Monica's Catholic Church",
                        "Golden Four Dr at Tugun Beach shops",
                        "Golden Four Dr at Shell Street",
                        "Tugun Village Community Centre hail 'n' ride",
                        "Golden Four Dr at Short Street",
                        "Golden Four Dr at Bilinga Beach SLSC",
                        "Golden Four Dr at Bilinga Beach",
                        "Golden Four Dr at Mills St hail 'n' ride",
                        "Golden Four Dr at George Street",
                        "Cahill Street",
                        "Golden Four Dr at Archer Street",
                        "Golden Four Dr at North Kirra Beach",
                        "Musgrave St at Coyne Street",
                        "Musgrave St at Kirra shops",
                        "Marine Pde at Kirra Beach",
                        "McLean St at Queen Elizabeth Park",
                        "Coolangatta Central",
                        "Griffith St at Coolangatta East",
                        "Wharf St at Tweed Mall",
                        "Wharf St near Florence St",
                        "Wharf St near Monastery Lane",
                        "Minjungbal Dr near Dry Dock Rd",
                        "Minjungbal Dr near Agnes St",
                        "Minjungbal Dr near Lloyd St",
                        "Minjungbal Dr at South Tweed Heads Coach Stop",
                        "Minjungbal Dr at Tweed City Shopping Centre",
                        "Minjungbal Dr near Soorley St",
                        "Minjungbal Dr at Tweed Hub",
                        "Sexton Hill Dr at Pioneer Parade Footbridge",
                        "Chinderah Bay Dr near Homestead Caravan Park",
                        "Chinderah Bay Dr near Waugh St",
                        "Wommin Bay Rd near Walsh St",
                        "Wommin Bay Rd near Phillip St",
                        "Kingscliff St near Shell St",
                        "Kingscliff St near Pacific St",
                        "Pearl St at Kingscliff Shopping Mall",
                        "Marine Pde near Faulks Park"
                    ],
                    "3422: Robina High - The Observatory": [
                        "Robina State High School",
                        "Christine Ave at Olympus Drive",
                        "Christine Ave at Konda Way",
                        "Christine Ave at Varsity Sound Avenue",
                        "Christine Ave at Varsity College",
                        "Christine Ave at Regensberg Close",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Silvabank Drive",
                        "Mattocks Rd near Bluemoon Cl",
                        "Mattocks Rd at Bushtree Ct",
                        "Mattocks Rd at Viburnum Street",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Bridgman Dr near Old Coach Rd",
                        "Bridgman Dr near Heulan Ct",
                        "Bridgman Dr near Royston Cr",
                        "Bridgman Dr near Woodland Dr",
                        "Woodland Dr near Navars St",
                        "Kingsmore Bvd near Tuckeroo Pl",
                        "Wyllie Way near Gordonia Dr",
                        "Observatory Dr near Grove Creek Cl",
                        "Observatory Dr near Golden Grove Bvd",
                        "Observatory Dr near Willow Tree Dr",
                        "Observatory Dr near Palomar St"
                    ],
                    "3423: Miami - Palm Beach": [
                        "Miami State High School",
                        "Gold Coast Hwy at Christine Avenue station",
                        "Christine Ave at Hibiscus Haven",
                        "Christine Ave at Spoonbill Court",
                        "Christine Ave at Barbet Place",
                        "Christine Ave at Burleigh Waters Library",
                        "Christine Ave at Caningeraba State School",
                        "Christine Ave at Bermuda Street",
                        "Mattocks Rd near Bluemoon Cl",
                        "Treeview Dr at Treetop Court",
                        "Treeview Dr near Honeywood Ct",
                        "Treeview Dr at Oakland Court",
                        "Treeview Dr near Whipbird Ct",
                        "Mattocks Rd at Bushtree Ct",
                        "Mattocks Rd at Viburnum Street"
                    ],
                    "3424: Mudgeeraba Primary - Robina Station": [
                        "Old Coach Rd at Mudgeeraba State School",
                        "Wallandra Dr at Old Coach Rd hail 'n' ride",
                        "Wallandra Rd near Marcus Way hail 'n' ride",
                        "Wallandra Rd near Tuena St hail 'n' ride",
                        "Wallandra Rd near Baileys Rd hail 'n' ride",
                        "Berrigans Rd near Wallandra Dr hail 'n' ride",
                        "Mudgeeraba Creek Primary School",
                        "Hardys Rd near Natan Rd hail 'n' ride",
                        "Hardys Rd near Gunsynd Dr hail 'n' ride",
                        "Hardys Rd near Bonogin Rd hail 'n' ride",
                        "Bonogin Rd near Warra Ct hail 'n' ride",
                        "Gunsynd Dr near Tulloch Cr hail 'n' ride",
                        "Gunsynd Dr near Todman Dr hail 'n' ride",
                        "Somerset Dr at Somerset College",
                        "Somerset Dr at Clover Hill Drive",
                        "Clover Hill Primary School",
                        "Swanton Dr near Somerset Dr",
                        "Swanton Dr near Springsure Dr",
                        "Swanton Dr near Chute St",
                        "Leviathan Dr near Victory Dr hail 'n' ride",
                        "Robina station"
                    ],
                    "3425: Miami High - Pacific Fair": [
                        "Miami State High School",
                        "Gold Coast Hwy at Third Avenue CLOSED until 26-04-26",
                        "Gold Coast Hwy at Second Avenue station",
                        "Acanthus Ave at Burleigh Heads Infants School",
                        "West Burleigh Rd at Stanley Street",
                        "West Burleigh Rd at George Street West",
                        "West Burleigh Rd at Dunlin Drive",
                        "Cassia Dr near Mattocks Dr hail 'n' ride",
                        "Coolibah Cr near Willow St",
                        "Brier Cr near Hedge Row hail 'n' ride",
                        "Willow St near Eucalyptus Ave",
                        "Mattocks Rd at Viburnum Street",
                        "Reedy Creek Rd at Ambassador Drive",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Gemvale Rd near Reedy Creek Rd",
                        "Gemvale Rd at Kings Christian College",
                        "Gemvale Rd near Langport Pde",
                        "Gemvale Rd near Northampton Bvd",
                        "Gemvale Rd near Somerset Dr",
                        "Somerset College",
                        "Somerset Dr near Gemvale Rd",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Killarney Ave near Huntingdale Cr",
                        "Killarney Ave at Robina State School",
                        "Glen Eagles Dr near Dundee Ct",
                        "Glen Eagles Dr near Karrinyup Pl",
                        "Glen Eagles Dr near Firestone Ct",
                        "Ron Penhaligon Way at Banff Court",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way near Bothwell St",
                        "Ron Penhaligon Way near Commerce Dr",
                        "Manly Dr near Pipers Pt",
                        "Manly Dr near Sandringham Dr",
                        "Pyrmont St near Cottesloe Dr",
                        "Cottesloe Dr near Manly Dr",
                        "Cottesloe Dr near Vancouver Dr",
                        "Cottesloe Dr near Bermuda St",
                        "Rio Vista Bvd near Cottesloe Dr hail 'n' ride",
                        "Rio Vista Bvd near Karabella Ct",
                        "Rio Vista Bvd near Crestmore Ct",
                        "Rio Vista Bvd near Barrier Reef Dr",
                        "Rio Vista Bvd near Wayfarer Ave",
                        "Rio Vista Bvd near Southerly St",
                        "Markeri St near Intrepid Dr",
                        "Markeri St near Rumrunner St",
                        "Markeri St near Sunshine Bvd",
                        "Sunshine Bvd near Markeri St",
                        "Sunshine Bvd at Gooding Park",
                        "Sunshine Bvd at Bordeaux Street",
                        "Pacific Fair, stop B"
                    ],
                    "3426: Marymount - Christine Ave via Mattocks Rd": [
                        "Marymount College",
                        "Mattocks Rd at Viburnum Street",
                        "Mattocks Rd near Bushtree Ct",
                        "Mattocks Rd at Bluemoon Cl",
                        "Christine Ave at Silvabank Drive",
                        "Christine Ave at Pennsylvania Avenue",
                        "Christine Ave at Regensberg Close",
                        "Christine Ave at Varsity College",
                        "Christine Ave at Bayswater Ave hail 'n' ride",
                        "Christine Ave at Varsity Sound Avenue",
                        "Christine Ave near Varsity Pde",
                        "Varsity Pde near University Dr",
                        "Varsity Pde at Lakefront Crescent",
                        "University Dr near Shore Ave",
                        "University Dr near Varsity Pde",
                        "Christine Ave at Konda Way",
                        "Christine Ave at Goldwater Drive",
                        "Christine Ave near Scottsdale Dr hail 'n' ride"
                    ],
                    "3427: Coolangatta Primary - Thrower Dr": [
                        "Coolangatta State Primary School",
                        "Golden Four Dr at North Kirra Beach",
                        "Johnston Street",
                        "Golden Four Dr at George Street",
                        "Coolangatta Rd at Kirribin Street",
                        "Coolangatta Rd near Loongana Ave",
                        "Coolangatta Rd near Kiewa Ave",
                        "Boyd St near Morshead St",
                        "Monash St near Foch St hail 'n' ride",
                        "Cabarita Ave near Nangana St hail 'n' ride",
                        "Cabarita Ave near Mirreen Dr",
                        "Thrower Dr near Luzon Pde",
                        "Palm Beach Currumbin High School"
                    ],
                    "3428: Marymount - Highland Park via Robina": [
                        "Marymount College",
                        "Scottsdale Dr near Reedy Creek Rd",
                        "Varsity Lakes station",
                        "Scottsdale Dr at Firebird Street",
                        "Scottsdale Dr at Laurel Oak Drive",
                        "Scottsdale Dr at Christine Avenue",
                        "Robina Town Centre Drive at Scottsdale Dr",
                        "Robina Town Centre Dr at Eastlake Apartments",
                        "Robina Town Centre Dr at Leabrook Crescent",
                        "Cheltenham Dr near Glenside Dr",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Cheltenham Dr near Bellmore Cl",
                        "Ron Penhaligon Way near Commerce Dr",
                        "Ron Penhaligon Way near Tennyson Pl",
                        "Ron Penhaligon Way near Kentwood Dr",
                        "Killarney Ave near Turnberry Ct",
                        "Killarney Ave near Birkdale St",
                        "Tullamarine Dr near Glen Iris Pl",
                        "Tullamarine Dr near Moorabbin Pl",
                        "Camberwell Cct near Caulfield Street",
                        "Camberwell Cct near Kensington St",
                        "Yarraville St at Camberwell Circuit",
                        "Yarraville St near Bentleigh Ct",
                        "Markeri St at Ron Penhaligon Way",
                        "Fairway Dr near Santa Cruz Bvd hail 'n' ride",
                        "Gooding Dr at Merrimac Golf Course",
                        "Nielsens Rd near Hickey Way hail 'n' ride",
                        "Nielsens Rd at Hickey Way",
                        "Bonooroo Park Shopping Centre",
                        "McKenzie Dr at Monopoly Boulevard",
                        "Cayuga St at Onslow Street"
                    ],
                    "3429: Nerang - Pacific Pines": [
                        "Weedons Rd at Nerang High School",
                        "Nerang St at Nerang State School",
                        "Banyula Dr near Coolibah Rd hail 'n' ride",
                        "Castle Hill Dr at Gaven hail 'n' ride",
                        "Castle Hill Dr at Arjuna Way hail 'n' ride",
                        "Pitcairn Way at Pacific Pines Town Centre",
                        "Pacific Pines High School",
                        "Banyula Dr near Cockatoo Ct hail 'n' ride",
                        "Banyula Dr near Arjuna Way hail 'n' ride",
                        "Banyula Dr near Castle Hill Dr hail 'n' ride",
                        "Nerang Connection Rd near Palings Ct hail 'n' ride",
                        "Southport Nerang Rd at Nerang interchange"
                    ],
                    "3430: Surfers Paradise - Molendinar": [
                        "Surfers Paradise Primary School",
                        "Salerno St at Salerno Street",
                        "Ashmore Rd at Upton Street",
                        "Ashmore Rd at Campbell Street",
                        "Ashmore Road Commercial Precinct",
                        "Ashmore Rd at Sir Bruce Small Park",
                        "Benowa Gardens Shopping Centre",
                        "Allchurch St at Benowa Primary School",
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at Collins Crescent",
                        "Bellevue Park Primary School",
                        "Benowa Rd at Sapium Road",
                        "Ridgeway Ave near Benowa Rd hail 'n' ride",
                        "Ridgeway Ave near Gayle St",
                        "Shirley St near Melinda St",
                        "Shirley St at Anne Street",
                        "Lilli Pilli Dr near Larwon Tce hail 'n' ride",
                        "Lilli Pilli Dr near Dander Dr hail 'n' ride",
                        "Cotlew St at Hermitage Close",
                        "Cotlew St at Parkleigh Court",
                        "Cotlew St at Ashmore Plaza",
                        "Currumburra Rd near Cotlew St",
                        "Currumburra Rd near Koonan Ct",
                        "Currumburra Rd at Green Glen Road",
                        "Ashmore City Shopping Centre",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Trinity Lutheran School",
                        "Panache St near Coachwood Dr hail 'n' ride",
                        "Verdelho Way near Chablis Ct hail 'n' ride",
                        "Coachwood Dr near Cabernet Cl hail 'n' ride",
                        "Mitchell Ave at Coachwood Drive",
                        "Macquarie Ave at Lachlan Avenue",
                        "Macquarie Ave near Watford Cr hail 'n' ride",
                        "Ashmore Rd near Kingsway Dr hail 'n' ride",
                        "Ashmore Rd near Keen St hail 'n' ride",
                        "Hellman St hail 'n' ride"
                    ],
                    "3431: Foxwell Secondary - Coomera Waters": [
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride"
                    ],
                    "3432: Benowa High - Molendinar": [
                        "Benowa Rd at Benowa State High School",
                        "Currumburra Rd at Ashmore Primary School",
                        "Benowa Rd at Collins Crescent",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Currumburra Rd near Cotlew St",
                        "Heeb St at The Crescent",
                        "Currumburra Rd near Koonan Ct",
                        "Currumburra Rd at Green Glen Road",
                        "Hillview Pde at Hillview Pde hail 'n' ride",
                        "Currumburra Rd at Tangerine Row",
                        "Ashmore City Shopping Centre",
                        "Currumburra Rd at Mualla Drive",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Trinity Lutheran School",
                        "Mitchell Ave at Coachwood Drive",
                        "Macquarie Ave at Lachlan Avenue",
                        "Breakspear Rd at Mahogany Hill Park",
                        "Crestwood Dr at Watergum Parade",
                        "Crestwood Dr at Crestwood Plaza"
                    ],
                    "3432: Benowa Schools - Molendainr": [
                        "Benowa Rd at Benowa State High School",
                        "Currumburra Rd at Ashmore Primary School",
                        "Benowa Rd at Collins Crescent",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Currumburra Rd near Cotlew St",
                        "Heeb St at The Crescent",
                        "Currumburra Rd near Koonan Ct",
                        "Currumburra Rd at Green Glen Road",
                        "Hillview Pde at Hillview Pde hail 'n' ride",
                        "Currumburra Rd at Tangerine Row",
                        "Ashmore City Shopping Centre",
                        "Currumburra Rd at Mualla Drive",
                        "Southport Nerang Rd at Industrial Avenue",
                        "Trinity Lutheran School",
                        "Mitchell Ave at Coachwood Drive",
                        "Macquarie Ave at Lachlan Avenue",
                        "Breakspear Rd at Mahogany Hill Park",
                        "Crestwood Dr at Watergum Parade",
                        "Crestwood Dr at Crestwood Plaza"
                    ],
                    "3433: Southport - Wintergreen Dr": [
                        "Brooke Ave at Southport State High School",
                        "Imperial Pde near Turpin Rd",
                        "Whiting St at Government Road",
                        "Whiting St at Brown Street",
                        "Whiting St at Usher Avenue",
                        "Usher Ave at Vona Place",
                        "Central St at Central Street",
                        "Central St near Davebill Ct",
                        "Olsen Ave at Central Street Shops",
                        "Olsen Ave at Paul Sharratt Park",
                        "Olsen Ave at Allied Drive",
                        "Olsen Ave at Blanford Street",
                        "Brisbane Rd at Centre View Drive",
                        "Brisbane Rd at Pine Ridge Road",
                        "Pine Ridge Rd at Lensgate Road",
                        "Pine Ridge Rd at Pine Ridge Caravan Park",
                        "Coombabah High School",
                        "Arundel Dr near Maltravers Dr",
                        "Arundel Dr near Arun Dr",
                        "Arundel Dr near Neri Cr",
                        "Napper Rd near Benalla Ct",
                        "Daintree Dr near Highview Pl",
                        "Napper Rd at Daintree Drive",
                        "Greenacre Dr at Parkwood station",
                        "Greenacre Dr at Fairview Ct",
                        "Greenacre Dr at Jamieson Drive",
                        "Uplands Dr at Greenacre Drive",
                        "Uplands Dr at Woodlands Way",
                        "Uplands Dr at Brushwood Ridge Reserve",
                        "Napper Rd at Arundel Primary School",
                        "Parkwood Bvd near Peter Thomson Dr",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Gary Player Cr",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr near Suncrest Ct",
                        "Wintergreen Dr near Ballybunion Dr"
                    ],
                    "3434: Benowa High - Southport station": [
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at Golden Crescent",
                        "Benowa Rd at Drury Avenue",
                        "Benowa Rd at Centro Southport",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B"
                    ],
                    "3435: Robina High - Nerang": [
                        "Robina State High School",
                        "Highfield Dr near Breakwater Rd",
                        "Highfield Dr near Outriggers Drive Reserve",
                        "Highfield Dr near All Saints Anglican School",
                        "Highfield Dr near Cabot Ct",
                        "Bourton Rd near Willunga Pl",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "Ghilgai Rd near Entry Dr",
                        "Ghilgai Rd near Griffon St",
                        "Jondique Ave at Saint Michaels College",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Palm Meadows Drive",
                        "Nerang Broadbeach Rd at Nielsens Road",
                        "Birmingham Rd at The Boulevard",
                        "Nielsens Rd at Hickey Way",
                        "Hickey Way near Michelmore Rd hail 'n' ride",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Pappas Way near Dawnann Ct",
                        "Hinkler Dr near Alexander Dr hail 'n' ride",
                        "Hinkler Dr near Explorers Way hail 'n' ride",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Way at Cozens Way",
                        "Explorers Way at Garvie Place",
                        "William Duncan Primary School",
                        "McLaren Rd at Beltana Way",
                        "Weedons Rd at Nerang High School",
                        "Birribi Ave near Nerang River Dr",
                        "Price St at Earle Plaza"
                    ],
                    "3436: Ashmore Primary - Nerang Interchange": [
                        "Benowa Rd at Benowa State High School",
                        "Currumburra Rd at Ashmore Primary School",
                        "Benowa Rd at Collins Crescent",
                        "Cotlew St at Ashmore Plaza",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Cotlew St at Parkleigh Court",
                        "Heeb St at The Crescent",
                        "Cotlew St at Hermitage Close",
                        "Hillview Pde at Hillview Pde hail 'n' ride",
                        "Currumburra Rd at Tangerine Row",
                        "Cotlew St at Tecoma Street",
                        "Currumburra Rd at Mualla Drive",
                        "Coolibah St at Sussex Drive Park",
                        "Coolibah St near Lilli Pilli Dr",
                        "Keebra Park State High School",
                        "Kindra Ave at Lara Avenue",
                        "Kindra Ave near Larwon Tce",
                        "Shirley St at Anne Street",
                        "Shirley St near Caroline Ave",
                        "Shirley St near Melinda St",
                        "Ridgeway Ave near Gayle St",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Benowa Rd at Benowa Gardens",
                        "Ashmore Rd at Boree Street",
                        "Ashmore Rd at Reed Street",
                        "Glenmore Dr near Lochinvar Ct",
                        "Southport Nerang Rd at BP Central Park",
                        "Southport Nerang Rd at Stewart Parade",
                        "Southport Nerang Rd at Bellara Street",
                        "Southport Nerang Rd at Parkridge Drive",
                        "City of Gold Coast, Nerang",
                        "Southport Nerang Rd at Nerang interchange"
                    ],
                    "3437: Robina HS - Old Coach Rd near Wallandra": [
                        "Robina State High School",
                        "Old Coach Rd at Wallandra Road",
                        "Rainbow Dr near Cobai Dr",
                        "Old Coach Rd at Mudgeeraba State School"
                    ],
                    "3438: Benowa High - Ashmore City": [
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at Collins Crescent",
                        "Heeb St at Gold Coast TAFE Ashmore",
                        "Heeb St at The Crescent",
                        "Hillview Pde at Hillview Pde hail 'n' ride",
                        "Currumburra Rd at Tangerine Row",
                        "Currumburra Rd at Mualla Drive",
                        "Currumburra Rd at Ashmore Primary School",
                        "Currumburra Rd at Green Glen Road"
                    ],
                    "3439: Marymount - Hinkler Dr via Mudgeeraba": [
                        "Marymount College",
                        "Hinterland Dr near Springbrook Rd hail 'n' ride",
                        "Cobai Dr at Chippewa Circuit",
                        "Wallandra Dr at Old Coach Rd hail 'n' ride",
                        "Wallandra Rd near Tuena St hail 'n' ride",
                        "Wallandra Rd near Baileys Rd hail 'n' ride",
                        "Old Coach Rd at Wallandra Road",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Old Coach Rd at Sid Bigg Park",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Worongary Rd near Harry Mills Dr hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Harry Mills Dr near Charland Ct hail 'n' ride",
                        "Vince Hinde Dr near Harry Mills Dr hail 'n' ride",
                        "Vince Hinde Dr near Worongary Rd hail 'n' ride",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Mudgeeraba Rd near Quambone St",
                        "Hinkler Dr near Kurilpa St hail 'n' ride",
                        "Barrine Dr near Hinkler Dr hail 'n' ride",
                        "Hinkler Dr near Explorers Way"
                    ],
                    "3440: Broadbeach Primary - Nerang": [
                        "Broadbeach Primary School",
                        "Pacific Fair, stop A",
                        "Sunshine Bvd at Bordeaux Street",
                        "Sunshine Bvd at Surfers Avenue",
                        "Sunshine Bvd at Lindon Park",
                        "Markeri St near Sunshine Bvd",
                        "Markeri St near Rumrunner St",
                        "Markeri St near Southerly St",
                        "Rio Vista Bvd near Dunlop Ct",
                        "Dunlop Ct at Merrimac State High School",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Gooding Dr at Merrimac Golf Course",
                        "Nerang Broadbeach Rd at Nielsens Road",
                        "Nerang Broadbeach Rd at Garden Grove",
                        "Riverside Home Caravan Park",
                        "Birmingham Rd near Nerang Broadbeach Rd hail 'n' ride",
                        "Birmingham Rd at Emerald Lakes Drive",
                        "Birmingham Rd at The Boulevard",
                        "Nielsens Rd near Hickey Way hail 'n' ride",
                        "Nielsens Rd at Hickey Way",
                        "Hickey Way near Michelmore Rd hail 'n' ride",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Pappas Way near Dawnann Ct",
                        "Hinkler Dr near Alexander Dr hail 'n' ride",
                        "Hinkler Dr near Explorers Way hail 'n' ride",
                        "Explorers Way near Nabarlek Dr hail 'n' ride",
                        "Explorers Wy near Delta Cove Dr",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Way at Cozens Way",
                        "Explorers Way at Garvie Place"
                    ],
                    "3441: Keebra Park High - Nerang Rail": [
                        "Keebra Park State High School",
                        "Nerang station"
                    ],
                    "3442: Merrimac High - Hardys Rd": [
                        "Dunlop Ct at Merrimac State High School",
                        "Markeri St near Drayton Tce",
                        "Markeri St near Orpheus Rd",
                        "Ron Penhaligon Way near Essendon Pl",
                        "Ron Penhaligon Way near Homebush Dr",
                        "Ron Penhaligon Way near Tennyson Pl",
                        "Ron Penhaligon Way near Kentwood Dr",
                        "Ron Penhaligon Way near Great Southern Dr",
                        "Ron Penhaligon Way at Banff Court",
                        "Glen Eagles Dr near Oakmont St",
                        "Glen Eagles Dr near Federal Pl",
                        "Glen Eagles Dr near Princeville Ct",
                        "Glen Eagles Dr near Killarney Ave",
                        "Killarney Ave near Turnberry Ct",
                        "Cheltenham Dr at Tullamarine Drive",
                        "Cheltenham Dr near Thorngate Dr",
                        "Robina Town Centre Dr at Leabrook Crescent",
                        "Robina Town Centre Dr at Eastlake Apartments",
                        "Robina Town Centre Drive at Scottsdale Dr",
                        "Robina Town Centre Dr at Christine Avenue",
                        "Robina Town Centre",
                        "Railway Street at Robert St",
                        "Somerset Dr near Bonogin Rd hail 'n' ride",
                        "Gunsynd Dr near Tulloch Cr hail 'n' ride",
                        "Hardys Rd near Rising Fast Rd hail 'n' ride"
                    ],
                    "3443: Foxwell College - Coomera Waters via Amity Rd": [
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride"
                    ],
                    "3444: St Michaels - Pacific Fair": [
                        "Jondique Ave at Saint Michaels College",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Rd at Cararra Markets",
                        "St Vincents Catholic Primary School",
                        "Fairway Dr near Santa Cruz Bvd hail 'n' ride",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Nerang Broadbeach Rd at Lakes Esp",
                        "Nerang Broadbeach Rd at Rawle Court",
                        "Pacific Fair, stop B"
                    ],
                    "3445: Surfers Paradise Primary - Main Beach": [
                        "Surfers Paradise Primary School",
                        "Remembrance Dr at Markwell Avenue",
                        "Remembrance Dr at Bruce Bishop Car Park",
                        "Surfers Paradise",
                        "Ferny Ave at Palm Avenue",
                        "Ferny Ave at Ocean Avenue",
                        "Tedder Avenue at Cronin Avenue",
                        "Tedder Ave at Montgomery Avenue",
                        "Main Beach Pde near Stafford Ave",
                        "Main Beach Pde at Main Beach Tourist Park",
                        "Main Beach Pde at Woodroffe Avenue"
                    ],
                    "3446: Benowa Schools - Pacific Fair": [
                        "Benowa Rd at St Kevins Catholic Primary",
                        "Benowa Rd at Benowa Gardens",
                        "Ashmore Rd at Sir Bruce Small Park",
                        "Ashmore Road Commercial Precinct",
                        "Ashmore Rd at Campbell Street",
                        "Salerno St at Salerno Street",
                        "Salerno St at Fiesta Avenue",
                        "Surfers Paradise Primary School",
                        "Via Roma at Verona Avenue",
                        "Remembrance Drive at Surfers Paradise Bvd",
                        "Savoy Dr near Ilkinia Ave hail 'n' ride",
                        "Gold Coast Hwy at Florida Gardens station",
                        "Rio Vista Bvd at Sheridan Park Avenue",
                        "Rio Vista Bvd at Cristobel Court",
                        "Rio Vista Bvd at Grant Place",
                        "TE Peters Dr at Andrea Avenue",
                        "Sunshine Bvd at Sonder Street",
                        "Sunshine Bvd at Merrimac Boulevard",
                        "Pacific Fair, stop B"
                    ],
                    "3447: Benowa High - Southport station": [
                        "Benowa Rd at Benowa State High School",
                        "Benowa Rd at Collins Crescent",
                        "Benowa Rd at Sapium Road",
                        "Benowa Rd at Golden Crescent",
                        "Benowa Rd at Drury Avenue",
                        "Benowa Rd at Centro Southport",
                        "Ferry Rd at Harvest Court",
                        "Ferry Rd at Minnie Street",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B"
                    ],
                    "3448: Labrador Primary - Labrador": [
                        "Imperial Pde near Turpin Rd",
                        "Brisbane Rd at Turpin Road",
                        "Labrador Park Shopping Centre",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Olsen Ave at Blanford Street",
                        "Olsen Ave at Allied Drive",
                        "Central St at Central Street Shops",
                        "Central St near Usher Ave",
                        "Usher Ave near Tanias Pl",
                        "Government Rd near Morinda Way",
                        "Government Rd at Galaxy Court",
                        "Olsen Ave at Boea Street",
                        "Musgrave Ave near Botanical Dr",
                        "Musgrave Ave at Keith Hunt Park",
                        "Stevens St near William St",
                        "Gold Coast Hwy at Broadwater Tourist Park"
                    ],
                    "3449: Keebra Park - Southport Station": [
                        "Keebra Park State High School",
                        "Nerang St at Falconer Street",
                        "Nerang St at West End Shops",
                        "Queen St at Garden Street",
                        "Scarborough St at White Street",
                        "Southport bus station, stop B"
                    ],
                    "3450: William Duncan Primary - Parkwood Blvd": [
                        "William Duncan Primary School",
                        "Cozens Way near Issell Pl hail 'n' ride",
                        "Explorers Wy near Fallon Ct",
                        "Explorers Wy near Delta Cove Dr",
                        "Worongary Primary School",
                        "Cozens Way near Tiley Ct hail 'n' ride",
                        "Alexander Dr at Kahlua Court",
                        "Pappas Way near Dawnann Ct",
                        "Pappas Way near Remount Pl",
                        "Pappas Way near Cambridge Ct",
                        "Pappas Way near Dearne Pl",
                        "Murev Way near Alzino Pl",
                        "Michelmore Rd near Woolmere St",
                        "Michelmore Rd near Hickey Way",
                        "Nielsens Rd at Hickey Way",
                        "Birmingham Rd near The Boulevard",
                        "Ross St at Royal Pines",
                        "Currumburra Rd at Tangerine Row",
                        "Currumburra Rd at Mualla Drive",
                        "Currumburra Rd at Ashmore Primary School",
                        "Currumburra Rd near Cotlew St",
                        "Currumburra Rd near Koonan Ct",
                        "Currumburra Rd at Green Glen Road",
                        "Olsen Ave at Crestwood Plaza",
                        "Henry Cotton Dr near Wintergreen Dr",
                        "Henry Cotton Dr near Hazeltine Pl",
                        "Henry Cotton Dr near Longreef Cr",
                        "Henry Cotton Dr at Parkwood East station",
                        "Parkwood Bvd near Arnold Palmer Dr",
                        "Parkwood Bvd near Davis Ct",
                        "Parkwood Bvd near Casper St",
                        "Parkwood Bvd near Kel Nagle Ct"
                    ],
                    "3451: Pimpama Colleges - Finnegan Way": [
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College",
                        "Kerkin Rd S at Vanes Street",
                        "Kerkin Rd South at St Joseph's College",
                        "Finnegan Way at Cirrus Way",
                        "Finnegan Way at Lily Avenue",
                        "Finnegan Way at Felix Entrance",
                        "Coomera station"
                    ],
                    "3452: Helensvale - Coombabah": [
                        "Helensvale State High School",
                        "Helensvale Primary School",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Gold Coast Hwy at Arundel Drive",
                        "Pine Ridge Rd at Lensgate Road",
                        "Pine Ridge Rd at Pine Ridge Caravan Park",
                        "Coombabah High School",
                        "Pine Ridge Rd at Coombabah High School",
                        "Pine Ridge Rd at Coombabah Road",
                        "Pine Ridge Rd at Siena Place",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Oxley Dr at Paradise Lake Resort",
                        "Oxley Dr at Crystal Reef Drive",
                        "Hansford Rd near Doreen Dr",
                        "Hansford Rd at Numbat Ct",
                        "Hansford Rd near Citie Dr",
                        "Myola Ct at Georgia Street",
                        "Esplanade at Tarni St",
                        "Hansford Rd near Sanctuary Ct",
                        "Lefroy Dr near Rason Way hail 'n' ride",
                        "Brady Dr near Burrendong Rd",
                        "Oxley Dr at Coombabah State Primary School",
                        "Oxley Dr at Daisy Elms Park",
                        "Oxley Dr at Blaxland Avenue",
                        "Oxley Dr near Sunbird Ave hail 'n' ride"
                    ],
                    "3453: Trinity College - Upper Coomera": [
                        "Yalburu St near St Josephs Primary School",
                        "Cuthbert Dr near Brookside Cct",
                        "Pascoe Rd at Halfway Drive",
                        "Pascoe Rd near Solanum St",
                        "Pascoe Rd near Tristan Ct hail 'n' ride",
                        "Winfield Rd near Metcalf Ct hail 'n' ride",
                        "Philben Dr near Winfield Rd",
                        "Philben Dr near Peachey Rd",
                        "Peachey Rd near Vaughan Dr",
                        "Vaughan Dr near Healy Ct hail 'n' ride",
                        "Vaughan Dr near Renford Ct hail 'n' ride",
                        "Peachey Rd at Doherty Court",
                        "Ormeau Ridge Rd near Yarwood",
                        "Ormeau Ridge Rd near Watego Cr hail 'n' ride",
                        "Ormeau Ridge Rd near Sir Charles Holme Dr",
                        "Ellenborough Ave near Terania Ave",
                        "River Run Cct near Lansdowne Dr",
                        "Lansdowne Dr near Upper Ormeau Rd hail 'n' ride",
                        "Rifle Range Rd at Bull Road",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Old Coach Rd at Days Road",
                        "Old Coach Rd near Billinghurst Cr",
                        "Old Coach Rd at Low Drive",
                        "Reserve Rd near Jessica Dr",
                        "Reserve Road at Abraham Rd"
                    ],
                    "3454: Biggera Waters - Helensvale Rd": [
                        "Morala Ave at Biggera Waters School",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Limetree Pde",
                        "Lae Dr at Morala Avenue",
                        "Runaway Bay Centre",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd near Siena Pl",
                        "Pine Ridge Rd at Coombabah Road",
                        "Coombabah High School",
                        "Pine Ridge Rd at Siena Place",
                        "Oxley Dr at Paradise Lake Resort",
                        "Oxley Dr at Crystal Reef Drive",
                        "Oxley Dr at Hansford Road",
                        "Oxley Dr at Coombabah State Primary School",
                        "Oxley Dr at Daisy Elms Park",
                        "Oxley Dr at Blaxland Avenue",
                        "Crescent Ave near Broadwater Ave hail 'n' ride",
                        "Bert Hood St near Boykambil Esp hail 'n' ride",
                        "Boykambil Esp near Shoe St hail 'n' ride",
                        "Shoe St near Coombe Ave hail 'n' ride",
                        "Broadwater Ave at Crescent Avenue",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Boykambil Esp near Sheehan Ave hail 'n' ride",
                        "Nelson Ave near Dunnes Ave hail 'n' ride",
                        "Cova Bvd at Hope Island Rd",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Santa Barbara Rd near Chindrina St",
                        "Pinnaroo St near Mungala St",
                        "Akoonah St near Mungala St",
                        "Buddeh St near Santa Barbara Rd",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Hope Island Rd near Magnolia Dr hail 'n' ride",
                        "Monterey Keys Dr at Creekwood Place",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Helensvale State High School",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd near Siganto Dr hail 'n' ride"
                    ],
                    "3455: Helensvale High - Coomera Waters": [
                        "Helensvale State High School",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd near Siganto Dr hail 'n' ride",
                        "Siganto Dr at Tradewinds Street",
                        "Dreamworld Parkway at Boathouse Tavern",
                        "Beattie Rd at Coomera Primary School",
                        "Beattie Rd at Ford Road",
                        "Waterway Dr at McPhail Rd",
                        "Waterway Dr at Shipper Drive",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Finnegan Way at Felix Entrance",
                        "Foxwell Rd near Oakey Creek Rd",
                        "Foxwell Rd at Galaxy Drive",
                        "Daintree Dr near Paradise Dr hail 'n' ride",
                        "Pamplet Lane near Daintree Dr hail 'n' ride",
                        "Edwardson Dr near Amity Rd hail 'n' ride",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride"
                    ],
                    "3456: Upper Coomera College - Hope Island": [
                        "Upper Coomera College",
                        "Reserve Rd near Reserve Rd hail 'n' ride",
                        "Old Coach Rd at Low Drive",
                        "Old Coach Rd near Billinghurst Cr",
                        "Days Rd at City Centre Drive",
                        "Days Rd at Coomera Anglican College",
                        "Coomera station, stop A",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Waterway Dr at Shipper Drive",
                        "Waterway Dr at McPhail Rd",
                        "Beattie Rd at Ford Road",
                        "Beattie Rd at Coomera Primary School",
                        "Dreamworld Pkwy at Foxwell Rd",
                        "River Links Bvd near Hope Island Rd hail 'n' ride",
                        "Siganto Dr at Tradewinds Street",
                        "Siganto Dr near Grey Gum St",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale State High School",
                        "Monterey Keys Dr at Lakeshore Drive",
                        "Monterey Keys Dr at Parkgate Street",
                        "Monterey Keys Dr at Glengate Street",
                        "Monterey Keys Dr at Greengate Street",
                        "Monterey Keys Dr near Creekwood Pl",
                        "Oxenford Southport Rd near The Lakes Dr HnR",
                        "Santa Barbara Rd at Hope Island Shopping Centre",
                        "Santa Barbara Rd near Chindrina St",
                        "Pinnaroo St near Mungala St",
                        "Akoonah St near Mungala St",
                        "Buddeh St near Santa Barbara Rd",
                        "Santa Barbara Rd at Marina Shopping Village",
                        "Cova Bvd at Hope Island Rd",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Boykambil Esp near Sheehan Ave hail 'n' ride",
                        "Nelson Ave near Dunnes Ave hail 'n' ride"
                    ],
                    "3457: Arundel Primary - Kumbari Ave": [
                        "Arundel State Primary School",
                        "Allied Dr at Carnoustie Ct",
                        "Allied Dr near Range Ct",
                        "Central St near Allied Dr",
                        "Central St near Carrumbella Dr",
                        "Central St at Central Street Shops",
                        "Central St near Usher Ave",
                        "Usher Ave near Central St hail 'n' ride",
                        "Usher Ave near Tanias Pl",
                        "Government Rd near Morinda Way",
                        "Government Rd at Galaxy Court",
                        "Stephenson St near Government Rd hail 'n' ride",
                        "Stephenson St near Olsen Ave hail 'n' ride",
                        "Olsen Ave at Boea Street",
                        "Musgrave Ave near Botanical Dr",
                        "Musgrave Ave at Keith Hunt Park",
                        "Musgrave Ave near Kumbari Ave hail 'n' ride",
                        "Kumbari Ave near Nakina St"
                    ],
                    "3458: St Hildas - Sanctuary Cove": [
                        "Ferry Rd at The Southport School",
                        "Ferry Rd near Lupus St",
                        "St Hilda's School",
                        "North St near Scarborough St hail 'n' ride",
                        "North St at Norman Street",
                        "Gold Coast Hwy at Broadwater Tourist Park",
                        "Gold Coast Hwy at Southport Tourist Park",
                        "Gold Coast Hwy at Central Street",
                        "Frank St at Whiting Street",
                        "Gold Coast Hwy at Labrador Senior Citizens",
                        "Marine Pde at Parker Street",
                        "Brisbane Rd at Turpin Road"
                    ],
                    "3459: Gaven Primary - Village Way": [
                        "Pacific Pines High School",
                        "Santa Isobel Bvd near Amanu Cr",
                        "Santa Isobel Bvd near Pitcairn Way",
                        "Brockman Way near Bowley St",
                        "Harmsworth Rd near Wunburra Ccl",
                        "McAuley Pde near Diamantina Cct",
                        "McAuley Pde near Matthews Dr",
                        "Greenway Bvd near Brissendon St",
                        "Universal St near Buchanan Ct",
                        "Gaven Primary School",
                        "Universal St near Takahe St",
                        "Universal St near Crestridge Cr",
                        "Universal St near Hervey St hail 'n' ride",
                        "Village Way near Studio Dr",
                        "Village Way near Drama St",
                        "Village Way near Mews Ct"
                    ],
                    "3460: Foxwell High - Upper Coomera & Coomera Springs": [
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Turnbull Dr near Abraham Rd hail 'n' ride",
                        "Billinghurst Cr near Godden Dr",
                        "Billinghurst Cr near Jessica Dr",
                        "Billinghurst Cr at Livingstone Street",
                        "Old Coach Rd near Billinghurst Cr",
                        "Days Rd near Coomera Grand Drive",
                        "Bridie Dr near Jagera Dr hail 'n' ride",
                        "Bridie Dr near Birley Link hail 'n' ride",
                        "Cassinia Link near Nightjar Dr hail 'n' ride",
                        "Nightjar Dr at Butcher Bird Circuit",
                        "Coomera Springs Bvd at Sandpiper Court",
                        "Coomera Springs Bvd at Dayflower Street",
                        "The Heights Bvd near Song Cr hail 'n' ride",
                        "The Heights Bvd near Peak Cr hail 'n' ride"
                    ],
                    "3461: Emmanuel College - Gilston": [
                        "Birmingham Rd at The Boulevard",
                        "Gooding Dr at Palm Meadows Drive",
                        "Gooding Dr at Merrimac Primary School",
                        "Gooding Dr at Jondique Avenue",
                        "Gooding Dr at Bourton Road",
                        "Jura Pde near Merridown Dr",
                        "Merridown Dr near Islay Ct",
                        "Merridown Dr near Longmorn Cr",
                        "Merridown Dr near Tarbert Cl",
                        "Hinkler Dr near San Fernando Dr hail 'n' ride",
                        "Alkira Way near Hinkler Dr hail 'n' ride",
                        "Alkira Way near Quambone St hail 'n' ride",
                        "Quambone St near Handel Ave hail 'n' ride",
                        "Quambone St near Walker Dr hail 'n' ride",
                        "Quambone St near Hannah Ct hail 'n' ride",
                        "Mudgeeraba Rd near Quambone St",
                        "Mudgeeraba Rd near Worongary Rd",
                        "Old Coach Rd at Sid Bigg Park",
                        "Old Coach Rd at Mudgeeraba State School",
                        "Rainbow Dr at Universe Court",
                        "Rainbow Dr near Constellation Cr hail 'n' ride",
                        "Cobai Dr at Chippewa Circuit",
                        "Wallandra Dr at Old Coach Rd hail 'n' ride",
                        "Wallandra Rd near Tuena St hail 'n' ride",
                        "Baileys Rd near Tallai Rd hail 'n' ride",
                        "Tallai Rd near Cromwell Ct hail 'n' ride",
                        "Old Coach Rd at Tallai Rd Bus Shelter HnR",
                        "Worongary Rd near Mudgeeraba Rd hail 'n' ride",
                        "Vince Hinde Dr near Worongary Rd hail 'n' ride",
                        "Harry Mills Dr near Charland Ct hail 'n' ride",
                        "Harry Mills Dr near Thomas Duncan Ct hail 'n' ride",
                        "Worongary Rd near Glenrowan Dr hail 'n' ride",
                        "Gilston State School"
                    ],
                    "3462: Nerang High - Hickey Way": [
                        "Nerang High School",
                        "Mortensen Rd near The Domain",
                        "Mortensen Rd near Apricot Ave",
                        "Pappas Way near Dawnann Ct",
                        "Pappas Way near Remount Pl",
                        "Pappas Way near Cambridge Ct",
                        "Pappas Way near Dearne Pl",
                        "Murev Way near Alzino Pl",
                        "Michelmore Rd near Woolmere St",
                        "Michelmore Rd near Hickey Way",
                        "Nielsens Rd at Hickey Way"
                    ],
                    "3463: Gaven - Universal Dr": [
                        "Gaven Primary School",
                        "Greenway Bvd near Keneally St hail 'n' ride",
                        "Greenway Bvd near Brissendon St",
                        "Park Lake Primary School",
                        "Pitcairn Way at McAuley Parade",
                        "Victoria Dr near Hawker St",
                        "Victoria Dr near Feathertop Cr",
                        "Hillary Cir near Victoria Dr hail 'n' ride",
                        "Pitcairn Way near Salvado Dr hail 'n' ride",
                        "Pitcairn Way near Sangster Cr",
                        "Pitcairn Way at Lennox Street",
                        "Springwood Ave near Harmsworth Rd hail 'n' ride",
                        "Wunburra Cct near Gascoyne St hail 'n' ride",
                        "Harmsworth Rd near Wunburra Ccl",
                        "Brockman Way near Bowley St",
                        "Pitcairn Way near Yaldara St",
                        "Pitcairn Way near Easter Cr",
                        "Archipelago St near Penrhyn St",
                        "Pacific Pines High School",
                        "Santa Isobel Bvd near Amanu Cr",
                        "Santa Isobel Bvd near Pitcairn Way",
                        "Pitcairn Way near Beerwah St",
                        "Pitcairn Way near Springwood Ave",
                        "Pitcairn Way at Blackheath Terrace",
                        "Rimatara Rise near Manra Way hail 'n' ride",
                        "Palmerston Dr near Maui Cr",
                        "Pinevale Dr near Hiva Ct",
                        "Pinehill Dr near Universal St"
                    ],
                    "3464: Southport High - Paradise Point": [
                        "Brooke Ave at Southport State High School",
                        "Government Rd at Labrador State School",
                        "Government Rd near Brookside Rd",
                        "Labrador Park Shopping Centre",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Brisbane Rd at Centre View Drive",
                        "Brisbane Rd at Pine Ridge Road",
                        "Pine Ridge Rd at Lensgate Road",
                        "Pine Ridge Rd at Pine Ridge Caravan Park",
                        "Coombabah High School",
                        "Pine Ridge Rd at Coombabah High School",
                        "Pine Ridge Rd near Rain Tree Glen hail 'n' ride",
                        "Pine Ridge Rd at Coombabah Road",
                        "Pine Ridge Rd at Siena Place",
                        "Pine Ridge Rd at Sage Court",
                        "Pine Ridge Rd at Sidney Nolan Drive",
                        "Lae Dr at The Runaway Brace",
                        "Lae Dr at Morala Avenue",
                        "Runaway Bay Centre",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Bayview St at Karema Crescent",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St near Salvia St",
                        "Bayview St at Columbus Drive",
                        "Bayview St near Sapphire St",
                        "Bayview St near Falkinder Ave",
                        "Paradise Pde near Sunbird Ave",
                        "The Esplanade near Abolone Ave hail 'n' ride",
                        "The Esplanade near The Soverign Mile hail 'n' ride",
                        "The Esplanade near Scoter Ave hail 'n' ride",
                        "Paradise Pde near Mallard Ave",
                        "Paradise Pde near Nankeen Ave",
                        "Abalone Ave near Thrush Ave hail 'n' ride",
                        "Sunbird Ave near Oxley Dr hail 'n' ride"
                    ],
                    "3465: Helensvale - Hope Island": [
                        "Helensvale Primary School",
                        "Lindfield Rd at Helensvale Plaza",
                        "Helensvale Community Centre",
                        "Discovery Dr at Ridgevale Drive",
                        "Discovery Dr at Lindfield Road Shops",
                        "Discovery Dr at Hession Oval",
                        "Discovery Dr at Eugenia Reserve",
                        "Discovery Dr at Ashford Road",
                        "Discovery Dr at Kingaroy Avenue",
                        "Helensvale State High School",
                        "Helensvale Rd near Monterey Keys Dr hail 'n' ride",
                        "Helensvale Rd at Dalley Park Dr",
                        "Audrey Ave near Dalley Park Dr hail 'n' ride",
                        "Audrey Ave near Calmwater Ct hail 'n' ride",
                        "Helensvale Rd at Calmwater Crescent",
                        "Helensvale Rd at Sabrina Avenue",
                        "Helensvale Rd at Saltwater Park",
                        "Sickle Ave at Park Cove Bvd",
                        "Sheehan Ave near Nelson Ave",
                        "Boykambil Esp near Sheehan Ave hail 'n' ride",
                        "Nelson Ave near Dunnes Ave hail 'n' ride",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Broadwater Ave at Crescent Avenue",
                        "Crescent Ave near Broadwater Ave hail 'n' ride",
                        "Bert Hood St near Boykambil Esp hail 'n' ride",
                        "Boykambil Esp near Shoe St hail 'n' ride",
                        "Shoe St near Coombe Ave hail 'n' ride",
                        "Cova Bvd at Hope Island Rd"
                    ],
                    "3466: Helensvale Schools - Helensvale station": [
                        "Helensvale State High School",
                        "Discovery Dr at Kingaroy Avenue",
                        "Discovery Dr at Ashford Road",
                        "Discovery Dr at Eugenia Reserve",
                        "Discovery Dr at Hession Oval",
                        "Discovery Dr at Lindfield Road Shops",
                        "Helensvale State Primary School",
                        "Discovery Dr at Ridgevale Drive",
                        "Ridgevale Dr at Dubbo Court",
                        "Ridgevale Dr at Mildura Drive",
                        "Mildura Dr at Pentland Court",
                        "Mildura Dr at Halbury Court",
                        "Mildura Dr near Burdekin Ave",
                        "Helensvale Community Centre",
                        "Helensvale station"
                    ],
                    "3467: Helensvale - Paradise Point": [
                        "Helensvale State High School",
                        "Helensvale Primary School",
                        "Lindfield Rd at Helensvale Plaza",
                        "Gold Coast Hwy at Discovery Drive",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Gold Coast Hwy at Arundel Drive",
                        "Brisbane Rd at Pine Ridge Road",
                        "Brisbane Rd at Centre View Drive",
                        "Harbour Town, stop A",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Labrador Park Shopping Centre",
                        "Hollywell Rd near Thelma Ave",
                        "Morala Ave at Biggera Waters School",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Limetree Pde",
                        "Lae Dr at Morala Avenue",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Bayview St at Karema Crescent",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St near Salvia St",
                        "Bayview St at Columbus Drive",
                        "Bayview St near Sapphire St",
                        "Bayview St near Falkinder Ave",
                        "Paradise Pde near Sunbird Ave",
                        "Abalone Ave near Thrush Ave hail 'n' ride",
                        "Sunbird Ave near Oxley Dr hail 'n' ride"
                    ],
                    "3468: Elanora High - The Pines": [
                        "Nineteenth Ave at Elanora High School",
                        "Avocado St at Jarrahdale Dr",
                        "KP McGrath Dr at Seaview Parade",
                        "KP McGrath Dr at Murtha Drive",
                        "KP McGrath Dr at Elanora State School",
                        "The Pines Shopping Centre, stop A",
                        "Sarawak Ave at Salk Oval",
                        "Palm Beach Currumbin High School",
                        "Thrower Dr near Luzon Pde",
                        "Gold Coast Hwy at Thrower Drive"
                    ],
                    "3469: Coomera Anglican - Oxley Dr": [
                        "Coomera Anglican College",
                        "Abraham Rd near Aviation Av hail 'n' ride",
                        "Reserve Road at Abraham Rd",
                        "Saint Stephens College",
                        "Reserve Rd at Dreamtime Zone",
                        "Heathwood Dr near Koala Town Rd",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Siganto Dr at Tradewinds Street",
                        "Siganto Dr near Grey Gum St",
                        "Helensvale Rd near Siganto Dr hail 'n' ride",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale State High School",
                        "Helensvale Rd near Monterey Keys Dr hail 'n' ride",
                        "Helensvale Rd at Dalley Park Dr",
                        "Helensvale Rd at Calmwater Crescent",
                        "Helensvale Rd at Sabrina Avenue",
                        "Helensvale Rd at Saltwater Park",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Broadwater Ave at Crescent Avenue",
                        "Broadwater Ave at Cresent Ave hail 'n' ride",
                        "Sunbird Ave near Oxley Dr hail 'n' ride",
                        "Abalone Ave near Thrush Ave hail 'n' ride",
                        "Paradise Pde at Sunbird Avenue",
                        "Bayview St near Falkinder Ave",
                        "Bayview St at Sapphire Street",
                        "Bayview St at Columbus Drive",
                        "Bayview St at Jasmine Avenue",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St at Cassia Street",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Morala Ave at Folkstone Place",
                        "Morala Ave near Broadwater St",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Kropp St",
                        "Hollywell Rd near Parr St",
                        "Labrador Park Shopping Centre",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Oxley Dr near Brisbane Rd hail 'n' ride"
                    ],
                    "3470: Merrimac High - Cayuga St": [
                        "Dunlop Ct at Merrimac State High School",
                        "Nerang Broadbeach Rd at Fairway Drive",
                        "Gooding Dr at Merrimac Golf Course",
                        "Nerang Broadbeach Rd at Nielsens Road",
                        "Birmingham Rd at The Boulevard",
                        "Nielsens Rd at Hickey Way",
                        "Hickey Way near Michelmore Rd hail 'n' ride",
                        "Michelmore Rd near Hickey Way",
                        "Michelmore Rd near Alison Rd",
                        "Murev Way near Mayjohn Ave",
                        "Pappas Way near Meister Ct",
                        "Pappas Way near Mercator Ct",
                        "Pappas Way at Remount Place",
                        "Pappas Way near Dawnann Ct",
                        "Mortensen Rd near Cayuga St hail 'n' ride"
                    ],
                    "3471: Pacific Pines - Riverstone": [
                        "Pacific Pines High School",
                        "McAuley Pde near Matthews Dr",
                        "Matthews Dr near Roberts Dr hail 'n' ride",
                        "Greenway Bvd near Brissendon St",
                        "Greenway Bvd near Keneally St hail 'n' ride",
                        "Gaven Arterial Rd at Felling Drive",
                        "Gaven Arterial Rd near Yallaroi Rd hail 'n' ride",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Cobb and Co Dr near Appollo Pl",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Lagoon Park Dr near Meadow Ct hail 'n' ride",
                        "Lagoon Park Dr near Summer Hill Cr hail 'n' ride",
                        "Greenacre Way near Lagoon Park Dr hail 'n' ride",
                        "Riverstone Crsg near Rivermill Tce hail 'n' ride",
                        "Riverstone Crsg near Northern Skies Tce HnR",
                        "Riverstone Crsg near Valley Brook Rise HnR",
                        "Riverstone Crsg near Hibiscus Cr hail 'n' ride",
                        "Riverstone Crsg near Prairie Av hail 'n' ride",
                        "Riverstone Crsg near Mountain View Pde HnR",
                        "Rivermill Tce near Plantation Cr hail 'n' ride",
                        "Rivermill Tce near Settlers Ave hail 'n' ride"
                    ],
                    "3472: Helensvale - Arundel": [
                        "Helensvale State High School",
                        "Helensvale Primary School",
                        "Gold Coast Hwy at Discovery Drive",
                        "Gold Coast Hwy at Marble Arch Place",
                        "Arundel Dr near Maltravers Dr",
                        "Arundel Dr near Arun Dr",
                        "Arundel Dr near Neri Cr",
                        "Uplands Dr at Brushwood Ridge Reserve",
                        "Uplands Dr at Woodlands Way",
                        "Uplands Dr at Greenacre Drive",
                        "Greenacre Dr at Jamieson Dr",
                        "Greenacre Dr at Fairview Court",
                        "Greenacre Dr at Parkwood station",
                        "Greenacre Dr near Napper Rd hail 'n' ride",
                        "Napper Rd at Daintree Drive",
                        "Daintree Dr near Highview Pl",
                        "Wardley Dr near Daintree Dr hail 'n' ride"
                    ],
                    "3473: Oxenford - Ormeau": [
                        "Oxenford State School",
                        "Tamborine Oxenford Rd near Graywillow Bvd",
                        "Siganto Dr at Tradewinds Street",
                        "Siganto Dr near Grey Gum St",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale State High School",
                        "Old Pacific Hwy at Oxenford hail 'n' ride",
                        "Heathwood Dr near Koala Town Rd",
                        "Reserve Rd at Dreamtime Zone",
                        "Saint Stephens College",
                        "Reserve Road at Hargraves Rd",
                        "Hargraves Rd at Caribou Crescent",
                        "Hargraves Rd at Con Brio Bvd",
                        "Fawn St near River Meadows Dr hail 'n' ride",
                        "Billinghurst Cr near Turnbull Dr",
                        "Billinghurst Cr opp Coomera Anglican College",
                        "Assisi Catholic College",
                        "Williamson Rd near Billinghurst Cr",
                        "Tillyroen Rd near Mirambeena Dr hail 'n' ride",
                        "Tillyroen Rd near Ormeau Ridge Rd hail 'n' ride",
                        "Peachey Road interchange hail 'n' ride",
                        "Peachey Rd at Doherty Ct",
                        "Vaughan Dr near Wille Ct hail 'n' ride",
                        "Vaughan Dr near Beausang Pl hail 'n' ride",
                        "Philben Dr near Peachey Rd",
                        "Philben Dr near Winfield Rd",
                        "Winfield Rd near Metcalf Ct hail 'n' ride",
                        "Pascoe Rd near Winfield Rd hail 'n' ride",
                        "Pascoe Rd near Solanum St",
                        "Halfway Dr near Evergreen Cct hail 'n' ride",
                        "Halfway Dr at Norfolk Village Primary School",
                        "Philben Dr near Citrinus Ct"
                    ],
                    "3474: OWHS - Pascoe Rd": [
                        "Ormeau Woods High School",
                        "Cuthbert Dr near Brookside Cct",
                        "Pascoe Rd at Halfway Drive",
                        "Pascoe Rd near Solanum St",
                        "Pascoe Rd near Hennie Cr hail 'n' ride",
                        "Pascoe Rd near Tristan Ct hail 'n' ride",
                        "Winfield Rd near Metcalf Ct hail 'n' ride",
                        "Philben Dr near Winfield Rd",
                        "Philben Dr near Peachey Rd",
                        "Peachey Rd near Vennor Dr hail 'n' ride",
                        "Pascoe Rd near Winfield Rd hail 'n' ride"
                    ],
                    "3475: Elanora High - Currumbin Waters": [
                        "Nineteenth Ave at Elanora High School",
                        "Nineteenth Ave at Kalmia Court",
                        "Simpsons Rd near Calcita Ave hail 'n' ride",
                        "Simpsons Rd near Killara St hail 'n' ride",
                        "Simpsons Rd near Buckingham Way hail 'n' ride",
                        "Simspons Rd near Cornwall Dr hail 'n' ride",
                        "Westminster Bvd near Cornwall Dr hail 'n' ride",
                        "Cornwall Dr near Cheshire Gr hail 'n' ride",
                        "Guineas Creek Rd at Doubleview Drive",
                        "Galleon Way at Aegean Way",
                        "Ware Dr near Aethalia St",
                        "Ware Dr near Tudor St",
                        "Galleon Way near Billabong Ct",
                        "Galleon Way at Brigantine Court",
                        "Galleon Way near Keegan Cct",
                        "Galleon Way near Jutland Pl",
                        "Currumbin Creek Rd near Mainsail St"
                    ],
                    "3476: Pimpama Colleges - Coomera Sports Park": [
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College",
                        "Shipper Dr at Shipper Drive Service Road",
                        "Waterway Dr at Shipper Drive",
                        "Waterway Dr at McPhail Rd",
                        "Beattie Rd at Ford Road",
                        "Lorenzo Dr at Beattie Road",
                        "Yaun St near Sena St",
                        "Yaun St near Jowett St"
                    ],
                    "3477: Elanora High School - Burleigh via Townson Ave": [
                        "Nineteenth Ave at Elanora High School",
                        "Nineteenth Ave near Chesnut St",
                        "Nineteenth Ave near Melaleuca Dr",
                        "Nineteenth Ave near Townson Ave",
                        "Townson Ave near Nineteenth Ave",
                        "Townson Ave near Twentyfourth Ave",
                        "Townson Ave near Tallebudgera Dr",
                        "Tallebudgera Dr near Tarni Ave",
                        "Gold Coast Hwy at Tallebudgera Tourist Park",
                        "Burleigh Heads National Park",
                        "Tweed St at George St",
                        "Burleigh Heads station"
                    ],
                    "3478: Pacific Pines - Helensvale Rail": [
                        "Pacific Pines High School",
                        "Pacific Pines Primary School",
                        "Pacific Pines Bvd near Nauru Pl hail 'n' ride",
                        "Pacific Pines Bvd near Capricorn Dr",
                        "Helensvale stop F"
                    ],
                    "3479: Assisi College - Arundel": [
                        "Assisi Catholic College",
                        "Saint Stephens College",
                        "Siganto Dr at Tradewinds Street",
                        "Siganto Dr near Grey Gum St",
                        "Helensvale Rd at Woodside Place",
                        "Helensvale Rd at St James Park Aged Care",
                        "Helensvale State High School",
                        "Helensvale Rd near Monterey Keys Dr hail 'n' ride",
                        "Helensvale Rd at Monterey Keys Drive",
                        "Helensvale Rd at Dalley Park Dr",
                        "Helensvale Rd at Calmwater Crescent",
                        "Helensvale Rd at Sabrina Avenue",
                        "Helensvale Rd at Saltwater Park",
                        "Broadwater Ave at Mervyn Thomas Drive",
                        "Broadwater Ave at Crescent Avenue",
                        "Broadwater Ave at Cresent Ave hail 'n' ride",
                        "Sunbird Ave near Oxley Dr hail 'n' ride",
                        "Abalone Ave near Thrush Ave hail 'n' ride",
                        "Paradise Pde at Sunbird Avenue",
                        "Bayview St near Falkinder Ave",
                        "Bayview St at Sapphire Street",
                        "Bayview St at Columbus Drive",
                        "Bayview St at Jasmine Avenue",
                        "Bayview St at Runaway Bay Marina",
                        "Bayview St at Cassia Street",
                        "Bayview St at St Francis Xavier Catholic School",
                        "Morala Ave at Folkstone Place",
                        "Morala Ave near Broadwater St",
                        "Morala Ave near Ocean St",
                        "Morala Ave near Kropp St",
                        "Hollywell Rd near Parr St",
                        "Labrador Park Shopping Centre",
                        "Brisbane Rd at Treasure Island Caravan Park",
                        "Harbour Town, stop B"
                    ],
                    "3482: OWHS - PSPC via Pimpama": [
                        "Ormeau Woods High School",
                        "Village Bvd at Dorset Street",
                        "Yawalpah Rd at Salzburg Rd hail 'n' ride",
                        "Yawalpah Rd at Swan Road",
                        "Yawalpah Rd near Gawthern Dr hail 'n' ride",
                        "Yawalpah Rd at Cunningham Dr North hail 'n' ride",
                        "Cunningham Dr at Arcadia Boulevard",
                        "Dixon Dr at Pimpama State Primary College"
                    ],
                    "3483: Pimpama Colleges - Foxwell Rd": [
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College",
                        "Edwardson Dr near Amity Rd hail 'n' ride",
                        "Pamplet Lane near Daintree Dr hail 'n' ride",
                        "Daintree Dr near Amity Rd hail 'n' ride",
                        "Foxwell Rd at Galaxy Drive",
                        "Foxwell Rd at Oakey Creek Road"
                    ],
                    "3484: Marymount - Mermaid Waters via GC Hwy & Miami": [
                        "Marymount College",
                        "Gold Coast Hwy at Christine Avenue station",
                        "Gold Coast Hwy at Miami station",
                        "Gold Coast Hwy at Miami North station",
                        "Pacific Ave at Pizzey Park Sporting Complex",
                        "Oceanic Dr at Miami School",
                        "Oceanic Dr near Cottsloe Dr",
                        "Oceanic Dr near Launch Rd",
                        "Sunshine Bvd near Arcadia Dr",
                        "Gold Coast Hwy at Mermaid Beach South station"
                    ],
                    "3485: Pimpama PS - Gainsborough & Yawalapah Rd": [
                        "Pimpama Primary School",
                        "Village Bvd at Dorset Street",
                        "Village Bvd at Chisolm Way",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Bedford Rd near Attenborough Rd hail 'n' ride",
                        "Bedford Rd near Katie St hail 'n' ride",
                        "Sarabah Way near Narrien St hail 'n' ride",
                        "Kosciuszko Cct near Sarabah Way hail 'n' ride",
                        "Gainsborough Dr at Flinders Street",
                        "Gainsborough Dr near Towarri St hail 'n' ride",
                        "Gainsborough Dr near Swan Rd hail 'n' ride",
                        "Gawthem Dr at Gainsborough State School",
                        "Chrome Dr near Nickel St hail 'n' ride",
                        "Chrome Dr near Pyrite St hail 'n' ride",
                        "Dixon Dr at Pimpama Junction",
                        "Cunningham Dr at Arcadia Boulevard"
                    ],
                    "3486: Pimpama Colleges - Coomera Springs": [
                        "Pimpama State Secondary College Bay 2",
                        "Yawalpah Rd at Gainsborough State School",
                        "Gainsborough Dr near Swan Rd hail 'n' ride",
                        "Gainsborough Dr near Towarri St hail 'n' ride",
                        "Gainsborough Dr at Flinders Street",
                        "Sarabah Way near Narrien St hail 'n' ride",
                        "Kosciuszko Cct near Sarabah Way hail 'n' ride",
                        "Bedford Rd near Christopher St hail 'n' ride",
                        "Bedford Rd near Attenborough Rd hail 'n' ride",
                        "Village Bvd at Dorset Street",
                        "Village Bvd at Chisolm Way",
                        "Pimpama Jacobs Well Rd at Pimpama City",
                        "Depot Rd near Pimpama Jacobs Well Rd",
                        "Hotham Creek Rd near Blacks Rd hail 'n' ride",
                        "Ruffles Rd near Hotham Creek Rd hail 'n' ride",
                        "Ruffles Rd near Peanba Park Rd hail 'n' ride",
                        "Days Rd near Capelily St hail 'n' ride",
                        "Days Rd near Bridie Dr hail 'n' ride",
                        "Days Rd near Nightjar Rd hail 'n' ride"
                    ],
                    "3487: Picnic Creek State School - Coomera Waters": [
                        "Picnic Creek State School",
                        "Foxwell Rd at Ragamuffin Drive",
                        "Foxwell Rd at Colman Road",
                        "Foxwell Rd near Tooraneedin Rd hail 'n' ride",
                        "Tooraneedin Rd near Figtree St hail 'n' ride",
                        "Brindabella Cl near IGA Village Market HnR",
                        "Ragamuffin Dr near Cherana Lane hail 'n' ride",
                        "Ragamuffin Dr East near Nocturne Lane HnR",
                        "Ragamuffin Dr near Condor Dr hail 'n' ride",
                        "Condor Dr near Serenade Dr hail 'n' ride",
                        "Condor Dr near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Ragamuffin Dr East hail 'n' ride",
                        "Colman Rd near Brilliant Lane",
                        "Ragamuffin Dr W near Ceil Cct hail 'n' ride",
                        "Ragamuffin Dr near Ratu Lane hail 'n' ride"
                    ],
                    "3488: Pacific Pines - Riverstone Crossing": [
                        "Pacific Pines High School",
                        "Pacific Pines Primary School",
                        "Matthews Dr near Roberts Dr hail 'n' ride",
                        "Greenway Bvd near Brissendon St",
                        "Greenway Bvd near Keneally St hail 'n' ride",
                        "Gaven Arterial Rd at Felling Drive",
                        "Cobb and Co Dr near Bahkeeta St",
                        "Cobb and Co Dr near Appollo Pl",
                        "Maudsland Rd at Killarney Ct hail 'n' ride",
                        "Lagoon Park Dr near Meadow Ct hail 'n' ride",
                        "Lagoon Park Dr near Summer Hill Cr hail 'n' ride",
                        "Greenacre Way near Lagoon Park Dr hail 'n' ride",
                        "Riverstone Crsg near Rivermill Tce hail 'n' ride",
                        "Riverstone Crsg near Northern Skies Tce HnR",
                        "Riverstone Crsg near Valley Brook Rise HnR",
                        "Riverstone Crsg near Hibiscus Cr hail 'n' ride",
                        "Riverstone Crsg near Prairie Av hail 'n' ride",
                        "Riverstone Crsg near Mountain View Pde HnR",
                        "Rivermill Tce near Plantation Cr hail 'n' ride",
                        "Rivermill Tce near Settlers Ave hail 'n' ride"
                    ],
                    "3489: Pimpama College - Finnegan Way": [
                        "Pimpama State Secondary College Bay 2",
                        "Dixon Dr at Pimpama State Primary College",
                        "Kerkin Rd S at Vanes Street",
                        "Kerkin Rd South at St Joseph's College",
                        "Finnegan Way at Cirrus Way",
                        "Finnegan Way at Lily Avenue",
                        "Finnegan Way at Felix Entrance"
                    ],
                    "3490: OWHS - Halfway Dr": [
                        "Ormeau Woods High School",
                        "Cuthbert Dr near Brookside Cct",
                        "Pascoe Rd at Halfway Drive",
                        "Halfway Dr near Evergreen Cct hail 'n' ride",
                        "Halfway Dr near Carallia Ct hail 'n' ride",
                        "Halfway Dr at Norfolk Village Primary School"
                    ],
                    "3491: Pimpama Colleges - Abraham Rd": [
                        "Pimpama State Secondary College Bay 1",
                        "Pimpama State Secondary College Bay 2",
                        "Yawalpah Rd at Gainsborough State School",
                        "Yawalpah Rd at Swan Road",
                        "Yawalpah Rd at Salzburg Rd hail 'n' ride",
                        "Rifle Range Rd at Bull Road",
                        "Pimpama Sports Hub",
                        "Rifle Range Rd at The Heights Boulevard",
                        "Old Coach Rd near Coomera Springs Bvd",
                        "Old Coach Rd at Days Road",
                        "Days Rd at City Centre Drive",
                        "Williamson Rd near Billinghurst Cr",
                        "Billinghurst Cr near Turnbull Dr",
                        "Turnbull Dr near Abraham Rd hail 'n' ride"
                    ],
                    "3492: Foxwell State Secondary College - Coomera Rail": [
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Coomera station"
                    ],
                    "3493: Foxwell State Secondary College - Coomera Rail": [
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Coomera station"
                    ],
                    "3494: Foxwell Secondary College - Coomera Springs": [
                        "Nineteenth Ave at Elanora High School",
                        "Casuarina Dr at Ottelia Drive",
                        "Casuarina Dr at Silver Glade Drive",
                        "Casuarina Dr near Silver Glade Dr",
                        "Casuarina Dr near Ottelia Dr",
                        "Tallebudgera Primary School",
                        "Valley Dr near Green Lane hail 'n' ride",
                        "Dungeon Dr near Valley Dr hail 'n' ride",
                        "Dudgeon Dr near Jersey Ct hail 'n' ride"
                    ],
                    "3495: Foxwell Secondary College - Coomera Springs": [
                        "Foxwell Rd at Foxwell State Secondary College",
                        "Days Rd at Coomera Anglican College",
                        "Days Rd at City Centre Drive",
                        "Days Rd near Coomera Grand Drive",
                        "Days Rd near Nightjar Rd hail 'n' ride",
                        "Bridie Dr near Jagera Dr hail 'n' ride",
                        "Bridie Rd near Forest Oak Dr hail 'n' ride",
                        "Bridie Dr near Birley Link hail 'n' ride",
                        "Cassinia Link near Nightjar Dr hail 'n' ride",
                        "Nightjar Dr at Butcher Bird Circuit",
                        "Coomera Springs Bvd at Sandpiper Court",
                        "Coomera Springs Bvd at Dayflower Street",
                        "Coomera Springs Bvd at Rainlily Crescent",
                        "The Heights Bvd near Song Cr hail 'n' ride",
                        "The Heights Bvd at McCabe Avenue",
                        "The Heights Bvd near Peak Cr hail 'n' ride"
                    ],
                    "3496: Ormeau Woods High - Ormeau Station via Reedmans": [
                        "Ormeau Woods High School",
                        "Arthur Way near Gawain Dr",
                        "Gawain Dr near Sugarmill St",
                        "Gawain Dr near Bedivere Dr",
                        "Reedmans Rd near Arthur Way",
                        "Mirambeena Dr near Lumeah Ave",
                        "Mirambeena Dr near Umbango Dr",
                        "Ormeau station"
                    ],
                    "3497: Marymount - The Observatory via Golden Grove": [
                        "Marymount College",
                        "Kingsmore Bvd near Tuckeroo Pl",
                        "Wyllie Way near Gordonia Dr",
                        "Observatory Dr near Grove Creek Cl",
                        "Observatory Dr near Golden Grove Bvd",
                        "Golden Grove Bvd near Skywatch Cct hail 'n' ride",
                        "Barden Ridge Rd near Kirkwood Pl hail 'n' ride",
                        "Barden Ridge Rd near Lowell St hail 'n' ride",
                        "Barden Ridge Rd near Willow Tree Dr hail 'n' ride",
                        "Barden Ridge Rd near Observatory Dr hail 'n' ride",
                        "Observatory Dr near Palomar St"
                    ],
                    "3499: Pacific Pines Schools - Helensvale via Universal": [
                        "Archipelago St near Penrhyn St",
                        "Pacific Pines High School",
                        "Santa Isobel Bvd near Amanu Cr",
                        "Harmsworth Rd near Wunburra Ccl",
                        "McAuley Pde near Diamantina Cct",
                        "McAuley Pde near Fortescue St hail 'n' ride",
                        "McAuley Pde near Matthews Dr",
                        "Matthews Dr near Roberts Dr hail 'n' ride",
                        "Greenway Bvd near Brissendon St",
                        "Greenway Bvd near Keneally St hail 'n' ride",
                        "Universal St near Buchanan Ct",
                        "Universal St near Guy Lane",
                        "Universal St near Takahe St",
                        "Universal St near Crestridge Cr",
                        "Studio Dr near Monroe Ct hail 'n' ride",
                        "Village Way near Studio Dr",
                        "Village Way near Drama St",
                        "Village Way near Mews Ct",
                        "Studio Dr near Hepburn Ct",
                        "Studio Dr near Village Way",
                        "Binstead Way at Universal Street",
                        "Helensvale station"
                    ],
                    "4100: Daisy Hill - Mansfield High": [
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Highview Terrace",
                        "Springwood Rd at Kinloch Road",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Flinders View",
                        "Dennis Rd near Springwood Rd",
                        "Exilis St near York Cl",
                        "Exilis St near Hush Pl",
                        "Exilis St near Jules Ave",
                        "Exilis St near Minutus St",
                        "Exilis St near Nule St",
                        "Exilis St near Underwood Rd",
                        "Underwood Rd near Belmore Dr",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Cilla Ct",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Koobil St",
                        "Koobil St near Sunningdale Ave",
                        "Koobil St near Greenview Ave",
                        "Greenview Ave near Justora St",
                        "Justora St near Rangeview St",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Miles Platting Rd near Rochedale Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Gardner Rd at Arise Boulevard",
                        "Gardner Road at Lorisch Way",
                        "Gardner Road at Prebble Street",
                        "Gardner Rd at Interchange Pl",
                        "Mt Gravatt Capalaba Rd at Wishart East",
                        "Ham Rd at Koola Street, stop 78",
                        "Ham Rd at Adnar Street, stop 77",
                        "Mansfield State High"
                    ],
                    "4102: Springwood - Clairvaux Mackillop College": [
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Parkwood St",
                        "Stellaris Way near Atra Ct",
                        "Belmore Dr near Kallista Rd",
                        "Pandeen Rd near Neerim St",
                        "Milperra Rd near Ranbini St",
                        "Gallang St near Glengala Dr",
                        "Glengala Dr near Kala St",
                        "Glengala Dr at Morbani Road",
                        "Priestdale Rd at William Street",
                        "William St near Cunningham St",
                        "Woodlands Dr near Stirling St",
                        "Devon St near Woodlands Dr",
                        "Devon St near Boskenne St",
                        "Somerset St near Devon St",
                        "Somerset St near Amanda St",
                        "Underwood Rd near Somerset St",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale Rd near Miles Platting Rd",
                        "Arise Bvd near Splendour St hail 'n' ride",
                        "Arise Bvd near Kev Vanstone Park hail 'n' ride",
                        "Arise Bvd near Skyview Av hail 'n' ride",
                        "Gardner Rd at Arise Boulevard",
                        "Gardner Road at Lorisch Way",
                        "Gardner Road at Prebble Street",
                        "Gardner Rd at Interchange Pl",
                        "Mt Gravatt Capalaba Rd at Wishart East",
                        "Ham Rd at Koola Street, stop 78",
                        "Ham Rd at Adnar Street, stop 77",
                        "Mansfield State High",
                        "Klumpp Rd at Klumpp-Dawson"
                    ],
                    "4110: Underwood - Rochedale Primary": [
                        "Logan Rd at Underwood Villas",
                        "Harris St at Louise St hail 'n' ride",
                        "Barton St near Charlane St hail 'n' ride",
                        "Tintagel St near Belgrave St hail 'n' ride",
                        "Murcot St near Bargara St hail 'n' ride",
                        "Coolana St near Fairymead St hail 'n' ride",
                        "Gunalda St at Sports Drive hail 'n' ride",
                        "Springwood Rd at Sports Drive",
                        "Springwood station, platform 1",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale State High School",
                        "Eight Mile Plains station, platform 1",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Rochedale Rd near Miles Platting Rd"
                    ],
                    "4111: Beenleigh - Rochedale South Primary": [
                        "Logan River Rd near Alexandra St",
                        "Logan River Rd at Spanns Rd",
                        "Beenleigh station, stop A",
                        "Alamein St at Beenleigh High School",
                        "Alamein St near Lae St",
                        "Alamein St near Juniper Ct",
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Drews Rd near Barokee Dr",
                        "Jalan St near Murrami Ct",
                        "Pintu Dr near Tanah Merah Ave",
                        "Loganholme, stop H",
                        "Mandew St at Hyperdome",
                        "Plantain Rd at Mandew Street",
                        "Shailer Rd near Oregon Dr",
                        "Shailer Rd near Hester St",
                        "Shailer Rd near Francis Rd",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Chatswood Rd at John Paul College",
                        "John Paul College",
                        "Rochedale State High School",
                        "Eight Mile Plains station, platform 1",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Priestdale Rd at Thallon Street",
                        "Rochedale South State Primary Wendron Street"
                    ],
                    "4112: Loganholme - Rochedale High": [
                        "Loganholme, stop H",
                        "Mandew St at Hyperdome",
                        "Plantain Rd at Mandew Street",
                        "Plantain Rd at Blackthorn Crescent",
                        "Plantain Rd at Narcamus Crescent",
                        "Kimberley Dr near Chatswood Rd",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Chatswood Rd near Voltaire St",
                        "Chatswood Rd at Koolan Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Rochedale Rd at Springwood Plaza",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale State High School"
                    ],
                    "4113: Waterford West - Rochedale High": [
                        "Allora St at John St",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station",
                        "Loganlea Rd near Ellerslie Rd",
                        "Loganlea Rd near Golf Course Dr",
                        "Chatswood Rd near Evenwood St",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at Brentwood Drive",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Hawkins Street",
                        "Rochedale Rd at Springwood Plaza",
                        "Cinderella Dr at Springwood Community Centre",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Cinderella Drive",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale State High School"
                    ],
                    "4114: Daisy Hill - Rochedale High": [
                        "Winnetts Rd near Dahlia St",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Highview Terrace",
                        "Springwood Rd at Kinloch Road",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Flinders View",
                        "Dennis Rd near Springwood Rd",
                        "Exilis St near York Cl",
                        "Exilis St near Hush Pl",
                        "Exilis St near Jules Ave",
                        "Exilis St near Minutus St",
                        "Exilis St near Nule St",
                        "Exilis St near Underwood Rd",
                        "Underwood Rd near Belmore Dr",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Cilla Ct",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Koobil St",
                        "Koobil St near Sunningdale Ave",
                        "Koobil St near Greenview Ave",
                        "Greenview Ave near Justora St",
                        "Justora St near Rangeview St",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale State High School"
                    ],
                    "4115: Edens Landing - Rochedale High": [
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Kingston Rd at Waterford West Shops",
                        "Kingston Rd at Waterford West Primary",
                        "Kingston Rd at Monash Road",
                        "Kingston Rd at Station Road",
                        "Kingston Rd at Gould Adams Park",
                        "Clare Rd near Kingston Rd",
                        "George St at Clare Road",
                        "Clare Rd near Brisbane St",
                        "Kingston Rd at Augustus Street",
                        "Kingston Rd at Edith Street",
                        "Kingston Rd at Market Square",
                        "Kingston Rd at Jean Street",
                        "Kingston Rd near Pilbi St",
                        "Kingston Rd at Woodridge Adventure Park",
                        "Park Rd at Kookaburra Park",
                        "Park Rd at Logan Palms",
                        "Springwood Rd at Dennis Road",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at McCormack Court",
                        "Springwood Road State School",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Rd at Cinderella Drive",
                        "Springwood Rd at Sports Drive",
                        "Logan Rd near Kingston Rd",
                        "Logan Rd at Celia Street",
                        "Logan Rd at Harris Road",
                        "Eight Mile Plains Primary School",
                        "Underwood Rd near Centre Pl",
                        "Underwood Rd near Gerrans St",
                        "Underwood Rd near Rochedale Rd",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale State High School"
                    ],
                    "4116: Springwood - Rochedale High": [
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Parkwood St",
                        "Stellaris Way near Atra Ct",
                        "Belmore Dr near Kallista Rd",
                        "Pandeen Rd near Neerim St",
                        "Milperra Rd near Ranbini St",
                        "Gallang St near Glengala Dr",
                        "Glengala Dr near Kala St",
                        "Glengala Dr at Morbani Road",
                        "Priestdale Rd at William Street",
                        "William St near Cunningham St",
                        "Woodlands Dr near Stirling St",
                        "Devon St near Woodlands Dr",
                        "Devon St near Boskenne St",
                        "Somerset St near Devon St",
                        "Somerset St near Amanda St",
                        "Underwood Rd near Somerset St",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale State High School"
                    ],
                    "4117: Springwood - Rochedale High": [
                        "Barbaralla Dr at Burgallby Road",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Wenlock Cr at Wyclif Avenue",
                        "Rochedale Rd at Springwood Plaza",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale State High School"
                    ],
                    "4120: Loganholme - Springwood Rd Primary": [
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Drews Rd near Barokee Dr",
                        "Jalan St near Murrami Ct",
                        "Pintu Dr near Tanah Merah Ave",
                        "Loganholme, stop H",
                        "Mandew St at Hyperdome",
                        "Plantain Rd at Mandew Street",
                        "Roselea St at Cooba Court",
                        "Roselea St at Hailar Street",
                        "Roselea St at Roselea Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Highview Terrace",
                        "Springwood Rd at Kinloch Road",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Dennis Road",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at McCormack Court",
                        "Springwood Road State School"
                    ],
                    "4121: Loganlea - Springwood High": [
                        "Monash Rd at Knight Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station",
                        "Armstrong Rd at Logan Hospital",
                        "Armstrong Rd at Loganlea TAFE",
                        "Edenlea Dr at Berendt Court",
                        "Edenlea Dr at Kilsay Crescent",
                        "Edenlea Dr at Edenlea Park",
                        "Edenlea Dr at Meadowbrook Shopping Centre",
                        "Meadowbrook Dr near Allenby Dr hail 'n' ride",
                        "Allenby Rd near Fuller Ave hail 'n' ride",
                        "Slacks Creek park 'n' ride stop A",
                        "Pacific Hwy at Centenary Road",
                        "Pacific Hwy at Alfred Street",
                        "Murrays Road near Mandew St",
                        "Shailer Rd at Hester St",
                        "Shailer Rd near Oregon Dr",
                        "Plantain Rd at Blackthorn Crescent",
                        "Plantain Rd at Narcamus Crescent",
                        "Kimberley Dr near Chatswood Rd",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Chatswood Rd near Voltaire St",
                        "Kimberly Park Primary",
                        "Chatswood Rd at Koolan Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Clivia Crescent at Lyndale Street",
                        "Allamanda Dr at Usher Park",
                        "Allamanda Dr at Allamanda Drive Shops",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Chatswood Rd at John Paul College",
                        "Chatswood Rd near Evenwood St",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at Brentwood Drive",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Hawkins Street",
                        "Barbaralla Dr at Burgallby Road",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Wenlock Cr at Wyclif Avenue",
                        "Rochedale Rd at Springwood Plaza",
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Springwood Rd at Springwood High School"
                    ],
                    "4127: Logandale - Kimberley Park Primary": [
                        "Logandale Bvd near Beenleigh Redland Bay Rd",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Plantain Rd near Jasmine Cr",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Plantain Rd near Lissadell St",
                        "Kimberley Dr near Chatswood Rd",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Chatswood Rd near Voltaire St",
                        "Kimberly Park Primary"
                    ],
                    "4128: Loganholme - Shailer Park High": [
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Shailer Park Primary",
                        "Shailer Park High"
                    ],
                    "4130: Rochedale South - Kimberley College": [
                        "Underwood Rd at Graham Hogg Park",
                        "Underwood Rd near Winston St",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Lancelot St",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Belmore Dr",
                        "Stellaris Way near Parfrey Rd",
                        "Parfrey Rd near Lancefield Pl",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at Dennis Road",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Kinloch Road",
                        "Daisy Hill Rd at Highview Terrace",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Shailer Rd at Hester St",
                        "Shailer Rd near Oregon Dr",
                        "Plantain Rd at Blackthorn Crescent",
                        "Plantain Rd at Narcamus Crescent",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Cornubia Park Sports Centre",
                        "California Creek Rd near Kilkenny St",
                        "Braddon St near Bromley St hail 'n' ride",
                        "Kimberley College",
                        "Beenleigh Redland Bay Rd at Carbrook Primary"
                    ],
                    "4131: Springwood - Chisholm College": [
                        "Springwood Road State School",
                        "Springwood Rd at Pannikin Street",
                        "Cinderella Dr at Collene Grove",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Burgallby Road",
                        "Chatswood Rd at Hawkins Street",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "Chatswood Rd at John Paul College",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Lyndale St at Celosia Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Kimberly Park Primary",
                        "Chatswood Rd at Koolan Park",
                        "Chatswood Rd near Floret St",
                        "Chatswood Rd near Voltaire St",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Kimberley Dr at Chatswood Rd",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd at Torres Street",
                        "California Creek Rd near Kilkenny St"
                    ],
                    "4132: Loganholme - Chisholm College": [
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Drews Rd near Barokee Dr",
                        "Jalan St near Murrami Ct",
                        "Pintu Dr near Tanah Merah Ave",
                        "Pacific Hwy at Alfred Street",
                        "Pacific Hwy at Springlands Drive",
                        "Pacific Hwy at Centenary Road",
                        "Nujooloo Rd at Nirimba Street",
                        "Slacks Creek park 'n' ride stop B",
                        "Winnetts Rd near Dahlia St",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Lyndale St at Celosia Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Kimberly Park Primary",
                        "Chatswood Rd at Koolan Park",
                        "Chatswood Rd near Floret St",
                        "Chatswood Rd near Voltaire St",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Kimberley Dr at Chatswood Rd",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd at Torres Street",
                        "California Creek Rd near Kilkenny St"
                    ],
                    "4133: Loganholme - Kimberley College": [
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Drews Rd near Barokee Dr",
                        "Jalan St near Murrami Ct",
                        "Pintu Dr near Tanah Merah Ave",
                        "Loganholme, stop H",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Plantain Rd",
                        "Plantain Rd near Jasmine Cr",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd at Torres Street",
                        "California Creek Rd near Kilkenny St",
                        "Logandale Bvd near Beenleigh Redland Bay Rd",
                        "Kimberley College",
                        "Beenleigh Redland Bay Rd at Carbrook Primary"
                    ],
                    "4134: Beenleigh - Shailer Park High": [
                        "Beenleigh station, stop A",
                        "Alamein St at Beenleigh High School",
                        "Alamein St near Lae St",
                        "Alamein St near Juniper Ct",
                        "River Hills Rd near Eagle Dr",
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Shailer Park Primary",
                        "Shailer Park High"
                    ],
                    "4135: Loganholme - Shailer Park High": [
                        "Drews Rd near Boeing St",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Drews Rd near Barokee Dr",
                        "Jalan St near Murrami Ct",
                        "Pintu Dr near Tanah Merah Ave",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Plantain Rd",
                        "Plantain Rd near Jasmine Cr",
                        "Shailer Park Primary",
                        "Shailer Park High"
                    ],
                    "4136: Loganholme - Shailer Park High": [
                        "Loganholme, stop C",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Plantain Rd",
                        "Plantain Rd near Jasmine Cr",
                        "Shailer Park Primary",
                        "Shailer Park High"
                    ],
                    "4140: Browns Plains - Kingston College": [
                        "Browns Plains station, stop 1B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Browns Plains Rd at Forestglen Park",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Campden Street",
                        "Logan Metro Sports Complex",
                        "Browns Plains Rd at Magnesium Drive",
                        "Fifth Ave at Christina Way",
                        "Fifth Ave at Robinson Court",
                        "Macarthy Rd at Devine Street",
                        "Macarthy Rd near Third Av",
                        "Macarthy Rd near Chasbet St",
                        "Coolmunda St at Ari Street",
                        "Coolmunda St at Kinchant Park",
                        "Coolmunda St at First Avenue",
                        "Homestead St near Galahad St",
                        "Homestead St at Pauline Street",
                        "Pauline St at Lynelle Street",
                        "Pauline St at Princess Street",
                        "Kurrajong Dr at Blue Gum Drive",
                        "Tamarind St at Marsden Park Shops",
                        "Chambers Flat Rd at Mark Lane",
                        "Muchow Rd near Moffatt Rd",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd at Clearview Street",
                        "Logan Reserve Rd near Hydrangea St",
                        "Beutel St at Lexham St",
                        "Beutel St at Tygum Road",
                        "Kingston Rd at Waterford West Primary",
                        "Allora St at John St",
                        "Waterford West Primary",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Keyes St near Sturdee St",
                        "Jellicoe St near Keyes St hail 'n' ride",
                        "Station Rd near Jellicoe St",
                        "Kingston Rd at Gould Adams Park",
                        "Kingston Primary School",
                        "Juers St near Polaris Ave",
                        "Polaris Ave near Sapium St",
                        "Kingston College"
                    ],
                    "4141: Springwood - Kingston College": [
                        "Springwood station, platform 2",
                        "Pacific Hwy at Moss Street",
                        "Park Rd at Watland Street",
                        "Park Rd at Logan Palms",
                        "Park Rd at Kookaburra Park",
                        "Smith Rd at Harrisfields Primary School",
                        "Smith Rd near Wentworth St",
                        "Ewing Rd near Karen St",
                        "Ewing Rd near Monash St",
                        "Fairdale St near Ewing Rd",
                        "Avoca St near Avoca Lane",
                        "Hunter St near Ormesby St",
                        "Willow St at Cypress St",
                        "Parkdale St near North Rd",
                        "North Rd at Smith Rd",
                        "North Rd at Bruce Road",
                        "North Rd at Albert Park",
                        "North Rd at Defiance Road",
                        "Woodridge station",
                        "Wembley Rd at Lennox Ct",
                        "Woodridge High School",
                        "Mayes Ave near Curry St",
                        "Mayes Ave near Heather St",
                        "Mayes Ave near Horton St",
                        "Mayes Ave near Veryan St",
                        "Mayes Ave near Kingston Rd",
                        "Kingston Rd at Edith Street",
                        "Kingston Rd at Market Square",
                        "Mabel Park Primary School",
                        "Kingston Rd at Augustus Street",
                        "George St at Clare Road",
                        "Clare Rd near Brisbane St",
                        "Clare Rd near Kingston Rd",
                        "Kingston Primary School",
                        "Juers St near Polaris Ave",
                        "Polaris Ave near Sapium St",
                        "Kingston College"
                    ],
                    "4142: Kingston - St Francis College": [
                        "Clare Rd near Kingston Rd",
                        "Clare Rd near Brisbane St",
                        "George St near Augustus St",
                        "Adelaide St near Queens Rd",
                        "Queens Rd near Arch St",
                        "Queens Rd near Royal Pde",
                        "Royal Pde near Duke St",
                        "Windsor St near Snowdon St",
                        "Windsor St near Crown St",
                        "Wagensveldt St near Magill Rd",
                        "Mabel Park Primary School",
                        "St Pauls Primary School",
                        "Ewing Rd near Albert St",
                        "Wembley Rd at Lennox Ct",
                        "Bardon Rd at Rudduck Street",
                        "Bardon Rd at Sycamore Ct",
                        "Bardon Rd near Ashton St",
                        "Lyngrove St near Ariel Ave",
                        "Juers St near Rigel St",
                        "Juers St near Bellatrix Dr",
                        "Apodis St near Aquarius Dr",
                        "Velorum Dr at Cognac Court",
                        "Velorum Dr near Anchusa St",
                        "Velorum Dr near Cabernet Ct",
                        "Velorum Dr near Antares Ave",
                        "West Bega Rd near Polaris Ave",
                        "Polaris Ave near Sapium St",
                        "Juers St near Polaris Ave",
                        "Kingston Rd at Gould Adams Park",
                        "Station Rd at Jellicoe Street",
                        "Jellicoe St near Edward St hail 'n' ride",
                        "Monash Rd at Knight Street",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St",
                        "Allora St near Glenda St",
                        "Allora St at John St",
                        "Kingston Rd at Waterford West Primary",
                        "Muchow Rd near Clearview St",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd near Moffatt Rd",
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Oakwood Drive",
                        "Waratah Dr at Whiteman Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Ramin Street",
                        "Augusta St at Crestmead Park",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Pinnington Park",
                        "Julie St at Wallace Street",
                        "St Francis College"
                    ],
                    "4149: Crestmead - Waterford Primary": [
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Oakwood Drive",
                        "Bumstead Rd near Judith St",
                        "Bumstead Rd at Wisdom Way",
                        "Julie St at Bumstead Road",
                        "Julie St at Brabham Park",
                        "Julie St at Wallace Street",
                        "Augusta St at Pinnington Park",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Crestmead Park",
                        "Waratah Dr at Ramin Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Whiteman Street",
                        "Chambers Flat Rd at Marsden Works Depot",
                        "Chambers Flat Rd at Mark Lane",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Lancaster Park",
                        "Monash Rd at Rellam Road",
                        "Monash Rd at Jellicoe Street",
                        "Keyes St near Sturdee St hail 'n' ride",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St",
                        "Allora St near Glenda St",
                        "Waterford West Primary",
                        "Allora St at John St",
                        "Waterford State Primary"
                    ],
                    "4150: Edens Landing - Marsden High": [
                        "Castile Cr near Avonmore St",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Station Rd near Grace St",
                        "Station Rd near Federation Dr",
                        "Federation Dr near Hayden St",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Copper Dr",
                        "Edinburgh Dr near Fadden Ct",
                        "Edinburgh Rd near Mathews St",
                        "Mathews St near Eastbourne Rd",
                        "Montrose Ave near Eastbourne Rd",
                        "Montrose Ave near Clarendon Ave",
                        "Burow Rd near Louise St hail 'n' ride",
                        "Allora St at John St",
                        "Waterford West Primary",
                        "Kingston Rd at Waterford West Primary",
                        "Muchow Rd near Clearview St",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd near Moffatt Rd"
                    ],
                    "4152: Loganlea - Marsden High": [
                        "Edenlea Dr at Meadowbrook Shopping Centre",
                        "Edenlea Dr at Edenlea Park",
                        "Edenlea Dr at Kilsay Crescent",
                        "Edenlea Dr at Berendt Court",
                        "Armstrong Rd at Loganlea TAFE",
                        "Armstrong Rd at Logan Hospital",
                        "Loganlea High School",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St",
                        "Allora St near Glenda St",
                        "Waterford West Primary",
                        "Allora St at John St",
                        "Kingston Rd at Waterford West Primary",
                        "Muchow Rd near Clearview St",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd near Moffatt Rd"
                    ],
                    "4160: Loganholme - Edens Landing Primary": [
                        "Loganholme, stop C",
                        "Mandew St at Hyperdome",
                        "Mandew St at Plantain Road",
                        "Pacific Hwy at Alfred Street",
                        "Pacific Hwy at Springlands Drive",
                        "Pacific Hwy at Centenary Road",
                        "Slacks Creek park 'n' ride stop B",
                        "Loganlea Rd near Golf Course Dr",
                        "Loganlea Rd near Ellerslie Rd",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St",
                        "Allora St near Glenda St",
                        "Waterford West Primary",
                        "Allora St at John St",
                        "Kingston Rd at Waterford West Shops",
                        "Waterford State Primary",
                        "Canterbury College",
                        "High Rd at Sabre St hail 'n' ride",
                        "Montrose Ave near Clarendon Ave",
                        "Montrose Ave near Mathews St",
                        "Edinburgh Rd near Mathews St",
                        "Edinburgh Rd near Fadden Ct",
                        "Federation Dr near Copper Dr",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Snedden St",
                        "Station Rd near Federation Dr",
                        "Station Rd near Grace St",
                        "King Arthur Bvd near Lynette Ct",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "Ivanhoe Dr near Jessie Cr",
                        "Castile Cr at Overland Dr",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr at Clayton Drive",
                        "Castile Cr at Edens Parkland",
                        "Jamie Nicolson Ave at Edens Landing Primary"
                    ],
                    "4161: Holmview - Loganlea High": [
                        "Holmview Rd near Logan River Rd",
                        "Holmview Rd near Logan Rd",
                        "Holmview Rd near Jarvis St",
                        "Grove Rd near Lima St",
                        "Grove Rd near Dendy Ct",
                        "Avonmore St near Auburn St",
                        "Avonmore St near Melton Ct",
                        "Castile Cr near Avonmore St",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Station Rd near Grace St",
                        "Station Rd near Federation Dr",
                        "Federation Dr near Hayden St",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Copper Dr",
                        "Cobalt Dr near Mercury Dr hail 'n' ride",
                        "Edinburgh Dr near Fadden Ct",
                        "Edinburgh Rd near Mathews St",
                        "Mathews St near Eastbourne Rd",
                        "Montrose Ave near Eastbourne Rd",
                        "Montrose Ave near Clarendon Ave",
                        "Waterford State Primary",
                        "Canterbury College",
                        "Schneider Rd near Albert St",
                        "Allora St at John St",
                        "Waterford West Primary",
                        "Loganlea High School"
                    ],
                    "4162: Browns Plains - Loganlea High": [
                        "Browns Plains station, stop 1B",
                        "Vansittart Rd near Estramina Rd",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd at Solandra Circuit",
                        "Green Rd at Sunrise Court",
                        "Green Rd at Isle of Ely Drive",
                        "Green Rd near Heritage Bvd",
                        "Green Rd near Cockatoo Court",
                        "Green Rd at Blue Wren Place",
                        "Green Rd near Venture St",
                        "Bumstead Rd near Clarke Rd",
                        "Julie St at Bumstead Road",
                        "Julie St at Brabham Park",
                        "Julie St at Wallace Street",
                        "Augusta St at Pinnington Park",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Crestmead Park",
                        "Waratah Dr at Ramin Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Whiteman Street",
                        "Chambers Flat Rd at Marsden Works Depot",
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Mark Lane",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Lancaster Park",
                        "Monash Rd at Rellam Road",
                        "Monash Rd at Jellicoe Street",
                        "Monash Rd at Knight Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station",
                        "Loganlea High School"
                    ],
                    "4163: Waterford West - Loganlea High": [
                        "Waterford West Primary",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station",
                        "Loganlea High School"
                    ],
                    "4170: Eagleby - Beenleigh High": [
                        "Sirus St near Roebuck Ave",
                        "Cowper Ave near Dryandra Dr",
                        "River Hills Rd near Laing St",
                        "Swallow St near Lyre St",
                        "Swallows St near Dove St",
                        "Bower Rd near Calliope St",
                        "Copperfield Dr near Burrum Ct",
                        "Copperfield Dr near Paroo Ct",
                        "Herses Rd near Westray Ct",
                        "Herses Rd near Paddington Lane",
                        "Herses Rd near Dion Dr",
                        "Halliday St at Devron Court",
                        "Fryar Rd at Balmoral Street",
                        "Fryar Rd near Sunscape Dr",
                        "Eagleby Shopping Plaza",
                        "River Hills Rd near Monmouth St",
                        "Temma St near River Hills Rd",
                        "Temma St near Magra Ct",
                        "Oliver St near Shirley St",
                        "Oliver St near Greenfield St",
                        "Logan St near Lemongrove St",
                        "Logan St near Boyd St",
                        "Fryar Rd near Albert St",
                        "George St near Macs Lane",
                        "Beenleigh State High School"
                    ],
                    "4171: Eagleby - Beenleigh Primary": [
                        "Sirus St near Roebuck Ave",
                        "Cowper Ave near Dryandra Dr",
                        "River Hills Rd near Laing St",
                        "Swallow St near Lyre St",
                        "Swallows St near Dove St",
                        "Bower Rd near Calliope St",
                        "Copperfield Dr near Burrum Ct",
                        "Copperfield Dr near Paroo Ct",
                        "Herses Rd near Westray Ct",
                        "Herses Rd near Paddington Lane",
                        "Herses Rd near Dion Dr",
                        "Halliday St at Devron Court",
                        "Fryar Rd at Balmoral Street",
                        "Fryar Rd near Sunscape Dr",
                        "Eagleby Shopping Plaza",
                        "River Hills Rd near Monmouth St",
                        "Temma St near River Hills Rd",
                        "Temma St near Magra Ct",
                        "Oliver St near Shirley St",
                        "Oliver St near Greenfield St",
                        "Logan St near Lemongrove St",
                        "Logan St near Boyd St",
                        "Fryar Rd near Albert St",
                        "George St near Macs Lane",
                        "Alamein St at Beenleigh High School",
                        "Kokoda St near City Rd",
                        "Trinity College and St Josephs Primary",
                        "Kokoda St near Bougainville St",
                        "Beenleigh Primary School",
                        "Beenleigh station, stop A"
                    ],
                    "4173: Windaroo - Beenleigh Primary": [
                        "Carl Heck Bvd near Bannockburn Rd",
                        "Carl Heck Bvd near Hendrix St",
                        "Kaiser Dr near Ernest St",
                        "Kaiser Dr near Lena Pl",
                        "Kaiser Dr near Carl Heck Bvd",
                        "Carl Heck Bvd near Mewing Ct",
                        "Windaroo Primary School",
                        "Windaroo State School",
                        "Mount Warren Bvd near Gaynor Ct",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Shea Ct",
                        "Robert Stanley Dr near Merrow St",
                        "Robert Stanley Dr near Doveton Cr",
                        "Vermont Cr near Rochester Dr",
                        "Rochester Dr near Guyra Cl",
                        "Rochester Dr near Willshire St",
                        "Mt Warren Park Primary School",
                        "Mount Warren Bvd near Ben Lexcen Ct",
                        "Mount Warren Bvd at Shields St",
                        "Mount Warren Bvd near Lance Dr",
                        "Tallagandra Rd near Nyah St",
                        "Harburg Dr near Rogers Ave",
                        "Harburg Dr near Benjul Dr",
                        "Harburg Dr near Horizon Dr",
                        "Logan River Rd near Alexandra St",
                        "Chapman Dr near Spanns Rd hail 'n' ride",
                        "Chapman Dr near Hazel Pl hail 'n' ride",
                        "Trinity College and St Josephs Primary",
                        "Kokoda St near York St",
                        "Beenleigh State High School",
                        "Beenleigh State Primary School"
                    ],
                    "4180: Cornubia - Rivermount College": [
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd near Plantain Rd",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Belbora Rd",
                        "Loganholme, stop C",
                        "Pintu Dr near Tanah Merah Ave",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Murrami Ct",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Hampton St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St",
                        "River Hills Rd near Eagle Dr",
                        "Alamein St near Juniper Ct",
                        "Alamein St near Lae St",
                        "Alamein St at Beenleigh High School",
                        "Beenleigh station, stop A",
                        "Mount Warren Bvd near Lance Dr",
                        "Mount Warren Bvd near Shields St",
                        "Mount Warren Bvd near Honeyman St",
                        "Mount Warren Bvd near Robert Stanley Dr",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Yvonne Cr",
                        "Mount Warren Bvd at Windaroo Primary School",
                        "Carl Heck Bvd near Mewing Ct",
                        "Kaiser Dr near Gustav Way",
                        "Kaiser Dr near Lena Pl",
                        "Kaiser Dr near Schonwerder Dr",
                        "Carl Heck Bvd near Hendrix St",
                        "Carl Heck Bvd near Lennon Dr",
                        "Rivermount College"
                    ],
                    "4181: Springwood - Windaroo Valley High": [
                        "Springwood station, platform 1",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Burgallby Road",
                        "Chatswood Rd at Hawkins Street",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "Chatswood Rd at John Paul College",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Lyndale St at Celosia Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Roselea St at Kimberley Plaza",
                        "Roselea St at Hailar Street",
                        "Roselea St at Cooba Court",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop H",
                        "Pintu Dr near Tanah Merah Ave",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Murrami Ct",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Hampton St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St",
                        "River Hills Rd near Eagle Dr",
                        "Brigade Dr at Fire & Ambulance Stations",
                        "Trinity College and St Josephs Primary",
                        "Kokoda St near York St",
                        "Alamein St at Beenleigh High School",
                        "Beenleigh station, stop A",
                        "Main St near Gona St",
                        "Main St near Lubach St",
                        "Vermont Cr near Rochester Dr",
                        "Robert Stanley Dr near Doveton Cr",
                        "Robert Stanley Dr near Merrow St",
                        "Mount Warren Bvd near Robert Stanley Dr",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Yvonne Cr",
                        "Mount Warren Bvd at Windaroo Primary School",
                        "Windaroo Valley High"
                    ],
                    "4182: Waterford West - Windaroo Valley High": [
                        "Kingston Rd at Waterford West Shops",
                        "Canterbury College",
                        "High Rd at Sabre St hail 'n' ride",
                        "Castile Cr at Overland Dr",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr at Clayton Drive",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Avonmore St",
                        "Avonmore St near Melton Ct",
                        "Avonmore St at Auburn Street",
                        "Grove Rd near Hanby Ct",
                        "Grove Rd near Lima St",
                        "Holmview Rd near Jarvis St",
                        "Holmview Rd near Jeetho St",
                        "Holmview Rd near Logan River Rd",
                        "Logan River Rd near Alexandra St",
                        "Sunrise St near Sunland St",
                        "Sunrise St near Tweedland Cr",
                        "Tweedvale St near Crest St",
                        "Tweedvale St near Meadow Cr",
                        "Oval St near Boundary St",
                        "Beenleigh State Primary School",
                        "Windaroo Valley High"
                    ],
                    "4183: Bethania - Windaroo Valley High": [
                        "Montrose Ave near Clarendon Ave",
                        "Montrose Ave near Mathews St",
                        "Edinburgh Rd near Mathews St",
                        "Edinburgh Rd near Fadden Ct",
                        "Cobalt Dr near Mercury Dr hail 'n' ride",
                        "Mercury Dr near Opperman Park hail 'n' ride",
                        "Federation Dr near Copper Dr",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Snedden St",
                        "Station Rd near Federation Dr",
                        "Station Rd near Grace St",
                        "King Arthur Bvd near Lynette Ct",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "Ivanhoe Dr near Jessie Cr",
                        "Castile Cr at Overland Dr",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr at Clayton Drive",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Avonmore St",
                        "Harburg Dr near Horizon Dr",
                        "Harburg Drive near Benjul Dr",
                        "Harburg Dr near Carrie Cr",
                        "Tallagandra Rd near Nyah St",
                        "Mount Warren Bvd near Lance Dr",
                        "Mount Warren Bvd near Shields St",
                        "Mount Warren Bvd near Honeyman St",
                        "Mount Warren Bvd near Robert Stanley Dr",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Yvonne Cr",
                        "Mount Warren Bvd at Windaroo Primary School",
                        "Windaroo Valley High"
                    ],
                    "4184: Marsden - Windaroo Valley High": [
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Mark Lane",
                        "Muchow Rd near Moffatt Rd",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd at Clearview Street",
                        "Logan Reserve Rd near Hydrangea St",
                        "Beutel St at Lexham St",
                        "Beutel St at Tygum Road",
                        "Kingston Rd at Waterford West Primary",
                        "Kingston Rd at Waterford West Shops",
                        "Montrose Ave near Clarendon Ave",
                        "Montrose Ave near Mathews St",
                        "Edinburgh Rd near Mathews St",
                        "Edinburgh Rd near Fadden Ct",
                        "Cobalt Dr near Mercury Dr hail 'n' ride",
                        "Mercury Dr near Opperman Park hail 'n' ride",
                        "Federation Dr near Copper Dr",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Snedden St",
                        "Station Rd near Federation Dr",
                        "Station Rd near Grace St",
                        "King Arthur Bvd near Lynette Ct",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "Ivanhoe Dr near Jessie Cr",
                        "Castile Cr at Overland Dr",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr at Clayton Drive",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Avonmore St",
                        "Avonmore St near Melton Ct",
                        "Avonmore St at Auburn Street",
                        "Grove Rd near Hanby Ct",
                        "Grove Rd near Lima St",
                        "Holmview Rd near Jarvis St",
                        "Holmview Rd near Jeetho St",
                        "Holmview Rd near Logan River Rd",
                        "Logan River Rd near Alexandra St",
                        "Chapman Dr near Spanns Rd hail 'n' ride",
                        "Chapman Dr near Hazel Pl hail 'n' ride",
                        "Trinity College and St Josephs Primary",
                        "Kokoda St near York St",
                        "Alamein St at Beenleigh High School",
                        "Beenleigh State Primary School",
                        "Mount Warren Bvd near Lance Dr",
                        "Mount Warren Bvd near Shields St",
                        "Mount Warren Bvd near Honeyman St",
                        "Mount Warren Bvd near Robert Stanley Dr",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Yvonne Cr",
                        "Mount Warren Bvd at Windaroo Primary School",
                        "Windaroo Valley High"
                    ],
                    "4185: Eagleby - Windaroo Valley High": [
                        "Sirus St near Roebuck Ave",
                        "Cowper Ave near Dryandra Dr",
                        "River Hills Rd near Laing St",
                        "Swallow St near Lyre St",
                        "Swallows St near Dove St",
                        "Bower Rd near Calliope St",
                        "Copperfield Dr near Burrum Ct",
                        "Copperfield Dr near Paroo Ct",
                        "Herses Rd near Westray Ct",
                        "Herses Rd near Paddington Lane",
                        "Herses Rd near Dion Dr",
                        "Halliday St at Devron Court",
                        "Fryar Rd at Balmoral Street",
                        "Fryar Rd near Sunscape Dr",
                        "Eagleby Shopping Plaza",
                        "River Hills Rd near Monmouth St",
                        "Temma St near River Hills Rd",
                        "Temma St near Magra Ct",
                        "Oliver St near Shirley St",
                        "Oliver St near Greenfield St",
                        "Logan St near Lemongrove St",
                        "Logan St near Boyd St",
                        "Fryar Rd near Albert St",
                        "Mount Warren Bvd near Lance Dr",
                        "Mount Warren Bvd near Shields St",
                        "Mount Warren Bvd near Honeyman St",
                        "Mount Warren Bvd near Robert Stanley Dr",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Yvonne Cr",
                        "Mount Warren Bvd at Windaroo Primary School",
                        "Windaroo Valley High"
                    ],
                    "4200: Mansfield High - Daisy Hill": [
                        "Mansfield State High",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Gardner Rd at Arise Boulevard",
                        "Miles Platting Rd at Brilliant Place",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Underwood Rd",
                        "Rochedale Rd near Sunningdale Ave",
                        "Greenview Ave near Esma St",
                        "Greenview Ave near Justora St",
                        "Koobil St near Esma St",
                        "Koobil St near Binnalong St",
                        "Underwood Rd near Winston St",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Lancelot St",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Belmore Dr",
                        "Exilis St near Finfoot St",
                        "Exilis St near Minutus St",
                        "Exilis St near Jules Ave",
                        "Exilis St near Evette Cl",
                        "Exilis St near Kent Cl",
                        "Dennis Rd near Springwood Rd",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Kinloch Road",
                        "Daisy Hill Rd at Highview Terrace",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Daisy Hill Primary School"
                    ],
                    "4201: Mansfield High - Underwood": [
                        "Mansfield State High",
                        "Broadwater Rd at Mansfield Park",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Arise Bvd near Gardner Rd hail 'n' ride",
                        "Arise Bvd near Kev Vanstone Park hail 'n' ride",
                        "Arise Bvd near Ross St hail 'n' ride",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Underwood Rd",
                        "Underwood Rd at Graham Hogg Park",
                        "Somerset St near Amanda St",
                        "Somerset St near Devon St",
                        "Devon St near Trevelloe St",
                        "Devon St near Woodlands Dr",
                        "Woodlands Dr near Hindmarsh Ct",
                        "William St near Landsborough St",
                        "Priestdale Rd at William Street",
                        "Glengala Dr near Morbani Rd",
                        "Glengala Dr near Gilandra St",
                        "Gallang St near Milperra Rd",
                        "Milperra Rd near Kancoona St",
                        "Pandeen Rd near Neerim St",
                        "Belmore Dr near Kallista Rd",
                        "Stellaris Way near Parfrey Rd",
                        "Parfrey Rd near Lancefield Pl",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Springwood Rd at McCormack Court",
                        "Springwood Road State School",
                        "Springwood Rd at Pannikin Street",
                        "Cinderella Dr at Collene Grove",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood station, platform 1",
                        "Logan Rd near Kingston Rd"
                    ],
                    "4202: Clairvaux Mackillop College - Waterford West": [
                        "Logan Rd at St Bernard, stop 42",
                        "Mansfield State High",
                        "Broadwater Rd at Mansfield Park",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Arise Bvd near Gardner Rd hail 'n' ride",
                        "Arise Bvd near Kev Vanstone Park hail 'n' ride",
                        "Arise Bvd near Ross St hail 'n' ride",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Underwood Rd",
                        "Underwood Rd at Graham Hogg Park",
                        "Somerset St near Amanda St",
                        "Somerset St near Devon St",
                        "Devon St near Trevelloe St",
                        "Devon St near Woodlands Dr",
                        "Woodlands Dr near Hindmarsh Ct",
                        "William St near Landsborough St",
                        "Priestdale Rd at William Street",
                        "Glengala Dr near Morbani Rd",
                        "Glengala Dr near Gilandra St",
                        "Gallang St near Milperra Rd",
                        "Milperra Rd near Kancoona St",
                        "Pandeen Rd near Neerim St",
                        "Belmore Dr near Kallista Rd",
                        "Stellaris Way near Parfrey Rd",
                        "Parfrey Rd near Lancefield Pl",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Springwood Rd at McCormack Court",
                        "Springwood Road State School",
                        "Springwood Rd at Pannikin Street",
                        "Cinderella Dr at Collene Grove",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood station, platform 3",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Burgallby Road",
                        "Chatswood Rd at Hawkins Street",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "John Paul College",
                        "Loganlea Rd near Golf Course Dr",
                        "Loganlea Rd near Ellerslie Rd",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St",
                        "Allora St near Glenda St",
                        "Allora St at John St"
                    ],
                    "4203: Clairvaux Mackillop College - Cornubia": [
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Miles Platting Road, stop 82",
                        "Logan Rd at Brandl Street, stop 83",
                        "Eight Mile Plains Primary School",
                        "Underwood Rd near Centre Pl",
                        "Underwood Rd near Gerrans St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Greenview Ave near Esma St",
                        "Greenview Ave near Justora St",
                        "Koobil St near Esma St",
                        "Koobil St near Binnalong St",
                        "Underwood Rd near Winston St",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Lancelot St",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Belmore Dr",
                        "Exilis St near Finfoot St",
                        "Exilis St near Minutus St",
                        "Exilis St near Jules Ave",
                        "Exilis St near Evette Cl",
                        "Exilis St near Kent Cl",
                        "Dennis Rd near Springwood Rd",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Kinloch Road",
                        "Daisy Hill Rd at Highview Terrace",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Lyndale St at Celosia Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Roselea St at Kimberley Plaza",
                        "Roselea St at Hailar Street",
                        "Roselea St at Cooba Court",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop H",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Plantain Rd",
                        "Plantain Rd near Jasmine Cr",
                        "Plantain Rd near Lissadell St",
                        "Parkview Rd near Gyles Ct",
                        "Parkview Cr near Aster Ct",
                        "Blackbutt St at Verbena Street",
                        "Glenvale St near Kilkenny St",
                        "Kilkenny St near Surrey St",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd at California Creek Road",
                        "Logandale Bvd near Beenleigh Redland Bay Rd",
                        "Beenleigh Redland Bay Rd near California Creek Rd",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive"
                    ],
                    "4204: Mansfield High - Rochedale": [
                        "Mansfield State High",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Arise Bvd near Gardner Rd hail 'n' ride",
                        "Arise Bvd near Kev Vanstone Park hail 'n' ride",
                        "Arise Bvd near Ross St hail 'n' ride",
                        "Miles Platting Rd near Rochedale Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Miles Platting Rd at Gardner Rd"
                    ],
                    "4209: Eight Mile Plains Primary - Mt Gravatt": [
                        "Eight Mile Plains Primary School",
                        "Rochedale State High School",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1"
                    ],
                    "4210: Rochedale Primary - Springwood": [
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale State High School",
                        "Logan Rd at Underwood Villas",
                        "Harris St at Louise St hail 'n' ride",
                        "Barton St near Charlane St hail 'n' ride",
                        "Tintagel St near Belgrave St hail 'n' ride",
                        "Murcot St near Bargara St hail 'n' ride",
                        "Coolana St near Fairymead St hail 'n' ride",
                        "Gunalda St at Sports Drive hail 'n' ride",
                        "Springwood Rd at Sports Drive",
                        "Springwood station, platform 1"
                    ],
                    "4211: Rochedale South Primary - Loganholme": [
                        "Rochedale South State Primary Wendron Street",
                        "Priestdale Rd at Thallon Street",
                        "Rochedale State High School",
                        "Eight Mile Plains station, platform 1",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Underwood Rd",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Kumbari Street hail 'n' ride",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr near Athena Gr",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Burgallby Road",
                        "Chatswood Rd at Hawkins Street",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "John Paul College",
                        "Chatswood Rd at John Paul College",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Shailer Rd at Hester St",
                        "Shailer Rd near Oregon Dr",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop D",
                        "Pintu Dr near Tanah Merah Ave",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Murrami Ct",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Hampton St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St"
                    ],
                    "4212: Rochedale High - Loganholme": [
                        "Rochedale State High School",
                        "Rochedale Rd at Kumbari Street hail 'n' ride",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Burgallby Road",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Lyndale St at Celosia Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Chatswood Rd at Koolan Park",
                        "Chatswood Rd near Voltaire St",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Kimberley Dr at Chatswood Rd",
                        "Plantain Rd at Narcamus Crescent",
                        "Plantain Rd at Blackthorn Crescent",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop C"
                    ],
                    "4213: Rochedale High - Waterford West": [
                        "Rochedale State High School",
                        "Chatswood Rd at Hawkins Street",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "John Paul College",
                        "Loganlea Rd near Golf Course Dr",
                        "Loganlea Rd near Ellerslie Rd",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St",
                        "Allora St near Glenda St",
                        "Allora St at John St"
                    ],
                    "4214: St Peters Primary - Daisy Hill": [
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale State High School",
                        "Eight Mile Plains station, platform 1",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale Rd near Underwood Rd",
                        "Rochedale Rd near Sunningdale Ave",
                        "Greenview Ave near Esma St",
                        "Greenview Ave near Justora St",
                        "Koobil St near Esma St",
                        "Koobil St near Binnalong St",
                        "Underwood Rd near Winston St",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Lancelot St",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Belmore Dr",
                        "Exilis St near Finfoot St",
                        "Exilis St near Minutus St",
                        "Exilis St near Jules Ave",
                        "Exilis St near Evette Cl",
                        "Exilis St near Kent Cl",
                        "Dennis Rd near Springwood Rd",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Kinloch Road",
                        "Daisy Hill Rd at Highview Terrace",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Winnetts Rd near Dahlia St"
                    ],
                    "4215: Rochedale High - Edens Landing": [
                        "Rochedale State High School",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd near Fielding Dr",
                        "Underwood Rd near Dalhouse Ct",
                        "Underwood Rd near Gerrans St",
                        "Underwood Rd near Centre Pl",
                        "Logan Rd at Underwood Villas",
                        "Logan Rd at Harris Road",
                        "Logan Rd at Celia Street",
                        "Logan Rd near Kingston Rd",
                        "Springwood Rd at Sports Drive",
                        "Springwood Rd at Pannikin Street",
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at Dennis Road",
                        "Dennis Rd at Springwood Central Primary School",
                        "Park Rd at Logan Palms",
                        "Park Rd at Kookaburra Park",
                        "Kingston Rd at Woodridge Adventure Park",
                        "Kingston Rd at Akora Street",
                        "Kingston Rd near Paradise Rd",
                        "Kingston Rd at Market Square",
                        "Kingston Rd at Edith Street",
                        "Kingston Rd at Augustus Street",
                        "George St at Clare Road",
                        "Clare Rd near Brisbane St",
                        "Clare Rd near Kingston Rd",
                        "Kingston Rd at Gould Adams Park",
                        "Kingston Rd at Station Road",
                        "Kingston Rd at Monash Road",
                        "Kingston Rd at Waterford West Primary",
                        "Kingston Rd at Waterford West Shops",
                        "King Arthur Bvd near Lynette Ct",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "Ivanhoe Dr near Jessie Cr"
                    ],
                    "4216: Rochedale South Primary - Springwood": [
                        "Rochedale South State Primary Wendron Street",
                        "Priestdale Rd at Thallon Street",
                        "Rochedale State High School",
                        "Eight Mile Plains station, platform 1",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Underwood Rd",
                        "Underwood Rd at Graham Hogg Park",
                        "Somerset St near Amanda St",
                        "Somerset St near Devon St",
                        "Devon St near Trevelloe St",
                        "Devon St near Woodlands Dr",
                        "Woodlands Dr near Hindmarsh Ct",
                        "William St near Landsborough St",
                        "Priestdale Rd at William Street",
                        "Glengala Dr near Morbani Rd",
                        "Glengala Dr near Gilandra St",
                        "Gallang St near Milperra Rd",
                        "Milperra Rd near Kancoona St",
                        "Pandeen Rd near Neerim St",
                        "Belmore Dr near Kallista Rd",
                        "Stellaris Way near Parfrey Rd",
                        "Parfrey Rd near Lancefield Pl",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Springwood Rd at McCormack Court",
                        "Springwood Road State School",
                        "Springwood Rd at Pannikin Street",
                        "Cinderella Dr at Collene Grove",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood station, platform 1"
                    ],
                    "4217: Rochedale High - Loganholme": [
                        "Rochedale State High School",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Springwood Community Centre",
                        "Cinderella Dr at Springwood Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Burgallby Road",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Lyndale St at Celosia Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Roselea St at Kimberley Plaza",
                        "Roselea St at Hailar Street",
                        "Roselea St at Cooba Court",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop D"
                    ],
                    "4218: Rochedale High - Loganholme": [
                        "Rochedale State High School",
                        "Springwood station, platform 1",
                        "Loganholme, stop D"
                    ],
                    "4220: Springwood Rd Primary - Loganholme": [
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at Dennis Road",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Kinloch Road",
                        "Daisy Hill Rd at Highview Terrace",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Lyndale St at Celosia Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Roselea St at Kimberley Plaza",
                        "Roselea St at Hailar Street",
                        "Roselea St at Cooba Court",
                        "Plaintain Rd at Mandew Street",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop D",
                        "Pintu Dr near Tanah Merah Ave",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Murrami Ct",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Hampton St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St"
                    ],
                    "4221: Springwood Rd Primary - Loganlea": [
                        "Springwood Road State School",
                        "Springwood Rd near Knox Ct",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at Dennis Road",
                        "Barbaralla Dr at Tallowood Park",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Burgallby Road",
                        "Chatswood Rd at Hawkins Street",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at St Edwards Catholic Primary School",
                        "Chatswood Rd at John Paul College",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Allamanda Dr at Allamanda Drive Shops",
                        "Allamanda Dr at Usher Park",
                        "Clivia Crescent at Lyndale Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Kimberly Park Primary",
                        "Chatswood Rd at Koolan Park",
                        "Chatswood Rd near Voltaire St",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Kimberley Dr at Chatswood Rd",
                        "Plantain Rd at Narcamus Crescent",
                        "Plantain Rd at Blackthorn Crescent",
                        "Shailer Rd near Oregon Dr",
                        "Shailer Rd near Hester St",
                        "Pacific Hwy at Alfred Street",
                        "Pacific Hwy at Springlands Drive",
                        "Pacific Hwy at Centenary Road",
                        "Slacks Creek park 'n' ride stop B",
                        "Allenby Rd near Fuller Ave hail 'n' ride",
                        "Meadowbrook Dr near Allenby Dr hail 'n' ride",
                        "Edenlea Dr at Meadowbrook Shopping Centre",
                        "Edenlea Dr at Edenlea Park",
                        "Edenlea Dr at Kilsay Crescent",
                        "Edenlea Dr at Berendt Court",
                        "Armstrong Rd at Loganlea TAFE",
                        "Armstrong Rd at Logan Hospital",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Monash Rd at Knight Street",
                        "Monash Rd at Jellicoe Street",
                        "Monash Rd near Rellam Rd"
                    ],
                    "4227: Kimberley Park Primary - Logandale": [
                        "Kimberly Park Primary",
                        "Chatswood Rd near Voltaire St",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Kimberley Dr at Chatswood Rd",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd at Torres Street",
                        "California Creek Rd near Kilkenny St",
                        "Logandale Bvd near Beenleigh Redland Bay Rd"
                    ],
                    "4229: Shailer Park Primary - Loganholme": [
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Bryants Rd near Plantain Rd",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Belbora Rd",
                        "Pintu Dr near Tanah Merah Ave",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Murrami Ct",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Hampton St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St"
                    ],
                    "4230: Chisholm College - Rochedale South": [
                        "California Creek Rd near Kilkenny St",
                        "Kimberley College",
                        "Beenleigh Redland Bay Rd at Carbrook Primary",
                        "Beenleigh Redland Bay Rd near California Creek Rd",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Plantain Rd near Jasmine Cr",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Plantain Rd near Lissadell St",
                        "Plantain Rd at Narcamus Crescent",
                        "Plantain Rd at Blackthorn Crescent",
                        "Shailer Rd near Oregon Dr",
                        "Shailer Rd near Hester St",
                        "Shailer Rd near Francis Rd",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Highview Terrace",
                        "Springwood Rd at Kinloch Road",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Dennis Road",
                        "Springwood Rd at Springwood High School",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Parkwood St",
                        "Stellaris Way near Atra Ct",
                        "Underwood Rd near Belmore Dr",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Cilla Ct",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Koobil St",
                        "Underwood Rd near Somerset St"
                    ],
                    "4231: St Matthews Primary - Springwood": [
                        "Bryants Rd at Torres Street",
                        "Chisholm Catholic College",
                        "California Creek Rd Mapping stop",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Plantain Rd near Jasmine Cr",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Plantain Rd near Lissadell St",
                        "Kimberley Dr near Chatswood Rd",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Chatswood Rd near Voltaire St",
                        "Kimberly Park Primary",
                        "Chatswood Rd at Koolan Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Chatswood Rd at John Paul College",
                        "Chatswood Rd near Evenwood St",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at Brentwood Drive",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Hawkins Street",
                        "Barbaralla Dr at Burgallby Road",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Cinderella Dr at Springwood Community Centre",
                        "Cinderella Dr at Arndale Shopping Centre"
                    ],
                    "4232: St Matthews Primary - Loganholme": [
                        "Bryants Rd at Torres Street",
                        "Chisholm Catholic College",
                        "California Creek Rd Mapping stop",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Plantain Rd near Jasmine Cr",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Plantain Rd near Lissadell St",
                        "Kimberley Dr near Chatswood Rd",
                        "Chatswood Rd at Kimberley Grove Park",
                        "Chatswood Rd near Voltaire St",
                        "Kimberly Park Primary",
                        "Chatswood Rd at Koolan Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Winnetts Rd near Dahlia St",
                        "Slacks Creek park 'n' ride stop A",
                        "Pacific Hwy at Centenary Road",
                        "Pacific Hwy at Alfred Street",
                        "Pintu Dr near Tanah Merah Ave",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Murrami Ct",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Hampton St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St"
                    ],
                    "4233: Chisholm College - Loganholme": [
                        "California Creek Rd near Kilkenny St",
                        "California Creek Rd Mapping stop",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Plantain Rd near Jasmine Cr",
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Bryants Rd near Plantain Rd",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Belbora Rd",
                        "Loganholme, stop D",
                        "Pintu Dr near Tanah Merah Ave",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Murrami Ct",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Hampton St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St"
                    ],
                    "4234: Shailer Park Primary - Beenleigh": [
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Drews Rd near Hampton St",
                        "Clarks Rd near Dewar Drive",
                        "Clarks Rd near Corndale St",
                        "River Hills Rd near Eagle Dr",
                        "Alamein St near Juniper Ct",
                        "Alamein St near Lae St",
                        "Alamein St at Beenleigh High School",
                        "Beenleigh station, stop A"
                    ],
                    "4235: Shailer Park Primary - Loganholme": [
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Bryants Rd near Plantain Rd",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Belbora Rd",
                        "Pintu Dr near Tanah Merah Ave",
                        "Jalan St near Nandala Dr",
                        "Jalan St near Murrami Ct",
                        "Jalan St near Mallee Dr",
                        "Drews Rd near Piari St",
                        "Drews Rd near Boeing St"
                    ],
                    "4236: Shailer Park Primary - Loganholme": [
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Loganholme, stop C"
                    ],
                    "4237: Shailer Park Primary - Loganholme": [
                        "Shailer Park Primary",
                        "Shailer Park High",
                        "Loganholme, stop C"
                    ],
                    "4238: Chisholm College - Loganholme": [
                        "Chisholm Catholic College",
                        "California Creek Rd Mapping stop",
                        "Loganholme, stop C"
                    ],
                    "4239: Chisholm College - Loganholme": [
                        "Chisholm Catholic College",
                        "California Creek Rd Mapping stop",
                        "Loganholme, stop C"
                    ],
                    "4240: Kingston Primary - Browns Plains": [
                        "Kingston Primary School",
                        "Juers St near Polaris Ave",
                        "Polaris Ave near Sapium St",
                        "Kingston College",
                        "Kingston Rd at Gould Adams Park",
                        "Station Rd at Jellicoe Street",
                        "Jellicoe St near Edward St hail 'n' ride",
                        "Jellicoe St near Keyes St hail 'n' ride",
                        "Keyes St near Sturdee St hail 'n' ride",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St",
                        "Allora St near Glenda St",
                        "Waterford West Primary",
                        "Allora St at John St",
                        "Kingston Rd at Waterford West Primary",
                        "Beutel St at Tygum Road",
                        "Beutel St at Lexham St",
                        "Logan Reserve Rd near Hydrangea St",
                        "Muchow Rd near Clearview St",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd near Moffatt Rd",
                        "Chambers Flat Rd at Mark Lane",
                        "Tamarind St at Marsden Park Shops",
                        "Kurrajong Dr at Blue Gum Drive",
                        "Pauline St at Princess Street",
                        "Pauline St near Leanne St",
                        "Homestead St at Pauline Street",
                        "Homestead St near Galahad St",
                        "Coolmunda St at First Avenue",
                        "Coolmunda St at Kinchant Park",
                        "Coolmunda St at Ari Street",
                        "Macarthy Rd near Chasbet St",
                        "Macarthy Rd at Kurilpa Street",
                        "Macarthy Rd at Devine Street",
                        "Macarthy Rd at Fifth Avenue",
                        "Fifth Ave at Christina Way",
                        "Browns Plains Rd at Magnesium Drive",
                        "Browns Plains Rd near Campden St",
                        "Browns Plains Rd at Campden Street",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 1B"
                    ],
                    "4241: Kingston Primary - Springwood": [
                        "Kingston Primary School",
                        "Juers St near Polaris Ave",
                        "Polaris Ave near Sapium St",
                        "Kingston College",
                        "Clare Rd near Kingston Rd",
                        "Clare Rd near Brisbane St",
                        "George St near Augustus St",
                        "Adelaide St near Queens Rd",
                        "Queens Rd near Arch St",
                        "Queens Rd near Royal Pde",
                        "Meakin Rd near Plain St",
                        "Veldt St near Rowanda St",
                        "Veldt St near Lowry St",
                        "Wagensveldt St near Renita St",
                        "Wagensveldt St near Evelyn St",
                        "Mabel Park Primary School",
                        "Kingston Rd at Market Square",
                        "Mayes Ave near Kingston Rd",
                        "Mayes Ave near Veryan St",
                        "Mayes Ave near David St",
                        "Mayes Ave near Huntress Ct",
                        "Mayes Ave near Heather St",
                        "Mayes Ave near Leichardt St",
                        "Woodridge station",
                        "North Rd at Defiance Road",
                        "North Rd at Albert Park",
                        "North Rd at Bruce Road",
                        "North Rd near Victoria St",
                        "Parkdale St near Deodar St",
                        "Cypress St near Hunter St",
                        "Hunter St near Ormesby St",
                        "Avoca St near Ormesby St",
                        "Fairdale St near Ewing Rd",
                        "Ewing Rd near Monash St",
                        "Ewing Rd near Karen St",
                        "Smith Rd at Harrisfields Primary School",
                        "Park Rd at Kookaburra Park",
                        "Park Rd at Logan Palms",
                        "Pacific Hwy at Park Road",
                        "Pacific Hwy at Moss Street",
                        "Springwood station, platform 1"
                    ],
                    "4242: St Francis College - Woodridge": [
                        "St Francis College",
                        "Julie St at Wallace Street",
                        "Augusta St at Pinnington Park",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Crestmead Park",
                        "Waratah Dr at Ramin Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Whiteman Street",
                        "Chambers Flat Rd at Marsden Works Depot",
                        "Muchow Rd near Moffatt Rd",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd at Clearview Street",
                        "Kingston Rd at Waterford West Primary",
                        "Allora St at John St",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Monash Rd at Knight Street",
                        "Station Rd near Jellicoe St",
                        "Kingston Rd at Gould Adams Park",
                        "Juers St near Polaris Ave",
                        "Polaris Ave near Sapium St",
                        "West Bega Rd near Polaris Ave",
                        "Velorum Dr near Antares Ave",
                        "Velorum Dr near Cabernet Ct",
                        "Velorum Dr near Anchusa St",
                        "Velorum Dr near Cognac Ct",
                        "Apodis St near Aquarius Dr",
                        "Juers St near Bellatrix Dr",
                        "Juers St near Rigel St",
                        "Lyngrove St near Alderbaran Dr",
                        "Bardon Rd near Ashton St",
                        "Bardon Rd at Pope Street",
                        "Bardon Rd at Rudduck Street",
                        "Wembley Rd at Lennox Ct",
                        "St Pauls Primary School",
                        "Ewing Rd near Defiance Rd",
                        "Ewing Rd near Orchid St",
                        "Ewing Rd near Smith Rd",
                        "Smith Rd at Harrisfields Primary School"
                    ],
                    "4244: Mabel Park High - Woodridge": [
                        "Mabel Park Primary School",
                        "Wembley Rd at Wilbur Street",
                        "Wembley Rd at Ewing Road",
                        "Woodridge station",
                        "North Rd at Defiance Road",
                        "North Rd at Albert Park",
                        "North Rd at Bruce Road",
                        "North Rd near Victoria St",
                        "Parkdale St near Deodar St",
                        "Cypress St near Hunter St",
                        "Hunter St near Ormesby St",
                        "Avoca St near Ormesby St",
                        "Fairdale St near Ewing Rd",
                        "Ewing Rd near Monash St",
                        "Ewing Rd near Karen St",
                        "Smith Rd at Harrisfields Primary School"
                    ],
                    "4245: Mabel Park High - Kingston": [
                        "Mabel Park Primary School",
                        "Wembley Rd at Logan City Centre",
                        "Logan Central station, platform 1",
                        "Wembley Rd at Wilbur Street",
                        "Mayes Ave near Curry St",
                        "Mayes Ave near Heather St",
                        "Mayes Ave near Horton St",
                        "Mayes Ave near Veryan St",
                        "Mayes Ave near Kingston Rd"
                    ],
                    "4246: Mabel Park High - Logan Central": [
                        "Mabel Park Primary School",
                        "Lake Rd near Carribean Dr",
                        "Lake Rd near Endota St",
                        "Lake Rd near Reserve Rd",
                        "Reserve Rd near Kunari St",
                        "Kingston Rd at Woodridge Adventure Park",
                        "Smith Rd at Harrisfields Primary School",
                        "Ewing Rd near Karen St",
                        "Ewing Rd near Monash St",
                        "Fairdale St near Ewing Rd",
                        "Avoca St near Avoca Lane",
                        "Hunter St near Ormesby St",
                        "Willow St at Cypress St",
                        "Parkdale St near North Rd",
                        "North Rd at Smith Rd",
                        "North Rd at Bruce Road",
                        "North Rd at Albert Park",
                        "North Rd at Defiance Road",
                        "Woodridge station",
                        "Wembley Rd at Ewing Road",
                        "Logan Central station, platform 1"
                    ],
                    "4247: Woodridge High - Woodridge": [
                        "Woodridge High School",
                        "Wembley Rd at Lennox Ct",
                        "Wembley Rd at Ewing Road",
                        "Logan Central station, platform 1",
                        "Wembley Rd at Wilbur Street",
                        "Woodridge station",
                        "North Rd at Defiance Road",
                        "North Rd at Albert Park",
                        "North Rd at Bruce Road",
                        "North Rd near Victoria St",
                        "Parkdale St near Deodar St",
                        "Cypress St near Hunter St",
                        "Hunter St near Ormesby St",
                        "Avoca St near Ormesby St",
                        "Fairdale St near Ewing Rd",
                        "Ewing Rd near Monash St",
                        "Ewing Rd near Karen St",
                        "Smith Rd at Harrisfields Primary School",
                        "Kingston Rd at Woodridge Adventure Park",
                        "Reserve Rd near Gomana St",
                        "Lake Rd near Endota St",
                        "Lake Rd near Carribean Dr"
                    ],
                    "4249: Waterford Primary - Browns Plains": [
                        "Waterford State Primary",
                        "Schneider Rd near Albert St",
                        "Allora St at John St",
                        "Waterford West Primary",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Keyes St near Sturdee St",
                        "Monash Rd at Jellicoe Street",
                        "Monash Rd near Rellam Rd",
                        "Chambers Flat Rd at Lancaster Park",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Mark Lane",
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Oakwood Drive",
                        "Waratah Dr at Whiteman Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Ramin Street",
                        "Augusta St at Crestmead Park",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Pinnington Park",
                        "Julie St at Wallace Street",
                        "Julie St at Brabham Park",
                        "Julie St at Bumstead Road",
                        "Bumstead Rd near Clarke Rd",
                        "Green Rd near Venture St",
                        "Green Rd at Blue Wren Place",
                        "Green Rd at Cockatoo Court",
                        "Green Rd near Heritage Bvd",
                        "Green Rd at Isle of Ely Drive",
                        "Green Rd at Solandra Circuit",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Estramina Rd",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 1B"
                    ],
                    "4250: Marsden High - Edens Landing": [
                        "Muchow Rd near Moffatt Rd",
                        "Kingston Rd at Waterford West Primary",
                        "Allora St at John St",
                        "Waterford West Primary",
                        "Burow Rd near Louise St hail 'n' ride",
                        "Montrose Ave near Clarendon Ave",
                        "Montrose Ave near Mathews St",
                        "Edinburgh Rd near Mathews St",
                        "Edinburgh Rd near Fadden Ct",
                        "Federation Dr near Copper Dr",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Snedden St",
                        "Station Rd near Federation Dr",
                        "Station Rd near Grace St",
                        "King Arthur Bvd near Lynette Ct",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "Ivanhoe Dr near Jessie Cr",
                        "Castile Cr at Overland Dr",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr at Clayton Drive",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Avonmore St"
                    ],
                    "4252: Marsden High To Loganlea": [
                        "Muchow Rd near Moffatt Rd",
                        "Loganlea station",
                        "Loganlea High School",
                        "Armstrong Rd at Logan Hospital",
                        "Armstrong Rd at Loganlea TAFE",
                        "Edenlea Dr at Berendt Court",
                        "Edenlea Dr at Kilsay Crescent",
                        "Edenlea Dr at Edenlea Park",
                        "Edenlea Dr at Meadowbrook Shopping Centre"
                    ],
                    "4253: Marsden High - Crestmead": [
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Oakwood Drive",
                        "Waratah Dr at Whiteman Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Ramin Street",
                        "Augusta St at Crestmead Park",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Trulson Drive"
                    ],
                    "4254: Marsden High - Crestmead": [
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Oakwood Drive",
                        "Waratah Dr at Whiteman Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Ramin Street",
                        "Augusta St at Crestmead Park",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Pinnington Park",
                        "Julie St at Wallace Street",
                        "Julie St at Brabham Park",
                        "Julie St at Bumstead Road",
                        "Bumstead Rd near Clarke Rd",
                        "Green Rd near Venture St",
                        "Green Rd at Blue Wren Place",
                        "Green Rd at Cockatoo Court",
                        "Green Rd near Heritage Bvd",
                        "Green Rd at Isle of Ely Drive",
                        "Green Rd at Solandra Circuit",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Estramina Rd",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 1B"
                    ],
                    "4255: Marsden High - Browns Plains": [
                        "Marsden High School",
                        "Chambers Flat Rd at Mark Lane",
                        "Tamarind St at Marsden Park Shops",
                        "Kurrajong Dr at Blue Gum Drive",
                        "Pauline St at Princess Street",
                        "Pauline St near Leanne St",
                        "Homestead St at Pauline Street",
                        "Homestead St near Galahad St",
                        "Coolmunda St at First Avenue",
                        "Coolmunda St at Kinchant Park",
                        "Coolmunda St at Ari Street",
                        "Macarthy Rd near Chasbet St",
                        "Macarthy Rd at Kurilpa Street",
                        "Macarthy Rd at Devine Street",
                        "Macarthy Rd at Fifth Avenue",
                        "Fifth Ave at Christina Way",
                        "Browns Plains Rd at Magnesium Drive",
                        "Browns Plains Rd near Bayliss Rd hail 'n' ride",
                        "Browns Plains Rd near Campden St",
                        "Browns Plains Rd at Campden Street",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 1A"
                    ],
                    "4256: Marsden High - Loganlea": [
                        "Chambers Flat Rd at Marsden Works Depot",
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Mark Lane",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Lancaster Park",
                        "Monash Rd at Rellam Road",
                        "Monash Rd at Jellicoe Street",
                        "Monash Rd at Knight Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station"
                    ],
                    "4257: Marsden High - Marsden": [
                        "Muchow Rd near Moffatt Rd",
                        "Chambers Flat Rd at Mark Lane",
                        "Tamarind St at Marsden Park Shops",
                        "Kurrajong Dr at Blue Gum Drive",
                        "Pauline St at Princess Street",
                        "Pauline St near Leanne St",
                        "Homestead St at Pauline Street",
                        "Homestead St near Galahad St",
                        "Coolmunda St at First Avenue",
                        "Coolmunda St at Kinchant Park",
                        "Coolmunda St at Ari Street",
                        "Macarthy Rd near Chasbet St",
                        "Macarthy Rd at Kurilpa Street",
                        "Macarthy Rd at Devine Street",
                        "Macarthy Rd at Fifth Avenue",
                        "Fifth Ave at Christina Way"
                    ],
                    "4258: Marsden High - Crestmead": [
                        "Chambers Flat Rd at Marsden High School",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Pinnington Park",
                        "Julie St at Wallace Street",
                        "St Francis College"
                    ],
                    "4259: Marsden High - Loganlea": [
                        "Muchow Rd near Moffatt Rd",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd at Clearview Street",
                        "Logan Reserve Rd near Hydrangea St",
                        "Beutel St at Lexham St",
                        "Beutel St at Tygum Road",
                        "Kingston Rd at Waterford West Primary",
                        "Allora St at John St",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd at Haig Street",
                        "Station Rd near Montecarlo Cl",
                        "Station Rd near Jellicoe St"
                    ],
                    "4260: Edens Landing Primary - Loganholme": [
                        "Jamie Nicolson Ave at Edens Landing Primary",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Station Rd near Grace St",
                        "Station Rd near Federation Dr",
                        "Federation Dr near Hayden St",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Copper Dr",
                        "Edinburgh Dr near Fadden Ct",
                        "Edinburgh Rd near Mathews St",
                        "Mathews St near Eastbourne Rd",
                        "Montrose Ave near Eastbourne Rd",
                        "Montrose Ave near Clarendon Ave",
                        "High Rd at Sabre St",
                        "Canterbury College",
                        "Schneider Rd near Albert St",
                        "Allora St at John St",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station",
                        "Loganlea Rd near Ellerslie Rd",
                        "Loganlea Rd near Golf Course Dr",
                        "Slacks Creek park 'n' ride stop A",
                        "Pacific Hwy at Centenary Road",
                        "Pacific Hwy at Alfred Street",
                        "Murrays Road near Mandew St",
                        "Mandew St at Plantain Road",
                        "Mandew St at Mandew Park",
                        "Loganholme, stop G"
                    ],
                    "4261: Loganlea High - Holmview": [
                        "Loganlea High School",
                        "Montrose Ave near Clarendon Ave",
                        "Montrose Ave near Mathews St",
                        "Edinburgh Rd near Mathews St",
                        "Edinburgh Rd near Fadden Ct",
                        "Cobalt Dr near Mercury Dr hail 'n' ride",
                        "Mercury Dr near Opperman Park hail 'n' ride",
                        "Federation Dr near Copper Dr",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Snedden St",
                        "Station Rd near Federation Dr",
                        "Station Rd near Grace St",
                        "King Arthur Bvd near Lynette Ct",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "Ivanhoe Dr near Jessie Cr",
                        "Castile Cr at Overland Dr",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr at Clayton Drive",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Avonmore St",
                        "Avonmore St near Melton Ct",
                        "Avonmore St at Auburn Street",
                        "Grove Rd near Hanby Ct",
                        "Grove Rd near Lima St",
                        "Holmview Rd near Jarvis St",
                        "Holmview Rd near Jeetho St",
                        "Holmview Rd near Logan River Rd"
                    ],
                    "4262: Loganlea High - Browns Plains": [
                        "Loganlea High School",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Monash Rd at Knight Street",
                        "Monash Rd at Jellicoe Street",
                        "Monash Rd near Rellam Rd",
                        "Chambers Flat Rd at Lancaster Park",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Mark Lane",
                        "Waratah Dr at Whiteman Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Ramin Street",
                        "Augusta St at Crestmead Park",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Pinnington Park",
                        "Julie St at Wallace Street",
                        "Julie St at Brabham Park",
                        "Julie St at Bumstead Road",
                        "Bumstead Rd near Clarke Rd",
                        "Green Rd near Venture St",
                        "Green Rd at Blue Wren Place",
                        "Green Rd at Cockatoo Court",
                        "Green Rd near Heritage Bvd",
                        "Green Rd at Isle of Ely Drive",
                        "Green Rd at Solandra Circuit",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Estramina Rd",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 1A"
                    ],
                    "4263: Loganlea High - Waterford West": [
                        "Loganlea High School",
                        "Loganlea station",
                        "Station Rd near Catalina St",
                        "Haig Rd at Omalley Street",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St"
                    ],
                    "4264: Loganlea High - Beenleigh": [
                        "Loganlea High School",
                        "Allora St near Glenda St",
                        "Waterford West Primary",
                        "Allora St at John St",
                        "Kingston Rd at Waterford West Shops",
                        "Waterford State Primary",
                        "Canterbury College",
                        "Montrose Ave near Clarendon Ave",
                        "Montrose Ave near Mathews St",
                        "Edinburgh Rd near Mathews St",
                        "Federation Dr near Copper Dr",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Snedden St",
                        "Station Rd near Federation Dr",
                        "Station Rd near Grace St",
                        "King Arthur Bvd near Lynette Ct",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "Ivanhoe Dr near Jessie Cr",
                        "Castile Cr at Overland Dr",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr at Clayton Drive",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Avonmore St",
                        "Avonmore St near Melton Ct",
                        "Avonmore St at Auburn Street",
                        "Grove Rd near Hanby Ct",
                        "Grove Rd near Lima St",
                        "Holmview Rd near Jarvis St",
                        "Holmview Rd near Jeetho St",
                        "Holmview Rd near Logan River Rd",
                        "Logan River Rd near Alexandra St",
                        "Logan River Rd at Spanns Rd",
                        "Beenleigh station, stop A"
                    ],
                    "4265: Loganlea High - Waterford West": [
                        "Loganlea High School",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Phie Street",
                        "Short St at Allora St",
                        "Allora St near Glenda St",
                        "Waterford West Primary",
                        "Allora St at John St"
                    ],
                    "4270: Beenleigh High - Eagleby": [
                        "Beenleigh State High School",
                        "George St near Macs Lane",
                        "Fryar Rd near Albert St",
                        "Logan St near Boyd St",
                        "Logan St near Lemongrove St",
                        "Oliver St near Greenfield St",
                        "Oliver St near Shirley St",
                        "Temma St near Magra Ct",
                        "Temma St near River Hills Rd",
                        "River Hills Rd near Thornside St",
                        "Eagleby Shopping Plaza",
                        "Fryar Rd near Beetson Ct",
                        "Fryar Rd at Balmoral Street",
                        "Halliday St at Vautin Way",
                        "Herses Rd near Dion Dr",
                        "Herses Rd at Tarlo Street",
                        "Herses Rd near Copperfield Dr",
                        "Copperfield Dr near Paroo Ct",
                        "Copperfield Dr near Burrum Ct",
                        "Bower Rd near Calliope St",
                        "Swallow St near Finch St",
                        "Swallow St near Lyre St",
                        "River Hills Rd near Laing St",
                        "Cowper Ave near Dryandra Dr",
                        "Sirus St near Roebuck Ave"
                    ],
                    "4271: Beenleigh Primary - Eagleby": [
                        "Beenleigh State Primary School",
                        "Kokoda St near Cameron St",
                        "Trinity College and St Josephs Primary",
                        "Kokoda St near York St",
                        "Beenleigh State High School",
                        "Alamein St at Beenleigh High School",
                        "George St near Macs Lane",
                        "Fryar Rd near Albert St",
                        "Logan St near Boyd St",
                        "Logan St near Lemongrove St",
                        "Oliver St near Greenfield St",
                        "Oliver St near Shirley St",
                        "Temma St near Magra Ct",
                        "Temma St near River Hills Rd",
                        "River Hills Rd near Thornside St",
                        "Eagleby Shopping Plaza",
                        "Fryar Rd near Beetson Ct",
                        "Fryar Rd at Balmoral Street",
                        "Halliday St at Vautin Way",
                        "Herses Rd near Dion Dr",
                        "Herses Rd at Tarlo Street",
                        "Herses Rd near Copperfield Dr",
                        "Copperfield Dr near Paroo Ct",
                        "Copperfield Dr near Burrum Ct",
                        "Bower Rd near Calliope St",
                        "Swallow St near Finch St",
                        "Swallow St near Lyre St",
                        "River Hills Rd near Laing St",
                        "Cowper Ave near Dryandra Dr",
                        "Sirus St near Roebuck Ave"
                    ],
                    "4272: Beenleigh High - Eagleby": [
                        "Beenleigh State High School",
                        "George St near Macs Lane",
                        "Fryar Rd near Albert St",
                        "Logan St near Boyd St",
                        "Logan St near Lemongrove St",
                        "Oliver St near Greenfield St",
                        "Oliver St near Shirley St",
                        "Temma St near Magra Ct",
                        "Temma St near River Hills Rd",
                        "River Hills Rd near Thornside St",
                        "Eagleby Shopping Plaza",
                        "Fryar Rd near Beetson Ct",
                        "Fryar Rd at Balmoral Street",
                        "Halliday St at Vautin Way",
                        "Herses Rd near Dion Dr",
                        "Herses Rd at Tarlo Street",
                        "Herses Rd near Copperfield Dr",
                        "Copperfield Dr near Paroo Ct",
                        "Copperfield Dr near Burrum Ct",
                        "Bower Rd near Calliope St",
                        "Swallow St near Finch St",
                        "Swallow St near Lyre St",
                        "River Hills Rd near Laing St",
                        "Cowper Ave near Dryandra Dr",
                        "Sirus St near Roebuck Ave"
                    ],
                    "4273: Beenleigh Primary - Windaroo": [
                        "Beenleigh State Primary School",
                        "Alamein St at Beenleigh High School",
                        "Kokoda St near City Rd",
                        "Trinity College and St Josephs Primary",
                        "Chapman Dr near Hazel Pl hail 'n' ride",
                        "Chapman Dr near Spanns Rd hail 'n' ride",
                        "Harburg Dr near Horizon Dr",
                        "Harburg Drive near Benjul Dr",
                        "Harburg Dr near Carrie Cr",
                        "Tallagandra Rd near Nyah St",
                        "Mount Warren Bvd near Lance Dr",
                        "Mount Warren Bvd near Shields St",
                        "Mount Warren Bvd near Honeyman St",
                        "Rochester Dr near Willshire St",
                        "Rochester Dr near Guyra Cl",
                        "Vermont Cr near Rochester Dr",
                        "Robert Stanley Dr near Doveton Cr",
                        "Robert Stanley Dr near Merrow St",
                        "Mount Warren Bvd near Robert Stanley Dr",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Yvonne Cr",
                        "Windaroo State School",
                        "Carl Heck Bvd near Mewing Ct",
                        "Kaiser Dr near Gustav Way",
                        "Kaiser Dr near Lena Pl",
                        "Kaiser Dr near Schonwerder Dr",
                        "Carl Heck Bvd near Hendrix St",
                        "Carl Heck Bvd near Lennon Dr"
                    ],
                    "4274: Beenleigh High - Bethania": [
                        "Alamein St at Beenleigh High School",
                        "Kokoda St near City Rd",
                        "Trinity College and St Josephs Primary",
                        "Logan River Rd at Crest St",
                        "Logan River Rd near Harburg Dr",
                        "Holmview Rd near Logan River Rd",
                        "Holmview Rd near Logan Rd",
                        "Holmview Rd near Jarvis St",
                        "Grove Rd near Lima St",
                        "Grove Rd near Dendy Ct",
                        "Avonmore St near Auburn St",
                        "Avonmore St near Melton Ct",
                        "Castile Cr near Avonmore St",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Station Rd near Grace St",
                        "Station Rd near Federation Dr",
                        "Federation Dr near Hayden St",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Copper Dr",
                        "Edinburgh Dr near Fadden Ct",
                        "Edinburgh Rd near Mathews St",
                        "Mathews St near Eastbourne Rd",
                        "Montrose Ave near Eastbourne Rd",
                        "Montrose Ave near Clarendon Ave"
                    ],
                    "4275: Beenleigh Station - Eagleby": [
                        "Beenleigh State High School",
                        "Beenleigh station, stop A",
                        "George St near Macs Lane",
                        "Fryar Rd near Albert St",
                        "Logan St near Boyd St",
                        "Logan St near Lemongrove St",
                        "Oliver St near Greenfield St",
                        "Oliver St near Shirley St",
                        "Temma St near Magra Ct",
                        "Temma St near River Hills Rd",
                        "River Hills Rd near Thornside St",
                        "Eagleby Shopping Plaza",
                        "Fryar Rd near Beetson Ct",
                        "Fryar Rd at Balmoral Street",
                        "Halliday St at Vautin Way",
                        "Herses Rd near Dion Dr",
                        "Herses Rd at Tarlo Street",
                        "Herses Rd near Copperfield Dr",
                        "Copperfield Dr near Paroo Ct",
                        "Copperfield Dr near Burrum Ct",
                        "Bower Rd near Calliope St",
                        "Swallow St near Finch St",
                        "Swallow St near Lyre St",
                        "River Hills Rd near Laing St",
                        "Cowper Ave near Dryandra Dr",
                        "Sirus St near Roebuck Ave"
                    ],
                    "4280: Rivermount College - Cornubia": [
                        "Rivermount College",
                        "Carl Heck Bvd near Bannockburn Rd",
                        "Carl Heck Bvd near Hendrix St",
                        "Kaiser Dr near Ernest St",
                        "Kaiser Dr near Lena Pl",
                        "Kaiser Dr near Carl Heck Bvd",
                        "Carl Heck Bvd near Mewing Ct",
                        "Windaroo Primary School",
                        "Mount Warren Bvd near Gaynor Ct",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Shea Ct",
                        "Mount Warren Bvd near Ben Lexcen Ct",
                        "Mount Warren Bvd at Shields St",
                        "Mount Warren Bvd near Lance Dr",
                        "Beenleigh station, stop A",
                        "Alamein St at Beenleigh High School",
                        "Alamein St near Lae St",
                        "Alamein St near Juniper Ct",
                        "River Hills Rd near Eagle Dr",
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Drews Rd near Barokee Dr",
                        "Jalan St near Murrami Ct",
                        "Pintu Dr near Tanah Merah Ave",
                        "Loganholme, stop H",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Plantain Rd",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd at Torres Street"
                    ],
                    "4281: Windaroo Valley High - Springwood": [
                        "Windaroo Valley High",
                        "Windaroo Primary School",
                        "Windaroo State School",
                        "Mount Warren Bvd near Gaynor Ct",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Shea Ct",
                        "Robert Stanley Dr near Merrow St",
                        "Robert Stanley Dr near Doveton Cr",
                        "Vermont Cr near Rochester Dr",
                        "Main St near Lubach St",
                        "Main St near Church St",
                        "Beenleigh station, stop A",
                        "Alamein St at Beenleigh High School",
                        "Trinity College and St Josephs Primary",
                        "Clarks Rd at Corndale Street",
                        "Clarks Rd near Dewar Dr",
                        "Drews Rd near Hampton St",
                        "Drews Rd near Wandilla Cr",
                        "Drews Rd near Boeing St",
                        "Drews Rd near Piari St Closed until 30 June 2026",
                        "Drews Rd near Barokee Dr",
                        "Jalan St near Murrami Ct",
                        "Pintu Dr near Tanah Merah Ave",
                        "Loganholme, stop C",
                        "Mandew St at Hyperdome",
                        "Plantain Rd at Mandew Street",
                        "Roselea St at Cooba Court",
                        "Roselea St at Hailar Street",
                        "Roselea St at Roselea Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Chatswood Rd at John Paul College",
                        "Chatswood Rd near Evenwood St",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at Brentwood Drive",
                        "Chatswood Rd at Old Chatswood Road",
                        "Chatswood Rd at Hawkins Street",
                        "Barbaralla Dr at Burgallby Road",
                        "Barbaralla Dr at Barbaralla Park",
                        "Barbaralla Dr at Tallowood Park",
                        "Wenlock Cr at Wyclif Avenue",
                        "Rochedale Rd at Springwood Plaza",
                        "Springwood station, platform 1"
                    ],
                    "4282: Windaroo Valley High - Crestmead": [
                        "Windaroo Valley High",
                        "Beenleigh State Primary School",
                        "Oval St near Catherine St",
                        "Tweedvale St at Meadow Crescent",
                        "Tweedvale St near Lehmans Rd",
                        "Sunrise St near Sunnyview St",
                        "Sunrise St near Sunland St",
                        "Logan River Rd near Harburg Dr",
                        "Holmview Rd near Logan River Rd",
                        "Holmview Rd near Logan Rd",
                        "Holmview Rd near Jarvis St",
                        "Grove Rd near Lima St",
                        "Grove Rd near Dendy Ct",
                        "Avonmore St near Auburn St",
                        "Avonmore St near Melton Ct",
                        "Castile Cr near Avonmore St",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Glasson Dr at High Rd",
                        "High Rd at Sabre St",
                        "Canterbury College",
                        "Schneider Rd near Albert St",
                        "Kingston Rd at Waterford West Primary",
                        "Beutel St at Tygum Road",
                        "Beutel St at Lexham St",
                        "Logan Reserve Rd near Hydrangea St",
                        "Muchow Rd near Clearview St",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd near Moffatt Rd",
                        "Chambers Flat Rd at Marsden High School",
                        "Chambers Flat Rd at Oakwood Drive",
                        "Waratah Dr at Whiteman Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Ramin Street",
                        "Augusta St at Crestmead Park",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Pinnington Park",
                        "Julie St at Wallace Street",
                        "Julie St at Brabham Park",
                        "Julie St at Bumstead Road",
                        "Bumstead Rd near Julie St hail 'n' ride",
                        "Bumstead Rd near Pidgeon Bvd hail 'n' ride",
                        "Bumstead Rd at Wisdom Way",
                        "Bumstead Rd near Judith St hail 'n' ride",
                        "Bumstead Rd near Gow Crt hail 'n' ride",
                        "Chambers Flat Rd at Marsden Works Depot"
                    ],
                    "4283: Windaroo Valley High - Bethania": [
                        "Windaroo Valley High",
                        "Windaroo Primary School",
                        "Windaroo State School",
                        "Mount Warren Bvd near Gaynor Ct",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Shea Ct",
                        "Mt Warren Park Primary School",
                        "Mount Warren Bvd near Ben Lexcen Ct",
                        "Mount Warren Bvd at Shields St",
                        "Mount Warren Bvd near Lance Dr",
                        "Tallagandra Rd near Nyah St",
                        "Harburg Dr near Rogers Ave",
                        "Harburg Dr near Benjul Dr",
                        "Harburg Dr near Horizon Dr",
                        "Castile Cr near Avonmore St",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Station Rd near Grace St",
                        "Station Rd near Federation Dr",
                        "Federation Dr near Hayden St",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Copper Dr",
                        "Cobalt Dr near Mercury Dr hail 'n' ride",
                        "Mercury Dr near Opperman Park hail 'n' ride",
                        "Edinburgh Dr near Fadden Ct",
                        "Edinburgh Rd near Mathews St",
                        "Mathews St near Eastbourne Rd",
                        "Montrose Ave near Eastbourne Rd",
                        "Montrose Ave near Clarendon Ave"
                    ],
                    "4284: Windaroo Valley High - Marsden": [
                        "Windaroo Valley High",
                        "Windaroo Primary School",
                        "Windaroo State School",
                        "Mount Warren Bvd near Gaynor Ct",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Shea Ct",
                        "Mt Warren Park Primary School",
                        "Mount Warren Bvd near Ben Lexcen Ct",
                        "Mount Warren Bvd at Shields St",
                        "Mount Warren Bvd near Lance Dr",
                        "Beenleigh Primary School",
                        "Alamein St at Beenleigh High School",
                        "Kokoda St near City Rd",
                        "Trinity College and St Josephs Primary",
                        "Chapman Dr near Hazel Pl hail 'n' ride",
                        "Chapman Dr near Spanns Rd hail 'n' ride",
                        "Logan River Rd near Harburg Dr",
                        "Holmview Rd near Logan River Rd",
                        "Holmview Rd near Logan Rd",
                        "Holmview Rd near Jarvis St",
                        "Grove Rd near Lima St",
                        "Grove Rd near Dendy Ct",
                        "Avonmore St near Auburn St",
                        "Avonmore St near Melton Ct",
                        "Castile Cr near Avonmore St",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Station Rd near Grace St",
                        "Station Rd near Federation Dr",
                        "Federation Dr near Hayden St",
                        "Federation Dr near Turquoise St",
                        "Federation Dr near Copper Dr",
                        "Cobalt Dr near Mercury Dr hail 'n' ride",
                        "Mercury Dr near Opperman Park hail 'n' ride",
                        "Edinburgh Dr near Fadden Ct",
                        "Edinburgh Rd near Mathews St",
                        "Mathews St near Eastbourne Rd",
                        "Montrose Ave near Eastbourne Rd",
                        "Montrose Ave near Clarendon Ave",
                        "Kingston Rd at Waterford West Shops",
                        "Kingston Rd at Waterford West Primary",
                        "Beutel St at Tygum Road",
                        "Beutel St at Lexham St",
                        "Logan Reserve Rd near Hydrangea St",
                        "Muchow Rd near Clearview St",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd near Moffatt Rd",
                        "Chambers Flat Rd at Mark Lane",
                        "Chambers Flat Rd at Marsden Park"
                    ],
                    "4285: Windaroo Valley High - Underwood": [
                        "Windaroo Valley High",
                        "Windaroo Primary School",
                        "Windaroo State School",
                        "Mount Warren Bvd near Gaynor Ct",
                        "Mount Warren Bvd near Magenta Ct",
                        "Mount Warren Bvd near Shea Ct",
                        "Mt Warren Park Primary School",
                        "Mount Warren Bvd near Ben Lexcen Ct",
                        "Mount Warren Bvd at Shields St",
                        "Mount Warren Bvd near Lance Dr",
                        "Fryar Rd near Albert St",
                        "Logan St near Boyd St",
                        "Logan St near Lemongrove St",
                        "Oliver St near Greenfield St",
                        "Oliver St near Shirley St",
                        "Temma St near Magra Ct",
                        "Temma St near River Hills Rd",
                        "River Hills Rd near Thornside St",
                        "Eagleby Shopping Plaza",
                        "Fryar Rd near Beetson Ct",
                        "Fryar Rd at Balmoral Street",
                        "Halliday St at Vautin Way",
                        "Herses Rd near Dion Dr",
                        "Herses Rd at Tarlo Street",
                        "Herses Rd near Copperfield Dr",
                        "Copperfield Dr near Paroo Ct",
                        "Copperfield Dr near Burrum Ct",
                        "Bower Rd near Calliope St",
                        "Swallow St near Finch St",
                        "Swallow St near Lyre St",
                        "River Hills Rd near Laing St",
                        "Cowper Ave near Dryandra Dr",
                        "Sirus St near Roebuck Ave",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Plantain Rd near Jasmine Cr",
                        "Plantain Rd near Lissadell St",
                        "Plantain Rd at Narcamus Crescent",
                        "Plantain Rd at Blackthorn Crescent",
                        "Shailer Rd near Oregon Dr",
                        "Shailer Rd near Hester St",
                        "Shailer Rd near Francis Rd",
                        "Daisy Hill Rd at Daisy Hill Primary School",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Daisy Hill Rd at Highview Terrace",
                        "Springwood Rd at Kinloch Road",
                        "Springwood Rd at Trevallyan Drive",
                        "Springwood Rd at Springwood Reservoir",
                        "Springwood Rd at Karawatha Street",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Flinders View",
                        "Springwood Rd at Dennis Road",
                        "Springwood Rd at Springwood High School",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Parfrey Rd near Dorset Dr",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Parkwood St",
                        "Stellaris Way near Atra Ct",
                        "Underwood Rd near Belmore Dr",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Cilla Ct",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Koobil St",
                        "Underwood Rd near Somerset St",
                        "Underwood Rd near Dalhouse Ct",
                        "Underwood Rd near Gerrans St",
                        "Underwood Rd near Centre Pl",
                        "Logan Rd at Underwood Villas",
                        "Logan Rd at Harris Road",
                        "Logan Rd at Celia Street",
                        "Kingston Rd at Curban Street"
                    ],
                    "4286: Windaroo Valley High - Loganlea": [
                        "Windaroo Valley High",
                        "Castile Cr near Avonmore St",
                        "Castile Cr at Edens Parkland",
                        "Castile Cr near Pendlebury Ct",
                        "Castile Cr near Delanty Ct",
                        "Castile Cr near Black Diamond Cr",
                        "Castile Cr near Ivanhoe Dr",
                        "Ivanhoe Dr near Jessie Cr",
                        "Ivanhoe Dr near King Arthur Bvd",
                        "King Arthur Bvd near Guinevere Ct",
                        "Allora St at John St",
                        "Allora St near Glenda St",
                        "Short St at Allora Street",
                        "Haig Rd at Phie Street",
                        "Haig Rd at Crestview Street",
                        "Haig Rd at Webb Road",
                        "Haig Rd at Sarah Street",
                        "Haig Rd at Omalley Street",
                        "Station Rd near Catalina St",
                        "Loganlea station"
                    ],
                    "4287: Windaroo Valley High - Bannockburn": [
                        "Windaroo Valley High",
                        "Carl Heck Bvd near Mewing Ct",
                        "Kaiser Dr near Gustav Way",
                        "Kaiser Dr near Lena Pl",
                        "Kaiser Dr near Schonwerder Dr",
                        "Carl Heck Bvd near Hendrix St",
                        "Carl Heck Bvd near Lennon Dr",
                        "Beaudesert Beenleigh Rd near Bannockburn Rd HnR",
                        "Emerson Rd near Maud St hail 'n' ride",
                        "Elise St near Bannockburn Rd hail 'n' ride"
                    ],
                    "5001: St Anthonys, Cleveland": [
                        "Point O'Halloran Rd near Orana St",
                        "Orana Esp near Bayswater Dr",
                        "Point O'Halloran Rd near Tipplers St",
                        "Point O'Halloran Rd near Cooba St",
                        "Colburn Ave at Point O'Halloran Road",
                        "Colburn Ave near Link Rd",
                        "Bunker Rd at High St, stop C",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Ziegenfusz Rd near Tuna Ct",
                        "Carmel Catholic College",
                        "Ziegenfusz Rd near Doull Pl",
                        "Cleveland Redland Bay Rd at Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near Melanie St",
                        "Cleveland Redland Bay Rd near South St",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Long St",
                        "Long St at Topatig Street",
                        "Smith St near Long St",
                        "Smith St at Cleveland Showground",
                        "Smith St at Cleveland District High School",
                        "Queen St near Haggup St",
                        "Cleveland station",
                        "Windemere Rd at Alexandra Hills High School",
                        "Finucane Rd at Keith Surridge Park",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Finucane Rd at Vienna Road",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Dawson Road",
                        "Delancey St near Russell St",
                        "Wellington St near Queen St",
                        "Shore St at RACQ",
                        "Shore St at Black Swamp Wetlands",
                        "Shore St West at Fitzroy Street",
                        "Shore St at Passage Street",
                        "Sommersea Dr near Genoa Ct hail 'n' ride",
                        "Little Shore St near Paxton St",
                        "Shore St near Paxton St",
                        "Shore St near Cross St",
                        "Passage St near Queen St",
                        "Passage St near Russell St",
                        "Passage St near Jacaranda Ct",
                        "Princess St near Blake St",
                        "Fitzroy St near Princess St",
                        "Bloomfield St near South St",
                        "Panorama Dr near Laurette Ave",
                        "Panorama Dr at Robert Mackie Park",
                        "Panorama Dr at Abbotsleigh Street",
                        "Panorama Dr at Manhattan Avenue",
                        "Moselle Dr near Cabernet Cr",
                        "Moselle Dr near Chateau St",
                        "Moselle Dr near Ziegenfusz Rd",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Panorama Dr near Milner Pl",
                        "Panorama Dr near Boundary Road",
                        "Boundary Rd at Panorama Drive",
                        "Boundary Rd at Springacre Road",
                        "Boundary Rd at Venn Parade",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Meadowland Road",
                        "Boundary Rd at Abeya Street",
                        "Colburn Ave near School Rd",
                        "Colburn Ave near Point O'Halloran Rd",
                        "Point O'Halloran Rd near Albert St",
                        "Orana Esp near Kianca Ct",
                        "Point O'Halloran Rd near Cheshire St",
                        "Wilson St near Colburn Ave",
                        "Colburn Av at White Street",
                        "Victoria Point Jetty",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at Thompson Street",
                        "Link Rd at Fryar Street",
                        "Link Rd at Salford Waters Retirement Estate",
                        "Benfer Rd at Bangalow Street",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Poinciana Avenue",
                        "Benfer Rd near Prescoter Dr",
                        "Benfer Rd at Cleveland Redland Bay Road"
                    ],
                    "5005: Anglican Snr & Jnr, Loretto, Capalaba": [
                        "Oaklands Pde at Anglican Church Grammar School",
                        "Oaklands Pde at Churchie Junior School",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at Coorparoo Shops, stop 26s",
                        "Cavendish Rd at Shire Street, stop 27/28",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd near Kanumbra St",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd near Pelham St",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Cambridge Street, stop 44",
                        "Winstanley St near Birdwood Rd, stop 45",
                        "Winstanley St at Willard Street, stop 46",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Carindale Shopping Centre station, platform J",
                        "Winstanley St near Hedlow Ct",
                        "Winstanley St near Talavera St",
                        "Scrub Rd at Winstanley East",
                        "Belmont State School",
                        "Old Cleveland Rd near Adley St",
                        "Old Cleveland Rd at Barbeque St",
                        "Old Cleveland Rd near Stanbrough Rd",
                        "Bacton Rd near Warriewood St",
                        "Old Cleveland Rd near Archer St",
                        "Old Cleveland Rd near New Cleveland Rd",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "5006: Anglican Snr & Jnr, Carindale, Capalaba": [
                        "Oaklands Pde at Anglican Church Grammar School",
                        "Oaklands Pde at Churchie Junior School",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at Coorparoo Shops, stop 26s",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Burke Street Stop 25",
                        "Old Cleveland Rd at Kismet Street Stop 26",
                        "Old Cleveland Rd at Madeline Street Stop 27",
                        "Old Cleveland Rd at Dorothy Lane Stop 28",
                        "Old Cleveland Rd at Pampling Street Stop 29",
                        "Old Cleveland Rd at Camp Hill",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Cambridge Street, stop 44",
                        "Winstanley St near Birdwood Rd, stop 45",
                        "Winstanley St at Willard Street, stop 46",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Carindale Shopping Centre station, platform J",
                        "Winstanley St near Firmiston St",
                        "Winstanley St near Hedlow Ct",
                        "Winstanley St near Talavera St",
                        "Scrub Rd at Winstanley East",
                        "Belmont State School",
                        "Old Cleveland Rd near Adley St",
                        "Grassdale Rd near Belmont Rd",
                        "Grassdale Rd at Stanbrough Rd",
                        "Stanbrough Rd near Grassdale Rd",
                        "Stanbrough Rd near Formosa St",
                        "New Cleveland Rd at Eastside Village",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "London Rd near New Cleveland Rd",
                        "New Cleveland Rd near Old Cleveland Rd",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "5007: Kimberley, Carbrook, Vic Point": [
                        "Kimberley College",
                        "Beenleigh Redland Bay Rd at Carbrook Primary",
                        "Carbrook Rd near West Mount Cotton Rd",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd near Plantain Rd",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Belbora Rd",
                        "Loganholme, stop E",
                        "Bryants Rd at Torres Street",
                        "Mount Cotton Rd near Gramzow Rd",
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Valley Way at Seeana Dr",
                        "Valley Way near Taffeta Dr",
                        "German Church Rd near Days Rd",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd at Salford Waters Retirement Estate",
                        "Link Rd at Fryar Street",
                        "Colburn Ave near Daysland St",
                        "Point O'Halloran Rd near Colburn Ave",
                        "Point O'Halloran Rd near Cooba St",
                        "Point O'Halloran Rd near Orana St",
                        "Orana Esp near Bayswater Dr",
                        "Point O'Halloran Rd near Tipplers St",
                        "Cheshire St near Point O'Halloran Rd",
                        "Nottingham Dr near Regency St",
                        "School Rd near Parklane Rd",
                        "School Rd near Aspect Dr",
                        "Colburn Ave near Link Rd",
                        "Bunker Rd at High St, stop C"
                    ],
                    "5009: Chisholm, Kimberley, Victoria Point": [
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Government Rd at Queen St",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Fielding Rd",
                        "Collins St near School of Arts Rd",
                        "Collins St at Torquay Road",
                        "Torquay Rd near Torbay St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "McWilliam St at Phillip Street",
                        "Phillip St near Wilkie St",
                        "Serpentine Creek Rd at Christopher St",
                        "Shanahan St near Michael St hail 'n' ride",
                        "Rusbrook St near Oakland Ave hail 'n' ride",
                        "Oakland Ave near Serpentine Creek Rd hail 'n' ride",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Serpentine Creek Rd near Kidd St hail 'n' ride",
                        "Serpentine Creek Rd near Scenic Rd hail 'n' ride",
                        "Shoreline Ave at Jingeri St",
                        "Shoreline Ave at Hydrangea Ave",
                        "Scenic Rd near Orchard Rd hail 'n' ride",
                        "Vine St near Alisa St hail 'n' ride",
                        "Orchard St near Scenic Rd hail 'n' ride",
                        "Lagoon View Rd near Serpentine Creek Rd HnR",
                        "Rocky Passage turnaround bay hail 'n' ride",
                        "Beenleigh Redland Bay Rd at Aquatic Gardens HnR",
                        "Beenleigh Redland Bay Rd at Carbrook Golf Course",
                        "Beenleigh Redland Bay Rd near Stern St HnR",
                        "Calvary Christian College",
                        "Kimberley College",
                        "Beenleigh Redland Bay Rd at Carbrook Primary",
                        "Beenleigh Redland Bay Rd near California Creek Rd",
                        "Chisholm Catholic College",
                        "California Creek Rd Mapping stop",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd at California Creek Road",
                        "Beenleigh Redland Bay Rd near Melaleuca Rd HnR",
                        "Beenleigh Redland Bay Rd near Ferry Rd HnR",
                        "Beenleigh Redland Bay opp Aquatic Gardens HnR",
                        "Beenleigh Redland Bay Rd near Riedel Rd HnR",
                        "Orchard Rd near Scenic Rd hail 'n' ride",
                        "Oakland Ave near Shanahan St hail 'n' ride",
                        "Serpentine Creek Rd near Christopher St",
                        "McWilliam St at Phillip St",
                        "Collins St at Donald Road",
                        "Queen St near School of Arts Rd",
                        "Redlands Satellite Health Centre",
                        "Redland Bay Marina, platform 2",
                        "Hamilton St at Pitt Street",
                        "Hamilton St near Broadwater Tce hail 'n' ride",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street"
                    ],
                    "5010: Kimberley College, Redland Bay": [
                        "Kimberley College",
                        "Kruger Rd at Carbrook Primary",
                        "Beenleigh Redland Bay Rd near Stern St HnR",
                        "Beenleigh Redland Bay Rd near Melaleuca Rd HnR",
                        "Beenleigh Redland Bay Rd near Ferry Rd HnR",
                        "Beenleigh Redland Bay opp Aquatic Gardens HnR",
                        "Beenleigh Redland Bay Rd near Riedel Rd HnR",
                        "Serpentine Creek Rd near Scenic Rd hail 'n' ride",
                        "Serpentine Creek Rd near Kidd St hail 'n' ride",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Serpentine Creek Rd near Christopher St",
                        "Serpentine Creek Rd near Phillip St hail 'n' ride",
                        "Collins St at Donald Road",
                        "Collins St near School of Arts Rd",
                        "School of Arts Rd near Fielding Rd",
                        "Queen St near School of Arts Rd",
                        "Queen St at Keirnan Street",
                        "Government Rd at Queen St",
                        "Redlands Satellite Health Centre",
                        "Redland Bay Marina, platform 2",
                        "Hamilton St at Pitt Street",
                        "Hamilton St near Broadwater Tce hail 'n' ride",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground"
                    ],
                    "5011: Kimberley, Carbook, Hyperdome": [
                        "Kimberley College",
                        "Kruger Rd at Carbrook Primary",
                        "Beenleigh Redland Bay Rd at Carbrook Primary",
                        "Logandale Bvd near Beenleigh Redland Bay Rd",
                        "Beenleigh Redland Bay Rd near California Creek Rd",
                        "Beenleigh Redland Bay Rd near Montessa St",
                        "Bryants Rd at Anakie Drive",
                        "Bryants Rd near Torres St",
                        "Cornubia Park Sports Centre",
                        "Bryants Rd near Plantain Rd",
                        "Bryants Rd near Oliver St",
                        "Bryants Rd near Belbora Rd",
                        "Loganholme station arrival stop 1"
                    ],
                    "5012: Kimberley College, Carbrook, Mt Cotton": [
                        "Mount Cotton Rd near Mt Cotton Primary School",
                        "Kimberley College",
                        "Beenleigh Redland Bay Rd at Carbrook Primary",
                        "Beenleigh Redland Bay Rd near California Creek Rd",
                        "California Creek Rd near Kilkenny St",
                        "Wuduru Rd near Woodhaven Pl",
                        "Mount Cotton Rd near Gramzow Rd",
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Valley Way near Hardwood Dr hail 'n' ride",
                        "Carissa St near Begonia Cr",
                        "Durian St near Carissa St hail 'n' ride",
                        "Orchid Dr near Flindersia Dr",
                        "Orchid Dr at Durian Street",
                        "Papaya St near Carissa St",
                        "Hardwood Dr near Seeana Dr hail 'n' ride",
                        "Hardwood Dr near Hoop Pine St hail 'n' ride",
                        "Hardwood Dr near German Church Rd hail 'n' ride",
                        "Valley Way at Seeana Dr",
                        "Seeana Dr near Pimelea Cr hail 'n' ride",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Village Dr near Valley Way hail 'n' ride",
                        "Valley Way near Taffeta Dr",
                        "Valley Way near German Church Rd hail 'n' ride",
                        "Bouquet Rd near Balthazar Cct hail 'n' ride",
                        "Heinemann Rd near Valley Way hail 'n' ride"
                    ],
                    "5013: Maridale Park, Gumdale, Cannon Hill Ang": [
                        "Capalaba bus station, stop E",
                        "Old Cleveland Rd near Tinchborne St",
                        "New Cleveland Rd near Old Cleveland Rd",
                        "London Rd near New Cleveland Rd",
                        "Archer Street near Boston Rd hail 'n' ride",
                        "Boston Rd near Tilley Rd",
                        "Tilley Rd at London Road",
                        "Tilley Rd at Gumdale Primary School",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Green Camp Rd",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "Ermelo Rd near New Cleveland Rd",
                        "Stanbrough Rd near New Cleveland Rd",
                        "New Cleveland Rd near Dairy Swamp Rd",
                        "New Cleveland Rd near Munda St",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Leon, stop 43",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Junction Rd at Colmslie, stop 53",
                        "Junction Rd at Algoori Street, stop 54",
                        "Junction Rd at Beelarong Street, stop 55",
                        "Cannon Hill Anglican College"
                    ],
                    "5014: Capalaba, Manly, Cannon Hill Anglican": [
                        "Cannon Hill Anglican College",
                        "Grenade St near Barrack Rd, stop 59",
                        "Southgate Ave near Wynnum Rd",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd near Thornlake Ct",
                        "Manly Rd at Leon, stop 43",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Wondall Rd near Manly Rd",
                        "Wondall Rd opp Moreton Bay College",
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd at Kianawah Road South",
                        "Randall Rd at Network Drive, stop 60",
                        "Randall Rd at Stockyard Street, stop 59a",
                        "Randall Rd at Natasha Street, stop 59",
                        "Randall Rd near Wynnum Rd",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Andrew St near Ronald St Stop 100",
                        "Pine St near Akonna St",
                        "Stratton Tce near Wolsey Pde",
                        "Gordon Pde near Stratton Tce",
                        "Gordon Pde near Oakley St",
                        "Gordon Pde near New Rd",
                        "Manly Rd at Preston Rd",
                        "Manly Rd at Whites Road",
                        "Manly Rd at Daisy Road Stop 68",
                        "Manly Rd at Manly West near Delsia St",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Silky Oaks",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Barramundi, stop 62",
                        "Manly Rd at Amberjack Stop 61/56",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Basella St near Caladium St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "New Cleveland Rd at Eastside Village",
                        "Tilley Rd at New Cleveland Road",
                        "Tilley Rd near Grassdale Rd",
                        "Tilley Rd near London Rd",
                        "Old Cleveland Rd near Archer St",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "5015: Gumdale, Cannon Hill": [
                        "Cannon Hill Anglican College",
                        "Whitworth Rd near Grenade Street Stop 57",
                        "Junction Rd at Colmslie, stop 53",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd near Thornlake Ct",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Manly Rd at Villanova Park, stop 45",
                        "New Cleveland Rd near Dairy Swamp Rd",
                        "Stanbrough Rd near New Cleveland Rd",
                        "New Cleveland Rd at Eastside Village",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Green Camp Rd",
                        "Green Camp Rd near New Cleveland Rd",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Rickertt Rd near Green Camp Rd",
                        "Rickertt Rd at Tingalpa Creek",
                        "Quarry Rd near Rosewood St",
                        "Birkdale Rd at Collingwood Road",
                        "Birkdale Rd at Creek Road",
                        "Old Cleveland Rd East at Birkdale South SS",
                        "Old Cleveland Rd near Currawong Dr",
                        "Old Cleveland Rd East at Randall Rd",
                        "Old Cleveland Rd near Main Rd",
                        "Allenby Rd near Montgomery Dr",
                        "Allenby Rd near Balmoral St",
                        "Allenby Rd at Monarch St",
                        "Allenby Rd near Topaz St",
                        "Allenby Rd near Finucane Rd",
                        "Vienna Rd near Cambridge Dr",
                        "Vienna Rd near Winchester Rd",
                        "Vienna Rd near Canterbury St",
                        "Vienna Rd at Alexandra Circuit",
                        "Vienna Rd near Wimborne Rd",
                        "Vienna Rd at Burwood Road",
                        "Lyndon Rd near Korawal St"
                    ],
                    "5025: Capalaba, Cleveland, Vic Pt": [
                        "Windemere Rd at Alexandra Hills High School",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Finucane Rd at Vienna Road",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Dawson Road",
                        "Finucane Rd at Redland Research Station",
                        "Shore St at Grant Street",
                        "Shore St at RACQ",
                        "Shore St at Black Swamp Wetlands",
                        "Cleveland station",
                        "Middle Street, stop B",
                        "Bloomfield St near Russell St",
                        "Bloomfield St at Donald Simpson Park",
                        "Bloomfield St at Princess Street",
                        "Bloomfield St at Long Street",
                        "Bloomfield St near Long St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near South St",
                        "Cleveland Redland Bay Rd near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay Rd near Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Victoria Point Central, platform 2"
                    ],
                    "5031: Gumdale, Carmel College": [
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "New Cleveland Rd at Eastside Village",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Archer St",
                        "New Cleveland Rd near Green Camp Rd",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Rickertt Rd near Green Camp Rd",
                        "Rickertt Rd at Tingalpa Creek",
                        "Ferry Rd near Thorneside Rd",
                        "Thorneside station",
                        "Thorneside Rd near Bayside Ct",
                        "Thorneside Rd at Fisher Rd",
                        "Thorneside Rd at Leon St",
                        "Thorneside Rd near jean St",
                        "Jean St near Mooroondu Rd",
                        "Mooroondu Rd near Nora St",
                        "Mooroondu Rd near Saul St",
                        "Mooroondu Rd at Ethel St",
                        "Mooroondu Rd near Marlin St",
                        "Mary St at Birkdale Primary School",
                        "Birkdale Rd at Birkdale Primary School",
                        "Birkdale Rd at Birkdale Fair",
                        "Birkdale Rd at Edwardson Court",
                        "Birkdale Rd at Wellington Manor Village",
                        "Birkdale Rd at Wellington Point High School",
                        "Redlands College",
                        "Birkdale Rd at EGW Wood Sportsfield",
                        "Birkdale Rd at Wellington Point Shops",
                        "Main Rd at Apsley Street",
                        "Main Rd near Courtice St",
                        "Main Rd near Station St",
                        "Main Rd at Whepstead Manor",
                        "Main Rd near Wellington Point Farmhouse hail 'n' ride",
                        "Allenby Rd near Montgomery Dr",
                        "McDonald Rd near Montgomery Dr",
                        "McDonald Rd at MacDonald Road Park",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Dawson Road",
                        "Finucane Rd at Redland Research Station",
                        "Delancey St near Freeth St",
                        "Delancey St near Sturgeon St",
                        "Ormiston station - Wellington St",
                        "Wellington St near Queen St",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Smith St near Long St",
                        "Smith St near Bay St",
                        "Bay St near Olympus Dr",
                        "Wellington St near South St",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Bayview State School",
                        "Carmel Catholic College"
                    ],
                    "5032: Capalaba, Maridale Park, Carmel": [
                        "Redland Bay Rd at Windemere Rd",
                        "Redland Bay Rd at Greater Glider C.A",
                        "Redland Bay Rd",
                        "Lyndon Rd near Redland Bay Rd",
                        "Lyndon Rd near Korawal St",
                        "Korawal St near Timbarra Ct",
                        "Montana Dr at Ivana Ct",
                        "Spirit Dr at Sunburst Ct",
                        "Barber Dr near Difford St",
                        "Callaghan Way near Brosnan Dr",
                        "Callaghan Way at Greenup St",
                        "Ney Rd at Callaghan Way",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Coolnwynpin Primary School",
                        "Ney Rd near Coolnwynpin Way",
                        "Degen Rd near Ney St",
                        "Degen Rd near St Lukes Ct",
                        "Mount Cotton Road near Broadwater Rd",
                        "Mount Cotton Rd at Ney Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Rd at Henderson Road",
                        "Duncan Rd at Duncan Road Sports Fields",
                        "Boundary Rd at Taylor Rd",
                        "Kinross Rd near East Ridge St hail 'n' ride",
                        "Kinross Rd near Kingsdale Ave hail 'n' ride",
                        "Boundary Rd at Kinross Road",
                        "Panorama Drive near Boundary Rd",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Bayview State School",
                        "Carmel Catholic College",
                        "Panorama Dr near Milner Pl",
                        "Panorama Dr near Boundary Road",
                        "Boundary Rd at Woodlands Drive",
                        "Parkwood Dr near Timbertop Ct",
                        "Parkwood Dr near Mahogany St",
                        "Mahogany St near Lyndon Rd",
                        "Lyndon Rd near Mahogany St",
                        "Lyndon Rd near Duncan Rd",
                        "Mount Cotton Rd near Ney Rd",
                        "Degen Rd at St Lukes Catholic Primary School",
                        "Ney Rd at Capalaba Sports Club",
                        "Macquarie St near Ney Rd",
                        "Macquarie St near Jacaranda Rd",
                        "Mount Cotton Rd near Jacaranda Rd",
                        "Wentworth Dr near Blaxland St",
                        "Wentworth Dr near Cunningham St",
                        "Wentworth Dr near Bute St",
                        "Macquarie St at Mitchell Street",
                        "Callaghan Way near Greenup St",
                        "Callaghan Way at Brosnan Drive",
                        "Callaghan Way near Frost St",
                        "Gundagai Dr near Nova Ct hail 'n' ride",
                        "Brosnan Dr near Callaghan Way",
                        "Ney Rd at Jeffrey Street",
                        "Redland Bay Rd at Andrew Street",
                        "Redland Bay Rd at Merritt Street",
                        "Redland Bay Rd at Smith Street",
                        "Capalaba bus station arrival stop 1"
                    ],
                    "5033: Carmel, Cleveland, Ormiston, Carindale": [
                        "Bayview State School",
                        "Carmel Catholic College",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Wellington St near Panorama Dr",
                        "Wellington St near Enterprise St",
                        "Wellington St near Coburg St West",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Smith St near Long St",
                        "Long St at Topatig Street",
                        "Long St near Fitzroy St hail 'n' ride",
                        "Cleveland State School",
                        "Cleveland station",
                        "Shore St at Black Swamp Wetlands",
                        "Gordon St near Cowley St",
                        "Gordon St at Ormiston Primary School",
                        "Sturgeon St near Wellington St",
                        "Wellington St near Counihan St",
                        "Wellington St at Clearwater St",
                        "Rose St near Hilliard St",
                        "Rose St near McCartney St",
                        "McCartney St near Wellington St",
                        "Wellington St near Oak St",
                        "Wellington St at Counihan St",
                        "Sturgeon St near Delancey St",
                        "Delancey St near Sturgeon St",
                        "Delancey St near Freeth St",
                        "Finucane Rd at Redland Research Station",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Vienna Road",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Finucane Rd at Alexandra Hills High School",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Elmhurst St near Sutphin St",
                        "Elmhurst St near Crotona Rd",
                        "Crotona Rd at Randwick St",
                        "Crotona Rd near Draycott St",
                        "Crotona Rd near Wicks Ct",
                        "Crotona Rd at Windemere Road",
                        "Windemere Rd at Sophia Place",
                        "Windemere Rd near Brompton St",
                        "Windemere Rd at Stovold Pl",
                        "Redland Bay Rd at Ney Road",
                        "Redland Bay Rd at Andrew Street",
                        "Redland Bay Rd at Merritt Street",
                        "Redland Bay Rd at Smith Street",
                        "Capalaba bus station arrival stop 1"
                    ],
                    "5034: Carmel, Ormiston & Redlands Colleges": [
                        "Thorneside station",
                        "Thorneside Rd near Bayside Ct",
                        "Thorneside Rd at Fisher Rd",
                        "Thorneside Rd at Leon St",
                        "Thorneside Rd near jean St",
                        "Jean St near Mooroondu Rd",
                        "Mooroondu Rd near Nora St",
                        "Mooroondu Rd near Saul St",
                        "Mooroondu Rd at Ethel St",
                        "Mooroondu Rd near Marlin St",
                        "Thorne Rd near Mary St",
                        "Agnes St near Thorne Rd",
                        "Birkdale Rd at Collingwood Road",
                        "Collingwood Rd at Redlands Mobile Village",
                        "Prins Willem Alexander Village",
                        "Collingwood Dr at Serendipity Close",
                        "Hardy Rd near Collingwood Rd",
                        "Wellington Point State High School",
                        "Birkdale Rd at EGW Wood Sportsfield",
                        "Birkdale Rd at Wellington Point Shops",
                        "Main Rd at Apsley Street",
                        "Main Rd near Courtice St",
                        "Main Rd near Station St",
                        "Main Rd at Whepstead Manor",
                        "Main Rd near Wellington Point Farmhouse hail 'n' ride",
                        "Allenby Rd near Montgomery Dr",
                        "Allenby Rd near Balmoral St",
                        "Allenby Rd at Monarch St",
                        "Allenby Rd near Topaz St",
                        "Allenby Rd near Finucane Rd",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Dawson Road",
                        "Finucane Rd at Redland Research Station",
                        "Shore St at Grant Street",
                        "Wellington St near Queen St",
                        "Wellington St near Coburg St West",
                        "Wellington St near South St",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Bayview State School",
                        "Carmel Catholic College",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Faith Lutheran College",
                        "Cleveland Redland Bay Rd at Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near Melanie St",
                        "Cleveland Redland Bay Rd near South St",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Smith St near Bay St",
                        "Smith St near Long St",
                        "Smith St at Cleveland Showground",
                        "Smith St at Cleveland District High School",
                        "Delancey St near Freeth St",
                        "Delancey St near Dundas St",
                        "Delancey St near Sturgeon St",
                        "Old Cleveland Rd near Starkey St",
                        "Old Cleveland Rd at Kefford St",
                        "Old Cleveland Rd near McDonald Rd",
                        "Main Rd near Nelson Rd hail 'n' ride",
                        "Marlborough Rd near Bayfields Ave",
                        "Marlborough Rd at Bella Street",
                        "Main Rd near Crossley Dr",
                        "Redlands College",
                        "Birkdale Rd at Wellington Point High School",
                        "Birkdale Rd at Wellington Manor Village",
                        "Birkdale Rd at Edwardson Court",
                        "Birkdale Rd at Birkdale Fair",
                        "Birkdale Rd near Napier St",
                        "Byng Rd at Almond Ave",
                        "Byng Rd near Mecoli Ct",
                        "Clive Rd near Bandiera St",
                        "Quarry Rd near Rosewood St",
                        "Mooroondu Rd near Thorne Rd",
                        "Mooroondu Rd near Alma St",
                        "Mooroondu Rd near Fisher Rd",
                        "Mooroondu Rd at John St",
                        "Thorneside Rd near John St",
                        "Thorneside Rd at Hugh Street",
                        "Thorneside Rd at Queens Esplanade",
                        "Thorneside Rd at Bayside Ct"
                    ],
                    "5035: Carmel College, Wakerley": [
                        "Old Cleveland Rd East at Birkdale South SS",
                        "Old Cleveland Rd near Currawong Dr",
                        "Old Cleveland Rd East at Randall Rd",
                        "Tulloch Dr near Riverton St",
                        "Tulloch Dr at Redgrove Avenue",
                        "Hardy Rd near Collingwood Rd",
                        "Wellington Point State High School",
                        "Birkdale Rd at EGW Wood Sportsfield",
                        "Birkdale Rd at Wellington Point Shops",
                        "Main Rd at Apsley Street",
                        "Main Rd near Courtice St",
                        "Main Rd near Station St",
                        "Main Rd at Whepstead Manor",
                        "Main Rd near Wellington Point Farmhouse hail 'n' ride",
                        "Allenby Rd near Montgomery Dr",
                        "Allenby Rd near Balmoral St",
                        "Allenby Rd at Monarch St",
                        "Allenby Rd near Topaz St",
                        "Allenby Rd near Finucane Rd",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Dawson Road",
                        "Finucane Rd at Redland Research Station",
                        "Shore St at Grant Street",
                        "Wellington St near Queen St",
                        "Wellington St near Coburg St West",
                        "Wellington St near South St",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Bayview State School",
                        "Carmel Catholic College",
                        "Wellington St near Panorama Dr",
                        "Wellington St near Enterprise St",
                        "Allenby Rd near Monarch St",
                        "Allenby Rd at Montgomery Drive",
                        "Old Cleveland Rd near McDonald Rd",
                        "Collingwood Rd at Serendipity Close",
                        "Prins Willem Alexander Village",
                        "Collingwood Road at Redland Mobile Village",
                        "Byng Rd at Almond Ave",
                        "Byng Rd near Mecoli Ct",
                        "Clive Rd near Bandiera St",
                        "Rickertt Rd at Tingalpa Creek",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Tilley Rd near Katherine St",
                        "Tilley Rd near Talltrees Cct",
                        "New Cleveland Rd at Eastside Village",
                        "Caladium St near Matthews Way",
                        "Caladium St near Underwood St",
                        "Caladium St near Basella St",
                        "Basella St near Arenga St",
                        "Arenga St near Williams St",
                        "Arenga St near Lexey Cres",
                        "Arenga St near Manly Rd"
                    ],
                    "5036: Carmel, Alexandra Hills, Capalaba": [
                        "Carmel Catholic College",
                        "Cleveland Redland Bay Rd at Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near Melanie St",
                        "Cleveland Redland Bay Rd near South St",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Long St",
                        "Bloomfield St at Long Street",
                        "Bloomfield St at Princess Street",
                        "Bloomfield St at Donald Simpson Park",
                        "Finucane Rd at Redland Research Station",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Vienna Road",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Cambridge Dr at Alexandra Hills Shops",
                        "Cambridge Dr at Charles Court",
                        "Vienna Rd near Cambridge Dr",
                        "Vienna Rd near Winchester Rd",
                        "Vienna Rd near Canterbury St",
                        "Vienna Rd at Alexandra Circuit",
                        "Alexandra Cct near Keynsham St",
                        "Hanover Dr near Garden St",
                        "Hanover Dr near Glenella Ct",
                        "Hanover Dr near Nanette Ct",
                        "Alexandra Cct at Hilliard Primary School",
                        "Alexandra Cct near Goorawin St",
                        "Vienna Rd near Wimborne Rd",
                        "Vienna Rd at Burwood Road",
                        "Lyndon Rd near Redland Bay Rd",
                        "Lyndon Rd near Korawal St",
                        "Lyndon Rd near Honeymyrtle Ct",
                        "Lyndon Rd near Kurrajong St",
                        "Lyndon Rd near Mahogany St",
                        "Lyndon Rd near Duncan Rd",
                        "Mount Cotton Rd at Henderson Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Rd near Ney Rd",
                        "Ney Rd near Koala Pl",
                        "Ney Rd at Capalaba Sports Club",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Ney Rd at Jeffrey Street",
                        "School Rd at Toni Street",
                        "School Rd near Gandarra St",
                        "School Rd at Capalaba State College",
                        "Mount Cotton Rd near Killarney Cr",
                        "Mount Cotton Rd at Winter Memorial Park",
                        "Capalaba bus station arrival stop 1"
                    ],
                    "5037: Bayview, Carmel, Thornlands, Cleveland": [
                        "Bayview State School",
                        "Carmel Catholic College",
                        "Passage St near Jacaranda Ct",
                        "Passage St near Russell St",
                        "Passage St near Queen St",
                        "Middle St near Emmett Dr",
                        "Emmett Drive near Middle St hail 'n' ride",
                        "Emmett Drive at Toondah Harbour Ferry",
                        "Emmett Drive near Middle St",
                        "Shore St at Passage Street",
                        "Cleveland station",
                        "Shore St at Black Swamp Wetlands",
                        "Shore St at RACQ",
                        "Delancey St near Freeth St",
                        "Delancey St near Sturgeon St"
                    ],
                    "5038: Carmel, Cleveland, Alexandra Hills": [
                        "Carmel Catholic College",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Wellington St near Enterprise St",
                        "Wellington St near Coburg St West",
                        "Finucane Rd at Redland Research Station",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Vienna Road",
                        "Princeton Ave near Garter St",
                        "Jasmine St at Alpinia St",
                        "Tulloch Dr near Riverton St",
                        "Tulloch Dr at Redgrove Avenue",
                        "Hardy Rd near Collingwood Rd",
                        "Spoonbill St near Sunnybay Dr",
                        "Burbank Rd near Spoonbill St",
                        "Barron Rd at Birkdale South Primary School",
                        "Valantine Rd at Bailey Rd",
                        "Valantine Rd near Bluebell St",
                        "Abelia St near Amarylis St",
                        "Abelia St near Armando St"
                    ],
                    "5040: Bayview, Carmel, Faith Snr, Mt Cotton": [
                        "Shanahan St near Michael St hail 'n' ride",
                        "Rusbrook St near Oakland Ave hail 'n' ride",
                        "Serpentine Creek Rd near Christopher St",
                        "Phillip St near Wilkie St",
                        "McWilliam St at Phillip St",
                        "Torquay Rd near McWilliam St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "Collins St at Donald Road",
                        "School of Arts Rd near Fielding Rd",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Watsonia St",
                        "German Church Rd near School of Arts Rd",
                        "Gordon Rd near Blair St hail 'n' ride",
                        "Government Rd at Queen St",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near Link Rd",
                        "Faith Lutheran College",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Ziegenfusz Rd near Tuna Ct",
                        "Carmel Catholic College",
                        "Vintage Dr at Bayview State School",
                        "Bayview State School",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Victoria Point Central, platform 2",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Cleveland Redland Bay Rd near Creekwood St",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Redland Bay Primary School",
                        "Collins St at Torquay Road",
                        "Torquay Rd near Torbay St hail 'n' ride",
                        "McWilliam St at Phillip Street",
                        "Serpentine Creek Rd at Christopher St",
                        "Oakland Ave near Shanahan St hail 'n' ride",
                        "Oakland Ave near Serpentine Creek Rd hail 'n' ride",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "German Church Rd near Days Rd",
                        "German Church Rd near Valley Way hail 'n' ride",
                        "Valley Way at Village Drive",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Valley Way near Hardwood Dr",
                        "Orchid Dr near Durian Cr",
                        "Orchid Dr near Flindersia Dr",
                        "Papaya St near Valley Way",
                        "Valley Way near Mount Cotton Rd"
                    ],
                    "5041: Redland Bay, Mt Cotton, Carmel College": [
                        "Carmel Catholic College",
                        "Ziegenfusz Rd near Doull Pl",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Colburn Ave near Link Rd",
                        "Link Rd near Jeanne Dr",
                        "Benfer Rd at Bangalow Street",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Poinciana Avenue",
                        "Benfer Rd near Prescoter Dr",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Government Rd at Queen St",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Fielding Rd",
                        "Collins St near School of Arts Rd",
                        "Collins St at Torquay Road",
                        "Torquay Rd near Torbay St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "McWilliam St at Phillip Street",
                        "Phillip St near Wilkie St",
                        "Serpentine Creek Rd at Christopher St",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "German Church Rd near Days Rd",
                        "German Church Rd near Valley Way hail 'n' ride",
                        "Valley Way at Village Drive",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Valley Way near Hardwood Dr",
                        "Valley Way near Mount Cotton Rd"
                    ],
                    "5042: Bayview, Victoria Pt High, St Ritas": [
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Papaya St near Valley Way",
                        "Orchid Dr near Durian Cr",
                        "Orchid Dr near Flindersia Dr",
                        "Orchid Dr at Durian Street",
                        "Orchid Dr near Papaya St hail 'n' ride",
                        "Papaya St near Carissa St",
                        "Hardwood Dr near Seeana Dr hail 'n' ride",
                        "Hardwood Dr near Hoop Pine St hail 'n' ride",
                        "Hardwood Dr near German Church Rd hail 'n' ride",
                        "Valley Way at Seeana Dr",
                        "Seeana Dr near Pimelea Cr hail 'n' ride",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Village Dr near Valley Way hail 'n' ride",
                        "Valley Way near Taffeta Dr",
                        "German Church Rd near Days Rd",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Serpentine Creek Rd near Christopher St",
                        "Phillip St near Wilkie St",
                        "McWilliam St at Phillip St",
                        "Torquay Rd near McWilliam St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "Collins St at Donald Road",
                        "Collins St near School of Arts Rd",
                        "School of Arts Rd near Fielding Rd",
                        "Queen St near School of Arts Rd",
                        "Queen St at Keirnan Street",
                        "Government Rd at Queen St",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near School Rd",
                        "Colburn Ave near Link Rd",
                        "Faith Lutheran College",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Ziegenfusz Rd near Tuna Ct",
                        "Carmel Catholic College",
                        "Vintage Dr at Bayview State School",
                        "Bayview State School",
                        "Ziegenfusz Rd near Doull Pl",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Magnolia Pde at Willow Street",
                        "Poinciana Ave at Pin Oak Crescent",
                        "Poinciana Ave at Peppercorn Crescent",
                        "Peppermint Dr near Mulberry Ct",
                        "Sycamore Pde near Wisteria Ct",
                        "Benfer Rd near Prescoter Dr",
                        "Main St near Pitt St hail 'n' ride",
                        "Main St at Gordon Road",
                        "German Church Rd near School of Arts Rd",
                        "German Church Rd near Valley Way hail 'n' ride",
                        "Bouquet Rd near Balthazar Cct hail 'n' ride",
                        "Heinemann Rd near Valley Way hail 'n' ride",
                        "Valley Way at Village Drive",
                        "Valley Way near Hardwood Dr",
                        "Valley Way near Mount Cotton Rd"
                    ],
                    "5046: Victoria Pt, Kimberley, Carbrook, Chisholm": [
                        "Bunker Rd at High St, stop C",
                        "Colburn Ave near Link Rd",
                        "Colburn Ave near School Rd",
                        "Colburn Ave near Point O'Halloran Rd",
                        "Colburn Ave near Daysland St",
                        "Link Rd at Fryar Street",
                        "Link Rd at Salford Waters Retirement Estate",
                        "Benfer Rd at Bangalow Street",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Poinciana Avenue",
                        "Benfer Rd near Prescoter Dr",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Hamilton St at Pitt Street",
                        "Redland Bay Marina, platform 2",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Fielding Rd",
                        "Collins St at Torquay Road",
                        "Serpentine Creek Rd at Christopher St",
                        "Serpentine Creek Rd near Kidd St hail 'n' ride",
                        "Serpentine Creek Rd near Scenic Rd hail 'n' ride",
                        "Beenleigh Redland Bay Rd at Aquatic Gardens HnR",
                        "Beenleigh Redland Bay Rd at Carbrook Golf Course",
                        "Beenleigh Redland Bay Rd near Stern St HnR",
                        "Kimberley College",
                        "Beenleigh Redland Bay Rd at Carbrook Primary",
                        "Beenleigh Redland Bay Rd near California Creek Rd",
                        "Chisholm Catholic College"
                    ],
                    "5047: Mt Cotton, Kimberley, Calvary, Chisholm": [
                        "Redland Bay Rd at Merritt Street",
                        "Redland Bay Rd at Andrew Street",
                        "Ney Rd near Redland Bay Rd",
                        "Ney Rd at Jeffrey Street",
                        "Ney Rd at Callaghan Way",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Coolnwynpin Primary School",
                        "Ney Rd near Coolnwynpin Way",
                        "Ney Rd at Koala Place",
                        "Mount Cotton Rd at Ney Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Rd at Henderson Road",
                        "Duncan Rd at Duncan Road Sports Fields",
                        "Sheldon College",
                        "Woodlands Dr near Taylor Dr",
                        "Mount Cotton Rd near Double Jump Rd hail 'n' ride",
                        "Mount Cotton Rd near Mt Cotton Primary School",
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Valley Way near Hardwood Dr hail 'n' ride",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Valley Way near Taffeta Dr",
                        "Valley Way near German Church Rd hail 'n' ride",
                        "Valley Way at Village Drive",
                        "Valley Way near Hardwood Dr",
                        "Carissa St near Begonia Cr",
                        "Durian St near Carissa St hail 'n' ride",
                        "Orchid Dr near Flindersia Dr",
                        "Orchid Dr at Durian Street",
                        "Papaya St near Valley Way",
                        "Valley Way near Mount Cotton Rd",
                        "Mount Cotton Rd near Gramzow Rd",
                        "Chisholm Catholic College",
                        "California Creek Rd Mapping stop",
                        "California Creek Rd near Kilkenny St",
                        "Beenleigh Redland Bay Rd at California Creek Road",
                        "Calvary Christian College",
                        "Kimberley College",
                        "Beenleigh Redland Bay Rd at Carbrook Primary"
                    ],
                    "5050: Cleveland High, Victoria Pt, Redland Bay": [
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Smith St near Long St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near South St",
                        "Cleveland Redland Bay Rd near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay Rd near Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Victoria Point Central, platform 2",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Hamilton St at Pitt Street",
                        "Redland Bay Marina, platform 2"
                    ],
                    "5051: Redland Bay, Victoria Point, Cleveland": [
                        "Redland Bay Marina, platform 2",
                        "Hamilton St at Pitt Street",
                        "Hamilton St near Broadwater Tce hail 'n' ride",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Victoria Point High School",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Baythorn Dr near Colthouse Dr hail 'n' ride",
                        "Clifford Perske Dr near Thornlands Rd",
                        "Clifford Perske Dr near Kriskyle Pl",
                        "South St near Clifford Perske Dr",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Smith St near Bay St",
                        "Smith St near Long St",
                        "Smith St at Cleveland Showground",
                        "Smith St at Cleveland District High School",
                        "Russell St at Cleveland District High School",
                        "Bloomfield St near Russell St",
                        "Cleveland State School",
                        "Long St at Topatig Street",
                        "Bloomfield St near Long St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near South St",
                        "Cleveland Redland Bay Rd near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Thornlands Rd near Ribbonwood St",
                        "Ziegenfusz Rd near Tuna Ct",
                        "Carmel Catholic College",
                        "Ziegenfusz Rd near Doull Pl",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Victoria Point Central, platform 2",
                        "Cleveland Redland Bay Rd near Creekwood St",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Bedarra St"
                    ],
                    "5052: Rocky Passage, Redland Bay, Victoria Pt": [
                        "Rocky Passage Rd near Serpentine Creek Rd HnR",
                        "Muriel St near Wallaby Rd hail 'n' ride",
                        "Orchard Rd near Scenic Rd hail 'n' ride",
                        "Vine St near Alisa St hail 'n' ride",
                        "Shoreline Ave at Jingeri St",
                        "Shoreline Ave at Hydrangea Ave",
                        "Serpentine Creek Rd near Scenic Rd hail 'n' ride",
                        "Serpentine Creek Rd near Kidd St hail 'n' ride",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Oakland Ave near Shanahan St hail 'n' ride",
                        "Shanahan St near Michael St hail 'n' ride",
                        "Rusbrook St near Oakland Ave hail 'n' ride",
                        "Oakland Ave near Serpentine Creek Rd hail 'n' ride",
                        "Serpentine Creek Rd near Christopher St",
                        "Phillip St near Wilkie St",
                        "McWilliam St at Phillip St",
                        "Torquay Rd near McWilliam St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "Collins St at Donald Road",
                        "Collins St near School of Arts Rd",
                        "School of Arts Rd near Fielding Rd",
                        "Queen St near School of Arts Rd",
                        "Queen St at Keirnan Street",
                        "Gordon Rd near Main St hail 'n' ride",
                        "Gordon Rd at Redland Bay Primary School",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near Link Rd",
                        "Faith Lutheran College",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Ziegenfusz Rd near Tuna Ct",
                        "Carmel Catholic College",
                        "Vintage Dr at Bayview State School"
                    ],
                    "5053: Pt Talburpin, Victoria Pt & Cleveland": [
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Oakland Ave near Shanahan St hail 'n' ride",
                        "Shanahan St near Michael St hail 'n' ride",
                        "Rusbrook St near Oakland Ave hail 'n' ride",
                        "Oakland Ave near Serpentine Creek Rd hail 'n' ride",
                        "Serpentine Creek Rd near Christopher St",
                        "Phillip St near Wilkie St",
                        "McWilliam St at Phillip St",
                        "Torquay Rd near McWilliam St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "Collins St at Donald Road",
                        "Collins St near School of Arts Rd",
                        "School of Arts Rd near Fielding Rd",
                        "Queen St near School of Arts Rd",
                        "Queen St at Keirnan Street",
                        "Gordon Rd near Main St hail 'n' ride",
                        "Gordon Rd at Redland Bay Primary School",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Benfer Rd near Prescoter Dr",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Cleveland Redland Bay Rd at Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near Melanie St",
                        "Cleveland Redland Bay Rd near South St",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Long St",
                        "Bloomfield St at Long Street",
                        "Bloomfield St at Princess Street",
                        "Bloomfield St at Donald Simpson Park",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Long St at Topatig Street",
                        "Long St near Fitzroy St hail 'n' ride",
                        "Cleveland State School",
                        "Waterloo St near Russell St",
                        "Bloomfield St near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Island Outlook Ave at Sylvie Street",
                        "Vintage Dr near Noir Ct",
                        "Vintage Dr near Touriga St",
                        "Vintage Dr at Bayview State School",
                        "Ziegenfusz Rd near Doull Pl",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Victoria Point Central, platform 2",
                        "Charlie Buckler Memorial Sportsground",
                        "Main St near Pitt St hail 'n' ride",
                        "Pitt St near Scott St hail 'n' ride",
                        "Hamilton St at Pitt Street",
                        "Redland Bay Marina, platform 2",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Queen St at School of Arts Road",
                        "Collins St at Torquay Road",
                        "Torquay Rd near Torbay St hail 'n' ride",
                        "McWilliam St at Phillip Street",
                        "Serpentine Creek Rd at Christopher St",
                        "Serpentine Creek Rd near Kidd St hail 'n' ride",
                        "Serpentine Creek Rd near Scenic Rd hail 'n' ride",
                        "Scenic Rd near Orchard Rd hail 'n' ride",
                        "Vine St near Alisa St hail 'n' ride",
                        "Orchard St near Scenic Rd hail 'n' ride",
                        "Lagoon View Rd near Orchard Rd hail 'n' ride",
                        "Muriel St near Albert St hail 'n' ride",
                        "Muriel St near Wallaby Rd hail 'n' ride",
                        "Rocky Passage Rd near Serpentine Creek Rd HnR"
                    ],
                    "5054: Pt Talburpin, Mt Cotton, Cleveland": [
                        "Serpentine Creek Rd near Christopher St",
                        "Collins St at Donald Road",
                        "Collins St near School of Arts Rd",
                        "School of Arts Rd near Fielding Rd",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Watsonia St",
                        "School of Arts Rd near German Church Rd",
                        "German Church Rd near Days Rd",
                        "German Church Rd near Valley Way hail 'n' ride",
                        "Valley Way at Village Drive",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Valley Way near Hardwood Dr",
                        "Valley Way near Mount Cotton Rd",
                        "Mount Cotton Rd near Sanctuary Dr hail 'n' ride",
                        "Sanctuary Dr near Wrights Pl hail 'n' ride",
                        "Mt Cotton Primary School",
                        "Woodlands Dr near Taylor Dr",
                        "Sheldon College",
                        "Boundary Rd at Taylor Rd",
                        "Boundary Rd at Kinross Road",
                        "Panorama Drive near Boundary Rd",
                        "Panorama Dr at Milner Pl",
                        "South St near Osprey Dr",
                        "South St at Redlands District Special School",
                        "South St near Fitzroy St",
                        "Clifford Perske Dr near Kriskyle Pl",
                        "Clifford Perske Dr near Thornlands Rd",
                        "Thornlands Rd near Ribbonwood St",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Ziegenfusz Rd near Tuna Ct",
                        "Carmel Catholic College",
                        "Vintage Dr at Bayview State School",
                        "Vintage Dr near Abalone Cr",
                        "Vintage Dr near Noir Ct",
                        "Island Outlook Ave near Margery St",
                        "Manhattan Ave near Sunview St",
                        "Panorama Dr at Robert Mackie Park",
                        "Panorama Dr near Laurette Ave",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Long St",
                        "Bloomfield St at Long Street",
                        "Bloomfield St at Princess Street",
                        "Bloomfield St at Donald Simpson Park",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Long St at Topatig Street",
                        "Long St near Fitzroy St hail 'n' ride",
                        "Cleveland State School",
                        "Waterloo St near Russell St",
                        "Wellington St near South St",
                        "Panorama Dr near Manhattan Ave",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Panorama Dr near Milner Pl",
                        "Panorama Dr near Boundary Road",
                        "Woodlands Dr near Boundary St",
                        "Woodlands Dr near Platres Dr",
                        "Mount Cotton Rd near Double Jump Rd hail 'n' ride",
                        "Mount Cotton Rd near Mt Cotton Primary School",
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Valley Way at Seeana Dr",
                        "Valley Way near Taffeta Dr",
                        "Collins St at Torquay Road",
                        "Serpentine Creek Rd at Christopher St",
                        "Shanahan St near Michael St hail 'n' ride",
                        "Rusbrook St near Oakland Ave hail 'n' ride"
                    ],
                    "5055: Redland Bay Primary, Marina, Victoria Pt High": [
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Serpentine Creek Rd near Christopher St",
                        "Collins St at Donald Road",
                        "Collins St near School of Arts Rd",
                        "School of Arts Rd near Fielding Rd",
                        "Queen St near School of Arts Rd",
                        "Queen St at Keirnan Street",
                        "Gordon Rd near Main St hail 'n' ride",
                        "Gordon Rd at Redland Bay Primary School",
                        "Gordon Rd near Blair St hail 'n' ride",
                        "Government Rd at Queen St",
                        "Redlands Satellite Health Centre",
                        "Redland Bay Marina, platform 2",
                        "Hamilton St at Pitt Street",
                        "Hamilton St near Broadwater Tce hail 'n' ride",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School"
                    ],
                    "5058: Cleveland, Thornlands, Vic Pt, Redland Bay": [
                        "Gordon Rd at Redland Bay Primary School",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near School Rd",
                        "Colburn Ave near Point O'Halloran Rd",
                        "Point O'Halloran Rd near Albert St",
                        "Point O'Halloran Rd near Cooba St",
                        "Point O'Halloran Rd near Orana St",
                        "Orana St near Macadamia St",
                        "Orana Esp near Bayswater Dr",
                        "Point O'Halloran Rd near Tipplers St",
                        "Point O'Halloran Rd near Cheshire St",
                        "Wilson St near Colburn Ave",
                        "Colburn Av at White Street",
                        "Victoria Point Jetty",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at Thompson Street",
                        "Link Rd at Fryar Street",
                        "Link Rd at Salford Waters Retirement Estate",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Faith Lutheran College",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Cleveland Redland Bay Rd at Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near Melanie St",
                        "Cleveland Redland Bay Rd near South St",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Long St",
                        "Bloomfield St at Long Street",
                        "Bloomfield St at Princess Street",
                        "Bloomfield St at Donald Simpson Park",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Long St at Topatig Street",
                        "Long St near Fitzroy St hail 'n' ride",
                        "Cleveland State School",
                        "Bloomfield St near Russell St",
                        "Smith St near Long St",
                        "Smith St near Bay St",
                        "Bloomfield St near South St",
                        "Panorama Dr near Laurette Ave",
                        "Panorama Dr at Robert Mackie Park",
                        "Panorama Dr at Abbotsleigh Street",
                        "Island Outlook Ave near Margery St",
                        "Island Outlook Ave at Vintage Drive",
                        "Cleveland Redland Bay Rd near Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Colburn Ave near Link Rd",
                        "Point O'Halloran Rd near Colburn Ave",
                        "Benfer Rd near Prescoter Dr",
                        "Redland Bay Primary School",
                        "Gordon Rd near Syracuse St hail 'n' ride",
                        "Gordon Rd near Blair St hail 'n' ride",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Watsonia St",
                        "School of Arts Rd near German Church Rd"
                    ],
                    "5062: Mount Cotton, Victoria Point High": [
                        "German Church Rd near Days Rd",
                        "German Church Rd near Valley Way hail 'n' ride",
                        "Valley Way at Village Drive",
                        "Village Dr near Valley Way hail 'n' ride",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Seeana Dr near Pimelea Cr hail 'n' ride",
                        "Valley Way near Hardwood Dr",
                        "Hardwood Dr near Seeana Dr hail 'n' ride",
                        "Hardwood Dr near Hoop Pine St hail 'n' ride",
                        "Hardwood Dr near German Church Rd hail 'n' ride",
                        "Carissa St near Begonia Cr",
                        "Begonia St near Durian St hail 'n' ride",
                        "Orchid Dr near Flindersia Dr",
                        "Orchid Dr at Durian Street",
                        "Papaya St near Valley Way",
                        "Valley Way near Mount Cotton Rd",
                        "Mount Cotton Rd near Sanctuary Dr hail 'n' ride",
                        "Sanctuary Dr near Wrights Pl hail 'n' ride",
                        "Mt Cotton Primary School",
                        "Double Jump Rd near Mt Cotton Rd hail 'n' ride",
                        "Double Jump Rd near Heinemann Rd hail 'n' ride",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near School Rd",
                        "Link Rd at Salford Waters Retirement Estate",
                        "Link Rd at Fryar Street",
                        "Colburn Ave at Thompson Street",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at White Street",
                        "Victoria Point Jetty",
                        "Colburn Av at Thompson Street",
                        "Mount Cotton Rd near Double Jump Rd hail 'n' ride",
                        "Mount Cotton Rd near Mt Cotton Primary School",
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Durian St near Carissa St hail 'n' ride",
                        "Orchid Dr near Papaya St hail 'n' ride",
                        "Papaya St near Carissa St",
                        "Valley Way at Seeana Dr",
                        "Valley Way near Taffeta Dr",
                        "Valley Way near German Church Rd hail 'n' ride",
                        "Bouquet Rd near Balthazar Cct hail 'n' ride",
                        "Heinemann Rd near Valley Way hail 'n' ride"
                    ],
                    "5064: Faith & Victoria Point Pmy, Pt O'Hallora": [
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near School Rd",
                        "Colburn Ave near Point O'Halloran Rd",
                        "Colburn Ave near Daysland St",
                        "Colburn Ave at Thompson Street",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at White Street",
                        "Victoria Point Jetty",
                        "Wilson St near Colburn Ave",
                        "Wilson Esp near Barron St",
                        "Albert St near Morell St",
                        "Point O'Halloran Rd near Albert St",
                        "Point O'Halloran Rd near Cooba St",
                        "Point O'Halloran Rd near Orana St",
                        "Point O'Halloran Rd near Tipplers St",
                        "Orana Esp near Bayswater Dr",
                        "Point O'Halloran Rd near Cheshire St",
                        "Point O'Halloran Rd near Colburn Ave hail 'n' ride"
                    ],
                    "5065: Carmel College, Victoria Point, St Ritas": [
                        "Bayview State School",
                        "Carmel Catholic College",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Victoria Point Central, platform 2",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd at Salford Waters Retirement Estate",
                        "Link Rd at Fryar Street",
                        "Colburn Ave at Thompson Street",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at White Street",
                        "Victoria Point Jetty",
                        "Wilson St near Colburn Ave",
                        "Wilson Esp near Barron St",
                        "Albert St near Morell St",
                        "Point O'Halloran Rd near Albert St",
                        "Point O'Halloran Rd near Cooba St",
                        "Point O'Halloran Rd near Orana St",
                        "Orana St near Macadamia St",
                        "Orana Esp near Bayswater Dr",
                        "Point O'Halloran Rd near Tipplers St",
                        "Cheshire St near Point O'Halloran Rd",
                        "Nottingham Dr near Regency St",
                        "School Rd near Parklane Rd",
                        "School Rd near Aspect Dr",
                        "Colburn Ave near Link Rd"
                    ],
                    "5069: Ormiston, Cleveland High, Carmel, Faith": [
                        "Ney Rd at Jeffrey Street",
                        "Ney Rd at Callaghan Way",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Macquarie St near Ney Rd",
                        "Macquarie St near Jacaranda Rd",
                        "Macquarie St near Simpson St",
                        "Wentworth Dr near Bute Street",
                        "Wentworth Dr near Wills Lane",
                        "Wentworth Dr near Blaxland St",
                        "Mount Cotton Rd near Howlett Rd",
                        "Mount Cotton Rd near Larbonya Cr",
                        "Mount Cotton Rd near Killarney Cr",
                        "Mount Cotton Rd at Winter Memorial Park",
                        "Capalaba bus station, stop A",
                        "Finucane Rd at Old Cleveland Rd",
                        "Finucane Rd at Willard Road",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Finucane Rd at Keith Surridge Park",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Finucane Rd at Vienna Road",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Dawson Road",
                        "Finucane Rd at Redland Research Station",
                        "Delancey St near Freeth St",
                        "Delancey St near Sturgeon St",
                        "Freeth St W at Wellington Street",
                        "Delancey St near Russell St",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Long St at Topatig Street",
                        "Bloomfield St near Long St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near South St",
                        "Cleveland Redland Bay Rd near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Ziegenfusz Rd near Tuna Ct",
                        "Carmel Catholic College",
                        "Ziegenfusz Rd near Doull Pl",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Faith Lutheran College"
                    ],
                    "5075: Gumdale, Iona College": [
                        "New Cleveland Rd at Eastside Village",
                        "Caladium St near Matthews Way",
                        "Caladium St near Underwood St",
                        "Caladium St near Basella St",
                        "Arenga St near Williams St",
                        "Arenga St near Lexey Cres",
                        "Arenga St near Manly Rd",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Amberjack Stop 56/61",
                        "Manly Rd at Barramundi Stop 62",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Silky Oaks",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Manly West near Stannard Rd",
                        "Manly Rd at Daisy Road Stop 68",
                        "Manly Rd at Whites Rd",
                        "Preston Rd at Seabreeze",
                        "Preston Rd at Corner House",
                        "Preston Rd near Alloa St, stop 75/65",
                        "Preston Rd near Randall Rd",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Wynnum Rd at Wynnum Golf",
                        "Wynnum Rd at Sibley Road",
                        "Wynnum Rd near Wynnum North Rd",
                        "Wynnum North Rd at Sibley Road, stop 38",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Sandy Camp Rd near Bulgin Av",
                        "Iona College Lindum Primary"
                    ],
                    "5076: Maridale Park, Capalaba, Iona College": [
                        "Capalaba bus station, stop A",
                        "Old Cleveland Rd near Tinchborne St",
                        "New Cleveland Rd near Old Cleveland Rd",
                        "Archer Street near Boston Rd hail 'n' ride",
                        "Boston Rd near Tilley Rd",
                        "Tilley Rd at London Road",
                        "Tilley Rd near Grassdale Rd",
                        "Tilley Rd at Gumdale Primary School",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Green Camp Rd",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Catamaran St near Manly Rd HnR",
                        "Graduate St near Meltemi St",
                        "Caloundra St at Janoah Gardens",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Silky Oaks",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Manly West near Stannard Rd",
                        "Manly Rd at Daisy Road Stop 68",
                        "Manly Rd at Whites Rd",
                        "Preston Rd at Seabreeze",
                        "Preston Rd at Corner House",
                        "Preston Rd near Alloa St, stop 75/65",
                        "Preston Rd near Randall Rd",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Wynnum Rd at Wynnum Golf",
                        "Wynnum Rd at Sibley Road",
                        "Wynnum Rd near Wynnum North Rd",
                        "Wynnum North Rd at Sibley Road, stop 38",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Sandy Camp Rd near Bulgin Av",
                        "Iona College Lindum Primary",
                        "Network Dr at Brisbane Bayside State College",
                        "Wynnum Rd at BMX, stop 50/56",
                        "Wynnum Rd at Plaza Street, stop 57",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58",
                        "Wynnum Rd at Wynnum West State School, stop 58A",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "Wynnum North Rd at Wynnum North Rail, stop 36/17",
                        "Wynnum North Rd at Prospect Street, stop 16",
                        "Wynnum North Rd at Ryder Street, stop 15",
                        "Wynnum North Rd at Nazareth House, stop 14",
                        "Wynnum North Rd at Constellation Way, stop 13",
                        "Tingal Rd at Tingal - Ure, stop 13A",
                        "Tingal Rd at Shepherd Street, stop 12",
                        "Tingal Rd at Warra Street, stop 11",
                        "Tingal Rd at Wynnum North State School, stop 10/5",
                        "Sibley Rd at Lindum Rail, stop 44/45",
                        "Sibley Rd at Pleasantville, stop 42",
                        "Sibley Rd at Florabelle Court, stop 41",
                        "Sibley Rd at Regent Street, stop 40/39",
                        "Wynnum Rd at Primrose Park",
                        "Wynnum Rd at Stradbroke Avenue",
                        "Tingal Rd at Wynnum near Wilde St",
                        "Tingal Rd at Leisure Centre, stop 2",
                        "Tingal Rd at Berrima Street, stop 1",
                        "Tingal Rd at Wynnum RSL",
                        "Florence St at Wynnum Library",
                        "Florence St at Wynnum Central, stop 97",
                        "Bay Tce at Clara Street Stop 96",
                        "Bay Tce at Guardian Angels School Stop 95",
                        "Bay Tce at Walnut Street, stop 94/93",
                        "Kingsley Tce at Picton Parade, stop 91",
                        "Kingsley Tce at Gordon Parade, stop 90",
                        "Cardigan Pde near Melville Tce",
                        "Ferguson St at Richard Russell Park, stop 86",
                        "Manly Rd at Preston Rd",
                        "Manly Rd at Whites Road",
                        "Manly Rd at Manly West near Delsia St",
                        "Manly Rd at Barramundi, stop 62",
                        "Manly Rd at Amberjack Stop 61/56",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "New Cleveland Rd at Eastside Village",
                        "Tilley Rd at New Cleveland Road",
                        "Tilley Rd near London Rd",
                        "Old Cleveland Rd near New Cleveland Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station, stop D",
                        "Mount Cotton Rd at Winter Memorial Park",
                        "Mount Cotton Rd at Killarney Crescent",
                        "Mount Cotton Rd near School Rd",
                        "Mount Cotton Rd near Howlett Rd",
                        "Wentworth Dr near Blaxland St",
                        "Wentworth Dr near Cunningham St",
                        "Wentworth Dr near Bute St",
                        "Macquarie St at Mitchell Street",
                        "Macquarie St near Jacaranda Rd",
                        "Macquarie St near Ney Rd",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Callaghan Way near Greenup St"
                    ],
                    "5077: Brisbane Bayside, Iona College, Capalaba": [
                        "Network Dr at Brisbane Bayside State College",
                        "Wynnum Rd at BMX, stop 50/56",
                        "Wynnum Rd at Plaza Street, stop 57",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58",
                        "Wynnum Rd at Wynnum West State School, stop 58A",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Wynnum Rd at Wynnum Golf",
                        "Brierty St near Malabar St, stop 53",
                        "Malabar St at Nemarra Street, stop 51",
                        "Malabar St at Lyones Street, stop 50",
                        "Malabar St at Meron Street, stop 49",
                        "Malabar St at Birru Street, stop 48",
                        "Malabar St at Talegalla Street, stop 47",
                        "Sibley Rd at Lindum Rail, stop 44/45",
                        "Sibley Rd at Pleasantville, stop 42",
                        "Sibley Rd at Florabelle Court, stop 41",
                        "Sibley Rd at Regent Street, stop 40/39",
                        "Wynnum North Rd at Sibley Road, stop 38",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Sandy Camp Rd near Bulgin Av",
                        "Iona College Lindum Primary",
                        "Kianawah Rd at Evelyn Rd",
                        "Kianawah Rd at Youngs Rd",
                        "Kianawah Rd at Vikings",
                        "Kianawah Rd at Glenwood Pl",
                        "Wynnum Rd at Bognor Road, stop 45",
                        "Wynnum Rd at Hemmant Cemetery, stop 44",
                        "Wynnum Rd at Arena, stop 43",
                        "Manly Rd at Leon, stop 43",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Manly Rd at Lockwood Crescent, stop 53",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Manly Rd at Moss Road Stop 54",
                        "Catamaran St near Manly Rd HnR",
                        "Graduate St near Meltemi St",
                        "Caloundra St at Janoah Gardens",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Barramundi, stop 62",
                        "Manly Rd at Amberjack Stop 61/56",
                        "Green Camp Rd at Habitat Drive",
                        "Green Camp Rd near New Cleveland Rd",
                        "Molle Rd near Chelsea Rd",
                        "New Cleveland Rd near Old Cleveland Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "5078: Iona College, Wynnum, Manly": [
                        "Iona College Lindum Primary",
                        "Sibley Rd at Pleasantville, stop 42",
                        "Wynnum North Rd at Sibley Road, stop 38",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Wynnum North Rd at Wynnum North Rail, stop 36/17",
                        "Wynnum North Rd at Prospect Street, stop 16",
                        "Wynnum North Rd at Ryder Street, stop 15",
                        "Wynnum North Rd at Nazareth House, stop 14",
                        "Wynnum North Rd at Constellation Way, stop 13",
                        "Tingal Rd at Tingal - Ure, stop 13A",
                        "Tingal Rd at Shepherd Street, stop 12",
                        "Tingal Rd at Warra Street, stop 11",
                        "Tingal Rd at Wynnum North State School, stop 10/5",
                        "Tingal Rd at Alkoomie Street, stop 4",
                        "Tingal Rd at Wynnum near Wilde St",
                        "Tingal Rd at Leisure Centre, stop 2",
                        "Tingal Rd at Berrima Street, stop 1",
                        "Tingal Rd at Wynnum RSL",
                        "Florence St at Wynnum Library",
                        "Florence St at Wynnum Central, stop 97",
                        "Bay Tce at Clara Street Stop 96",
                        "Bay Tce at Guardian Angels School Stop 95",
                        "Bay Tce at Walnut Street, stop 94/93",
                        "Kingsley Tce at Picton Parade, stop 91",
                        "Kingsley Tce at Gordon Parade, stop 90",
                        "Cardigan Pde near Melville Tce",
                        "Kooralgin St near Arnold St",
                        "Ernest St near Manly Rd",
                        "Manly Rd at Preston Rd",
                        "Manly Rd at Whites Road",
                        "Manly Rd at Daisy Road Stop 68",
                        "Manly Rd at Manly West near Delsia St",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Silky Oaks",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Amberjack Stop 61/56"
                    ],
                    "5081: Lourdes Hill College, San Sisto College": [
                        "Capalaba bus station, stop B",
                        "Old Cleveland Rd near Tinchborne St",
                        "New Cleveland Rd near Old Cleveland Rd",
                        "New Cleveland Rd near Archer St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd at Eastside Village",
                        "Stanbrough Rd near New Cleveland Rd",
                        "Stanbrough Rd at Formosa St",
                        "Stanbrough Rd near Grassdale Rd",
                        "Grassdale Rd near Stanbrough Rd",
                        "Grassdale Rd near Belmont Rd",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Meadowlands Rd at Epala Street, stop 56",
                        "Meadowlands Rd at Hilltop Court, stop 57",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Mayfield Rd at San Sisto Convent",
                        "Old Cleveland Rd at Carina, stop 35",
                        "Old Cleveland Rd at Wonersh Street, stop 34",
                        "Old Cleveland Rd at Orwell Street, stop 33",
                        "Old Cleveland Rd at Camp Hill Primary",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Pampling Street, stop 29",
                        "Old Cleveland Rd at Madeline Street, stop 27",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Bennetts Rd at Pattison Avenue, stop 27",
                        "Bennetts Rd at Acfold Street, stop 28",
                        "Bennetts Rd at Bennetts Bushland, stop 29",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Virginia Ave near Aaron Ave",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Old Cleveland Rd near Gallipoli Rd Stop 37",
                        "Old Cleveland Rd near Scrub Rd",
                        "Old Cleveland Rd near Adley St",
                        "Wright St at Melaleuca Place",
                        "Grassdale Rd at Stanbrough Rd",
                        "Stanbrough Rd near Formosa St",
                        "Ermelo Rd near Stanborough Rd hail 'n' ride",
                        "Caladium St near Matthews Way",
                        "Caladium St near Underwood St",
                        "Caladium St near Basella St",
                        "Basella St near Arenga St",
                        "Dianthus St near Basella St",
                        "New Cleveland Rd near Green Camp Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "5082: Carindale, Capalaba, Gumdale, LourdesHill": [
                        "Capalaba bus station, stop C",
                        "Old Cleveland Rd near Tinchborne St",
                        "New Cleveland Rd near Old Cleveland Rd",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "New Cleveland Rd at Eastside Village",
                        "Tilley Rd at New Cleveland Road",
                        "Formosa St near Archer St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Judd St",
                        "Stanbrough Rd near New Cleveland Rd",
                        "Stanbrough Rd at Formosa St",
                        "Stanbrough Rd near Grassdale Rd",
                        "Grassdale Rd near Stanbrough Rd",
                        "Grassdale Rd near Belmont Rd",
                        "Old Cleveland Rd near Scrub Rd",
                        "Winstanley St at Winstanley East",
                        "Winstanley St near Talavera St",
                        "Winstanley St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Carindale Shopping Centre station, platform J",
                        "Old Cleveland Rd at Orana Street, stop 37",
                        "Old Cleveland Rd at Pembroke Street, stop 36",
                        "Old Cleveland Rd at Carina, stop 35",
                        "Old Cleveland Rd at Wonersh Street, stop 34",
                        "Old Cleveland Rd at Orwell Street, stop 33",
                        "Old Cleveland Rd at Camp Hill Primary",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Pampling Street, stop 29",
                        "Old Cleveland Rd at Madeline Street, stop 27",
                        "Old Cleveland Rd at Kismet Street, stop 26",
                        "Old Cleveland Rd at Burke Street, stop 25",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Cavendish Rd at Wakefield Street, stop 25/21",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Milsom St, stop 19",
                        "Stanley St East at Edgar Street, stop 18",
                        "Vulture St at Didsbury Street, stop 17",
                        "Oaklands Pde at Anglican Church Grammar School",
                        "Oaklands Pde at Churchie Junior School",
                        "Virginia Ave near Aaron Ave",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Bennetts Rd near Jean Howie Dr, stop 20",
                        "Agnew St at Norman Park North",
                        "Agnew St at Seven Hills Stop 42",
                        "Kensington Ave near Marshall Ave, stop 41/40",
                        "Oateson Skyline Dr at Quirinal Crescent, stop 39",
                        "Oateson Skyline Dr at Claudia Avenue, stop 38a",
                        "Oateson Skyline Dr at Servius Street, stop 38",
                        "Oateson Skyline Dr at Caelian Street, stop 37",
                        "Oateson Skyline Dr at Ursus Street, stop 36",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Cambridge Street, stop 44",
                        "Winstanley St near Birdwood Rd, stop 45",
                        "Winstanley St at Willard Street, stop 46",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Old Cleveland Rd near Adley St",
                        "Old Cleveland Rd at Barbeque St",
                        "Old Cleveland Rd near Stanbrough Rd",
                        "Stanbrough Rd near Boston Rd",
                        "Stanbrough Rd near Formosa St",
                        "Ermelo Rd near Stanborough Rd hail 'n' ride",
                        "Dianthus St near Basella St",
                        "Tilley Rd near Katherine St",
                        "Green Camp Rd near New Cleveland Rd",
                        "Old Cleveland Rd at Tollett Street",
                        "Old Cleveland Rd near Caradoc St",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "5088: Capalaba, Wynnum, Moreton Bay Colleges": [
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Whites Rd near Dane Ct hail 'n' ride",
                        "Hindes St at Bay Brooke, stop 76",
                        "Hindes St at Lota State School, stop 77",
                        "Alexander St at Lota PCYC Stop 78",
                        "MacDonald St near Ernest St, stop 79",
                        "Oceana Tce at Lota House, stop 81",
                        "Oceana Tce at Britannia Street, stop 82",
                        "Ernest St at Parramatta Street, stop 83",
                        "Ernest St at St John Vianneys School, stop 84",
                        "Ferguson St at Richard Russell Park, stop 86",
                        "Stratton Tce near Nelson Pde",
                        "Stratton Tce near Wolsey Pde",
                        "Pine St near Akonna St",
                        "Tingal Rd at Wynnum RSL, stop 99",
                        "Tingal Rd at Berrima Street, stop 1",
                        "Tingal Rd at Leisure Centre, stop 2",
                        "Tingal Rd at Wynnum, stop 3",
                        "Tingal Rd at Alkoomie Street, stop 11",
                        "Tingal Rd at Wynnum North State School, stop 10/5",
                        "Tingal Rd at Warra Street, stop 11",
                        "Tingal Rd at Shepherd Street, stop 12",
                        "Wynnum North Rd at Nazareth House, stop 14",
                        "Wynnum North Rd at Prospect Street, stop 15/16",
                        "Wynnum North Rd at Stanley Terrace, stop 17",
                        "Wynnum North Rd at Wynnum North Rail, stop 36/17",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Wynnum Rd at Stradbroke Avenue",
                        "Stradbroke Ave at Tragorin St",
                        "Stradbroke Ave at Davidson Street",
                        "Stradbroke Ave at Carnation Street",
                        "Stradbroke Ave at Golf Club",
                        "Stradbroke Ave at Kitchener Park",
                        "West Ave near Coolcrest St",
                        "Preston Rd at Corner House, stop 74/66",
                        "Preston Rd at Seabreeze, stop 72/68",
                        "Manly Rd at Whites Road",
                        "Manly Rd at Daisy Road Stop 68",
                        "Manly Rd at Manly West near Delsia St",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Silky Oaks",
                        "Moreton Bay Boys College",
                        "Caloundra St at Janoah Gardens",
                        "Radford Rd at Manly Vista",
                        "Radford Rd near Wondall Rd",
                        "Moreton Bay Girls College",
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd near Manly Rd",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Leon, stop 43",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Meadowlands Rd at Epala Street, stop 56",
                        "Meadowlands Rd at Hilltop Court, stop 57",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Mayfield Rd at San Sisto Convent",
                        "Wondall Rd at Kianawah Road South",
                        "Wondall Rd at Wondall Heights State School,stop 61",
                        "Wondall Rd at Heers Park, stop 62",
                        "Preston Rd near Alloa St, stop 75/65",
                        "Preston Rd near Randall Rd",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Andrew St near Ronald St Stop 100",
                        "Stradbroke Ave at Targorin St",
                        "Wynnum North Rd at Prospect Street, stop 16",
                        "Wynnum North Rd at Ryder Street, stop 15",
                        "Tingal Rd at Alkoomie Street, stop 4",
                        "Tingal Rd at Wynnum near Wilde St",
                        "Tingal Rd at Wynnum RSL",
                        "Nelson Pde at Boswell Terrace, stop 88",
                        "Esplanade at Manly Baths, stop 87A",
                        "Kooralgin St near Arnold St"
                    ],
                    "5089: Moreton Bay, Thorneside, Cleveland": [
                        "Sommersea Dr near Genoa Ct hail 'n' ride",
                        "Little Shore St near Paxton St",
                        "Shore St near Paxton St",
                        "Shore St near Cross St",
                        "Middle St at Redlands RSL Services",
                        "Middle St at Island Street",
                        "Middle Street, stop A",
                        "Shore St at Black Swamp Wetlands",
                        "Gordon St near Cowley St",
                        "Gordon St at Ormiston Primary School",
                        "Sturgeon St near Wellington St",
                        "Sturgeon St near Delancey St",
                        "Old Cleveland Rd near Starkey St",
                        "Old Cleveland Rd at Kefford St",
                        "Old Cleveland Rd near McDonald Rd",
                        "Main Rd near Nelson Rd hail 'n' ride",
                        "Main Rd at Whepstead Manor",
                        "Main Rd near Crossley Dr",
                        "Main Rd near Courtice St",
                        "Main Rd at Apsley Street",
                        "Birkdale Rd at Wellington Point Shops",
                        "Birkdale Rd at EGW Wood Sportsfield",
                        "Birkdale Rd at Wellington Point High School",
                        "Birkdale Rd at Wellington Manor Village",
                        "Birkdale Rd at Edwardson Court",
                        "Birkdale Rd at Birkdale Fair",
                        "Birkdale Rd near Napier St",
                        "Mooroondu Rd near Thorne Rd",
                        "Mooroondu Rd near Alma St",
                        "Mooroondu Rd near Saul St",
                        "Thorneside Rd at Queens Esplanade",
                        "Thorneside Rd at Bayside Ct",
                        "Rickertt Rd at Tingalpa Creek",
                        "Rickertt Rd near Green Camp Rd",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Manly Rd at Lockwood Crescent, stop 53",
                        "Wondall Rd near Manly Rd",
                        "Moreton Bay Girls College",
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd at Kianawah Road South",
                        "Radford Rd near Lewis Neibling Pl",
                        "Radford Rd at Manly Vista",
                        "Caloundra St at Janoah Gardens",
                        "Moreton Bay Boys College",
                        "Network Dr at Brisbane Bayside State College",
                        "Wynnum Rd at BMX, stop 56/50",
                        "Wynnum Rd at Bognor Road, stop 45",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Barramundi, stop 62",
                        "Manly Rd at Amberjack Stop 61/56",
                        "Tilley Rd near Talltrees Cct",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Archer St",
                        "New Cleveland Rd near Green Camp Rd",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Clive Rd near Bandiera St",
                        "Byng Rd near Mecoli Ct",
                        "Byng Rd near Marcos St",
                        "Byng Rd near Almond Ave",
                        "Birkdale Rd at Collingwood Road",
                        "Thorneside Rd at Fisher Rd",
                        "Thorneside Rd at Leon St",
                        "Mooroondu Rd at Ethel St",
                        "Mooroondu Rd near Marlin St",
                        "Birkdale Rd at Birkdale Primary School",
                        "Main Rd near Station St",
                        "Main Rd near Wellington Point Farmhouse hail 'n' ride",
                        "Old Cleveland Rd near Main Rd",
                        "Old Cleveland Rd East at Kefford St",
                        "Sturgeon St near Starkey St",
                        "Sturgeon St at Delancey St",
                        "Gordon St near Bainbridge St",
                        "Middle Street, stop B"
                    ],
                    "5090: Brisbane Bayside, Moreton Bay, Carindale": [
                        "Wiles Rd near Lewis St hail 'n' ride",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Stanley Rd at Lunga Street, stop 39/40",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Creek Rd near Meadowlands Rd, stop 76/41",
                        "Creek Rd near Zahel St, stop 75",
                        "Creek Rd near Cuthred St, stop 75A",
                        "Old Cleveland Rd near Scrub Rd",
                        "Scrub Rd at Winstanley East",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Berkley - Scrub Rd South",
                        "Scrub Rd South near Oakley St",
                        "Kirra - Scrub Rd South",
                        "Winstanley St at Winstanley East",
                        "Winstanley St near Talavera St",
                        "Winstanley St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Carindale Shopping Centre station, platform J",
                        "Old Cleveland Rd near Adley St",
                        "Old Cleveland Rd at Barbeque St",
                        "Old Cleveland Rd near Stanbrough Rd",
                        "Archer Street near Boston Rd",
                        "Tilley Rd near London Rd",
                        "Boston Rd near Tilley Rd hail 'n' ride",
                        "Stanbrough Rd near Boston Rd",
                        "Stanbrough Rd near Grassdale Rd",
                        "Stanbrough Rd near Formosa St",
                        "Stanbrough Rd near New Cleveland Rd",
                        "New Cleveland Rd near Dairy Swamp Rd",
                        "New Cleveland Rd near Munda St",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Wondall Rd near Manly Rd",
                        "Moreton Bay Girls College",
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd at Kianawah Road South",
                        "Network Dr at Brisbane Bayside State College",
                        "Brisbane Bayside State College",
                        "Wynnum Rd at BMX, stop 50/56",
                        "Wynnum Rd at Plaza Street, stop 57",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58",
                        "Wynnum Rd at Wynnum West State School, stop 58A",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "Randall Rd near Wynnum Rd",
                        "Randall Rd at Natasha Street, stop 59",
                        "Randall Rd at Stockyard Street, stop 59a",
                        "Randall Rd at Network Drive, stop 60",
                        "Wondall Rd near Randall Rd",
                        "Wondall Rd at Kianawah Rd South hail 'n' ride",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Leon, stop 43",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Creek Rd near Bernecker St, stop 75a",
                        "Stanley Rd at Lunga Street, stop 40",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Wiles Rd opposite Lewis St hail 'n' ride"
                    ],
                    "5091: Capalaba, Moreton Bay Colleges & Lourdes": [
                        "Capalaba bus station, stop C",
                        "Old Cleveland Rd near Tinchborne St",
                        "Old Cleveland Rd near Swinton St",
                        "Old Cleveland Rd near Bacton Rd",
                        "Boston Rd near Tilley Rd hail 'n' ride",
                        "Stanbrough Rd near Boston Rd",
                        "London Rd near Tilly Rd",
                        "Tilley Rd at London Road",
                        "Tilley Rd near Grassdale Rd",
                        "Tilley Rd at Gumdale Primary School",
                        "New Cleveland Rd at Eastside Village",
                        "Caladium St near Matthews Way",
                        "Caladium St near Underwood St",
                        "Caladium St near Basella St",
                        "Arenga St near Williams St",
                        "Arenga St near Lexey Cres",
                        "Arenga St near Manly Rd",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Amberjack Stop 56/61",
                        "Manly Rd at Barramundi Stop 62",
                        "Moreton Bay Boys College",
                        "Caloundra St at Janoah Gardens",
                        "Radford Rd at Manly Vista",
                        "Radford Rd near Wondall Rd",
                        "Moreton Bay Girls College",
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd near Manly Rd",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Leon, stop 43",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Shops, stop 28",
                        "Wynnum Rd at School of Arts, stop 27",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Dutton St near Hawthorne Rd Mapping Stop",
                        "Virginia Ave near Aaron Ave"
                    ],
                    "5092: Moreton Bay Girls, Capalaba, Cleveland": [
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd near Manly Rd",
                        "Manly Rd at Lockwood Crescent, stop 53",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Dianthus St near Basella St",
                        "New Cleveland Rd at Eastside Village",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "Tilley Rd near Grassdale Rd",
                        "Archer Street near Boston Rd hail 'n' ride",
                        "Boston Rd near Tilley Rd",
                        "Bacton Rd near Tilley Rd",
                        "Geldart Rd near Bacton Rd",
                        "Mount Gravatt Capalaba Rd at Golf Driving Range",
                        "Capalaba bus station arrival stop 2"
                    ],
                    "5101: Cleveland, Victoria Point, Mt Cotton": [
                        "Smith St at Cleveland District High School",
                        "Bunker Rd at High St, stop A",
                        "Bunker Rd near Sandy Dr",
                        "Bunker Rd at Brendan Way",
                        "Mount Cotton Rd near Double Jump Rd hail 'n' ride",
                        "Mount Cotton Rd near Mt Cotton Primary School",
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Papaya St near Valley Way",
                        "Papaya St near Carissa St",
                        "Hardwood Dr near Seeana Dr hail 'n' ride",
                        "Hardwood Dr near Hoop Pine St hail 'n' ride",
                        "Hardwood Dr near German Church Rd hail 'n' ride",
                        "Valley Way near Mount Cotton Rd"
                    ],
                    "5102: Sheldon College, Mt Cotton Primary": [
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Serpentine Creek Rd near Christopher St",
                        "Collins St at Donald Road",
                        "Collins St near School of Arts Rd",
                        "School of Arts Rd near Fielding Rd",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Watsonia St",
                        "School of Arts Rd near German Church Rd",
                        "German Church Rd near Days Rd",
                        "German Church Rd near Valley Way hail 'n' ride",
                        "Bouquet Rd near Balthazar Cct hail 'n' ride",
                        "Heinemann Rd near Valley Way hail 'n' ride",
                        "Valley Way at Village Drive",
                        "Village Dr near Valley Way hail 'n' ride",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Seeana Dr near Pimelea Cr hail 'n' ride",
                        "Valley Way near Hardwood Dr",
                        "Hardwood Dr near Seeana Dr hail 'n' ride",
                        "Hardwood Dr near Hoop Pine St hail 'n' ride",
                        "Hardwood Dr near German Church Rd hail 'n' ride",
                        "Carissa St near Begonia Cr",
                        "Begonia St near Durian St hail 'n' ride",
                        "Orchid Dr near Flindersia Dr",
                        "Orchid Dr at Durian Street",
                        "Papaya St near Valley Way",
                        "Valley Way near Mount Cotton Rd",
                        "Mount Cotton Rd near Sanctuary Dr hail 'n' ride",
                        "Sanctuary Dr near Wrights Pl hail 'n' ride",
                        "Mt Cotton Primary School",
                        "Mount Cotton Rd near Mt Cotton Primary School",
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Papaya St near Carissa St",
                        "Valley Way at Seeana Dr",
                        "Valley Way near Taffeta Dr",
                        "Valley Way near German Church Rd hail 'n' ride",
                        "Collins St at Torquay Road",
                        "Serpentine Creek Rd at Christopher St"
                    ],
                    "5103: Mt Cotton Primary, Cotton Ridge, Bayview": [
                        "Mount Cotton Rd near Mt Cotton Primary School",
                        "Valley Way near Mt Cotton Rd hail 'n' ride",
                        "Papaya St near Valley Way",
                        "Orchid Dr near Durian Cr",
                        "Orchid Dr near Flindersia Dr",
                        "Begonia St near Durian St hail 'n' ride",
                        "Papaya St near Carissa St",
                        "Valley Way at Seeana Dr",
                        "Valley Way near Seeana Dr hail 'n' ride",
                        "Village Dr near Valley Way hail 'n' ride",
                        "Valley Way near Taffeta Dr",
                        "Bouquet Rd near Balthazar Cct hail 'n' ride",
                        "Heinemann Rd near Valley Way hail 'n' ride"
                    ],
                    "5110: Cleveland State, Cleveland High": [
                        "Cleveland State School",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Long St at Topatig Street",
                        "Long St near Fitzroy St hail 'n' ride",
                        "Passage St near Jacaranda Ct",
                        "Passage St near Russell St",
                        "Passage St near Queen St",
                        "Emmett Drive near Middle St hail 'n' ride",
                        "Emmett Drive at Toondah Harbour Ferry"
                    ],
                    "5113: Toondah Harbour, Cleveland Primary & High": [
                        "Sturgeon St near Starkey St",
                        "Sturgeon St at Delancey St",
                        "Sturgeon St near Wellington St",
                        "Gordon St at Ormiston Primary School",
                        "Gordon St near Bainbridge St",
                        "Shore St at Black Swamp Wetlands",
                        "Cleveland station",
                        "Shore St West at Fitzroy Street",
                        "Shore St at Passage Street",
                        "Emmett Drive near Middle St hail 'n' ride",
                        "Emmett Drive at Toondah Harbour Ferry",
                        "Emmett Drive near Middle St",
                        "Middle St at Redlands RSL Services",
                        "Middle St at Island Street",
                        "Cleveland State School",
                        "Waterloo St near Russell St",
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Smith St near Long St",
                        "Smith St near Bay St",
                        "Bay St near Olympus Dr",
                        "Wellington St near South St",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Bayview State School",
                        "Carmel Catholic College"
                    ],
                    "5114: Redland Bay, Cleveland, Ormiston": [
                        "Redland Bay Marina, platform 2",
                        "Hamilton St at Pitt Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street",
                        "Charlie Buckler Memorial Sportsground",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Cleveland Redland Bay Rd near Finlandia Village",
                        "Cleveland Redland Bay Rd at Dinwoodie Rd",
                        "Cleveland Redland Bay Rd at Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near Melanie St",
                        "Cleveland Redland Bay Rd near South St",
                        "Bloomfield St at South Street",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Long St",
                        "Long St at Topatig Street",
                        "Smith St near Long St",
                        "Smith St at Cleveland Showground",
                        "Smith St at Cleveland District High School",
                        "Emmett Drive at Toondah Harbour Ferry",
                        "Emmett Drive near Middle St",
                        "Middle St at Redlands RSL Services",
                        "Middle St at Island Street",
                        "Cleveland State School",
                        "Bloomfield St near Russell St",
                        "Bloomfield St at Long Street",
                        "Bloomfield St at Princess Street",
                        "Bloomfield St at Donald Simpson Park",
                        "Cleveland station",
                        "Shore St at Black Swamp Wetlands",
                        "Shore St at RACQ",
                        "Delancey St near Freeth St",
                        "Delancey St near Sturgeon St"
                    ],
                    "5118: Redland Bay Primary, Redland Bay Rusbrook": [
                        "Gordon Rd at Redland Bay Primary School",
                        "School of Arts Rd near Watsonia St",
                        "Kalmia Dr near School of Arts Rd",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Fielding Rd",
                        "Collins St near School of Arts Rd",
                        "Collins St at Torquay Road",
                        "Torquay Rd near Torbay St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "McWilliam St at Phillip Street",
                        "Phillip St near Wilkie St",
                        "Serpentine Creek Rd at Christopher St",
                        "Oakland Ave near Shanahan St hail 'n' ride",
                        "Shanahan St near Michael St hail 'n' ride",
                        "Rusbrook St near Oakland Ave hail 'n' ride"
                    ],
                    "5119: Redland Bay, Victoria Pt Schools": [
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Bay St near Cane St hail 'n' ride",
                        "Peel St near Mill St",
                        "Peel St near James St",
                        "Hamilton St at Pitt Street",
                        "Redland Bay Marina, platform 2",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Gordon Rd near Main St hail 'n' ride",
                        "Gordon Rd at Redland Bay Primary School",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near School Rd",
                        "Colburn Ave near Point O'Halloran Rd",
                        "Colburn Ave at Thompson Street",
                        "Colburn Av at Edinburgh St",
                        "Colburn Av at White Street",
                        "Victoria Point Jetty",
                        "Colburn Av at Thompson Street",
                        "Colburn Ave near Daysland St",
                        "Colburn Ave at Point O'Halloran Road",
                        "Colburn Ave near Link Rd",
                        "Redland Bay Primary School",
                        "Gordon Rd near Blair St hail 'n' ride",
                        "Hamilton St near Broadwater Tce hail 'n' ride",
                        "Main St near Bay St hail 'n' ride",
                        "Broadwater Tce at Dart Street",
                        "Boundary St at Main Street"
                    ],
                    "5131: Carmel College, Faith, Sheldon College": [
                        "Carmel Catholic College",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Faith Lutheran College",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Bunker Rd at High St, stop A",
                        "Bunker Rd near Sandy Dr",
                        "Bunker Rd at Brendan Way",
                        "Bunker Rd at Brookvale Drive",
                        "Bunker Rd at High St, stop D",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Woodlands Dr near Boundary St",
                        "Woodlands Dr near Platres Dr",
                        "Woodlands Dr near Taylor Dr",
                        "Sheldon College",
                        "Mount Cotton Rd at Henderson Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Rd near Ney Rd",
                        "Avalon Rd at Summit Street",
                        "Kiwi St near Campbell Rd",
                        "Kiwi St near Emu St",
                        "Emu St near Avalon Rd",
                        "Avalon Rd near Campbell Rd",
                        "Pioneer Rd near Summit St",
                        "Summit St near Pioneer Rd",
                        "Avalon Rd near Summit St"
                    ],
                    "5134: Carmel College, Bayview State": [
                        "Callaghan Way near Greenup St",
                        "Callaghan Way at Brosnan Drive",
                        "Callaghan Way near Frost St",
                        "Spirit Dr at Sunburst Ct",
                        "Korawal St near Timbarra Ct",
                        "Lyndon Rd near Korawal St",
                        "Vienna Rd near Redland Bay Rd hail 'n' ride",
                        "Vienna Rd at Burwood Road",
                        "Vienna Rd at Wimborne Road",
                        "Vienna Rd near Redruth Rd",
                        "Alexandra Cct near Keynsham St",
                        "Hanover Dr near Garden St",
                        "Hanover Dr near Glenella Ct",
                        "Hanover Dr near Nanette Ct",
                        "Alexandra Cct at Hilliard Primary School",
                        "Alexandra Cct near Goorawin St",
                        "Vienna Rd at Alexandra Circuit",
                        "Vienna Rd near Canterbury St",
                        "Vienna Rd near Cumberland Dr",
                        "Vienna Rd near Finucane Rd",
                        "Finucane Rd at Vienna Woods",
                        "Finucane Rd at Birch Street",
                        "Finucane Rd at McDonald Road",
                        "Finucane Rd at Dawson Road",
                        "Finucane Rd at Redland Research Station",
                        "Shore St at Grant Street",
                        "Shore St at RACQ",
                        "Shore St at Black Swamp Wetlands",
                        "Cleveland station",
                        "Shore St West at Fitzroy Street",
                        "Shore St at Passage Street",
                        "Shore St near Paxton St",
                        "Little Shore St near Paxton St",
                        "Shore St at Fitzroy Street",
                        "Wynyard St near Princess St",
                        "Fitzroy St near Princess St",
                        "Fitzroy St near Sturt St",
                        "Fitzroy St near Baypark Ct",
                        "Beach St near Cleary St",
                        "Beach St at Goleby Esp",
                        "McLeod St near Goleby Esp",
                        "South St near Manning Esp",
                        "Clifford Perske Dr near Kriskyle Pl",
                        "Clifford Perske Dr near Thornlands Rd",
                        "Thornlands Rd near Ribbonwood St",
                        "Island Outlook Ave at Sylvie Street",
                        "Island Outlook Ave near Margery St",
                        "Manhattan Ave near Sunview St",
                        "Panorama Dr at Manhattan Avenue",
                        "Moselle Dr near Cabernet Cr",
                        "Moselle Dr near Chateau St",
                        "Moselle Dr near Ziegenfusz Rd",
                        "Bayview State School",
                        "Carmel Catholic College"
                    ],
                    "5137: St Anthonys, Alexandra Hills High": [
                        "Lyndon Rd near Mount Cotton Rd",
                        "Lyndon Rd near Firtree St",
                        "Lyndon Rd near Kurrajong St",
                        "Lyndon Rd near Honeymyrtle Ct",
                        "Lyndon Rd near Korawal St",
                        "Merriott Ct near Burwood Rd",
                        "Alexandra Cct near Goorawin St",
                        "Vienna Rd near Wimborne Rd",
                        "Alexandra Cct near Keynsham St",
                        "Hanover Dr near Garden St",
                        "Hanover Dr near Glenella Ct",
                        "Hanover Dr near Nanette Ct",
                        "Alexandra Cct at Hilliard Primary School",
                        "Vienna Rd at Alexandra Circuit",
                        "Vienna Rd near Canterbury St",
                        "Winchester Rd at Payne Ct",
                        "Heffernan Rd near Lawrence Ct",
                        "Cambridge Dr at Charles Court",
                        "Windemere Rd at Alexandra Hills High School",
                        "St Anthonys Primary School",
                        "Windemere Rd at Keith Surridge Park",
                        "Vienna Rd near Cambridge Dr",
                        "Heffernan Rd near OGorman St",
                        "Winchester Rd near Suthurst Ct",
                        "Vienna Rd at Wimborne Road",
                        "Lyndon Rd near Mahogany St",
                        "Lyndon Rd near Duncan Rd"
                    ],
                    "5138: St Anthonys, Alexandra Hills, Birkdale": [
                        "St Anthonys Primary School",
                        "Finucane Rd at Alexandra Hills High School",
                        "Abelia St near Ellora St",
                        "Abelia St near Babiana St",
                        "Valantine Rd near Leith St",
                        "Valantine Rd near Bailey Rd",
                        "Barron Rd at Birkdale South Primary School",
                        "Burbank Rd near Barron Rd",
                        "Spoonbill St near Peacock Ct",
                        "Tulloch Dr at Redgrove Ave",
                        "Tulloch Dr near Biscay St",
                        "Old Cleveland Rd near Main Rd",
                        "Allenby Rd near Montgomery Dr",
                        "McDonald Rd near Montgomery Dr",
                        "McDonald Rd at MacDonald Road Park",
                        "Dawson Rd near McMillan Rd",
                        "Dawson Rd near Dean Rd",
                        "Finucane Rd at Dawson Road",
                        "Finucane Rd at Redland Research Station",
                        "Delancey St near Freeth St",
                        "Delancey St near Sturgeon St",
                        "Old Cleveland Rd near Starkey St",
                        "Old Cleveland Rd at Kefford St",
                        "Old Cleveland Rd near McDonald Rd",
                        "Main Rd near Nelson Rd hail 'n' ride",
                        "Main Rd at Whepstead Manor",
                        "Main Rd near Crossley Dr",
                        "Main Rd near Courtice St",
                        "Main Rd at Apsley Street",
                        "Birkdale Rd at Wellington Point Shops",
                        "Birkdale Rd at EGW Wood Sportsfield",
                        "Birkdale Rd at Wellington Point High School",
                        "Birkdale Rd at Wellington Manor Village",
                        "Birkdale Rd at Edwardson Court",
                        "Birkdale Rd at Birkdale Fair",
                        "Birkdale Rd near Napier St",
                        "Agnes St at Birkdale Primary School",
                        "Thorne Rd at Mary St",
                        "Mooroondu Rd near Thorne Rd",
                        "Mooroondu Rd near Alma St",
                        "Mooroondu Rd near Saul St",
                        "Mooroondu Rd at John St",
                        "Thorneside Rd near John St",
                        "Thorneside Rd at Hugh Street",
                        "Thorneside Rd at Queens Esplanade",
                        "Thorneside Rd at Bayside Ct",
                        "Quarry Rd near Rosewood St",
                        "Birkdale Rd at Collingwood Road",
                        "Byng Rd at Almond Ave",
                        "Byng Rd near Mecoli Ct",
                        "Clive Rd near Bandiera St",
                        "Rickertt Rd at Tingalpa Creek",
                        "Rickertt Rd near Green Camp Rd",
                        "Tilley Rd near Katherine St",
                        "Tilley Rd near Talltrees Cct",
                        "Tilley Rd at New Cleveland Road",
                        "Tilley Rd near Grassdale Rd",
                        "Grassdale Rd near Archer St",
                        "Archer Street near Boston Rd hail 'n' ride"
                    ],
                    "5153: Victoria Pt Schools, Faith Snr, Cleveland": [
                        "Victoria Point High School",
                        "Benfer Rd at Poinciana Avenue",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Bangalow Street",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near School Rd",
                        "Colburn Ave near Link Rd",
                        "Faith Lutheran College",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Bunker Rd at High St, stop C",
                        "Bunker Rd near Sandy Dr",
                        "Bunker Rd at Brendan Way",
                        "Springacre Rd near Eprapah Rd",
                        "Boundary Rd at Woodlands Drive",
                        "Panorama Drive near Boundary Rd",
                        "Panorama Dr at Milner Pl",
                        "Moselle Dr near Cabernet Cr",
                        "Moselle Dr near Chateau St",
                        "Moselle Dr near Ziegenfusz Rd",
                        "Bayview State School",
                        "Vintage Dr at Bayview State School",
                        "Vintage Dr near Abalone Cr",
                        "Vintage Dr near Noir Ct",
                        "Island Outlook Ave near Margery St",
                        "Manhattan Ave near Sunview St",
                        "Panorama Dr at Robert Mackie Park",
                        "Panorama Dr near Laurette Ave",
                        "Panorama Dr near South St",
                        "South St near Fitzroy St",
                        "South St near Langdon St",
                        "McLeod St near Beach St",
                        "Beach St at Goleby Esp",
                        "Beach St near Cleary St",
                        "Fitzroy St near Tarcutta St",
                        "Fitzroy St near Baypark Ct",
                        "Fitzroy St near Sturt St",
                        "Long St near Fitzroy St hail 'n' ride",
                        "Passage St near Jacaranda Ct",
                        "Passage St near Russell St",
                        "Passage St near Queen St",
                        "Middle St at Redlands RSL Services",
                        "Middle St at Island Street",
                        "Middle Street, stop A"
                    ],
                    "5154: Cleveland, Victoria Point, Redland Bay": [
                        "Smith St at Cleveland District High School",
                        "Smith St near Long St",
                        "Smith St near Bay St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near South St",
                        "Cleveland Redland Bay Rd near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Victoria Point Central, platform 2",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Cleveland Redland Bay Rd near Creekwood St",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "School of Arts Rd near Watsonia St",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Queen St",
                        "Queen St near School of Arts Rd",
                        "Queen St at Keirnan Street",
                        "Government Rd at Queen St",
                        "Redlands Satellite Health Centre",
                        "Redland Bay Marina, platform 2"
                    ],
                    "5155: Victoria Point High, Redland Bay Marina": [
                        "Redland Bay Marina, platform 2",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Gordon Rd near Main St hail 'n' ride",
                        "Gordon Rd at Redland Bay Primary School",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Victoria Point High School",
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Hamilton St at Pitt Street"
                    ],
                    "5156: Victoria Point High, Rocky Passage": [
                        "Victoria Point High School",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Gordon Rd at Redland Bay Primary School",
                        "Gordon Rd near Blair St hail 'n' ride",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Fielding Rd",
                        "Collins St near School of Arts Rd",
                        "Collins St at Torquay Road",
                        "Torquay Rd near Torbay St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "McWilliam St at Phillip Street",
                        "Phillip St near Wilkie St",
                        "Serpentine Creek Rd at Christopher St",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Serpentine Creek Rd near Kidd St hail 'n' ride",
                        "Serpentine Creek Rd near Scenic Rd hail 'n' ride",
                        "Shoreline Ave at Jingeri St",
                        "Shoreline Ave at Hydrangea Ave",
                        "Scenic Rd near Orchard Rd hail 'n' ride",
                        "Vine St near Alisa St hail 'n' ride",
                        "Orchard St near Scenic Rd hail 'n' ride",
                        "Lagoon View Rd near Orchard Rd hail 'n' ride",
                        "Muriel St near Albert St hail 'n' ride",
                        "Muriel St near Wallaby Rd hail 'n' ride",
                        "Rocky Passage Rd near Serpentine Creek Rd HnR"
                    ],
                    "5158: Cleveland, Victoria Point, Redland Bay": [
                        "Victoria Point High School",
                        "Peppermint Dr near Mulberry Ct",
                        "Sycamore Pde near Wisteria Ct",
                        "Link Rd near Jeanne Dr",
                        "Colburn Ave near School Rd",
                        "Benfer Rd at Bangalow Street",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Poinciana Avenue",
                        "Benfer Rd near Prescoter Dr",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Hamilton St at Pitt Street",
                        "Redland Bay Marina, platform 2",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Watsonia St",
                        "School of Arts Rd near German Church Rd",
                        "German Church Rd near School of Arts Rd",
                        "Gordon Rd at Redland Bay Primary School"
                    ],
                    "5165: San Sisto College, Carindale": [
                        "Mayfield Rd at San Sisto Convent",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Old Cleveland Rd near Gallipoli Rd Stop 37",
                        "Carindale Shopping Centre station, platform J"
                    ],
                    "5172: Capalaba, Birkdale, Wellington Point": [
                        "Capalaba bus station, stop A",
                        "Finucane Rd at Old Cleveland Rd",
                        "Finucane Rd at Willard Road",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Finucane Rd at Keith Surridge Park",
                        "Finucane Rd at Alexandra Hills Shops",
                        "Finucane Rd at Vienna Road",
                        "Allenby Rd near Finucane Rd",
                        "Allenby Rd near Monarch St",
                        "Allenby Rd near Balmoral St",
                        "Old Cleveland Rd near McDonald Rd",
                        "Old Cleveland Rd near Randall Rd",
                        "Old Cleveland Rd near Rossinton St",
                        "Burbank Rd near Barron Rd",
                        "Spoonbill St near Peacock Ct",
                        "Collingwood Rd at Serendipity Close",
                        "Prins Willem Alexander Village",
                        "Collingwood Road at Redland Mobile Village",
                        "Byng Rd at Almond Ave",
                        "Byng Rd near Mecoli Ct",
                        "Clive Rd near Bandiera St",
                        "Boorana St near Tempi St hail 'n' ride",
                        "Kunden St near Mond St hail 'n' ride",
                        "Thorneside Rd near Bayside Ct",
                        "Thorneside Rd at Fisher Rd",
                        "Thorneside Rd at Leon St",
                        "Thorneside Rd near jean St",
                        "Jean St near Mooroondu Rd",
                        "Mooroondu Rd near Nora St",
                        "Mooroondu Rd near Saul St",
                        "Mooroondu Rd at Ethel St",
                        "Mooroondu Rd near Marlin St",
                        "Mary St at Birkdale Primary School",
                        "Birkdale Rd at Birkdale Primary School",
                        "Birkdale Rd at Birkdale Fair",
                        "Birkdale Rd at Edwardson Court",
                        "Birkdale Rd at Wellington Manor Village",
                        "Birkdale Rd at Wellington Point High School",
                        "Wellington Point State High School",
                        "Birkdale Rd near Napier St",
                        "Agnes St at Birkdale Primary School",
                        "Thorne Rd at Mary St",
                        "Mooroondu Rd near Thorne Rd",
                        "Mooroondu Rd near Alma St",
                        "Mooroondu Rd near Fisher Rd",
                        "Mooroondu Rd at John St",
                        "Thorneside Rd at Helen Street",
                        "Thorneside Rd near John St",
                        "Thorneside Rd at Hugh Street",
                        "Thorneside Rd at Queens Esplanade",
                        "Thorneside Rd at Bayside Ct",
                        "Byng Rd near Marcos St",
                        "Byng Rd near Almond Ave",
                        "Birkdale Rd at Collingwood Road",
                        "Collingwood Rd at Redlands Mobile Village",
                        "Collingwood Dr at Serendipity Close",
                        "Spoonbill St near Sunnybay Dr",
                        "Burbank Rd near Spoonbill St",
                        "Old Cleveland Rd near Currawong Dr",
                        "Old Cleveland Rd East at Randall Rd",
                        "Old Cleveland Rd near Main Rd",
                        "Allenby Rd near Montgomery Dr",
                        "Allenby Rd at Monarch St",
                        "Allenby Rd near Topaz St",
                        "Finucane Rd at Alexandra Hills High School",
                        "Moreton Bay Rd at Dan St",
                        "Capalaba park 'n' ride, platform 1",
                        "Capalaba bus station arrival stop 1"
                    ],
                    "5173: Tingalpa - Wellington Point High": [
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Grassdale Rd near Belmont Rd",
                        "Grassdale Rd at Stanbrough Rd",
                        "Stanbrough Rd near Grassdale Rd",
                        "Stanbrough Rd near Formosa St",
                        "Caladium St near Matthews Way",
                        "Caladium St near Underwood St",
                        "Caladium St near Basella St",
                        "Basella St near Arenga St",
                        "Dianthus St near Basella St",
                        "New Cleveland Rd at Eastside Village",
                        "New Cleveland Rd near Judd St",
                        "New Cleveland Rd near Feathertail Pl",
                        "New Cleveland Rd near Green Camp Rd",
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Rickertt Rd near Green Camp Rd",
                        "Rickertt Rd at Tingalpa Creek",
                        "Quarry Rd near Rosewood St",
                        "Birkdale Rd at Birkdale Primary School",
                        "Birkdale Rd at Birkdale Fair",
                        "Birkdale Rd at Edwardson Court",
                        "Birkdale Rd at Wellington Manor Village",
                        "Birkdale Rd at Wellington Point High School",
                        "Wellington Point State High School",
                        "Birkdale Rd near Napier St",
                        "Green Camp Rd near New Cleveland Rd",
                        "New Cleveland Rd near Archer St",
                        "Dianthus St near Isaacs Way",
                        "Ermelo Rd near New Cleveland Rd",
                        "Stanbrough Rd at Formosa St",
                        "Grassdale Rd near Stanbrough Rd",
                        "Belmont Rd at Hillcroft Place, stop 59/5"
                    ],
                    "5174: Brisbane Bayside SC Local Loop": [
                        "Network Dr at Brisbane Bayside State College",
                        "Wynnum Rd at BMX, stop 56/50",
                        "Wynnum Rd at Bognor Road, stop 45",
                        "Wynnum Rd at Hemmant Cemetery, stop 44",
                        "Wynnum Rd at Arena, stop 43",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Wondall Rd near Manly Rd",
                        "Wondall Rd opp Moreton Bay College",
                        "Bognor Rd near Torquay Cres hail 'n' ride"
                    ],
                    "5175: Scenic Shores Primary School": [
                        "Rocky Passage Rd near Serpentine Creek Rd HnR",
                        "Muriel St near Wallaby Rd hail 'n' ride",
                        "Orchard Rd near Scenic Rd hail 'n' ride",
                        "Vine St near Alisa St hail 'n' ride",
                        "Shoreline Ave at Jingeri St",
                        "Shoreline Ave at Hydrangea Ave",
                        "Serpentine Creek Rd near Scenic Rd hail 'n' ride",
                        "Serpentine Creek Rd near Kidd St hail 'n' ride",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd",
                        "Oakland Ave near Shanahan St hail 'n' ride",
                        "Shanahan St near Michael St hail 'n' ride",
                        "Rusbrook St near Oakland Ave hail 'n' ride",
                        "Oakland Ave near Serpentine Creek Rd hail 'n' ride",
                        "Serpentine Creek Rd near Christopher St",
                        "Phillip St near Wilkie St",
                        "McWilliam St at Phillip St",
                        "Torquay Rd near McWilliam St hail 'n' ride",
                        "Torquay Rd East near Jania St",
                        "Collins St at Donald Road",
                        "Collins St near School of Arts Rd",
                        "School of Arts Rd near Fielding Rd",
                        "School of Arts Rd near Queen St",
                        "School of Arts Rd near Bedarra St",
                        "School of Arts Rd near Watsonia St",
                        "School of Arts Rd near German Church Rd",
                        "German Church Rd near School of Arts Rd",
                        "Gordon Rd at Redland Bay Primary School",
                        "Scenic Shores State School",
                        "Redland Bay Primary School",
                        "Gordon Rd near Syracuse St hail 'n' ride",
                        "Collins St at Torquay Road",
                        "Torquay Rd near Torbay St hail 'n' ride",
                        "McWilliam St at Phillip Street",
                        "Serpentine Creek Rd at Christopher St",
                        "Scenic Rd near Orchard Rd hail 'n' ride",
                        "Orchard St near Scenic Rd hail 'n' ride",
                        "Lagoon View Rd near Orchard Rd hail 'n' ride",
                        "Muriel St near Albert St hail 'n' ride"
                    ],
                    "5176: Cleveland High, Vic Pt High, Redland Bay Primary": [
                        "Smith St at Cleveland District High School",
                        "Smith St at Cleveland Showground",
                        "Smith St near Long St",
                        "Smith St near Bay St",
                        "Bloomfield St near Bay St",
                        "Bloomfield St near Beach St",
                        "Bloomfield St near South St",
                        "Cleveland Redland Bay Rd near South St",
                        "Cleveland Redland Bay Rd near Thornlands Rd",
                        "Cleveland Redland Bay Rd near Island Outlook Ave",
                        "Cleveland Redland Bay Rd near William Stewart Park",
                        "Cleveland Redland Bay Rd near Ziegenfusz Rd",
                        "Cleveland Redland Bay Rd at Ziegenfusz Dr",
                        "Cleveland Redland Bay Rd at Dinwoodie Road",
                        "Cleveland Redland Bay Rd near Beveridge Rd",
                        "Victoria Point Central, platform 2",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Cleveland Redland Bay Rd near Creekwood St",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Hamilton St at Pitt Street",
                        "Redland Bay Marina, platform 2",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Fielding Rd",
                        "Collins St near School of Arts Rd",
                        "Collins St at Torquay Road",
                        "Serpentine Creek Rd at Christopher St",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd"
                    ],
                    "5177: Cleveland State High, Cleveland Primary School": [
                        "Kinross Rd near East Ridge St hail 'n' ride",
                        "Kinross Rd near Kingsdale Ave hail 'n' ride",
                        "Boundary Rd at Kinross Road",
                        "Panorama Drive near Boundary Rd",
                        "Ziegenfusz Rd near Panorama Dr",
                        "Moselle Dr near Hermitage Cr",
                        "Moselle Dr near Chateau St",
                        "Moselle Dr near Cabernet Cr",
                        "Panorama Dr near Manhattan Ave",
                        "Panorama Dr at Robert Mackie Park",
                        "Panorama Dr near Laurette Ave",
                        "Panorama Dr near South St",
                        "Thornlands State School",
                        "South St at Redlands District Special School",
                        "South St at Osprey Drive",
                        "Wellington St near Enterprise St",
                        "Bay St near Wellington St",
                        "Smith St near Bay St",
                        "Smith St near Long St",
                        "Smith St at Cleveland Showground",
                        "Smith St at Cleveland District High School",
                        "Russell St at Cleveland District High School",
                        "Bloomfield St near Russell St",
                        "Cleveland State School",
                        "Bay St near Olympus Dr",
                        "Wellington St near South St",
                        "South St near Osprey Dr",
                        "Panorama Dr at Abbotsleigh Street",
                        "Panorama Dr at Manhattan Avenue",
                        "Moselle Dr near Ziegenfusz Rd",
                        "Panorama Dr near Milner Pl",
                        "Panorama Dr near Boundary Road",
                        "Boundary Rd at Woodlands Drive"
                    ],
                    "5178: Victoria Point High - Serpentine Creek Rd": [
                        "Victoria Point High School",
                        "Benfer Rd at Cleveland Redland Bay Road",
                        "Cleveland Redland Bay Rd at Anita Street",
                        "Cleveland Redland Bay Rd at Double Jump Road",
                        "Charlie Buckler Memorial Sportsground",
                        "Broadwater Tce at Main Street",
                        "Boundary St at Dart Street",
                        "Broadwater Tce at Redland Bay Shops",
                        "Hamilton St at Pitt Street",
                        "Redland Bay Marina, platform 2",
                        "Redlands Satellite Health Centre",
                        "Government Rd at Queen St",
                        "Gordon Rd near Main St hail 'n' ride",
                        "Gordon Rd at Redland Bay Primary School",
                        "Queen St at Keirnan Street",
                        "Queen St at School of Arts Road",
                        "School of Arts Rd near Fielding Rd",
                        "Collins St near School of Arts Rd",
                        "Collins St at Torquay Road",
                        "Serpentine Creek Rd at Christopher St",
                        "Serpentine Creek Rd near Cleveland Redland Bay Rd"
                    ],
                    "5179: Iona College Express - Mayfair then Eastside Vill": [
                        "Iona College Lindum Primary",
                        "Wondall Rd at Moreton Bay College",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "Stanbrough Rd near New Cleveland Rd",
                        "New Cleveland Rd at Eastside Village",
                        "Tilley Rd at New Cleveland Road",
                        "Tilley Rd near Grassdale Rd",
                        "Tilley Rd near London Rd",
                        "The Sleeman Centre, stop C"
                    ],
                    "5180: Sheldon - Capalaba SS and Coolnwynpin SS": [
                        "Kiwi St near Campbell Rd",
                        "Kiwi St near Emu St",
                        "Emu St near Avalon Rd",
                        "Avalon Rd near Campbell Rd",
                        "Pioneer Rd near Summit St",
                        "Summit St near Pioneer Rd",
                        "Avalon Rd near Summit St",
                        "Ney Rd near Koala Pl",
                        "Degen Rd near Ney St",
                        "Degen Rd near St Lukes Ct",
                        "Mount Cotton Rd near Jacaranda Rd",
                        "Wentworth Dr near Blaxland St",
                        "Wentworth Dr near Cunningham St",
                        "Wentworth Dr near Bute St",
                        "Ney Rd at Jeffrey Street",
                        "School Rd at Toni Street",
                        "School Rd near Gandarra St",
                        "School Rd at Capalaba State College",
                        "Mount Cotton Rd near Killarney Cr",
                        "Mount Cotton Rd at Winter Memorial Park",
                        "Finucane Rd at Old Cleveland Rd",
                        "Finucane Rd at Willard Road",
                        "Elmhurst St near Sutphin St",
                        "Elmhurst St near Crotona Rd",
                        "Crotona Rd at Randwick St",
                        "Crotona Rd near Draycott St",
                        "Crotona Rd near Wicks Ct",
                        "Crotona Rd at Windemere Road",
                        "Cumberland Dr near Thirlmere Rd",
                        "Cumberland Dr near Sherington St",
                        "Cumberland Dr near Henley St",
                        "Cumberland Dr near Vienna Rd",
                        "Vienna Rd near Winchester Rd",
                        "Vienna Rd near Canterbury St",
                        "Vienna Rd at Alexandra Circuit",
                        "Vienna Rd near Wimborne Rd",
                        "Vienna Rd at Burwood Road",
                        "Lyndon Rd near Redland Bay Rd",
                        "Lyndon Rd near Korawal St",
                        "Korawal St near Timbarra Ct",
                        "Montana Dr at Ivana Ct",
                        "Spirit Dr at Sunburst Ct",
                        "Callaghan Way near Telaska Ct",
                        "Mount Cotton Rd near School Rd",
                        "Mount Cotton Rd near Howlett Rd",
                        "Callaghan Way near Greenup St",
                        "Callaghan Way at Brosnan Drive",
                        "Callaghan Way near Frost St",
                        "Montana Dr near Riley Dr",
                        "Vienna Rd near Redland Bay Rd hail 'n' ride",
                        "Vienna Rd at Wimborne Road",
                        "Vienna Rd near Redruth Rd",
                        "Vienna Rd near Cumberland Dr",
                        "Cumberland Dr at Henly St",
                        "Cumberland Dr at Sherrington Street",
                        "Moreton Bay Rd at Dan St",
                        "Capalaba park 'n' ride, platform 1",
                        "Mount Cotton Rd at Killarney Crescent",
                        "Degen Rd at St Lukes Catholic Primary School",
                        "Ney Rd at Koala Place",
                        "Avalon Rd at Summit Street"
                    ],
                    "5201: Redbank, Kruger, Goodna, St Francis": [
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "TJ Ryan Av near Forgan Smith St hail 'n' ride",
                        "T J Ryan Av near Hanlon Ct hail 'n' ride",
                        "Eagle St near TJ Ryan Ave",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Redbank Plaza",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Kanangra St at Balook Street",
                        "Kanangra St near Lemana St",
                        "Kanangra St at Cedar Road",
                        "Cedar Rd at Orana Street",
                        "Shanahan Pde at Tina Street",
                        "Shanahan Pde at School Road",
                        "School Rd at Redbank Plains State School",
                        "School Rd near Cashmere St hail 'n' ride",
                        "Glen Fairlie Ave near Redbank Plains Rd HnR",
                        "Small Cl near Henry Dr hail 'n' ride",
                        "Henty Dr near Knight St",
                        "Henty Dr near Martin Pl",
                        "Henty Dr near Benjamina Dr hail 'n' ride",
                        "Henty Dr near Kennedy Dr hail 'n' ride",
                        "Henty Dr at Batman Drive",
                        "Henty Dr at Kruger Parade",
                        "Kruger Pde at Kruger State School",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd at Kingsford Street",
                        "Curnow St near Howard St",
                        "Stuart St near Bellevue Rd",
                        "Cross St at Bellevue Road",
                        "Gorry St at Kilner Street",
                        "Gorry St at Dowden Street",
                        "Dowden St near Gorry St hail 'n' ride",
                        "Smiths Rd near Stephen Cr",
                        "Stanley St at Goodna Primary School",
                        "Goodna Shopping Centre",
                        "St Francis Xavier Catholic Primary School",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Brisbane Tce near Layard St hail 'n' ride",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at Brisbane River Terraces",
                        "Redbank station, stop B",
                        "Brisbane Rd at Redbank Primary School"
                    ],
                    "5202: Kruger, StPeter Clavier, Bundamba, Bremer": [
                        "Goodna station, stop A",
                        "Bertha Street near Mill Street hail 'n' ride",
                        "Bertha St near Eric St hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Fiona St near Rita Ct hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Rosemary St near Moonyean St hail 'n' ride",
                        "Rosemary St near Jones Rd hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Redbank Plains Rd at Kingsford Street",
                        "Curnow St near Howard St",
                        "Stuart St near Bellevue Rd",
                        "Cross St at Bellevue Road",
                        "Gorry St at Kilner Street",
                        "Gorry St at Dowden Street",
                        "Dowden St near Gorry St hail 'n' ride",
                        "Smiths Rd near Stephen Cr",
                        "Smiths Rd at Arne Street",
                        "Goodna Shopping Centre",
                        "Brisbane Tce near Layard St hail 'n' ride",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at Brisbane River Terraces",
                        "Redbank station, stop B",
                        "Mine Street at Brisbane Road",
                        "Redbank Plaza",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Duncan St near Old Ipswich Rd hail 'n' ride",
                        "Old Ipswich Rd at Ipswich Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd near Riverview Primary School",
                        "Old Ipswich Rd near Laura St",
                        "Acirl St at St Peter Claver College",
                        "Old Ipswich Rd at St Peter Claver Catholic College",
                        "Valerie St near Child St",
                        "Diamond St near Gibbs St",
                        "Price St at Hayden Street",
                        "Mitchell St at Tessman Street",
                        "Tessman St near Brian St hail 'n' ride",
                        "Endeavour Rd at Riverview Gardens",
                        "Riverview Rd at Maryanne Street",
                        "Riverview Rd at Kenneth Street",
                        "Riverview Rd near Jessica St hail 'n' ride",
                        "River Rd at Richard Street",
                        "River Rd near King St hail 'n' ride",
                        "River Rd at Dinmore station",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Ebbw Vale Station",
                        "Brisbane Rd at Railway Street",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at McCormack Street",
                        "Brisbane Rd near Braeside Rd hail 'n' ride",
                        "Brisbane Rd at Coal Street",
                        "Elms St near Naomi St hail 'n' ride",
                        "Naomai St at Bundamba Secondary College",
                        "Bundamba Secondary College",
                        "Thompson St near Naomi St",
                        "Thompson St near Wise St",
                        "Brisbane Rd at Bundamba Primary",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Brisbane Rd at Hamilton Street",
                        "Cothill Rd at Sacred Heart Catholic Primary School",
                        "Glebe St at Sacred Heart Catholic Primary School",
                        "Molloy St opp Silkstone Primary",
                        "Blackstone Rd opp Silkstone State School",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Salisbury Rd near Jackes St",
                        "Salisbury Rd at Thorn Street",
                        "Bremer State High School"
                    ],
                    "5204: Raceview, Sacred Heart, Collingwood Park": [
                        "Rose St near Tulip St hail 'n' ride",
                        "Cypress St near Jacaranda Dr hail 'n' ride",
                        "Jacaranda Dr near Aloe St",
                        "Nuala St near Jacaranda Dr",
                        "Tristania St near Ruthven Ct",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Hall Street",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Whitehill Rd near Anna Dr hail 'n' ride",
                        "Cascade St at Cascade Gardens",
                        "Raceview St at Rockman Drive",
                        "Raceview St at Westminister Crescent",
                        "Edwards St near Rockman Dr",
                        "Edwards St near Thornton St",
                        "South Station Rd near Rumsey Dr hail 'n' ride",
                        "Fischer Rd near Clarke St hail 'n' ride",
                        "Levi St near Scotts Rd hail 'n' ride",
                        "Fischer Rd near Scotts Rd hail 'n' ride",
                        "Edwards Street near South Station Rd hail 'n' ride",
                        "Wildey St near Edwards St hail 'n' ride",
                        "Wildey St near Rumsey Dr",
                        "Wildey St at Raceview Primary School",
                        "Wildey St near Nolan St",
                        "Wildey St at Brothers Leagues Club",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Auld St",
                        "South Station Rd at Long Lane",
                        "Glebe St at Sacred Heart Catholic Primary School",
                        "Blackstone Rd near Johnston St",
                        "Thomas St at Queen Street",
                        "Mary St near Hill Street",
                        "Old Ipswich Rd at St Peter Claver Catholic College",
                        "Old Ipswich Rd near Laura St",
                        "Old Ipswich Rd at Anderson Street",
                        "Old Ipswich Rd at Ipswich Street",
                        "Old Ipswich Rd at Maxwell Street",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Collingwood Dr at Old Ipswich Road",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Dr at Gibbs Avenue",
                        "Collingwood Dr near Paul Tully Ave hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "Gibbs Ave near TJ Ryan Ave hail 'n' ride",
                        "Gibbs Ave near Avoca Ct hail 'n' ride",
                        "Gibbs Ave near Genoa Pl hail 'n' ride",
                        "Gibbs Ave near Paul Tully Ave hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue hail 'n' ride",
                        "Collingwood Dr at Jamboree Park hail 'n' ride",
                        "Burrel St at Collingwood Park Primary"
                    ],
                    "5205: Redbank Plains, St Francis, Goodna": [
                        "River Rd at King Street",
                        "Riverview Rd at Kenneth Street",
                        "Tessman St near Brian St",
                        "Mitchell St at Tessman Street",
                        "Price St near Hayden St",
                        "Gibbs St near Diamond St",
                        "Diamond St near Valerie St",
                        "Old Ipswich Rd near Laura St",
                        "Old Ipswich Rd at Anderson Street",
                        "Old Ipswich Rd at Ipswich Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Nile St near Duncan St hail 'n' ride",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Collingwood Dr at Old Ipswich Road",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Katandra Cr near Jones Rd hail 'n' ride",
                        "Katandra Cr near Beryl Ct hail 'n' ride",
                        "Katandra Cr near Perdita St hail 'n' ride",
                        "Katandra Cr near Rosemary St hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Fiona St near Rita Ct hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Bertha St near Eric St hail 'n' ride",
                        "Mill St at McVeigh Court",
                        "St Francis Xavier Catholic Primary School",
                        "Alice St near Martha St hail 'n' ride",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Stanley St at Goodna Primary School",
                        "Smiths Rd near Stephen Cr hail 'n' ride",
                        "Smiths Rd hail 'n' ride",
                        "Gorry St at Dowden Street",
                        "Gorry St at Killner Street",
                        "Cross St near Hamar St",
                        "Stuart St at Bellevue Road",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Rosemary St near Moonyean St hail 'n' ride",
                        "Rosemary St near Jones Rd hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Redbank Plains Rd at Brennan Street",
                        "Batman Dr at Nigel Street",
                        "Henty Dr at Batman Drive",
                        "Henty Dr at Kruger Parade",
                        "Kruger Pde at Kruger State School"
                    ],
                    "5206: Bremer, Silkstone, Bethany, Raceview": [
                        "Providence Pde at Splendid Drive",
                        "Harmony Cr at Greenview Avenue",
                        "Parkway Ave hail 'n' ride",
                        "Parkway Ave at Ripley Valley Schools",
                        "Fitzgibbon Rd near Joy Chambers Cct hail 'n' ride",
                        "Panorama Cct near Edinburgh St hail 'n' ride",
                        "Brooking Ave near Parkview Pde hail 'n' ride",
                        "Parkview Pde near Lillypilly Dr hail 'n' ride",
                        "Levi St near Scotts Rd hail 'n' ride",
                        "Scotts Rd near Ripley Rd hail 'n' ride",
                        "Monterea Rd near Maguire St hail 'n' ride",
                        "Belle Pde near Optima St hail 'n' ride",
                        "Carpenter Dr near Rex Hills Dr hail 'n' ride",
                        "Rex Hills Dr near Cityhope Church hail 'n' ride",
                        "Ripley Rd at Trigona Drive",
                        "Fischer Rd near Scotts Rd hail 'n' ride",
                        "Cascade St near South Station Rd",
                        "Cascade St near Wildey St hail 'n' ride",
                        "Raceview St at Hayes Street",
                        "Cemetery Rd near Raceview St hail 'n' ride",
                        "Cemetery Rd near Whitehill Rd",
                        "Cemetery Rd near Warner St",
                        "Cemetery Rd at Briggs Road",
                        "Carr St at Warwick Road",
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Salisbury Rd at Thorn Street",
                        "Salisbury Rd near Briggs Rd",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Molloy St at Silkstone Primary School",
                        "Whitehill Rd near Raff St",
                        "Whitehill Rd near George Lane hail 'n' ride",
                        "Grange Rd near Edwards St",
                        "Robertson Rd near France St",
                        "Raceview St near Taylor St",
                        "Raceview St at Carlita Place",
                        "Cascade St at Bethany Lutheran Primary School",
                        "Cascade St near Wildey St",
                        "Fischer Rd near Clarke St hail 'n' ride",
                        "Melrose Dr at Rourke Park hail 'n' ride",
                        "Edwards Street near South Station Rd hail 'n' ride",
                        "Edwards St near Thornton St",
                        "Edwards St near Rockman Dr",
                        "Raceview St at Westminster Crescent",
                        "Raceview St at Rockman Drive",
                        "Wildey St at Raceview Primary School",
                        "Wildey St near Nolan St",
                        "Wildey St at Brothers Leagues Club",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Auld St",
                        "Blackstone Rd near Heather St"
                    ],
                    "5207: Bundamba, Bremer, Riverview, Redbank": [
                        "Duncan St near Old Ipswich Rd hail 'n' ride",
                        "Old Ipswich Rd at Ipswich Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd near Riverview Primary School",
                        "Old Ipswich Rd near Laura St",
                        "Valerie St near Child St",
                        "Diamond St near Gibbs St",
                        "Price St at Hayden Street",
                        "Mitchell St at Tessman Street",
                        "Tessman St near Brian St hail 'n' ride",
                        "Endeavour Rd at Riverview Gardens",
                        "Riverview Rd at Maryanne Street",
                        "Riverview Rd at Kenneth Street",
                        "River Rd at Richard Street",
                        "River Rd near King St hail 'n' ride",
                        "River Rd at Dinmore station",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Ebbw Vale Station",
                        "Brisbane Rd at Railway Street",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at McCormack Street",
                        "Brisbane Rd at Coal Street",
                        "Bergins Hill Rd at Bundamba Secondary College",
                        "Elms St near Naomi St hail 'n' ride",
                        "Naomai St at Bundamba Secondary College",
                        "Bundamba Secondary College",
                        "Thompson St near Naomi St",
                        "Thompson St near Wise St",
                        "Brisbane Rd at Bundamba Primary",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Brisbane Rd at Hamilton Street",
                        "Booval Fair",
                        "South Station Rd at Ivory Street",
                        "South Station Rd at Long Lane",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Salisbury Rd near Jackes St",
                        "Salisbury Rd at Thorn Street",
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Salisbury Rd near Briggs Rd",
                        "Brisbane Rd at Montauban Street",
                        "Brisbane Rd at Watson Street",
                        "Brisbane Rd at Eileen Street",
                        "Brisbane Rd at Nimmo Street",
                        "Brisbane Rd at Vowles Street",
                        "Brisbane Rd at Bundamba Swimming Centre",
                        "Brisbane Rd at Bundamba Uniting Church",
                        "Brisbane Rd at TAFE Queensland Ipswich campus",
                        "Brisbane Rd at Ebbw Vale station",
                        "River Rd at King Street",
                        "Tessman St near Brian St",
                        "Price St near Hayden St",
                        "Gibbs St near Diamond St",
                        "Diamond St near Valerie St",
                        "Old Ipswich Rd at Riverview Primary School",
                        "Nile St near Duncan St hail 'n' ride",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Collingwood Dr at Old Ipswich Road",
                        "Burrel St at Collingwood Park Primary",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Brisbane Rd at Redbank Primary School"
                    ],
                    "5208: East Ipswich, St Marys, Bremer, Bundamba": [
                        "Vale St near Perrett St hail 'n' ride",
                        "Vale St near Law St hail 'n' ride",
                        "Boundary St near Bognunda St hail 'n' ride",
                        "Mary St near River Rd hail 'n' ride",
                        "River Rd near Mafeking St hail 'n' ride",
                        "Nelson St near Wade St hail 'n' ride",
                        "Burgoyne St near Eclipse Ct hail 'n' ride",
                        "Cullen St near Jeffrey St hail 'n' ride",
                        "Mary St near Watkins St hail 'n' ride",
                        "Creek St at Bundamba station",
                        "Gledson St at Jack Barkley Park",
                        "Selwyn St near Roy St hail 'n' ride",
                        "David St near Diane Ct hail 'n' ride",
                        "David St near Christine St hail 'n' ride",
                        "Gledson St at Bergin Street",
                        "Logan St near Janet St hail 'n' ride",
                        "Logan St near Beth St hail 'n' ride",
                        "Beth St near Logan St hail 'n' ride",
                        "Baden Jones Way near Nixon Dr hail 'n' ride",
                        "North Station Rd near Soudan St hail 'n' ride",
                        "North Station Rd at Booval station",
                        "Jacaranda St near Tuggerah St",
                        "Jacaranda St near Cook St",
                        "Jacaranda St near Nathan St",
                        "Jacaranda St near Cotton St",
                        "Chermside Rd near McGill St",
                        "McGill St near Howard St",
                        "McGill St near Battye St",
                        "Springall St near Charlotte St",
                        "Charlotte St near Bowers St",
                        "Charlotte St near Blackall St",
                        "Blackall St near Goodwin St",
                        "Blackall St near Norman St",
                        "Blackall St near Barry St",
                        "Elizabeth St at St Mary's Primary School",
                        "Brisbane St near Bell St hail 'n' ride",
                        "East St at South Street",
                        "Ipswich Hospital, Stop C",
                        "Warwick Rd at Park Street",
                        "Warwick Rd at Short Street",
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Salisbury Rd at Thorn Street",
                        "Salisbury Rd near Briggs Rd",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Blackstone Rd at Coolibah Street",
                        "Molloy St at Silkstone Primary School",
                        "Glebe Rd near Cothill St",
                        "Stafford St near Videroni St",
                        "Brisbane Rd at Bundamba Swimming Centre",
                        "Bundamba State School"
                    ],
                    "5210: Ipswich Grammar, St Marys, Redbank": [
                        "Goodna Shopping Centre",
                        "Smiths Rd at Arne Street",
                        "Alice St near Albert Street hail 'n' ride",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Bertha St near Eric St hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Fiona St near Rita Ct hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Rosemary St near Moonyean St hail 'n' ride",
                        "Rosemary St near Jones Rd hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Redbank Plains Rd at Brennan Street",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Redbank Palms",
                        "Duncan St at Dancer Street",
                        "Collingwood Dr at Old Ipswich Road",
                        "Redbank Plaza",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Ebbw Vale Station",
                        "Brisbane Rd at Railway Street",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at McCormack Street",
                        "Brisbane Rd at Coal Street",
                        "Brisbane Rd at Bundamba Primary",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Brisbane Rd at Hamilton Street",
                        "Booval Fair",
                        "Brisbane Rd at Swifts Sports Club",
                        "Brisbane Rd at Bright Street",
                        "Brisbane Rd at Montauban Street",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Ellenborough St at Ellenborough Street",
                        "Waghorn St at Ipswich Grammar School",
                        "Elizabeth St at St Mary's Primary School",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Brisbane Rd at Watson Street",
                        "Brisbane Rd at Eileen Street",
                        "Brisbane Rd at Nimmo Street",
                        "Brisbane Rd at Vowles Street",
                        "Brisbane Rd at Bundamba Swimming Centre",
                        "Brisbane Rd at Bundamba Uniting Church",
                        "Brisbane Rd at TAFE Queensland Ipswich campus",
                        "Brisbane Rd at Ebbw Vale station",
                        "River Rd at Dinmore station",
                        "River Rd at King Street",
                        "Riverview Rd at Kenneth Street",
                        "Riverview Rd near Ursula St hail 'n' ride",
                        "Riverview Rd at Maryanne Street",
                        "Endeavour Rd at Riverview Gardens",
                        "Redbank Primary School",
                        "Mine Street at Brisbane Road",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Dr at Gibbs Avenue",
                        "Collingwood Dr near Paul Tully Ave hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "TJ Ryan Av near Forgan Smith St hail 'n' ride",
                        "T J Ryan Av near Hanlon Ct hail 'n' ride",
                        "Eagle St near TJ Ryan Ave",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School"
                    ],
                    "5211: Redbank Plains, St Peter Claver, Bundamba": [
                        "Bertha Street near Mill Street hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Alice St near Martha St hail 'n' ride",
                        "Goodna Shopping Centre",
                        "Smiths Rd at Arne Street",
                        "Smiths Rd near Bellevue Rd hail 'n' ride",
                        "Smiths Rd hail 'n' ride",
                        "Gorry St at Dowden Street",
                        "Gorry St at Killner Street",
                        "Cross St near Hamar St",
                        "Stuart St at Bellevue Road",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Redbank Plains Rd at Brennan Street",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Kanangra St at Balook Street",
                        "Kanangra St near Lemana St",
                        "Kanangra St at Cedar Road",
                        "Cedar Rd at Orana Street",
                        "Cedar Rd at Kentucky Street",
                        "Redbank Plains Rd at Brennan Park",
                        "School Rd at Redbank Plains State School",
                        "School Rd near Willow Rd West hail 'n' ride",
                        "Rice Rd near Henry Samuel Dr hail 'n' ride",
                        "Acirl St at St Peter Claver College",
                        "Old Ipswich Rd near Laura St",
                        "Old Ipswich Rd at Anderson Street",
                        "Nile St near Duncan St hail 'n' ride",
                        "Old Ipswich Rd at Maxwell Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd near Riverview Primary School",
                        "Valerie St near Child St",
                        "Diamond St near Gibbs St",
                        "Price St at Hayden Street",
                        "Mitchell St at Tessman Street",
                        "Tessman St near Brian St hail 'n' ride",
                        "Endeavour Rd at Riverview Gardens",
                        "Riverview Rd at Maryanne Street",
                        "Riverview Rd at Kenneth Street",
                        "River Rd at Richard Street",
                        "River Rd near King St hail 'n' ride",
                        "River Rd at Dinmore station",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Ebbw Vale Station",
                        "Brisbane Rd at Railway Street",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at McCormack Street",
                        "Brisbane Rd at Coal Street",
                        "Elms St near Naomi St hail 'n' ride",
                        "Naomai St at Bundamba Secondary College",
                        "Bundamba Secondary College",
                        "Thompson St near Naomi St",
                        "Thompson St near Wise St",
                        "Brisbane Rd at Bundamba Primary"
                    ],
                    "5212: St Marys, Ipswich Grammar, West Moreton": [
                        "Collingwood Dr at Old Ipswich Road",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Rd near Verran St hail 'n' ride",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Kanangra St at Balook Street",
                        "Kanangra St near Lemana St",
                        "Kanangra St at Cedar Road",
                        "Cedar Rd at Orana Street",
                        "Shanahan Pde at Tina Street",
                        "Shanahan Pde at School Road",
                        "School Rd at Redbank Plains State School",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Cedar Rd at Kentucky Street",
                        "Redbank Plains Rd at Brennan Park",
                        "Mary St at Blackstone Primary School",
                        "Mary St near Hill Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Thomas St at Queen Street",
                        "Blackstone Rd near Johnston St",
                        "Blackstone Rd near Cothill Rd",
                        "Blackstone Rd near Cole St hail 'n' ride",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd opp Silkstone State School",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Whitehill Rd near Raff St",
                        "Frederick St near Glebe St hail 'n' ride",
                        "Brisbane Rd at Montauban Street",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Ellenborough St at Ellenborough Street",
                        "Elizabeth St at St Mary's Primary School",
                        "Waghorn St near Waghorn St hail 'n' ride",
                        "Waghorn St near Ipswich Boys Grammar School",
                        "Brisbane St at Waghorn Street",
                        "Brisbane St at Ipswich City Square",
                        "Brisbane St at Marsden Parade",
                        "Griffith Rd at Ipswich Central State Primay School",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Molloy St at Silkstone Primary School"
                    ],
                    "5213: Kruger, Redbank Plains, St Francis Xavier": [
                        "Redbank Plaza",
                        "Collingwood Dr at Old Ipswich Road",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Kruger State School",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Alawoona St near Barkala St hail 'n' ride",
                        "Alawoona St near Lemana St hail 'n' ride",
                        "Alawoona St near Cedar Rd hail 'n' ride",
                        "Alawoona St near Dandenong Av hail 'n' ride",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "Glen Brae St near Frawley Dr hail 'n' ride",
                        "Glen Fairlie Ave near Redbank Plains Rd HnR",
                        "Redbank Plains Recreation Reserve",
                        "Henty Dr at Barnes Street",
                        "Henty Dr near Knight St",
                        "Henty Dr near Martin Pl",
                        "Henty Dr near Benjamina Dr hail 'n' ride",
                        "Henty Dr near Kennedy Dr hail 'n' ride",
                        "Henty Dr at Batman Drive",
                        "Henty Dr at Kruger Parade",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd at Kingsford Street",
                        "Curnow St near Howard St",
                        "Stuart St near Bellevue Rd",
                        "Cross St at Bellevue Road",
                        "Gorry St at Kilner Street",
                        "Gorry St at Dowden Street",
                        "Smiths Rd near Stephen Cr",
                        "Smiths Rd at Arne Street",
                        "Goodna Shopping Centre",
                        "St Francis Xavier Catholic Primary School",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Bertha St near Eric St hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Fiona St near Rita Ct hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Katandra Cr near Rosemary St hail 'n' ride",
                        "Katandra Cr near Perdita St hail 'n' ride",
                        "Katandra Cr near Beryl Ct hail 'n' ride",
                        "Katandra Cr near Jones Rd hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Willow Rd at Redbank Plains High School"
                    ],
                    "5214: Ipswich, StMarys, West Moreton": [
                        "Providence Pde at Splendid Drive",
                        "Harmony Cr at Greenview Avenue",
                        "Ripley Rd at Wensley Rd",
                        "Levi St near Scotts Rd hail 'n' ride",
                        "Fischer Rd near Scotts Rd hail 'n' ride",
                        "Melrose Dr at Rourke Park hail 'n' ride",
                        "Edwards Street near South Station Rd hail 'n' ride",
                        "Edwards St near Thornton St",
                        "Edwards St near Rockman Dr",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Whitehill Rd near Anna Dr hail 'n' ride",
                        "Whitehill Rd near McGill St",
                        "Cemetery Rd near Whitehill Rd",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Elizabeth St at St Mary's Primary School",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Leichhardt and One Mile Community Centre",
                        "Toongarra Rd near Coleman St hail 'n' ride",
                        "Toongarra St near Birrell St hail 'n' ride",
                        "Toongarra Rd near Aspinall St hail 'n' ride",
                        "Toongarra Rd near May St hail 'n' ride",
                        "Keswick Rd at West Moreton Anglican College"
                    ],
                    "5215: Bremer, Churchill, Blair, Ipswich": [
                        "Cunningham Hwy at Amberley Caravan Park",
                        "Coopers Rd near Willowbank Caravan Park HnR",
                        "Coopers Rd near Willowbank Dr",
                        "Tinworth St near Wigmore St hail 'n' ride",
                        "Sancroft St near Melbury St",
                        "Rose St near Tulip St hail 'n' ride",
                        "Cypress St near Jacaranda Dr hail 'n' ride",
                        "Jacaranda Dr near Aloe St",
                        "Nuala St near Jacaranda Dr",
                        "Tristania St near Ruthven Ct",
                        "Jacaranda Dr near Hanworth Dr hail 'n' ride",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Hall Street",
                        "Ash St at Kensington Drive",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Warwick Rd at Meadow Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Sheehan Lane",
                        "Warwick Rd at Perry Street",
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Salisbury Rd at Thorn Street",
                        "Salisbury Rd near Briggs Rd",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Grange Rd near Edwards St",
                        "Robertson Rd near France St",
                        "Raceview St near Taylor St",
                        "Raceview St at Carlita Place",
                        "Raceview St at Rockman Drive",
                        "Raceview St at Westminister Crescent",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Ash St at Winston Glades Shopping Centre",
                        "Warwick Rd at Ash Street",
                        "Leichhardt and One Mile Community Centre",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Chubb St at Woodford Street",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Brisbane St at Hooper Street",
                        "Brisbane St at Tiger Street",
                        "Brisbane St at Clay Street",
                        "Burnett St at Blair State School",
                        "Kingsmill Rd at Robin Street",
                        "Albion St at Workshops Street",
                        "Hunter St at Brassall Shopping Village",
                        "Hunter St at Ipswich State High School",
                        "Ipswich State High School"
                    ],
                    "5216: Bundamba Primary, Bundamba High": [
                        "Bognuda St near Ashburn Rd hail 'n' ride",
                        "Bogunda St near Peacock Dr hail 'n' ride",
                        "Bird St near Bognuda St hail 'n' ride",
                        "Carberry St near Wall St hail 'n' ride",
                        "Vale St near Law St hail 'n' ride",
                        "Mary St near River Rd hail 'n' ride",
                        "River Rd near Mafeking St hail 'n' ride",
                        "Nelson St near Wade St hail 'n' ride",
                        "Nelson St near Burgoyne St hail 'n' ride",
                        "Andrew St near Hanlon St hail 'n' ride",
                        "Hart St near Cornish St hail 'n' ride",
                        "Egerton St near Hanlon St hail 'n' ride",
                        "Burgoyne St near Eclipse Ct hail 'n' ride",
                        "Cullen St near Jeffrey St hail 'n' ride",
                        "Mary St near Watkins St hail 'n' ride",
                        "River Rd near TAFE Queensland Ipswich campus",
                        "Creek St at Bundamba station",
                        "Gledson St at Jack Barkley Park",
                        "Gledson St at Bergin Street",
                        "Baden Jones Way near Nixon Dr hail 'n' ride",
                        "North Station Rd near Soudan St hail 'n' ride",
                        "North Station Rd at Booval station",
                        "Jacaranda St near Tuggerah St",
                        "Jacaranda St near Cook St",
                        "Jacaranda St near Nathan St",
                        "Jacaranda St near Cotton St",
                        "Blackall St at Norman Street",
                        "Blackall St near Davidson St",
                        "Charlotte St at Blackall Street",
                        "Charlotte St near Springall St",
                        "Springall St near Charlotte St",
                        "McGill St near Battye St",
                        "McGill St near Howard St",
                        "Chermside Rd near Goodwin St",
                        "Chermside Rd near Jacaranda St",
                        "Jacaranda St at Ipswich East Primary School",
                        "Jacaranda St at Nathan Street",
                        "Jacaranda St near Spengler St",
                        "Jacaranda St near Burton St",
                        "Jacaranda St near Welsby St",
                        "Dudleigh St near Clifton St",
                        "Hamilton St near Brisbane Rd hail 'n' ride",
                        "Bundamba State School",
                        "Brisbane Rd at Bundamba Primary",
                        "Naomai St at Bundamba Secondary College",
                        "Bundamba Secondary College"
                    ],
                    "5217: Ipswich, St Marys, Bremer, Blair": [
                        "Cunningham Hwy at Amberley Caravan Park",
                        "Coopers Rd near Willowbank Caravan Park HnR",
                        "Coopers Rd near Willowbank Dr",
                        "Tinworth St near Wigmore St hail 'n' ride",
                        "Sancroft St near Melbury St",
                        "Rose St near Tulip St hail 'n' ride",
                        "Cypress St near Jacaranda Dr hail 'n' ride",
                        "Jacaranda Dr near Aloe St",
                        "Nuala St near Jacaranda Dr",
                        "Tristania St near Ruthven Ct",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Hall Street",
                        "Ash St at Kensington Drive",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Warwick Rd at Meadow Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Showground",
                        "Warwick Rd at Showground North",
                        "Warwick Rd at Park Street",
                        "Waghorn St at Ipswich Grammar School",
                        "St Edmunds Secondary College",
                        "Mary St at St Marys Primary School",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Leichhardt and One Mile Community Centre",
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Gilmore St near Watsonia Dr",
                        "Avon St at Larsen St",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Fraser St near Everdina St hail 'n' ride",
                        "Kynance St near Maenporth St hail 'n' ride",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St",
                        "Old Toowoomba Rd at Immaculate Heart School",
                        "Perry St near Gibbs St hail 'n' ride",
                        "Bremer State High School",
                        "Burnett St at Blair State School",
                        "Kingsmill Rd at Robin Street",
                        "Kingsmill Rd near Hancock Bridge hail 'n' ride",
                        "Albion St at Workshops Street",
                        "Hunter St at Brassall Shopping Village",
                        "Hunter St at Ipswich State High School",
                        "Ipswich State High School"
                    ],
                    "5218: St Marys, Ipswich High, Amberley": [
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Hall Street",
                        "Warwick Rd at Meadow Street",
                        "Warwick Rd at Fitzroy Street",
                        "Leichhardt and One Mile Community Centre",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Chubb St at Woodford Street",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Gilmore St near Watsonia Dr",
                        "Avon St at Larsen St",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Wulkuraka station",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St",
                        "Brisbane St at Hooper Street",
                        "Brisbane St at Tiger Street",
                        "Brisbane St at Clay Street",
                        "Waghorn St at Ipswich Grammar School",
                        "St Edmunds Secondary College",
                        "Mary St at St Marys Primary School",
                        "Woodend Rd near Waghorn St hail 'n' ride",
                        "Kingsmill Rd at Robin Street",
                        "Kingsmill Rd near Hancock Bridge hail 'n' ride",
                        "Albion St at Workshops Street",
                        "Hunter St at Brassall Shopping Village",
                        "Hunter St at Ipswich State High School",
                        "Ipswich State High School",
                        "Workshops St at Sutton Park",
                        "Burnett St at Blair State School",
                        "Brisbane St at Keogh Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Ash Street",
                        "Yamanto Shopping Centre",
                        "Cunningham Hwy at Amberley Caravan Park",
                        "Coopers Rd near Willowbank Caravan Park HnR",
                        "Coopers Rd near Willowbank Dr",
                        "Tinworth St near Wigmore St hail 'n' ride",
                        "Sancroft St near Melbury St",
                        "Heit St near Ipswich Rosewood Rd hail 'n' ride",
                        "Deebing Creek Rd at Amberley State School",
                        "Amberley District State School"
                    ],
                    "5220: St Marys, Churchill, Raceview, Silkstone": [
                        "Edwards Street near South Station Rd hail 'n' ride",
                        "Edwards St near Thornton St",
                        "Edwards St near Rockman Dr",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Whitehill Rd near Anna Dr hail 'n' ride",
                        "Whitehill Rd near McGill St",
                        "Cemetery Rd near Edinburgh St hail 'n' ride",
                        "Raceview St at Taylor Street",
                        "Grange Rd near Robertson Rd",
                        "Grange Rd near Edwards St",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Glebe Rd near Frederick St hail 'n' ride",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Ellenborough St at Ellenborough Street",
                        "Elizabeth St at St Mary's Primary School",
                        "Brisbane St near Bell St hail 'n' ride",
                        "East St at South Street",
                        "Ipswich Hospital, Stop C",
                        "Warwick Rd at Park Street",
                        "Warwick Rd at Short Street",
                        "Warwick Rd at Bremer High",
                        "Bremer State High School",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Meadow Street hail 'n' ride",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Deebing Creek Rd at Amberley State School",
                        "Kuril Dr near Lakeview Dr HnR",
                        "Kuril Dr near Lakeview Dr hail 'n' ride",
                        "Warwick Rd at Hall Street",
                        "Rose St near Tulip St hail 'n' ride",
                        "Cypress St near Jacaranda Dr hail 'n' ride",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Meadow Street",
                        "Warwick Rd at Sheehan Lane",
                        "Warwick Rd at Showground",
                        "Carr St at Thorn Street",
                        "Cemetery Rd at Vernon Street",
                        "Cemetery Rd near Orchard St",
                        "Cemetery Rd near Whitehill Rd",
                        "Raceview St at Carlita Place",
                        "Cascade St at Bethany Lutheran Primary School",
                        "Cascade St near Wildey St",
                        "Cascade St near South Station Rd",
                        "South Station Rd at Harding Street",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Auld St",
                        "Blackstone Rd near Church St",
                        "Blackstone Rd near Johnston St",
                        "Creek St near Blackstone Rd",
                        "Stafford St near Chilcott St",
                        "Stafford St near Videroni St",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Brisbane Rd at Hamilton Street",
                        "Cothill Rd at Sacred Heart Catholic Primary School",
                        "Glebe St at Sacred Heart Catholic Primary School",
                        "Molloy St opp Silkstone Primary",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Griffith Rd opp Ipswich Central State School"
                    ],
                    "5221: St Marys, Bremer, Raceview, Silkstone": [
                        "Duncan St at Dancer Street",
                        "Collingwood Dr at Old Ipswich Road",
                        "Redbank Plaza",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Ebbw Vale Station",
                        "Brisbane Rd at Railway Street",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at McCormack Street",
                        "Brisbane Rd at Coal Street",
                        "Brisbane Rd at Bundamba Primary",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Brisbane Rd at Hamilton Street",
                        "Booval Fair",
                        "Brisbane Rd at Swifts Sports Club",
                        "Brisbane Rd at Bright Street",
                        "Brisbane Rd at Montauban Street",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Ellenborough St at Ellenborough Street",
                        "Waghorn St at Ipswich Grammar School",
                        "St Edmunds Secondary College",
                        "Mary St at St Marys Primary School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Warwick Rd at Short Street",
                        "Bremer State High School",
                        "Carr St at Thorn Street",
                        "Cemetery Rd at Vernon Street",
                        "Cemetery Rd near Orchard St",
                        "Cemetery Rd near Whitehill Rd",
                        "Cemetery Rd near Edinburgh St hail 'n' ride",
                        "Raceview St at Taylor Street",
                        "Robertson Rd near Whitehill Rd",
                        "Whitehill Rd near McGill St",
                        "Whitehill Rd near Chapel St hail 'n' ride",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Reif St at Fairview Park",
                        "Reif St at Plover Street",
                        "Reif St at Wallace St",
                        "Ripley Rd at Kingston Drive",
                        "Ripley Rd at Hibiscus Street",
                        "Ripley Rd at Edwards Street",
                        "Edwards St near Rockman Dr",
                        "Edwards St near Thornton St",
                        "Wildey St near Edwards St hail 'n' ride",
                        "Wildey St near Rumsey Dr",
                        "Wildey St at Raceview Primary School",
                        "Cascade St near Wildey St",
                        "Cascade St near South Station Rd",
                        "South Station Rd at Harding Street",
                        "Robertson Rd near France St",
                        "Salisbury Rd near Jackes St",
                        "Salisbury Rd at Thorn Street",
                        "Salisbury Rd near Briggs Rd",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Blackstone Rd at Coolibah Street",
                        "Molloy St at Silkstone Primary School"
                    ],
                    "5223: West Moreton Anglican College": [
                        "Wildey St near Edwards St hail 'n' ride",
                        "Wildey St near Rumsey Dr",
                        "Raceview St at Rockman Drive",
                        "Raceview St at Westminister Crescent",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Ash St at Winston Glades Shopping Centre",
                        "Ash St at Kensington Drive",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Warwick Rd at Ash Street",
                        "Warwick Rd at Hall Street",
                        "Jacaranda Dr near Rose St",
                        "Cypress St near Tulip St hail 'n' ride",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Meadow Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Sheehan Lane",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Showground",
                        "Salisbury Rd at Thorn Street",
                        "Salisbury Rd near Briggs Rd",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Limestone St at Waghorn Street",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Leichhardt and One Mile Community Centre",
                        "Toongarra Rd near Coleman St hail 'n' ride",
                        "Toongarra St near Birrell St hail 'n' ride",
                        "Toongarra Rd near Aspinall St hail 'n' ride",
                        "Toongarra Rd near May St hail 'n' ride",
                        "Keswick Rd at West Moreton Anglican College",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Avon Street",
                        "Toongarra Rd at Leichhardt Primary",
                        "Old Toowoomba Rd at Immaculate Heart School",
                        "Woodford St near Vineyard St hail 'n' ride",
                        "Chubb St at Woodford Street",
                        "Perry St near Gibbs St hail 'n' ride",
                        "Bremer State High School"
                    ],
                    "5226: Camira, Ipswich Grammar, St Marys": [
                        "Goodna station, stop A",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Alice St near Parker St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Newman St near Mirrin St hail 'n' ride",
                        "Newman St near Braggan St hail 'n' ride",
                        "Newman St near Globe St hail 'n' ride",
                        "Old Logan Rd at Julieanne Street",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Vanessa Court",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd at Hallett Avenue",
                        "Old Logan Rd near Stella St hail 'n' ride",
                        "Cairns Rd near Old Logan Rd hail 'n' ride",
                        "Cairns Rd near Meier Rd hail 'n' ride",
                        "Hayes Ave near Woodlands Ave hail 'n' ride",
                        "Woodlands Ave near Hallett Ave hail 'n' ride",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Ishmael Rd",
                        "Garden Ave near Cochrane St hail 'n' ride",
                        "Blue Gum Dr near Addison Rd hail 'n' ride",
                        "Addison Rd near Allamanda Dr hail 'n' ride",
                        "Addison Rd near Ishmael Rd hail 'n' ride",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Ishmael Rd near Moss Rd",
                        "Angela St near Moss Rd",
                        "Angela St near Jean Rd hail 'n' ride",
                        "Fran St near Steven St",
                        "Kertes Rd near Pharoah St",
                        "Mur Bvd near Sharpless Rd",
                        "Sharpless Rd near Zircon St",
                        "Topaz Rd near Sharpless Rd",
                        "Topaz Rd at Springfield Fair",
                        "Springfield Pkwy at Panorama Drive",
                        "Springfield Pwy at Escarpment Drive",
                        "Springfield Lakes Bvd at Springfield Lakes Shops",
                        "Spring Lake Village 4",
                        "Orion Springfield Central",
                        "Eden Station Dr near Brookwater Dr hail 'n' ride",
                        "Augusta Pkwy at Eden Station Drive",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Forester Avenue",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop D",
                        "Redbank Plains Rd at Brennan Park",
                        "Mary St at Blackstone Primary School",
                        "Mary St near Hill Street",
                        "Thomas St at Queen Street",
                        "Blackstone Rd near Johnston St",
                        "Blackstone Rd near Cothill Rd",
                        "Blackstone Rd near Cole St hail 'n' ride",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Chermside Rd near Rockton St hail 'n' ride",
                        "Ipswich Girls Grammar School",
                        "Blackall St near Norman St",
                        "Blackall St near Barry St",
                        "Waghorn St at Ipswich Grammar School",
                        "St Edmunds Secondary College",
                        "Ipswich station, stop C"
                    ],
                    "5227: Goodna, Springfield, Springfield Central": [
                        "Spring Lake Village 1",
                        "Lakeside Ave near Burlington Tce",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Janus Gr",
                        "Lakeside Ave near Coventina Cr",
                        "Summit Dr near Lakeside Ave",
                        "Summit Dr near Liberty Cr",
                        "Springfield Lakes Bvd near The Promenade",
                        "Springfield Lakes Bvd near Parkview Dr",
                        "Springfield Lakes Bvd near Lakes Entrance Drive",
                        "Lakes Entrance Dr near Foreshore Dr",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Grande Ave near Oak Leaf Dr",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave at Angelica Avenue",
                        "Springfield Central State School",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High",
                        "Grande Ave at Woodline Dr",
                        "Grande Ave at Dublin Ave",
                        "Grand Ave at Applecross Cct",
                        "Grande Ave at Sierra Drive",
                        "Spring Mountain Bvd at Grande Ave",
                        "Spring Mountain Bvd at London Avenue",
                        "Sinnathamby Bvd at Parkside Business Park",
                        "Orion Springfield Central",
                        "Eden Station Dr near Brookwater Dr hail 'n' ride",
                        "Augusta Pkwy at Eden Station Drive",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "St Augustines College"
                    ],
                    "5228: St Augustine, Redbank, Camira, Woodcrest": [
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd at Hallett Avenue",
                        "Old Logan Rd near Stella St hail 'n' ride",
                        "Cairns Rd near Old Logan Rd hail 'n' ride",
                        "Cairns Rd near Meier Rd hail 'n' ride",
                        "Hayes Ave near Woodlands Ave hail 'n' ride",
                        "Woodlands Ave near Hallett Ave hail 'n' ride",
                        "Woodlands Ave near Old Logan Rd hail 'n' ride",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Ishmael Rd",
                        "Czarnecki St near Lowana St hail 'n' ride",
                        "Czarnecki St near Odra St hail 'n' ride",
                        "Franklin St near Cochrane St hail 'n' ride",
                        "Garden Ave near Cochrane St hail 'n' ride",
                        "Blue Gum Dr near Addison Rd hail 'n' ride",
                        "Addison Rd near Allamanda Dr hail 'n' ride",
                        "Addison Rd near Ishmael Rd hail 'n' ride",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Ishmael Rd near Moss Rd",
                        "Angela St near Moss Rd",
                        "Angela St near Jean Rd hail 'n' ride",
                        "Fran St near Steven St",
                        "Kertes Rd near Shiral Ct hail 'n' ride",
                        "Wilson Dr near Kertes Rd hail 'n' ride",
                        "Wilson Dr near Corial Ct hail 'n' ride",
                        "Wilson Dr near Durham Ct hail 'n' ride",
                        "Wilson Dr near Paula Ct hail 'n' ride",
                        "Wilson Dr near Myra Ct hail 'n' ride",
                        "Kertes Rd near Pharoah St",
                        "Mur Bvd near Sharpless Rd",
                        "Sharpless Rd near Zircon St",
                        "Topaz Rd near Sharpless Rd",
                        "Topaz Rd at Springfield Fair",
                        "Woodcrest Way near Woodcrest College",
                        "Woodcrest Way near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Karamea Ave near Bridgewater Rd",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Springfield Pkwy at Panorama Drive",
                        "Springfield Pwy at Springfield Greenbank Art",
                        "Springfield Pwy at Escarpment Drive",
                        "Spring Lake Village 1",
                        "Springfield Lakes Bvd at Springfield Lakes Shops",
                        "Spring Lake Village 4",
                        "Augusta Pkwy at Eden Station Drive",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "St Augustines College",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Forester Avenue",
                        "Jones Rd near Augusta Pkwy",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd at Kingsford Street",
                        "Queen Rd near Azure St hail 'n' ride",
                        "Queen Rd at Marie Street hail 'n' ride",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Alice St near Parker St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Newman St near Mirrin St hail 'n' ride",
                        "Newman St near Braggan St hail 'n' ride",
                        "Newman St near Globe St hail 'n' ride",
                        "Marshall St near Gay St hail 'n' ride",
                        "Ashworth St near Connell St hail 'n' ride",
                        "Karina St near Nagel St hail 'n' ride",
                        "Hogan St near Karina St hail 'n' ride",
                        "Hogan St near Nagel St hail 'n' ride",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Vanessa Court",
                        "Old Logan Rd at Langley Road hail 'n' ride",
                        "Old Logan Rd near Dale Rd hail 'n' ride",
                        "Old Logan Rd near Allan Rd hail 'n' ride",
                        "Old Logan Rd near Steven St hail 'n' ride",
                        "Old Logan Rd near Brendan St West hail 'n' ride",
                        "Old Logan Rd near Nev Smith Dr hail 'n' ride",
                        "Woodcrest College",
                        "Springfield Pkwy at Springfield Greenbank Arterial",
                        "Hymba Yumba Community Hub (Springfield) HnR"
                    ],
                    "5229: Redbank Plains, St Augustine, Woodcrest": [
                        "Wacol station",
                        "Wilruna St at Wacol train station",
                        "Wilruna St at Wilga Street",
                        "Wilruna St at Wuriga St",
                        "Wilruna St at Gailes station",
                        "Old Logan Rd at Julieanne Street",
                        "Baker St at Fiesta Caravan Park hail 'n' ride",
                        "Hogan St near Nagel St hail 'n' ride",
                        "Hogan St near Karina St hail 'n' ride",
                        "Karina St near Nagel St hail 'n' ride",
                        "Marshall St near Old Logan Rd hail 'n' ride",
                        "Newman St near Caswell St hail 'n' ride",
                        "Newman St near Dulin St hail 'n' ride",
                        "Newman St near Killalan St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Alice St near Allan St hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Alice St near Martha St hail 'n' ride",
                        "Queen Rd at Marie Street hail 'n' ride",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Redbank Plains Rd at Brennan Street",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Jones Rd near Augusta Pkwy",
                        "Augusta Pkwy at Forester Avenue",
                        "Augusta Pkwy near Grangewood Ave hail 'n' ride",
                        "St Augustines College",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Spring Lake Village 1",
                        "Lakeside Ave near Burlington Tce",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Janus Gr",
                        "Lakeside Ave near Coventina Cr",
                        "Summit Dr near Lakeside Ave",
                        "Summit Dr near Liberty Cr",
                        "Springfield Lakes Bvd near The Promenade",
                        "Springfield Lakes Bvd near Parkview Dr",
                        "Springfield Lakes Bvd near Lakes Entrance Drive",
                        "Springfield Pkwy at Panorama Drive",
                        "Springfield Pkwy at Bob Gibbs Park hail 'n' ride",
                        "Woodcrest College"
                    ],
                    "5231: StAugustines, Redbank Plains, Springfield": [
                        "Goodna station, stop A",
                        "Bertha St near Eric St hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Fiona St near Rita Ct hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Katandra Cr near Rosemary St hail 'n' ride",
                        "Katandra Cr near Perdita St hail 'n' ride",
                        "Katandra Cr near Beryl Ct hail 'n' ride",
                        "Katandra Cr near Jones Rd hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Augusta Pkwy at Forester Avenue",
                        "Santa Monica Dr near McAuley Cr",
                        "Santa Monica Dr near Christopher St hail 'n' ride",
                        "Santa Monica Dr near Hallow Cr",
                        "Santa Monica Dr near Oudeman St",
                        "Santa Monica Dr near Ambrose Dr",
                        "Santa Monica Dr at Oudeman Street",
                        "Santa Monica Dr near Mcauley Cr",
                        "St Augustines College",
                        "Augusta Pkwy at Saint Augustines College",
                        "Cardena Dr near Brigid Bvd hail 'n' ride",
                        "Bellbird Dr near Columbia Dr hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop D",
                        "Henty Dr at Barnes Street",
                        "Argyle St near Price Cl",
                        "Argyle St near McBrien Ct hail 'n' ride",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Alawoona St near Barkala St hail 'n' ride",
                        "Alawoona St near Lemana St hail 'n' ride",
                        "Alawoona St near Cedar Rd hail 'n' ride",
                        "Alawoona St near Dandenong Av hail 'n' ride",
                        "Alawoona St at Ingles Drive",
                        "Ingles Dr at McNamara Place",
                        "Fernbrooke Bvd at Ingles Drive",
                        "School Rd near Fernbrooke Bvd",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Willow Rd at Redbank Plains High School",
                        "Brittains Rd at Augusta State School",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Sinnathamby Bvd near Main St hail 'n' ride",
                        "Sinnathamby Bvd at Parkside Business Park",
                        "Health Care Dr at UniSQ",
                        "Wellness Way at Health Care Dr",
                        "Springfield Central State High"
                    ],
                    "5232: Grand Ave, Forest Lake, St Marks, Glenala": [
                        "Goodna station, stop A",
                        "Waterford Rd at Carole Park Primary School",
                        "David St at Stephen Street",
                        "John Street near Skepper St",
                        "Southampton Rd at Sinclair Drive",
                        "Doreen Cr near Southampton Rd",
                        "Southampton Rd near Sinclair Dr",
                        "Sinclair Dr at Julie Road",
                        "Roxwell Street at Roxwell Street",
                        "Roxwell St at Lovat Street",
                        "Grand Ave West near Centennial Way",
                        "Grand Ave at Grand Avenue School",
                        "Grand Ave at Grand Avenue Lake",
                        "Grand Ave at Grand Avenue Cascade",
                        "Grand Ave East near Ascot Ave",
                        "Forest Lake Shops",
                        "Forest Lake Bvd near The Esplanade hail 'n' ride",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Forest Lake Bvd at St Johns Anglican College",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Government Rd near Flower Pl",
                        "Government Rd near Archerfield Rd, stop 75",
                        "Poinsettia St near Archerfield Rd, stop 76",
                        "Poinsettia St at Richlands Campus, stop 59/77",
                        "Hydrangea St near Frangipani St, stop 59",
                        "Eucalypt St opp St Marks Catholic Primary School",
                        "Rosemary St at Rosemary South, stop 75A",
                        "Glenala High School",
                        "Glenala Rd at Glenala East, stop 71",
                        "Glenala Rd at Hampton Rd",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Inala Ave at Gannett Street, stop 79/57",
                        "Inala Ave at Poinsettia Street, stop 78/58",
                        "Poinsettia St at Richlands Campus, stop 77/59",
                        "Poinsettia St near Mira St, stop 76",
                        "Government Rd near Rudyard St, stop 75",
                        "Forest Lake Bvd at Forest Lake Shops"
                    ],
                    "5233: Camira State School, Woodcrest College": [
                        "Old Logan Rd near Vanessa Ct",
                        "Baker St at Fiesta Caravan Park hail 'n' ride",
                        "Hogan St near Nagel St hail 'n' ride",
                        "Hogan St near Karina St hail 'n' ride",
                        "Karina St near Nagel St hail 'n' ride",
                        "Marshall St near Old Logan Rd hail 'n' ride",
                        "Old Logan Rd at Julieanne Street",
                        "Newman St near Caswell St hail 'n' ride",
                        "Newman St near Dulin St hail 'n' ride",
                        "Newman St near Killalan St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Alice St near Allan St hail 'n' ride",
                        "Mill St at McVeigh Court",
                        "St Francis Xavier Catholic Primary School",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Smiths Rd at Arne Street",
                        "Stanley St at Goodna Primary School",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Alice St near Parker St hail 'n' ride",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd at Hallett Avenue",
                        "Old Logan Rd near Stella St hail 'n' ride",
                        "Cairns Rd near Old Logan Rd hail 'n' ride",
                        "Cairns Rd near Meier Rd hail 'n' ride",
                        "Hayes Ave near Woodlands Ave hail 'n' ride",
                        "Woodlands Ave near Hallett Ave hail 'n' ride",
                        "Woodlands Ave near Old Logan Rd hail 'n' ride",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Ishmael Rd",
                        "Czarnecki St near Lowana St hail 'n' ride",
                        "Czarnecki St near Odra St hail 'n' ride",
                        "Franklin St near Cochrane St hail 'n' ride",
                        "Garden Ave near Cochrane St hail 'n' ride",
                        "Blue Gum Dr near Addison Rd hail 'n' ride",
                        "Addison Rd near Allamanda Dr hail 'n' ride",
                        "Addison Rd near Ishmael Rd hail 'n' ride",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Ishmael Rd near Moss Rd",
                        "Angela St near Moss Rd",
                        "Angela St near Jean Rd hail 'n' ride",
                        "Fran St near Steven St",
                        "Kertes Rd near Shiral Ct hail 'n' ride",
                        "Wilson Dr near Kertes Rd hail 'n' ride",
                        "Wilson Dr near Corial Ct hail 'n' ride",
                        "Wilson Dr near Durham Ct hail 'n' ride",
                        "Wilson Dr near Paula Ct hail 'n' ride",
                        "Wilson Dr near Myra Ct hail 'n' ride",
                        "Kertes Rd near Pharoah St",
                        "Old Logan Rd near Brendan St West hail 'n' ride",
                        "Old Logan Rd near Nev Smith Dr hail 'n' ride",
                        "Springfield Pkwy at Bob Gibbs Park hail 'n' ride",
                        "Springfield Pkwy at Springfield Fair hail 'n' ride",
                        "Woodcrest Way near Woodcrest College",
                        "Woodcrest College"
                    ],
                    "5234: Kruger, Redbank Plains High": [
                        "Namatjira Dr at Drysdale Ave hail 'n' ride",
                        "Duncan St at Dancer Street",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Rd near Irving Ct hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue",
                        "Paul Tully Ave near Hayden Dr hail 'n' ride",
                        "Paul Tully Ave near Warburton Ct hail 'n' ride",
                        "Paul Tully Ave near Dawson Ct hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "TJ Ryan Av near Forgan Smith St hail 'n' ride",
                        "T J Ryan Av near Hanlon Ct hail 'n' ride",
                        "Eagle St near TJ Ryan Ave",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Rd near Verran St hail 'n' ride",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "River Rd at Dinmore station",
                        "River Rd at King Street",
                        "Riverview Rd at Kenneth Street",
                        "Riverview Rd near Ursula St hail 'n' ride",
                        "Riverview Rd at Maryanne Street",
                        "Endeavour Rd at Riverview Gardens",
                        "Tessman St near Brian St",
                        "Mitchell St at Tessman Street",
                        "Price St near Hayden St",
                        "Gibbs St near Diamond St",
                        "Diamond St near Valerie St",
                        "Old Ipswich Rd near Laura St",
                        "Old Ipswich Rd at Anderson Street",
                        "Old Ipswich Rd at Riverview Primary School",
                        "Nile St near Duncan St hail 'n' ride",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Collingwood Dr at Old Ipswich Road",
                        "Collingwood Dr near Paul Tully Ave hail 'n' ride",
                        "Kruger Pde at Kruger State School"
                    ],
                    "5235: Forest Lake, St Augustines College": [
                        "Garden Rd at Government Road",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Woogaroo St at Forest Lake Primary",
                        "Woogaroo St at Lochwood Ave",
                        "Grand Ave West near Centennial Way",
                        "Grand Ave at Grand Avenue School",
                        "Grand Ave at Grand Avenue Lake",
                        "Grand Ave at Grand Avenue Cascade",
                        "Grand Ave East near Ascot Ave",
                        "Forest Lake Shops",
                        "College Ave at Hillbrook",
                        "College Ave at Halifax Court",
                        "Joseph Banks Ave near Leichhardt Cct",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "St John's Anglican College near Alpine Pl",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "St Augustines College",
                        "Augusta Pkwy at Saint Augustines College",
                        "Spring Lake Village 1",
                        "Lakeside Ave near Burlington Tce",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Janus Gr",
                        "Lakeside Ave near Coventina Cr",
                        "Lakeside Av near Daydream Cr hail 'n' ride",
                        "Springfield Lakes Bvd near Parkview Dr",
                        "Springfield Lakes Bvd near Lakes Entrance Drive",
                        "Lakes Entrance Dr near Foreshore Dr",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Grande Ave near Oak Leaf Dr",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave at Angelica Avenue",
                        "Springfield Central State School",
                        "Good Shepherd Catholic Primary School",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High"
                    ],
                    "5236: Redbank Shops, Orion, Springfield Central": [
                        "Redbank station, stop B",
                        "Mine Street at Brisbane Road",
                        "Collingwood Dr at Old Ipswich Road",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Jones Rd near Augusta Pkwy",
                        "Augusta Pkwy at Forester Avenue",
                        "Santa Monica Dr near McAuley Cr",
                        "Santa Monica Dr near Christopher St hail 'n' ride",
                        "Santa Monica Dr near Hallow Cr",
                        "Santa Monica Dr near Oudeman St",
                        "Santa Monica Dr near Ambrose Dr",
                        "Santa Monica Dr at Oudeman Street",
                        "Santa Monica Dr near Mcauley Cr",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Spring Lake Village 1",
                        "Lakeside Ave near Burlington Tce",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Janus Gr",
                        "Lakeside Ave near Coventina Cr",
                        "Summit Dr near Lakeside Ave",
                        "Summit Dr near Liberty Cr",
                        "Springfield Lakes Bvd near The Promenade",
                        "Springfield Lakes Bvd near Parkview Dr",
                        "Springfield Lakes Bvd near Lakes Entrance Drive",
                        "Lakes Entrance Dr near Foreshore Dr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Grande Ave near Oak Leaf Dr",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave at Angelica Avenue",
                        "Springfield Central State School",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High",
                        "Wellness Way at Health Care Dr",
                        "Education City",
                        "Orion Springfield Central",
                        "Health Care Dr at UniSQ",
                        "Good Shepherd Catholic Primary School"
                    ],
                    "5237: Brassall, Ipswich, Churchill, Bremer": [
                        "Collingwood Dr at Old Ipswich Road",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Namatjira Dr at Drysdale Avenue",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Mount Crosby Rd near Lumbye Pl hail 'n' ride",
                        "Mount Crosby Rd near Church St",
                        "Mount Crosby Rd at Ipswich Caravan Village",
                        "Moores Pocket Rd near Wood St",
                        "Moores Pocket Rd at Tivoli Gardens",
                        "Moores Pocket Rd at Bremer Waters Village",
                        "Moores Pocket Rd at Bremer Waters Resort",
                        "Moores Pocket Rd at Bremer Waters",
                        "Mount Crosby Rd near Croydon St",
                        "Mount Crosby Rd near Greasley St",
                        "Hill St near Phie St",
                        "Hill St at Cyprus Street",
                        "Cyprus St at Hefferan St",
                        "Cyprus St near Simmons Rd",
                        "Allen St near Francis St",
                        "Holdsworth Rd near Roberts St",
                        "Holdsworth Rd near Paten St",
                        "Holdsworth Rd near Holmes St",
                        "Holmes St at Holdsworth Road",
                        "Waterworks Rd at Simmons Road",
                        "Pine Mountain Rd near Shelley St hail 'n' ride",
                        "Pine Mountain Rd at Glossop Street",
                        "Pine Mountain Rd at Brassall Primary School",
                        "Hunter St at Ipswich State High School",
                        "Hunter St at Brassall Shopping Village",
                        "Albion St at Workshops Street",
                        "Kingsmill Rd at Robin Street",
                        "Burnett St at Blair State School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Warwick Rd at Short Street",
                        "Bremer State High School"
                    ],
                    "5238: Ipswich Boys Grammar, St Marys": [
                        "Warwick Rd at Meadow Street hail 'n' ride",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Reif St at Fairview Park",
                        "Reif St at Plover Street",
                        "Reif St at Wallace St",
                        "Ripley Rd at Kingston Drive",
                        "Ripley Rd at Hibiscus Street",
                        "Ripley Rd at Edwards Street",
                        "Edwards St near Rockman Dr",
                        "Edwards St near Thornton St",
                        "Wildey St near Edwards St hail 'n' ride",
                        "Wildey St near Rumsey Dr",
                        "Cascade St near Wildey St",
                        "Cascade St near South Station Rd",
                        "South Station Rd at Harding Street",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Auld St",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd opp Silkstone State School",
                        "Blackstone Rd at Coolibah Street",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Grange Rd near Edwards St",
                        "Wildey St at Brothers Leagues Club",
                        "Wildey St near Nolan St",
                        "Raceview St at Hayes Street",
                        "Cemetery Rd near Raceview St hail 'n' ride",
                        "Cemetery Rd near Whitehill Rd",
                        "Cemetery Rd near Warner St",
                        "Cemetery Rd at Briggs Road",
                        "Carr St at Warwick Road",
                        "Warwick Rd at Showground North",
                        "Warwick Rd at Park Street",
                        "East St at South Street",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Ellenborough St at Ellenborough Street",
                        "Elizabeth St at St Mary's Primary School",
                        "Waghorn St near Waghorn St hail 'n' ride"
                    ],
                    "5239: Bremer, Ipswich Boys Grammar, St Marys": [
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Hall Street",
                        "Deebing Creek Rd at Amberley State School",
                        "Kuril Dr near Lakeview Dr HnR",
                        "Winland Dr near Tenville Ct hail 'n' ride",
                        "Newsky Ct near Winland Dr hail 'n' ride",
                        "Winland Dr near Chilton Ct hail 'n' ride",
                        "Kuril Dr near Lakeview Dr hail 'n' ride",
                        "Sovereign Dr near Bottlebrush Dr hail 'n' ride",
                        "Deebing Heights State School",
                        "Kerners Rd near Deebing Ck Rd hail 'n' ride",
                        "Warwick Rd at Meadow Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Sheehan Lane",
                        "Warwick Rd at Perry Street",
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Warwick Rd at Showground North",
                        "Warwick Rd at Park Street",
                        "East St at South Street",
                        "Limestone St at Foote Lane",
                        "Ellenborough St at Ellenborough Street",
                        "Waghorn St at Ipswich Grammar School",
                        "Elizabeth St at St Mary's Primary School"
                    ],
                    "5240: Gailes, Springfield": [
                        "Old Logan Rd at Julieanne Street",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Vanessa Court",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd at Hallett Avenue",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Ishmael Rd",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Ishmael Rd near Moss Rd",
                        "Angela St near Moss Rd",
                        "Fran St near Steven St",
                        "Kertes Rd near Pharoah St",
                        "Mur Bvd near Sharpless Rd",
                        "Sharpless Rd near Zircon St",
                        "Topaz Rd near Sharpless Rd",
                        "Topaz Rd at Springfield Fair",
                        "Woodcrest Way near Woodcrest College",
                        "Woodcrest Way near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Karamea Ave near Bridgewater Rd",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Springfield Pwy at Escarpment Drive",
                        "Spring Lake Village 1",
                        "Springfield Lakes Bvd near The Promenade",
                        "Springfield Lakes Bvd near Parkview Dr",
                        "Springfield Lakes Bvd near Lakes Entrance Drive",
                        "Lakes Entrance Dr near Foreshore Dr",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Grande Ave near Oak Leaf Dr",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave at Angelica Avenue",
                        "Springfield Central State School",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High",
                        "Wellness Way at Health Care Dr",
                        "Sinnathamby Bvd at UniSQ",
                        "Sinnathamby Bvd at Parkside Business Park",
                        "Sinnathamby Bvd near Main St hail 'n' ride",
                        "Orion Springfield Central"
                    ],
                    "5241: Ipswich West, Ipswich Central, Silkstone": [
                        "Leichhardt and One Mile Community Centre",
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Larsen St at Leichhardt State School",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Wulkuraka station",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Fraser St near Everdina St hail 'n' ride",
                        "Kynance St near Maenporth St hail 'n' ride",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Woodford St near Vineyard St hail 'n' ride",
                        "Peacock St near General Foch St hail 'n' ride",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Brisbane St at Hooper Street",
                        "Omar St at Ipswich West State Primary",
                        "Griffith Rd at Ipswich Central State Primay School",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Ellenborough St at Ellenborough Street",
                        "Waghorn St at Ipswich Grammar School",
                        "Elizabeth St at St Mary's Primary School",
                        "Darling St East at Ipswich Grammar School",
                        "Burnett St at Blair State School",
                        "Cribb St at Blair State School",
                        "Kingsmill Rd at Robin Street",
                        "Kingsmill Rd near Hancock Bridge hail 'n' ride",
                        "Albion St at Workshops Street",
                        "Hunter St at Brassall Shopping Village",
                        "Hunter St at Ipswich State High School",
                        "Pine Mountain Rd at Brassall Primary School"
                    ],
                    "5245: Yamanto, Bundamba State High": [
                        "Providence Pde at Ripley Valley School",
                        "Ripley Rd at Wensley Rd",
                        "Ripley Rd at Canary St",
                        "Ripley Rd at Trigona Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Ash St at Winston Glades Shopping Centre",
                        "Ash St at Kensington Drive",
                        "Bladon St near Blenheim Cr",
                        "Equestrian Dr near Tilbury Ct",
                        "Amberley District State School",
                        "Kuril Dr near Lakeview Dr HnR",
                        "Rhythm Rd near Daleys Rd hail 'n' ride",
                        "Rhythm Rd near Tempo Dr hail 'n' ride",
                        "Ripley Rd near Fischer Rd hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Barrams Rd near Bellthorpe St hail 'n' ride",
                        "Greenview Av near Wallaman St hail 'n' ride",
                        "Morwell St near Eildon St hail 'n' ride",
                        "Barrams Rd at Olympus Drive",
                        "Cumner Rd near Dimmick St hail 'n' ride"
                    ],
                    "5246: Yamanto, Ripley Valley schools": [
                        "Reif St at Wallace St",
                        "Ripley Rd at Trigona Drive",
                        "Levi St near Flavey St hail 'n' ride",
                        "Fischer Rd near Clarke St hail 'n' ride",
                        "Scotts Rd near Ripley Rd hail 'n' ride",
                        "Ripley Central State School",
                        "Ripley Rd at Canary St",
                        "Ripley Rd near Fischer Rd hail 'n' ride",
                        "Fitzgibbon Rd near Joy Chambers Cct hail 'n' ride",
                        "Panorama Cct near Edinburgh St hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Barrams Rd near Bellthorpe St hail 'n' ride",
                        "Providence Pde at Ripley Valley School"
                    ],
                    "5247: Bremer, Silkstone, Churchill": [
                        "Harper St near Bligh St hail 'n' ride",
                        "Sussex St near Swanbank Rd hail 'n' ride",
                        "Melrose Dr at Rourke Park hail 'n' ride",
                        "Cascade St near South Station Rd",
                        "Raceview St at Hayes Street",
                        "Raceview St at Taylor Street",
                        "Grange Rd near Robertson Rd",
                        "Grange Rd near Edwards St",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Salisbury Rd near Jackes St",
                        "Salisbury Rd at Thorn Street",
                        "Bremer State High School",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Meadow Street hail 'n' ride",
                        "Deebing Creek Rd at Amberley State School",
                        "Deebing Creek Rd near Connemara Ct hail 'n' ride",
                        "Deebing Creek Rd near Quando Cl",
                        "Equestrian Dr near Mustang St",
                        "Equestrian Dr near Arabian Cl",
                        "Bladon St near Blenheim Ct",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Reif St at Fairview Park",
                        "Reif St at Plover Street",
                        "Reif St at Wallace St",
                        "Ripley Rd at Kingston Drive",
                        "Ripley Rd at Hibiscus Street",
                        "Ripley Rd at Edwards Street",
                        "Raceview St at Westminster Crescent",
                        "Raceview St at Rockman Drive",
                        "Cascade St at Bethany Lutheran Primary School",
                        "Cascade St near Wildey St",
                        "South Station Rd at Harding Street",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Auld St",
                        "Blackstone Rd near Church St",
                        "Blackstone Rd near Johnston St",
                        "Creek St near Blackstone Rd",
                        "Stafford St near Chilcott St",
                        "Stafford St near Videroni St",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Brisbane Rd at Hamilton Street",
                        "Cothill Rd at Sacred Heart Catholic Primary School",
                        "Molloy St opp Silkstone Primary",
                        "Blackstone Rd opp Silkstone State School",
                        "Blackstone Rd at Coolibah Street"
                    ],
                    "5248: Redbank Stn - Bellbrd Pk Coll - Redbank": [
                        "Redbank station, stop A",
                        "Brisbane Tce at Brisbane River Terraces",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Layard Street",
                        "Brisbane Tce at Lowe Street",
                        "Old Logan Rd at Julieanne Street",
                        "Newman St near Caswell St hail 'n' ride",
                        "Newman St near Dulin St hail 'n' ride",
                        "Newman St near Killalan St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Alice St near Allan St hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop D",
                        "Henty Dr at Barnes Street",
                        "Henty Dr near Knight St",
                        "Henty Dr near Martin Pl",
                        "Highbury Dr near Llewellyn St",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Alawoona St near Barkala St hail 'n' ride",
                        "Alawoona St near Lemana St hail 'n' ride",
                        "Alawoona St near Cedar Rd hail 'n' ride",
                        "Alawoona St near Dandenong Av hail 'n' ride",
                        "Alawoona St at Ingles Drive",
                        "Ingles Dr at McNamara Place",
                        "Fernbrooke Bvd at Ingles Drive",
                        "School Rd near Fernbrooke Bvd",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Willow Rd at Redbank Plains High School"
                    ],
                    "5249: Collingwood Park, Woodlinks SS": [
                        "Redbank station, stop B",
                        "Mine Street at Brisbane Road",
                        "Collingwood Dr at Old Ipswich Road",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Namatjira Dr at Drysdale Avenue",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Dr near Paul Tully Ave hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Forgan Smith St near Theodore Ct hail 'n' ride",
                        "Gibbs Ave near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near TJ Ryan Ave",
                        "Woodlinks State School",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop C",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College"
                    ],
                    "5250: Redbank Stn , Bellbird Park": [
                        "Redbank station, stop B",
                        "Mine Street at Brisbane Road",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Namatjira Dr at Drysdale Ave hail 'n' ride",
                        "Duncan St at Dancer Street",
                        "Collingwood Dr at Old Ipswich Road",
                        "Redbank Plaza",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Stuart St near Eric St hail 'n' ride",
                        "Curnow St near Howard St",
                        "Kingsford St at Howard Street",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride"
                    ],
                    "5251: Redbank Stn, Goodna Stn, Bellbird Park": [
                        "Redbank station, stop A",
                        "Brisbane Tce at Brisbane River Terraces",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Layard Street",
                        "Goodna station, stop A",
                        "Bertha Street near Mill Street hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Alice St near Martha St hail 'n' ride",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Smiths Rd at Arne Street",
                        "Smiths Rd near Stephen Cr hail 'n' ride",
                        "Smiths Rd near Bellevue Rd hail 'n' ride",
                        "Smiths Rd hail 'n' ride",
                        "Gorry St at Dowden Street",
                        "Gorry St at Killner Street",
                        "Cross St near Hamar St",
                        "Stuart St at Bellevue Road",
                        "Eric St near Albert St hail 'n' ride",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College"
                    ],
                    "5252: Redbank Stn , Kruger Pde, Bellbird Park": [
                        "Redbank station, stop B",
                        "Mine Street at Brisbane Road",
                        "Collingwood Dr at Old Ipswich Road",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Dr at Gibbs Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Kruger State School",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop A",
                        "Argyle St at Price Close",
                        "Henty Dr near Knight St",
                        "Henty Dr near Martin Pl",
                        "Highbury Dr near Llewellyn St",
                        "Russell Dr at Kerwin Street",
                        "Josey St at Neal Street",
                        "Josey St at Kennedy Drive",
                        "Batman Dr at Nigel Street",
                        "Henty Dr at Batman Drive",
                        "Henty Dr at Kruger Parade"
                    ],
                    "5253: Goodna Stn, Springfield Schools": [
                        "Goodna station, stop A",
                        "Brisbane Tce at Lowe Street",
                        "Old Logan Rd at Julieanne Street",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Vanessa Court",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd at Hallett Avenue",
                        "Old Logan Rd near Stella St hail 'n' ride",
                        "Old Logan Rd at Langley Road hail 'n' ride",
                        "Old Logan Rd near Dale Rd hail 'n' ride",
                        "Old Logan Rd near Allan Rd hail 'n' ride",
                        "Old Logan Rd near Steven St hail 'n' ride",
                        "Kertes Rd at Pharoah Street",
                        "Kertes Rd near Shiral Ct hail 'n' ride",
                        "Wilson Dr near Kertes Rd hail 'n' ride",
                        "Wilson Dr near Corial Ct hail 'n' ride",
                        "Wilson Dr near Durham Ct hail 'n' ride",
                        "Wilson Dr near Paula Ct hail 'n' ride",
                        "Wilson Dr near Myra Ct hail 'n' ride",
                        "Kertes Rd near Pharoah St",
                        "Mur Bvd near Sharpless Rd",
                        "Sharpless Rd near Zircon St",
                        "Topaz Rd near Sharpless Rd",
                        "Topaz Rd at Springfield Fair",
                        "Woodcrest Way near Woodcrest College",
                        "Woodcrest Way near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Karamea Ave near Bridgewater Rd",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Springfield Pwy at Escarpment Drive",
                        "Spring Lake Village 1",
                        "Springfield Lakes Bvd near The Promenade",
                        "Springfield Lakes Bvd near Parkview Dr",
                        "Springfield Lakes Bvd near Lakes Entrance Drive",
                        "Lakes Entrance Dr near Foreshore Dr",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Grande Ave near Oak Leaf Dr",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave at Angelica Avenue",
                        "Springfield Central State School",
                        "Good Shepherd Catholic Primary School",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High"
                    ],
                    "5254: Leichhardt, One Mile, Bremer": [
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Gilmore St near Watsonia Dr",
                        "Avon St at Larsen St",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Fraser St near Everdina St hail 'n' ride",
                        "Kynance St near Maenporth St hail 'n' ride",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Woodford St near Vineyard St hail 'n' ride",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Leichhardt and One Mile Community Centre",
                        "Brisbane St at Hooper Street",
                        "Brisbane St at Tiger Street",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Waghorn Street",
                        "Brisbane St at Ipswich City Square",
                        "East St at South Street",
                        "Ipswich Hospital, Stop C",
                        "Warwick Rd at Park Street",
                        "Warwick Rd at Short Street",
                        "Warwick Rd at Bremer High",
                        "Bremer State High School"
                    ],
                    "5255: Goodna, Camira, Springfield SS, SHS, Orion": [
                        "Goodna station, stop A",
                        "Brisbane Tce at Lowe Street",
                        "Old Logan Rd at Julieanne Street",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Vanessa Court",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd at Hallett Avenue",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Ishmael Rd",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Ishmael Rd near Moss Rd",
                        "Angela St near Moss Rd",
                        "Fran St near Steven St",
                        "Kertes Rd near Pharoah St",
                        "Mur Bvd near Sharpless Rd",
                        "Sharpless Rd near Zircon St",
                        "Topaz Rd near Sharpless Rd",
                        "Topaz Rd at Springfield Fair",
                        "Woodcrest Way near Woodcrest College",
                        "Woodcrest Way near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Karamea Ave near Bridgewater Rd",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Springfield Pwy at Escarpment Drive",
                        "Spring Lake Village 1",
                        "Lakeside Ave near Burlington Tce",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Janus Gr",
                        "Lakeside Ave near Coventina Cr",
                        "Summit Dr near Lakeside Ave",
                        "Summit Dr near Liberty Cr",
                        "Springfield Lakes Bvd near The Promenade",
                        "Springfield Lakes Bvd near Parkview Dr",
                        "Springfield Lakes Bvd near Lakes Entrance Drive",
                        "Lakes Entrance Dr near Foreshore Dr",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Grande Ave near Oak Leaf Dr",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave at Angelica Avenue",
                        "Springfield Central State School",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High",
                        "Sinnathamby Bvd at UniSQ",
                        "Sinnathamby Bvd at Parkside Business Park",
                        "Sinnathamby Bvd near Main St hail 'n' ride",
                        "Orion Springfield Central"
                    ],
                    "5257: Collingwood Park State SC": [
                        "Collingwood Dr at Br Ted Magee Drive",
                        "Palaszczuk Av at Neumann Drive hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr",
                        "Eagle St near TJ Ryan Ave",
                        "Collingwood Park State Secondary School"
                    ],
                    "5258: Goodna State PreSchool-Collingwood Park State SC": [
                        "Stuart St at Goodna State Pre School",
                        "Smiths Rd near Stephen Cr hail 'n' ride",
                        "Smiths Rd near Bellevue Rd hail 'n' ride",
                        "Smiths Rd hail 'n' ride",
                        "Gorry St at Dowden Street",
                        "Gorry St at Killner Street",
                        "Cross St near Hamar St",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at Maxwell Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd near Riverview Primary School",
                        "Old Ipswich Rd near Laura St",
                        "Valerie St near Child St",
                        "Diamond St near Gibbs St",
                        "Price St at Hayden Street",
                        "Mitchell St at Tessman Street",
                        "Nile St near Duncan St hail 'n' ride",
                        "Redbank Plaza",
                        "Collingwood Dr at Old Ipswich Road",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Lawrie Dr near Whitlam Dr hail 'n' ride",
                        "Goss Dr at Jo Ann Miller Dr hail 'n' ride",
                        "Goss Dr at Hawke Avenue hail 'n' ride",
                        "Gibbs Ave at Hunt Court",
                        "Gibbs Ave near Genoa Pl",
                        "Gibbs Ave near Avoca Ct",
                        "Gibbs Ave near TJ Ryan Ave",
                        "Eagle St near Bassili Dr",
                        "Eagle St near TJ Ryan Ave",
                        "Collingwood Park State Secondary School"
                    ],
                    "5260: Yamanto, Ripley Valley schools": [
                        "Reif St at Wallace St",
                        "Ripley Rd at Trigona Drive",
                        "Monterea Rd near Maguire St hail 'n' ride",
                        "Belle Pde near Optima St hail 'n' ride",
                        "Ripley Rd at Canary St",
                        "Parkview Pde at Lillypilly Drive",
                        "Tuckeroo St near Parkview Pde hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Barrams Rd near Bellthorpe St hail 'n' ride",
                        "Providence Pde at Ripley Valley School"
                    ],
                    "5265: Deebing Heights and Ripley Valley Schools": [
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Kuril Dr near Lakeview Dr HnR",
                        "Winland Dr near Tenville Ct hail 'n' ride",
                        "Newsky Ct near Winland Dr hail 'n' ride",
                        "Winland Dr near Chilton Ct hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Providence Pde at Ripley Valley School",
                        "Parkway Ave hail 'n' ride",
                        "Parkway Ave near Lomond St hail 'n' ride",
                        "Watheroo St near Herberton Rd hail 'n' ride",
                        "Lashmar St near Wyperfeld Cres hail 'n' ride",
                        "Parkway Ave at Ripley Valley Schools",
                        "Barrams Rd near Bellthorpe St hail 'n' ride"
                    ],
                    "5267: Kruger SS, Bellbird Park SHS, FernbrookSS": [
                        "Redbank station, stop B",
                        "Mine Street at Brisbane Road",
                        "Smiths Rd near Stephen Cr",
                        "Stuart St at Bellevue Road",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Kruger Pde at Kruger State School",
                        "Johnston St near Harris St hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd near Augusta Pkwy",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Alawoona St near Keidges Rd hail 'n' ride",
                        "Aldinga St near Keidges Rd",
                        "Aldinga St near Karabil St",
                        "Aldinga St near Cedar Rd",
                        "Berrigan St near Burrawang St hail 'n' ride",
                        "Diamond Way near Sapphire Cr hail 'n' ride",
                        "Woogaroo Creek State School",
                        "Berrigan St near Nardoo Ct hail 'n' ride",
                        "Glorious Prom near Cordeaux Cr hail 'n' ride",
                        "Regents Dr at Fernbrooke State School",
                        "Fernbrooke Bvd at Ingles Drive",
                        "School Rd near Fernbrooke Bvd",
                        "Cedar Rd at Orana Street",
                        "Willow Rd at Redbank Plains High School"
                    ],
                    "5268: Goodna Stn, Kruger SS, Bellbird Park SHS": [
                        "Goodna station, stop A",
                        "Goodna Shopping Centre",
                        "Smiths Rd at Arne Street",
                        "Smiths Rd near Stephen Cr hail 'n' ride",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Namatjira Dr at Drysdale Ave hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Milan Rd near Chris St hail 'n' ride",
                        "Henty Dr at Kruger Parade",
                        "Henty Dr at Batman Drive",
                        "Henty Dr near Kennedy Dr hail 'n' ride",
                        "Henty Dr near Evergreen Pl hail 'n' ride",
                        "Henty Dr at Ropati Street",
                        "Henty Dr near Knight St",
                        "Redbank Plains Town Square, stop C",
                        "Redbank Plains Town Square, stop A",
                        "Argyle St at Price Close",
                        "Jones Rd near Augusta Pkwy",
                        "Columbia Dr near Bellbird Dr hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College"
                    ],
                    "5269: Ipswich, West Moreton, Silkstone": [
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Kanangra St at Balook Street",
                        "Kanangra St near Lemana St",
                        "Kanangra St at Cedar Road",
                        "Cedar Rd at Orana Street",
                        "Shanahan Pde at Tina Street",
                        "Shanahan Pde at School Road",
                        "School Rd at Redbank Plains State School",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Cedar Rd at Kentucky Street",
                        "Redbank Plains Rd at Brennan Park",
                        "Mary St at Blackstone Primary School",
                        "Mary St near Hill Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Thomas St at Queen Street",
                        "Blackstone Rd near Johnston St",
                        "Blackstone Rd near Cothill Rd",
                        "Blackstone Rd near Cole St hail 'n' ride",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Whitehill Rd near Raff St",
                        "Frederick St near Glebe St hail 'n' ride",
                        "Brisbane Rd at Montauban Street",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Limestone St at The Terrace Medical Centre",
                        "Limestone St at Dimmeys Ipswich Plaza",
                        "Limestone St at Foote Lane",
                        "Limestone St at Nicholas Street",
                        "Limestone St at Waghorn Street",
                        "Burnett St at Blair State School",
                        "Kingsmill Rd at Robin Street",
                        "Kingsmill Rd near Hancock Bridge hail 'n' ride",
                        "Vogel Rd at Sharpe Street",
                        "Workshops St at Sutton Park",
                        "Hunter St at Brassall Shopping Village",
                        "Hunter St at Ipswich State High School",
                        "Pine Mountain Rd near Holt St hail 'n' ride",
                        "Fernvale Rd at Bourke Street",
                        "Fernvale Rd at North High Street",
                        "Keswick Rd at West Moreton Anglican College",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Toongarra St at Birrell Street",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Chubb St at Woodford Street",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Leichhardt and One Mile Community Centre",
                        "Brisbane St at Hooper Street",
                        "Omar St at Ipswich West State School",
                        "Thorn St near Moffatt St hail 'n' ride",
                        "Thorn St near Park St hail 'n' ride",
                        "Thorn St near Quarry St hail 'n' ride",
                        "Griffith Rd at Ipswich Central State Primay School",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Blackstone Rd at Silkstone Primary School",
                        "Molloy St at Silkstone Primary School"
                    ],
                    "5270: Amberley, Amberley State Primary": [
                        "Cunningham Hwy at Amberley Caravan Park",
                        "Coopers Rd near Willowbank Caravan Park HnR",
                        "Coopers Rd near Willowbank Dr",
                        "Tinworth St near Wigmore St hail 'n' ride",
                        "Sancroft St near Melbury St",
                        "Heit St near Ipswich Rosewood Rd hail 'n' ride",
                        "Rose St near Tulip St hail 'n' ride",
                        "Aloe St near Daffodil Cl hail 'n' ride",
                        "Jacaranda Dr near Aloe St",
                        "Nuala St near Jacaranda Dr",
                        "Tristania St near Ruthven Ct",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Hall Street",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Bladon St near Blenheim Cr",
                        "Equestrian Dr near Arabian Cl",
                        "Equestrian Dr near Mustang St",
                        "Deebing Creek Rd near Sandalwood Dr",
                        "Deebing Creek Rd near Redwood Pl hail 'n' ride",
                        "Amberley District State School"
                    ],
                    "5271: Rebank Plains, Belbird Park College": [
                        "Redbank Plaza",
                        "Collingwood Dr at Old Ipswich Road",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Rd near Irving Ct hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue",
                        "Collingwood Dr near Paul Tully Ave hail 'n' ride",
                        "Paul Tully Ave near Dawson Ct hail 'n' ride",
                        "Paul Tully Av near Warburton Ct hail 'n' ride",
                        "Paul Tully Av near Gibbs Av hail 'n' ride",
                        "Gibbs Ave at Hunt Court",
                        "Gibbs Ave near Genoa Pl",
                        "Gibbs Ave near Avoca Ct",
                        "Gibbs Ave near TJ Ryan Ave",
                        "Eagle St near Bassili Dr",
                        "Eagle St near TJ Ryan Ave",
                        "Palaszczuk Av at Neumann Drive hail 'n' ride",
                        "BR Ted Magee Dr near Norman Cl hail 'n' ride",
                        "BR Ted Magee Dr near Juxgold Ave hail 'n' ride",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop C",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College"
                    ],
                    "5273: Ripley Valley": [
                        "Rex Hills Dr near Ripley Rd hail 'n' ride",
                        "Carpenter Dr near Rex Hills Dr hail 'n' ride",
                        "Ripley Rd at Trigona Drive",
                        "Monterea Rd near Maguire St hail 'n' ride",
                        "Rhea De Wit Dr near Raven St hail 'n' ride",
                        "Canary St near Sable St hail 'n' ride",
                        "Ripley Rd at Canary St",
                        "Parkview Pde at Lillypilly Drive",
                        "Tuckeroo St near Parkview Pde hail 'n' ride",
                        "Ripley Rd at Wensley Rd",
                        "Ripley Central State School",
                        "Ripley Rd near Fischer Rd hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Barrams Rd near Bellthorpe St hail 'n' ride",
                        "Providence Pde at Ripley Valley School"
                    ],
                    "5274: Redbank Stn - Bellrd Pk Coll - Redbank": [
                        "Old Logan Rd at Julieanne Street",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Vanessa Court",
                        "Alice St near Allan St hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Alice St near Martha St hail 'n' ride",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Eric St near Albert St hail 'n' ride",
                        "Curnow St near Howard St",
                        "Kingsford St at Howard Street",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Redbank Plains Rd at Brennan Street",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Keidges Rd at Harry Street",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Aldinga St near Keidges Rd",
                        "Aldinga St near Karabil St",
                        "Aldinga St near Cedar Rd",
                        "Regents Dr at Fernbrooke State School",
                        "School Rd near Fernbrooke Bvd",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Willow Rd at Redbank Plains High School"
                    ],
                    "5276: Redbank Plains SHS, Bellbird Park SSC": [
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Namatjira Dr at Drysdale Avenue",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Rd near Irving Ct hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue",
                        "Collingwood Dr near Paul Tully Ave hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr",
                        "Eagle St near TJ Ryan Ave",
                        "Palaszczuk Av at Neumann Drive hail 'n' ride",
                        "BR Ted Magee Dr near Norman Cl hail 'n' ride",
                        "BR Ted Magee Dr near Juxgold Ave hail 'n' ride",
                        "Cedar Rd near Redbank Plains Rd hail 'n' ride",
                        "Cedar Rd near Vicki St hail 'n' ride",
                        "Willow Rd at Redbank Plains High School",
                        "Columbia Dr near Bellbird Dr hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College"
                    ],
                    "5277: Ripley Valley schools, Deebing Heights": [
                        "Deebing Heights State School",
                        "Kuril Dr near Lakeview Dr HnR",
                        "Rhythm Rd near Daleys Rd hail 'n' ride",
                        "Rhythm Rd near Tempo Dr hail 'n' ride",
                        "Ripley Rd at Canary St",
                        "Parkview Pde at Lillypilly Drive",
                        "Tuckeroo St near Parkview Pde hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Barrams Rd near Bellthorpe St hail 'n' ride",
                        "Providence Pde at Ripley Valley School"
                    ],
                    "5501: Little Mountain - Caloundra High": [
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Stradbroke Dr near Snapper St",
                        "Mark Road West near Cheviot Ct",
                        "Latcham Dr near Mark Rd",
                        "Caloundra Rd at Industrial Avenue",
                        "Pelican Waters Bvd near Marmont St hail 'n' ride",
                        "Pelican Waters Bvd near Agincourt St",
                        "Caloundra City Private School",
                        "Pelican Waters Bvd near The Corso",
                        "Pelican Waters Bvd near Kalowendha Ave",
                        "Pelican Waters Shopping Centre",
                        "Coral Sea Dr near Spitfire Banks Dr hail 'n' ride",
                        "Michael St near Carmel St hail 'n' ride",
                        "Catherine St near Judy St",
                        "Verdon St near Catherine St",
                        "Pelican Waters Bvd near Anning Ave hail 'n' ride",
                        "Lamerough Pde near Moorshead Ave hail 'n' ride",
                        "Sir Joseph Banks Dr near Godwin Pl hail 'n' ride",
                        "Nelson St near Caldwell St",
                        "Nelson St near Palmer Ave hail 'n' ride",
                        "Landsborough Pde at Golden Beach Shops",
                        "Beattie St near Taylor Ave",
                        "Westminster Ave near McLean St",
                        "Golden Beach State Primary School",
                        "Blaxland St near Gregory St",
                        "Baldwin St near Ambako Pl",
                        "Baldwin St near North St",
                        "Bowman Rd near First Ave",
                        "Caloundra State Primary School",
                        "Queen St near Ulm St",
                        "Caloundra State High School",
                        "Queen St at Caloundra State High School",
                        "Baldwin St near Pumicestone Pl",
                        "Blaxland St near Burke St",
                        "Nelson St near Palmer Ave",
                        "Catherine St near Maryann St",
                        "Pelican Waters Bvd near Bledisloe Bvd",
                        "Mark Rd near Cheviot Ct",
                        "Caloundra Rd at Stradbroke Drive"
                    ],
                    "5502: Bellvista - Caloundra High": [
                        "Bellvista Bvd at Bellcarra Place",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Lomond Cr at Balmoral Boulevard",
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Caloundra Rd at Industrial Avenue",
                        "Pelican Waters Bvd near Marmont St hail 'n' ride",
                        "Pelican Waters Bvd near Agincourt St",
                        "Caloundra City Private School",
                        "Kalowendha Ave near Agincourt St hail 'n' ride",
                        "Bledisloe Bvd near Scartree St hail 'n' ride",
                        "Bledisloe Bvd near Mahogany Dr hail 'n' ride",
                        "Bledisloe Bvd near Sydney Av hail 'n' ride",
                        "Bledisloe Bvd near Comet St hail 'n' ride",
                        "Bells Esp near Wadebird Cr hail 'n' ride",
                        "Michael St near Carmel St hail 'n' ride",
                        "Anning Ave near Maryann St",
                        "Anning Ave near Roy St",
                        "Landsborough Pde near Churchill St",
                        "Landsborough Pde near Monash St",
                        "Landsborough Pde near Onslow St",
                        "Landsborough Pde near Nelson St",
                        "Landsborough Pde at Golden Beach Shops",
                        "Esplanade near McLean St hail 'n' ride",
                        "Golden Beach State Primary School",
                        "Esplanade near Burke St hail 'n' ride",
                        "Caloundra State Primary School",
                        "Queen St near Ulm St",
                        "Caloundra State High School",
                        "Queen St at Caloundra State High School",
                        "Our Lady of the Rosary School hail 'n' ride",
                        "Edmund St at Caloundra Catholic Church",
                        "The Esplanade near McLean St hail 'n' ride",
                        "Bledisloe Bvd near Rutherford Pl hail 'n' ride"
                    ],
                    "5503: Banya/Baringa - Our Lady of Rosary Primary": [
                        "Western Dr near Tyndall Cct hail 'n' ride",
                        "Banya Ave near Nirimba Dr hail 'n' ride",
                        "Banya Ave near Lady Elliot Ave hail 'n' ride",
                        "Aura Bvd at Park Avenue",
                        "Baringa Dr at Baringa Secondary College",
                        "Baringa Dr at Emerson Street",
                        "Baringa Dr at Baringa State Primary School",
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Bellvista Bvd at Bellcarra Place",
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Caloundra Rd at Industrial Avenue",
                        "Caloundra Rd at Caloundra Police Station",
                        "Bowman Rd near First Ave",
                        "Caloundra State Primary School",
                        "Queen St near Ulm St",
                        "Caloundra State High School",
                        "Aura Bvd at Central Avenue",
                        "Banya Av near Thrive Bvd hail 'n' ride",
                        "Banya Ave near Great Keppel Way hail 'n' ride",
                        "Bellvista Bvd at Emerald Drive",
                        "Aura Bvd at Eden Dr",
                        "Baringa Dr at Marybell Drive"
                    ],
                    "5504: Little Mountain/Talara SS - Caloundra High": [
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Caloundra Rd at Stradbroke Drive",
                        "Caloundra Rd at Sugarbag Road",
                        "Woodroffe St near Pinewood St hail 'n' ride",
                        "Winchester Rd near Oakwood St hail 'n' ride",
                        "Caloundra Rd at Ridgewood Road",
                        "Pierce Ave near Lexington Dr",
                        "Lexington Dr at Kentucky Ct hail 'n' ride",
                        "247 Raintree Bvd hail 'n' ride",
                        "Raintree Bvd near Casuarina Dr hail 'n' ride",
                        "Bluegrass St near Ghostgum Cl hail 'n' ride",
                        "27 Koala Ct hail 'n' ride",
                        "41 Ascot Way hail 'n' ride",
                        "Keneland Dr at Little Mountain Shops hail 'n' ride",
                        "Parklands Bvd near Village Way",
                        "Parklands Bvd at Little Mountain Drive",
                        "Parklands Bvd at Liekefett Way",
                        "Meridan State College",
                        "Parklands Bvd at Sunset Drive",
                        "Kalana Rd near Talara St",
                        "Talara St at Talara Primary College",
                        "Talara Primary College",
                        "Erang St at Alstonville Way",
                        "Gannawarra St near Menyan St hail 'n' ride",
                        "Gothic Pde near Edna St",
                        "Currimundi Rd near Ilya St",
                        "Buderim St at Currimundi Hotel",
                        "Coonowrin St near Teewah St hail 'n' ride",
                        "Coonowrin St near Trundle St",
                        "Cooroora St near Coonowrin St",
                        "Cooroora St at Ulm Street North",
                        "Cooroora St near Tinbeerwah St",
                        "Buccleugh St at Bryce Street",
                        "Rinaldi St at Moffat Beach",
                        "Edmund St at Russell Street",
                        "Edmund St near Simpson St hail 'n' ride",
                        "Edmund St at Caloundra Catholic Church",
                        "Moreton Pde at Saltair Street",
                        "Moreton Pde at Levuka Avenue",
                        "Moreton Pde at Canberra Terrace",
                        "Ormuz Ave at Bingera Terrace",
                        "Mary St near Arthur St",
                        "Caloundra State Primary School",
                        "Queen St near Ulm St",
                        "Caloundra State High School",
                        "Queen St at Caloundra State High School",
                        "Orsova Tce near Osterley Ave",
                        "Bulcock St at Canberra Terrace",
                        "Moreton Pde at Mahia Terrace",
                        "Cooroora St near James St",
                        "Cooroora St near Ulm St Nth",
                        "Coonowrin St near Anderson St hail 'n' ride",
                        "Nicklin Way at Currimundi",
                        "Erang St near Alstonville Way",
                        "Parklands Bvd at Meridan State College",
                        "Parklands Bvd near Liekefett Way",
                        "Caloundra Rd at Parklands Boulevard"
                    ],
                    "5505: Kawana/Talara SS - Caloundra High": [
                        "Nicklin Way at Jessica Park",
                        "Nicklin Way at Jessica Boulevard",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Beach Drive",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Currimundi",
                        "Erang St near Alstonville Way",
                        "Creekside Bvd near Snapdragon St",
                        "Creekside Bvd near Mimosa Cr",
                        "Creekside Bvd near Brushwood St",
                        "Creekside Bvd near Oakdale Cct",
                        "Woodlands Bvd at Pacific Lutheran College",
                        "Woodlands Bvd at Forest Park Street",
                        "Creekside Bvd near Sycamore Dr",
                        "Creekside Bvd near Lakeside Cr",
                        "Talara Primary College",
                        "Talara St at Talara Primary College",
                        "Curlew St near Beerburrum St",
                        "Beerburrum St near Sanderling St",
                        "Beerburrum St at Caloundra Private Hospital",
                        "Beerburrum St near Cooroy St",
                        "Beerburrum St at Dicky Beach",
                        "Buccleugh St at Bryce Street",
                        "Buccleugh St near Nothling St",
                        "William St near Maltman St Nth",
                        "Caloundra State Primary School",
                        "Queen St near Ulm St",
                        "Caloundra State High School",
                        "Queen St at Caloundra State High School",
                        "William St near Buccleugh St",
                        "Beerburrum St near Albatross Ave",
                        "Curlew St near Cassowary St",
                        "Erang St at Alstonville Way",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at The Groves Minyama"
                    ],
                    "5511: Dicky Beach/Pelican Waters - Unity College": [
                        "Beerburrum St at Dicky Beach",
                        "Buccleugh St at Bryce Street",
                        "Buccleugh St near Nothling St",
                        "William St near Maltman St Nth",
                        "Orsova Tce near Osterley Ave",
                        "Suller St near Nutley St",
                        "Esplanade near Burke St hail 'n' ride",
                        "The Esplanade near McLean St hail 'n' ride",
                        "Landsborough Pde at Golden Beach Shops",
                        "Landsborough Pde near Nelson St",
                        "Landsborough Pde near Monash St",
                        "Landsborough Pde near Churchill St",
                        "Anning Ave near Roy St",
                        "Anning Ave near Maryann St",
                        "Michael St near Carmel St hail 'n' ride",
                        "Bells Esp near Wadebird Cr hail 'n' ride",
                        "Bledisloe Bvd near Comet St hail 'n' ride",
                        "Bledisloe Bvd near Rutherford Pl hail 'n' ride",
                        "Bledisloe Bvd near Mahogany Dr hail 'n' ride",
                        "Bledisloe Bvd near Scartree St hail 'n' ride",
                        "Kalowendha Ave near Agincourt St hail 'n' ride",
                        "Pelican Waters Bvd near Agincourt St",
                        "Caloundra City Private School",
                        "Westminster Ave near McLean St",
                        "Golden Beach State Primary School",
                        "Blaxland St near Gregory St",
                        "Blaxland St near Burke St",
                        "Baldwin St near Ambako Pl",
                        "Baldwin St near North St",
                        "Caloundra Rd at Caloundra Police Station",
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Bellvista Bvd at Bellcarra Place",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Caloundra Rd at Industrial Avenue",
                        "Baldwin St near Pumicestone Pl",
                        "Bledisloe Bvd near Sydney Av hail 'n' ride",
                        "Landsborough Pde near Onslow St",
                        "Esplanade near McLean St hail 'n' ride",
                        "Mary St near Arthur St",
                        "George St at Caloundra State School",
                        "William St near Buccleugh St"
                    ],
                    "5512: Kings Beach/Pelican Waters - Notre Dame College": [
                        "Moreton Pde at Saltair Street",
                        "Moreton Pde at Levuka Avenue",
                        "Moreton Pde at Canberra Terrace",
                        "Ormuz Ave at Bingera Terrace",
                        "Esplanade near Burke St hail 'n' ride",
                        "The Esplanade near McLean St hail 'n' ride",
                        "Landsborough Pde at Golden Beach Shops",
                        "Nelson St near Palmer Ave",
                        "Nelson St near Caldwell St",
                        "Sir Joseph Banks Dr near Godwin Pl hail 'n' ride",
                        "Lamerough Pde near Moorshead Ave hail 'n' ride",
                        "Pelican Waters Bvd near Anning Ave hail 'n' ride",
                        "Verdon St near Catherine St",
                        "Catherine St near Maryann St",
                        "Michael St near Carmel St hail 'n' ride",
                        "Coral Sea Dr near Spitfire Banks Dr hail 'n' ride",
                        "Pelican Waters Shopping Centre",
                        "Pelican Waters Bvd near Bledisloe Bvd",
                        "Pelican Waters Bvd near Agincourt St",
                        "Caloundra City Private School",
                        "Westminster Ave near McLean St",
                        "Golden Beach State Primary School",
                        "Blaxland St near Gregory St",
                        "Blaxland St near Burke St",
                        "Baldwin St near Ambako Pl",
                        "Baldwin St near North St",
                        "Caloundra Rd at Caloundra Police Station",
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Bellvista Bvd at Bellcarra Place",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Bellvista Bvd at Emerald Drive",
                        "Aura Bvd at Eden Dr",
                        "Aura Bvd at McArthur Parade",
                        "Aura Bvd at Graf Drive",
                        "Aura Bvd at Annalise Circuit Park",
                        "Aura Bvd at Central Avenue",
                        "Aura Bvd at Park Avenue",
                        "Festival St at Notre Dame College",
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Caloundra Rd at Industrial Avenue",
                        "Baldwin St near Pumicestone Pl",
                        "Pelican Waters Bvd near The Corso",
                        "Pelican Waters Bvd near Kalowendha Ave",
                        "Catherine St near Judy St",
                        "Nelson St near Palmer Ave hail 'n' ride",
                        "Esplanade near McLean St hail 'n' ride",
                        "Bulcock St at Canberra Terrace",
                        "Moreton Pde at Mahia Terrace"
                    ],
                    "5513: Kawana/Currimundi - Notre Dame College": [
                        "Nicklin Way at Jessica Park",
                        "Nicklin Way at Jessica Boulevard",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Beach Drive",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Coora Crescent",
                        "Nicklin Way near Browning Bvd hail 'n' ride",
                        "Beerburrum St near Albatross Ave",
                        "Parklands Bvd at Sunset Drive",
                        "Parklands Bvd at Meridan State College",
                        "Meridan State College (Senior Campus)",
                        "Parklands Bvd near Liekefett Way",
                        "Parklands Bvd at Little Mountain Drive",
                        "Parklands Bvd near Village Way",
                        "Caloundra Rd at Parklands Boulevard",
                        "Caloundra Rd at Ridgewood Road",
                        "Caloundra Rd at Sugarbag Road",
                        "Bellvista Bvd at Bellcarra Place",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Bellvista Bvd at Emerald Drive",
                        "Aura Bvd at Eden Dr",
                        "Aura Bvd at McArthur Parade",
                        "Central Ave near Splendour St hail 'n' ride",
                        "Central Ave near Celebration St hail 'n' ride",
                        "Aura Bvd at Central Avenue",
                        "Aura Bvd at Park Avenue",
                        "Festival St at Notre Dame College",
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Caloundra Rd at Stradbroke Drive",
                        "Parklands Bvd at Liekefett Way",
                        "Beerburrum St near Sanderling St",
                        "Nicklin Way at Wide World of Lights hail 'n' ride",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at The Groves Minyama"
                    ],
                    "5521: Banya - Nirimba SS": [
                        "Western Dr near Tyndall Cct hail 'n' ride",
                        "Banya Ave near Nirimba Dr hail 'n' ride",
                        "Banya Ave near Lady Elliot Ave hail 'n' ride",
                        "Nirimba State School",
                        "Aura Bvd at Park Avenue",
                        "Banya Av near Thrive Bvd hail 'n' ride",
                        "Banya Ave near Great Keppel Way hail 'n' ride"
                    ],
                    "5522: Unity College - Nirimba SS": [
                        "Unity College",
                        "Bellvista Bvd at Emerald Drive",
                        "Aura Bvd at Eden Dr",
                        "Aura Bvd at McArthur Parade",
                        "Aura Bvd at Graf Drive",
                        "Aura Bvd at Annalise Circuit Park",
                        "Charlotte Ave near Jasmine Ave hail 'n' ride",
                        "Nirimba Dr near Pretty St hail 'n' ride",
                        "Central Av near Nirimba Dr hail 'n' ride",
                        "Nirimba State School",
                        "Central Av near North Village Dr hail 'n' ride",
                        "Aura Bvd at Central Avenue",
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Stornaway Ave at Shannon Crescent"
                    ],
                    "5523: From Banya - Baringa SHS": [
                        "Attenborough Dr near Western Dr hail 'n' ride",
                        "Western Dr near Girraween Cr hail 'n' ride",
                        "Western Dr near Tamborine Cr hail 'n' ride",
                        "Western Dr near Tyndall Cct hail 'n' ride",
                        "Baringa Dr at Baringa Secondary College"
                    ],
                    "5531: Glenview - Glasshouse Christian College": [
                        "Frizzo Rd at Aussie World",
                        "Palmview Forest Dr near Glasswing Ave HnR",
                        "Kookaburra Dr near Palmview Forest Dr HnR",
                        "Palmview Forest Dr near Richmond Lane HnR",
                        "Glenview Rd near Mawhinney Rd hail 'n' ride",
                        "Glenview Rd near Nina Dr hail 'n' ride",
                        "Glenview Rd near Dunne Rd hail 'n' ride",
                        "Glenview Rd near Isamberts Rd hail 'n' ride",
                        "Connection Rd at Country Club hail 'n' ride",
                        "Connection Rd near Greenacres Ct hail 'n' ride",
                        "329 Connection Rd hail 'n' ride",
                        "Mooloolah Rd near Christine Ct hail 'n' ride",
                        "Bray Rd near Paget St hail 'n' ride",
                        "Mooloolah State Primary School",
                        "Bray Rd at Mooloolah Town Park hail 'n' ride",
                        "Connection Rd near South River Dr hail 'n' ride",
                        "Connection Rd near Tunnel Ridge Rd hail 'n' ride",
                        "Connection Rd near Hamilton Cl hail 'n' ride",
                        "Glenview Rd near Old Gympie Rd hail 'n' ride",
                        "Glenview Rd near Evans Grove Rd hail 'n' ride",
                        "Glenview Rd at Chambers Ct hail 'n' ride",
                        "492 Glenview Rd hail 'n' ride",
                        "Leeding Rd at Glenview Pmy hail 'n' ride",
                        "Beerwah High School",
                        "Glasshouse Country Christian College",
                        "493 Glenview Rd hail 'n' ride",
                        "Connection Rd near Old Gympie Rd hail 'n' ride",
                        "Connection Road at Country Club hail 'n' ride",
                        "Glenview Rd at Glenview Primary School",
                        "Frizzo Rd at Glenview Road"
                    ],
                    "5541: Pelican Waters/Golden Beach - Unity College": [
                        "Caloundra City Private School",
                        "Kalowendha Ave near Agincourt St hail 'n' ride",
                        "Bledisloe Bvd near Scartree St hail 'n' ride",
                        "Bledisloe Bvd near Mahogany Dr hail 'n' ride",
                        "Bledisloe Bvd near Sydney Av hail 'n' ride",
                        "Bledisloe Bvd near Comet St hail 'n' ride",
                        "Bells Esp near Wadebird Cr hail 'n' ride",
                        "Michael St near Carmel St hail 'n' ride",
                        "Anning Ave near Maryann St",
                        "Anning Ave near Roy St",
                        "Lamerough Pde near Moorshead Ave hail 'n' ride",
                        "Sir Joseph Banks Dr near Godwin Pl hail 'n' ride",
                        "Nelson St near Caldwell St",
                        "Nelson St near Palmer Ave hail 'n' ride",
                        "Landsborough Pde at Golden Beach Shops",
                        "Esplanade near McLean St hail 'n' ride",
                        "Esplanade near Burke St hail 'n' ride",
                        "Suller St near Nutley St",
                        "Mary St near Arthur St",
                        "George St at Caloundra State School",
                        "William St near Buccleugh St",
                        "Buccleugh St at Bryce Street",
                        "Beerburrum St at Dicky Beach",
                        "Beerburrum St near Cooroy St",
                        "Buderim St at Currimundi Hotel",
                        "Currimundi Rd near Ilya St",
                        "Gothic Pde near Edna St",
                        "Gannawarra St near Menyan St hail 'n' ride",
                        "Nicklin Way at Currimundi",
                        "Erang St near Alstonville Way",
                        "Creekside Bvd near Snapdragon St",
                        "Creekside Bvd near Mimosa Cr",
                        "Creekside Bvd near Brushwood St",
                        "Creekside Bvd near Oakdale Cct",
                        "Woodlands Bvd at Pacific Lutheran College",
                        "Woodlands Bvd at Forest Park Street",
                        "Creekside Bvd near Sycamore Dr",
                        "Creekside Bvd near Lakeside Cr",
                        "Talara Primary College",
                        "Saffron Dr near Bluebell St",
                        "Saffron Dr at Burnsall St",
                        "Parklands Bvd at Sunset Drive",
                        "Parklands Bvd at Meridan State College",
                        "Meridan State College (Senior Campus)",
                        "Parklands Bvd near Liekefett Way",
                        "Parklands Bvd at Little Mountain Drive",
                        "Parklands Bvd near Village Way",
                        "Caloundra Rd at Parklands Boulevard",
                        "Caloundra Rd at Ridgewood Road",
                        "Caloundra Rd at Sugarbag Road",
                        "Bellvista Bvd at Bellcarra Place",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Caloundra Rd at Stradbroke Drive",
                        "Parklands Bvd at Liekefett Way",
                        "Saffron Dr near Burnsall St",
                        "Erang St at Alstonville Way",
                        "Buccleugh St near Nothling St",
                        "William St near Maltman St Nth",
                        "Orsova Tce near Osterley Ave",
                        "The Esplanade near McLean St hail 'n' ride",
                        "Nelson St near Palmer Ave",
                        "Bledisloe Bvd near Rutherford Pl hail 'n' ride",
                        "Pelican Waters Bvd near Agincourt St"
                    ],
                    "5550: Nirimba - Meridan College": [
                        "Nirimba State School",
                        "Aura Bvd at Park Avenue",
                        "Aura Bvd at Central Avenue",
                        "Aura Bvd at Graf Drive",
                        "Meridan State College (Senior Campus)",
                        "Aura Bvd at Annalise Circuit Park",
                        "Central Ave near Aura Bvd hail 'n' ride"
                    ],
                    "5551: Kawana/Baringa - Meridan College": [
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Beach Drive",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Coora Crescent",
                        "Buderim St at Coryule Street",
                        "Buderim St at Currimundi Hotel",
                        "Beerburrum St near Cooroy St",
                        "Beerburrum St at Dicky Beach",
                        "Buccleugh St at Bryce Street",
                        "Rinaldi St at Moffat Beach",
                        "Edmund St at Russell Street",
                        "Edmund St near Simpson St hail 'n' ride",
                        "Edmund St at Caloundra Catholic Church",
                        "Moreton Pde at Saltair Street",
                        "Moreton Pde at Levuka Avenue",
                        "Moreton Pde at Canberra Terrace",
                        "Ormuz Ave at Bingera Terrace",
                        "Bowman Rd near First Ave",
                        "Caloundra Rd at Caloundra Police Station",
                        "Latcham Dr near Mark Rd",
                        "Mark Rd near Cheviot Ct",
                        "Stradbroke Dr near Snapper St",
                        "Bellvista Bvd at Bellcarra Place",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Bellvista Bvd at Emerald Drive",
                        "McArthur Pde at Meredith Crescent",
                        "McArthur Pde at Paddington Circuit",
                        "Baringa Dr at Marybell Drive",
                        "Baringa Dr at Baringa Secondary College",
                        "Baringa Dr at Emerson Street",
                        "Baringa Dr at Baringa State Primary School",
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Caloundra Rd at Stradbroke Drive",
                        "Caloundra Rd at Sugarbag Road",
                        "Caloundra Rd at Ridgewood Road",
                        "Parklands Bvd near Village Way",
                        "Parklands Bvd at Little Mountain Drive",
                        "Parklands Bvd at Liekefett Way",
                        "Meridan State College (Senior Campus)",
                        "Parklands Bvd at Sunset Drive",
                        "Parklands Bvd at Meridan State College",
                        "Parklands Bvd near Liekefett Way",
                        "Caloundra Rd at Parklands Boulevard",
                        "Mark Road West near Cheviot Ct",
                        "Caloundra Rd at Industrial Avenue",
                        "Bulcock St at Canberra Terrace",
                        "Moreton Pde at Mahia Terrace",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2"
                    ],
                    "5552: Nirimba/Baringa - Meridan College": [
                        "Nirimba State School",
                        "Central Av near North Village Dr hail 'n' ride",
                        "Nirimba Dr near Pretty St hail 'n' ride",
                        "Charlotte Ave near Jasmine Ave hail 'n' ride",
                        "Aura Bvd at Central Avenue",
                        "Aura Bvd at Graf Drive",
                        "Baringa Dr at Marybell Drive",
                        "Baringa Dr at Baringa Secondary College",
                        "Baringa Dr at Emerson Street",
                        "Baringa Dr at Baringa State Primary School",
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Bellvista Bvd at Bellcarra Place",
                        "Caloundra Rd at Stradbroke Drive",
                        "Parklands Bvd at Meridan State College",
                        "Meridan State College (Senior Campus)",
                        "Parklands Bvd at Sunset Drive",
                        "Aura Bvd at Eden Dr",
                        "Aura Bvd at McArthur Parade",
                        "Aura Bvd at Annalise Circuit Park",
                        "Bellvista Bvd at Emerald Drive",
                        "Central Av near Nirimba Dr hail 'n' ride"
                    ],
                    "5553: Little Mountain/Bellvista - Meridan College": [
                        "Parklands Bvd near Village Way",
                        "Pierce Ave near Lexington Dr",
                        "Lexington Dr at Kentucky Ct hail 'n' ride",
                        "247 Raintree Bvd hail 'n' ride",
                        "Raintree Bvd near Casuarina Dr hail 'n' ride",
                        "Bluegrass St near Ghostgum Cl hail 'n' ride",
                        "27 Koala Ct hail 'n' ride",
                        "41 Ascot Way hail 'n' ride",
                        "Keneland Dr at Little Mountain Shops hail 'n' ride",
                        "Caloundra Rd at Parklands Boulevard",
                        "Woodroffe St near Pinewood St hail 'n' ride",
                        "Winchester Rd near Oakwood St hail 'n' ride",
                        "Caloundra Rd at Ridgewood Road",
                        "Caloundra Rd at Sugarbag Road",
                        "Bellvista Bvd at Bellcarra Place",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Lomond Cr at Balmoral Boulevard",
                        "Caloundra Rd at Stradbroke Drive",
                        "Parklands Bvd at Meridan State College",
                        "Meridan State College (Senior Campus)",
                        "Parklands Bvd at Sunset Drive"
                    ],
                    "5554: Mooloolah/Glenview - Meridan College": [
                        "Steve Irwin Way at Mooloolah Cemetery",
                        "Connection Rd at Country Club hail 'n' ride",
                        "Connection Rd near Greenacres Ct hail 'n' ride",
                        "329 Connection Rd hail 'n' ride",
                        "Mooloolah Rd near Christine Ct hail 'n' ride",
                        "Bray Rd near Paget St hail 'n' ride",
                        "Mooloolah State Primary School",
                        "Bray Rd at Mooloolah Town Park hail 'n' ride",
                        "Connection Rd near South River Dr hail 'n' ride",
                        "Connection Rd near Tunnel Ridge Rd hail 'n' ride",
                        "Connection Rd near Hamilton Cl hail 'n' ride",
                        "Glenview Rd near Old Gympie Rd hail 'n' ride",
                        "Glenview Rd near Evans Grove Rd hail 'n' ride",
                        "Glenview Rd at Chambers Ct hail 'n' ride",
                        "492 Glenview Rd hail 'n' ride",
                        "Leeding Rd at Glenview Pmy hail 'n' ride",
                        "Glenview Rd at Glenview Primary School",
                        "Glenview Rd near Isamberts Rd hail 'n' ride",
                        "Glenview Rd near Dunne Rd hail 'n' ride",
                        "Glenview Rd near Nina Dr hail 'n' ride",
                        "Glenview Rd near Mawhinney Rd hail 'n' ride",
                        "Frizzo Rd at Glenview Road",
                        "Caloundra Rd at Parklands Boulevard",
                        "Caloundra Rd at Ridgewood Road",
                        "Caloundra Rd at Sugarbag Road",
                        "Bellvista Bvd at Bellcarra Place",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Stornaway Ave at Shannon Crescent",
                        "Unity College",
                        "Caloundra Rd at Stradbroke Drive",
                        "Sugar Bag Rd near Carisbrook Ct hail 'n' ride",
                        "Seagull Ave near Albatross Ave",
                        "Albatross Ave near Beerburrum St",
                        "Beerburrum St near Albatross Ave",
                        "Parklands Bvd at Sunset Drive",
                        "Parklands Bvd at Meridan State College",
                        "Meridan State College (Senior Campus)",
                        "Beerburrum St near Sanderling St",
                        "Albatross Ave near Miranda St",
                        "Seagull Ave near Sugarbag Rd",
                        "Sugar Bag Rd near Rosewood Dr hail 'n' ride",
                        "493 Glenview Rd hail 'n' ride",
                        "Connection Rd near Old Gympie Rd hail 'n' ride",
                        "Connection Road at Country Club hail 'n' ride",
                        "Steve Irwin Way at Mooloolah Connection Rd"
                    ],
                    "5561: Nirimba/Baringa - Kawana College": [
                        "Western Dr near Tyndall Cct hail 'n' ride",
                        "Banya Ave near Nirimba Dr hail 'n' ride",
                        "Banya Ave near Lady Elliot Ave hail 'n' ride",
                        "Central Av near North Village Dr hail 'n' ride",
                        "Nirimba Dr near Pretty St hail 'n' ride",
                        "Charlotte Ave near Jasmine Ave hail 'n' ride",
                        "Aura Bvd at Central Avenue",
                        "Aura Bvd at Graf Drive",
                        "McArthur Pde at Paddington Circuit",
                        "Aura Bvd at Baringa Shopping Centre Stop A",
                        "Aura Bvd at Emerald Drive",
                        "Bellvista Bvd at Dumbarton Drive",
                        "Bellvista Bvd at Bellcarra Place",
                        "Caloundra Rd at Stradbroke Drive",
                        "Sugar Bag Rd near Carisbrook Ct hail 'n' ride",
                        "Seagull Ave near Albatross Ave",
                        "Albatross Ave near Beerburrum St",
                        "Beerburrum St near Albatross Ave",
                        "Curlew St near Cassowary St",
                        "Talara St at Talara Primary College",
                        "Talara Primary College",
                        "Creekside Bvd near Snapdragon St",
                        "Creekside Bvd near Mimosa Cr",
                        "Creekside Bvd near Brushwood St",
                        "Creekside Bvd near Oakdale Cct",
                        "Woodlands Bvd at Pacific Lutheran College",
                        "Woodlands Bvd at Forest Park Street",
                        "Kawana Bvd at The Decks Lake Kawana",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Kawana Waters State High School",
                        "Kawana State College Primary",
                        "Nicklin Way at Beach Drive",
                        "Creekside Bvd near Sycamore Dr",
                        "Creekside Bvd near Lakeside Cr",
                        "Curlew St near Beerburrum St",
                        "Beerburrum St near Sanderling St",
                        "Albatross Ave near Miranda St",
                        "Seagull Ave near Sugarbag Rd",
                        "Sugar Bag Rd near Rosewood Dr hail 'n' ride",
                        "Bellvista Bvd at Emerald Drive",
                        "McArthur Pde at Meredith Crescent",
                        "Aura Bvd at McArthur Parade",
                        "Aura Bvd at Annalise Circuit Park",
                        "Central Av near Nirimba Dr hail 'n' ride",
                        "Nirimba State School",
                        "Aura Bvd at Park Avenue",
                        "Banya Av near Thrive Bvd hail 'n' ride",
                        "Banya Ave near Great Keppel Way hail 'n' ride"
                    ],
                    "5562: Brightwater/Kawana - Kawana College": [
                        "Brightwater Bvd at Frogmouth Cct hail 'n' ride",
                        "Attenuata Dr at Crayfish Street",
                        "Attenuata Dr at Amberjack Street",
                        "Brightwater State School",
                        "Brightwater Bvd near Panama Cr hail 'n' ride",
                        "Manatunga Pde at Brightwater Bvd",
                        "Manatunga Pde at Lady Elliot Dr",
                        "Bundilla Bvd at Cootamundra Drive",
                        "Nicklin Way at Jessica Park",
                        "Nicklin Way at Jessica Boulevard",
                        "Point Cartwright Dr near Nanyima St hail 'n' ride",
                        "Point Cartwright Dr near Wingara St hail 'n' ride",
                        "Yaringa Ave near Boorook St hail 'n' ride",
                        "Iluka Ave near Koolena St hail 'n' ride",
                        "Buddina Primary School",
                        "Lowanna Dr near Ilumba St hail 'n' ride",
                        "Oceanic Dr near Currawan St hail 'n' ride",
                        "Oceanic Dr near Bandaroo St hail 'n' ride",
                        "Oceanic Dr near Bareena Pl hail 'n' ride",
                        "Kawana Waters State High School",
                        "Kawana State College Primary",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Iluka Ave near near Undara Ave hail 'n' ride",
                        "Point Cartwright Dr near Minya St hail 'n' ride",
                        "Point Cartwright Dr near Ninyima St hail 'n' ride",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at The Groves Minyama"
                    ],
                    "5571: Talara SS - Meridan College via PLC": [
                        "Meridan State College (Senior Campus)",
                        "Parklands Bvd at Sunset Drive",
                        "Saffron Dr near Burnsall St",
                        "Saffron Dr near Bluebell St",
                        "Creekside Bvd near Snapdragon St",
                        "Creekside Bvd near Mimosa Cr",
                        "Creekside Bvd near Brushwood St",
                        "Creekside Bvd near Oakdale Cct",
                        "Woodlands Bvd at Pacific Lutheran College",
                        "Woodlands Bvd at Forest Park Street",
                        "Creekside Bvd near Sycamore Dr",
                        "Creekside Bvd near Lakeside Cr",
                        "Talara Primary College",
                        "Saffron Dr at Burnsall St",
                        "Parklands Bvd at Meridan State College"
                    ],
                    "5572: Talara SS - Meridan College via Aroona": [
                        "Meridan State College (Senior Campus)",
                        "Sugar Bag Rd near Carisbrook Ct hail 'n' ride",
                        "Seagull Ave near Albatross Ave",
                        "Albatross Ave near Beerburrum St",
                        "Curlew St near Cassowary St",
                        "Talara Primary College",
                        "Curlew St near Beerburrum St",
                        "Beerburrum St near Sanderling St",
                        "Albatross Ave near Miranda St",
                        "Seagull Ave near Sugarbag Rd",
                        "Sugar Bag Rd near Rosewood Dr hail 'n' ride",
                        "Parklands Bvd at Meridan State College"
                    ],
                    "5600: Maroochydore High - Buderim": [
                        "Maroochydore High Bus Bays",
                        "Main St at Buderim Mountain Primary School"
                    ],
                    "5601: Alexandra Headland/Mooloolaba - Maroochydore High": [
                        "Maroochydore station, platform 1",
                        "First Ave near Memorial Ave",
                        "King St at Cotton Tree Caravan Park",
                        "Sixth Ave at Maroochy Library",
                        "Sixth Ave at Sea Breeze Caravan Park",
                        "Alexandra Pde at Okinja Road",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Alexandra Pde at Wilkes Family Park",
                        "Alexandra Pde at Alexandra Headland",
                        "Mooloolaba Esp at Meta Street",
                        "Walan St near Smith St",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Brisbane Rd at Woomba Place",
                        "Amarina Ave near Darrung St",
                        "Amarina Ave near Admirals Ct",
                        "Amarina Ave near Goonawarra Dr",
                        "Goonawarra Dr near Yallanga Pl",
                        "Palm Dr near Brentwood Ave",
                        "Ocean View Ave near Aruma Ct",
                        "Pettigrew St near Kalinda Ave",
                        "Mooloolaba Rd near Mary St",
                        "Buderim Av at Janet Street",
                        "Mooloolaba Rd near Correa Pl",
                        "Sugar Rd near Centenary Cr",
                        "Maud St at Coghlan Court",
                        "Maud St near Gloria St",
                        "First Av at Future Way",
                        "Maroochydore station, platform 2",
                        "Maroochydore Rd at Homemaker Centre",
                        "Maroochydore High Bus Bays",
                        "Maroochydore Rd at Maroochydore High",
                        "Buderim Ave at Mary Street",
                        "Pettigrew St near Marjorie St",
                        "Ocean View Ave near Warrina Ct",
                        "Goonawarra Dr near Yuruga St",
                        "Amarina Ave near Kononda Ct",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Walan St near Bahlaka St",
                        "Cotton Tree Pde at Cotton Tree Caravan Park",
                        "First Ave near George St"
                    ],
                    "5602: Buderim - Maroochydore High": [
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Golf Links Rd",
                        "Buderim Pines Dr near Treefern Ct",
                        "Oakmont Dr near Buderim Pines South Park",
                        "Oakmont Dr near Alfriston Dr",
                        "Karawatha St near Jingellic Dr hail 'n' ride",
                        "Jingellic Dr near Killeen Cl hail 'n' ride",
                        "Karawatha Dr near Jingellic Dr",
                        "Karawatha Dr near Dixon Rd",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Mooloolaba Rd at Foote Avenue",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Deloraine Dr near Whitehaven Dr",
                        "Cumberland Way near Glen Kyle Dr",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Wises Rd near Forestwood Drive",
                        "Wises Rd near Bluebush Ave",
                        "North Buderim Bvd near Highfield St hail 'n' ride",
                        "North Buderim Bvd near Pittards Rd",
                        "Pittards Rd near Cammeray Ct",
                        "Pittards Rd near Jones Rd",
                        "Maroochydore High Bus Bays",
                        "Maroochydore Rd at Maroochydore High",
                        "Pittards Rd near Jewel Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "Cumberland Way near Keswick Pl",
                        "Deloraine Dr near Lindeman Ave",
                        "Jingellic Dr near Amberton Ct hail 'n' ride",
                        "Karawatha St near Bringenbrong Dr hail 'n' ride",
                        "Karawatha Dr near Mountain Creek Rd"
                    ],
                    "5603: Mons/Buderim - Maroochydore High": [
                        "Mons Rd near Mons School Rd",
                        "Mons Rd near Twin Ridges Rd hail 'n' ride",
                        "Mons Rd near Wilguy Cr",
                        "Townsend Rd at Sage Street",
                        "Tulip Lane near Royal Dr",
                        "Lindsay Rd near Attunga Cr",
                        "Lindsay Rd near Feeley St",
                        "Main St at Buderim Mountain Primary School",
                        "King St at Water Street",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Mill Rd at Buderim Park Shopping Centre HnR",
                        "Mill Rd near Price Lane hail 'n' ride",
                        "Gloucester Rd near Orme Rd hail 'n' ride",
                        "Jones Rd at Horseshoe Bend",
                        "Maroochydore High Bus Bays",
                        "Maroochydore Rd at Maroochydore High",
                        "14 Orme Rd hail 'n' ride",
                        "Lindsay Rd near Tulip Lane",
                        "Tulip Lane at Royal Drive",
                        "William St near Mons Rd",
                        "Mons Rd near Twin Ridges Rd"
                    ],
                    "5604: Eudlo Flats - Maroochydore High": [
                        "David Low Way at Harbourside Holiday Resort",
                        "820 Diddillibah Rd hail 'n' ride",
                        "Diddillibah Rd near Bahdilli Cr hail 'n' ride",
                        "Diddillibah Rd at Diddillibah Community Hall HnR",
                        "Eudlo Flats Rd near Ellem Ct hail 'n' ride",
                        "Eudlo Flats Rd near Gateway Dr hail 'n' ride",
                        "Eudlo Flats Rd near Malones Rd hail 'n' ride",
                        "Old Maroochydore Rd at Vise Road",
                        "Old Maroochydore Rd at Stark Lane",
                        "Montessori College",
                        "Old Maroochydore Rd near Whites Rd",
                        "Hobbs Rd near Jarrah Rd hail 'n' ride",
                        "Sam White Dr near Loch Lomond Ct hail 'n' ride",
                        "Sam White Dr near Dungannon Ct hail 'n' ride",
                        "Maroochydore Rd near Pike St",
                        "Maroochydore Rd at Robert Street",
                        "Main Rd near Ghost Gum Ave",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Bradman Ave at Minti Street",
                        "Bradman Ave at Chambers Island",
                        "Broadmeadows Rd near Kenewin Ave hail 'n' ride",
                        "Maroochydore State Primary School",
                        "Maroochydore Rd at Homemaker Centre",
                        "Maroochydore High Bus Bays",
                        "Stella Maris Catholic Primary School",
                        "Main Rd near Radiata Dr",
                        "Main Rd near Pindari St",
                        "Main Rd near Tallow Wood Dr",
                        "Main Rd near Elkhorn St",
                        "Main Rd near Daintree Cl",
                        "Main Rd near Renison Dr",
                        "Kuluin State Primary School",
                        "Maroochydore Rd at Maroochydore High",
                        "Ball St near Hinley Ave hail 'n' ride",
                        "Bradman Ave near Denna St",
                        "Maroochydore Rd at Pike Street",
                        "Eudlo Flats Rd near Needham Ct hail 'n' ride",
                        "Diddillibah Rd near Melcar Ct hail 'n' ride",
                        "Diddillibah Rd near Clarkes Rd hail 'n' ride",
                        "Diddillibah Rd near Petrie Creek Rd hail 'n' ride"
                    ],
                    "5605: Bli Bli - Maroochydore High": [
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "School Rd at Bli Bli Primary school hail 'n' ride",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Harbourside Holiday Resort",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Maroochydore High Bus Bays",
                        "Maroochydore Rd at Maroochydore High",
                        "David Low Way at Bli Bli Castle",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr"
                    ],
                    "5606: Bli Bli - Maroochydore High": [
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Parklakes Dr at Agnes Place",
                        "Parklakes Dr at Camp Flat Road",
                        "Parklakes Dr at Clarence Avenue",
                        "Parklakes Dr at Bottlebrush Avenue",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "Willis Rd at Lefoes Rd",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Harbourside Holiday Resort",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Maroochydore High Bus Bays",
                        "Maroochydore Rd at Maroochydore High",
                        "David Low Way at Bli Bli Castle",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Thomas Rd near Samantha Dr"
                    ],
                    "5607: Mudjimba - Maroochydore High": [
                        "Mudjimba Esp near David Low Way",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Toyango St hail 'n' ride",
                        "Maroochydore High Bus Bays",
                        "Maroochydore Rd at Maroochydore High",
                        "David Low Way at Kowonga Street"
                    ],
                    "5608: Marcoola - Maroochydore High": [
                        "David Low Way at Lorraine Avenue",
                        "Tamarindus St near Willow Cr",
                        "Marcoola Esp at Marcoola SLSC",
                        "Petrie Ave at Marcoola",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "David Low Way near Surfrider Pl hail 'n' ride",
                        "David Low Way at Friendship Avenue",
                        "David Low Way at Pacific Paradise",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way at Namba Street",
                        "Maroochydore High Bus Bays",
                        "Maroochydore Rd at Maroochydore High",
                        "David Low Way at Kowonga Street",
                        "David Low Way at Fourth Avenue",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Petrie Ave near Begonia Way",
                        "Tamarindus St near Cycas St"
                    ],
                    "5609: Mount Coolum - Maroochydore High": [
                        "Jarnahill Dr near Quinn Ct",
                        "Lumeah Dr near Fairway Cl hail 'n' ride",
                        "Burremah Cr near Lumeah Dr hail 'n' ride",
                        "Marakari Cr near Coorara Ct hail 'n' ride",
                        "Lumeah Dr near Suncoast Beach Dr hail 'n' ride",
                        "David Low Way at Mount Coolum",
                        "Boardwalk Bvd near Breakers Pl hail 'n' ride",
                        "Seaside Bvd near David Low Way hail 'n' ride",
                        "Tamarindus St near Willow Cr",
                        "Marcoola Esp at Marcoola SLSC",
                        "Petrie Ave at Marcoola",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "Mudjimba Esp near David Low Way",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Toyango St hail 'n' ride",
                        "David Low Way near Godfreys Rd hail 'n' ride",
                        "Godfreys Ave near Waterview Cr hail 'n' ride",
                        "David Low Way at Kowonga Street",
                        "David Low Way at Namba Street",
                        "Pacific Paradise State Primary School",
                        "David Low Way at Pacific Paradise",
                        "Maroochydore High Bus Bays",
                        "Maroochydore Rd at Maroochydore High",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Petrie Ave near Begonia Way",
                        "Tamarindus St near Cycas St",
                        "Suncoast Beach Dr near Jarnahill Dr"
                    ],
                    "5610: Pacific Paradise - Maroochydore High": [
                        "David Low Way at Kowonga Street",
                        "David Low Way at Namba Street",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way at Pacific Paradise",
                        "David Low Way at Friendship Avenue",
                        "David Low Way at Fourth Avenue",
                        "David Low Way at Sunset Strip",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "David Low Way at Petrie Avenue",
                        "David Low Way at Lorraine Avenue",
                        "Tamarindus St near Willow Cr",
                        "Marcoola Esp at Marcoola SLSC",
                        "Petrie Ave at Marcoola",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "Mudjimba Esp near David Low Way",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Toyango St hail 'n' ride",
                        "Maroochydore High Bus Bays"
                    ],
                    "5611: Bli Bli - Maroochydore High": [
                        "School Rd at Bli Bli Primary school hail 'n' ride",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Parklakes Dr at Agnes Place",
                        "Parklakes Dr at Camp Flat Road",
                        "Parklakes Dr at Clarence Avenue",
                        "Parklakes Dr at Bottlebrush Avenue",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Harbourside Holiday Resort",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Maroochydore High Bus Bays"
                    ],
                    "5612: Buderim - Maroochydore High": [
                        "Hobbs Rd near Jarrah Rd hail 'n' ride",
                        "Sam White Dr near Loch Lomond Ct hail 'n' ride",
                        "Sam White Dr near Dungannon Ct hail 'n' ride",
                        "Old Maroochydore Rd near Whites Rd",
                        "Mons Rd near Mons School Rd",
                        "Mons Rd near Twin Ridges Rd hail 'n' ride",
                        "Mons Rd near Wilguy Cr",
                        "Townsend Rd at Sage Street",
                        "Tulip Lane near Royal Dr",
                        "Lindsay Rd near Attunga Cr",
                        "Lindsay Rd near Feeley St",
                        "Main St at Buderim Mountain Primary School",
                        "King St at Water Street",
                        "Mill Rd at Buderim Park Shopping Centre HnR",
                        "Mill Rd near Price Lane hail 'n' ride",
                        "Gloucester Rd near Orme Rd hail 'n' ride",
                        "Jones Rd at Horseshoe Bend",
                        "Pittards Rd near Jewel Ct",
                        "Pittards Rd near Cammeray Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "North Buderim Bvd near Highfield St hail 'n' ride",
                        "Wises Rd near Bluebush Ave",
                        "Wises Rd near Forestwood Drive",
                        "Wises Rd at Kayleigh Drive",
                        "Sugar Rd near Centenary Cr",
                        "Maud St at Coghlan Court",
                        "Maud St near Gloria St",
                        "Aerodrome Rd at Maud Street",
                        "Maroochydore station, platform 2",
                        "Maroochydore Rd at Homemaker Centre",
                        "Maroochydore High Bus Bays"
                    ],
                    "5616: Express from MSHS - GSC": [
                        "Maroochydore High Bus Bays",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Parklakes Dr at Good Samaritan Catholic College"
                    ],
                    "5631: Kawana - Mountain Creek High": [
                        "Kawana Bvd at The Decks Lake Kawana",
                        "Dune Vista Dr near Beachcomber Ct hail 'n' ride",
                        "Oceanic Dr near Wyanda Dr hail 'n' ride",
                        "Oceanic Dr near Bareena Pl hail 'n' ride",
                        "Oceanic Dr near Bandaroo St hail 'n' ride",
                        "Oceanic Dr near Currawan St hail 'n' ride",
                        "Lowanna Dr near Ilumba St hail 'n' ride",
                        "Buddina Primary School",
                        "Iluka Ave near near Undara Ave hail 'n' ride",
                        "Yaringa Ave near Boorook St hail 'n' ride",
                        "Point Cartwright Dr near Minya St hail 'n' ride",
                        "Point Cartwright Dr near Wingara St hail 'n' ride",
                        "Point Cartwright Dr near Ninyima St hail 'n' ride",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Lady Musgrave Dr at Mooloolaba TAFE",
                        "Mountain Creek State High",
                        "Lady Musgrave Dr at Mountain Creek High School",
                        "Nicklin Way at Jessica Park",
                        "Point Cartwright Dr near Nanyima St hail 'n' ride",
                        "Iluka Ave near Koolena St hail 'n' ride",
                        "Nicklin Way at Beach Drive"
                    ],
                    "5632: Caloundra/Dicky Beach - Mountain Creek High": [
                        "Caloundra Rd at Caloundra Police Station",
                        "Bowman Rd near First Ave",
                        "Ormuz Ave at Bingera Terrace",
                        "Bulcock St at Canberra Terrace",
                        "Moreton Pde at Mahia Terrace",
                        "Moreton Pde at Saltair Street",
                        "Edmund St at Caloundra Catholic Church",
                        "Edmund St near Simpson St hail 'n' ride",
                        "Edmund St at Russell Street",
                        "Rinaldi St at Moffat Beach",
                        "Buccleugh St at Bryce Street",
                        "Beerburrum St at Dicky Beach",
                        "Beerburrum St near Cooroy St",
                        "Beerburrum St at Caloundra Private Hospital",
                        "Beerburrum St near Albatross Ave",
                        "Curlew St near Cassowary St",
                        "Kalana Rd near Talara St",
                        "Saffron Dr near Burnsall St",
                        "Saffron Dr near Bluebell St",
                        "Talara Primary College",
                        "Erang St at Alstonville Way",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Lady Musgrave Dr at Mooloolaba TAFE",
                        "Mountain Creek State High",
                        "Lady Musgrave Dr at Mountain Creek High School",
                        "Kawana Waters State High School",
                        "Kawana State College Primary",
                        "Nicklin Way at Jessica Park",
                        "Nicklin Way at Beach Drive",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Minkara Street",
                        "Saffron Dr at Burnsall St",
                        "Curlew St near Beerburrum St",
                        "Beerburrum St near Sanderling St",
                        "Moreton Pde at Levuka Avenue",
                        "Moreton Pde at Canberra Terrace"
                    ],
                    "5633: Brightwater - Mountain Creek High": [
                        "Grand Pde near Kawana Island Bvd",
                        "Brightwater State School",
                        "Grand Pde near Maldives Pl",
                        "Brightwater Bvd near Panama Cr hail 'n' ride",
                        "Jamaica Way near Providence St",
                        "Manatunga Pde at Brightwater Bvd",
                        "Manatunga Pde at Lady Elliot Dr",
                        "Kawana Way at Island Point Villas",
                        "Brightwater Bvd at Frogmouth Cct hail 'n' ride",
                        "Bundilla Bvd at Cootamundra Drive",
                        "Lady Musgrave Dr at Mooloolaba TAFE",
                        "Attenuata Dr at Crayfish Street",
                        "Attenuata Dr at Amberjack Street",
                        "Mountain Creek State High",
                        "Lady Musgrave Dr at Mountain Creek High School"
                    ],
                    "5634: Sippy Downs - Mountain Creek High": [
                        "Sippy Downs Dr at High St",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Ballinger Rd near Lara Dr hail 'n' ride",
                        "Karawatha Dr near Dixon Rd",
                        "Karawatha Dr near Jingellic Dr",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Golf Links Rd",
                        "Karawatha Dr near Kapilano Cr",
                        "Karawatha Dr near Molakai Dr",
                        "Karawatha Dr near Saratoga Dr",
                        "Karawatha Dr near Satinay St",
                        "Glenfields Bvd at Greenway Place",
                        "Glenfields Bvd near Lacebark St",
                        "Glenfields Bvd near Escolar Dr",
                        "Glenfields Bvd at Sailfish Drive",
                        "Molakai Dr near Hermosa St",
                        "Mountain Creek State High",
                        "Lady Musgrave Dr at Mountain Creek High School",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr near Brianna Cl",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College"
                    ],
                    "5635: Buderim - Mountain Creek High": [
                        "Main St at Buderim Mountain Primary School",
                        "King St at Water Street",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Karawatha Dr near Dixon Rd",
                        "Karawatha Dr near Jingellic Dr",
                        "Jingellic Dr near Amberton Ct hail 'n' ride",
                        "Karawatha St near Bringenbrong Dr hail 'n' ride",
                        "Karawatha St near Alfriston Dr",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Golf Links Rd",
                        "Karawatha Dr near Kapilano Cr",
                        "Molakai Dr near Hermosa St",
                        "Mountain Creek State High",
                        "Lady Musgrave Dr at Mountain Creek High School",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha St near Jingellic Dr hail 'n' ride",
                        "Jingellic Dr near Killeen Cl hail 'n' ride"
                    ],
                    "5636: North Buderim - Mountain Creek High": [
                        "Pittards Rd near Jewel Ct",
                        "Pittards Rd near Cammeray Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "North Buderim Bvd near Highfield St hail 'n' ride",
                        "Wises Rd near Bluebush Ave",
                        "Wises Rd near Forestwood Drive",
                        "Wises Rd at Kayleigh Drive",
                        "Cumberland Way near Keswick Pl",
                        "Deloraine Dr near Lindeman Ave",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Mooloolaba Rd at Foote Avenue",
                        "Mooloolaba Rd at Golf Links Drive",
                        "Buderim Pines Dr near Treefern Ct",
                        "Oakmont Dr near Buderim Pines South Park",
                        "Oakmont Dr near Alfriston Dr",
                        "Mountain Creek State High",
                        "Deloraine Dr near Whitehaven Dr",
                        "Cumberland Way near Glen Kyle Dr",
                        "Wises Rd near Glen Kyle Dr",
                        "North Buderim Bvd near Pittards Rd",
                        "Pittards Rd near Jones Rd"
                    ],
                    "5637: Kuuin/Maroochydore - Mountain Creek High": [
                        "Mooloolaba Rd near Correa Pl",
                        "Main Rd near Radiata Dr",
                        "Buderim Av at Janet Street",
                        "Main Rd near Pindari St",
                        "Buderim Ave at Mary Street",
                        "Main Rd near Tallow Wood Dr",
                        "Buderim Ave at Douglas Street",
                        "Main Rd near Elkhorn St",
                        "Mooloolaba Esp at Meta Street",
                        "Main Rd near Daintree Cl",
                        "Walan St near Smith St",
                        "Maroochydore Multi Sports Complex hail 'n' ride",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Brisbane Rd at Woomba Place",
                        "Bradman Ave at Minti Street",
                        "Karawatha Dr near Satinay St",
                        "Bradman Ave at Chambers Island",
                        "Karawatha Dr near Saratoga Dr",
                        "Duporth Ave at Picnic Point",
                        "Molakai Dr near Hermosa St",
                        "Maroochydore station, platform 1",
                        "Mountain Creek State High",
                        "First Av at Future Way",
                        "Maud St near Gloria St",
                        "Maud St at Coghlan Court",
                        "Sugar Rd near Centenary Cr",
                        "Lady Musgrave Dr at Mountain Creek High School",
                        "Karawatha Dr near Molakai Dr",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Walan St near Bahlaka St",
                        "Mooloolaba Rd near Mary St",
                        "Maroochydore station, platform 2",
                        "Bradman Ave near Denna St",
                        "Main Rd near Advance Rd"
                    ],
                    "5638: Palmview - Mountain Creek High": [
                        "Sugar Mill Rd near Soprano St hail 'n' ride",
                        "Flintwood Cr at Elation Street",
                        "Flintwood Cr near Velvet Way hail 'n' ride",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Peter Crosby Way at Village Green Bvd",
                        "University Way near Claymore Rd",
                        "Albany St near Windermere Way",
                        "Albany St near Trinity Cr",
                        "Albany St near Bronte Ct",
                        "University Way at Chancellor Park",
                        "University Way at Hibiscus Resort",
                        "University Way at Chancellor Park Marketplace",
                        "Molakai Dr near Hermosa St",
                        "Mountain Creek State High",
                        "Lady Musgrave Dr at Mountain Creek High School",
                        "University Dr at Hibiscus Resort",
                        "University Way at Claymore Rd",
                        "Tranquility Way at Greenview Terrace"
                    ],
                    "5700: Kuluin - St John's College": [
                        "Stella Maris Catholic Primary School",
                        "Main Rd near Radiata Dr",
                        "Main Rd near Pindari St",
                        "Main Rd near Tallow Wood Dr",
                        "Main Rd near Elkhorn St",
                        "Main Rd near Daintree Cl",
                        "Main Rd near Renison Dr",
                        "St John's Catholic College",
                        "Perwillowen Road at Valley View Street",
                        "Main Rd near Ghost Gum Ave",
                        "Main Rd near Advance Rd"
                    ],
                    "5701: Sunshine Cove/Maroochydore - St John's College": [
                        "Sunshine Cove Way near Sunrise Dr hail 'n' ride",
                        "Maroochy Bvd at Sunrise Drive",
                        "Plaza Pde at Southern Drive",
                        "Maroochydore station, platform 2",
                        "Duporth Ave at Picnic Point",
                        "Bradman Ave at Chambers Island",
                        "Bradman Ave at Minti Street",
                        "Bradman Ave near Denna St",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Main Rd near Renison Dr",
                        "Maroochydore Rd at Robert Street",
                        "Maroochydore Rd at Pike Street",
                        "Nambour Connection Rd at Big Pineapple",
                        "Nambour Connection Rd at Woombye Gardens",
                        "629 Nambour Connection Rd hail 'n' ride",
                        "Lamington Tce near Magnolia St",
                        "St John's Catholic College",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Maroochydore Rd near Pike St",
                        "Main Rd near Ghost Gum Ave",
                        "Maroochydore station, platform 1",
                        "Plaza Pde at King Street",
                        "Sunshine Cove Way near Sunrise Dr"
                    ],
                    "5702: Golden Beach/Caloundra - Montessori College": [
                        "Landsborough Pde at Golden Beach Shops",
                        "Esplanade near McLean St hail 'n' ride",
                        "Esplanade near Burke St hail 'n' ride",
                        "Ormuz Ave at Bingera Terrace",
                        "Bulcock St at Canberra Terrace",
                        "Moreton Pde at Mahia Terrace",
                        "Moreton Pde at Saltair Street",
                        "Edmund St at Caloundra Catholic Church",
                        "Edmund St near Simpson St hail 'n' ride",
                        "Edmund St at Russell Street",
                        "Rinaldi St at Moffat Beach",
                        "Buccleugh St at Bryce Street",
                        "Beerburrum St at Dicky Beach",
                        "Beerburrum St near Cooroy St",
                        "Buderim St at Currimundi Hotel",
                        "Buderim St at Coryule Street",
                        "Talara Primary College",
                        "Erang St at Alstonville Way",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Karawatha Dr near Satinay St",
                        "Karawatha Dr near Saratoga Dr",
                        "Karawatha Dr near Molakai Dr",
                        "Karawatha Dr near Kapilano Cr",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Brianna Cl",
                        "Karawatha Dr near Jingellic Dr",
                        "Karawatha Dr near Dixon Rd",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Tanawha Tourist Dr near Glenmount Rd hail 'n' ride",
                        "38 Owen Creek Rd hail 'n' ride",
                        "Mons Rd near Owen Creek Rd",
                        "Sunshine Coast Grammar School",
                        "Montessori College",
                        "Sippy Downs Dr at High St",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Ballinger Rd near Lara Dr hail 'n' ride",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr near Golf Links Rd",
                        "Nicklin Way at Jessica Park",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Beach Drive",
                        "Erang St near Alstonville Way",
                        "Moreton Pde at Levuka Avenue",
                        "Moreton Pde at Canberra Terrace",
                        "The Esplanade near McLean St hail 'n' ride"
                    ],
                    "5704: Meridan Plans - Siena College": [
                        "Woodlands Bvd at Pacific Lutheran College",
                        "Woodlands Bvd at Forest Park Street",
                        "Creekside Bvd near Sycamore Dr",
                        "Creekside Bvd near Brushwood St",
                        "Creekside Bvd near Mimosa Cr",
                        "Creekside Bvd near Lakeside Cr",
                        "Talara Primary College",
                        "Erang St at Alstonville Way",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Dune Vista Dr near Beachcomber Ct hail 'n' ride",
                        "Oceanic Dr near Wyanda Dr hail 'n' ride",
                        "Oceanic Dr near Bareena Pl hail 'n' ride",
                        "Oceanic Dr near Bandaroo St hail 'n' ride",
                        "Oceanic Dr near Currawan St hail 'n' ride",
                        "Lowanna Dr near Ilumba St hail 'n' ride",
                        "Buddina Primary School",
                        "Iluka Ave near near Undara Ave hail 'n' ride",
                        "Yaringa Ave near Boorook St hail 'n' ride",
                        "Point Cartwright Dr near Minya St hail 'n' ride",
                        "Point Cartwright Dr near Wingara St hail 'n' ride",
                        "Point Cartwright Dr near Ninyima St hail 'n' ride",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Nicklin Way at Jessica Park",
                        "Point Cartwright Dr near Nanyima St hail 'n' ride",
                        "Iluka Ave near Koolena St hail 'n' ride",
                        "Nicklin Way at Beach Drive",
                        "Erang St near Alstonville Way",
                        "Creekside Bvd near Snapdragon St",
                        "Creekside Bvd near Oakdale Cct"
                    ],
                    "5705: Mountain Creek - St Joseph's Primary": [
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Chevallum Primary School",
                        "Karawatha St near Alfriston Dr",
                        "Chevallum Rd near Dales Rd hail 'n' ride",
                        "Chevallum Rd near Old Chevallum Rd hail 'n' ride",
                        "Oakmont Dr near Alfriston Dr",
                        "Oakmont Dr near Buderim Pines South Park",
                        "Chevallum Rd near Harris Dr hail 'n' ride",
                        "Chevallum Rd near Railway St",
                        "Buderim Pines Dr near Treefern Ct",
                        "Mooloolaba Rd at Golf Links Drive",
                        "Chevallum Rd opp Duck Pond hail 'n' ride",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Mooloolaba Rd at Foote Avenue",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "King St at Hamilton Street",
                        "Woombye State Primary School",
                        "King St at Water Street",
                        "Pine Grove Rd near Junee Ct",
                        "Main St at Buderim Mountain Primary School",
                        "Dinmore St near Wakefield St",
                        "Burnett St at Buderim Marketplace",
                        "Wakefield St near Blackall St",
                        "Lamington Tce near Magnolia St",
                        "Burnett St near Townsend Rd",
                        "Currie St at Nambour Library",
                        "William St near Mons Rd",
                        "Mons Rd near Twin Ridges Rd",
                        "Nambour State High School",
                        "Mons Rd near Owen Creek Rd",
                        "Rainforest Rd near Chevallum Rd hail 'n' ride",
                        "Coronation Ave at Matthew Street",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Pine Grove Rd at Woombye State School",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride",
                        "Chevallum Rd near Bareena Ct hail 'n' ride",
                        "99 Chevallum Rd hail 'n' ride",
                        "Mons Rd near Mons School Rd",
                        "Mons Rd near Twin Ridges Rd hail 'n' ride",
                        "Mons Rd near Wilguy Cr",
                        "King St at Wirreanda Park"
                    ],
                    "5708: Pacific Paradise/Bli Bli - Burnside High": [
                        "David Low Way at Namba Street",
                        "School Rd at Bli Bli Primary school hail 'n' ride",
                        "Coronation Ave at Show and Sportsgrounds",
                        "David Low Way near Godfreys Rd hail 'n' ride",
                        "David Low Way at Bli Bli hail 'n' ride",
                        "Nambour State High School",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "Coronation Ave at Matthew Street",
                        "Currie St at Nambour Library",
                        "Burnside State High School",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Carter Rd at Arundell Ave",
                        "Mill Lane at Nambour Mill Village",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Kowonga Street"
                    ],
                    "5710: Tanawha/Mons/Buderim - Chancellor College": [
                        "Tanawha Tourist Dr near Glenmount Rd hail 'n' ride",
                        "38 Owen Creek Rd hail 'n' ride",
                        "Mons Rd near Mons School Rd",
                        "Mons Rd near Twin Ridges Rd hail 'n' ride",
                        "Mons Rd near Wilguy Cr",
                        "Burnett St near Townsend Rd",
                        "Burnett St at Buderim Marketplace",
                        "Main St at Buderim Mountain Primary School",
                        "King St at Water Street",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Ochre Way",
                        "Chancellor State College",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Ballinger Rd near Lara Dr hail 'n' ride",
                        "William St near Mons Rd",
                        "Mons Rd near Twin Ridges Rd"
                    ],
                    "5711: Buderim - Chancellor College": [
                        "Chancellor State College",
                        "Main St at Buderim Mountain Primary School"
                    ],
                    "5712: Pelican Waters - Immanuel Lutheran College": [
                        "Caloundra City Private School",
                        "Kalowendha Ave near Agincourt St hail 'n' ride",
                        "Bledisloe Bvd near Scartree St hail 'n' ride",
                        "Bledisloe Bvd near Mahogany Dr hail 'n' ride",
                        "Spitfire Banks Dr nr New Holland Dr HnR",
                        "Michael St near Carmel St hail 'n' ride",
                        "Catherine St near Judy St",
                        "Verdon St near Catherine St",
                        "Pelican Waters Bvd near Anning Ave hail 'n' ride",
                        "Lamerough Pde near Moorshead Ave hail 'n' ride",
                        "Sir Joseph Banks Dr near Godwin Pl hail 'n' ride",
                        "Nelson St near Caldwell St",
                        "Nelson St near Palmer Ave hail 'n' ride",
                        "Landsborough Pde at Golden Beach Shops",
                        "Esplanade near McLean St hail 'n' ride",
                        "Esplanade near Burke St hail 'n' ride",
                        "Bowman Rd near First Ave",
                        "Caloundra Rd at Caloundra Police Station",
                        "Beerburrum St near Albatross Ave",
                        "Saffron Dr near Burnsall St",
                        "Saffron Dr near Bluebell St",
                        "Talara Primary College",
                        "Erang St at Alstonville Way",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Lowanna Dr near Ilumba St hail 'n' ride",
                        "Buddina Primary School",
                        "Iluka Ave near near Undara Ave hail 'n' ride",
                        "Yaringa Ave near Boorook St hail 'n' ride",
                        "Point Cartwright Dr near Minya St hail 'n' ride",
                        "Point Cartwright Dr near Wingara St hail 'n' ride",
                        "Point Cartwright Dr near Ninyima St hail 'n' ride",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Immanuel Lutheran College",
                        "Nicklin Way at Jessica Park",
                        "Point Cartwright Dr near Nanyima St hail 'n' ride",
                        "Iluka Ave near Koolena St hail 'n' ride",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Beach Drive",
                        "Erang St near Alstonville Way",
                        "Saffron Dr at Burnsall St",
                        "Beerburrum St near Sanderling St",
                        "The Esplanade near McLean St hail 'n' ride",
                        "Nelson St near Palmer Ave",
                        "Catherine St near Maryann St",
                        "Pelican Waters Bvd near Agincourt St"
                    ],
                    "5715: Marcoola - Good Samaritan College": [
                        "David Low Way at Lorraine Avenue",
                        "Tamarindus St near Willow Cr",
                        "Marcoola Esp at Marcoola SLSC",
                        "Petrie Ave at Marcoola",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "Mudjimba Esp near David Low Way",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Toyango St hail 'n' ride",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Petrie Ave near Begonia Way",
                        "Tamarindus St near Cycas St"
                    ],
                    "5716: Buderim Meadows - Stella Maris Primary": [
                        "Karawatha Dr near Dixon Rd",
                        "Karawatha Dr near Jingellic Dr",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Golf Links Rd",
                        "Karawatha Dr near Kapilano Cr",
                        "Karawatha Dr near Molakai Dr",
                        "Karawatha Dr near Saratoga Dr",
                        "Karawatha Dr near Satinay St",
                        "Bundilla Bvd at Cootamundra Drive",
                        "Brightwater Bvd at Frogmouth Cct hail 'n' ride",
                        "Attenuata Dr at Crayfish Street",
                        "Attenuata Dr at Amberjack Street",
                        "Brightwater State School",
                        "Brightwater Bvd near Panama Cr hail 'n' ride",
                        "Manatunga Pde at Brightwater Bvd",
                        "Manatunga Pde at Lady Elliot Dr",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Walan St near Bahlaka St",
                        "Palm Dr near Brentwood Ave",
                        "Ocean View Ave near Greygum Ct hail 'n' ride",
                        "Parkway Dr near Poinsettia Ave hail 'n' ride",
                        "Ocean View Ave near Aruma Ct",
                        "Pettigrew St near Kalinda Ave",
                        "Buderim Ave at Douglas Street",
                        "Alexandra Pde at Alexandra Headland",
                        "Alexandra Pde at Wilkes Family Park",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Okinja Rd at Wirraway Street",
                        "Maroubra St near Wrigley St",
                        "Bungama St near May St",
                        "Maud St near Gloria St",
                        "Maud St at Coghlan Court",
                        "Sugar Rd near Centenary Cr",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Immanuel Lutheran College",
                        "Sunshine Cove Way near Sunrise Dr",
                        "Sunshine Cove Way near Sunrise Dr hail 'n' ride",
                        "Maroochy Bvd at Sunrise Drive",
                        "Maroochydore Rd at Homemaker Centre",
                        "Maroochydore Rd at Maroochydore High",
                        "Stella Maris Catholic Primary School",
                        "Maroubra St near Wirraway St",
                        "Wirraway St near Okinja Rd",
                        "Pettigrew St near Marjorie St",
                        "Ocean View Ave near Warrina Ct",
                        "Walan St near Smith St",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Brisbane Rd at Woomba Place",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr near Brianna Cl"
                    ],
                    "5717: Caloundra - Siena College": [
                        "Caloundra Rd at Caloundra Police Station",
                        "Bowman Rd near First Ave",
                        "Suller St near Nutley St",
                        "Mary St near Arthur St",
                        "George St at Caloundra State School",
                        "William St near Buccleugh St",
                        "Buccleugh St at Bryce Street",
                        "Beerburrum St at Dicky Beach",
                        "Beerburrum St near Cooroy St",
                        "Buderim St at Currimundi Hotel",
                        "Currimundi Rd near Ilya St",
                        "Gothic Pde near Edna St",
                        "Gannawarra St near Menyan St hail 'n' ride",
                        "Nicklin Way at Currimundi",
                        "Erang St near Alstonville Way",
                        "Talara Primary College",
                        "Nicklin Way at Coora Crescent",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at 224 Centre",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Nicklin Way at Jessica Park",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Beach Drive",
                        "Buccleugh St near Nothling St",
                        "William St near Maltman St Nth",
                        "Orsova Tce near Osterley Ave"
                    ],
                    "5718: Maroochydore/Alexandra Headland - Siena College": [
                        "Wises Rd at Kayleigh Drive",
                        "Sugar Rd near Centenary Cr",
                        "Maud St at Coghlan Court",
                        "Maud St near Gloria St",
                        "First Av at Future Way",
                        "Aerodrome Rd at Maud Street",
                        "Aerodrome Rd at Rose Street",
                        "Maroubra St near Wirraway St",
                        "Wirraway St near Okinja Rd",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Mary St near William St",
                        "Buderim Ave at Mary Street",
                        "Pettigrew St near Marjorie St",
                        "Ocean View Ave near Warrina Ct",
                        "Ocean View Ave near Greygum Ct hail 'n' ride",
                        "Parkway Dr near Poinsettia Ave hail 'n' ride",
                        "Palm Dr near Brentwood Ave",
                        "Walan St near Smith St",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Brisbane Rd at Woomba Place",
                        "Glenfields Bvd at Greenway Place",
                        "Glenfields Bvd near Lacebark St",
                        "Glenfields Bvd near Escolar Dr",
                        "Glenfields Bvd at Sailfish Drive",
                        "Karawatha Dr near Satinay St",
                        "Karawatha Dr near Saratoga Dr",
                        "Karawatha Dr near Molakai Dr",
                        "Karawatha Dr near Kapilano Cr",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Brianna Cl",
                        "Karawatha Dr near Jingellic Dr",
                        "Karawatha Dr near Dixon Rd",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Dixon Road at Power Road",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr near Golf Links Rd",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Walan St near Bahlaka St",
                        "Ocean View Ave near Aruma Ct",
                        "Pettigrew St near Kalinda Ave",
                        "Mooloolaba Rd near Mary St",
                        "Mary St near Kate St",
                        "Okinja Rd at Wirraway Street",
                        "Maroubra St near Wrigley St",
                        "Wises Rd near Glen Kyle Dr"
                    ],
                    "5719: Bli Bli - Siena College": [
                        "School Rd at Bli Bli Primary school hail 'n' ride",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Harbourside Holiday Resort",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Bradman Ave at Minti Street",
                        "Bradman Ave at Chambers Island",
                        "Broadmeadows Rd near Kenewin Ave hail 'n' ride",
                        "Maroochydore station, platform 1",
                        "First Ave near Memorial Ave",
                        "King St at Cotton Tree Caravan Park",
                        "Sixth Ave at Maroochy Library",
                        "Sixth Ave at Sea Breeze Caravan Park",
                        "Alexandra Pde at Okinja Road",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Mooloolaba Rd near Correa Pl",
                        "Wises Rd near Glen Kyle Dr",
                        "Immanuel Lutheran College",
                        "Wises Rd at Kayleigh Drive",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Cotton Tree Pde at Cotton Tree Caravan Park",
                        "First Ave near George St",
                        "Maroochydore station, platform 2",
                        "Ball St near Hinley Ave hail 'n' ride",
                        "Bradman Ave near Denna St",
                        "David Low Way at Bli Bli Castle",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd"
                    ],
                    "5723: Pacific Paradise - Peregian Springs Primary": [
                        "David Low Way at Kowonga Street",
                        "David Low Way at Namba Street",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way at Pacific Paradise",
                        "David Low Way at Friendship Avenue",
                        "David Low Way at Fourth Avenue",
                        "David Low Way at Sunset Strip",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Petrie Ave near Begonia Way",
                        "Petrie Ave at Marcoola",
                        "Marcoola Esp at Marcoola SLSC",
                        "Tamarindus St near Cycas St",
                        "Seaside Bvd near David Low Way hail 'n' ride",
                        "Boardwalk Bvd near Breakers Pl hail 'n' ride",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Lumeah Dr near Fairway Cl hail 'n' ride",
                        "Burremah Cr near Lumeah Dr hail 'n' ride",
                        "Marakari Cr near Coorara Ct hail 'n' ride",
                        "Lumeah Dr near Suncoast Beach Dr hail 'n' ride",
                        "David Low Way at Mount Coolum",
                        "David Low Way at Tanah Street",
                        "David Low Way at Warran Road",
                        "David Low Way at Yaroomba Beach",
                        "David Low Way at Point Arkwright",
                        "David Low Way at Wilkinson Park",
                        "Yandina Coolum Rd near Greenoaks Dr hail 'n' ride",
                        "Yandina Coolum Rd near Park Cr",
                        "Coolum State Primary School",
                        "Ridges Bvd at Mallee Street",
                        "Peregian Springs State School",
                        "Ridgeview Dr at Laurina Way",
                        "David Low Way near Goongilla St",
                        "David Low Way near Yaroomba Dr hail 'n' ride",
                        "Tamarindus St near Willow Cr",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way near Surfrider Pl hail 'n' ride"
                    ],
                    "5724: South Coolum - Burnside High": [
                        "South Coolum Rd near Green Oaks Dr",
                        "South Coolum Rd near Wandaa Ct",
                        "Toolga St near Warrack St",
                        "Jarnahill Dr near Quinn Ct",
                        "Lumeah Dr near Fairway Cl hail 'n' ride",
                        "Burremah Cr near Lumeah Dr hail 'n' ride",
                        "Marakari Cr near Coorara Ct hail 'n' ride",
                        "Lumeah Dr near Suncoast Beach Dr hail 'n' ride",
                        "David Low Way at Mount Coolum",
                        "David Low Way at Seaside Boulevard",
                        "David Low Way at Lorraine Avenue",
                        "David Low Way at Petrie Avenue",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "David Low Way near Surfrider Pl hail 'n' ride",
                        "David Low Way at Friendship Avenue",
                        "David Low Way at Pacific Paradise",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way at Namba Street",
                        "Nambour State High School",
                        "Coronation Ave at Matthew Street",
                        "Currie St at Nambour Library",
                        "Windsor Rd at Nambour TAFE",
                        "Burnside State High School",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Carter Rd at Arundell Ave",
                        "Mill Lane at Nambour Mill Village",
                        "David Low Way at Fourth Avenue",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Toolga St near Carrock Ct"
                    ],
                    "5725: Coolum Beach - Stella Maris Primary": [
                        "David Low Way at Coolum Beach",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Point Arkwright",
                        "David Low Way near Goongilla St",
                        "David Low Way at Warran Road",
                        "David Low Way near Yaroomba Dr hail 'n' ride",
                        "David Low Way at Tanah Street",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Lumeah Dr near Fairway Cl hail 'n' ride",
                        "Burremah Cr near Lumeah Dr hail 'n' ride",
                        "Marakari Cr near Coorara Ct hail 'n' ride",
                        "David Low Way at Mount Coolum",
                        "Boardwalk Bvd near Breakers Pl hail 'n' ride",
                        "Seaside Bvd near David Low Way hail 'n' ride",
                        "David Low Way at Lorraine Avenue",
                        "David Low Way at Petrie Avenue",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "Mudjimba Esp near David Low Way",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Toyango St hail 'n' ride",
                        "Pittards Rd near Jewel Ct",
                        "Pittards Rd near Cammeray Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "North Buderim Bvd near Highfield St hail 'n' ride",
                        "Wises Rd near Bluebush Ave",
                        "Wises Rd near Forestwood Drive",
                        "Immanuel Lutheran College",
                        "Stella Maris Catholic Primary School",
                        "North Buderim Bvd near Pittards Rd",
                        "Pittards Rd near Jones Rd",
                        "David Low Way at Kowonga Street",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "David Low Way at Yaroomba Beach"
                    ],
                    "5726: Coolum Beach - St John's College": [
                        "David Low Way at Coolum Beach",
                        "Birtwill St near David Low Way",
                        "Banksia Ave at Tradewinds Avenue",
                        "Central Ave near Palm Ave",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Point Arkwright",
                        "David Low Way near Goongilla St",
                        "David Low Way at Warran Road",
                        "David Low Way near Yaroomba Dr hail 'n' ride",
                        "David Low Way at Tanah Street",
                        "David Low Way at Mount Coolum",
                        "Boardwalk Bvd near Breakers Pl hail 'n' ride",
                        "Seaside Bvd near David Low Way hail 'n' ride",
                        "Tamarindus St near Willow Cr",
                        "Marcoola Esp at Marcoola SLSC",
                        "Petrie Ave at Marcoola",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "Mudjimba Esp near David Low Way",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Toyango St hail 'n' ride",
                        "Nambour State High School",
                        "Coronation Ave at Matthew Street",
                        "Currie St at Nambour Library",
                        "St John's Catholic College",
                        "Perwillowen Road at Valley View Street",
                        "Mill Lane at Nambour Mill Village",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Petrie Ave near Begonia Way",
                        "Tamarindus St near Cycas St",
                        "David Low Way at Yaroomba Beach",
                        "Yandina Coolum Rd near Greenoaks Dr hail 'n' ride",
                        "Central Ave near Pandanus Ave",
                        "Banksia Ave near Tradewinds Ave",
                        "Birtwill St near Heathfield Rd"
                    ],
                    "5727: Buderim - Chancellor College": [
                        "Townsend Rd at Sage Street",
                        "Tulip Lane near Royal Dr",
                        "Lindsay Rd near Attunga Cr",
                        "Lindsay Rd near Feeley St",
                        "Main St at Buderim Mountain Primary School",
                        "Gloucester Rd at Fielding Street",
                        "Mill Rd near Price Lane hail 'n' ride",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Ochre Way",
                        "Chancellor State College",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Ballinger Rd near Lara Dr hail 'n' ride",
                        "Mill Rd at Buderim Park Shopping Centre HnR",
                        "Lindsay Rd near Tulip Lane",
                        "Tulip Lane at Royal Drive"
                    ],
                    "5728: Cotton Tree/Maroochydore - St Joseph's Primary": [
                        "Sixth Ave at Sea Breeze Caravan Park",
                        "Sixth Ave at Maroochy Library",
                        "Cotton Tree Pde at Cotton Tree Caravan Park",
                        "First Ave near George St",
                        "First Av at Future Way",
                        "Maud St near Gloria St",
                        "Maud St at Coghlan Court",
                        "Sugar Rd near Centenary Cr",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Wises Rd near Forestwood Drive",
                        "Wises Rd near Bluebush Ave",
                        "North Buderim Bvd near Highfield St hail 'n' ride",
                        "North Buderim Bvd near Pittards Rd",
                        "Pittards Rd near Cammeray Ct",
                        "Pittards Rd near Jones Rd",
                        "Maroochydore Rd at Robert Street",
                        "Maroochydore Rd at Pike Street",
                        "Hobbs Rd near Jarrah Rd hail 'n' ride",
                        "Sam White Dr near Loch Lomond Ct hail 'n' ride",
                        "Sam White Dr near Dungannon Ct hail 'n' ride",
                        "Old Maroochydore Rd near Whites Rd",
                        "Old Maroochydore Rd at Vise Road",
                        "Old Maroochydore Rd at Stark Lane",
                        "Sunshine Coast Grammar School",
                        "Mons Rd near Owen Creek Rd",
                        "Nambour Connection Rd at Big Pineapple",
                        "Nambour Connection Rd at Woombye Gardens",
                        "629 Nambour Connection Rd hail 'n' ride",
                        "Lamington Tce near Magnolia St",
                        "Currie St at Nambour Library",
                        "Nambour State High School",
                        "Coronation Ave at Matthew Street",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Stark Lane at Vyner Court",
                        "Maroochydore Rd near Pike St",
                        "Pittards Rd near Jewel Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "First Ave near Memorial Ave",
                        "King St at Cotton Tree Caravan Park"
                    ],
                    "5729: North Buderim - Sunshine Coast Grammar": [
                        "Wises Rd near Forestwood Drive",
                        "Sunshine Cove Way near Sunrise Dr",
                        "Sunshine Cove Way near Sunrise Dr hail 'n' ride",
                        "Maroochy Bvd at Sunrise Drive",
                        "Plaza Pde at Southern Drive",
                        "First Av at Future Way",
                        "Maud St near Gloria St",
                        "Maud St at Coghlan Court",
                        "Sugar Rd near Centenary Cr",
                        "Mooloolaba Rd at Buderim Garden Village",
                        "Mooloolaba Rd at Golf Links Drive",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Mooloolaba Rd at Foote Avenue",
                        "King St at Hamilton Street",
                        "King St at Water Street",
                        "Main St at Buderim Mountain Primary School",
                        "Burnett St at Buderim Marketplace",
                        "Burnett St near Townsend Rd",
                        "William St near Mons Rd",
                        "Mons Rd near Twin Ridges Rd",
                        "Mons Rd near Owen Creek Rd",
                        "Sunshine Coast Grammar School",
                        "Mons Rd near Mons School Rd",
                        "Mons Rd near Twin Ridges Rd hail 'n' ride",
                        "Mons Rd near Wilguy Cr",
                        "King St at Wirreanda Park",
                        "Plaza Pde at King Street"
                    ],
                    "5732: Marcus Beach - Good Samaritan College": [
                        "David Low Way at Marcus Beach",
                        "David Low Way at Mahogany Drive",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Peregian South",
                        "David Low Way at Coolum High School",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Beach",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Point Arkwright",
                        "David Low Way near Goongilla St",
                        "David Low Way at Warran Road",
                        "David Low Way near Yaroomba Dr hail 'n' ride",
                        "David Low Way at Tanah Street",
                        "David Low Way at Mount Coolum",
                        "Boardwalk Bvd near Breakers Pl hail 'n' ride",
                        "Seaside Bvd near David Low Way hail 'n' ride",
                        "David Low Way at Lorraine Avenue",
                        "David Low Way at Petrie Avenue",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "David Low Way at Yaroomba Beach",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride"
                    ],
                    "5735: North Buderim - Siena College": [
                        "Pittards Rd near Jewel Ct",
                        "Pittards Rd near Cammeray Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "North Buderim Bvd near Highfield St hail 'n' ride",
                        "Wises Rd near Bluebush Ave",
                        "Wises Rd near Forestwood Drive",
                        "Wises Rd at Kayleigh Drive",
                        "Cumberland Way near Keswick Pl",
                        "Deloraine Dr near Lindeman Ave",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Mooloolaba Rd at Foote Avenue",
                        "King St at Hamilton Street",
                        "King St at Water Street",
                        "Main St at Buderim Mountain Primary School",
                        "Burnett St at Buderim Marketplace",
                        "Burnett St near Townsend Rd",
                        "Townsend Rd at Sage Street",
                        "Tulip Lane near Royal Dr",
                        "Lindsay Rd near Attunga Cr",
                        "Lindsay Rd near Feeley St",
                        "Ballinger Rd near Ballinger Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Sippy Downs Dr at High St",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Lindsay Rd near Tulip Lane",
                        "Tulip Lane at Royal Drive",
                        "King St at Wirreanda Park",
                        "Deloraine Dr near Whitehaven Dr",
                        "Cumberland Way near Glen Kyle Dr",
                        "Wises Rd near Glen Kyle Dr",
                        "North Buderim Bvd near Pittards Rd",
                        "Pittards Rd near Jones Rd"
                    ],
                    "5739: Sunshine Cove - Good Samaritan College": [
                        "Sunshine Cove Way near Sunrise Dr hail 'n' ride",
                        "Wises Rd near Forestwood Drive",
                        "Wises Rd near Bluebush Ave",
                        "North Buderim Bvd near Highfield St hail 'n' ride",
                        "North Buderim Bvd near Pittards Rd",
                        "Pittards Rd near Cammeray Ct",
                        "Pittards Rd near Jones Rd",
                        "Maroochydore Rd at Robert Street",
                        "Maroochydore Rd at Pike Street",
                        "Hobbs Rd near Jarrah Rd hail 'n' ride",
                        "Sam White Dr near Loch Lomond Ct hail 'n' ride",
                        "Sam White Dr near Dungannon Ct hail 'n' ride",
                        "Old Maroochydore Rd near Whites Rd",
                        "Eudlo Flats Rd near Needham Ct hail 'n' ride",
                        "Eudlo Flats Rd near Ellem Ct hail 'n' ride",
                        "Diddillibah Rd near Eudlo Flats Rd hail 'n' ride",
                        "Diddillibah Rd near Melcar Ct hail 'n' ride",
                        "Diddillibah Rd near Clarkes Rd hail 'n' ride",
                        "Diddillibah Rd near Petrie Creek Rd hail 'n' ride",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Bli Bli Castle",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "Diddillibah Rd near Bahdilli Cr hail 'n' ride",
                        "Diddillibah Rd at Diddillibah Community Hall HnR",
                        "Eudlo Flats Rd near Gateway Dr hail 'n' ride",
                        "Eudlo Flats Rd near Malones Rd hail 'n' ride",
                        "Maroochydore Rd near Pike St",
                        "Pittards Rd near Jewel Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "Sunshine Cove Way near Sunrise Dr"
                    ],
                    "5740: Forest Glen - Good Samaritan College": [
                        "Mons Rd at Forest Glen",
                        "Mons Rd near Mons School Rd",
                        "Mons Rd near Twin Ridges Rd hail 'n' ride",
                        "Mons Rd near Wilguy Cr",
                        "Burnett St near Townsend Rd",
                        "Burnett St at Buderim Marketplace",
                        "Main St at Buderim Mountain Primary School",
                        "King St at Water Street",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Mooloolaba Rd at Foote Avenue",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Mooloolaba Rd at Golf Links Drive",
                        "Mooloolaba Rd at Buderim Garden Village",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Main Rd near Ghost Gum Ave",
                        "Main Rd near Advance Rd",
                        "Main Rd near Elkhorn St",
                        "Main Rd near Tallow Wood Dr",
                        "Main Rd near Pindari St",
                        "Main Rd near Radiata Dr",
                        "Maroochydore Rd at Maroochydore High",
                        "Maroochydore Rd at Homemaker Centre",
                        "Ball St near Hinley Ave hail 'n' ride",
                        "Bradman Ave at Chambers Island",
                        "Bradman Ave at Minti Street",
                        "Bradman Ave near Denna St",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "David Low Way at Harbourside Holiday Resort",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Bli Bli Castle",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "Broadmeadows Rd near Kenewin Ave hail 'n' ride",
                        "Main Rd near Daintree Cl",
                        "Main Rd near Renison Dr",
                        "William St near Mons Rd",
                        "Mons Rd near Twin Ridges Rd",
                        "Mons Rd near Owen Creek Rd"
                    ],
                    "5741: Kuluin - St Joseph's Primary": [
                        "Maroochydore Multi Sports Complex hail 'n' ride",
                        "David Low Way at Harbourside Holiday Resort",
                        "820 Diddillibah Rd hail 'n' ride",
                        "Diddillibah Rd near Bahdilli Cr hail 'n' ride",
                        "Diddillibah Rd at Diddillibah Community Hall HnR",
                        "Diddillibah Rd near Mango Vale Ct hail 'n' ride",
                        "Diddillibah Rd near Rose Marie Dr hail 'n' ride",
                        "354 Diddillibah Rd hail 'n' ride",
                        "Diddillibah Rd near Brookfield Ct hail 'n' ride",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Wakefield St near Blackall St",
                        "Plantation Rise Dr near Davey Dr hail 'n' ride",
                        "Plantation Rise Dr near Ridgeview Pl hail 'n' ride",
                        "Woombye State Primary School",
                        "Pine Grove Rd near Junee Ct",
                        "Dinmore St near Wakefield St",
                        "Cobbs Rd near Paynter Park Dr hail 'n' ride",
                        "Nambour Christian College",
                        "Lamington Tce near Magnolia St",
                        "Currie St at Nambour Library",
                        "Nambour State High School",
                        "Coronation Ave at Matthew Street",
                        "Pine Grove Rd at Woombye State School",
                        "Diddillibah Rd near Preston Rd hail 'n' ride",
                        "Diddillibah Rd near Eudlo Flats Rd hail 'n' ride",
                        "Diddillibah Rd near Melcar Ct hail 'n' ride",
                        "Diddillibah Rd near Clarkes Rd hail 'n' ride",
                        "Diddillibah Rd near Petrie Creek Rd hail 'n' ride"
                    ],
                    "5742: Eudlo Flats - St John's College": [
                        "Montessori College",
                        "Old Maroochydore Rd at Stark Lane",
                        "Old Maroochydore Rd at Vise Road",
                        "Eudlo Flats Rd near Needham Ct hail 'n' ride",
                        "Eudlo Flats Rd near Ellem Ct hail 'n' ride",
                        "Kiel Mountain Rd near Fernhill Pl hail 'n' ride",
                        "Kiel Mountain Rd near Merimist Way hail 'n' ride",
                        "Kiel Mountain Rd near Old Kiel Mountain Rd 1st HnR",
                        "Kiel Mountain Rd near Old Kiel Mountain Rd 2nd HnR",
                        "Kiel Mountain Rd near Meher Rd hail 'n' ride",
                        "Kiel Mountain Rd near Kentish Rd hail 'n' ride",
                        "Opposite 27 Kiel Mountain Rd hail 'n' ride",
                        "Suncoast Christian College",
                        "Woombye State Primary School",
                        "Pine Grove Rd near Junee Ct",
                        "Dinmore St near Wakefield St",
                        "Wakefield St near Blackall St",
                        "Nambour Christian College",
                        "Lamington Tce near Magnolia St",
                        "St John's Catholic College",
                        "Perwillowen Road at Valley View Street",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Pine Grove Rd at Woombye State School",
                        "59/61 Kiel Mountain Rd hail 'n' ride",
                        "183/199 Kiel Mountain Rd hail 'n' ride",
                        "247 Kiel Mountain Rd hail 'n' ride",
                        "275 Kiel Mountain Rd hail 'n' ride",
                        "Kiel Mountain Rd near Bellwood Ct hail 'n' ride",
                        "Eudlo Flats Rd near Gateway Dr hail 'n' ride",
                        "Eudlo Flats Rd near Malones Rd hail 'n' ride"
                    ],
                    "5743: West Woombye - Burnside High": [
                        "Nambour Christian College",
                        "Blackall Range Rd near Laidlaw Rd hail 'n' ride",
                        "91 Blackall Range Rd hail 'n' ride",
                        "Blackall Range Rd near Hamilton Rd hail 'n' ride",
                        "Jacksons Rd near Kalang Dr hail 'n' ride",
                        "Jacksons Rd near Simba Rd hail 'n' ride",
                        "Jacksons Rd near Blackall Range Rd hail 'n' ride",
                        "Blackall Range Rd near Carruthers Rd hail 'n' ride",
                        "Blackall Range Rd near Menary Rd hail 'n' ride",
                        "Old Palmwoods Rd near Reids Rd hail 'n' ride",
                        "Mckees Rd near Parsons Knob Rd hail 'n' ride",
                        "Jubilee Dr at G Rae Oval hail 'n' ride",
                        "Jubilee Dr near Woombye Palmwoods Rd",
                        "Main St at Palmwoods Railway Station",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Montville Rd near Dunning St",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "Woombye State Primary School",
                        "Pine Grove Rd near Junee Ct",
                        "Dinmore St near Wakefield St",
                        "Wakefield St near Blackall St",
                        "Lamington Tce near Magnolia St",
                        "Burnside State High School",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Carter Rd at Arundell Ave",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Pine Grove Rd at Woombye State School",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Jubilee Dr near Hobson St hail 'n' ride",
                        "Old Palmwoods Rd near Mullers Rd hail 'n' ride"
                    ],
                    "5744: Chevallum - Palmwoods Primary": [
                        "Chevallum Primary School",
                        "Chevallum Rd near Dales Rd hail 'n' ride",
                        "Chevallum Rd near Old Chevallum Rd hail 'n' ride",
                        "Chevallum Rd near Harris Dr hail 'n' ride",
                        "Chevallum Rd near Railway St",
                        "Chevallum Rd opp Duck Pond hail 'n' ride",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Parkpine Dr near Skyline Cct hail 'n' ride",
                        "Abbotts Rd near Parkpine Dr hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride",
                        "Main St at Palmwoods Railway Station",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Petigrain Ave at Old Orchard Drive",
                        "Landershute Rd at Petigrain Avenue",
                        "Montville Rd at Palmwoods Primary",
                        "Palmwoods School Rd at Cobb and Co Lane",
                        "Montville Rd near Dunning St",
                        "Main st near Lawson Park hail 'n' ride",
                        "Chevallum Rd near Bareena Ct hail 'n' ride",
                        "99 Chevallum Rd hail 'n' ride"
                    ],
                    "5745: Palmwoods - Siena College": [
                        "Main St at Palmwoods Railway Station",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Montville Rd at Palmwoods Primary",
                        "Montville Rd near Dunning St",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "Woombye State Primary School",
                        "Pine Grove Rd near Junee Ct",
                        "Dinmore St near Wakefield St",
                        "Wakefield St near Blackall St",
                        "Pine Grove Rd at Woombye State School",
                        "59/61 Kiel Mountain Rd hail 'n' ride",
                        "183/199 Kiel Mountain Rd hail 'n' ride",
                        "247 Kiel Mountain Rd hail 'n' ride",
                        "275 Kiel Mountain Rd hail 'n' ride",
                        "Kiel Mountain Rd near Bellwood Ct hail 'n' ride",
                        "Kiel Mountain Rd near Merimist Way hail 'n' ride",
                        "Kiel Mountain Rd near Fernhill Pl hail 'n' ride",
                        "Diddillibah Rd near Eudlo Flats Rd hail 'n' ride",
                        "Diddillibah Rd near Melcar Ct hail 'n' ride",
                        "Diddillibah Rd near Clarkes Rd hail 'n' ride",
                        "Diddillibah Rd near Petrie Creek Rd hail 'n' ride",
                        "David Low Way at Harbourside Holiday Resort",
                        "Main Rd near Advance Rd",
                        "Main Rd near Elkhorn St",
                        "Main Rd near Tallow Wood Dr",
                        "Main Rd near Pindari St",
                        "Main Rd near Radiata Dr",
                        "Maroochydore Rd at Maroochydore High",
                        "Maroochydore Rd at Homemaker Centre",
                        "Maroochy Bvd at Sunrise Drive",
                        "Sunshine Cove Way near Sunrise Dr",
                        "Sunshine Cove Way near Sunrise Dr hail 'n' ride",
                        "Immanuel Lutheran College",
                        "Wises Rd at Kayleigh Drive",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Wises Rd near Glen Kyle Dr",
                        "Main Rd near Daintree Cl",
                        "820 Diddillibah Rd hail 'n' ride",
                        "Diddillibah Rd near Bahdilli Cr hail 'n' ride",
                        "Diddillibah Rd at Diddillibah Community Hall HnR",
                        "Kiel Mountain Rd near Old Kiel Mountain Rd 1st HnR",
                        "Kiel Mountain Rd near Old Kiel Mountain Rd 2nd HnR",
                        "Kiel Mountain Rd near Meher Rd hail 'n' ride",
                        "Kiel Mountain Rd near Kentish Rd hail 'n' ride",
                        "Opposite 27 Kiel Mountain Rd hail 'n' ride",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride"
                    ],
                    "5746: Kunda Park - Burnside High": [
                        "Maroochydore Rd at Robert Street",
                        "Jones Rd at Horseshoe Bend",
                        "14 Orme Rd hail 'n' ride",
                        "Mill Rd near Price Lane hail 'n' ride",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "UniSC station, platform 1",
                        "University Way at Chancellor Park",
                        "University Way at Hibiscus Resort",
                        "University Way at Chancellor Park Marketplace",
                        "Tanawha Tourist Dr near Glenmount Rd hail 'n' ride",
                        "38 Owen Creek Rd hail 'n' ride",
                        "Old Maroochydore Rd at Vise Road",
                        "Old Maroochydore Rd at Stark Lane",
                        "Montessori College",
                        "Nambour Connection Rd at Big Pineapple",
                        "Nambour Connection Rd at Woombye Gardens",
                        "Suncoast Christian College",
                        "Woombye State Primary School",
                        "Pine Grove Rd near Junee Ct",
                        "Dinmore St near Wakefield St",
                        "Wakefield St near Blackall St",
                        "Lamington Tce near Magnolia St",
                        "Burnside State High School",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Carter Rd at Arundell Ave",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Pine Grove Rd at Woombye State School",
                        "Stark Lane at Vyner Court",
                        "University Dr at Hibiscus Resort",
                        "Chancellor Primary School",
                        "UniSC station, platform 2",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Ballinger Rd near Lara Dr hail 'n' ride",
                        "Mill Rd at Buderim Park Shopping Centre HnR",
                        "Gloucester Rd near Orme Rd hail 'n' ride"
                    ],
                    "5747: Brightwater - Burnside High": [
                        "Brightwater Bvd at Frogmouth Cct hail 'n' ride",
                        "Attenuata Dr at Crayfish Street",
                        "Attenuata Dr at Amberjack Street",
                        "Brightwater Bvd at Holloway Street",
                        "Kawana Way at Island Point Villas",
                        "Jamaica Way near Providence St",
                        "Grand Pde near Maldives Pl",
                        "Grand Pde near Kawana Island Bvd",
                        "Kawana Island Bvd at Grand Parade",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Beachwood Hostel",
                        "Nicklin Way at Sunbird Chase",
                        "Kawana station platform 2",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at Jessica Boulevard",
                        "Nicklin Way at The Groves Minyama",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Walan St near Bahlaka St",
                        "Palm Dr near Brentwood Ave",
                        "Ocean View Ave near Greygum Ct hail 'n' ride",
                        "Parkway Dr near Poinsettia Ave hail 'n' ride",
                        "Ocean View Ave near Aruma Ct",
                        "Pettigrew St near Kalinda Ave",
                        "Buderim Ave at Douglas Street",
                        "Alexandra Pde at Alexandra Headland",
                        "Alexandra Pde at Wilkes Family Park",
                        "Alexandra Pde at Alexandra Headland Beach",
                        "Okinja Rd at Wirraway Street",
                        "Maroubra St near Wrigley St",
                        "Bungama St near May St",
                        "Second Ave near Parker St",
                        "Aerodrome Rd at Maud Street",
                        "First Av at Future Way",
                        "Maud St near Gloria St",
                        "Maud St at Coghlan Court",
                        "Sugar Rd near Centenary Cr",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Maroochydore Rd at Robert Street",
                        "Maroochydore Rd at Pike Street",
                        "Montessori College",
                        "Nambour Connection Rd at Big Pineapple",
                        "Nambour Connection Rd at Woombye Gardens",
                        "629 Nambour Connection Rd hail 'n' ride",
                        "Lamington Tce near Magnolia St",
                        "St John's Catholic College",
                        "Burnside State High School",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Carter Rd at Arundell Ave",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Stark Lane at Vyner Court",
                        "Maroochydore Rd near Pike St",
                        "Maroubra St near Wirraway St",
                        "Wirraway St near Okinja Rd",
                        "Pettigrew St near Marjorie St",
                        "Ocean View Ave near Warrina Ct",
                        "Walan St near Smith St",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Brisbane Rd at Woomba Place",
                        "Nicklin Way at Jessica Park",
                        "Kawana station platform 1",
                        "Nicklin Way at Lapoinya Crescent Walkway",
                        "Nicklin Way at Balyata Street Walkway"
                    ],
                    "5748: Palmwoods - St Johns College": [
                        "Montville Rd at Palmwoods Primary",
                        "Montville Rd near Dunning St",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "Lamington Tce near Magnolia St",
                        "St John's Catholic College",
                        "Perwillowen Road at Valley View Street",
                        "Nambour Connection Rd at Diddillibah Road",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride",
                        "Main St at Palmwoods Railway Station"
                    ],
                    "5749: Palmwoods - St Joseph's Primary": [
                        "Montville Rd at Palmwoods Primary",
                        "Montville Rd near Dunning St",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "Suncoast Christian College",
                        "Lamington Tce near Magnolia St",
                        "Currie St at Nambour Library",
                        "Nambour State High School",
                        "Coronation Ave at Matthew Street",
                        "Nambour Connection Rd at Diddillibah Road",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride",
                        "Main St at Palmwoods Railway Station"
                    ],
                    "5750: Palmwoods - Burnside High": [
                        "Montville Rd at Palmwoods Primary",
                        "Montville Rd near Dunning St",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "Lamington Tce near Magnolia St",
                        "Burnside State High School",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Carter Rd at Arundell Ave",
                        "Nambour Connection Rd at Diddillibah Road",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride",
                        "Main St at Palmwoods Railway Station"
                    ],
                    "5751: Mount Coolum - Good Samaritan College": [
                        "South Coolum Rd near Green Oaks Dr",
                        "South Coolum Rd near Wandaa Ct",
                        "Toolga St near Warrack St",
                        "Jarnahill Dr near Quinn Ct",
                        "David Low Way at Mount Coolum",
                        "David Low Way at Seaside Boulevard",
                        "David Low Way at Lorraine Avenue",
                        "David Low Way at Petrie Avenue",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "David Low Way near Surfrider Pl hail 'n' ride",
                        "David Low Way at Friendship Avenue",
                        "David Low Way at Pacific Paradise",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way at Namba Street",
                        "David Low Way near Godfreys Rd hail 'n' ride",
                        "David Low Way at Bli Bli hail 'n' ride",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Kowonga Street",
                        "David Low Way at Fourth Avenue",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Toolga St near Carrock Ct"
                    ],
                    "5752: Eudlo/Chevallum - Burnside High": [
                        "Rosebed St at Eudlo Hall hail 'n' ride",
                        "Logwoods Rd near Perrins Rd hail 'n' ride",
                        "Highlands Rd near Sullivans Rd hail 'n' ride",
                        "Rambert Rd near Brooks Rd hail 'n' ride",
                        "Highlands Rd near Rambert Rd hail 'n' ride",
                        "Mooloolah Rd near Logwoods Rd hail 'n' ride",
                        "Eudlo State School",
                        "Anzac Rd near McGilchrists Rd hail 'n' ride",
                        "Ilkley Road near Slaughter Yard Rd hail 'n' ride",
                        "Ilkley Rd near Nobels Rd hail 'n' ride",
                        "273 Ilkley Rd hail 'n' ride",
                        "407 Ilkley Road hail 'n' ride",
                        "Chevallum School Rd near Lisa Rd hail 'n' ride",
                        "Chevallum Primary School",
                        "Chevallum Rd near Dales Rd hail 'n' ride",
                        "Chevallum Rd near Old Chevallum Rd hail 'n' ride",
                        "Chevallum Rd near Harris Dr hail 'n' ride",
                        "Chevallum Rd near Railway St",
                        "Main St at Palmwoods Railway Station",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Montville Rd near Dunning St",
                        "Jubilee Dr near Hobson St hail 'n' ride",
                        "Jubilee Dr at G Rae Oval hail 'n' ride",
                        "Old Palmwoods Rd near Mullers Rd hail 'n' ride",
                        "Blackall Range Rd near Laidlaw Rd hail 'n' ride",
                        "Nambour Christian College",
                        "Lamington Tce near Magnolia St",
                        "Burnside State High School",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Carter Rd at Arundell Ave",
                        "91 Blackall Range Rd hail 'n' ride",
                        "Old Palmwoods Rd near Reids Rd hail 'n' ride",
                        "Jubilee Dr near Woombye Palmwoods Rd",
                        "Chevallum Rd near Bareena Ct hail 'n' ride",
                        "99 Chevallum Rd hail 'n' ride",
                        "33 Olsens Road hail 'n' ride",
                        "Ilkley Rd near Wilsons Rd hail 'n' ride",
                        "Ilkley Rd near Hutchisons Rd hail 'n' ride",
                        "Anzac Road near McGilchrists Rd hail 'n' ride"
                    ],
                    "5753: Maroochydore/Kuluin - Siena College": [
                        "Maroochydore Rd at Maroochydore High",
                        "Maroochydore Rd at Homemaker Centre",
                        "Ball St near Hinley Ave hail 'n' ride",
                        "Bradman Ave at Chambers Island",
                        "Bradman Ave at Minti Street",
                        "Bradman Ave near Denna St",
                        "Bradman Ave at Maroochy River Caravan Pk",
                        "Bradman Ave at Maroochy Palms Caravan Pk",
                        "Maroochydore Multi Sports Complex hail 'n' ride",
                        "Main Rd near Renison Dr",
                        "Jones Rd at Horseshoe Bend",
                        "14 Orme Rd hail 'n' ride",
                        "Mill Rd near Price Lane hail 'n' ride",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Karawatha Dr near Dixon Rd",
                        "Karawatha Dr near Jingellic Dr",
                        "Jingellic Dr near Amberton Ct hail 'n' ride",
                        "Karawatha St near Bringenbrong Dr hail 'n' ride",
                        "Oakmont Dr near Alfriston Dr",
                        "Oakmont Dr near Buderim Pines South Park",
                        "Buderim Pines Dr near Treefern Ct",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Brianna Cl",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Dixon Road at Power Road",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr near Golf Links Rd",
                        "Karawatha St near Jingellic Dr hail 'n' ride",
                        "Jingellic Dr near Killeen Cl hail 'n' ride",
                        "Mill Rd at Buderim Park Shopping Centre HnR",
                        "Gloucester Rd near Orme Rd hail 'n' ride",
                        "Main Rd near Ghost Gum Ave",
                        "Broadmeadows Rd near Kenewin Ave hail 'n' ride"
                    ],
                    "5754: Nambour - Siena College": [
                        "Nambour General Hospital",
                        "Netherton St at Sapphire Drive",
                        "National Park Rd near Zealey Rd",
                        "Coronation Ave at Show and Sportsgrounds",
                        "Coronation Ave at Matthew Street",
                        "Currie St at Nambour Library",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Wakefield St near Blackall St",
                        "Dinmore St near Wakefield St",
                        "Pine Grove Rd at Woombye State School",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride",
                        "Main St at Palmwoods Railway Station",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Montville Rd near Dunning St",
                        "Chevallum Rd near Bareena Ct hail 'n' ride",
                        "Chevallum Rd near Harris Dr hail 'n' ride",
                        "99 Chevallum Rd hail 'n' ride",
                        "Chevallum Primary School",
                        "Rainforest Rd near Chevallum Rd hail 'n' ride",
                        "Sunshine Coast Grammar School",
                        "Tanawha Tourist Dr near Glenmount Rd hail 'n' ride",
                        "Sippy Downs Dr at High St",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "38 Owen Creek Rd hail 'n' ride",
                        "Mons Rd near Owen Creek Rd",
                        "Chevallum Rd near Dales Rd hail 'n' ride",
                        "Chevallum Rd near Old Chevallum Rd hail 'n' ride",
                        "Chevallum Rd near Railway St",
                        "Chevallum Rd opp Duck Pond hail 'n' ride",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "Woombye State Primary School",
                        "Pine Grove Rd near Junee Ct",
                        "Lamington Tce near Magnolia St",
                        "National Park Rd near Rigby St"
                    ],
                    "5756: Woombye - Chancellor Primary": [
                        "Mons Rd near Mons School Rd",
                        "Pine Grove Rd at Woombye State School",
                        "Mons Rd near Twin Ridges Rd hail 'n' ride",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Mons Rd near Wilguy Cr",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Burnett St near Townsend Rd",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Burnett St at Buderim Marketplace",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride",
                        "Main St at Palmwoods Railway Station",
                        "Buderim Mountain State School Bus Zone",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Montville Rd at Palmwoods Primary",
                        "Montville Rd near Dunning St",
                        "Chevallum Rd near Bareena Ct hail 'n' ride",
                        "Chevallum Rd near Harris Dr hail 'n' ride",
                        "Eudlo Rd near Bamboo Rd hail 'n' ride",
                        "Eudlo Rd near Cardinal Ct",
                        "Rosebed St at Eudlo Hall hail 'n' ride",
                        "Anzac Rd near McGilchrists Rd hail 'n' ride",
                        "Ilkley Road near Slaughter Yard Rd hail 'n' ride",
                        "Ilkley Rd near Nobels Rd hail 'n' ride",
                        "273 Ilkley Rd hail 'n' ride",
                        "407 Ilkley Road hail 'n' ride",
                        "Chevallum School Rd near Lisa Rd hail 'n' ride",
                        "Chevallum Primary School",
                        "Rainforest Rd near Chevallum Rd hail 'n' ride",
                        "King St at Water Street",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Ochre Way",
                        "Chancellor State College",
                        "UniSC station, platform 1",
                        "Chancellor Primary School",
                        "Sippy Downs Dr at Siena Catholic College",
                        "University Way at Chancellor Park Marketplace",
                        "University Dr at Hibiscus Resort",
                        "University Way at Chancellor Park",
                        "UniSC station, platform 2",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Ballinger Rd near Lara Dr hail 'n' ride",
                        "William St near Mons Rd",
                        "Mons Rd near Twin Ridges Rd",
                        "Mons Rd near Owen Creek Rd",
                        "33 Olsens Road hail 'n' ride",
                        "Ilkley Rd near Wilsons Rd hail 'n' ride",
                        "Ilkley Rd near Hutchisons Rd hail 'n' ride",
                        "Anzac Road near McGilchrists Rd hail 'n' ride",
                        "Eudlo State School",
                        "Chevallum Rd near Railway St",
                        "Chevallum Rd opp Duck Pond hail 'n' ride",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "Woombye State Primary School"
                    ],
                    "5761: Palmview - Maroochydore Primary": [
                        "Sugar Mill Rd near Soprano St hail 'n' ride",
                        "Flintwood Cr at Elation Street",
                        "Flintwood Cr near Velvet Way hail 'n' ride",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Peter Crosby Way at Village Green Bvd",
                        "University Way near Claymore Rd",
                        "Albany St near Windermere Way",
                        "Albany St near Trinity Cr",
                        "Albany St near Bronte Ct",
                        "Springhill Dr near Lacewing Dr",
                        "Bellflower Rd near Peppermint Cr",
                        "Bellflower Rd near Creekside Dr",
                        "Bellflower Rd at Lakehead Drive",
                        "University Way at Chancellor Park Marketplace",
                        "Sippy Downs Dr at High St",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Burnett St at Buderim Marketplace",
                        "Burnett St near Townsend Rd",
                        "Townsend Rd at Sage Street",
                        "Tulip Lane near Royal Dr",
                        "Lindsay Rd near Attunga Cr",
                        "Lindsay Rd near Feeley St",
                        "Main St at Buderim Mountain Primary School",
                        "Gloucester Rd at Fielding Street",
                        "Mill Rd near Price Lane hail 'n' ride",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Mooloolaba Rd at Foote Avenue",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Mooloolaba Rd at Golf Links Drive",
                        "Mooloolaba Rd at Buderim Garden Village",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Immanuel Lutheran College",
                        "Maroochy Bvd at Sunrise Drive",
                        "Maroochydore State Primary School",
                        "Mill Rd at Buderim Park Shopping Centre HnR",
                        "Lindsay Rd near Tulip Lane",
                        "Tulip Lane at Royal Drive",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Bellflower Rd at Bellflower Retirement Resort",
                        "Springhill Dr near Edgewater Pl",
                        "University Way at Claymore Rd",
                        "Tranquility Way at Greenview Terrace"
                    ],
                    "5762: Mooloolah/Glenview - Palmview Primary": [
                        "Steve Irwin Way at Mooloolah Cemetery",
                        "Connection Rd at Country Club hail 'n' ride",
                        "Connection Rd near Greenacres Ct hail 'n' ride",
                        "329 Connection Rd hail 'n' ride",
                        "Mooloolah Rd near Christine Ct hail 'n' ride",
                        "Bray Rd near Paget St hail 'n' ride",
                        "Mooloolah State Primary School",
                        "Bray Rd at Mooloolah Town Park hail 'n' ride",
                        "Connection Rd near South River Dr hail 'n' ride",
                        "Connection Rd near Tunnel Ridge Rd hail 'n' ride",
                        "Connection Rd near Hamilton Cl hail 'n' ride",
                        "Glenview Rd near Old Gympie Rd hail 'n' ride",
                        "Glenview Rd near Evans Grove Rd hail 'n' ride",
                        "Glenview Rd at Chambers Ct hail 'n' ride",
                        "492 Glenview Rd hail 'n' ride",
                        "Glenview Rd at Glenview Primary School",
                        "Glenview Rd near Isamberts Rd hail 'n' ride",
                        "Glenview Rd near Dunne Rd hail 'n' ride",
                        "Glenview Rd near Nina Dr hail 'n' ride",
                        "Glenview Rd near Mawhinney Rd hail 'n' ride",
                        "Frizzo Rd at Glenview Road",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Peter Crosby Way at Village Green Bvd",
                        "Palmview State High School",
                        "Palmview State Primary School",
                        "Tranquility Way at Greenview Terrace",
                        "Frizzo Rd at Aussie World",
                        "Leeding Rd at Glenview Pmy hail 'n' ride",
                        "493 Glenview Rd hail 'n' ride",
                        "Connection Rd near Old Gympie Rd hail 'n' ride",
                        "Connection Road at Country Club hail 'n' ride"
                    ],
                    "5763: Mooloolah/Glenview - Chancellor Primary": [
                        "Steve Irwin Way at Mooloolah Cemetery",
                        "Connection Rd at Country Club hail 'n' ride",
                        "Connection Rd near Greenacres Ct hail 'n' ride",
                        "329 Connection Rd hail 'n' ride",
                        "Mooloolah Rd near Christine Ct hail 'n' ride",
                        "Bray Rd near Paget St hail 'n' ride",
                        "Mooloolah State Primary School",
                        "Bray Rd at Mooloolah Town Park hail 'n' ride",
                        "Connection Rd near South River Dr hail 'n' ride",
                        "Connection Rd near Tunnel Ridge Rd hail 'n' ride",
                        "Connection Rd near Hamilton Cl hail 'n' ride",
                        "Glenview Rd near Old Gympie Rd hail 'n' ride",
                        "Glenview Rd near Evans Grove Rd hail 'n' ride",
                        "Glenview Rd at Chambers Ct hail 'n' ride",
                        "492 Glenview Rd hail 'n' ride",
                        "Glenview Rd at Glenview Primary School",
                        "Glenview Rd near Isamberts Rd hail 'n' ride",
                        "Glenview Rd near Dunne Rd hail 'n' ride",
                        "Glenview Rd near Nina Dr hail 'n' ride",
                        "Glenview Rd near Mawhinney Rd hail 'n' ride",
                        "Frizzo Rd at Glenview Road",
                        "Palmview Forest Dr near Richmond Lane HnR",
                        "Kookaburra Dr near Palmview Forest Dr HnR",
                        "Palmview Forest Dr near Glasswing Ave HnR",
                        "101 Pignata Rd hail 'n' ride",
                        "Pignata Rd at Palmview Sawmill hail 'n' ride",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Peter Crosby Way at Village Green Bvd",
                        "University Way near Claymore Rd",
                        "Sippy Downs Dr at Claymore Road",
                        "Chancellor State College",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "UniSC station, platform 1",
                        "Chancellor Primary School",
                        "Sippy Downs Dr at Siena Catholic College",
                        "University Way at Chancellor Park Marketplace",
                        "University Dr at Hibiscus Resort",
                        "University Way at Chancellor Park",
                        "UniSC station, platform 2",
                        "University Way at Claymore Rd",
                        "Tranquility Way at Greenview Terrace",
                        "Frizzo Rd at Aussie World",
                        "Leeding Rd at Glenview Pmy hail 'n' ride",
                        "493 Glenview Rd hail 'n' ride",
                        "Connection Rd near Old Gympie Rd hail 'n' ride",
                        "Connection Road at Country Club hail 'n' ride",
                        "Steve Irwin Way at Mooloolah Connection Rd"
                    ],
                    "5764: Palmview (Harmony) - Chancellor SS": [
                        "Sugar Mill Rd near Staccato Way hail 'n' ride",
                        "Sugar Mill Rd near Soprano St hail 'n' ride",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Peter Crosby Way at Village Green Bvd",
                        "University Way near Claymore Rd",
                        "Albany St near Windermere Way",
                        "Albany St near Trinity Cr",
                        "Albany St near Bronte Ct",
                        "Chancellor Primary School",
                        "University Way at Claymore Rd",
                        "Tranquility Way at Greenview Terrace"
                    ],
                    "5765: Caloundra - St Johns College": [
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Caloundra Rd at Stradbroke Drive",
                        "Caloundra Rd at Sugarbag Road",
                        "Caloundra Rd at Ridgewood Road",
                        "Parklands Bvd near Village Way",
                        "Parklands Bvd at Little Mountain Drive",
                        "Parklands Bvd at Liekefett Way",
                        "Parklands Bvd near Liekefett Way",
                        "Caloundra Rd at Parklands Boulevard",
                        "Glenview Rd near Mawhinney Rd hail 'n' ride",
                        "Glenview Rd near Nina Dr hail 'n' ride",
                        "Glenview Rd near Dunne Rd hail 'n' ride",
                        "Glenview Rd near Isamberts Rd hail 'n' ride",
                        "Leeding Rd at Glenview Pmy hail 'n' ride",
                        "493 Glenview Rd hail 'n' ride",
                        "Glenview Rd at Chambers Ct hail 'n' ride",
                        "Glenview Rd near Evans Grove Rd hail 'n' ride",
                        "Glenview Rd near Old Gympie Rd hail 'n' ride",
                        "Mooloolah Rd near Christine Ct hail 'n' ride",
                        "Bray Rd at Mooloolah Town Park hail 'n' ride",
                        "Connection Rd near South River Dr hail 'n' ride",
                        "Connection Rd near Tunnel Ridge Rd hail 'n' ride",
                        "Connection Rd near Hamilton Cl hail 'n' ride",
                        "297 Old Gympie Rd hail 'n' ride",
                        "Mooloolah Rd near Logwoods Rd hail 'n' ride",
                        "Eudlo State School",
                        "Eudlo Rd near Bamboo Rd hail 'n' ride",
                        "Chevallum Rd near Railway St",
                        "Chevallum Rd opp Duck Pond hail 'n' ride",
                        "Woombye Palmwoods Rd near Holly Green Cr",
                        "Woombye Palmwoods Rd near Atkinsons Rd HnR",
                        "Woombye State Primary School",
                        "Pine Grove Rd near Junee Ct",
                        "Dinmore St near Wakefield St",
                        "Wakefield St near Blackall St",
                        "Lamington Tce near Magnolia St",
                        "St John's Catholic College",
                        "Perwillowen Road at Valley View Street",
                        "Nambour Connection Rd at Diddillibah Road",
                        "Pine Grove Rd at Woombye State School",
                        "110 Woombye Palmwoods Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Winston Rd hail 'n' ride",
                        "Woombye Palmwoods Rd near Nicklin Rd",
                        "Woombye Palmwoods Rd near Lagoon Dr hail 'n' ride",
                        "Chevallum Rd near Bareena Ct hail 'n' ride",
                        "Eudlo Rd near Cardinal Ct",
                        "Rosebed St at Eudlo Hall hail 'n' ride",
                        "294 Old Gympie Rd hail 'n' ride",
                        "492 Glenview Rd hail 'n' ride",
                        "Glenview Rd at Glenview Primary School",
                        "Frizzo Rd at Glenview Road"
                    ],
                    "5766: Mooloolah/Glenview - Siena College": [
                        "Steve Irwin Way at Mooloolah Cemetery",
                        "Connection Rd at Country Club hail 'n' ride",
                        "Connection Rd near Greenacres Ct hail 'n' ride",
                        "329 Connection Rd hail 'n' ride",
                        "Mooloolah Rd near Christine Ct hail 'n' ride",
                        "Bray Rd near Paget St hail 'n' ride",
                        "Mooloolah State Primary School",
                        "Bray Rd at Mooloolah Town Park hail 'n' ride",
                        "Connection Rd near South River Dr hail 'n' ride",
                        "Connection Rd near Tunnel Ridge Rd hail 'n' ride",
                        "Connection Rd near Hamilton Cl hail 'n' ride",
                        "Glenview Rd near Old Gympie Rd hail 'n' ride",
                        "Glenview Rd near Evans Grove Rd hail 'n' ride",
                        "Glenview Rd at Chambers Ct hail 'n' ride",
                        "492 Glenview Rd hail 'n' ride",
                        "Leeding Rd at Glenview Pmy hail 'n' ride",
                        "Glenview Rd at Glenview Primary School",
                        "Glenview Rd near Isamberts Rd hail 'n' ride",
                        "Glenview Rd near Dunne Rd hail 'n' ride",
                        "Glenview Rd near Nina Dr hail 'n' ride",
                        "Glenview Rd near Mawhinney Rd hail 'n' ride",
                        "Frizzo Rd at Glenview Road",
                        "Palmview Forest Dr near Richmond Lane HnR",
                        "Kookaburra Dr near Palmview Forest Dr HnR",
                        "Palmview Forest Dr near Glasswing Ave HnR",
                        "Sugar Mill Rd near Soprano St hail 'n' ride",
                        "Sugar Mill Rd near Staccato Way hail 'n' ride",
                        "Grazier way near Botanic Ave hail 'n' ride",
                        "Flintwood Cr at Elation Street",
                        "Flintwood Cr near Velvet Way hail 'n' ride",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Peter Crosby Way at Village Green Bvd",
                        "University Way near Claymore Rd",
                        "Chancellor State College",
                        "Sippy Downs Dr at Fairfax Street",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Sippy Downs Dr at High St",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Claymore Road",
                        "University Way at Claymore Rd",
                        "Tranquility Way at Greenview Terrace",
                        "Frizzo Rd at Aussie World",
                        "493 Glenview Rd hail 'n' ride",
                        "Connection Rd near Old Gympie Rd hail 'n' ride",
                        "Connection Road at Country Club hail 'n' ride",
                        "Steve Irwin Way at Mooloolah Connection Rd"
                    ],
                    "5768: Brightwater - Matthew Flinders/Siena Colleges": [
                        "Brightwater Bvd at Holloway Street",
                        "Brightwater State School",
                        "Brightwater Bvd near Panama Cr hail 'n' ride",
                        "Brightwater Bvd at Frogmouth Cct hail 'n' ride",
                        "Sippy Downs Dr at Claymore Road",
                        "Dixon Road at Power Road",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Ballinger Rd near Lara Dr hail 'n' ride"
                    ],
                    "5769: Caloundra - Siena College": [
                        "Caloundra Rd at Palm Village Caravan Park",
                        "Caloundra Rd at Stradbroke Drive",
                        "Caloundra Rd at Sugarbag Road",
                        "Caloundra Rd at Ridgewood Road",
                        "Parklands Bvd near Village Way",
                        "Parklands Bvd at Little Mountain Drive",
                        "Parklands Bvd at Liekefett Way",
                        "Meridan State College",
                        "Parklands Bvd at Sunset Drive",
                        "Saffron Dr near Burnsall St",
                        "Saffron Dr near Bluebell St",
                        "Talara Primary College",
                        "Erang St at Alstonville Way",
                        "Nicklin Way at Currimundi",
                        "Nicklin Way at Ahern Bridge",
                        "Nicklin Way at Wurtulla Shopping Village",
                        "Nicklin Way at Park Haven",
                        "Nicklin Way at Kawana Waters Bowls Club",
                        "Nicklin Way at Kawana Waters High School",
                        "Nicklin Way at Thunderbird Drive",
                        "Nicklin Way at Sunshine Coast Stadium",
                        "Nicklin Way at Main Drive",
                        "Nicklin Way at 224 Centre",
                        "Kawana Island Bvd at Grand Parade",
                        "Grand Pde near Kawana Island Bvd",
                        "Grand Pde near Maldives Pl",
                        "Jamaica Way near Providence St",
                        "Kawana Way at Island Point Villas",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Nicklin Way at Palkana Drive",
                        "Nicklin Way at Minkara Street",
                        "Nicklin Wy at Thunderbird Drive",
                        "Nicklin Way at Beach Drive",
                        "Erang St near Alstonville Way",
                        "Saffron Dr at Burnsall St",
                        "Parklands Bvd at Meridan State College",
                        "Parklands Bvd near Liekefett Way",
                        "Caloundra Rd at Parklands Boulevard"
                    ],
                    "5772: Eudlo Flats - Bli Bli Primary": [
                        "Old Maroochydore Rd near Whites Rd",
                        "Eudlo Flats Rd near Needham Ct hail 'n' ride",
                        "Eudlo Flats Rd near Ellem Ct hail 'n' ride",
                        "Diddillibah Rd near Melcar Ct hail 'n' ride",
                        "Diddillibah Rd near Clarkes Rd hail 'n' ride",
                        "Diddillibah Rd near Petrie Creek Rd hail 'n' ride",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Bli Bli Castle",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Kirra Rd near Tamin Pl hail 'n' ride",
                        "Kirra Rd near East View Ct hail 'n' ride",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Parklakes Dr at Agnes Place",
                        "Parklakes Dr at Camp Flat Road",
                        "Parklakes Dr at Clarence Avenue",
                        "Parklakes Dr at Bottlebrush Avenue",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "School Rd at Bli Bli Primary school hail 'n' ride",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "820 Diddillibah Rd hail 'n' ride",
                        "Diddillibah Rd near Bahdilli Cr hail 'n' ride",
                        "Diddillibah Rd at Diddillibah Community Hall HnR",
                        "Eudlo Flats Rd near Gateway Dr hail 'n' ride",
                        "Eudlo Flats Rd near Malones Rd hail 'n' ride"
                    ],
                    "5773: Kuluin/Bli Bli - St Johns College": [
                        "Maroochydore Multi Sports Complex hail 'n' ride",
                        "David Low Way at Harbourside Holiday Resort",
                        "David Low Way at Edgewater Village",
                        "David Low Way at Bli Bli Castle",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Parklakes Dr at Bottlebrush Avenue",
                        "Parklakes Dr at Clarence Avenue",
                        "Parklakes Dr at Camp Flat Road",
                        "Parklakes Dr at Agnes Place",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Kirra Rd near Tamin Pl hail 'n' ride",
                        "Kirra Rd near East View Ct hail 'n' ride",
                        "Francis Rd near Atkinson Rd hail 'n' ride",
                        "Coronation Ave at Show and Sportsgrounds",
                        "Nambour State High School",
                        "Coronation Ave at Matthew Street",
                        "Currie St at Nambour Library",
                        "St John's Catholic College",
                        "Perwillowen Road at Valley View Street",
                        "Mill Lane at Nambour Mill Village",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street"
                    ],
                    "5774: Glenview - Palmview Primary": [
                        "Frizzo Rd at Aussie World",
                        "Palmview Forest Dr near Richmond Lane HnR",
                        "Kookaburra Dr near Palmview Forest Dr HnR",
                        "Palmview Forest Dr near Glasswing Ave HnR",
                        "Sugar Mill Rd near Soprano St hail 'n' ride",
                        "Sugar Mill Rd near Staccato Way hail 'n' ride",
                        "Grazier way near Botanic Ave hail 'n' ride",
                        "Flintwood Cr at Elation Street",
                        "Flintwood Cr near Velvet Way hail 'n' ride",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Peter Crosby Way at Village Green Bvd",
                        "Palmview State High School",
                        "Palmview State Primary School",
                        "Tranquility Way at Greenview Terrace"
                    ],
                    "5775: Buderim - Chancellor College": [
                        "Main St at Buderim Mountain Primary School",
                        "King St at Water Street",
                        "King St at Wirreanda Park",
                        "King St at Hamilton Street",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Karawatha Dr near Dixon Rd",
                        "Karawatha Dr near Jingellic Dr",
                        "Jingellic Dr near Amberton Ct hail 'n' ride",
                        "Karawatha St near Bringenbrong Dr hail 'n' ride",
                        "Oakmont Dr near Alfriston Dr",
                        "Oakmont Dr near Buderim Pines South Park",
                        "Buderim Pines Dr near Treefern Ct",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Brianna Cl",
                        "Dixon Road at Power Road",
                        "Sippy Downs Dr at Claymore Road",
                        "Chancellor State College",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr near Golf Links Rd",
                        "Karawatha St near Jingellic Dr hail 'n' ride",
                        "Jingellic Dr near Killeen Cl hail 'n' ride"
                    ],
                    "5780: Palmview - Chancellor College": [
                        "Sugar Mill Rd near Soprano St hail 'n' ride",
                        "Flintwood Cr at Elation Street",
                        "Flintwood Cr near Velvet Way hail 'n' ride",
                        "Tranquility Way at Greenview Tce",
                        "Harmony Bvd at Spinifex Street",
                        "Harmony Bvd at Sienna Crescent",
                        "Palmview State High School",
                        "Peter Crosby Way at Village Green Bvd",
                        "University Way near Claymore Rd",
                        "Sippy Downs Dr at Claymore Road",
                        "Chancellor State College",
                        "University Way at Claymore Rd",
                        "Tranquility Way at Greenview Terrace"
                    ],
                    "5782: Maroochydore/Mooloolaba - Sunshine Coast Grammar": [
                        "Wises Rd at Kayleigh Drive",
                        "Mooloolaba Rd near Correa Pl",
                        "Buderim Av at Janet Street",
                        "Buderim Ave at Mary Street",
                        "Buderim Ave at Douglas Street",
                        "Mooloolaba Esp at Meta Street",
                        "Walan St near Smith St",
                        "Brisbane Rd at Mooloolaba Bowls Club",
                        "Brisbane Rd at Woomba Place",
                        "Nicklin Way at Jessica Park",
                        "Nicklin Way at Jessica Boulevard",
                        "Point Cartwright Dr near Nanyima St hail 'n' ride",
                        "Point Cartwright Dr near Wingara St hail 'n' ride",
                        "Point Cartwright Dr near Parkana Cr hail 'n' ride",
                        "Yaringa Ave near Boorook St hail 'n' ride",
                        "Iluka Ave near Koolena St hail 'n' ride",
                        "Buddina Primary School",
                        "Lowanna Dr near Ilumba St hail 'n' ride",
                        "Oceanic Dr near Currawan St hail 'n' ride",
                        "Kawana Island Bvd at Grand Parade",
                        "Grand Pde near Kawana Island Bvd",
                        "Grand Pde near Maldives Pl",
                        "Jamaica Way near Providence St",
                        "Kawana Way at Island Point Villas",
                        "Brightwater Bvd at Holloway Street",
                        "Brightwater State School",
                        "Brightwater Bvd near Panama Cr hail 'n' ride",
                        "Brightwater Bvd at Frogmouth Cct hail 'n' ride",
                        "Chancellor State College",
                        "Sippy Downs Dr at Ochre Way",
                        "Sippy Downs Dr at Fairfax Street",
                        "Sippy Downs Dr at Siena Catholic College",
                        "Tanawha Tourist Dr near Glenmount Rd hail 'n' ride",
                        "38 Owen Creek Rd hail 'n' ride",
                        "Mons Rd near Owen Creek Rd",
                        "Sunshine Coast Grammar School",
                        "Sippy Downs Dr at High St",
                        "Sippy Downs Dr at Claymore Road",
                        "Iluka Ave near near Undara Ave hail 'n' ride",
                        "Point Cartwright Dr near Minya St hail 'n' ride",
                        "Point Cartwright Dr near Ninyima St hail 'n' ride",
                        "Nicklin Way at Point Cartwright Drive",
                        "Nicklin Way at The Groves Minyama",
                        "Brisbane Rd at Neerim Drive",
                        "Brisbane Rd at Tuckers Creek",
                        "Brisbane Rd at Mooloolaba Bowls Club CLOSED",
                        "Walan St near Bahlaka St",
                        "Mooloolaba Rd near Mary St",
                        "Wises Rd near Glen Kyle Dr"
                    ],
                    "5791: Palmview - Chevallum Primary": [
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Dunning St at Jane Street",
                        "Dunning St near Lingara Av hail 'n' ride",
                        "Montville Rd near Dunning St",
                        "Chevallum Rd near Bareena Ct hail 'n' ride",
                        "Chevallum Rd near Harris Dr hail 'n' ride",
                        "Eudlo Rd near Bamboo Rd hail 'n' ride",
                        "Eudlo Rd near Cardinal Ct",
                        "Rosebed St at Eudlo Hall hail 'n' ride",
                        "Anzac Rd near McGilchrists Rd hail 'n' ride",
                        "Ilkley Road near Slaughter Yard Rd hail 'n' ride",
                        "Ilkley Rd near Nobels Rd hail 'n' ride",
                        "273 Ilkley Rd hail 'n' ride",
                        "407 Ilkley Road hail 'n' ride",
                        "Chevallum School Rd near Lisa Rd hail 'n' ride",
                        "Chevallum Primary School",
                        "33 Olsens Road hail 'n' ride",
                        "Ilkley Rd near Wilsons Rd hail 'n' ride",
                        "Ilkley Rd near Hutchisons Rd hail 'n' ride",
                        "Anzac Road near McGilchrists Rd hail 'n' ride",
                        "Eudlo State School",
                        "Chevallum Rd near Railway St",
                        "Chevallum Rd opp Duck Pond hail 'n' ride",
                        "Main St at Palmwoods Railway Station"
                    ],
                    "5792: Buderim - Chevallum Primary": [
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Burnett St at Buderim Marketplace",
                        "Burnett St near Townsend Rd",
                        "William St near Mons Rd",
                        "Mons Rd near Twin Ridges Rd",
                        "Mons Rd near Owen Creek Rd",
                        "Rainforest Rd near Chevallum Rd hail 'n' ride",
                        "Chevallum Primary School",
                        "Mons Rd near Mons School Rd",
                        "Mons Rd near Twin Ridges Rd hail 'n' ride",
                        "Mons Rd near Wilguy Cr",
                        "Ballinger Rd near Ballinger Ct"
                    ],
                    "5794: Sippy Downs - Buderim Mountain Primary": [
                        "Sippy Downs Dr at High St",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Ballinger Rd near Lara Dr hail 'n' ride",
                        "Karawatha Dr near Dixon Rd",
                        "Karawatha Dr near Jingellic Dr",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Golf Links Rd",
                        "Buderim Pines Dr near Treefern Ct",
                        "Oakmont Dr near Buderim Pines South Park",
                        "Oakmont Dr near Alfriston Dr",
                        "Karawatha St near Jingellic Dr hail 'n' ride",
                        "Jingellic Dr near Killeen Cl hail 'n' ride",
                        "Dixon Rd near Nandewar Dr hail 'n' ride",
                        "Dixon Rd near Lauren Dr hail 'n' ride",
                        "Mooloolaba Rd at Foote Avenue",
                        "Mooloolaba Rd at Buderim Pines Drive",
                        "Deloraine Dr near Whitehaven Dr",
                        "Cumberland Way near Glen Kyle Dr",
                        "Wises Rd near Glen Kyle Dr",
                        "Wises Rd at Kayleigh Drive",
                        "Wises Rd near Forestwood Drive",
                        "Wises Rd near Bluebush Ave",
                        "North Buderim Bvd near Highfield St hail 'n' ride",
                        "North Buderim Bvd near Pittards Rd",
                        "Pittards Rd near Cammeray Ct",
                        "Pittards Rd near Jones Rd",
                        "Jones Rd at Horseshoe Bend",
                        "14 Orme Rd hail 'n' ride",
                        "Mill Rd near Price Lane hail 'n' ride",
                        "Gilbert St near Barralong Ct hail 'n' ride",
                        "King St at Hamilton Street",
                        "King St at Water Street",
                        "Main St at Buderim Mountain Primary School",
                        "Buderim Mountain State School Bus Zone",
                        "King St at Wirreanda Park",
                        "Gloucester Rd near Orme Rd hail 'n' ride",
                        "Pittards Rd near Jewel Ct",
                        "North Buderim Bvd near Lakeshore Ave",
                        "Cumberland Way near Keswick Pl",
                        "Deloraine Dr near Lindeman Ave",
                        "Jingellic Dr near Amberton Ct hail 'n' ride",
                        "Karawatha St near Bringenbrong Dr hail 'n' ride",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr near Brianna Cl",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College"
                    ],
                    "5795: Maroochydore - Mountain Creek Primary": [
                        "Wises Rd at Kayleigh Drive",
                        "Cumberland Way near Keswick Pl",
                        "Deloraine Dr near Lindeman Ave",
                        "Mooloolaba Rd at Golf Links Drive",
                        "Buderim Pines Dr near Treefern Ct",
                        "Oakmont Dr near Buderim Pines South Park",
                        "Oakmont Dr near Alfriston Dr",
                        "Karawatha St near Jingellic Dr hail 'n' ride",
                        "Jingellic Dr near Killeen Cl hail 'n' ride",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Golf Links Rd",
                        "Karawatha Dr near Kapilano Cr",
                        "Karawatha Dr near Molakai Dr",
                        "Karawatha Dr near Saratoga Dr",
                        "Karawatha Dr near Satinay St",
                        "Bundilla Bvd at Cootamundra Drive",
                        "Manatunga Pde at Lady Elliot Dr",
                        "Manatunga Pde at Brightwater Bvd",
                        "Brightwater Bvd near Panama Cr hail 'n' ride",
                        "Brightwater State School",
                        "Attenuata Dr at Amberjack Street",
                        "Attenuata Dr at Crayfish Street",
                        "Brightwater Bvd at Frogmouth Cct hail 'n' ride",
                        "Glenfields Bvd at Greenway Place",
                        "Glenfields Bvd near Lacebark St",
                        "Glenfields Bvd near Escolar Dr",
                        "Glenfields Bvd at Sailfish Drive",
                        "Mountain Creek Primary School",
                        "Molakai Dr near Hermosa St",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr near Brianna Cl",
                        "Jingellic Dr near Amberton Ct hail 'n' ride",
                        "Karawatha St near Bringenbrong Dr hail 'n' ride",
                        "Deloraine Dr near Whitehaven Dr",
                        "Cumberland Way near Glen Kyle Dr",
                        "Wises Rd near Glen Kyle Dr"
                    ],
                    "5797: Landershute/Hunchy - Palmwoods": [
                        "Montville Rd at Palmwoods Primary",
                        "Lower Landershute Rd near Upper Landershute HnR",
                        "136 Landershute Rd hail 'n' ride",
                        "Lower Landershute Rd near Citrus Rd hail 'n' ride",
                        "Landershute Rd at Petigrain Avenue",
                        "Palmwoods Montville Rd near Macdonald Rd HnR",
                        "Kirbys Rd near Remington Shute Rd hail 'n' ride",
                        "Palmwoods Montville Rd near Kirbys Rd hail 'n' ride",
                        "Hunchy Rd near Blackbutt Rd hail 'n' ride",
                        "Hunchy Rd near Hardings Rd hail 'n' ride",
                        "Hunchy Rd near Ratcliffe Rd hail 'n' ride",
                        "599 Hunchy Rd hail 'n' ride",
                        "731 Hunchy Rd hail 'n' ride",
                        "Hunchy Rd near Ratcliffes Rd hail 'n' ride",
                        "Main St near Palm Grove Ct hail 'n' ride",
                        "Landershute Rd near Citrus Rd hail 'n' ride",
                        "Montville Rd near Dunning St"
                    ],
                    "5802: Noosaville (Goodchap St) - Sunshine Coast Grammar": [
                        "Eumundi Rd at Goodchap Street",
                        "Gibson Rd near Portside Ct",
                        "Shorehaven Dr near Oceanmist Ct hail 'n' ride",
                        "Shorehaven Dr near The Peninsula hail 'n' ride",
                        "Shorehaven Dr near Saltwater Ave hail 'n' ride",
                        "Shorehaven Dr near Waterside Ct hail 'n' ride",
                        "Weyba Rd near Anchor St",
                        "Weyba Rd near Swan St",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St",
                        "Cooyar St near Elanora Tce",
                        "Noosa Junction station, stop A",
                        "Pacific Ave near Weyba St",
                        "Pacific Ave near Ferguson Ave",
                        "Pacific Ave near Elanda St",
                        "David Low Way at Vernon Street",
                        "David Low Way at Sunrise Beach",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Castaways Creek",
                        "David Low Way at Mahogany Drive",
                        "David Low Way at Marcus Beach",
                        "David Low Way at Peregian North",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Peregian South",
                        "David Low Way at Coolum High School",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Beach",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Point Arkwright",
                        "David Low Way near Goongilla St",
                        "David Low Way at Warran Road",
                        "David Low Way near Yaroomba Dr hail 'n' ride",
                        "David Low Way at Tanah Street",
                        "David Low Way at Mount Coolum",
                        "Boardwalk Bvd near Breakers Pl hail 'n' ride",
                        "Seaside Bvd near David Low Way hail 'n' ride",
                        "Tamarindus St near Willow Cr",
                        "Marcoola Esp at Marcoola SLSC",
                        "Petrie Ave at Marcoola",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way at Sunset Strip",
                        "Mudjimba Esp near David Low Way",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Toyango St hail 'n' ride",
                        "David Low Way near Godfreys Rd hail 'n' ride",
                        "David Low Way at Bli Bli hail 'n' ride",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Stark Lane at Vyner Court",
                        "Montessori College",
                        "Sunshine Coast Grammar School",
                        "Mons Rd near Owen Creek Rd",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Kowonga Street",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Petrie Ave near Begonia Way",
                        "Tamarindus St near Cycas St",
                        "David Low Way at Yaroomba Beach",
                        "Pacific Ave near Wildflower St",
                        "Pacific Ave near Ferguson St",
                        "Pacific Ave near Edwards St",
                        "Cooyar St near Langura St",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Noosa AFL Grounds temp park 'n' ride",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Shorehaven Dr near The Anchorage hail 'n' ride",
                        "Shorehaven Dr near Shipwright Av hail 'n' ride"
                    ],
                    "5803: Peregian Springs - Coolum High": [
                        "St Andrews College",
                        "David Low Way at Peregian South",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Peregian North",
                        "David Low Way at Marcus Beach",
                        "David Low Way at Mahogany Drive",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride",
                        "David Low Way at Coolum High School",
                        "Coolum High School",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride"
                    ],
                    "5804: Mt Tinbeerwah - St Andrews College": [
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Sunrise Rd near Gyndier Dr hail 'n' ride",
                        "Patterson Dr near Wilkes Ct hail 'n' ride",
                        "Kingsgate Dr near Jaggers Ct hail 'n' ride",
                        "Kingsgate Dr near Brookland Rd hail 'n' ride",
                        "Sunrise Rd near Smiths Rd hail 'n' ride",
                        "415 Sunrise Road hail 'n' ride",
                        "Wust Rd near Valley Dr hail 'n' ride",
                        "Valley Dr near Wust Rd hail 'n' ride",
                        "Valley Dr near Meadow Ct hail 'n' ride",
                        "Duke Rd near Sunrise Rd hail 'n' ride",
                        "Duke Rd near Eagle Farm Cl hail 'n' ride",
                        "Duke Rd near Eumundi Noosa Rd hail 'n' ride",
                        "Eumarella Rd near Tidswell Rd hail 'n' ride",
                        "Eumarella Rd near Paradise Dr hail 'n' ride",
                        "Paradise Dr near Eumarella Rd hail 'n' ride",
                        "Lake Weyba Dr near Lake View Ct hail 'n' ride",
                        "Charlotte Dr near Eumarella Rd hail 'n' ride",
                        "St Andrews College",
                        "108 Duke Rd hail 'n' ride",
                        "Sunrise Rd near Wust Rd hail 'n' ride",
                        "391 Sunrise Road hail 'n' ride",
                        "Sunrise Rd near Wendoma Ct hail 'n' ride"
                    ],
                    "5806: Boreen Point - Noosa District High (Pomona)": [
                        "Louis Bazzo Dr near McKinnon Dr hail 'n' ride",
                        "Hector St near Coates Dr hail 'n' ride",
                        "Laguna St near Rainforest Ct hail 'n' ride",
                        "McKinnon Dr near Riverpark Dr hail 'n' ride",
                        "Illoura Pl near Glenridge Dr hail 'n' ride",
                        "Illoura Pl near Greengate Rd hail 'n' ride",
                        "Woodhaven Way near Dela Ct hail 'n' ride",
                        "Woodhaven Way at Woodhaven Park hail 'n' ride",
                        "Illoura Pl near Jirrima Cres hail 'n' ride",
                        "McKinnon Dr near Yellowood Cl hail 'n' ride",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Butler St at Noosa Crematorium",
                        "Cooroy Noosa Rd at Ross Court",
                        "Tewantin Noosa Golf Club",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Cooroy Noosa Rd at Carramar Noosa Homes",
                        "Cooroy Noosa Rd at Heritage Park",
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Tewantin Rd near Miva St",
                        "Elm St opp Cooroy station",
                        "Noosa District High (Cooroy)",
                        "Maple St at Victory Lane",
                        "Elm St at Cooroy station",
                        "Cooroy Primary School",
                        "Elm St at Pearsons Rd",
                        "Noosa District High (Pomona)",
                        "Tewantin Rd near Olivine St",
                        "Cooroy Noosa Rd near Sivyers Rd hail 'n' ride",
                        "Jack Hasset Dr at Heritage Park",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Lake Cooroibah Rd near Yatama Pl hail 'n' ride",
                        "Woodhaven Way near Illoura Pl hail 'n' ride"
                    ],
                    "5807: Pomona - St Teresa's College": [
                        "Reserve St at Station St",
                        "Pioneer Rd near Highfield Rise hail 'n' ride",
                        "Old Bruce Hwy near Pioneer Rd hail 'n' ride",
                        "Black Mountain Range Rd near Woodswallow Lane HnR",
                        "Cudgerie Dr near Foambark Pl hail 'n' ride",
                        "Cudgerie Dr near Pepper Berry Pl hail 'n' ride",
                        "Elm St at Pearsons Rd",
                        "Elm St opp Cooroy station",
                        "Tewantin Rd near Olivine St",
                        "Cooroy Noosa Rd near Sivyers Rd hail 'n' ride",
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Jack Hasset Dr at Heritage Park",
                        "Cooroy Noosa Rd at Carramar Noosa Homes",
                        "Sea Eagle Drive at Noosaville State School",
                        "St Teresas Catholic College",
                        "Cooroy Noosa Rd at Heritage Park",
                        "Tewantin Rd near Miva St",
                        "Elm St at Cooroy station",
                        "Cooroy Primary School"
                    ],
                    "5808: Noosa Junction - Noosa District High (Cooroy)": [
                        "Noosa Junction station, stop A",
                        "Cooyar St near Langura St",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Weyba Rd near Swan St",
                        "Weyba Rd near Anchor St",
                        "Mary St near George St",
                        "Mary St near Albert St",
                        "Gibson Rd at The Cockleshell",
                        "Gibson Rd near Portside Ct",
                        "Hilton Tce at Tewantin Noosa Bowls Club",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Eumundi Rd at Rene Street",
                        "Lake Entrance Bvd near Eumundi Noosa Rd hail 'n' ride",
                        "Lake Entrance Bvd near Casuarina Ct hail 'n' ride",
                        "Lake Entrance Bvd near Satinash St hail 'n' ride",
                        "Lake Entrance Bvd near Redgum Ct hail 'n' ride",
                        "Lake Entrance Bvd near Doolan Ct hail 'n' ride",
                        "Swanbourne Way near Beckmans Rd hail 'n' ride",
                        "Shire Dr near Sea Eagle Dr hail 'n' ride",
                        "St Teresas Catholic College",
                        "Furness Dr near Troon Ct hail 'n' ride",
                        "Furness Dr near Portrush Ct",
                        "Furness Dr near Blackheath Dr",
                        "Furness Dr near Felsted Ct",
                        "Fairway Dr near Thompson Cr",
                        "Tewantin Noosa Golf Club",
                        "Golf Course Dr near Carramar St hail 'n' ride",
                        "Griffith Ave near Club Ct",
                        "Griffith Ave near Parkview Ct",
                        "Griffith Ave near Cedarleigh Dr",
                        "Griffith Ave at Palmer Crescent",
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Sunrise Rd near Gyndier Dr hail 'n' ride",
                        "Patterson Dr near Wilkes Ct hail 'n' ride",
                        "Kingsgate Dr near Jaggers Ct hail 'n' ride",
                        "Kingsgate Dr near Brookland Rd hail 'n' ride",
                        "Dath Henderson Rd near Sunrise Rd hail 'n' ride",
                        "Tewantin Rd near Miva St",
                        "Elm St opp Cooroy station",
                        "Noosa District High (Cooroy)",
                        "Maple St at Victory Lane",
                        "Elm St at Cooroy station",
                        "Cooroy Primary School",
                        "Tewantin Rd near Olivine St",
                        "Sunrise Rd near Wendoma Ct hail 'n' ride",
                        "Jack Hasset Dr at Heritage Park",
                        "Griffith Ave near Harlow Cr",
                        "Griffith Ave near Golf Course Dr",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Fairway Dr near Thompson Cr hail 'n' ride",
                        "Furness Dr near Felsted Ct hail 'n' ride",
                        "Furness Dr near Blackheath Dr hail 'n' ride",
                        "Furness Dr near Portrush Ct hail 'n' ride",
                        "Furness Dr near Muirfield Cr hail 'n' ride",
                        "Sea Eagle Drive at Noosaville State School",
                        "Shire Dr near Morinda Cct hail 'n' ride",
                        "Swanbourne Way near Beckmans Rd",
                        "Mary St near Edward St",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St",
                        "Cooyar St near Elanora Tce"
                    ],
                    "5810: Cooroy - St Teresa's College": [
                        "Elm St opp Cooroy station",
                        "Tewantin Rd near Olivine St",
                        "Cooroy Noosa Rd near Sivyers Rd hail 'n' ride",
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Sunrise Rd near Gyndier Dr hail 'n' ride",
                        "Patterson Dr near Wilkes Ct hail 'n' ride",
                        "Kingsgate Dr near Jaggers Ct hail 'n' ride",
                        "Kingsgate Dr near Brookland Rd hail 'n' ride",
                        "Sunrise Rd near Smiths Rd hail 'n' ride",
                        "415 Sunrise Road hail 'n' ride",
                        "Duke Rd near Sunrise Rd hail 'n' ride",
                        "Duke Rd near Eagle Farm Cl hail 'n' ride",
                        "Duke Rd near Eumundi Noosa Rd hail 'n' ride",
                        "Sea Eagle Drive at Noosaville State School",
                        "St Teresas Catholic College",
                        "108 Duke Rd hail 'n' ride",
                        "Sunrise Rd near Wust Rd hail 'n' ride",
                        "391 Sunrise Road hail 'n' ride",
                        "Sunrise Rd near Wendoma Ct hail 'n' ride",
                        "Tewantin Rd near Miva St",
                        "Noosa District High (Cooroy)"
                    ],
                    "5812: Mount Coolum - Sunshine Beach Primary": [
                        "David Low Way at Tanah Street",
                        "Jarnahill Dr near Quinn Ct",
                        "Toolga St near Carrock Ct",
                        "South Coolum Rd near Wandaa Ct",
                        "Yarrock St near South Coolum Rd hail 'n' ride",
                        "Jenyor St near Bimini Dr hail 'n' ride",
                        "Yungar St near Karlee Ct hail 'n' ride",
                        "Yungar St near Greenoaks Dr hail 'n' ride",
                        "Central Ave near Pandanus Ave",
                        "Banksia Ave near Tradewinds Ave",
                        "Birtwill St near Heathfield Rd",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Mt Peregian",
                        "Coolum High School",
                        "David Low Way at Coolum High School",
                        "St Andrews College",
                        "David Low Way at Peregian South",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Water Tower",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride",
                        "David Low Way at Castaways Creek",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Sunrise Beach",
                        "David Low Way at Vernon Street",
                        "David Low Way at Sunshine Beach Primary",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride",
                        "Birtwill St near David Low Way",
                        "Banksia Ave at Tradewinds Avenue",
                        "Central Ave near Palm Ave",
                        "Toolga St near Warrack St",
                        "David Low Way at Mount Coolum"
                    ],
                    "5813: Castaways Beach - Sunshine Beach Primary": [
                        "David Low Way at Castaways Beach",
                        "Wavecrest Dr near Tropicana Rise hail 'n' ride",
                        "Wavecrest Dr near Moonbeam Cr hail 'n' ride",
                        "Wavecrest Dr near Coconut Gr hail 'n' ride",
                        "David Low Way at Sunrise Beach",
                        "Orient Dr at Newfield St",
                        "Orient Dr at Corsair Cr",
                        "Orient Dr near Wollomia Way",
                        "Wollomia Way near Victory Cr",
                        "Wollomia Way near Comet Dr",
                        "Dame Patti Dr near Ben Lexcen Dr",
                        "Dame Patti Dr near Southern Cross Pde",
                        "David Low Way at Vernon Street",
                        "David Low Way at Sunshine Beach Primary",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Ben Lexcen Dr near Lipton St",
                        "Wollomia Way near Bond Ct hail 'n' ride",
                        "Orient Dr near Wollomia Way hail 'n' ride",
                        "Orient Dr near Newfield St hail 'n' ride",
                        "David Low Way at Castaways Creek"
                    ],
                    "5817: Coolum Beach - Noosaville Primary": [
                        "David Low Way at Coolum Beach",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum High School",
                        "David Low Way at Peregian South",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Water Tower",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride",
                        "Wavecrest Dr near Tropicana Rise hail 'n' ride",
                        "Wavecrest Dr near Moonbeam Cr hail 'n' ride",
                        "Wavecrest Dr near Coconut Gr hail 'n' ride",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Sunrise Beach",
                        "David Low Way at Vernon Street",
                        "David Low Way at Sunshine Beach Primary",
                        "Noosa Junction station, stop A",
                        "Cooyar St near Langura St",
                        "Myrtle Rd near Smoke Bush dr hail 'n' ride",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Weyba Rd near Swan St",
                        "Weyba Rd near Anchor St",
                        "Shorehaven Dr near The Anchorage hail 'n' ride",
                        "Shorehaven Dr near Saltwater Ave hail 'n' ride",
                        "Shorehaven Dr near Shipwright Av hail 'n' ride",
                        "Shorehaven Dr near Oceanmist Ct hail 'n' ride",
                        "Gibson Rd near Portside Ct",
                        "Eumundi Rd at Goodchap Street",
                        "Good Shepherd Lutheran College",
                        "Walter Hay Dr at Selkirk Drive",
                        "Goodchap St at Heritage Dr",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St near Ridge St",
                        "Hilton Tce at Noosa Convention Centre",
                        "Poinciana Ave at Ward Park",
                        "Poinciana Ave at Tewantin Primary School",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Butler St at Noosa Crematorium",
                        "Cooroy Noosa Rd at Ross Court",
                        "Saint Andrews Dr at William Street",
                        "Saint Andrews Dr at Wattle Street",
                        "St Andrews Dr at Hibiscus Retirement Resort",
                        "Saint Andrews Dr near Furness Dr",
                        "Sea Eagle Drive at Noosaville State School",
                        "Saint Andrews Dr near Linksland St hail 'n' ride",
                        "Saint Andrews Dr near Furness Dr hail 'n' ride",
                        "Saint Andrews Dr near William St",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Hilton Tce at Earl Street",
                        "Shorehaven Dr near The Peninsula hail 'n' ride",
                        "Shorehaven Dr near Waterside Ct hail 'n' ride",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St",
                        "Cooyar St near Elanora Tce",
                        "David Low Way at Castaways Creek",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride"
                    ],
                    "5818: Coolum - St Thomas More Primary": [
                        "Coolum High School",
                        "David Low Way at Coolum High School",
                        "David Low Way at Peregian South",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Water Tower",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride",
                        "Wavecrest Dr near Tropicana Rise hail 'n' ride",
                        "Wavecrest Dr near Moonbeam Cr hail 'n' ride",
                        "Wavecrest Dr near Coconut Gr hail 'n' ride",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Sunrise Beach",
                        "Orient Dr at Newfield St",
                        "Orient Dr at Corsair Cr",
                        "Orient Dr near Wollomia Way",
                        "Wollomia Way near Victory Cr",
                        "Wollomia Way near Comet Dr",
                        "Dame Patti Dr near Ben Lexcen Dr",
                        "Ben Lexcen Dr near Grasstree Ct",
                        "Ben Lexcen Dr near Sarena Ct",
                        "St Teresas Catholic College",
                        "Eumundi Rd at Rene Street",
                        "Ben Lexcen Dr near Lipton St",
                        "Wollomia Way near Bond Ct hail 'n' ride",
                        "Orient Dr near Wollomia Way hail 'n' ride",
                        "Orient Dr near Newfield St hail 'n' ride",
                        "David Low Way at Castaways Creek",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride"
                    ],
                    "5819: Cooroibah - St Teresa's College": [
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "McKinnon Dr near Yellowood Cl hail 'n' ride",
                        "Butler St at Noosa Crematorium",
                        "Lake Cooroibah Rd near Yatama Pl hail 'n' ride",
                        "Cooroy Noosa Rd at Ross Court",
                        "Morning Glory Dr near Stanley St hail 'n' ride",
                        "Tewantin Noosa Golf Club",
                        "Lake Cooroibah Rd near Amaroo Pl hail 'n' ride",
                        "Golf Course Dr near Carramar St hail 'n' ride",
                        "Jirrima Cr near Amaroo Pl hail 'n' ride",
                        "10 Jirrima Cr hail 'n' ride",
                        "Golf Course Dr near Daintree Way",
                        "Griffith Ave near Club Ct",
                        "Illoura Pl near Jirrima Cres hail 'n' ride",
                        "Griffith Ave near Parkview Ct",
                        "Woodhaven Way near Dela Ct hail 'n' ride",
                        "Griffith Ave near Cedarleigh Dr",
                        "Woodhaven Way near Illoura Pl hail 'n' ride",
                        "Griffith Ave at Palmer Crescent",
                        "Illoura Pl near Greengate Rd hail 'n' ride",
                        "Illoura Pl near Glenridge Dr hail 'n' ride",
                        "Carramar St near Tinaroo Pl hail 'n' ride",
                        "Carramar St near Avron Cl hail 'n' ride",
                        "26 Coral Fern Dr hail 'n' ride",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Coral Fern Dr near Morning Dew Cl hail 'n' ride",
                        "Fairway Dr near Thompson Cr hail 'n' ride",
                        "Coral Fern Dr near McKinnon Dr hail 'n' ride",
                        "Mckinnon Dr near Silverwood Dr hail 'n' ride",
                        "Furness Dr near Felsted Ct hail 'n' ride",
                        "Furness Dr near Blackheath Dr hail 'n' ride",
                        "Noosa Banks Dr near McKinnon Dr hail 'n' ride",
                        "Furness Dr near Portrush Ct hail 'n' ride",
                        "Poinciana Ave at Tewantin Primary School",
                        "Furness Dr near Muirfield Cr hail 'n' ride",
                        "Moorindil St near Toolar St",
                        "Sea Eagle Drive at Noosaville State School",
                        "Moorindil St near Gympie St",
                        "Moorindil St near George St",
                        "Moorindil St near Cobham St",
                        "Moorindil St near Read St",
                        "Werin St near George St hail 'n' ride",
                        "Werin St at Crank Street",
                        "St Teresas Catholic College",
                        "Furness Dr near Troon Ct hail 'n' ride",
                        "Furness Dr near Portrush Ct",
                        "Furness Dr near Blackheath Dr",
                        "Furness Dr near Felsted Ct",
                        "Fairway Dr near Thompson Cr",
                        "Tewantin State School at Werin Rd hail 'n' ride"
                    ],
                    "5820: Noosaville - St Thomas More Primary": [
                        "St Teresas Catholic College",
                        "Golf Course Dr near Carramar St hail 'n' ride",
                        "Golf Course Dr near Daintree Way",
                        "Griffith Ave near Club Ct",
                        "Griffith Ave near Parkview Ct",
                        "Griffith Ave near Cedarleigh Dr",
                        "Griffith Ave at Palmer Crescent",
                        "Carramar St near Tinaroo Pl hail 'n' ride",
                        "Carramar St near Avron Cl hail 'n' ride",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Tewantin Noosa Golf Club",
                        "Butler St at Noosa Crematorium",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Sunshine Beach High School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Cooroy Noosa Rd at Ross Court",
                        "Sea Eagle Drive at Noosaville State School"
                    ],
                    "5821: Tewantin - St Thomas More Primary": [
                        "Tewantin Central",
                        "Moorindil St near Toolar St",
                        "Moorindil St near Gympie St",
                        "Moorindil St near George St",
                        "Moorindil St near Cobham St",
                        "Moorindil St near Read St",
                        "Werin St near George St hail 'n' ride",
                        "Werin St at Crank Street",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Sunshine Beach High School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Poinciana Ave at Poinciana Place"
                    ],
                    "5822: Noosaville SS - Tewantin SS": [
                        "Golf Course Dr near Carramar St hail 'n' ride",
                        "Golf Course Dr near Daintree Way",
                        "Griffith Ave near Club Ct",
                        "Griffith Ave near Parkview Ct",
                        "Griffith Ave near Cedarleigh Dr",
                        "Griffith Ave at Palmer Crescent",
                        "Carramar St near Tinaroo Pl hail 'n' ride",
                        "Carramar St near Avron Cl hail 'n' ride",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Fairway Dr near Thompson Cr hail 'n' ride",
                        "Furness Dr near Felsted Ct hail 'n' ride",
                        "Furness Dr near Blackheath Dr hail 'n' ride",
                        "Furness Dr near Portrush Ct hail 'n' ride",
                        "Furness Dr near Muirfield Cr hail 'n' ride",
                        "Saint Andrews Dr near Furness Dr",
                        "Outlook Dr at Clarey Road",
                        "Outlook Dr near Freeman Ct",
                        "Outlook Dr near Gooloi Ct",
                        "Outlook Dr near Buchanan Cr",
                        "Saint Andrews Dr near William St",
                        "Butler St at Noosa Crematorium",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Cooroy Noosa Rd at Ross Court",
                        "Saint Andrews Dr at William Street",
                        "Outlook Dr near Talara Ct",
                        "Furness Dr near Troon Ct hail 'n' ride",
                        "Furness Dr near Portrush Ct",
                        "Furness Dr near Blackheath Dr",
                        "Furness Dr near Felsted Ct",
                        "Fairway Dr near Thompson Cr",
                        "Tewantin Noosa Golf Club"
                    ],
                    "5823: Lake Cooroibah - Sunshine Beach High": [
                        "McKinnon Dr near Yellowood Cl hail 'n' ride",
                        "Lake Cooroibah Rd near Yatama Pl hail 'n' ride",
                        "Morning Glory Dr near Stanley St hail 'n' ride",
                        "Lake Cooroibah Rd near Amaroo Pl hail 'n' ride",
                        "Jirrima Cr near Amaroo Pl hail 'n' ride",
                        "10 Jirrima Cr hail 'n' ride",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Cooyar St near Elanora Tce",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Sunshine Beach High School",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin State School at Werin Rd hail 'n' ride"
                    ],
                    "5824: CSHS - Mt Coolum": [
                        "Coolum High School",
                        "David Low Way at Coolum Beach",
                        "David Low Way near Goongilla St",
                        "David Low Way at Mount Coolum"
                    ],
                    "5825: Pacific Paradise - Coolum High": [
                        "David Low Way at Kowonga Street",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Esp near David Low Way",
                        "David Low Way at Sunset Strip",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "David Low Way at Petrie Avenue",
                        "David Low Way at Lorraine Avenue",
                        "David Low Way at Seaside Boulevard",
                        "David Low Way at Mount Coolum",
                        "Coolum High School",
                        "David Low Way at Keith Royal Drive",
                        "Ocean Dr near Toyango St hail 'n' ride"
                    ],
                    "5826: Lake Weyba - Sunshine Beach High": [
                        "Eumarella Rd near Tidswell Rd hail 'n' ride",
                        "Eumarella Rd near Paradise Dr hail 'n' ride",
                        "Paradise Dr near Eumarella Rd hail 'n' ride",
                        "Lake Weyba Dr near Lake View Ct hail 'n' ride",
                        "Charlotte Dr near Eumarella Rd hail 'n' ride",
                        "Beddington Rd near Eumundi Noosa Rd hail 'n' ride",
                        "160 Beddington Rd hail 'n' ride",
                        "Wattlebird Dr near Whipbird Pl hail 'n' ride",
                        "Lenehans Lane near Livistona Dr hail 'n' ride",
                        "Eumundi Rd at Rene Street",
                        "Good Shepherd Lutheran College",
                        "Walter Hay Dr at Selkirk Drive",
                        "Cooyar St near Elanora Tce",
                        "Sunshine Beach Primary School",
                        "Sunshine Beach High School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Wattlebird Dr near Lenehans Lane hail 'n' ride",
                        "Wattlebird Dr near Beddington Rd hail 'n' ride",
                        "Beddington Rd near Persoonia Lane hail 'n' ride"
                    ],
                    "5827: Mt Coolum - Sunshine Beach High": [
                        "David Low Way at Tanah Street",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Lumeah Dr near Fairway Cl hail 'n' ride",
                        "Burremah Cr near Lumeah Dr hail 'n' ride",
                        "Marakari Cr near Coorara Ct hail 'n' ride",
                        "Lumeah Dr near Suncoast Beach Dr hail 'n' ride",
                        "David Low Way at Mount Coolum",
                        "David Low Way at Warran Road",
                        "David Low Way at Yaroomba Beach",
                        "David Low Way at Point Arkwright",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Coolum Beach",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Mt Peregian",
                        "Coolum High School",
                        "David Low Way at Coolum High School",
                        "David Low Way at Peregian South",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Water Tower",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride",
                        "Wavecrest Dr near Tropicana Rise hail 'n' ride",
                        "Wavecrest Dr near Moonbeam Cr hail 'n' ride",
                        "Wavecrest Dr near Coconut Gr hail 'n' ride",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Sunrise Beach",
                        "Orient Dr at Newfield St",
                        "Orient Dr at Corsair Cr",
                        "Orient Dr near Wollomia Way",
                        "Wollomia Way near Victory Cr",
                        "Wollomia Way near Comet Dr",
                        "Dame Patti Dr near Ben Lexcen Dr",
                        "Ben Lexcen Dr near Grasstree Ct",
                        "Sunshine Beach High School",
                        "Ben Lexcen Dr near Lipton St",
                        "Wollomia Way near Bond Ct hail 'n' ride",
                        "Orient Dr near Wollomia Way hail 'n' ride",
                        "Orient Dr near Newfield St hail 'n' ride",
                        "David Low Way at Castaways Creek",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride",
                        "David Low Way near Goongilla St",
                        "David Low Way near Yaroomba Dr hail 'n' ride"
                    ],
                    "5828: Noosa Heads - St Thomas More Primary": [
                        "Leslie Dr at Arkana Dr",
                        "Sunset Dr near Weyba Park Dr hail 'n' ride",
                        "Sunset Dr near Kookaburra Lane hail 'n' ride",
                        "Leslie Dr near Tarina St",
                        "Myrtle Rd near Smoke Bush dr hail 'n' ride",
                        "Toulambi St near Allambi Tce hail 'n' ride",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Sunshine Beach High School",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St"
                    ],
                    "5829: Cooroibah - Tewantin Primary": [
                        "Turpentine Rd near Cream Box Ct hail 'n' ride",
                        "McKinnon Dr near Turpentine Rd hail 'n' ride",
                        "26 Coral Fern Dr hail 'n' ride",
                        "Coral Fern Dr near Morning Dew Cl hail 'n' ride",
                        "Coral Fern Dr near McKinnon Dr hail 'n' ride",
                        "Carriage Way near Bushranger Ct hail 'n' ride",
                        "Silverwood Dr near Illawarra Dr hail 'n' ride",
                        "Silverwood Dr near Harmony Ct hail 'n' ride",
                        "Mckinnon Dr near Silverwood Dr hail 'n' ride",
                        "McKinnon Dr near Yellowood Cl hail 'n' ride",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Tewantin State School at Werin Rd hail 'n' ride"
                    ],
                    "5830: Noosaville - Sunshine Beach High": [
                        "Sea Eagle Drive at Noosaville State School",
                        "Saint Andrews Dr near Furness Dr",
                        "Outlook Dr at Clarey Road",
                        "Outlook Dr near Freeman Ct",
                        "Outlook Dr near Gooloi Ct",
                        "Outlook Dr near Buchanan Cr",
                        "Saint Andrews Dr near William St",
                        "Butler St at Noosa Crematorium",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Sunshine Beach High School",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Cooroy Noosa Rd at Ross Court",
                        "Saint Andrews Dr at William Street",
                        "Outlook Dr near Talara Ct"
                    ],
                    "5831: Pomona - St Thomas More Primary": [
                        "Reserve St at Station St",
                        "Pioneer Rd near Highfield Rise hail 'n' ride",
                        "Old Bruce Hwy near Pioneer Rd hail 'n' ride",
                        "Black Mountain Range Rd near Woodswallow Lane HnR",
                        "Cudgerie Dr near Foambark Pl hail 'n' ride",
                        "Cudgerie Dr near Pepper Berry Pl hail 'n' ride",
                        "Elm St at Pearsons Rd",
                        "Elm St opp Cooroy station",
                        "Tewantin Rd near Olivine St",
                        "Cooroy Noosa Rd near Sivyers Rd hail 'n' ride",
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Sunrise Rd near Gyndier Dr hail 'n' ride",
                        "Patterson Dr near Wilkes Ct hail 'n' ride",
                        "Kingsgate Dr near Jaggers Ct hail 'n' ride",
                        "Kingsgate Dr near Brookland Rd hail 'n' ride",
                        "Sunrise Rd near Smiths Rd hail 'n' ride",
                        "415 Sunrise Road hail 'n' ride",
                        "Duke Rd near Sunrise Rd hail 'n' ride",
                        "Duke Rd near Eagle Farm Cl hail 'n' ride",
                        "Duke Rd near Eumundi Noosa Rd hail 'n' ride",
                        "Walter Hay Dr at Selkirk Drive",
                        "Good Shepherd Lutheran College",
                        "Sunshine Beach High School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "108 Duke Rd hail 'n' ride",
                        "Sunrise Rd near Wust Rd hail 'n' ride",
                        "391 Sunrise Road hail 'n' ride",
                        "Sunrise Rd near Wendoma Ct hail 'n' ride",
                        "Tewantin Rd near Miva St",
                        "Elm St at Cooroy station"
                    ],
                    "5832: Noosaville - Sunshine Beach High": [
                        "Sea Eagle Drive at Noosaville State School",
                        "Furness Dr near Troon Ct hail 'n' ride",
                        "Furness Dr near Portrush Ct",
                        "Furness Dr near Blackheath Dr",
                        "Furness Dr near Felsted Ct",
                        "Fairway Dr near Thompson Cr",
                        "Tewantin Noosa Golf Club",
                        "Butler St at Noosa Crematorium",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Cooyar St near Elanora Tce",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Sunshine Beach High School",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Cooroy Noosa Rd at Ross Court",
                        "Fairway Dr near Thompson Cr hail 'n' ride",
                        "Furness Dr near Felsted Ct hail 'n' ride",
                        "Furness Dr near Blackheath Dr hail 'n' ride",
                        "Furness Dr near Portrush Ct hail 'n' ride",
                        "Furness Dr near Muirfield Cr hail 'n' ride"
                    ],
                    "5833: Mt Tinbeerwah - Burnside High": [
                        "Cooroy Noosa Rd at Sunrise Road",
                        "Tewantin Rd near Miva St",
                        "Elm St opp Cooroy station",
                        "Memorial Dr at Eerwah Vale Overpass",
                        "Memorial Dr at Eumundi Markets",
                        "Memorial Dr at Eumundi Aquatic Centre",
                        "Pioneer Rd at The Ginger Factory",
                        "Yandina Primary School Bus Bays",
                        "Fleming Street at School Road",
                        "Old Bruce Hwy at Yandina Caravan Park",
                        "Nambour Connection Rd at Nambour Caravan Park",
                        "Nambour Connection Rd at Nambour Park",
                        "Nambour Connection Rd near City View Tce HnR",
                        "Coronation Ave at Show and Sportsgrounds",
                        "Nambour State High School",
                        "Coronation Ave at Matthew Street",
                        "Currie St at Nambour Library",
                        "St John's Catholic College",
                        "Burnside State High School",
                        "Perwillowen Road at Valley View Street",
                        "Blaxland Rd near Lawson Cl",
                        "Carter Rd near Solandra St",
                        "Carter Rd at Arundell Ave",
                        "Mill Lane at Nambour Mill Village",
                        "Nambour Connection Rd near Boronia St",
                        "Nambour Connection Rd near Oleander Dr",
                        "Old Bruce Hwy near Ayrshire Rd",
                        "Farrell St near Stevens St",
                        "Memorial Dr at Fullager Dr",
                        "Elm St at Cooroy station",
                        "Tewantin Rd near Olivine St",
                        "Cooroy Noosa Rd near Sivyers Rd hail 'n' ride"
                    ],
                    "5834: CSHS - Toolga": [
                        "Coolum High School",
                        "South Coolum Rd near Green Oaks Dr",
                        "South Coolum Rd near Wandaa Ct",
                        "Toolga St near Warrack St"
                    ],
                    "5835: Noosa Junction - Matthew Flinders College": [
                        "Noosa Junction station, stop A",
                        "David Low Way at Sunshine Beach Primary",
                        "Pacific Ave near Weyba St",
                        "Pacific Ave near Ferguson Ave",
                        "Pacific Ave near Elanda St",
                        "David Low Way at Vernon Street",
                        "David Low Way at Sunrise Beach",
                        "David Low Way at Castaways Beach",
                        "Wavecrest Dr near Coconut Gr hail 'n' ride",
                        "Wavecrest Dr near Moonbeam Cr hail 'n' ride",
                        "Wavecrest Dr near Tropicana Rise hail 'n' ride",
                        "David Low Way at Castaways Creek",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Peregian South",
                        "St Andrews College",
                        "Immanuel Lutheran College",
                        "Wises Rd at Kayleigh Drive",
                        "Mooloolaba Rd at Buderim Garden Village",
                        "Karawatha Dr near Mountain Creek Rd",
                        "Karawatha Dr at Hibiscus Retirement Resort",
                        "Karawatha Dr near Brianna Cl",
                        "Karawatha Dr near Jingellic Dr",
                        "Karawatha Dr near Dixon Rd",
                        "Ballinger Rd near Elliot Dr hail 'n' ride",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Ballinger Rd near Lara Dr hail 'n' ride",
                        "Karawatha Dr near Leah Cl",
                        "Karawatha Dr near Golf Links Rd",
                        "Wises Rd near Glen Kyle Dr",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride",
                        "Pacific Ave near Wildflower St",
                        "Pacific Ave near Ferguson St",
                        "Pacific Ave near Edwards St"
                    ],
                    "5836: Noosa Banks - Sunshine Beach High": [
                        "Noosa Banks Dr near McKinnon Dr hail 'n' ride",
                        "McKinnon Dr near Yellowood Cl hail 'n' ride",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Walter Hay Dr at Selkirk Drive",
                        "Sunshine Beach High School",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin State School at Werin Rd hail 'n' ride"
                    ],
                    "5837: Noosaville - St Thomas More Primary": [
                        "Lake Entrance Bvd near Casuarina Ct hail 'n' ride",
                        "Lake Entrance Bvd near Satinash St hail 'n' ride",
                        "Lake Entrance Bvd near Redgum Ct hail 'n' ride",
                        "Lake Entrance Bvd near Doolan Ct hail 'n' ride",
                        "Eumundi Rd at Rene Street",
                        "Eumundi Rd at Goodchap Street",
                        "Gibson Rd near Portside Ct",
                        "Shorehaven Dr near Oceanmist Ct hail 'n' ride",
                        "Shorehaven Dr near The Peninsula hail 'n' ride",
                        "Shorehaven Dr near Saltwater Ave hail 'n' ride",
                        "Shorehaven Dr near Waterside Ct hail 'n' ride",
                        "Weyba Rd near Anchor St",
                        "Lake Weyba Dr near Creek Rd",
                        "Lake Weyba Dr near Nannygai St",
                        "Weyba Rd near Swan St",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St",
                        "Cooyar St near Elanora Tce",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Sunshine Beach High School",
                        "Cooyar St near Langura St",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Shorehaven Dr near The Anchorage hail 'n' ride",
                        "Shorehaven Dr near Shipwright Av hail 'n' ride",
                        "Lake Entrance Bvd near Eumundi Noosa Rd hail 'n' ride"
                    ],
                    "5838: Pomona - Siena College": [
                        "Reserve St at Station St",
                        "Pioneer Rd near Highfield Rise hail 'n' ride",
                        "Old Bruce Hwy near Pioneer Rd hail 'n' ride",
                        "Black Mountain Range Rd near Woodswallow Lane HnR",
                        "Cudgerie Dr near Foambark Pl hail 'n' ride",
                        "Cudgerie Dr near Pepper Berry Pl hail 'n' ride",
                        "Elm St at Pearsons Rd",
                        "Elm St opp Cooroy station",
                        "Memorial Dr at Eerwah Vale Overpass",
                        "Memorial Dr at Eumundi Markets",
                        "Memorial Dr at Eumundi Aquatic Centre",
                        "Pioneer Rd at The Ginger Factory",
                        "Sunshine Coast Grammar School",
                        "Tanawha Tourist Dr near Glenmount Rd hail 'n' ride",
                        "Sippy Downs Dr at High St",
                        "Stringybark Rd near Jorl Ct",
                        "Stringybark Rd near Ebony Ct",
                        "Stringybark Rd at Matthew Flinders Anglican",
                        "Stringybark Rd near Greenwood Cl",
                        "Stringybark Rd near Goshawk Bvd",
                        "Sippy Downs Dr at Siena Catholic College",
                        "38 Owen Creek Rd hail 'n' ride",
                        "Mons Rd near Owen Creek Rd",
                        "Memorial Dr at Fullager Dr",
                        "Elm St at Cooroy station"
                    ],
                    "5839: Pacific Paradise - St Andrew's College": [
                        "David Low Way at Kowonga Street",
                        "Ocean Dr near Prestwick Dr hail 'n' ride",
                        "Ocean Dr near Magnolia Lane hail 'n' ride",
                        "Mudjimba Beach Rd near Coolibah St",
                        "Mudjimba Beach Rd near Kawanna St",
                        "Mudjimba Esp at Currawong Street",
                        "Mudjimba Esp near David Low Way",
                        "David Low Way at Sunset Strip",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "David Low Way at Petrie Avenue",
                        "Petrie Ave near Begonia Way",
                        "Petrie Ave at Marcoola",
                        "Marcoola Esp at Marcoola SLSC",
                        "Tamarindus St near Cycas St",
                        "Seaside Bvd near David Low Way hail 'n' ride",
                        "Boardwalk Bvd near Breakers Pl hail 'n' ride",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Jarnahill Dr near Quinn Ct",
                        "Toolga St near Carrock Ct",
                        "South Coolum Rd near Wandaa Ct",
                        "South Coolum Rd near Green Oaks Dr",
                        "St Andrews College",
                        "Toolga St near Warrack St",
                        "David Low Way at Mount Coolum",
                        "Tamarindus St near Willow Cr",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "Ocean Dr near Toyango St hail 'n' ride"
                    ],
                    "5840: Noosa Bushlands - St Thomas More Primary": [
                        "St Teresas Catholic College",
                        "Shire Dr near Morinda Cct hail 'n' ride",
                        "Bushlands Dr at Rose Ash Crescent",
                        "Swanbourne Way near Beckmans Rd",
                        "Eumundi Rd at Rene Street",
                        "Eumundi Rd at Goodchap Street",
                        "Gibson Rd near Portside Ct",
                        "Gibson Rd at The Cockleshell",
                        "Mary St near Albert St",
                        "Mary St near Edward St",
                        "Weyba Rd near Anchor St",
                        "Weyba Rd near Swan St",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Sunshine Beach High School",
                        "Noosa Junction station, stop A",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Mary St near George St",
                        "Swanbourne Way near Beckmans Rd hail 'n' ride",
                        "Bushlands Dr near Satinwood St",
                        "Shire Dr near Sea Eagle Dr hail 'n' ride"
                    ],
                    "5841: South Coolum - Coolum High": [
                        "South Coolum Rd near Green Oaks Dr",
                        "Yarrock St near South Coolum Rd hail 'n' ride",
                        "Jenyor St near Bimini Dr hail 'n' ride",
                        "Warran Rd near Neurum Rd hail 'n' ride",
                        "Coolum High School",
                        "Warran Rd near Holbrook Ct hail 'n' ride"
                    ],
                    "5842: Tewantin (Bougainvillia) - St Thomas More Primary": [
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Tewantin Noosa Golf Club",
                        "Butler St at Noosa Crematorium",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Hilton Tce at Tewantin Noosa Bowls Club",
                        "Gympie Tce at James Duke Bridge",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Massoud Park",
                        "Weyba Rd at Pelican Beach Park",
                        "Noosa Pde at William Street",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Witta Circle",
                        "Noosa Heads station, platform 2",
                        "Noosa Dr at Hibiscus Avenue",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Sunshine Beach High School",
                        "Noosa Junction station, stop A",
                        "Noosa Heads station, platform 1",
                        "Hilton Tce at Noosa Convention Centre",
                        "Cooroy Noosa Rd at Ross Court"
                    ],
                    "5843: Peregian Springs - Peregian Springs Primary": [
                        "St Andrews College",
                        "David Low Way at Peregian South",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Peregian North",
                        "David Low Way at Marcus Beach",
                        "David Low Way at Mahogany Drive",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride",
                        "Ridgeview Dr at Peregian Springs Drive",
                        "Ridgeview Dr at North Ridge Avenue",
                        "Ridgeview Dr at The Avenue",
                        "Peregian Springs State School",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride"
                    ],
                    "5844: Noosa Junction - St Andrew's College": [
                        "Noosa Junction station, stop A",
                        "David Low Way at Sunshine Beach Primary",
                        "Pacific Ave near Weyba St",
                        "Pacific Ave near Ferguson Ave",
                        "Pacific Ave near Elanda St",
                        "David Low Way at Vernon Street",
                        "David Low Way at Sunrise Beach",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Castaways Creek",
                        "David Low Way at Mahogany Drive",
                        "David Low Way at Marcus Beach",
                        "David Low Way at Peregian North",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Peregian South",
                        "St Andrews College",
                        "Pacific Ave near Wildflower St",
                        "Pacific Ave near Ferguson St",
                        "Pacific Ave near Edwards St"
                    ],
                    "5845: Noosaville (Goodchap St) - Coolum High": [
                        "Eumundi Rd at Goodchap Street",
                        "Gympie Tce at James Duke Bridge",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Massoud Park",
                        "Weyba Rd at Pelican Beach Park",
                        "Noosa Pde at William Street",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Witta Circle",
                        "Noosa Heads station, platform 2",
                        "Noosa Dr at Hibiscus Avenue",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Noosa Junction station, stop A",
                        "Cooyar St near Langura St",
                        "Old Emu Mountain Rd near Peregian Breeze Dr HnR",
                        "Old Emu Mountain Rd near California Bvd HnR",
                        "St Andrews College",
                        "Yandina Coolum Rd near Park Cr",
                        "Central Ave near Pandanus Ave",
                        "Banksia Ave near Mistral Ave hail 'n' ride",
                        "Cinnamon Ave near Fourwinds Ave hail 'n' ride",
                        "Hewitt St near Third Ave hail 'n' ride",
                        "Coolum High School",
                        "Central Ave near Palm Ave",
                        "Ridges Bvd at Mallee Street",
                        "Ridges Bvd at Kurrajong Circuit",
                        "Ridges Bvd at Peregian Springs State School",
                        "Cooyar St near Elanora Tce",
                        "Noosa Heads station, platform 1"
                    ],
                    "5846: Mt Coolum - St Teresa's College": [
                        "David Low Way at Tanah Street",
                        "Eumarella Rd near Tidswell Rd hail 'n' ride",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Eumarella Rd near Paradise Dr hail 'n' ride",
                        "Jarnahill Dr near Quinn Ct",
                        "Paradise Dr near Eumarella Rd hail 'n' ride",
                        "Lake Weyba Dr near Lake View Ct hail 'n' ride",
                        "Toolga St near Carrock Ct",
                        "Charlotte Dr near Eumarella Rd hail 'n' ride",
                        "South Coolum Rd near Wandaa Ct",
                        "Beddington Rd near Eumundi Noosa Rd hail 'n' ride",
                        "Yarrock St near South Coolum Rd hail 'n' ride",
                        "160 Beddington Rd hail 'n' ride",
                        "Jenyor St near Bimini Dr hail 'n' ride",
                        "Yungar St near Karlee Ct hail 'n' ride",
                        "Wattlebird Dr near Whipbird Pl hail 'n' ride",
                        "Yungar St near Greenoaks Dr hail 'n' ride",
                        "Central Ave near Pandanus Ave",
                        "Lenehans Lane near Livistona Dr hail 'n' ride",
                        "Banksia Ave near Tradewinds Ave",
                        "Lake Entrance Bvd near Eumundi Noosa Rd hail 'n' ride",
                        "Birtwill St near Heathfield Rd",
                        "Lake Entrance Bvd near Casuarina Ct hail 'n' ride",
                        "David Low Way at Coolum Hotel",
                        "Lake Entrance Bvd near Satinash St hail 'n' ride",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "Lake Entrance Bvd near Redgum Ct hail 'n' ride",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum High School",
                        "Lake Entrance Bvd near Doolan Ct hail 'n' ride",
                        "Sea Eagle Drive at Noosaville State School",
                        "Old Emu Mountain Rd near California Bvd HnR",
                        "Old Emu Mountain Rd near Peregian Breeze Dr HnR",
                        "St Teresas Catholic College",
                        "Wattlebird Dr near Lenehans Lane hail 'n' ride",
                        "Wattlebird Dr near Beddington Rd hail 'n' ride",
                        "Beddington Rd near Persoonia Lane hail 'n' ride",
                        "Birtwill St near David Low Way",
                        "Banksia Ave at Tradewinds Avenue",
                        "Central Ave near Palm Ave",
                        "Toolga St near Warrack St",
                        "David Low Way at Mount Coolum"
                    ],
                    "5847: Mt Coolum - Coolum High": [
                        "David Low Way at Tanah Street",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Jarnahill Dr near Quinn Ct",
                        "Toolga St near Carrock Ct",
                        "South Coolum Rd near Wandaa Ct",
                        "Yarrock St near South Coolum Rd hail 'n' ride",
                        "Jenyor St near Bimini Dr hail 'n' ride",
                        "Yungar St near Karlee Ct hail 'n' ride",
                        "Yungar St near Greenoaks Dr hail 'n' ride",
                        "Yandina Coolum Rd near Park Cr",
                        "Coolum State Primary School",
                        "David Low Way at Coolum Beach",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Mt Peregian",
                        "Coolum High School",
                        "Yandina Coolum Rd near Greenoaks Dr hail 'n' ride",
                        "Toolga St near Warrack St",
                        "David Low Way at Mount Coolum"
                    ],
                    "5848: Mt Coolum - Coolum High": [
                        "David Low Way at Tanah Street",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Lumeah Dr near Fairway Cl hail 'n' ride",
                        "Burremah Cr near Lumeah Dr hail 'n' ride",
                        "Marakari Cr near Coorara Ct hail 'n' ride",
                        "Lumeah Dr near Suncoast Beach Dr hail 'n' ride",
                        "David Low Way at Mount Coolum",
                        "David Low Way at Warran Road",
                        "David Low Way at Yaroomba Beach",
                        "David Low Way at Point Arkwright",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Coolum Beach",
                        "Coolum High School",
                        "David Low Way near Goongilla St",
                        "David Low Way near Yaroomba Dr hail 'n' ride"
                    ],
                    "5849: Pacific Paradise - Coolum High": [
                        "David Low Way at Kowonga Street",
                        "David Low Way at Namba Street",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way at Pacific Paradise",
                        "David Low Way at Friendship Avenue",
                        "David Low Way at Fourth Avenue",
                        "David Low Way at Sunset Strip",
                        "David Low Way near Surfside Av hail 'n' ride",
                        "Petrie Ave near Begonia Way",
                        "Petrie Ave at Marcoola",
                        "Marcoola Esp at Marcoola SLSC",
                        "Tamarindus St near Cycas St",
                        "Seaside Bvd near David Low Way hail 'n' ride",
                        "Boardwalk Bvd near Breakers Pl hail 'n' ride",
                        "David Low Way at Mount Coolum",
                        "David Low Way at Tanah Street",
                        "David Low Way at Warran Road",
                        "David Low Way at Yaroomba Beach",
                        "David Low Way at Point Arkwright",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Coolum Beach",
                        "Coolum High School",
                        "David Low Way near Goongilla St",
                        "David Low Way near Yaroomba Dr hail 'n' ride",
                        "Tamarindus St near Willow Cr",
                        "Petrie Ave near Ramona St",
                        "David Low Way at Keith Royal Drive",
                        "David Low Way near Surfrider Pl hail 'n' ride"
                    ],
                    "5850: Noosa Junction - Coolum Primary": [
                        "Noosa Junction station, stop A",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Ben Lexcen Dr near Lipton St",
                        "Wollomia Way near Bond Ct hail 'n' ride",
                        "Orient Dr near Wollomia Way hail 'n' ride",
                        "Orient Dr near Newfield St hail 'n' ride",
                        "David Low Way at Sunrise Beach",
                        "David Low Way at Castaways Beach",
                        "Wavecrest Dr near Coconut Gr hail 'n' ride",
                        "Wavecrest Dr near Moonbeam Cr hail 'n' ride",
                        "Wavecrest Dr near Tropicana Rise hail 'n' ride",
                        "David Low Way at Castaways Creek",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride",
                        "David Low Way at Peregian Water Tower",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Peregian South",
                        "St Andrews College",
                        "David Low Way at Coolum High School",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Beach",
                        "Yandina Coolum Rd near Greenoaks Dr hail 'n' ride",
                        "Yandina Coolum Rd near Park Cr",
                        "Coolum State Primary School",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride",
                        "Orient Dr at Newfield St",
                        "Orient Dr at Corsair Cr",
                        "Orient Dr near Wollomia Way",
                        "Wollomia Way near Victory Cr",
                        "Wollomia Way near Comet Dr",
                        "Dame Patti Dr near Ben Lexcen Dr",
                        "Ben Lexcen Dr near Grasstree Ct"
                    ],
                    "5851: Noosa Springs - Coolum High": [
                        "Myrtle Rd near Smoke Bush dr hail 'n' ride",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Weyba Rd near Swan St",
                        "Weyba Rd near Anchor St",
                        "Shorehaven Dr near The Anchorage hail 'n' ride",
                        "Shorehaven Dr near Saltwater Ave hail 'n' ride",
                        "Shorehaven Dr near Shipwright Av hail 'n' ride",
                        "Shorehaven Dr near Oceanmist Ct hail 'n' ride",
                        "Gibson Rd near Portside Ct",
                        "Eumundi Rd at Goodchap Street",
                        "Walter Hay Dr at Selkirk Drive",
                        "St Andrews College",
                        "Yandina Coolum Rd near Park Cr",
                        "Central Ave near Pandanus Ave",
                        "Banksia Ave near Tradewinds Ave",
                        "Birtwill St near Heathfield Rd",
                        "Coolum High School",
                        "Birtwill St near David Low Way",
                        "Banksia Ave at Tradewinds Avenue",
                        "Central Ave near Palm Ave",
                        "Ridges Bvd at Mallee Street",
                        "Ridges Bvd at Kurrajong Circuit",
                        "Ridges Bvd at Peregian Springs State School",
                        "Shorehaven Dr near The Peninsula hail 'n' ride",
                        "Shorehaven Dr near Waterside Ct hail 'n' ride",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St"
                    ],
                    "5852: Tewantin - Coolum High": [
                        "Tewantin Central",
                        "Poinciana Ave at Ward Park",
                        "Moorindil St near Toolar St",
                        "Moorindil St near Gympie St",
                        "Moorindil St near George St",
                        "Moorindil St near Cobham St",
                        "Moorindil St near Read St",
                        "Werin St near George St hail 'n' ride",
                        "Werin St at Crank Street",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Butler St at Noosa Crematorium",
                        "Cooroy Noosa Rd at Ross Court",
                        "Fairway Dr near Thompson Cr hail 'n' ride",
                        "Furness Dr near Felsted Ct hail 'n' ride",
                        "Furness Dr near Blackheath Dr hail 'n' ride",
                        "Furness Dr near Portrush Ct hail 'n' ride",
                        "Furness Dr near Muirfield Cr hail 'n' ride",
                        "Sea Eagle Drive at Noosaville State School",
                        "Shire Dr near Morinda Cct hail 'n' ride",
                        "Swanbourne Way near Beckmans Rd",
                        "Lake Entrance Bvd near Eumundi Noosa Rd hail 'n' ride",
                        "Lake Entrance Bvd near Casuarina Ct hail 'n' ride",
                        "Lake Entrance Bvd near Satinash St hail 'n' ride",
                        "Lake Entrance Bvd near Redgum Ct hail 'n' ride",
                        "Lake Entrance Bvd near Doolan Ct hail 'n' ride",
                        "Wattlebird Dr near Lenehans Lane hail 'n' ride",
                        "Wattlebird Dr near Beddington Rd hail 'n' ride",
                        "Beddington Rd near Persoonia Lane hail 'n' ride",
                        "Beddington Rd near Eumundi Noosa Rd hail 'n' ride",
                        "St Andrews College",
                        "South Coolum Rd near Green Oaks Dr",
                        "Learg St near Magenta Dr hail 'n' ride",
                        "Centenary Heights Rd near Halley Ct hail 'n' ride",
                        "Centenary Heights Rd near Yungar St hail 'n' ride",
                        "David Low Way at Coolum Beach",
                        "Coolum High School",
                        "Yandina Coolum Rd near Greenoaks Dr hail 'n' ride",
                        "Learg St near South Coolum Rd hail 'n' ride",
                        "Ridges Bvd at Mallee Street",
                        "Ridges Bvd at Kurrajong Circuit",
                        "Ridges Bvd at Peregian Springs State School",
                        "160 Beddington Rd hail 'n' ride",
                        "Wattlebird Dr near Whipbird Pl hail 'n' ride",
                        "Lenehans Lane near Livistona Dr hail 'n' ride",
                        "Swanbourne Way near Beckmans Rd hail 'n' ride",
                        "Shire Dr near Sea Eagle Dr hail 'n' ride",
                        "Furness Dr near Troon Ct hail 'n' ride",
                        "Furness Dr near Portrush Ct",
                        "Furness Dr near Blackheath Dr",
                        "Furness Dr near Felsted Ct",
                        "Fairway Dr near Thompson Cr",
                        "Tewantin Noosa Golf Club",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Poinciana Ave at Poinciana Place"
                    ],
                    "5853: Noosaville (Goodchap St) - Pacific Paradise SS": [
                        "Eumundi Rd at Goodchap Street",
                        "Hilton Tce at Tewantin Noosa Bowls Club",
                        "Hilton Tce at Noosa Convention Centre",
                        "Poinciana Ave at Ward Park",
                        "Poinciana Ave at Tewantin Primary School",
                        "Butler St at Noosa Crematorium",
                        "Cooroy Noosa Rd at Ross Court",
                        "Tewantin Noosa Golf Club",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Sea Eagle Drive at Noosaville State School",
                        "Laguna Grove Park hail 'n' ride",
                        "Memorial Dr at Eumundi Markets",
                        "Memorial Dr at Eumundi Aquatic Centre",
                        "493 Bunya Rd hail 'n' ride",
                        "Bunya Rd near Gold Creek Rd hail 'n' ride",
                        "Bunya Rd near Monak Rd hail 'n' ride",
                        "North Arm State School",
                        "North Arm Yandina Creek Rd near Bunya Rd HnR",
                        "Bunya Rd near Lees Rd hail 'n' ride",
                        "Yandina Primary School Bus Bays",
                        "Pioneer Rd at The Ginger Factory",
                        "Fleming Street at School Road",
                        "Railway St at Yandina station",
                        "Old Bruce Hwy at Yandina Caravan Park",
                        "Nambour Connection Rd at Nambour Caravan Park",
                        "Nambour Connection Rd at Nambour Park",
                        "Nambour Connection Rd near City View Tce HnR",
                        "Francis Rd near Atkinson Rd hail 'n' ride",
                        "Parklakes Dr at Camp Flat Road",
                        "Parklakes Dr at Agnes Place",
                        "Parklakes Dr at Good Samaritan Catholic College",
                        "Thomas Rd at Samantha Dr",
                        "Thomas Rd at Bellevue St",
                        "School Rd at Bli Bli Primary school hail 'n' ride",
                        "Bli Bli Rd near Waigani St",
                        "Bli Bli Rd at Tasol Street",
                        "David Low Way at Bli Bli hail 'n' ride",
                        "David Low Way at Kowonga Street",
                        "David Low Way at Namba Street",
                        "Pacific Paradise State Primary School",
                        "David Low Way at Pacific Paradise Primary",
                        "David Low Way near Godfreys Rd hail 'n' ride",
                        "Bli Bli Rd near Tasol St",
                        "Bli Bli Rd near Kennedy Rd",
                        "Willis Rd at Lefoes Rd",
                        "Thomas Rd near Samantha Dr",
                        "Nambour Connection Rd near Boronia St",
                        "Nambour Connection Rd near Oleander Dr",
                        "Old Bruce Hwy near Ayrshire Rd",
                        "Farrell St near Stevens St",
                        "School Rd near Yandina State Primary School",
                        "Bunya Rd near Running Creek Rd hail 'n' ride",
                        "Bunya Rd near Shrub Rd hail 'n' ride",
                        "496 Bunya Rd hail 'n' ride",
                        "Hilton Tce at Earl Street"
                    ],
                    "5854: South Coolum - Coolum High": [
                        "Coolum State Primary School",
                        "Yandina Coolum Rd near Park Cr",
                        "Yungar St near Greenoaks Dr hail 'n' ride",
                        "Centenary Heights Rd near Yungar St hail 'n' ride",
                        "David Low Way at Coolum Beach",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Mt Peregian",
                        "Coolum High School",
                        "Yandina Coolum Rd near Greenoaks Dr hail 'n' ride"
                    ],
                    "5855: South Coolum - Sunshine Beach Primary": [
                        "Yandina Coolum Rd near Park Cr",
                        "Yungar St near Greenoaks Dr hail 'n' ride",
                        "Yungar St near Karlee Ct hail 'n' ride",
                        "Jenyor St near Bimini Dr hail 'n' ride",
                        "Yarrock St near South Coolum Rd hail 'n' ride",
                        "South Coolum Rd near Wandaa Ct",
                        "Toolga St near Warrack St",
                        "Jarnahill Dr near Quinn Ct",
                        "David Low Way at Mount Coolum",
                        "David Low Way at Tanah Street",
                        "David Low Way at Warran Road",
                        "David Low Way at Yaroomba Beach",
                        "David Low Way at Point Arkwright",
                        "David Low Way at Wilkinson Park",
                        "David Low Way at Coolum Beach",
                        "David Low Way at Coolum Hotel",
                        "David Low Way at Coolum Peregian Sports Complex",
                        "David Low Way at Mt Peregian",
                        "David Low Way at Coolum High School",
                        "David Low Way at Peregian South",
                        "David Low Way at Peregian Beach",
                        "David Low Way at Woodland Drive",
                        "David Low Way at Peregian Water Tower",
                        "Podargus Pde near Parakeet Cr hail 'n' ride",
                        "Podargus Pde near Wagtail Dr hail 'n' ride",
                        "Persimmon Dr near Lowry St hail 'n' ride",
                        "Persimmon Dr near Almond Ct hail 'n' ride",
                        "Mahogany Dr near Redwood Ave hail 'n' ride",
                        "Mahogany Dr near Hawthorn Gr hail 'n' ride",
                        "Mahogany Dr near Royena Pl hail 'n' ride",
                        "Wavecrest Dr near Tropicana Rise hail 'n' ride",
                        "Wavecrest Dr near Moonbeam Cr hail 'n' ride",
                        "Wavecrest Dr near Coconut Gr hail 'n' ride",
                        "David Low Way at Castaways Beach",
                        "David Low Way at Sunrise Beach",
                        "Dame Patti Dr near Columbus Ct hail 'n' ride",
                        "Ben Lexcen Dr near Grasstree Ct",
                        "Sunshine Beach High School",
                        "Ben Lexcen Dr near Lipton St",
                        "Dame Patti Dr near Southern Cross Pde",
                        "David Low Way at Castaways Creek",
                        "Mahogany Dr near Ashwood Ct hail 'n' ride",
                        "Podargus Pde near Spoonbill St hail 'n' ride",
                        "Podargus Pde near Bustard St hail 'n' ride",
                        "David Low Way near Goongilla St",
                        "David Low Way near Yaroomba Dr hail 'n' ride",
                        "Suncoast Beach Dr near Jarnahill Dr",
                        "Toolga St near Carrock Ct"
                    ],
                    "5856: Tinbeerwah - Sunshine Beach High": [
                        "Sunrise Rd near Gyndier Dr hail 'n' ride",
                        "Patterson Dr near Wilkes Ct hail 'n' ride",
                        "Kingsgate Dr near Jaggers Ct hail 'n' ride",
                        "Kingsgate Dr near Brookland Rd hail 'n' ride",
                        "Sunrise Rd near Smiths Rd hail 'n' ride",
                        "415 Sunrise Road hail 'n' ride",
                        "Duke Rd near Sunrise Rd hail 'n' ride",
                        "Duke Rd near Eagle Farm Cl hail 'n' ride",
                        "Duke Rd near Eumundi Noosa Rd hail 'n' ride",
                        "Beddington Rd near Eumundi Noosa Rd hail 'n' ride",
                        "160 Beddington Rd hail 'n' ride",
                        "Wattlebird Dr near Whipbird Pl hail 'n' ride",
                        "Lenehans Lane near Livistona Dr hail 'n' ride",
                        "Eumarella Rd near Tidswell Rd hail 'n' ride",
                        "Eumarella Rd near Paradise Dr hail 'n' ride",
                        "Paradise Dr near Eumarella Rd hail 'n' ride",
                        "Lake Weyba Dr near Lake View Ct hail 'n' ride",
                        "Charlotte Dr near Eumarella Rd hail 'n' ride",
                        "Sunshine Beach High School",
                        "Noosa Civic Shopping Centre",
                        "Wattlebird Dr near Lenehans Lane hail 'n' ride",
                        "Wattlebird Dr near Beddington Rd hail 'n' ride",
                        "Beddington Rd near Persoonia Lane hail 'n' ride",
                        "108 Duke Rd hail 'n' ride",
                        "Sunrise Rd near Wust Rd hail 'n' ride",
                        "391 Sunrise Road hail 'n' ride",
                        "Sunrise Rd near Wendoma Ct hail 'n' ride",
                        "Cooroy Noosa Rd at Sunrise Road"
                    ],
                    "5857: Tewantin (Carramar Str) - Sunshine Beach SHS": [
                        "Cooroy Noosa Rd at Carramar Noosa Homes",
                        "Cooroy Noosa Rd at Heritage Park",
                        "Griffith Ave at Palmer Crescent",
                        "Griffith Ave near Harlow Cr",
                        "Griffith Ave near Parkview Ct",
                        "Griffith Ave near Golf Course Dr",
                        "Golf Course Dr near Daintree Way",
                        "Golf Course Dr near Carramar St hail 'n' ride",
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Sea Eagle Drive at Noosaville State School",
                        "Shire Dr near Morinda Cct hail 'n' ride",
                        "Bushlands Dr near Satinwood St",
                        "Bushlands Dr at Rose Ash Crescent",
                        "Swanbourne Way near Beckmans Rd",
                        "Lake Entrance Bvd near Eumundi Noosa Rd hail 'n' ride",
                        "Lake Entrance Bvd near Casuarina Ct hail 'n' ride",
                        "Lake Entrance Bvd near Satinash St hail 'n' ride",
                        "Lake Entrance Bvd near Redgum Ct hail 'n' ride",
                        "Lake Entrance Bvd near Doolan Ct hail 'n' ride",
                        "Eumundi Rd at Rene Street",
                        "Eumundi Rd at Goodchap Street",
                        "Gibson Rd near Portside Ct",
                        "Shorehaven Dr near Oceanmist Ct hail 'n' ride",
                        "Shorehaven Dr near The Peninsula hail 'n' ride",
                        "Shorehaven Dr near Saltwater Ave hail 'n' ride",
                        "Shorehaven Dr near Waterside Ct hail 'n' ride",
                        "Weyba Rd near Anchor St",
                        "Lake Weyba Dr near Creek Rd",
                        "Lake Weyba Dr near Nannygai St",
                        "Weyba Rd near Swan St",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St",
                        "Myrtle Rd near Smoke Bush dr hail 'n' ride",
                        "Cooyar St near Elanora Tce",
                        "Noosa Junction station, stop A",
                        "Sunshine Beach Primary School",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Sunshine Beach High School",
                        "Cooyar St near Langura St",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Shorehaven Dr near The Anchorage hail 'n' ride",
                        "Shorehaven Dr near Shipwright Av hail 'n' ride",
                        "Swanbourne Way near Beckmans Rd hail 'n' ride",
                        "Shire Dr near Sea Eagle Dr hail 'n' ride",
                        "Griffith Ave near Club Ct",
                        "Griffith Ave near Cedarleigh Dr"
                    ],
                    "5858: Tewantin (Bougainvillia) - Sunshine Beach High": [
                        "Cooroy Noosa Rd at Bougainvillia Caravan Park",
                        "Fairway Dr near Thompson Cr hail 'n' ride",
                        "Furness Dr near Felsted Ct hail 'n' ride",
                        "Furness Dr near Blackheath Dr hail 'n' ride",
                        "Furness Dr near Portrush Ct hail 'n' ride",
                        "Furness Dr near Muirfield Cr hail 'n' ride",
                        "Saint Andrews Dr near Furness Dr",
                        "Outlook Dr at Clarey Road",
                        "Outlook Dr near Freeman Ct",
                        "Outlook Dr near Gooloi Ct",
                        "Outlook Dr near Buchanan Cr",
                        "Saint Andrews Dr near William St",
                        "Butler St at Noosa Crematorium",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Werin St at Crank Street",
                        "Werin St near George St hail 'n' ride",
                        "Moorindil St near George St",
                        "Moorindil St near Cobham St",
                        "Moorindil St near Read St",
                        "Moorindil St near Gympie St",
                        "Moorindil St near Toolar St",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Hilton Tce at Tewantin Noosa Bowls Club",
                        "Gympie Tce at James Duke Bridge",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Massoud Park",
                        "Weyba Rd at Pelican Beach Park",
                        "Noosa Pde at William Street",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Witta Circle",
                        "Noosa Heads station, platform 2",
                        "Noosa Dr at Hibiscus Avenue",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Ben Lexcen Dr near Sarena Ct",
                        "Sunshine Beach High School",
                        "Noosa Junction station, stop A",
                        "Noosa Heads station, platform 1",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Cooroy Noosa Rd at Ross Court",
                        "Saint Andrews Dr at William Street",
                        "Outlook Dr near Talara Ct",
                        "Furness Dr near Troon Ct hail 'n' ride",
                        "Furness Dr near Portrush Ct",
                        "Furness Dr near Blackheath Dr",
                        "Furness Dr near Felsted Ct",
                        "Fairway Dr near Thompson Cr",
                        "Tewantin Noosa Golf Club"
                    ],
                    "5859: Cooroibah - Sunshine Beach High": [
                        "Illoura Pl near Glenridge Dr hail 'n' ride",
                        "Illoura Pl near Greengate Rd hail 'n' ride",
                        "Woodhaven Way near Dela Ct hail 'n' ride",
                        "Woodhaven Way at Woodhaven Park hail 'n' ride",
                        "Illoura Pl near Jirrima Cres hail 'n' ride",
                        "Jirrima Cr near Amaroo Pl hail 'n' ride",
                        "Morning Glory Dr near Stanley St hail 'n' ride",
                        "Noosa Banks Dr near McKinnon Dr hail 'n' ride",
                        "McKinnon Dr near Yellowood Cl hail 'n' ride",
                        "Tewantin State School at Goodwin St hail 'n' ride",
                        "Poinciana Ave at Tewantin Primary School",
                        "Poinciana Ave at Ward Park",
                        "Hilton Tce at Earl Street",
                        "Goodchap St near Ridge St",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St at Heritage Dr",
                        "Walter Hay Dr at Selkirk Drive",
                        "Sunshine Beach High School",
                        "Hilton Tce at Noosa Convention Centre",
                        "Tewantin State School at Werin Rd hail 'n' ride",
                        "Lake Cooroibah Rd near Yatama Pl hail 'n' ride",
                        "Lake Cooroibah Rd near Amaroo Pl hail 'n' ride",
                        "10 Jirrima Cr hail 'n' ride",
                        "Woodhaven Way near Illoura Pl hail 'n' ride"
                    ],
                    "5860: Sunshine Beach - St Teresa's College": [
                        "Ben Lexcen Dr near Sarena Ct",
                        "Noosa Junction station, stop A",
                        "Sunshine Beach Rd at Noosa Plaza",
                        "Noosa Dr at Hibiscus Avenue",
                        "Noosa Heads station, platform 1",
                        "Noosa Pde at Witta Circle",
                        "Noosa Parade at Ravenwood Park",
                        "Noosa Pde at Quamby Place",
                        "Noosa Pde at Nancy Cato Park",
                        "Noosa Pde at William Street",
                        "Weyba Rd at Pelican Beach Park",
                        "Gympie Tce at Massoud Park",
                        "Gympie Tce at Ely Park",
                        "Gympie Tce at Quota Park",
                        "Gympie Tce at Lions Park",
                        "Gympie Tce at James Duke Bridge",
                        "Eumundi Rd at Goodchap Street",
                        "Goodchap St at Heritage Dr",
                        "Goodchap St at Noosa Hospital",
                        "Goodchap St near Ridge St",
                        "Hilton Tce at Noosa Convention Centre",
                        "Poinciana Ave at Ward Park",
                        "Poinciana Ave at Tewantin Primary School",
                        "Butler St at Noosa Crematorium",
                        "Cooroy Noosa Rd at Ross Court",
                        "Saint Andrews Dr at William Street",
                        "Saint Andrews Dr at Wattle Street",
                        "St Andrews Dr at Hibiscus Retirement Resort",
                        "Saint Andrews Dr near Furness Dr",
                        "Sea Eagle Drive at Noosaville State School",
                        "St Teresas Catholic College",
                        "Saint Andrews Dr near Linksland St hail 'n' ride",
                        "Saint Andrews Dr near Furness Dr hail 'n' ride",
                        "Saint Andrews Dr near William St",
                        "Hilton Tce at Earl Street",
                        "Noosa Heads station, platform 2",
                        "Sunshine Beach Primary School"
                    ],
                    "5861: Sunshine Beach - St Teresa's College": [
                        "Ben Lexcen Dr near Sarena Ct",
                        "Cooyar St near Langura St",
                        "Myrtle Rd near Smoke Bush dr hail 'n' ride",
                        "Leslie Dr near Noosa Springs Dr",
                        "Leslie Dr at Paul St",
                        "Weyba Rd at Pacific Noosa Resort",
                        "Weyba Rd near Swan St",
                        "Weyba Rd near Anchor St",
                        "Shorehaven Dr near The Anchorage hail 'n' ride",
                        "Shorehaven Dr near Saltwater Ave hail 'n' ride",
                        "Shorehaven Dr near Shipwright Av hail 'n' ride",
                        "Shorehaven Dr near Oceanmist Ct hail 'n' ride",
                        "Gibson Rd near Portside Ct",
                        "Eumundi Rd at Goodchap Street",
                        "Eumundi Rd at Rene Street",
                        "Sea Eagle Drive at Noosaville State School",
                        "St Teresas Catholic College",
                        "Shorehaven Dr near The Peninsula hail 'n' ride",
                        "Shorehaven Dr near Waterside Ct hail 'n' ride",
                        "Leslie Dr at Arkana Dr",
                        "Leslie Dr near Tarina St",
                        "Cooyar St near Elanora Tce",
                        "Sunshine Beach Primary School"
                    ],
                    "5862: Sunshine Beach - St Teresa's College": [
                        "Sunshine Beach High School",
                        "Pacific Ave near Wildflower St",
                        "Pacific Ave near Ferguson St",
                        "Pacific Ave near Edwards St",
                        "David Low Way at Sunshine Beach Primary",
                        "Cooyar St near Langura St",
                        "Walter Hay Dr at Selkirk Drive",
                        "Eumundi Rd at Rene Street",
                        "Sea Eagle Drive at Noosaville State School",
                        "St Teresas Catholic College",
                        "Cooyar St near Elanora Tce",
                        "Pacific Ave near Weyba St",
                        "Pacific Ave near Ferguson Ave",
                        "Pacific Ave near Elanda St"
                    ],
                    "6001: Veresdale, Gleneagle, Beaudesert": [
                        "Stoney Camp Rd near Brightwell St",
                        "Teviot Rd at Hives Rd",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Mount Lindesay Hwy near South St",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Woodhill State School",
                        "Veresdale Scrub State Primary School",
                        "Worip Dr near Glycine Ct hail 'n' ride",
                        "Malabar Rd near Veresdale Scrub Rd hail 'n' ride",
                        "Beaudesert State High School",
                        "Bromelton St at St Marys Catholic Primary School",
                        "Tina St at Beaudesert State Primary"
                    ],
                    "6002: Park Ridge, Flagstone College & Primary": [
                        "Granger Rd near Eastern Service Rd",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Janelle Ct hail 'n' ride",
                        "Andalusian Dr near Greenbank Rd hail 'n' ride",
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Braemer Rd near Teviot Rd hail 'n' ride",
                        "Mountain Ridge Rd near Teviot Rd hail 'n' ride",
                        "Grampian Rd near Chadwick Dr hail 'n' ride",
                        "Chadwick Dr near Flagstone Ct hail 'n' ride",
                        "Chadwick Dr in South Maclean hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Payne Rd near Teviot Rd hail 'n' ride",
                        "Payne Rd near Five Oak Green Ct hail 'n' ride",
                        "Five Oak Green Ct near Eastwood Ct hail 'n' ride",
                        "Marjorie Ct at Jimboomba hail 'n' ride",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary"
                    ],
                    "6003: Jimboomba, Gleneagle, Beaudesert": [
                        "Talinga Drive near Mount Lindesay Hwy",
                        "Park Ridge park 'n' ride stop A",
                        "Coronation Dr near MacAuley Dr hail 'n' ride",
                        "Middle Rd at Federation Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Wineglass Dr",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Mount Lindesay Hwy near BP Service Centre HnR",
                        "Granger Rd near Eastern Service Rd",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Norris Creek Rd near Chloe Dr hail 'n' ride",
                        "Chloe Dr near Gaynor Rd hail 'n' ride",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Stanley Ct at Crowson Lane",
                        "Service Rd at St Aldwyn Rd",
                        "Trace Rd at Wearing Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Honora St at Jimboomba Primary School",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Woodhill State School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Mount Lindesay Hwy near Walker Rd hail 'n' ride",
                        "Beaudesert State High School"
                    ],
                    "6004: Emmaus, Woodhill, Gleneagle, Beaudesert": [
                        "Stockleigh Rd near Mount Lindesay Hwy HnR",
                        "Stockleigh Rd near Evergreen Dr hail 'n' ride",
                        "Maryland St near Stockleigh Rd hail 'n' ride",
                        "Maryland St near Missouri St hail 'n' ride",
                        "Carrum Rd near Nash St hail 'n' ride",
                        "Abell Rd near Camp Cable Rd hail 'n' ride",
                        "Camp Cable Rd near Edelsten Rd hail 'n' ride",
                        "Amber Cr near Camp Cable Rd hail 'n' ride",
                        "Amber Cr near Edelsten Rd hail 'n' ride",
                        "Wynne Rd near Woodlands Crt hail 'n' ride",
                        "Davidson Rd near Minugh Rd hail 'n' ride",
                        "Marks Rd near McDonald Rd hail 'n' ride",
                        "Marks Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "Emmaus College Jimboomba",
                        "South St near Mary St hail 'n' ride",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Mount Lindesay Hwy at Woodhill School",
                        "Woodhill State School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Mount Lindesay Hwy near Walker Rd hail 'n' ride",
                        "Beaudesert State High School"
                    ],
                    "6005: Jimboomba, Woodhill Pmy, Beaudesert High": [
                        "Tamborine Street near Merlon Street hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "Mundoolun Rd near Green Ridge Rd",
                        "Peppertree Dr near Weatherly Dr hail 'n' ride",
                        "Peppertree Dr near Melaleuca Crt hail 'n' ride",
                        "Peppertree Dr near Myrtle Rd hail 'n' ride",
                        "Millstreem Rd near Hughes Rd hail 'n' ride",
                        "Jarrah Rd near Millstream Rd hail 'n' ride",
                        "Jarrah Rd near Razorback Rd hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Blackbutt Rd near Orion Rd hail 'n' ride",
                        "Turpentine Rd near White Beach Ct hail 'n' ride",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Mount Lindesay Hwy at Woodhill School",
                        "Woodhill State School",
                        "Mount Lindesay Hwy near Walker Rd hail 'n' ride",
                        "Gleneagle State School",
                        "Beaudesert State High School"
                    ],
                    "6006: Flagstone, Jimboomba, Emmaus, Beaudesert": [
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Coachwood Dr near River Oak Rd hail 'n' ride",
                        "Red Cedar Crt near Pink Alder Ct hail 'n' ride",
                        "Red Cedar Crs near Poinciana Dr hail 'n' ride",
                        "Silver Wattle Dr near River Oak Dr hail 'n' ride",
                        "River Oak Dr near Coachwood Dr hail 'n' ride",
                        "Coachwood Dr near Sandalwood Ct hail 'n' ride",
                        "Poinciana Dr at Flagstone State Primary",
                        "Glynton Rd near Cattle Camp Ct hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "South St near John St hail 'n' ride",
                        "Emmaus College Jimboomba",
                        "South St near Mary St hail 'n' ride",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Mount Lindesay Hwy at Woodhill School",
                        "Woodhill State School",
                        "Gleneagle State School",
                        "Beaudesert State High School"
                    ],
                    "6007: Jimboomba, Gleneagle, Beaudesert": [
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Greenbank Rd near Teviot Rd hail 'n' ride",
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Scott Lane near Aberdeen Rd hail 'n' ride",
                        "Teviot Rd at Clifton Dr",
                        "Pennine Dr near Mountain Ridge Rd hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Payne Rd near Five Oak Green Ct hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Saint Jude Cct near Cusack Lane hail 'n' ride",
                        "Saint Jude Cct near Gaillee Ct hail 'n' ride",
                        "Victoria St near Dianne Ct hail 'n' ride",
                        "Victoria Drive at Jimboomba hail 'n' ride",
                        "Phar Lap Crt near Saint Covet Crt hail 'n' ride",
                        "Candlebark Rd near Redwood Crl hail 'n' ride",
                        "Redwood Crl near Sugarwood Rd hail 'n' ride",
                        "Candlebark Rd near Glenlogan Ct hail 'n' ride",
                        "Henderson Rd near Candlebark Rd hail 'n' ride",
                        "Henderson Rd near Victoria Dr hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Woodhill State School",
                        "Gleneagle State School",
                        "Beaudesert State High School"
                    ],
                    "6008: Hills College, Jimboomba, Flagstone": [
                        "Granger Rd near Eastern Service Rd",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Carter Rd near Clancy Rd hail 'n' ride",
                        "Kings Way near Myall Tce hail 'n' ride",
                        "Kings Way near Chambers Flat Rd hail 'n' ride",
                        "Greenvale Rd near Daly St hail 'n' ride",
                        "Service Rd at St Aldwyn Rd",
                        "Trace Rd at Wearing Rd",
                        "Crest Rd near Coonan Rd hail 'n' ride",
                        "Vista Rd at South Maclean hail 'n' ride",
                        "Coonan Rd near Casurina Rd hail 'n' ride",
                        "Stockleigh Rd near Mount Lindesay Hwy HnR",
                        "Stockleigh Rd near Evergreen Dr hail 'n' ride",
                        "Maryland St near Stockleigh Rd hail 'n' ride",
                        "Maryland St near Missouri St hail 'n' ride",
                        "Maryland St near Camp Cable Rd hail 'n' ride",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Johanna St at Hills International College",
                        "Honora St at Jimboomba Primary School",
                        "Henderson Rd near Victoria Dr hail 'n' ride",
                        "Henderson Rd near Candlebark Rd hail 'n' ride",
                        "Victoria St near Dianne Ct hail 'n' ride",
                        "Victoria Drive at Jimboomba hail 'n' ride",
                        "Saint Jude Cct near Gaillee Ct hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Margaret Rd hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary"
                    ],
                    "6009: Emmaus, Hills, Jimboomba, Flagstone": [
                        "Talinga Drive near Mount Lindesay Hwy",
                        "Rosia Rd at Parklands Christian College",
                        "Sylvan Rd near Pollen Ct hail 'n' ride",
                        "Granger Rd near Mackunda Ct hail 'n' ride",
                        "Thylungra Rd near Merluna Rd hail 'n' ride",
                        "Thylungra Rd near Saxby Ct hail 'n' ride",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Teresa Dr near Chloe Dr hail 'n' ride",
                        "Chloe Dr near Gaynor Rd hail 'n' ride",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "South St near John St hail 'n' ride",
                        "Emmaus College Jimboomba",
                        "South St near Mary St hail 'n' ride",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Bamboo Dr near Mount Lindesay Hwy hail 'n' ride",
                        "Bamboo Dr near Apollo Ct hail 'n' ride",
                        "Bamboo Dr near Venus Ct hail 'n' ride",
                        "Ashwood Dr near Bamboo Dr hail 'n' ride",
                        "Ashwood Dr near Orbit Ct hail 'n' ride",
                        "Ashwood Dr near Cassia Ct hail 'n' ride",
                        "Ashwood Dr near Bluff Rd hail 'n' ride",
                        "Bluff Rd near Norfolk Dr hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Millstream Rd near Millwood Ct hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "Mundoolun Rd near Mona Dr hail 'n' ride",
                        "Johanna St at Hills International College",
                        "Honora St at Jimboomba Primary School",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Margaret Rd hail 'n' ride",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary"
                    ],
                    "6010: Emmaus, Hills, Jimboomba, Flagstone": [
                        "Stockleigh Rd near Mount Lindesay Hwy HnR",
                        "Carrum Rd near Nash St hail 'n' ride",
                        "Abell Rd near Camp Cable Rd hail 'n' ride",
                        "Camp Cable Rd near Edelsten Rd hail 'n' ride",
                        "Herriman Crt near Edelsten Rd hail 'n' ride",
                        "Amber Cr near Camp Cable Rd hail 'n' ride",
                        "Amber Cr near Edelsten Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Davidson Rd near Minugh Rd hail 'n' ride",
                        "Marks Rd near McDonald Rd hail 'n' ride",
                        "Marks Rd hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "Green Ridge Rd near Mundoolun Rd hail 'n' ride",
                        "Emmaus College Jimboomba",
                        "Tamborine St near Merton St hail 'n' ride",
                        "Johanna St at Hills International College",
                        "Honora St at Jimboomba Primary School",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Margaret Rd hail 'n' ride",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary"
                    ],
                    "6011: Jimboomba, Emmaus, Beaudesert High": [
                        "Dennis Rd near Millstream Rd hail 'n' ride",
                        "Dennis Rd near Allspice St hail 'n' ride",
                        "Dennis Rd near Heron Rd hail 'n' ride",
                        "Quail St near Lyrebird Rd hail 'n' ride",
                        "Quail St near Heron St hail 'n' ride",
                        "Barnes Rd near Trewin Rd hail 'n' ride",
                        "Blackbean St near Teak St hail 'n' ride",
                        "Millstream Rd near Bloodwood Ct hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Bluff Rd near Norfolk Dr hail 'n' ride",
                        "Ashwood Dr near Cassia Ct hail 'n' ride",
                        "Ashwood Dr near Bamboo Dr hail 'n' ride",
                        "Bamboo Dr near Venus Ct hail 'n' ride",
                        "Bamboo Dr near Saturn Ct hail 'n' ride",
                        "Bamboo Dr near Mount Lindesay Hwy hail 'n' ride",
                        "Bedelia Dr near Walton St hail 'n' ride",
                        "Woodhill State School",
                        "Cyrus Rd hail 'n' ride",
                        "Beaudesert State High School"
                    ],
                    "6012: Jimboomba, Woodhill Pmy, Beaudesert High": [
                        "Tamborine Street near Merlon Street hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "Mundoolun Rd near Green Ridge Rd",
                        "John Collins Dr near Scarborough Ct hail 'n' ride",
                        "Canterbury Dr near Randwick Dr hail 'n' ride",
                        "Collins Creek Rd near Canterbury Dr hail 'n' ride",
                        "Arabian Crt near Clydesdale Rd hail 'n' ride",
                        "Clydesdale Rd near Cremello Ct hail 'n' ride",
                        "Mundoolun Rd near Kurrajong Rd hail 'n' ride",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Millstreem Rd near Hughes Rd hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Woodhill State School",
                        "Veresdale Scrub State Primary School",
                        "Gleneagle State School",
                        "Beaudesert State High School"
                    ],
                    "6013: Parklands College, Park Ridge High & Pmy": [
                        "Pub Lane at Greenbank Shopping Centre",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Middle Rd near Crest Rd hail 'n' ride",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge park 'n' ride stop B",
                        "Rosia Rd at Parklands Christian College",
                        "Sylvan Rd near Pollen Ct hail 'n' ride",
                        "Granger Rd near Mackunda Ct hail 'n' ride",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Norris Creek Rd near Chloe Dr hail 'n' ride",
                        "Chloe Dr near Gaynor Rd hail 'n' ride",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Chambers Flat Rd near Eastern Service Rd HnR",
                        "Norris Creek Rd near Grevillea Rd hail 'n' ride",
                        "Norris Creek Rd near Greenwood Rd hail 'n' ride",
                        "Greenvale Rd near Daly St hail 'n' ride",
                        "Sungold Rd near Andrews Ct hail 'n' ride",
                        "Lakefield Ct near Flesser Rd hail 'n' ride",
                        "Hubner Rd near Park Ridge Rd hail 'n' ride",
                        "Park Ridge State High",
                        "Mt Lindesay Hwy at Park Ridge State School"
                    ],
                    "6014: Greenbank Pmy, Park Ridge High & Pmy": [
                        "Park Ridge park 'n' ride stop A",
                        "Middle Rd at Wineglass Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Coronation Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Tovey Rd near Macquarie St",
                        "Tovey Rd near Tasman Ct",
                        "Parklands Dr near Samantha St hail 'n' ride",
                        "Parklands Dr near Titan Ct",
                        "Short St near Whetton Ct",
                        "Short St near Moreton St",
                        "Crest Rd near Lennons Rd",
                        "Lennons Rd near Birdsville St",
                        "Carlton Rd near Middle Rd",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Kallioota St near Kamarga Ct",
                        "Birdsville St near Andrew Rd",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Kensington Dr near Regent Ct hail 'n' ride",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St",
                        "Greenbank State Primary School",
                        "Birdsville St near Kallioota St hail 'n' ride",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Mt Lindesay Hwy at Park Ridge State School"
                    ],
                    "6015: St Francis, Park Ridge High & Primary": [
                        "Rosia Rd at Parklands Christian College",
                        "Hubner Rd near Park Ridge Rd hail 'n' ride",
                        "Bumstead Rd near Clarke Rd",
                        "Julie St at Bumstead Road",
                        "Julie St at Brabham Park",
                        "St Francis College",
                        "Bumstead Rd at Wisdom Way",
                        "Bumstead Rd near Gow Crt hail 'n' ride",
                        "Park Ridge Rd near Jacaranda Dr hail 'n' ride",
                        "Park Ridge State High",
                        "Mt Lindesay Hwy at Park Ridge State School"
                    ],
                    "6016: Corymbia State School, Park Ridge State High Sch": [
                        "Corymbia State School",
                        "Park Ridge Rd at Mt Archer Rd",
                        "Chambers Flat Rd at Isla St",
                        "Mt Archer Rd near East Beaumont Bvd hail 'n' ride",
                        "Mt Archer Rd near Heath Tce hail 'n' ride",
                        "Park Ridge Rd near Jacaranda Dr hail 'n' ride",
                        "Park Ridge Rd at Lindenthal Rd",
                        "Park Ridge Rd at Tilleman Pde",
                        "Park Ridge State High"
                    ],
                    "6018: Yugumbir, Browns Plains, St Bernadines": [
                        "Abbey St near Archery St hail 'n' ride",
                        "Abbey St near Scribner Ave hail 'n' ride",
                        "Archery St near Abbey St hail 'n' ride",
                        "Archery St near Saracen Ct hail 'n' ride",
                        "Forestdale Dr near Lionheart St",
                        "Forestdale Dr near Sheriff St",
                        "Forestdale Dr near Nottingham Ct",
                        "Forestdale Dr near Johnson Rd",
                        "Peverell St near Newburn St",
                        "Peverell St near Clabon St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Cosway St hail 'n' ride",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Silvertop St near Hoop St",
                        "Silvertop St at Silvertop Park",
                        "Vansittart Rd near Estramina Rd",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Widewood Ct",
                        "Waller Rd near Lamberth Rd East",
                        "Waller Rd near Charlton Pl",
                        "Green Rd at Isle of Ely Drive",
                        "Bayliss Rd near Green Rd",
                        "Bayliss Rd near Heritage Bvd",
                        "Hawthorn St near Taylor St",
                        "Grier Dr near Montgomery Ct",
                        "Bayliss Rd near Grier Dr",
                        "Bayliss Rd near Volstead Rd",
                        "Bayliss Rd near Hawthorn St",
                        "Waller Rd near Lamberth Rd",
                        "Waller Rd near Renee St",
                        "Yugumbir Primary",
                        "Vansittart Rd near Volant St",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Vergulde Rd at St Bernadines Primary",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Browns Plains Rd at Forestglen Park",
                        "Waller Rd near Ammons St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Ivor St",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Rossmore St"
                    ],
                    "6019: Bumstead Rd, Corymbia State School": [
                        "Bumstead Rd near Judith St",
                        "Bumstead Rd at Wisdom Way",
                        "Bumstead Rd near Clarke Rd",
                        "Park Ridge Rd at Jacaranda Dr hail 'n' ride",
                        "Mt Archer Rd near Heath Tce hail 'n' ride",
                        "Mt Archer Rd near East Beaumont Bvd HnR",
                        "East Beaumont Rd near Chambers Ridge Bvd HnR",
                        "Park Ridge Rd at Mt Archer Rd hail 'n' ride",
                        "Corymbia State School"
                    ],
                    "6020: Park Ridge, Regents Park, Browns Plains": [
                        "Honora St at Jimboomba Primary School",
                        "Mount Lindesay Hwy near South St",
                        "Millstream Rd near Mount Lindsay Hwy hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "Mundoolun Rd near Mona Dr hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Amber Cr near Edelsten Rd hail 'n' ride",
                        "Amber Cr near Camp Cable Rd hail 'n' ride",
                        "Maryland St near Camp Cable Rd hail 'n' ride",
                        "Maryland St near Missouri St hail 'n' ride",
                        "Maryland St near Stockleigh Rd hail 'n' ride",
                        "Stockleigh Rd near Evergreen Dr hail 'n' ride",
                        "Stockleigh Rd near Mount Lindesay Hwy HnR",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Trace Road at Wearing Rd",
                        "Service Rd at St Aldwyn Rd",
                        "Stanley Ct at Crowson Lane",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Gaynor Rd near Chloe Dr hail 'n' ride",
                        "Teresa Dr near Bascombe Ct hail 'n' ride",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Granger Rd near Eastern Service Rd",
                        "Rosia Rd at Parklands Christian College",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Crest Rd near Lennons Rd",
                        "Short St near Moreton St",
                        "Short St near Whetton Ct",
                        "Short St near Parklands Dr",
                        "Short St near Kadlunga Ct",
                        "Fedrick St near Short St",
                        "Fedrick St at Tenielle Street",
                        "Fedrick St near Foxhall St",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Vergulde Rd at St Bernadines Primary",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary"
                    ],
                    "6022: Emmaus, Woodhill, Gleneagle, Beaudesert": [
                        "Spring Mountain Dr near Platypus Dr hail 'n' ride",
                        "Spring Mountain Dr near Dunnart Rd hail 'n' ride",
                        "Spring Mountain Dr near Tigercat Ct hail 'n' ride",
                        "Spring Mountain Dr near Raglan Rd hail 'n' ride",
                        "Spring Mountain Drv near New Beith Rd hail 'n' ride",
                        "New Beith Rd near Lyon Dr hail 'n' ride",
                        "New Beith Rd near Mc Taggart Rd HnR",
                        "32 Preston St",
                        "Red Gum Rd near Heysen Rd",
                        "Red Gum Rd near Whiteley Cct hail 'n' ride",
                        "Red Gum Rd near Boyd Rd",
                        "Red Gum Road near Laurina Dr hail 'n' ride",
                        "Red Gum Rd near Lyon Dr hail 'n' ride",
                        "Equestrian Dr near Hakea Rd hail 'n' ride",
                        "Equestrian Dr near Pub Lane",
                        "Pub Lane near East Sentinel Drive hail 'n' ride",
                        "Pub Lane at Greenbank Shopping Centre",
                        "Teviot Rd at Hives Rd",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "South St near John St hail 'n' ride",
                        "Emmaus College Jimboomba",
                        "Millstream Rd near Mount Lindsay Hwy hail 'n' ride",
                        "Millstreem Rd near Hughes Rd hail 'n' ride",
                        "Hughes Rd near Fleming Ct hail 'n' ride",
                        "Heritage Rd near Joy Pl hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Bluff Rd near Norfolk Dr hail 'n' ride",
                        "Norfolk Dr near Rose Gum Ct hail 'n' ride",
                        "Cedarvale Rd School Interchange",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Woodhill State School",
                        "Beaudesert State High School"
                    ],
                    "6024: Heathwood, Sunnybank, St Thomas More": [
                        "Stapylton Rd near Sanctuary Dr hail 'n' ride",
                        "Wadeville St at Wadeville West",
                        "Parkwood Dr North near Beech St",
                        "Parkwood Dr near Coolibah St",
                        "Parkwood Dr at Parkwood Drive South",
                        "Parkwood Dr near Juniper St",
                        "Stapylton Rd near Stradbroke St",
                        "Johnson Rd near Paradise Rd",
                        "Paradise Rd near Forestdale Dr",
                        "Forestdale Dr near Robin Ct hail 'n' ride",
                        "Forestdale Dr near Scabbard Ct hail 'n' ride",
                        "Abbey St near Archery St hail 'n' ride",
                        "Abbey St near Scribner Ave hail 'n' ride",
                        "Archery St near Abbey St hail 'n' ride",
                        "Archery St near Saracen Ct hail 'n' ride",
                        "Forestdale Dr near Lionheart St",
                        "Lincoln Green Dr near Persea St",
                        "Forestdale Dr near Sheriff St",
                        "Forestdale Dr near Nottingham Ct",
                        "Forestdale Dr near Johnson Rd",
                        "Peverell St near Newburn St",
                        "Peverell St near Clabon St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Cosway St hail 'n' ride",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Silvertop St near Hoop St",
                        "Silvertop St at Silvertop Park",
                        "Beaudesert Rd at Illaweena Street",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd at Benhiam Street",
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Turton St at Sunnybank High School",
                        "Turton St at St Thomas More College"
                    ],
                    "6025: Greenbank, Springfield Central, St August": [
                        "Pub Lane near Equestrian Dr hail 'n' ride",
                        "Equestrian Dr near Themeda Cl hail 'n' ride",
                        "Pub Lane near Dungaree Dr hail 'n' ride",
                        "Dungaree Dr near Settler Ct hail 'n' ride",
                        "Lyon Dr near Wallaby Way hail 'n' ride",
                        "Red Gum Rd near Boyd Rd hail 'n' ride",
                        "Red Gum Rd near Whiteley Cct hail 'n' ride",
                        "36 Preston St",
                        "New Beith Rd near Lyon Dr hail 'n' ride",
                        "Spring Mountain Dr near Raglan Rd hail 'n' ride",
                        "Spring Mountain Dr near Brushtail Dr hail 'n' ride",
                        "Spring Mountain Dr near Platypus Dr hail 'n' ride",
                        "Spring Mountain Dr near Tigercat Ct hail 'n' ride",
                        "Greenbank State Primary School",
                        "Ison Rd near Bombala Rd hail 'n' ride",
                        "Begley Rd near Attunga Rd hail 'n' ride",
                        "Attunga Rd near Coolac Ct hail 'n' ride",
                        "Honeyeater Dr near Kingfisher Rd hail 'n' ride",
                        "Lyndale Rd near Attunga Rd hail 'n' ride",
                        "Begley Rd near Pakenham Rd hail 'n' ride",
                        "Thompson Rd near Daniel Ct hail 'n' ride",
                        "Goodna Oxley Rd near Thompson Rd hail 'n' ride",
                        "The Springfield Anglican Senior College",
                        "The Springfield Anglican Primary College",
                        "St Augustines College"
                    ],
                    "6026: Forest Lake Schools & Colleges, Grand Ave": [
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Roseneath Rd near Bronte Pl",
                        "Wallum Dr near Cocoparra Cr",
                        "Wallum Dr near Watarrka Dr",
                        "Wallum Dr near Bournda Ct",
                        "Nottingham Rd near Algester Rd",
                        "Nottingham Rd at Lakewood",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Johnson Rd near Peverell St",
                        "Forestdale Dr near Nottingham Ct hail 'n' ride",
                        "Forestdale Dr near Lincoln Green Dr",
                        "Lincoln Green Dr near Persea St",
                        "Abbey St near Archery St hail 'n' ride",
                        "Abbey St near Scribner Ave hail 'n' ride",
                        "Archery St near Abbey St hail 'n' ride",
                        "Archery St near Saracen Ct hail 'n' ride",
                        "Forestdale Dr near Scabbard Ct hail 'n' ride",
                        "Forestdale Dr near Robin Ct",
                        "Paradise Rd near Forestdale Dr",
                        "Dickman Rd near Johnson Rd hail 'n' ride",
                        "Stapylton Rd near Stradbroke St",
                        "Stapylton Rd near Sanctuary Dr hail 'n' ride",
                        "Wadeville St at Wadeville West",
                        "Wadeville St Heathwood Rise",
                        "Forest Lake Bvd at Kensington Way",
                        "High St at Forest Lake High School",
                        "Forest Lake Shops",
                        "College Ave at St John's Anglican College",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "St John's Anglican College near Alpine Pl",
                        "Woogaroo St at Forest Lake Primary",
                        "Woogaroo St at Lochwood Ave",
                        "Grand Ave West near Centennial Way",
                        "Centennial Way at Grand Avenue State School"
                    ],
                    "6027: Flagstone Pmy, Park Ridge High & Pmy": [
                        "Honora St at Jimboomba Primary School",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Henderson Rd near Victoria Dr hail 'n' ride",
                        "Henderson Rd near Candlebark Rd hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Margaret Rd hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Bushman Dr near Homestead Dr hail 'n' ride",
                        "Bushman Dr near Shearer Ct hail 'n' ride",
                        "Bushman Dr near Drover Cct hail 'n' ride",
                        "Bushman Dr near Whittling Ct hail 'n' ride",
                        "Whittling Ct near Damper Ct hail 'n' ride",
                        "Teviot Rd near Blacksmith Ct hail 'n' ride",
                        "Blacksmith Ct near Bushman Dr hail 'n' ride",
                        "Bushman Dr near Blacksmith Ct hail 'n' ride",
                        "Drover Cr near Stockman Dr hail 'n' ride",
                        "Drover Cr near Jackeroo Ct hail 'n' ride",
                        "Coachwood Dr near River Oak Rd hail 'n' ride",
                        "Poinciana Dr at Flagstone State Primary",
                        "Baker Rd near Teviot Rd hail 'n' ride",
                        "Holyman Ct near Janet Ct hail 'n' ride",
                        "Holyman Ct near Derek Ct hail 'n' ride",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Hives Rd",
                        "389 Teviot Road",
                        "Everleigh Dr near Ivory Pkwy hail 'n' ride",
                        "Everleigh Dr near Kessels Bvd hail 'n' ride",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Middle Rd near Crest Rd hail 'n' ride",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High"
                    ],
                    "6028: Park Ridge, Regents Park, Browns Plains": [
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Scott Lane near Aberdeen Rd hail 'n' ride",
                        "Braemer Rd near Teviot Rd hail 'n' ride",
                        "Greenock Rd in South Maclean hail 'n' ride",
                        "Teviot Rd near Greenock Rd hail 'n' ride",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Hives Rd",
                        "Hives Rd near Lance Rd hail 'n' ride",
                        "Lance Rd near Koolena Rd hail 'n' ride",
                        "Lance Rd near Pub Lane hail 'n' ride",
                        "Pub Lane near Lance Rd hail 'n' ride",
                        "Pub Lane near Equestrian Dr hail 'n' ride",
                        "Horseshoe Ct near Farrer Ct",
                        "Horseshoe Ct near Equestrian Dr hail 'n' ride",
                        "Bradman Drive near Equestrian Drive hail 'n' ride",
                        "Equestrian Dr near Themeda Cl hail 'n' ride",
                        "Pub Lane at Greenbank Shopping Centre",
                        "Greenbank Rd near Teviot Rd hail 'n' ride",
                        "Andalusian Dr near Greenbank Rd hail 'n' ride",
                        "Crowson Lane near Shetland Ct hail 'n' ride",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Middle Rd near Crest Rd hail 'n' ride",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Park Ridge park 'n' ride stop A",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Lamberth Rd near Great Ct",
                        "Lamberth Rd near Regal Dr",
                        "Lamberth Rd at Bushland Drive",
                        "Lamberth Rd near Waller Rd",
                        "Waller Rd near Lamberth Rd",
                        "Waller Rd near Renee St",
                        "Waller Rd near Vansittart Rd",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Rossmore St",
                        "Vansittart Rd at Yugumbir Primary School"
                    ],
                    "6029: Browns Plains, Burrowes, St Francis": [
                        "Short St near Parklands Dr",
                        "Short St near Kadlunga Ct",
                        "Mackellar Dr near Jade Garden Dr hail 'n' ride",
                        "Maclean Dr near MacAuley Dr hail 'n' ride",
                        "MacAuley Dr near Mack Ct hail 'n' ride",
                        "Middle Rd at Federation Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Wineglass Dr",
                        "Silvertop St at Silvertop Park",
                        "Silvertop St near Hoop St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Cosway St hail 'n' ride",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Vansittart Rd near Estramina Rd",
                        "Vansittart Rd near Carina St hail 'n' ride",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary"
                    ],
                    "6030: Park Ridge, St Bernadines, Browns Plains": [
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Kensington Dr near Regent Ct hail 'n' ride",
                        "Kensington Dr near Hyde Ct hail 'n' ride",
                        "Granger Rd near Eastern Service Rd",
                        "Thylungra Rd near Merluna Rd hail 'n' ride",
                        "Merluna Rd near Durham Ct hail 'n' ride",
                        "Thylungra Rd near Saxby Ct hail 'n' ride",
                        "Thylungra Rd near Granger Rd hail 'n' ride",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Norris Creek Rd near Chloe Dr hail 'n' ride",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Western Service Rd near Stoney Camp Rd HnR",
                        "Andrew Rd near Mount Lindesay Hwy",
                        "Andrew Rd near Banyulla St hail 'n' ride",
                        "Kallioota St near Kamarga Ct",
                        "Kallioota St near Birdsville St",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Crest Rd near Lennons Rd",
                        "Short St near Moreton St",
                        "Short St near Whetton Ct",
                        "Short St near Parklands Dr",
                        "Wilton Cr near Flinders Cr",
                        "Flinders Cr near Blaxland St hail 'n' ride",
                        "Flinders Cr near Bass St hail 'n' ride",
                        "Owens St near Baudin St hail 'n' ride",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd at Federation Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Wineglass Dr",
                        "Vergulde Rd at St Bernadines Primary",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Browns Plains Rd",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B",
                        "Beaudesert Rd at Illaweena Street",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Calamvale Community College"
                    ],
                    "6032: Woodhill, Gleneagle, Beaudesert": [
                        "Tamborine St near Mt Lindesay Hwy hail 'n' ride",
                        "Tamborine Street near Merlon Street hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "Green Ridge Rd near Mundoolun Rd hail 'n' ride",
                        "South St near Mary St hail 'n' ride",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Bluff Rd near Norfolk Dr hail 'n' ride",
                        "Bluff Rd near Fern Tree Ct hail 'n' ride",
                        "Bluff Rd near Bunya Ct hail 'n' ride",
                        "Ashwood Dr near Cassia Ct hail 'n' ride",
                        "Ashwood Dr near Bamboo Dr hail 'n' ride",
                        "Bamboo Dr near Silverleigh Ct hail 'n' ride",
                        "Bamboo Dr near Summerhill Pl hail 'n' ride",
                        "Bamboo Dr near Oakleigh Ct hail 'n' ride",
                        "Bamboo Dr near Venus Ct hail 'n' ride",
                        "Bamboo Dr near Saturn Ct hail 'n' ride",
                        "Woodhill State School",
                        "Gleneagle State School",
                        "Beaudesert State High School",
                        "Bromelton St at St Marys Catholic Primary School",
                        "Tina St at Beaudesert State Primary"
                    ],
                    "6033: Browns Plains, Canterbury College": [
                        "Talinga Drive near Mount Lindesay Hwy",
                        "Park Ridge park 'n' ride stop A",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Lamberth Rd near Great Ct",
                        "Lamberth Rd near Regal Dr",
                        "Lamberth Rd at Leis Way",
                        "Lamberth Rd at Bushland Drive",
                        "Lamberth Rd near Waller Rd",
                        "Waller Rd near Renee St",
                        "Waller Rd near Vansittart Rd",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Browns Plains Rd",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Browns Plains Rd at Forestglen Park",
                        "Browns Plains Rd at Oakdale Park",
                        "Logan Metro Sports Complex",
                        "Browns Plains Rd at Magnesium Drive",
                        "Browns Plains Rd at Fifth Avenue",
                        "Browns Plains Rd at Third Avenue",
                        "Browns Plains Rd at Second Avenue",
                        "Augusta St at Crestmead Park",
                        "Augusta St at Crestmead Primary School",
                        "Augusta St at Trulson Drive",
                        "Augusta St at Pinnington Park",
                        "Julie St at Wallace Street",
                        "Julie St at Brabham Park",
                        "Waratah Dr at Ramin Street",
                        "Waratah Dr at Myall Street",
                        "Waratah Dr at Forestwood Street",
                        "Waratah Dr at Whiteman Street",
                        "Chambers Flat Rd at Marsden High School",
                        "Marsden High School",
                        "Muchow Rd near Moffatt Rd",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd at Clearview Street",
                        "Kingston Rd at Waterford West Primary",
                        "Kingston Rd at Waterford West Shops",
                        "Waterford State Primary",
                        "Canterbury College"
                    ],
                    "6034: Cedar Vale, Flagstone College & Primary": [
                        "Stockleigh Rd near Mount Lindesay Hwy HnR",
                        "Carrum Rd near Nash St hail 'n' ride",
                        "Abell Rd near Camp Cable Rd hail 'n' ride",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Tamborine St near Mt Lindesay Hwy hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "Swan Rd at Jimboomba hail 'n' ride",
                        "Wynne Rd at near Swan Rd hail 'n' ride",
                        "Swan Rd near Tamborine St hail 'n' ride",
                        "Mundoolun Rd near Green Ridge Rd",
                        "John Collins Dr near Scarborough Ct hail 'n' ride",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Hughes Rd near Fleming Ct hail 'n' ride",
                        "Heritage Rd near Joy Pl hail 'n' ride",
                        "Dennis Rd near Millstream Rd hail 'n' ride",
                        "Dennis Rd near Allspice St hail 'n' ride",
                        "Dennis Rd near Heron Rd hail 'n' ride",
                        "Quail St near Lyrebird Rd hail 'n' ride",
                        "Quail St near Heron St hail 'n' ride",
                        "Barnes Rd near Trewin Rd hail 'n' ride",
                        "Millstream Rd near Bloodwood Ct hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Bluff Rd near Norfolk Dr hail 'n' ride",
                        "Norfolk Dr near Rose Gum Ct hail 'n' ride",
                        "Blackbutt Rd near Orion Rd hail 'n' ride",
                        "Turpentine Rd near White Beach Ct hail 'n' ride",
                        "Cedarvale Rd School Interchange",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "South St near John St hail 'n' ride",
                        "Emmaus College Jimboomba",
                        "Tamborine St near Merton St hail 'n' ride",
                        "Johanna St at Hills International College",
                        "Honora St at Jimboomba Primary School",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Margaret Road in Jimboomba hail 'n' ride",
                        "Glynton Rd near Cattle Camp Ct hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary"
                    ],
                    "6035: Park Ridge, Yugumbir, Boronia Heights": [
                        "Park Ridge park 'n' ride stop B",
                        "Park Ridge park 'n' ride stop A",
                        "Green Rd at Solandra Circuit",
                        "Green Rd at Sunrise Court",
                        "Green Rd at Isle of Ely Drive",
                        "Bayliss Rd near Green Rd",
                        "Bayliss Rd near Heritage Bvd",
                        "Browns Plains Rd near Campden St",
                        "Browns Plains Rd at Campden Street",
                        "Furzer St near Oakdale St",
                        "Furzer St near Ben St",
                        "Begonia St near Forestglen Cr",
                        "Begonia St near Woodview St",
                        "Ranchwood Ave near Highcrest Dr",
                        "Ranchwood Ave near Leonard St",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Browns Plains Rd at Forestglen Park",
                        "Waller Rd near Ammons St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Ivor St",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Rossmore St",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Volant St",
                        "Vansittart Rd near Estramina Rd",
                        "Vergulde Rd at St Bernadines Primary",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd near Emerald Dr",
                        "Fedrick St near Foxhall St",
                        "Fedrick St near Tenielle St",
                        "Fedrick St near Short St",
                        "Short St near Kadlunga Ct",
                        "Short St near Parklands Dr",
                        "Short St near Whetton Ct",
                        "Short St near Moreton St",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Mackellar Dr near Rick Ct",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Flinders Cr near MacQuarie St hail 'n' ride",
                        "Tovey Rd near Tasman Ct",
                        "Parklands Dr near Titan Ct",
                        "Mt Lindesay Hwy at Park Ridge State School"
                    ],
                    "6036: MacGregor High, Clairvaux Mackillop": [
                        "Brisbane St near Mount Lindesay Hwy",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Mount Lindesay Hwy near Greenbank Rd hail 'n' ride",
                        "Andalusian Dr near Greenbank Rd hail 'n' ride",
                        "Greenhill Rd near Crowson Lane hail 'n' ride",
                        "Greenhill Rd near Madison Ct hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Deborah Ct hail 'n' ride",
                        "Andall Rd near Carbeen Rd hail 'n' ride",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Granger Rd near Eastern Service Rd",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Browns Plains Rd",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B",
                        "Logan Rd at Palmdale, stop 79c",
                        "Klumpp Rd at Klumpp-Dawson"
                    ],
                    "6037: Grand Plaza, Sunnybank High, St Thomas": [
                        "Green Rd at Isle of Ely Drive",
                        "Green Rd at Solandra Circuit",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Browns Plains Rd",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B",
                        "Beaudesert Rd at Illaweena Street",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd at Benhiam Street",
                        "Calam Rd near Lear St",
                        "Calam Rd near Celadon St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd near Symons Rd",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Turton St near Mains Rd",
                        "Turton St near Boorman St",
                        "Turton St at Sunnybank High School",
                        "Turton St near Gager St",
                        "Turton St at Oasis",
                        "Turton St near Station Rd",
                        "Turton St near Mitchell St",
                        "Turton St at Sunnybank State School",
                        "Turton St at St Thomas More College"
                    ],
                    "6038: Grand Plaza, Runcorn High, MacGregor High": [
                        "Browns Plains station, stop 2B",
                        "Beaudesert Rd at Illaweena Street",
                        "Honeysuckle Way at Sunflower",
                        "Honeysuckle Way at Calamvale",
                        "Gowan Rd at The Parks",
                        "Gowan Rd near Kameruka St",
                        "Gowan Rd at Parkside",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd near Blackbean St",
                        "Gowan Rd near Coori Street, stop 74",
                        "Gowan Rd near Darnell Street, stop 73",
                        "Beenleigh Rd at Runcorn Railway, stop 72",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Hill Rd at Runcorn High School, zone C",
                        "Warrigal Rd at Runcorn North",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Padstow Views",
                        "Padstow Rd near Logan Rd",
                        "Logan Rd near Liverpool St, stop 81",
                        "Logan Rd at Marada Street, stop 79b",
                        "Logan Rd at Palmdale, stop 79c",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Springfield St at MacGregor High School"
                    ],
                    "6040: Flagstone, Jimboomba Primary": [
                        "Granger Rd near Eastern Service Rd",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St hail 'n' ride",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Koolena Rd near Teviot Rd hail 'n' ride",
                        "Lance Rd near Koolena Rd hail 'n' ride",
                        "Hives Rd near Lance Rd hail 'n' ride",
                        "Teviot Rd at Hives Rd",
                        "Philippa Rd near Willowbrook Rd hail 'n' ride",
                        "Clifton Dr near Teviot Rd hail 'n' ride",
                        "Clifton Dr at North Maclean hail 'n' ride",
                        "Teviot Rd at Clifton Dr",
                        "Greenock Rd in South Maclean hail 'n' ride",
                        "Teviot Rd near Greenock Rd hail 'n' ride",
                        "Pennine Dr near Mountain Ridge Rd hail 'n' ride",
                        "Pebble Creek Way near Mountain Ridge Rd HnR",
                        "Hann St near Saxby St hail 'n' ride",
                        "Bloomfield Esp near Pebble Creek Way hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Baker Rd near Teviot Rd hail 'n' ride",
                        "Baker Rd near Amanda Ct hail 'n' ride",
                        "Holyman Ct near Janet Ct hail 'n' ride",
                        "Holyman Ct near Derek Ct hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Honora St at Jimboomba Primary School"
                    ],
                    "6041: Mundoolun, Emmaus, Jimboomba Pmy": [
                        "Tamborine St near Mt Lindesay Hwy hail 'n' ride",
                        "Tamborine Street near Merlon Street hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "Mundoolun Rd near Green Ridge Rd",
                        "Collins Creek Rd near Canterbury Dr hail 'n' ride",
                        "Randwick Dr near Rosehill Ct hail 'n' ride",
                        "Canterbury Dr near Randwick Dr hail 'n' ride",
                        "John Collins Dr near Scarborough Ct hail 'n' ride",
                        "Peppertree Dr near Weatherly Dr hail 'n' ride",
                        "Bottlebrush Dr near Panitz Dr hail 'n' ride",
                        "Peppertree Dr near Melaleuca Crt hail 'n' ride",
                        "Peppertree Dr near Myrtle Rd hail 'n' ride",
                        "Jarrah Rd near Millstream Rd hail 'n' ride",
                        "Jarrah Rd near Razorback Rd hail 'n' ride",
                        "Coolibah Rd near Jarrah Rd hail 'n' ride",
                        "Coolibah Rd at Jimboomba hail 'n' ride",
                        "Blackbean St near Teak St hail 'n' ride",
                        "Millstream Rd near Bloodwood Ct hail 'n' ride",
                        "Millstream Rd near Banksia Ct hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Cedarvale Rd School Interchange",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "South St near John St hail 'n' ride",
                        "Emmaus College Jimboomba",
                        "Tamborine St near Merton St hail 'n' ride",
                        "Honora St at Jimboomba Primary School"
                    ],
                    "6042: Munruben, Boronia Heights, Park Ridge": [
                        "Granger Rd near Eastern Service Rd",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Teresa Dr near Chloe Dr hail 'n' ride",
                        "Chloe Dr near Gaynor Rd hail 'n' ride",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Stanley Ct at Crowson Lane",
                        "Greenhill Rd near Crowson Lane hail 'n' ride",
                        "Greenhill Rd near Madison Ct hail 'n' ride",
                        "Kensington Dr near Regent Ct hail 'n' ride",
                        "Kensington Dr near Hyde Ct hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Deborah Ct hail 'n' ride",
                        "Andall Rd near Carbeen Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Western Service Rd near Stoney Camp Rd HnR",
                        "Andrew Rd near Mount Lindesay Hwy",
                        "Birdsville St near Andrew Rd",
                        "Birdsville St near Kallioota St hail 'n' ride",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Crest Rd near Lennons Rd",
                        "Short St near Moreton St",
                        "Short St near Whetton Ct",
                        "Short St near Parklands Dr",
                        "Wilton Cr near Flinders Cr",
                        "Flinders Cr near Blaxland St hail 'n' ride",
                        "Tovey Rd at Macquarie Street",
                        "Middle Rd near Tovey Rd",
                        "Middle Rd at Parklands Dr",
                        "Tovey Rd near Macquarie St",
                        "Tovey Rd near Tasman Ct",
                        "Parklands Dr near Samantha St hail 'n' ride",
                        "Parklands Dr near Titan Ct",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Rosia Rd at Parklands Christian College"
                    ],
                    "6043: Greenbank, Munruben, Logan Village SS": [
                        "Crest Rd at Boulia St",
                        "Kallioota St near Birdsville St hail 'n' ride",
                        "Kallioota St near Banyulla St hail 'n' ride",
                        "Andrew Rd near Mount Lindesay Hwy",
                        "Western Service Rd near Talinga Dr hail 'n' ride",
                        "Park Ridge park 'n' ride stop B",
                        "Hubner Rd near Park Ridge Rd hail 'n' ride",
                        "Hubner Rd near Rosia Rd hail 'n' ride",
                        "Eastern Service Rd near Rosia Rd hail 'n' ride",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Kensington Dr near Regent Ct hail 'n' ride",
                        "Kensington Dr near Hyde Ct hail 'n' ride",
                        "Hyde Ct hail 'n' ride",
                        "Greenhill Rd near Janelle Ct hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Gaynor Rd near Chloe Dr hail 'n' ride",
                        "Teresa Dr near Bascombe Ct hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Carter Rd near Clancy Rd hail 'n' ride",
                        "Kings Way near Myall Tce hail 'n' ride",
                        "Kings Way near Chambers Flat Rd hail 'n' ride",
                        "Kirk Rd near Kenny Rd hail 'n' ride",
                        "Anzac Ave near Towns Ave hail 'n' ride",
                        "Logan Village State School"
                    ],
                    "6044: Park Ridge, Hills, Jimboomba, Flagstone": [
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Estramina Rd",
                        "Middle Rd near Anzac Ave hail 'n' ride",
                        "Middle Rd at Wineglass Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Coronation Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Janelle Ct hail 'n' ride",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Johanna St at Hills International College",
                        "Honora St at Jimboomba Primary School",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Margaret Rd hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary"
                    ],
                    "6046: Greenbank, Sunnybank, Clairvaux": [
                        "Sheppards Dr at Greenbank Store hail 'n' ride",
                        "Middle Road near Sheppards Drive hail 'n' ride",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St hail 'n' ride",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Western Service Rd near Stoney Camp Rd HnR",
                        "Andrew Rd near Mount Lindesay Hwy",
                        "Andrew Rd at Baratt Dr",
                        "Andrew Rd near Banyulla St hail 'n' ride",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Middle Rd near Crest Rd hail 'n' ride",
                        "Middle Rd near Cunningham Dr hail 'n' ride",
                        "Middle Rd near Tovey Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle St at Boronia Heights State School",
                        "Middle Rd at Federation Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Wineglass Dr",
                        "Silvertop St near Anzac Av mapping stop",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Browns Plains station",
                        "Beaudesert Rd at Illaweena Street",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd at Benhiam Street",
                        "Calam Rd near Lear St",
                        "Calam Rd near Celadon St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd near Symons Rd",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Robertson",
                        "Kessels Rd at Grout Street, stop 2/58",
                        "Kessels Rd at MacGregor, stop 59",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42"
                    ],
                    "6047: Jimboomba, Park Ridge, St Laurences": [
                        "Brisbane St near Mount Lindesay Hwy",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Trace Road at Wearing Rd",
                        "Service Rd at St Aldwyn Rd",
                        "Greenhill Rd near Crowson Lane hail 'n' ride",
                        "Greenhill Rd near Madison Ct hail 'n' ride",
                        "Kensington Dr near Regent Ct hail 'n' ride",
                        "Kensington Dr near Hyde Ct hail 'n' ride",
                        "Granger Rd near Eastern Service Rd",
                        "Park Ridge park 'n' ride stop B",
                        "Mexicanus Dr near Peregrine St hail 'n' ride",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Beaudesert Rd at Illaweena Street",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd at Benhiam Street",
                        "Beaudesert Rd near Algester Rd, stop 21",
                        "Beaudesert Rd near Learoyd Rd, stop 75",
                        "Bradman St Stop 74",
                        "Beaudesert Rd at Durbell Street, stop 73",
                        "Beaudesert Rd near Paradise Rd, stop 72",
                        "Beaudesert Rd near Mannington Rd, stop 58/71",
                        "Beaudesert Rd at A & IICS, stop 55/56",
                        "Beaudesert Rd at Mortimer Road, stop 54",
                        "Beaudesert Rd at Acacia Market Place, stop 53",
                        "Beaudesert Rd at Kerry Rd, stop 52",
                        "Beaudesert Rd near Kerry Rd, stop 51/45",
                        "Beaudesert Rd near Boundary Rd, stop 44",
                        "Beaudesert Rd at Meadow Avenue, stop 43",
                        "Beaudesert Rd at Boyland Avenue, stop 42/41",
                        "Beaudesert Rd at Marshall Road, stop 40",
                        "Beaudesert Rd at Salisbury station",
                        "Beaudesert Rd at Moorooka South, stop 38",
                        "Beaudesert Rd at Muriel - Evans, stop 37",
                        "Beaudesert Rd at Fegan Drive, stop 36",
                        "Beaudesert Rd at Keats Street, stop 35",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Dora Street, stop 33",
                        "Beaudesert Rd at Moorvale, stop 32",
                        "Beaudesert Rd at Helles Street, stop 31",
                        "Beaudesert Rd at Colebrook - Wharton, stop 30",
                        "Beaudesert Rd at Stimpson Park, stop 29",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Ipswich Rd at School Road, stop 27",
                        "Ipswich Rd at Yeronga Park, stop 26",
                        "Ipswich Rd at Chardons Corner",
                        "Ipswich Rd at Venner - Waterton, stop 24",
                        "Ipswich Rd at Ekibin Road, stop 23",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Ipswich Rd at Annerley RSL, stop 21a",
                        "Annerley Rd at Portland Street, stop 21",
                        "Annerley Rd at Herbert Street, stop 20",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Carville Street, stop 20/19",
                        "Annerley Rd at Cemetery, stop 13/18",
                        "Gladstone Rd at Gair Park, stop 17",
                        "Gladstone Rd at Dutton Park, stop 16",
                        "Gladstone Rd at Pope Street, stop 15",
                        "Gladstone Rd at Wahcumba Street, stop 14",
                        "Gladstone Rd at Ampthill Street, stop 13",
                        "Gladstone Rd at Dornoch Terrace, stop 11",
                        "Gladstone Rd at Morris Street, stop 10",
                        "Dorchester St at Somerville House, stop 5",
                        "Stephens Rd at St Laurences College, stop 7"
                    ],
                    "6048: Regents Park, Park Ridge": [
                        "Johnson Rd near Peverell St",
                        "Forestdale Dr near Johnson Rd",
                        "Johnson Rd near Paradise Rd",
                        "Paradise Rd near Forestdale Dr",
                        "Forestdale Dr near Robin Ct hail 'n' ride",
                        "Forestdale Dr near Scabbard Ct hail 'n' ride",
                        "Abbey St near Archery St hail 'n' ride",
                        "Abbey St near Scribner Ave hail 'n' ride",
                        "Archery St near Abbey St hail 'n' ride",
                        "Archery St near Saracen Ct hail 'n' ride",
                        "Forestdale Dr near Lionheart St",
                        "Forestdale Dr near Sheriff St",
                        "Forestdale Dr near Nottingham Ct",
                        "Peverell St near Newburn St",
                        "Peverell St near Clabon St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Cosway St hail 'n' ride",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Silvertop St near Hoop St",
                        "Silvertop St at Silvertop Park",
                        "Vergulde Rd at St Bernadines Primary",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd near Emerald Dr",
                        "Fedrick St near Foxhall St",
                        "Fedrick St near Tenielle St",
                        "Fedrick St near Short St",
                        "Mackellar Dr near Rick Ct",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Mt Lindesay Hwy at Park Ridge State School"
                    ],
                    "6051: Kagaru, Jimboomba, Flagstone Primary": [
                        "Greenbank State Primary School",
                        "Middle Road near Sheppards Drive hail 'n' ride",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Gracelands Dr hail 'n' ride",
                        "Hives Rd near Teviot Rd",
                        "Hives Rd near Lance Rd hail 'n' ride",
                        "Lance Rd near Olson Rd hail 'n' ride",
                        "Olson Rd near Teviot Rd hail 'n' ride",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Coachwood Dr near River Oak Rd hail 'n' ride",
                        "Red Cedar Crt near Pink Alder Ct hail 'n' ride",
                        "Red Cedar Crs near Rose Almond St hail 'n' ride",
                        "Silver Wattle Dr near River Oak Dr hail 'n' ride",
                        "Silver Wattle Dr near Bunya Pine Ct hail 'n' ride",
                        "River Oak Dr near Coachwood Dr hail 'n' ride",
                        "Poinciana Dr at Flagstone State Primary",
                        "Poinciana Dr at Flagstone Schools",
                        "Homestead Dr at Gates Rd",
                        "Flagstonian Dr at Trailblazer Dr",
                        "St Bonaventure's College",
                        "Homestead Dr near Poinciana Dr hail 'n' ride",
                        "Bushman Dr near Homestead Dr hail 'n' ride",
                        "Bushman Dr near Shearer Ct hail 'n' ride",
                        "Bushman Dr near Drover Cct hail 'n' ride",
                        "Bushman Dr near Whittling Ct hail 'n' ride",
                        "Teviot Rd near Blacksmith Ct hail 'n' ride",
                        "Blacksmith Ct near Bushman Dr hail 'n' ride",
                        "Bushman Dr near Blacksmith Ct hail 'n' ride",
                        "Whittling Ct near Damper Ct hail 'n' ride",
                        "Drover Cr near Stockman Dr hail 'n' ride",
                        "Drover Cr near Jackeroo Ct hail 'n' ride",
                        "Poinciana Dr at Flagstone State College"
                    ],
                    "6052: Park Ridge, Marsden High, Canterbury": [
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Nottingham Rd near Algester Rd",
                        "Nottingham Rd at Avondale",
                        "Nottingham Rd at Lakewood",
                        "Trinity Way at Mirthwood Drive",
                        "Trinity Way at Westcott St",
                        "MacQuarie Way at Lockyer Place",
                        "MacQuarie Way near Buckley Drive",
                        "MacQuarie Way near Wembley Rd",
                        "Browns Plains Rd at Campden Street",
                        "Logan Metro Sports Complex",
                        "Browns Plains Rd at Magnesium Drive",
                        "Browns Plains Rd at Fifth Avenue",
                        "Browns Plains Rd at Third Avenue",
                        "Browns Plains Rd at Second Avenue",
                        "Browns Plains Rd at Pedder Street",
                        "Browns Plains Rd at Emerald Street",
                        "Browns Plains Rd at Birch Street",
                        "Browns Plains Rd at Blue Gum Drive",
                        "Browns Plains Rd at Havenbah Park",
                        "Muchow Rd near Moffatt Rd",
                        "Muchow Rd at Carnation Street",
                        "Muchow Rd at Clearview Street",
                        "Kingston Rd at Waterford West Primary",
                        "Kingston Rd at Waterford West Shops",
                        "Waterford State Primary",
                        "Canterbury College"
                    ],
                    "6053: Berrinba, Parkinson, Stretton Colleges": [
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Trinity Way at Mirthwood Drive",
                        "Trinity Way at Westcott St",
                        "MacQuarie Way at Lockyer Place",
                        "MacQuarie Way near Buckley Drive",
                        "MacQuarie Way near Buckley Dr",
                        "MacQuarie Way near Wembley Rd",
                        "Stretton College (Bus Bay)",
                        "Freshwater Dr near Anderson St",
                        "Aquatic Dr near Pebbles Ct",
                        "Gowan Rd at Stretton State College"
                    ],
                    "6055: Heritage Park, Grand Plaza, Park Ridge": [
                        "Green Rd at Blue Wren Place",
                        "Green Rd at Cockatoo Court",
                        "Green Rd near Heritage Bvd",
                        "Bayliss Rd near Green Rd",
                        "Bayliss Rd near Heritage Bvd",
                        "Lamberth Rd near Waller Rd",
                        "Lamberth Rd at Bushland Drive",
                        "Lamberth Rd at Leis Way",
                        "Lamberth Rd near Pinnacle Cl",
                        "Lamberth Rd near Great Ct",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Yancey St",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B",
                        "Silvertop St at Silvertop Park",
                        "Silvertop St near Hoop St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Middle Rd at Wineglass Dr",
                        "Middle Rd at Coronation Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Park Ridge park 'n' ride stop B",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Rosia Rd at Parklands Christian College"
                    ],
                    "6060: Regents Park, Forest Lake, Springfield": [
                        "Peverell St near Newburn St",
                        "Peverell St near Clabon St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Cosway St hail 'n' ride",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Silvertop St near Hoop St",
                        "Silvertop St at Silvertop Park",
                        "Middle Rd near Anzac Ave hail 'n' ride",
                        "Middle Rd at Wineglass Dr",
                        "Federation Dr near Eli Ct hail 'n' ride",
                        "Federation Drive near Murrumbidgee St HnR",
                        "Mackellar Dr near Rick Ct",
                        "Eugene St near Yvonne Dr",
                        "Barry St near Eugene St hail 'n' ride",
                        "Strathallen Dr near MacAuley Dr hail 'n' ride",
                        "Maclean Dr near MacKellar Dr hail 'n' ride",
                        "Mackellar Dr near Salkirk Dr hail 'n' ride",
                        "Mackellar Dr near Short St hail 'n' ride",
                        "Short St near Kadlunga Ct",
                        "Short St near Parklands Dr",
                        "Short St near Whetton Ct",
                        "Short St near Moreton St",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Park Ridge park 'n' ride stop B",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Eastern Service Rd near Rosia Rd hail 'n' ride",
                        "Thylungra Rd near Barrine Ct hail 'n' ride",
                        "Merluna Rd near Durham Ct hail 'n' ride",
                        "Granger Rd near Mackunda Ct hail 'n' ride",
                        "Granger Rd near Botany Ct hail 'n' ride",
                        "Chesterfield Rd near Granger Rd hail 'n' ride",
                        "Western Service Rd near Stoney Camp Rd HnR",
                        "Andrew Rd near Mount Lindesay Hwy",
                        "Birdsville St near Andrew Rd",
                        "Birdsville St near Kallioota St hail 'n' ride",
                        "Lennons Rd near Crest Rd hail 'n' ride"
                    ],
                    "6061: Jimboomba, Buccan, Trinity College": [
                        "Poinciana Dr at Flagstone State Primary",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Bushman Dr near Homestead Dr hail 'n' ride",
                        "Bushman Dr near Shearer Ct hail 'n' ride",
                        "Bushman Dr near Drover Cct hail 'n' ride",
                        "Drover Cr near Stockman Dr hail 'n' ride",
                        "Drover Cr near Jackeroo Ct hail 'n' ride",
                        "Glynton Rd near Cattle Camp Ct hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "John Collins Dr near Scarborough Ct hail 'n' ride",
                        "Mundoolun Rd near Kurrajong Rd hail 'n' ride",
                        "Mundoolun Rd near Mona Dr hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Edelsten Rd near Amber Cr hail 'n' ride",
                        "Edelstein Rd near Camp Cable Rd hail 'n' ride",
                        "Camp Cable Rd near Allans Creek hail 'n' ride",
                        "Logan Village State School",
                        "Waterford Tamborine Rd near Weaber Rd",
                        "Canterbury College",
                        "Logan River Rd near Alexandra St",
                        "Logan River Rd at Spanns Rd",
                        "Kokoda St at Trinity College"
                    ],
                    "6062: Greenbank, Springfield Central": [
                        "Pub Rd near Old Pub Rd hail 'n' ride",
                        "Pub Lane near Equestrian Dr hail 'n' ride",
                        "Pub Lane near Dungaree Dr hail 'n' ride",
                        "Pub Lane near Dungaree Dr",
                        "Pub Lane near New Beith Road",
                        "New Beith Rd near Lyon Dr hail 'n' ride",
                        "New Beith Rd near Mc Taggart Rd HnR",
                        "New Beith Rd near Preston Street HnR",
                        "Tall Timber Rd near Polebark Ct hail 'n' ride",
                        "Tall Timber Rd near Benchmill Rd hail 'n' ride",
                        "32 Preston St",
                        "Red Gum Rd near Heysen Rd",
                        "Red Gum Rd near Whiteley Cct hail 'n' ride",
                        "Red Gum Rd near Boyd Rd",
                        "Red Gum Road near Laurina Dr hail 'n' ride",
                        "Laurina Rd near Marshbird Dr hail 'n' ride",
                        "Marsh Bird Dr near Bradman St",
                        "Lyon Dr near Dungaree Dr hail 'n' ride",
                        "Dungaree Dr near Settler Ct hail 'n' ride",
                        "Argyle Rd near Citrine St hail 'n' ride",
                        "New Beith Rd near Citrine St",
                        "Greenbank State Primary School",
                        "Goodna Oxley Rd near Thompson Rd hail 'n' ride",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High"
                    ],
                    "6063: Greenbank, Springfield Central SHS": [
                        "Spring Mountain Dr near Raglan Rd hail 'n' ride",
                        "Spring Mountain Dr near Brushtail Dr hail 'n' ride",
                        "Spring Mountain Dr near Platypus Dr hail 'n' ride",
                        "Spring Mountain Dr near Dunnart Rd hail 'n' ride",
                        "Spinebill Dr near Echidna Ct hail 'n' ride",
                        "Silvereye Cr near Spinebill Dr hail 'n' ride",
                        "Silvereye Cr near Parrot St hail 'n' ride",
                        "Spinebill Dr near Bowerbird Cl hail 'n' ride",
                        "Spring Mountain Dr near Tigercat Ct hail 'n' ride",
                        "Spring Mountain Drv near New Beith Rd hail 'n' ride",
                        "Greenbank State Primary School",
                        "Ison Rd near Bombala Rd hail 'n' ride",
                        "197 Begley Road",
                        "Begley Rd near Pakenham Rd hail 'n' ride",
                        "Thompson Rd near Nufflield Rd",
                        "Thompson Rd near Klipspringer Ct hail 'n' ride",
                        "Thompson Rd near Lyndale Rd",
                        "Thompson Rd near Daniel Ct hail 'n' ride",
                        "Thompson Rd near Goodna Rd",
                        "Goodna Oxley Rd near Thompson Rd hail 'n' ride",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High"
                    ],
                    "6066: Browns Plains, Sunnybank, St Thomas More": [
                        "Park Ridge park 'n' ride stop A",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Beaudesert Rd at Illaweena Street",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd at Benhiam Street",
                        "Calam Rd near Lear St",
                        "Calam Rd near Celadon St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Turton St near Mains Rd",
                        "Turton St near Boorman St",
                        "Turton St at Sunnybank High School",
                        "Turton St near Gager St",
                        "Turton St at Oasis",
                        "Turton St near Station Rd",
                        "Turton St near Mitchell St",
                        "Turton St at Sunnybank State School",
                        "Turton St at St Thomas More College"
                    ],
                    "6068: Jimboomba, Everleigh SS": [
                        "Granger Rd near Eastern Service Rd",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Janelle Ct hail 'n' ride",
                        "Crowson Lane near Shetland Ct hail 'n' ride",
                        "Greenbank Rd near Willowbrook Rd hail 'n' ride",
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Braemer Rd near Teviot Rd hail 'n' ride",
                        "Pebble Creek Way near Mountain Ridge Rd HnR",
                        "Hann St near Saxby St hail 'n' ride",
                        "Bloomfield Esp near Pebble Creek Way hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Hives Rd",
                        "389 Teviot Road",
                        "Everleigh State School"
                    ],
                    "6101: Beaudesert, Gleneagle, Veresdale Scrub": [
                        "Tina St at Beaudesert State Primary",
                        "Brisbane St at Turbot Street",
                        "Beaudesert State High School",
                        "Mount Lindesay Hwy at Dick Westerman Park",
                        "Gleneagle State School",
                        "Malabar Rd near Veresdale Scrub Rd hail 'n' ride",
                        "Worip Dr near Glycine Ct hail 'n' ride",
                        "Veresdale Scrub State Primary School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Boorah Rd near Razorback Rd hail 'n' ride",
                        "Peppertree Dr near Boorah Rd hail 'n' ride",
                        "Egret Ct at Jimboomba hail 'n' ride",
                        "Millstream Rd near Millwood Ct hail 'n' ride",
                        "Millstream Rd near Mount Lindsay Hwy hail 'n' ride",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Margaret Rd hail 'n' ride",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd at Clifton Dr",
                        "Philippa Rd near Willowbrook Rd hail 'n' ride",
                        "Teviot Rd at Hives Rd",
                        "Pub Lane at Greenbank Shopping Centre"
                    ],
                    "6102: Flagstone, Jimboomba, Park Ridge": [
                        "St Bonaventure's College",
                        "Flagstonian Dr at Trailblazer Dr",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary",
                        "Homestead Dr near Poinciana Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Payne Rd near Five Oak Green Ct hail 'n' ride",
                        "Marjorie Ct at Jimboomba hail 'n' ride",
                        "Five Oak Green Ct near Eastwood Ct hail 'n' ride",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Mountain Ridge Rd near Teviot Rd hail 'n' ride",
                        "Grampian Rd near Chadwick Dr hail 'n' ride",
                        "Chadwick Dr near Flagstone Ct hail 'n' ride",
                        "Chadwick Dr in South Maclean hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Braemer Rd near Teviot Rd hail 'n' ride",
                        "Glasgow Rd near Wishaw Rd hail 'n' ride",
                        "Wishaw Rd at South Maclean hail 'n' ride",
                        "Aberdeen Rd near Braemar Rd hail 'n' ride",
                        "Dundee Rd near Aberdeen Rd hail 'n' ride",
                        "Dundee Rd at North Maclean hail 'n' ride",
                        "Aberdeen Rd near Dundee Rd hail 'n' ride",
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Greenbank Rd near Willowbrook Rd hail 'n' ride",
                        "Andalusian Dr near Greenbank Rd hail 'n' ride",
                        "Greenhill Rd near Crowson Lane hail 'n' ride",
                        "Greenhill Rd near Madison Ct hail 'n' ride",
                        "Greenhill Rd near Deborah Ct hail 'n' ride",
                        "Andall Rd near Carbeen Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Thylungra Rd near Barrine Ct hail 'n' ride",
                        "Granger Rd near Mackunda Ct hail 'n' ride",
                        "Sylvan Rd near Gardenia Ct hail 'n' ride",
                        "Sylvan Rd near Rosia Rd hail 'n' ride",
                        "Hubner Rd near Park Ridge Rd hail 'n' ride"
                    ],
                    "6103: Beaudesert, Gleneagle, Jimboomba": [
                        "Beaudesert State High School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Woodhill State School",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Trace Road at Wearing Rd",
                        "Wearing Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Service Rd at St Aldwyn Rd",
                        "Sharon St near Saint Aldwyn Rd hail 'n' ride",
                        "Saint Aldwyn Rd near Mount Lindesay Hwy HnR",
                        "Stanley Ct at Crowson Lane",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Gaynor Rd near Chloe Dr hail 'n' ride",
                        "Norris Creek Rd near Chloe Dr hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Granger Rd near Eastern Service Rd",
                        "Park Ridge park 'n' ride stop A",
                        "Coronation Dr near MacAuley Dr hail 'n' ride",
                        "Middle Rd at Federation Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Wineglass Dr",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Talinga Drive near Mount Lindesay Hwy"
                    ],
                    "6104: Beaudesert, Gleneagle, Woodhill, Emmaus": [
                        "Beaudesert State High School",
                        "Mount Lindesay Hwy at Dick Westerman Park",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Woodhill State School",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "South St near John St hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Davidson Rd near Minugh Rd hail 'n' ride",
                        "Marks Rd near McDonald Rd hail 'n' ride",
                        "Marks Rd hail 'n' ride",
                        "Wynne Rd near Woodlands Crt hail 'n' ride",
                        "Edelsten Rd near Amber Cr hail 'n' ride",
                        "Amber Cr near Edelsten Rd hail 'n' ride",
                        "Amber Cr near Camp Cable Rd hail 'n' ride",
                        "Abell Rd near Mellody Lane hail 'n' ride",
                        "Carrum Rd near Nash St hail 'n' ride",
                        "Maryland St near Missouri St hail 'n' ride",
                        "Maryland St near Stockleigh Rd hail 'n' ride",
                        "Stockleigh Rd near Evergreen Dr hail 'n' ride",
                        "Stockleigh Rd near Mount Lindesay Hwy HnR"
                    ],
                    "6105: Beaudesert, Cedar Vale, Jimboomba": [
                        "Beaudesert State High School",
                        "Mount Lindesay Hwy at Dick Westerman Park",
                        "Gleneagle State School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Woodhill State School",
                        "Blackbutt Rd near Orion Rd hail 'n' ride",
                        "Turpentine Rd near White Beach Ct hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Jarrah Rd near Millstream Rd hail 'n' ride",
                        "Jarrah Rd near Razorback Rd hail 'n' ride",
                        "Boorah Rd near Razorback Rd hail 'n' ride",
                        "Peppertree Dr near Boorah Rd hail 'n' ride",
                        "Peppertree Dr near Melaleuca Crt hail 'n' ride",
                        "Peppertree Dr near Mundoolun Rd hail 'n' ride",
                        "Mundoolun Rd near Kurrajong Rd hail 'n' ride",
                        "Mundoolun Rd near Mona Dr hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "Tamborine St near Merton St hail 'n' ride"
                    ],
                    "6106: Beaudesert, Emmaus, Jimboomba, Flagstone": [
                        "Beaudesert State High School",
                        "Mount Lindesay Hwy at Dick Westerman Park",
                        "Gleneagle State School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Margaret Road in Jimboomba hail 'n' ride",
                        "Glynton Rd near Cattle Camp Ct hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Coachwood Dr near River Oak Rd hail 'n' ride",
                        "Red Cedar Crt near Pink Alder Ct hail 'n' ride",
                        "Red Cedar Crs near Rose Almond St hail 'n' ride",
                        "Red Cedar Crs near Poinciana Dr hail 'n' ride",
                        "Silver Wattle Dr near River Oak Dr hail 'n' ride",
                        "River Oak Dr near Coachwood Dr hail 'n' ride",
                        "Coachwood Dr near Sandalwood Ct hail 'n' ride",
                        "Poinciana Dr at Flagstone State Primary",
                        "Bushman Dr near Homestead Dr hail 'n' ride",
                        "Bushman Dr near Shearer Ct hail 'n' ride",
                        "Drover Cr near Bushman Dr hail 'n' ride",
                        "Drover Cr near Jackeroo Ct hail 'n' ride",
                        "Drover Ct near Bushman Dr hail 'n' ride",
                        "Teviot Rd near Blacksmith Ct hail 'n' ride",
                        "Blacksmith Ct near Bushman Dr hail 'n' ride",
                        "Bushman Dr near Blacksmith Ct hail 'n' ride",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd near Greenock Rd hail 'n' ride"
                    ],
                    "6107: Beaudesert, Gleneagle, Jimboomba": [
                        "Beaudesert State High School",
                        "Mount Lindesay Hwy at Dick Westerman Park",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Woodhill State School",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Brisbane Rd near BP Truckstop hail 'n' ride",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Henderson Rd near Victoria Dr hail 'n' ride",
                        "Victoria St near Dianne Ct hail 'n' ride",
                        "Victoria Drive at Jimboomba hail 'n' ride",
                        "Phar Lap Crt near Saint Covet Crt hail 'n' ride",
                        "Candlebark Rd near Glenlogan Ct hail 'n' ride",
                        "Candlebark Rd near Redwood Crl hail 'n' ride",
                        "Redwood Crl near Sugarwood Rd hail 'n' ride",
                        "Henderson Rd near Candlebark Rd hail 'n' ride",
                        "Saint Jude Cct near Gaillee Ct hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Payne Rd near Five Oak Green Ct hail 'n' ride",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Pennine Dr near Mountain Ridge Rd hail 'n' ride",
                        "Teviot Rd at Clifton Dr",
                        "Scott Lane near Teviot Rd hail 'n' ride",
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Greenbank Rd near Willowbrook Rd hail 'n' ride",
                        "Greenbank Rd near Andalusian Dr hail 'n' ride",
                        "Greenbank Rd near Teviot Rd hail 'n' ride",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Middle Rd near Andrew Rd hail 'n' ride"
                    ],
                    "6108: Flagstone, Jimboomba, Hills, Munruben": [
                        "Poinciana Dr at Flagstone State Primary",
                        "Poinciana Dr at Flagstone State College",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Cusack Lane near Teviot Rd hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Johanna St at Hills International College",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Maryland St near Camp Cable Rd hail 'n' ride",
                        "Maryland St near Missouri St hail 'n' ride",
                        "Maryland St near Stockleigh Rd hail 'n' ride",
                        "Stockleigh Rd near Evergreen Dr hail 'n' ride",
                        "Stockleigh Rd near Mount Lindesay Hwy HnR",
                        "Crest Rd near Coonan Rd hail 'n' ride",
                        "Vista Rd at South Maclean hail 'n' ride",
                        "Coonan Rd near Casurina Rd hail 'n' ride",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Trace Road at Wearing Rd",
                        "Service Rd at St Aldwyn Rd",
                        "Chambers Flat Rd near Eastern Service Rd HnR",
                        "Greenvale Rd near Daly St hail 'n' ride",
                        "Kings Way near Myall Tce hail 'n' ride",
                        "Carter Rd near Kings Way hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Granger Rd near Eastern Service Rd"
                    ],
                    "6109: Flagstone, Jimboomba, Hills, Park Ridge": [
                        "Poinciana Dr at Flagstone State Primary",
                        "Poinciana Dr at Flagstone State College",
                        "Homestead Dr near Poinciana Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Glynton Rd near Cattle Camp Ct hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Saint Jude Cct near Gaillee Ct hail 'n' ride",
                        "Phar Lap Crt near Saint Covet Crt hail 'n' ride",
                        "Candlebark Rd near Glenlogan Ct hail 'n' ride",
                        "Henderson Rd near Candlebark Rd hail 'n' ride",
                        "Victoria Drive at Jimboomba hail 'n' ride",
                        "Henderson Rd near Victoria Dr hail 'n' ride",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Johanna St at Hills International College",
                        "Tamborine St near Mt Lindesay Hwy hail 'n' ride",
                        "Tamborine Street near Merlon Street hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "John St near Green Ridge Rd hail 'n' ride",
                        "Green Ridge Rd near John St hail 'n' ride",
                        "Mundoolun Rd near Mona Dr hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Davidson Rd near Minugh Rd hail 'n' ride",
                        "Marks Rd near McDonald Rd hail 'n' ride",
                        "Marks Rd hail 'n' ride",
                        "Amber Cr near Edelsten Rd hail 'n' ride",
                        "Amber Cr near Camp Cable Rd hail 'n' ride",
                        "Herriman Crt near Edelsten Rd hail 'n' ride",
                        "Abell Rd near Mellody Lane hail 'n' ride",
                        "Carrum Rd near Nash St hail 'n' ride",
                        "Stockleigh Rd near Mount Lindesay Hwy HnR",
                        "Mount Lindesay Hwy near Greenbank Rd hail 'n' ride",
                        "Mount Lindesay Hwy near St Aldwyn Rd hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Gaynor Rd near Chloe Dr hail 'n' ride",
                        "Teresa Dr near Bascombe Ct hail 'n' ride",
                        "Teresa Dr near Carter Rd hail 'n' ride",
                        "Thylungra Rd near Barrine Ct hail 'n' ride",
                        "Granger Rd near Mackunda Ct hail 'n' ride",
                        "Sylvan Rd near Gardenia Ct hail 'n' ride",
                        "Sylvan Rd near Rosia Rd hail 'n' ride",
                        "Talinga Drive near Mount Lindesay Hwy"
                    ],
                    "6110: Flagstone, Jimboomba, Hills Int, Emmaus": [
                        "Honora St at Jimboomba Primary School",
                        "South St near John St hail 'n' ride",
                        "Emmaus College Jimboomba",
                        "John St near Green Ridge Rd hail 'n' ride",
                        "Green Ridge Rd near John St hail 'n' ride",
                        "Mundoolun Rd near Mona Dr hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Davidson Rd near Minugh Rd hail 'n' ride",
                        "Marks Rd near McDonald Rd hail 'n' ride",
                        "Marks Rd hail 'n' ride",
                        "Edelsten Rd near Amber Cr hail 'n' ride",
                        "Amber Cr near Edelsten Rd hail 'n' ride",
                        "Amber Cr near Camp Cable Rd hail 'n' ride",
                        "Herriman Crt near Edelsten Rd hail 'n' ride",
                        "Edelstein Rd near Camp Cable Rd hail 'n' ride",
                        "Abell Rd near Mellody Lane hail 'n' ride",
                        "Carrum Rd near Nash St hail 'n' ride",
                        "Mount Lindesay Hwy near Stockleigh Rd"
                    ],
                    "6111: Flagstone": [
                        "Poinciana Dr at Flagstone State Primary",
                        "Poinciana Dr at Flagstone Schools",
                        "Homestead Dr at Gates Rd",
                        "Flagstonian Dr at Trailblazer Dr",
                        "Trailblazer Dr at Meeds Lane",
                        "Gateway Dr at Elizabeth Drive"
                    ],
                    "6112: Beaudesert High, Woodhill Pmy, Jimboomba": [
                        "Beaudesert State High School",
                        "Mount Lindesay Hwy at Dick Westerman Park",
                        "Gleneagle State School",
                        "Mount Lindesay Hwy at Gleneagle School",
                        "Veresdale Scrub State Primary School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Woodhill State School",
                        "Mount Lindesay Hwy at Woodhill School",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "Arabian Crt near Clydesdale Rd hail 'n' ride",
                        "John Collins Dr near Scarborough Ct hail 'n' ride",
                        "Canterbury Dr near Randwick Dr hail 'n' ride",
                        "Collins Creek Rd near Canterbury Dr hail 'n' ride",
                        "Mundoolun Rd near Kurrajong Rd hail 'n' ride",
                        "Mundoolun Rd near Mona Dr hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "Tamborine St near Merton St hail 'n' ride"
                    ],
                    "6113: Park Ridge, Parklands College, Greenbank": [
                        "Park Ridge State High",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Rosia Rd at Parklands Christian College",
                        "Rosia Rd near Virgil Rd hail 'n' ride",
                        "Flesser Rd near Greygum Rd hail 'n' ride",
                        "Lakefield Ct near Flesser Rd hail 'n' ride",
                        "Sungold Rd near Andrews Ct hail 'n' ride",
                        "Greenvale Rd near Daly St hail 'n' ride",
                        "Norris Creek Rd near Grevillea Rd hail 'n' ride",
                        "Norris Creek Rd near Greenwood Rd hail 'n' ride",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Gaynor Rd near Chloe Dr hail 'n' ride",
                        "Norris Creek Rd near Chloe Dr hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Thylungra Rd near Barrine Ct hail 'n' ride",
                        "Merluna Rd near Durham Ct hail 'n' ride",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Pub Lane at Greenbank Shopping Centre"
                    ],
                    "6114: Park Ridge, Greenbank, Boronia Heights": [
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Birdsville St near Andrew Rd",
                        "Andrew Rd near Banyulla St hail 'n' ride",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Greenbank State Primary School",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Kensington Dr near Regent Ct hail 'n' ride",
                        "Kensington Dr near Hyde Ct hail 'n' ride",
                        "Andrew Rd near Mount Lindesay Hwy",
                        "Kallioota St near Birdsville St hail 'n' ride",
                        "Kallioota St near Banyulla St hail 'n' ride",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Carlton Rd near Middle Rd",
                        "Crest Rd near Lennons Rd",
                        "Short St near Moreton St",
                        "Short St near Whetton Ct",
                        "Short St near Parklands Dr",
                        "Parklands Dr near Samantha St",
                        "Tovey Rd near Mitchell St",
                        "Tovey Rd at Macquarie Street",
                        "Middle Rd near Tovey Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle St at Boronia Heights State School",
                        "Mackellar Dr near Rick Ct",
                        "Short St near Kadlunga Ct",
                        "Crest Rd at Punter St",
                        "Park Ridge park 'n' ride stop B"
                    ],
                    "6115: Yugumbir, Browns Plains, Park Ridge": [
                        "Vergulde Rd at St Bernadines Primary",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Rossmore St",
                        "Waller Rd near Widewood Ct",
                        "Waller Rd near Lamberth Rd East",
                        "Waller Rd near Charlton Pl",
                        "Green Rd at Isle of Ely Drive",
                        "Bayliss Rd near Green Rd",
                        "Bayliss Rd near Heritage Bvd",
                        "Hawthorn St near Taylor St",
                        "Grier Dr near Montgomery Ct",
                        "Bayliss Rd near Grier Dr",
                        "Bayliss Rd near Volstead Rd",
                        "Bayliss Rd near Hawthorn St",
                        "Bayliss Rd at Heritage Boulevard Park",
                        "Green Rd at Solandra Circuit",
                        "Green Rd near Emerald Dr",
                        "Fedrick St near Foxhall St",
                        "Fedrick St near Tenielle St",
                        "Fedrick St near Short St",
                        "Short St near Kadlunga Ct",
                        "Short St near Parklands Dr",
                        "Short St near Whetton Ct",
                        "Short St near Moreton St",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Park Ridge park 'n' ride stop B",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Mount Lindesay Hwy near Talinga Dr hail 'n' ride",
                        "Bumstead Rd near Clarke Rd",
                        "Julie St at Bumstead Road",
                        "Julie St at Brabham Park",
                        "St Francis College",
                        "Park Ridge Rd near Jacaranda Dr hail 'n' ride",
                        "Hubner Rd near Park Ridge Rd hail 'n' ride",
                        "Hubner Rd near Rosia Rd hail 'n' ride",
                        "Sylvan Rd near Pollen Ct hail 'n' ride",
                        "Granger Rd near Mackunda Ct hail 'n' ride",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Pub Lane at Greenbank Shopping Centre"
                    ],
                    "6116: Park Ridge, Yugumbir, St Bernadines": [
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Mount Lindesay Hwy near Talinga Dr hail 'n' ride",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Crest Rd near Lennons Rd",
                        "Short St near Moreton St",
                        "Short St near Whetton Ct",
                        "Short St near Parklands Dr",
                        "Short St near Kadlunga Ct",
                        "Fedrick St near Short St",
                        "Fedrick St at Tenielle Street",
                        "Fedrick St near Foxhall St",
                        "Green Rd at Solandra Circuit",
                        "Green Rd at Sunrise Court",
                        "Waller Rd near Charlton Pl",
                        "Waller Rd near Lamberth Rd",
                        "Waller Rd near Renee St",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Volant St",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Vergulde Rd at St Bernadines Primary",
                        "Silvertop St at Silvertop Park",
                        "Silvertop St near Hoop St",
                        "Conifer St near Ponderosa St",
                        "Conifer St at Cosway St",
                        "Conifer St near Whitcomb St",
                        "Peverell St near Tarver St",
                        "Peverell St near Clabon St",
                        "Peverell St near Newburn St"
                    ],
                    "6117: Greenbank, Park Ridge, Boronia Heights": [
                        "Greenbank State Primary School",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Middle Rd near Crest Rd hail 'n' ride",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Short St near Moreton St",
                        "Short St near Whetton Ct",
                        "Short St near Parklands Dr",
                        "Short St near Kadlunga Ct",
                        "Mackellar Dr near Jade Garden Dr hail 'n' ride",
                        "Maclean Dr near MacAuley Dr hail 'n' ride",
                        "Eugene St near Yvonne Dr",
                        "Mackellar Dr near Rick Ct",
                        "Federation Drive near Murrumbidgee St HnR",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Coronation Rd"
                    ],
                    "6118: Yugumbir, Browns Plains, Forestdale": [
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Vergulde Rd at St Bernadines Primary",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Browns Plains Rd",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd at Wembley Road",
                        "Wembley Rd near Campden St",
                        "Campden St near Melbury St hail 'n' ride",
                        "Browns Plains Rd at Campden Street",
                        "Wembley Rd near Dunbar St hail 'n' ride",
                        "MacQuarie Way near Wembley Rd",
                        "MacQuarie Way near Buckley Dr",
                        "Brett Rd near Cooper Ct",
                        "Erin Dr near Adam St",
                        "Furzer St near Ben St",
                        "Begonia St near Forestglen Cr",
                        "Begonia St near Woodview St",
                        "Ranchwood Ave near Highcrest Dr",
                        "Ranchwood Ave near Leonard St",
                        "Browns Plains station, stop 2B",
                        "Silvertop St at Silvertop Park",
                        "Silvertop St near Hoop St",
                        "Conifer St near Ponderosa St",
                        "Conifer St at Cosway St",
                        "Conifer St near Whitcomb St",
                        "Peverell St near Tarver St",
                        "Peverell St near Clabon St",
                        "Peverell St near Newburn St",
                        "Forestdale Dr near Nottingham Ct hail 'n' ride",
                        "Forestdale Dr near Lincoln Green Dr",
                        "Abbey St near Archery St hail 'n' ride",
                        "Abbey St near Scribner Ave hail 'n' ride",
                        "Archery St near Abbey St hail 'n' ride",
                        "Archery St near Saracen Ct hail 'n' ride",
                        "Forestdale Dr near Scabbard Ct hail 'n' ride",
                        "Forestdale Dr near Robin Ct",
                        "Paradise Rd near Forestdale Dr",
                        "Dickman Rd near Johnson Rd hail 'n' ride"
                    ],
                    "6119: Corymbia State School, Bumstead Rd": [
                        "Corymbia State School",
                        "Mt Archer Rd near Heath Tce hail 'n' ride",
                        "Mt Archer Rd near East Beaumont Bvd HnR",
                        "East Beaumont Rd near Chambers Ridge Bvd HnR",
                        "Bumstead Rd near Judith St",
                        "Bumstead Rd at Wisdom Way",
                        "Bumstead Rd near Clarke Rd",
                        "Mercantile Dr near Clarke Rd hail 'n' ride"
                    ],
                    "6120: Browns Plains, Regents Park, Jimboomba": [
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Rossmore St",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Volant St",
                        "Letitia St at Vansittart Road",
                        "Dryade St near Clonmel St hail 'n' ride",
                        "Vergulde Rd at St Bernadines Primary",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd near Emerald Dr",
                        "Mount Lindesay Hwy at Greenbank Gardens",
                        "Mexicanus Dr near Peregrine St hail 'n' ride",
                        "Park Ridge State High",
                        "Park Ridge park 'n' ride stop B",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Mount Lindesay Hwy near Talinga Dr hail 'n' ride",
                        "Rosia Rd at Parklands Christian College",
                        "Eastern Service Rd near Rosia Rd hail 'n' ride",
                        "Granger Rd near Eastern Service Rd",
                        "Carter Rd near Eastern Service Rd hail 'n' ride",
                        "Teresa Dr near Chloe Dr hail 'n' ride",
                        "Chloe Dr near Gaynor Rd hail 'n' ride",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Stanley Ct at Crowson Lane",
                        "Service Rd at St Aldwyn Rd",
                        "Trace Rd at Wearing Rd",
                        "Stockleigh Rd near Mount Lindesay Hwy HnR",
                        "Stockleigh Rd near Evergreen Dr hail 'n' ride",
                        "Maryland St near Stockleigh Rd hail 'n' ride",
                        "Maryland St near Missouri St hail 'n' ride",
                        "Maryland St near Camp Cable Rd hail 'n' ride",
                        "Camp Cable Rd near Edelsten Rd hail 'n' ride",
                        "Amber Cr near Camp Cable Rd hail 'n' ride",
                        "Amber Cr near Edelsten Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Millstream Rd near Mount Lindsay Hwy hail 'n' ride",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Brisbane St near Mount Lindesay Hwy"
                    ],
                    "6121: Browns Plains, Regents Pk, Boronia Hghts": [
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Ivor St",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Volant St",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Vergulde Rd at St Bernadines Primary",
                        "Johnson Rd near Peverell St",
                        "Peverell St near Newburn St",
                        "Peverell St near Clabon St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Cosway St hail 'n' ride",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Silvertop St near Hoop St",
                        "Silvertop St at Silvertop Park",
                        "Silvertop St near Anzac Av mapping stop",
                        "Vansittart Rd near Estramina Rd",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd near Emerald Dr",
                        "Middle Rd near Anzac Ave hail 'n' ride",
                        "Middle Rd at Wineglass Dr",
                        "Federation Dr near Eli Ct hail 'n' ride",
                        "Federation Drive near Murrumbidgee St HnR",
                        "Eugene St near Barry St",
                        "Barry St near Eugene St hail 'n' ride",
                        "Strathallen Dr near MacAuley Dr hail 'n' ride",
                        "Maclean Dr near MacKellar Dr hail 'n' ride",
                        "Mackellar Dr near Salkirk Dr hail 'n' ride",
                        "Mackellar Dr near Short St hail 'n' ride",
                        "Cambridge St near Parklands Dr hail 'n' ride",
                        "Owens St near Baudin St hail 'n' ride",
                        "Flinders Cr near MacQuarie St hail 'n' ride",
                        "Wilton Cr near Flinders Cr",
                        "Wilton Cr near Parklands Dr",
                        "Short St near Whetton Ct",
                        "Short St near Moreton St"
                    ],
                    "6122: Gleneagle State School, Cedar Vale": [
                        "Gleneagle State School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Woodhill State School",
                        "Bedelia Dr near Walton St hail 'n' ride",
                        "Bamboo Dr near Mount Lindesay Hwy hail 'n' ride",
                        "Bamboo Dr near Apollo Ct hail 'n' ride",
                        "Bamboo Dr near Venus Ct hail 'n' ride",
                        "Bamboo Dr near Silverleigh Ct hail 'n' ride",
                        "Bamboo Dr near Summerhill Pl hail 'n' ride",
                        "Bamboo Dr near Oakleigh Ct hail 'n' ride",
                        "Ashwood Dr near Bamboo Dr hail 'n' ride",
                        "Ashwood Dr near Orbit Ct hail 'n' ride",
                        "Ashwood Dr near Cassia Ct hail 'n' ride",
                        "Ashwood Dr near Bluff Rd hail 'n' ride",
                        "Norfolk Dr near Rose Gum Ct hail 'n' ride",
                        "Blackbutt Rd near Orion Rd hail 'n' ride",
                        "Turpentine Rd near White Beach Ct hail 'n' ride",
                        "Bluff Rd near Norfolk Dr hail 'n' ride",
                        "Bluff Rd near Bunya Ct hail 'n' ride",
                        "Bluff Rd near Fern Tree Ct hail 'n' ride",
                        "Millstream Rd near Bloodwood Ct hail 'n' ride",
                        "Dennis Rd near Millstream Rd hail 'n' ride",
                        "Dennis Rd near Allspice St hail 'n' ride",
                        "Dennis Rd near Pinkwood St hail 'n' ride"
                    ],
                    "6123: Emmaus, Greenbank": [
                        "Emmaus College Jimboomba",
                        "South St near Mary St hail 'n' ride",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Henderson Rd near Victoria Dr hail 'n' ride",
                        "Victoria St near Dianne Ct hail 'n' ride",
                        "Victoria Drive at Jimboomba hail 'n' ride",
                        "Candlebark Rd near Glenlogan Ct hail 'n' ride",
                        "Henderson Rd near Candlebark Rd hail 'n' ride",
                        "Phar Lap Crt near Saint Covet Crt hail 'n' ride",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Mount Lindesay Hwy near Greenbank Rd hail 'n' ride",
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Teviot Rd at Hives Rd",
                        "Pub Rd near Old Pub Rd hail 'n' ride",
                        "Pub Lane near Equestrian Dr hail 'n' ride",
                        "Bradman Drive near Equestrian Drive hail 'n' ride",
                        "Red Gum Road near Laurina Dr",
                        "Red Gum Rd near Boyd Rd hail 'n' ride",
                        "Red Gum Rd near Whiteley Cct hail 'n' ride",
                        "36 Preston St",
                        "New Beith Rd near Lyon Dr hail 'n' ride",
                        "Spring Mountain Dr near Raglan Rd hail 'n' ride",
                        "Spring Mountain Dr near Brushtail Dr hail 'n' ride",
                        "Spring Mountain Dr near Platypus Dr hail 'n' ride",
                        "Spring Mountain Dr near Dunnart Rd hail 'n' ride",
                        "Spring Mountain Dr near Tigercat Ct hail 'n' ride",
                        "Spring Mountain Drv near New Beith Rd hail 'n' ride",
                        "Pub Lane near Dungaree Dr hail 'n' ride",
                        "Pub Lane near East Sentinel Drive hail 'n' ride",
                        "Pub Lane at Greenbank Shopping Centre"
                    ],
                    "6124: St Thomas More Sunnybank, Browns Plains": [
                        "Turton St at St Thomas More College",
                        "Troughton Rd at Banoon",
                        "McCullough St at Brooklands",
                        "Station Rd at Wen Place, stop 80",
                        "Station Rd at Oasis Gardens, stop 79",
                        "Gager St at Sunybank High School, zone D",
                        "Mains Rd at Altandi, stop 68",
                        "Pinelands",
                        "Pinelands Rd at Hellawell",
                        "Compton Rd near Beaudesert Rd",
                        "Beaudesert Rd at Benhiam Street",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Browns Plains station, stop 2B",
                        "Browns Plains station",
                        "Silvertop St at Silvertop Park",
                        "Silvertop St near Hoop St",
                        "Conifer St near Ponderosa St",
                        "Conifer St at Cosway St",
                        "Conifer St near Whitcomb St",
                        "Peverell St near Tarver St",
                        "Peverell St near Clabon St",
                        "Peverell St near Newburn St",
                        "Forestdale Dr near Johnson Rd",
                        "Forestdale Dr near Nottingham Ct hail 'n' ride",
                        "Forestdale Dr near Lincoln Green Dr",
                        "Lincoln Green Dr near Persea St",
                        "Abbey St near Archery St hail 'n' ride",
                        "Abbey St near Scribner Ave hail 'n' ride",
                        "Archery St near Abbey St hail 'n' ride",
                        "Archery St near Saracen Ct hail 'n' ride",
                        "Forestdale Dr near Scabbard Ct hail 'n' ride",
                        "Forestdale Dr near Robin Ct",
                        "Paradise Rd near Forestdale Dr",
                        "Stapylton Rd near Stradbroke St",
                        "Parkwood Dr near Juniper St",
                        "Parkwood Dr near Acacia St",
                        "Parkwood Dr near Coolibah St",
                        "Parkwood Dr North near Laurel St",
                        "Stapylton Rd near Wadeville St",
                        "Stapylton Rd near Sanctuary Dr hail 'n' ride"
                    ],
                    "6125: St Augustine, Springfield, Boronia Hghts": [
                        "St Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "The Springfield Anglican Primary College",
                        "Springfield Greenbank Art at Springfield College",
                        "The Springfield Anglican Senior College",
                        "Thompson Rd near Daniel Ct hail 'n' ride",
                        "Huntingdale Drive near Gazelle Court hail 'n' ride",
                        "Begley Rd near Attunga Rd hail 'n' ride",
                        "Attunga Rd near Coolac Ct hail 'n' ride",
                        "Honeyeater Dr near Kingfisher Rd hail 'n' ride",
                        "Ison Rd near Goodna Road hail 'n' ride",
                        "Greenbank State Primary School",
                        "New Beith Rd near Goodna Rd hail 'n' ride",
                        "New Beith Rd near Salston Rd hail 'n' ride",
                        "Spring Mountain Dr near Raglan Rd hail 'n' ride",
                        "Spring Mountain Dr near Brushtail Dr hail 'n' ride",
                        "Spring Mountain Dr near Platypus Dr hail 'n' ride",
                        "Spring Mountain Dr near Tigercat Ct hail 'n' ride",
                        "New Beith Rd near Lyon Dr hail 'n' ride",
                        "New Beith Rd near Mc Taggart Rd HnR",
                        "32 Preston St",
                        "Red Gum Rd near Heysen Rd",
                        "Red Gum Rd near Whiteley Cct hail 'n' ride",
                        "Red Gum Rd near Boyd Rd",
                        "Red Gum Road near Laurina Dr hail 'n' ride",
                        "Red Gum Rd near Lyon Dr hail 'n' ride",
                        "Lyon Dr near Dungaree Dr hail 'n' ride",
                        "Dungaree Dr near Settler Ct hail 'n' ride",
                        "Pub Lane near Dungaree Dr hail 'n' ride",
                        "Equestrian Dr near Maculata Ct hail 'n' ride",
                        "Equestrian Dr near Pub Lane",
                        "Pub Lane near East Sentinel Drive hail 'n' ride",
                        "Pub Lane at Greenbank Shopping Centre"
                    ],
                    "6126: Forest Lake, Forestdale, Browns Plains": [
                        "Centennial Way at Grand Avenue State School",
                        "Lochwood Ave at Woogaroo St",
                        "Lochwood Ave at Lochwood Broadwater",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "St John's Anglican College near Alpine Pl",
                        "Woogaroo St at Forest Lake Primary",
                        "College Ave at St John's Anglican College",
                        "Forest Lake Bvd at Forest Lake Shops",
                        "High St at Forest Lake High School",
                        "Forest Lake Bvd at Kensington Way",
                        "Stapylton Rd near Wadeville St",
                        "Stapylton Rd near Sanctuary Dr hail 'n' ride",
                        "Stapylton Rd near Stradbroke St",
                        "Dickman Rd near Loxley Ch",
                        "Dickman Rd near Johnson Rd hail 'n' ride",
                        "Paradise Rd near Forestdale Dr",
                        "Forestdale Dr near Robin Ct hail 'n' ride",
                        "Forestdale Dr near Scabbard Ct hail 'n' ride",
                        "Abbey St near Archery St hail 'n' ride",
                        "Archery St near Abbey St hail 'n' ride",
                        "Forestdale Dr near Lionheart St",
                        "Lincoln Green Dr near Persea St",
                        "Forestdale Dr near Sheriff St",
                        "Forestdale Dr near Johnson Rd",
                        "Browns Plains station, stop 2B",
                        "Nottingham Rd near Appleby St",
                        "Nottingham Rd at Avondale",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Parkinson, stop 90",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Algester Rd at Beaudesert Road Stop 76"
                    ],
                    "6127: Park Ridge, Flagstone Primary, Jimboomba": [
                        "Park Ridge State High",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Eastern Service Rd near Rosia Rd hail 'n' ride",
                        "Thylungra Rd near Barrine Ct hail 'n' ride",
                        "Merluna Rd near Durham Ct hail 'n' ride",
                        "Granger Rd near Mackunda Ct hail 'n' ride",
                        "Granger Rd near Botany Ct hail 'n' ride",
                        "Chesterfield Rd near Granger Rd hail 'n' ride",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St",
                        "Stoney Camp Rd near Brightwell St hail 'n' ride",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Everleigh Dr near Ivory Pkwy hail 'n' ride",
                        "Everleigh Dr near Kessels Bvd hail 'n' ride",
                        "Teviot Rd at Hives Rd",
                        "Teviot Rd at Clifton Dr",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Baker Rd near Teviot Rd hail 'n' ride",
                        "Holyman Ct near Janet Ct hail 'n' ride",
                        "Holyman Ct near Derek Ct hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Poinciana Dr at Flagstone State Primary",
                        "Homestead Dr near Poinciana Dr hail 'n' ride",
                        "Glynton Rd near Cattle Camp Ct hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Saint Jude Cct near Cusack Lane hail 'n' ride",
                        "Saint Jude Cct near Gaillee Ct hail 'n' ride",
                        "Henderson Rd near Victoria Dr hail 'n' ride",
                        "Honora St at Jimboomba Primary School"
                    ],
                    "6128: Browns Plains, Park Ridge, Maclean": [
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Browns Plains Rd",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B",
                        "Vansittart Rd near Estramina Rd",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Vergulde Rd at St Bernadines Primary",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd near Emerald Dr",
                        "Eastern Service Rd near Green Rd hail 'n' ride",
                        "Eastern Service Rd near Kantenna St hail 'n' ride",
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd near Middle Rd hail 'n' ride",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Greenbank Rd near Teviot Rd hail 'n' ride",
                        "Andalusian Dr near Greenbank Rd hail 'n' ride",
                        "Crowson Lane near Shetland Ct hail 'n' ride",
                        "Horseshoe Ct near Farrer Ct",
                        "Horseshoe Ct near Equestrian Dr hail 'n' ride",
                        "Bradman Drive near Equestrian Drive hail 'n' ride",
                        "Equestrian Dr near Themeda Cl hail 'n' ride",
                        "Pub Lane near East Sentinel Drive hail 'n' ride",
                        "Lance Rd near Koolena Rd hail 'n' ride",
                        "Hives Rd near Lance Rd hail 'n' ride",
                        "Teviot Rd at Hives Rd",
                        "Teviot Rd at Clifton Dr",
                        "Mountain Ridge Rd near Pennine Rd hail 'n' ride",
                        "Pennine Rd near Selkirk Dr hail 'n' ride",
                        "Braemer Rd near Teviot Rd hail 'n' ride",
                        "Aberdeen Rd near Dundee Rd hail 'n' ride",
                        "Scott Lane near Greenbank Rd hail 'n' ride"
                    ],
                    "6129: St Francis, Browns Plains, Greenbank": [
                        "St Francis College",
                        "Augusta St at Pinnington Park",
                        "Trulson Dr near Limerick Dr",
                        "Macarthy Rd at Kurilpa Street",
                        "Browns Plains Rd at Fifth Avenue",
                        "Browns Plains Rd at Magnesium Drive",
                        "Bayliss Rd near Grier Dr",
                        "Bayliss Rd near Volstead Rd",
                        "Bayliss Rd near Hawthorn St"
                    ],
                    "6130: Calamvale, Browns Plains, Park Ridge": [
                        "Calamvale Community College",
                        "Beaudesert Rd at Illaweena Street",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Browns Plains Rd at Forestglen Park",
                        "Waller Rd near Ammons St",
                        "Waller Rd near Yancey St",
                        "Ivor St at Browns Plains High School",
                        "Mayfair Dr at Browns Plains Primary",
                        "Waller Rd near Rossmore St",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Volant St",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Vergulde Rd at St Bernadines Primary",
                        "Middle Rd at Wineglass Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Coronation Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Birdsville St near Andrew Rd",
                        "Birdsville St near Kallioota St hail 'n' ride",
                        "Crest Rd at Punter St",
                        "Park Ridge State High"
                    ],
                    "6132: Beaudesert, Gleneagle, Jimboomba": [
                        "Beaudesert State High School",
                        "Gleneagle State School",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Woodhill State School",
                        "Bamboo Dr near Mount Lindesay Hwy hail 'n' ride",
                        "Bamboo Dr near Apollo Ct hail 'n' ride",
                        "Bamboo Dr near Silverleigh Ct hail 'n' ride",
                        "Bamboo Dr near Summerhill Pl hail 'n' ride",
                        "Bamboo Dr near Oakleigh Ct hail 'n' ride",
                        "Ashwood Dr near Bamboo Dr hail 'n' ride",
                        "Ashwood Dr near Orbit Ct hail 'n' ride",
                        "Ashwood Dr near Cassia Ct hail 'n' ride",
                        "Ashwood Dr near Bluff Rd hail 'n' ride",
                        "Bluff Rd near Fern Tree Ct hail 'n' ride",
                        "Bluff Rd near Bunya Ct hail 'n' ride",
                        "Bluff Rd near Norfolk Dr hail 'n' ride",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "South St near John St hail 'n' ride",
                        "John St near Green Ridge Rd hail 'n' ride",
                        "Green Ridge Rd near John St hail 'n' ride",
                        "Mundoolun Rd near Mona Dr hail 'n' ride",
                        "Jimboomba Mundoolin Rd near Swan Rd hail 'n' ride",
                        "Tamborine St near Merton St hail 'n' ride",
                        "Tamborine St near Mt Lindesay Hwy hail 'n' ride"
                    ],
                    "6133: Canterbury College, Marsden, Grand Plaza": [
                        "Canterbury College",
                        "Kingston Rd at Waterford West Primary",
                        "Muchow Rd near Clearview St",
                        "Muchow Rd at Carnation Street",
                        "Marsden High School",
                        "Browns Plains Rd at Havenbah Park",
                        "Browns Plains Rd at Blue Gum Drive",
                        "Browns Plains Rd at Birch Street",
                        "Browns Plains Rd at Emerald Street",
                        "Browns Plains Rd at Pedder Street",
                        "Browns Plains Rd at Second Avenue",
                        "Browns Plains Rd at Third Avenue",
                        "Browns Plains Rd at Fifth Avenue",
                        "Browns Plains Rd at Magnesium Drive",
                        "Browns Plains Rd near Bayliss Rd hail 'n' ride",
                        "Browns Plains Rd near Campden St",
                        "Browns Plains Rd at Campden Street",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Waller Rd near Ammons St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Rossmore St",
                        "Waller Rd near Widewood Ct",
                        "Waller Rd near Lamberth Rd East",
                        "Lamberth Rd near Waller Rd",
                        "Lamberth Rd at Bushland Drive",
                        "Lamberth Rd at Leis Way",
                        "Lamberth Rd near Pinnacle Cl",
                        "Lamberth Rd near Great Ct",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd"
                    ],
                    "6134: Flagstone, Cedar Vale, Jimboomba": [
                        "Emmaus College Jimboomba",
                        "South St near Mary St hail 'n' ride",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Johanna St at Hills International College",
                        "Tamborine St near Mt Lindesay Hwy hail 'n' ride",
                        "Tamborine Street near Merlon Street hail 'n' ride",
                        "Swan Rd at Jimboomba hail 'n' ride",
                        "Wynne Rd at near Swan Rd hail 'n' ride",
                        "Swan Rd near Tamborine St hail 'n' ride",
                        "Mundoolun Rd near Green Ridge Rd",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Millstreem Rd near Hughes Rd hail 'n' ride",
                        "Heritage Rd near Joy Pl hail 'n' ride",
                        "Jarrah Rd near Millstream Rd hail 'n' ride",
                        "Jarrah Rd near Razorback Rd hail 'n' ride",
                        "Coolibah Rd at Jimboomba hail 'n' ride",
                        "Boorah Rd near Razorback Rd hail 'n' ride",
                        "Peppertree Dr near Boorah Rd hail 'n' ride",
                        "Peppertree Dr near Melaleuca Crt hail 'n' ride",
                        "Bottlebrush Dr near Panitz Dr hail 'n' ride",
                        "Peppertree Dr near Mundoolun Rd hail 'n' ride",
                        "John Collins Dr near Scarborough Ct hail 'n' ride",
                        "Collins Creek Rd near Canterbury Dr hail 'n' ride",
                        "Randwick Dr near Rosehill Ct hail 'n' ride",
                        "Canterbury Dr near Randwick Dr hail 'n' ride"
                    ],
                    "6135: Park Ridge, Boronia Heights, Grand Plaza": [
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Mount Lindesay Hwy near Talinga Dr hail 'n' ride",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Crest Rd near Lennons Rd",
                        "Short St near Moreton St",
                        "Short St near Whetton Ct",
                        "Short St near Parklands Dr",
                        "Short St near Kadlunga Ct",
                        "Mackellar Dr near Jade Garden Dr hail 'n' ride",
                        "Maclean Dr near MacAuley Dr hail 'n' ride",
                        "MacAuley Dr near Mack Ct hail 'n' ride",
                        "Eugene St near Barry St",
                        "Eugene St near Yvonne Dr",
                        "Mackellar Dr near Rick Ct",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Flinders Cr near MacQuarie St hail 'n' ride",
                        "Tovey Rd near Tasman Ct",
                        "Parklands Dr near Samantha St hail 'n' ride",
                        "Parklands Dr near Titan Ct",
                        "Fedrick St near Short St",
                        "Fedrick St at Tenielle Street",
                        "Fedrick St near Foxhall St",
                        "Emerald Dr at Green Road",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr near Colisa Cr",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Parkroyal Crescent",
                        "Letitia St at Hydrabad Street",
                        "Letitia St at Vansittart Road",
                        "Vansittart Rd near Pavon St",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Waller Rd near Vansittart Rd",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Browns Plains Rd",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B",
                        "Ranchwood Ave near Leonard St",
                        "Ranchwood Ave near Highcrest Dr",
                        "Begonia St near Woodview St",
                        "Begonia St near Forestglen Cr",
                        "Furzer St near Ben St",
                        "Furzer St near Oakdale St",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Campden Street",
                        "Logan Metro Sports Complex",
                        "Bayliss Rd near Grier Dr",
                        "Bayliss Rd near Volstead Rd",
                        "Bayliss Rd near Hawthorn St",
                        "Bayliss Rd at Heritage Boulevard Park",
                        "Green Rd at Isle of Ely Drive",
                        "Green Rd at Solandra Circuit",
                        "Green Rd near Emerald Dr"
                    ],
                    "6136: Clairvaux-Mackillop, Grand Plz, Jimboomba": [
                        "Klumpp Rd at Klumpp-Dawson",
                        "Klumpp Rd at Hibiscus",
                        "Mains Road park 'n' ride",
                        "Mains Rd at Robertson",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Beenleigh Rd near Ardargie St",
                        "Gowan Rd at Darnell Street, stop 73",
                        "Gowan Rd near Coori Street, stop 74",
                        "Gowan Rd at Calliope Street, stop 79",
                        "Gowan Rd near Blackbean St",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd at Parkside",
                        "Gowan Rd near The Parkway",
                        "Honeysuckle Way at The Parks",
                        "Honeysuckle Way at Calamvale",
                        "Honeysuckle Way at Sunflower",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Browns Plains Rd at Forestglen Park",
                        "Waller Rd near Ammons St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Rossmore St",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Volant St",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd near Emerald Dr",
                        "Granger Rd near Eastern Service Rd",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Janelle Ct hail 'n' ride",
                        "Andalusian Dr near Greenbank Rd hail 'n' ride",
                        "Greenbank Rd near Willowbrook Rd hail 'n' ride",
                        "Trace Road at Wearing Rd",
                        "Service Rd at St Aldwyn Rd",
                        "Sharon St near Saint Aldwyn Rd hail 'n' ride",
                        "Saint Aldwyn Rd near Mount Lindesay Hwy HnR",
                        "Trace Rd at Wearing Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Johanna St near Grandview Rd hail 'n' ride",
                        "Brisbane St near Mount Lindesay Hwy"
                    ],
                    "6137: St Thomas More, Sunnybank, Grand Plaza": [
                        "Turton St at St Thomas More College",
                        "Troughton Rd at Banoon",
                        "McCullough St at Brooklands",
                        "Station Rd at Wen Place, stop 80",
                        "Station Rd at Oasis Gardens, stop 79",
                        "Gager St at Sunybank High School, zone D",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Compton Rd near Beaudesert Rd",
                        "Beaudesert Rd at Benhiam Street",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd near Honeysuckle Way",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Waller Rd near Ammons St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Rossmore St",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Volant St",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Emerald Dr at Regents Park Primary School",
                        "Emerald Dr at Green Rd",
                        "Green Rd at Solandra Circuit",
                        "Green Rd at Sunrise Court",
                        "Green Rd at Isle of Ely Drive"
                    ],
                    "6138: MacGregor High, Runcorn High, Grand Plaza": [
                        "Springfield St at MacGregor High School",
                        "Parkway St near Springfield St, stop 80",
                        "Granadilla St at Mimosa Creek, stop 79",
                        "Granadilla St at Ceriman Street, stop 78",
                        "Granadilla St near Darlington St, stop 7",
                        "Granadilla St at Sunderland Street, stop 76",
                        "Padstow Rd at Devonlea",
                        "Warrigal Rd at Padstow Views",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Runcorn North",
                        "Pine St near Warrigal Rd",
                        "Mango St near Orange St",
                        "Lemon St near Mango St",
                        "Hill Rd at Runcorn High School, zone B",
                        "Warrigal Rd at Fruitgrove",
                        "Beenleigh Rd at Fruitgrove station",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Beenleigh Rd at Runcorn Railway, stop 72",
                        "Gowan Rd near Coori Street, stop 74",
                        "Gowan Rd at Calliope Street, stop 79",
                        "Gowan Rd near Blackbean St",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd at Parkside",
                        "Gowan Rd near The Parkway",
                        "Honeysuckle Way at The Parks",
                        "Honeysuckle Way at Calamvale",
                        "Honeysuckle Way at Sunflower",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Mount Lindesay Hwy at Browns Plains",
                        "Browns Plains station, stop 2B"
                    ],
                    "6141: Emmaus, Hills Int, Jimboomba, Mundoolun": [
                        "Emmaus College Jimboomba",
                        "South St near Mary St hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Johanna St at Hills International College",
                        "Mount Lindesay Hwy near Millstream Rd",
                        "Mount Lindesay Hwy at Cedar Vale Rd",
                        "Bamboo Dr near Mount Lindesay Hwy hail 'n' ride",
                        "Bamboo Dr near Apollo Ct hail 'n' ride",
                        "Bamboo Dr near Venus Ct hail 'n' ride",
                        "Ashwood Dr near Bamboo Dr hail 'n' ride",
                        "Ashwood Dr near Orbit Ct hail 'n' ride",
                        "Ashwood Dr near Cassia Ct hail 'n' ride",
                        "Ashwood Dr near Bluff Rd hail 'n' ride",
                        "Norfolk Dr near Rose Gum Ct hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Dennis Rd near Allspice St hail 'n' ride",
                        "Dennis Rd near Heron Rd hail 'n' ride",
                        "Quail St near Lyrebird Rd hail 'n' ride",
                        "Quail St near Heron St hail 'n' ride",
                        "Barnes Rd near Trewin Rd hail 'n' ride",
                        "Blackbean St near Teak St hail 'n' ride",
                        "Millstream Rd near Bloodwood Ct hail 'n' ride",
                        "Millstream Rd near Cedar Vale Rd hail 'n' ride"
                    ],
                    "6142: Park Ridge, Boronia Heights, Munruben": [
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Tovey Rd near Macquarie St",
                        "Mitchell St near Flinders Cr hail 'n' ride",
                        "Wilton Cr near Flinders Cr",
                        "Wilton Cr near Parklands Dr",
                        "Short St near Whetton Ct",
                        "Short St near Moreton St",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge State High",
                        "Rosia Rd at Parklands Christian College",
                        "Eastern Service Rd near Rosia Rd hail 'n' ride",
                        "Granger Rd near Eastern Service Rd",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Greenhill Rd near Glenwood Rd hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Kensington Dr near Regent Ct hail 'n' ride",
                        "Kensington Dr near Hyde Ct hail 'n' ride",
                        "Greenhill Rd near Janelle Ct hail 'n' ride",
                        "Stanley Ct at Crowson Lane",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Gaynor Rd near Chloe Dr hail 'n' ride",
                        "Teresa Dr near Bascombe Ct hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Norris Creek Rd near Chloe Dr hail 'n' ride"
                    ],
                    "6143: Canterbury College, Munruben, Park Ridge": [
                        "Logan Village State School",
                        "Albert St near Wharf St hail 'n' ride",
                        "Anzac Ave near Towns Ave hail 'n' ride",
                        "Kirk Rd near Anzac Ave hail 'n' ride",
                        "Kenny Rd near Chambers Flat Rd hail 'n' ride",
                        "Kings Way near Myall Tce hail 'n' ride",
                        "Carter Rd near Kings Way hail 'n' ride",
                        "Carter Rd near Cardwell Cl hail 'n' ride",
                        "Teresa Dr near Chloe Dr hail 'n' ride",
                        "Chloe Dr near Gaynor Rd hail 'n' ride",
                        "Cooreen Rd near Mount Lindesay Hwy hail 'n' ride",
                        "Eastern Services Rd near Chambers Flat Rd HnR",
                        "Greenhill Rd near Crowson Lane hail 'n' ride",
                        "Greenhill Rd near Madison Ct hail 'n' ride",
                        "Kensington Dr near Regent Ct hail 'n' ride",
                        "Kensington Dr near Hyde Ct hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Deborah Ct hail 'n' ride",
                        "Andall Rd near Carbeen Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St",
                        "Brightwell Rd near Campbell Rd hail 'n' ride",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Western Service Rd near Stoney Camp Rd HnR",
                        "Andrew Rd near Mount Lindesay Hwy",
                        "Andrew Rd near Banyulla St hail 'n' ride",
                        "Kallioota St near Birdsville St",
                        "Birdsville St near Kallioota St hail 'n' ride",
                        "Lennons Rd near Crest Rd hail 'n' ride",
                        "Crest Rd at Punter St"
                    ],
                    "6144: Flagstone, Jimboomba, Hills, Regents Park": [
                        "Poinciana Dr at Flagstone State Primary",
                        "Poinciana Dr at Flagstone State College",
                        "Homestead Dr near Poinciana Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Cusack Lane near Teviot Rd hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Cusack Ln near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Johanna St at Hills International College",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Greenhill Rd near Crowson Lane hail 'n' ride",
                        "Greenhill Rd near Madison Ct hail 'n' ride",
                        "Greenhill Rd near Deborah Ct hail 'n' ride",
                        "Andall Rd near Carbeen Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Middle Rd near Crest Rd hail 'n' ride",
                        "Middle Rd near Cunningham Dr hail 'n' ride",
                        "Middle Rd near Tovey Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle St at Boronia Heights State School",
                        "Middle Rd at Federation Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Wineglass Dr",
                        "Vansittart Rd near Estramina Rd",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Lamberth Rd near Great Ct",
                        "Lamberth Rd near Regal Dr",
                        "Lamberth Rd at Leis Way",
                        "Lamberth Rd at Bushland Drive",
                        "Lamberth Rd near Waller Rd",
                        "Waller Rd near Lamberth Rd East",
                        "Waller Rd near Charlton Pl",
                        "Green Rd at Solandra Circuit",
                        "Green Rd near Emerald Dr",
                        "Mount Lindesay Hwy at Greenbank Gardens",
                        "Mexicanus Dr near Peregrine St hail 'n' ride",
                        "Park Ridge park 'n' ride stop B"
                    ],
                    "6145: Flagstone Schools, Jimboomba, Maclean": [
                        "Emmaus College Jimboomba",
                        "South St near Mary St hail 'n' ride",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Margaret Road in Jimboomba hail 'n' ride",
                        "Glynton Rd near Cattle Camp Ct hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Homestead Dr near Elderberry Dr hail 'n' ride",
                        "Poinciana Dr at Flagstone State College",
                        "Poinciana Dr at Flagstone State Primary",
                        "Baker Rd near Teviot Rd hail 'n' ride",
                        "Baker Rd near Amanda Ct hail 'n' ride",
                        "Holyman Ct near Janet Ct hail 'n' ride",
                        "Holyman Ct near Derek Ct hail 'n' ride",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Pebble Creek Way near Mountain Ridge Rd HnR",
                        "Hann St near Saxby St hail 'n' ride",
                        "Bloomfield Esp near Pebble Creek Way hail 'n' ride",
                        "Mountain Ridge Rd near Pennine Rd hail 'n' ride",
                        "Pennine Rd near Selkirk Dr hail 'n' ride",
                        "Greenock Rd in South Maclean hail 'n' ride",
                        "Clifton Dr near Teviot Rd hail 'n' ride",
                        "Clifton Dr at North Maclean hail 'n' ride",
                        "Teviot Rd at Clifton Dr",
                        "Philippa Rd near Willowbrook Rd hail 'n' ride",
                        "Teviot Rd at Hives Rd",
                        "Hives Rd near Lance Rd hail 'n' ride",
                        "Lance Rd near Koolena Rd hail 'n' ride",
                        "Lance Rd near Pub Lane hail 'n' ride",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Middle Rd near Moody Rd hail 'n' ride",
                        "Middle Rd near Crest Rd hail 'n' ride",
                        "Crest Rd near Lennons Rd",
                        "Crest Rd at Punter St",
                        "Park Ridge park 'n' ride stop B"
                    ],
                    "6146: Clairvaux Mackillop, Greenbank": [
                        "Klumpp Rd at Klumpp-Dawson",
                        "Klumpp Rd at Hibiscus",
                        "Mains Road park 'n' ride",
                        "Mains Rd at Robertson",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Compton Rd near Beaudesert Rd",
                        "Beaudesert Rd at Benhiam Street",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd near Honeysuckle Way",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Mount Lindesay Hwy at Browns Plains",
                        "Browns Plains station, stop 2B",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Middle Rd near Anzac Ave hail 'n' ride",
                        "Middle Rd at Wineglass Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Coronation Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle Rd near Tovey Rd",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Sheppards Dr at Greenbank Store hail 'n' ride",
                        "Teviot Rd near Stoney Camp Rd hail 'n' ride",
                        "Stoney Camp Rd near Brightwell St hail 'n' ride",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Granger Rd near Eastern Service Rd"
                    ],
                    "6147: St Laurence, Brisbane High, Jimboomba": [
                        "Stephens Rd at St Laurences College, stop 7",
                        "Gladstone Rd at Dornoch Terrace, stop 11",
                        "Gladstone Rd at Ampthill Street, stop 13",
                        "Gladstone Rd at Wahcumba Street, stop 14",
                        "Gladstone Rd at Pope Street, stop 15",
                        "Gladstone Rd at Dutton Park, stop 16",
                        "TJ Doyle Memorial Park Dr at Gair Park, stop 17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Annerley Rd at Hefferan Park, stop 19",
                        "Annerley Rd at Carville Street, stop 20",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Herbert Street, stop 20b",
                        "Annerley Rd at Portland Street, stop 21",
                        "Annerley Rd at Annerley RSL, stop 21a",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ipswich Rd at Ekibin Road, stop 23",
                        "Ipswich Rd at Venner - Waterton, stop 24",
                        "Ipswich Rd at Chardons Corner, stop 25",
                        "Ipswich Rd at Yeronga Park, stop 26/27",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Beaudesert Rd at Stimpson Park, stop 29",
                        "Beaudesert Rd at Colebrook - Wharton, stop 30",
                        "Beaudesert Rd at Helles Street, stop 31",
                        "Beaudesert Rd at Moorvale, stop 32",
                        "Beaudesert Rd at Dora Street, stop 33",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Keats Street, stop 35",
                        "Beaudesert Rd at Salisbury station",
                        "Beaudesert Rd at Marshall Road, stop 40",
                        "Beaudesert Rd at Musgrave Road, stop 41",
                        "Beaudesert Rd at Boyland Avenue, stop 42",
                        "Beaudesert Rd near Boundary Rd, stop 44",
                        "Beaudesert Rd near Kerry Rd, stop 45/51",
                        "Beaudesert Rd at Kerry Rd, stop 52",
                        "Beaudesert Rd near Kerry Rd, stop 53",
                        "Beaudesert Rd at Mortimer Road, stop 54",
                        "Beaudesert Rd at A & IICS, stop 55/56",
                        "Beaudesert Rd near Miltiadis St, stop 57",
                        "Beaudesert Rd near OConnel St, stop 58",
                        "Beaudesert Rd at Durbell Street, stop 73",
                        "Beaudesert Rd near Hellawell Rd, stop 75",
                        "Beaudesert Rd at Benhiam Street",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd near Honeysuckle Way",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Mount Lindesay Hwy at Greenbank Gardens",
                        "Park Ridge park 'n' ride stop B",
                        "Granger Rd near Eastern Service Rd",
                        "Western Service Rd near Kooringal Rd hail 'n' ride",
                        "Kensington Dr near Hyde Ct hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Janelle Ct hail 'n' ride",
                        "Service Rd at St Aldwyn Rd",
                        "Trace Rd at Wearing Rd",
                        "Mount Lindesay Hwy near Stockleigh Rd",
                        "Mount Lindesay Hwy at Camp Cable Rd",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Brisbane St near Mount Lindesay Hwy"
                    ],
                    "6150: Stretton Colleges, Browns Plains": [
                        "Gowan Rd at Stretton College Primary",
                        "Stretton College (Bus Bay)",
                        "Illaweena St at Waterstone",
                        "Illaweena St at Tamarisk Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Trinity Way at Mirthwood Drive",
                        "Trinity Way at Westcott St",
                        "MacQuarie Way at Lockyer Place",
                        "MacQuarie Way near Buckley Dr",
                        "MacQuarie Way near Wembley Rd",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B"
                    ],
                    "6151: Flagstone Schools, Jimboomba, Kagaru": [
                        "Poinciana Dr at Flagstone State Primary",
                        "Poinciana Dr at Flagstone State College",
                        "Homestead Dr near Poinciana Dr hail 'n' ride",
                        "Red Cedar Crt near Pink Alder Ct hail 'n' ride",
                        "Red Cedar Crs near Rose Almond St hail 'n' ride",
                        "Silver Wattle Dr near River Oak Dr hail 'n' ride",
                        "Silver Wattle Dr near Bunya Pine Ct hail 'n' ride",
                        "River Oak Dr near Coachwood Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Bushman Dr near Homestead Dr hail 'n' ride",
                        "Bushman Dr near Shearer Ct hail 'n' ride",
                        "Drover Cr near Bushman Dr hail 'n' ride",
                        "Drover Cr near Jackeroo Ct hail 'n' ride",
                        "Drover Ct near Bushman Dr hail 'n' ride",
                        "Bushman Dr near Whittling Ct hail 'n' ride",
                        "Whittling Ct near Damper Ct hail 'n' ride",
                        "Teviot Rd near Blacksmith Ct hail 'n' ride",
                        "Blacksmith Ct near Bushman Dr hail 'n' ride",
                        "Bushman Dr near Blacksmith Ct hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Teviot Rd near Tralee Ct hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Teviot Rd at Clifton Dr",
                        "Lance Rd near Olson Rd hail 'n' ride",
                        "Hives Rd near Lance Rd hail 'n' ride",
                        "Gracelands Dr hail 'n' ride",
                        "Middle Rd near Teviot Rd hail 'n' ride",
                        "Middle Rd near Andrew Rd hail 'n' ride",
                        "Andrew Rd near Mount Lindesay Hwy"
                    ],
                    "6152: Canterbury College, Calamvale, Algester": [
                        "Gowan Rd at Stretton College Primary",
                        "Stretton College (Bus Bay)",
                        "Freshwater Dr near Anderson St",
                        "Aquatic Dr near Pebbles Ct",
                        "MacQuarie Way near Buckley Dr",
                        "Browns Plains Rd at Campden Street",
                        "Browns Plains Rd at Magnesium Drive",
                        "Fifth Ave at Christina Way",
                        "Fifth Ave at Robinson Court",
                        "Browns Plains station, stop 2B",
                        "Honeysuckle Way at Calamvale",
                        "Honeysuckle Way at Sunflower",
                        "Nottingham Rd near Appleby St",
                        "Nottingham Rd at Lakewood",
                        "Nottingham Rd at Avondale",
                        "Nottingham Rd near Algester Rd",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Algester",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Algester Rd at Beaudesert Road Stop 76"
                    ],
                    "6153: Stretton Colleges, Marsden, Browns Plains": [
                        "Gowan Rd at Stretton College Primary",
                        "Stretton College (Bus Bay)",
                        "MacQuarie Way near Wembley Rd",
                        "MacQuarie Way at Buckley Drive",
                        "MacQuarie Way at Lockyer Place",
                        "Trinity Way at Westcott St",
                        "Trinity Way at Mirthwood Drive",
                        "Searvic Rd near Acacia St hail 'n' ride",
                        "Mount Lindesay Hwy at Browns Plains",
                        "Browns Plains station, stop 2B"
                    ],
                    "6154: Beaudesert, Gleneagle": [
                        "Beaudesert State High School",
                        "Mount Lindesay Hwy at Gleneagle School",
                        "Cyrus Rd hail 'n' ride",
                        "Mount Lindesay Hwy at Veresdale Hotel HnR",
                        "Woodhill State School",
                        "Bedelia Dr near Walton St hail 'n' ride",
                        "Cedar Vale Rd near Mt Lindesay Hwy hail 'n' ride",
                        "Norfolk Dr near Rose Gum Ct hail 'n' ride",
                        "Cedar Vale Rd near Millstream Rd hail 'n' ride",
                        "Dennis Rd near Millstream Rd hail 'n' ride",
                        "Dennis Rd near Allspice St hail 'n' ride",
                        "Dennis Rd near Heron Rd hail 'n' ride",
                        "Quail St near Lyrebird Rd hail 'n' ride",
                        "Quail St near Heron St hail 'n' ride",
                        "Barnes Rd near Trewin Rd hail 'n' ride",
                        "Blackbean St near Teak St hail 'n' ride",
                        "Millstream Rd near Bloodwood Ct hail 'n' ride",
                        "Millstream Rd near Cedar Vale Rd hail 'n' ride",
                        "Heritage Rd near Joy Pl hail 'n' ride",
                        "Hughes Rd near Millstream Rd hail 'n' ride",
                        "Millstream Rd near Millwood Ct hail 'n' ride",
                        "Millstream Rd near Mount Lindsay Hwy hail 'n' ride"
                    ],
                    "6155: Park Ridge, Grand Plaza, Heritage Park": [
                        "Mt Lindesay Hwy at Park Ridge State School",
                        "Mount Lindesay Hwy near Talinga Dr hail 'n' ride",
                        "Rosia Rd at Parklands Christian College",
                        "Park Ridge State High",
                        "Crest Rd at Boulia St",
                        "Crest Rd near Lennons Rd",
                        "Middle Rd near Cunningham Dr hail 'n' ride",
                        "Middle Rd near Tovey Rd",
                        "Middle Rd at Parklands Dr",
                        "Middle St at Boronia Heights State School",
                        "Middle Rd at Federation Dr",
                        "Middle Rd at Hillview Dr",
                        "Middle Rd at Wineglass Dr",
                        "Silvertop St at Silvertop Park",
                        "Silvertop St near Hoop St",
                        "Peverell St near Tarver St",
                        "Conifer St near Whitcomb St",
                        "Conifer St near Bywater St",
                        "Conifer St near Silvertop St",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Browns Plains Rd at Ranchwood Avenue",
                        "Browns Plains Rd at Forestglen Park",
                        "Waller Rd near Ammons St",
                        "Waller Rd near Yancey St",
                        "Waller Rd near Ivor St",
                        "Waller Rd near Rossmore St",
                        "Vansittart Rd at Yugumbir Primary School",
                        "Vansittart Rd near Bushland Dr",
                        "Vansittart Rd near Bennett Dr",
                        "Vansittart Rd near Volant St",
                        "Letitia St at Vansittart Road",
                        "Letitia St at Hydrabad Street",
                        "Emerald Dr at Parkroyal Crescent",
                        "Emerald Dr at Owens Crescent",
                        "Emerald Dr at Colisa Crescent North",
                        "Emerald Dr at Colisa Crescent South",
                        "Lamberth Rd near Great Ct",
                        "Lamberth Rd near Regal Dr",
                        "Lamberth Rd at Leis Way",
                        "Lamberth Rd at Bushland Drive",
                        "Lamberth Rd near Waller Rd",
                        "Bayliss Rd near Hawthorn St",
                        "Bayliss Rd at Heritage Boulevard Park",
                        "Green Rd near Heritage Bvd",
                        "Green Rd near Cockatoo Court",
                        "Green Rd at Blue Wren Place"
                    ],
                    "6161: Trinity College, Jimboomba, Maclean": [
                        "Kokoda St at Trinity College",
                        "Canterbury College",
                        "Waterford Tamborine Rd at Acton St hail 'n' ride",
                        "Albert St near Wharf St hail 'n' ride",
                        "Logan Village State School",
                        "Camp Cable Rd near Allans Creek hail 'n' ride",
                        "Edelstein Rd near Camp Cable Rd hail 'n' ride",
                        "Edelsten Rd near Davidson Rd hail 'n' ride",
                        "Edelsten Rd near Mundoolun Rd hail 'n' ride",
                        "John Collins Dr near Scarborough Ct hail 'n' ride",
                        "Mundoolun Rd near Kurrajong Rd hail 'n' ride",
                        "Kurrajong Rd near Mundoolun Rd hail 'n' ride",
                        "Kurrajong Rd near Millstream Rd hail 'n' ride",
                        "Millstream Rd near Mount Lindsay Hwy hail 'n' ride",
                        "Brisbane St near Cusack Lane hail 'n' ride",
                        "Honora St at Jimboomba Primary School",
                        "Cusack Lane near Johanna St hail 'n' ride",
                        "Cusack Lane near Riverton Dr hail 'n' ride",
                        "Cusack Lane near Duncan Rd hail 'n' ride",
                        "Margaret Road in Jimboomba hail 'n' ride",
                        "Glynton Rd near Cattle Camp Ct hail 'n' ride",
                        "Teviot Rd near Homestead Dr hail 'n' ride",
                        "Bushman Dr near Homestead Dr hail 'n' ride",
                        "Bushman Dr near Shearer Ct hail 'n' ride",
                        "Drover Cr near Bushman Dr hail 'n' ride",
                        "Drover Cr near Jackeroo Ct hail 'n' ride",
                        "Drover Ct near Bushman Dr hail 'n' ride",
                        "Homestead Dr near Coachwood Dr hail 'n' ride",
                        "Poinciana Dr at Flagstone State Primary"
                    ],
                    "6162: Springfield Central, Greenbank": [
                        "Springfield Central State High",
                        "Springfield Greenbank Art near Thompson Rd HnR",
                        "Greenbank State Primary School",
                        "New Beith Rd near Goodna Rd hail 'n' ride",
                        "Argyle Rd near Citrine St hail 'n' ride",
                        "Argyle Road near Sentinel Drive",
                        "Dungaree Dr near Settler Ct hail 'n' ride",
                        "Lyon Dr near Dungaree Dr hail 'n' ride",
                        "Lyon Dr near Wallaby Way hail 'n' ride",
                        "Marsh Bird Dr near Bradman St hail 'n' ride",
                        "Red Gum Road near Laurina Dr",
                        "Red Gum Rd near Boyd Rd hail 'n' ride",
                        "Red Gum Rd near Whiteley Cct hail 'n' ride",
                        "36 Preston St",
                        "New Beith Rd near Preston Street HnR",
                        "Tall Timber Rd near Polebark Ct hail 'n' ride",
                        "Tall Timber Rd near Benchmill Rd hail 'n' ride",
                        "New Beith Rd near Lyon Dr hail 'n' ride",
                        "Pub Lane near Dungaree Dr hail 'n' ride",
                        "Pub Lane near East Sentinel Drive hail 'n' ride",
                        "Pub Lane at Greenbank Shopping Centre"
                    ],
                    "6163: Springfield Central SHS, Greenbank": [
                        "Springfield Central State High",
                        "Parkland Dr near Wellness Way",
                        "Springfield Greenbank Art near Thompson Rd HnR",
                        "Thompson Rd near Daniel Ct hail 'n' ride",
                        "Thompson Rd near Nufflield Rd",
                        "Thompson Rd near Klipspringer Ct hail 'n' ride",
                        "Begley Rd near Attunga Rd hail 'n' ride",
                        "307 Backwater Pocket Road",
                        "Backwater Rd near Marvelle Cl hail 'n' ride",
                        "Ison Rd near Goodna Road hail 'n' ride",
                        "Goodna Rd near Ison Rd",
                        "Greenbank State Primary School",
                        "New Beith Rd near Goodna Rd hail 'n' ride",
                        "New Beith Rd near Salston Rd hail 'n' ride",
                        "Spring Mountain Dr near Raglan Rd hail 'n' ride",
                        "Spring Mountain Dr near Brushtail Dr hail 'n' ride",
                        "Spring Mountain Dr near Platypus Dr hail 'n' ride",
                        "Spring Mountain Dr near Dunnart Rd hail 'n' ride",
                        "Spinebill Dr near Echidna Ct hail 'n' ride",
                        "Silvereye Cr near Spinebill Dr hail 'n' ride",
                        "Silvereye Cr near Parrot St hail 'n' ride",
                        "Spinebill Dr near Bowerbird Cl hail 'n' ride",
                        "Spring Mountain Dr near Tigercat Ct hail 'n' ride"
                    ],
                    "6165: Marsden HS, Logan Cent, Woodridge GCity": [
                        "Marsden High School",
                        "Chambers Flat Rd at Mark Lane",
                        "Chambers Flat Rd at Marsden Park",
                        "Chambers Flat Rd at Lancaster Park",
                        "Kingston Rd at Monash Road",
                        "Kingston Rd at Station Road",
                        "Kingston Rd at Gould Adams Park",
                        "Kingston Rd at Augustus Street",
                        "Kingston Rd at Edith Street",
                        "Kingston Rd at Market Square",
                        "Wembley Rd at Logan City Centre",
                        "Logan Central station, platform 1",
                        "Wembley Rd at Wilbur Street",
                        "Wembley Rd at Ewing Road",
                        "Woodridge station",
                        "North Rd at Defiance Road",
                        "North Rd at Albert Park",
                        "North Rd at Bruce Road",
                        "Smith Rd at Lindley Street",
                        "Smith Rd at Andella Street",
                        "Smith Rd at Ewing Road",
                        "Smith Rd at Harrisfields Primary School",
                        "Kingston Rd at Park Road",
                        "Kingston Rd at Rudge Street",
                        "Kingston Rd at Booran Drive",
                        "Kingston Rd at Kenway Drive",
                        "Kingston Rd near Parramatta Rd",
                        "Kingston Rd at Curban Street",
                        "Logan Rd at Celia Street",
                        "Logan Rd at Harris Road",
                        "Logan Rd at Underwood Rd",
                        "Logan Rd at Brandl Street, stop 83",
                        "Logan Rd at Miles Platting Road, stop 82",
                        "Logan Rd near Liverpool St, stop 81",
                        "MacGregor St at Garden City Depot",
                        "Upper Mt Gravatt station, platform 1"
                    ],
                    "6166: St Thomas More, Browns Plains": [
                        "Turton St at St Thomas More College",
                        "Lister St at Gager St, stop 77",
                        "Lister St at Boorman Street, stop 76",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Compton Rd near Beaudesert Rd",
                        "Beaudesert Rd at Benhiam Street",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd near Honeysuckle Way",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Grand Plaza Shopping Centre (Sth Car Park)",
                        "Browns Plains station, stop 2B",
                        "Mount Lindesay Hwy at Greenbank Gardens",
                        "Park Ridge park 'n' ride stop A"
                    ],
                    "6167: Marsden High, Crestmead, Browns Plains": [
                        "Marsden High School",
                        "Browns Plains Rd at Havenbah Park",
                        "Browns Plains Rd at Blue Gum Drive",
                        "Browns Plains Rd at Emerald Street",
                        "Browns Plains Rd at Pedder Street",
                        "Browns Plains Rd at Second Avenue",
                        "Browns Plains Rd at Third Avenue",
                        "Browns Plains Rd at Fifth Avenue",
                        "Browns Plains Rd at Magnesium Drive",
                        "Browns Plains Rd near Campden St",
                        "Browns Plains Rd at Campden Street",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B"
                    ],
                    "6168: Everleigh State, Sth Maclean, Nth Maclean": [
                        "Everleigh State School",
                        "Teviot Rd near Pub Lane hail 'n' ride",
                        "Teviot Rd at Hives Rd",
                        "Teviot Rd at Clifton Dr",
                        "Pebble Creek Way near Mountain Ridge Rd HnR",
                        "Hann St near Saxby St hail 'n' ride",
                        "Bloomfield Esp near Pebble Creek Way hail 'n' ride",
                        "Teviot Rd at Mountain Ridge Rd",
                        "Braemer Rd near Teviot Rd hail 'n' ride",
                        "Aberdeen Rd near Dundee Rd hail 'n' ride",
                        "Scott Lane near Greenbank Rd hail 'n' ride",
                        "Greenbank Rd near Willowbrook Rd hail 'n' ride",
                        "Greenhill Rd near Crowson Lane hail 'n' ride",
                        "Greenhill Rd near Madison Ct hail 'n' ride",
                        "Greenhill Rd near Kensington Dr hail 'n' ride",
                        "Greenhill Rd near Deborah Ct hail 'n' ride",
                        "Andall Rd near Carbeen Rd hail 'n' ride",
                        "Andall Rd near Sycamore Rd hail 'n' ride",
                        "Stoney Camp Rd near Andall Rd hail 'n' ride",
                        "Stoney Camp Rd near Mount Lindesay Hwy HnR",
                        "Granger Rd near Eastern Service Rd"
                    ],
                    "6169: Marsden High, Bumstead Road": [
                        "Chambers Flat Rd at Marsden High School",
                        "Park Ridge Rd near Jacaranda Dr hail 'n' ride",
                        "Bumstead Rd near Clarke Rd",
                        "Bumstead Rd near Pidgeon Bvd hail 'n' ride",
                        "Bumstead Rd at Wisdom Way",
                        "Bumstead Rd near Judith St hail 'n' ride",
                        "Bumstead Rd near Gow Crt hail 'n' ride"
                    ],
                    "6170: Stretton State College, Macquarie, Browns Plains": [
                        "Stretton College (Bus Bay)",
                        "MacQuarie Way near Wembley Rd",
                        "MacQuarie Way at Buckley Drive",
                        "MacQuarie Way at Lockyer Place",
                        "Trinity Way at Westcott St",
                        "Trinity Way at Mirthwood Drive",
                        "Searvic Rd near Acacia St hail 'n' ride",
                        "Mount Lindesay Hwy at Browns Plains",
                        "Browns Plains station, stop 2B"
                    ],
                    "6171: Stretton College - Macquarie - Brown Plains": [
                        "Stretton College (Bus Bay)",
                        "Illaweena St at Waterstone",
                        "Illaweena St at Tamarisk Way",
                        "Beaudesert Rd at Illaweena Street",
                        "Trinity Way at Mirthwood Drive",
                        "Trinity Way at Westcott St",
                        "MacQuarie Way at Lockyer Place",
                        "MacQuarie Way near Buckley Drive",
                        "MacQuarie Way near Wembley Rd",
                        "Browns Plains Rd at Wembley Road",
                        "Browns Plains Rd at Oakdale Park",
                        "Browns Plains Rd near Waller Rd",
                        "Browns Plains Rd at Webber Drive",
                        "Browns Plains station, stop 2B"
                    ],
                    "6201: Kruger, Goodna, Redbank Plains, Redbank": [
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Redbank Plains Rd at Kingsford Street",
                        "Curnow St near Howard St",
                        "Stuart St near Bellevue Rd",
                        "Cross St at Bellevue Road",
                        "Gorry St at Kilner Street",
                        "Gorry St at Dowden Street",
                        "Dowden St near Gorry St hail 'n' ride",
                        "Smiths Rd near Stephen Cr",
                        "Stanley St at Goodna Primary School",
                        "Goodna Shopping Centre",
                        "St Francis Xavier Catholic Primary School",
                        "Alice St near Martha St hail 'n' ride",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Smiths Rd near Stephen Cr hail 'n' ride",
                        "Smiths Rd near Bellevue Rd hail 'n' ride",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Namatjira Dr at Drysdale Ave hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Henty Dr at Kruger Parade",
                        "Henty Dr at Batman Drive",
                        "Henty Dr near Kennedy Dr hail 'n' ride",
                        "Henty Dr near Evergreen Pl hail 'n' ride",
                        "Henty Dr at Ropati Street",
                        "Henty Dr near Knight St",
                        "Small Cl near Knight St hail 'n' ride",
                        "Glen Brae St near Frawley Dr hail 'n' ride",
                        "Cedar Rd near Redbank Plains Rd hail 'n' ride",
                        "Cedar Rd near Vicki St hail 'n' ride",
                        "School Rd at Redbank Plains State School",
                        "School Rd near Willow Rd West hail 'n' ride",
                        "School Rd near Alawoona St hail 'n' ride",
                        "Alawoona St near Keidges Rd hail 'n' ride",
                        "Keidges Rd near Orana St hail 'n' ride",
                        "Willow Rd at Redbank Plains High School",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Kruger Pde at Redbank Palms",
                        "Duncan St at Dancer Street",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Rd near Irving Ct hail 'n' ride",
                        "Gibbs Ave at Hunt Court",
                        "Gibbs Ave near Genoa Pl",
                        "Gibbs Ave near Avoca Ct",
                        "Gibbs Ave near TJ Ryan Ave",
                        "Eagle St near Bassili Dr",
                        "Eagle St near TJ Ryan Ave",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Collingwood Dr at Gibbs Avenue hail 'n' ride",
                        "Collingwood Dr at Jamboree Park hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6202: Bundamba State, Riverview, Redbank Plaza": [
                        "Brisbane Rd at Bundamba Primary",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Hamilton St near Clifton St hail 'n' ride",
                        "Dudleigh St near Clifton St",
                        "Jacaranda St near Tuggerah St",
                        "Jacaranda St near Cook St",
                        "Jacaranda St near Nathan St",
                        "Jacaranda St near Cotton St",
                        "Brockwell Gardens hail 'n' ride",
                        "Jacaranda St at Ipswich East Primary School",
                        "Jacaranda St at Nathan Street",
                        "Jacaranda St near Spengler St",
                        "Jacaranda St near Burton St",
                        "Jacaranda St near Welsby St",
                        "North Station Rd at Booval station",
                        "North Station Rd at Bridge Street",
                        "North Station Rd near Soudan St hail 'n' ride",
                        "Baden Jones Way near Nixon Dr hail 'n' ride",
                        "North Station Rd near Lamont St hail 'n' ride",
                        "Beth St near North Station Rd hail 'n' ride",
                        "Logan St near Janet St hail 'n' ride",
                        "Logan St near Gledson St hail 'n' ride",
                        "Gledson St near Bergin St",
                        "Gledson St at Jack Barkley Park",
                        "Creek St at Bundamba station",
                        "River Rd near TAFE Queensland Ipswich campus",
                        "River Rd near Mafeking St hail 'n' ride",
                        "Nelson St near Wade St hail 'n' ride",
                        "Nelson St near Burgoyne St hail 'n' ride",
                        "Andrew St near Hanlon St hail 'n' ride",
                        "Hart St near Cornish St hail 'n' ride",
                        "Egerton St near Hanlon St hail 'n' ride",
                        "Burgoyne St near Eclipse Ct hail 'n' ride",
                        "Cullen St near Jeffrey St hail 'n' ride",
                        "Mary St near Watkins St hail 'n' ride",
                        "Mary St near Byrne St hail 'n' ride",
                        "Carberry St near Wall St hail 'n' ride",
                        "Vale St near Law St hail 'n' ride",
                        "Vale St near Byrne St hail 'n' ride",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at Ebbw Vale station",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "River Rd at Dinmore station",
                        "River Rd at King Street",
                        "Riverview Rd at Kenneth Street",
                        "Riverview Rd near Ursula St hail 'n' ride",
                        "Riverview Rd at Maryanne Street",
                        "Endeavour Rd at Riverview Gardens",
                        "Tessman St near Brian St",
                        "Mitchell St at Tessman Street",
                        "Price St near Hayden St",
                        "Gibbs St near Diamond St",
                        "Diamond St near Valerie St",
                        "Old Ipswich Rd near Laura St",
                        "Old Ipswich Rd at Anderson Street",
                        "Nile St near Duncan St hail 'n' ride",
                        "Old Ipswich Rd at Maxwell Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd at Ipswich Street",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Redbank Plaza",
                        "Gorry St at Dowden Street",
                        "Gorry St at Killner Street",
                        "Cross St near Hamar St",
                        "Stuart St at Bellevue Road",
                        "Curnow St near Howard St",
                        "Kingsford St at Howard Street",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Redbank Plains Rd at Brennan Street",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Alawoona St near Barkala St hail 'n' ride",
                        "Alawoona St near Lemana St hail 'n' ride",
                        "Alawoona St near Cedar Rd hail 'n' ride",
                        "Alawoona St near Dandenong Av hail 'n' ride",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "School Rd near Cashmere St hail 'n' ride",
                        "Redbank Plains Rd at Bronzewing Street",
                        "Rice Rd near Henry Samuel Dr",
                        "Halletts Rd near Penrose Cct hail 'n' ride",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop C"
                    ],
                    "6203: St Marys, St Edmonds, Bremer, Silkstone": [
                        "Elizabeth St at St Mary's Primary School",
                        "Brisbane St near Bell St hail 'n' ride",
                        "East St at South Street",
                        "Ipswich Hospital, Stop C",
                        "Warwick Rd at Park Street",
                        "Warwick Rd at Short Street",
                        "Warwick Rd at Bremer High",
                        "Bremer State High School",
                        "Salisbury Rd at Thorn Street",
                        "Salisbury Rd near Briggs Rd",
                        "Chermside Rd at Fifer Street",
                        "Marvin St near Olmai Ave",
                        "Marvin St near Grange Rd",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd at Silkstone Primary School",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd near Church St",
                        "Blackstone Rd near Johnston St",
                        "Thomas St at Queen Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Mary St near Hill Street",
                        "Mary St near Edward St hail 'n' ride",
                        "Cedar Rd near Redbank Plains Rd hail 'n' ride",
                        "Cedar Rd near Vicki St hail 'n' ride",
                        "School Rd at Redbank Plains State School",
                        "School Rd near Willow Rd West hail 'n' ride",
                        "Shanahan Pde near Lietzow St hail 'n' ride",
                        "Cedar Rd near Orana St hail 'n' ride",
                        "Kanangra St at Cedar Road",
                        "Kanangra St at Lemana Street",
                        "Kanangra St near Balook St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Keidges Rd near Orana St hail 'n' ride",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd at Harris St hail 'n' ride",
                        "Jones Rd at Nugent Street hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Katandra Cr near Jones Rd hail 'n' ride",
                        "Katandra Cr near Beryl Ct hail 'n' ride",
                        "Katandra Cr near Perdita St hail 'n' ride",
                        "Katandra Cr near Rosemary St hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Bertha St near Eric St hail 'n' ride",
                        "Brisbane Tce near Layard St hail 'n' ride"
                    ],
                    "6204: St Peter Claver, Sacred Heart, Silkstone": [
                        "Acirl St at St Peter Claver College",
                        "Mary St at Blackstone Primary School",
                        "Mary St near Hill Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Thomas St at Queen Street",
                        "Blackstone Rd near Johnston St",
                        "Cothill Rd at Sacred Heart Catholic Primary",
                        "Booval Fair",
                        "South Station Rd at Ivory Street",
                        "Glebe Rd at Silkstone Primary School",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd at Silkstone Primary School",
                        "Blackstone Rd near Heather St",
                        "South Station Rd near Auld St",
                        "South Station Rd near Morris St",
                        "South Station Rd near Robertson Rd",
                        "South Station Rd near Harding St",
                        "Cascade St near South Station Rd",
                        "Wildey St at Raceview Primary School",
                        "Wildey St near Rumsey Dr",
                        "Wildey St near Edwards St hail 'n' ride",
                        "Edwards St near Thornton St",
                        "Edwards St near Rockman Dr",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive",
                        "South Station Rd near Rumsey Dr hail 'n' ride",
                        "Fischer Rd near Clarke St hail 'n' ride",
                        "Levi St near Scotts Rd hail 'n' ride",
                        "Ripley Rd near Fischer Rd hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Harmony Cr at Greenview Avenue",
                        "Rose St near Tulip St hail 'n' ride",
                        "Cypress St near Jacaranda Dr hail 'n' ride",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Hall Street",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Whitehill Rd near Anna Dr hail 'n' ride",
                        "Whitehill Rd near McGill St",
                        "Cemetery Rd near Whitehill Rd",
                        "Cemetery Rd near Warner St",
                        "Cemetery Rd at Briggs Road",
                        "Carr St at Warwick Road"
                    ],
                    "6206: St Marys, St Edmonds, Ipswich, Raceview": [
                        "Elizabeth St at St Mary's Primary School",
                        "Waghorn St near Waghorn St hail 'n' ride",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Warwick Rd at Short Street",
                        "Warwick Rd at Bremer High",
                        "Bremer State High School",
                        "Carr St at Thorn Street",
                        "Cemetery Rd near Briggs Rd hail 'n' ride",
                        "Cemetery Rd near Orchard St",
                        "Whitehill Rd near Raff St",
                        "Glebe Rd opp Silkstone Primary School",
                        "Molloy St opp Silkstone Primary",
                        "Blackstone Rd opp Silkstone State School",
                        "Blackstone Rd at Coolibah Street",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Grange Rd near Edwards St",
                        "Robertson Rd near France St",
                        "Raceview St near Taylor St",
                        "Raceview St at Carlita Place",
                        "Cascade St at Bethany Lutheran Primary School",
                        "Wildey St at Raceview Primary School",
                        "Wildey St near Rumsey Dr",
                        "Wildey St near Edwards St hail 'n' ride",
                        "South Station Rd near Rumsey Dr hail 'n' ride",
                        "Melrose Dr at Rourke Park hail 'n' ride",
                        "Fischer Rd near Clarke St hail 'n' ride",
                        "Levi St near Scotts Rd hail 'n' ride",
                        "Scotts Rd near Ripley Rd hail 'n' ride",
                        "Monterea Rd near Maguire St hail 'n' ride",
                        "Belle Pde near Optima St hail 'n' ride",
                        "Carpenter Dr near Rex Hills Dr hail 'n' ride",
                        "Rex Hills Dr near Cityhope Church hail 'n' ride",
                        "Ripley Rd at Trigona Drive",
                        "Parkview Pde at Lillypilly Drive",
                        "Fitzgibbon Rd near Joy Chambers Cct hail 'n' ride",
                        "Panorama Cct near Edinburgh St hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Harmony Cr at Greenview Avenue",
                        "Parkway Ave hail 'n' ride",
                        "Parkway Ave at Ripley Valley Schools",
                        "Ripley Rd at Wensley Rd",
                        "Ripley Rd at Canary St"
                    ],
                    "6207: Bundamba, Sacred Heart, Bremer": [
                        "Brisbane Rd at Bundamba Primary",
                        "Brisbane Rd at Bundamba Swimming Centre",
                        "Naomai St at Bundamba Secondary College",
                        "Bundamba Secondary College",
                        "Naomai St at Innes Crescent",
                        "Naomai St at Alice Street",
                        "William St near Charlotte St",
                        "Mary St at Blackstone Primary School",
                        "Mary St near Hill Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Thomas St at Queen Street",
                        "Blackstone Rd near Johnston St",
                        "Cothill Rd at Sacred Heart Catholic Primary",
                        "Booval Fair",
                        "South Station Rd at Ivory Street",
                        "Molloy St opp Silkstone Primary",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Chermside Rd near Countess St",
                        "Chermside Rd near McGill St",
                        "McGill St near Howard St",
                        "McGill St near Battye St",
                        "Springall St near Charlotte St",
                        "Charlotte St near Bowers St",
                        "Charlotte St near Blackall St",
                        "Blackall St near Goodwin St",
                        "Jacaranda St at Ipswich East Primary School",
                        "Jacaranda St at Nathan Street",
                        "Jacaranda St near Spengler St",
                        "Jacaranda St near Burton St",
                        "Jacaranda St near Welsby St",
                        "North Station Rd at Booval station",
                        "North Station Rd at Bridge Street",
                        "Baden Jones Way near Nixon Dr hail 'n' ride",
                        "Beth St near North Station Rd hail 'n' ride",
                        "Logan St near Janet St hail 'n' ride",
                        "Gledson St near Bergin St",
                        "Selwyn St near Roy St hail 'n' ride",
                        "David St near Diane Ct hail 'n' ride",
                        "David St near Christine St hail 'n' ride",
                        "Gledson St at Jack Barkley Park",
                        "Creek St at Bundamba station",
                        "River Rd near TAFE Queensland Ipswich campus",
                        "River Rd near Mafeking St hail 'n' ride",
                        "Nelson St near Wade St hail 'n' ride",
                        "Nelson St near Burgoyne St hail 'n' ride",
                        "Andrew St near Hanlon St hail 'n' ride",
                        "Hart St near Cornish St hail 'n' ride",
                        "Egerton St near Hanlon St hail 'n' ride",
                        "Burgoyne St near Eclipse Ct hail 'n' ride",
                        "Cullen St near Jeffrey St hail 'n' ride",
                        "Mary St near Watkins St hail 'n' ride",
                        "Mary St near Byrne St hail 'n' ride",
                        "Vale St near Byrne St hail 'n' ride",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at Ebbw Vale station",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "River Rd at Dinmore station",
                        "River Rd at King Street",
                        "Riverview Rd at Kenneth Street",
                        "Riverview Rd at Maryanne Street",
                        "Endeavour Rd at Riverview Gardens",
                        "Tessman St near Brian St",
                        "Mitchell St at Tessman Street",
                        "Price St near Hayden St",
                        "Gibbs St near Diamond St",
                        "Diamond St near Valerie St",
                        "Old Ipswich Rd near Laura St",
                        "Old Ipswich Rd at Anderson Street",
                        "Old Ipswich Rd at Ipswich Street",
                        "Old Ipswich Rd at Maxwell Street",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Redbank Plaza",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6208: Bundamba, East Ipswich, Bremer": [
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Warwick Rd at Showground North",
                        "Warwick Rd at Park Street",
                        "Waghorn St at Ipswich Grammar School",
                        "Elizabeth St at St Mary's Primary School",
                        "Blackall St near Barry St",
                        "Blackall St near Northcote St",
                        "Blackall St at Norman Street",
                        "Blackall St near Davidson St",
                        "Charlotte St at Blackall Street",
                        "Charlotte St near Springall St",
                        "Springall St near Charlotte St",
                        "McGill St near Battye St",
                        "McGill St near Howard St",
                        "Chermside Rd near Goodwin St",
                        "Chermside Rd near Jacaranda St",
                        "Jacaranda St at Ipswich East Primary School",
                        "Jacaranda St at Nathan Street",
                        "Jacaranda St near Spengler St",
                        "Jacaranda St near Burton St",
                        "Jacaranda St near Welsby St",
                        "North Station Rd at Booval station",
                        "North Station Rd at Bridge Street",
                        "North Station Rd near Soudan St hail 'n' ride",
                        "Baden Jones Way near Nixon Dr hail 'n' ride",
                        "Beth St near North Station Rd hail 'n' ride",
                        "Logan St near Janet St hail 'n' ride",
                        "Logan St near Gledson St hail 'n' ride",
                        "Gledson St near Bergin St",
                        "David St near Diane Ct hail 'n' ride",
                        "Selwyn St near Roy St hail 'n' ride",
                        "David St near Christine St hail 'n' ride",
                        "Gledson St at Jack Barkley Park",
                        "Creek St at Bundamba station",
                        "River Rd near TAFE Queensland Ipswich campus",
                        "River Rd near Mafeking St hail 'n' ride",
                        "Nelson St near Wade St hail 'n' ride",
                        "Nelson St near Burgoyne St hail 'n' ride",
                        "Andrew St near Hanlon St hail 'n' ride",
                        "Hart St near Cornish St hail 'n' ride",
                        "Egerton St near Hanlon St hail 'n' ride",
                        "Burgoyne St near Eclipse Ct hail 'n' ride",
                        "Cullen St near Jeffrey St hail 'n' ride",
                        "Mary St near Watkins St hail 'n' ride",
                        "Mary St near Byrne St hail 'n' ride",
                        "Carberry St near Wall St hail 'n' ride",
                        "Vale St near Law St hail 'n' ride",
                        "Vale St near Byrne St hail 'n' ride"
                    ],
                    "6209: Redbank Plains, Redbank": [
                        "School Rd at Redbank Plains State School",
                        "School Rd near Cashmere St hail 'n' ride",
                        "Rice Rd near Henry Samuel Dr",
                        "Halletts Rd near Penrose Cct hail 'n' ride",
                        "School Rd near Alawoona St hail 'n' ride",
                        "Cedar Rd at Orana Street",
                        "Cedar Rd at Kentucky Street",
                        "Redbank Plains Recreation Reserve",
                        "Henty Dr at Barnes Street",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Kanangra St at Balook Street",
                        "Kanangra St near Lemana St",
                        "Kanangra St at Cedar Road",
                        "Shanahan Pde at Tina Street",
                        "Shanahan Pde at School Road",
                        "Alawoona St at Ingles Drive",
                        "Ingles Dr at McNamara Place",
                        "Fernbrooke Bvd at Ingles Drive",
                        "School Rd near Fernbrooke Bvd",
                        "School Rd at Alawoona Street",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Glen Brae St near Frawley Dr hail 'n' ride",
                        "Small Cl near Henry Dr hail 'n' ride",
                        "Argyle St near Price Cl",
                        "Argyle St near McBrien Ct hail 'n' ride",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Stuart St near Eric St hail 'n' ride",
                        "Stuart St near Bellevue Rd",
                        "Alice St near Albert Street hail 'n' ride",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Queen Street near Little Street hail 'n' ride",
                        "Brisbane Tce near Layard St hail 'n' ride",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at Brisbane River Terraces",
                        "Redbank station, stop B"
                    ],
                    "6210: Ipswich Boys & Girls, StMarys, StEdmonds": [
                        "Waghorn St at Ipswich Grammar School",
                        "Elizabeth St at St Mary's Primary School",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Brisbane Rd at Montauban Street",
                        "Brisbane Rd near Newtown St hail 'n' ride",
                        "Brisbane Rd at Watson Street",
                        "Brisbane Rd at Eileen Street",
                        "Booval Fair",
                        "Brisbane Rd at Nimmo Street",
                        "Brisbane Rd at Vowles Street",
                        "Brisbane Rd at Bundamba Swimming Centre",
                        "Brisbane Rd at Bundamba Primary",
                        "Brisbane Rd at Bundamba Uniting Church",
                        "Brisbane Rd at TAFE Queensland Ipswich campus",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at Ebbw Vale station",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "River Rd at Dinmore station",
                        "River Rd at King Street",
                        "Riverview Rd at Kenneth Street",
                        "Riverview Rd at Maryanne Street",
                        "Endeavour Rd at Riverview Gardens",
                        "Tessman St near Brian St",
                        "Mitchell St at Tessman Street",
                        "Price St near Hayden St",
                        "Gibbs St near Diamond St",
                        "Diamond St near Valerie St",
                        "Old Ipswich Rd near Laura St",
                        "Old Ipswich Rd at Anderson Street",
                        "Old Ipswich Rd at Ipswich Street",
                        "Old Ipswich Rd at Maxwell Street",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Redbank Plaza",
                        "Collingwood Dr at Old Ipswich Road",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Rd near Irving Ct hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue",
                        "Collingwood Dr near Paul Tully Ave hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "Gibbs Ave near TJ Ryan Ave hail 'n' ride",
                        "Gibbs Ave near Avoca Ct hail 'n' ride",
                        "Gibbs Ave near Genoa Pl hail 'n' ride",
                        "Gibbs Ave near Paul Tully Ave hail 'n' ride",
                        "Paul Tully Ave near Hayden Dr hail 'n' ride",
                        "Paul Tully Ave near Warburton Ct hail 'n' ride",
                        "Paul Tully Ave near Dawson Ct hail 'n' ride",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Redbank Plains Rd at Kingsford Street",
                        "Queen Rd near Azure St hail 'n' ride",
                        "Queen Rd at Marie Street hail 'n' ride",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Brisbane Tce near Layard St hail 'n' ride",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Brisbane River Terraces"
                    ],
                    "6211: Kruger, Redbank, Collingwood Park": [
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Stanley St at Goodna Primary School",
                        "Goodna Shopping Centre",
                        "Smiths Rd at Arne Street",
                        "Smiths Rd near Stephen Cr hail 'n' ride",
                        "Smiths Rd near Bellevue Rd hail 'n' ride",
                        "Smiths Rd at Smiths Road",
                        "Smiths Rd at Redbank Collingwood Park Sports Complex",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Brisbane Rd at Redbank Primary School",
                        "Mine Street at Brisbane Road",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Namatjira Dr at Drysdale Ave hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Kruger Pde at Henderson Street",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Rd near Verran St hail 'n' ride",
                        "Argyle St at Price Close",
                        "Henty Dr at Barnes Street",
                        "Redbank Plains Rd at Brennan Park",
                        "Collingwood Dr at Br Ted Magee Drive",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Collingwood Dr at Gibbs Avenue hail 'n' ride",
                        "Collingwood Dr at Jamboree Park hail 'n' ride",
                        "Burrel St at Collingwood Park Primary",
                        "Hannant St near Stowell St hail 'n' ride",
                        "Lawrie Dr near Whitlam Dr hail 'n' ride",
                        "Goss Dr at Jo Ann Miller Dr hail 'n' ride",
                        "Goss Dr at Hawke Avenue hail 'n' ride",
                        "Collingwood Dr near Paul Tully Ave hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "Gibbs Ave near TJ Ryan Ave hail 'n' ride",
                        "Gibbs Ave near Avoca Ct hail 'n' ride",
                        "Gibbs Ave near Genoa Pl hail 'n' ride",
                        "Gibbs Ave near Paul Tully Ave hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Old Ipswich Rd at Johnstone Place",
                        "Duncan St near Old Ipswich Rd hail 'n' ride",
                        "Old Ipswich Rd at Ipswich Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd near Riverview Primary School",
                        "Old Ipswich Rd near Laura St",
                        "Valerie St near Child St",
                        "Diamond St near Gibbs St",
                        "Price St at Hayden Street",
                        "Mitchell St at Tessman Street",
                        "Tessman St near Brian St hail 'n' ride",
                        "Endeavour Rd at Riverview Gardens",
                        "Riverview Rd at Maryanne Street",
                        "Riverview Rd at Kenneth Street",
                        "Riverview Rd near Jessica St hail 'n' ride",
                        "River Rd at Richard Street"
                    ],
                    "6212: St Marys, St Edmonds, Redbank Plains": [
                        "Ipswich State High School",
                        "Workshops St at Sutton Park",
                        "Albion St at Workshops Street",
                        "Kingsmill Rd near Hancock Bridge hail 'n' ride",
                        "Kingsmill Rd at Robin Street",
                        "Woodend Rd near Macrae St",
                        "Woodend Rd near Hawthorne St hail 'n' ride",
                        "Waghorn St near Arthur St",
                        "Ipswich Boys Grammar School",
                        "Brisbane St at Ipswich City Square",
                        "Ipswich station, stop A",
                        "Elizabeth St at St Mary's Primary School",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Brisbane Rd at Montauban Street",
                        "Frederick St near Glebe St hail 'n' ride",
                        "Walsh St near George St hail 'n' ride",
                        "Blackstone Rd at Frederick Street",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd at Silkstone Primary School",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd near Church St",
                        "Blackstone Rd near Johnston St",
                        "Thomas St at Queen Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Mary St near Hill Street",
                        "Mary St near Edward St hail 'n' ride",
                        "Cedar Rd near Redbank Plains Rd hail 'n' ride",
                        "Cedar Rd near Vicki St hail 'n' ride",
                        "School Rd at Redbank Plains State School",
                        "School Rd near Willow Rd West hail 'n' ride",
                        "Shanahan Pde near Lietzow St hail 'n' ride",
                        "Cedar Rd near Orana St hail 'n' ride",
                        "Kanangra St at Cedar Road",
                        "Kanangra St at Lemana Street",
                        "Kanangra St near Balook St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Keidges Rd near Orana St hail 'n' ride",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Redbank Palms",
                        "Duncan St at Dancer Street",
                        "Collingwood Dr near Manning Ct hail 'n' ride",
                        "Collingwood Dr at Jamboree Park",
                        "Collingwood Rd near Irving Ct hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Kruger Pde at Palm Lake Resort",
                        "Katandra Cr near Jones Rd hail 'n' ride",
                        "Katandra Cr near Beryl Ct hail 'n' ride",
                        "Katandra Cr near Perdita St hail 'n' ride",
                        "Katandra Cr near Rosemary St hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Fiona St near Rita Ct hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Bertha St near Eric St hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Alice St near Martha St hail 'n' ride",
                        "Goodna Shopping Centre"
                    ],
                    "6213: Redbank Plains, Redbank Station": [
                        "Springfield Central State School",
                        "Good Shepherd Catholic Primary School",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High",
                        "Wellness Way at Health Care Dr",
                        "Education City",
                        "Orion Springfield Central",
                        "Eden Station Dr near Brookwater Dr hail 'n' ride",
                        "Augusta Pkwy at Eden Station Drive",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Forester Avenue",
                        "Jones Rd near Augusta Pkwy",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd at Kingsford Street",
                        "Curnow St near Howard St",
                        "Stuart St near Bellevue Rd",
                        "Cross St at Bellevue Road",
                        "Gorry St at Kilner Street",
                        "Gorry St at Dowden Street",
                        "Smiths Rd near Stephen Cr",
                        "Stanley St at Goodna Primary School",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at Brisbane River Terraces"
                    ],
                    "6214: Bremer, Bundamba, Redbank": [
                        "Bremer State High School",
                        "Warwick Rd at Bremer High",
                        "Warwick Rd at Showground",
                        "Salisbury Rd at Thorn Street",
                        "Salisbury Rd near Briggs Rd",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Grange Rd near Edwards St",
                        "Robertson Rd near France St",
                        "Raceview St near Taylor St",
                        "Raceview St at Carlita Place",
                        "Raceview St at Rockman Drive",
                        "Raceview St at Westminister Crescent",
                        "Edwards St near Rockman Dr",
                        "Edwards St near Thornton St",
                        "South Station Rd near Rumsey Dr hail 'n' ride",
                        "Charlotte St near Short St",
                        "Naomai St near Alice St",
                        "Naomai St at Innes Crescent",
                        "Naomai St at Bundamba Secondary College",
                        "Bundamba Secondary College",
                        "Thompson St near Naomi St",
                        "Thompson St near Wise St",
                        "Brisbane Rd at Bundamba Uniting Church",
                        "Brisbane Rd at TAFE Queensland Ipswich campus",
                        "Brisbane Rd at Harold Street",
                        "Brisbane Rd at Ebbw Vale station",
                        "Brisbane Rd at Robert Street",
                        "Brisbane Rd at Dinmore Murri Baptist Church",
                        "River Rd at Dinmore station",
                        "River Rd at King Street",
                        "Riverview Rd at Kenneth Street",
                        "Riverview Rd near Ursula St hail 'n' ride",
                        "Riverview Rd at Maryanne Street",
                        "Endeavour Rd at Riverview Gardens",
                        "Tessman St near Brian St",
                        "Mitchell St at Tessman Street",
                        "Price St near Hayden St",
                        "Gibbs St near Diamond St",
                        "Diamond St near Valerie St",
                        "Old Ipswich Rd near Laura St",
                        "Old Ipswich Rd at Anderson Street",
                        "Nile St near Duncan St hail 'n' ride",
                        "Old Ipswich Rd at Maxwell Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd at Ipswich Street",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Redbank Plaza",
                        "Gorry St at Dowden Street",
                        "Gorry St at Killner Street",
                        "Cross St near Hamar St",
                        "Stuart St at Bellevue Road",
                        "Curnow St near Howard St",
                        "Kingsford St at Howard Street",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Jones Rd near Vanwyk Ct hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Redbank Palms",
                        "Namatjira Dr at Drysdale Avenue",
                        "Mine Street near Brisbane Rd hail 'n' ride"
                    ],
                    "6215: Bremer, Blair State, Ipswich High": [
                        "Bremer State High School",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Meadow Street hail 'n' ride",
                        "Warwick Rd at Ash Street",
                        "Warwick Rd at Hall Street",
                        "Rose St near Tulip St hail 'n' ride",
                        "Cypress St near Jacaranda Dr hail 'n' ride",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Warwick Rd at Meadow Street",
                        "Brisbane St at Tiger Street",
                        "Brisbane St at Clay Street",
                        "Cribb St at Blair State School",
                        "Kingsmill Rd at Robin Street",
                        "Kingsmill Rd near Hancock Bridge hail 'n' ride",
                        "Albion St at Workshops Street",
                        "Workshops St at Sutton Park",
                        "Ipswich State High School",
                        "Burnett St at Blair State School",
                        "Brisbane St at Keogh Street",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Yamanto Shopping Centre",
                        "Cunningham Hwy at Amberley Caravan Park",
                        "Coopers Rd near Willowbank Caravan Park HnR",
                        "Willowbank Dr near McHale Way hail 'n' ride",
                        "Tinworth St near Wigmore St hail 'n' ride",
                        "Sancroft St near Melbury St",
                        "Heit St near Ipswich Rosewood Rd hail 'n' ride"
                    ],
                    "6216: St Marys, St Edmonds, Raceview, Silkstone": [
                        "Elizabeth St at St Mary's Primary School",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Warwick Rd at Short Street",
                        "Carr St at Thorn Street",
                        "Cemetery Rd at Vernon Street",
                        "Cemetery Rd near Briggs Rd hail 'n' ride",
                        "Cemetery Rd near Orchard St",
                        "Cemetery Rd near Whitehill Rd",
                        "Whitehill Rd near McGill St",
                        "Whitehill Rd near Chapel St hail 'n' ride",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Reif St at Fairview Park",
                        "Reif St at Plover Street",
                        "Reif St at Wallace St",
                        "Ripley Rd at Kingston Drive",
                        "Ripley Rd at Hibiscus Street",
                        "Ripley Rd at Edwards Street",
                        "Raceview St at Westminster Crescent",
                        "Raceview St at Rockman Drive",
                        "Cascade St at Bethany Lutheran Primary School",
                        "Wildey St at Raceview Primary School",
                        "Wildey St near Rumsey Dr",
                        "Wildey St near Edwards St hail 'n' ride",
                        "South Station Rd at Harding Street",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Auld St",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd opp Silkstone State School",
                        "Blackstone Rd at Coolibah Street",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Grange Rd near Edwards St",
                        "Robertson Rd near France St",
                        "Raceview St near Taylor St",
                        "Raceview St at Carlita Place",
                        "Raceview St at Westminister Crescent",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Whitehill Rd near Anna Dr hail 'n' ride",
                        "Cemetery Rd near Warner St",
                        "Salisbury Rd near Briggs Rd",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Blackstone Rd at Silkstone Primary School",
                        "Blackstone Rd near Church St",
                        "Blackstone Rd near Johnston St",
                        "Thomas St at Queen Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Mary St near Hill Street"
                    ],
                    "6217: St Marys, St Edmonds, Ipswich, Amberley": [
                        "St Edmunds Secondary College",
                        "Mary St at St Marys Primary School",
                        "Waghorn St near Waghorn St hail 'n' ride",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Warwick Rd at Short Street",
                        "Warwick Rd at Bremer High",
                        "Bremer State High School",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Meadow Street hail 'n' ride",
                        "Deebing Creek Rd at Amberley State School",
                        "Amberley District State School",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Reif St at Fairview Park",
                        "Warwick Rd at Ash Street",
                        "Warwick Rd at Hall Street",
                        "Rose St near Tulip St hail 'n' ride",
                        "Cypress St near Jacaranda Dr hail 'n' ride",
                        "Jacaranda Dr near Aloe St",
                        "Nuala St near Jacaranda Dr",
                        "Tristania St near Ruthven Ct",
                        "Yamanto Shopping Centre",
                        "Cunningham Hwy at Amberley Caravan Park",
                        "Coopers Rd near Willowbank Caravan Park HnR",
                        "Willowbank Dr near McHale Way hail 'n' ride",
                        "Tinworth St near Wigmore St hail 'n' ride",
                        "Sancroft St near Melbury St",
                        "Heit St near Ipswich Rosewood Rd hail 'n' ride"
                    ],
                    "6218: Immaculate Heart, Ipswich High": [
                        "Ipswich State High School",
                        "Workshops St at Sutton Park",
                        "Albion St at Workshops Street",
                        "Kingsmill Rd at Robin Street",
                        "Burnett St at Blair State School",
                        "Brisbane St at Ipswich City Square",
                        "Ipswich station, stop A",
                        "Elizabeth St at St Mary's Primary School",
                        "Waghorn St near Waghorn St hail 'n' ride",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Clay Street",
                        "Omar St at Ipswich West State School",
                        "Leichhardt and One Mile Community Centre",
                        "Old Toowoomba Rd at Immaculate Heart School",
                        "Woodford St near Vineyard St hail 'n' ride",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Peacock St near General Foch St hail 'n' ride",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Gilmore St near Watsonia Dr",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Wulkuraka station",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Fraser St near Everdina St hail 'n' ride",
                        "Kynance St near Maenporth St hail 'n' ride",
                        "Toongarra Rd near Coleman St"
                    ],
                    "6220: Central, Bremer, Silkstone, Raceview": [
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Thorn St near Short St hail 'n' ride",
                        "Thorn St near Moffatt St hail 'n' ride",
                        "Thorn St near Park St hail 'n' ride",
                        "Thorn St near Quarry St hail 'n' ride",
                        "Griffith Rd at Ipswich Central State Primay School",
                        "Blackstone Rd near Cramb St",
                        "Blackstone Rd at Frederick Street",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd at Silkstone Primary School",
                        "Molloy St at Silkstone Primary School",
                        "Cothill Rd at Sacred Heart Catholic Primary",
                        "Stafford St near Videroni St",
                        "Brisbane Rd at Walkers Lane",
                        "Brisbane Rd at Joffre Street",
                        "Brisbane Rd at Hamilton Street",
                        "Booval Fair",
                        "South Station Rd at Ivory Street",
                        "South Station Rd at Long Lane",
                        "South Station Rd near Auld St",
                        "South Station Rd near Morris St",
                        "South Station Rd near Robertson Rd",
                        "South Station Rd near Harding St",
                        "Cascade St near South Station Rd",
                        "Cascade St near Wildey St hail 'n' ride",
                        "Raceview St at Hayes Street",
                        "Cemetery Rd near Raceview St hail 'n' ride",
                        "Cemetery Rd near Whitehill Rd",
                        "Cemetery Rd near Warner St",
                        "Cemetery Rd at Briggs Road",
                        "Carr St at Warwick Road",
                        "Warwick Rd at Bremer High",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Brisbane Street",
                        "Leichhardt and One Mile Community Centre",
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Larsen St at Leichhardt State School",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Fraser St near Everdina St hail 'n' ride",
                        "Toongarra Rd near Coleman St",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Chubb St at Woodford Street",
                        "Old Toowoomba Rd near Immaculate Heart School"
                    ],
                    "6221: St Edmunds, St Marys, Yamanto Deebing Hts": [
                        "St Edmunds Secondary College",
                        "Elizabeth St at St Mary's Primary School",
                        "Ipswich station, stop B",
                        "East St at South Street",
                        "Ipswich Hospital, Stop C",
                        "Warwick Rd at Park Street",
                        "Warwick Rd at Short Street",
                        "Warwick Rd at Bremer High",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Brisbane Street",
                        "Hall St near Berry St hail 'n' ride",
                        "Jacaranda Dr near Nuala St hail 'n' ride",
                        "Jacaranda Dr near Hanworth Dr hail 'n' ride",
                        "Warwick Rd at Yamanto Shopping Centre",
                        "Sovereign Dr near Bottlebrush Dr hail 'n' ride",
                        "Deebing Heights State School",
                        "Kuril Dr near Lakeview Dr hail 'n' ride"
                    ],
                    "6223: West Moreton, Ipswich Girls, Booval": [
                        "Keswick Rd at West Moreton Anglican College",
                        "Toongarra Rd near May St",
                        "Toongarra St at Birrell Street",
                        "Toongarra Rd near Coleman St",
                        "Leichhardt and One Mile Community Centre",
                        "Brisbane St at Hooper Street",
                        "Brisbane St at Tiger Street",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Waghorn Street",
                        "Brisbane St at Ipswich City Square",
                        "Brisbane St near Bell St hail 'n' ride",
                        "Brisbane St at Marsden Parade",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Ipswich Girls Grammar School",
                        "Salisbury Rd near Jackes St",
                        "Salisbury Rd at Thorn Street",
                        "Warwick Rd at Bremer High",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Meadow Street hail 'n' ride",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Whitehill Rd near Anna Dr hail 'n' ride",
                        "Whitehill Rd near McGill St",
                        "Cemetery Rd near Edinburgh St hail 'n' ride",
                        "Raceview St at Carlita Place",
                        "Raceview St at Rockman Drive",
                        "Raceview St at Westminister Crescent",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive"
                    ],
                    "6224: Goodna,St Augustines College, Forest Lake": [
                        "St Augustines College",
                        "Stanley St at Goodna Primary School",
                        "Augusta Pkwy at Saint Augustines College",
                        "Smiths Rd at Arne Street",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Smiths Rd near Stephen Cr hail 'n' ride",
                        "Garden Rd at Government Road",
                        "Smiths Rd near Bellevue Rd hail 'n' ride",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Smiths Rd hail 'n' ride",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Gorry St at Dowden Street",
                        "Gorry St at Killner Street",
                        "Woogaroo St at Forest Lake Primary",
                        "Cross St near Hamar St",
                        "Woogaroo St at Lochwood Ave",
                        "Grand Ave West near Centennial Way",
                        "Stuart St at Bellevue Road",
                        "Curnow St near Howard St",
                        "Grand Ave at Grand Avenue School",
                        "Grand Ave at Grand Avenue Lake",
                        "Kingsford St at Howard Street",
                        "Grand Ave at Grand Avenue Cascade",
                        "Redbank Plains Rd at Caldwell Street",
                        "Grand Ave East near Ascot Ave",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Forest Lake Shops",
                        "College Ave at Hillbrook",
                        "Redbank Plains Rd at Brennan Street",
                        "College Ave at Halifax Court",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Joseph Banks Ave near Leichhardt Cct",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Redbank Plains Rd at Shannon Street",
                        "Forest Lake Bvd at St Johns Anglican College",
                        "Redbank Plains Rd at Highbury Dr",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Redbank Plains Town Square, stop B",
                        "Jones Rd near Augusta Pkwy"
                    ],
                    "6225: Bremer, Bundamba": [
                        "Bremer State High School",
                        "Warwick Rd at Bremer High",
                        "Warwick Rd at Showground",
                        "Thorn St near Short St hail 'n' ride",
                        "Thorn St near Moffatt St hail 'n' ride",
                        "Thorn St near Park St hail 'n' ride",
                        "Thorn St near Quarry St hail 'n' ride",
                        "Griffith Rd at Ipswich Central State Primay School",
                        "Marvin St near Olmai Ave",
                        "Marvin St near Grange Rd",
                        "Grange Rd at Silkstone Village Shopping Centre HnR",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd at Silkstone Primary School",
                        "Molloy St at Silkstone Primary School",
                        "South Station Rd at Long Lane",
                        "South Station Rd near Auld St",
                        "South Station Rd near Morris St",
                        "South Station Rd near Robertson Rd",
                        "Wildey St at Brothers Leagues Club",
                        "Wildey St near Nolan St",
                        "Nolan St near South Station Rd",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Ivory St",
                        "Booval Fair",
                        "Brisbane Rd at Nimmo Street",
                        "Brisbane Rd at Vowles Street",
                        "Brisbane Rd at Bundamba Swimming Centre",
                        "Brisbane Rd at Bundamba Primary"
                    ],
                    "6226: Ipswich Boys, Ipswich Girls, St Marys": [
                        "St Edmunds Secondary College",
                        "Mary St at St Marys Primary School",
                        "Waghorn St near Waghorn St hail 'n' ride",
                        "Brisbane St at Ipswich City Square",
                        "Brisbane St near Bell St hail 'n' ride",
                        "Brisbane St at Marsden Parade",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Frederick St near Glebe St hail 'n' ride",
                        "Blackstone Rd at Frederick Street",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd at Silkstone Primary School",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd near Church St",
                        "Blackstone Rd near Johnston St",
                        "Thomas St at Queen Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Mary St near Hill Street",
                        "Mary St near Edward St hail 'n' ride",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop C",
                        "Jones Rd near Augusta Pkwy",
                        "Augusta Pkwy at Forester Avenue",
                        "Augusta Pkwy near Grangewood Ave hail 'n' ride",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Orion Springfield Central",
                        "Springfield Pwy at Escarpment Drive",
                        "Spring Lake Village 1",
                        "Springfield Lakes Bvd at Springfield Lakes Shops",
                        "Spring Lake Village 4",
                        "Springfield Pkwy at Springfield Greenbank Arterial",
                        "Springfield Pkwy at Panorama Drive",
                        "Springfield Pkwy at Springfield Fair",
                        "Springfield Pkwy at Bob Gibbs Park hail 'n' ride",
                        "Old Logan Rd near Brendan St West hail 'n' ride",
                        "Kertes Rd at Pharoah Street",
                        "Fran St near Jean Rd",
                        "Angela St near Allan Rd hail 'n' ride",
                        "Angela St near Moss Rd",
                        "Ishmael Rd near Dale Rd",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Addison Rd near Ishmael Rd hail 'n' ride",
                        "Addison Rd near Allamanda Dr hail 'n' ride",
                        "Blue Gum Dr near Addison Rd hail 'n' ride",
                        "Garden Ave near Cochrane St hail 'n' ride",
                        "Cochrane St near Ishmael Rd",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Old Logan Rd hail 'n' ride",
                        "Old Logan Rd near Stella St hail 'n' ride",
                        "Cairns Rd near Old Logan Rd hail 'n' ride",
                        "Cairns Rd near Meier Rd hail 'n' ride",
                        "Hayes Ave near Woodlands Ave hail 'n' ride",
                        "Woodlands Ave near Hallett Ave hail 'n' ride",
                        "Woodlands Ave near Old Logan Rd hail 'n' ride",
                        "Old Logan Rd near Lacey St hail 'n' ride",
                        "Old Logan Rd near Hallett Ave",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd near Vanessa Ct",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Julieanne Street",
                        "Newman St near Caswell St hail 'n' ride",
                        "Newman St near Dulin St hail 'n' ride",
                        "Newman St near Killalan St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Alice St near Allan St hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Alice St near Martha St hail 'n' ride",
                        "Queen Street near Little Street hail 'n' ride",
                        "Goodna station, stop A"
                    ],
                    "6227: Goodna, St Francis Xavier, Camira": [
                        "Springfield Central State School",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central State High",
                        "Good Shepherd Catholic Primary School",
                        "The Good Shepherd Catholic Primary School",
                        "Grande Ave at Angelica Avenue",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Oak Leaf Dr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Lakes Entrance Drive at Shearwater Tce",
                        "Springfield Lakes Bvd at Lakes Entrance Drive",
                        "Springfield Lakes Bvd at Parkview Drive",
                        "Summit Dr near Lakeside Ave",
                        "Summit Dr near Liberty Cr",
                        "Springfield Lakes Bvd near Summit Dr hail 'n' ride",
                        "Springfield Lakes Bvd at Springfield Lakes State",
                        "Spring Lake Village 4",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "St Augustines College",
                        "Leon Capra Dr near Arnaldo Ave hail 'n' ride",
                        "Augusta Pkwy at Forester Avenue",
                        "Jones Rd near Augusta Pkwy",
                        "Keidges Rd at Harry Street",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Kanangra St at Balook Street",
                        "Kanangra St near Lemana St",
                        "Kanangra St at Cedar Road",
                        "Alawoona St near Cedar Rd hail 'n' ride",
                        "Alawoona St near Dandenong Av hail 'n' ride",
                        "Alawoona St at Ingles Drive",
                        "Ingles Dr at McNamara Place",
                        "Fernbrooke Bvd at Ingles Drive",
                        "School Rd near Fernbrooke Bvd",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Cedar Rd at Kentucky Street",
                        "Redbank Plains Recreation Reserve",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Redbank Palms",
                        "Duncan St at Dancer Street",
                        "Collingwood Dr at Old Ipswich Road",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6228: Woodcrest, Springfield Lakes, Redbank": [
                        "Woodcrest College",
                        "Springfield Pkwy at Bob Gibbs Park hail 'n' ride",
                        "Springfield Pkwy at Springfield Fair hail 'n' ride",
                        "Springfield Pkwy at Panorama Drive",
                        "Springfield Pwy at Escarpment Drive",
                        "Spring Lake Village 1",
                        "Lakeside Ave near Burlington Tce",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Janus Gr",
                        "Lakeside Ave near Coventina Cr",
                        "Summit Dr near Lakeside Ave",
                        "Summit Dr near Liberty Cr",
                        "Springfield Lakes Bvd near Summit Dr hail 'n' ride",
                        "Springfield Lakes Bvd at Springfield Lakes State",
                        "Spring Lake Village 4",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "St Augustines College",
                        "Leon Capra Dr near Arnaldo Ave hail 'n' ride",
                        "Augusta Pkwy at Forester Avenue",
                        "Bellbird Dr near Columbia Dr hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Redbank Plains Rd at Kingsford Street",
                        "Queen Rd near Azure St hail 'n' ride",
                        "Queen Rd at Marie Street hail 'n' ride",
                        "Queen Street near Little Street hail 'n' ride",
                        "Goodna station, stop A",
                        "Alice St near Parker St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Newman St near Mirrin St hail 'n' ride",
                        "Newman St near Braggan St hail 'n' ride",
                        "Newman St near Globe St hail 'n' ride",
                        "Brisbane Tce near Layard St",
                        "Brisbane Tce near Layard St hail 'n' ride",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at Brisbane River Terraces",
                        "Westside Depot"
                    ],
                    "6229: Woodcrest College, Camira, Goodna Station": [
                        "Stanley St at Goodna Primary School",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Alice St near Parker St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Newman St near Mirrin St hail 'n' ride",
                        "Newman St near Braggan St hail 'n' ride",
                        "Newman St near Globe St hail 'n' ride",
                        "Old Logan Rd at Julieanne Street",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Vanessa Court",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd at Hallett Avenue",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Ishmael Rd",
                        "Czarnecki St near Lowana St hail 'n' ride",
                        "Czarnecki St near Odra St hail 'n' ride",
                        "Garden Ave near Cochrane St hail 'n' ride",
                        "Blue Gum Dr near Addison Rd hail 'n' ride",
                        "Addison Rd near Allamanda Dr hail 'n' ride",
                        "Addison Rd near Ishmael Rd hail 'n' ride",
                        "Old Logan Rd at Langley Road hail 'n' ride",
                        "Old Logan Rd near Dale Rd hail 'n' ride",
                        "Old Logan Rd near Allan Rd hail 'n' ride",
                        "Old Logan Rd near Steven St hail 'n' ride",
                        "Old Logan Rd near Nev Smith Dr hail 'n' ride",
                        "Woodcrest College",
                        "Woodcrest Way near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Karamea Ave near Bridgewater Rd",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Springfield Pwy at Springfield Greenbank Art",
                        "Springfield Pwy at Escarpment Drive",
                        "Springfield Pkwy at Springfield Greenbank Arterial",
                        "Hymba Yumba Community Hub (Springfield) HnR",
                        "Springfield Pkwy at Panorama Drive",
                        "Topaz Rd at Springfield Fair",
                        "Topaz Rd near Sharpless Rd",
                        "Sharpless Rd near Tourmaline St",
                        "Mur Bvd near Old Logan Rd",
                        "Kertes Rd at Pharoah Street",
                        "Kertes Rd near Shiral Ct hail 'n' ride",
                        "Wilson Dr near Kertes Rd hail 'n' ride",
                        "Wilson Dr near Corial Ct hail 'n' ride",
                        "Wilson Dr near Durham Ct hail 'n' ride",
                        "Wilson Dr near Paula Ct hail 'n' ride",
                        "Wilson Dr near Myra Ct hail 'n' ride",
                        "Fran St near Jean Rd",
                        "Angela St near Allan Rd hail 'n' ride",
                        "Angela St near Moss Rd",
                        "Ishmael Rd near Dale Rd",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Cairns Rd near Old Logan Rd hail 'n' ride",
                        "Cairns Rd near Meier Rd hail 'n' ride",
                        "Hayes Ave near Woodlands Ave hail 'n' ride",
                        "Woodlands Ave near Hallett Ave hail 'n' ride",
                        "Woodlands Ave near Old Logan Rd hail 'n' ride",
                        "Addison Rd near Tudor St hail 'n' ride",
                        "Cochrane St near Old Logan Rd hail 'n' ride",
                        "Old Logan Rd near Hallett Ave",
                        "Old Logan Rd near Vanessa Ct",
                        "Baker St at Fiesta Caravan Park hail 'n' ride",
                        "Hogan St near Nagel St hail 'n' ride",
                        "Hogan St near Karina St hail 'n' ride",
                        "Karina St near Nagel St hail 'n' ride",
                        "Ashworth St near Connell St hail 'n' ride",
                        "Marshall St near Old Logan Rd hail 'n' ride",
                        "Newman St near Caswell St hail 'n' ride",
                        "Newman St near Dulin St hail 'n' ride",
                        "Newman St near Killalan St hail 'n' ride",
                        "Alice St near Allan St hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Alice St near Martha St hail 'n' ride",
                        "Queen Street near Little Street hail 'n' ride",
                        "Goodna station, stop A",
                        "Brisbane Tce near Layard St hail 'n' ride",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at Brisbane River Terraces"
                    ],
                    "6230: Camira, Woodcrest, Redbank Plains, St Aug": [
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd near Stella St hail 'n' ride",
                        "Old Logan Rd at Langley Road hail 'n' ride",
                        "Old Logan Rd near Dale Rd hail 'n' ride",
                        "Old Logan Rd near Allan Rd hail 'n' ride",
                        "Old Logan Rd near Steven St hail 'n' ride",
                        "Old Logan Rd near Brendan St West hail 'n' ride",
                        "Old Logan Rd near Nev Smith Dr hail 'n' ride",
                        "Woodcrest College",
                        "Woodcrest Way near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Karamea Ave near Bridgewater Rd",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Springfield Pkwy at Panorama Drive",
                        "Springfield Pkwy at Springfield Fair",
                        "Springfield Pkwy at Bob Gibbs Park hail 'n' ride",
                        "Old Logan Rd near Meier Rd hail 'n' ride",
                        "Old Logan Rd near Hallett Ave",
                        "Old Logan Rd near Vanessa Ct",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Julieanne Street",
                        "Newman St near Caswell St hail 'n' ride",
                        "Newman St near Dulin St hail 'n' ride",
                        "Newman St near Killalan St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Alice St near Allan St hail 'n' ride",
                        "Alice St near Jo St hail 'n' ride",
                        "Alice St near Martha St hail 'n' ride",
                        "Queen Rd at Marie Street hail 'n' ride",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Redbank Plains Rd at Brennan Street",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School"
                    ],
                    "6231: Augusta, Redbank Plains SHS, St Augustine": [
                        "Brittains Rd at Augusta State School",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Alawoona St near Barkala St hail 'n' ride",
                        "Alawoona St near Lemana St hail 'n' ride",
                        "Alawoona St near Cedar Rd hail 'n' ride",
                        "Ingles Dr at McNamara Place",
                        "Fernbrooke Bvd at Ingles Drive",
                        "School Rd near Fernbrooke Bvd",
                        "School Rd at Alawoona Street",
                        "School Rd at Redbank Plains State School",
                        "Vicki St at School Road",
                        "Vicki St near Jane St",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Bellbird Dr near Columbia Dr hail 'n' ride",
                        "Brookwater Dr at Forester Avenue hail 'n' ride",
                        "St Augustines College",
                        "Santa Monica Dr near Leon Capra Dr hail 'n' ride",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Orion Springfield Central",
                        "Eden Station Dr near Brookwater Dr hail 'n' ride",
                        "Augusta Pkwy at Eden Station Drive",
                        "Santa Monica Dr near McAuley Cr",
                        "Santa Monica Dr near Christopher St hail 'n' ride",
                        "Santa Monica Dr near Hallow Cr",
                        "Santa Monica Dr near Oudeman St",
                        "Santa Monica Dr near Ambrose Dr",
                        "Santa Monica Dr at Oudeman Street",
                        "Santa Monica Dr near Mcauley Cr",
                        "Augusta Pkwy at Forester Avenue",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd at Harris St hail 'n' ride",
                        "Jones Rd at Nugent Street hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Katandra Cr near Jones Rd hail 'n' ride",
                        "Katandra Cr near Beryl Ct hail 'n' ride",
                        "Katandra Cr near Perdita St hail 'n' ride",
                        "Katandra Cr near Rosemary St hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Fiona St near Rita Ct hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Bertha St near Eric St hail 'n' ride",
                        "Goodna station, stop A"
                    ],
                    "6232: Forest Lake, St Marks, Inala, Glenala": [
                        "High St at Forest Lake High School",
                        "Grand Ave East near Ascot Ave",
                        "Grand Ave at Grand Avenue Cascade",
                        "Grand Ave at Grand Avenue Lake",
                        "Grand Ave at Grand Avenue School",
                        "Grand Ave West near Centennial Way",
                        "Roxwell St at Lovat Street",
                        "Roxwell Street near Bagnall St",
                        "Sinclair Dr at Julie Road",
                        "Doreen Crescent near Southampton Rd",
                        "Doreen Cr at Southampton Road",
                        "Southampton Rd at Doreen Crescent",
                        "John Street near Julie Rd",
                        "David St near Stephen St hail 'n' ride",
                        "Muriel Ave at Stephen Street",
                        "Waterford Rd at Carole Park Primary School",
                        "Clendon St near Waterford Rd hail 'n' ride",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Government Rd near Flower Pl",
                        "Government Rd near Archerfield Rd, stop 75",
                        "Poinsettia St near Archerfield Rd, stop 76",
                        "Poinsettia St at Richlands Campus, stop 59/77",
                        "Hydrangea St near Frangipani St, stop 59",
                        "Eucalypt St opp St Marks Catholic Primary School",
                        "Balsa St at Biota St, stop 67",
                        "Balsa St at Balsa - Ebony, stop 68",
                        "Rosemary St at Holly St, stop 74",
                        "Rosemary St at Inala School, stop 75",
                        "Glenala High School",
                        "Glenala Rd at Glenala East, stop 71",
                        "Akama Rd at Akama Central Stop 73",
                        "Akama Rd at Akama South Stop 74",
                        "Durella St at Durella East, stop 75",
                        "Durella St at Durella West, stop 76",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Inala Ave at Gannett Street, stop 79/57",
                        "Inala Ave at Poinsettia Street, stop 78/58",
                        "Poinsettia St at Richlands Campus, stop 77/59",
                        "Poinsettia St near Mira St, stop 76",
                        "Government Rd near Rudyard St, stop 75",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Forest Lake Bvd at Forest Lake Shops",
                        "Goodna station, stop A"
                    ],
                    "6233: Redbank Plains, Sprinfield Lakes, Camira": [
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Henty Dr at Kruger Parade",
                        "Henty Dr at Batman Drive",
                        "Henty Dr near Kennedy Dr hail 'n' ride",
                        "Henty Dr near Evergreen Pl hail 'n' ride",
                        "Henty Dr at Ropati Street",
                        "Glen Brae St near Frawley Dr hail 'n' ride",
                        "School Rd at Redbank Plains State School",
                        "School Rd near Willow Rd West hail 'n' ride",
                        "School Rd near Alawoona St hail 'n' ride",
                        "Alawoona St near Keidges Rd hail 'n' ride",
                        "St Augustines College",
                        "Santa Monica Dr near Leon Capra Dr hail 'n' ride",
                        "Augusta Pkwy at Saint Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Sinnathamby Bvd near Main St hail 'n' ride",
                        "Spring Mountain Bvd at London Avenue",
                        "Spring Mountain Bvd at Grande Ave",
                        "Grande Ave at Sierra Drive",
                        "Grande Ave at Applecross Cct",
                        "Grande Ave at Dublin Ave",
                        "Grande Ave at Woodline Drive",
                        "Grande Ave at Angelica Avenue",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Oak Leaf Dr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Drive at Shearwater Tce",
                        "Springfield Lakes Bvd at Lakes Entrance Drive",
                        "Springfield Lakes Bvd at Parkview Drive",
                        "Springfield Lakes Bvd near Greentrees Tce",
                        "Summit Dr near Liberty Cr",
                        "Summit Dr near Lakeside Ave",
                        "Lakeside Ave near Diana St",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Burlington Tce",
                        "Spring Lake Village 4",
                        "Springfield Pkwy at Springfield Greenbank Arterial",
                        "Hymba Yumba Community Hub (Springfield) HnR",
                        "Springfield Pkwy at Panorama Drive",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Karamea Ave near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Woodcrest Way near Millwood Tce",
                        "Woodcrest Way at Nev Smith Drive",
                        "Topaz Rd at Springfield Fair",
                        "Topaz Rd near Sharpless Rd",
                        "Sharpless Rd near Tourmaline St",
                        "Mur Bvd near Old Logan Rd",
                        "Kertes Rd at Pharoah Street",
                        "Fran St near Jean Rd",
                        "Angela St near Allan Rd hail 'n' ride",
                        "Angela St near Moss Rd",
                        "Ishmael Rd near Dale Rd",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Cochrane St near Ishmael Rd",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Old Logan Rd hail 'n' ride",
                        "Old Logan Rd near Lacey St hail 'n' ride",
                        "Old Logan Rd near Hallett Ave",
                        "Old Logan Rd at Camira Primary School"
                    ],
                    "6234: Redbank Plains, Redbank Plaza, Dinmore": [
                        "Woogaroo Creek State School",
                        "Willow Rd at Redbank Plains High School",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd at Kingsford Street",
                        "Curnow St near Howard St",
                        "Stuart St near Bellevue Rd",
                        "Cross St at Bellevue Road",
                        "Gorry St at Kilner Street",
                        "Gorry St at Dowden Street",
                        "Dowden St near Gorry St hail 'n' ride",
                        "Smiths Rd near Stephen Cr",
                        "Alice St near Albert Street hail 'n' ride",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Goodna Shopping Centre",
                        "Smiths Rd at Arne Street",
                        "Redbank Plaza",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Old Ipswich Rd at Johnstone Place",
                        "Duncan St near Old Ipswich Rd hail 'n' ride",
                        "Riverview St near Nile St hail 'n' ride",
                        "Old Ipswich Rd at Ipswich Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd near Riverview Primary School",
                        "Old Ipswich Rd near Laura St",
                        "Valerie St near Child St",
                        "Diamond St near Gibbs St",
                        "Price St at Hayden Street",
                        "Mitchell St at Tessman Street",
                        "Tessman St near Brian St hail 'n' ride",
                        "Endeavour Rd at Riverview Gardens",
                        "Riverview Rd at Maryanne Street",
                        "Riverview Rd at Kenneth Street",
                        "River Rd at Richard Street",
                        "River Rd near King St hail 'n' ride",
                        "River Rd at Dinmore station"
                    ],
                    "6235: St Augustine's - Springfield Central": [
                        "St Augustines College",
                        "Augusta Pkwy at Brookwater Golf Club",
                        "Augusta Pkwy at Eden Station Drive",
                        "Eden Station Dr near Brookwater Dr hail 'n' ride",
                        "Springfield Central station, stop A",
                        "Spring Mountain Bvd at London Avenue",
                        "Spring Mountain Bvd at Grande Ave",
                        "Grande Ave at Sierra Drive",
                        "Grande Ave at Applecross Cct",
                        "Grande Ave at Dublin Ave",
                        "Grande Ave at Woodline Drive",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central Bvd",
                        "Springfield Greenbank Art near Springfield Central Bvd HnR"
                    ],
                    "6236: Springfield Central, Springfield Lakes": [
                        "Springfield Central State High",
                        "Summit Dr near Liberty Cr",
                        "Summit Dr near Lakeside Ave",
                        "Lakeside Ave near Diana St",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Burlington Tce",
                        "Spring Lake Village 4"
                    ],
                    "6237: Bremer, Ipswich High, Brassall Primary": [
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Warwick Rd at Showground North",
                        "Leichhardt and One Mile Community Centre",
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Gilmore St near Watsonia Dr",
                        "Avon St at Larsen St",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Fraser St near Everdina St hail 'n' ride",
                        "Kynance St near Maenporth St hail 'n' ride",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Brisbane St at Hooper Street",
                        "Brisbane St at Tiger Street",
                        "Brisbane St at Clay Street",
                        "Burnett St at Blair State School",
                        "Kingsmill Rd at Robin Street",
                        "Albion St at Workshops Street",
                        "Hunter St at Brassall Shopping Village",
                        "Hunter St at Ipswich State High School",
                        "Pine Mountain Rd at Brassall Primary School",
                        "Pine Mountain Rd at Glossop Street",
                        "Waterworks Rd at Simmons Road",
                        "Holmes St near Holdsworth St hail 'n' ride",
                        "Holdsworth Rd near Paten St",
                        "Holdsworth Rd near Roberts St",
                        "Allen St near Francis St",
                        "Cyprus St at Allen Street",
                        "Cyprus St at Hefferan Street",
                        "Hill St at Cyprus Street",
                        "Hill St near Phie St",
                        "Moores Pocket Rd near Wood St",
                        "Moores Pocket Rd at Tivoli Gardens",
                        "Moores Pocket Rd at Bremer Waters Village",
                        "Moores Pocket Rd at Bremer Waters Resort",
                        "Moores Pocket Rd at Bremer Waters",
                        "Mount Crosby Rd near Tantivy St hail 'n' ride",
                        "Mount Crosby Rd at Ipswich Caravan Village",
                        "Mount Crosby Rd at Tivoli State School",
                        "Mount Crosby Rd near roundabout hail 'n' ride"
                    ],
                    "6238: St Marys, St Edmonds, Ips Boys, Churchill": [
                        "Elizabeth St at St Mary's Primary School",
                        "Waghorn St near Waghorn St hail 'n' ride",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Warwick Rd at Short Street",
                        "Bremer State High School",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Meadow Street hail 'n' ride",
                        "Deebing Creek Rd at Amberley State School",
                        "Deebing Creek Rd near Connemara Ct hail 'n' ride",
                        "Deebing Creek Rd near Quando Cl",
                        "Equestrian Dr near Mustang St",
                        "Equestrian Dr near Arabian Cl",
                        "Bladon St near Blenheim Ct",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre",
                        "Reif St at Fairview Park",
                        "Reif St at Plover Street",
                        "Reif St at Wallace St",
                        "Ripley Rd at Kingston Drive",
                        "Ripley Rd at Hibiscus Street",
                        "Ripley Rd at Edwards Street",
                        "Raceview St at Westminster Crescent",
                        "Raceview St at Rockman Drive",
                        "Cemetery Rd near Raceview St hail 'n' ride",
                        "Cemetery Rd near Whitehill Rd",
                        "Cemetery Rd near Warner St",
                        "Cemetery Rd at Briggs Road",
                        "Warwick Rd at Showground North"
                    ],
                    "6239: Bremer, Churchill, Yamanto, Deebing Heights": [
                        "Bremer State High School",
                        "Warwick Rd at Perry Street",
                        "Warwick Rd at Balaclava Street",
                        "Warwick Rd at Brisbane Street",
                        "Warwick Rd at Fitzroy Street",
                        "Warwick Rd at Winston Street",
                        "Warwick Rd at Meadow Street hail 'n' ride",
                        "Deebing Creek Rd at Amberley State School",
                        "Amberley District State School",
                        "Kuril Dr near Lakeview Dr HnR",
                        "Kuril Dr near Lakeview Dr hail 'n' ride",
                        "Sovereign Dr near Bottlebrush Dr hail 'n' ride",
                        "Deebing Heights State School",
                        "Winland Dr near Tenville Ct hail 'n' ride",
                        "Newsky Ct near Winland Dr hail 'n' ride",
                        "Winland Dr near Chilton Ct hail 'n' ride"
                    ],
                    "6240: Brassall, Ipswich, St Marys, St Edmunds": [
                        "Pine Mountain Rd at Brassall Primary School",
                        "Ipswich State High School",
                        "Haig St near Vogel Rd hail 'n' ride",
                        "Haig St near Hunter St hail 'n' ride",
                        "Hunter St at Brassall Shopping Village",
                        "Albion St at Workshops Street",
                        "Kingsmill Rd at Robin Street",
                        "Cribb St at Blair State School",
                        "Waghorn St at Ipswich Grammar School",
                        "Elizabeth St at St Mary's Primary School",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Leichhardt and One Mile Community Centre",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Woodford St near Vineyard St hail 'n' ride",
                        "Old Toowoomba Rd near Immaculate Heart School",
                        "Kynance St near Coverack St hail 'n' ride",
                        "Coverack St near Kynance St hail 'n' ride",
                        "Everdina St near Toongarra Rd hail 'n' ride",
                        "Toongarra St at Birrell Street",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St"
                    ],
                    "6241: Ipswich Central, Bremer, Raceview": [
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Thorn St near Short St hail 'n' ride",
                        "Thorn St near Moffatt St hail 'n' ride",
                        "Thorn St near Park St hail 'n' ride",
                        "Thorn St near Quarry St hail 'n' ride",
                        "Griffith Rd at Ipswich Central State Primay School",
                        "Cemetery Rd near Warner St",
                        "Edwards St near Whitehill Rd hail 'n' ride",
                        "Raceview St at Westminster Crescent",
                        "Raceview St at Rockman Drive",
                        "Cascade St at Bethany Lutheran Primary School",
                        "Wildey St at Raceview Primary School",
                        "Wildey St near Rumsey Dr",
                        "Wildey St near Edwards St hail 'n' ride",
                        "Edwards St near Thornton St",
                        "Edwards St near Rockman Dr",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Ash St at Winston Glades Shopping Centre",
                        "Ash St at Kensington Drive",
                        "Bladon St near Blenheim Cr",
                        "Equestrian Dr near Arabian Cl",
                        "Equestrian Dr near Mustang St",
                        "Deebing Creek Rd near Sandalwood Dr",
                        "Deebing Creek Rd near Redwood Pl hail 'n' ride",
                        "Deebing Creek Rd at Amberley State School",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "South Station Rd near Rumsey Dr hail 'n' ride",
                        "Harper St near Bligh St hail 'n' ride",
                        "Sussex St near Swanbank Rd hail 'n' ride"
                    ],
                    "6242: Kruger, Goodna, Redbank Plains, Redbank": [
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Redbank Plains Rd at Kingsford Street",
                        "Queen Rd near Azure St hail 'n' ride",
                        "Queen Rd at Marie Street hail 'n' ride",
                        "Queen Street near Little Street hail 'n' ride",
                        "Goodna Shopping Centre",
                        "Stanley St at Goodna Primary School",
                        "St Francis Xavier Catholic Primary School",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Bertha St near Eric St hail 'n' ride",
                        "Fiona St near Surrey Rd hail 'n' ride",
                        "Fiona St near Rita Ct hail 'n' ride",
                        "Fiona St near Rosemary St hail 'n' ride",
                        "Katandra Cr near Rosemary St hail 'n' ride",
                        "Katandra Cr near Perdita St hail 'n' ride",
                        "Katandra Cr near Beryl Ct hail 'n' ride",
                        "Katandra Cr near Jones Rd hail 'n' ride",
                        "Redbank Plains Rd at Brennan Street",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Highbury Dr",
                        "Redbank Plains Rd near Verran St hail 'n' ride",
                        "Redbank Plains Town Square, stop B",
                        "Keidges Rd at Harry Street",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Redbank Palms",
                        "Namatjira Dr at Drysdale Avenue",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Hannant St near Stowell St hail 'n' ride",
                        "Lawrie Dr near Whitlam Dr hail 'n' ride",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6245: Bundamba College, Silkstone, Bremer": [
                        "Bundamba Secondary College",
                        "Naomai St at Innes Crescent",
                        "Naomai St at Alice Street",
                        "William St near Charlotte St",
                        "Mary St at Blackstone Primary School",
                        "Mary St near Hill Street",
                        "Thomas St at Queen Street",
                        "Creek St near Blackstone Rd",
                        "Stafford St near Chilcott St",
                        "Glebe Rd near Cothill St",
                        "Cothill Rd at Sacred Heart Catholic Primary",
                        "Glebe Rd at Silkstone Primary School",
                        "Whitehill Rd near Raff St",
                        "Whitehill Rd near George Lane hail 'n' ride",
                        "Salisbury Rd near Jackes St",
                        "Salisbury Rd at Thorn Street",
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Salisbury Rd near Briggs Rd",
                        "Robertson Rd near Whitehill Rd",
                        "South Station Rd at Robertson Road",
                        "South Station Rd near Trumpy St",
                        "South Station Rd near Auld St",
                        "Blackstone Rd near Heather St",
                        "Blackstone Rd at Coolibah Street",
                        "Blackstone Rd near Frederick St",
                        "Blackstone Rd near Whitehill Rd",
                        "Chermside Rd at Fifer Street",
                        "Cemetery Rd near Whitehill Rd",
                        "Whitehill Rd near McGill St",
                        "Whitehill Rd near Chapel St hail 'n' ride",
                        "Ripley Rd at Edwards Street",
                        "Ripley Rd at Kingston Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Ash St at Winston Glades Shopping Centre",
                        "Ash St at Kensington Drive",
                        "Bladon St near Blenheim Cr",
                        "Equestrian Dr near Arabian Cl",
                        "Equestrian Dr near Mustang St",
                        "Deebing Creek Rd near Sandalwood Dr",
                        "Deebing Creek Rd at Amberley State School",
                        "Warwick Rd at Ash Street",
                        "Warwick Rd at Hall Street",
                        "Jacaranda Dr near Rose St",
                        "Jacaranda Dr near Nuala St hail 'n' ride",
                        "Yamanto Shopping Centre"
                    ],
                    "6246: Ripley Valley SS, Ripley Rd, Rex Hills Dr": [
                        "Providence Pde at Ripley Valley School",
                        "Parkway Ave hail 'n' ride",
                        "Parkway Ave near Lomond St hail 'n' ride",
                        "Watheroo St near Herberton Rd hail 'n' ride",
                        "Lashmar St near Wyperfeld Cres hail 'n' ride",
                        "Parkway Ave at Ripley Valley Schools",
                        "Greenview Av near Wallaman St hail 'n' ride",
                        "Morwell St near Eildon St hail 'n' ride",
                        "Fitzgibbon Rd near Joy Chambers Cct hail 'n' ride",
                        "Panorama Cct near Edinburgh St hail 'n' ride",
                        "Tuckeroo St near Parkview Pde hail 'n' ride",
                        "Brooking Ave near Parkview Pde hail 'n' ride",
                        "Parkview Pde near Lillypilly Dr hail 'n' ride",
                        "Ripley Rd at Canary St",
                        "Ripley Rd at Trigona Drive"
                    ],
                    "6247: Ipswich High, Bremer State High": [
                        "Hunter St at Ipswich State High School",
                        "Pine Mountain Rd at Brassall Primary School",
                        "Pine Mountain Rd at Glossop Street",
                        "Pine Mountain Rd at Cushing Street",
                        "Pine Mountain Rd near Carter St",
                        "Pine Mountain Rd near McLean St",
                        "Downs St at Ferguson Street",
                        "Downs St at Fitzgibbon Street",
                        "Downs St at Browns Park",
                        "Riverlink, Stop B",
                        "Ipswich station, stop A",
                        "Elizabeth St at St Mary's Primary School",
                        "Waghorn St near Waghorn St hail 'n' ride",
                        "Darling St East at Ipswich Grammar School",
                        "Brisbane St at Waghorn Street",
                        "Brisbane St at Ipswich City Square",
                        "East St at South Street",
                        "Ipswich Hospital, Stop C",
                        "Warwick Rd at Park Street",
                        "Warwick Rd at Short Street",
                        "Bremer State High School",
                        "Warwick Rd at Showground",
                        "Carr St at Thorn Street",
                        "Cemetery Rd at Vernon Street",
                        "Cemetery Rd near Orchard St",
                        "Cemetery Rd near Whitehill Rd",
                        "Whitehill Rd near McGill St",
                        "Whitehill Rd near Chapel St hail 'n' ride",
                        "Whitehill Rd near Thomas St hail 'n' ride",
                        "Reif St at Fairview Park",
                        "Reif St at Plover Street",
                        "Reif St at Wallace St",
                        "Ripley Rd at Kingston Drive",
                        "Ripley Rd at Hibiscus Street",
                        "Ripley Rd at Edwards Street",
                        "Raceview St at Westminster Crescent",
                        "Raceview St at Rockman Drive",
                        "Cascade St at Bethany Lutheran Primary School",
                        "Cascade St near Wildey St",
                        "Cascade St near South Station Rd",
                        "Harper St near Bligh St hail 'n' ride",
                        "Sussex St near Swanbank Rd hail 'n' ride",
                        "Melrose Dr at Rourke Park hail 'n' ride",
                        "Douglas St near East Saunders St hail 'n' ride"
                    ],
                    "6248: Bellbird Park College - Redbank Station": [
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Columbia Dr near Bellbird Dr hail 'n' ride",
                        "Jones Rd at Harris St hail 'n' ride",
                        "Jones Rd at Nugent Street hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Alice St near Parker St hail 'n' ride",
                        "Newman St near Karen St hail 'n' ride",
                        "Newman St near Mirrin St hail 'n' ride",
                        "Newman St near Braggan St hail 'n' ride",
                        "Newman St near Globe St hail 'n' ride",
                        "Old Logan Rd at Julieanne Street",
                        "Brisbane Tce near Layard St",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at Brisbane River Terraces",
                        "Redbank station, stop B"
                    ],
                    "6249: Bellbird Park, Woodlinks SS, Redbank": [
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Redbank Plains Town Square, stop D",
                        "Redbank Plains Rd at Brennan Park",
                        "Woodlinks State School",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Forgan Smith St near Theodore Ct hail 'n' ride",
                        "Gibbs Ave near TJ Ryan Ave hail 'n' ride",
                        "McCorry Dr near MacBride Ct hail 'n' ride",
                        "Eagle St near Foundation St hail 'n' ride",
                        "MacSwiney St near Eagle St hail 'n' ride",
                        "Bassili Dr near Cheihk Cr hail 'n' ride",
                        "Eagle St near TJ Ryan Ave",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Collingwood Dr at Jamboree Park hail 'n' ride",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Lawrie Dr near Whitlam Dr hail 'n' ride",
                        "Goss Dr at Jo Ann Miller Dr hail 'n' ride",
                        "Goss Dr at Hawke Avenue hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue hail 'n' ride",
                        "Duncan St at Dancer Street hail 'n' ride",
                        "Namatjira Dr at Drysdale Avenue",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6250: Bellbird Park, Redbank Stn": [
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Redbank Plains Town Square, stop A",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Redbank Plains Rd at Len Shearer Park",
                        "Redbank Plains Rd at Frangipanni Street",
                        "Redbank Plains Rd at Jayvilla Court",
                        "Stuart St near Eric St hail 'n' ride",
                        "Curnow St near Howard St",
                        "Kingsford St at Howard Street",
                        "Redbank Plains Rd at Caldwell Street",
                        "Redbank Plains Rd near Stuart St hail 'n' ride",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Redbank Palms",
                        "Namatjira Dr at Drysdale Avenue",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Redbank Plaza",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6251: Bellbird Park, Goodna Stn, Redbank Stn": [
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Columbia Dr near Bellbird Dr hail 'n' ride",
                        "Jones Rd at Harris St hail 'n' ride",
                        "Jones Rd at Nugent Street hail 'n' ride",
                        "Jones Rd at Brennan Street hail 'n' ride",
                        "Redbank Plains Rd at Kingsford Street",
                        "Eric St near Albert St hail 'n' ride",
                        "Stuart St near Bellevue Rd",
                        "Cross St at Bellevue Road",
                        "Gorry St at Kilner Street",
                        "Gorry St at Dowden Street",
                        "Smiths Rd near Stephen Cr",
                        "Smiths Rd at Arne Street",
                        "Goodna Shopping Centre",
                        "Goodna station, stop A",
                        "Brisbane Tce near Layard St hail 'n' ride",
                        "Brisbane Tce at RJ Richardson Park",
                        "Brisbane Tce at Lower Stuart Street",
                        "Brisbane Tce at Brisbane River Terraces"
                    ],
                    "6252: Bellbird Park, Redbank Stn": [
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Redbank Plains Town Square, stop A",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Argyle St at Price Close",
                        "Henty Dr near Knight St",
                        "Henty Dr near Martin Pl",
                        "Highbury Dr near Llewellyn St",
                        "Russell Dr at Kerwin Street",
                        "Josey St at Neal Street",
                        "Josey St at Kennedy Drive",
                        "Batman Dr at Nigel Street",
                        "Henty Dr at Batman Drive",
                        "Henty Dr at Kruger Parade",
                        "Kruger Pde at Henderson Street",
                        "Kruger Pde at Redbank Palms",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Lawrie Dr near Whitlam Dr hail 'n' ride",
                        "Goss Dr at Jo Ann Miller Dr hail 'n' ride",
                        "Goss Dr at Hawke Avenue hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue hail 'n' ride",
                        "Collingwood Dr at Jamboree Park hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6253: Springfield Schools, Goodna Stn": [
                        "Springfield Central State High",
                        "Springfield Central State School",
                        "Good Shepherd Catholic Primary School",
                        "Grande Ave at Angelica Avenue",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Oak Leaf Dr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Drive at Shearwater Tce",
                        "Springfield Lakes Bvd at Lakes Entrance Drive",
                        "Springfield Lakes Bvd at Parkview Drive",
                        "Springfield Lakes Bvd near Greentrees Tce",
                        "Summit Dr near Liberty Cr",
                        "Summit Dr near Lakeside Ave",
                        "Lakeside Ave near Diana St",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Burlington Tce",
                        "Spring Lake Village 4",
                        "Springfield Pkwy at Springfield Greenbank Arterial",
                        "Hymba Yumba Community Hub (Springfield) HnR",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Karamea Ave near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Woodcrest Way near Millwood Tce",
                        "Woodcrest Way at Nev Smith Drive",
                        "Topaz Rd at Springfield Fair",
                        "Topaz Rd near Sharpless Rd",
                        "Sharpless Rd near Tourmaline St",
                        "Mur Bvd near Old Logan Rd",
                        "Kertes Rd at Pharoah Street",
                        "Kertes Rd near Shiral Ct hail 'n' ride",
                        "Wilson Dr near Kertes Rd hail 'n' ride",
                        "Wilson Dr near Corial Ct hail 'n' ride",
                        "Wilson Dr near Durham Ct hail 'n' ride",
                        "Wilson Dr near Paula Ct hail 'n' ride",
                        "Wilson Dr near Myra Ct hail 'n' ride",
                        "Kertes Rd near Pharoah St",
                        "Old Logan Rd near Steven St hail 'n' ride",
                        "Old Logan Rd near Meier Rd hail 'n' ride",
                        "Old Logan Rd near Dale Rd hail 'n' ride",
                        "Old Logan Rd at Langley Road hail 'n' ride",
                        "Old Logan Rd near Lacey St hail 'n' ride",
                        "Old Logan Rd near Hallett Ave",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd near Vanessa Ct",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Julieanne Street",
                        "Brisbane Tce near Layard St",
                        "Goodna station, stop A"
                    ],
                    "6254: Bremer, Leichhardt, One Mile": [
                        "Toongarra Rd at Leichhardt Primary",
                        "Bremer State High School",
                        "Warwick Rd at Bremer High",
                        "Toongarra Rd near Coleman St",
                        "Warwick Rd at Showground",
                        "Old Toowoomba Rd at Immaculate Heart School",
                        "Warwick Rd at Showground North",
                        "Chubb St near Fair St hail 'n' ride",
                        "Warwick Rd at Park Street",
                        "Chubb St near Coyne St hail 'n' ride",
                        "East St at South Street",
                        "Cafferky St near Chubb St hail 'n' ride",
                        "Limestone St at Foote Lane",
                        "Siemons St near Phillip St hail 'n' ride",
                        "Limestone St at Nicholas Street",
                        "Siemons St near Woodford St hail 'n' ride",
                        "Limestone St at Waghorn Street",
                        "Ernest St near Crescent St",
                        "Brisbane St at Clay Street",
                        "Casey St near Coleman St",
                        "Brisbane St at Keogh Street",
                        "Casey St at Samford Rd",
                        "Leichhardt and One Mile Community Centre",
                        "Samford Rd near Gilmore St",
                        "Gilmore St near Watsonia Dr",
                        "Avon St at Larsen St",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wulkuraka station",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Wentworth St near Beckler St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Fraser St near Everdina St hail 'n' ride",
                        "Kynance St near Maenporth St hail 'n' ride",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Woodford St near Vineyard St hail 'n' ride",
                        "Old Toowoomba Rd near Immaculate Heart School"
                    ],
                    "6255: Springfield SHS, Camira SS, Goodna": [
                        "Parkland Dr near Wellness Way",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Grande Ave at Angelica Avenue",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Oak Leaf Dr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Drive at Shearwater Tce",
                        "Springfield Lakes Bvd at Lakes Entrance Drive",
                        "Springfield Lakes Bvd at Parkview Drive",
                        "Springfield Lakes Bvd near Greentrees Tce",
                        "Summit Dr near Liberty Cr",
                        "Summit Dr near Lakeside Ave",
                        "Lakeside Ave near Diana St",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Burlington Tce",
                        "Spring Lake Village 4",
                        "Springfield Pkwy at Springfield Greenbank Arterial",
                        "Hymba Yumba Community Hub (Springfield) HnR",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Karamea Ave near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Woodcrest Way near Millwood Tce",
                        "Woodcrest Way at Nev Smith Drive",
                        "Topaz Rd at Springfield Fair",
                        "Topaz Rd near Sharpless Rd",
                        "Sharpless Rd near Tourmaline St",
                        "Mur Bvd near Old Logan Rd",
                        "Kertes Rd at Pharoah Street",
                        "Fran St near Jean Rd",
                        "Angela St near Moss Rd",
                        "Ishmael Rd near Dale Rd",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Cochrane St near Ishmael Rd",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Old Logan Rd hail 'n' ride",
                        "Old Logan Rd near Lacey St hail 'n' ride",
                        "Old Logan Rd near Hallett Ave",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd near Vanessa Ct",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Julieanne Street",
                        "Brisbane Tce near Layard St",
                        "Goodna station, stop A",
                        "Mill St at McVeigh Court",
                        "William St at Smiths Road",
                        "Goodna Shopping Centre"
                    ],
                    "6256: Orion, Springfield SHS, Camira, Goodna": [
                        "Springfield Central State High",
                        "Parkland Dr near Wellness Way",
                        "Springfield Central Bvd at Hookes Terrace",
                        "Grande Ave at Angelica Avenue",
                        "Grande Ave at Kinglake Avenue",
                        "Grande Ave near Park Edge Dr hail 'n' ride",
                        "Grande Ave near Carnarvon Ave",
                        "Grande Ave near Oak Leaf Dr",
                        "Lakes Entrance Dr near Sunset Pl",
                        "Lakes Entrance Dr near Riverside Cr",
                        "Lakes Entrance Drive at Shearwater Tce",
                        "Springfield Lakes Bvd at Lakes Entrance Drive",
                        "Springfield Lakes Bvd at Parkview Drive",
                        "Springfield Lakes Bvd near Greentrees Tce",
                        "Summit Dr near Liberty Cr",
                        "Summit Dr near Lakeside Ave",
                        "Lakeside Ave near Diana St",
                        "Lakeside Ave near James Josey Ave",
                        "Lakeside Ave near Burlington Tce",
                        "Spring Lake Village 4",
                        "Springfield Pkwy at Springfield Greenbank Arterial",
                        "Hymba Yumba Community Hub (Springfield) HnR",
                        "Bridgewater Rd near Springfield Pkwy",
                        "Karamea Ave near Bridgewater Rd",
                        "Woodcrest Way at Danube Crescent",
                        "Woodcrest Way near Millwood Tce",
                        "Woodcrest Way at Nev Smith Drive",
                        "Topaz Rd at Springfield Fair",
                        "Topaz Rd near Sharpless Rd",
                        "Sharpless Rd near Tourmaline St",
                        "Mur Bvd near Old Logan Rd",
                        "Kertes Rd at Pharoah Street",
                        "Fran St near Jean Rd",
                        "Angela St near Moss Rd",
                        "Ishmael Rd near Dale Rd",
                        "Ishmael Rd near Mikkelsen Rd",
                        "Cochrane St near Ishmael Rd",
                        "Cochrane St near Barbara St",
                        "Cochrane St near Old Logan Rd hail 'n' ride",
                        "Old Logan Rd near Lacey St hail 'n' ride",
                        "Old Logan Rd near Hallett Ave",
                        "Old Logan Rd at Camira Primary School",
                        "Old Logan Rd near Vanessa Ct",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Julieanne Street",
                        "Brisbane Tce near Layard St",
                        "Goodna station, stop A",
                        "Mill St at McVeigh Court",
                        "Goodna Shopping Centre"
                    ],
                    "6257: Collingwood Park State SC": [
                        "Collingwood Park State Secondary School",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr",
                        "Eagle St near TJ Ryan Ave",
                        "Palaszczuk Av at Neumann Drive hail 'n' ride",
                        "BR Ted Magee Dr near Norman Cl hail 'n' ride",
                        "BR Ted Magee Dr near Juxgold Ave hail 'n' ride"
                    ],
                    "6258: Collingwood Park State SC-Goodna State PreSchool": [
                        "Collingwood Park State Secondary School",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "Gibbs Ave near TJ Ryan Ave hail 'n' ride",
                        "Gibbs Ave near Avoca Ct hail 'n' ride",
                        "Gibbs Ave near Genoa Pl hail 'n' ride",
                        "Gibbs Ave near Paul Tully Ave hail 'n' ride",
                        "Collingwood Dr at Gibbs Avenue hail 'n' ride",
                        "Collingwood Dr at Jamboree Park hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Old Ipswich Rd at West Falen Community Garden",
                        "Old Ipswich Rd at Johnstone Place",
                        "Old Ipswich Rd at Maxwell Street",
                        "Bannerman St near Lynch St hail 'n' ride",
                        "Old Ipswich Rd near Riverview Primary School",
                        "Old Ipswich Rd near Laura St",
                        "Valerie St near Child St",
                        "Diamond St near Gibbs St",
                        "Price St at Hayden Street",
                        "Mitchell St at Tessman Street",
                        "Nile St near Duncan St hail 'n' ride",
                        "Redbank Plaza",
                        "Smiths Rd hail 'n' ride",
                        "Gorry St at Dowden Street",
                        "Gorry St at Killner Street",
                        "Cross St near Hamar St",
                        "Smiths Rd near Stephen Cr",
                        "Stuart St at Goodna State Pre School"
                    ],
                    "6260: Ripley Valley schools, Yamanto": [
                        "Providence Pde at Ripley Valley School",
                        "Providence Pde near Splendid Dr hail 'n' ride",
                        "Tuckeroo St near Parkview Pde hail 'n' ride",
                        "Brooking Ave near Parkview Pde hail 'n' ride",
                        "Parkview Pde near Lillypilly Dr hail 'n' ride",
                        "Ripley Rd at Canary St",
                        "Monterea Rd near Maguire St hail 'n' ride",
                        "Belle Pde near Optima St hail 'n' ride",
                        "Ripley Rd at Trigona Drive",
                        "Reif St at Wallace Street",
                        "Reif St near Fairview Ave",
                        "Reif St at Fairview Park",
                        "Ash St at Winston Glades Shopping Centre"
                    ],
                    "6263: Ripley Valley Schools": [
                        "Providence Pde at Ripley Valley School",
                        "Watheroo St near Herberton Rd hail 'n' ride",
                        "Lashmar St near Wyperfeld Cres hail 'n' ride"
                    ],
                    "6264: Ripley Valley SS": [
                        "Providence Pde at Ripley Valley School",
                        "Greenview Av near Wallaman St hail 'n' ride",
                        "Morwell St near Eildon St hail 'n' ride",
                        "Barrams Rd at Olympus Drive",
                        "Cumner Rd near Dimmick St hail 'n' ride"
                    ],
                    "6265: Ripley Valley Schools and Deebing Heights": [
                        "Providence Pde at Ripley Valley School",
                        "Winland Dr near Tenville Ct hail 'n' ride",
                        "Newsky Ct near Winland Dr hail 'n' ride",
                        "Winland Dr near Chilton Ct hail 'n' ride",
                        "Yamanto Shopping Centre"
                    ],
                    "6267: Fernbrooke, Bellbird Park, Redbank Stn": [
                        "Regents Dr at Fernbrooke State School",
                        "Fernbrooke Bvd at Ingles Drive",
                        "Glorious Prom near Huntley Crv hail 'n' ride",
                        "Berrigan St near Burrawang St hail 'n' ride",
                        "Diamond Way near Sapphire Cr hail 'n' ride",
                        "Keidges Rd near Orana St hail 'n' ride",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Stuart St near Eric St hail 'n' ride",
                        "Stuart St near Bellevue Rd",
                        "Smiths Rd near Stephen Cr hail 'n' ride",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6268: Bellbird Park SHS, Kruger SS, Goodna Stn": [
                        "Bellbird Park State School",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Bellbird Dr near Columbia Dr hail 'n' ride",
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop A",
                        "Highbury Dr at Llewellyn Street",
                        "Henty Dr near Benjamina Dr hail 'n' ride",
                        "Henty Dr near Kennedy Dr hail 'n' ride",
                        "Henty Dr at Batman Drive",
                        "Henty Dr at Kruger Parade",
                        "Chris St near Milan Rd hail 'n' ride",
                        "Kruger Pde at Redbank Palms",
                        "Namatjira Dr at Drysdale Avenue",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Smiths Rd near Stephen Cr",
                        "Smiths Rd at Arne Street",
                        "Goodna Shopping Centre",
                        "Goodna station, stop A"
                    ],
                    "6269: West Moreton, Ipswich, Redbank Plains": [
                        "Keswick Rd at West Moreton Anglican College",
                        "Schillings Road hail 'n' ride",
                        "Vogel Rd at Sharpe Street",
                        "Bourke St near Hayes St",
                        "Fernvale Rd at Bourke Street",
                        "Fernvale Rd at North High Street",
                        "Fernvale Rd at Vaughan Hill",
                        "Ipswich Warrego Hwy at North High Street",
                        "Warrego Hwy near North High St hail 'n' ride",
                        "Fernvale Rd near Vogel Rd hail 'n' ride",
                        "Hunter St at Ipswich State High School",
                        "Hunter St at Brassall Shopping Village",
                        "Albion St at Workshops Street",
                        "Kingsmill Rd at Robin Street",
                        "Woodend Rd near Macrae St hail 'n' ride",
                        "Woodend Rd near Hawthorne St hail 'n' ride",
                        "Waghorn St near Woodend Rd hail 'n' ride",
                        "Ipswich Boys Grammar School",
                        "Elizabeth St at St Mary's Primary School",
                        "Ipswich station, stop C",
                        "Brisbane St at Marsden Parade",
                        "Queen Victoria Pde at Ipswich Special School",
                        "Queen Victoria Pde at Ipswich Girls Grammar School",
                        "Brisbane Rd at Montauban Street",
                        "Frederick St near Glebe St hail 'n' ride",
                        "Glebe Rd opp Silkstone Primary School",
                        "South Station Rd at Long Lane",
                        "Blackstone Rd near Church St",
                        "Blackstone Rd near Johnston St",
                        "Thomas St at Queen Street",
                        "Mary St near Thomas St hail 'n' ride",
                        "Mary St near Hill Street",
                        "Mary St near Edward St hail 'n' ride",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Goss Dr at Jo Ann Miller Drive",
                        "Lawrie Dr at Whitlam Drive",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Redbank Plaza"
                    ],
                    "6271: Bellbird Park College, Redbank Plains": [
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop D",
                        "Redbank Plains Rd at Brennan Park",
                        "BR Ted Magee Dr near Juxgold Ave hail 'n' ride",
                        "BR Ted Magee Dr near Parsons St hail 'n' ride",
                        "Palaszczuk Av at Neumann Drive hail 'n' ride",
                        "Cedar Rd near Redbank Plains Rd hail 'n' ride",
                        "Cedar Rd near Vicki St hail 'n' ride",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Harry St hail 'n' ride",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr hail 'n' ride",
                        "Gibbs Ave near TJ Ryan Ave hail 'n' ride",
                        "Gibbs Ave near Avoca Ct hail 'n' ride",
                        "Gibbs Ave near Genoa Pl hail 'n' ride",
                        "Gibbs Ave near Paul Tully Ave hail 'n' ride",
                        "Paul Tully Ave near Hayden Dr hail 'n' ride",
                        "Paul Tully Ave near Warburton Ct hail 'n' ride",
                        "Paul Tully Ave near Dawson Ct hail 'n' ride",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Collingwood Dr at Gibbs Avenue hail 'n' ride",
                        "Collingwood Dr at Jamboree Park hail 'n' ride",
                        "Collingwood Dr at Old Ipswich Road",
                        "Redbank Plaza"
                    ],
                    "6272: Ipswich HS, One Mile, Leichhardt": [
                        "Ipswich State High School",
                        "Workshops St at Sutton Park",
                        "Albion St at Workshops Street",
                        "Kingsmill Rd at Robin Street",
                        "Burnett St at Blair State School",
                        "Ipswich station, stop A",
                        "Brisbane St at Clay Street",
                        "Brisbane St at Keogh Street",
                        "Leichhardt and One Mile Community Centre",
                        "Ernest St near Crescent St",
                        "Casey St near Coleman St",
                        "Casey St at Samford Rd",
                        "Samford Rd near Gilmore St",
                        "Gilmore St near Watsonia Dr",
                        "Avon St at Larsen St",
                        "Avon St near Leonard St",
                        "Flinders Dr near Torres St",
                        "Flinders Dr near Wills St",
                        "Wentworth St near Beckler St",
                        "Wulkuraka station",
                        "Aspinall St near Beckler St",
                        "Bass St at Light Street",
                        "Light St at Bass Street",
                        "Toongarra Rd near May St",
                        "Toongarra Rd at Finch Street",
                        "Toongarra Rd at Avon Street",
                        "Fraser St near Everdina St hail 'n' ride",
                        "Kynance St near Maenporth St hail 'n' ride",
                        "Toongarra Rd at Leichhardt Primary",
                        "Toongarra Rd near Coleman St",
                        "Siemons St near Old Toowoomba Rd",
                        "Siemons St near Oakhill St",
                        "Siemons St near Phillip St",
                        "Cafferky St at Georgette Street",
                        "Chubb St near Coyne St",
                        "Chubb St near Adam St",
                        "Chubb St at Fair Street",
                        "Woodford St near Vineyard St hail 'n' ride",
                        "Old Toowoomba Rd near Immaculate Heart School"
                    ],
                    "6273: Ripley Valley SS, Ripley Rd, Rex Hills Dr": [
                        "Ripley Central State School",
                        "Ripley Rd at Canary St",
                        "Levi St near Flavey St hail 'n' ride",
                        "Fischer Rd near Clarke St hail 'n' ride",
                        "Scotts Rd near Ripley Rd hail 'n' ride",
                        "Rhea De Wit Dr near Raven St hail 'n' ride",
                        "Canary St near Sable St hail 'n' ride",
                        "Parkview Pde at Lillypilly Drive",
                        "Tuckeroo St near Parkview Pde hail 'n' ride",
                        "Providence Pde at Splendid Drive",
                        "Barrams Rd near Bellthorpe St hail 'n' ride",
                        "Providence Pde at Ripley Valley School",
                        "Harmony Cres near Greenview Ave hail 'n' ride",
                        "Amity Way near Providence Pde hail 'n' ride",
                        "Brooking Ave near Parkview Pde hail 'n' ride",
                        "Parkview Pde near Lillypilly Dr hail 'n' ride",
                        "Fischer Rd near Scotts Rd hail 'n' ride",
                        "Monterea Rd near Maguire St hail 'n' ride",
                        "Carpenter Dr near Rex Hills Dr hail 'n' ride",
                        "Simpatico Dr near Boyland Way hail 'n' ride",
                        "Rex Hills Dr near Cityhope Church hail 'n' ride"
                    ],
                    "6274: Bellbird Park College - Redbank Station": [
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Jones Rd at Bellbird Drive hail 'n' ride",
                        "Jones Rd near Augusta Pkwy",
                        "Redbank Plains Town Square, stop A",
                        "Redbank Plains Rd at Barry Drive",
                        "Redbank Plains Rd at Shannon Street",
                        "Kruger Pde at Kruger Village hail 'n' ride",
                        "Redbank Plains Rd near Eagle St hail 'n' ride",
                        "Redbank Plains Rd at Kingsford Street",
                        "Curnow St near Howard St",
                        "Eric St near Albert St hail 'n' ride",
                        "Alice St near St Albans Street hail 'n' ride",
                        "Alice St near Spalding Hillson Ct hail 'n' ride",
                        "Alice St near Parker St hail 'n' ride",
                        "Old Logan Rd near Vanessa Ct",
                        "Old Logan Rd near Baker St",
                        "Old Logan Rd at Julieanne Street"
                    ],
                    "6275: Deebing Heights SS": [
                        "Providence Pde at Ripley Valley School",
                        "Ripley Rd at Wensley Rd",
                        "Rhythm Rd near Tempo Dr hail 'n' ride",
                        "Rhythm Rd near Daleys Rd hail 'n' ride",
                        "Kuril Dr near Lakeview Dr hail 'n' ride",
                        "Sovereign Dr near Bottlebrush Dr hail 'n' ride",
                        "Deebing Heights State School"
                    ],
                    "6276: Bellbird Park College": [
                        "Jones Rd at Bellbird Park State Secondary College",
                        "Columbia Dr near Bellbird Dr hail 'n' ride",
                        "Willow Rd at Redbank Plains High School",
                        "Keidges Rd near Cudgee St hail 'n' ride",
                        "Kanangra St at Keidges Road",
                        "Kanangra St at Balook Street",
                        "Kanangra St near Lemana St",
                        "Kanangra St at Cedar Road",
                        "Cedar Rd at Orana Street",
                        "Cedar Rd at Kentucky Street",
                        "Redbank Plains Rd at Brennan Park",
                        "Eagle St near TJ Ryan Ave hail 'n' ride",
                        "Eagle St near Bassili Dr",
                        "Collingwood Dr at Paul Tully Avenue",
                        "Goss Dr at Hawke Avenue",
                        "Lawrie Dr at Milgate Street hail 'n' ride",
                        "Namatjira Dr near Dargie Ave hail 'n' ride",
                        "Mine Street near Brisbane Rd hail 'n' ride",
                        "Redbank station, stop A"
                    ],
                    "6277: Deebing Heights SS, Ripley Valley schools": [
                        "Providence Pde at Ripley Valley School",
                        "Ripley Rd at Wensley Rd",
                        "Canary St near Sable St hail 'n' ride",
                        "Rhythm Rd near Tempo Dr hail 'n' ride",
                        "Rhythm Rd near Daleys Rd hail 'n' ride",
                        "Kuril Dr near Lakeview Dr hail 'n' ride",
                        "Kerners Rd near Deebing Ck Rd hail 'n' ride",
                        "Deebing Creek Rd at Amberley State School",
                        "Ash St near Deebing Cr hail 'n' ride",
                        "Ash St at Kensington Drive",
                        "Ash St at Winston Glades Shopping Centre"
                    ],
                    "6701: Redcliffe, Scarborough, Humpybong": [
                        "Sandgate bus station, stop 1",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate, stop 34",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Brighton Tce near Wakefield St",
                        "Brighton Tce near Tenth Ave",
                        "Brighton Tce near Twelfth Ave",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Princess St",
                        "Beaconsfield Tce near Duke St",
                        "Hornibrook Hwy at Eventide",
                        "Hornibrook Hwy at Brighton Bayside Park",
                        "Hornibrook Esp at Clontarf Beach West",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp near Donald St",
                        "Hornibrook Esp at Bramble Bay Bowls Club",
                        "Hornibrook Esp at Woody Point Park",
                        "Oxley Ave at Alfred Street",
                        "Oxley Ave at Annie Street",
                        "Oxley Ave at Westbrook Street",
                        "Oxley Ave at Langdon Park",
                        "Oxley Ave at Margate Shopping Centre",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at State Emergency Service",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Humpybong Primary School",
                        "Ernest St near Eveline St",
                        "Ernest St near King St",
                        "Victoria Ave at King Street",
                        "Victoria Ave at Clifford Street",
                        "Maine Rd near Isobel St",
                        "Victoria Ave at Dunbar Street",
                        "Victoria Ave at Duffield Road",
                        "Victoria Ave at Barry Bolton Park",
                        "Victoria Ave at Macdonnell Road",
                        "Victoria Ave at Bradley Park",
                        "Recreation St at Redcliffe Hospital",
                        "Scarborough Rd at Redcliffe Showgrounds",
                        "Klingner Rd at Longland Street",
                        "Klingner Rd at OConnell Street",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Marsala Street",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd near Brunel St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Gynther Road",
                        "Anzac Ave at Finnegan Street",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Capestone Boulevard",
                        "Anzac Ave at Kinsellas Road",
                        "Anzac Ave at Halpine Drive",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Gympie Rd at Station Road",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Paisley Park",
                        "Gympie Rd at Pine Rivers High School",
                        "Gympie Rd at Bray Park station",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station, stop C",
                        "Gympie Rd near Mecklem St hail 'n' ride",
                        "Strathpine Rd at Adair Street",
                        "Strathpine Rd near Bald Hills Rd",
                        "Bracken Ridge Rd near Glenealy St hail 'n' ride",
                        "Barfoot St near Cedarwood St hail 'n' ride",
                        "Barfoot St at Bracken Ridge High School",
                        "Douglas St near Gordon St, stop 52",
                        "Douglas St near Sandown St, stop 51",
                        "Baskerville St at Nashville School",
                        "Baskerville St at Peace Park",
                        "Baskerville St at Sandgate North, stop 39",
                        "Deagon St near Albion St, stop 38",
                        "Deagon St near Brisbane St, stop 37",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Brighton Rd near Seventh Ave, stop 35"
                    ],
                    "6702: Living Faith, Grace Lutheran, Redcliffe": [
                        "Gympie Rd at Saint Pauls School",
                        "Gympie Rd near Mecklem St hail 'n' ride",
                        "Gympie Rd at Bray Park station",
                        "Gympie Rd at Pine Rivers High School",
                        "Gympie Rd at Paisley Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Station Road",
                        "Petrie station, stop A",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Dohles Rocks Rd near Bluegum St",
                        "Dohles Rocks Rd near School Rd",
                        "Dohles Rocks Rd near Clyde St",
                        "Dohles Rocks Rd near Chestnut Drive",
                        "Blatchford Dr near Marlene St",
                        "Alana St near Blatchford Dr",
                        "Goodfellows Rd near Murrumba State Secondary College HnR",
                        "Castle Hill Dr near Cherington Way",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Farrington Dr",
                        "Murrumba Downs Shopping Centre",
                        "Brays Rd near Vermilion Av hail 'n' ride",
                        "Brays Rd near Tesch Rd",
                        "Brays Rd near Cairns Rd (Closed from 10 Nov 2025 - 31 July 2026)",
                        "Brays Rd near Burnett Dr",
                        "Brays Rd near Moreton St",
                        "Anzac Ave at Westfield North Lakes",
                        "Anzac Ave at Discovery Drive",
                        "Anzac Ave at Kinsellas Road",
                        "Anzac Ave at Capestone Boulevard",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Finnegan Street",
                        "Gynther Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Wattle Road",
                        "Southern Cross Kippa-Ring College hail 'n' ride",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Susan Avenue",
                        "Peninsula Fair, stop B",
                        "Anzac Ave at Lindel Street",
                        "Anzac Ave at Ashmole Road",
                        "Anzac Avenue near Recreation St",
                        "Anzac Ave at Redcliffe Hospital",
                        "Oxley Ave at State Emergency Service",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Landsborough Ave at Murphy Street",
                        "Scarborough Rd at Shields Street",
                        "Scarborough Rd at Klinger Road",
                        "Scarborough Rd at Redcliffe Showgrounds",
                        "Recreation St at Redcliffe Hospital",
                        "Peninsula Fair, stop C",
                        "Elizabeth Ave at Grimley Street",
                        "Elizabeth Ave at Korsch Street",
                        "Oxley Ave at Redcliffe Cultural Centre",
                        "Oxley Ave at Humpybong Park",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Margate Shopping Centre",
                        "Oxley Ave at Langdon Park",
                        "King St at Southern Cross College",
                        "Victoria Ave at King Street",
                        "Victoria Ave at Clifford Street",
                        "Maine Rd near Gerald Ave",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Elizabeth Ave near Handsworth St",
                        "Elizabeth Ave near Roland St",
                        "Elizabeth Ave at Clontarf Primary School",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Alice St",
                        "Isobel St near Weaber St",
                        "Maine Rd near Isobel St",
                        "Maine Rd at Beedham Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd near Duffield Rd hail 'n' ride",
                        "Maine Rd at Gardenia Street",
                        "Macdonnell Rd at Kingsford Street",
                        "Trilby St near Macdonnell Rd",
                        "Trilby St near Highland St",
                        "Trilby St near George St",
                        "Ashmole Rd near Hibiscus Ave",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Marsala Street",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd near Brunel St",
                        "Anzac Avenue at Regency Street",
                        "Nathan Rd near Napier St",
                        "Morris Rd at Lynanda Court",
                        "Gynther Rd near Eton St",
                        "Anzac Ave at Halpine Drive",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at The Crescent",
                        "School Rd near Doon St"
                    ],
                    "6703: Redcliffe, Deception Bay, North Lakes": [
                        "Sandgate bus station, stop 1",
                        "Kennerley St near Rainbow St",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate, stop 34",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Deagon St near Southerden St, stop 37",
                        "Deagon Devn at Deagon Street, stop 38",
                        "Bracken Ridge Rd near Rinnicrew St",
                        "Hoyland St near Dresden St",
                        "Strathpine Rd near Lucy St",
                        "Gympie Rd at Saint Pauls School",
                        "Gympie Rd near Mecklem St hail 'n' ride",
                        "Gympie Rd at Bray Park station",
                        "Gympie Rd at Pine Rivers High School",
                        "Gympie Rd at Paisley Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Station Road",
                        "Petrie station, stop A",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "Anzac Ave at Discovery Drive",
                        "Anzac Ave at Kinsellas Road",
                        "Anzac Ave at Capestone Boulevard",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Finnegan Street",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd at Marsala Street",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Pinewood Street",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Landsborough Ave at Murphy Street",
                        "Scarborough Rd at Shields Street",
                        "Klingner Rd at Longland Street",
                        "Klingner Rd at OConnell Street",
                        "Anzac Ave at Ashmole Road",
                        "Victoria Ave at Anzac Avenue",
                        "Victoria Ave at Bradley Park",
                        "Victoria Ave at Macdonnell Road",
                        "Victoria Ave at Barry Bolton Park",
                        "Victoria Ave at Duffield Road",
                        "Victoria Ave at Dunbar Street",
                        "Humpybong Primary School"
                    ],
                    "6704: North Lakes, Deception Bay, St Pauls": [
                        "Isobel St near Weaber St",
                        "Maine Rd near Isobel St",
                        "Maine Rd at Beedham Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd near Duffield Rd hail 'n' ride",
                        "Maine Rd at Gardenia Street",
                        "Macdonnell Rd at Kingsford Street",
                        "Trilby St near Macdonnell Rd",
                        "Trilby St near Highland St",
                        "Trilby St near George St",
                        "Anzac Ave at Ashmole Road",
                        "Anzac Ave at Lindel Street",
                        "Peninsula Fair, stop C",
                        "Elizabeth Ave at Grimley Street",
                        "Elizabeth Ave at Korsch Street",
                        "Duffield Rd near Elizabeth Ave",
                        "Duffield Rd near Kalimna Dr hail 'n' ride",
                        "Victoria Ave at Duffield Road",
                        "Victoria Ave at Dunbar Street",
                        "Victoria Ave at Clifford Street",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Elizabeth Ave near Handsworth St",
                        "Elizabeth Ave near Roland St",
                        "Elizabeth Ave at Clontarf Primary School",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Alice St",
                        "Boardman Rd at Susan Avenue",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Talobilla Park",
                        "Boardman Rd near Griffith Rd hail 'n' ride",
                        "Lakeview Prom near IGA hail 'n' ride",
                        "Lakeview Prom near Spinnaker Bvd hail 'n' ride",
                        "Morris Rd at Summerfield Street",
                        "Morris Rd at Lynanda Court",
                        "Gynther Rd near Morris Rd",
                        "Gynther Rd near Eton St",
                        "Gynther Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Anzac Ave at Finnegan Street",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Curruther Park",
                        "Narangba Rd at Kedron Road",
                        "Eucumbene Dr near Narangba Rd hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St hail 'n' ride",
                        "Eucumbene Dr near Frenchs Rd",
                        "Frenchs Rd near Kurwongbah Primary School HnR",
                        "Beeville Rd near Pymble Ave",
                        "Chambery Rd near Forestville Rd",
                        "Belrose Ave near Gehrman Ct hail 'n' ride",
                        "Belrose Ave near Rue Montaigne",
                        "Woonara Dr near Joora Ave",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Petrie station, stop B",
                        "Gympie Rd at Station Road",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Paisley Park",
                        "Gympie Rd at Pine Rivers High School",
                        "Gympie Rd at Bray Park station",
                        "Gympie Rd at Stanley Street",
                        "Gympie Rd near Duncan Ave"
                    ],
                    "6705: Clontarf, North Lakes, Redcliffe": [
                        "Norris Rd at Norris - Bracken Ridge",
                        "Norris Rd near Gawain Rd",
                        "Norris Rd at Greenore Street",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Norris Rd near Barbour Rd",
                        "Barbour Rd near Phillips St",
                        "Phillips St at St Josephs",
                        "Phillips St at Enbrook Street",
                        "Phillips St near Tomah Rd",
                        "Denham St near Phillips St, stop 32",
                        "Denham St near Childs St, stop 33",
                        "Barrett St at McKeering-Barrett",
                        "Barrett St near Tallara St, stop 37",
                        "Bracken St at Bracken Ridge Library",
                        "Deagon St near Albion St, stop 38",
                        "Deagon St near Brisbane St, stop 37",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Kate St near Palm Ave",
                        "Sandgate Central, stop 33",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Brighton Tce near Wakefield St",
                        "Brighton Tce near Tenth Ave",
                        "Brighton Tce near Twelfth Ave",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Princess St",
                        "Beaconsfield Tce near Duke St",
                        "Hornibrook Hwy at Eventide",
                        "Hornibrook Hwy at Brighton Bayside Park",
                        "Elizabeth Ave near Handsworth St",
                        "Elizabeth Ave near Roland St",
                        "Elizabeth Ave at Clontarf Primary School",
                        "Elizabeth Ave near Alice St",
                        "Elizabeth Ave at Korsch Street",
                        "Elizabeth Ave at Grimley Street",
                        "Anzac Ave at Kroll Street",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Morris Rd at Lynanda Court",
                        "Morris Rd at Bertie Dow Park",
                        "Morris Rd at Cambridge Street",
                        "Anzac Ave at Finnegan Street",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Capestone Boulevard",
                        "St Benedicts Catholic Primary School",
                        "Isobel St near Weaber St",
                        "King St at Clontarf Beach High School",
                        "Boardman Rd at Susan Avenue",
                        "Boardman Rd at McGregor Street",
                        "Klingner Rd near Brunel St",
                        "Nathan Rd near Napier St",
                        "Cambridge St near Kelliher St",
                        "Morris Rd near Gynther Rd",
                        "Morris Rd near Melaleuca Cr",
                        "Morris Rd near Lynanda Ct",
                        "Wattle Rd near Oakmont St hail 'n' ride",
                        "Bremner Road",
                        "Hornibrook Hwy at Eventide Aged Home",
                        "Beaconsfield Tce near Shepherd St",
                        "Beaconsfield Tce near Twelfth Ave",
                        "Friday St near Rainbow St",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Deagon Devn at Deagon Street, stop 38"
                    ],
                    "6706: Clontarf, Mueller, North Lakes, Redcliffe": [
                        "North Lakes station, platform 2",
                        "Anzac Ave near Brays Rd hail 'n' ride",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at McBain Street",
                        "Duffield Rd near Kahala Rd hail 'n' ride",
                        "Duffield Rd near Sapphire Ct hail 'n' ride",
                        "Duffield Rd near Brickworks Rd",
                        "Duffield Rd near Wyena St",
                        "Lavercombe Dr near Lintone St",
                        "Balstrup Rd near Olsen Cct",
                        "Old Gympie Rd at Plantation Road",
                        "Old Gympie Rd at Butterfly Drive",
                        "Ann St near Archer St",
                        "Ann St near Marsden Rd",
                        "Marsden Rd near Sylvester Dr",
                        "Marsden Rd near Narangba Rd",
                        "Dohles Rocks Rd near Bluegum St",
                        "Dohles Rocks Rd near School Rd",
                        "Dohles Rocks Rd near Clyde St",
                        "Dohles Rocks Rd near Chestnut Drive",
                        "Ogg Rd at Undurba Primary School",
                        "Murrumba State Secondary College",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Dohles Rocks Rd at McClintock Drive",
                        "Murrumba Downs Shopping Centre",
                        "Brays Rd at Henry Road",
                        "Brays Rd near Tesch Rd",
                        "Brays Rd near Cairns Rd (Closed from 10 Nov 2025 - 31 July 2026)",
                        "Brays Rd near Moreton St",
                        "Halpine Dr at Mango Hill Shopping Centre",
                        "Mango Hill Bvd near Bowen St hail 'n' ride",
                        "Mango Hill State Secondary College",
                        "Napier Ave near Jamie St hail 'n' ride",
                        "Capestone Bvd near Campbell Dr hail 'n' ride",
                        "North Lakes State College",
                        "Anzac Ave at Halpine Drive",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Alana St at Blatchford Drive",
                        "Brays Rd near Burnett Dr",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Curruther Park",
                        "Ann St at Blazey Street",
                        "Lavercombe Dr near Campbell St",
                        "Duffield Rd near Boyandra Dr",
                        "Anzac Ave at Duffield Road"
                    ],
                    "6707: Redcliffe High, Scarborough Primary": [
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Landsborough Ave at Murphy Street",
                        "Scarborough Rd at Shields Street",
                        "Klingner Rd at Longland Street",
                        "Klingner Rd at OConnell Street",
                        "Anzac Ave at Ashmole Road",
                        "Anzac Ave at Lindel Street",
                        "Peninsula Fair, stop C",
                        "Boardman Rd at Susan Avenue",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Talobilla Park",
                        "Boardman Rd near Griffith Rd hail 'n' ride",
                        "Lakeview Prom near IGA hail 'n' ride",
                        "Lakeview Prom near Spinnaker Bvd hail 'n' ride",
                        "Southern Cross Kippa-Ring College hail 'n' ride",
                        "Nathan Rd near Napier St",
                        "Morris Rd at Lynanda Court",
                        "Cambridge St near Kelliher St",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Elizabeth Ave at Grimley Street",
                        "Elizabeth Ave at Korsch Street"
                    ],
                    "6708: North Lakes, Grace, Redcliffe": [
                        "Strathpine Rd near Lucy St",
                        "Gympie Rd near Mecklem St hail 'n' ride",
                        "Gympie Rd at Bray Park station",
                        "Gympie Rd at Pine Rivers High School",
                        "Gympie Rd at Paisley Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Station Road",
                        "Petrie station, stop B",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "North Lakes State College",
                        "Anzac Ave at Discovery Drive",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "Anzac Ave at Kinsellas Road",
                        "Anzac Ave at Capestone Boulevard",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Finnegan Street",
                        "Gynther Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Morris Rd at Lynanda Court",
                        "Gynther Rd near Eton St",
                        "Wattle Road",
                        "Nathan Rd near Napier St",
                        "Lakeview Prom near Spinnaker Bvd hail 'n' ride",
                        "Lakeview Prom near IGA hail 'n' ride",
                        "Boardman Rd at Arcadia Crescent",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd at Marsala Street",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Pinewood Street",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Eversleigh Road",
                        "Oxley Ave at Pearl Street",
                        "Landsborough Ave at Murphy Street",
                        "Scarborough Rd at Shields Street",
                        "Klingner Rd at Longland Street",
                        "Klingner Rd at OConnell Street",
                        "Klingner Rd near Brunel St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Anzac Ave at Halpine Drive",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Caine Street",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station, stop C",
                        "Gympie Rd near Duncan Ave",
                        "Gympie Rd near Bald Hills Rd",
                        "Gympie Rd near Dickson St",
                        "Gympie Rd near Telegraph Rd",
                        "Roghan Rd near Gympie Rd",
                        "Ridley Rd at Gardenia Place",
                        "Ridley Rd near Retreat St",
                        "Beams Rd near Tintara St"
                    ],
                    "6709: North Lakes, Grace, Clontarf": [
                        "Petrie station, stop B",
                        "Dayboro Rd near Baldwin St",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Joora Ave",
                        "Frenchs Rd near Beeville Rd hail 'n' ride",
                        "Kurwongbah Primary School",
                        "Eucumbene Dr near Pedder Ct",
                        "Eucumbene Dr near Burrumbeet St",
                        "Narangba Rd near Kedron Rd",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "North Lakes State College",
                        "Anzac Ave at Discovery Drive",
                        "Anzac Ave at Kinsellas Road",
                        "Anzac Ave at Capestone Boulevard",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Finnegan Street",
                        "Gynther Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Morris Rd at Lynanda Court",
                        "King St at Clontarf Beach High School",
                        "Elizabeth Ave near Long St",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Roland St",
                        "Elizabeth Ave near Angus St",
                        "Hornibrook Esp at Clontarf Beach West",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp near Donald St",
                        "Hornibrook Esp at Bramble Bay Bowls Club",
                        "Hornibrook Esp at Woody Point Park",
                        "Oxley Ave at Alfred Street",
                        "Oxley Ave at Annie Street",
                        "Oxley Ave at Westbrook Street",
                        "Oxley Ave at Langdon Park",
                        "Oxley Ave at Margate Shopping Centre",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at State Emergency Service",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Oxley Ave at Eversleigh Road",
                        "Oxley Ave at Pearl Street",
                        "Oxley Ave near Adams St",
                        "Landsborough Ave at Murphy Street",
                        "Landsborough Ave at Bunton Street",
                        "Landsborough Ave at Rock Street",
                        "Landsborough Ave at Warde Street",
                        "Fifth Ave at Moffat Street",
                        "North Quay near Fifth Ave",
                        "Seaville Ave near Jeays St",
                        "Jeays St at Palmtree Avenue",
                        "Oyster Point Esp at Michel Road",
                        "Oyster Point Esp at Sunnyside Road",
                        "Endeavour Esp at Dolphin Street",
                        "Newport Dr near Southern Cross Dr",
                        "Newport Drive near Griffith Rd",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Shields Street",
                        "Klingner Rd at Longland Street",
                        "Klingner Rd at OConnell Street",
                        "Ashmole Rd near Anzac Ave"
                    ],
                    "6710: Grace Lutheran, Mueller, The Lakes": [
                        "Ashmole Rd near Anzac Ave hail 'n' ride",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Pinewood Street",
                        "Scarborough Rd at Klinger Road",
                        "Scarborough Rd at Shields Street",
                        "Scarborough State Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Newport Drive near Griffith Rd",
                        "Newport Dr at Southern Cross Drive",
                        "Endeavour Esp at Dolphin Street",
                        "Sunnyside Rd near Oyster Point Esp",
                        "Oyster Point Esp at Michel Road",
                        "Jeays St at Palmtree Avenue",
                        "Seaville Ave near Jeays St",
                        "North Quay at Fifth Avenue",
                        "Fifth Ave at Moffatt Street",
                        "Landsborough Ave at Warde Street",
                        "Landsborough Ave at Rock Street",
                        "Landsborough Ave at Kennedy Esplanade",
                        "Landsborough Ave at Murphy Street",
                        "Oxley Ave at Adams Street",
                        "Oxley Ave at Pearl Street",
                        "Oxley Ave at Eversleigh Road",
                        "Oxley Ave at Shields Street",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Redcliffe Cultural Centre",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Humpybong Park",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Margate Shopping Centre",
                        "Oxley Ave at Langdon Park",
                        "Oxley Ave at King Street",
                        "Oxley Ave at Westbrook Street",
                        "Oxley Ave at Annie Street",
                        "Oxley Ave at Alfred Street",
                        "Hornibrook Esp at Woody Point Park",
                        "Hornibrook Esp at Victoria Avenue",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp at Pelican Park East",
                        "Maine Rd near Cornelius St",
                        "Maine Rd near Gerald Ave",
                        "Maine Rd near Isobel St",
                        "Maine Rd at Beedham Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd near Duffield Rd hail 'n' ride",
                        "Maine Rd at Gardenia Street",
                        "Macdonnell Rd near Maine Rd",
                        "Elizabeth Ave at Korsch Street",
                        "Elizabeth Ave at Grimley Street",
                        "Boardman Rd at Susan Avenue",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Talobilla Park",
                        "Boardman Rd near Griffith Rd hail 'n' ride",
                        "Lakeview Prom near IGA hail 'n' ride",
                        "Lakeview Prom near Spinnaker Bvd hail 'n' ride",
                        "Southern Cross Kippa-Ring College hail 'n' ride",
                        "Chelsea Street",
                        "Bremner Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Morris Rd at Lynanda Court",
                        "Nathan Rd near Napier St",
                        "Gynther Rd near Eton St",
                        "Gynther Road",
                        "Wattle Road",
                        "Boardman Rd at Arcadia Crescent",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd at Marsala Street"
                    ],
                    "6711: Humpybong, Redcliffe, Southern Cross": [
                        "Elizabeth Ave at Korsch Street",
                        "Kroll St near Apex Ave hail 'n' ride",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Mewes Road",
                        "Gynther Road",
                        "Anzac Ave at Finnegan Street",
                        "Wattle Road",
                        "Nathan Rd near Napier St",
                        "Lakeview Prom near Spinnaker Bvd hail 'n' ride",
                        "Lakeview Prom near IGA hail 'n' ride",
                        "Boardman Rd at Arcadia Crescent",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Susan Avenue",
                        "Elizabeth Ave at Grimley Street",
                        "Maine Rd at Windsor Street",
                        "Maine Rd at Gardenia Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd at Beedham Street",
                        "Isobel St near Maine Rd",
                        "Isobel St near Weaber St",
                        "Elizabeth Ave near Long St",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Roland St",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Hornibrook Esp at Pelican Park",
                        "Gerald Ave near Laura St",
                        "Maine Rd near Gerald Ave",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp near Donald St",
                        "Victoria Avenue near Hornibrook Esp",
                        "Victoria Ave at Clifford Street",
                        "Oxley Ave at Langdon Park",
                        "Humpybong Primary School",
                        "Marine Pde near Macdonnell Rd",
                        "Marine Pde near Sydney St",
                        "Anzac Ave at Sutton Street",
                        "Anzac Ave at Museum and Historical Society",
                        "Oxley Ave at State Emergency Service",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Margate Shopping Centre",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Landsborough Ave at Murphy Street",
                        "Landsborough Ave at Bunton Street",
                        "Landsborough Ave at Rock Street",
                        "Landsborough Ave at Warde Street",
                        "Fifth Ave at Moffat Street",
                        "North Quay near Fifth Ave",
                        "Seaville Ave near Jeays St",
                        "Jeays St at Palmtree Avenue",
                        "Oyster Point Esp at Michel Road",
                        "Oyster Point Esp at Sunnyside Road",
                        "Endeavour Esp at Dolphin Street",
                        "Newport Dr near Southern Cross Dr",
                        "Newport Drive near Griffith Rd",
                        "Oxley Ave at Pearl Street",
                        "Oxley Ave at Eversleigh Road",
                        "Oxley Ave at Redcliffe Cultural Centre",
                        "Oxley Ave at Humpybong Park",
                        "Victoria Ave at Macdonnell Road",
                        "Victoria Ave at Barry Bolton Park",
                        "Victoria Ave at Duffield Road",
                        "Victoria Ave at Dunbar Street",
                        "Victoria Ave at King Street",
                        "Maine Rd near Cornelius St",
                        "Maine Rd near Isobel St",
                        "Maine Rd near Duffield Rd hail 'n' ride",
                        "Macdonnell Rd near Maine Rd",
                        "Elizabeth Ave near Macdonnell Rd",
                        "Elizabeth Ave near Gardenia St",
                        "Duffield Rd near Elizabeth Ave"
                    ],
                    "6712: Grace, Lutheran, Mueller": [
                        "Boardman Rd at Susan Avenue",
                        "Boardman Rd at McGregor Street",
                        "Newport Drive near Griffith Rd",
                        "Newport Dr at Southern Cross Drive",
                        "Endeavour Esp at Dolphin Street",
                        "Sunnyside Rd near Oyster Point Esp",
                        "Oyster Point Esp at Michel Road",
                        "Jeays St at Palmtree Avenue",
                        "Seaville Ave near Jeays St",
                        "North Quay at Fifth Avenue",
                        "Fifth Ave at Moffatt Street",
                        "Landsborough Ave at Warde Street",
                        "Landsborough Ave at Rock Street",
                        "Landsborough Ave at Kennedy Esplanade",
                        "Landsborough Ave at Murphy Street",
                        "Oxley Ave at Adams Street",
                        "Oxley Ave at Pearl Street",
                        "Oxley Ave at Eversleigh Road",
                        "Oxley Ave at Shields Street",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Redcliffe Cultural Centre",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Humpybong Park",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Margate Shopping Centre",
                        "Oxley Ave at Langdon Park",
                        "Oxley Ave at King Street",
                        "Oxley Ave at Westbrook Street",
                        "Oxley Ave at Annie Street",
                        "Oxley Ave at Alfred Street",
                        "Hornibrook Esp at Woody Point Park",
                        "Hornibrook Esp at Victoria Avenue",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Elizabeth Ave near Handsworth St",
                        "Elizabeth Ave near Roland St",
                        "Elizabeth Ave at Clontarf Primary School",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Alice St",
                        "Isobel St near Weaber St",
                        "Maine Rd near Isobel St",
                        "Maine Rd at Beedham Street",
                        "Maine Rd at Heather Street",
                        "Duffield Rd at Duffield Road",
                        "Duffield Rd near Kalimna Dr hail 'n' ride",
                        "Elizabeth Ave near Nerida Ct",
                        "Elizabeth Ave near Pamrick Cr",
                        "Elizabeth Ave at Korsch Street",
                        "Elizabeth Ave at Grimley Street",
                        "Klingner Rd near Brunel St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Morris Rd at Lynanda Court",
                        "Southern Cross Kippa-Ring College hail 'n' ride",
                        "Nathan Rd near Napier St",
                        "Gynther Rd near Eton St",
                        "Gynther Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Peninsula Fair, stop B",
                        "Anzac Ave at Lindel Street",
                        "Anzac Ave at Ashmole Road",
                        "Anzac Avenue near Recreation St",
                        "Anzac Ave at Redcliffe Hospital",
                        "Victoria Avenue near Hornibrook Esp",
                        "Bell St near Maine St hail 'n' ride"
                    ],
                    "6714: Kallangur, Murrumba Downs, Dakabin": [
                        "North Lakes station, platform 1",
                        "Anzac Ave near Brays Rd hail 'n' ride",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at McBain Street",
                        "Duffield Rd near Kahala Rd hail 'n' ride",
                        "Duffield Rd near Sapphire Ct hail 'n' ride",
                        "Duffield Rd near Brickworks Rd",
                        "Duffield Rd near Wyena St",
                        "Lavercombe Dr near Lintone St",
                        "Plantation Rd at Kerr Road",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop A",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Marsden Rd near Narangba Rd",
                        "Marsden Rd near Sylvester Dr",
                        "Ann St near Marsden Rd",
                        "Sheaves Rd near Olivia Dr",
                        "Dakabin Primary School",
                        "Whitehorse Rd near Sheaves Rd",
                        "Whitehorse Rd near Seabiscuit Cr",
                        "Dakabin High School",
                        "Alma Rd at Conquest Boulevard",
                        "Kallangur Primary School",
                        "Ann St near Archer St",
                        "Alma Rd at Essencia Avenue",
                        "Balstrup Rd near Olsen Cct",
                        "Lavercombe Dr near Campbell St",
                        "Duffield Rd near Boyandra Dr",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Petrie station, stop B"
                    ],
                    "6715: Southern Cross, Clontarf, Redcliffe": [
                        "Duffield Rd near Elizabeth Ave",
                        "Elizabeth Ave near Nerida Ct",
                        "Elizabeth Ave near Pamrick Cr",
                        "Maine Rd at Windsor Street",
                        "Maine Rd at Gardenia Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd at Beedham Street",
                        "Isobel St near Maine Rd",
                        "Elizabeth Ave near Long St",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Roland St",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp near Donald St",
                        "Victoria Avenue near Hornibrook Esp",
                        "Victoria Ave at Clifford Street",
                        "Victoria Ave at King Street",
                        "Victoria Ave at Dunbar Street",
                        "Victoria Ave at Duffield Road",
                        "Victoria Ave at Barry Bolton Park",
                        "Macdonnell Rd at Kirkwood Street",
                        "Macdonnell Rd at Trilby Street",
                        "Macdonnell Rd near Maine Rd",
                        "Elizabeth Ave at Korsch Street",
                        "George St near Kappella St",
                        "George St near Lindel St",
                        "George St at Jentz St",
                        "Ashmole Rd near Hibiscus Ave",
                        "Ashmole Rd near Anzac Ave hail 'n' ride",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Pinewood Street",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Landsborough Ave at Murphy Street",
                        "Newport Drive near Griffith Rd",
                        "Newport Dr at Southern Cross Drive",
                        "Endeavour Esp at Dolphin Street",
                        "Oyster Point Esp at Michel Road",
                        "Jeays St at Palmtree Avenue",
                        "Seaville Ave near Jeays St",
                        "North Quay at Fifth Avenue",
                        "Fifth Ave at Moffatt Street",
                        "Landsborough Ave at Warde Street",
                        "Landsborough Ave at Rock Street",
                        "Landsborough Ave at Kennedy Esplanade",
                        "Oxley Ave at Adams Street",
                        "Oxley Ave at Pearl Street",
                        "Oxley Ave at Eversleigh Road",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Redcliffe Cultural Centre",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Humpybong Park",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Margate Shopping Centre",
                        "Humpybong Primary School",
                        "Maine Rd near Gerald Ave",
                        "Elizabeth Ave near Handsworth St",
                        "Elizabeth Ave at Clontarf Primary School",
                        "Klingner Rd at Redcliffe State High School",
                        "Kippa-Ring station, stop A",
                        "King St at Clontarf Beach High School",
                        "Victoria Ave at Macdonnell Road",
                        "Victoria Ave at Bradley Park",
                        "Recreation St at Redcliffe Hospital",
                        "Scarborough Rd at Redcliffe Showgrounds",
                        "Scarborough Rd at Klinger Road",
                        "Scarborough Rd at Shields Street",
                        "Scarborough State Primary School",
                        "Oxley Ave at Langdon Park",
                        "Oxley Ave at King Street",
                        "Oxley Ave at Westbrook Street",
                        "Oxley Ave at Annie Street",
                        "Oxley Ave at Alfred Street",
                        "Hornibrook Esp at Woody Point Park",
                        "Hornibrook Esp at Victoria Avenue",
                        "Hornibrook Esp at Clontarf Beach West",
                        "Hornibrook Hwy at Eventide Aged Home",
                        "Beaconsfield Tce near Duke St",
                        "Beaconsfield Tce near Shepherd St",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Twelfth Ave",
                        "Brighton Tce near Tenth Ave",
                        "Brighton Tce near Wakefield St",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Sandgate bus station, stop 3"
                    ],
                    "6716: Rothwell, Kippa-Ring, Clontarf, Sandgate": [
                        "Gynther Rd near Eton St",
                        "Cambridge St near Oxford St",
                        "Cambridge St near Badcoe Ct",
                        "Morris Rd near Gynther Rd",
                        "Morris Rd near Melaleuca Cr",
                        "Morris Rd near Lynanda Ct",
                        "Morris Rd near Taronga St",
                        "Morris Rd near Kirribilli St",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Susan Avenue",
                        "Peninsula Fair, stop B",
                        "Anzac Ave at Lindel Street",
                        "Ashmole Rd near Anzac Ave",
                        "Trilby St at George Street",
                        "Trilby St near Centaur St",
                        "Macdonnell Rd at Trilby Street",
                        "Maine Rd at Windsor Street",
                        "Maine Rd at Gardenia Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd at Beedham Street",
                        "King St at Clontarf Beach High School",
                        "Elizabeth Ave near Long St",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Roland St",
                        "Elizabeth Ave near Angus St",
                        "Hornibrook Hwy at Eventide Aged Home",
                        "Beaconsfield Tce near Duke St",
                        "Beaconsfield Tce near Shepherd St",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Twelfth Ave",
                        "Brighton Tce near Tenth Ave",
                        "Brighton Tce near Wakefield St",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Sandgate bus station, stop 1",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Shields Street",
                        "Oxley Ave at Redcliffe State High School",
                        "Oxley Ave at Redcliffe Cultural Centre",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Humpybong Park",
                        "Oxley Ave at Jamieson Street",
                        "Oxley Ave at Macdonnell Road",
                        "Oxley Ave at McCulloch Avenue",
                        "Oxley Ave at Margate Shopping Centre",
                        "Humpybong Primary School",
                        "Ernest St near Eveline St",
                        "Ernest St near King St",
                        "Oxley Ave at King Street",
                        "Oxley Ave at Westbrook Street",
                        "Oxley Ave at Annie Street",
                        "Oxley Ave at Alfred Street",
                        "Hornibrook Esp at Woody Point Park",
                        "Hornibrook Esp at Victoria Avenue",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Elizabeth Ave near Handsworth St",
                        "Elizabeth Ave at Clontarf Primary School",
                        "Elizabeth Ave near Alice St",
                        "Isobel St near Weaber St",
                        "Maine Rd near Isobel St",
                        "Maine Rd near Duffield Rd hail 'n' ride",
                        "Macdonnell Rd near Maine Rd",
                        "Elizabeth Ave at Korsch Street",
                        "Elizabeth Ave at Grimley Street",
                        "Kroll St near Apex Ave hail 'n' ride",
                        "Chelsea St near Nottingham St hail 'n' ride"
                    ],
                    "6718: North Lakes, Dakabin, Mueller": [
                        "Elizabeth Ave at Korsch Street",
                        "Elizabeth Ave at Grimley Street",
                        "Anzac Ave at Kroll Street",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Mewes Road",
                        "Gynther Road",
                        "Anzac Ave at Finnegan Street",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Capestone Boulevard",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "North Lakes State College",
                        "Anzac Ave at Halpine Drive",
                        "Anzac Ave near Brays Rd hail 'n' ride",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at McBain Street",
                        "Duffield Rd near Kahala Rd hail 'n' ride",
                        "Duffield Rd near Sapphire Ct hail 'n' ride",
                        "Brickworks Rd near Galway Dr",
                        "Ladybird St near Baines St",
                        "Ann St near Old Gympie Rd",
                        "Ann St near Archer St",
                        "Sheaves Rd near Olivia Dr",
                        "Dakabin Primary School",
                        "Dakabin High School",
                        "Alma Rd at Essencia Avenue",
                        "Alma Rd at Conquest Boulevard",
                        "Old Gympie Rd at Butterfly Drive",
                        "Kallangur Primary School",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Marsden Rd near Narangba Rd",
                        "Marsden Rd near Sylvester Dr",
                        "Marsden Rd at Ballara Street",
                        "Dakabin High School Oval Bus Bay",
                        "Old Gympie Rd at Plantation Road",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at Westfield North Lakes",
                        "Anzac Ave at Discovery Drive",
                        "St Benedicts Catholic Primary School",
                        "Gynther Rd near Eton St",
                        "Morris Rd near Gynther Rd",
                        "Morris Rd near Melaleuca Cr",
                        "Morris Rd near Lynanda Ct",
                        "Wattle Rd near Oakmont St hail 'n' ride",
                        "Grace Lutheran College",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Boardman Rd at McGregor Street",
                        "Boardman Rd at Susan Avenue",
                        "Elizabeth Ave near Macdonnell Rd",
                        "Elizabeth Ave near Gardenia St",
                        "Duffield Rd near Kalimna Dr hail 'n' ride",
                        "Maine Rd at Heather Street",
                        "Maine Rd at Beedham Street",
                        "Isobel St near Maine Rd",
                        "Isobel St near Weaber St",
                        "Elizabeth Ave near Long St",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Roland St",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp near Donald St",
                        "Victoria Avenue near Hornibrook Esp",
                        "Victoria Ave at Clifford Street",
                        "Victoria Ave at King Street",
                        "Victoria Ave at Dunbar Street",
                        "Victoria Ave at Duffield Road",
                        "Victoria Ave at Barry Bolton Park",
                        "Victoria Ave at Macdonnell Road",
                        "Victoria Ave at Bradley Park",
                        "Recreation St at Redcliffe Hospital"
                    ],
                    "6719: Rothwell, North Lakes, Kallangur": [
                        "Petrie station, stop A",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "North Lakes station, platform 2",
                        "Endeavour Bvd near Bergin St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Astley Pde",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Bounty Bvd",
                        "Bounty Bvd near Aurora Bvd",
                        "Bounty Bvd near Possum Pde",
                        "Bounty Bvd near Brumby Pde",
                        "Bounty Bvd near Wombat Pde",
                        "Discovery Dr near Tuckeroo Pde",
                        "Discovery Dr near Gardenia Pde",
                        "Discovery Dr near Peron Cr",
                        "Discovery Dr near Willandra Pde",
                        "Discovery Dr near Springsure Pde",
                        "Discovery Dr near College St",
                        "North Lakes State College",
                        "Freshwater Creek Rd near Brushwood Crt",
                        "Freshwater Creek Rd near Jabiru Dr hail 'n' ride",
                        "Freshwater Creek Rd near Tattler St",
                        "Capestone Bvd at Campbell Drive",
                        "Anzac Ave at Capestone Boulevard",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Finnegan Street",
                        "Gynther Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Morris Rd at Lynanda Court",
                        "Gynther Rd near Morris Rd",
                        "Gynther Rd near Eton St",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd at Marsala Street",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Pinewood Street",
                        "Oxley Ave at Klingner Rd",
                        "Oxley Ave at Shields Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Morris Rd near Lynanda Ct",
                        "Wattle Rd near Oakmont St hail 'n' ride",
                        "Bremner Road",
                        "Bounty Bvd near Trevino Pde",
                        "Bounty Bvd near Montgomerie Pde",
                        "Bounty Bvd near Garcia Pde",
                        "Bounty Bvd near Aurora Bvd hail 'n' ride",
                        "Anzac Ave near Brays Rd hail 'n' ride",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Caine Street"
                    ],
                    "6720: North Lakes, Mango Hill, Rothwell": [
                        "Discovery Dr near Springsure Pde",
                        "Discovery Dr near College St",
                        "North Lakes State College",
                        "Halpine Dr at Mango Hill Shopping Centre",
                        "Freshwater Creek Rd near Brushwood Crt",
                        "Freshwater Creek Rd near Jabiru Dr hail 'n' ride",
                        "Freshwater Creek Rd near Tattler St",
                        "Capestone Bvd at Campbell Drive",
                        "Anzac Ave at Capestone Boulevard",
                        "Anzac Ave at Josey Road",
                        "Anzac Ave at Finnegan Street",
                        "Gynther Road",
                        "Grace Lutheran College",
                        "Mewes Road",
                        "Morris Rd at Lynanda Court",
                        "Morris Rd near Lynanda Ct",
                        "Wattle Rd near Oakmont St hail 'n' ride",
                        "Bremner Road",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "Halpine Dr near Talara Way",
                        "Discovery Dr near Southerden Dr",
                        "Discovery Dr near Davenport Pde",
                        "Discovery Dr near Otway Pde",
                        "Discovery Dr near Bridgeport Dr",
                        "Discovery Dr near Marsh St",
                        "Discovery Dr near Tuckeroo Pde"
                    ],
                    "6721: Northlakes State College, Mango Hill": [
                        "St Benedicts Catholic Primary School",
                        "Anzac Ave at Kinsellas Road",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "Kinsellas Rd at Ruby Street",
                        "Capestone Bvd at Campbell Drive",
                        "Napier Ave near Campbell Pde hail 'n' ride",
                        "Campbell Dr near Craigie St hail 'n' ride",
                        "Capestone Bvd near Campbell Dr hail 'n' ride",
                        "Mango Hill station",
                        "Freshwater Creek Rd near Jabiru Dr hail 'n' ride",
                        "Freshwater Creek Rd near Tattler St",
                        "Mango Hill State Secondary College",
                        "Napier Ave near Jamie St hail 'n' ride",
                        "North Lakes State College",
                        "Kinsellas Rd near Maryvale Rd hail 'n' ride",
                        "Halpine Dr near Talara Way",
                        "Mango Hill Bvd near Bowen St hail 'n' ride"
                    ],
                    "6722: Mango Hill State School": [
                        "Anzac Ave at Kinsellas Road",
                        "Stodart Tce near Abercrombie St hail 'n' ride",
                        "Napier Ave near Campbell Pde hail 'n' ride",
                        "Campbell Dr near Craigie St hail 'n' ride",
                        "Capestone Bvd near Campbell Dr hail 'n' ride",
                        "Kinsellas Rd near Maryvale Rd hail 'n' ride",
                        "Freshwater Creek Rd near Tattler St",
                        "Freshwater Creek Rd near Jabiru Dr hail 'n' ride",
                        "Halpine Dr near Talara Way",
                        "Mango Hill Bvd near Bowen St hail 'n' ride",
                        "Mango Hill Primary School",
                        "Freshwater Creek Rd near Brushwood Crt",
                        "Capestone Bvd at Campbell Drive",
                        "Campbell Dr near Napier Av hail 'n' ride",
                        "Campbell Dr near Beesand St hail 'n' ride",
                        "Campbell Dr near Jepson St hail 'n' ride",
                        "Campbell Dr near Capestone Bvd hail 'n' ride"
                    ],
                    "6723: Mango Hill North Lakes Murrumba College": [
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "Kinsellas Rd at Ruby Street",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Capestone Bvd at Campbell Drive",
                        "Kinsellas Rd near Maryvale Rd hail 'n' ride",
                        "Freshwater Creek Rd near Tattler St",
                        "Freshwater Creek Rd near Jabiru Dr hail 'n' ride",
                        "Halpine Dr at Mango Hill Shopping Centre",
                        "North Lakes State College",
                        "Anzac Ave at Halpine Drive",
                        "Anzac Ave near Brays Rd hail 'n' ride",
                        "Brays Rd near Moreton St",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Ogg Rd at Undurba Primary School",
                        "Murrumba State Secondary College",
                        "Alana St at Blatchford Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "Freshwater Creek Rd near Brushwood Crt"
                    ],
                    "6800: Bray Park, Holy Spirit, Kurwongbah, Petrie": [
                        "Bells Pocket Rd near Robel St",
                        "Spitfire Ave near Blenheim St hail 'n' ride",
                        "Strathpine Primary School",
                        "Bells Pocket Rd near Wirraway St",
                        "Peter St near Marshall St hail 'n' ride",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Samsonvale Rd near Windrest St",
                        "Bray Park High School",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Old North Rd at Brisbane Rd",
                        "Samsonvale Rd near Dundee St",
                        "Samsonvale Rd near Elmwood Dr",
                        "Samsonvale Rd near Kentwood Dr",
                        "Samsonvale Rd near Evergreen Ave",
                        "Casuarina Dr S near Taedi Ave",
                        "Holy Spirit Catholic Primary School",
                        "Sparks Rd near Alcira St",
                        "Sparkes Rd near Panorama St",
                        "Francis Rd near Nightingale Dr",
                        "Francis Rd near Granville Dr",
                        "Francis Rd near Colonial Dr",
                        "Francis Rd near Havana Lane",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd at Todds Road",
                        "Fairlane St near Jaguar Ct hail 'n' ride",
                        "McIllwraith Rd near Gladys Ct hail 'n' ride",
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Beeville Rd at Oleron Tce",
                        "Frenchs Rd near Beeville Rd hail 'n' ride",
                        "Frenchs Rd near Macquarie Dr hail 'n' ride",
                        "Macquarie Dr near Barrine Ct hail 'n' ride",
                        "Kurwongbah Primary School",
                        "Frenchs Rd at Macquarie Drive",
                        "Belrose Ave near Gehrman Ct hail 'n' ride",
                        "Belrose Ave near Rue Montaigne",
                        "Woonara Dr near Joora Ave",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Joora Ave",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride",
                        "Youngs Crossing Rd near McIllwraith Rd HnR",
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Nanbaree Dr near Quiamong Ct",
                        "Nanbaree Dr near Old North Rd",
                        "Windrest St near Garbala Dr",
                        "Strathpine West Primary School",
                        "Ellerdale St near Tecoma St",
                        "Navua St near Bygrave St",
                        "Stanley Street near Navua St",
                        "Leitchs Rd near Avalon Ct",
                        "Nicol Way near Stevens Dr",
                        "Nicol Way near Turner Dr",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Bray Park station",
                        "Bells Pocket Rd near Lancaster St",
                        "Bells Pocket Rd near Bateman St",
                        "Gympie Rd at Stanley Street",
                        "Strathpine bus station"
                    ],
                    "6801: Lawnton, Holy Spirit, Bray Park": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Samsonvale Rd near Dundee St",
                        "Samsonvale Rd near Elmwood Dr",
                        "Dean St near Lockyer Dr",
                        "Mitze St near Clayton Ct",
                        "Aaron St near Mitze St",
                        "Todds Rd near Oxbow Rd",
                        "Todds Rd at Sandown Ct",
                        "Todds Rd near Youngs Crossing Rd",
                        "Francis Rd near Ebony Ct",
                        "Francis Rd near Colonial Dr",
                        "Francis Rd near Granville Dr",
                        "Nightingale Dr near Slack Ct",
                        "Nightingale Dr near Darcy Way",
                        "Todds Rd at Lawnton Primary School",
                        "Spencer St near Todds Rd",
                        "Tulip St near Spencer St",
                        "Tulip St near Colleen St",
                        "Rose St near Bray Rd",
                        "Bray Rd near Pinelands St",
                        "Slater Avenue at Lawnton",
                        "Lawnton station",
                        "Ellis St near Brown St CLOSED 1 Sept 2025 - June 2026",
                        "Francis Rd near Mitchell St",
                        "Tarandi St near Francis Rd",
                        "Tarandi St near Yenara St",
                        "Pine Rivers High School",
                        "Viscount St near Welsh St",
                        "Bray Park Primary School",
                        "Sparkes Rd near Nottingham Pde",
                        "Sparkes Rd near Cedrela Cr",
                        "Bray Park High School",
                        "Nanbaree Dr near Quiamong Ct",
                        "Nanbaree Dr near Old North Rd",
                        "Windrest St near Garbala Dr",
                        "Strathpine West Primary School",
                        "Windrest St near Acland Dr",
                        "Sparkes Rd near Cedrela Cr hail 'n' ride",
                        "Holy Spirit Catholic Primary School",
                        "Kumbari St near Tarandi St",
                        "Tarandi St near Jilba St",
                        "Francis Rd near Nightingale Dr",
                        "Bray Rd near Rose St",
                        "Todds Rd at Wattlebird Court",
                        "Aaron St near Francis Rd",
                        "Mitze St near Aaron St",
                        "Dean St near Shirley St",
                        "Dean St near Lester St",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6805: Genesis, Bray Park, Strathpine, Holy Spirit": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "Warner Rd near Haven St hail 'n' ride",
                        "Whimbrel St near Warner Rd hail 'n' ride",
                        "Starling St near Lowan St hail 'n' ride",
                        "Sanderling Dr near Quarrion Ct Rd hail 'n' ride",
                        "Somers St near Mary Ct hail 'n' ride",
                        "Somers St near Jane Ct hail 'n' ride",
                        "Somers St near Thomas Ct hail 'n' ride",
                        "Barker St near Ireland Ct hail 'n' ride",
                        "Beech Dr near Gibson Ct hail 'n' ride",
                        "Cashs Rd near Beech Dr hail 'n' ride",
                        "Peppermint Dr near Bracken Ct hail 'n' ride",
                        "Peppermint Dr near Ira Buckby Rd West HnR",
                        "Corvus Dr near Trevor Pl hail 'n' ride",
                        "Corvus Dr near Harrison St hail 'n' ride",
                        "Ken Duncombe Dr near Corvus Dr hail 'n' ride",
                        "Ira Buckby Rd nr Cashmere Lane hail'n'ride",
                        "Ira Buckby Rd near Hayward Ave",
                        "Ira Buckby Rd near Franzin Dr",
                        "Samsonvale Rd near Regent St",
                        "Samsonvale Rd at Kurrajong Drive",
                        "Samsonvale Rd near Youngs Crossing Rd",
                        "Genesis Christian College",
                        "Samsonvale Rd near Dundee St",
                        "Samsonvale Rd near Elmwood Dr",
                        "Samsonvale Rd near Kentwood Dr",
                        "Samsonvale Rd near Evergreen Ave",
                        "Bray Park High School",
                        "Windrest St near Garbala Dr",
                        "Strathpine West Primary School",
                        "Samsonvale Rd near Windrest St",
                        "Holy Spirit Catholic Primary School",
                        "Bray Park Primary School",
                        "Guards St near Grenadier St",
                        "Sovereign Ave near Durham Cr",
                        "Kensington Way near Sovereign Ave",
                        "Kensington Ave near Cheltenham St",
                        "Samsonvale Rd near Gum St",
                        "Samsonvale Rd near Kurrajong Dr",
                        "Samsonvale Rd near Ira Buckby Rd hail 'n' ride",
                        "Ira Buckby Rd near Franzin Dr hail 'n' ride",
                        "Ira Buckby Rd near Hayward Av hail 'n' ride",
                        "Ira Buckby Rd near Sarow Dr hail 'n' ride",
                        "Beech Dr near Cashs Rd hail 'n' ride",
                        "Beech Dr near Laurel Ct hail 'n' ride",
                        "Beech Dr near Lilley Rd hail 'n' ride",
                        "Sanderling Dr near Quarrion Ct hail 'n' ride",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6806: Genesis, Bray Park, Pine Rivers": [
                        "Protheroe Rd near Byrnes Rd hail 'n' ride",
                        "Forgan Rd near Bullocky Rest hail 'n' ride",
                        "Forgan Rd near Gordons Crossing Rd hail 'n' ride",
                        "Samsonvale Rd near Lindale Ct hail 'n' ride",
                        "Regent St near Samsonvale Rd hail 'n' ride",
                        "Gordons Crossing Rd near Karelyn Dr hail 'n' ride",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd at Todds Road",
                        "Fairlane St near Jaguar Ct hail 'n' ride",
                        "McIllwraith Rd near Gladys Ct hail 'n' ride",
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Bray Park High School",
                        "Samsonvale Rd near Windrest St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Buckby St at Pine Rivers High School",
                        "Strathpine Primary School",
                        "Bells Pocket Rd near Bateman St",
                        "Bells Pocket Rd near Robel St",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Clifford St near Edward St hail 'n' ride",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Old North Rd at Brisbane Rd"
                    ],
                    "6807: Genesis, Bray Park, Pine Rivers": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "South Pine Rd at Bunya Park",
                        "Albany Creek Rd at Hylacola",
                        "Albany Creek Rd near Old Northern Rd",
                        "Albany Creek Rd near Bowen Ave",
                        "Albany Creek Rd at Leitchs Road",
                        "Keong Rd near Seligan St",
                        "Keong Rd near Malvern Rd",
                        "Keong Rd near Crofty St",
                        "Keong Rd near Rafter Ave",
                        "Keong Rd near Dawn Rd",
                        "Keong Rd near Hampshire Tce",
                        "Old Northern Rd at Keong Road",
                        "Jinker Track near Allamanda Cr",
                        "Thiess Dr at Challinor",
                        "Thiess Dr at Jagora",
                        "Thiess Dr near Mahogany Dr",
                        "Thiess Dr at Narrabeen",
                        "Albany Forest Dr at Explorer",
                        "Albany Forest Dr at Dove",
                        "Morgan Rd at Morgan",
                        "Faheys Rd West at Kingfisher",
                        "Flamingo Dr near Garganey St",
                        "South Pine Rd at Hylacola",
                        "Queen Elizabeth Dr at Eatons Hill",
                        "Queen Elizabeth Dr at Hero Street",
                        "Queen Elizabeth Dr at Corso Street",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "Queen Elizabeth Dr at Eatonvale",
                        "Church Road near Drapers Road hail 'n' ride",
                        "Lilley Rd near Eatons Crossing Rd hail 'n' ride",
                        "Lilley Rd near Parakeet Ct hail 'n' ride",
                        "Kremzow Rd near Rolland Pde hail 'n' ride",
                        "Russet Burbank Pde near Delawar Rd",
                        "Pallas Pde near Russett Burbank Pde",
                        "Pallas Pde near Brisbane Rd",
                        "Brisbane Rd near Old North Rd",
                        "Old North Rd at Brisbane Rd",
                        "Genesis Christian College",
                        "Buckby St at Pine Rivers High School",
                        "Bells Pocket Rd near Robel St",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Windrest St near Acland Dr",
                        "Nanbaree Dr near Old North Rd",
                        "Nanbaree Dr near Quiamong Ct",
                        "Bray Park High School",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Brisbane Rd near Solomon Pde",
                        "Pallas Pde at Ballyalla Crescent",
                        "Russet Burbank Pde near Swan Pde",
                        "Eden Dr near Sarah Ct hail 'n' ride",
                        "Drapers Rd near Fletchers Rd hail 'n' ride",
                        "Drapers Rd near Barton Ct hail 'n' ride",
                        "Drapers Rd near Bunya Crossing Rd hail 'n' ride",
                        "Bunya Crossing Rd near Birmingham St hail 'n' ride",
                        "Queen Elizabeth Dr at Hero",
                        "Eatons Hill at Queen Elizabeth Drive",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6808: Strathpine West, Bray Park, Holy Spirit": [
                        "Strathpine bus station, stop B",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Leitchs Rd near Avalon Ct",
                        "Nicol Way near Stevens Dr",
                        "Nicol Way near Turner Dr",
                        "Stanley St near Leitchs Rd",
                        "Stanley St near Livingstone St",
                        "Navua St near Torelliana Dr",
                        "Ellerdale St near Centre St",
                        "Strathpine West Primary School",
                        "Windrest St near Acland Dr",
                        "Nanbaree Dr near Old North Rd",
                        "Nanbaree Dr near Quiamong Ct",
                        "Bray Park High School",
                        "Holy Spirit Catholic Primary School",
                        "Bray Park Primary School"
                    ],
                    "6811: Eatons Hill, All Saints, Albany Hills, AlbanyCreek": [
                        "Protheroe Rd near Byrnes Rd hail 'n' ride",
                        "Forgan Rd near Bullocky Rest hail 'n' ride",
                        "Forgan Rd near Gordons Crossing Rd hail 'n' ride",
                        "Samsonvale Rd near Lindale Ct hail 'n' ride",
                        "Ira Buckby Rd near Franzin Dr hail 'n' ride",
                        "Ira Buckby Rd near Hayward Av hail 'n' ride",
                        "Ira Buckby Rd near Sarow Dr hail 'n' ride",
                        "Corvus Dr near Trevor Pl hail 'n' ride",
                        "Corvus Dr near Harrison St hail 'n' ride",
                        "Ken Duncombe Dr near Corvus Dr hail 'n' ride",
                        "Peppermint Dr near Ira Buckby Rd West HnR",
                        "Peppermint Dr near Bracken Ct hail 'n' ride",
                        "Beech Dr near Cashs Rd hail 'n' ride",
                        "Beech Dr near Laurel Ct hail 'n' ride",
                        "Beech Dr near Gibson Ct hail 'n' ride",
                        "Beech Dr near Lilley Rd hail 'n' ride",
                        "Sanderling Dr near Quarrion Ct hail 'n' ride",
                        "Starling St near Lowan St hail 'n' ride",
                        "Whimbrel St near Warner Rd hail 'n' ride",
                        "Paddy Rd near Sally Ct hail 'n' ride",
                        "Marylin Tce at Eatons Hill State School",
                        "South Pine Rd at Bunya Park",
                        "Old Northern Rd at Retirement Village",
                        "Albany Forest Dr at Explorer",
                        "Albany Creek State High School",
                        "All Saints Catholic Primary School",
                        "Sussex Dr near Folkstone Ave",
                        "Keong Rd near Dawn Rd",
                        "Albany Hills State Primary School",
                        "Old Northern Rd at Albany Creek High",
                        "Old Northern Rd near Albany Forest Dr",
                        "Old Northern Rd at Leisure Centre",
                        "South Pine Rd at Hylacola",
                        "Paddy Rd near Beth Ct hail 'n' ride",
                        "Sanderling Dr near Quarrion Ct Rd hail 'n' ride",
                        "Cashs Rd near Beech Dr hail 'n' ride",
                        "Ira Buckby Rd nr Cashmere Lane hail'n'ride",
                        "Ira Buckby Rd near Hayward Ave",
                        "Ira Buckby Rd near Franzin Dr",
                        "Samsonvale Rd near Winn Rd hail 'n' ride"
                    ],
                    "6812: Eatons Hill, Albany Creek": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Samsonvale Rd near Gum St",
                        "Samsonvale Rd near Kurrajong Dr",
                        "Samsonvale Rd near Ira Buckby Rd hail 'n' ride",
                        "Ira Buckby Rd near Franzin Dr hail 'n' ride",
                        "Ira Buckby Rd near Hayward Av hail 'n' ride",
                        "Ira Buckby Rd near Sarow Dr hail 'n' ride",
                        "Lilley Rd near Parakeet Ct hail 'n' ride",
                        "Lilley Rd near Eatons Crossing Rd hail 'n' ride",
                        "Eden Dr near Sarah Ct hail 'n' ride",
                        "Church Road near Drapers Road hail 'n' ride",
                        "Drapers Rd near Fletchers Rd hail 'n' ride",
                        "Drapers Rd near Barton Ct hail 'n' ride",
                        "Drapers Rd near Bunya Crossing Rd hail 'n' ride",
                        "Bunya Crossing Rd near Birmingham St hail 'n' ride",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "Queen Elizabeth Dr at Corso Street",
                        "Queen Elizabeth Dr at Hero",
                        "Marylin Tce at Eatons Hill State School",
                        "South Pine Rd at Bunya Park",
                        "Old Northern Rd at Retirement Village",
                        "Albany Forest Dr at Explorer",
                        "Albany Creek State High School",
                        "Old Northern Rd at Leisure Centre",
                        "South Pine Rd at Hylacola",
                        "Queen Elizabeth Dr at Hero Street",
                        "Queen Elizabeth Dr at Eatonvale",
                        "Ira Buckby Rd nr Cashmere Lane hail'n'ride",
                        "Ira Buckby Rd near Hayward Ave",
                        "Ira Buckby Rd near Franzin Dr",
                        "Samsonvale Rd near Regent St",
                        "Samsonvale Rd at Kurrajong Drive",
                        "Samsonvale Rd near Youngs Crossing Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6813: Eatons Hill, All Saints, Albany Hills, AlbanyCreek": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Gordons Crossing Rd near Karelyn Dr hail 'n' ride",
                        "Regent St near Samsonvale Rd hail 'n' ride",
                        "Ira Buckby Rd near Franzin Dr hail 'n' ride",
                        "Ira Buckby Rd near Hayward Av hail 'n' ride",
                        "Ira Buckby Rd near Sarow Dr hail 'n' ride",
                        "Lilley Rd near Parakeet Ct hail 'n' ride",
                        "Clear Mountain Rd near Branch Creek Rd HnR",
                        "Clear Mountain Rd near Buranda Rd hail 'n' ride",
                        "Clear Mountain Rd near Ramsay Rd hail 'n' ride",
                        "Clear Mountain Rd and Dobson Rd hail 'n' ride",
                        "Clear Mountain Rd near Cashs Rd hail 'n' ride",
                        "Somers St near Mary Ct hail 'n' ride",
                        "Somers St near Jane Ct hail 'n' ride",
                        "Somers St near Thomas Ct hail 'n' ride",
                        "Barker St near Ireland Ct hail 'n' ride",
                        "Harrier Pl near Warner Rd West hail 'n' ride",
                        "Lilley Rd near Eatons Crossing Rd hail 'n' ride",
                        "Marylin Tce at Eatons Hill State School",
                        "South Pine Rd at Bunya Park",
                        "Albany Creek Rd at Hylacola",
                        "Albany Creek Rd near Old Northern Rd",
                        "Albany Creek Primary School",
                        "All Saints Catholic Primary School",
                        "Sussex Dr near Folkstone Ave",
                        "Keong Rd near Dawn Rd",
                        "Albany Hills State Primary School",
                        "South Pine Rd at Hylacola",
                        "Ira Buckby Rd nr Cashmere Lane hail'n'ride",
                        "Ira Buckby Rd near Hayward Ave",
                        "Ira Buckby Rd near Franzin Dr",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6814: Eatons Hill, Albany Creek": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Francis Rd near Ebony Ct",
                        "Francis Rd near Colonial Dr",
                        "Francis Rd near Granville Dr",
                        "Francis Rd near Nightingale Dr",
                        "Sparkes Rd near Gerard St",
                        "Sparks Rd near Hopetoun St",
                        "Sparkes Rd near Nottingham Pde",
                        "Sparkes Rd near Cedrela Cr",
                        "Samsonvale Rd near Windrest St",
                        "Windrest St near Acland Dr",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "Marylin Tce at Eatons Hill State School",
                        "South Pine Rd at Bunya Park",
                        "Old Northern Rd at Retirement Village",
                        "Albany Forest Dr at Explorer",
                        "Albany Creek State High School",
                        "Old Northern Rd at Leisure Centre",
                        "South Pine Rd at Hylacola",
                        "Windrest St near Garbala Dr",
                        "Sparkes Rd near Cedrela Cr hail 'n' ride",
                        "Holy Spirit Catholic Primary School",
                        "Sparks Rd near Alcira St",
                        "Sparkes Rd near Panorama St",
                        "Francis Rd near Havana Lane",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6815: Eatons Hill, Albany Creek": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Gordons Crossing Rd near Karelyn Dr hail 'n' ride",
                        "Regent St near Samsonvale Rd hail 'n' ride",
                        "Samsonvale Rd near Regent St",
                        "Samsonvale Rd at Kurrajong Drive",
                        "Samsonvale Rd near Youngs Crossing Rd",
                        "Samsonvale Rd near Dundee St",
                        "Samsonvale Rd near Elmwood Dr",
                        "Samsonvale Rd near Kentwood Dr",
                        "Samsonvale Rd near Evergreen Ave",
                        "Bray Park High School",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Brisbane Rd near Solomon Pde",
                        "Pallas Pde near Brisbane Rd",
                        "Pallas Pde at Ballyalla Crescent",
                        "Russet Burbank Pde near Swan Pde",
                        "Russet Burbank Pde near Delawar Rd",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "Marylin Tce at Eatons Hill State School",
                        "South Pine Rd at Bunya Park",
                        "Flamingo Dr near Chickowee St",
                        "Faheys Rd West at Kingfisher",
                        "Morgan Rd at Morgan",
                        "Albany Forest Dr at Dove",
                        "Albany Forest Dr at Explorer",
                        "Albany Creek State High School",
                        "Old Northern Rd at Leisure Centre",
                        "Flamingo Dr near Garganey St",
                        "South Pine Rd at Hylacola",
                        "Pallas Pde near Russett Burbank Pde",
                        "Brisbane Rd near Old North Rd",
                        "Lavarack Rd at Bray Park High School",
                        "Samsonvale Rd near Gum St",
                        "Samsonvale Rd near Kurrajong Dr",
                        "Samsonvale Rd near Ira Buckby Rd hail 'n' ride",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6820: Murrumba, Unburba, Dakabin": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "Brays Rd near Moreton St",
                        "Brays Rd near Burnett Dr",
                        "Brays Rd near Tesch Rd (CLOSED FROM 13/4/26 - 31/7/26)",
                        "Cairns Rd at Vermilion Avenue",
                        "Vermillion Ave near Grandview Pde",
                        "Brays Rd near Lavender Dr hail 'n' ride",
                        "Shoreview Bvd near Sawmill Dr hail 'n' ride",
                        "Dohles Rocks Rd near Castle Hill Dr",
                        "Castle Hill Dr near Pine River Dr",
                        "Pine River Dr near Paroo Pl",
                        "Pine River Dr near Drysdale Ct",
                        "Castle Hill Dr near Nottinghill Rd",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Winchcombe Ave",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Ogg Rd at Undurba Primary School",
                        "Murrumba State Secondary College",
                        "Goodfellows Rd near Alana St",
                        "Goodfellows Rd near Buse Ct",
                        "Duffield Rd near Winter Rd",
                        "Duffield Rd at Azalea Ct",
                        "Anzac Ave at The Crescent",
                        "School Rd near Ann St",
                        "Lillybrook Shops hail 'n' ride",
                        "Brickworks Rd near Kookaburra St hail 'n' ride",
                        "Brickworks Rd near Galway Dr",
                        "Duffield Rd near Brickworks Rd",
                        "Duffield Rd near Wyena St",
                        "Loowa St near Duffield Rd hail 'n' ride",
                        "Balstrup Rd near Olsen Cct",
                        "Plantation Rd at Kerr Road",
                        "Old Gympie Rd at Plantation Road",
                        "Whitehorse Rd near Cootha Dr",
                        "Whitehorse Rd near Sheaves Rd",
                        "Whitehorse Rd near Seabiscuit Cr",
                        "Dakabin High School Oval Bus Bay",
                        "Old Gympie Road at Whitehorse Road",
                        "Lintone St near Boyanda Dr hail 'n' ride",
                        "Kallangur Primary School",
                        "Kallangur station, stop B",
                        "Dohles Rocks Rd near Chestnut Drive",
                        "Alana St at Blatchford Drive",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Castle Hill Dr near Cherington Way",
                        "Castle Hill Dr near Farrington Dr",
                        "Murrumba Downs Shopping Centre",
                        "Dohles Rocks Rd at Silvereye Ave hail 'n' ride",
                        "Brays Rd near Vermilion Av hail 'n' ride",
                        "Vermilion Ave near Sepia Pl hail 'n' ride",
                        "Brays Rd near Cairns Rd (Closed from 10 Nov 2025 - 31 July 2026)",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Dayboro Rd near Joora Ave",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6821: Genesis, Bray Park, Kurwongbah, Petrie": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Narangba Rd at Kedron Road",
                        "Eucumbene Dr near Narangba Rd hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St hail 'n' ride",
                        "Eucumbene Dr near Frenchs Rd",
                        "Frenchs Rd near Kurwongbah Primary School HnR",
                        "Frenchs Rd at Macquarie Drive",
                        "Frenchs Rd near Belrose Av hail 'n' ride",
                        "Frenchs Rd near Beeville Rd hail 'n' ride",
                        "Beeville Rd near Chambery Rd hail 'n' ride",
                        "Affleck Ave at Washbrook Crescent",
                        "Affleck Ave at Homestead Place",
                        "D'Aguilar St at Hunter Circuit",
                        "D'Aguilar St near Ruby Cr hail 'n' ride",
                        "Andrew Petrie Dr at Affleck Avenue",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride",
                        "Youngs Crossing Rd near McIllwraith Rd HnR",
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Bray Park High School",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road",
                        "Beeville Rd at Oleron Tce",
                        "Frenchs Rd near Macquarie Dr hail 'n' ride",
                        "Macquarie Dr near Barrine Ct hail 'n' ride",
                        "Kurwongbah Primary School",
                        "Belrose Ave near Gehrman Ct hail 'n' ride",
                        "Belrose Ave near Rue Montaigne",
                        "Woonara Dr near Joora Ave",
                        "Petrie Primary School",
                        "Dayboro Rd near Joora Ave",
                        "Fairlane St near Jaguar Ct hail 'n' ride",
                        "McIllwraith Rd near Gladys Ct hail 'n' ride",
                        "Francis Rd near Ebony Ct",
                        "Francis Rd near Colonial Dr",
                        "Francis Rd near Granville Dr",
                        "Francis Rd near Nightingale Dr",
                        "Sparkes Rd near Gerard St",
                        "Sparks Rd near Hopetoun St",
                        "Sparkes Rd near Nottingham Pde",
                        "Sparkes Rd near Cedrela Cr",
                        "Samsonvale Rd near Evergreen Ave",
                        "Samsonvale Rd near Kentwood Dr",
                        "Samsonvale Rd near Elmwood Dr",
                        "Samsonvale Rd near Dundee St"
                    ],
                    "6822: Pine Rivers, Bray Park, Kallangur, Dakabin, Petrie": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Dohles Rocks Rd near Bluegum St",
                        "Dohles Rocks Rd near Clyde St",
                        "Dohles Rocks Rd near Chestnut Drive",
                        "Blatchford Dr near Marlene St",
                        "Alana St near Blatchford Dr",
                        "Goodfellows Rd near Alana St",
                        "Goodfellows Rd near Buse Ct",
                        "Duffield Rd near Winter Rd",
                        "Duffield Rd at Azalea Ct",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Ann St near Archer St",
                        "Ann St near Marsden Rd",
                        "Marsden Rd at Ballara Street",
                        "Dakabin High School Oval Bus Bay",
                        "Marsden Rd near Sylvester Dr",
                        "Marsden Rd near Narangba Rd",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Dayboro Rd near Joora Ave",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride",
                        "Youngs Crossing Rd near McIllwraith Rd HnR",
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Bray Park High School",
                        "Samsonvale Rd near Windrest St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Buckby St at Pine Rivers High School",
                        "Strathpine Primary School",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road",
                        "Ogg Rd at Undurba Primary School",
                        "Murrumba State Secondary College",
                        "School Rd near Ann St",
                        "Ann St near Old Gympie Rd",
                        "Narangba Rd at Kedron Road",
                        "Eucumbene Dr near Narangba Rd hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St hail 'n' ride",
                        "Eucumbene Dr near Frenchs Rd",
                        "Frenchs Rd near Kurwongbah Primary School HnR",
                        "Frenchs Rd at Macquarie Drive",
                        "Frenchs Rd near Belrose Av hail 'n' ride",
                        "Frenchs Rd near Beeville Rd hail 'n' ride",
                        "Beeville Rd near Chambery Rd hail 'n' ride"
                    ],
                    "6823: Undurba, Murrumba": [
                        "Ogg Rd at Undurba Primary School",
                        "Murrumba State Secondary College",
                        "Alana St at Blatchford Drive",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Brays Rd near Burnett Dr",
                        "Brays Rd near Tesch Rd (CLOSED FROM 13/4/26 - 31/7/26)",
                        "Cairns Rd at Vermilion Avenue",
                        "Vermillion Ave near Grandview Pde",
                        "Lavender Dr near Vanilla Ave",
                        "Vanilla Ave near Basil Street",
                        "Dandelion St at Sorrel Street",
                        "Coriander Dr near Sandlewood Cr hail 'n' ride",
                        "Brays Rd near Cardamom Cl hail 'n' ride",
                        "Brays Rd near Sunray Pde hail 'n' ride",
                        "Kalu St near Verano Rd hail 'n' ride",
                        "Summertaste Pde near Goldie St hail 'n' ride",
                        "Rondalee Dr near Floradel St hail 'n' ride",
                        "Brays Rd at Henry Road",
                        "Tesch Rd near Stewart Rd hail 'n' ride",
                        "Griffin Primary School"
                    ],
                    "6824: Undurba, Murrumba": [
                        "Griffin Primary School",
                        "Tesch Rd near Stewart Rd hail 'n' ride",
                        "Brays Rd near Tesch Rd (CLOSED FROM 13/4/26 - 31/7/26)",
                        "Cairns Rd at Vermilion Avenue",
                        "Vermillion Ave near Grandview Pde",
                        "Lavender Dr near Vanilla Ave",
                        "Vanilla Ave near Basil Street",
                        "Dandelion St at Sorrel Street",
                        "Coriander Dr near Sandlewood Cr hail 'n' ride",
                        "Brays Rd near Cardamom Cl hail 'n' ride",
                        "Brays Rd near Sunray Pde hail 'n' ride",
                        "Kalu St near Verano Rd hail 'n' ride",
                        "Summertaste Pde near Goldie St hail 'n' ride",
                        "Rondalee Dr near Floradel St hail 'n' ride",
                        "Brays Rd at Henry Road",
                        "Shoreview Bvd near Sawmill Dr hail 'n' ride",
                        "Dohles Rocks Rd near Henry Rd hail 'n' ride",
                        "Apple Cct near Mint Cr hail 'n' ride",
                        "Apple Cct near Fern Pde hail 'n' ride",
                        "White Ibis Dr near Ferngrove Estate hail 'n' ride",
                        "Silvereye Dr at 67 Silvereye Plc hail 'n' ride",
                        "Bettson Bvd near Montegrande Cct hail 'n' ride",
                        "Bettson Bvd near Griffin Rise hail 'n' ride",
                        "Bettson Bvd near Harvey Cct hail 'n' ride",
                        "Wagner Rd near Oriole St hail 'n' ride",
                        "Dohles Rocks Rd near Castle Hill Dr",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Ogg Rd at Undurba Primary School",
                        "Murrumba State Secondary College",
                        "Alana St at Blatchford Drive",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Dohles Rocks Rd at McClintock Drive",
                        "Murrumba Downs Shopping Centre",
                        "White Ibis Dr near Silvereye Dr hail 'n' ride",
                        "Brays Rd near Coriander Dr hail 'n' ride",
                        "Brays Rd near Vermilion Av hail 'n' ride"
                    ],
                    "6825: Undurba, Murrumba": [
                        "Ogg Rd at Undurba Primary School",
                        "Murrumba State Secondary College",
                        "Alana St at Blatchford Drive",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Castle Hill Dr near Cherington Way",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Farrington Dr",
                        "Pine River Dr near Paroo Pl",
                        "Pine River Dr near Drysdale Ct",
                        "Pine River Dr near Yaraki Ct hail 'n' ride",
                        "Pine River Dr near Neales St",
                        "Pine River Dr near Yaraki Ct",
                        "Murrumba Downs Shopping Centre"
                    ],
                    "6830: Mango Hill, St Benedicts, North Lakes High": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Samsonvale Rd near Dundee St",
                        "Samsonvale Rd near Elmwood Dr",
                        "Samsonvale Rd near Kentwood Dr",
                        "Samsonvale Rd near Evergreen Ave",
                        "Sparkes Rd near Cedrela Cr hail 'n' ride",
                        "Holy Spirit Catholic Primary School",
                        "Sparks Rd near Alcira St",
                        "Sparkes Rd near Panorama St",
                        "Ellis St at Brown Street",
                        "Ellis St near Brett St",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Station Road",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Duffield Rd at Azalea Ct",
                        "Duffield Rd near Winter Rd",
                        "Goodfellows Rd near Blatchford Dr",
                        "Goodfellows Rd near Murrumba State Secondary College HnR",
                        "Brays Rd near Moreton St",
                        "Anzac Ave at Westfield North Lakes",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "North Lakes station, platform 1",
                        "North Lakes State College",
                        "St Benedicts Catholic Primary School",
                        "Capestone Bvd near Campbell Dr hail 'n' ride",
                        "Mango Hill Primary School",
                        "Capestone Bvd at Campbell Drive",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "Kinsellas Rd at Ruby Street",
                        "Anzac Ave at Halpine Drive",
                        "Murrumba State Secondary College",
                        "Goodfellows Rd near Alana St",
                        "Goodfellows Rd near Buse Ct",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Ellis St near Brown St CLOSED 1 Sept 2025 - June 2026",
                        "Sparkes Rd near Gerard St",
                        "Sparks Rd near Hopetoun St",
                        "Sparkes Rd near Nottingham Pde",
                        "Sparkes Rd near Cedrela Cr",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6831: Griffin Primary": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Dohles Rocks Rd near Bluegum St",
                        "Dohles Rocks Rd near Clyde St",
                        "Dohles Rocks Rd near Chestnut Drive",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Dohles Rocks Rd at McClintock Drive",
                        "Murrumba Downs Shopping Centre",
                        "Bettson Bvd near Montegrande Cct hail 'n' ride",
                        "Bettson Bvd near Griffin Rise hail 'n' ride",
                        "Bettson Bvd near Harvey Cct hail 'n' ride",
                        "Wagner Rd near Oriole St hail 'n' ride",
                        "White Ibis at Silvereye Rd hail 'n' ride",
                        "Apple Cct near Mint Cr hail 'n' ride",
                        "Apple Cct near Fern Pde hail 'n' ride",
                        "White Ibis Dr near Ferngrove Estate hail 'n' ride",
                        "Silvereye Dr at 67 Silvereye Plc hail 'n' ride",
                        "Dohles Rocks Rd at Silvereye Ave hail 'n' ride",
                        "Shoreview Bvd near Sawmill Dr hail 'n' ride",
                        "Brays Rd near Coriander Dr hail 'n' ride",
                        "Brays Rd near Cardamom Cl hail 'n' ride",
                        "Brays Rd near Sunray Pde hail 'n' ride",
                        "Kalu St near Verano Rd hail 'n' ride",
                        "Summertaste Pde near Goldie St hail 'n' ride",
                        "Rondalee Dr near Floradel St hail 'n' ride",
                        "Dandelion St at Sorrel St hail 'n' ride",
                        "Lavender Dr near Vanilla Ave hail 'n' ride",
                        "Vermilion Ave near Sepia Pl hail 'n' ride",
                        "Cairns Rd at Vermilion Avenue",
                        "Tesch Rd near Stewart Rd hail 'n' ride",
                        "Griffin Primary School",
                        "Brays Rd near Tesch Rd (CLOSED FROM 13/4/26 - 31/7/26)",
                        "Vermillion Ave near Grandview Pde",
                        "Lavender Dr near Vanilla Ave",
                        "Vanilla Ave near Basil Street",
                        "Dandelion St at Sorrel Street",
                        "Coriander Dr near Sandlewood Cr hail 'n' ride",
                        "Brays Rd at Henry Road",
                        "White Ibis Dr near Silvereye Dr hail 'n' ride",
                        "Dohles Rocks Rd near Castle Hill Dr",
                        "Castle Hill Dr near Pine River Dr",
                        "Castle Hill Dr near Nottinghill Rd",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Winchcombe Ave",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Dohles Rocks Rd near Chestnut Dr",
                        "Dohles Rocks Rd near School Rd",
                        "Dohles Rocks Rd near Evelyn St",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Dayboro Rd near Joora Ave",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6832: Mango Hill, St Benedicts, North Lakes High": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "Discovery Dr near Southerden Dr",
                        "Discovery Dr near Davenport Pde",
                        "Discovery Dr near Otway Pde",
                        "Discovery Dr near Bridgeport Dr",
                        "Discovery Dr near Marsh St",
                        "Discovery Dr near Tuckeroo Pde",
                        "Bounty Bvd near Trevino Pde",
                        "Bounty Bvd near Montgomerie Pde",
                        "Bounty Bvd near Garcia Pde",
                        "Bounty Bvd near Aurora Bvd hail 'n' ride",
                        "Endeavour Bvd near Bounty Bvd",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Astley Pde",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Bergin St",
                        "North Lakes station, platform 1",
                        "North Lakes State College",
                        "Kinsellas Rd West at McKenzie Rd",
                        "Park Vista Dr at Macadamia Street",
                        "Park Vista Dr at Stamens Street",
                        "Chermside Rd at Kinsellas Road",
                        "John St near Rose St",
                        "Kinsellas Rd at Ruby Street",
                        "St Benedicts Catholic Primary School",
                        "Capestone Bvd near Campbell Dr hail 'n' ride",
                        "Mango Hill Primary School",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "Anzac Ave at Halpine Drive",
                        "Brays Rd near Moreton St",
                        "Brays Rd near Burnett Dr",
                        "Brays Rd near Tesch Rd (CLOSED FROM 13/4/26 - 31/7/26)",
                        "Brays Rd near Lavender Dr hail 'n' ride",
                        "Dohles Rocks Rd near Henry Rd hail 'n' ride",
                        "Dohles Rocks Rd near Bettson Bvd hail 'n' ride",
                        "Dohles Rocks Rd near Castle Hill Dr",
                        "Castle Hill Dr near Pine River Dr",
                        "Pine River Dr near Paroo Pl",
                        "Pine River Dr near Drysdale Ct",
                        "Castle Hill Dr near Nottinghill Rd",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Winchcombe Ave",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Dohles Rocks Rd near Chestnut Dr",
                        "Dohles Rocks Rd near School Rd",
                        "Dohles Rocks Rd near Evelyn St",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Dayboro Rd near Joora Ave",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6833: The Lakes College, North Lakes High": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Beeville Rd at Oleron Tce",
                        "Frenchs Rd near Beeville Rd hail 'n' ride",
                        "Frenchs Rd near Macquarie Dr hail 'n' ride",
                        "Kurwongbah Primary School",
                        "Eucumbene Dr near Frenchs Rd hail 'n' ride",
                        "Eucumbene Dr near Goldsmith Ct hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St",
                        "Narangba Rd near Kedron Rd",
                        "Dohles Rocks Rd near Bluegum St",
                        "Dohles Rocks Rd near Clyde St",
                        "Dohles Rocks Rd near Chestnut Drive",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Castle Hill Dr near Cherington Way",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Farrington Dr",
                        "Murrumba Downs Shopping Centre",
                        "Wagner Rd near Oriole St hail 'n' ride",
                        "Bettson Bvd near Griffin Rise hail 'n' ride",
                        "Dohles Rocks Rd at Silvereye Ave hail 'n' ride",
                        "Brays Rd near Coriander Dr hail 'n' ride",
                        "Dandelion St at Sorrel St hail 'n' ride",
                        "Lavender Dr near Tesch Rd hail 'n' ride",
                        "Brays Rd near Tesch Rd",
                        "Brays Rd near Cairns Rd (Closed from 10 Nov 2025 - 31 July 2026)",
                        "Brays Rd near Burnett Dr",
                        "Brays Rd near Moreton St",
                        "Halpine Dr at Mango Hill Shopping Centre",
                        "Freshwater Creek Rd near Brushwood Crt",
                        "Mango Hill station",
                        "Capestone Bvd at Campbell Drive",
                        "Napier Ave near Campbell Pde hail 'n' ride",
                        "Campbell Dr near Napier Av hail 'n' ride",
                        "Campbell Dr near Beesand St hail 'n' ride",
                        "Campbell Dr near Parkway Tce hail 'n' ride",
                        "Campbell Dr near Jepson St hail 'n' ride",
                        "Capestone Bvd near Campbell Dr hail 'n' ride",
                        "The Lakes College",
                        "Discovery Dr near Davenport Pde",
                        "Discovery Dr near Otway Pde",
                        "Discovery Dr near Bridgeport Dr",
                        "Discovery Dr near Marsh St",
                        "Discovery Dr near Tuckeroo Pde",
                        "Bounty Bvd near Trevino Pde",
                        "Bounty Bvd near Montgomerie Pde",
                        "Bounty Bvd near Garcia Pde",
                        "Bounty Bvd near Aurora Bvd hail 'n' ride",
                        "Endeavour Bvd near Bounty Bvd",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Astley Pde",
                        "North Lakes State College",
                        "Discovery Dr near Southerden Dr",
                        "Halpine Dr near Talara Way",
                        "Anzac Ave at Halpine Drive",
                        "Brays Rd near Tesch Rd (CLOSED FROM 13/4/26 - 31/7/26)",
                        "Lavender Dr near Vanilla Ave",
                        "Vanilla Ave near Basil Street",
                        "Dandelion St at Sorrel Street",
                        "Coriander Dr near Sandlewood Cr hail 'n' ride",
                        "Brays Rd at Henry Road",
                        "Dohles Rocks Rd near Henry Rd hail 'n' ride",
                        "Bettson Bvd near Montegrande Cct hail 'n' ride",
                        "Bettson Bvd near Harvey Cct hail 'n' ride",
                        "Dohles Rocks Rd near Castle Hill Dr",
                        "Castle Hill Dr near Pine River Dr",
                        "Castle Hill Dr near Nottinghill Rd",
                        "Castle Hill Dr near Winchcombe Ave",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Dohles Rocks Rd near Chestnut Dr",
                        "Dohles Rocks Rd near School Rd",
                        "Dohles Rocks Rd near Evelyn St",
                        "Narangba Rd at Kedron Road",
                        "Eucumbene Dr near Narangba Rd hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St hail 'n' ride",
                        "Eucumbene Dr near Frenchs Rd",
                        "Frenchs Rd near Kurwongbah Primary School HnR",
                        "Frenchs Rd at Macquarie Drive",
                        "Frenchs Rd near Belrose Av hail 'n' ride",
                        "Beeville Rd near Chambery Rd hail 'n' ride",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6834: North Lakes High, St Benedicts": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "Discovery Dr near Southerden Dr",
                        "Discovery Dr near Davenport Pde",
                        "Discovery Dr near Otway Pde",
                        "Discovery Dr near Bridgeport Dr",
                        "Discovery Dr near Marsh St",
                        "Discovery Dr near Tuckeroo Pde",
                        "Bounty Bvd near Trevino Pde",
                        "Bounty Bvd near Montgomerie Pde",
                        "Bounty Bvd near Garcia Pde",
                        "Bounty Bvd near Aurora Bvd hail 'n' ride",
                        "Endeavour Bvd near Bounty Bvd",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Astley Pde",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Bergin St",
                        "North Lakes station, platform 1",
                        "North Lakes State College",
                        "St Benedicts Catholic Primary School",
                        "North Lakes Shopping Centre, stop B",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Dayboro Rd near Joora Ave",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6835: North Lakes High, Bounty Bvd": [
                        "North Lakes State College",
                        "Discovery Dr near Southerden Dr",
                        "Discovery Dr near Davenport Pde",
                        "Discovery Dr near Otway Pde",
                        "Discovery Dr near Bridgeport Dr",
                        "Discovery Dr near Marsh St",
                        "Discovery Dr near Tuckeroo Pde",
                        "Bounty Bvd near Trevino Pde",
                        "Bounty Bvd near Montgomerie Pde",
                        "Bounty Bvd near Garcia Pde",
                        "Bounty Bvd near Aurora Bvd hail 'n' ride",
                        "Endeavour Bvd near Bounty Bvd",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Astley Pde",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Bergin St",
                        "North lakes arrivals stop"
                    ],
                    "6836: St Benedicts": [
                        "North Lakes station, platform 1",
                        "Discovery Dr near Southerden Dr",
                        "Discovery Dr near Davenport Pde",
                        "Discovery Dr near Otway Pde",
                        "Discovery Dr near Bridgeport Dr",
                        "Discovery Dr near Marsh St",
                        "Discovery Dr near Tuckeroo Pde",
                        "Bounty Bvd near Trevino Pde",
                        "Bounty Bvd near Montgomerie Pde",
                        "Bounty Bvd near Garcia Pde",
                        "Bounty Bvd near Aurora Bvd hail 'n' ride",
                        "Endeavour Bvd near Bounty Bvd",
                        "Endeavour Bvd near Augusta Pde",
                        "Endeavour Bvd near Astley Pde",
                        "St Benedicts Catholic Primary School",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Bergin St",
                        "North lakes arrivals stop"
                    ],
                    "6840: St Pauls, Craigslea": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "South Pine Rd near Leitchs Rd",
                        "Graham Rd near Nemira St",
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Graham Rd at Gympie Rd, stop 56a",
                        "Gympie Rd at Brickfield Street, stop 45/44",
                        "Gympie Rd at Aspley",
                        "Robinson Rd West near Navua Av hail 'n' ride",
                        "Kirby Rd near Robinson Rd, stop 48",
                        "Kirby Rd at Ailsa Street, stop 47/46",
                        "Kirby Rd at Kirby South, stop 45",
                        "Webster Rd at Chermside Markets",
                        "Webster Rd at Ronmack Street, stop 41",
                        "Webster Rd at Milburn Street, stop 40/3",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Hamilton Rd at Delan Street, stop 44a",
                        "Hamilton Rd at Backford Street, stop 45",
                        "Whites St at Kenna Street, stop 46",
                        "Stringybark Dr at Martindale Street, stop 47",
                        "Stringybark Dr near Horn Rd, stop 48",
                        "Horn Rd at Muneera Street, stop 49",
                        "Horn Rd at Candlebark Street, stop 50a",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Chermside West, stop 48/11",
                        "Maundrell Tce at John Goss Reserve, stop 47/12",
                        "Maundrell Tce at St Gerards, stop 46",
                        "Hamilton Rd near Whites Rd",
                        "Hamilton Rd at Trouts Rd, stop 46",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at Paramount Chase",
                        "Beckett Rd at Bridgeman near Saturn Cr",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Bridgeman Downs",
                        "Graham Rd at Carseldine West near Kentia St",
                        "Champagne St near Marsala St, stop 60",
                        "Tintara St near Chateau St hail 'n' ride",
                        "Ridley Rd at Retreat Street",
                        "Ridley Rd at Gardenia Place",
                        "Roghan Rd at Ridley Rd",
                        "Gympie Rd near Telegraph Rd",
                        "Gympie Rd near Griffiths St",
                        "Gympie Rd near Bald Hills Rd",
                        "Gympie Rd at Saint Pauls School",
                        "Strathpine Rd at Adair Street",
                        "Gympie Rd near Dickson St",
                        "Gympie Rd near Roghan Rd",
                        "Roghan Rd near Gympie Rd",
                        "Ridley Rd near Retreat St",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6841: Holy Spirit, StJosephs, BrackenRidge, StJohnFisher": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Samsonvale Rd near Dundee St",
                        "Samsonvale Rd near Elmwood Dr",
                        "Samsonvale Rd near Kentwood Dr",
                        "Samsonvale Rd near Evergreen Ave",
                        "Samsonvale Rd near Windrest St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Gympie Rd at Stanley Street",
                        "Strathpine Rd at Adair Street",
                        "Strathpine Rd near Bald Hills Rd",
                        "Bald Hills Rd near Godfrey St",
                        "Bald Hills Rd near Attunga St hail 'n' ride",
                        "Seaton St near Racton St hail 'n' ride",
                        "Attunga St near Cambrian St",
                        "Hoyland St near Kluver St",
                        "Coriander St near Kluver St, stop 60",
                        "Taragon St near Chervil St",
                        "Kluver St near Bracken Ridge Rd",
                        "Arnica Cr near Korina St, stop 57",
                        "Arnica Cr near Mantias Street, stop 56",
                        "Charlock Rd near Arnica Cr, stop 55",
                        "Charlock Rd near Gladdon St",
                        "Bracken Ridge Rd at Wetlands",
                        "Ballynde St at Toormore Street, stop 52",
                        "Ballynde St near Bungowla St, stop 51",
                        "Killare St near Wickfield Cr, stop 50",
                        "Wickfield St near Rosa Cr, stop 49",
                        "Wickfield St near Sophy Cr, stop 48",
                        "Barbour Rd near Wickfield St, stop 47",
                        "Norris Rd near Barbour Rd",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Norris Rd at Greenore Street, stop 45",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Gawain East, stop 42",
                        "John Fisher Dr at St John Fisher College",
                        "Barfoot St near Cedarwood St hail 'n' ride",
                        "Tallara St near Tarwarri St, stop 36",
                        "Tomah Rd near Binburra St, stop 34",
                        "Phillips St at Enbrook Street",
                        "Phillips St at St Josephs",
                        "Barbour Rd near Phillips St",
                        "Norris Rd near Barbour Rd, stop 46",
                        "Norris Rd at Bracken Ridge Plaza",
                        "Norris Rd at Tasman Bvd hail 'n' ride",
                        "Norris Rd at Cape Arid Park",
                        "Carselgrove Ave near Roghan Rd",
                        "Carselgrove Ave near Carnarvon Cr",
                        "Beams Rd at Holy Spirit College",
                        "Handford Rd at Liberty Dr",
                        "Handford Rd at Symes Grove",
                        "Handford Rd at Handford - Roghan",
                        "Roghan Rd near Springbok Street",
                        "Tallara St near Tulee St, stop 36",
                        "Bracken St at Bracken Ridge Library",
                        "Norris Rd at Greenore Street",
                        "Barbour Rd at Caulfield Street, stop 47A",
                        "Wickfield St near Rosa Cr, stop 47",
                        "Wickfield St at Rosa Crescent, stop 49",
                        "Killare St near Wickfield St, stop 50",
                        "Arnica Cr at Mantias Street, stop 56",
                        "Coriander St near Kluver St",
                        "Hoyland St near Dresden St",
                        "Strathpine Rd near Lucy St",
                        "Strathpine Rd at Adair St",
                        "Gympie Rd near Mecklem St hail 'n' ride",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6842: St John Fisher, StPauls, StPatricks, Sandgate High": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Strathpine Rd at Adair Street",
                        "Strathpine Rd near Bald Hills Rd",
                        "Hoyland St near Kluver St",
                        "Bracken Ridge Rd near Glenealy St hail 'n' ride",
                        "Barfoot St at Bracken Ridge High School",
                        "Lascelles St near Lebanon St, stop 53",
                        "Lascelles St near Craig St, stop 54",
                        "Lascelles St at Brighton South, stop 54a",
                        "Lascelles St at Brighton near Hall St",
                        "North Rd at Brighton School, stop 58",
                        "North Rd at St Kieran",
                        "North Rd at Brighton North, stop 62",
                        "North Rd at Bayview, stop 63",
                        "Beaconsfield Tce near Duke St",
                        "Beaconsfield Tce near Shepherd St",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Twelfth Ave",
                        "Brighton Tce near Tenth Ave",
                        "Brighton Tce near Wakefield St",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Yundah St at St Patricks College",
                        "Pier Ave near Collins Lane",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St at Kift Street, stop 30",
                        "Board St near Racecourse Rd, stop 29a",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Depot Rd at Braun Street, stop 29",
                        "Depot Rd at Quinlan Street South, stop 30",
                        "Denham St at Warra",
                        "Phillips St at Tomah Street",
                        "Enbrook St near Appledore St",
                        "Enbrook St near Mustang St",
                        "Mustang St near Telegraph Rd",
                        "Telegraph Rd near Langer Pl",
                        "Lacey Rd near Highbridge Cct",
                        "Lacey Rd near Macaranga Cr",
                        "Gympie Rd near Telegraph Rd",
                        "Gympie Rd near Griffiths St",
                        "Gympie Rd near Bald Hills Rd",
                        "Gympie Rd at Saint Pauls School",
                        "John Fisher Dr at St John Fisher College",
                        "Bracken Ridge Rd near Rinnicrew St",
                        "Hoyland St near Dresden St",
                        "Strathpine Rd near Lucy St",
                        "Gympie Rd near Dickson St",
                        "Gympie Rd near Roghan Rd",
                        "Roghan Rd near Gympie Rd",
                        "Ridley Rd at Gardenia Place",
                        "Ridley Rd near Retreat St",
                        "Beams Rd near Tintara St",
                        "Telegraph Rd near Mustang St",
                        "Phillips St near Tomah Rd",
                        "Denham St at Warra, stop 31",
                        "Rainbow St near Lunn St, stop 31",
                        "Rainbow St at Hancock Street, stop 32",
                        "Yundah St at Shorncliffe State School",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Brighton Tce near Twelfth Ave",
                        "Beaconsfield Tce near Princess St",
                        "North Rd at Bayview",
                        "North Rd at Brighton North near Prince St",
                        "Lascelles St at Brighton, stop 56a",
                        "Lascelles St near Mary Ellen St, stop 54",
                        "Lascelles St near Palina St, stop 53",
                        "Strathpine Rd at Adair St",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6850: St Patricks, Sandgate High, StJohn Fisher, StPauls": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Francis Rd near Ebony Ct",
                        "Francis Rd near Colonial Dr",
                        "Francis Rd near Granville Dr",
                        "Todds Rd at Wattlebird Court",
                        "Todds Rd at Lawnton Primary School",
                        "Ellis St near Brown St CLOSED 1 Sept 2025 - June 2026",
                        "Sparkes Rd near Gerard St",
                        "Sparks Rd near Hopetoun St",
                        "Sparkes Rd near Nottingham Pde",
                        "Sparkes Rd near Cedrela Cr",
                        "Samsonvale Rd near Windrest St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Gympie Rd at Stanley Street",
                        "Strathpine Rd at Adair Street",
                        "Strathpine Rd near Bald Hills Rd",
                        "Hoyland St near Kluver St",
                        "Bracken Ridge Rd near Glenealy St hail 'n' ride",
                        "John Fisher Dr at St John Fisher College",
                        "Deagon St near Albion St, stop 38",
                        "Deagon St near Brisbane St, stop 37",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Yundah St at Shorncliffe State School",
                        "Pier Ave at Saint Patricks College",
                        "Signal Row at Shorncliffe State School",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St at Kift Street, stop 30",
                        "Board St near Racecourse Rd, stop 29a",
                        "Board St near Ibis Ave, stop 28",
                        "Depot Rd at Braun Street, stop 29",
                        "Board St at Deagon Racecourse, stop 29",
                        "Depot Rd at Quinlan Street South, stop 30",
                        "Denham St at Warra",
                        "Denham St near Phillips St, stop 32",
                        "Denham St near Childs St, stop 33",
                        "Barrett St at McKeering-Barrett",
                        "Barrett St near Tallara St, stop 37",
                        "Bracken St at Bracken Ridge Library",
                        "Bracken Ridge Rd near Rinnicrew St",
                        "Hoyland St near Dresden St",
                        "Strathpine Rd near Lucy St",
                        "Strathpine Rd at Adair St",
                        "Gympie Rd near Mecklem St hail 'n' ride",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Sparkes Rd near Cedrela Cr hail 'n' ride",
                        "Holy Spirit Catholic Primary School",
                        "Sparks Rd near Alcira St",
                        "Sparkes Rd near Panorama St",
                        "Ellis St at Brown Street",
                        "Ellis St near Brett St",
                        "Francis Rd near Havana Lane",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6851: Bald Hills, St Pauls": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Brisbane Rd near Solomon Pde",
                        "Pallas Pde near Brisbane Rd",
                        "Pallas Pde at Ballyalla Crescent",
                        "Russet Burbank Pde near Swan Pde",
                        "Russet Burbank Pde near Delawar Rd",
                        "Windrest St near Garbala Dr",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Spitfire Ave near Blenheim St hail 'n' ride",
                        "Strathpine Primary School",
                        "Bells Pocket Rd near Bateman St",
                        "Bells Pocket Rd near Robel St",
                        "Gympie Rd at Stanley Street",
                        "Strathpine Rd at Adair Street",
                        "Strathpine Rd near Bald Hills Rd",
                        "Bracken Ridge Rd at Wetlands",
                        "Charlock Rd near Arnica Cr, stop 55",
                        "Arnica Cr at Mantias Street, stop 56",
                        "Arnica Cr near Korina St, stop 57",
                        "Kluver St near Bracken Ridge Rd",
                        "Taragon St near Chervil St",
                        "Coriander St near Kluver St",
                        "Hoyland St near Dresden St",
                        "Bald Hills Rd near Godfrey St",
                        "Bald Hills Rd near Attunga St hail 'n' ride",
                        "Attunga St near Cambrian St",
                        "Seaton St near Racton St hail 'n' ride",
                        "Feuerriegel St at Juxon St",
                        "Strathpine Rd near Lucy St",
                        "Gympie Rd at Bald Hills State School",
                        "Lucy St near Bald Hills station",
                        "Hoyland St near Kluver St",
                        "Coriander St near Kluver St, stop 60",
                        "Arnica Cr near Mantias Street, stop 56",
                        "Charlock Rd near Gladdon St",
                        "Strathpine Rd at Adair St",
                        "Gympie Rd near Mecklem St hail 'n' ride",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Windrest St near Acland Dr",
                        "Pallas Pde near Russett Burbank Pde",
                        "Brisbane Rd near Old North Rd",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6852: St Patricks, Sandgate High, StJohn Fisher, StPauls": [
                        "Protheroe Rd near Byrnes Rd hail 'n' ride",
                        "Forgan Rd near Bullocky Rest hail 'n' ride",
                        "Forgan Rd near Gordons Crossing Rd hail 'n' ride",
                        "Samsonvale Rd near Lindale Ct hail 'n' ride",
                        "Ira Buckby Rd near Franzin Dr hail 'n' ride",
                        "Ira Buckby Rd near Hayward Av hail 'n' ride",
                        "Ira Buckby Rd near Sarow Dr hail 'n' ride",
                        "Lilley Rd near Parakeet Ct hail 'n' ride",
                        "Lilley Rd near Eatons Crossing Rd hail 'n' ride",
                        "Eden Dr near Sarah Ct hail 'n' ride",
                        "Church Road near Drapers Road hail 'n' ride",
                        "Drapers Rd near Fletchers Rd hail 'n' ride",
                        "Drapers Rd near Barton Ct hail 'n' ride",
                        "Drapers Rd near Bunya Crossing Rd hail 'n' ride",
                        "Bunya Crossing Rd near Birmingham St hail 'n' ride",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "Queen Elizabeth Dr at Corso Street",
                        "Queen Elizabeth Dr at Hero",
                        "Eatons Hill at Queen Elizabeth Drive",
                        "South Pine Rd near Leitchs Rd",
                        "South Pine Rd near Deakin St",
                        "South Pine Rd near Johnstone Rd",
                        "Strathpine Rd at Adair Street",
                        "Lucy St near Bald Hills station",
                        "Hoyland St near Kluver St",
                        "Bracken Ridge Rd near Glenealy St hail 'n' ride",
                        "John Fisher Dr at St John Fisher College",
                        "Deagon St near Albion St, stop 38",
                        "Deagon St near Brisbane St, stop 37",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Yundah St at Shorncliffe State School",
                        "Pier Ave at Saint Patricks College",
                        "Signal Row at Shorncliffe State School",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St at Kift Street, stop 30",
                        "Board St near Racecourse Rd, stop 29a",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Depot Rd at Braun Street, stop 29",
                        "Depot Rd at Quinlan Street South, stop 30",
                        "Denham St at Warra",
                        "Denham St near Phillips St, stop 32",
                        "Denham St near Childs St, stop 33",
                        "Barrett St at McKeering-Barrett",
                        "Barrett St near Tallara St, stop 37",
                        "Bracken St at Bracken Ridge Library",
                        "Bracken Ridge Rd near Rinnicrew St",
                        "Hoyland St near Dresden St",
                        "Strathpine Rd near Lucy St",
                        "Strathpine Rd at Adair St",
                        "Queen Elizabeth Dr at Eatons Hill",
                        "Queen Elizabeth Dr at Hero Street",
                        "Queen Elizabeth Dr at Eatonvale",
                        "Paddy Rd near Beth Ct hail 'n' ride",
                        "Whimbrel St near Warner Rd hail 'n' ride",
                        "Starling St near Lowan St hail 'n' ride",
                        "Sanderling Dr near Quarrion Ct Rd hail 'n' ride",
                        "Beech Dr near Gibson Ct hail 'n' ride",
                        "Cashs Rd near Beech Dr hail 'n' ride",
                        "Peppermint Dr near Bracken Ct hail 'n' ride",
                        "Peppermint Dr near Ira Buckby Rd West HnR",
                        "Corvus Dr near Trevor Pl hail 'n' ride",
                        "Corvus Dr near Harrison St hail 'n' ride",
                        "Ken Duncombe Dr near Corvus Dr hail 'n' ride",
                        "Ira Buckby Rd nr Cashmere Lane hail'n'ride",
                        "Ira Buckby Rd near Hayward Ave",
                        "Ira Buckby Rd near Franzin Dr",
                        "Samsonvale Rd near Winn Rd hail 'n' ride"
                    ],
                    "6860: St Patricks, Sandgate High": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Beeville Rd at Oleron Tce",
                        "Frenchs Rd near Beeville Rd hail 'n' ride",
                        "Frenchs Rd near Macquarie Dr hail 'n' ride",
                        "Kurwongbah Primary School",
                        "Eucumbene Dr near Frenchs Rd hail 'n' ride",
                        "Eucumbene Dr near Goldsmith Ct hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St",
                        "Narangba Rd near Kedron Rd",
                        "Marsden Rd near Narangba Rd",
                        "Marsden Rd near Sylvester Dr",
                        "Ann St near Marsden Rd",
                        "Ann St at Blazey Street",
                        "School Rd near Brickworks Rd",
                        "Brickworks Rd near Kookaburra St hail 'n' ride",
                        "Brickworks Rd near Galway Dr",
                        "Duffield Rd near Sapphire Ct hail 'n' ride",
                        "Duffield Rd near Kahala Rd hail 'n' ride",
                        "Duffield Rd at Azalea Ct",
                        "Duffield Rd near Winter Rd",
                        "Goodfellows Rd near Blatchford Dr",
                        "Goodfellows Rd near Murrumba State Secondary College HnR",
                        "Ogg Rd at Undurba Primary School",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Castle Hill Dr near Cherington Way",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Farrington Dr",
                        "Murrumba Downs Shopping Centre",
                        "Deagon St near Albion St, stop 38",
                        "Rainbow St near Lunn St, stop 31",
                        "Rainbow St at Hancock Street, stop 32",
                        "Pier Ave at Saint Patricks College",
                        "Signal Row at Shorncliffe State School",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St at Kift Street, stop 30",
                        "Board St near Racecourse Rd, stop 29a",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Depot Rd at Braun Street, stop 29",
                        "Dohles Rocks Rd near Castle Hill Dr",
                        "Castle Hill Dr near Pine River Dr",
                        "Castle Hill Dr near Nottinghill Rd",
                        "Castle Hill Dr near Winchcombe Ave",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Murrumba State Secondary College",
                        "Goodfellows Rd near Alana St",
                        "Goodfellows Rd near Buse Ct",
                        "Ann St near Old Gympie Rd",
                        "Ann St near Archer St",
                        "Narangba Rd at Kedron Road",
                        "Eucumbene Dr near Narangba Rd hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St hail 'n' ride",
                        "Eucumbene Dr near Frenchs Rd",
                        "Frenchs Rd near Kurwongbah Primary School HnR",
                        "Frenchs Rd at Macquarie Drive",
                        "Frenchs Rd near Belrose Av hail 'n' ride",
                        "Beeville Rd near Chambery Rd hail 'n' ride",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6861: St John Fisher, Bracken Ridge": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Beeville Rd at Oleron Tce",
                        "Frenchs Rd near Beeville Rd hail 'n' ride",
                        "Frenchs Rd near Macquarie Dr hail 'n' ride",
                        "Kurwongbah Primary School",
                        "Eucumbene Dr near Frenchs Rd hail 'n' ride",
                        "Eucumbene Dr near Goldsmith Ct hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St",
                        "Narangba Rd near Kedron Rd",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "North Lakes station, platform 1",
                        "Duffield Rd at Azalea Ct",
                        "Duffield Rd near Winter Rd",
                        "Goodfellows Rd near Blatchford Dr",
                        "Goodfellows Rd near Murrumba State Secondary College HnR",
                        "Ogg Rd at Undurba Primary School",
                        "Dohles Rocks Rd near Ogg Rd",
                        "Castle Hill Dr near Cherington Way",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Farrington Dr",
                        "Murrumba Downs Shopping Centre",
                        "John Fisher Dr at St John Fisher College",
                        "Dohles Rocks Rd near Castle Hill Dr",
                        "Castle Hill Dr near Pine River Dr",
                        "Castle Hill Dr near Nottinghill Rd",
                        "Castle Hill Dr near Winchcombe Ave",
                        "Dohles Rocks Rd at Castle Hill Drive",
                        "Murrumba State Secondary College",
                        "Goodfellows Rd near Alana St",
                        "Goodfellows Rd near Buse Ct",
                        "Anzac Ave at The Crescent",
                        "Narangba Rd at Kedron Road",
                        "Eucumbene Dr near Narangba Rd hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St hail 'n' ride",
                        "Eucumbene Dr near Frenchs Rd",
                        "Frenchs Rd near Kurwongbah Primary School HnR",
                        "Frenchs Rd at Macquarie Drive",
                        "Frenchs Rd near Belrose Av hail 'n' ride",
                        "Beeville Rd near Chambery Rd hail 'n' ride",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6863: St Patricks, Sandgate High": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Anzac Ave at Duffield Road",
                        "Anzac Ave at McBain Street",
                        "Anzac Ave at Allison Drive",
                        "Anzac Ave at Westfield North Lakes",
                        "Endeavour Bvd at North Lakes Health Precinct",
                        "North Lakes station, platform 1",
                        "Brays Rd near Moreton St",
                        "Brays Rd near Burnett Dr",
                        "Brays Rd near Tesch Rd (CLOSED FROM 13/4/26 - 31/7/26)",
                        "Cairns Rd at Vermilion Avenue",
                        "Vermillion Ave near Grandview Pde",
                        "Brays Rd near Lavender Dr hail 'n' ride",
                        "Dohles Rocks Rd near Henry Rd hail 'n' ride",
                        "Dohles Rocks Rd near Bettson Bvd hail 'n' ride",
                        "Deagon St near Albion St, stop 38",
                        "Rainbow St near Lunn St, stop 31",
                        "Rainbow St at Hancock Street, stop 32",
                        "Pier Ave at Saint Patricks College",
                        "Signal Row at Shorncliffe State School",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St at Kift Street, stop 30",
                        "Board St near Racecourse Rd, stop 29a",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Depot Rd at Braun Street, stop 29",
                        "Dohles Rocks Rd at Silvereye Ave hail 'n' ride",
                        "Brays Rd near Vermilion Av hail 'n' ride",
                        "Vermilion Ave near Sepia Pl hail 'n' ride",
                        "Brays Rd near Cairns Rd (Closed from 10 Nov 2025 - 31 July 2026)",
                        "Anzac Ave at The Crescent",
                        "Anzac Ave at Caine Street",
                        "Petrie station, stop B",
                        "Dayboro Rd near Joora Ave",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6870: Mount Alvernia, Padua, Craigslea, St Pauls": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Todds Rd at Youngs Crossing Road",
                        "Todds Rd near Sandown Ct",
                        "Todds Rd at Oxbow Crescent hail 'n' ride",
                        "Todds Rd near Isis Rd hail 'n' ride",
                        "Todds Rd at Wattlebird Court",
                        "Todds Rd at Lawnton Primary School",
                        "Ellis St near Brown St CLOSED 1 Sept 2025 - June 2026",
                        "Sparkes Rd near Gerard St",
                        "Sparks Rd near Hopetoun St",
                        "Sparkes Rd near Nottingham Pde",
                        "Sparkes Rd near Cedrela Cr",
                        "Samsonvale Rd near Windrest St",
                        "Samsonvale Rd at Beitz St",
                        "Samsonvale Rd near Symphony Ave",
                        "Gympie Rd at Stanley Street",
                        "Strathpine Rd at Adair Street",
                        "Gympie Rd near Bald Hills Rd",
                        "Gympie Rd near Dickson St",
                        "Gympie Rd near Telegraph Rd",
                        "Lacey Rd near Highbridge Cct",
                        "Lacey Rd near Macaranga Cr",
                        "Beams Rd at Bangalore Street",
                        "Dorville Rd at Denver East",
                        "Zillmere Rd at Aspley High School",
                        "Zillmere Rd at Aspley State High",
                        "Kirby Rd near Zillmere Rd, stop 52A",
                        "Kirby Rd at Funnell Street, stop 52",
                        "Kirby Rd at Aspley East, stop 50",
                        "Robinson Rd West near Valnay St hail 'n' ride",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Maundrell Tce at Darwin Street, stop 50",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Chermside West, stop 48/11",
                        "Maundrell Tce at John Goss Reserve, stop 47/12",
                        "Maundrell Tce at St Gerards, stop 46",
                        "Maundrell Tce at Craigslea, stop 44/15",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Maundrell Tce at Risdon Street, stop 42",
                        "Appleby Rd at Stafford Heights",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Kitchener Rd near Salway St",
                        "Kitchener Rd at Somerset Hills State School",
                        "Kitchener Rd at North Street, stop 47",
                        "Turner Rd at East Street, stop 46",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Padua College - Jardine St Stop A",
                        "Padua College - Turner St Stop B",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd near Dundalli St, stop 39/23",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Maundrell Tce at St Gerards, stop 45/46",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Robinson Rd West near Navua Av hail 'n' ride",
                        "Kirby Rd near Zillmere Rd, stop 52a",
                        "Gympie Rd near Griffiths St",
                        "Gympie Rd at Saint Pauls School",
                        "Gympie Rd near Mecklem St hail 'n' ride",
                        "Strathpine bus station, stop B",
                        "Samsonvale Rd near Bland St",
                        "Samsonvale Rd at Beitz Street",
                        "Sparkes Rd near Cedrela Cr hail 'n' ride",
                        "Holy Spirit Catholic Primary School",
                        "Sparks Rd near Alcira St",
                        "Sparkes Rd near Panorama St",
                        "Ellis St at Brown Street",
                        "Ellis St near Brett St",
                        "Todds Rd near Oxbow Rd",
                        "Todds Rd at Sandown Ct",
                        "Todds Rd near Youngs Crossing Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6871: Mount Alvernia, Padua, Craigslea, St Pauls": [
                        "Dayboro Rd near Maurienne Rd hail 'n' ride",
                        "Beeville Rd at Oleron Tce",
                        "Frenchs Rd near Beeville Rd hail 'n' ride",
                        "Frenchs Rd near Macquarie Dr hail 'n' ride",
                        "Kurwongbah Primary School",
                        "Eucumbene Dr near Frenchs Rd hail 'n' ride",
                        "Eucumbene Dr near Goldsmith Ct hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St",
                        "Narangba Rd near Kedron Rd",
                        "Anzac Ave at Curruther Park",
                        "Anzac Ave at Pine Rivers RSL Services",
                        "Anzac Ave at Sylvan Park",
                        "Anzac Ave at Brewer Street",
                        "Anzac Ave at Kallangur Fair",
                        "Duffield Rd at Azalea Ct",
                        "Duffield Rd near Winter Rd",
                        "Goodfellows Rd near Blatchford Dr",
                        "Goodfellows Rd near Murrumba State Secondary College HnR",
                        "Castle Hill Dr near Cherington Way",
                        "Castle Hill Dr near Dorchester Ct",
                        "Castle Hill Dr near Farrington Dr",
                        "Murrumba Downs Shopping Centre",
                        "Strathpine Rd near Lucy St",
                        "Strathpine Rd at Adair St",
                        "Gympie Rd near Duncan Ave",
                        "Gympie Rd near Bald Hills Rd",
                        "Gympie Rd near Dickson St",
                        "Gympie Rd near Telegraph Rd",
                        "Gympie Rd near Roghan Rd",
                        "Roghan Rd near Gympie Rd",
                        "Ridley Rd at Gardenia Place",
                        "Ridley Rd near Retreat St",
                        "Ridley Rd near Centurion St",
                        "Ridley Rd near Dimboola St",
                        "Ridley Rd at Ridley Road South",
                        "Graham Rd at Carseldine West near Kentia St",
                        "Graham Rd near Nemira St",
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Graham Rd at Gympie Rd, stop 56a",
                        "Gympie Rd at Brickfield Street, stop 45/44",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Maundrell Tce at Darwin Street, stop 50",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Chermside West, stop 48/11",
                        "Maundrell Tce at John Goss Reserve, stop 47/12",
                        "Maundrell Tce at St Gerards, stop 46",
                        "Maundrell Tce at Craigslea, stop 44/15",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Maundrell Tce at Risdon Street, stop 42",
                        "Appleby Rd at Stafford Heights",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Kitchener Rd near Salway St",
                        "Kitchener Rd at Somerset Hills State School",
                        "Kitchener Rd at North Street, stop 47",
                        "Turner Rd at East Street, stop 46",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Padua College - Jardine St Stop A",
                        "Padua College - Turner St Stop B",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd near Dundalli St, stop 39/23",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Maundrell Tce at St Gerards, stop 45/46",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Gympie Rd at Aspley",
                        "Gympie Rd at Gayford Street, stop 44",
                        "Gympie Rd at Brickfield Street, stop 45",
                        "Graham Rd at Nemira Street, stop 48",
                        "Ridley Rd at Retreat Street",
                        "Roghan Rd at Ridley Rd",
                        "Gympie Rd near Griffiths St",
                        "Gympie Rd at Saint Pauls School",
                        "Strathpine Rd at Adair Street",
                        "Strathpine Rd near Bald Hills Rd",
                        "Dohles Rocks Rd near Castle Hill Dr",
                        "Castle Hill Dr near Pine River Dr",
                        "Castle Hill Dr near Nottinghill Rd",
                        "Castle Hill Dr near Winchcombe Ave",
                        "Murrumba State Secondary College",
                        "Goodfellows Rd near Alana St",
                        "Goodfellows Rd near Buse Ct",
                        "Anzac Ave at The Crescent",
                        "Narangba Rd at Kedron Road",
                        "Eucumbene Dr near Narangba Rd hail 'n' ride",
                        "Eucumbene Dr near Burrumbeet St hail 'n' ride",
                        "Eucumbene Dr near Frenchs Rd",
                        "Frenchs Rd near Kurwongbah Primary School HnR",
                        "Frenchs Rd at Macquarie Drive",
                        "Frenchs Rd near Belrose Av hail 'n' ride",
                        "Beeville Rd near Chambery Rd hail 'n' ride",
                        "Dayboro Rd near Beeville Rd hail 'n' ride",
                        "Dayboro Rd near Youngs Crossing Rd hail 'n' ride"
                    ],
                    "6872: Mount Alvernia, Padua, Craigslea": [
                        "Protheroe Rd near Byrnes Rd hail 'n' ride",
                        "Forgan Rd near Bullocky Rest hail 'n' ride",
                        "Forgan Rd near Gordons Crossing Rd hail 'n' ride",
                        "Samsonvale Rd near Lindale Ct hail 'n' ride",
                        "Ira Buckby Rd near Franzin Dr hail 'n' ride",
                        "Ira Buckby Rd near Hayward Av hail 'n' ride",
                        "Ira Buckby Rd near Sarow Dr hail 'n' ride",
                        "Corvus Dr near Trevor Pl hail 'n' ride",
                        "Corvus Dr near Harrison St hail 'n' ride",
                        "Ken Duncombe Dr near Corvus Dr hail 'n' ride",
                        "Peppermint Dr near Ira Buckby Rd West HnR",
                        "Peppermint Dr near Bracken Ct hail 'n' ride",
                        "Beech Dr near Cashs Rd hail 'n' ride",
                        "Beech Dr near Laurel Ct hail 'n' ride",
                        "Beech Dr near Gibson Ct hail 'n' ride",
                        "Beech Dr near Lilley Rd hail 'n' ride",
                        "Sanderling Dr near Quarrion Ct hail 'n' ride",
                        "Starling St near Lowan St hail 'n' ride",
                        "Whimbrel St near Warner Rd hail 'n' ride",
                        "Paddy Rd near Sally Ct hail 'n' ride",
                        "Eatons Hill at Queen Elizabeth Drive",
                        "South Pine Rd at Bunya Park",
                        "Albany Creek Rd at Hylacola",
                        "Albany Creek Rd near Old Northern Rd",
                        "Albany Creek Rd near Bowen Ave",
                        "Albany Creek Rd at Leitchs Road",
                        "Albany Creek Rd at Preston Point",
                        "Albany Creek Rd at Pinnaroo",
                        "Beckett Rd at Bridgeman Downs",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Bridgeman near Althorp Rd",
                        "Beckett Rd near Althorp Rd",
                        "Beckett Rd at Paramount Chase",
                        "Hamilton Rd at Paramount Circuit, stop 47",
                        "Hamilton Rd at Trouts Rd, stop 46",
                        "Hamilton Rd near Raven St hail 'n' ride",
                        "Hamilton Rd at Backford Street, stop 45",
                        "Hamilton Rd at Delan Street, stop 44a",
                        "Hamilton Rd at Maundrell Tce, stop 43a",
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Kitchener Rd at North Street, stop 47",
                        "Turner Rd at East Street, stop 46",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Padua College - Jardine St Stop A",
                        "Padua College - Turner St Stop B",
                        "Webster Rd near Dundalli St, stop 39/23",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Hamilton Rd near Whites Rd",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at Bridgeman near Saturn Cr",
                        "Albany Creek Rd at Albany Creek State School",
                        "South Pine Rd at Hylacola",
                        "Queen Elizabeth Dr at Eatons Hill",
                        "Paddy Rd near Beth Ct hail 'n' ride",
                        "Sanderling Dr near Quarrion Ct Rd hail 'n' ride",
                        "Cashs Rd near Beech Dr hail 'n' ride",
                        "Ira Buckby Rd nr Cashmere Lane hail'n'ride",
                        "Ira Buckby Rd near Hayward Ave",
                        "Ira Buckby Rd near Franzin Dr",
                        "Samsonvale Rd near Winn Rd hail 'n' ride"
                    ],
                    "6873: Mount Alvernia, Padua, McDowall": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "Eden Dr near Sarah Ct hail 'n' ride",
                        "Church Road near Drapers Road hail 'n' ride",
                        "Drapers Rd near Fletchers Rd hail 'n' ride",
                        "Drapers Rd near Barton Ct hail 'n' ride",
                        "Drapers Rd near Bunya Crossing Rd hail 'n' ride",
                        "Bunya Crossing Rd near Birmingham St hail 'n' ride",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "Queen Elizabeth Dr at Corso Street",
                        "Queen Elizabeth Dr at Hero",
                        "Eatons Hill at Queen Elizabeth Drive",
                        "South Pine Rd at Bunya Park",
                        "Old Northern Rd at Retirement Village",
                        "Old Northern Rd at Leisure Centre",
                        "Old Northern Rd at Albany Creek High",
                        "Old Northern Rd at Keong Road",
                        "Old Northern Rd at The Boulevard",
                        "Jinker Track near Allamanda Cr",
                        "Bunya Road near The Jinker Track",
                        "Collins Rd near Hillenvale Av hail 'n' ride",
                        "Collins Rd near Yarraman St hail 'n' ride",
                        "Collins Rd near Quandong Cr hail 'n' ride",
                        "Collins Rd near Service Rd hail 'n' ride",
                        "Padua College - Jardine St Stop A",
                        "Padua College - Turner St Stop B",
                        "Rode Rd at McDowall near Metro St",
                        "Collins Rd near Hawkes Ave",
                        "Collins Rd at Hillenvale, stop 1",
                        "Collins Rd at Hillenvale, stop 2",
                        "Old Northern Rd near Albany Forest Dr",
                        "South Pine Rd at Hylacola",
                        "Old North Rd near Bray Park High hail 'n' ride",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6874: Mount Alvernia, Padua, McDowall": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Brisbane Rd near Solomon Pde",
                        "Pallas Pde near Brisbane Rd",
                        "Pallas Pde at Ballyalla Crescent",
                        "Russet Burbank Pde near Swan Pde",
                        "Russet Burbank Pde near Delawar Rd",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "Brendale St at Doonside Pde",
                        "Brendale St near Gowrie St",
                        "Karena St near Heatherlea St",
                        "South Pine Rd near Leitchs Rd",
                        "Beckett Rd at Bridgeman Downs",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Bridgeman near Althorp Rd",
                        "Beckett Rd near Althorp Rd",
                        "Beckett Rd at Paramount Chase",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Rode Rd at Trouts Road",
                        "Rode Rd near Cilento St, stop 44a",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd near Tyrone St",
                        "Rode Rd at Stafford Heights near Cranbourne St",
                        "Rode Rd at Cherston St",
                        "Rode Rd at Webster Road, stop 37",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Kitchener Rd at North Street, stop 47",
                        "Turner Rd at East Street, stop 46",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Padua College - Jardine St Stop A",
                        "Padua College - Turner St Stop B",
                        "Rode Rd at Stafford Heights near Maundrell Tce",
                        "Rode Rd near Chuter St",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Voigt Street, stop 46",
                        "Rode Rd at McDowall near Metro St",
                        "Beckett Rd at McDowall North",
                        "Beckett Rd at Bridgeman near Saturn Cr",
                        "Pallas Pde near Russett Burbank Pde",
                        "Brisbane Rd near Old North Rd",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6875: Joyner, Craigslea High, Wavell Heights SHS": [
                        "Youngs Crossing Rd near Fairlane St",
                        "Youngs Crossing Rd near Gordons Crossing Rd",
                        "Youngs Crossing Rd near Oxford St",
                        "Old North Rd at Warner Shops",
                        "Brisbane Rd near Solomon Pde",
                        "Pallas Pde near Brisbane Rd",
                        "Pallas Pde at Ballyalla Crescent",
                        "Russet Burbank Pde near Swan Pde",
                        "Russet Burbank Pde near Delawar Rd",
                        "Old North Rd near Kremzow Rd hail 'n' ride",
                        "Brendale St at Doonside Pde",
                        "Brendale St near Gowrie St",
                        "Karena St near Heatherlea St",
                        "South Pine Rd at Bunya Park",
                        "Flamingo Dr near Chickowee St",
                        "Faheys Rd West at Kingfisher",
                        "Morgan Rd at Morgan",
                        "Albany Forest Dr at Dove",
                        "Albany Forest Dr at Explorer",
                        "Narrabeen Dr near Yellowjack Cr",
                        "Thiess Dr near Mahogany Dr",
                        "Thiess Dr at Jagora",
                        "Jagora Dr near Hale St hail 'n' ride",
                        "Old Northern Rd at Albany Creek High",
                        "Old Northern Rd at Keong Road",
                        "Jinker Track near Allamanda Cr",
                        "Bunya Road near The Jinker Track",
                        "Collins Rd near Hillenvale Av hail 'n' ride",
                        "Collins Rd near Yarraman St hail 'n' ride",
                        "Collins Rd near Quandong Cr hail 'n' ride",
                        "Collins Rd near Service Rd hail 'n' ride",
                        "Hamilton Rd near Streisand Dr",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Rode Rd at Trouts Road",
                        "Rode Rd near Cilento St, stop 44a",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd near Tyrone St",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Farnell Street, stop 39",
                        "Chermside Shopping Centre interchange F",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Unmack Street, stop 50",
                        "Pfingst Rd near Hamilton Rd, stop 49",
                        "Pfingst Rd near Gumbrae St, stop 48",
                        "Pfingst Rd near Wirega St, stop 47",
                        "Pfingst Rd near Highcrest Ave, stop 46",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near White St, stop 44",
                        "White St at Wavell State High, stop E",
                        "Wavell State High Oval Stop",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Old Northern Rd at Hamilton Road",
                        "Collins Rd near Hawkes Ave",
                        "Collins Rd at Hillenvale, stop 1",
                        "Collins Rd at Hillenvale, stop 2",
                        "Thiess Dr at Challinor",
                        "Thiess Dr at Narrabeen",
                        "Flamingo Dr near Garganey St",
                        "South Pine Rd at Hylacola",
                        "Brendale St near Currajon St",
                        "Pallas Pde near Russett Burbank Pde",
                        "Brisbane Rd near Old North Rd",
                        "Old North Rd at Brisbane Rd",
                        "Youngs Crossing Rd at Todds Road"
                    ],
                    "6891: Sandgate station - St Patricks": [
                        "Sandgate bus station, stop 2",
                        "Pier Ave at Saint Patricks College"
                    ],
                    "6892: St Patricks - Sandgate station": [
                        "Pier Ave at Saint Patricks College",
                        "Sandgate bus station, stop 2"
                    ],
                    "6893: St Patricks - Sandgate station": [
                        "Pier Ave at Saint Patricks College",
                        "Sandgate bus station, stop 2"
                    ],
                    "6894: St Patricks - Sandgate station": [
                        "Pier Ave at Saint Patricks College",
                        "Sandgate bus station, stop 2"
                    ],
                    "6895: St Patricks - Sandgate station": [
                        "Pier Ave at Saint Patricks College",
                        "Sandgate bus station, stop 2"
                    ],
                    "6896: St Patricks - Sandgate station": [
                        "Pier Ave at Saint Patricks College",
                        "Sandgate bus station, stop 2"
                    ],
                    "7011: Oakey Flat Road Morayfield East SS": [
                        "Hauton Rd near Hunt Rd hail 'n' ride",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Lindsay Rd near Clark Rd hail 'n' ride",
                        "Lindsay Rd near Anderson Rd hail 'n' ride",
                        "Morayfield Rd at Lindsay Road",
                        "Morayfield Rd at Supacentre Shopping Centre",
                        "Walkers Rd near Oakey Flat Rd",
                        "Oakey Flat Rd near Ashbrook Dr hail 'n' ride",
                        "Oakey Flat Road near Cronin Street",
                        "Oakey Flat Road near Sheoak Street",
                        "Ridgegarden Drive near Jarad Street",
                        "Braheem Street near Keeley St",
                        "Keeley Street near Anderson Rd",
                        "Lakeview Road near Bilby Dr",
                        "Bilby Drive near Awoonga Cr",
                        "Bilby Drive near Quoll Drive",
                        "Bilby Drive near Wombat Place",
                        "Woodrose Road near Maurice Ave",
                        "Minimbah State School",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Aireal Cr at Morayfield High School",
                        "Glenwood Drive at Morayfield East State School",
                        "Glenwood Dr near Glenmay Ct",
                        "Glenwood Dr near Cotswold St",
                        "Woodrose Road near Trinity Way",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Oakey Flat Rd near Ashbrook Dr",
                        "Lindsay Rd near Anderson Rd"
                    ],
                    "7012: Moorina, St Eugenes, Burpengary College": [
                        "Melba St near Wiley St hail 'n' ride",
                        "Moorina Rd near Ralph St hail 'n' ride",
                        "Caboolture River Rd near F Lindsay Rd HnR",
                        "Caboolture River Rd near Moorina Rd hail 'n' ride",
                        "Caboolture River Rd near Tinney Rd hail 'n' ride",
                        "Minimbah State School",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Bristlebird Dr near Kestrel Ct hail 'n' ride",
                        "Petersen Rd near J Dobson Rd hail 'n' ride",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Oakey Flat Rd near Ashbrook Dr hail 'n' ride",
                        "Ridgegarden Drive near Jarad Street",
                        "Braheem Street near Keeley St",
                        "Keeley Street near Anderson Rd",
                        "Morayfield Rd at Paradise Rd",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "St Eugene Catholic Primary School",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Pitt Rd near Henderson Rd",
                        "Henderson Rd near Corelli Ct hail 'n' ride",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Rowley Rd near Hauton Road hail 'n' ride",
                        "Burpengary Meadows Primary",
                        "Station Rd at Burpengary State School",
                        "Station Rd near David St",
                        "Morayfield Rd at Burpengary Pine Village",
                        "Lindsay Rd near Anderson Rd",
                        "Anderson Rd near Keeley St hail 'n' ride",
                        "Oakey Flat Rd near Ashbrook Dr"
                    ],
                    "7013: Narangba, Burpengary State, St Euguene": [
                        "Osborne Dr near Burpengary Rd hail 'n' ride",
                        "Osborne Dr near Leonard Ct hail 'n' ride",
                        "Morgan Rd near Valentine Ct hail 'n' ride",
                        "Tadorna St near Grazier St hail 'n' ride",
                        "Callaghan Rd near Kassandra Ct hail 'n' ride",
                        "Burpengary Rd near Mackie Rd hail 'n' ride",
                        "Narangba station",
                        "Oakey Flat Rd near Main St",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd near Dorothy St",
                        "Oakey Flat Rd near Pioneer Rd",
                        "Pioneer Dr near Oakey Flat Dr",
                        "Pioneer Dr near Eliza Ct",
                        "Pioneer Dr near Harry Mac Ct",
                        "Rifle Range Rd near Lilly Mac Ct",
                        "Rifle Range Rd near Florence Ct",
                        "Forest Ridge Rd near New Settlement Rd",
                        "Forest Ridge Dr near Tuckeroo St",
                        "Forest Ridge Rd near Rokeby St",
                        "Forest Ridge Rd near Outlook Pl",
                        "Sovereign Dr near Champion Cct hail 'n' ride",
                        "Sovereign Dr near Grace Cr hail 'n' ride",
                        "Sovereign Dr near Superb Cr hail 'n' ride",
                        "Young Rd at Golden Wattle Drive",
                        "Young Rd at Ridge View Drive",
                        "Hickory Dr near Banyan St hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "Mackenzie Ave near MacDonald Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "Tontonan Dr near Marscay Ct hail 'n' ride",
                        "Rosehill Dr near Wain Rd hail 'n' ride",
                        "Henderson Rd near Corelli Ct hail 'n' ride",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Station Rd at Burpengary State School",
                        "Station Rd near Hewson St",
                        "Station Rd near David St",
                        "St Eugene Catholic Primary School",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Banyan St near Juniper Ct hail 'n' ride",
                        "Hickory Dr near Banyan St",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Forest Ridge Dr near Waterway Cr hail 'n' ride",
                        "Forest Ridge Dr near Rokeby St hail 'n' ride",
                        "Forest Ridge Dr near Needletail Ct hail 'n' ride",
                        "Forest Ridge Dr near Friarbird Dr hail 'n' ride",
                        "Rifle Range Rd near Florence Ct hail 'n' ride",
                        "Rifle Range Rd near Lily Mac Ct hail 'n' ride",
                        "Pioneer Dr near Harry Mac Ct hail 'n' ride",
                        "Pioneer Dr near Oakey Flat Rd hail 'n' ride",
                        "Oakey Flat Rd near Duncombe Dr",
                        "Oakey Flat Rd near Stark Dr",
                        "Oakey Flat Rd at Windemere Avenue"
                    ],
                    "7014: St Eugenes, Burpengary Secondary": [
                        "Moreton Bay Bvd near Sunday Ct hail 'n' ride",
                        "Buckley Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd at Burpengary East Shopping Centre hail 'n' ride",
                        "Uhlmann Road near Morayfield Road hail 'n' ride",
                        "Morayfield Rd near Ogilvy Rd hail 'n' ride",
                        "Morayfield Rd at Burpengary Pine Village",
                        "Station Road at North Shore Drive",
                        "St Eugene Catholic Primary School",
                        "Progress Rd near Old Gympie Rd hail 'n' ride",
                        "Old Gympie Rd near Pitt Rd",
                        "Pitt Rd near Wain Rd hail 'n' ride"
                    ],
                    "7015: Narangba, Narangba Valley State High": [
                        "Burpengary Rd at Narangba Hall hail 'n' ride",
                        "Boundary Rd near Burpengary Rd hail 'n' ride",
                        "Boundary Rd near Clearview Ct hail 'n' ride",
                        "Mcphail Rd near Ferrier Rd hail 'n' ride",
                        "Mackie Rd near Ryder Ct",
                        "Mackie Rd near Hall Rd",
                        "Mackie Rd near Burpengary Rd hail 'n' ride",
                        "Burpengary Rd near Mackie Rd hail 'n' ride",
                        "Osborne Dr near Burpengary Rd hail 'n' ride",
                        "Osborne Dr near Leonard Ct hail 'n' ride",
                        "Morgan Rd near Valentine Ct hail 'n' ride",
                        "Tadorna St near Grazier St hail 'n' ride",
                        "Old Gympie Rd near Casino Ct hail 'n' ride",
                        "New Settlement Rd near Old Gympie Rd hail 'n' ride",
                        "New Settlement Rd near Marks Rd hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Narangba Valley State High School",
                        "Young Rd at Ridge View Drive",
                        "Young Rd at Cottonwood Street",
                        "New Settlement Rd near Sir Dapper Dr hail 'n' ride",
                        "Forbes Rd near Denham Rd hail 'n' ride",
                        "Moore Rd near Roche Rd hail 'n' ride",
                        "Narangba State School",
                        "Golden Wattle Dr at Narangba Valley High",
                        "Narangba Valley Primary School",
                        "Mackie Rd at Hall Road",
                        "Mackie Rd near Ferrier Rd",
                        "McPhail Rd near Ferrier Rd hail 'n' ride",
                        "Browns Rd near Mumford Rd hail 'n' ride",
                        "Eric Mcsweeney Ct near McCormack Rd Nth HnR",
                        "Eric Mcsweeney Ct near Bonnie View hail 'n' ride",
                        "Eric Mcsweeney Ct near McCormack Rd Nth",
                        "Callaghan Rd near Kassandra Ct hail 'n' ride"
                    ],
                    "7016: Grace College, St Peters, St Columbans": [
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Rosehill Dr near Wain Rd hail 'n' ride",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "Mackenzie Ave near MacDonald Dr hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "New Settlement Rd near Oakley Flat Rd HnR",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Young Rd near Harris Ave hail 'n' ride",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Oakey Flat Rd near Facer Rd hail 'n' ride",
                        "Facer Rd near Ironwood Rd hail 'n' ride",
                        "Laurel Dr near Rowley Rd hail 'n' ride",
                        "Rivergum Dr near Ash Ct hail 'n' ride",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Sauvignon Dr near Williamson Rd hail 'n' ride",
                        "Sauvignon Dr near Excelsior Dr hail 'n' ride",
                        "Excelsior Dr near Sauvignon Dr hail 'n' ride",
                        "Homestead Rd near Woodsmoke Ct hail 'n' ride",
                        "Oakey Flat Rd near Nairn Rd hail 'n' ride",
                        "Oakey Flat Rd near Lakeview Rd hail 'n' ride",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Cresthaven Dr near Crestwood Ave",
                        "Torrens Rd near Grant Rd",
                        "Torrens Rd near Dorset Dr",
                        "Bellmere Rd at Bellmere Shops hail 'n' ride",
                        "King St at Caboolture Swimming Pool",
                        "King St at Maple Lane",
                        "Watt St near Pearl Cr",
                        "Grace College Caboolture Campus",
                        "George St near Toohey St",
                        "St Peter's Primary School",
                        "Beerburrum Rd near Nursery Rd",
                        "Mckean St near Bradman St hail 'n' ride",
                        "McKean St at Caboolture Hospital",
                        "George St at Caboolture State School",
                        "McKean St near Lang St hail 'n' ride",
                        "Watt St near Jade St",
                        "River Dr at Lotus Ave",
                        "Sauvignon Dr near Willamson Rd hail 'n' ride",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Young Rd at Golden Wattle Drive",
                        "Young Rd at Ridge View Drive",
                        "Young Rd at Cottonwood Street",
                        "Pitt Rd near Henderson Rd hail 'n' ride"
                    ],
                    "7017: Burpengary, Burpengary Secondary College": [
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Foxwood Dr hail 'n' ride",
                        "Uhlmann Rd near Fleet St hail 'n' ride",
                        "High Rd near Dover Ct",
                        "High Rd near Hastings Ct hail 'n' ride",
                        "Dunbar Rd near Montrose Ct hail 'n' ride",
                        "Fleet St near Dunbar Rd hail 'n' ride",
                        "Bradford Rd near Linda Gray Ct hail 'n' ride",
                        "Farry Rd near Cobb Rd hail 'n' ride",
                        "Moreton Bay Bvd near Sunday Ct hail 'n' ride",
                        "Buckley Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd near Fountain St hail 'n' ride",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Pitt Rd near Henderson Rd",
                        "Pitt Rd at Claudia St",
                        "Pitt Rd at Pendula Drive",
                        "Burpengary station",
                        "Henderson Rd near Findlay St",
                        "North Shore Dr near Station Rd",
                        "St Eugene Catholic Primary School",
                        "Buckley Rd near Fountain Rd hail 'n' ride",
                        "Uhlmann Road near Morayfield Road hail 'n' ride"
                    ],
                    "7018: Caboolture High, Minimbah State": [
                        "McNamara Rd near Best Rd hail 'n' ride",
                        "Caboolture River Rd near Old North Rd HnR",
                        "Caboolture River Rd near Moorina Rd hail 'n' ride",
                        "Macginley Rd near Caboolture River Rd HnR",
                        "Mackney Rd near Morrisby St hail 'n' ride",
                        "Macginley Rd near Chiverton St hail 'n' ride",
                        "Caboolture River Rd near Tinney Rd hail 'n' ride",
                        "Thornbill Dr near Mallard Ct hail 'n' ride",
                        "Minimbah State School",
                        "Cresthaven Dr near Crestwood Ave",
                        "Caboolture River Rd near Ben St",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd at Kenneth Street",
                        "Morayfield Rd at Domnick Street",
                        "Caboolture Square Shopping Centre",
                        "George St at Caboolture State School",
                        "St Peter's Primary School",
                        "Lee St at Caboolture State High School",
                        "St Peters Primary School",
                        "McKean St at St Columbans College",
                        "Charles St at Caboolture High School",
                        "Lower King St at Charles Street",
                        "Morayfield Rd at John Street",
                        "Morayfield Rd at Caboolture River Road",
                        "Cresthaven Rd near Crestbrook Dr hail 'n' ride",
                        "Thornbill Dr near Petersen Rd hail 'n' ride",
                        "Caboolture River Rd near F Lindsay Rd HnR",
                        "McNamara Road near Best Road hail 'n' ride"
                    ],
                    "7019: Morayfield Primary & High, Minimbah Primary": [
                        "Melba St near Wiley St hail 'n' ride",
                        "Moorina Rd near Ralph St hail 'n' ride",
                        "Fantail Ct near Moorina Rd hail 'n' ride",
                        "Fantail Ct near Sunbird Ct",
                        "Caboolture River Rd near Moorina Rd hail 'n' ride",
                        "Caboolture River Rd near Tinney Rd hail 'n' ride",
                        "Caboolture River Rd near Dobson Lane hail 'n' ride",
                        "Minimbah State School",
                        "Cresthaven Dr near Crestwood Ave",
                        "Caboolture River Rd near Ben St",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd at Kenneth Street",
                        "Morayfield Rd at Domnick Street",
                        "Beerburrum Rd near Nursery Rd",
                        "McKean St at St Columbans College",
                        "Caboolture River Rd near Virginia Rd hail 'n' ride"
                    ],
                    "7020: Morayfield High, Minimbah Primary, Tullawong": [
                        "Morayfield Rd at Burpengary Pine Village",
                        "Morayfield Rd near Ogilvy Rd hail 'n' ride",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Morayfield Rd at Paradise Rd",
                        "Graham Rd near Grady Crt",
                        "Hargrave St near Sturt St hail 'n' ride",
                        "Hargrave St near Streeton Ct hail 'n' ride",
                        "Wimbledon Dr near Keneally Ct hail 'n' ride",
                        "Graham Rd at Hargrave Street",
                        "Laver Rd near Emerson Dr",
                        "Grogan Rd at Grigg Dr",
                        "Evert Ct near Denson St",
                        "Coach Rd West at Laver St",
                        "Coach Rd West near Lomandra Dr",
                        "Lomandra Dr near Redcedar Pl",
                        "Glenwood Dr near Glenmay Ct",
                        "Glenwood Dr near Cotswold St",
                        "Aireal Cr at Morayfield High School",
                        "Morayfield Rd at Oakey Flat Road",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Parkridge Ave near Newfarm St",
                        "Parkridge Ave near Olympic Ct",
                        "Minimbah State School",
                        "Cresthaven Dr near Crestwood Ave",
                        "Beacon St near Cox St",
                        "Beacon St near Ronald Ct",
                        "Beacon St near Grant St",
                        "Torrens Rd near Grant Rd",
                        "Torrens Rd near Dorset Dr",
                        "River Dr at Lotus Avenue",
                        "Bellmere Rd at Bellmere Shops hail 'n' ride",
                        "Bellmere Rd near King St",
                        "King St near Hillcrest Ave",
                        "Tullawong State High School",
                        "Tullawong State Primary School",
                        "St Pauls Lutheran Primary School",
                        "Smiths Rd near Afton St",
                        "River Dr at Lotus Ave",
                        "Beacon St near Caboolture River Rd",
                        "Caboolture River Rd near Maple Dr",
                        "Caboolture River Rd near Maple Dr hail 'n' ride",
                        "Cresthaven Rd near Crestbrook Dr hail 'n' ride",
                        "Walkers Rd near Oakey Flat Rd hail 'n' ride",
                        "Glenwood Dr near Avondale St",
                        "Coach Rd West near Acemia Dr hail 'n' ride",
                        "Evert Ct near Denston St",
                        "Grogan Rd near Laver Rd",
                        "Wimbledon Dr near Keneally Ct",
                        "Hargrave St near Sturt St"
                    ],
                    "7021: Minimbah, Morayfield & Morayfield East": [
                        "Caboolture River Rd near Dobson Lane hail 'n' ride",
                        "Dobson Lane near Arcadia Street hail 'n' ride",
                        "Sunflower Cres near Thistle St hail 'n' ride",
                        "Pauls Rd near Sunflower Cres hail 'n' ride",
                        "Pauls Road near Olympic Court hail 'n' ride",
                        "Parkridge Ave near Olympic Ct",
                        "Parkridge Ave near Kensington Ct",
                        "Parkridge Ave near Newfarm St",
                        "Minimbah State School",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Aireal Cr at Morayfield High School",
                        "Glenwood Drive at Morayfield East State School",
                        "McKean St at St Columbans College",
                        "Walkers Rd near Oakey Flat Rd hail 'n' ride",
                        "Morayfield Rd at Supacentre Shopping Centre"
                    ],
                    "7022: Morayfield Station, Burpengary Primary, NVSHS": [
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Henderson Rd near Fernando St",
                        "Pitt Rd near Hedges Ave hail 'n' ride",
                        "Pitt Rd at Claudia St",
                        "Pitt Rd at Pendula Drive",
                        "Burpengary station",
                        "Burpengary Meadows Primary",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Cedar Dr near Watergum St hail 'n' ride",
                        "Lindsay Rd near Clark Rd hail 'n' ride",
                        "Morayfield Rd near Lindsay Rd hail 'n' ride",
                        "Graham Rd near Parer Cr",
                        "Graham Rd at Hargrave Street",
                        "Glenwood Drive at Morayfield East State School",
                        "Glenwood Dr near Glenmay Ct",
                        "Glenwood Dr near Cotswold St",
                        "Morayfield station"
                    ],
                    "7023: Morayfield, Morayfield East State": [
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Pitt Rd near Henderson Rd",
                        "Henderson Rd near Corelli Ct hail 'n' ride",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Station Rd at Burpengary State School",
                        "Station Rd near Hewson St",
                        "Station Rd near David St",
                        "Morayfield Rd near Arthur Drewett Dr hail 'n' ride",
                        "Morayfield Rd at Burpengary Pine Village",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Morayfield Rd at Paradise Rd",
                        "Lindsay Rd near Anderson Rd",
                        "Anderson Rd near Keeley St hail 'n' ride",
                        "Braheem Street near Keeley St",
                        "Ridgegarden Drive near Jarad Street",
                        "Oakey Flat Rd near Nairn Rd hail 'n' ride",
                        "Oakey Flat Rd near Madeline Dr hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Excelsior Dr near Sauvignon Dr hail 'n' ride",
                        "Homestead Rd near Woodsmoke Ct hail 'n' ride",
                        "Mcloughlin Rd near Range View Rd hail 'n' ride",
                        "Rangeview Rd near Petersen Rd hail 'n' ride",
                        "Petersen Rd near J Dobson Rd hail 'n' ride",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Minimbah State School",
                        "Cresthaven Dr near Crestwood Ave",
                        "Caboolture River Rd near Ben St",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd at Kenneth Street",
                        "Aireal Cr at Morayfield High School",
                        "Glenwood Drive at Morayfield East State School",
                        "Cresthaven Rd near Crestbrook Dr hail 'n' ride",
                        "Petersen Rd near Rangeview Rd hail 'n' ride",
                        "Oakey Flat Rd near Bridges Rd hail 'n' ride",
                        "Oakey Flat Rd near Lakeview Rd hail 'n' ride",
                        "Keeley Street near Anderson Rd",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Pitt Rd near Henderson Rd hail 'n' ride"
                    ],
                    "7024: Morayfield State, St Peters, St Columbans": [
                        "Burpengary Meadows Primary",
                        "Rivergum Dr near Chestnut Dr hail 'n' ride",
                        "Rivergum Dr near Laurel Dr hail 'n' ride",
                        "Rivergum Dr near Ash Ct hail 'n' ride",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Williamson Rd near Oakey Flat Rd hail 'n' ride",
                        "Sauvignon Dr near Excelsior Dr hail 'n' ride",
                        "Sauvignon Dr near Willamson Rd hail 'n' ride",
                        "Ward Rd near Nairn Rd hail 'n' ride",
                        "Nairn Rd near J Dobson Rd hail 'n' ride",
                        "Mcloughlin Rd near Range View Rd hail 'n' ride",
                        "Rangeview Rd near Petersen Rd hail 'n' ride",
                        "Petersen Rd near J Dobson Rd hail 'n' ride",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Aireal Cr at Morayfield High School",
                        "Morayfield Rd at Domnick Street",
                        "Beerburrum Rd near Nursery Rd",
                        "McKean St at St Columbans College",
                        "Glenwood Drive at Morayfield East State School",
                        "Glenwood Dr near Glenmay Ct",
                        "Glenwood Dr near Cotswold St",
                        "Morayfield Rd at Oakey Flat Road",
                        "Petersen Rd near Rangeview Rd hail 'n' ride",
                        "Ward Rd near Semilion Ct hail 'n' ride",
                        "Sauvignon Dr near Williamson Rd hail 'n' ride",
                        "Rowley Rd near Hauton Road hail 'n' ride",
                        "Rowley Rd near Belford Dr hail 'n' ride",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Henderson Rd near Landini Ct hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride"
                    ],
                    "7025: Morayfield, Caboolture, St Columbans": [
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Rowley Rd near Hauton Road hail 'n' ride",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Oakey Flat Rd near Lakeview Rd hail 'n' ride",
                        "Ridgegarden Drive near Jarad Street",
                        "Braheem Street near Keeley St",
                        "Anderson Rd near Keeley St hail 'n' ride",
                        "Morayfield Rd near Lindsay Rd hail 'n' ride",
                        "Graham Rd near Parer Cr",
                        "Graham Rd at Hargrave Street",
                        "Laver Rd near Emerson Dr",
                        "Grogan Rd at Grigg Dr",
                        "Evert Ct near Denson St",
                        "Coach Rd West at Laver St",
                        "Coach Rd West near Lomandra Dr",
                        "Lomandra Dr near Redcedar Pl",
                        "Glenwood Drive at Morayfield East State School",
                        "Glenwood Dr near Glenmay Ct",
                        "Glenwood Dr near Cotswold St",
                        "Aireal Cr at Morayfield High School",
                        "Morayfield State School",
                        "Morayfield Rd at Domnick Street",
                        "George St at Caboolture State School",
                        "Lee St at Caboolture State High School",
                        "Caboolture River Rd at Kenneth Street",
                        "Glenwood Dr near Avondale St",
                        "Coach Rd West near Acemia Dr hail 'n' ride",
                        "Evert Ct near Denston St",
                        "Grogan Rd near Laver Rd",
                        "Graham Rd near Parer Cr hail 'n' ride",
                        "Lindsay Rd near Anderson Rd",
                        "Rowley Rd near Belford Dr hail 'n' ride",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Pitt Rd near Henderson Rd hail 'n' ride"
                    ],
                    "7026: Morayfield, Morayfield East State": [
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Foxwood Dr hail 'n' ride",
                        "Uhlmann Rd near Fleet St hail 'n' ride",
                        "High Rd near Hastings Ct hail 'n' ride",
                        "Dunbar Rd near Montrose Ct hail 'n' ride",
                        "Fleet St near Dunbar Rd hail 'n' ride",
                        "Bradford Rd near Linda Gray Ct hail 'n' ride",
                        "Farry Rd near Cobb Rd hail 'n' ride",
                        "Moreton Bay Bvd near Sunday Ct hail 'n' ride",
                        "Buckley Rd near Cobb Rd hail 'n' ride",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Morayfield Rd at Paradise Rd",
                        "Morayfield Rd at Lindsay Road",
                        "Morayfield Rd at Supacentre Shopping Centre",
                        "Morayfield Rd at Oakey Flat Road",
                        "Aireal Cr at Morayfield High School",
                        "Glenwood Drive at Morayfield East State School",
                        "Glenwood Dr near Avondale St",
                        "Glenwood Dr near Glenmay Ct",
                        "North Harbour Bvd hail 'n'ride",
                        "Moreton Bay Bvd near Normanby Cres hail 'n'ride",
                        "Buckley Rd near Moreton Bay Bvd hail 'n' ride",
                        "Northwood Dr near Buckley Rd hail 'n' ride",
                        "Fleet St near Uhlmann Rd hail 'n' ride"
                    ],
                    "7027: Burpengary State Primary & Meadows": [
                        "Hunt Rd near Cedar Dr hail 'n' ride",
                        "Cedar Dr near Watergum St hail 'n' ride",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Bridges Rd near Trail Rd hail 'n' ride",
                        "Oakey Flat Rd near Madeline Dr hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Excelsior Dr near Sauvignon Dr hail 'n' ride",
                        "Nairn Rd near J Dobson Rd hail 'n' ride",
                        "Homestead Rd near Woodsmoke Ct hail 'n' ride",
                        "Sauvignon Dr near Excelsior Dr hail 'n' ride",
                        "Sauvignon Dr near Willamson Rd hail 'n' ride",
                        "Williamson Rd near Oakey Flat Rd hail 'n' ride",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Rivergum Dr near Ash Ct hail 'n' ride",
                        "Rivergum Dr near Laurel Dr hail 'n' ride",
                        "Rivergum Dr near Chestnut Dr hail 'n' ride",
                        "Chestnut Dr near Birch Ct hail 'n' ride",
                        "Laurel Dr near Rowley Rd hail 'n' ride",
                        "Facer Rd near Ironwood Rd hail 'n' ride",
                        "Hawthorn Rd near Facer Rd hail 'n' ride",
                        "Hawthorn Rd near Redgum Dr hail 'n' ride",
                        "Ironwood Rd near Redgum Dr hail 'n' ride",
                        "Burpengary Meadows Primary",
                        "Rowley Rd near Belford Dr hail 'n' ride",
                        "Station Rd at Burpengary State School",
                        "Station Rd near Hewson St",
                        "Station Rd near David St",
                        "St Eugene Catholic Primary School",
                        "Sauvignon Dr near Williamson Rd hail 'n' ride",
                        "Oakey Flat Rd near Bridges Rd hail 'n' ride",
                        "Obrien Rd near Lindsay Rd hail 'n' ride",
                        "Oakey Flat Rd near Nairn Rd hail 'n' ride"
                    ],
                    "7028: Petrie Primary, Pine Rivers High": [
                        "Oakey Flat Rd at BP Narangba hail 'n' ride",
                        "Oakey Flat Rd near Duncombe Dr",
                        "Oakey Flat Rd near Stark Dr",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd at Windemere Avenue",
                        "Narangba Rd near Cooper Rd hail 'n' ride",
                        "Narangba Rd near Dakabin station",
                        "Narangba Rd near Torrens Rd hail 'n' ride",
                        "Beeville Rd near Mona Vale Way",
                        "Chambery Rd near Forestville Rd",
                        "Belrose Ave near Gehrman Ct hail 'n' ride",
                        "Belrose Ave near Rue Montaigne",
                        "Woonara Dr near Joora Ave",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Gympie Rd at Station Road",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Paisley Park",
                        "Gympie Rd at Pine Rivers High School",
                        "Buckby St at Pine Rivers High School",
                        "Bells Pocket Rd near Bateman St",
                        "Bells Pocket Rd near Wirraway St",
                        "Bells Pocket Rd near Dobson Dr hail 'n' ride",
                        "Lawnton Pocket Rd near Paisley Dr",
                        "Dayboro Rd near Joora Ave",
                        "Belrose Ave near St Quentin Rd",
                        "Belrose Ave near Gehrman Ct",
                        "Chambery Rd near Bordeau Cr",
                        "Beeville Rd at Frenchs Rd",
                        "Narangba Rd near Torrens Rd",
                        "Main St near Narangba station",
                        "Oakey Flat Rd near Main St",
                        "Oakey Flat Rd near Dorothy St",
                        "Oakey Flat Rd near Pioneer Rd",
                        "New Settlement Rd near Oakley Flat Rd HnR",
                        "New Settlement Rd near Young Rd hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "Rosehill Dr near Baguette St hail 'n' ride"
                    ],
                    "7029: Burpengary, Narangba Primary, Dakabin High": [
                        "Station Rd at Springfield Drive",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Bellini Rd near Neri Place",
                        "Bellini Rd near Ravel St",
                        "Pitt Rd near Henderson Rd",
                        "Rosehill Dr near Wain Rd hail 'n' ride",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "Mackenzie Ave near MacDonald Dr hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "Banyan St near Juniper Ct hail 'n' ride",
                        "New Settlement Rd near Oakley Flat Rd HnR",
                        "Rifle Range Rd near Florence Ct hail 'n' ride",
                        "Rifle Range Rd near Lily Mac Ct hail 'n' ride",
                        "Pioneer Dr near Harry Mac Ct hail 'n' ride",
                        "Pioneer Dr near Oakey Flat Rd hail 'n' ride",
                        "Oakey Flat Rd near Duncombe Dr",
                        "Oakey Flat Rd near Stark Dr",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd at Windemere Avenue",
                        "Narangba State School",
                        "Burpengary Rd at Narangba Hall hail 'n' ride",
                        "Boundary Rd near Burpengary Rd hail 'n' ride",
                        "Boundary Rd near Clearview Ct hail 'n' ride",
                        "Old Gympie Rd near Boundary Rd hail 'n' ride",
                        "Old Gympie Rd at Plantation Road",
                        "Whitehorse Rd near Cootha Dr",
                        "Whitehorse Rd near Sheaves Rd",
                        "Whitehorse Rd near Seabiscuit Cr",
                        "Dakabin High School",
                        "Alma Rd at Conquest Boulevard",
                        "Old Gympie Rd near Hughes Rd East hail 'n' ride",
                        "Main St near Narangba station",
                        "Oakey Flat Rd near Main St",
                        "Oakey Flat Rd near Dorothy St",
                        "Oakey Flat Rd near Pioneer Rd",
                        "Pioneer Dr near Oakey Flat Dr",
                        "Pioneer Dr near Eliza Ct",
                        "Pioneer Dr near Harry Mac Ct",
                        "Rifle Range Rd near Lilly Mac Ct",
                        "Rifle Range Rd near Florence Ct",
                        "New Settlement Rd near Young Rd hail 'n' ride",
                        "Pitt Rd near Henderson Rd hail 'n' ride",
                        "Bellini Rd near Borodin Ct hail 'n' ride",
                        "Bellini Rd near Neri Pl hail 'n' ride",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Progress Rd near Old Gympie Rd hail 'n' ride"
                    ],
                    "7030: Deception Bay, Dakabin High": [
                        "Deception Bay bus station",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Ewart St near Raymond Tce",
                        "Ewart St near Thompson St",
                        "Bancroft Tce near Airlie Ave",
                        "Bermuda Ave near St George Cl",
                        "Bermuda Ave near Surfrey Ct",
                        "Bancroft Tce near Moore St",
                        "Thompson St near Elna Ct",
                        "Old Bay Rd near Warroo Dr",
                        "Claverton Dr near Aberfoyle Dr",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd at Krause Street",
                        "Warroo Dr near Kippah St",
                        "Bucknor Dr near Kerwalli St",
                        "Park Rd near Deception Bay Rd",
                        "Deception Bay Rd at Bailey Road",
                        "Moreton Downs Dr near Alexandra Ct",
                        "Kate Ave near Moreton Downs Dr",
                        "Government St near Kevin St",
                        "Phillip Pde near Spencer Ave",
                        "Phillip Pde near Bundaberg St",
                        "Bundaberg St near Clair Ave",
                        "Parsons Bvd near Cairns Cr",
                        "Mariner Bvd near Parsons Bvd",
                        "Boundary Rd near Business Dr hail 'n' ride",
                        "Boundary Rd at Narangba Depot",
                        "Old Gympie Rd near Boundary Rd hail 'n' ride",
                        "Old Gympie Rd at Plantation Road",
                        "Dakabin High School",
                        "Alma Rd at Conquest Boulevard",
                        "Old Gympie Rd near Hughes Rd East hail 'n' ride",
                        "Mariner Bvd near Lipscombe St",
                        "Parsons Bvd near Mariner Bvd",
                        "Phillip Pde near Moreton Down Dr",
                        "Government St near Kate St",
                        "Moreton Downs Dr near Felicity Ct",
                        "Deception Bay Rd at Tallagon Court"
                    ],
                    "7031: Dakabin, Petrie, Pine Rivers State": [
                        "Narangba Rd near Torrens Rd hail 'n' ride",
                        "Kurwongbah Dr near Beeville Rd",
                        "Kurwongbah Dr near Carwell Ave",
                        "Eucumbene Dr near Burrumbeet St hail 'n' ride",
                        "Eucumbene Dr near Frenchs Rd",
                        "Chambery Rd near Forestville Rd",
                        "Belrose Ave near Gehrman Ct hail 'n' ride",
                        "Belrose Ave near Rue Montaigne",
                        "Woonara Dr near Joora Ave",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Anzac Ave at Whites Road",
                        "Anzac Ave at Our Lady Of The Way Primary",
                        "Anzac Ave at Macs Lane",
                        "Marsden Rd near Narangba Rd",
                        "Marsden Rd near Sylvester Dr",
                        "Dakabin High School Oval Bus Bay",
                        "Narangba Rd at Kedron Road",
                        "Torrens Rd near Narangba Rd hail 'n' ride",
                        "Beeville Rd near Pymble Ave",
                        "Gympie Rd at Station Road",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Paisley Park",
                        "Gympie Rd at Pine Rivers High School",
                        "Buckby St at Pine Rivers High School",
                        "Frenchs Rd near Kurwongbah Primary School HnR",
                        "Bells Pocket Rd near Bateman St",
                        "Bells Pocket Rd near Wirraway St",
                        "Bells Pocket Rd near Dobson Dr hail 'n' ride",
                        "Lawnton Pocket Rd near Paisley Dr",
                        "Dayboro Rd near Joora Ave",
                        "Beeville Rd at Frenchs Rd",
                        "Beeville Rd near Mona Vale Way",
                        "Macquarie Dr near Frenchs Rd hail 'n' ride",
                        "Frenchs Rd near Eucumbene Dr",
                        "Eucumbene Dr near Pedder Ct",
                        "Eucumbene Dr near Burrumbeet St",
                        "Narangba Rd near Kedron Rd",
                        "Marsden Rd near Whitehorse Rd",
                        "Dakabin High School",
                        "Alma Rd at Conquest Boulevard"
                    ],
                    "7032: Deception Bay State, Moreton Downs": [
                        "Old Bay Rd Community Hall hail 'n' ride",
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Bancroft Tce near Moore St",
                        "Thompson St near Elna Ct",
                        "Old Bay Rd near Warroo Dr",
                        "Claverton Dr near Aberfoyle Dr",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd at Krause Street",
                        "Deception Bay Rd at Tallagon Court",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay High School",
                        "Cross St near Webster Rd hail 'n' ride",
                        "Cross St near Windlass St hail 'n' ride",
                        "Cross St near Coman St hail 'n' ride",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Webster Road",
                        "Government St near Kate St",
                        "Embassy St at Major Street",
                        "Government St near Kevin St",
                        "Government St near Phillip Pde",
                        "Phillip Pde near Spencer Ave",
                        "Deception Bay bus station",
                        "Grosvenor Tce at Deception Bay State School",
                        "Ewart St near Raymond Tce",
                        "Ewart St near Thompson St",
                        "Thompson St at Christ The King Primary",
                        "Old Bay Rd at Deception Bay North Primary",
                        "Park Rd near Deception Bay Rd",
                        "Lipscombe Rd at Leyland Avenue",
                        "Lipscombe Rd near Mariner Bvd",
                        "Mariner Bvd near Lipscombe St",
                        "Mariner Bvd near Yandina Pl",
                        "Moreton Downs State School",
                        "Mariner Bvd near Parsons Bvd",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Warroo Dr near Headland Pl hail 'n' ride",
                        "Warroo Dr near Kippah St",
                        "Warroo Dr near Kippah St hail 'n' ride",
                        "Thompson St near Airlie Ave",
                        "Ewart St near Rayleigh St hail 'n' ride",
                        "Ewart St near Bayview Tce hail 'n' ride",
                        "Deception Bay Rd at Phillip Parade",
                        "Zammit St near Monarch Dr hail 'n' ride",
                        "Eveshan Rd near Zammit St hail 'n' ride",
                        "Claverton Dr near Aberfoyle Dr hail 'n' ride",
                        "Bancroft Tce near Rainbow St hail 'n' ride",
                        "Old Bay Rd opposite Community Hall hail 'n' ride"
                    ],
                    "7033: Clontarf High, Kippa Ring State": [
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Bancroft Tce near Bermuda Ave hail 'n' ride",
                        "Thompson St at Christ The King Primary",
                        "Thompson St near Airlie Ave",
                        "Ewart St near Rayleigh St hail 'n' ride",
                        "Ewart St near Bayview Tce hail 'n' ride",
                        "Bailey Rd near Osborne Tce hail 'n' ride",
                        "Deception Bay bus station",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Elizabeth Ave at Grimley Street",
                        "Elizabeth Ave at Korsch Street",
                        "Isobel St near Weaber St",
                        "Maine Rd near Isobel St",
                        "Maine Rd at Beedham Street",
                        "Maine Rd at Heather Street",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Maine Tce near Union St",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Ewart St near Raymond Tce",
                        "Ewart St near Thompson St",
                        "Thompson St near Elna Ct",
                        "Buckley Rd near Fountain Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Currant Rd hail 'n' ride",
                        "Morayfield Rd at Burpengary Pine Village"
                    ],
                    "7034: Scarborough State, Grace, Morayfield": [
                        "Morayfield Rd near Ogilvy Rd hail 'n' ride",
                        "Uhlmann Rd near Fleet St hail 'n' ride",
                        "High Rd near Hastings Ct hail 'n' ride",
                        "Dunbar Rd near Montrose Ct hail 'n' ride",
                        "Fleet St near Dunbar Rd hail 'n' ride",
                        "Bradford Rd near Linda Gray Ct hail 'n' ride",
                        "Farry Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Buckley Rd near Fountain St hail 'n' ride",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Bancroft Tce near Bermuda Ave hail 'n' ride",
                        "Thompson St at Christ The King Primary",
                        "Ewart St near Rayleigh St hail 'n' ride",
                        "Ewart St near Bayview Tce hail 'n' ride",
                        "Bailey Rd near Osborne Tce hail 'n' ride",
                        "Deception Bay bus station",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Southern Cross Kippa-Ring College hail 'n' ride",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Boardman Rd at Talobilla Park",
                        "Boardman Rd near Griffith Rd hail 'n' ride",
                        "Griffith Rd at Volunteer Street",
                        "Oxley Ave at Pearl Street",
                        "Eversleigh Rd at Scarborough Primary School",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Southern Cross College",
                        "Scarborough Rd at Griffith Road",
                        "Sunnyside Rd at Central Avenue",
                        "Endeavour Esp at Dolphin Street",
                        "Newport Dr near Southern Cross Dr",
                        "Newport Drive near Griffith Rd",
                        "Griffith Rd at Newport Marina",
                        "Boardman Rd at Arcadia Crescent",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Deception Bay Rd at Zone One hail 'n' ride",
                        "Maine Tce near Union St",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Ewart St near Raymond Tce",
                        "Ewart St near Thompson St",
                        "Thompson St near Elna Ct",
                        "Buckley Rd near Fountain Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Foxwood Dr hail 'n' ride",
                        "Buckley Rd at Burpengary East Shopping Centre hail 'n' ride",
                        "Uhlmann Road near Morayfield Road hail 'n' ride"
                    ],
                    "7035: Morayfield, Mueller, Grace": [
                        "Hasking St near Beerburrum Rd",
                        "Morayfield Rd at John Street",
                        "Morayfield Rd at Caboolture River Road",
                        "Aireal Cr at Morayfield High School",
                        "Glenwood Dr near Avondale St",
                        "Glenwood Dr near Glenmay Ct",
                        "Graham Rd at Hargrave Street",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Morayfield Rd at Burpengary Pine Village",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Station Rd at Burpengary State School",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Henderson Rd near Landini Ct hail 'n' ride",
                        "Rosehill Dr near Wain Rd hail 'n' ride",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "Osborne Dr near Burpengary Rd hail 'n' ride",
                        "Osborne Dr near Leonard Ct hail 'n' ride",
                        "Morgan Rd near Valentine Ct hail 'n' ride",
                        "Old Gympie Rd near Casino Ct hail 'n' ride",
                        "Deception Bay Rd at Eastern Service Rd",
                        "Deception Bay Rd near Tallowood Dr",
                        "Deception Bay Rd at Zammit Street",
                        "Deception Bay Rd at Krause Street",
                        "Deception Bay Rd at Tallagon Court",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay bus station",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Morris Rd near Gynther Rd",
                        "Morris Rd near Melaleuca Cr",
                        "Morris Rd near Lynanda Ct",
                        "Morris Rd at Lynanda Court",
                        "Morris Rd at Bertie Dow Park",
                        "Morris Rd at Cambridge Street",
                        "Deception Bay Rd at Wayper Way",
                        "Henderson Rd near Corelli Ct hail 'n' ride",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Station Rd near Hewson St",
                        "Station Rd near David St",
                        "Graham Rd near Parer Cr",
                        "Glenwood Dr near Cotswold St",
                        "Morayfield station",
                        "Caboolture River Rd at Kenneth Street",
                        "Morayfield Rd at Domnick Street",
                        "Caboolture Square Shopping Centre"
                    ],
                    "7036: Burpengary, Deception Bay, Grace": [
                        "Station Rd at Burpengary State School",
                        "Obrien Rd near Lindsay Rd hail 'n' ride",
                        "Braheem Street near Keeley St",
                        "Ridgegarden Drive near Jarad Street",
                        "Oakey Flat Rd near Nairn Rd hail 'n' ride",
                        "Homestead Rd near Woodsmoke Ct hail 'n' ride",
                        "Excelsior Dr near Sauvignon Dr hail 'n' ride",
                        "Williamson Rd near Oakey Flat Rd hail 'n' ride",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Rivergum Dr near Ash Ct hail 'n' ride",
                        "Rivergum Dr near Laurel Dr hail 'n' ride",
                        "Rivergum Dr near Chestnut Dr hail 'n' ride",
                        "Chestnut Dr near Birch Ct hail 'n' ride",
                        "Laurel Dr near Rowley Rd hail 'n' ride",
                        "Facer Rd near Ironwood Rd hail 'n' ride",
                        "Oakey Flat Rd near Facer Rd hail 'n' ride",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Raynbird Rd near Highlands Rd hail 'n' ride",
                        "Rifle Range Rd near Florence Ct",
                        "Forest Ridge Rd near New Settlement Rd",
                        "Forest Ridge Dr near Tuckeroo St",
                        "Forest Ridge Rd near Rokeby St",
                        "Forest Ridge Rd near Outlook Pl",
                        "Young Rd at Golden Wattle Drive",
                        "Young Rd at Ridge View Drive",
                        "Young Rd at Cottonwood Street",
                        "New Settlement Rd near Banyan St",
                        "Mackenzie Ave near MacDonald Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Sir Dapper Dr hail 'n' ride",
                        "New Settlement Rd near Old Gympie Rd hail 'n' ride",
                        "Deception Bay Rd at Eastern Service Rd",
                        "Deception Bay Rd near Tallowood Dr",
                        "Deception Bay Rd at Zammit Street",
                        "Deception Bay Rd at Krause Street",
                        "Deception Bay Rd at Tallagon Court",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay bus station",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Grace Lutheran College",
                        "Southern Cross Kippa-Ring College hail 'n' ride",
                        "Bremner Road",
                        "Mewes Road",
                        "Deception Bay Rd at Zone One hail 'n' ride",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Wayper Way",
                        "New Settlement Rd near Marks Rd hail 'n' ride",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Young Rd near Harris Ave hail 'n' ride",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Forest Ridge Dr near Waterway Cr hail 'n' ride",
                        "Forest Ridge Dr near Rokeby St hail 'n' ride",
                        "Forest Ridge Dr near Needletail Ct hail 'n' ride",
                        "Forest Ridge Dr near Friarbird Dr hail 'n' ride",
                        "Rifle Range Rd near Florence Ct hail 'n' ride",
                        "Oakey Flat Road near Elm Ct hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Oakey Flat Rd near Lakeview Rd hail 'n' ride",
                        "Keeley Street near Anderson Rd",
                        "Lindsay Rd near Clark Rd hail 'n' ride"
                    ],
                    "7037: Excelsior Park, Narangba Valley High": [
                        "Minimbah State School",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Petersen Rd near J Dobson Rd hail 'n' ride",
                        "Petersen Rd near Rangeview Rd hail 'n' ride",
                        "Ward Rd near Semilion Ct hail 'n' ride",
                        "Sauvignon Dr near Williamson Rd hail 'n' ride",
                        "Sauvignon Dr near Excelsior Dr hail 'n' ride",
                        "Williamson Rd near Oakey Flat Rd hail 'n' ride",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Sovereign Dr near Champion Cct hail 'n' ride",
                        "Sovereign Dr near Grace Cr hail 'n' ride",
                        "Sovereign Dr near Superb Cr hail 'n' ride",
                        "Carmichael College",
                        "Facer Rd near Ironwood Rd hail 'n' ride",
                        "Narangba Valley State High School",
                        "Golden Wattle Dr at Narangba Valley High",
                        "Oakey Flat Rd near Facer Rd hail 'n' ride",
                        "Sauvignon Dr near Willamson Rd hail 'n' ride",
                        "Ward Rd near Nairn Rd hail 'n' ride",
                        "Nairn Rd near J Dobson Rd hail 'n' ride",
                        "Mcloughlin Rd near Range View Rd hail 'n' ride",
                        "Rangeview Rd near Petersen Rd hail 'n' ride",
                        "Dobson Lane near Arcadia Street hail 'n' ride",
                        "Sunflower Cres near Thistle St hail 'n' ride",
                        "Pauls Rd near Sunflower Cres hail 'n' ride",
                        "Pauls Road near Olympic Court hail 'n' ride",
                        "Kensington Ct near Parkridge Ave hail 'n' ride",
                        "Parkridge Ave near Kensington Ct",
                        "Parkridge Ave near Newfarm St"
                    ],
                    "7038: Minimbah State, Tullawong Primary & High": [
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Bellini Rd near Borodin Ct hail 'n' ride",
                        "Bellini Rd near Neri Pl hail 'n' ride",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Station Rd at Burpengary State School",
                        "Obrien Rd near Lindsay Rd hail 'n' ride",
                        "Hunt Rd near Blackbutt Ct hail 'n' ride",
                        "Bridges Rd near Trail Rd hail 'n' ride",
                        "Oakey Flat Rd near Madeline Dr hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Sauvignon Dr near Williamson Rd hail 'n' ride",
                        "Sauvignon Dr near Excelsior Dr hail 'n' ride",
                        "Excelsior Dr near Sauvignon Dr hail 'n' ride",
                        "Homestead Rd near Woodsmoke Ct hail 'n' ride",
                        "Burgundy Dr near Brandy Ct",
                        "Mcloughlin Rd near Range View Rd hail 'n' ride",
                        "Rangeview Rd near Petersen Rd hail 'n' ride",
                        "Petersen Rd near J Dobson Rd hail 'n' ride",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Minimbah State School",
                        "Cresthaven Dr near Crestwood Ave",
                        "Torrens Rd near Grant Rd",
                        "Torrens Rd near Dorset Dr",
                        "River Dr at Lotus Avenue",
                        "Bellmere Rd at Bellmere Shops hail 'n' ride",
                        "Bellmere Rd near King St",
                        "Tullawong State Primary School",
                        "Tullawong State High School",
                        "Smiths Rd near Afton St",
                        "River Dr at Lotus Ave",
                        "Cresthaven Rd near Crestbrook Dr hail 'n' ride",
                        "Petersen Rd near Rangeview Rd hail 'n' ride",
                        "Sauvignon Dr near Willamson Rd hail 'n' ride",
                        "Oakey Flat Rd near Bridges Rd hail 'n' ride",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Bellini Rd near Neri Place",
                        "Bellini Rd near Ravel St"
                    ],
                    "7039: Burpengary, Burpengary Secondary College": [
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Foxwood Dr hail 'n' ride",
                        "Uhlmann Rd near Fleet St hail 'n' ride",
                        "Dunbar Rd near Montrose Ct hail 'n' ride",
                        "Fleet St near Dunbar Rd hail 'n' ride",
                        "Bradford Rd near Linda Gray Ct hail 'n' ride",
                        "Farry Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd near Fountain St hail 'n' ride",
                        "New Settlement Rd near Old Gympie Rd hail 'n' ride",
                        "New Settlement Rd near Marks Rd hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "New Settlement Rd near Oakley Flat Rd HnR",
                        "New Settlement Rd near Oakley Flat Rd",
                        "Rifle Range Rd near Florence Ct hail 'n' ride",
                        "Side Creek Pde near Banksia Dr hail 'n' ride",
                        "Side Creek Pde near Ridge Pde hail 'n' ride",
                        "Ridge Pde near Bluegrass Dr hail 'n' ride",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Sovereign Dr near Champion Cct hail 'n' ride",
                        "Sovereign Dr near Grace Cr hail 'n' ride",
                        "Sovereign Dr near Superb Cr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Narangba Valley State High School",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Ridge Pde near Grey Cr hail 'n' ride",
                        "Side Creek Pde near Bush Tucker Dr hail 'n' ride",
                        "Rifle Range Rd near Florence Ct",
                        "New Settlement Rd near Young Rd hail 'n' ride",
                        "New Settlement Rd near Sir Dapper Dr hail 'n' ride",
                        "Callaghan Rd near Kassandra Ct hail 'n' ride",
                        "Tadorna St near Grazier St hail 'n' ride",
                        "Old Gympie Rd near Casino Ct hail 'n' ride",
                        "Buckley Rd near Fountain Rd hail 'n' ride"
                    ],
                    "7040: Deception Bay, Narangba Valley State High": [
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Bancroft Tce near Bermuda Ave hail 'n' ride",
                        "Bancroft Tce near Moore St",
                        "Bancroft Tce near Airlie Ave hail 'n' ride",
                        "Thompson St near Elna Ct",
                        "Warroo Dr near Headland Pl hail 'n' ride",
                        "Eveshan Rd near Breakwater Ct hail 'n' ride",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd at Krause Street",
                        "Deception Bay Rd at Tallagon Court",
                        "Park Rd near Stamp St hail 'n' ride",
                        "Park Rd near Murray Dr hail 'n' ride",
                        "Bayview Tce near Raymond Tce hail 'n' ride",
                        "Bailey Rd near Osborne Tce hail 'n' ride",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay Rd at Deception Bay Shops",
                        "Deception Bay Rd at Phillip Parade",
                        "Phillip Pde near Spencer Ave",
                        "Phillip Pde near Bundaberg St",
                        "Bundaberg St near Clair Ave",
                        "Parsons Bvd near Cairns Cr",
                        "Mariner Bvd near Parsons Bvd",
                        "Boundary Rd near Business Dr hail 'n' ride",
                        "Boundary Rd at Narangba Depot",
                        "Old Gympie Rd near Frawley Ave hail 'n' ride",
                        "Old Gympie Rd near Casino Ct hail 'n' ride",
                        "New Settlement Rd near Old Gympie Rd hail 'n' ride",
                        "New Settlement Rd near Marks Rd hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Narangba Valley State High School",
                        "Young Rd at Ridge View Drive",
                        "Young Rd at Cottonwood Street",
                        "New Settlement Rd near Sir Dapper Dr hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Eastern Service Rd at Creek Road",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride"
                    ],
                    "7041: Narangba Station, Narangba Valley High": [
                        "Eric Mcsweeney Ct near Bonnie View hail 'n' ride",
                        "Eric Mcsweeney Ct near McCormack Rd Nth",
                        "Forbes Rd near Denham Rd hail 'n' ride",
                        "Moore Rd near Roche Rd hail 'n' ride",
                        "Browns Rd near Mumford Rd hail 'n' ride",
                        "Narangba station",
                        "Oakey Flat Rd near Main St",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd near Dorothy St",
                        "Oakey Flat Rd near Pioneer Rd",
                        "Pioneer Dr near Oakey Flat Dr",
                        "Pioneer Dr near Eliza Ct",
                        "Pioneer Dr near Harry Mac Ct",
                        "Rifle Range Rd near Lilly Mac Ct",
                        "Rifle Range Rd near Florence Ct",
                        "Forest Ridge Rd near New Settlement Rd",
                        "Forest Ridge Dr near Tuckeroo St",
                        "Forest Ridge Rd near Rokeby St",
                        "Forest Ridge Rd near Outlook Pl",
                        "Narangba Valley Primary School",
                        "Young Rd at Golden Wattle Drive",
                        "Narangba Valley State High School",
                        "Carmichael College",
                        "Oakey Flat Rd near Facer Rd hail 'n' ride",
                        "Facer Rd near Ironwood Rd hail 'n' ride",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Sovereign Dr near Champion Cct hail 'n' ride",
                        "Sovereign Dr near Grace Cr hail 'n' ride",
                        "Sovereign Dr near Superb Cr hail 'n' ride",
                        "New Settlement Rd near Young Rd hail 'n' ride",
                        "Tadorna St near Grazier St hail 'n' ride",
                        "Osborne Dr near Burpengary Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride"
                    ],
                    "7042: Burpengary Meadows, Narangba Valley": [
                        "Morayfield Rd at Burpengary Pine Village",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Morayfield Rd at Paradise Rd",
                        "Lindsay Rd near Anderson Rd",
                        "Anderson Rd near Keeley St hail 'n' ride",
                        "Braheem Street near Keeley St",
                        "Ridgegarden Drive near Jarad Street",
                        "Oakey Flat Rd near Nairn Rd hail 'n' ride",
                        "Burgundy Dr near Brandy Ct",
                        "Nairn Rd near J Dobson Rd hail 'n' ride",
                        "Homestead Rd near Woodsmoke Ct hail 'n' ride",
                        "Excelsior Dr near Sauvignon Dr hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Oakey Flat Road near Williamson Road hail 'n' ride",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Burpengary Meadows Primary",
                        "Oakey Flat Rd near Facer Rd hail 'n' ride",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Young Rd at Golden Wattle Drive",
                        "Narangba Valley State High School",
                        "Carmichael College",
                        "Golden Wattle Dr at Narangba Valley High",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Oakey Flat Rd near Lakeview Rd hail 'n' ride",
                        "Lindsay Rd near Anderson Rd hail 'n' ride",
                        "Morayfield Rd near Ogilvy Rd hail 'n' ride"
                    ],
                    "7043: Narangba Valley Primary, Jinibara State": [
                        "Pitt Rd near Henderson Rd",
                        "Station Rd at Burpengary State School",
                        "Obrien Rd near Lindsay Rd hail 'n' ride",
                        "Hunt Rd near Cedar Dr hail 'n' ride",
                        "Cedar Dr near Watergum St hail 'n' ride",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Oakey Flat Rd near Madeline Dr hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Sauvignon Dr near Excelsior Dr hail 'n' ride",
                        "Sauvignon Dr near Willamson Rd hail 'n' ride",
                        "Williamson Rd near Oakey Flat Rd hail 'n' ride",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Rivergum Dr near Ash Ct hail 'n' ride",
                        "Laurel Dr near Rowley Rd hail 'n' ride",
                        "Facer Rd near Ironwood Rd hail 'n' ride",
                        "Oakey Flat Rd near Facer Rd hail 'n' ride",
                        "Carmichael College",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Oakey Flat Rd at BP Narangba hail 'n' ride",
                        "Pioneer Dr near Oakey Flat Dr",
                        "Pioneer Dr near Eliza Ct",
                        "Pioneer Dr near Harry Mac Ct",
                        "Rifle Range Rd near Lilly Mac Ct",
                        "Rifle Range Rd near Florence Ct",
                        "Forest Ridge Rd near New Settlement Rd",
                        "Forest Ridge Dr near Tuckeroo St",
                        "Forest Ridge Rd near Rokeby St",
                        "Forest Ridge Rd near Outlook Pl",
                        "Narangba Valley Primary School",
                        "Young Rd at Golden Wattle Drive",
                        "Young Rd at Ridge View Drive",
                        "Hickory Dr near Banyan St hail 'n' ride",
                        "Jinibara State Primary School",
                        "New Settlement Rd near Banyan St",
                        "Mackenzie Ave near MacDonald Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Old Gympie Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Hickory Dr near Banyan St",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Young Rd near Harris Ave hail 'n' ride",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Forest Ridge Dr near Waterway Cr hail 'n' ride",
                        "Forest Ridge Dr near Rokeby St hail 'n' ride",
                        "Forest Ridge Dr near Needletail Ct hail 'n' ride",
                        "Forest Ridge Dr near Friarbird Dr hail 'n' ride",
                        "Rifle Range Rd near Florence Ct hail 'n' ride",
                        "Rifle Range Rd near Lily Mac Ct hail 'n' ride",
                        "Pioneer Dr near Harry Mac Ct hail 'n' ride",
                        "Pioneer Dr near Oakey Flat Rd hail 'n' ride",
                        "Sauvignon Dr near Williamson Rd hail 'n' ride",
                        "Oakey Flat Rd near Bridges Rd hail 'n' ride",
                        "Bridges Rd near Trail Rd hail 'n' ride",
                        "Pitt Rd near Henderson Rd hail 'n' ride"
                    ],
                    "7044: Narangba Station, Narangba Valley High": [
                        "Golden Wattle Dr at Narangba Valley High",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Oakey Flat Rd at BP Narangba hail 'n' ride",
                        "Oakey Flat Rd near Duncombe Dr",
                        "Oakey Flat Rd near Stark Dr",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd at Windemere Avenue",
                        "Narangba station",
                        "Carmichael College",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Hunt Rd near Cedar Dr hail 'n' ride",
                        "Cedar Dr near Watergum St hail 'n' ride",
                        "Mcloughlin Rd near Range View Rd hail 'n' ride",
                        "Rangeview Rd near Petersen Rd hail 'n' ride",
                        "Petersen Rd near J Dobson Rd hail 'n' ride",
                        "Minimbah State School",
                        "Glenwood Dr near Avondale St",
                        "Morayfield Rd at Paradise Rd"
                    ],
                    "7045: Morayfield Station, Burpengary Primary, NVSHS": [
                        "Morayfield station",
                        "Glenwood Dr near Avondale St",
                        "Glenwood Dr near Glenmay Ct",
                        "Graham Rd at Hargrave Street",
                        "Graham Rd near Parer Cr hail 'n' ride",
                        "Lindsay Rd near Clark Rd hail 'n' ride",
                        "Hunt Rd near Cedar Dr hail 'n' ride",
                        "Cedar Dr near Watergum St hail 'n' ride",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Burpengary Meadows Primary",
                        "Rowley Rd near Belford Dr hail 'n' ride",
                        "Pitt Rd near Pendula Dr hail 'n' ride",
                        "Pitt Rd near Claudia St hail 'n' ride",
                        "Pitt Rd near Henderson Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Burpengary State Secondary College",
                        "Wain Rd near Rosehill Dr hail 'n' ride",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Narangba Valley State High School",
                        "Young Rd at Cottonwood Street",
                        "Rowley Rd near Hauton Road hail 'n' ride",
                        "Morayfield Rd near Lindsay Rd hail 'n' ride",
                        "Graham Rd near Parer Cr",
                        "Glenwood Dr near Cotswold St"
                    ],
                    "7046: Burpengary, St Eugenes, Burpengary State": [
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Foxwood Dr hail 'n' ride",
                        "Uhlmann Rd near Fleet St hail 'n' ride",
                        "High Rd near Hastings Ct hail 'n' ride",
                        "Dunbar Rd near Montrose Ct hail 'n' ride",
                        "Fleet St near Dunbar Rd hail 'n' ride",
                        "Farry Rd near Cobb Rd hail 'n' ride",
                        "Moreton Bay Bvd near Sunday Ct hail 'n' ride",
                        "Buckley Rd near Cobb Rd hail 'n' ride",
                        "Morayfield Rd at Burpengary Pine Village",
                        "St Eugene Catholic Primary School",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Station Rd at Burpengary State School",
                        "Pitt Rd near Pendula Dr hail 'n' ride",
                        "Pitt Rd near Claudia St hail 'n' ride",
                        "Pitt Rd near Henderson Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Morayfield Rd near Ogilvy Rd hail 'n' ride",
                        "High Rd near Dover Ct"
                    ],
                    "7047: Caboolture, Morayfield, Northpine College": [
                        "Caboolture River Rd near Lorebury Dr",
                        "Torrens Rd near Grant Rd",
                        "Torrens Rd near Dorset Dr",
                        "Bellmere Rd at Bellmere Shops hail 'n' ride",
                        "King St at Caboolture Swimming Pool",
                        "King St at Maple Lane",
                        "King St at Arthur Street",
                        "King St at Caboolture RSL Care",
                        "Hasking St near Beerburrum Rd",
                        "Morayfield Rd at John Street",
                        "Morayfield Rd at Caboolture River Road",
                        "Glenwood Dr near Avondale St",
                        "Glenwood Dr near Glenmay Ct",
                        "Graham Rd at Hargrave Street",
                        "Graham Rd near Parer Cr hail 'n' ride",
                        "Lindsay Rd near Clark Rd hail 'n' ride",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Hauton Rd near Hunt Rd hail 'n' ride",
                        "Hunt Rd near Blackbutt Ct hail 'n' ride",
                        "Obrien Rd near Lindsay Rd hail 'n' ride",
                        "Station Rd at Burpengary State School",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Henderson Rd near Landini Ct hail 'n' ride",
                        "Rosehill Dr near Wain Rd hail 'n' ride",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "Mackenzie Ave near MacDonald Dr hail 'n' ride",
                        "Burpengary Rd near Osborne Dr hail 'n' ride",
                        "Osborne Dr near Burpengary Rd hail 'n' ride",
                        "Osborne Dr near Leonard Ct hail 'n' ride",
                        "Morgan Rd near Valentine Ct hail 'n' ride",
                        "Tadorna St near Grazier St hail 'n' ride",
                        "Callaghan Rd near Kassandra Ct hail 'n' ride",
                        "Burpengary Rd near Mackie Rd hail 'n' ride",
                        "Mackie Rd at Hall Road",
                        "Mackie Rd near Hall Rd",
                        "Mackie Rd near Ferrier Rd",
                        "Old Gympie Rd near Frawley Ave hail 'n' ride",
                        "Old Gympie Rd near Boundary Rd hail 'n' ride",
                        "Northpine Adventist College",
                        "Mackie Rd near Ryder Ct",
                        "Mackie Rd near Burpengary Rd hail 'n' ride",
                        "Henderson Rd near Corelli Ct hail 'n' ride",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Hunt Rd near Cedar Dr hail 'n' ride",
                        "Morayfield Rd near Lindsay Rd hail 'n' ride",
                        "Graham Rd near Parer Cr",
                        "Glenwood Dr near Cotswold St",
                        "Caboolture River Rd at Kenneth Street"
                    ],
                    "7048: Caboolture, NVSHS, Northpine College": [
                        "Moreton Bay Bvd near Sunday Ct hail 'n' ride",
                        "Buckley Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd at Burpengary East Shopping Centre hail 'n' ride",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Anderson Rd near Keeley St hail 'n' ride",
                        "Braheem Street near Keeley St",
                        "Ridgegarden Drive near Jarad Street",
                        "Oakey Flat Rd near Nairn Rd hail 'n' ride",
                        "Homestead Rd near Woodsmoke Ct hail 'n' ride",
                        "Excelsior Dr near Sauvignon Dr hail 'n' ride",
                        "Sauvignon Dr near Excelsior Dr hail 'n' ride",
                        "Sauvignon Dr near Willamson Rd hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Oakey Flat Rd near Facer Rd hail 'n' ride",
                        "Carmichael College",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Sovereign Dr near Champion Cct hail 'n' ride",
                        "Sovereign Dr near Grace Cr hail 'n' ride",
                        "Sovereign Dr near Superb Cr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Young Rd at Ridge View Drive",
                        "New Settlement Rd near Oakley Flat Rd HnR",
                        "Rifle Range Rd near Florence Ct hail 'n' ride",
                        "Rifle Range Rd near Lily Mac Ct hail 'n' ride",
                        "Pioneer Dr near Harry Mac Ct hail 'n' ride",
                        "Pioneer Dr near Oakey Flat Rd hail 'n' ride",
                        "Oakey Flat Rd near Duncombe Dr",
                        "Oakey Flat Rd near Stark Dr",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd at Windemere Avenue",
                        "Narangba station",
                        "Burpengary Rd at Narangba Hall hail 'n' ride",
                        "Boundary Rd near Burpengary Rd hail 'n' ride",
                        "Boundary Rd near Clearview Ct hail 'n' ride",
                        "Endeavour Bvd near Oxley St",
                        "Endeavour Bvd near Kerr Rd East",
                        "Endeavour Bvd near Bergin St",
                        "North Lakes station, platform 2",
                        "Plantation Rd at Balstrup Road",
                        "Northpine Adventist College",
                        "Plantation Rd at Kerr Road",
                        "Main St near Narangba station",
                        "Oakey Flat Rd near Main St",
                        "Oakey Flat Rd near Dorothy St",
                        "Oakey Flat Rd near Pioneer Rd",
                        "Pioneer Dr near Oakey Flat Dr",
                        "Pioneer Dr near Eliza Ct",
                        "Pioneer Dr near Harry Mac Ct",
                        "Rifle Range Rd near Lilly Mac Ct",
                        "Rifle Range Rd near Florence Ct",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Young Rd near Harris Ave hail 'n' ride",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Sauvignon Dr near Williamson Rd hail 'n' ride",
                        "Morayfield Rd near Lindsay Rd hail 'n' ride",
                        "Morayfield Rd at Paradise Rd"
                    ],
                    "7050: Burpengary, Clontarf High, Redcliffe": [
                        "Eastern Service Rd at Creek Road",
                        "Deception Bay Rd at Eastern Service Rd",
                        "Deception Bay Rd at Zammit Street",
                        "Zammit St near Monarch Dr hail 'n' ride",
                        "Eveshan Rd near Zammit St hail 'n' ride",
                        "Claverton Dr near Aberfoyle Dr hail 'n' ride",
                        "Warroo Dr near Headland Pl hail 'n' ride",
                        "Bucknor Dr near Kerwalli St",
                        "Park Rd near Deception Bay Rd",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay bus station",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Elizabeth Ave at Grimley Street",
                        "Elizabeth Ave at Korsch Street",
                        "Isobel St near Weaber St",
                        "Park Rd near Stamp St hail 'n' ride",
                        "Bucknor Dr near Kerwalli St hail 'n' ride",
                        "Old Bay Rd near Warroo Dr",
                        "Claverton Dr near Aberfoyle Dr",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd at Wayper Way"
                    ],
                    "7051: Burpengary, Narangba Valley State High": [
                        "Station Rd at Burpengary State School",
                        "Burpengary station",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Henderson Rd near Landini Ct hail 'n' ride",
                        "Pitt Rd at Claudia St",
                        "Pitt Rd at Pendula Drive",
                        "Callaghan Rd near Kassandra Ct hail 'n' ride",
                        "Tadorna St near Grazier St hail 'n' ride",
                        "Morgan Rd near Valentine Ct hail 'n' ride",
                        "Osborne Dr near Leonard Ct hail 'n' ride",
                        "Burpengary Rd near Osborne Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Narangba Valley State High School",
                        "Narangba Valley Primary School",
                        "Burpengary Meadows Primary",
                        "Rowley Rd near Hauton Road hail 'n' ride",
                        "Rowley Rd near Belford Dr hail 'n' ride",
                        "Station Rd near Hewson St",
                        "Station Rd near David St",
                        "St Eugene Catholic Primary School",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Rosehill Dr near Wain Rd hail 'n' ride",
                        "Tontonan Dr near Marscay Ct hail 'n' ride",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "Mackenzie Ave near MacDonald Dr hail 'n' ride",
                        "Osborne Dr near Burpengary Rd hail 'n' ride"
                    ],
                    "7052: Burpengary, Burpengary Secondary College": [
                        "Eastern Service Rd at Creek Road",
                        "Foster Rd near Eastern Service Rd hail 'n' ride",
                        "Foster Rd near Twists Rd hail 'n' ride",
                        "Old Bay Rd opposite Community Hall hail 'n' ride",
                        "Station Road at North Shore Drive",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Station Rd at Burpengary State School",
                        "Burpengary station",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Henderson Rd near Landini Ct hail 'n' ride",
                        "Pitt Rd near Pendula Dr hail 'n' ride",
                        "Pitt Rd near Claudia St hail 'n' ride",
                        "Pitt Rd near Henderson Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Burpengary State Secondary College",
                        "Pitt Rd near Henderson Rd",
                        "Henderson Rd near Corelli Ct hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Station Rd near Hewson St",
                        "Station Rd near David St",
                        "Old Bay Rd Community Hall hail 'n' ride",
                        "Eastern Services Rd near Creek Rd hail 'n' ride"
                    ],
                    "7053: Deception Bay, Clontarf, Kippa Ring": [
                        "Deception Bay Rd at Zammit Street",
                        "Lipscombe Rd at Leyland Avenue",
                        "Mariner Bvd near Lipscombe St",
                        "Parsons Bvd near Mariner Bvd",
                        "Bundaberg St near Clair Ave",
                        "Phillip Pde near Bundaberg St",
                        "Kate Ave near Moreton Downs Dr",
                        "Government St near Kevin St",
                        "Cross St near Webster Rd hail 'n' ride",
                        "Cross St near Windlass St hail 'n' ride",
                        "Cross St near Coman St hail 'n' ride",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Elizabeth Ave at Grimley Street",
                        "Elizabeth Ave at Korsch Street",
                        "Isobel St near Weaber St",
                        "Grace Lutheran College",
                        "Deception Bay Rd at Zone One hail 'n' ride",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay bus station",
                        "Deception Bay Rd near Moreton Downs Dr HnR",
                        "Deception Bay Rd at Bailey Road",
                        "Park Rd near Stamp St hail 'n' ride",
                        "Bucknor Dr near Kerwalli St hail 'n' ride",
                        "Old Bay Rd near Warroo Dr",
                        "Claverton Dr near Aberfoyle Dr",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd near Zammit St hail 'n' ride",
                        "Deception Bay Rd near Tallowood Dr",
                        "Deception Bay Rd at Wayper Way",
                        "Old Gympie Rd near Ruatoka Ct hail 'n' ride",
                        "Old Gympie Rd near Pitt Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Bellini Rd near Borodin Ct hail 'n' ride",
                        "Bellini Rd near Neri Pl hail 'n' ride",
                        "Bellini Rd near Weber Ct",
                        "Bellini Rd near Northshore Dr",
                        "Burpengary Plaza"
                    ],
                    "7054: Morayfield, Deception Bay, Redcliffe High": [
                        "Station Rd at Burpengary State School",
                        "Station Rd near David St",
                        "Morayfield Rd at Burpengary Pine Village",
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Buckley Rd near Fountain St hail 'n' ride",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Bancroft Tce near Bermuda Ave hail 'n' ride",
                        "Thompson St at Christ The King Primary",
                        "Thompson St near Airlie Ave",
                        "Ewart St near Rayleigh St hail 'n' ride",
                        "Ewart St near Bayview Tce hail 'n' ride",
                        "Bailey Rd near Osborne Tce hail 'n' ride",
                        "Deception Bay bus station",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Klingner Rd at McPherson Street",
                        "Klingner Rd at Marsala Street",
                        "Klingner Rd at Ashmole Road",
                        "Klingner Rd at Pinewood Street",
                        "Scarborough Rd at Klinger Road",
                        "Scarborough Rd at Redcliffe Showgrounds",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Redcliffe State High School",
                        "Klingner Rd at Longland Street",
                        "Klingner Rd at OConnell Street",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Deception Bay Rd at Webster Road",
                        "Maine Tce near Union St",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Ewart St near Raymond Tce",
                        "Ewart St near Thompson St",
                        "Thompson St near Elna Ct",
                        "Buckley Rd near Fountain Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Currant Rd hail 'n' ride",
                        "Station Road at North Shore Drive",
                        "Station Rd at Springfield Drive"
                    ],
                    "7056: Burpengary West, Burpengary Primary, NVSHS": [
                        "Morayfield Rd at Burpengary Pine Village",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Morayfield Rd at Paradise Rd",
                        "Oakey Flat Rd near Ashbrook Dr hail 'n' ride",
                        "Oakey Flat Rd near Nairn Rd hail 'n' ride",
                        "Bridges Rd near Trail Rd hail 'n' ride",
                        "Rivergum Dr near Chestnut Dr hail 'n' ride",
                        "Rivergum Dr near Laurel Dr hail 'n' ride",
                        "Rivergum Dr near Ash Ct hail 'n' ride",
                        "Burpengary Meadows Primary",
                        "Facer Rd near Ironwood Rd hail 'n' ride",
                        "Hawthorn Rd near Facer Rd hail 'n' ride",
                        "Hawthorn Rd near Redgum Dr hail 'n' ride",
                        "Oakey Flat Rd near Facer Rd hail 'n' ride",
                        "Oakey Flat Rd near Young Rd hail 'n' ride",
                        "Young Rd at Golden Wattle Drive",
                        "Narangba Valley State High School",
                        "Golden Wattle Dr at Narangba Valley High",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Oakey Flat Rd near Lakeview Rd hail 'n' ride",
                        "Walkers Rd near Oakey Flat Rd hail 'n' ride",
                        "Morayfield Rd at Supacentre Shopping Centre"
                    ],
                    "7058: Burpengary, Narangba Valley State High": [
                        "Station Road at North Shore Drive",
                        "North Shore Dr near Station Rd",
                        "Bellini Rd near North Shore Dr hail 'n' ride",
                        "Bellini Rd near Weber Ct hail 'n' ride",
                        "Bellini Rd near Neri Place",
                        "Bellini Rd near Ravel St",
                        "Pitt Rd near Henderson Rd",
                        "Rosehill Dr near Tontonan Dr hail 'n' ride",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Banyan St",
                        "Hickory Dr near Banyan St",
                        "Young Rd near Ridge View Dr hail 'n' ride",
                        "Narangba Valley State High School",
                        "Young Rd at Ridge View Drive",
                        "Hickory Dr near Banyan St hail 'n' ride",
                        "Bellini Rd near Borodin Ct hail 'n' ride",
                        "Bellini Rd near Neri Pl hail 'n' ride",
                        "St Eugene Catholic Primary School",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Buckley Rd near Fountain Rd hail 'n' ride",
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Moreton Bay Bvd near Sunday Ct hail 'n' ride",
                        "Fleet St near Eton Ct hail 'n' ride",
                        "High Rd near Hastings Ct hail 'n' ride",
                        "Fleet St near Uhlmann Rd hail 'n' ride",
                        "Uhlmann Rd near Fleet St hail 'n' ride",
                        "Uhlmann Rd near Currant Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride"
                    ],
                    "7059: Morayfield, Burpengary, Narangba Valley": [
                        "Old Bay Rd Community Hall hail 'n' ride",
                        "Lakewood Dr near Camphor Ct hail 'n' ride",
                        "Lakewood Dr near Silverdale Ct hail 'n' ride",
                        "Randwick Dr near Ryloch Ct hail 'n' ride",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Narangba Valley State High School",
                        "Young Rd at Ridge View Drive",
                        "Young Rd at Cottonwood Street",
                        "New Settlement Rd near Banyan St",
                        "New Settlement Rd near Burpengary Rd hail 'n' ride",
                        "New Settlement Rd near Sir Dapper Dr hail 'n' ride",
                        "New Settlement Rd near Old Gympie Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Callaghan Rd near Kassandra Ct hail 'n' ride",
                        "Tadorna St near Grazier St hail 'n' ride",
                        "Morgan Rd near Valentine Ct hail 'n' ride",
                        "Osborne Dr near Leonard Ct hail 'n' ride",
                        "Burpengary Rd near Osborne Dr hail 'n' ride",
                        "Pitt Rd near Pendula Dr hail 'n' ride",
                        "Pitt Rd near Claudia St hail 'n' ride",
                        "Henderson Rd near Corelli Ct hail 'n' ride",
                        "Bellini Rd near Weber Ct",
                        "Bellini Rd near Northshore Dr",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Burpengary station",
                        "Station Rd at Burpengary State School",
                        "Station Rd near Hewson St",
                        "Station Rd near David St",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Old Bay Rd opposite Community Hall hail 'n' ride"
                    ],
                    "7060: Deception Bay, St Euguene, Burpengary": [
                        "Eastern Service Rd at Creek Road",
                        "Foster Rd near Eastern Service Rd hail 'n' ride",
                        "Foster Rd near Twists Rd hail 'n' ride",
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Bancroft Tce near Bermuda Ave hail 'n' ride",
                        "Bancroft Tce near Moore St",
                        "Thompson St at Christ The King Primary",
                        "Thompson St near Elna Ct",
                        "Old Bay Rd at Deception Bay North Primary",
                        "Bailey Rd near Osborne Tce hail 'n' ride",
                        "Deception Bay Rd at Bailey Road",
                        "Phillip Pde near Bundaberg St",
                        "Bundaberg St near Clair Ave",
                        "Parsons Bvd near Cairns Cr",
                        "Mariner Bvd near Parsons Bvd",
                        "Lipscombe Rd at Leyland Avenue",
                        "Deception Bay Rd at Tallagon Court",
                        "Warroo Dr near Kippah St",
                        "Old Bay Rd near Warroo Dr",
                        "Claverton Dr near Aberfoyle Dr",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd near Zammit St hail 'n' ride",
                        "Deception Bay Rd at Wayper Way",
                        "Old Gympie Rd near Ruatoka Ct hail 'n' ride",
                        "Old Gympie Rd near Pitt Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Bellini Rd near Borodin Ct hail 'n' ride",
                        "Bellini Rd near Neri Pl hail 'n' ride",
                        "Henderson Rd near Symphony Crt hail 'n' ride",
                        "Henderson Rd near Findlay St hail 'n' ride",
                        "Burpengary station",
                        "Station Rd at Burpengary State School",
                        "Station Rd near Hewson St",
                        "Station Rd near David St",
                        "St Eugene Catholic Primary School",
                        "Station Rd at Springfield Drive",
                        "Station Rd near George St",
                        "Henderson Rd near Findlay St",
                        "Henderson Rd at Symphony Crescent",
                        "Bellini Rd near Neri Place",
                        "Bellini Rd near Ravel St",
                        "Deception Bay Rd at Eastern Service Rd",
                        "Deception Bay Rd near Tallowood Dr",
                        "Deception Bay Rd at Zammit Street",
                        "Zammit St near Monarch Dr hail 'n' ride",
                        "Eveshan Rd near Zammit St hail 'n' ride",
                        "Claverton Dr near Aberfoyle Dr hail 'n' ride",
                        "Warroo Dr near Headland Pl hail 'n' ride",
                        "Warroo Dr near Kippah St hail 'n' ride",
                        "Mariner Bvd near Lipscombe St",
                        "Parsons Bvd near Mariner Bvd",
                        "Deception Bay bus station",
                        "Maine Tce near Union St",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Bancroft Tce near Rainbow St hail 'n' ride",
                        "Eastern Services Rd near Creek Rd hail 'n' ride"
                    ],
                    "7062: Burpengary, Clontarf, Kippa Ring": [
                        "New Settlement Rd near Oakley Flat Rd",
                        "Rifle Range Rd near Florence Ct hail 'n' ride",
                        "Rifle Range Rd near Lily Mac Ct hail 'n' ride",
                        "Pioneer Dr near Harry Mac Ct hail 'n' ride",
                        "Pioneer Dr near Oakey Flat Rd hail 'n' ride",
                        "Oakey Flat Rd near Duncombe Dr",
                        "Oakey Flat Rd near Stark Dr",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd at Windemere Avenue",
                        "Narangba station",
                        "Boundary Rd near Burpengary Rd hail 'n' ride",
                        "Boundary Rd near Clearview Ct hail 'n' ride",
                        "Boundary Rd at Narangba Depot",
                        "Boundary Rd near Business Dr hail 'n' ride",
                        "Lipscombe Rd near North Ridge Cct",
                        "North Ridge Cct near Lazzarini Pl",
                        "Lipscombe Rd near Mariner Bvd",
                        "Lipscombe Rd at Leyland Avenue",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay Rd at Deception Bay Shops",
                        "Deception Bay bus station",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Morris Rd near Gynther Rd",
                        "Morris Rd near Melaleuca Cr",
                        "Morris Rd near Lynanda Ct",
                        "Wattle Rd near Oakmont St hail 'n' ride",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Elizabeth Ave at Grimley Street",
                        "Elizabeth Ave at Korsch Street",
                        "Isobel St near Weaber St",
                        "Maine Rd near Tainton St",
                        "Maine Rd near Gerald Ave",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Elizabeth Ave near Handsworth St",
                        "Elizabeth Ave near Roland St",
                        "Elizabeth Ave at Clontarf Primary School",
                        "Elizabeth Ave near Cornelius St",
                        "Elizabeth Ave near Alice St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Morris Rd at Lynanda Court",
                        "Morris Rd at Bertie Dow Park",
                        "Morris Rd at Cambridge Street",
                        "Deception Bay Rd near Moreton Downs Dr HnR",
                        "Burpengary Rd at Narangba Hall hail 'n' ride",
                        "Main St near Narangba station",
                        "Oakey Flat Rd near Main St",
                        "Oakey Flat Rd near Dorothy St",
                        "Oakey Flat Rd near Pioneer Rd",
                        "Pioneer Dr near Oakey Flat Dr",
                        "Pioneer Dr near Eliza Ct",
                        "Pioneer Dr near Harry Mac Ct",
                        "Rifle Range Rd near Lilly Mac Ct",
                        "Rifle Range Rd near Florence Ct",
                        "New Settlement Rd near Oakley Flat Rd HnR"
                    ],
                    "7063: Caboolture, Deception Bay, Aust Tech College": [
                        "Caboolture station, stop B",
                        "Morayfield Rd at John Street",
                        "Morayfield Shops bus station, platform 2",
                        "Morayfield Rd at Caboolture River Road",
                        "Morayfield Rd at Oakey Flat Road",
                        "Morayfield Rd near Lindsay Rd hail 'n' ride",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Morayfield Rd near Ogilvy Rd hail 'n' ride",
                        "Morayfield Rd at Burpengary Pine Village",
                        "Station Road at North Shore Drive",
                        "Burpengary Plaza",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Eastern Service Rd at Creek Road",
                        "Deception Bay Rd at Eastern Service Rd",
                        "Deception Bay Rd at Zammit Street",
                        "Deception Bay Rd at Krause Street",
                        "Deception Bay Rd at Tallagon Court",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay Rd at Deception Bay Shops",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Boardman Rd near Griffith Rd hail 'n' ride",
                        "Griffith Rd at Volunteer Street",
                        "Griffith Rd at Newport Marina",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Southern Cross College",
                        "Sunnyside Rd at Central Avenue",
                        "Sunnyside Rd at Fernlea Avenue",
                        "Endeavour Esp at Dolphin Street",
                        "Newport Dr near Southern Cross Dr",
                        "Newport Drive near Griffith Rd",
                        "Boardman Rd at Arcadia Crescent",
                        "Klingner Rd near Brunel St",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Deception Bay Rd at Zone One hail 'n' ride",
                        "Deception Bay Rd near Moreton Downs Dr HnR",
                        "Deception Bay Rd near Zammit St hail 'n' ride",
                        "Deception Bay Rd near Tallowood Dr",
                        "Deception Bay Rd at Wayper Way",
                        "North Shore Dr near Station Rd",
                        "Morayfield Rd at Lindsay Road",
                        "Morayfield Rd at Supacentre Shopping Centre",
                        "Morayfield Rd at Domnick Street"
                    ],
                    "7064: Deception Bay High, Hercules Road": [
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Buckley Rd near Fountain St hail 'n' ride",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Randwick Dr near Ryloch Ct hail 'n' ride",
                        "Lakewood Dr near Silverdale Ct hail 'n' ride",
                        "Lakewood Dr near Camphor Ct hail 'n' ride",
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Bancroft Tce near Bermuda Ave hail 'n' ride",
                        "Bancroft Tce near Moore St",
                        "Thompson St near Elna Ct",
                        "Old Bay Rd near Warroo Dr",
                        "Claverton Dr near Aberfoyle Dr",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd at Krause Street",
                        "Warroo Dr near Kippah St",
                        "Bucknor Dr near Kerwalli St",
                        "Park Rd near Murray Dr hail 'n' ride",
                        "Bayview Tce near Raymond Tce hail 'n' ride",
                        "Bailey Rd near Osborne Tce hail 'n' ride",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay Rd at Deception Bay Shops",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay High School",
                        "Cross St near Webster Rd hail 'n' ride",
                        "Cross St near Windlass St hail 'n' ride",
                        "Cross St near Coman St hail 'n' ride",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Deception Bay Rd at Zone One hail 'n' ride",
                        "Cross St near Sirene Crt hail 'n' ride",
                        "Webster Rd near Deception Bay Rd hail 'n' ride",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Bucknor Dr near Kerwalli St hail 'n' ride",
                        "Thompson St at Christ The King Primary",
                        "Bancroft Tce near Rainbow St hail 'n' ride",
                        "Buckley Rd near Fountain Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Currant Rd hail 'n' ride"
                    ],
                    "7065: Petrie, Petrie State, Pine Rivers High": [
                        "Torrens Rd near Narangba Rd hail 'n' ride",
                        "Beeville Rd near Mona Vale Way",
                        "Washbrook Crt near Valmadre Ct hail 'n' ride",
                        "Washbrook Crt near Mohr Ct hail 'n' ride",
                        "Affleck Ave at Homestead Place",
                        "D'Aguilar St near Ruby Cr hail 'n' ride",
                        "Dayboro Rd near Tandoor Dr",
                        "Dayboro Rd near Baldwin St",
                        "Gympie Rd at Station Road",
                        "Gympie Rd at Pine Rivers Special School",
                        "Gympie Rd at Eddie Hyland Park",
                        "Gympie Rd at Paisley Drive",
                        "Gympie Rd at Paisley Park",
                        "Buckby St at Pine Rivers High School",
                        "Bells Pocket Rd near Bateman St",
                        "Bells Pocket Rd near Dobson Dr hail 'n' ride",
                        "Lawnton Pocket Rd near Paisley Dr",
                        "Dayboro Rd near Joora Ave",
                        "Beeville Rd at Frenchs Rd",
                        "Mackie Rd opp Bowls Club hail 'n' ride"
                    ],
                    "7066: Deception Bay, Rothwell, Redcliffe High": [
                        "Morayfield Rd at Burpengary Pine Village",
                        "Buckley Rd near Fountain St hail 'n' ride",
                        "Eastern Service Rd at Creek Road",
                        "Deception Bay Rd at Eastern Service Rd",
                        "Deception Bay Rd at Zammit Street",
                        "Deception Bay Rd at Krause Street",
                        "Deception Bay Rd at Tallagon Court",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay Rd at Deception Bay Shops",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Morris Road",
                        "Gynther Road",
                        "Mewes Road",
                        "Wattle Road",
                        "Nathan Road",
                        "Anzac Ave at Mandin St",
                        "Peninsula Fair, stop B",
                        "Anzac Ave at Lindel Street",
                        "Anzac Ave at Ashmole Road",
                        "Anzac Avenue near Recreation St",
                        "Anzac Ave at Redcliffe Hospital",
                        "Oxley Ave at State Emergency Service",
                        "Oxley Ave at Redcliffe Showgrounds",
                        "Oxley Ave at Redcliffe State High School",
                        "Redcliffe State High School",
                        "Oxley Ave at Redcliffe Cultural Centre",
                        "Peninsula Fair, stop C",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Deception Bay Rd at Zone One hail 'n' ride",
                        "Deception Bay bus station",
                        "Maine Tce near Union St",
                        "Deception Bay Rd near Moreton Downs Dr HnR",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Ewart St near Raymond Tce",
                        "Ewart St near Thompson St",
                        "Deception Bay Rd near Zammit St hail 'n' ride",
                        "Thompson St near Elna Ct",
                        "Deception Bay Rd at Wayper Way",
                        "Bancroft Tce near Bermuda Ave hail 'n' ride",
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Buckley Rd near Fountain Rd hail 'n' ride",
                        "Old Bay Rd near Arthur Drewett Rd hail 'n' ride",
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Currant Rd hail 'n' ride"
                    ],
                    "7067: Burpengary, Clontarf, Kippa Ring": [
                        "Isobel St near Weaber St",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Mewes Road",
                        "Gynther Road",
                        "Deception Bay Rd at Zone One hail 'n' ride",
                        "Deception Bay Rd at Morris Road",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Webster Road",
                        "Phillip Pde near Spencer Ave",
                        "Phillip Pde near Bundaberg St",
                        "Bundaberg St near Clair Ave",
                        "Parsons Bvd near Cairns Cr",
                        "Moreton Downs State School",
                        "Mariner Bvd near Parsons Bvd",
                        "Lipscombe Rd near Mariner Bvd",
                        "Lipscombe Rd at Leyland Avenue",
                        "Deception Bay Rd at Tallagon Court",
                        "Deception Bay Rd at Krause Street",
                        "Deception Bay Rd near Zammit St hail 'n' ride",
                        "Deception Bay Rd at Wayper Way",
                        "Old Gympie Rd near Ruatoka Ct hail 'n' ride",
                        "Old Gympie Rd near Pitt Rd hail 'n' ride",
                        "Pitt Rd near Wain Rd hail 'n' ride",
                        "Pitt Rd near Henderson Rd",
                        "Henderson Rd near Corelli Ct hail 'n' ride",
                        "Burpengary Plaza"
                    ],
                    "7069: Deception Bay, St Euguene, Burpengary": [
                        "Grosvenor Tce at Deception Bay State School",
                        "Maine Tce near Union St",
                        "Phillip Pde near Moreton Down Dr",
                        "Deception Bay High School",
                        "Government St near Kate St",
                        "Cross St near Webster Rd hail 'n' ride",
                        "Cross St near Windlass St hail 'n' ride",
                        "Cross St near Coman St hail 'n' ride",
                        "Deception Bay Rd at Higgs Street",
                        "Deception Bay Rd at Webster Road",
                        "Deception Bay Rd at Phillip Parade",
                        "Deception Bay Rd at Bailey Road",
                        "Deception Bay Rd at Tallagon Court",
                        "Deception Bay Rd at Krause Street",
                        "Zammit St near Monarch Dr hail 'n' ride",
                        "Eveshan Rd near Zammit St hail 'n' ride",
                        "Claverton Dr near Aberfoyle Dr hail 'n' ride",
                        "Thompson St at Christ The King Primary",
                        "Bancroft Tce near Rainbow St hail 'n' ride",
                        "Old Bay Rd near Moore Rd hail 'n' ride",
                        "Old Bay Rd opposite Community Hall hail 'n' ride"
                    ],
                    "7111: Oakey Flat Road Morayfield East SS": [
                        "Aireal Cr at Morayfield High School",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Minimbah State School",
                        "Woodrose Road near Trinity Way",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Braheem Street near Keeley St",
                        "Oakey Flat Rd near Ashbrook Dr"
                    ],
                    "7119: Morayfield Primary & High, Minimbah Primary": [
                        "Aireal Cr at Morayfield High School",
                        "Caboolture River Rd at Kenneth Street",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd near Ben St",
                        "Minimbah State School",
                        "Thornbill Dr near Petersen Rd hail 'n' ride",
                        "Macginley Rd near Caboolture River Rd HnR",
                        "Mackney Rd near Morrisby St hail 'n' ride",
                        "Macginley Rd near Chiverton St hail 'n' ride",
                        "Caboolture River Rd near Moorina Rd hail 'n' ride",
                        "Caboolture River Rd near F Lindsay Rd HnR"
                    ],
                    "7121: Minimbah, Morayfield & Morayfield East": [
                        "Aireal Cr at Morayfield High School",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Minimbah State School",
                        "Caboolture River Rd near Dobson Lane hail 'n' ride",
                        "Dobson Lane near Arcadia Street hail 'n' ride",
                        "Sunflower Cres near Thistle St hail 'n' ride",
                        "Pauls Rd near Sunflower Cres hail 'n' ride",
                        "Pauls Road near Olympic Court hail 'n' ride",
                        "Parkridge Ave near Olympic Ct",
                        "Parkridge Ave near Kensington Ct",
                        "Parkridge Ave near Newfarm St",
                        "Walkers Rd near Oakey Flat Rd hail 'n' ride",
                        "Morayfield Rd at Oakey Flat Road"
                    ],
                    "7123: Morayfield, Morayfield East State": [
                        "Aireal Cr at Morayfield High School",
                        "Caboolture River Rd at Kenneth Street",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd near Ben St",
                        "Cresthaven Rd near Crestbrook Dr hail 'n' ride",
                        "Minimbah State School",
                        "Walkers Rd near Bristlebird Dr hail 'n' ride",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Petersen Rd near J Dobson Rd hail 'n' ride",
                        "Petersen Rd near Rangeview Rd hail 'n' ride",
                        "Homestead Rd near Woodsmoke Ct hail 'n' ride",
                        "Excelsior Dr near Sauvignon Dr hail 'n' ride",
                        "Madeline Dr near Donovan Ct hail 'n' ride",
                        "Oakey Flat Rd near Bridges Rd hail 'n' ride",
                        "Oakey Flat Rd near Nairn Rd hail 'n' ride",
                        "Oakey Flat Rd near Lakeview Rd hail 'n' ride",
                        "Ridgegarden Drive near Jarad Street",
                        "Braheem Street near Keeley St",
                        "Keeley Street near Anderson Rd",
                        "Lindsay Rd near Anderson Rd hail 'n' ride"
                    ],
                    "7124: Morayfield State, St Peters, St Columbans": [
                        "Aireal Cr at Morayfield High School",
                        "Morayfield Rd at Oakey Flat Road",
                        "Petersen Rd at Trinity Way hail 'n' ride",
                        "Petersen Rd near Rangeview Rd hail 'n' ride",
                        "Ward Rd near Semilion Ct hail 'n' ride",
                        "Sauvignon Dr near Williamson Rd hail 'n' ride",
                        "Sauvignon Dr near Excelsior Dr hail 'n' ride",
                        "Williamson Rd near Oakey Flat Rd hail 'n' ride",
                        "Rowley Rd near Oakey Flat Rd hail 'n' ride",
                        "Burpengary Meadows Primary"
                    ],
                    "7125: Morayfield, Caboolture, St Columbans": [
                        "Aireal Cr at Morayfield High School",
                        "Glenwood Dr near Avondale St",
                        "Glenwood Dr near Glenmay Ct",
                        "Coach Rd West near Acemia Dr hail 'n' ride",
                        "Evert Ct near Denston St",
                        "Grogan Rd near Laver Rd",
                        "Laver Rd near Emerson Dr",
                        "Graham Rd at Hargrave Street",
                        "Wimbledon Dr near Keneally Ct",
                        "Hargrave St near Sturt St",
                        "Lindsay Rd near Anderson Rd",
                        "Braheem Street near Keeley St",
                        "Ridgegarden Drive near Jarad Street",
                        "Hauton Rd near Blanch Ct hail 'n' ride",
                        "Burpengary Meadows Primary",
                        "Lindsay Rd near Clark Rd hail 'n' ride"
                    ],
                    "7126: Morayfield, Morayfield East State": [
                        "Aireal Cr at Morayfield High School",
                        "North Harbour Bvd hail 'n'ride",
                        "Moreton Bay Bvd near Normanby Cres hail 'n'ride",
                        "Buckley Rd near Moreton Bay Bvd hail 'n' ride",
                        "Buckley Rd near Cameron Rd hail 'n' ride",
                        "Cameron Rd near Currant Rd hail 'n' ride",
                        "Uhlmann Rd near Foxwood Dr hail 'n' ride",
                        "Uhlmann Rd near Fleet St hail 'n' ride",
                        "High Rd near Dover Ct",
                        "High Rd near Hastings Ct hail 'n' ride",
                        "Dunbar Rd near Montrose Ct hail 'n' ride",
                        "Fleet St near Dunbar Rd hail 'n' ride",
                        "Bradford Rd near Linda Gray Ct hail 'n' ride",
                        "Farry Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd near Cobb Rd hail 'n' ride",
                        "Buckley Rd at Burpengary East Shopping Centre hail 'n' ride",
                        "Uhlmann Road near Morayfield Road hail 'n' ride",
                        "Morayfield Rd near Uhlmann Rd hail 'n' ride",
                        "Morayfield Rd at Paradise Rd"
                    ],
                    "7132: Deception Bay State, Moreton Downs": [
                        "Deception Bay High School",
                        "Phillip Pde near Spencer Ave",
                        "Bailey Rd at Flegg Street",
                        "Bailey Rd at Osborne Terrace",
                        "Ewart St near Raymond Tce",
                        "Ewart St near Thompson St",
                        "Thompson St near Elna Ct",
                        "Old Bay Rd near Warroo Dr",
                        "Claverton Dr near Aberfoyle Dr",
                        "Eveshan Rd near Zammit St",
                        "Zammit St near Monarch Dr",
                        "Deception Bay Rd at Krause Street",
                        "Mariner Bvd near Lipscombe St"
                    ],
                    "7141: Narangba Station, Narangba Valley High": [
                        "Golden Wattle Dr at Narangba Valley High",
                        "Young Rd near Golden Wattle Dr hail 'n' ride",
                        "Narangba Valley Primary School",
                        "Forest Ridge Dr near Waterway Cr hail 'n' ride",
                        "Forest Ridge Dr near Rokeby St hail 'n' ride",
                        "Forest Ridge Dr near Needletail Ct hail 'n' ride",
                        "Forest Ridge Dr near Friarbird Dr hail 'n' ride",
                        "Rifle Range Rd near Florence Ct hail 'n' ride",
                        "Rifle Range Rd near Lily Mac Ct hail 'n' ride",
                        "Pioneer Dr near Harry Mac Ct hail 'n' ride",
                        "Pioneer Dr near Oakey Flat Rd hail 'n' ride",
                        "Oakey Flat Rd near Duncombe Dr",
                        "Oakey Flat Rd near Stark Dr",
                        "Oakey Flat Rd near McCullagh Cr",
                        "Oakey Flat Rd at Windemere Avenue",
                        "Narangba station"
                    ],
                    "7153: Deception Bay, Clontarf, Kippa Ring": [
                        "Isobel St near Weaber St",
                        "Maine Rd near Isobel St",
                        "Maine Rd at Beedham Street",
                        "Maine Rd at Heather Street",
                        "Maine Rd near Duffield Rd hail 'n' ride",
                        "Maine Rd at Gardenia Street",
                        "Macdonnell Rd near Maine Rd",
                        "Elizabeth Ave at Korsch Street",
                        "Elizabeth Ave at Grimley Street",
                        "Anzac Ave at Hercules Road Primary School",
                        "Anzac Avenue at Regency Street",
                        "Chelsea Street",
                        "Bremner Road",
                        "Gynther Road",
                        "Deception Bay Rd at Zone One hail 'n' ride",
                        "Deception Bay Rd at Morris Road",
                        "Cross St near Coman St hail 'n' ride",
                        "Cross St near Sirene Crt hail 'n' ride",
                        "Cross St near Webster Rd hail 'n' ride",
                        "Webster Rd near Deception Bay Rd hail 'n' ride",
                        "Government St near Kate St",
                        "Kate Ave near Moreton Downs Dr",
                        "Moreton Downs Dr near Felicity Ct",
                        "Deception Bay Rd at Phillip Parade"
                    ],
                    "7201: Beachmere, Bribie Island State Schools": [
                        "Caboolture Bus Depot",
                        "Beachmere Rd near Ann Maree Dr",
                        "Beachmere Rd at Riversleigh Rd",
                        "James St near Beachmere Rd hail 'n' ride",
                        "James St near Dorunda Ave hail 'n' ride",
                        "Moreton Tce near Hodgson St",
                        "Bryant St near Dwyer St",
                        "Dwyer St near Hodgson St",
                        "Kunde St near Gretel Dr",
                        "Biggs Ave near Huntley St",
                        "Biggs Ave near Second Ave",
                        "First St near Moreton Tce hail 'n' ride",
                        "Bishop Rd near Margaret St",
                        "Bishop Rd near McGregor Tce",
                        "Bishop Rd near Mynott Rd hail 'n' ride",
                        "Bribie Island State School",
                        "Bribie Island High School",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Moreton Tce near Main St",
                        "First St near Short St hail 'n' ride",
                        "Biggs Ave near Kunde St hail 'n' ride",
                        "James St near Lalroy St hail 'n' ride",
                        "Beachmere Primary School",
                        "Beachmere Rd near James Rd",
                        "Beachmere Rd near Bakers Flat Rd hail 'n' ride",
                        "Lee St at Caboolture State High School"
                    ],
                    "7202: Beachmere Primary, Caboolture High": [
                        "Bribie Island High School",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Dr near Coolgarra Ave",
                        "Bribie Island Rd near Bestmann Rd East",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd at Pinelands Way",
                        "Bribie Island Rd at Aylward Road",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Campbell Pde near Bellay Rd hail 'n' ride",
                        "Campbell Pde near Louise Dr hail 'n' ride",
                        "Campbell Pde near Bishop Rd hail 'n' ride",
                        "Bishop Rd near McGregor Tce",
                        "Moreton Tce near Main St",
                        "Moreton Tce near Second Ave",
                        "Beachmere Primary School",
                        "Beachmere Rd near James Rd",
                        "Beachmere Rd near Bakers Flat Rd hail 'n' ride",
                        "Birali Steiner School",
                        "Beachmere Rd at Riversleigh Rd",
                        "Beachmere Rd near Ann Maree Dr",
                        "Lee St at Caboolture State High School",
                        "Tallon St near Mackay St",
                        "Caboolture station, stop C",
                        "Lawrence Dr near Leishman Rd hail 'n' ride",
                        "James St near Beachmere Rd hail 'n' ride",
                        "Jocelyn St near Beachmere Rd hail 'n' ride",
                        "James St near Dorunda Ave hail 'n' ride",
                        "Moreton Tce near Hodgson St",
                        "Bryant St near Dwyer St",
                        "Dwyer St near Hodgson St",
                        "Kunde St near Gretel Dr",
                        "Biggs Ave near Huntley St",
                        "Biggs Ave near Second Ave",
                        "Main St near Moreton Tce",
                        "Beachmere Rd near Old Becahmere Rd hail 'n' ride",
                        "Bishop Rd near Margaret St",
                        "Bribie Island Rd at Peel Road"
                    ],
                    "7203: Bellmere, Tullawong Schools": [
                        "King St at Caboolture Swimming Pool",
                        "Bellmere Rd near Bishop Lane",
                        "Bells Lane near Bellmere Rd hail 'n' ride",
                        "Bells Lane near Harper Rd hail 'n' ride",
                        "Behrens Rd near Richards Ct hail 'n' ride",
                        "Wade Rd near Behrens Rd hail 'n' ride",
                        "Wade Rd in Bellmere hail 'n' ride",
                        "Thompson Rd near Faye Rd hail 'n' ride",
                        "Belle Air Dr near Riverwood Dr",
                        "Belle Air Dr near Riverpark Crt hail 'n' ride",
                        "Belle Air Dr near Riverside Cct",
                        "Bishop Lane near Bellmere Rd",
                        "Bellemere Rd near River Dr",
                        "King St at Maple Lane",
                        "Watt St near Pearl Cr",
                        "Grace College Caboolture Campus",
                        "Lynfield Dr near Smiths Rd",
                        "Tullawong State High School",
                        "St Pauls Lutheran Primary School",
                        "Tullawong State Primary School",
                        "Smiths Rd near Afton St",
                        "Peggy Rd near Daintree St hail 'n' ride",
                        "Piggott Rd near Daintree St",
                        "Daintree St near Tara Gr hail 'n' ride",
                        "Almond Way near Bellbrook Ave hail 'n' ride",
                        "Hollywood Ave near Swann Rd hail 'n' ride",
                        "Plover Rd near Piggott Rd hail 'n' ride",
                        "Cisticola Ct near Whipbird Ct hail 'n' ride",
                        "Kendall Rd near Whimbrel Ct",
                        "Ulster Dr near Hamyln St",
                        "Bishop Lane near Bellmere Rd hail 'n' ride",
                        "Belle Air Dr near Riverside Cct hail 'n' ride",
                        "Belle Air Dr near Bellmere Rd hail 'n' ride",
                        "178 Jackson Rd Wamuran hail 'n' ride"
                    ],
                    "7204: Caboolture, Elimbah Primary": [
                        "Pumicestone Rd near Pumicestone Rd Park HnR",
                        "Goshawk Ct near Pumicestone Rd hail 'n' ride",
                        "Golden Dr near Platinum Rd hail 'n' ride",
                        "Emu Rd near Urban Rd hail 'n' ride",
                        "Florey St near Anstey Ct hail 'n' ride",
                        "Shaun Pde near Cliff Ct hail 'n' ride",
                        "Leray Rd near Bigmor Dr hail 'n' ride",
                        "Hall Rd near Perima Rd hail 'n' ride",
                        "Hall Rd near Rojan Crt hail 'n' ride",
                        "Mansfield Rd near Glanville Rd hail 'n' ride",
                        "Morris Rd near Aidan Ct hail 'n' ride",
                        "Morris Rd near Hall Rd hail 'n' ride",
                        "Bigmor Dr near Morris Rd hail 'n' ride",
                        "Bigmor Rd near Leray Rd hail 'n' ride",
                        "Bigmor Dr near Sunita Dr hail 'n' ride",
                        "Bigmor Dr near Melmor Crt hail 'n' ride",
                        "Bigmor Dr near Remor Ct hail 'n' ride",
                        "Elimbah Primary School",
                        "Bigmor Dr near Kelmor Ct hail 'n' ride",
                        "Bigmor Dr near Pike Crt hail 'n' ride",
                        "Bigmor Dr near Perima Rd hail 'n' ride",
                        "Pumicestone Rd near Cowie St"
                    ],
                    "7205: Bellmere, Tullawong Pmy & High, St Pauls": [
                        "Tullawong State High School",
                        "Piggott Rd near Daintree St",
                        "Piggott Rd near Hind Ct hail 'n' ride",
                        "Almond Way near Bellbrook Ave hail 'n' ride",
                        "Hollywood Ave near Swann Rd hail 'n' ride",
                        "Bellmere Rd near Stern Rd hail 'n' ride",
                        "178 Jackson Rd Wamuran hail 'n' ride"
                    ],
                    "7206: Caboolture, Elimbah Primary": [
                        "McKean St at Caboolture Hospital",
                        "Lower King St at Charles Street",
                        "Beerburrum Rd near Nursery Rd",
                        "Central Springs Pde near Smiths Rd hail 'n' ride",
                        "Cottonwood Rd near Coneflower St hail 'n' ride",
                        "Craigslea Dr near Heathbrook Ct hail 'n' ride",
                        "Craigslea Dr near Coventry Pl hail 'n' ride",
                        "Porter Rd near Peters Dr hail 'n' ride",
                        "Pumicestone Rd near Argyll St",
                        "Jensen Rd near Winterbrook Ct",
                        "Schofield Cct near Fazey Ct hail 'n' ride",
                        "Schofield Cct near Kerswell St hail 'n' ride",
                        "Van Beelan St near Linwood Ct",
                        "Van Beelen St near Lasek Ct hail 'n' ride",
                        "Male Rd at Herd Street",
                        "Water Fern Dr near Basalt St hail 'n' ride",
                        "Racemosa St near Silica St",
                        "Pumicestone State School",
                        "Elimbah Primary School",
                        "Smith Rd near Kirrang Dr hail 'n' ride",
                        "Markwell Rd near Spring Lane hail 'n' ride",
                        "Glady Ave near Daisy Ave hail 'n' ride",
                        "Floral Dr near Glady Ave hail 'n' ride",
                        "Markwell Rd near Old Gympie Rd hail 'n' ride",
                        "Hammond Rd near Lynanda Ct hail 'n' ride",
                        "Elof Rd near Riccardo St",
                        "Van Beelan St near Hook Ct",
                        "Water Fern Dr near Scribbly Gum Cct",
                        "Pumicestone Rd near Cowie St",
                        "Mckean St near Bradman St hail 'n' ride",
                        "McKean St at St Columbans College",
                        "Central Lakes Dr near St Columbans Ct",
                        "Central Lakes Dr near St Columbans Ct HnR",
                        "Caboolture Bus Depot"
                    ],
                    "7207: Bellmere, Caboolture, Morayfield": [
                        "Caboolture Bus Depot",
                        "Bellmere Rd near Michelle St hail 'n' ride",
                        "Bellemere Rd near River Dr",
                        "Bellmere Rd near Bishop Lane",
                        "178 Jackson Rd Wamuran hail 'n' ride",
                        "Bells Lane near Bellmere Rd hail 'n' ride",
                        "Bells Lane near Harper Rd hail 'n' ride",
                        "Behrens Rd near Richards Ct hail 'n' ride",
                        "Wade Rd near Behrens Rd hail 'n' ride",
                        "Wade Rd in Bellmere hail 'n' ride",
                        "Thompson Rd near Faye Rd hail 'n' ride",
                        "Belle Air Dr near Riverwood Dr",
                        "Belle Air Dr near Riverpark Crt hail 'n' ride",
                        "Belle Air Dr near Riverside Cct",
                        "Bishop Lane near Bellmere Rd",
                        "River Dr at Lotus Ave",
                        "Torrens Rd near Dorset Dr",
                        "Torrens Rd near Grant Rd",
                        "Grant Rd at Julie Drive",
                        "Matthew Flinders Dr near Governor King Dr hail 'n' ride",
                        "Matthew Flinders Dr near Bongaree Ave",
                        "Matthew Flinders Dr near Investigator Dr",
                        "Rosewood St near Waterside Esp hail 'n' ride",
                        "Jeffreys St near Waterside Esplanade hail 'n' ride",
                        "Market Dr near Suter Dr",
                        "George St at Caboolture State School",
                        "St Peter's Primary School",
                        "Lower King St near Charles St hail 'n' ride",
                        "McKean St at St Columbans College",
                        "Lee St at Caboolture State High School",
                        "Manley St at Caboolture East State School",
                        "River Dr at Lotus Avenue",
                        "Bishop Lane near Bellmere Rd hail 'n' ride",
                        "Belle Air Dr near Riverside Cct hail 'n' ride",
                        "Belle Air Dr near Bellmere Rd hail 'n' ride",
                        "Lesley Ave near Jennifer Ct",
                        "King St at Caboolture Swimming Pool"
                    ],
                    "7209: Elimbah, Caboolture High, St Columbans": [
                        "Bigmor Dr near Morris Rd hail 'n' ride",
                        "Bigmor Dr near Remor Ct hail 'n' ride",
                        "Bigmor Dr near Melmor Crt hail 'n' ride",
                        "Bigmor Dr near Kelmor Ct hail 'n' ride",
                        "Bigmor Dr near Pike Crt hail 'n' ride",
                        "Leray Rd near Bigmor Dr hail 'n' ride",
                        "Bigmor Dr near Perima Rd hail 'n' ride",
                        "Hall Rd near Perima Rd hail 'n' ride",
                        "Hall Rd near Rojan Crt hail 'n' ride",
                        "Mansfield Rd near Glanville Rd hail 'n' ride",
                        "Morris Rd near Aidan Ct hail 'n' ride",
                        "Morris Rd near Hall Rd hail 'n' ride",
                        "Goshawk Ct near Pumicestone Rd hail 'n' ride",
                        "Pumicestone Rd near Cowie St",
                        "George St at Caboolture State School",
                        "Beerburrum Rd near Nursery Rd",
                        "Mckean St near Bradman St hail 'n' ride",
                        "McKean St at St Columbans College",
                        "Lee St at Caboolture State High School",
                        "Beerburrum Road near Shell St hail 'n' ride",
                        "Pumicestone State School",
                        "Reserve Dr near Riverlilly Cres hail 'n' ride",
                        "Morris Rd near Bigmor Dr hail 'n' ride",
                        "Delisser Ave near The Esplanade hail 'n' ride",
                        "First Ave near The Esplanade hail 'n' ride",
                        "Pumicestone Rd at Freeman Rd hail 'n' ride"
                    ],
                    "7210: Toorbul, Caboolture, Tullawong": [
                        "Pumicestone Rd near Elimbah Ave hail 'n' ride",
                        "Pumicestone Rd near Kleise St hail 'n' ride",
                        "Pumicestone Rd near Perry Rd hail 'n' ride",
                        "Pumicestone Rd at Freeman Rd hail 'n' ride",
                        "Delisser Ave near The Esplanade hail 'n' ride",
                        "Carnegie St near The Crescent hail 'n' ride",
                        "Freeman Rd near The Esplanade hail 'n' ride",
                        "Summerfields Dr near Twilight Ct",
                        "McKean St at Caboolture Hospital",
                        "Manley St at Caboolture East State School",
                        "Tallon St at Caboolture TAFE/UniSC",
                        "Tallon St near Mackay St",
                        "Wallace St Nth near Carseldine St",
                        "St Peter's Primary School",
                        "George St at Caboolture State School",
                        "George St near Toohey St",
                        "Lynfield Dr near Smiths Rd",
                        "Tullawong State Primary School",
                        "Tullawong State High School",
                        "St Pauls Lutheran Primary School",
                        "King St at Caboolture Swimming Pool",
                        "King St at Maple Lane",
                        "King St at Arthur Street",
                        "King St at Caboolture RSL Care",
                        "Beerburrum Rd near Nursery Rd",
                        "McKean St at St Columbans College"
                    ],
                    "7211: Toorbul, Caboolture High, St Columbans": [
                        "Pumicestone State School",
                        "Male Rd near Wild Horse Rd hail 'n' ride",
                        "Water Fern Dr near Basalt St hail 'n' ride",
                        "Water Fern Dr near Scribbly Gum Cct",
                        "Scribbly Gum Cct near White Ash Ct hail 'n' ride",
                        "Racemosa St near Silica St",
                        "Pumicestone Rd near Cowie St",
                        "Pumicestone Rd near D'Aguilar Hwy",
                        "Mckean St near Bradman St hail 'n' ride",
                        "Lee St at Caboolture State High School",
                        "Scribbly Gum Cct near Water Fern Dr hail 'n' ride",
                        "Reserve Dr near Riverlilly Cres hail 'n' ride",
                        "Pumicestone Rd near Elimbah Ave hail 'n' ride",
                        "Pumicestone Rd near Kleise St hail 'n' ride",
                        "Pumicestone Rd near Perry Rd hail 'n' ride",
                        "Pumicestone Rd at Freeman Rd hail 'n' ride",
                        "Delisser Ave near The Esplanade hail 'n' ride",
                        "Carnegie St near The Crescent hail 'n' ride",
                        "Freeman Rd near The Esplanade hail 'n' ride"
                    ],
                    "7213: Elimbah, Caboolture, St Columbans": [
                        "Pumicestone Rd near Pumicestone Rd Park HnR",
                        "Flowers Rd near Dot Newman Ct hail 'n' ride",
                        "Golden Dr near Platinum Rd hail 'n' ride",
                        "Emu Rd near Urban Rd hail 'n' ride",
                        "Shaun Pde near Cliff Ct hail 'n' ride",
                        "Florey St near Anstey Ct hail 'n' ride",
                        "Emu Rd near Hamilton Rd hail 'n' ride",
                        "Dances Rd near Cottrill Rd hail 'n' ride",
                        "Victoria St near Anastasia Ct hail 'n' ride",
                        "Pumicestone State School",
                        "Pumicestone Rd near Cowie St",
                        "Mckean St near Bradman St hail 'n' ride",
                        "McKean St at St Columbans College",
                        "Manley St at Caboolture East State School",
                        "Lee St at Caboolture State High School",
                        "Lower King St at Charles Street",
                        "Caboolture Square Shopping Centre",
                        "George St at Caboolture State School"
                    ],
                    "7214: Caboolture Pmy, Caboolture East, StPeters": [
                        "Caboolture Bus Depot",
                        "Pumicestone Rd near Pumicestone Rd Park HnR",
                        "Goshawk Ct near Pumicestone Rd hail 'n' ride",
                        "Golden Dr near Platinum Rd hail 'n' ride",
                        "Bigmor Dr near Morris Rd hail 'n' ride",
                        "Hall Rd near Perima Rd hail 'n' ride",
                        "Hall Rd near Rojan Crt hail 'n' ride",
                        "Mansfield Rd near Glanville Rd hail 'n' ride",
                        "Morris Rd near Aidan Ct hail 'n' ride",
                        "Morris Rd near Hall Rd hail 'n' ride",
                        "Leray Rd near Bigmor Dr hail 'n' ride",
                        "Bigmor Dr near Melmor Crt hail 'n' ride",
                        "Bigmor Dr near Remor Ct hail 'n' ride",
                        "Bigmor Dr near Kelmor Ct hail 'n' ride",
                        "Bigmor Dr near Pike Crt hail 'n' ride",
                        "Shaun Pde near Cliff Ct hail 'n' ride",
                        "Emu Rd near Hamilton Rd hail 'n' ride",
                        "Dances Rd near Cottrill Rd hail 'n' ride",
                        "Victoria St near Anastasia Ct hail 'n' ride",
                        "Cottrill Rd near Reibelt Dr hail 'n' ride",
                        "Pumicestone State School",
                        "Pumicestone Rd near Cowie St",
                        "St Peter's Primary School",
                        "Caboolture station, stop C",
                        "Beerburrum Rd near Nursery Rd",
                        "Grace College Caboolture Campus",
                        "Tullawong State High School",
                        "St Pauls Lutheran Primary School",
                        "Tullawong State Primary School",
                        "Smiths Rd near Afton St",
                        "Lynfield Dr near Smiths Rd",
                        "George St near Toohey St",
                        "Beerburrum Road near Shell St hail 'n' ride"
                    ],
                    "7216: Caboolture, Tullawong State High": [
                        "Cowie St near Ruby St",
                        "Jensen Rd near Winterbrook Ct",
                        "Balkee Dr near Elof Rd hail 'n' ride",
                        "Schofield Cct near Fazey Ct hail 'n' ride",
                        "Schofield Cct near Kerswell St hail 'n' ride",
                        "Elof Rd near Riccardo St",
                        "Van Beelan St near Linwood Ct",
                        "Van Beelan St near Hook Ct",
                        "Male Rd near Van Beelan St",
                        "Male Rd near Granger St",
                        "Granger St near Elof Rd",
                        "Male Rd near Wild Horse Rd hail 'n' ride",
                        "Male Rd at Herd Street",
                        "Water Fern Dr near Basalt St hail 'n' ride",
                        "Water Fern Dr near Scribbly Gum Cct",
                        "Scribbly Gum Cct near White Ash Ct hail 'n' ride",
                        "Scribbly Gum Cct near Water Fern Dr hail 'n' ride",
                        "Racemosa St near Silica St",
                        "Pumicestone Rd near Cowie St",
                        "Tullawong State High School",
                        "St Pauls Lutheran Primary School",
                        "Tullawong State Primary School",
                        "Smiths Rd near Afton St",
                        "Lynfield Dr near Smiths Rd"
                    ],
                    "7217: Ningi, Beachmere Primary": [
                        "Aylward Rd near Wrenaus Way hail 'n' ride",
                        "Pinelands Way near Relesah Dr hail 'n' ride",
                        "Bribie Island Rd at Pinelands Way",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd near Rebecca Ave",
                        "Ranald Ave near Robert Ave hail 'n' ride",
                        "Ranald Ave near Rebecca Ave hail 'n' ride",
                        "Regina Ave near Ranald Ave hail 'n' ride",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd at Aylward Road",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Bishop Rd near McGregor Tce",
                        "Moreton Tce near Main St",
                        "Moreton Tce near Second Ave",
                        "Beachmere Primary School",
                        "Birali Steiner School",
                        "Jocelyn St near Beachmere Rd hail 'n' ride",
                        "Lawrence Dr near Leishman Rd hail 'n' ride",
                        "Beachmere Rd near Ann Maree Dr",
                        "Lower King St at Charles Street",
                        "Caboolture station, stop C",
                        "Lee St at Lee Street State Special School"
                    ],
                    "7218: Bellmere, Minimbah, Caboolture": [
                        "Caboolture Bus Depot",
                        "King St at Caboolture Swimming Pool",
                        "Bellmere Rd near Michelle St hail 'n' ride",
                        "Bellemere Rd near River Dr",
                        "Bellmere Rd near Bishop Lane",
                        "Belle Air Dr near Riverwood Dr",
                        "Belle Air Dr near Riverside Cct",
                        "Bishop Lane near Bellmere Rd",
                        "River Dr at Lotus Ave",
                        "Torrens Rd near Dorset Dr",
                        "Torrens Rd near Grant Rd",
                        "Grant Rd at Julie Drive",
                        "Matthew Flinders Dr near Governor King Dr hail 'n' ride",
                        "Matthew Flinders Dr near Bongaree Ave",
                        "Matthew Flinders Dr near Investigator Dr",
                        "Mingaye St near Queen St",
                        "Mingaye St near Domnick St",
                        "Torrens Rd near Adelaide Dr",
                        "Michael Ave near Lorebury Dr",
                        "Michael Ave near Adelaide Dr",
                        "Caboolture River Rd at Kenneth Street",
                        "Beacon St near Grant St",
                        "Caboolture River Rd near Maple Dr",
                        "Caboolture River Rd near Dobson Lane hail 'n' ride",
                        "Dobson Lane near Arcadia Street hail 'n' ride",
                        "Sunflower Cres near Thistle St hail 'n' ride",
                        "Pauls Rd near Sunflower Cres hail 'n' ride",
                        "Pauls Road near Olympic Court hail 'n' ride",
                        "Parkridge Ave near Olympic Ct",
                        "Minimbah State School",
                        "Walkers Rd near Minimbah Dr hail 'n' ride",
                        "Cresthaven Dr near Crestwood Ave",
                        "Caboolture River Rd near Ben St",
                        "Caboolture River Rd near Lorebury Dr",
                        "Aireal Cr at Morayfield High School",
                        "Morayfield State School",
                        "Beacon St near Ronald Ct",
                        "Cresthaven Rd near Crestbrook Dr hail 'n' ride",
                        "Beacon St near Caboolture River Rd",
                        "Torrens Rd near Moon St",
                        "Parkridge Ave near Kensington Ct",
                        "River Dr at Lotus Avenue",
                        "Belle Air Dr near Riverside Cct hail 'n' ride",
                        "Belle Air Dr near Bellmere Rd hail 'n' ride"
                    ],
                    "7220: Beachmere, Tullawong, Caboolture": [
                        "Bribie Island Rd at Old Toorbul Point Rd",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Campbell Pde near Bellay Rd hail 'n' ride",
                        "Campbell Pde near Louise Dr hail 'n' ride",
                        "Campbell Pde near Bishop Rd hail 'n' ride",
                        "Bishop Rd near McGregor Tce",
                        "Moreton Tce near Main St",
                        "Lee St at Caboolture State High School",
                        "Beachmere Rd near Ann Maree Dr",
                        "Lawrence Dr near Leishman Rd hail 'n' ride",
                        "Jocelyn St near Beachmere Rd hail 'n' ride",
                        "Beachmere Rd at Riversleigh Rd",
                        "Beachmere Rd near Moreton Tce",
                        "Moreton Tce near Second Ave",
                        "Moreton Tce near Dorunda Ave",
                        "Moreton Tce near Hodgson St",
                        "Bryant St near Dwyer St",
                        "Dwyer St near Hodgson St",
                        "Kunde St near Gretel Dr",
                        "Biggs Ave near Huntley St",
                        "Biggs Ave near Second Ave",
                        "Main St near Moreton Tce"
                    ],
                    "7221: Caboolture, Tullawong, St Pauls, Grace": [
                        "Mahogany Dr near Bottlebrush Ct hail 'n' ride",
                        "Porter Rd near Peters Dr hail 'n' ride",
                        "Craigslea Dr near Heathbrook Ct hail 'n' ride",
                        "Craigslea Dr near Coventry Pl hail 'n' ride",
                        "Old Gympie Rd near Markwell Rd hail 'n' ride",
                        "Markwell Rd near Spring Lane hail 'n' ride",
                        "Cathy Crt near Hidden Gr hail 'n' ride",
                        "Lyndhurst Tce near Jarrahdale Tce hail 'n' ride",
                        "Breadsell Dr near Field Rd hail 'n' ride",
                        "Alcock Rd near Markwell Rd hail 'n' ride",
                        "Alcock Rd near Mcrae Rd hail 'n' ride",
                        "Greening Rd near Hawk St hail 'n' ride",
                        "King St near Sunnymeade Dr hail 'n' ride",
                        "Cottonwood Rd near Coneflower St hail 'n' ride",
                        "Tullawong State High School",
                        "St Pauls Lutheran Primary School",
                        "Tullawong State Primary School",
                        "Grace College Caboolture Campus",
                        "King St at Caboolture Swimming Pool",
                        "George St at Caboolture State School",
                        "Beerburrum Rd near Nursery Rd",
                        "Central Springs Pde near Smiths Rd hail 'n' ride",
                        "Smiths Rd near Cottonwood St hail 'n' ride",
                        "Markwell Rd near Old Gympie Rd hail 'n' ride",
                        "Lesley Ave near King St"
                    ],
                    "7222: Caboolture, Caboolture East Schools": [
                        "King St at Caboolture RSL Care",
                        "King St at Maple Lane",
                        "King St at Caboolture Swimming Pool",
                        "King St at Lesley Avenue",
                        "King St near Sunnymeade Village hail 'n' ride",
                        "Markwell Rd near Cathy Ct hail 'n' ride",
                        "Markwell Rd near Old Gympie Rd hail 'n' ride",
                        "Breadsell Dr near Field Rd hail 'n' ride",
                        "Alcock Rd near Markwell Rd hail 'n' ride",
                        "Alcock Rd near Mcrae Rd hail 'n' ride",
                        "Hammond Rd near Lynanda Ct hail 'n' ride",
                        "Central Springs Pde near Smiths Rd hail 'n' ride",
                        "Smiths Rd near Cottonwood St hail 'n' ride",
                        "Cottonwood Rd near Coneflower St hail 'n' ride",
                        "George St at Caboolture State School",
                        "Beerburrum Rd near Nursery Rd",
                        "McKean St at St Columbans College",
                        "Manley St at Caboolture East State School",
                        "Lee St at Caboolture State High School",
                        "Lower King St at Charles Street",
                        "Watt St near Pearl Cr",
                        "Grace College Caboolture Campus",
                        "Lynfield Dr near Smiths Rd",
                        "Old Gympie Rd near Markwell Rd hail 'n' ride",
                        "Floral Dr near Glady Ave hail 'n' ride",
                        "Greening Rd near Hawk St hail 'n' ride",
                        "King St near Sunnymeade Dr hail 'n' ride",
                        "Lesley Ave near Jennifer Ct",
                        "Lesley Ave near King St"
                    ],
                    "7223: Morayfield, Tullawong Schools, St Pauls": [
                        "Morayfield station",
                        "Caboolture River Rd at Kenneth Street",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd near Ben St",
                        "Grant Rd at Julie Drive",
                        "Matthew Flinders Dr near Governor King Dr hail 'n' ride",
                        "Torrens Rd near Grant Rd",
                        "Torrens Rd near Dorset Dr",
                        "River Dr at Lotus Avenue",
                        "Bellmere Rd at Bellmere Shops hail 'n' ride",
                        "Tullawong State High School",
                        "St Pauls Lutheran Primary School",
                        "Tullawong State Primary School",
                        "Lynfield Dr near Smiths Rd",
                        "Grace College Caboolture Campus",
                        "Smiths Rd near Afton St",
                        "Bellmere Rd near Michelle St hail 'n' ride",
                        "Bellemere Rd near River Dr",
                        "Bellmere Rd near Bishop Lane",
                        "Bellmere State School",
                        "River Dr at Lotus Ave",
                        "Torrens Rd near Moon St",
                        "Mingaye St near Domnick St",
                        "Morayfield Rd at Domnick Street",
                        "Matthew Flinders Dr near Investigator Dr",
                        "Matthew Flinders Dr near Bongaree Ave"
                    ],
                    "7226: Caboolture & East, StPeters, StColumbans": [
                        "Mahogany Dr near Old Gympie Rd hail 'n' ride",
                        "Mahogany Dr near Bottlebrush Ct hail 'n' ride",
                        "Craigslea Dr near Heathbrook Ct hail 'n' ride",
                        "Craigslea Dr near Coventry Pl hail 'n' ride",
                        "Old Gympie Rd near Markwell Rd hail 'n' ride",
                        "Floral Dr near Glady Ave hail 'n' ride",
                        "Markwell Rd near Old Gympie Rd hail 'n' ride",
                        "Lyndhurst Tce near Jarrahdale Tce hail 'n' ride",
                        "Timbergrove Rd near Old Gympie Rd hail 'n' ride",
                        "Kirrang Dr near Smith Rd hail 'n' ride",
                        "Smith Rd near Kirrang Dr hail 'n' ride",
                        "Porter Rd near Beerburrum Rd hail 'n' ride",
                        "Porter Rd near Peters Rd hail 'n' ride",
                        "Caboolture station, stop C",
                        "Beerburrum Rd near Nursery Rd",
                        "McKean St at St Columbans College",
                        "Manley St at Caboolture East State School",
                        "Lee St at Caboolture State High School",
                        "Lower King St at Charles Street",
                        "George St at Caboolture State School",
                        "Pumicestone State School",
                        "Pumicestone Rd near Cowie St",
                        "Central Springs Pde near Smiths Rd hail 'n' ride",
                        "Cottonwood Rd near Coneflower St hail 'n' ride",
                        "Smiths Rd near Afton St",
                        "Summerfields Dr near Twilight Ct",
                        "Morningview Dr near Breeze Ct",
                        "McKean St at Caboolture Hospital",
                        "Hammond Rd near Lynanda Ct hail 'n' ride"
                    ],
                    "7227: Beachmere, Caboolture High": [
                        "Beachmere Primary School",
                        "Beachmere Rd near James Rd",
                        "Beachmere Rd near Bakers Flat Rd hail 'n' ride",
                        "Beachmere Rd at Riversleigh Rd",
                        "Beachmere Rd near Ann Maree Dr",
                        "Lee St at Caboolture State High School",
                        "Lee St at Lee Street State Special School",
                        "McKean St at St Columbans College",
                        "Lawrence Dr near Leishman Rd hail 'n' ride",
                        "Beachmere Rd near Moreton Tce",
                        "Bishop Rd near Margaret St",
                        "Bishop Rd near McGregor Tce",
                        "Campbell Pde near Bellay Rd hail 'n' ride",
                        "Campbell Pde near Louise Dr hail 'n' ride",
                        "Campbell Pde near Bishop Rd hail 'n' ride",
                        "Bishop Rd near Mynott Rd hail 'n' ride",
                        "Bribie Island Rd at Lee Road",
                        "Aylward Rd near Wrenaus Way hail 'n' ride",
                        "Pinelands Way near Relesah Dr hail 'n' ride",
                        "Bribie Island Rd at Pinelands Way",
                        "Bribie Island Rd at Bestmann Road"
                    ],
                    "7228: Beachmere, Caboolture High, St Peters": [
                        "King St at Caboolture Swimming Pool",
                        "Cottonwood Rd near Coneflower St hail 'n' ride",
                        "Lynfield Dr near Smiths Rd",
                        "George St near Toohey St",
                        "Caboolture station, stop C",
                        "Lower King St at Charles Street",
                        "Beachmere Rd near Ann Maree Dr",
                        "Beachmere Rd at Riversleigh Rd",
                        "Birali Steiner School",
                        "Beachmere Rd near Moreton Tce",
                        "Moreton Tce near Main St",
                        "Moreton Tce near Second Ave",
                        "Beachmere Primary School",
                        "Beachmere Rd near James Rd",
                        "Beachmere Rd near Bakers Flat Rd hail 'n' ride",
                        "Jocelyn St near Beachmere Rd hail 'n' ride",
                        "Lawrence Dr near Leishman Rd hail 'n' ride",
                        "McKean St at Caboolture Hospital",
                        "Lee St at Caboolture State High School"
                    ],
                    "7231: Caboolture, Beerburrum, Beerwah High": [
                        "Caboolture Bus Depot",
                        "Caboolture station, stop C",
                        "Beerburrum Rd near Nursery Rd",
                        "Pumicestone State School",
                        "Bigmor Dr near Morris Rd hail 'n' ride",
                        "Hall Rd near Perima Rd hail 'n' ride",
                        "Hall Rd near Rojan Crt hail 'n' ride",
                        "Mansfield Rd near Glanville Rd hail 'n' ride",
                        "Morris Rd near Aidan Ct hail 'n' ride",
                        "Morris Rd near Hall Rd hail 'n' ride",
                        "Bigmor Rd near Leray Rd hail 'n' ride",
                        "Bigmor Dr near Sunita Dr hail 'n' ride",
                        "Bigmor Dr near Melmor Crt hail 'n' ride",
                        "Bigmor Dr near Remor Ct hail 'n' ride",
                        "Elimbah station",
                        "Beerburrum station",
                        "Beerwah High School",
                        "Steve Irwin Way near Tibrogargan Dr",
                        "Bigmor Dr near Kelmor Ct hail 'n' ride",
                        "Bigmor Dr near Pike Crt hail 'n' ride",
                        "Bigmor Dr near Perima Rd hail 'n' ride",
                        "Pumicestone Rd near Cowie St",
                        "Lower King St near Charles St hail 'n' ride"
                    ],
                    "7232: Caboolture High, Caboolture East Primary": [
                        "Cowie St near Ruby St",
                        "Jensen Rd near Winterbrook Ct",
                        "Balkee Dr near Elof Rd hail 'n' ride",
                        "Schofield Cct near Fazey Ct hail 'n' ride",
                        "Schofield Cct near Kerswell St hail 'n' ride",
                        "Elof Rd near Riccardo St",
                        "Van Beelan St near Linwood Ct",
                        "Van Beelan St near Hook Ct",
                        "Male Rd near Van Beelan St",
                        "Male Rd near Granger St",
                        "Granger St near Elof Rd",
                        "Male Rd at Herd Street",
                        "Water Fern Dr near Basalt St hail 'n' ride",
                        "Water Fern Dr near Scribbly Gum Cct",
                        "Scribbly Gum Cct near White Ash Ct hail 'n' ride",
                        "Scribbly Gum Cct near Water Fern Dr hail 'n' ride",
                        "Racemosa St near Silica St",
                        "Pumicestone State School"
                    ],
                    "7234: Tullawong Pmy & High, St Pauls, Bellmere": [
                        "Lower King St at Charles Street",
                        "178 Jackson Rd Wamuran hail 'n' ride",
                        "Bellmere Rd near Stern Rd hail 'n' ride",
                        "Clementine St near Bellmere Rd hail 'n' ride",
                        "Hollywood Ave near Swann Rd hail 'n' ride",
                        "Almond Way near Bellbrook Ave hail 'n' ride",
                        "Peggy Rd near Daintree St hail 'n' ride",
                        "Daintree St near Tara Gr hail 'n' ride",
                        "Plover Rd near Piggott Rd hail 'n' ride",
                        "Cisticola Ct near Whipbird Ct hail 'n' ride",
                        "Kendall Rd near Whimbrel Ct",
                        "Ulster Dr near Hamyln St",
                        "Tullawong State Primary School",
                        "Tullawong State High School",
                        "St Pauls Lutheran Primary School",
                        "Ulster Dr near Kendall Rd",
                        "Piggott Rd near Hind Ct hail 'n' ride",
                        "Belle Air Dr near Riverwood Dr",
                        "Belle Air Dr near Riverpark Crt hail 'n' ride",
                        "Belle Air Dr near Riverside Cct",
                        "Bishop Lane near Bellmere Rd",
                        "Bellmere Rd near Bishop Lane",
                        "Bellmere State School",
                        "Bells Lane near Bellmere Rd hail 'n' ride",
                        "Thompson Rd near Faye Rd hail 'n' ride",
                        "Bells Lane near Harper Rd hail 'n' ride",
                        "Behrens Rd near Richards Ct hail 'n' ride",
                        "Wade Rd near Behrens Rd hail 'n' ride",
                        "Wade Rd in Bellmere hail 'n' ride"
                    ],
                    "7235: Caboolture Pmy, Tullawong, Grace": [
                        "Cowie St near Ruby St",
                        "Jensen Rd near Winterbrook Ct",
                        "Balkee Dr near Elof Rd hail 'n' ride",
                        "Schofield Cct near Fazey Ct hail 'n' ride",
                        "Schofield Cct near Kerswell St hail 'n' ride",
                        "Elof Rd near Riccardo St",
                        "Van Beelan St near Linwood Ct",
                        "Van Beelan St near Hook Ct",
                        "Male Rd near Van Beelan St",
                        "Granger St near Elof Rd",
                        "Male Rd near Wild Horse Rd hail 'n' ride",
                        "Male Rd at Herd Street",
                        "Water Fern Dr near Basalt St hail 'n' ride",
                        "Water Fern Dr near Scribbly Gum Cct",
                        "Scribbly Gum Cct near White Ash Ct hail 'n' ride",
                        "Scribbly Gum Cct near Water Fern Dr hail 'n' ride",
                        "Racemosa St near Silica St",
                        "Reserve Dr near Riverlilly Cres hail 'n' ride",
                        "Pumicestone Rd near Cowie St",
                        "St Peter's Primary School",
                        "George St at Caboolture State School",
                        "Beerburrum Rd near Nursery Rd",
                        "Mckean St near Bradman St hail 'n' ride",
                        "McKean St at St Columbans College",
                        "Manley St at Caboolture East State School",
                        "Beerburrum Road near Shell St hail 'n' ride",
                        "Male Rd near Granger St",
                        "Pumicestone State School"
                    ],
                    "7236: Caboolture, Caboolture High": [
                        "Cowie St near Ruby St",
                        "Jensen Rd near Winterbrook Ct",
                        "Balkee Dr near Elof Rd hail 'n' ride",
                        "Schofield Cct near Fazey Ct hail 'n' ride",
                        "Schofield Cct near Kerswell St hail 'n' ride",
                        "Elof Rd near Riccardo St",
                        "Van Beelan St near Linwood Ct",
                        "Van Beelan St near Hook Ct",
                        "Male Rd near Van Beelan St",
                        "Male Rd near Granger St",
                        "Granger St near Elof Rd",
                        "Elof Rd near Riccardo St hail 'n' ride",
                        "Brown St at Jensen Road",
                        "Pettigrew St at Baptisia Cct",
                        "McKean St at Caboolture Hospital",
                        "Lee St at Caboolture State High School",
                        "Pettigrew St at Caboolture PCYC",
                        "Jensen Rd near Kent St",
                        "Pumicestone Rd near Cowie St"
                    ],
                    "7237: Caboolture, Bellmere": [
                        "St Pauls Lutheran Primary School",
                        "Smiths Rd near Afton St",
                        "River Dr at Lotus Ave",
                        "Torrens Rd near Dorset Dr",
                        "Torrens Rd near Grant Rd",
                        "River Dr at Lotus Avenue",
                        "Piggott Rd near Daintree St",
                        "Peggy Rd near Daintree St hail 'n' ride",
                        "Daintree St near Tara Gr hail 'n' ride",
                        "Almond Way near Bellbrook Ave hail 'n' ride",
                        "Plover Rd near Piggott Rd hail 'n' ride",
                        "Cisticola Ct near Whipbird Ct hail 'n' ride",
                        "Kendall Rd near Whimbrel Ct",
                        "Ulster Dr near Hamyln St",
                        "Bellemere Rd near River Dr",
                        "Bellmere State School",
                        "Clementine St near Bellmere Rd hail 'n' ride",
                        "Hollywood Ave near Swann Rd hail 'n' ride",
                        "Lesley Ave near King St",
                        "King St at Caboolture Swimming Pool",
                        "Lower King St at Charles Street",
                        "Summerfields Dr near Twilight Ct"
                    ],
                    "7240: Elimbah, Pumicestone Rd": [
                        "Pumicestone Rd near Elimbah Ave hail 'n' ride",
                        "Pumicestone Rd at Freeman Rd hail 'n' ride",
                        "Delisser Ave near The Esplanade hail 'n' ride",
                        "Carnegie St near The Crescent hail 'n' ride",
                        "Freeman Rd near The Esplanade hail 'n' ride",
                        "Pumicestone Rd near Perry Rd hail 'n' ride",
                        "Bigmor Dr near Morris Rd hail 'n' ride",
                        "Hall Rd near Rojan Crt hail 'n' ride",
                        "Mansfield Rd near Glanville Rd hail 'n' ride",
                        "Morris Rd near Aidan Ct hail 'n' ride",
                        "Morris Rd near Hall Rd hail 'n' ride",
                        "Leray Rd near Bigmor Dr hail 'n' ride",
                        "Bigmor Dr near Melmor Crt hail 'n' ride",
                        "Bigmor Dr near Remor Ct hail 'n' ride",
                        "Bigmor Dr near Kelmor Ct hail 'n' ride",
                        "Shaun Pde near Cliff Ct hail 'n' ride",
                        "Florey St near Anstey Ct hail 'n' ride",
                        "Golden Dr near Platinum Rd hail 'n' ride",
                        "Flowers Rd near Dot Newman Ct hail 'n' ride",
                        "Pumicestone State School",
                        "Mckean St near Bradman St hail 'n' ride",
                        "Lee St at Caboolture State High School",
                        "Emu Rd near Urban Rd hail 'n' ride",
                        "Bigmor Dr near Perima Rd hail 'n' ride",
                        "Pumicestone Rd near Kleise St hail 'n' ride"
                    ],
                    "7241: Pumicestone Rd School, Caboolture North": [
                        "Pumicestone State School",
                        "Balkee Dr near Elof Rd hail 'n' ride",
                        "Schofield Cct near Fazey Ct hail 'n' ride",
                        "Schofield Cct near Kerswell St hail 'n' ride",
                        "Elof Rd near Riccardo St",
                        "Van Beelan St near Linwood Ct",
                        "Van Beelan St near Hook Ct",
                        "Male Rd near Granger St",
                        "Male Rd near Wild Horse Rd hail 'n' ride",
                        "Water Fern Dr near Basalt St hail 'n' ride",
                        "Scribbly Gum Cct near White Ash Ct hail 'n' ride",
                        "Scribbly Gum Cct near Water Fern Dr hail 'n' ride",
                        "Racemosa St near Silica St",
                        "Pumicestone Rd near Cowie St",
                        "Ruby St near Cowie St hail 'n' ride",
                        "Lee St at Caboolture State High School"
                    ],
                    "7242: Morayfield, Minimbah, Caboolture": [
                        "Aireal Cr at Morayfield High School",
                        "Caboolture River Rd at Kenneth Street",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd near Ben St",
                        "Cresthaven Rd near Crestbrook Dr hail 'n' ride",
                        "Minimbah State School",
                        "Cresthaven Dr near Crestwood Ave",
                        "Torrens Rd near Moon St",
                        "Mingaye St near Domnick St",
                        "Morayfield Rd at Domnick Street",
                        "Caboolture Square Shopping Centre",
                        "George St at Caboolture State School",
                        "St Peter's Primary School",
                        "Beerburrum Rd near Nursery Rd",
                        "Manley St at Caboolture East State School",
                        "Lee St at Caboolture State High School",
                        "Market Dr near Suter Dr",
                        "Torrens Rd near Adelaide Dr"
                    ],
                    "7243: Morayfield, Caboolture": [
                        "Aireal Cr at Morayfield High School",
                        "Caboolture River Rd at Kenneth Street",
                        "Cresthaven Rd near Crestbrook Dr hail 'n' ride",
                        "Minimbah State School",
                        "Caboolture River Rd near Maple Dr hail 'n' ride",
                        "Torrens Rd near Moon St",
                        "Mingaye St near Domnick St",
                        "Mingaye St near Queen St",
                        "Matthew Flinders Dr near Investigator Dr",
                        "Matthew Flinders Dr near Bongaree Ave",
                        "Matthew Flinders Dr near Governor King Dr hail 'n' ride",
                        "Grant Rd at Julie Drive",
                        "Torrens Rd near Grant Rd",
                        "Torrens Rd near Dorset Dr",
                        "River Dr at Lotus Avenue",
                        "Bellemere Rd near River Dr",
                        "Bellmere Rd near Bishop Lane",
                        "Belle Air Dr near Riverwood Dr",
                        "Belle Air Dr near Riverside Cct",
                        "Bishop Lane near Bellmere Rd",
                        "King St at Caboolture Swimming Pool"
                    ],
                    "7244: Reserve Road - Caboolture High": [
                        "Caboolture station, stop C",
                        "Beerburrum Rd near Nursery Rd",
                        "Pumicestone State School",
                        "Reserve Dr near Riverlilly Cres hail 'n' ride",
                        "Lee St at Caboolture State High School"
                    ],
                    "7245: Beachmere Bribie Island": [
                        "Birali Steiner School",
                        "Beachmere Rd near Moreton Tce",
                        "Biggs Ave near Kunde St hail 'n' ride",
                        "Beachmere Primary School",
                        "Bishop Rd near Margaret St",
                        "Campbell Pde near Bellay Rd hail 'n' ride",
                        "Campbell Pde near Louise Dr hail 'n' ride",
                        "Bishop Rd near Mynott Rd hail 'n' ride",
                        "Fauna Way near Cocos Dr hail 'n' ride",
                        "Bribie Island Rd at Lee Road",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd near Rebecca Ave",
                        "Bribie Island Rd near Rowan Lane",
                        "Bribie Island Rd near Ruby Ave",
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Sandstone Bvd near Echidna Pl hail 'n' ride",
                        "Rose St near Bestmann Rd hail 'n' ride",
                        "Oak St near May St hail 'n' ride",
                        "Rose St near Georgia St hail 'n' ride",
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Bestmann Rd East near Mackerel St",
                        "Bestmann Rd East near Clark Tce",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave near Verdoni St",
                        "Lawn St near Coolgarra Ave hail 'n' ride",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Kangaroo Ave at Doomba Drive",
                        "Kangaroo Ave at Welsby Parade",
                        "Welsby Pde at First Avenue"
                    ],
                    "7246: Morayfield High - Upper Caboolture": [
                        "Aireal Cr at Morayfield High School",
                        "Caboolture River Rd near Maple Dr",
                        "Parkridge Ave near Olympic Ct",
                        "Parkridge Ave near Newfarm St"
                    ],
                    "7270: Caboolture High - Beachmere": [
                        "Lee St at Caboolture State High School",
                        "Beachmere Rd at Riversleigh Rd",
                        "Beachmere Rd near Moreton Tce",
                        "Moreton Tce near Main St",
                        "Moreton Tce near Second Ave",
                        "Moreton Tce near Dorunda Ave",
                        "Moreton Tce near Hodgson St",
                        "Bryant St near Dwyer St",
                        "Dwyer St near Hodgson St",
                        "Kunde St near Gretel Dr",
                        "Biggs Ave near Huntley St",
                        "Biggs Ave near Second Ave",
                        "Main St near Moreton Tce",
                        "Beachmere Rd near Old Becahmere Rd hail 'n' ride"
                    ],
                    "7271: Caboolture High - Caboolture North & Toorbul": [
                        "Lee St at Caboolture State High School",
                        "Pumicestone State School",
                        "Male Rd near Wild Horse Rd hail 'n' ride",
                        "Water Fern Dr near Scribbly Gum Cct",
                        "Scribbly Gum Cct near White Ash Ct hail 'n' ride",
                        "Scribbly Gum Cct near Water Fern Dr hail 'n' ride",
                        "Racemosa St near Silica St",
                        "Reserve Dr near Riverlilly Cres hail 'n' ride",
                        "Pumicestone Rd near Elimbah Ave hail 'n' ride",
                        "Pumicestone Rd near Kleise St hail 'n' ride",
                        "Pumicestone Rd near Perry Rd hail 'n' ride",
                        "Pumicestone Rd at Freeman Rd hail 'n' ride",
                        "Delisser Ave near The Esplanade hail 'n' ride",
                        "Carnegie St near The Crescent hail 'n' ride",
                        "Freeman Rd near The Esplanade hail 'n' ride"
                    ],
                    "7276: Caboolture High - Caboolture North": [
                        "Lee St at Caboolture State High School",
                        "Pettigrew St at Caboolture PCYC",
                        "Brown St at Jensen Road",
                        "Jensen Rd near Kent St",
                        "Pumicestone Rd near Cowie St",
                        "Cowie St near Ruby St",
                        "Jensen Rd near Winterbrook Ct",
                        "Balkee Dr near Elof Rd hail 'n' ride",
                        "Schofield Cct near Fazey Ct hail 'n' ride",
                        "Schofield Cct near Kerswell St hail 'n' ride",
                        "Elof Rd near Riccardo St",
                        "Van Beelan St near Linwood Ct",
                        "Male Rd near Van Beelan St",
                        "Male Rd near Granger St",
                        "Granger St near Elof Rd",
                        "Elof Rd near Riccardo St hail 'n' ride",
                        "Pumicestone State School",
                        "Golden Dr near Platinum Rd hail 'n' ride",
                        "Emu Rd near Urban Rd hail 'n' ride",
                        "Emu Rd near Hamilton Rd hail 'n' ride",
                        "Dances Rd near Cottrill Rd hail 'n' ride",
                        "Victoria St near Anastasia Ct hail 'n' ride"
                    ],
                    "7277: Caboolture High - Beachmere & Peel Rd": [
                        "Lee St at Caboolture State High School",
                        "Lee St at Lee Street State Special School",
                        "Beachmere Rd near Ann Maree Dr",
                        "Lawrence Dr near Leishman Rd hail 'n' ride",
                        "Beachmere Rd at Riversleigh Rd",
                        "Beachmere Rd near Moreton Tce",
                        "Bishop Rd near Margaret St",
                        "Bishop Rd near McGregor Tce",
                        "Campbell Pde near Bellay Rd hail 'n' ride",
                        "Campbell Pde near Louise Dr hail 'n' ride",
                        "Campbell Pde near Bishop Rd hail 'n' ride",
                        "Bishop Rd near Mynott Rd hail 'n' ride",
                        "Bribie Island Rd at Peel Road"
                    ],
                    "7280: Tullawong High - Bellmere": [
                        "Tullawong State High School",
                        "Smiths Rd near Afton St",
                        "Ulster Dr near Kendall Rd",
                        "Kendall Rd near Whimbrel Ct",
                        "Bellmere Rd at Bellmere Shops hail 'n' ride"
                    ],
                    "7288: Morayfield High - Upper Caboolture Early Fri svc": [
                        "Aireal Cr at Morayfield High School",
                        "Caboolture River Rd near Lorebury Dr",
                        "Caboolture River Rd near Ben St",
                        "Beacon St near Grant St",
                        "Beacon St near Ronald Ct",
                        "Beacon St near Caboolture River Rd",
                        "Dobson Lane near Arcadia Street hail 'n' ride",
                        "Sunflower Cres near Thistle St hail 'n' ride",
                        "Pauls Rd near Sunflower Cres hail 'n' ride",
                        "Pauls Road near Olympic Court hail 'n' ride",
                        "Parkridge Ave near Olympic Ct",
                        "Parkridge Ave near Kensington Ct"
                    ],
                    "7308: St Columbans - Ningi / Bribie": [
                        "St Columbans College",
                        "Caboolture Bribie Island Rd near Volz Rd hail 'n' ride",
                        "Bribie Island Rd at Lee Road",
                        "Aylward Rd near Wrenaus Way hail 'n' ride",
                        "Pinelands Way near Relesah Dr hail 'n' ride",
                        "Bribie Island Rd at Pinelands Way",
                        "Bestmann Rd near Lever Ct",
                        "Bestmann Rd near Greygum Ct",
                        "Bestmann Rd at Sunny Court",
                        "Bestmann Rd near Fairhaven Dr",
                        "Rose St near Bestmann Rd hail 'n' ride",
                        "Oak St near May St hail 'n' ride",
                        "Rose St near Georgia St hail 'n' ride",
                        "Bestmann Rd near Rose St",
                        "Ningi Waters Dr near Pristine Pl hail 'n' ride",
                        "Ningi Waters Dr near Grice Cr hail 'n' ride",
                        "Sandstone Bvd near Echidna Pl hail 'n' ride",
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Peerless Way near Smout Ct",
                        "Carpenter Way near Loftus Pl",
                        "Carpenter Way near Bayswater Ct",
                        "Bestmann Rd East at Dylan Court",
                        "Lachlan Cr at Day Place",
                        "Lachlan Cr near Nelson St",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Eucalypt St near Melrose Ave",
                        "Eucalypt St near Karee Dv",
                        "Boronia Dr near Wistaria St",
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Endeavour Dr near Headsail Dr",
                        "Endeavour Dr near Marlin Ct",
                        "Endeavour Dr near Swallow St",
                        "Endeavour Dr near Carl Ct",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Goodwin Dr near Coolgarra Ave",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr at Cotterill Avenue",
                        "First Ave at Bribie Island Recreation Grounds",
                        "First Ave at McMahon Street"
                    ],
                    "7309: Banksia Beach - Tullawong High": [
                        "North St at Second Avenue",
                        "Boyd St near Benny St hail 'n' ride",
                        "Boyd St near Curlew St hail 'n' ride",
                        "Arcadia Ave near Heron St hail 'n' ride",
                        "Arcadia Ave near Box St hail 'n' ride",
                        "First Ave near Arcadia Ave",
                        "First Ave at McMahon Street",
                        "First Ave at Bribie Island Recreation Grounds",
                        "Toorbul St at Bribie Island Sports Club",
                        "Welsby Pde at First Avenue",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Kangaroo Ave near Welsby Pde hail 'n' ride",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr near Coolgarra Ave",
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Endeavour Dr near Marlin Ct",
                        "Endeavour Dr near Swallow St",
                        "White Patch Esp near Toowa St hail 'n' ride",
                        "Endeavour Dr near Carl Ct",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Boronia Dr near Hovea St",
                        "Boronia Dr near Eucalypt St",
                        "Boronia Dr near Warrigal St",
                        "Jabiru St near Bellara St",
                        "Elkhorn Ave near Oorooba Ave",
                        "Eucalypt St near Karee Dr",
                        "Eucalypt St near Melrose Ave",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Bribie Island Rd near Bestmann Rd East",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd at Redondo Street",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Bribie Island Rd near Robert Ave",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd at Peel Road",
                        "Caboolture Bribie Island Rd near Browns Rd hail 'n' ride",
                        "McKean St at St Columbans College",
                        "Lee St at Lee Street State Special School",
                        "Tullawong State High School",
                        "St Columbans College",
                        "Lee St at Caboolture State High School",
                        "Caboolture Bribie Island Rd near Volz Rd hail 'n' ride",
                        "Bribie Island Rd at Lee Road",
                        "Bribie Island Rd near Rebecca Ave",
                        "Bribie Island Rd near Rowan Lane",
                        "Bribie Island Rd near Ruby Ave",
                        "Bribie Island Rd at Bestmann Road East",
                        "Eucalypt St near Karee Dv",
                        "Boronia Dr near Pandanus St",
                        "Boronia Dr near Orchid St",
                        "Boronia Dr near Wistaria St",
                        "Verdoni St near Bellara St",
                        "Verdoni St near Faraday St",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Endeavour Dr near Headsail Dr",
                        "Kangaroo Ave at Doomba Drive",
                        "Kangaroo Ave at Welsby Parade",
                        "First Ave near Bracken St",
                        "Jacana Ave at Cypress Lane"
                    ],
                    "7310: Bribie Ningi - St Michaels St Peters": [
                        "First Ave at McMahon Street",
                        "First Ave at Bribie Island Recreation Grounds",
                        "Welsby Pde at First Avenue",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Kangaroo Ave near Welsby Pde hail 'n' ride",
                        "Kangaroo Ave near Doomba Dr hail 'n' ride",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr near Coolgarra Ave",
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Freshwater Dr near Vanillalily Cl hail 'n' ride",
                        "Freshwater Dr near Corymbia Way hail 'n' ride",
                        "Endeavour Dr near Headsail Dr",
                        "Quarterdeck Dr near Bowsprit Cres hail 'n' ride",
                        "Endeavour Dr near Marlin Ct",
                        "Endeavour Dr near Swallow St",
                        "Endeavour Dr near Carl Ct",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Verdoni St near Faraday St",
                        "Verdoni St near Currong Cres",
                        "Boronia Dr near Hovea St",
                        "Eucalypt St near Karee Dr",
                        "Eucalypt St near Melrose Ave",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Bestmann Rd East near Bribie Island Rd",
                        "Bestmann Rd East at Lachlan Cresent",
                        "Bestmann Rd East at Dylan Court",
                        "Carpenter Way near Bayswater Ct",
                        "Carpenter Way near Loftus Pl",
                        "Peerless Way near Smout Ct",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at Corrimal Place",
                        "Sandstone Bvd near Redondo St hail 'n' ride",
                        "Sandstone Bvd near Echidna Pl hail 'n' ride",
                        "Sandstone Bvd near Bestmann Rd hail 'n' ride",
                        "Bestmann Rd near Rose St",
                        "Bestmann Rd near Fairhaven Dr",
                        "Bestmann Rd near Regina Ave",
                        "Bestmann Rd near Greygum Ct",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd at Pinelands Way",
                        "Pinelands Way near Relesah Dr hail 'n' ride",
                        "Aylward Rd near Wrenaus Way hail 'n' ride",
                        "Bribie Island Rd at Peel Road",
                        "Caboolture Bribie Island Rd near Browns Rd hail 'n' ride",
                        "St Michaels College",
                        "Beerburrum Rd near Nursery Rd",
                        "Caboolture Bribie Island Rd near Volz Rd hail 'n' ride",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Fauna Way near Cocos Dr hail 'n' ride",
                        "Bribie Island Rd at Lee Road",
                        "Bestmann Rd at Sunny Court",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Eucalypt St near Karee Dv",
                        "Boronia Dr near Wistaria St",
                        "Verdoni St near Bellara St",
                        "Kangaroo Ave at Doomba Drive",
                        "Kangaroo Ave at Welsby Parade",
                        "Jacana Ave at Cypress Lane",
                        "North St at Second Avenue"
                    ],
                    "7311: Ningi - Banksia Beach Pmy": [
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Fauna Way near Cocos Dr hail 'n' ride",
                        "Bribie Island Rd at Lee Road",
                        "Aylward Rd near Wrenaus Way hail 'n' ride",
                        "Aylward Rd near Triton Ct hail 'n' ride",
                        "Bernborough Way near Tulloch Ct hail 'n' ride",
                        "Pinelands Way near Relesah Dr hail 'n' ride",
                        "Bribie Island Rd at Pinelands Way",
                        "Bestmann Rd near Lever Ct",
                        "Bestmann Rd near Greygum Ct",
                        "Bestmann Rd at Sunny Court",
                        "Bestmann Rd near Fairhaven Dr",
                        "Rose St near Bestmann Rd hail 'n' ride",
                        "Oak St near May St hail 'n' ride",
                        "Rose St near Georgia St hail 'n' ride",
                        "Bestmann Rd near Rose St",
                        "Sandstone Bvd near Redondo St hail 'n' ride",
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Bribie Island Rd at Redondo Street",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Benabrow Ave near Verdoni St",
                        "Sunderland Dr near Eagles Landing",
                        "Banksia Beach Primary School",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd at Bestmann Road"
                    ],
                    "7312: Ningi and Sandstone Pt - Banksia Beach": [
                        "Bribie Island Rd at Redondo Street",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Ranald Ave near Robert Ave hail 'n' ride",
                        "Ranald Ave near Rebecca Ave hail 'n' ride",
                        "Regina Ave near Ranald Ave hail 'n' ride",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd near Ruby Ave",
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Ningi Waters Dr near Pristine Pl hail 'n' ride",
                        "Ningi Waters Dr near Grice Cr hail 'n' ride",
                        "Sandstone Bvd near Echidna Pl hail 'n' ride",
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Bestmann Rd East near Mackerel St",
                        "Bestmann Rd East at Dylan Court",
                        "Bestmann Rd East near Clark Tce",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Banksia Beach Primary School",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd near Rebecca Ave",
                        "Bribie Island Rd near Rowan Lane",
                        "Benabrow Ave at Bribie Island Bridge"
                    ],
                    "7313: Banksia Beach Pmy - Woorim": [
                        "Arcadia Ave near Box St",
                        "Arcadia Ave near Broom St",
                        "Arcadia Ave near Heron St",
                        "Arcadia Ave near Boyd St",
                        "Boyd St near Curlew St",
                        "Boyd St near Benny St",
                        "Boyd St near Ottiwell St",
                        "Jacana Ave at Cypress Lane",
                        "North St near Fourth Ave",
                        "Eighth Ave near Sixth Ave",
                        "Sixth Ave near Longland Ct",
                        "Sixth Ave near Clement St",
                        "Clement St near Seventh Ave",
                        "North St at Second Avenue",
                        "First Ave at Jacana Avenue",
                        "First Ave near Arcadia Ave",
                        "First Ave at McMahon Street",
                        "First Ave at Bribie Island Recreation Grounds",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Lawn St near Coolgarra Ave hail 'n' ride",
                        "Goodwin Dr near Coolgarra Ave",
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "White Patch Esp near Endeavour Dr hail 'n' ride",
                        "White Patch Esp near Toowa St hail 'n' ride",
                        "Endeavour Dr near Carl Ct",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Banksia Beach Primary School",
                        "Boronia Dr near Hovea St",
                        "Boronia Dr near Eucalypt St",
                        "Boronia Dr near Warrigal St",
                        "Jabiru St near Bellara St",
                        "Elkhorn Ave near Oorooba Ave",
                        "Verdoni St near Faraday St",
                        "First Ave near Bracken St",
                        "Eighth Ave near Clement St",
                        "North St near Seventh Ave"
                    ],
                    "7314: Sandstone Pt - Bribie Island Pmy": [
                        "Bribie Island High School",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr near Coolgarra Ave",
                        "Benabrow Ave near Gidya Ave",
                        "Benabrow Ave at Ferguson Avenue",
                        "Bestmann Rd East near Bribie Island Rd",
                        "Bestmann Rd East at Lachlan Cresent",
                        "Bestmann Rd East at Oxley Place",
                        "Bestmann Rd East at Dylan Court",
                        "Bestmann Rd near Mackerel St",
                        "Peerless Way near Smout Ct",
                        "Carpenter Way near Seaforth St hail 'n' ride",
                        "Carpenter Way near Reeders St hail 'n' ride",
                        "Bilinga Ct near Tugun Pl hail 'n' ride",
                        "Rose St near Bestmann Rd hail 'n' ride",
                        "Oak St near May St hail 'n' ride",
                        "Rose St near Georgia St hail 'n' ride",
                        "Bestmann Rd near Rose St",
                        "Bribie Island State School"
                    ],
                    "7315: Banksia Beach - St Columbans": [
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Freshwater Dr near Vanillalily Cl hail 'n' ride",
                        "Freshwater Dr near Corymbia Way hail 'n' ride",
                        "Endeavour Dr near Headsail Dr",
                        "Quarterdeck Dr near Bowsprit Cres hail 'n' ride",
                        "Benabrow Ave near Gidya Ave",
                        "Benabrow Ave at Ferguson Avenue",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Bribie Island Rd near Bestmann Rd East",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd at Redondo Street",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Bribie Island Rd near Robert Ave",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd at Pinelands Way",
                        "Bribie Island Rd at Aylward Road",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Fauna Way near Cocos Dr hail 'n' ride",
                        "Bribie Island Rd at Peel Road",
                        "St Columbans College",
                        "Bribie Island Rd at Aerodrome Road",
                        "Bribie Island Rd at Pasturage Road",
                        "Bribie Island Rd at Lee Road",
                        "Bribie Island Rd near Rebecca Ave",
                        "Bribie Island Rd near Rowan Lane",
                        "Bribie Island Rd near Ruby Ave",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave near Verdoni St"
                    ],
                    "7317: Sandstone Pt, Ningi - Bribie Island SS": [
                        "Bribie Island Rd at Redondo Street",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Ranald Ave near Robert Ave hail 'n' ride",
                        "Ranald Ave near Rebecca Ave hail 'n' ride",
                        "Regina Ave near Ranald Ave hail 'n' ride",
                        "Bribie Island Rd near Rebecca Ave",
                        "Bribie Island Rd near Rowan Lane",
                        "Bribie Island Rd near Ruby Ave",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Benabrow Ave at Ferguson Avenue",
                        "Welsby Pde near Palm Ave",
                        "Welsby Pde near Charlotte Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Bribie Island State School",
                        "Welsby Pde near Wattle Ave",
                        "Benabrow Ave near Verdoni St",
                        "Verdoni St near Faraday St",
                        "Verdoni St near Currong Cres",
                        "Boronia Dr near Hovea St",
                        "Boronia Dr near Eucalypt St",
                        "Boronia Dr near Warrigal St",
                        "Jabiru St near Bellara St",
                        "Elkhorn Ave near Oorooba Ave",
                        "Sunderland Dr near Eagles Landing",
                        "Banksia Beach Primary School",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr near Coolgarra Ave",
                        "Benabrow Ave near Gidya Ave",
                        "Bribie Island Rd near Bestmann Rd East",
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Bribie Island Rd near Regina Ave"
                    ],
                    "7318: Bongaree - Caboolture": [
                        "First Ave at McMahon Street",
                        "First Ave at Bribie Island Recreation Grounds",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr near Coolgarra Ave",
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Endeavour Dr near Headsail Dr",
                        "Endeavour Dr near Marlin Ct",
                        "Endeavour Dr near Swallow St",
                        "Endeavour Dr near Carl Ct",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Boronia Dr near Hovea St",
                        "Eucalypt St near Karee Dr",
                        "Eucalypt St near Melrose Ave",
                        "Bestmann Rd East near Bribie Island Rd",
                        "Bestmann Rd East at Lachlan Cresent",
                        "Lachlan Cr near Nelson St",
                        "Lachlan Cr near Day Pl",
                        "Bestmann Rd East at Dylan Court",
                        "Carpenter Way near Bayswater Ct",
                        "Carpenter Way near Loftus Pl",
                        "Peerless Way near Smout Ct",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at Corrimal Place",
                        "Ningi Waters Dr near Pristine Pl hail 'n' ride",
                        "Ningi Waters Dr near Grice Cr hail 'n' ride",
                        "Sandstone Bvd near Echidna Pl hail 'n' ride",
                        "Rose St near Bestmann Rd hail 'n' ride",
                        "Oak St near May St hail 'n' ride",
                        "Rose St near Georgia St hail 'n' ride",
                        "Bestmann Rd near Rose St",
                        "Bestmann Rd near Fairhaven Dr",
                        "Bestmann Rd near Regina Ave",
                        "Bestmann Rd near Greygum Ct",
                        "Bestmann Rd near Lever Ct",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd at Pinelands Way",
                        "Pinelands Way near Relesah Dr hail 'n' ride",
                        "Aylward Rd near Wrenaus Way hail 'n' ride",
                        "Bribie Island Rd at Peel Road",
                        "Caboolture Bribie Island Rd near Browns Rd hail 'n' ride",
                        "McKean St at St Columbans College",
                        "Lee St at Lee Street State Special School",
                        "Tullawong State High School",
                        "St Pauls Lutheran Primary School",
                        "Smiths Rd near Afton St",
                        "Beerburrum Rd near Nursery Rd",
                        "Lee St at Caboolture State High School",
                        "Caboolture Bribie Island Rd near Volz Rd hail 'n' ride",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Fauna Way near Cocos Dr hail 'n' ride",
                        "Bribie Island Rd at Lee Road",
                        "Bestmann Rd at Sunny Court",
                        "Lachlan Cr at Day Place",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Eucalypt St near Karee Dv",
                        "Boronia Dr near Wistaria St",
                        "Quarterdeck Dr near Bowsprit Cres hail 'n' ride",
                        "Kangaroo Ave at Doomba Drive",
                        "Kangaroo Ave at Welsby Parade",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Welsby Pde at First Avenue"
                    ],
                    "7319: Sandstone Pt - Bribie Island State School": [
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Ningi Waters Dr near Pristine Pl hail 'n' ride",
                        "Ningi Waters Dr near Grice Cr hail 'n' ride",
                        "Sandstone Bvd near Echidna Pl hail 'n' ride",
                        "Bestmann Rd East near Mackerel St",
                        "Bestmann Rd East at Dylan Court",
                        "Bestmann Rd East near Clark Tce",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island State School",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr near Coolgarra Ave",
                        "Benabrow Ave near Gidya Ave",
                        "Benabrow Ave at Ferguson Avenue",
                        "Bestmann Rd at Corrimal Place"
                    ],
                    "7320: Ningi, Sandstone Pt - Bribie Island SS": [
                        "Aylward Rd near Wrenaus Way hail 'n' ride",
                        "Aylward Rd near Triton Ct hail 'n' ride",
                        "Bernborough Way near Tulloch Ct hail 'n' ride",
                        "Pinelands Way near Relesah Dr hail 'n' ride",
                        "Bribie Island Rd at Pinelands Way",
                        "Bestmann Rd near Lever Ct",
                        "Bestmann Rd near Greygum Ct",
                        "Bestmann Rd at Sunny Court",
                        "Bestmann Rd near Fairhaven Dr",
                        "Bribie Island State School",
                        "Bestmann Rd near Rose St",
                        "Bestmann Rd near Regina Ave",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd at Aylward Road",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Fauna Way near Cocos Dr hail 'n' ride",
                        "Bribie Island Rd at Lee Road"
                    ],
                    "7321: Sandstone Pt - Bribie Island State School": [
                        "Bestmann Rd East at Lachlan Cresent",
                        "Bestmann Rd East at Oxley Place",
                        "Bestmann Rd East at Dylan Court",
                        "Carpenter Way near Bayswater Ct",
                        "Carpenter Way near Loftus Pl",
                        "Peerless Way near Smout Ct",
                        "Mackrel St near Perch Cct hail 'n' ride",
                        "Mackrel St near Sole Pl hail 'n' ride",
                        "Lachlan Cr at Day Place",
                        "Lachlan Cr near Nelson St",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Bribie Island State School",
                        "Bestmann Rd East near Bribie Island Rd",
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Benabrow Ave at Bribie Island Bridge"
                    ],
                    "7322: Woorim - Bribie Island State School": [
                        "First Ave near Bracken St",
                        "Arcadia Ave near Boyd St",
                        "Boyd St near Curlew St",
                        "Boyd St near Benny St",
                        "Boyd St near Ottiwell St",
                        "Jacana Ave at Cypress Lane",
                        "North St near Fourth Ave",
                        "Eighth Ave near Clement St",
                        "Eighth Ave near Sixth Ave",
                        "Sixth Ave near Longland Ct",
                        "Sixth Ave near Clement St",
                        "Clement St near Seventh Ave",
                        "North St near Seventh Ave",
                        "North St at Second Avenue",
                        "First Ave at Jacana Avenue",
                        "First Ave near Arcadia Ave",
                        "Bribie Island State School",
                        "Banksia Beach Primary School",
                        "Avon Ave near Endeavour Dr",
                        "Freshwater Dr near Vanillalily Cl hail 'n' ride",
                        "Freshwater Dr near Corymbia Way hail 'n' ride",
                        "Quarterdeck Dr near Bowsprit Cres hail 'n' ride",
                        "White Patch Esp near Endeavour Dr hail 'n' ride",
                        "White Patch Esp near Toowa St hail 'n' ride",
                        "Endeavour Dr near Carl Ct",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Boronia Dr near Hovea St",
                        "Eucalypt St near Karee Dr",
                        "Eucalypt St near Melrose Ave",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Welsby Pde near Palm Ave",
                        "Welsby Pde near Charlotte Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde at Bongaree Caravan Park"
                    ],
                    "7324: Bongaree - Bribie Island State School": [
                        "Bribie Island State School",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Wattle Ave",
                        "Welsby Pde near Palm Ave",
                        "Benabrow Ave near Verdoni St",
                        "Verdoni St near Faraday St",
                        "Verdoni St near Currong Cres",
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Avon Ave near Endeavour Dr",
                        "Freshwater Dr near Vanillalily Cl hail 'n' ride",
                        "Freshwater Dr near Corymbia Way hail 'n' ride",
                        "Endeavour Dr near Headsail Dr",
                        "Endeavour Dr near Swallow St",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Boronia Dr near Hovea St",
                        "Boronia Dr near Eucalypt St",
                        "Boronia Dr near Warrigal St",
                        "Jabiru St near Bellara St",
                        "Elkhorn Ave near Oorooba Ave",
                        "Eucalypt St near Karee Dr",
                        "Eucalypt St near Melrose Ave",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr at Cotterill Avenue",
                        "First Ave at Bribie Island Recreation Grounds",
                        "First Ave at McMahon Street"
                    ],
                    "7325: Bongaree - Bribie Island State School": [
                        "Bribie Island High School",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Verdoni St near Faraday St",
                        "Verdoni St near Currong Cres",
                        "Boronia Dr near Hovea St",
                        "Boronia Dr near Eucalypt St",
                        "Boronia Dr near Warrigal St",
                        "Jabiru St near Bellara St",
                        "Elkhorn Ave near Oorooba Ave",
                        "Eucalypt St near Karee Dr",
                        "Eucalypt St near Melrose Ave",
                        "Benabrow Ave near Verdoni St",
                        "Benabrow Ave near Gidya Ave",
                        "Welsby Pde near Palm Ave",
                        "Welsby Pde near Charlotte Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Bribie Island State School",
                        "First Ave at Bribie Island Recreation Grounds",
                        "First Ave at McMahon Street",
                        "First Ave near Bracken St",
                        "Arcadia Ave near Box St",
                        "Arcadia Ave near Broom St",
                        "Arcadia Ave near Heron St",
                        "Arcadia Ave near Boyd St",
                        "Boyd St near Curlew St",
                        "Boyd St near Benny St",
                        "Boyd St near Ottiwell St",
                        "Jacana Ave at Cypress Lane",
                        "North St near Fourth Ave",
                        "Eighth Ave near Clement St",
                        "Eighth Ave near Sixth Ave",
                        "Sixth Ave near Longland Ct",
                        "Sixth Ave near Clement St",
                        "Clement St near Seventh Ave",
                        "North St near Seventh Ave",
                        "North St at Second Avenue",
                        "First Ave at Jacana Avenue",
                        "First Ave near Arcadia Ave",
                        "Lawn St near Coolgarra Ave hail 'n' ride",
                        "Jasmin Dr near Lawn St",
                        "Jasmin Dr near Protea Dr",
                        "Protea Dr near Melia St",
                        "Cotterill Ave near Barklya Cr",
                        "Cotterill Ave near Goodwin Dr",
                        "Goodwin Drive at Ian Fairweather Park"
                    ],
                    "7326: Sandstone Pt - Banksia Beach": [
                        "Bestmann Rd East at Lachlan Cresent",
                        "Bestmann Rd East at Oxley Place",
                        "Bestmann Rd East at Dylan Court",
                        "Carpenter Way near Bayswater Ct",
                        "Carpenter Way near Loftus Pl",
                        "Carpenter Way near Seaforth St hail 'n' ride",
                        "Carpenter Way near Reeders St hail 'n' ride",
                        "Bilinga Ct near Tugun Pl hail 'n' ride",
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Mackrel St near Perch Cct hail 'n' ride",
                        "Mackrel St near Sole Pl hail 'n' ride",
                        "Lachlan Cr at Day Place",
                        "Lachlan Cr near Nelson St",
                        "Bestmann Rd at Lachlan Cresent",
                        "Eucalypt St near Melrose Ave",
                        "Sylvan Beach Esp near Warrigal St hail 'n' ride",
                        "Sylvan Beach Esp near Bellara St hail 'n' ride",
                        "Marina Bvd near Seaside Dr hail 'n' ride",
                        "Marina Bvd near Harbour Promenade hail 'n' ride",
                        "Marina Bvd near Whitehaven Pl hail 'n' ride",
                        "Marina Bvd near North Point hail 'n' ride",
                        "Marina Bvd near Pectoral Pl hail 'n' ride",
                        "Marina Bvd near The Peninsula hail 'n' ride",
                        "Banksia Beach Primary School",
                        "Cosmos Ave near Caltowie Ave hail 'n' ride",
                        "Cosmos Ave near Tradewinds Dr hail 'n' ride",
                        "Cosmos Ave near Seafarer Pl hail 'n' ride",
                        "Bestmann Rd East near Bribie Island Rd"
                    ],
                    "7327: Pac Harbour, Endeavour, Quarterdeck - BBSS": [
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Freshwater Dr near Vanillalily Cl hail 'n' ride",
                        "Freshwater Dr near Corymbia Way hail 'n' ride",
                        "Quarterdeck Dr near Bowsprit Cres hail 'n' ride",
                        "Voyagers Dr near Skysail Ct hail 'n' ride",
                        "Sunderland Dr near Alpinia Ave",
                        "Banksia Beach Primary School"
                    ],
                    "7360: Ningi - Bribie Island State School": [
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Ranald Ave near Robert Ave hail 'n' ride",
                        "Ranald Ave near Rebecca Ave hail 'n' ride",
                        "Regina Ave near Ranald Ave hail 'n' ride",
                        "Bestmann Rd near Lever Ct",
                        "Bestmann Rd near Greygum Ct",
                        "Bestmann Rd at Sunny Court",
                        "Bestmann Rd near Fairhaven Dr",
                        "Bestmann Rd near Rose St",
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Bestmann Rd East near Mackerel St",
                        "Bestmann Rd East at Dylan Court",
                        "Bestmann Rd East near Clark Tce",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Benabrow Ave near Verdoni St",
                        "Benabrow Ave near Gidya Ave",
                        "Benabrow Ave at Ferguson Avenue",
                        "Welsby Pde near Palm Ave",
                        "Welsby Pde near Charlotte Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Welsby Pde at First Avenue",
                        "First Ave near Cumming St",
                        "Bribie Island High School",
                        "Bribie Island Rd near Bestmann Rd East",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd near Donald St"
                    ],
                    "7361: Woorim - Bribie Island High": [
                        "First Ave near Bracken St",
                        "Arcadia Ave near Boyd St",
                        "Boyd St near Curlew St",
                        "Boyd St near Benny St",
                        "Boyd St near Ottiwell St",
                        "Jacana Ave at Cypress Lane",
                        "North St near Fourth Ave",
                        "Eighth Ave near Clement St",
                        "Eighth Ave near Sixth Ave",
                        "Sixth Ave near Longland Ct",
                        "Sixth Ave near Clement St",
                        "Clement St near Seventh Ave",
                        "North St near Seventh Ave",
                        "North St at Second Avenue",
                        "First Ave at Jacana Avenue",
                        "First Ave near Arcadia Ave",
                        "First Ave at McMahon Street",
                        "First Ave at Bribie Island Recreation Grounds",
                        "Bribie Island High School",
                        "Arcadia Ave near Box St",
                        "Arcadia Ave near Broom St",
                        "Arcadia Ave near Heron St"
                    ],
                    "7362: Sandstone Pt - Bribie Island High": [
                        "Bestmann Rd East at Dylan Court",
                        "Carpenter Way near Bayswater Ct",
                        "Carpenter Way near Loftus Pl",
                        "Peerless Way near Smout Ct",
                        "Mackrel St near Perch Cct hail 'n' ride",
                        "Mackrel St near Sole Pl hail 'n' ride",
                        "Lachlan Cr at Day Place",
                        "Lachlan Cr near Nelson St",
                        "Bestmann Rd at Lachlan Cresent",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Benabrow Ave at Ferguson Avenue",
                        "Welsby Pde near Palm Ave",
                        "Welsby Pde near Charlotte Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde at Bongaree Caravan Park",
                        "First Ave near Cumming St",
                        "Bribie Island High School",
                        "Bestmann Rd East near Bribie Island Rd",
                        "Bestmann Rd East at Lachlan Cresent",
                        "Bestmann Rd East at Oxley Place",
                        "Bestmann Rd East near Mackerel St",
                        "Bestmann Rd near Mackerel St",
                        "Welsby Pde at First Avenue",
                        "Bribie Island State School"
                    ],
                    "7363: Sandstone Pt - Bribie Island High": [
                        "Bestmann Rd East at Lachlan Cresent",
                        "Bestmann Rd East at Oxley Place",
                        "Bestmann Rd East at Dylan Court",
                        "Carpenter Way near Seaforth St hail 'n' ride",
                        "Carpenter Way near Reeders St hail 'n' ride",
                        "Bilinga Ct near Tugun Pl hail 'n' ride",
                        "Rose St near Bestmann Rd hail 'n' ride",
                        "Oak St near May St hail 'n' ride",
                        "Rose St near Georgia St hail 'n' ride",
                        "Bestmann Rd near Rose St",
                        "Bribie Island High School",
                        "Bestmann Rd East near Bribie Island Rd",
                        "Bestmann Rd near Mackerel St",
                        "Peerless Way near Smout Ct"
                    ],
                    "7364: Pinelands, Sandstone Pt - Bribie High": [
                        "Bribie Island Rd at Pinelands Way",
                        "Aylward Rd near Wrenaus Way hail 'n' ride",
                        "Aylward Rd near Triton Ct hail 'n' ride",
                        "Bernborough Way near Tulloch Ct hail 'n' ride",
                        "Pinelands Way near Relesah Dr hail 'n' ride",
                        "Bestmann Rd near Lever Ct",
                        "Bestmann Rd near Greygum Ct",
                        "Bestmann Rd at Sunny Court",
                        "Bestmann Rd near Fairhaven Dr",
                        "Bribie Island High School",
                        "Bestmann Rd near Regina Ave",
                        "Bribie Island Rd at Bestmann Road"
                    ],
                    "7365: Sandstone Pt - Bribie Island State School": [
                        "Ningi Waters Dr near Pristine Pl hail 'n' ride",
                        "Ningi Waters Dr near Grice Cr hail 'n' ride",
                        "Sandstone Bvd near Echidna Pl hail 'n' ride",
                        "Sandstone Bvd near Bestmann Rd hail 'n' ride",
                        "Bribie Island High School"
                    ],
                    "7366: Ningi - Bribie Island State School": [
                        "Bribie Island Rd at Redondo Street",
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Ranald Ave near Robert Ave hail 'n' ride",
                        "Ranald Ave near Rebecca Ave hail 'n' ride",
                        "Regina Ave near Ranald Ave hail 'n' ride",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd at Bestmann Road",
                        "Bribie Island Rd at Pinelands Way",
                        "Bribie Island Rd at Aylward Road",
                        "Peel Rd near Cocos Dr hail 'n' ride",
                        "Fauna Way near Cocos Dr hail 'n' ride",
                        "Bribie Island Rd at Lee Road",
                        "Bribie Island Rd near Rebecca Ave",
                        "Bribie Island Rd near Rowan Lane",
                        "Bribie Island Rd near Ruby Ave",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd at Bestmann Road East",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Welsby Pde near Palm Ave",
                        "Welsby Pde near Charlotte Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Bribie Island High School",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Freshwater Dr near Vanillalily Cl hail 'n' ride",
                        "Freshwater Dr near Corymbia Way hail 'n' ride",
                        "Endeavour Dr near Headsail Dr",
                        "Endeavour Dr near Marlin Ct",
                        "Endeavour Dr near Swallow St",
                        "Endeavour Dr near Carl Ct",
                        "Verdoni St near Faraday St",
                        "Verdoni St near Currong Cres",
                        "Boronia Dr near Hovea St",
                        "Eucalypt St near Karee Dr",
                        "Eucalypt St near Melrose Ave",
                        "Bribie Island Rd near Bestmann Rd East",
                        "Bribie Island Rd near Robert Ave"
                    ],
                    "7367: Banksia Beach - Bribie Island High": [
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Cosmos Ave near Caltowie Ave hail 'n' ride",
                        "Cosmos Ave near Tradewinds Dr hail 'n' ride",
                        "Cosmos Ave near Seafarer Pl hail 'n' ride",
                        "Seaeagle Pl near Eagles Landing hail 'n' ride",
                        "Raptor Pde near Seaeagle Pl hail 'n' ride",
                        "Marina Bvd near The Peninsula hail 'n' ride",
                        "Marina Bvd near Pectoral Pl hail 'n' ride",
                        "Marina Bvd near North Point hail 'n' ride",
                        "Marina Bvd near Whitehaven Pl hail 'n' ride",
                        "Marina Bvd near Harbour Promenade hail 'n' ride",
                        "Marina Bvd near Seaside Dr hail 'n' ride",
                        "Sylvan Beach Esp near Bellara St hail 'n' ride",
                        "Sylvan Beach Esp near Warrigal St hail 'n' ride",
                        "Bribie Island High School",
                        "Banksia Beach Primary School"
                    ],
                    "7368: Banksia Beach - Bribie High School": [
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Endeavour Dr near Headsail Dr",
                        "Endeavour Dr near Marlin Ct",
                        "Endeavour Dr near Swallow St",
                        "Solander Esp near Elizabeth Batts Ct hail 'n' ride",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Goodwin Dr near Coolgarra Ave",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr at Cotterill Avenue",
                        "Bribie Island High School",
                        "Boronia Dr near Warrigal St",
                        "Jabiru St near Bellara St",
                        "Elkhorn Ave near Oorooba Ave",
                        "Verdoni St near Currong Cres",
                        "Endeavour Dr near Carl Ct"
                    ],
                    "7369: White Patch, Banksia Beach - Bribie High": [
                        "White Patch Esp near Endeavour Dr hail 'n' ride",
                        "White Patch Esp near Toowa St hail 'n' ride",
                        "Endeavour Dr near Carl Ct",
                        "Kakadu Cr near Triller Way hail 'n' ride",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Sunderland Dr near Alpinia Ave",
                        "Sunderland Dr near Eagles Landing",
                        "Goodwin Dr near Coolgarra Ave",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr at Cotterill Avenue",
                        "Bribie Island High School",
                        "Avon Ave near Pacific Dr",
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Endeavour Dr near Headsail Dr",
                        "Quarterdeck Dr near Bowsprit Cres hail 'n' ride",
                        "Voyagers Dr near Skysail Ct hail 'n' ride",
                        "Banksia Beach Primary School"
                    ],
                    "7370: Bribie Island High - Sandstone Pt, Ningi": [
                        "Bribie Island High School",
                        "Goodwin Dr at Cotterill Avenue",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Goodwin Dr near Coolgarra Ave",
                        "Benabrow Ave near Gidya Ave",
                        "Benabrow Ave at Ferguson Avenue",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Bribie Island Rd near Bestmann Rd East",
                        "Bribie Island Rd near Kalmakuta Dr",
                        "Bribie Island Rd near Donald St",
                        "Bribie Island Rd at Redondo Street",
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Bribie Island Rd near Rex Lane",
                        "Bribie Island Rd near Rita Ave",
                        "Ranald Ave near Robert Ave hail 'n' ride",
                        "Ranald Ave near Rebecca Ave hail 'n' ride",
                        "Regina Ave near Ranald Ave hail 'n' ride",
                        "Bribie Island Rd near Regina Ave",
                        "Bribie Island Rd near Rebecca Ave",
                        "Bribie Island Rd near Rowan Lane",
                        "Bribie Island Rd near Ruby Ave",
                        "Bribie Island Rd at Bestmann Road East"
                    ],
                    "7371: Bellara - Bribie High School": [
                        "Verdoni St near Faraday St",
                        "Verdoni St near Currong Cres",
                        "Boronia Dr near Hovea St",
                        "Boronia Dr near Eucalypt St",
                        "Boronia Dr near Warrigal St",
                        "Jabiru St near Bellara St",
                        "Elkhorn Ave near Oorooba Ave",
                        "Eucalypt St near Karee Dr",
                        "Eucalypt St near Melrose Ave",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Welsby Pde near Palm Ave",
                        "Welsby Pde near Charlotte Ave",
                        "Welsby Pde near Dolphin Dr",
                        "Welsby Pde near Kangaroo Ave",
                        "Welsby Pde at Bongaree Caravan Park",
                        "Bribie Island High School"
                    ],
                    "7372: Bribie High School - Banksia Beach": [
                        "Bribie Island High School",
                        "Sunderland Dr near Eagles Landing",
                        "Sunderland Dr near Alpinia Ave",
                        "Sunderland Dr at Cosmos Ave hail 'n' ride",
                        "Endeavour Dr near Banks St hail 'n' ride",
                        "Solander Esp near Elizabeth Batts Ct hail 'n' ride",
                        "Kakadu Cr near Triller Way hail 'n' ride",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Banksia Beach Primary School"
                    ],
                    "7373: Bribie Lakes - Bribie High": [
                        "Avon Ave near Headsail Dr",
                        "Avon Ave near Endeavour Dr",
                        "Freshwater Dr near Vanillalily Cl hail 'n' ride",
                        "Freshwater Dr near Corymbia Way hail 'n' ride",
                        "Endeavour Dr near Headsail Dr",
                        "Quarterdeck Dr near Bowsprit Cres hail 'n' ride",
                        "Voyagers Dr near Skysail Ct hail 'n' ride",
                        "Endeavour Dr near Marlin Ct",
                        "Endeavour Dr near Swallow St",
                        "Endeavour Dr near Carl Ct",
                        "Sunderland Dr at Banksia Beach Shops",
                        "Sunderland Dr near Reef St",
                        "Sunderland Dr near Alpinia Ave",
                        "Sunderland Dr near Eagles Landing",
                        "Lawn St near Coolgarra Ave hail 'n' ride",
                        "Jasmin Dr near Lawn St",
                        "Protea Dr near Melia St",
                        "Cotterill Ave near Barklya Cr",
                        "Goodwin Dr at Cotterill Avenue",
                        "Bribie Island High School",
                        "Bribie Island State School",
                        "Goodwin Dr at Kangaroo Avenue",
                        "Benabrow Ave near Gidya Ave",
                        "Eucalypt St near Melrose Ave",
                        "Benabrow Ave at Bribie Island Bridge",
                        "Welsby Pde near Palm Ave"
                    ],
                    "7374: Bribie High - Sandstone Point": [
                        "Bribie Island High School",
                        "Bribie Island Rd at Redondo Street",
                        "Redondo St near Sandheath Pl hail 'n' ride",
                        "Ningi Waters Dr near Pristine Pl hail 'n' ride",
                        "Ningi Waters Dr near Grice Cr hail 'n' ride",
                        "Sandstone Bvd near Echidna Pl hail 'n' ride",
                        "Sandstone Bvd near Bestmann Rd hail 'n' ride",
                        "Bestmann Rd at Corrimal Place",
                        "Bestmann Rd at Pebble Beach Retirement",
                        "Bestmann Rd at The Village Sandstone Point",
                        "Bestmann Rd East near Mackerel St",
                        "Bestmann Rd East at Dylan Court",
                        "Bestmann Rd East near Clark Tce",
                        "Bestmann Rd at Lachlan Cresent"
                    ],
                    "8001: Mt Cotton, Victoria Point, Rochedale": [
                        "Link Rd near Jeanne Dr",
                        "Benfer Rd at Bangalow Street",
                        "St Ritas Catholic Primary School",
                        "Benfer Rd at Poinciana Avenue",
                        "Benfer Rd near Prescoter Dr",
                        "Cleveland Redland Bay Rd at Victoria Point High School",
                        "Cleveland Redland Bay Rd at Rosevale Court",
                        "Cleveland Redland Bay Rd at Magnolia Pde",
                        "Victoria Point Central, platform 1",
                        "Boundary Rd at Abeya Street",
                        "Boundary Rd at Meadowland Road",
                        "Lake Sherrin Homes for Aged",
                        "Boundary Rd at Venn Parade",
                        "Boundary Rd at Woodlands Drive",
                        "Boundary Rd at Kinross Road",
                        "Boundary Rd at Taylor Rd",
                        "Duncan Road Sports Fields",
                        "Mount Cotton Rd at Henderson Road",
                        "Mount Cotton Rd at Greenacres Caravan Park",
                        "Mount Cotton Rd near Ney Rd",
                        "Mount Cotton Road near Broadwater Rd",
                        "Mount Cotton Rd near Marawah St",
                        "Kloske Rd near Leacroft Rd",
                        "Grieve Rd near Ford Rd",
                        "Grieve Rd",
                        "Grieve Rd near Pillinger Rd",
                        "Grieve Rd near Rochedale Rd hail 'n' ride",
                        "Rochedale Rd near Grieve Rd",
                        "Rochedale Rd at Farley",
                        "Rochedale Rd near Ford Rd",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale State High School",
                        "Priestdale Rd opp Rochedale High School",
                        "Redeemer Lutheran College",
                        "Rochedale Rd near Grieve Rd hail 'n' ride",
                        "Ford Rd near Simmins Pl hail 'n' ride",
                        "274 Ford Rd, Burbank",
                        "Mount Cotton Rd at Ney Road",
                        "Duncan Rd at Duncan Road Sports Fields",
                        "Boundary Rd at Panorama Drive",
                        "Boundary Rd at Springacre Road",
                        "Victoria Point Central, platform 2",
                        "Sycamore Pde near Waratah Ave",
                        "Sycamore Pde near Belah Ct",
                        "Sycamore Pde near Peppermint Dr",
                        "Sycamore Pde near Wisteria Ct"
                    ],
                    "8003: Mt Cotton, Mackenzie, Loreto College": [
                        "Glengala Dr near Kala St",
                        "Glengala Dr at Morbani Road",
                        "Avalon Rd near Campbell Rd",
                        "Avalon Rd near Summit St",
                        "Mount Cotton Road near Broadwater Rd",
                        "Mount Cotton Rd near Wildsoet St",
                        "Mount Cotton Rd near Marawah St",
                        "Mount Cotton Rd at Alperton Rd",
                        "Mount Cotton Rd near Moxon Rd",
                        "Mount Cotton Rd at Daymar Street",
                        "Mt Gravatt Capalaba Rd at Gateway Baptist",
                        "Mackenzie State Primary School",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Gainsborough Ave near Monet Cr",
                        "Rembrandt Way at Gainsborough Park",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Berkley - Scrub Rd South",
                        "Scrub Road South at Aspen St",
                        "Wecker Rd at Wecker and Ham Roads",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Cavendish Rd at Seton College stop 59/56",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Kirra - Scrub Rd South",
                        "Avalon Rd at Summit Street",
                        "Glengala Dr near Morbani Rd",
                        "Glengala Dr near Gilandra St"
                    ],
                    "8004: Mt Cotton, Capalaba, Mackenzie, Mt Gravatt": [
                        "Priestdale Rd at Thallon Street",
                        "Kloske Rd near Town & Coaches Depot",
                        "Mount Cotton Rd near Marawah St",
                        "Mount Cotton Road near Broadwater Rd",
                        "Ney Rd near Koala Pl",
                        "Ney Rd at Capalaba Sports Club",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Ney Rd at Jeffrey Street",
                        "Redland Bay Rd at Ney Road",
                        "Redland Bay Rd at Coolnwynpin Creek",
                        "Windemere Rd at Sophia Place",
                        "Windemere Rd at Alexandra Hills High School",
                        "Finucane Rd at Alexandra Hills High School",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Finucane Rd at Willard Road",
                        "Old Cleveland Rd at Anderson Street",
                        "Old Cleveland Rd at Capalaba Central",
                        "Old Cleveland Rd at Sam Sciacca Sportsfield",
                        "Capalaba bus station, stop C",
                        "Mount Cotton Road at Pittwin Road North",
                        "Mount Cotton Rd at Winter Memorial Park",
                        "Mount Cotton Rd at Killarney Crescent",
                        "Mount Cotton Rd near School Rd",
                        "Mount Cotton Rd near Howlett Rd",
                        "Mount Cotton Rd near Jacaranda Rd",
                        "Mount Cotton Rd at Alperton Rd",
                        "Mount Cotton Rd near Moxon Rd",
                        "Mount Cotton Rd at Daymar Street",
                        "Mt Gravatt Capalaba Rd at Gateway Baptist",
                        "Mackenzie State Primary School",
                        "Gainsborough Ave near Monet Cr",
                        "Rembrandt Way at Gainsborough Park",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Gardner Road at Lorisch Way",
                        "Gardner Road at Prebble Street",
                        "Gardner Rd at Interchange Pl",
                        "Broadwater Rd at Mansfield Park",
                        "Broadwater Rd near Ham Rd",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Mailey St, stop 74",
                        "Broadwater Rd near Newnham Rd, stop 72",
                        "Newnham Rd at Civic Fair, stop 73",
                        "Newnham Rd at Tolson Street, stop 75",
                        "Newnham Rd near Zetland St",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Arila Street, stop 77",
                        "Dawson Rd near Cale St, stop 76B",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Dawson Rd at Gurney Street, stop 78",
                        "Dawson Rd at Gerty Street, stop 79",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station, stop K",
                        "Garden City Shopping Centre station, stop N",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at Wanda, stop 40",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Wishart Rd at Newnham Road, stop 44/74",
                        "Wishart Rd near Pasley St, stop 75",
                        "Wishart Rd near Invicta St",
                        "Wishart Rd near Elkana Pl, stop 76",
                        "Wishart Rd near Ham Rd, stop 77",
                        "Ham Rd at Adnar Street, stop 77",
                        "Mansfield State High",
                        "Gardner Rd at Frangipani St",
                        "Grieve Rd near Rochedale Rd hail 'n' ride",
                        "Grieve Rd near Pillinger Rd",
                        "Grieve Rd",
                        "Grieve Rd near Ford Rd",
                        "Ford Rd near Simmins Pl hail 'n' ride",
                        "Kloske Rd near Leacroft Rd",
                        "Macquarie St near Ney Rd",
                        "Macquarie St near Jacaranda Rd",
                        "Mount Cotton Rd near Larbonya Cr",
                        "Mount Cotton Rd near Killarney Cr",
                        "Mount Cotton Rd near Pittwin Rd",
                        "Finucane Rd at Old Cleveland Rd",
                        "Windemere Rd at Keith Surridge Park",
                        "Windemere Rd at Stovold Pl",
                        "Ney Rd at Callaghan Way",
                        "Ney Rd near Coolnwynpin Way",
                        "Degen Rd near St Lukes Ct"
                    ],
                    "8005: Rochedale - Mansfield SHS": [
                        "Gardner Rd at Arise Boulevard",
                        "Gardner Road at Lorisch Way",
                        "Gardner Road at Prebble Street",
                        "Gardner Rd at Interchange Pl",
                        "Mt Gravatt Capalaba Rd at Wishart East",
                        "Ham Rd at Koola Street, stop 78",
                        "Ham Rd at Adnar Street, stop 77",
                        "Mansfield High and Junior Schools"
                    ],
                    "800: Yeronga High - Inala Plaza": [
                        "Villa St at Yeronga High School",
                        "Park Rd at Memorial Park",
                        "Park Rd near Christensen St",
                        "Park Rd at School Rd, stop 25",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Ipswich Rd at Clifton Hill near Beaudesert Rd",
                        "Ipswich Rd at Lyon Street, stop 36",
                        "Ipswich Rd at Michlin Street, stop 37",
                        "Ipswich Rd at Gainsborough Street, stop 38",
                        "Ipswich Rd at Moorooka station, stop 39",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Blunder Rd at Blunder - Freeman, stop 68",
                        "Blunder Rd at Forest Place North, stop 69",
                        "Blunder Rd at Forest Place South, stop 70",
                        "Glenala Rd at Glenala East, stop 71",
                        "Akama Rd at Akama Central Stop 73",
                        "Akama Rd at Akama South Stop 74",
                        "Durella St at Durella East, stop 75",
                        "Durella St at Durella West, stop 76",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Inala station, platform A"
                    ],
                    "8010: Mansfield, Loreto, Villanova, Cannon Hill": [
                        "Miles Platting Rd near Rochedale Rd",
                        "Gardner Rd at Arise Boulevard",
                        "Gardner Road at Lorisch Way",
                        "Gardner Road at Prebble Street",
                        "Rembrandt Way at Gainsborough Park",
                        "Gainsborough Ave near Monet Cr",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Broadwater Rd at Mansfield Park",
                        "Ham Rd near Broadwater Rd",
                        "Ham Rd at Mansfield High School",
                        "Ham Rd at Banika Street, stop 64c",
                        "Wecker Rd at Dividend Street, stop 64a",
                        "Wecker Rd at Wecker Rd Business Center, stop 63",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Creek Rd at Greek Memorial, stop 59b",
                        "Creek Rd at Fairland Street",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Glindemann Park, stop 33",
                        "Logan Rd at Boronia Street, stop 32",
                        "Logan Rd at Holland Park South, stop 31",
                        "Holland Rd near Stewart St, stop 44",
                        "Holland Rd at Greenmount Avenue, stop 45",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Chatsworth Rd at Stirrat Street, stop 31",
                        "Chatsworth Rd at Trundle Street, stop 30",
                        "Upper Cornwall St at Upper Cornwall, stop 29",
                        "Upper Cornwall St at Pembroke Rd, stop 28",
                        "Villanova College",
                        "Old Cleveland Rd at Saint Leonards Street Stop 21",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Cavendish Rd at Wakefield Street, stop 25/21",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Milsom St, stop 19",
                        "Stanley St E at Coorparoo Secondary College",
                        "Tiber St at Rome Street, stop 25",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Virginia Ave near Aaron Ave",
                        "Uhlmann St near Harris Street, stop 22a",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Fifth Avenue, stop 33",
                        "Lytton Rd opp Balmoral High School",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Old Cleveland Rd at Macauly Street, stop 22",
                        "Old Cleveland Rd at Dowar Street Stop 20",
                        "Upper Cornwall St at Pembroke Street, stop 20/28",
                        "Cavendish Rd near Kanumbra St",
                        "Cavendish Rd near Pelham St",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Holland Rd near Rita St, stop 44",
                        "Holland Rd at Lamette Avenue, stop 43A",
                        "Logan Rd at Mt Gravatt Central",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Wecker Rd at Eastwood Drive, stop 64b",
                        "Ham Rd at Linfield Street, stop 64d",
                        "Ham Rd near Kelnat St",
                        "Ham Rd at Mansfield State School",
                        "Ham Rd near Rupari St",
                        "Mansfield High and Junior Schools",
                        "Gardner Rd at Frangipani St",
                        "Rochedale Rd near Miles Platting Rd"
                    ],
                    "8012: Carindale, Cannon Hill": [
                        "Rembrandt Way at Gainsborough Park",
                        "Gainsborough Ave near Monet Cr",
                        "Greendale Way at Ridgeview St",
                        "Greendale Way at Empress Drive",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Winstanley St at Winstanley East",
                        "Winstanley St near Talavera St",
                        "Winstanley St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Winstanley St at Laurie Street, stop 48/47",
                        "Winstanley St at Willard Street, stop 46",
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Darcy Rd near Solander St, stop 50",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Minnippi Bvd",
                        "Richmond Rd at Richmond East",
                        "Richmond Rd at Molloy Road",
                        "Junction Rd at Colmslie, stop 53",
                        "Junction Rd at Algoori Street, stop 54",
                        "Junction Rd at Beelarong Street, stop 55",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Richmond Rd near Imperial Ave, stop 58",
                        "Richmond Rd at Ludwick Street, stop 66",
                        "Creek Rd at Foxmont Drive, stop 49",
                        "Darcy Rd near Mayfair St, stop 50",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Winstanley St near Birdwood Rd, stop 45",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St near Firmiston St",
                        "Winstanley St near Hedlow Ct",
                        "Scrub Rd at Winstanley East"
                    ],
                    "8013: Rochedale, Coorparoo, Cannon Hill": [
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Garden City Shopping Centre station, stop N",
                        "Newnham Rd near Tryon St, stop 79",
                        "Delavan St at Delavan Terminus, stop 78/87",
                        "Delavan St at Wolcott Street, stop 86",
                        "Delavan St at Delavan Street Park, stop 85",
                        "Cummin St near Monte Carlo St, stop 84",
                        "Mannetto St near Matincock St, stop 83",
                        "Mannetto St at Gilgo Street, stop 82",
                        "Greenwood St near Kavanagh Rd, stop 81",
                        "Mindona St at Mindona Park, stop 80",
                        "Boyanda St near Tyrrell St, stop 79",
                        "Ham Rd at Koola Street, stop 78",
                        "Ham Rd at Adnar Street, stop 77",
                        "Ham Rd near Broadwater Rd",
                        "Broadwater Rd near Ham Rd",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Mailey St, stop 74",
                        "Newnham Rd at Westbrooke Street, stop 71",
                        "Newnham Rd at Condong Street, stop 70/63",
                        "Newnham Rd at Enderby Street, stop 62",
                        "Mt Gravatt East School - 61",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Cavendish Rd at Seton College stop 59/56",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Turquoise Street, stop 49/43",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Pampling Street, stop 29",
                        "Old Cleveland Rd at Madeline Street, stop 27",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Bennetts Rd at Pattison Avenue, stop 27",
                        "Bennetts Rd at Acfold Street, stop 28",
                        "Bennetts Rd at Bennetts Bushland, stop 29",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Virginia Ave near Aaron Ave",
                        "Lindsay St at Barton Street, stop 22b",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Fifth Avenue, stop 33",
                        "Lytton Rd opp Balmoral High School",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Bennetts Rd near Jean Howie Dr, stop 20",
                        "Old Cleveland Rd at Kismet Street Stop 26",
                        "Old Cleveland Rd at Madeline Street Stop 27",
                        "Old Cleveland Rd at Dorothy Lane Stop 28",
                        "Old Cleveland Rd at Pampling Street Stop 29",
                        "Old Cleveland Rd at Camp Hill",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Newnham Rd at Condong Street, stop 63/70",
                        "Broadwater Rd near Newnham Rd, stop 72",
                        "Broadwater Rd near Cresthaven Dr, stop 74",
                        "Ham Rd at Toulon Street, stop 76",
                        "Mannetto St near Cummin St, stop 83",
                        "Delavan St at Delavan Terminus, stop 87/78",
                        "Newnham Rd at Tryon St",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2"
                    ],
                    "8014: Wellers Hill, Holland Park, Cannon Hill": [
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Monash Rd at Monash Park, stop 56",
                        "Monash Rd at Monash Bushland, stop 55",
                        "Monash Rd at Craigmont Street, stop 54",
                        "Monash Rd at Aldora Street, stop 53",
                        "Monash Rd at Ferrand Street, stop 52",
                        "Monash Rd near Kaypee St, stop 51",
                        "Monash Rd at Monash Road Shops, stop 49",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Toohey Rd at Bramston Terrace, stop 47",
                        "Toohey Rd at Chamberlain Street, stop 46a",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Denham Terrace, stop 44/41",
                        "Cracknell Rd at Toohey Road, stop 40",
                        "Cracknell Rd at Ellington Street, stop 38",
                        "Cracknell Rd at Laura Street, stop 37",
                        "Sexton St near Barr St",
                        "Sexton St near Effingham St",
                        "Logan Rd at CB Mott Park, stop 26",
                        "Abbotsleigh St opp Holland Park Primary School",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Emlyn Street, stop 31/30",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Shire Street, stop 28/27",
                        "Cavendish Rd at Coorparoo Shops, stop 26",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Old Cleveland Rd at Macauly Street, stop 22",
                        "Old Cleveland Rd at Saint Leonards Street Stop 21",
                        "Villanova College",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Burke Street Stop 25",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Bennetts Rd at Pattison Avenue, stop 27",
                        "Bennetts Rd at Acfold Street, stop 28",
                        "Bennetts Rd at Bennetts Bushland, stop 29",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Virginia Ave near Aaron Ave",
                        "Pashen St at Hawthorne Park, stop 46",
                        "Pashen St at Morningside State School, stop 47",
                        "Pashen St at Talma Street, stop 48",
                        "Pashen St near Thynne Rd, stop 49",
                        "Thynne Rd at Belgrave Street, stop 28",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Lytton Rd opp Balmoral High School",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Wynnum Rd at Balmoral Cemetery, stop 23",
                        "Old Cleveland Rd at Burke Street, stop 25",
                        "Cavendish Rd at Shire Street, stop 27/28",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd near Kanumbra St",
                        "Cavendish Rd near Pelham St",
                        "Abbotsleigh St at Holland Park Primary School",
                        "Cracknell Rd at Esther Street, stop 36",
                        "Cracknell Rd near Effingham St",
                        "Cracknell Rd at Fingal Street, stop 39",
                        "Monash Rd at Monash Bushlands, stop 55",
                        "Messines Ridge Rd at Messines Bushland, stop 57/58",
                        "Messines Ridge Rd at Algona Street, stop 59",
                        "Messines Ridge Rd at Carloch Street, stop 60",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2"
                    ],
                    "8015: Sunnybank, Mt Gravatt, Carindale, Moreton Bay Coll": [
                        "Underwood Rd near Warrigal Rd, stop 89",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Warrigal Road Primary School",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Padstow Views",
                        "Padstow Rd at Devonlea",
                        "McCullough St at Granadilla",
                        "Turton St near Mains Rd",
                        "Turton St near Boorman St",
                        "Turton St near Gager St",
                        "Turton St at Oasis",
                        "Station Rd at Oasis Gardens, stop 79",
                        "Station Rd at Wen Place, stop 80",
                        "McCullough St at Station Road, stop 80a",
                        "McCullough St at Matt Street, stop 81",
                        "McCullough St at Sunnybank Plaza",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Robertson",
                        "Kessels Rd at Grout Street, stop 2/58",
                        "Kessels Rd at MacGregor, stop 59",
                        "Garden City Shopping Centre station, stop N",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Fairland Street",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Creek Rd at Greenmeadows South",
                        "Creek Rd at Greenmeadow",
                        "Pine Mountain Rd near Brechin St",
                        "Pine Mountain Rd near Flame Tree Cr",
                        "Pine Mountain Rd near Linwood St",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Pine Mountain Rd near Gretna St",
                        "Creek Rd at Salvin Park, stop 69",
                        "Donnington St at Stanmere, stop 52",
                        "Donnington St at Donnington, stop 53",
                        "Carindale Shopping Centre station, platform G",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Cadogan St at Bamburgh Street, stop 67/53",
                        "Cadogan St at Whitecastle Street, stop 65/54",
                        "Cadogan St at Cadogan Park, stop 65/54a",
                        "Cadogan St at Breadsell Street, stop 64/63",
                        "Cadogan St at Rolls Court, stop 62",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Manly Rd at Leon, stop 43",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Wondall Rd near Manly Rd",
                        "Moreton Bay Girls College",
                        "Wondall Rd at Moreton Bay College",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Cadogan St at Breadsell Street, stop 63/64",
                        "Cadogan St at Whitecastle Street, stop 66/54",
                        "Carindale Shopping Centre station",
                        "Creek Rd near Donnington St, stop 70",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Creek Rd at Greek Memorial, stop 59b",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Kessels Rd at Grout Street, stop 58",
                        "McCullough St near Chadford St"
                    ],
                    "8016: Salisbury, Wellers Hill, East Brisbane": [
                        "Logan Rd near Kingston Rd",
                        "Logan Rd at Celia Street",
                        "Logan Rd at Harris Road",
                        "Underwood Rd at Levington, stop 85",
                        "Underwood Rd at Mapleleaf Street, stop 88",
                        "Underwood Rd near Warrigal Rd, stop 89",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Warrigal Road Primary School",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Padstow Views",
                        "Padstow Rd at Devonlea",
                        "McCullough St at Granadilla",
                        "McCullough St at Matt Street, stop 81",
                        "McCullough St at Brooklands",
                        "Troughton Rd near Vereker St",
                        "Troughton Rd at Brittain Park",
                        "Troughton Rd at Musgrave Road, stop 39",
                        "Troughton Rd at QEII Hospital, stop 37",
                        "Orange Grove Rd at Salisbury East, stop 51",
                        "Henson Rd at Salisbury East, stop 50",
                        "Henson Rd at Meynell Street, stop 49a",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Henson Rd at Ainger Street, stop 48",
                        "Cripps St at Ness Road, stop 47",
                        "Cripps St at Douglas Rd, stop 45/46",
                        "McCarthy Rd near Cubitt St, stop 44",
                        "Evans Rd at Pentex Street, stop 43",
                        "Evans Rd at Industries Street, stop 42/41",
                        "Evans Rd at Standish Street, stop 40",
                        "Evans Rd at Nettleton Crescent, stop 39/38",
                        "Beaudesert Rd at Muriel - Evans, stop 37",
                        "Beaudesert Rd at Fegan Drive, stop 36",
                        "Beaudesert Rd at Keats Street, stop 35",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Dora Street, stop 33",
                        "Mayfield Rd at Kipling Street, stop 31a",
                        "Mayfield Rd at Harlock Street, stop 31",
                        "Mayfield Rd at Hermes Street, stop 30d",
                        "Tarragindi Rd at Moresby Street, stop 30c",
                        "Tarragindi Rd at La Monte Street, stop 30b",
                        "Tarragindi Rd at Tarragindi Hill Reserve, stop 29a",
                        "Beverley Hill St near Millicent St, stop 28",
                        "Glendale Gr near Moorland St, stop 27a",
                        "Glendale Gr at MacKenzie Place, stop 27",
                        "Sarah St at Hamlet Street, stop 26",
                        "Tarragindi Rd at Kenneth Street, stop 36",
                        "Andrew Ave at Bailey Street, stop 37",
                        "Andrew Ave at Tarragindi Bowls, stop 38a",
                        "Andrew Ave near Fernvale Rd, stop 38",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Chamberlain Street, stop 46a",
                        "Toohey Rd at Bramston Terrace, stop 47",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Marshall Rd at Chamberlain Street, stop 49",
                        "Garioch St near Pozieres Rd, stop 51",
                        "Pozieres Rd at Belvedere Street, stop 52",
                        "Messines Ridge Rd near Queensthorpe St, stop 53A",
                        "Bapaume Rd near Peronne Rd, stop 54",
                        "Holland Park West station Kiss and Ride HnR",
                        "Logan Rd at Holland Park South, stop 31",
                        "Holland Rd near Stewart St, stop 44",
                        "Holland Rd at Greenmount Avenue, stop 45",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Chatsworth Rd at Stirrat Street, stop 31",
                        "Chatsworth Rd at Trundle Street, stop 30",
                        "Upper Cornwall St at Upper Cornwall, stop 29",
                        "Upper Cornwall St at Pembroke Rd, stop 28",
                        "Villanova College",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Burke Street Stop 25",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Bennetts Rd at Pattison Avenue, stop 27",
                        "Bennetts Rd at Acfold Street, stop 28",
                        "Bennetts Rd at Bennetts Bushland, stop 29",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Wynnum Rd at Balmoral Street, stop 21",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Wynnum Rd at Canning Bridge, stop 17",
                        "Oaklands Pde at Churchie Senior School",
                        "Oaklands Pde at Anglican Church Grammar School",
                        "Oaklands Pde at Churchie Junior School",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd near Kanumbra St",
                        "Cavendish Rd near Pelham St",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Holland Rd near Rita St, stop 44",
                        "Holland Rd at Lamette Avenue, stop 43A",
                        "Bapaume Rd near Mulsanne Rd, stop 61/57",
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd at Dobbs Street, stop 63",
                        "Pozieres Rd at Messines Ridge Road, stop 53",
                        "Garioch St near Marieander St, stop 51",
                        "Marshall Rd at Heathwhite Street, stop 50",
                        "Marshall Rd at Hexham Street, stop 49",
                        "Fernvale Rd near Salkeld St",
                        "Tarragindi Rd at Bailey Street, stop 37",
                        "Sarah St at MacKenzie Place, stop 27",
                        "Evans Rd at Nettleton Crescent, stop 38/39",
                        "McCarthy Rd at Russ Hall Park, stop 45",
                        "Cripps St at Douglas Rd, stop 46",
                        "Henson Rd near Ainger St, stop 48",
                        "Troughton Rd at QEII Hospital",
                        "Troughton Rd at Musgrave Road",
                        "McCullough St at Station Road, stop 80a",
                        "McCullough St at Sunnybank Plaza",
                        "McCullough St near Chadford St",
                        "Underwood Rd at Levington Rd, stop 85",
                        "Logan Rd at Underwood Villas",
                        "Kingston Rd at Curban Street"
                    ],
                    "8017: Mt Gravatt, Carindale, Cannon Hill": [
                        "Mackenzie State Primary School",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Winstanley St at Winstanley East",
                        "Winstanley St near Talavera St",
                        "Winstanley St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Winstanley St at Laurie Street, stop 48/47",
                        "Winstanley St at Willard Street, stop 46",
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Darcy Rd near Solander St, stop 50",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Minnippi Bvd",
                        "Richmond Rd at Richmond East",
                        "Richmond Rd at Molloy Road",
                        "Junction Rd at Colmslie, stop 53",
                        "Junction Rd at Algoori Street, stop 54",
                        "Junction Rd at Beelarong Street, stop 55",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Wynnum Rd at Abinger, stop 29",
                        "Thynne Rd at Belgrave Street, stop 28",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Hawthorne Rd near Lytton Rd",
                        "Hawthorne Rd near Barton St",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Bennetts Rd at Bennetts Bushland, stop 29",
                        "Bennetts Rd at Pattison Avenue, stop 27",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Old Cleveland Rd at Burke Street, stop 25",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Coorparoo, stop 23",
                        "Old Cleveland Rd at Macauly Street, stop 22",
                        "Villanova College",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Riding Rd at Miles Street, stop 24",
                        "Virginia Ave near Aaron Ave",
                        "Uhlmann St near Harris Street, stop 22a",
                        "Lytton Rd at Fifth Avenue, stop 33",
                        "Richmond Rd near Imperial Ave, stop 58",
                        "Richmond Rd at Ludwick Street, stop 66",
                        "Creek Rd at Foxmont Drive, stop 49",
                        "Darcy Rd near Mayfair St, stop 50",
                        "Darcy Rd near Madison Pl",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Winstanley St near Birdwood Rd, stop 45",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St near Firmiston St",
                        "Winstanley St near Hedlow Ct",
                        "Scrub Rd at Winstanley East",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Pine Mountain Rd near Gretna St",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Creek Rd at Greenmeadow",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Wecker Rd Business Center, stop 63",
                        "Wecker Rd at Dividend Street, stop 64a",
                        "Wecker Rd at Eastwood Drive, stop 64b",
                        "Ham Rd at Banika Street, stop 64c",
                        "Ham Rd at Linfield Street, stop 64d",
                        "Ham Rd near Kelnat St",
                        "Ham Rd at Mansfield State School",
                        "Ham Rd near Rupari St",
                        "Mansfield High and Junior Schools",
                        "Broadwater Rd at Mansfield Park",
                        "Grieve Rd at Rochedale Rd hail 'n' ride"
                    ],
                    "8018: Wellers Hill, Carindale, Cannon Hill": [
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Chamberlain Street, stop 46a",
                        "Toohey Rd at Bramston Terrace, stop 47",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Monash Rd at Monash Road Shops, stop 49",
                        "Monash Rd near Ferrand St, stop 51",
                        "Monash Rd at Ferrand Street, stop 52",
                        "Monash Rd at Aldora Street, stop 53",
                        "Monash Rd at Craigmont Street, stop 54",
                        "Monash Rd at Monash Bushlands, stop 55",
                        "Monash Rd at Monash Park, stop 56",
                        "Nursery Rd at Gaza Road, stop 64",
                        "Nursery Rd at Flynn Street, stop 65",
                        "Nursery Rd at Iris Street, stop 67",
                        "Nursery Rd at Miriam Street, stop 68",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Fairland Street",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Creek Rd at Greenmeadows South",
                        "Creek Rd at Greenmeadow",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd at Salvin Park, stop 69",
                        "Donnington St at Stanmere, stop 52",
                        "Donnington St at Donnington, stop 53",
                        "Carindale Shopping Centre station, platform H",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Cadogan St at Bamburgh Street, stop 67/53",
                        "Cadogan St at Whitecastle Street, stop 65/54",
                        "Cadogan St at Cadogan Park, stop 65/54a",
                        "Baynes St near Sherborne St, stop 55",
                        "Meadowlands Rd at Epala Street, stop 56",
                        "Meadowlands Rd at Hilltop Court, stop 57",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Old Stockyards",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Junction Rd at Colmslie, stop 53",
                        "Junction Rd at Algoori Street, stop 54",
                        "Junction Rd at Beelarong Street, stop 55",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Grenade St near Barrack Rd, stop 59",
                        "Creek Rd at Old Stockyards, stop 66a",
                        "Creek Rd at Foxmont Drive, stop 49",
                        "Creek Rd at Carina North near Billan St",
                        "Baynes St near Stevenson Ct, stop 55",
                        "Cadogan St at Whitecastle Street, stop 66/54",
                        "Carindale Shopping Centre station",
                        "Creek Rd near Donnington St, stop 70",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Creek Rd at Greek Memorial, stop 59b",
                        "Logan Rd at Big Top, stop 35a",
                        "Nursery Rd at Marvin Street, stop 66",
                        "Monash Rd at Monash Bushland, stop 55",
                        "Monash Rd near Kaypee St, stop 51"
                    ],
                    "8019: Eight Mile Plains, Tarragindi, Coopooroo": [
                        "Rochedale station, platform 1",
                        "Eight Mile Plains station, platform 1",
                        "Upper Mt Gravatt station, platform 1",
                        "Griffith University station, platform 1",
                        "Mains Road park 'n' ride",
                        "Kessels Rd near Troughton Rd, stop 55",
                        "Orange Grove Rd at Salisbury East, stop 51",
                        "Henson Rd at Salisbury East, stop 50",
                        "Henson Rd at Meynell Street, stop 49a",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Henson Rd at Ainger Street, stop 48",
                        "Cripps St at Ness Road, stop 47",
                        "Cripps St at Douglas Rd, stop 45/46",
                        "McCarthy Rd near Cubitt St, stop 44",
                        "Evans Rd at Pentex Street, stop 43",
                        "Evans Rd at Industries Street, stop 42/41",
                        "Evans Rd at Standish Street, stop 40",
                        "Evans Rd at Nettleton Crescent, stop 39/38",
                        "Beaudesert Rd at Muriel - Evans, stop 37",
                        "Beaudesert Rd at Fegan Drive, stop 36",
                        "Beaudesert Rd at Keats Street, stop 35",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Dora Street, stop 33",
                        "Mayfield Rd at Kipling Street, stop 31a",
                        "Mayfield Rd at Harlock Street, stop 31",
                        "Mayfield Rd at Hermes Street, stop 30d",
                        "Tarragindi Rd at Moresby Street, stop 30c",
                        "Tarragindi Rd at La Monte Street, stop 30b",
                        "Tarragindi Rd at Tarragindi Hill Reserve, stop 29a",
                        "Beverley Hill St near Millicent St, stop 28",
                        "Glendale Gr near Moorland St, stop 27a",
                        "Glendale Gr at MacKenzie Place, stop 27",
                        "Sarah St at Hamlet Street, stop 26",
                        "Tarragindi Rd at Kenneth Street, stop 36",
                        "Andrew Ave at Bailey Street, stop 37",
                        "Andrew Ave at Tarragindi Bowls, stop 38a",
                        "Andrew Ave near Fernvale Rd, stop 38",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Chamberlain Street, stop 46a",
                        "Toohey Rd at Bramston Terrace, stop 47",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Marshall Rd at Chamberlain Street, stop 49",
                        "Garioch St near Pozieres Rd, stop 51",
                        "Pozieres Rd at Belvedere Street, stop 52",
                        "Messines Ridge Rd near Queensthorpe St, stop 53A",
                        "Holland Park West station Kiss and Ride HnR",
                        "Logan Rd at Holland Park South, stop 31",
                        "Holland Rd near Stewart St, stop 44",
                        "Holland Rd at Greenmount Avenue, stop 45",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Emlyn Street, stop 31/30",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Shire Street, stop 28/27",
                        "Old Cleveland Rd at Macauly Street, stop 22",
                        "Villanova College",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Leicester St at Halstead Street",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd near Kanumbra St",
                        "Cavendish Rd near Pelham St",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Holland Rd near Rita St, stop 44",
                        "Holland Rd at Lamette Avenue, stop 43A",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Messines Ridge Rd near Queensthorpe St",
                        "Pozieres Rd at Messines Ridge Road, stop 53",
                        "Garioch St near Marieander St, stop 51",
                        "Marshall Rd at Heathwhite Street, stop 50",
                        "Marshall Rd at Hexham Street, stop 49",
                        "Tarragindi Rd at Bailey Street, stop 37",
                        "Sarah St at MacKenzie Place, stop 27",
                        "Evans Rd at Nettleton Crescent, stop 38/39",
                        "Evans Rd at Industries Street, stop 41/42",
                        "McCarthy Rd at Russ Hall Park, stop 45",
                        "Cripps St at Douglas Rd, stop 46",
                        "Henson Rd near Ainger St, stop 48",
                        "Henson Rd at Meynell Street, stop 49A",
                        "Kessels Rd at Griffith Road, stop 55",
                        "Kessels Rd at Estoril Street, stop 56",
                        "Griffith University station, platform 2",
                        "Upper Mt Gravatt station, platform 2",
                        "Eight Mile Plains station, platform 2",
                        "Rochedale station, platform 2"
                    ],
                    "801: Learoyd Rd (Willawong) - Calamvale College": [
                        "Learoyd Rd near Gooderham Rd",
                        "Learoyd Rd at Paradise",
                        "Learoyd Rd at Range View",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Algester Rd at Parkinson East, stop 92",
                        "Beaudesert Rd at Illaweena Street",
                        "Beaudesert Rd at Calamvale College",
                        "Beaudesert Rd at Kameruka Street",
                        "Calamvale Community College",
                        "Beaudesert Rd near Honeysuckle Way",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Algester Rd at Lichfield Place, stop 93",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Algester",
                        "Algester Rd at Dellforest Drive Stop 78"
                    ],
                    "8022: Carindale, Morningside, MBC, MBBC": [
                        "Greendale Way at Ridgeview St",
                        "Greendale Way at Empress Drive",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Winstanley St at Winstanley East",
                        "Winstanley St near Talavera St",
                        "Winstanley St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Winstanley St at Laurie Street, stop 48/47",
                        "Winstanley St at Willard Street, stop 46",
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Old Cleveland Rd at Camp Hill, stop 30",
                        "Old Cleveland Rd at Pampling Street, stop 29",
                        "Old Cleveland Rd at Madeline Street, stop 27",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Govett Ave at Leura Avenue, stop 27",
                        "Oxford St at Wambool Street, stop 31",
                        "Riding Rd at Bulimba Preschool, stop 35/41",
                        "Riding Rd near Fifth Ave, stop 34/42",
                        "Riding Rd at Main Avenue, stop 33/43",
                        "Riding Rd at Victoria Street, stop 32/44",
                        "Riding Rd at Grosvenor Street, stop 31/45",
                        "Pashen St at Hawthorne Park, stop 46",
                        "Pashen St at Morningside State School, stop 47",
                        "Pashen St at Talma Street, stop 48",
                        "Pashen St near Thynne Rd, stop 49",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd near Thornlake Ct",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Wondall Rd near Manly Rd",
                        "Moreton Bay Girls College",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Manly Rd at Leon, stop 43",
                        "Wynnum Rd near Belmont Rd",
                        "Wynnum Rd at Tingalpa West near Stanton Rd",
                        "Riding Rd near Sixth Ave, stop 34/42",
                        "Stuart St at Leura Avenue, stop 27",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Old Cleveland Rd at Burke Street, stop 25",
                        "Leicester St at Halstead Street",
                        "Leicester St near York St",
                        "Newman Ave at Kelsey Street, stop 35",
                        "Newman Ave near Lavington St, stop 36",
                        "Newman Ave at Lavington Street, stop 37",
                        "Chatsworth Rd at Arc Street, stop 40",
                        "Winstanley St near Birdwood Rd, stop 45",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St near Firmiston St",
                        "Winstanley St near Hedlow Ct",
                        "Scrub Rd at Winstanley East"
                    ],
                    "8024: Kuraby, Rochedale, Underwood, JPC, Mable Park": [
                        "Stiller Dr at Beenleigh Rd, stop 90",
                        "Stiller Dr at Balmoral St, stop 89",
                        "Stiller Dr at Crestwood St, stop 88",
                        "Stiller Dr at Redland Close, stop 87",
                        "Franquin Cr at Underwood Rd, stop 86",
                        "Underwood Rd at Mapleleaf Street, stop 88",
                        "Underwood Rd near Warrigal Rd, stop 89",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Warrigal Road Primary School",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Padstow Views",
                        "Padstow Rd near Logan Rd",
                        "Logan Rd at Miles Platting Road, stop 82",
                        "Logan Rd at Brandl Street, stop 83",
                        "Gaskell St at The Glen, stop 84",
                        "Gaskell St at Alan Crescent, stop 86",
                        "Gaskell St near Underwood Rd, stop 87",
                        "Underwood Rd at Levington Rd, stop 85",
                        "Eight Mile Plains Primary School",
                        "Underwood Rd near Centre Pl",
                        "Underwood Rd near Gerrans St",
                        "Underwood Rd near Rochedale Rd",
                        "Underwood Rd at Graham Hogg Park",
                        "Underwood Rd near Winston St",
                        "Underwood Rd near Woodlands Dr",
                        "Underwood Rd near Lancelot St",
                        "Underwood Rd near Kiato St",
                        "Underwood Rd near Belmore Dr",
                        "Exilis St near Finfoot St",
                        "Exilis St near Minutus St",
                        "Parfrey Rd near Brompton St",
                        "Parfrey Rd near Stannard St",
                        "Parfrey Rd near Dorset Dr",
                        "Springwood Rd at Springwood High School",
                        "Springwood Rd at Springwell Avenue",
                        "Springwood Rd at Trevallyan Drive",
                        "Daisy Hill Rd at Highview Terrace",
                        "John Paul College",
                        "Lyndale St at Celosia Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Trinette Street",
                        "Upper Lyndale St at Arnold Street",
                        "Roselea St at Kimberley Plaza",
                        "Roselea St at Hailar Street",
                        "Roselea St at Cooba Court",
                        "Shailer Rd near Oregon Dr",
                        "Shailer Rd near Hester St",
                        "Shailer Rd near Francis Rd",
                        "Winnetts Rd near Dahlia St",
                        "Pacific Hwy at Segovia Way",
                        "Mabel Park Primary School",
                        "Springwood Rd at Karawatha Street",
                        "Parfrey Rd near Knightsbridge Cr",
                        "Parfrey Rd near Parkwood St",
                        "Exilis St near Nule St",
                        "Exilis St near Underwood Rd",
                        "Underwood Rd near Cilla Ct",
                        "Underwood Rd near Koobil St",
                        "Underwood Rd near Somerset St",
                        "Underwood Rd near Dalhouse Ct",
                        "Underwood Rd at Levington, stop 85",
                        "Gaskell St at Angel Street, stop 85",
                        "Stiller Dr at Woodglen St, stop 87"
                    ],
                    "8025: Mt Gravatt, Springwood, Rochedale": [
                        "Garden City Shopping Centre station, stop N",
                        "Kessels Rd at MacGregor, stop 59",
                        "Kessels Rd at Grout Street, stop 58",
                        "Mains Rd at Sunnybank",
                        "McCullough St near Chadford St",
                        "Comley St near Delafield St, stop 75",
                        "Comley St at Arcoona Street, stop 74",
                        "Arcoona St at Hedina Street, stop 73",
                        "Arcoona St at Jundal Street, stop 72",
                        "Kylie St near Norinda St, stop 71",
                        "Selvage St near Mains Rd, stop 75/70",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Beenleigh Rd near Ardargie St",
                        "Beenleigh Rd at Runcorn Railway, stop 72",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Beenleigh Rd at Fruitgrove station",
                        "Beenleigh Rd at Kuraby station, stop 92",
                        "Beenleigh Rd at Kuraby Primary School",
                        "Beenleigh Rd near Stiller Dr",
                        "Beenleigh Rd at Logan Road",
                        "Logan Rd near Kingston Rd",
                        "Fitzgerald Ave at Fitzgerald Avenue",
                        "Cinderella Dr at Arndale Shopping Centre",
                        "Springwood Rd at Cinderella Drive",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd at Underwood Rd",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Packman Ave",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Miles Platting Rd near Rochedale Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Miles Platting Rd at Gardner Rd",
                        "School Rd near Priestdale Rd",
                        "Priestdale Rd opp Rochedale High School",
                        "Rochedale State High School",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Kumbari Street hail 'n' ride",
                        "Cinderella Dr at Collene Grove",
                        "Kuraby station",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Arcoona St near Valhalla St, stop 74",
                        "Comley St near Melaleuca St, stop 75",
                        "McCullough St at Granadilla",
                        "Garden City Shopping Centre station, stop K"
                    ],
                    "8026: Rochedale South, Sunnybank, John Paul College": [
                        "Miles Platting Rd near Rochedale Rd",
                        "Miles Platting Rd at Brilliant Place",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at McKechnie Dr",
                        "Miles Platting Rd at Technology Park",
                        "Padstow Rd near Logan Rd",
                        "Padstow Rd at Devonlea",
                        "McCullough St at Granadilla",
                        "Mains Rd at Sunnybank",
                        "Troughton Rd at Brittain Park",
                        "McCullough St at Brooklands",
                        "McCullough St at Matt Street, stop 81",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Compton Rd at Sunnybank Hills Shops, stop 83",
                        "Compton Rd near Chateau St, stop 84",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd near Blackbean St",
                        "Nemies Rd at Runcorn West",
                        "Nemies Rd at Runcorn Heights",
                        "Nursery Ave at Runcorn",
                        "Nursery Ave near Marika St",
                        "Beenleigh Rd at Fruitgrove station",
                        "Beenleigh Rd at Kuraby station, stop 92",
                        "Beenleigh Rd at Kuraby Primary School",
                        "Beenleigh Rd near Stiller Dr",
                        "Beenleigh Rd at Logan Road",
                        "Logan Rd near Kingston Rd",
                        "Springwood Rd at Sports Drive",
                        "Cinderella Dr at Collene Grove",
                        "Barbaralla Dr at Barbaralla Park",
                        "Chatswood Rd at Hawkins Street",
                        "John Paul College",
                        "Chatswood Rd near Evenwood St",
                        "Chatswood Rd at Coleman Crescent",
                        "Chatswood Rd at Brentwood Drive",
                        "Kuraby station",
                        "Nursery Ave at Runcorn near Silkyoak St",
                        "Nemies Rd at Runcorn Heights near Basking St",
                        "Nemies Rd near Runcorn Heights Primary School",
                        "Nemies Rd at Runcorn West near Belyando St",
                        "Gowan Rd at Calliope Street, stop 79",
                        "Compton Rd near Chateau St, stop 25",
                        "Calam Rd near Lear St",
                        "Calam Rd near Celadon St",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Pristina Street, stop 79",
                        "Troughton Rd near Vereker St",
                        "McCullough St near Chadford St",
                        "Miles Platting Rd at Mersey St",
                        "Rochedale Rd near Miles Platting Rd"
                    ],
                    "8027: Mable Park - Logan Central, Shailer Park, JPC": [
                        "Mabel Park Primary School",
                        "Wembley Rd at Logan City Centre",
                        "Logan Central station, platform 1",
                        "Wembley Rd at Wilbur Street",
                        "Kingston Rd at Market Square",
                        "Pacific Hwy at Segovia Way",
                        "Winnetts Rd near Dahlia St",
                        "Shailer Rd at Hester St",
                        "Shailer Rd near Oregon Dr",
                        "Roselea St at Cooba Court",
                        "Roselea St at Hailar Street",
                        "Roselea St at Roselea Park",
                        "Upper Lyndale St at Arnold Street",
                        "Lyndale St at Trinette Street",
                        "Lyndale St at Davina Street",
                        "Lyndale St at Elita Street",
                        "Lyndale St at Scarlet Park",
                        "Lyndale St at Celosia Street",
                        "Daisy Hill Rd at Lyndale Street",
                        "Daisy Hill Rd at Gladewood Drive",
                        "Chatswood Rd at John Paul College",
                        "John Paul College"
                    ],
                    "8028: Runcorn, Algester, John Paul College": [
                        "Kuraby station",
                        "Beenleigh Rd at Fruitgrove station",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Beenleigh Rd at Runcorn Railway, stop 72",
                        "Gowan Rd at Darnell Street, stop 73",
                        "Gowan Rd near Coori Street, stop 74",
                        "Hellawell Rd near Hillcrest St, stop 73/16",
                        "Hellawell Rd at Signata Street",
                        "Hellawell Rd at Stringybark Street, stop 75",
                        "Hellawell Rd at Cazna Gardens",
                        "Learoyd Rd at Range View",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Nottingham Rd near Algester Rd",
                        "Nottingham Rd at Avondale",
                        "Nottingham Rd at Lakewood",
                        "Honeysuckle Way at Sunflower",
                        "Honeysuckle Way at Calamvale",
                        "Gowan Rd at The Parks",
                        "Gowan Rd near Kameruka St",
                        "Gowan Rd at Parkside",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd at Calam North, stop 35",
                        "Compton Rd at Frizzell Street, stop 85",
                        "Compton Rd at Kyabra Street, stop 86",
                        "Compton Rd at Piccadilly Way, stop 28",
                        "Compton Rd near North Rd",
                        "Compton Rd near Pendrey Ct",
                        "Kingston Rd at Compton Rd",
                        "Kingston Rd at Monte Street",
                        "Kingston Rd at Park Road",
                        "Reserve Rd near Gomana St",
                        "Lake Rd near Endota St",
                        "Lake Rd near Carribean Dr",
                        "John Paul College",
                        "Reserve Rd near Kunari St",
                        "Kingston Rd at Rudge Street",
                        "Kingston Rd at Booran Drive",
                        "Compton Rd near Kyabra Street, stop 86",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd near Palatine St, stop 36",
                        "Honeysuckle Way at The Parks",
                        "Nottingham Rd near Appleby St",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Algester",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Hellawell Rd at Hillcrest Street, stop 72a",
                        "Hellawell Rd near Peppercorn Pl",
                        "Gowan Rd near Darnell Street, stop 73",
                        "Beenleigh Rd at Kuraby station, stop 92"
                    ],
                    "8029: Runcorn, Stretton, Calamvale, Redeemer, Rochedale": [
                        "Logan Rd near Kingston Rd",
                        "Beenleigh Rd at Logan Road",
                        "Beenleigh Rd at Kuraby Primary School",
                        "Kuraby station",
                        "Persse Rd at The Oaks",
                        "Persse Rd near Gumtree St",
                        "Compton Rd at Piccadilly Way, stop 28",
                        "Compton Rd near Kyabra Street, stop 86",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Pennant Hills",
                        "Kameruka St near Golden Ave",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd near Honeysuckle Way",
                        "Nottingham Rd near Appleby St",
                        "Nottingham Rd at Lakewood",
                        "Nottingham Rd at Avondale",
                        "Nottingham Rd near Algester Rd",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Laurel Oak Drive Stop 90A",
                        "Algester Rd at Crestone Street Stop 90/89",
                        "Algester Rd at Formby Street Stop 88A",
                        "Endiandra St at Macaranga Street, stop 88",
                        "Endiandra St near Macaranga St, stop 87",
                        "Endiandra St at Bonewood Street, stop 86/85",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Algester",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Learoyd Rd at Range View",
                        "Hellawell Rd at Cazna Gardens",
                        "Hellawell Rd at Stringybark Street, stop 75",
                        "Hellawell Rd at Signata Street",
                        "Hellawell Rd at Hillcrest Street, stop 72a",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Compton Rd near Chateau St, stop 84",
                        "Gowan Rd near Blackbean St",
                        "Gowan Rd near Coori Street, stop 74",
                        "Gowan Rd near Darnell Street, stop 73",
                        "Beenleigh Rd at Runcorn Railway, stop 72",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Beenleigh Rd at Fruitgrove station",
                        "Warrigal Rd at Fruitgrove",
                        "Warrigal Rd at Runcorn North",
                        "Underwood Rd near Warrigal Rd, stop 89",
                        "Underwood Rd at Mapleleaf Street, stop 88",
                        "Underwood Rd at Levington Rd, stop 85",
                        "Eight Mile Plains Primary School",
                        "Rochedale Rd near Fielding Dr",
                        "Redeemer Lutheran College",
                        "Miles Platting Rd near Rochedale Rd",
                        "Priestdale Rd opp Rochedale High School",
                        "Rochedale State High School",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Underwood Rd at Levington, stop 85",
                        "Beenleigh Rd at Kuraby station, stop 92",
                        "Beenleigh Rd near Stiller Dr",
                        "Kingston Rd at Curban Street"
                    ],
                    "802: MacGregor High - Coopers Plains": [
                        "Springfield St at MacGregor High School",
                        "Parkway St near Springfield St, stop 80",
                        "Granadilla St at Mimosa Creek, stop 79",
                        "Granadilla St at Ceriman Street, stop 78",
                        "Granadilla St near Darlington St, stop 7",
                        "Granadilla St at Sunderland Street, stop 76",
                        "Comley St near Delafield St, stop 75",
                        "Comley St at Arcoona Street, stop 74",
                        "Arcoona St at Hedina Street, stop 73",
                        "Arcoona St at Jundal Street, stop 72",
                        "Kylie St near Norinda St, stop 71",
                        "Selvage St near Mains Rd, stop 75/70",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Wynne St near Garro St, stop 75",
                        "Wynne St at Torbey Street, stop 74",
                        "Chilton St near Taminga St, stop 73",
                        "Chilton St at Garro Street, stop 72",
                        "Chilton St at Janina Street, stop 71",
                        "Stones Rd at Stones Road Reservoir, stop 70",
                        "Stones Rd near Lang St, stop 69",
                        "Lang St near Newcombe St, stop 68",
                        "Findon St near Jackson Rd, stop 67",
                        "Goman St at Exton Street, stop 65",
                        "Goman St near Ditton Rd, stop 64/63",
                        "Ditton Rd at Cromer Street, stop 62",
                        "Ditton Rd near Beaudesert Rd, stop 61",
                        "Beenleigh Rd at Morden Road, stop 60",
                        "Lensworth St near Selhurst St, stop 59",
                        "Boundary Rd at Rosedale Street, stop 45",
                        "Orange Grove Rd at Joyce Street, stop 57",
                        "Orange Grove Rd at Rookwood Avenue, stop 56",
                        "Orange Grove Rd at Bosworth Street, stop 55"
                    ],
                    "8030: Mackenzie, Carindale,Mt Gravatt, John Paul College": [
                        "Gardner Rd at Arise Boulevard",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Winstanley St near Talavera St",
                        "Winstanley St at Firmiston",
                        "Carindale Shopping Centre station, platform I",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Creek Rd near Donnington St, stop 71",
                        "Creek Rd near Donnington St, stop 70",
                        "Creek Rd at Salvin Park, stop 69",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Creek Rd at Greenmeadow",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Creek Rd at Greek Memorial, stop 59b",
                        "Creek Rd at Fairland Street",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Wishart Rd at Newnham Road, stop 44/74",
                        "Wishart Rd near Pasley St, stop 75",
                        "Wishart Rd near Invicta St",
                        "Wishart Rd near Elkana Pl, stop 76",
                        "Wishart Rd near Ham Rd, stop 77",
                        "Ham Rd at Koola Street, stop 78",
                        "Boyanda St near Tyrrell St, stop 79",
                        "Mindona St at Mindona Park, stop 80",
                        "Greenwood St near Kavanagh Rd, stop 81",
                        "Delavan St at Delavan Street Park, stop 85",
                        "Delavan St at Wolcott Street, stop 86",
                        "Delavan St at Delavan Terminus, stop 87/78",
                        "Newnham Rd at Tryon St",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station, stop N",
                        "Eight Mile Plains station, platform 2",
                        "Priestdale Rd opp Rochedale High School",
                        "Redeemer Lutheran College",
                        "Rochedale Rd near Fielding Dr",
                        "Rochedale Rd near Underwood Rd",
                        "Rochedale Rd near Sunningdale Ave",
                        "Rochedale Rd near Fitzgerald Ave Mapping Only",
                        "Springwood station, platform 3",
                        "Rochedale Rd at Springwood Plaza",
                        "John Paul College",
                        "Springwood station, platform 1",
                        "Rochedale Rd near Rangeview St",
                        "Rochedale Rd at Underwood Rd",
                        "St Peters Primary",
                        "Rochedale State High School",
                        "Eight Mile Plains station, platform 1",
                        "Newnham Rd near Tryon St, stop 79",
                        "Delavan St at Delavan Terminus, stop 78/87",
                        "Kavanagh Rd near Vicki Pl",
                        "Wishart Rd near Hibiscus Cl, stop 77",
                        "Wishart Rd at Newnham Road, stop 74/44",
                        "Wishart Rd at Exmoor Street, stop 42",
                        "Logan Rd at Wishart Road, stop 39",
                        "Creek Rd at Greenmeadows South",
                        "Creek Rd near Gallipoli Rd, stop 70",
                        "Creek Rd near Buzacott St, stop 71",
                        "Winstanley St near Firmiston St",
                        "Winstanley St near Hedlow Ct",
                        "Scrub Rd at Winstanley East",
                        "Greendale Way at Ridgeview St",
                        "Gardner Road at Lorisch Way"
                    ],
                    "8031: Carindale, Mansfield, Redeemer, Rochedale": [
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Wecker Rd at Wecker Rd Business Center, stop 63",
                        "Wecker Rd at Eastwood Drive, stop 64b",
                        "Ham Rd at Banika Street, stop 64c",
                        "Ham Rd at Linfield Street, stop 64d",
                        "Ham Rd near Kelnat St",
                        "Ham Rd at Mansfield State School",
                        "Ham Rd near Rupari St",
                        "Broadwater Rd near Ham Rd",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Mailey St, stop 74",
                        "Broadwater Rd near Newnham Rd, stop 72",
                        "Broadwater Rd at Hillgrove, stop 40",
                        "Broadwater Rd at Wardle Street, stop 39",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Mt Gravatt Capalaba Rd at Dowrie St",
                        "Mount Gravatt Capalaba Rd at Auckland",
                        "Mt Gravatt Capalaba Rd at Agaton",
                        "Mt Gravatt Capalaba Rd at Ham Road South",
                        "Mt Gravatt Capalaba Rd at Wishart East",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Gainsborough Ave near Monet Cr",
                        "Rembrandt Way at Gainsborough Park",
                        "Gardner Rd at Interchange Pl",
                        "Gardner Rd at Frangipani St",
                        "Gardner Road at Lorisch Way",
                        "Gardner Rd at Arise Boulevard",
                        "Miles Platting Rd at Brilliant Place",
                        "Rochedale Rd near Miles Platting Rd",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Rochedale State High School",
                        "Priestdale Rd opp Rochedale High School",
                        "Miles Platting Rd near Rochedale Rd",
                        "Gardner Road at Prebble Street",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42",
                        "Broadwater Rd near Cresthaven Dr, stop 74",
                        "Ham Rd near Broadwater Rd",
                        "Wecker Rd at Dividend Street, stop 64a",
                        "Wecker Rd at Wecker Road, stop 62"
                    ],
                    "8033: Runcorn, Eight Mile Plains, Rochedale": [
                        "Kingston Rd at Curban Street",
                        "Beenleigh Rd at Logan Road",
                        "Keith St near Millers Rd hail 'n' ride",
                        "Stiller Dr at Beenleigh Rd, stop 90",
                        "Stiller Dr at Balmoral St, stop 89",
                        "Stiller Dr at Crestwood St, stop 88",
                        "Stiller Dr at Redland Close, stop 87",
                        "Franquin Cr at Underwood Rd, stop 86",
                        "Underwood Rd at Levington, stop 85",
                        "Levington Rd at Settler Street",
                        "Levington Rd at RACQ, stop 84",
                        "Gaskell St at The Glen, stop 84",
                        "Gaskell St at Alan Crescent, stop 86",
                        "Gaskell St near Underwood Rd, stop 87",
                        "Underwood Rd at Mapleleaf Street, stop 88",
                        "Underwood Rd near Warrigal Rd, stop 89",
                        "Warrigal Rd at Runcorn North",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Warrigal Road Primary School",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Padstow Rd near Logan Rd",
                        "Miles Platting Rd at Mersey St",
                        "Eight Mile Plains station, platform 1",
                        "School Rd near Priestdale Rd",
                        "Priestdale Rd opp Rochedale High School",
                        "Rochedale Rd at Redeemer Lutheran College",
                        "Miles Platting Rd near Rochedale Rd",
                        "Redeemer Lutheran College",
                        "Miles Platting Rd at Brilliant Place",
                        "Miles Platting Rd at Gardner Rd",
                        "Miles Platting Rd at McKechnie Dr",
                        "Miles Platting Rd at Technology Park",
                        "Warrigal Rd at Padstow Views",
                        "Pine St near Warrigal Rd",
                        "Daw Rd at Hill Road, stop 65",
                        "Daw Rd near Warrigal Rd, stop 64",
                        "Gaskell St at Angel Street, stop 85",
                        "Levington Rd at Settler St",
                        "Underwood Rd at Levington Rd, stop 85",
                        "Stiller Dr at Woodglen St, stop 87",
                        "Kingston Rd at Ferguson Street"
                    ],
                    "8038: Alexandra Hills, Capalaba, Mackenzie": [
                        "Rembrandt Way at Gainsborough Park",
                        "Gainsborough Ave near Monet Cr",
                        "Mt Petrie Rd at Vivaldi Place",
                        "Mackenzie State Primary School",
                        "Mt Gravatt Capalaba Rd at Gateway Baptist",
                        "Mount Cotton Rd at Daymar Street",
                        "Mount Cotton Rd near Moxon Rd",
                        "Mount Cotton Rd at Alperton Rd",
                        "Mount Cotton Rd near Marawah St",
                        "Degen Rd at St Lukes Catholic Primary School",
                        "Ney Rd at Capalaba Sports Club",
                        "Ney Rd at Coolnwynpin Primary School",
                        "Ney Rd at Jeffrey Street",
                        "Redland Bay Rd at Ney Road",
                        "Redland Bay Rd at Coolnwynpin Creek",
                        "Windemere Rd at Sophia Place",
                        "Windemere Rd at Alexandra Hills High School",
                        "Finucane Rd at Alexandra Hills High School",
                        "Finucane Road at Moreton Institute of TAFE",
                        "Windemere Rd at Keith Surridge Park",
                        "Windemere Rd near Brompton St",
                        "Windemere Rd at Stovold Pl",
                        "Ney Rd near Redland Bay Rd",
                        "Ney Rd at Callaghan Way",
                        "Ney Rd near Coolnwynpin Way",
                        "Degen Rd near St Lukes Ct",
                        "Mount Cotton Rd near Wildsoet St"
                    ],
                    "803: Heathwood Estate - Pallara State School": [
                        "Brookbent Rd near Ivory Cres",
                        "Pallara Ave near Pipet Cr",
                        "Pallara Ave at Gooderham Rd",
                        "Gooderham Rd at Brookbent Rd",
                        "Vied Rd near Landel St",
                        "Esky Rd near Kraft Rd",
                        "Ritchie Rd near Kraft Rd",
                        "Laxton Rd near Ritchie Rd",
                        "Laxton Rd near Bellerive St",
                        "Laxton Rd near Esky Rd",
                        "Van Dieren Rd near Esky Rd",
                        "Van Dieren Rd near Whitehaven St",
                        "Van Dieren Rd at Pallara District Sports Park",
                        "Richie Rd near Falkland St",
                        "Pallara State School",
                        "Ritchie Rd near Falkland St",
                        "Ritchie Rd near Laxton Rd",
                        "Van Dieren near Prominence St",
                        "Van Dieren Rd near Morganite St",
                        "Van Dieran Rd near Esky Rd",
                        "Ritche Rd near Van Dieren Rd",
                        "Kraft Rd near Esky Rd",
                        "Vied St near Landel St"
                    ],
                    "804: Pallara - Pallara State School (via Heathwood)": [
                        "Parkwood Dr North near Beech St",
                        "Parkwood Dr near Coolibah St",
                        "Parkwood Dr at Parkwood Drive South",
                        "Parkwood Dr near Juniper St",
                        "Sanctuary Dr near Dandenong St",
                        "Sanctuary Dr near Eungella Place",
                        "Sanctuary Dr near Warrumbungle St",
                        "Sanctuary Dr at Sanctuary Park",
                        "Sanctuary Dr near Lomandra Ave",
                        "Pacific Pde near Muscovy Place",
                        "Pacific Pde near Pintail Cr",
                        "Pacific Pde near Carolina Pde",
                        "Blunder Rd at Chain of Ponds Estate",
                        "Wadeville St Heathwood Rise",
                        "Wadeville St at Wadeville West",
                        "Pallara State School",
                        "Ritchie Rd near Falkland St",
                        "Ritchie Rd near Kraft Rd",
                        "Vied Rd near Landel St",
                        "Esky Rd near Kraft Rd",
                        "Richie Rd near Falkland St"
                    ],
                    "805: Algester - Calamvale Community College": [
                        "Parklands Dr near Casuarina Cres",
                        "Parklands Dr near Eden Elm St",
                        "Palatine St near Parklands Dr",
                        "Chateau St near Monsour St",
                        "Chateau St near Tequila Ct",
                        "Compton Rd near Chateau St, stop 84",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Pennant Hills",
                        "Kameruka St near Golden Ave",
                        "Calamvale Community College",
                        "Gowan Rd at Parkside",
                        "Gowan Rd near The Parkway",
                        "Gowan Road near Honeysuckle Way",
                        "Gowan Rd at Stretton College Primary",
                        "Gowan Rd at Stretton State College",
                        "Gowan Rd at The Parks",
                        "Gowan Rd near Kameruka St"
                    ],
                    "806: Upper Mt Gravatt - Woolloongabba": [
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Glindemann Park, stop 33",
                        "Logan Rd at Boronia Street, stop 32",
                        "Logan Rd at Holland Park South, stop 31",
                        "Logan Rd at Barter Street, stop 30",
                        "Logan Rd at Holland Park, stop 29",
                        "Logan Rd at Harold Street, stop 28",
                        "Logan Rd at Swain Street, stop 27",
                        "Logan Rd at CB Mott Park, stop 26",
                        "Logan Rd at Greenslopes Mall, stop 25/24",
                        "Logan Rd at Donaldson Street, stop 23",
                        "Logan Rd at Greenslopes, stop 22",
                        "Logan Rd at Greenslopes School, stop 21",
                        "Logan Rd at Bardsley Avenue, stop 20",
                        "Logan Rd at Logan Rd North, stop 19",
                        "Logan Rd at Vine Street, stop 18",
                        "Logan Rd at Stones Corner Shops, stop 17",
                        "Old Cleveland Rd at Stones Corner Library, stop 17",
                        "Logan Rd at Buranda Railway, stop 16/14",
                        "Logan Rd at Vanda Street, stop 13",
                        "Logan Rd at Buranda Street, stop 12",
                        "Logan Rd at Lewis Street, stop 11",
                        "Logan Rd at Walker Street, stop 10a",
                        "Stanley St at Jurgens Street, stop F",
                        "Woolloongabba station, platform 1"
                    ],
                    "807: Balmoral High - Murrarie (Cannon Hill)": [
                        "Cannon Hill Shopping Centre E",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Northcliffe St at Marvell St",
                        "Queensport Rd at Murarrie near Railway Tce",
                        "Murarrie SS",
                        "Creek Rd near Herbert St",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Thynne Rd at Belgrave Street, stop 28",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Walkers Dr at Balmoral High School, stop 32",
                        "Balmoral High School",
                        "Creek Rd near Mitchell Bvd",
                        "Murarrie State School",
                        "Northcliffe St near Marvell St"
                    ],
                    "808: Balmoral High - Cannon Hill": [
                        "Balmoral High School",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Archives, stop 33",
                        "Cannon Hill Shopping Centre"
                    ],
                    "809: Stretton College - Algester": [
                        "Gowan Rd at Stretton State College",
                        "Honeysuckle Way at The Parks",
                        "Honeysuckle Way at Calamvale",
                        "Honeysuckle Way at Sunflower",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Algester Rd at Lichfield Place, stop 93",
                        "Algester Rd at Parkinson East, stop 92",
                        "Algester Rd at Whitsunday St",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Nottingham",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Algester",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79"
                    ],
                    "810: MacGregor - Salisbury": [
                        "Springfield St at MacGregor High School",
                        "Parkway St near Springfield St, stop 80",
                        "Granadilla St at Mimosa Creek, stop 79",
                        "Granadilla St at Ceriman Street, stop 78",
                        "Mains Rd at Sunnybank",
                        "Turton St near Mains Rd",
                        "Turton St near Boorman St",
                        "Turton St near Gager St",
                        "Turton St at Oasis",
                        "Turton St at Sunnybank State School",
                        "Troughton Rd at Banoon",
                        "Troughton Rd near Vereker St",
                        "Troughton Rd at Brittain Park",
                        "Troughton Rd at Musgrave Road, stop 39",
                        "Troughton Rd at QEII Hospital, stop 37",
                        "Kessels Rd near Troughton Rd, stop 55",
                        "Orange Grove Rd at Salisbury East, stop 51",
                        "Henson Rd at Salisbury East, stop 50",
                        "Henson Rd at Meynell Street, stop 49a",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Cripps St at Salisbury Interchange, stop 48 zone B",
                        "Lillian Ave at Salisbury Interchange, zone A"
                    ],
                    "811: Belmont - Gumdale - Balmoral High": [
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Manly Rd at Leon, stop 43",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Villanova Park, stop 45",
                        "Stanbrough Rd near New Cleveland Rd",
                        "Stanbrough Rd near Formosa St",
                        "Stanbrough Rd near Grassdale Rd",
                        "Grassdale Rd near Stanbrough Rd",
                        "Grassdale Rd near Belmont Rd",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Annette St at Cahia Street, stop 50/46",
                        "Annette St at Jarrow Street, stop 49/45",
                        "Wynnum Rd near Belmont Rd",
                        "Ranch St Tingalpa",
                        "Boundary St at Jafam Lane",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Junction Rd at Colmslie, stop 53",
                        "Junction Rd at Algoori Street, stop 54",
                        "Junction Rd at Beelarong Street, stop 55",
                        "Balmoral High School",
                        "Walkers Dr at Balmoral High School, stop 32",
                        "Walkers Dr near Fifth Ave, stop 32a",
                        "Fifth Ave near Lytton Rd, stop 33",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Riding Rd at Bulimba Preschool, stop 35/41",
                        "Riding Rd near Fifth Ave, stop 34/42",
                        "Riding Rd at Main Avenue, stop 33/43",
                        "Riding Rd at Victoria Street, stop 32/44",
                        "Riding Rd at Grosvenor Street, stop 31/45",
                        "Pashen St at Hawthorne Park, stop 46",
                        "Pashen St at Morningside State School, stop 47",
                        "Pashen St at Talma Street, stop 48",
                        "Pashen St near Thynne Rd, stop 49",
                        "Thynne Rd at Morningside Police, stop 28",
                        "Thynne Rd at Morningside Park, stop 27",
                        "Thynne Rd at Ison Street, stop 26",
                        "Wynnum Rd at School of Arts, stop 27",
                        "Wynnum Rd at Morningside Shops, stop 28",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Boundary St near Wynnum Rd",
                        "Wynnum Rd near Thornlake Ct",
                        "Thurston St at McCorkell Street, stop 53/49",
                        "Grassdale Rd at Stanbrough Rd"
                    ],
                    "812: Cavendish Rd High - Murrarie": [
                        "Barrack Rd near Bombery St, stop 60",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at East Village, stop 34",
                        "Cannon Hill Shopping Centre E",
                        "Creek Rd at Old Stockyards, stop 66a",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Foxmont Drive, stop 49",
                        "Creek Rd at Carina North near Billan St",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Creek Rd at Carina Bus Depot",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Tristan St at Gorlois Court, stop 54",
                        "Tristan St at Cuthred Street, stop 53",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Carindale Shopping Centre station, platform C",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Winstanley St at Laurie Street, stop 48/47",
                        "Winstanley St at Willard Street, stop 46",
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "McGahan St near Chataway St, stop 45",
                        "Chataway St at Rea Street, stop 46",
                        "Chataway St near Gallipoli Rd, stop 47",
                        "Summerville St near Buzacott St, stop 48",
                        "Buzacott St near Buckley St, stop 48a",
                        "Bedivere St near Agravain St",
                        "Bedivere St at Lindisfarne Street",
                        "Meadowlands Rd near Bedivere St",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Old Stockyards",
                        "Railway Tce at Murarrie South near Herbert St",
                        "Queensport Rd at Murarrie near Railway Tce"
                    ],
                    "813: St Bernards - Murrarie": [
                        "Logan Rd at St Bernard, stop 42",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Fairland Street",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Creek Rd at Greenmeadows South",
                        "Creek Rd at Greenmeadow",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd at Salvin Park, stop 69",
                        "Donnington St at Stanmere, stop 52",
                        "Donnington St at Donnington, stop 53",
                        "Carindale Shopping Centre station, platform H",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Bedivere St near Agravain St",
                        "Bedivere St at Lindisfarne Street",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Old Stockyards",
                        "Cannon Hill Shopping Centre E",
                        "Railway Tce at Murarrie South near Herbert St",
                        "Queensport Rd at Murarrie near Railway Tce",
                        "Queensport Rd at Murarrie North near Ives St",
                        "Queensport Rd at Queensport North"
                    ],
                    "814: Cavendish Road High - Carindale": [
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Cambridge Street, stop 44",
                        "McGahan St near Chataway St, stop 45",
                        "Chataway St at Rea Street, stop 46",
                        "Chataway St near Gallipoli Rd, stop 47",
                        "Summerville St near Buzacott St, stop 48",
                        "Buzacott St near Buckley St, stop 48a",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "815: Iona College - Wynnum State School": [
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Annette St at Cahia Street, stop 50/46",
                        "Annette St at Jarrow Street, stop 49/45",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Wynnum Rd near Belmont Rd",
                        "Ranch St Tingalpa",
                        "Boundary St at Jafam Lane",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd near Thornlake Ct",
                        "Wynnum Rd at Arena, stop 43",
                        "Wynnum Rd at Hemmant Cemetery, stop 44",
                        "Wynnum Rd at Bognor Road, stop 45",
                        "Wynnum Rd at Kianawah Rd, stop 46/49",
                        "Kianawah Rd at Glenwood Pl",
                        "Kianawah Rd at Vikings",
                        "Kianawah Rd at Youngs Rd",
                        "Kianawah Rd at Evelyn Rd",
                        "Alness St at Iona College",
                        "Crawford Rd near Kanawah Rd",
                        "Crawford Rd at Pecan St",
                        "Crawford Rd at Balnave St",
                        "School Rd near New Lindum Rd",
                        "Federation St near School Rd",
                        "Federation St at Federation Park",
                        "New Lindum Rd at Health",
                        "New Lindum Rd at Moreton Bay",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58",
                        "Wynnum Rd at Wynnum Plaza, stop 58",
                        "Randall Rd near Wynnum Rd",
                        "Preston Rd near Wynnum Rd",
                        "Preston Rd fs Brockworth",
                        "West Ave near Coolcrest St",
                        "Stradbroke Ave at Kitchener Park",
                        "Stradbroke Ave at Golf Club",
                        "Stradbroke Ave at Carnation Street",
                        "Stradbroke Ave at Davidson Street",
                        "Stradbroke Ave at Targorin St",
                        "Wynnum Rd at Stradbroke Avenue",
                        "Wynnum Rd at Primrose Park",
                        "Wynnum State School",
                        "Preston Rd near Alloa St, stop 75/65",
                        "Preston Rd near Randall Rd",
                        "Wynnum Rd at Wynnum West State School, stop 58A",
                        "Boundary St near Wynnum Rd",
                        "Thurston St at McCorkell Street, stop 53/49"
                    ],
                    "816: Wishart State School - Garden City": [
                        "Morella St near Balloch St",
                        "Newnham Rd near Zetland St",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Arila Street, stop 77",
                        "Amsterdam St near Copenhagen St",
                        "Monte Carlo St near Auckland St",
                        "Barcelona St near Monte Carlo St",
                        "Barcelona St near Amsterdam St",
                        "Montreal St near Colombo St",
                        "Newnham Rd at Montreal Street, stop 77A",
                        "Newnham Rd at Delavan, stop 78",
                        "Newnham Rd at Tryon St",
                        "Midwood St near Remsen St",
                        "Midwood St near Delavan St",
                        "Delavan St at Wolcott Street, stop 86",
                        "Delavan St at Delavan Street Park, stop 85",
                        "Cummin St near Monte Carlo St, stop 84",
                        "Mannetto St near Matincock St, stop 83",
                        "Mannetto St at Gilgo Street, stop 82",
                        "Greenwood St near Kavanagh Rd, stop 81",
                        "Mindona St at Mindona Park, stop 80",
                        "Boyanda St near Tyrrell St, stop 79",
                        "Mt Gravatt Capalaba Rd at Ham Road South",
                        "Mt Gravatt Capalaba Rd at Agaton",
                        "Mt Gravatt Capalaba Rd near Amsterdam St",
                        "Mt Gravatt Capalaba Rd near Dowrie St, stop 62/78",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station"
                    ],
                    "817: Villanova - Cannon Hill station": [
                        "Villanova College",
                        "Old Cleveland Rd at Saint Leonards Street Stop 21",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Burke Street Stop 25",
                        "Bennetts Rd at Norman Park near Morehead Ave",
                        "Bennetts Rd at Pattison Avenue, stop 27",
                        "Bennetts Rd at Acfold Street, stop 28",
                        "Bennetts Rd at Bennetts Bushland, stop 29",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Riding Rd at Miles Street, stop 24",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Virginia Ave near Aaron Ave",
                        "Uhlmann St near Harris Street, stop 22a",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Fifth Avenue, stop 33",
                        "Balmoral High School",
                        "Thynne Rd at Beelarong Street, stop 31",
                        "Thynne Rd at Algoori Street, stop 30",
                        "Thynne Rd at Baringa Street, stop 29",
                        "Wynnum Rd at Abinger, stop 29",
                        "Junction Rd at Colmslie, stop 53",
                        "Junction Rd at Algoori Street, stop 54",
                        "Junction Rd at Beelarong Street, stop 55",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Barrack Rd near Bombery St, stop 60"
                    ],
                    "819: Carindale - Iona College": [
                        "Carindale Shopping Centre station, platform A",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Cadogan St at Bamburgh Street, stop 67/53",
                        "Cadogan St at Whitecastle Street, stop 65/54",
                        "Cadogan St at Cadogan Park, stop 65/54a",
                        "Baynes St near Sherborne St, stop 55",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Alness St at Iona College",
                        "Malabar St at Cabanda Street, stop 46",
                        "Malabar St at Talegalla Street, stop 47",
                        "Malabar St at Birru Street, stop 48",
                        "Malabar St at Meron Street, stop 49",
                        "Malabar St at Lyones Street, stop 50",
                        "Malabar St at Nemarra Street, stop 50",
                        "Brierty St near Alex St, stop 53",
                        "Wynnum Rd at Sibley Road",
                        "Wynnum North Rd at Sibley Road, stop 38",
                        "Wynnum North Rd at Radius Street, stop 37",
                        "Wynnum North Rd at Wynnum North Rail, stop 36/17",
                        "Wynnum North Rd at Ryder Street, stop 15",
                        "Wynnum North Rd at Nazareth House, stop 14",
                        "Wynnum North Rd at Constellation Way, stop 13",
                        "Tingal Rd at Tingal - Ure, stop 13A",
                        "Tingal Rd at Shepherd Street, stop 12",
                        "Tingal Rd at Warra Street, stop 11",
                        "Tingal Rd at Wynnum North State School, stop 10/5",
                        "Tingal Rd at Alkoomie Street, stop 4",
                        "Tingal Rd at Wynnum near Wilde St",
                        "Tingal Rd at Leisure Centre, stop 2",
                        "Tingal Rd at Berrima Street, stop 1",
                        "Tingal Rd at Wynnum RSL",
                        "Dibar St near West Ave, stop 99",
                        "Stradbroke Ave at Kitchener Park",
                        "Stradbroke Ave at Golf Club",
                        "Stradbroke Ave at Carnation Street",
                        "Stradbroke Ave at Davidson Street",
                        "Stradbroke Ave at Targorin St",
                        "Wynnum Rd at Stradbroke Avenue",
                        "Wynnum Rd at Primrose Park",
                        "Wynnum State School",
                        "Andrew St near Ronald St Stop 100",
                        "Tingal Rd at Wynnum RSL, stop 99",
                        "Tingal Rd at Wynnum, stop 3",
                        "Tingal Rd at Alkoomie Street, stop 11",
                        "Wynnum North Rd at Constellation Way, st",
                        "Wynnum North Rd at Prospect Street, stop 15/16",
                        "Wynnum Rd at Wynnum Golf, stop 54",
                        "Wynnum Rd at Wynnum West, stop 55",
                        "Wynnum Rd at Palm Spring Village, stop 59/56",
                        "Wynnum Rd at Wynnum Fire Station, stop 57/58",
                        "Wynnum Rd at Plaza Street, stop 57",
                        "Wynnum Rd at BMX, stop 56/50",
                        "Wynnum Rd at Kianawah Rd, stop 49/46",
                        "Wynnum Rd at Bognor Road, stop 45",
                        "Wynnum Rd at Hemmant Cemetery, stop 44",
                        "Wynnum Rd at Arena, stop 43",
                        "Baynes St near Stevenson Ct, stop 55",
                        "Cadogan St at Whitecastle Street, stop 66/54",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "820: Garden City - Mansfield High": [
                        "Garden City Shopping Centre station, stop G",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Mt Gravatt Capalaba Rd at Dowrie St",
                        "Newnham Rd at Arila Street, stop 77",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Tolson Street, stop 75",
                        "Wishart Rd at Newnham Road, stop 74/44",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Wishart Rd at Exmoor Street, stop 42",
                        "Hillgrove St at Kingsway Street, stop 41",
                        "Broadwater Rd near Newnham Rd, stop 72",
                        "Broadwater Rd near Cresthaven Dr, stop 74",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Ham Rd",
                        "Mansfield High and Junior Schools"
                    ],
                    "821: Mansfield High School - Garden City": [
                        "Mansfield High and Junior Schools",
                        "Broadwater Rd at Mansfield Park",
                        "Mt Gravatt Capalaba Rd at Wishart East",
                        "Mt Gravatt Capalaba Rd at Ham Road South",
                        "Mt Gravatt Capalaba Rd at Agaton",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Griffith University station, platform 2",
                        "Garden City Shopping Centre station"
                    ],
                    "822: BSSSC - Tarragindi": [
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Prior St at Windmill Street, stop 43",
                        "Windmill St at Pring Street, stop 42",
                        "Bramston St near Andrew Ave, stop 41",
                        "Andrew Ave at Pope Street, stop 40",
                        "Andrew Ave at Elliot Street, stop 39",
                        "Andrew Ave near Fernvale Rd, stop 38",
                        "Andrew Ave at Tarragindi Bowls, stop 38a",
                        "Tarragindi Rd at Bailey Street, stop 37",
                        "Tarragindi Rd at Kenneth Street, stop 36",
                        "Tarragindi Rd at Cosker Street, stop 34",
                        "Ekibin Rd at Ekibin Road East, stop 33",
                        "Ekibin Rd at Ferndale Street, stop 32",
                        "Ekibin Rd at Rigby Street, stop 31a",
                        "Ekibin Rd at Chester Street, stop 31",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Ekibin Rd at Ekibin Park South, stop 28",
                        "Ekibin Rd at Bower Street, stop 27",
                        "Ekibin Rd at Lambton Street stop 25",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Ipswich Rd at Annerley RSL, stop 21a",
                        "Annerley Rd at Portland Street, stop 21",
                        "Annerley Rd at Herbert Street, stop 20",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Carville Street, stop 20/19",
                        "Annerley Rd at Dutton Park, stop 17/12",
                        "Annerley Rd at Dutton Park, stop 11/17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Annerley Rd at Hefferan Park, stop 19",
                        "Annerley Rd at Carville Street, stop 20",
                        "Annerley Rd at Herbert Street, stop 20b",
                        "Annerley Rd at Annerley RSL, stop 21a",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ekibin Rd at Lambton Street, stop 25",
                        "Ekibin Rd at Lothian Street, stop 26",
                        "Ekibin Rd at Chester Road, stop 31",
                        "Andrew Ave at Bailey Street, stop 37",
                        "Bramston St at Pring Street, stop 41a",
                        "Windmill St near Prior St, stop 42/43",
                        "Prior St at Tarragindi, stop 44/48"
                    ],
                    "823: Woollongabba - Garden City": [
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Vulture St at Kennedy Street, stop 11",
                        "Vulture St at Rosslyn Street, stop 12/15",
                        "Vulture St at Withington Street, stop 16",
                        "Vulture St at Didsbury Street, stop 17",
                        "Cavendish Rd at Coorparoo College, stop 19",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at Coorparoo Shops, stop 26s",
                        "Cavendish Rd at Shire Street, stop 27/28",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Camlet St at Little Cavendish Rd, stop 55",
                        "Camlet St at Mapleton Street, stop 56",
                        "Camlet St near Kentish St, stop 57/41",
                        "Kentish St at Pond Street, stop 58",
                        "Kentish St near Pond St",
                        "Kentish St at Canterbury Street, stop 59",
                        "Mt Gravatt East Creek Rd Stop 60",
                        "Mt Gravatt East School - 61",
                        "Newnham Rd at Enderby Street, stop 62",
                        "Fairland St near Hillcroft St",
                        "Fairland St near Dykes St",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Mt Gravatt Central, stop 38",
                        "Logan Rd at Rover Street, stop 38",
                        "Broadwater Rd at Wardle Street, stop 39",
                        "Broadwater Rd at Hillgrove, stop 40",
                        "Hillgrove St at Kingsway Street, stop 41",
                        "Hillgrove St at Exmoor Street, stop 42",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Wemvern St at Wanda Street, stop 75",
                        "Wemvern St at Zetland Street, stop 76",
                        "Wemvern St at Lumley Street, stop 76a",
                        "Cale St near Dawson Rd, stop 76b",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Dawson Rd at Gurney Street, stop 78",
                        "Dawson Rd at Gerty Street, stop 79",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "824: Mansfield High School - Garden City": [
                        "Ham Rd near Rupari St",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Mailey St, stop 74",
                        "Broadwater Rd near Newnham Rd, stop 72",
                        "Newnham Rd at Civic Fair, stop 73",
                        "Newnham Rd at Tolson Street, stop 75",
                        "Newnham Rd near Zetland St",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Arila Street, stop 77",
                        "Mt Gravatt Capalaba Rd near Dowrie St, stop 62/78",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station"
                    ],
                    "825: Mansfield High - Garden City": [
                        "Mansfield High and Junior Schools",
                        "Broadwater Rd at Mansfield Park",
                        "Mt Gravatt Capalaba Rd at Wishart East",
                        "Boyanda St near Tyrrell St, stop 79",
                        "Mindona St at Mindona Park, stop 80",
                        "Greenwood St near Kavanagh Rd, stop 81",
                        "Mannetto St at Gilgo Street, stop 82",
                        "Mannetto St near Cummin St, stop 83",
                        "Cummin St near Monte Carlo St, stop 84",
                        "Delavan St at Delavan Street Park, stop 85",
                        "Delavan St at Wolcott Street, stop 86",
                        "Delavan St at Delavan Terminus, stop 87/78",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "826: Mansfield High School - Carina": [
                        "Ham Rd near Rupari St",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Mailey St, stop 74",
                        "Broadwater Rd near Newnham Rd, stop 72",
                        "Newnham Rd at Westbrooke Street, stop 71",
                        "Condong St near Valentia St, stop 69a",
                        "Condong St near Togar St, stop 69A",
                        "Condong St near Mingera St, stop 68",
                        "Aminya St at Mansfield, stop 67a",
                        "Olivella St near Luprena St, stop 66",
                        "Luprena St at Arura Street, stop 65",
                        "Luprena St at Mansfield North near Amoria St",
                        "Wecker Rd at Wecker Rd Business Center, stop 63",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Creek Rd at Greenmeadows South",
                        "Creek Rd at Greenmeadow",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd at Salvin Park, stop 69",
                        "Donnington St at Stanmere, stop 52",
                        "Donnington St at Donnington, stop 53",
                        "Carindale Shopping Centre station, platform I",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Bedivere St near Agravain St",
                        "Bedivere St at Lindisfarne Street",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Stanley Rd at Vince Herbert Field, stop 45"
                    ],
                    "827: Meadowlands - St Catherines School": [
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Meadowlands Rd near Bedivere St",
                        "Bedivere St at Lindisfarne Street",
                        "Bedivere St near Cadogan St",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Carindale Shopping Centre station, platform D",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Creek Rd near Donnington St, stop 71",
                        "Creek Rd near Donnington St, stop 70",
                        "Creek Rd at Salvin Park, stop 69",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Greenmeadow Rd near Cornflower St, stop 66",
                        "Greenmeadow Rd near Harvest St, stop 65",
                        "Greenmeadow Rd near Bluebell St, stop 64",
                        "Greenmeadow Rd near Canter St, stop 63",
                        "Greenmeadow Rd near Raintree St, stop 62",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Dividend Street, stop 64a",
                        "Wecker Rd at Eastwood Drive, stop 64b",
                        "Ham Rd at Banika Street, stop 64c",
                        "Ham Rd at Linfield Street, stop 64d",
                        "Ham Rd near Kelnat St",
                        "Ham Rd near Rupari St",
                        "Broadwater Rd near Ham Rd",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Mailey St, stop 74",
                        "Broadwater Rd near Newnham Rd, stop 72",
                        "Newnham Rd at Civic Fair, stop 73",
                        "Newnham Rd near Zetland St",
                        "Cresthaven Dr at Cresthaven, stop 74",
                        "Cresthaven Dr at Salandra Street, stop 67c/73",
                        "Aminya St at Mansfield, stop 67a",
                        "Olivella St near Luprena St, stop 66",
                        "Luprena St at Arura Street, stop 65",
                        "Luprena St at Mansfield North near Amoria St",
                        "Wecker Rd at Wecker Rd Business Center, stop 63",
                        "Greenmeadow Rd near Honeysuckle St, stop 61",
                        "Greenmeadow Rd at Greenmeadows",
                        "Greenmeadow Rd near Creek Rd, stop 66",
                        "Creek Rd near Gallipoli Rd, stop 70",
                        "Creek Rd near Buzacott St, stop 71",
                        "Carindale Shopping Centre station, platform I",
                        "Bedivere St near Agravain St"
                    ],
                    "828: Cavendish Rd High - Holland Park": [
                        "Elgar St at Macklin St",
                        "Seville Rd at Seville Shops, stop 48",
                        "Seville Rd near Glindemann Dr, stop 47c",
                        "Glindemann Dr near Seville Rd, stop 47b",
                        "Holland Rd at Lamette Avenue, stop 43A",
                        "Cannes St at Marshall Road, stop 55",
                        "Bapaume Rd near Sterculia Ave, stop 57/61"
                    ],
                    "829: Logan Rd - Parkinson": [
                        "Illaweena St at Waterstone",
                        "Illaweena St at Tamarisk Way",
                        "Algester Rd at Lichfield Place, stop 93",
                        "Algester Rd at Parkinson East, stop 92",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Nottingham",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Algester",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Beaudesert Rd at Highlands Drive",
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Robertson",
                        "Kessels Rd at Grout Street, stop 2/58",
                        "Kessels Rd at MacGregor, stop 59",
                        "Garden City Shopping Centre station, stop J",
                        "Logan Rd at Marada Street, stop 79b",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42",
                        "Klumpp Rd at Klumpp-Dawson",
                        "Klumpp Rd at Hibiscus",
                        "Garden City Shopping Centre station, stop N",
                        "Kessels Rd at Grout Street, stop 58",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands Rd near Noelana St",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd near Algester Rd, stop 21",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Algester Rd at Injune Cct, stop 93"
                    ],
                    "830: Klumpp Rd - Parkinson": [
                        "Logan Rd at St Bernard, stop 42",
                        "Klumpp Rd at Klumpp-Dawson",
                        "Mains Road park 'n' ride",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd at Highlands Drive",
                        "Beaudesert Rd near Algester Rd, stop 21",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Algester Rd at Parkinson East, stop 92"
                    ],
                    "831: Lourdes Hill - Cannon Hill": [
                        "Virginia Ave near Aaron Ave",
                        "Harris St at Uhlmann Street, stop 22",
                        "Lindsay St at Barton Street, stop 22b",
                        "Lindsay St at Virginia Avenue, stop 23",
                        "Lindsay St at Hawthorn Ferry, stop 23a",
                        "Gordon St at Elliott St, stop 24",
                        "Barton Rd at Blackheath Avenue, stop 25/26",
                        "Govett Ave at Leura Avenue, stop 27",
                        "Carr St near Stuart St, stop 28",
                        "Smallman St near Carr St, stop 29",
                        "Smallman St at Eton Street, stop 30",
                        "Smallman St at Wambool Street, stop 31",
                        "Oxford St at Bulimba Memorial Park, stop 32",
                        "Oxford St at Bulimba Ferry, stop 33",
                        "Brisbane St at Coutts Street, stop 34",
                        "Brisbane St near Bulimba St, stop 35",
                        "Henderson St at Bulimba Street, stop 36",
                        "Henderson St at Princess Street, stop 37",
                        "Henderson St at Pine Street, stop 38a",
                        "Apollo Rd near Brisbane St, stop 38",
                        "Apollo Rd at Tugulawa Park, stop 37/39",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Riding Rd at Bulimba Preschool, stop 35/41",
                        "Riding Rd near Fifth Ave, stop 34/42",
                        "Riding Rd at Main Avenue, stop 33/43",
                        "Riding Rd at Victoria Street, stop 32/44",
                        "Riding Rd at Grosvenor Street, stop 31/45",
                        "Pashen St at Hawthorne Park, stop 46",
                        "Pashen St at Morningside State School, stop 47",
                        "Pashen St at Talma Street, stop 48",
                        "Pashen St near Thynne Rd, stop 49",
                        "Kates St at Coates Street, stop 50",
                        "Kates St at Beverley Street, stop 52",
                        "Junction Rd at Colmslie, stop 53",
                        "Junction Rd at Algoori Street, stop 54",
                        "Junction Rd at Beelarong Street, stop 55",
                        "Krupp Rd near Shrapnel Rd, stop 56",
                        "Whitworth Rd near Grenade Street Stop 57",
                        "Grenade St at Bent Street, stop 58",
                        "Grenade St near Barrack Rd, stop 59",
                        "Barrack Rd near Bombery St, stop 60",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at East Village, stop 34",
                        "Cannon Hill Shopping Centre B"
                    ],
                    "832: MacGregror High - Parkinson": [
                        "Springfield St at MacGregor High School",
                        "Parkway St near Springfield St, stop 80",
                        "Granadilla St at Mimosa Creek, stop 79",
                        "Granadilla St at Ceriman Street, stop 78",
                        "Granadilla St near Darlington St, stop 7",
                        "Granadilla St at Sunderland Street, stop 76",
                        "McCullough St at Granadilla",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd at Highlands Drive",
                        "Beaudesert Rd near Algester Rd, stop 21",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90"
                    ],
                    "833: Annerley - Holland Park High - Cavendish Rd High": [
                        "Annerley Rd at Dutton Park Primary, stop 10",
                        "Annerley Rd at Dutton Park, stop 11/17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Annerley Rd at Hefferan Park, stop 19",
                        "Annerley Rd at Carville Street, stop 20",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Herbert Street, stop 20b",
                        "Annerley Rd at Portland Street, stop 21",
                        "Annerley Rd at Annerley RSL, stop 21a",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ekibin Rd at Lambton Street, stop 25",
                        "Ekibin Rd at Lothian Street, stop 26",
                        "Ekibin Rd at Bower Street, stop 27",
                        "Ekibin Rd at Ekibin Park South, stop 28",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Sexton St near Barr St",
                        "Sexton St near Effingham St",
                        "Toohey Rd at Denham Terrace, stop 44/41",
                        "Weller Rd near Vantage St",
                        "Cannes St at Marshall Road, stop 55",
                        "Cannes St at Holland Park West",
                        "Bapaume Rd near Mulsanne Rd, stop 61/57",
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Bapaume Rd at Marshall Road, stop 55",
                        "Holland Rd near Stewart St, stop 44",
                        "Holland Rd at Greenmount Avenue, stop 45",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Elgar St at Macklin St",
                        "Seville Rd at Seville Shops, stop 48",
                        "Seville Rd near Glindemann Dr, stop 47c",
                        "Glindemann Dr near Seville Rd, stop 47b",
                        "Holland Rd at Lamette Avenue, stop 43A",
                        "Bapaume Rd at Dobbs Street, stop 63",
                        "Monash Rd at Monash Park, stop 56",
                        "Monash Rd at Monash Bushland, stop 55",
                        "Monash Rd at Craigmont Street, stop 54",
                        "Monash Rd at Aldora Street, stop 53",
                        "Monash Rd at Ferrand Street, stop 52",
                        "Monash Rd near Kaypee St, stop 51",
                        "Monash Rd at Monash Road Shops, stop 49",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Prior St at Windmill Street, stop 43",
                        "Windmill St at Pring Street, stop 42",
                        "Bramston St near Andrew Ave, stop 41",
                        "Andrew Ave at Pope Street, stop 40",
                        "Andrew Ave at Elliot Street, stop 39",
                        "Fernvale Rd near Pope St",
                        "Fernvale Rd near Prior St",
                        "Homestead St near Kine St, stop 30a",
                        "Tarragindi Rd at La Monte Street, stop 30b",
                        "Fernvale Rd near Pring St",
                        "Fernvale Rd near Elliot St",
                        "Andrew Ave near Fernvale Rd, stop 38",
                        "Andrew Ave at Tarragindi Bowls, stop 38a",
                        "Tarragindi Rd at Bailey Street, stop 37",
                        "Tarragindi Rd at Kenneth Street, stop 36",
                        "Tarragindi Rd at Cosker Street, stop 34",
                        "Cracknell Rd near Benbow St, stop 34",
                        "Cracknell Rd at Esther Street, stop 36",
                        "Cracknell Rd at Laura Street, stop 37",
                        "Cracknell Rd at Ellington Street, stop 38",
                        "Cracknell Rd near Effingham St",
                        "Cracknell Rd at Fingal Street, stop 39",
                        "Ekibin Rd at Lambton Street stop 25",
                        "Ipswich Rd at Annerley Junction, stop 22/21",
                        "Ipswich Rd at Annerley RSL, stop 21a",
                        "Annerley Rd at Herbert Street, stop 20",
                        "Annerley Rd at Carville Street, stop 20/19",
                        "Annerley Rd at Dutton Park, stop 17/12",
                        "Annerley Rd at Boggo Road, stop 11"
                    ],
                    "834: Holland Park High - Nathan": [
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Bapaume Rd at Marshall Road, stop 55",
                        "Weller Rd near Vantage St",
                        "Fernvale Rd near Pope St",
                        "Fernvale Rd near Prior St",
                        "Tarragindi Rd at La Monte Street, stop 30b",
                        "Tarragindi Rd at Moresby Street, stop 30c",
                        "Mayfield Rd at Hermes Street, stop 30d",
                        "Mayfield Rd at Harlock Street, stop 31",
                        "Mayfield Rd at Kipling Street, stop 31a",
                        "Beaudesert Rd at Dora Street, stop 33",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Keats Street, stop 35",
                        "Beaudesert Rd at Fegan Drive, stop 36",
                        "Beaudesert Rd at Muriel - Evans, stop 37",
                        "Evans Rd at Nettleton Crescent, stop 38/39",
                        "Evans Rd at Standish Street, stop 40",
                        "Evans Rd at Industries Street, stop 41/42",
                        "Evans Rd at Pentex Street, stop 43",
                        "McCarthy Rd near Cubitt St, stop 44",
                        "McCarthy Rd at Russ Hall Park, stop 45",
                        "Cripps St at Douglas Rd, stop 46",
                        "Cripps St at Ness Road, stop 47",
                        "Henson Rd near Ainger St, stop 48",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Henson Rd at Meynell Street, stop 49A",
                        "Henson Rd at Salisbury East, stop 50",
                        "Orange Grove Rd near Georgina St, stop 52A",
                        "Orange Grove Rd at Dulcie Street, stop 52",
                        "Toohey Rd at Toohey Forest, stop 53",
                        "Toohey Rd near Flanders St, stop 52A",
                        "Toohey Rd near Fairlawn St, stop 53"
                    ],
                    "835: Moorvale - Holland Park High": [
                        "Beaudesert Rd at Moorvale, stop 32",
                        "Beaudesert Rd at Dora Street, stop 33",
                        "Beaudesert Rd at Gainsborough Street, stop 34",
                        "Beaudesert Rd at Keats Street, stop 35",
                        "Beaudesert Rd at Fegan Drive, stop 36",
                        "Beaudesert Rd at Muriel - Evans, stop 37",
                        "Evans Rd at Nettleton Crescent, stop 38/39",
                        "Evans Rd at Standish Street, stop 40",
                        "Evans Rd at Industries Street, stop 41/42",
                        "Evans Rd at Pentex Street, stop 43",
                        "McCarthy Rd near Cubitt St, stop 44",
                        "McCarthy Rd at Russ Hall Park, stop 45",
                        "Cripps St at Douglas Rd, stop 46",
                        "Cripps St at Ness Road, stop 47",
                        "Cripps St at Salisbury Interchange, stop 48 zone B",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Henson Rd at Meynell Street, stop 49A",
                        "Henson Rd at Salisbury East, stop 50",
                        "Orange Grove Rd near Georgina St, stop 52A",
                        "Orange Grove Rd at Dulcie Street, stop 52",
                        "Toohey Rd at Toohey Forest, stop 53",
                        "Marshall Rd at Chamberlain Street, stop 49",
                        "Cannes St at Marshall Road, stop 55",
                        "Bapaume Rd at Holland Park High School, stop 62"
                    ],
                    "836: Holland Park High - Moorvale": [
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Bapaume Rd at Marshall Road, stop 55",
                        "Marshall Rd at Heathwhite Street, stop 50",
                        "Marshall Rd at Hexham Street, stop 49",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Prior St at Windmill Street, stop 43",
                        "Windmill St at Pring Street, stop 42",
                        "Bramston St near Andrew Ave, stop 41",
                        "Andrew Ave at Pope Street, stop 40",
                        "Andrew Ave at Elliot Street, stop 39",
                        "Andrew Ave near Fernvale Rd, stop 38",
                        "Andrew Ave at Tarragindi Bowls, stop 38a",
                        "Tarragindi Rd at Bailey Street, stop 37",
                        "Tarragindi Rd at Kenneth Street, stop 36",
                        "Tarragindi Rd at Cosker Street, stop 34",
                        "Cracknell Rd at Juster Street, stop 25A",
                        "Cracknell Rd at Horatio Street, stop 25b",
                        "Ipswich Rd at Yeronga Park, stop 26/27",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Beaudesert Rd at Stimpson Park, stop 29",
                        "Beaudesert Rd at Colebrook - Wharton, stop 30",
                        "Beaudesert Rd at Helles Street, stop 31",
                        "Beaudesert Rd at Moorvale, stop 32"
                    ],
                    "837: Holland Park School - Garden City": [
                        "Wilbur St at Holland Park State School",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Seville Rd at Seville Shops, stop 48",
                        "Elgar St at Macklin St",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Dividend Street, stop 64a",
                        "Wecker Rd at Eastwood Drive, stop 64b",
                        "Ham Rd at Banika Street, stop 64c",
                        "Ham Rd at Linfield Street, stop 64d",
                        "Luprena St at Arura Street, stop 65",
                        "Olivella St near Balamara St, stop 66",
                        "Aminya St at Mansfield, stop 67a",
                        "Cresthaven Dr at Salandra Street, stop 67c/73",
                        "Ham Rd near Rupari St",
                        "Ham Rd at Toulon Street, stop 76",
                        "Ham Rd at Adnar Street, stop 77",
                        "Ham Rd at Koola Street, stop 78",
                        "Boyanda St near Tyrrell St, stop 79",
                        "Mindona St at Mindona Park, stop 80",
                        "Maibry St near Michelle Cr",
                        "Kavanagh Rd near Vicki Pl",
                        "Mannetto St at Gilgo Street, stop 82",
                        "Mannetto St near Cummin St, stop 83",
                        "Cummin St near Monte Carlo St, stop 84",
                        "Delavan St at Delavan Street Park, stop 85",
                        "Delavan St at Wolcott Street, stop 86",
                        "Delavan St at Delavan Terminus, stop 87/78",
                        "Logan Rd at Marada Street, stop 79b",
                        "Logan Rd at Palmdale, stop 79c",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station"
                    ],
                    "838: Vulture St - Seton College": [
                        "Vulture St at Kennedy Street, stop 11",
                        "Vulture St at Rosslyn Street, stop 12/15",
                        "Vulture St at Withington Street, stop 16",
                        "Vulture St at Didsbury Street, stop 17",
                        "Cavendish Rd at Coorparoo College, stop 19",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at Coorparoo Shops, stop 26s",
                        "Cavendish Rd at Shire Street, stop 27/28",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Seton College stop 56/59"
                    ],
                    "839: Glenala High - Acacia Ridge": [
                        "Glenala Rd at Glenala High",
                        "Mortimer Rd at Acacia Ridge West, stop 53",
                        "Mortimer Rd at Brandon Park, stop 54",
                        "Mortimer Rd at Acacia Ridge North, stop 59",
                        "Mortimer Rd near Harden St, stop 54A",
                        "Beaudesert Rd at A & IICS, stop 55/56",
                        "Sussex Rd at Chifley Street, stop 57",
                        "Sussex Rd at Harden Street, stop 58",
                        "Watson Rd near Agnes St, stop 56a/59",
                        "Agnes Street Stop 60 near Oxley St",
                        "Agnes St at Agnes-Gregory Stop 61",
                        "Gregory St at Dunkeld Street, stop 62",
                        "Emily St at Eade Street, stop 63",
                        "Watson Rd at Acacia Ridge",
                        "Chandler St near Gloucester St, stop 65",
                        "Chandler St near Chardean St, stop 66",
                        "Kilkenny St near Chardean St, stop 67",
                        "Kilkenny St near Alderwood St, stop 68",
                        "Alderwood Street Stop 68A near Limerick St",
                        "Alderwood St at Limerick Street Stop 69",
                        "Alderwood St at Mitchell Street Stop 70",
                        "Mitchell St at Acacia Ridge East"
                    ],
                    "840: Heathwood - Sunnybank": [
                        "Parkwood Dr near Watergum St",
                        "Parkwood Dr near Acacia St",
                        "Parkwood Dr near Coolibah St",
                        "Ritchie Rd near Kraft Rd",
                        "Gooderham Rd near Brookbent Rd",
                        "Brookbent Rd near Ivory Cres",
                        "Pallara Ave near Pipet Cr",
                        "Pallara Ave at Gooderham Rd",
                        "Learoyd Rd near Gooderham Rd",
                        "Watson Rd at Learoyd Road",
                        "Alderwood St at Benton Street Stop 67",
                        "Kilkenny St near Alderwood St, stop 68",
                        "Kilkenny St near Chardean St, stop 67",
                        "Chandler St near Forgan St, stop 66",
                        "Chandler St near Gloucester St, stop 65",
                        "Watson Rd at Acacia Ridge",
                        "Emily St at Eade Street, stop 63",
                        "Gregory St at Dunkeld Street, stop 62",
                        "Agnes St at Agnes-Gregory Stop 61",
                        "Agnes Street Stop 60 near Oxley St",
                        "Watson Rd near Sussex St, stop 56a/59",
                        "Watson Rd at Acacia Ridge North, stop 59",
                        "Mortimer Rd near Harden St, stop 54A",
                        "Beaudesert Rd at Mortimer Road, stop 54",
                        "Beaudesert Rd at Acacia Market Place, stop 53",
                        "Beaudesert Rd at Kerry Rd, stop 52",
                        "Beaudesert Rd near Kerry Rd, stop 51/45",
                        "Beaudesert Rd near Boundary Rd, stop 44",
                        "Beaudesert Rd at Meadow Avenue, stop 43",
                        "Beaudesert Rd at Boyland Avenue, stop 42/41",
                        "Beaudesert Rd at Marshall Road, stop 40",
                        "Beaudesert Rd at Salisbury station",
                        "Beaudesert Rd at Moorooka South, stop 38",
                        "Gladstone St at Moorooka South",
                        "Fairlie Tce at Nyanda, stop 41",
                        "Frewin St near Ness Rd",
                        "Henson Rd at Ainsworth Street, stop 49",
                        "Henson Rd at Meynell Street, stop 49A",
                        "Henson Rd at Salisbury East, stop 50",
                        "Orange Grove Rd at Salisbury East, stop 51",
                        "Orange Grove Rd at Aldi, stop 52",
                        "Orange Grove Rd at QG Laboratory",
                        "Musgrave Rd at Orange Grove Road, stop 54b",
                        "Musgrave Rd at Boundary Street",
                        "Mandarin St at Nyleta Street, stop 53",
                        "Mandarin St at Highgate Street, stop 53b",
                        "Middle St near Troughton Rd, stop 54",
                        "Troughton Rd at Musgrave Road",
                        "Troughton Rd at Brittain Park",
                        "Troughton Rd near Vereker St",
                        "Troughton Rd at Banoon near Turton St",
                        "Turton St at Sunnybank State School",
                        "Turton St at Oasis",
                        "Gager St near Young St, zone C"
                    ],
                    "843: Brisbane State High - Yeerongpilly": [
                        "Cordelia St at Brisbane State High, stop 3",
                        "Stephens Rd near Brook St",
                        "Stephens Rd at St Laurences College, stop 7",
                        "Stephens Rd near Annerley Rd, stop 8",
                        "Annerley Rd at Dutton Park Primary, stop 10",
                        "Annerley Rd at Dutton Park, stop 11/17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Noble St at Princess Street, stop 13a",
                        "Noble St at Fenton Street, stop 14a",
                        "Stimpson St near Glengregory St, stop 14A",
                        "Stimpson St at Stimpson - Luya, stop 14B",
                        "Brisbane Corso at Turley Street, stop 15",
                        "Brisbane Corso at Newcastle Street, stop 16",
                        "Turner Ave near Brougham St, stop 17",
                        "Ashby St near Newcastle St, stop 18",
                        "Ashby St at Fairfield Rd, stop 19",
                        "Fairfield Rd at Fairfield - Venner, stop 20",
                        "Fairfield Rd at Ovendean Street, stop 21",
                        "Kadumba St near Eversley Tce, stop 23",
                        "Kadumba St at Kadumba - Colevale, stop 25",
                        "Kadumba St at Kadumba - Douglas, stop 26A",
                        "Kadumba St at St Sebastians School, stop 26",
                        "Kadumba St at Kadumba-Rome St South, stop 27",
                        "Kadumba St at Kadumba - Rhyndarra, stop 28",
                        "Orestes Rd near Rhyndarra St, stop 29",
                        "Orlando Rd near Orama Rd, stop 34/30",
                        "Orlando Rd at Wanganui Gardens, stop 35",
                        "Brisbane Corso near Ormuz Rd, stop 34",
                        "Orsova Rd at Orsova-Brisbane Corso, stop 33",
                        "Orsova Rd near Orvieto Rd, stop 32/31",
                        "Hyde Rd near Utzon St, stop 31",
                        "Hyde Rd at Rome Street North, stop 27",
                        "Hyde Rd near Cansdale St, stop 26/24",
                        "Hyde Rd near Manson Pde, stop 23A",
                        "Hyde Rd at Fairfield Rd, stop 22",
                        "Fairfield Rd at Yeronga station",
                        "Fairfield Rd at Fairfield - Ortive, stop 33"
                    ],
                    "844: Brisbane South Secondary College - Mt Gravatt Cent": [
                        "Annerley Rd at Dutton Park, stop 17/12",
                        "Annerley Rd at Boggo Road, stop 11",
                        "Annerley Rd at Dutton Park Primary, stop 10",
                        "Annerley Rd at Lockhart Street, stop 8",
                        "Annerley Rd at Clarence Street, stop 7",
                        "Buranda busway, platform 2",
                        "Cornwall St at Baron Street, stop 18",
                        "Cornwall St at Cleveland Street, stop 18a",
                        "Logan Rd at Logan Rd North, stop 19",
                        "Logan Rd at Bardsley Avenue, stop 20",
                        "Logan Rd at Greenslopes School, stop 21",
                        "Logan Rd at Greenslopes, stop 22",
                        "Logan Rd at Donaldson Street, stop 23",
                        "Logan Rd at Greenslopes Mall, stop 24",
                        "Logan Rd at Raff Ave, stop 25",
                        "Logan Rd at CB Mott Park, stop 26",
                        "Logan Rd at Swain Street, stop 27",
                        "Logan Rd at Harold Street, stop 28",
                        "Logan Rd at Holland Park, stop 29",
                        "Logan Rd at Barter St, stop 30",
                        "Holland Rd near Stewart St, stop 44",
                        "Holland Rd at Greenmount Avenue, stop 45",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Creek Rd at Mt Gravatt East, stop 60",
                        "Creek Rd at Greek Memorial, stop 59b",
                        "Creek Rd at Fairland Street",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Mt Gravatt Central, stop 38"
                    ],
                    "845: Annerley Rd - Holland Park High": [
                        "Elgar St at Macklin St",
                        "Seville Rd at Seville Shops, stop 48",
                        "Seville Rd near Glindemann Dr, stop 47c",
                        "Glindemann Dr near Seville Rd, stop 47b",
                        "Holland Rd at Lamette Avenue, stop 43A",
                        "Marshall Rd at Heathwhite Street, stop 50",
                        "Marshall Rd at Hexham Street, stop 49",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Toohey Rd at Bramston Terrace, stop 47",
                        "Toohey Rd at Chamberlain Street, stop 46a",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Denham Terrace, stop 44/41",
                        "Cracknell Rd at Toohey Road, stop 40",
                        "Cracknell Rd at Ellington Street, stop 38",
                        "Cracknell Rd at Laura Street, stop 37",
                        "Cracknell Rd at Esther Street, stop 36",
                        "Cracknell Rd near Benbow St, stop 34",
                        "Cracknell Rd at Juster Street, stop 25A",
                        "Cracknell Rd at Horatio Street, stop 25b"
                    ],
                    "846: Tarragindi - Cavendish Rd High": [
                        "Cracknell Rd at Toohey Road, stop 40",
                        "Cracknell Rd at Ellington Street, stop 38",
                        "Cracknell Rd at Laura Street, stop 37",
                        "Cracknell Rd at Esther Street, stop 36",
                        "Cracknell Rd near Benbow St, stop 34",
                        "Tarragindi Rd at Cosker Street, stop 34",
                        "Tarragindi Rd at Kenneth Street, stop 36",
                        "Andrew Ave at Bailey Street, stop 37",
                        "Andrew Ave at Tarragindi Bowls, stop 38a",
                        "Andrew Ave near Fernvale Rd, stop 38",
                        "Fernvale Rd near Pope St",
                        "Fernvale Rd near Prior St",
                        "Homestead St near Kine St, stop 30a",
                        "Tarragindi Rd at La Monte Street, stop 30b",
                        "Fernvale Rd near Pring St",
                        "Fernvale Rd near Elliot St",
                        "Weller Rd near Vantage St",
                        "Cannes St at Marshall Road, stop 55",
                        "Cannes St at Holland Park West",
                        "Bapaume Rd near Mulsanne Rd, stop 61/57",
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd at Dobbs Street, stop 63",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Bapaume Rd at Marshall Road, stop 55",
                        "Holland Rd near Stewart St, stop 44",
                        "Holland Rd at Greenmount Avenue, stop 45",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41"
                    ],
                    "847: Annerley - Holland Park - Mt Gravatt": [
                        "High St near Roblyn St",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Nursery Rd at Iris Street, stop 67",
                        "Nursery Rd at Marvin Street, stop 66",
                        "Nursery Rd at Flynn Street, stop 65",
                        "Nursery Rd at Gaza Road, stop 64",
                        "Bapaume Rd at Dobbs Street, stop 63",
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Bapaume Rd at Marshall Road, stop 55",
                        "Kuring-Gai Ave near Nurinda Lane, stop 54",
                        "Pozieres Rd at Coromandel Street, stop 53a",
                        "Pozieres Rd at Messines Ridge Road, stop 53",
                        "Pozieres Rd at Belvedere Street, stop 52",
                        "Garioch St near Marieander St, stop 51",
                        "Marshall Rd at Heathwhite Street, stop 50",
                        "Marshall Rd at Hexham Street, stop 49",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Toohey Rd at Bramston Terrace, stop 47",
                        "Toohey Rd at Chamberlain Street, stop 46a",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Denham Terrace, stop 44/41",
                        "Cracknell Rd at Toohey Road, stop 40",
                        "Cracknell Rd at Ellington Street, stop 38",
                        "Cracknell Rd at Laura Street, stop 37",
                        "Cracknell Rd at Esther Street, stop 36",
                        "Cracknell Rd near Benbow St, stop 34",
                        "Ekibin Rd at Ekibin Road East, stop 33",
                        "Ekibin Rd at Ferndale Street, stop 32",
                        "Ekibin Rd at Rigby Street, stop 31a",
                        "Ekibin Rd at Chester Street, stop 31",
                        "Ekibin Rd E at Ekibin, stop 30",
                        "Ekibin Rd at Ekibin Park South, stop 28",
                        "Ekibin Rd at Bower Street, stop 27",
                        "Ekibin Rd at Lambton Street stop 25"
                    ],
                    "849: Tarragindi - Cavendish Rd High": [
                        "Annerley Rd at Dutton Park Primary, stop 10",
                        "Annerley Rd at Dutton Park, stop 11/17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Annerley Rd at Hefferan Park, stop 19",
                        "Annerley Rd at Carville Street, stop 20",
                        "Annerley Rd at Palmerston Street, stop 20a",
                        "Annerley Rd at Herbert Street, stop 20b",
                        "Annerley Rd at Portland Street, stop 21",
                        "Annerley Rd at Annerley RSL, stop 21a",
                        "Ipswich Rd at Annerley Junction, stop 22",
                        "Ipswich Rd at Ekibin Road, stop 23",
                        "Ipswich Rd at Venner - Waterton, stop 24",
                        "Ipswich Rd at Chardons Corner, stop 25",
                        "Ipswich Rd at Yeronga Park, stop 26/27",
                        "Ipswich Rd at Clifton Hill, stop 28",
                        "Beaudesert Rd at Stimpson Park, stop 29",
                        "Beaudesert Rd at Colebrook - Wharton, stop 30",
                        "Beaudesert Rd at Helles Street, stop 31",
                        "Beaudesert Rd at Moorvale, stop 32",
                        "Mayfield Rd at Kipling Street, stop 31a",
                        "Mayfield Rd at Harlock Street, stop 31",
                        "Mayfield Rd at Hermes Street, stop 30d",
                        "Tarragindi Rd at Moresby Street, stop 30c",
                        "Tarragindi Rd at La Monte Street, stop 30b",
                        "Fernvale Rd near Pring St",
                        "Fernvale Rd near Elliot St",
                        "Andrew Ave at Pope Street, stop 40",
                        "Bramston St at Pring Street, stop 41a",
                        "Windmill St near Prior St, stop 42/43",
                        "Prior St at Tarragindi, stop 44/48",
                        "Monash Rd at Monash Road Shops, stop 49",
                        "Monash Rd near Ferrand St, stop 51",
                        "Monash Rd at Ferrand Street, stop 52",
                        "Monash Rd at Aldora Street, stop 53",
                        "Monash Rd at Craigmont Street, stop 54",
                        "Monash Rd at Monash Bushlands, stop 55",
                        "Monash Rd at Monash Park, stop 56",
                        "Bapaume Rd at Dobbs Street, stop 63",
                        "Bapaume Rd at Holland Park High School, stop 62",
                        "Bapaume Rd near Sterculia Ave, stop 57/61",
                        "Bapaume Rd at Marshall Road, stop 55",
                        "Weller Rd near Vantage St",
                        "Toohey Rd at Wellers Hill School, stop 47a",
                        "Toohey Rd at Chamberlain Street, stop 46a",
                        "Toohey Rd at Bramston Terrace, stop 47",
                        "Toohey Rd at Tarragindi, stop 44/48",
                        "Marshall Rd at Chamberlain Street, stop 49",
                        "Holland Rd near Stewart St, stop 44",
                        "Holland Rd at Greenmount Avenue, stop 45",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41"
                    ],
                    "850: Clairvaux-Mackillop - Calamvale": [
                        "Logan Rd at St Bernard, stop 42",
                        "Klumpp Rd at Klumpp-Dawson",
                        "Klumpp Rd at Hibiscus",
                        "Garden City Shopping Centre station, stop O",
                        "Kessels Rd at MacGregor, stop 59",
                        "Kessels Rd at Grout Street, stop 58",
                        "Mains Rd at Robertson",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Symons Rd at Sunnybank Hills School",
                        "Hellawell Rd at Signata Street",
                        "Hellawell Rd at Stringybark Street, stop 75",
                        "Hellawell Rd at Cazna Gardens",
                        "Beaudesert Rd near Hellawell Rd, stop 75",
                        "Compton Rd near Chateau St, stop 84",
                        "Compton Rd at Frizzell Street, stop 85",
                        "Compton Rd at Kyabra Street, stop 86",
                        "Eisenhower St at Park, stop 87",
                        "Eisenhower St near Hoover Ct, stop 88",
                        "Harrison St at Truman Court, stop 89",
                        "Harrison St at Washington Place, stop 90",
                        "Penson St near Cleveland Pl, stop 91",
                        "Penson St near Roosevelt Dr, stop 33",
                        "Penson St near Frizzell St, stop 34",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd at Parkside",
                        "Gowan Rd near The Parkway",
                        "Honeysuckle Way at The Parks",
                        "Honeysuckle Way at Calamvale",
                        "Honeysuckle Way at Sunflower"
                    ],
                    "851: St Thomas More - The Parks": [
                        "Troughton Rd at Banoon near Turton St",
                        "Turton St at Sunnybank State School",
                        "Turton St at Oasis",
                        "Gager St near Young St, stop A",
                        "Lister St at Gager St, stop 77",
                        "Lister St at Boorman Street, stop 76",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Elva Street, stop 81",
                        "McCullough St near Chadford St",
                        "McCullough St at Granadilla",
                        "Padstow Rd at Devonlea",
                        "Warrigal Rd at Padstow Views",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Runcorn North",
                        "Warrigal Rd at Fruitgrove",
                        "Beenleigh Rd at Fruitgrove station",
                        "Nursery Ave near Marika St",
                        "Nursery Ave at Runcorn near Silkyoak St",
                        "Nemies Rd at Runcorn Heights near Basking St",
                        "Nemies Rd near Runcorn Heights Primary School",
                        "Nemies Rd at Runcorn West near Belyando St"
                    ],
                    "852: Sunnybank Hills - Garden City": [
                        "Ditton Rd at Cromer Street, stop 62",
                        "Goman St near Ditton Rd, stop 63/64",
                        "Goman St at Exton Street, stop 65",
                        "Findon St near Midholm St, stop 67",
                        "Jackson Rd near Emery St",
                        "Jackson Rd near Chilton St",
                        "Hellawell Rd at Stringybark Street, stop 75",
                        "Hellawell Rd at Signata Street",
                        "Hellawell Rd at Hillcrest Street, stop 72a",
                        "Pinelands Rd at Hellawell",
                        "Symons Rd at Sunnybank Hills School",
                        "Borella Rd at Bendell Park",
                        "Wynne St near Ravenala St",
                        "Wynne St at Chilton Street East, stop 74",
                        "Wynne St at Torbey Street, stop 74",
                        "Wynne St near Garro St, stop 75",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Elva Street, stop 81",
                        "Zamia St at Sunnybank Plaza",
                        "McCullough St at Matt Street, stop 81",
                        "Station Rd at Wen Place, stop 80",
                        "Station Rd at Oasis Gardens, stop 79",
                        "Station Rd at Oasis, stop 78a",
                        "Station Rd at Young Street, stop 78",
                        "Lister St at Gager St, stop 77",
                        "Lister St at Boorman Street, stop 76",
                        "Selvage St near Mains Rd, stop 75/70",
                        "Kylie St near Norinda St, stop 71",
                        "Arcoona St at Jundal Street, stop 72",
                        "Arcoona St at Hedina Street, stop 73",
                        "Arcoona St near Valhalla St, stop 74",
                        "Comley St near Melaleuca St, stop 75",
                        "Granadilla St at Sunderland Street, stop 76",
                        "Granadilla St at Henderson Park, stop 77",
                        "Granadilla St at Ceriman Street, stop 78",
                        "Granadilla St at Mimosa Creek, stop 79",
                        "Parkway St near Springfield St, stop 80",
                        "Springfield St near Mintern St, stop 81",
                        "Garden City Shopping Centre station"
                    ],
                    "853: Carindale - Hawthorne Rd": [
                        "Carindale Shopping Centre station, platform I",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Tristan St at Cuthred Street, stop 53",
                        "Tristan St at Gorlois Court, stop 54",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Lunga Street, stop 40",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Ferguson Rd at Camp Hill Bowls, stop 35s",
                        "Oateson Skyline Dr at Ursus Street, stop 36/37",
                        "Oateson Skyline Dr at Servius Street, stop 38",
                        "Oateson Skyline Dr at Claudia Avenue, stop 38a",
                        "Oateson Skyline Dr at Quirinal Crescent, stop 39",
                        "Oateson Skyline Dr at Darcy Road, stop 40",
                        "Kensington Ave at Kensingston Avenue, stop 40/41",
                        "Agnew St at Seven Hills Stop 42",
                        "Agnew St at Norman Park North",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Riding Rd at Miles Street, stop 24",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd near Beatrice St, stop 21A",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Bennetts Rd near Jean Howie Dr, stop 20",
                        "Kensington Ave near Marshall Ave, stop 41/40",
                        "Oateson Skyline Dr at Caelian Street, stop 37",
                        "Oateson Skyline Dr at Ursus Street, stop 36",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Stanley Rd at Lunga Street, stop 39/40",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Carindale Shopping Centre station, platform B",
                        "Winstanley St near Firmiston St",
                        "Bridgnorth St near Boynedale St",
                        "Bridgnorth St at Belmont School",
                        "Scrub Rd at Winstanley East",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Cribb Rd near Cowell St",
                        "Cribb Road at Cribb Road East"
                    ],
                    "854: Creek & Stanley Rds - Lourdes Hill": [
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Lunga Street, stop 40",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Ferguson Rd at Camp Hill Bowls, stop 35s",
                        "Oateson Skyline Dr at Ursus Street, stop 36/37",
                        "Oateson Skyline Dr at Servius Street, stop 38",
                        "Oateson Skyline Dr at Claudia Avenue, stop 38a",
                        "Oateson Skyline Dr at Quirinal Crescent, stop 39",
                        "Oateson Skyline Dr at Darcy Road, stop 40",
                        "Kensington Ave at Kensingston Avenue, stop 40/41",
                        "Wickham St at Morningside",
                        "Waminda St",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Riding Rd at Miles Street, stop 24",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd near Beatrice St, stop 21A",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Bennetts Rd near Jean Howie Dr, stop 20",
                        "Agnew St at Norman Park North",
                        "Agnew St at Seven Hills Stop 42",
                        "Kensington Ave near Marshall Ave, stop 41/40",
                        "Oateson Skyline Dr at Caelian Street, stop 37",
                        "Oateson Skyline Dr at Ursus Street, stop 36",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Stanley Rd at Lunga Street, stop 39/40",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Tristan St at Gorlois Court, stop 54",
                        "Tristan St at Cuthred Street, stop 53",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "855: Algester Rd - St Thomas More College": [
                        "Algester Rd near Ormskirk St, stop 88A",
                        "Algester Rd at Formby Street Stop 89",
                        "Algester Rd at Crestone Street Stop 90/89",
                        "Algester Rd at Laurel Oak Drive Stop 90A",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Algester",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Beaudesert Rd at Highlands Drive",
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Turton St near Mains Rd",
                        "Turton St near Boorman St",
                        "Turton St near Gager St",
                        "Turton St at Oasis",
                        "Turton St at Sunnybank State School",
                        "Turton St near Troughton Rd",
                        "Troughton Rd at Banoon near Turton St",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands Rd near Noelana St",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Compton Rd near Beaudesert Rd",
                        "Beaudesert Rd at Benhiam Street",
                        "Beaudesert Rd at Kameruka Street",
                        "Beaudesert Rd near Honeysuckle Way",
                        "Beaudesert Rd at Honeysuckle Way",
                        "Algester Rd at Lichfield Place, stop 93",
                        "Algester Rd at Parkinson East, stop 92",
                        "Algester Rd at Lake Eyre Crescent Stop 91"
                    ],
                    "856: Wakerley - Whites Hill College": [
                        "Green Camp Rd near Gumdale St",
                        "Green Camp Rd at Habitat Drive",
                        "Manly Rd at Amberjack Stop 56/61",
                        "Manly Rd at Barramundi Stop 62",
                        "Caloundra St at Janoah Gardens",
                        "Radford Rd at Manly Vista",
                        "Radford Rd near Wondall Rd",
                        "Randall Rd at Network Drive, stop 60",
                        "Randall Rd at Stockyard Street, stop 59a",
                        "Randall Rd at Natasha Street, stop 59",
                        "Randall Rd near Wynnum Rd",
                        "Preston Rd near Wynnum Rd",
                        "Preston Rd fs Brockworth",
                        "Wondall Rd near MacKenzie St",
                        "Wondall Rd at Heers Park, stop 62",
                        "Wondall Rd at Wondall Heights State School,stop 61",
                        "Wondall Rd at Kianawah Rd South hail 'n' ride",
                        "Wondall Rd at Moreton Bay College",
                        "Wondall Rd near Manly Rd",
                        "Manly Rd at Nestle Inn, stop 52/46",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Leon, stop 43",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Annette St at Jarrow Street, stop 49/45",
                        "Annette St at Cahia Street, stop 50/46",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Thurston St at McCorkell Street, stop 53/49",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Grassdale Rd near Belmont Rd",
                        "Grassdale Rd at Stanbrough Rd",
                        "Stanbrough Rd near Grassdale Rd",
                        "Stanbrough Rd near Formosa St",
                        "Stanbrough Rd near New Cleveland Rd",
                        "New Cleveland Rd at Eastside Village",
                        "Tilley Rd at New Cleveland Road",
                        "Tilley Rd near Grassdale Rd",
                        "Tilley Rd near London Rd",
                        "The Sleeman Centre, stop C",
                        "Old Cleveland Rd at Belmont Shooting Complex",
                        "Old Cleveland Rd at Belmont Primary School",
                        "Creek Rd near Bernecker St, stop 75a",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Mayfield Rd at San Sisto Convent",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Gallipoli Rd at Orana Street, stop 37",
                        "Gallipoli Rd at Hecklemann Street, stop 38",
                        "Gallipoli Rd at Salonica Street, stop 39",
                        "Gallipoli Rd at Carina Heights, stop 40/45",
                        "Samuel St at Cambridge Street, stop 44",
                        "Burn St near Fred St",
                        "Burn St near Samuel St, stop 42a",
                        "Samuel St at Jade Street, stop 43",
                        "Winstanley St near Birdwood Rd, stop 45",
                        "Winstanley St at Willard Street, stop 46",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Winstanley St near Firmiston St",
                        "Bridgnorth St near Boynedale St",
                        "Bridgnorth St at Belmont School",
                        "Old Cleveland Rd",
                        "Old Cleveland Rd at Barbeque St",
                        "Old Cleveland Rd near Stanbrough Rd",
                        "The Sleeman Centre, stop D",
                        "Grassdale Rd near Stanbrough Rd",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Wondall Rd hail 'n' ride",
                        "Radford Rd near Lewis Neibling Pl",
                        "Manly Rd at Moreton Bay Boys Stop 63"
                    ],
                    "857: Sunnybank High - Salisbury": [
                        "Gager St near Young St, stop A",
                        "Breton St at Banoon station",
                        "Turton St at Sunnybank State School",
                        "Turton St at Oasis",
                        "Turton St near Gager St",
                        "Turton St near Boorman St",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Pristina Street, stop 67",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Lampson Street",
                        "Wynne St near Garro St, stop 75",
                        "Wynne St at Torbey Street, stop 74",
                        "Wynne St at Chilton Street East, stop 74",
                        "Wynne St near Ravenala St",
                        "Borella Rd at Bendell Park",
                        "Symons Rd at Sunnybank Hills",
                        "Hellawell Rd near Hillcrest St, stop 73/16",
                        "Hellawell Rd at Signata Street",
                        "Stones Rd at Stones Road Reservoir, stop 70",
                        "Stones Rd near Lang St, stop 69",
                        "Lang St near Newcombe St, stop 68",
                        "Findon St near Jackson Rd, stop 67",
                        "Goman St at Exton Street, stop 65",
                        "Goman St near Ditton Rd, stop 64/63",
                        "Ditton Rd at Cromer Street, stop 62",
                        "Ditton Rd near Beaudesert Rd, stop 61"
                    ],
                    "858: Acacia Ridge - Garden City": [
                        "Mitchell St at Acacia Ridge East",
                        "Elizabeth St at Kilkenny",
                        "Watson St at Chardean Street, stop 65",
                        "Watson Rd at Acacia Ridge",
                        "Watson Rd near Agnes St, stop 56a/59",
                        "Watson Rd at Acacia Ridge North, stop 59",
                        "Mortimer Rd at Brandon Park, stop 54",
                        "Mortimer Rd at Acacia Ridge West, stop 53",
                        "Kerry Rd at Beatty Rd, stop 52",
                        "Kerry Rd near Desgrand St, stop 51",
                        "Desgrand St at Spowers Street, stop 50",
                        "Desgrand St at Janzoon Street, stop 49",
                        "Desgrand St at Boundary Rd, stop 48",
                        "Boundary Rd at Postle Street, stop 47",
                        "Boundary Rd at Halt Street, stop 46",
                        "Lensworth St near Selhurst St, stop 59",
                        "Beenleigh Rd at Morden Road, stop 60",
                        "Ditton Rd at Cromer Street, stop 62",
                        "Goman St near Ditton Rd, stop 63/64",
                        "Goman St at Exton Street, stop 65",
                        "Findon St near Midholm St, stop 67",
                        "Lang St near Debenham St, stop 68",
                        "Stones Rd near Lang St, stop 69",
                        "Stones Rd at Stones Road Reservoir, stop 70",
                        "Chilton St at Janina Street, stop 71",
                        "Chilton St at Garro Street, stop 72",
                        "Chilton St near Wynne St, stop 73",
                        "Wynne St at Torbey Street, stop 74",
                        "Wynne St near Garro St, stop 75",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Turton St near Mains Rd",
                        "Turton St near Boorman St",
                        "Turton St near Gager St",
                        "Turton St at Oasis",
                        "Station Rd at Oasis Gardens, stop 79",
                        "Station Rd at Wen Place, stop 80",
                        "McCullough St at Station Road, stop 80a",
                        "McCullough St at Matt Street, stop 81",
                        "Zamia St at Sunnybank Plaza, stop 82",
                        "McCullough St at Sunnybank Plaza",
                        "McCullough St near Chadford St",
                        "McCullough St at Granadilla",
                        "Granadilla St at Sunderland Street, stop 76",
                        "Granadilla St at Henderson Park, stop 77",
                        "Granadilla St at Ceriman Street, stop 78",
                        "Granadilla St at Mimosa Creek, stop 79",
                        "Parkway St near Springfield St, stop 80",
                        "Springfield St near Mintern St, stop 81",
                        "Garden City Shopping Centre station"
                    ],
                    "859: Lourdes Hill - Murarrie": [
                        "Hawthorne Rd near Beatrice St, stop 21A",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Wynnum Rd at Balmoral Cemetery, stop 23",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Wynnum Rd at School of Arts, stop 27",
                        "Wynnum Rd at Morningside Shops, stop 28",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at East Village, stop 34",
                        "Creek Rd near Mitchell Bvd",
                        "Murarrie State School",
                        "Queensport Rd at Murarrie near Railway Tce"
                    ],
                    "860: Carindale - Stephens Rd": [
                        "Carindale Shopping Centre station, platform C",
                        "Donnington St at Donnington, stop 53",
                        "Donnington St at Stanmere, stop 52",
                        "Gallipoli Rd at Tirrabella Street, stop 51",
                        "Gallipoli Rd at Gallipoli, stop 50",
                        "Gallipoli Rd at Gallipoli Road Bushlands, stop 49",
                        "Gallipoli Rd at Warenda Street, stop 48",
                        "Chataway St near Gallipoli Rd, stop 47",
                        "Chataway St at Rea Street, stop 46",
                        "McGahan St near Chataway St, stop 45",
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Chatsworth Rd at Arc Street, stop 40",
                        "Buena Vista Ave at Sector Street, stop 3",
                        "Buena Vista Ave near Spica St, stop 37",
                        "Buena Vista Ave at Crucis Street, stop 36",
                        "Orion St at Sirius Street, stop 36",
                        "Orion St near Satellite St, stop 35",
                        "Eva St near Glyn St, stop 34",
                        "Chatsworth Rd at Gristock Street, stop 33",
                        "Chatsworth Rd at Rossmore Ave, stop 32",
                        "Chatsworth Rd at Stirrat Street, stop 31",
                        "Chatsworth Rd at Trundle Street, stop 30",
                        "Upper Cornwall St at Upper Cornwall, stop 29",
                        "Upper Cornwall St at Pembroke Rd, stop 28",
                        "Cornwall St at Rialto Street, stop 19a",
                        "Cornwall St at Darreen St, stop 19",
                        "Logan St near Juliette St, stop 21",
                        "Juliette St at Beatrice Street, stop 19",
                        "Buranda busway, platform 1",
                        "OKeefe St near Wolseley St",
                        "Cornwall St at PA Hospital South, stop 1",
                        "Cornwall St at Ayr Street, stop 14",
                        "Cornwall St at Rusk Street, stop 14a",
                        "Annerley Rd at Dutton Park, stop 17/12",
                        "Annerley Rd at Boggo Road, stop 11",
                        "Annerley Rd at Dutton Park Primary, stop 10",
                        "Stephens Rd near Athlone St, stop 8",
                        "Stephens Rd at St Laurence College, stop 7",
                        "Stephens Rd at Prospect Tce, stop 7A",
                        "Stephens Rd at Somerville House, stop 5",
                        "Dorchester St at Somerville House, stop 5",
                        "Stephens Rd near Brook St",
                        "Stephens Rd at St Laurences College, stop 7",
                        "Stephens Rd near Annerley Rd, stop 8",
                        "Annerley Rd at Dutton Park, stop 11/17",
                        "Annerley Rd at Cemetery, stop 18/12",
                        "Buranda busway, platform 2",
                        "Cornwall St at Baron Street, stop 18",
                        "Cornwall St at Cleveland Street, stop 18a",
                        "Cornwall St at Darreen Street, stop 19",
                        "Cornwall St at Raby Street, stop 19b",
                        "Upper Cornwall St at Pembroke Street, stop 20/28",
                        "Eva St near Chatsworth Rd, stop 33",
                        "Satellite St at Orion Street, stop 34",
                        "Buena Vista Ave at Crucis Street, stop 37",
                        "Buena Vista Ave near Spica St, stop 38",
                        "Spica St near Chatsworth Rd, stop 38",
                        "Chatsworth Rd at Greens Road, stop 39",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "861: Runcorn High - Algester Rd": [
                        "Algester Rd near Ormskirk St, stop 88A",
                        "Algester Rd at Formby Street Stop 89",
                        "Algester Rd at Crestone Street Stop 90/89",
                        "Algester Rd at Laurel Oak Drive Stop 90A",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Algester",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Hellawell Rd at Cazna Gardens",
                        "Hellawell Rd at Stringybark Street, stop 75",
                        "Hellawell Rd at Signata Street",
                        "Hellawell Rd at Hillcrest Street, stop 72a",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Beenleigh Rd near Ardargie St",
                        "Beenleigh Rd at Runcorn Railway, stop 72",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Hill Rd at Runcorn High School, zone A",
                        "Pinelands",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd at Highlands Drive",
                        "Beaudesert Rd near Algester Rd, stop 21",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Algester Rd at Formby Street Stop 88A"
                    ],
                    "863: Acacia Ridge - Algester - Runcorn High School": [
                        "Beaudesert Rd near Boundary Rd, stop 44",
                        "Beaudesert Rd near Kerry Rd, stop 45/51",
                        "Beaudesert Rd at Kerry Rd, stop 52",
                        "Beaudesert Rd near Kerry Rd, stop 53",
                        "Beaudesert Rd at Mortimer Road, stop 54",
                        "Beaudesert Rd at A & IICS, stop 55/56",
                        "Beaudesert Rd at Durbell Street, stop 73",
                        "Beaudesert Rd near Hellawell Rd, stop 75",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd near Ormskirk St, stop 88A",
                        "Algester Rd at Formby Street Stop 89",
                        "Algester Rd at Crestone Street Stop 90/89",
                        "Algester Rd at Laurel Oak Drive Stop 90A",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Algester Rd at Parkinson East, stop 92",
                        "Algester Rd at Injune Cct, stop 93",
                        "Illaweena St at Tamarisk Way",
                        "Illaweena St at Waterstone",
                        "Gowan Rd at Stretton State College",
                        "Gowan Rd at The Parks",
                        "Gowan Rd near Kameruka St",
                        "Gowan Rd at Parkside",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd near Blackbean St",
                        "Nemies Rd at Runcorn West",
                        "Nemies Rd at Runcorn Heights",
                        "Nursery Ave at Runcorn",
                        "Nursery Ave near Marika St",
                        "Hill Rd at Runcorn High School, zone A"
                    ],
                    "864: Runcorn High - Parkinson": [
                        "Hill Rd at Runcorn High School, zone B",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Wynne St near Garro St, stop 75",
                        "Wynne St at Torbey Street, stop 74",
                        "Wynne St at Chilton Street East, stop 74",
                        "Wynne St near Ravenala St",
                        "Borella Rd at Bendell Park",
                        "Symons Rd at Sunnybank Hills",
                        "Pinelands Rd near Noelana St",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Lynelle St",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd at Highlands Drive",
                        "Beaudesert Rd near Algester Rd, stop 21",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Ridgewood Park near Yorrell",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Lake Eyre Crescent Stop 91",
                        "Algester Rd at Parkinson East, stop 92",
                        "Algester Rd at Injune Cct, stop 93",
                        "Illaweena St at Tamarisk Way",
                        "Illaweena St at Waterstone"
                    ],
                    "865: Calam Rd - Runcorn High": [
                        "Chenin St near Gowan Rd",
                        "Chateau St near Tequila Ct",
                        "Honeywood St near Calam Rd, stop 81",
                        "Pompadour St near Driftwood St",
                        "Pompadour St near Celadon St",
                        "Pompadour St near Seafern St",
                        "Seafern St near Driftwood St",
                        "Gowan Rd near Blackbean St",
                        "Chartreuse St near Dubarry St",
                        "Chartreuse St near Peppercorn Pl",
                        "Peppercorn Pl near Peatmoss St",
                        "Pinelands Rd at Hellawell",
                        "Symons Rd at Sunnybank Hills School",
                        "Borella Rd at Bendell Park",
                        "Wynne St near Ravenala St",
                        "Wynne St at Chilton Street East, stop 74",
                        "Wynne St at Torbey Street, stop 74",
                        "Wynne St near Garro St, stop 75",
                        "Beenleigh Rd near Ardargie St",
                        "Beenleigh Rd at Runcorn Railway, stop 72",
                        "Beenleigh Rd near Datura Street, stop 71",
                        "Hill Rd at Runcorn High School, zone C",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Hellawell Rd near Hillcrest St, stop 73/16",
                        "Symons Rd at Sunnybank Hills",
                        "Terowi St near Evander St",
                        "Dubarry St near Chartreuse St",
                        "Dubarry St near Firelight St",
                        "Gowan Rd at Calliope Street, stop 79",
                        "Seafern St near Honeywood St",
                        "Honeywood St near Calam Rd",
                        "Calam Rd near Honeywood St",
                        "Compton Rd near Chateau St, stop 84",
                        "Compton Rd at Frizzell Street, stop 85",
                        "Compton Rd at Kyabra Street, stop 86",
                        "Eisenhower St at Park, stop 87",
                        "Eisenhower St near Hoover Ct, stop 88",
                        "Harrison St at Truman Court, stop 89",
                        "Harrison St at Washington Place, stop 90",
                        "Penson St near Cleveland Pl, stop 91",
                        "Penson St near Roosevelt Dr, stop 33",
                        "Penson St near Frizzell St, stop 34",
                        "Beaudesert Rd near Algester Rd, stop 21",
                        "Beaudesert Rd near Learoyd Rd, stop 75",
                        "Beaudesert Rd at Durbell Street, stop 73",
                        "Beaudesert Rd near Paradise Rd, stop 72",
                        "Beaudesert Rd near Mannington Rd, stop 58/71",
                        "Beaudesert Rd at Whittingham Street, stop 56",
                        "Beaudesert Rd at A & IICS, stop 55/56",
                        "Beaudesert Rd at Mortimer Road, stop 54",
                        "Beaudesert Rd at Acacia Market Place, stop 53",
                        "Beaudesert Rd at Kerry Rd, stop 52",
                        "Beaudesert Rd near Kerry Rd, stop 51/45",
                        "Beaudesert Rd near Boundary Rd, stop 44"
                    ],
                    "866: St Thomas More - Algester Rd": [
                        "Troughton Rd at Banoon near Turton St",
                        "Turton St at Sunnybank State School",
                        "Turton St at Oasis",
                        "Gager St near Young St, stop B",
                        "Lister St at Gager St, stop 77",
                        "Lister St at Boorman Street, stop 76",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Hellawell Rd near Hillcrest St, stop 73/16",
                        "Hellawell Rd at Signata Street",
                        "Hellawell Rd at Stringybark Street, stop 75",
                        "Hellawell Rd at Cazna Gardens",
                        "Beaudesert Rd near Hellawell Rd, stop 75",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Algester East Stop 79",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Algester, stop 83",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Endiandra St at Bonewood Street, stop 85/86",
                        "Endiandra St near Satinash St, stop 87",
                        "Endiandra St at Macaranga Street, stop 88",
                        "Algester Rd near Ormskirk St, stop 88A",
                        "Algester Rd at Formby Street Stop 89",
                        "Algester Rd at Crestone Street Stop 90/89",
                        "Algester Rd at Laurel Oak Drive Stop 90A",
                        "Algester Rd at Nottingham",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Parkinson, stop 90",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St"
                    ],
                    "867: St Thomas More - Pallara": [
                        "Troughton Rd at Banoon near Turton St",
                        "Turton St at Sunnybank State School",
                        "Turton St at Oasis",
                        "Gager St near Young St, zone C",
                        "Lister St at Gager St, stop 77",
                        "Lister St at Boorman Street, stop 76",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Runcorn School A, stop 68A",
                        "Pinelands",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Calam Rd near Honeywood St",
                        "Beaudesert Rd at Highlands Drive",
                        "Beaudesert Rd near Algester Rd, stop 21",
                        "Beaudesert Rd near Learoyd Rd, stop 75",
                        "Beaudesert Rd at Durbell Street, stop 73",
                        "Beaudesert Rd near Paradise Rd, stop 72",
                        "Beaudesert Rd near Mannington Rd, stop 58/71",
                        "Beaudesert Rd at Whittingham Street, stop 56",
                        "Beaudesert Rd at A & IICS, stop 55/56",
                        "Mortimer Rd near Harden St, stop 54A",
                        "Mortimer Rd at Brandon Park, stop 54",
                        "Gooderham Rd at Brookbent Rd",
                        "Sweets Rd near Ritchie Rd",
                        "Sweets Rd near Esky Rd",
                        "Esky Rd near Kraft Rd",
                        "Laxton Rd near Esky Rd",
                        "Ritchie Rd near Kraft Rd"
                    ],
                    "868: Anglican Church Grammar - Adelaide St": [
                        "Oaklands Pde at Anglican Church Grammar School",
                        "Adelaide St app Wharf St Stop 32",
                        "Adelaide Street Stop 34 near Creek St",
                        "Adelaide Street Stop 39 at David Jones",
                        "Adelaide Street Stop 44 near City Hall"
                    ],
                    "869: Mansfield High - Carindale": [
                        "Ham Rd near Broadwater Rd",
                        "Ham Rd at Mansfield High School",
                        "Ham Rd at Banika Street, stop 64c",
                        "Kirra - Scrub Rd South",
                        "Berkley - Scrub Rd South",
                        "Cribb Rd near Cowell St",
                        "Cribb Road at Cribb Road East",
                        "Cribb Rd at Cribb Road East",
                        "Cribb Rd near Oakwood Way",
                        "Scrub Rd at Carindale Heights",
                        "Scrub Rd at Greendale",
                        "Pine Mountain Rd near Gretna St",
                        "Creek Rd at Salvin Park, stop 69",
                        "Donnington St at Stanmere, stop 52",
                        "Donnington St at Donnington, stop 53",
                        "Carindale Shopping Centre station, platform I"
                    ],
                    "870: Coorparoo - Garden City": [
                        "Garden City Shopping Centre station, stop M",
                        "Logan Rd at Marada Street, stop 79b",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a",
                        "Logan Rd at Mt Thompson, stop 34",
                        "Logan Rd at Glindemann Park, stop 33",
                        "Logan Rd at Boronia Street, stop 32",
                        "Logan Rd at Holland Park South, stop 31",
                        "Logan Rd at Barter Street, stop 30",
                        "Logan Rd at Holland Park, stop 29",
                        "Logan Rd at Harold Street, stop 28",
                        "Logan Rd at Swain Street, stop 27",
                        "Logan Rd at CB Mott Park, stop 26",
                        "Logan Rd at Greenslopes Mall, stop 25/24",
                        "Logan Rd at Donaldson Street, stop 23",
                        "Logan Rd at Greenslopes, stop 22",
                        "Logan Rd at Greenslopes School, stop 21",
                        "Logan Rd at Bardsley Avenue, stop 20",
                        "Logan Rd at Logan Rd North, stop 19",
                        "Logan Rd at Vine Street, stop 18",
                        "Old Cleveland Rd at Panitya Street, stop 18",
                        "Old Cleveland Rd at Coorparoo West Stop 19",
                        "Villanova College",
                        "Upper Cornwall St at Pembroke Street, stop 20/28",
                        "Upper Cornwall St at Upper Cornwall, stop 29",
                        "Logan Rd at Greenslopes Mall, stop 24",
                        "Logan Rd at Raff Ave, stop 25",
                        "Logan Rd at Barter St, stop 30",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "871: Cavendish Rd High - Cannon Hill": [
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Old Stockyards",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Archives, stop 33",
                        "Barrack Rd near Bombery St, stop 60"
                    ],
                    "872: Cavendish Rd High - Queen St bus station": [
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Emlyn Street, stop 31/30",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Shire Street, stop 28/27",
                        "Cavendish Rd at Coorparoo Shops, stop 26",
                        "Cavendish Rd at Wakefield Street, stop 25/21",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Milsom St, stop 19",
                        "Stanley St East at Edgar Street, stop 18",
                        "Stanley St E at Didsbury Street, stop 17",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Fisher Street, stop 15/11",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Queen Street station"
                    ],
                    "873: St Laurences College - Balmoral": [
                        "Apollo Rd near Byron St, stop 41",
                        "Cowper St at Tennyson Street, stop 40b",
                        "McConnell St near Banya St",
                        "Bulimba St at Merry Street",
                        "Brisbane St near Bulimba St, stop 35",
                        "Brisbane St at Coutts Street, stop 34",
                        "Oxford St at Bulimba Ferry, stop 33",
                        "Oxford St at Bulimba Memorial Park, stop 32",
                        "Oxford St at Wambool Street, stop 31",
                        "Riding Rd at Bulimba Preschool, stop 35/41",
                        "Riding Rd near Fifth Ave, stop 34/42",
                        "Riding Rd at Main Avenue, stop 33/43",
                        "Riding Rd at Victoria Street, stop 32/44",
                        "Riding Rd at Grosvenor Street, stop 31/45",
                        "Riding Rd at Hawthorne Park, stop 30/25",
                        "Riding Rd at Miles Street, stop 24",
                        "Riding Rd at Goulburn Street, stop 23",
                        "Riding Rd at Balmoral Cemetery, stop 22",
                        "Wynnum Rd at Balmoral Street, stop 21",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Wynnum Rd at Canning Bridge, stop 17",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Heidelberg St at Heath Street, stop 15",
                        "Heidelberg St near Mowbray Tce, stop 14",
                        "Mowbray Tce near Northcote St, stop 13",
                        "Elfin St near Mowbray Tce, stop 12",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Annerley Rd at Clarence Street, stop 7",
                        "Annerley Rd at Lockhart Street, stop 8",
                        "Stephens Rd near Athlone St, stop 8",
                        "Stephens Rd at St Laurence College, stop 7",
                        "Stephens Rd at St Laurences College, stop 7",
                        "Woolloongabba station, platform 2",
                        "Stanley St at East Brisbane School, stop 10",
                        "Wellington Rd at Linton Street, stop 11",
                        "Mowbray Tce at Elfin Street, stop 12",
                        "Wynnum Rd at Walter Avenue, stop 16",
                        "Wynnum Rd at Norman Creek Bridge, stop 17",
                        "Wynnum Rd at Norman Crescent, stop 19",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Riding Rd near Sixth Ave, stop 34/42",
                        "McConnell St near Johnston St"
                    ],
                    "874: Camp Hill - Cavendish Rd High": [
                        "Perth St at Perth Street Park, stop 33",
                        "Perth St near Wiles St, stop 34/35",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Stanley Rd at Lunga Street, stop 39/40",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Old Stockyards",
                        "Cannon Hill Shopping Centre E",
                        "Creek Rd at Old Stockyards, stop 66a",
                        "Creek Rd at Foxmont Drive, stop 49",
                        "Creek Rd at Carina North near Billan St",
                        "Creek Rd near Meadowlands Rd, stop 76/41",
                        "Creek Rd near Zahel St, stop 75",
                        "Creek Rd near Cuthred St, stop 75A",
                        "Winstanley St at Laurie Street, stop 48/47",
                        "Winstanley St at Willard Street, stop 46",
                        "Samuel St at Cambridge Street, stop 44",
                        "Samuel St at Jade Street, stop 43",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41"
                    ],
                    "875: Lourdes Hill - City, Adelaide St": [
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Hawthorne Rd at Cawmore Street, stop 21",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Wynnum Rd at Canning Bridge, stop 17",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Heidelberg St at Heath Street, stop 15",
                        "Heidelberg St near Mowbray Tce, stop 14",
                        "Mowbray Tce near Northcote St, stop 13",
                        "Elfin St near Mowbray Tce, stop 12",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St"
                    ],
                    "876: Samuel St - All Hallows": [
                        "Samuel St at Jade Street, stop 43",
                        "Carindale Shopping Centre station, platform F",
                        "Old Cleveland Rd at Orwell Street, stop 33",
                        "Ferguson Rd at Camp Hill State School",
                        "Ferguson Rd near Wyena St, stop 36a",
                        "Perth St near Wiles St, stop 34/35",
                        "Perth St at Perth Street Park, stop 33",
                        "Perth St at St Thomas Primary, stop 31",
                        "Joseph St near McIlwraith Ave, stop 30",
                        "McIlwraith Ave at Hume Street, stop 29",
                        "McIlwraith Ave at Katherine Street, stop 28",
                        "McIlwraith Ave near Bennetts Rd, stop 26",
                        "Milsom St near Adina St, stop 24",
                        "Milsom St at Bottomley Park, stop 22/23",
                        "Milsom St at Thomas Street, stop 21",
                        "Stanley St E at Coorparoo Secondary College",
                        "Stanley St East at Edgar Street, stop 18",
                        "Stanley St E at Didsbury Street, stop 17",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Fisher Street, stop 15/11",
                        "Stanley St at Stanley Street East, stop 10",
                        "Main St at The Fiveways, stop 9",
                        "Main St at Linton Street, stop 8C",
                        "Main St at Llewellyn Street, stop 8B",
                        "Main St at Sinclair Street, stop 8A",
                        "Main St at River Terrace, stop 8",
                        "Main St at St Vincent's, stop 7",
                        "Ann Street Stop 218 at All Hallows"
                    ],
                    "877: Cavendish Road High - Garden City": [
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Luprena St at Mansfield North near Amoria St",
                        "Luprena St at Arura Street, stop 65",
                        "Olivella St near Balamara St, stop 66",
                        "Aminya St at Mansfield, stop 67a",
                        "Cresthaven Dr at Salandra Street, stop 67c/73",
                        "Cresthaven Dr at Cresthaven, stop 74",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Ham Rd",
                        "Mansfield High and Junior Schools",
                        "Broadwater Rd at Mansfield Park",
                        "Mt Gravatt Capalaba Rd at Wishart East",
                        "Mt Gravatt Capalaba Rd at Ham Road South",
                        "Mt Gravatt Capalaba Rd at Agaton",
                        "Mt Gravatt Capalaba Rd near Amsterdam St",
                        "Mt Gravatt Capalaba Rd near Dowrie St, stop 62/78",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station"
                    ],
                    "878: Churchie - Camp Hill": [
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Tristan St at Gorlois Court, stop 54",
                        "Tristan St at Cuthred Street, stop 53",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Carindale Shopping Centre station, platform D",
                        "Winstanley St near Firmiston St",
                        "Winstanley St near Hedlow Ct",
                        "Scrub Rd at Winstanley East",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Cribb Rd near Cowell St",
                        "Cribb Rd at Cribb Road East",
                        "Cribb Rd near Oakwood Way",
                        "Pine Mountain Rd near Gretna St",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Greenmeadow Rd near Cornflower St, stop 66",
                        "Greenmeadow Rd near Harvest St, stop 65",
                        "Greenmeadow Rd near Bluebell St, stop 64",
                        "Greenmeadow Rd near Canter St, stop 63",
                        "Greenmeadow Rd near Raintree St, stop 62",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Cavendish Rd at Seton College stop 59/56",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Turquoise Street, stop 49/43",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Oaklands Pde at Anglican Church Grammar School",
                        "Cavendish Rd at Coorparoo College, stop 19",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at Coorparoo Shops, stop 26s",
                        "Cavendish Rd at Shire Street, stop 27/28",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd near Pelham St",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Greenmeadow Rd near Honeysuckle St, stop 61",
                        "Greenmeadow Rd at Greenmeadows",
                        "Greenmeadow Rd near Creek Rd, stop 66",
                        "Pine Mountain Rd near Brechin St",
                        "Pine Mountain Rd near Flame Tree Cr",
                        "Pine Mountain Rd near Linwood St",
                        "Cribb Road at Cribb Road East",
                        "Winstanley St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Carindale Shopping Centre station, platform F",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Lunga Street, stop 40",
                        "Stanley Rd at Garth Webb Park, stop 39",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a"
                    ],
                    "879: Loreto - Eastside Village": [
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Cavendish Rd at Mt Gravatt TAFE, stop 55",
                        "Cavendish Rd at Seton College stop 56/59",
                        "Cavendish Rd at Mt Gravatt East, stop 60",
                        "Greenmeadow Rd near Honeysuckle St, stop 61",
                        "Greenmeadow Rd near Canter St, stop 63",
                        "Greenmeadow Rd near Bluebell St, stop 64",
                        "Greenmeadow Rd at Greenmeadows",
                        "Greenmeadow Rd near Creek Rd, stop 66",
                        "Pine Mountain Rd near Brechin St",
                        "Pine Mountain Rd near Flame Tree Cr",
                        "Pine Mountain Rd near Linwood St",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Cribb Rd near Cowell St",
                        "Cribb Rd at Cribb Road East",
                        "Cribb Rd near Oakwood Way",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Winstanley St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Carindale Shopping Centre station, platform F",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Cadogan St at Bamburgh Street, stop 67/53",
                        "Cadogan St at Whitecastle Street, stop 65/54",
                        "Cadogan St at Cadogan Park, stop 65/54a",
                        "Cadogan St at Breadsell Street, stop 64/63",
                        "Cadogan St at Rolls Court, stop 62",
                        "Meadowlands Rd at Wright Street, stop 60",
                        "Belmont Rd at Hillcroft Place, stop 59/5",
                        "Belmont Rd at Rechner Street, stop 58/54",
                        "Belmont Rd at Burstall Street, stop 57/53",
                        "Belmont Rd at Eversholt St, stop 56/52",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Manly Rd at Lockwood Crescent, stop 53",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "New Cleveland Rd at Eastside Village"
                    ],
                    "880: Mansfield State High - Carindale": [
                        "Ham Rd near Broadwater Rd",
                        "Ham Rd at Mansfield High School",
                        "Ham Rd at Banika Street, stop 64c",
                        "Kirra - Scrub Rd South",
                        "Berkley - Scrub Rd South",
                        "Cribb Rd near Cowell St",
                        "Cribb Road at Cribb Road East",
                        "Cribb Rd at Cribb Road East",
                        "Cribb Rd near Oakwood Way",
                        "Scrub Rd at Carindale Heights",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Winstanley St near Boynedale St",
                        "Winstanley St at Firmiston",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "881: San Sisto Convent - Murarrie": [
                        "Mayfield Rd at San Sisto Convent",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Gallipoli Rd at Orana Street, stop 37",
                        "Gallipoli Rd at Hecklemann Street, stop 38",
                        "Gallipoli Rd at Salonica Street, stop 39",
                        "Gallipoli Rd at Carina Heights, stop 40/45",
                        "Winstanley St at Willard Street, stop 46",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Carindale Shopping Centre station, platform B",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Cadogan St at Bamburgh Street, stop 67/53",
                        "Cadogan St at Whitecastle Street, stop 65/54",
                        "Cadogan St at Cadogan Park, stop 65/54a",
                        "Cadogan St at Breadsell Street, stop 64/63",
                        "Cadogan St at Rolls Court, stop 62",
                        "Meadowlands Rd at Epala Street, stop 56",
                        "Meadowlands Rd at Hilltop Court, stop 57",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Old Stockyards",
                        "Cannon Hill Shopping Centre E",
                        "Railway Tce at Murarrie South near Herbert St",
                        "Queensport Rd at Murarrie near Railway Tce"
                    ],
                    "882: Cavendish Rd High - Loreto - Fortitude Valley": [
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Emlyn Street, stop 31/30",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Shire Street, stop 28/27",
                        "Cavendish Rd at Coorparoo Shops, stop 26",
                        "Cavendish Rd at Wakefield Street, stop 25/21",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Milsom St, stop 19",
                        "Stanley St East at Edgar Street, stop 18",
                        "Stanley St E at Didsbury Street, stop 17",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Fisher Street, stop 15/11",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1",
                        "Mater Hill station, platform 1",
                        "South Bank busway station, platform 1",
                        "Cultural Centre station, platform 1",
                        "Adelaide Street Stop 18 at City Hall",
                        "Adelaide Street Stop 24 near Edward St",
                        "Adelaide Street Stop 28 near Hutton Lane"
                    ],
                    "883: Cavendish Rd High - Cannon Hill": [
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Samuel St at Samuel Street Shops, stop 4",
                        "Samuel St at Herbert Street, stop 42",
                        "Samuel St at Jade Street, stop 43",
                        "Abbott Street Stop 42/34 near Brooks St",
                        "Prout St at Raven Street, stop 41/35",
                        "Prout St near Boundary Rd, stop 40/36",
                        "Boundary Rd at Albert St",
                        "Wiles St at Henderson St",
                        "Stanley Rd at Viminal Hill Crescent, stop 35a",
                        "Stanley Rd at Tranters Avenue, stop 36",
                        "Stanley Rd at Arrol Street, stop 37",
                        "Stanley Rd at Garth Webb Park, stop 38",
                        "Stanley Rd at Lunga Street, stop 39/40",
                        "Stanley Rd at Sage Street, stop 41",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Creek Rd at Carina Bus Depot",
                        "Creek Rd at Carindale Tennis Centre, stop 46",
                        "Creek Rd at Fursden Road, stop 47",
                        "Creek Rd at Carina North, stop 49",
                        "Creek Rd near Foxmont Dr, stop 50",
                        "Creek Rd at Minnippi Bvd",
                        "Creek Rd at Old Stockyards",
                        "Cannon Hill Shopping Centre E",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Archives, stop 33",
                        "Barrack Rd near Bombery St, stop 60"
                    ],
                    "884: Balmoral High - Mt Gravatt Central": [
                        "Walkers Dr near Fifth Ave, stop 32a",
                        "Fifth Ave near Lytton Rd, stop 33",
                        "Lytton Rd at Cecil Street, stop 34",
                        "Lytton Rd at Taylor Street, stop 35",
                        "Lytton Rd at Bolan Street, stop 36",
                        "Lytton Rd at Nuttall Street, stop 40",
                        "Hawthorne Rd at Forbes Street, stop 21b",
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Wynnum Rd at Waldo Street, stop 20",
                        "Wynnum Rd at Norman Avenue, stop 18",
                        "Wynnum Rd at Canning Bridge, stop 17",
                        "Lytton Rd at Walter Avenue, stop 16",
                        "Oaklands Pde at Anglican Church Grammar School",
                        "Cavendish Rd at Coorparoo College, stop 19",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Wakefield Street, stop 21/25",
                        "Cavendish Rd at Coorparoo Shops, stop 26s",
                        "Cavendish Rd at Shire Street, stop 27/28",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Emlyn Street, stop 30/31",
                        "Cavendish Rd at Mt Carmel School, stop 32",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Meridian Street, stop 37a",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Holland Park East, stop 42",
                        "Cavendish Rd at Crystal Street, stop 50",
                        "Cavendish Rd at Oates Avenue, stop 51",
                        "Cavendish Rd at Pine Mountain, stop 52",
                        "Cavendish Rd at Coolong Street, stop 53",
                        "Cavendish Rd at Coolibah Street, stop 54",
                        "Camlet St at Little Cavendish Rd, stop 55",
                        "Camlet St at Mapleton Street, stop 56",
                        "Camlet St near Kentish St, stop 57/41",
                        "Kentish St at Pond Street, stop 58",
                        "Kentish St at Canterbury Street, stop 59",
                        "Creek Rd at Fairland Street",
                        "Creek Rd at Chrysler Street, stop 40",
                        "Creek Rd at Grenfell Street, stop 39",
                        "Creek Rd at Mt Gravatt Central, stop 38"
                    ],
                    "886: Cavendish Rd - Woolloongabba": [
                        "Cavendish Rd at Cavendish Rd High School, stop 41",
                        "Cavendish Rd at Cavendish Rd Reservoir, stop 40",
                        "Cavendish Rd at Capella Street, stop 39",
                        "Cavendish Rd at Stoneleigh Street, stop 38",
                        "Cavendish Rd at Arlington Street, stop 37",
                        "Cavendish Rd at Loreto College, stop 35",
                        "Cavendish Rd at Goring Street, stop 34",
                        "Cavendish Rd at St Stephens, stop 33",
                        "Cavendish Rd at Emlyn Street, stop 31/30",
                        "Cavendish Rd at York Street, stop 29",
                        "Cavendish Rd at Shire Street, stop 28/27",
                        "Cavendish Rd at Coorparoo Shops, stop 26",
                        "Cavendish Rd at Wakefield Street, stop 25/21",
                        "Cavendish Rd at Yarrabin Street, stop 20",
                        "Cavendish Rd at Milsom St, stop 19",
                        "Stanley St East at Edgar Street, stop 18",
                        "Stanley St E at Didsbury Street, stop 17",
                        "Stanley St E at Longlands Street, stop 16",
                        "Stanley St at Fisher Street, stop 15/11",
                        "Stanley St at Stanley Street East, stop 10",
                        "Woolloongabba station, platform 1"
                    ],
                    "887: Carindale - Garden City": [
                        "Garden City Shopping Centre station, stop B",
                        "Newnham Rd near Tryon St, stop 79",
                        "Newnham Rd at Delavan, stop 78",
                        "Newnham Rd at Montreal Street, stop 77a",
                        "Newnham Rd at Arila Street, stop 77",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Tolson Street, stop 75",
                        "Wishart Rd near Pasley St, stop 75",
                        "Wishart Rd near Invicta St",
                        "Wishart Rd near Elkana Pl, stop 76",
                        "Wishart Rd near Ham Rd, stop 77",
                        "Ham Rd at Adnar Street, stop 77",
                        "Ham Rd near Broadwater Rd",
                        "Ham Rd at Mansfield High School",
                        "Ham Rd at Banika Street, stop 64c",
                        "Wecker St at Eastwood Drive, stop 64b",
                        "Wecker Rd at Dividend Street, stop 64a",
                        "Wecker Rd at Wecker Rd Business Center, stop 63",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Greenmeadow Rd near Honeysuckle St, stop 61",
                        "Greenmeadow Rd near Canter St, stop 63",
                        "Greenmeadow Rd near Bluebell St, stop 64",
                        "Greenmeadow Rd at Greenmeadows",
                        "Greenmeadow Rd near Creek Rd, stop 66",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd at Salvin Park, stop 69",
                        "Creek Rd near Gallipoli Rd, stop 70",
                        "Creek Rd near Buzacott St, stop 71",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Carindale Shopping Centre station, platform E",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Bedivere St near Agravain St",
                        "Bedivere St at Lindisfarne Street",
                        "Meadowlands Rd near Bedivere St",
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Stanley Rd at Vince Herbert Field, stop 45",
                        "Stanley Rd at Carina Bowls, stop 44",
                        "Stanley Rd at Orana Street, stop 43",
                        "Stanley Rd at Pembroke Street, stop 42",
                        "Stanley Rd at Sage Street, stop 41",
                        "Mayfield Rd at San Sisto Convent",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Gallipoli Rd at Orana Street, stop 37",
                        "Gallipoli Rd at Hecklemann Street, stop 38",
                        "Gallipoli Rd at Salonica Street, stop 39",
                        "Gallipoli Rd at Carina Heights, stop 40/45",
                        "Samuel St at Cambridge Street, stop 44",
                        "Burn St near Fred St",
                        "Burn St near Samuel St, stop 42a",
                        "Donnington St at Stanmere, stop 52",
                        "Donnington St at Donnington, stop 53",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "888: Lourdes Hill College - Eastside Village": [
                        "Hawthorne Rd near Beatrice St, stop 21A",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Wynnum Rd at Balmoral Cemetery, stop 23",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Wynnum Rd at School of Arts, stop 27",
                        "Wynnum Rd at Morningside Shops, stop 28",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at East Village, stop 34",
                        "Cannon Hill Shopping Centre E",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Belmont Rd at Palgrave Street, stop 47/43",
                        "Belmont Rd at Annette Street, stop 48/44",
                        "Thurston St at Peachdale Street, stop 55/51",
                        "Thurston St at Loughrea Street, stop 54/50",
                        "Thurston St at McCorkell St, stop 53/49",
                        "Thurston St at Wallington Street, stop 52/48",
                        "Castlerea St at Roscrea Street, stop 51/47",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Manly Rd at Lockwood Crescent, stop 53",
                        "Arenga St near Manly Rd",
                        "Arenga St near Gordon Cr",
                        "Arenga St near Williams St",
                        "Caladium St near Basella St",
                        "Caladium St near Underwood St",
                        "Caladium St near Matthews Way",
                        "New Cleveland Rd at Eastside Village"
                    ],
                    "889: Carindale - Garden City": [
                        "Meadowlands Rd at Carina State School, stop 58",
                        "Meadowlands Rd near Bedivere St",
                        "Bedivere St at Lindisfarne Street",
                        "Bedivere St near Cadogan St",
                        "Bedivere St at Tristan Street, stop 68/52",
                        "Carindale Shopping Centre station, platform E",
                        "Winstanley St near Hedlow Ct",
                        "Scrub Rd at Winstanley East",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Cribb Rd near Cowell St",
                        "Cribb Rd at Cribb Road East",
                        "Cribb Rd near Oakwood Way",
                        "Pine Mountain Rd near Gretna St",
                        "Creek Rd at Pacific Golf, stop 68",
                        "Creek Rd near Glen Nevis St, stop 67",
                        "Greenmeadow Rd near Cornflower St, stop 66",
                        "Greenmeadow Rd near Harvest St, stop 65",
                        "Greenmeadow Rd near Bluebell St, stop 64",
                        "Greenmeadow Rd near Canter St, stop 63",
                        "Greenmeadow Rd near Raintree St, stop 62",
                        "Creek Rd at Greenmeadows South, stop 61",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Dividend Street, stop 64a",
                        "Wecker Rd at Eastwood Drive, stop 64b",
                        "Ham Rd at Banika Street, stop 64c",
                        "Ham Rd at Linfield Street, stop 64d",
                        "Ham Rd near Kelnat St",
                        "Ham Rd near Rupari St",
                        "Ham Rd at Toulon Street, stop 76",
                        "Ham Rd at Adnar Street, stop 77",
                        "Wishart Rd near Hibiscus Cl, stop 77",
                        "Wishart Rd near Elkana Pl, stop 76",
                        "Wishart Rd near Pasley St, stop 75",
                        "Newnham Rd at Tolson Street, stop 75",
                        "Newnham Rd near Zetland St",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Arila Street, stop 77",
                        "Newnham Rd at Montreal Street, stop 77A",
                        "Newnham Rd at Delavan, stop 78",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station",
                        "Mayfield Rd at San Sisto Convent",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Old Cleveland Rd near Gallipoli Rd Stop 37",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Winstanley St near Firmiston St"
                    ],
                    "890: Garden City - Mt Gravatt High": [
                        "Garden City Shopping Centre station, stop N",
                        "Logan Rd at Marada Street, stop 79b",
                        "Logan Rd at Palmdale, stop 79c",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Logan Rd at St Bernard, stop 42",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "High St near Roblyn St",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Logan Rd at Australian Tax Office, stop 80",
                        "Garden City Shopping Centre station"
                    ],
                    "891: Parkinson - Garden City": [
                        "Algester Rd at Parkinson, stop 90",
                        "Algester Rd at Glenfield",
                        "Algester Rd at Nottingham",
                        "Ridgewood Rd near Kulcha St",
                        "Ridgewood Rd at Ridgewood Heights",
                        "Ridgewood Rd at Helicia Street, stop 85a",
                        "Ridgewood Rd at Ridgewood Park near Yorrell St",
                        "Ridgewood Rd at Woollybutt Street, stop 84",
                        "Ridgewood Rd at Algester",
                        "Ridgewood Rd at Rapanea Street, stop 82",
                        "Ridgewood Rd at Limewood Place, stop 81",
                        "Algester Rd at Algester East Stop 79",
                        "Algester Rd at Algester Central Stop 78A",
                        "Algester Rd at Dellforest Drive Stop 78",
                        "Algester Rd at Beaudesert Road Stop 76",
                        "Beaudesert Rd at Highlands Drive",
                        "Calam Rd near Lear St",
                        "Pinelands Rd at Sunnybank Hills South",
                        "Pinelands Rd at Hellawell",
                        "Pinelands Rd at Barney Street, stop 70/71",
                        "Pinelands",
                        "Mains Rd at Runcorn School A, stop 68B",
                        "Mains Rd at Altandi, stop 68",
                        "Mains Rd at Pristina Street, stop 79",
                        "Mains Rd at Turton Street, stop 80",
                        "Mains Rd at Elva Street, stop 81",
                        "Mains Rd at Sunnybank",
                        "Mains Rd at Robertson",
                        "Kessels Rd at Grout Street, stop 2/58",
                        "Kessels Rd at MacGregor, stop 59",
                        "Garden City Shopping Centre station"
                    ],
                    "892: Mt Gravatt High - Garden City - The Parks": [
                        "High St near Roblyn St",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station, stop K",
                        "MacGregor St at Garden City Depot",
                        "Warrigal Road Green Link",
                        "Warrigal Rd at Padstow Views",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Runcorn North",
                        "Warrigal Rd at Fruitgrove",
                        "Beenleigh Rd at Fruitgrove station",
                        "Nursery Ave near Marika St",
                        "Nursery Ave at Runcorn near Silkyoak St",
                        "Nemies Rd at Runcorn Heights near Basking St",
                        "Nemies Rd near Runcorn Heights Primary School",
                        "Nemies Rd at Runcorn West near Belyando St",
                        "Gowan Rd at Calliope Street, stop 79",
                        "Compton Rd at Frizzell Street, stop 85",
                        "Compton Rd at Kyabra Street, stop 86",
                        "Eisenhower St at Park, stop 87",
                        "Eisenhower St near Hoover Ct, stop 88",
                        "Harrison St at Truman Court, stop 89",
                        "Harrison St at Washington Place, stop 90",
                        "Penson St near Cleveland Pl, stop 91",
                        "Penson St near Roosevelt Dr, stop 33",
                        "Penson St near Frizzell St, stop 34",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd at Parkside",
                        "Gowan Rd at The Parks"
                    ],
                    "893: Browns Plains - Garden City": [
                        "Browns Plains station, stop 3B",
                        "Beaudesert Rd at Illaweena Street",
                        "Honeysuckle Way at Sunflower",
                        "Honeysuckle Way at Calamvale",
                        "Gowan Rd at The Parks",
                        "Gowan Rd at Parkside",
                        "Gowan Rd at Pennant Hills",
                        "Gowan Rd near Palatine St, stop 36",
                        "Gowan Rd at Calam North, stop 35",
                        "Gowan Rd at Gowan and Compton",
                        "Gowan Rd near Blackbean St",
                        "Nemies Rd at Runcorn West",
                        "Nemies Rd at Runcorn Heights",
                        "Nursery Ave at Runcorn",
                        "Nursery Ave near Marika St",
                        "Beenleigh Rd at Fruitgrove station",
                        "Warrigal Rd at Fruitgrove",
                        "Warrigal Rd at Runcorn North",
                        "Warrigal Rd near Daw Rd",
                        "Warrigal Rd at Fanfare",
                        "Warrigal Rd at Bordeaux",
                        "Warrigal Rd at Padstow Views",
                        "Warrigal Road Green Link",
                        "MacGregor St at Garden City Depot",
                        "Garden City Shopping Centre station",
                        "High St near Roblyn St",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Showgrounds, stop 38A",
                        "Logan Rd at Wishart Road, stop 39",
                        "Logan Rd at Wanda, stop 40",
                        "Logan Rd at Dittmer Park, stop 41",
                        "Logan Rd at St Bernards, stop 42",
                        "Logan Rd at Kessels Corner, stop 43",
                        "Logan Rd at Mt Gravatt Corner, stop 44",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station, stop K",
                        "Nursery Ave at Runcorn near Silkyoak St",
                        "Nemies Rd at Runcorn Heights near Basking St",
                        "Nemies Rd near Runcorn Heights Primary School",
                        "Nemies Rd at Runcorn West near Belyando St"
                    ],
                    "894: Sixth Ave - Cribb Rd": [
                        "Villanova College",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Carindale Shopping Centre station, platform B",
                        "Winstanley St near Firmiston St",
                        "Bridgnorth St near Boynedale St",
                        "Bridgnorth St at Belmont School",
                        "Scrub Rd at Winstanley East",
                        "Scrub Rd at Kilmorey near Fairway Pl",
                        "Scrub Rd at Greendale",
                        "Scrub Rd at Carindale Heights",
                        "Cribb Rd near Cowell St",
                        "Cribb Road at Cribb Road East"
                    ],
                    "895: Villanova - Carindale": [
                        "Villanova College",
                        "Old Cleveland Rd at Saint Leonards Street Stop 21",
                        "Old Cleveland Rd at Macaulay Street Stop 22",
                        "Old Cleveland Rd at Coorparoo Stop 23",
                        "Old Cleveland Rd at Coorparoo Primary",
                        "Old Cleveland Rd at Burke Street Stop 25",
                        "Old Cleveland Rd at Kismet Street Stop 26",
                        "Old Cleveland Rd at Madeline Street Stop 27",
                        "Old Cleveland Rd at Dorothy Lane Stop 28",
                        "Old Cleveland Rd at Pampling Street Stop 29",
                        "Old Cleveland Rd at Camp Hill",
                        "Old Cleveland Rd at Camp Hill Primary",
                        "Old Cleveland Rd at Orwell Street Stop 33",
                        "Old Cleveland Rd at Wonersh Street Stop 34",
                        "Old Cleveland Rd at Carina Stop 35",
                        "Old Cleveland Rd at Pembroke Street Stop 36",
                        "Gallipoli Rd at Orana Street, stop 37",
                        "Gallipoli Rd at Hecklemann Street, stop 38",
                        "Gallipoli Rd at Salonica Street, stop 39",
                        "Gallipoli Rd at Carina Heights, stop 40/45",
                        "Winstanley St at Willard Street, stop 46",
                        "Winstanley St at Macalister Street, stop 47",
                        "Winstanley St at Laurie Street, stop 47a/48",
                        "Winstanley St at Carindale Shops, stop 49",
                        "Carindale Shopping Centre Interchange"
                    ],
                    "896: Mt Gravatt High - Garden City": [
                        "High St near Roblyn St",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at Rover Street, stop 38",
                        "Broadwater Rd at Wardle Street, stop 39",
                        "Broadwater Rd at Hillgrove, stop 40",
                        "Hillgrove St at Kingsway Street, stop 41",
                        "Hillgrove St at Exmoor Street, stop 42",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Newnham Rd at Tolson Street, stop 75",
                        "Newnham Rd near Zetland St",
                        "Newnham Rd at Wishart West, stop 76",
                        "Newnham Rd at Arila Street, stop 77",
                        "Newnham Rd at Montreal Street, stop 77A",
                        "Newnham Rd at Delavan, stop 78",
                        "Tryon St at Greenleaves Village, stop 79",
                        "Tryon St at Mascar Street, stop 81",
                        "Mt Gravatt Capalaba Rd at Tryon, stop 61",
                        "Kessels Rd at Cremin Street, stop 60/45",
                        "Garden City Shopping Centre station"
                    ],
                    "897: Wishart SS - Clairvaux Mac - Wishart Outlook": [
                        "Morella St near Balloch St",
                        "Newnham Rd near Zetland St",
                        "Newnham Rd at Wishart West, stop 76",
                        "Dawson Rd near Cale St, stop 76B",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Dawson Rd at Gurney Street, stop 78",
                        "Dawson Rd at Gerty Street, stop 79",
                        "Klumpp Rd at Klumpp-Dawson",
                        "Klumpp Rd at Hibiscus",
                        "Garden City Shopping Centre station, stop O",
                        "MacGregor St at Garden City Depot",
                        "Holmead Rd at Brisbane Holiday Village",
                        "Holmead Rd at Nardie St",
                        "Nardie St at Goorari St",
                        "Nardie St at Blue Grass Cr",
                        "Nardie St at Vanderbilt St",
                        "Holmead Rd near Brampton St",
                        "Holmead Rd at Wishart Lookout"
                    ],
                    "898: Garden City - Newnham Rd": [
                        "Garden City Shopping Centre station, stop F",
                        "Logan Rd at Kessels Corner, stop 44",
                        "Logan Rd at Upper Mt Gravatt School, stop 43",
                        "Dawson Rd at Gerty Street, stop 79",
                        "Dawson Rd at Gurney Street, stop 78",
                        "Dawson Rd at Brockhouse Street, stop 77",
                        "Dawson Rd near Dowrie St, stop 77",
                        "Montreal St near Colombo St",
                        "Monte Carlo St near Auckland St",
                        "Cummin St near Monte Carlo St, stop 84",
                        "Mannetto St near Matincock St, stop 83",
                        "Mannetto St at Gilgo Street, stop 82",
                        "Greenwood St near Kavanagh Rd, stop 81",
                        "Mindona St at Mindona Park, stop 80",
                        "Boyanda St near Tyrrell St, stop 79",
                        "Ham Rd at Koola Street, stop 78",
                        "Ham Rd at Adnar Street, stop 77",
                        "Broadwater Rd near Ham Rd",
                        "Broadwater Rd at Broadwater Creek, stop 75",
                        "Broadwater Rd near Mailey St, stop 74",
                        "Broadwater Rd near Newnham Rd, stop 72",
                        "Broadwater Rd near Valmar St",
                        "Hillgrove St at Kingsway Street, stop 41",
                        "Hillgrove St at Exmoor Street, stop 42",
                        "Wishart Rd at Pinner Street, stop 43",
                        "Wishart Rd at Newnham Road, stop 44/74",
                        "Morella St near Balloch St",
                        "Newnham Rd near Zetland St",
                        "Ham Rd near Broadwater Rd",
                        "Luprena St at Mansfield North near Amoria St",
                        "Wecker Rd at Wecker Rd Business Center, stop 63",
                        "Wecker Rd at Wecker Road, stop 62",
                        "Wecker Rd at Grevillea Oval, stop 61",
                        "Mt Gravatt East School - 61",
                        "Newnham Rd at Enderby Street, stop 62",
                        "Condong St near Valentia St, stop 69a",
                        "Condong St near Togar St, stop 69A",
                        "Condong St near Mingera St, stop 68",
                        "Lorinya St near Valentia St",
                        "Newnham Rd at Westbrooke Street, stop 71",
                        "Wishart Rd at Newnham Road, stop 74/44",
                        "Wishart Rd at Exmoor Street, stop 42",
                        "Hillgrove St near Broadwater Rd",
                        "Broadwater Rd at Hillgrove, stop 40",
                        "Broadwater Rd at Wardle Street, stop 39",
                        "Logan Rd at Rover Street, stop 38",
                        "Logan Rd at Mt Gravatt Central, stop 37",
                        "Logan Rd at High Street, stop 36",
                        "Logan Rd at Mt Gravatt School, stop 35s",
                        "Logan Rd at Big Top, stop 35a"
                    ],
                    "899: Lourdes Hill College - Wynnum": [
                        "Hawthorne Rd at Lourdes Hill, stop 21a",
                        "Balmoral St near Philip St, stop 21",
                        "Balmoral St at Dover Street, stop 22",
                        "Wynnum Rd at Balmoral Cemetery, stop 23",
                        "Wynnum Rd at Balmoral Park, stop 24",
                        "Wynnum Rd at Morningside Rail, stop 25",
                        "Wynnum Rd at School of Arts, stop 27",
                        "Wynnum Rd at Morningside Shops, stop 28",
                        "Wynnum Rd at Abinger, stop 29",
                        "Wynnum Rd at Morningside Central, stop 30",
                        "Wynnum Rd at Cannon Hill Primary, stop 31",
                        "Wynnum Rd at Cash Park, stop 32",
                        "Wynnum Rd at Archives, stop 33",
                        "Wynnum Rd at East Village, stop 34",
                        "Wynnum Rd at Cannon Hill",
                        "Wynnum Rd at Northcliffe, stop 36",
                        "Wynnum Rd at Murarrie Park, stop 37",
                        "Wynnum Rd at Bulimba Creek, stop 38",
                        "Wynnum Rd at Murarrie Road",
                        "Wynnum Rd at Tingalpa West near Crossley Ave",
                        "Wynnum Rd at Kianawah Park, stop 41",
                        "Wynnum Rd near Thornlake Ct",
                        "Manly Rd at Leon, stop 43",
                        "Manly Rd near Castlerea St",
                        "Manly Rd at Villanova Park, stop 45",
                        "Manly Rd at Nestle Inn, stop 46/52",
                        "Manly Rd at Lockwood Crescent, stop 53",
                        "Manly Rd at Mayfair Village Stop 53a",
                        "Manly Rd at Moss Road Stop 54",
                        "Manly Rd at Catamaran Stop 55",
                        "Manly Rd at Amberjack Stop 56/61",
                        "Manly Rd at Barramundi Stop 62",
                        "Manly Rd at Moreton Bay Boys Stop 63",
                        "Manly Rd at Silky Oaks",
                        "Manly Rd at Talwong Stop 65",
                        "Manly Rd at Manly West near Stannard Rd",
                        "Stannard Rd at Milfoil Street, stop 67",
                        "Stannard Rd at Stannard Road Park, stop 66",
                        "Stannard Rd at Lenora Street, stop 65",
                        "Stannard Rd at Aphrodite Street, stop 64",
                        "Stannard Rd at Stannard Road Creek, stop 63",
                        "Wondall Rd at Heers Park, stop 62",
                        "Wondall Rd at Wondall Heights State School,stop 61",
                        "Randall Rd at Network Drive, stop 60",
                        "Randall Rd at Stockyard Street, stop 59a",
                        "Randall Rd at Natasha Street, stop 59",
                        "Wynnum Rd at Wynnum Plaza, stop 58"
                    ],
                    "901: Albany Creek - Padua/Mt Alvernia": [
                        "Keong Rd near Hampshire Tce",
                        "Keong Rd near Dawn Rd",
                        "Keong Rd near Jambaroo St",
                        "Keong Rd near Essex Dr",
                        "Keong Rd near Malvern Rd",
                        "Keong Rd at Preston Point",
                        "Keong Rd at Leitchs Road",
                        "Albany Creek Rd at Albany Creek State School",
                        "Wruck Cr at Albany Village",
                        "Flamingo Dr near Chickowee St",
                        "Faheys Rd West at Kingfisher",
                        "Morgan Rd at Morgan",
                        "Albany Forest Dr at Dove",
                        "Albany Forest Dr at Explorer",
                        "Old Northern Rd at Albany Creek High",
                        "Old Northern Rd at Keong Road",
                        "Old Northern Rd at The Boulevard",
                        "Old Northern Rd at Allamanda Crescent",
                        "Old Northern Rd at Hamilton Road",
                        "Old Northern Rd at Chinook",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Rode Rd at Trouts Road",
                        "Rode Rd near Cilento St, stop 44a",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd near Tyrone St",
                        "Appleby Rd at Stafford Heights",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Appleby Rd at Ringrose Street, stop 38",
                        "Appleby Rd at Stafford Heights South",
                        "Wilgarning St at Kingaroy Street, stop 3",
                        "Wilgarning St at Mumbil St",
                        "Wilgarning St near Webster Rd",
                        "Moree St at View Street, stop 42",
                        "Moree St at Dawn Street, stop 43",
                        "Padua College - Jardine St Stop A"
                    ],
                    "904: Ferny Hills - Ferny Grove High and Primary": [
                        "Gordon Rd near Owarra Ave",
                        "Gordon Rd near Andina Cr",
                        "Patricks Rd near Wallaroy Ct",
                        "Patricks Rd near Bunora Ave",
                        "Patricks Rd near Ferny Way",
                        "Patricks Rd near Cycas St",
                        "Patricks Rd near Leslie St",
                        "Patricks Rd at Nepean Ave",
                        "Dawson Pde at Leagues Club",
                        "Silvertop St at Keperra station, stop 30",
                        "Blackbutt St near Alpine St, stop 31",
                        "Satinay St at Samford - Blackbutt",
                        "Glenmorgan St near Aramac St, stop 33",
                        "Eidsvold St at Calen St, stop 34",
                        "Eidsvold St at Eidsvold - Welford, stop 35",
                        "Eidsvold St near Camoola St, stop 36",
                        "Camoola St at Camoola - Bowyer, stop 36A",
                        "Gilliat St near Camoola St, stop 36b",
                        "Cobalt St at Onyx St",
                        "Marble St near Lapilli St",
                        "Mungarie St at Cobalt St",
                        "Cobalt St at Balvenie St",
                        "Cobalt St at Kindilan Place",
                        "Samford Rd at Cobalt St",
                        "Samford Rd near Warrong St",
                        "Samford Rd near Claverton St",
                        "Tramway St near Arbor St",
                        "Ferny Grove High School",
                        "Ferny Grove Primary School",
                        "McGinn Rd at Archdale Rd",
                        "McGinn Rd at Ferny Grove High School",
                        "Samford Rd near Tramway St",
                        "Camoola St at Bowyer St, stop 36a",
                        "Camoola St near Avington St, stop 37",
                        "Eidsvold St at Welford St, stop 35",
                        "Glenmorgan St near Keperra St, stop 33",
                        "Blackbutt St at Keperra station, stop 30",
                        "Madsen St at Grovely State School",
                        "Dawson Pde near Casey St",
                        "Patricks Rd at Arana Hills K Mart",
                        "Patricks Rd near Bargo St",
                        "Patricks Rd near Wingara Gr",
                        "Gordon Rd near Anora Cr"
                    ],
                    "905: Ferny Grove - St Pauls & Strathpine": [
                        "Ferny Grove station, stop B (Temporary)",
                        "Gordon Rd near Owarra Ave",
                        "Gordon Rd near Andina Cr",
                        "Hutton Rd near Yingally Dr",
                        "Hutton Rd at Yalamba Court",
                        "Bunya Road near Woodhill Rd",
                        "Bunya Rd at Blackwood",
                        "Bunya Rd near Arlington Dr",
                        "Bunya Rd at Francis Road",
                        "South Pine Rd at Plucks Rd",
                        "South Pine Rd near Henderson Rd",
                        "Henderson Road near Bunya Rd",
                        "Bunya Road near Garfield Tce",
                        "Bennetts Rd near Bowers Rd N",
                        "Old Northern Rd at Chinook",
                        "Old Northern Rd at Hamilton Road",
                        "Old Northern Rd at Allamanda Crescent",
                        "Old Northern Rd at The Boulevard",
                        "Old Northern Rd at Keong Road",
                        "Old Northern Rd at Albany Creek High",
                        "Jagora Drive near Daniel Dr",
                        "Thiess Dr at Jagora",
                        "Thiess Dr near Mahogany Dr",
                        "Thiess Dr at Narrabeen",
                        "Albany Forest Dr at Explorer",
                        "Albany Forest Dr at Dove",
                        "Morgan Rd at Morgan",
                        "Faheys Rd West at Kingfisher",
                        "Flamingo Dr near Garganey St",
                        "Faheys Rd East near Folkstone Ave",
                        "Sussex Dr near Folkstone Ave",
                        "Keong Rd near Essex Dr",
                        "Keong Rd near Malvern Rd",
                        "Keong Rd at Preston Point",
                        "Keong Rd at Leitchs Road",
                        "Albany Creek Rd at Albany Creek State School",
                        "South Pine Rd at Hylacola",
                        "South Pine Rd at Bunya Park",
                        "South Pine Rd near Leitchs Rd",
                        "Gympie Rd near Telegraph Rd",
                        "Gympie Rd near Griffiths St",
                        "Gympie Rd near Bald Hills Rd",
                        "Gympie Rd at Saint Pauls School",
                        "Strathpine Rd at Adair Street",
                        "Gympie Rd near Dickson St",
                        "Albany Creek Rd at Hylacola",
                        "Albany Creek Rd near Old Northern Rd",
                        "Albany Creek Rd near Bowen Ave",
                        "Albany Creek Rd at Leitchs Road",
                        "Keong Rd near Seligan St",
                        "Keong Rd near Crofty St",
                        "Keong Rd near Rafter Ave",
                        "Flamingo Dr near Chickowee St",
                        "Narrabeen Dr near Yellowjack Cr",
                        "Bennetts Rd near Bowers Rd",
                        "Bunya Rd near Pepper Rd",
                        "Henderson Road near Timms Rd",
                        "South Pine Rd near Plucks Rd",
                        "Bunya Rd near South Pine Rd",
                        "Bunya Rd near Blackwood Dr",
                        "Hutton Rd at Yalamba Ct",
                        "Gordon Rd near Anora Cr"
                    ],
                    "906: Ferny Grove - Padua - Craigslea": [
                        "Ferny Grove station, stop B (Temporary)",
                        "Gordon Rd near Owarra Ave",
                        "Gordon Rd near Andina Cr",
                        "Patricks Rd near Wallaroy Ct",
                        "Patricks Rd near Bunora Ave",
                        "Patricks Rd near Ferny Way",
                        "Patricks Rd near Cycas St",
                        "Patricks Rd near Leslie St",
                        "Patricks Rd at Nepean Ave",
                        "South Pine Rd near Henderson Rd",
                        "South Pine Rd near Pimelea St",
                        "South Pine Rd at Buckland Rd Stop 46",
                        "South Pine Rd at Queens Rd, stop 45",
                        "South Pine Rd at Rogers Pde W, stop 44",
                        "South Pine Rd at South Pine Bend, stop 43",
                        "South Pine Rd near Ballinderry St, stop 42",
                        "South Pine Rd at Barton West, stop 41",
                        "Barton St at Pullen Road, stop 40",
                        "Pullen Rd near Kambala St",
                        "Pullen Rd near Carcoar St",
                        "Camelia Ave at Camelia - Galeola, stop 50",
                        "Camelia Ave at Violet St, stop 49",
                        "Camelia Ave at Camelia/Nymphaea, stop 48",
                        "Camelia Ave at Mirbelia St, stop 47",
                        "South Pine Rd near Basand St",
                        "Henderson Road near Bunya Rd",
                        "Bunya Road near Garfield Tce",
                        "Bennetts Rd near Bowers Rd N",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Rode Rd at Trouts Road",
                        "Rode Rd near Cilento St, stop 44a",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd near Tyrone St",
                        "Rode Rd at Stafford Heights near Cranbourne St",
                        "Rode Rd at Cherston St",
                        "Rode Rd at Webster Road, stop 37",
                        "Rode Rd at Rode Road Hospital, stop 36",
                        "Parkdale St at Parkdale - Rode, stop 52/34",
                        "Parkdale St at Eltham Street, stop 51",
                        "Parkdale St near Exley St, stop 50",
                        "Turner Rd at East Street, stop 46",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Padua College - Jardine St Stop A",
                        "Clifford St at Jardine Street, stop 32",
                        "Moree St near Dorrigo St, stop 40",
                        "Webster Rd near Koolewong St, stop 32",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Appleby Rd at Maryland Street, stop 40",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Hamilton Rd at Maundrell Tce, stop 43a",
                        "Hamilton Rd at Pullford St, stop 42/41"
                    ],
                    "908: Albany Creek - Padua College - Wavell High": [
                        "Collins Rd near Hawkes Ave",
                        "Collins Rd at Hillenvale, stop 1",
                        "Collins Rd at Hillenvale, stop 2",
                        "Thiess Dr at Challinor",
                        "Thiess Dr at Jagora",
                        "Thiess Dr near Mahogany Dr",
                        "Thiess Dr at Narrabeen",
                        "Albany Forest Dr at Explorer",
                        "Old Northern Rd at Leisure Centre",
                        "Sussex Dr near Folkstone Ave",
                        "Keong Rd near Dawn Rd",
                        "Keong Rd near Hampshire Tce",
                        "Old Northern Rd at Keong Road",
                        "Old Northern Rd at The Boulevard",
                        "Old Northern Rd at Allamanda Crescent",
                        "Hamilton Rd near Streisand Dr",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Rode Rd at Trouts Road",
                        "Rode Rd near Cilento St, stop 44a",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd near Tyrone St",
                        "Appleby Rd at Stafford Heights",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Appleby Rd at Ringrose Street, stop 38",
                        "Appleby Rd at Stafford Heights South",
                        "Wilgarning St at Kingaroy Street, stop 3",
                        "Wilgarning St at Mumbil St",
                        "Wilgarning St near Webster Rd",
                        "Moree St at View Street, stop 42",
                        "Moree St at Dawn Street, stop 43",
                        "Padua College - Jardine St Stop A",
                        "Clifford St at Jardine Street, stop 32",
                        "Clifford St at Dorrigo Street, stop 33",
                        "Scott St near Oates St",
                        "Strathmore St near Goodall St",
                        "Castle St near Seabrook St",
                        "Castle St near Leckie Rd",
                        "Wavell State High Oval Stop",
                        "Pfingst Rd at Brae Street, stop 43"
                    ],
                    "911: Padua - Albany Creek": [
                        "Padua College - Jardine St Stop A",
                        "Clifford St at Jardine Street, stop 32",
                        "Moree St near Dorrigo St, stop 40",
                        "Webster Rd near Koolewong St, stop 32",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Rode Rd at Webster Road, stop 37",
                        "Rode Rd at Stafford Heights near Maundrell Tce",
                        "Rode Rd near Chuter St",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Voigt Street, stop 46",
                        "Rode Rd at McDowall near Metro St",
                        "Old Northern Rd at Chinook",
                        "Old Northern Rd at Hamilton Road",
                        "Old Northern Rd at Allamanda Crescent",
                        "Old Northern Rd at The Boulevard",
                        "Old Northern Rd at Keong Road",
                        "Old Northern Rd at Albany Creek High",
                        "Old Northern Rd near Albany Forest Dr",
                        "Old Northern Rd at Leisure Centre",
                        "Faheys Rd East near Folkstone Ave",
                        "Sussex Dr near Folkstone Ave",
                        "Keong Rd near Essex Dr",
                        "Keong Rd near Malvern Rd",
                        "Keong Rd at Preston Point",
                        "Keong Rd at Leitchs Road",
                        "Albany Creek Rd at Albany Creek State School",
                        "Wruck Cr at Albany Village"
                    ],
                    "912: Mitchelton State High - Arana Hills": [
                        "Samford Rd at Samford - Melrick, stop 25",
                        "Samford Rd at Cobalt St",
                        "Hogarth Rd District Stop",
                        "McGinn Rd at Archdale Rd",
                        "McGinn Rd at Ferny Grove High School",
                        "Ferny Grove station, stop B (Temporary)",
                        "England Rd near Pylara Cr",
                        "Patricks Rd at Patricks Road State School",
                        "Patricks Rd near Quinnia Ct",
                        "Patricks Rd near Wallaroy Ct",
                        "Bunora Ave near Coolibah Cr",
                        "Ferny Way at Ferny Hills State School",
                        "Ferny Way near Langura Cr",
                        "Tarnook Dr at Barber Rd",
                        "Tarnook Dr at Ukamirra Ct",
                        "Hutton Rd at Yalamba Ct",
                        "Hutton Rd near Yingally Dr",
                        "View Cr near Plucks Rd",
                        "View Cr near Eveleigh St",
                        "View Cr near Floyd Ct",
                        "Bunya Rd near Arlington Dr",
                        "Bunya Rd at Francis Road",
                        "South Pine Rd at Plucks Rd",
                        "Plucks Rd near South Pine Rd",
                        "Plucks Rd near Tetragona Dr",
                        "Yanderra Ave near Onslow St",
                        "Bringelly St at Onslow St",
                        "Bringelly St near Narellan St",
                        "Patricks Rd at Nepean Ave"
                    ],
                    "913: Padua - Albany Creek": [
                        "Padua College - Jardine St Stop A",
                        "Clifford St at Jardine Street, stop 32",
                        "Moree St near Dorrigo St, stop 40",
                        "Webster Rd near Koolewong St, stop 32",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Rode Rd at Webster Road, stop 37",
                        "Rode Rd at Stafford Heights near Maundrell Tce",
                        "Rode Rd near Chuter St",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Voigt Street, stop 46",
                        "Rode Rd at McDowall near Metro St",
                        "Old Northern Rd at Chinook",
                        "Old Northern Rd at Hamilton Road",
                        "Old Northern Rd at Allamanda Crescent",
                        "Old Northern Rd at The Boulevard",
                        "Jinker Track near Allamanda Cr",
                        "Thiess Dr at Challinor",
                        "Thiess Dr at Jagora",
                        "Thiess Dr near Mahogany Dr",
                        "Thiess Dr at Narrabeen",
                        "Albany Forest Dr at Explorer",
                        "Albany Forest Dr at Dove",
                        "Morgan Rd at Morgan",
                        "Faheys Rd West at Kingfisher",
                        "Flamingo Dr near Garganey St",
                        "Old Northern Rd at Retirement Village"
                    ],
                    "915: Craigslea High - Brookside": [
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Rode Rd at Webster Road, stop 37",
                        "Rode Rd at Stafford Heights near Maundrell Tce",
                        "Rode Rd near Chuter St",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Voigt Street, stop 46",
                        "Rode Rd at McDowall near Metro St",
                        "Bennetts Rd near Bowers Rd",
                        "Bunya Road near Garfield Tce",
                        "Bunya Rd near Pepper Rd",
                        "Henderson Road near Timms Rd",
                        "Pimelea St near Hobbs St",
                        "Pimelea St near Capsella St",
                        "Camelia Ave at Camelia - Mirbelia, stop 47",
                        "Camelia Ave at Camelia - Nymphaea, stop 48",
                        "Camelia Ave at Violet St, stop 49",
                        "Camelia Ave at Galeola Street, stop 50",
                        "Pullen Rd at Hornby Street, stop 51A",
                        "Osborne Rd at Osborne North, stop 51",
                        "Osborne Rd near Northmore St, stop 52",
                        "Brookside Shopping Centre"
                    ],
                    "918: Wavell High - Brookside via Padua College": [
                        "White St at Wavell State High, stop E",
                        "Rode Rd near Telopia Ave, stop 46",
                        "Rode Rd near Davenport St",
                        "Parkdale St at Parkdale - Rode, stop 52/34",
                        "Parkdale St at Eltham Street, stop 51",
                        "Parkdale St near Exley St, stop 50",
                        "Bohland St at Allan Street, stop 49",
                        "Bohland St near Araluen St, stop 48",
                        "Kitchener Rd at North Street, stop 47",
                        "Turner Rd at East Street, stop 46",
                        "Mawson St near Shackleton St, stop 45",
                        "Mawson St at Oates Street",
                        "Mawson St near Bayview St, stop 34",
                        "Mawson St at Wattle Street, stop 35",
                        "Scott St near Oates St",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Padua College - Jardine St Stop A",
                        "Clifford St at Jardine Street, stop 32",
                        "Moree St near Dorrigo St, stop 40",
                        "Wilgarning St near Canonbar St",
                        "Wilgarning St at Mumbil St",
                        "Wilgarning St at Euratha Street, stop 37",
                        "Wilgarning St at Kingaroy Street, stop 3",
                        "Farrant St at Jarvis Street",
                        "Redwood St at Farrant Street",
                        "Redwood St at Falkirk Street",
                        "Redwood St at Gunn Street",
                        "Redwood St at Lalor Street",
                        "Felstead St at Heflin Street",
                        "Felstead St at Sizer Street",
                        "Dargie St at Murch Street",
                        "Old Northern Rd at Deakin Street",
                        "South Pine Rd at Everton Junction, stop 40",
                        "Pullen Rd near Warren L",
                        "Pullen Rd near Kambala St",
                        "Pullen Rd near Carcoar St",
                        "Osborne Rd at Osborne North, stop 51",
                        "Osborne Rd near Northmore St, stop 52",
                        "Brookside Shopping Centre"
                    ],
                    "920: Padua College - Ferny Grove Station": [
                        "Padua College - Jardine St Stop A",
                        "Camelia Ave at Camelia - Galeola, stop 50",
                        "Camelia Ave at Violet St, stop 49",
                        "Camelia Ave at Camelia/Nymphaea, stop 48",
                        "Camelia Ave at Mirbelia St, stop 47",
                        "Pimelea St near Capsella St",
                        "Pimelea St near Olearia St West",
                        "Patricks Rd at Arana Hills K Mart",
                        "Bringelly St near Narellan St",
                        "Bringelly St at Onslow St",
                        "Yanderra Ave near Onslow St",
                        "Plucks Rd near Tetragona Dr",
                        "Plucks Rd near Barney St",
                        "South Pine Rd near Plucks Rd",
                        "Collins Rd near Hawkes Ave",
                        "Collins Rd at Hillenvale, stop 1",
                        "Collins Rd at Hillenvale, stop 2",
                        "Bunya Rd at Blackwood",
                        "Bunya Rd near Arlington Dr",
                        "View Cr near Floyd Ct",
                        "View Cr near Eveleigh St",
                        "Hutton Rd near Yingally Dr",
                        "Hutton Rd at Yalamba Court",
                        "Tarnook Dr near Ukamirra Ct",
                        "Tarnook Dr at Barber Rd",
                        "Gordon Rd near Andina Cr",
                        "Gordon Rd near Anora Cr",
                        "Ferny Grove station, stop B (Temporary)"
                    ],
                    "921: Kelvin Grove - Mitchelton": [
                        "Lestrange Tce - 21 (Zone A)",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Enoggera Rd at Banks Street, stop 22",
                        "Enoggera Rd at Sedgley Park, stop 23",
                        "Enoggera Rd at Beaufort Street, stop 24",
                        "Enoggera Rd at Lloyd Street, stop 25",
                        "Samford Rd at Alderley Junction, stop 26",
                        "Samford Rd at Musgrave Terrace, stop 27",
                        "Samford Rd at Camborne Street, stop 28",
                        "Samford Rd at Bond Street, stop 29",
                        "Samford Rd at Wardell Street, stop 30",
                        "Samford Rd at Norman Terrace, stop 31",
                        "Samford Rd at Gaythorne station, stop 32",
                        "Samford Rd at Gaythorne RSL, stop 33",
                        "Blackwood St at Mitchelton, stop 34",
                        "Ruby Rd near McConahgy St, stop 35",
                        "Mitchelton Rail station"
                    ],
                    "922: Brisbane Grammar - RBWH - Grange": [
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Kennigo St, stop 9",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "RBWH station, platform 2",
                        "Northey St near Allom St",
                        "Green Tce at Downey Park, stop 13a",
                        "Green Tce at Table Tennis Complex, stop 14",
                        "Green Tce near Newmarket Rd, stop 15",
                        "Newmarket Rd at Oakwal Lane, stop 16",
                        "Newmarket Rd at Granville Street, stop 17",
                        "Newmarket Rd at Wilston station, stop 18",
                        "Lamont Rd at Abuklea Street, stop 19",
                        "Lamont Rd at Ruth Street, stop 20/21",
                        "Montpelier St at Vale Street, stop 22",
                        "Montpelier St at Inglis Street, stop 23",
                        "Montpelier St at Thomas Street, stop 24",
                        "Thomas St at Primrose Street, stop 24a",
                        "Thomas St at Grange, stop 25/26"
                    ],
                    "923: Spring Hill - City": [
                        "Queen Street Stop 58 near Pedestrian Crossing",
                        "Upper Edward Street Stop 135 near Wickham Tce",
                        "Leichhardt Street Stop 178 near Little Edward St",
                        "Boundary St Stop 172 at St Andrews",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "Boundary St near Torrington St, stop 3",
                        "Boundary St at Fortescue Street, stop 2",
                        "Little Edward St near Upper Edward St, stop 1",
                        "Upper Edward Street Stop 140 near Wickham Tce",
                        "Edward Street Stop 141 near Ann St",
                        "Queen Street Stop 56 near Edward St"
                    ],
                    "924: Ascot - Gregory Tce": [
                        "Alexandra Rd at Reeve Street Stop 27",
                        "Upper Lancaster Rd near Wren Street, stop 25",
                        "Anthony St at Tower Street, stop 24",
                        "Anthony St at Ascot School, stop 23",
                        "Crosby Rd at Hipwood Street, stop 22",
                        "Crosby Rd at Bushview, stop 21",
                        "Crosby Rd at Comus Avenue, stop 20",
                        "Crosby Rd at Brothers, stop 19",
                        "Crosby Rd at Albion Road, stop 18",
                        "Abbotsford Rd at Bus Depot, stop 17",
                        "Abbotsford Rd at Allison Street Stop 16",
                        "Abbotsford Rd at Bowen Hills near Folkestone St",
                        "Oconnell Tce at Hamilton Place",
                        "OConnell Terrace near Bowen Bridge Rd",
                        "Gregory Tce near Brunswick St, stop 10",
                        "Gregory Tce near Park St, stop 9",
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce at Brisbane Grammar, stop 4"
                    ],
                    "925: Toombul - Spring Hill": [
                        "Toombul Shopping Centre station, platform B",
                        "Sandgate Rd at Noble Street, stop 31",
                        "Noble St at Noble - Sandgate, stop 39/45",
                        "Noble St near Widdop St, stop 38/44",
                        "Widdop St at Eliza Street, stop 37/43",
                        "Gellibrand St near Zillman Rd, stop 36/4",
                        "Zillman Rd at Junction Road, stop 35a/42",
                        "Gerler Rd at Zillman Road, stop 36/38",
                        "Gerler Rd at Doncaster Street, stop 39/40",
                        "Gerler Rd at TC Beirne Park, stop 40/39",
                        "Gerler Rd at Dorames Street, stop 37/36",
                        "Nudgee Rd at Long Street, stop 35a/42",
                        "Manson Road near Paul St",
                        "Zillman Rd at Hendra Rail, stop 32/8",
                        "Sefton Rd at Marie Street, stop 31",
                        "Sefton Rd near Alexandra Rd, stop 30",
                        "Alexandra Rd at Florence Street Stop 29",
                        "Alexandra Rd at Oriel Road Stop 28",
                        "Sandgate Rd at Clayfield South, stop 23",
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce at Brisbane Grammar, stop 4"
                    ],
                    "926: All Hallows - Stafford": [
                        "Stafford City",
                        "Stafford Rd at Willowie Street, stop 30a",
                        "Webster Rd at Sayers Street, stop 30",
                        "Webster Rd at Lindley Street, stop 29",
                        "Webster Rd at Wulfrunian, stop 28",
                        "Grange Rd at Raymont Road, stop 27",
                        "Raymont Rd at Chermside Street, stop 8A",
                        "Raymont Rd at Grange Forest Park, stop 7A",
                        "Raymont Rd at Billington Street, stop 6A",
                        "Raymont Rd at Beatson Terrace, stop 5A",
                        "Sidney St near David St, stop 4A",
                        "Progress Pde near Gawler St, stop 3A",
                        "Days Rd at Yarradale Street, stop 2A",
                        "Days Rd at Wilston Road, stop 1A",
                        "Days Rd near Grange Rd, stop 1",
                        "Days Rd at Carroll Cr, stop 25A",
                        "Days Rd at Uxbridge Street, stop 25",
                        "Days Rd at Eighth Ave, stop 24",
                        "Days Rd at Paling Ave, stop 23",
                        "Maygar St at Bank Street, stop 22",
                        "Maygar St at Anderson Street, stop 21",
                        "Maygar St at Whish Street, stop 20",
                        "Maygar St at McKenzie Street, stop 19",
                        "Roblane St at Windsor Park stop 15",
                        "Lutwyche Rd at Bowen Street, stop 14",
                        "Lutwyche Rd at Windsor Rail, stop 13",
                        "Lutwyche Rd near Bryden St, stop 11",
                        "Federation Street, platform 1",
                        "RBWH station, platform 1",
                        "Gregory Tce near Brunswick St, stop 10",
                        "Gregory Tce near Park St, stop 9",
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "Boundary St near Torrington St, stop 3",
                        "Boundary St at Fortescue Street, stop 2",
                        "Ann Street Stop 220 at All Hallows",
                        "Ann Street Stop 218 at All Hallows",
                        "Boundary St Stop 172 at St Andrews",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Kennigo St, stop 9",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "RBWH station, platform 2",
                        "Federation Street, platform 2",
                        "Lutwyche Rd near Taylor St, stop 11",
                        "Lutwyche Rd near Newmarket Rd, stop 12",
                        "Lutwyche Rd at Windsor Rail",
                        "Lutwyche Rd at Windsor State School, stop 15",
                        "Lutwyche Rd at Old Council Chambers, stop 16",
                        "Lutwyche Rd at Maygar Street, stop 17",
                        "Days Rd at Grange - Days",
                        "Sidney St near Beatson Tce, stop 4A",
                        "Beatson Tce near Raymont Rd, stop 5",
                        "Raymont Rd at Alderley Grove, stop 5A"
                    ],
                    "928: Gregory Tce - Toombul": [
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Kennigo St, stop 9",
                        "Hamilton Pl near Jeays St",
                        "Abbotsford Rd at Bowen Hills",
                        "Abbotsford Rd at Allison Street Stop 16",
                        "Abbotsford Rd at Bus Depot, stop 17/18",
                        "Crosby Rd near Dover St, stop 18",
                        "Crosby Rd at Brothers, stop 19",
                        "Crosby Rd at Comus Avenue, stop 20",
                        "Crosby Rd at Bushview, stop 21",
                        "Crosby Rd at Hipwood Street, stop 22",
                        "Anthony St at Ascot School, stop 23",
                        "Anthony St at Tower Street, stop 24",
                        "Oriel Rd near Stafford St, stop 27",
                        "Alexandra Rd at Oriel Road Stop 28",
                        "Alexandra Rd at Palm Avenue Stop 29",
                        "Alexandra Rd at Sefton Road Stop 30",
                        "Sefton Rd at Marie Street, stop 31",
                        "Zillman Rd at Hendra Rail, stop 32/8",
                        "Manson Rd near General St",
                        "Manson St at Goodwood Street, stop 44",
                        "Nudgee Rd at Long Street, stop 35/45",
                        "Nudgee Rd at Flemington Street, stop 36/46",
                        "Gerler Rd at Dorames Street, stop 37/36",
                        "Gerler Rd at Newmarket Street, stop 41/38",
                        "Gerler Rd at TC Beirne Park, stop 39/40",
                        "Gerler Rd at Doncaster Street, stop 40/39",
                        "Gerler Rd at Zillman Road, stop 38/36",
                        "Gellibrand St near Zillman Rd, stop 36/4",
                        "Widdop St at Eliza Street, stop 37/43",
                        "Widdop St at Noble Street, stop 38/44",
                        "Widdop St at Walkers Way, stop 39/45",
                        "Kreutzer St near Grace St, stop 40/46",
                        "Toombul Interchange"
                    ],
                    "929: Gregory Tce - Toombul": [
                        "Gregory Tce near Union St, stop 6",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Kennigo St, stop 9",
                        "Hamilton Pl near Jeays St",
                        "Abbotsford Rd at Bowen Hills",
                        "Abbotsford Rd at Allison Street Stop 16",
                        "Abbotsford Rd at Bus Depot, stop 17/18",
                        "Crosby Rd near Dover St, stop 18",
                        "Crosby Rd at Brothers, stop 19",
                        "Crosby Rd at Comus Avenue, stop 20",
                        "Crosby Rd at Bushview, stop 21",
                        "Crosby Rd at Hipwood Street, stop 22",
                        "Anthony St at Ascot School, stop 23",
                        "Anthony St at Tower Street, stop 24",
                        "Upper Lancaster Rd near Wren Street, stop 25",
                        "Alexandra Rd at Reeve Street Stop 27",
                        "Alexandra Rd at Oriel Road Stop 28",
                        "Alexandra Rd at Palm Avenue Stop 29",
                        "Alexandra Rd at Sefton Road Stop 30",
                        "Sefton Rd at Marie Street, stop 31",
                        "Zillman Rd at Hendra Rail, stop 32/8",
                        "Manson Rd near General St",
                        "Manson St at Goodwood Street, stop 44",
                        "Nudgee Rd at Long Street, stop 35/45",
                        "Nudgee Rd at Flemington Street, stop 36/46",
                        "Gerler Rd at Dorames Street, stop 37/36",
                        "Gerler Rd at Newmarket Street, stop 41/38",
                        "Gerler Rd at TC Beirne Park, stop 39/40",
                        "Gerler Rd at Doncaster Street, stop 40/39",
                        "Gerler Rd at Zillman Road, stop 38/36",
                        "Gellibrand St near Zillman Rd, stop 36/4",
                        "Widdop St at Eliza Street, stop 37/43",
                        "Widdop St at Noble Street, stop 38/44",
                        "Widdop St at Walkers Way, stop 39/45",
                        "Kreutzer St near Grace St, stop 40/46",
                        "Toombul Interchange"
                    ],
                    "930: New Farm - Spring Hill": [
                        "Brunswick St at Harcourt Street, stop 6",
                        "Brunswick St at Kent Street, stop 7/8",
                        "Brunswick St at Barker Street, stop 9",
                        "Barker St at Oxley Lane, stop 9",
                        "Moray St at Locke Street, stop 10",
                        "Moray St at Langshaw Street, stop 11",
                        "Moray St at Roundabout, stop 12",
                        "Sydney St at Llewellyn Street",
                        "Oxlade Dr at Merthyr, stop 1",
                        "Oxlade Dr at Hazelwood Street, stop 27/24a",
                        "Oxlade Dr at River Path, stop 25",
                        "Oxlade Dr at Lower Bowen Terrace, stop 19",
                        "Brunswick St at Oxlade Drive, stop 17",
                        "Brunswick St at Bowls Club, stop 16",
                        "Brunswick St at Sydney Street, stop 15",
                        "Merthyr Rd at Merthyr Central, stop 11",
                        "Merthyr Rd at Alford Street, stop 12",
                        "Merthyr Rd at Hawthorne Street, stop 13",
                        "Macquarie St at Saratoga, stop 13A",
                        "Macquarie St at Mercantile Place, stop 14",
                        "Macquarie St at Vernon Terrace, stop 15",
                        "Commercial Rd near Vernon Tce",
                        "Commercial Rd at Florence Street, stop 13",
                        "Commercial Rd near Leopold St, stop 12",
                        "Saint Pauls Tce at Alexandria Street Stop 11",
                        "St Pauls Terrace at Fortitude Valley Stop 240",
                        "St Pauls Terrace Stop 238 near Quarry St",
                        "St Pauls Terrace Stop 235 near Union St",
                        "Leichhardt Street Stop 164 at The Ridge",
                        "Leichhardt St at Fortescue Street - 1",
                        "Leichhardt St at Allenby St, stop 2",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "Wickham Terrace Stop 174 at Albert Park",
                        "Leichhardt Street Stop 165 at The Ridge",
                        "St Pauls Terrace Stop 237 near Union St",
                        "St Pauls Terrace Stop 239 near Quarry St",
                        "St Pauls Terrace at Fortitude Valley Stop 232",
                        "Saint Pauls Tce at Constance Street Stop 6/10",
                        "Commercial Rd near Stratton St, stop 12",
                        "Commercial Rd near Skyring Tce",
                        "Commercial Rd at Teneriffe Ferry, stop 16",
                        "Vernon Tce near Florence St, stop 15",
                        "Brunswick St at Parkview, stop 17",
                        "Oxlade Dr near Brunswick St, stop 19",
                        "Oxlade Dr at Riverside, stop 25",
                        "Oxlade Dr at River Path, stop 25a",
                        "Oxlade Dr at Sargent Street, stop 26",
                        "Sydney St near Griffith St",
                        "Sydney St at Llewellyn Street, stop 23",
                        "Brunswick St at Heal Street, stop 8",
                        "Brunswick St at Robertson Street, stop 5"
                    ],
                    "931: New Farm - Fortitide Valley": [
                        "Brunswick St at Harcourt Street, stop 6",
                        "Brunswick St at Kent Street, stop 7/8",
                        "Brunswick St at Barker Street, stop 9",
                        "Barker St at Oxley Lane, stop 9",
                        "Moray St at Locke Street, stop 10",
                        "Moray St at Langshaw Street, stop 11",
                        "Moray St at Roundabout, stop 12",
                        "Sydney St at Llewellyn Street",
                        "Oxlade Dr at Merthyr, stop 1",
                        "Oxlade Dr at Hazelwood Street, stop 27/24a",
                        "Oxlade Dr at River Path, stop 25",
                        "Oxlade Dr at Lower Bowen Terrace, stop 19",
                        "Brunswick St at Oxlade Drive, stop 17",
                        "Brunswick St at Bowls Club, stop 16",
                        "Brunswick St at Sydney Street, stop 15",
                        "Merthyr Rd at Merthyr Central, stop 11",
                        "Merthyr Rd at Alford Street, stop 12",
                        "Merthyr Rd at Hawthorne Street, stop 13",
                        "Macquarie St at Saratoga, stop 13A",
                        "Macquarie St at Mercantile Place, stop 14",
                        "Macquarie St at Vernon Terrace, stop 15",
                        "Commercial Rd near Vernon Tce",
                        "Commercial Rd at Florence Street, stop 13",
                        "Commercial Rd near Leopold St, stop 12",
                        "Wickham St at Knapp Street Stop 8",
                        "Breakfast Creek Rd at Riverpark Stop 9",
                        "Breakfast Creek Rd at Evelyn Street Stop 10",
                        "Folkestone St near Abbotsford Rd",
                        "Abbotsford Rd at Montpelier Road Stop 12/13",
                        "Saint Pauls Tce at Alexandria Street Stop 11",
                        "Abbotsford Rd at Bowen Hills",
                        "Folkestone St at Perry Park",
                        "Breakfast Creek Rd at Evelyn Street, stop 10",
                        "Commercial Rd near Stratton St, stop 12",
                        "Commercial Rd near Skyring Tce",
                        "Commercial Rd at Teneriffe Ferry, stop 16",
                        "Vernon Tce near Florence St, stop 15",
                        "Brunswick St at Parkview, stop 17",
                        "Oxlade Dr near Brunswick St, stop 19",
                        "Oxlade Dr at Riverside, stop 25",
                        "Oxlade Dr at River Path, stop 25a",
                        "Oxlade Dr at Sargent Street, stop 26",
                        "Sydney St near Griffith St",
                        "Sydney St at Llewellyn Street, stop 23",
                        "Brunswick St at Heal Street, stop 8"
                    ],
                    "934: L'Estrange Tce - Waterworks Rd": [
                        "Lestrange Tce - 21 (Zone A)",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Banks St at Banks - School, stop 22",
                        "Banks St at Banks - Laurence, stop 23",
                        "Banks St at Banks View, stop 24",
                        "Banks St at Banks Bend, stop 25",
                        "Banks St at Banks Reserve, stop 25a",
                        "Banks St near Lexington St, stop 26",
                        "Banks St at Gifford Street, stop 27",
                        "Bowral St near Banks St, stop 28",
                        "Bowral St at Goskar Avenue, stop 29",
                        "Cole St near Hilda St, stop 27",
                        "Cole St at Cole - Lloyd, stop 28",
                        "Lloyd St near Girton St, stop 29",
                        "Lloyd St at Lloyd - North, stop 30",
                        "Wardell St at Enoggera South, stop 31",
                        "Wardell St near Yates Ave, stop 32",
                        "Victoria St near Tweed St, stop 34",
                        "Canberra Dr near Tweed St, stop 35",
                        "Canberra Dr near Frasers Rd, stop 36",
                        "Frasers Rd near Nimmo Rd, stop 37",
                        "Arinya Rd near Moola Rd, stop 38",
                        "Arinya Rd near Mirrabooka Rd, stop 39",
                        "Frasers Rd near Tay St, stop 40",
                        "Stewart Rd at Frasers Bridge, stop 42",
                        "Stewart Rd near Celia St, stop 43",
                        "Stewart Rd at Ashgrove near Devoy St",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Waterworks Rd at Girraween Grove, stop 21/22",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Kaloma Rd at Kaloma - Harward, stop 38",
                        "Kaloma Rd at Woorama Rd, stop 39",
                        "Kaloma Rd at Hilder Road School, stop 40",
                        "Hilder Rd at Kaloma - Hilder, stop 41",
                        "Hilder Rd at Wittonga Park, stop 42",
                        "Petmar St at Petmar Street North, stop 43",
                        "Petmar St at Petmar Street South, stop 44",
                        "Waterworks Rd at Petmar St, stop 45",
                        "Waterworks Rd at Hilder Rd, stop 46"
                    ],
                    "935: L'Estrange Tce - Taigum": [
                        "Lestrange Tce - 21 (Zone A)",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Enoggera Rd at Banks Street, stop 22",
                        "Enoggera Rd at Sedgley Park, stop 23",
                        "Enoggera Rd at Beaufort Street, stop 24",
                        "Enoggera Rd at Lloyd Street, stop 25",
                        "South Pine Rd at Alderley, stop 27",
                        "South Pine Rd at Farrington Street, stop 30",
                        "Shand St at Sicklefield Rd, stop 31",
                        "Shand St at Sparkes Hill",
                        "Stafford Rd at Victor Street, stop 32",
                        "Stafford Rd at Windorah Street, stop 31",
                        "Stafford Rd at Willowie Street, stop 30a",
                        "Webster Rd at Stafford, stop 30",
                        "Webster Rd at Wilgarning Street, stop 31",
                        "Webster Rd near Koolewong St, stop 32",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd near Dundalli St, stop 39/23",
                        "Hamilton Rd at Farnell Street, stop 39",
                        "Chermside Shopping Centre interchange A",
                        "Gympie Rd at The Gardens Stop 38a",
                        "Murphy Rd at Marchant Park, stop 40",
                        "Murphy Rd at Ellison Road, stop 41",
                        "Murphy Rd at Butt Street",
                        "Murphy Rd near Sollis St, stop 43",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Dunsford Street, stop 45",
                        "Handford Rd at Zillmere station",
                        "Handford Rd at Kolberg Street, stop 47a",
                        "Handford Rd at Handford - Battersby, stop 48",
                        "Handford Rd at St Flannans School"
                    ],
                    "936: Kelvin Grove High - Aspley Hypermarket": [
                        "Lestrange Tce - 21 (Zone A)",
                        "Appleby Rd at Reuben Street, stop 33",
                        "Appleby Rd at Stafford North, stop 34a",
                        "Appleby Rd at Allowrie Street, stop 35",
                        "Stafford Heights South, Appleby Road",
                        "Appleby Rd at Ringrose Street, stop 38",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Appleby Rd at Maryland Street, stop 40",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Maundrell Tce at Craigslea, stop 44",
                        "Maundrell Tce at St Gerards, stop 45/46",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Aspley Hypermarket"
                    ],
                    "937: Kelvin Grove High - Stafford": [
                        "Lestrange Tce - 21 (Zone A)",
                        "Wilston Rd at Newmarket station",
                        "Thomas St at Grange, stop 25/26",
                        "Days Rd at Wilston Road, stop 1A",
                        "Days Rd at Yarradale Street, stop 2A",
                        "Progress Pde near Gawler St, stop 3A",
                        "Sidney St near Beatson Tce, stop 4A",
                        "Beatson Tce near Raymont Rd, stop 5",
                        "Chelford St near Longsight St",
                        "Chelford St near Royal Pde",
                        "Mornington St near Longsight St",
                        "Raymont Rd at Alderley Grove, stop 5A",
                        "Raymont Rd at Billington Street, stop 6A",
                        "Raymont Rd at Grange Forest Park, stop 7A",
                        "Raymont Rd at Chermside Street, stop 8A",
                        "Grange Rd at Raymont Road, stop 27",
                        "Webster Rd at Wulfrunian, stop 28",
                        "Webster Rd at Lindley Street, stop 29"
                    ],
                    "938: Kelvin Grove High - Grange": [
                        "Kelvin Grove Rd at Victoria Street, stop 12",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Edmondstone St at Newmarket",
                        "Wilston Rd at Newmarket station",
                        "Thomas St at Grange, stop 25/26"
                    ],
                    "939: Padua College - Geebung Station": [
                        "Padua College - Turner St Stop B",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Chermside Shopping Centre interchange F",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Unmack Street, stop 50",
                        "Hamilton Rd at Chermside East near Newman Rd",
                        "Newman Rd at Mylne Street, stop 44",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Geebung School, stop 49",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung station, stop 51"
                    ],
                    "940: Padua College - Carseldine": [
                        "Padua College - Turner St Stop B",
                        "Moree St at Dawn St, stop 43",
                        "Moree St at View Street, stop 42",
                        "Moree St near Dorrigo St, stop 40",
                        "Wilgarning St near Canonbar St",
                        "Wilgarning St at Mumbil St",
                        "Wilgarning St at Euratha Street, stop 37",
                        "Wilgarning St at Kingaroy Street, stop 3",
                        "Stafford Heights South, Appleby Road",
                        "Appleby Rd at Ringrose Street, stop 38",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Appleby Rd at Maryland Street, stop 40",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Maundrell Tce at Craigslea, stop 44",
                        "Hamilton Rd at Delan Street, stop 44a",
                        "Hamilton Rd at Backford Street, stop 45",
                        "Whites St at Kenna Street, stop 46",
                        "Stringybark Dr at Martindale Street, stop 47",
                        "Stringybark Dr near Horn Rd, stop 48",
                        "Horn Rd at Muneera Street, stop 49",
                        "Horn Rd at Candlebark Street, stop 50a",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Gympie Rd at Aspley",
                        "Gympie Rd at Gayford Street, stop 44",
                        "Gympie Rd at Brickfield Street, stop 45",
                        "Graham Rd at Gympie Rd, stop 56a",
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Graham Rd at Nemira Street, stop 48",
                        "Champagne St near Marsala St, stop 60",
                        "Sauterne St near Claret St, stop 61",
                        "Riesling St near Marsala St, stop 62",
                        "Hawbridge St near Quantum St, stop 63"
                    ],
                    "941: Padua College - Boondall Station": [
                        "Padua College - Turner St Stop B",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Wavell State High Oval Stop",
                        "Pfingst Rd at Brae Street, stop 43",
                        "Pfingst Rd near Taylor St, stop 44",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near Gurley St, stop 46",
                        "Pfingst Rd near Calga St, stop 47",
                        "Pfingst Rd near Miller St, stop 48",
                        "Pfingst Rd near Norla St, stop 49",
                        "Hamilton Rd at Chermside East near Newman Rd",
                        "Newman Rd at Mylne Street, stop 44",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Geebung School, stop 49",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung station, stop 51",
                        "Railway Pde near Bayview Tce",
                        "Newman Rd near Delta St, stop 52",
                        "Newman Rd at Newman North, stop 52a",
                        "Zillmere Rd at Zillmere South",
                        "Church Rd at Church Road South",
                        "Church Rd at Church-Battersby",
                        "Church Rd near Keyatta St",
                        "Taigum Shopping Centre, stop 52/57",
                        "Muller Rd at Taigum, stop 60a",
                        "Muller Rd near Bambrook St, stop 61",
                        "Muller Rd at Boondall West near Futuna St",
                        "Roghan Rd near Lindeman St",
                        "Roghan Rd at Roghan East",
                        "Sandgate Rd near Carlyle Rd, stop 22/21",
                        "Sandgate Rd at Boondall School, stop 20/21",
                        "Roscommon Rd at Roscommon East, stop 64/19",
                        "Roscommon Rd near Landsboro Ave, stop 20",
                        "Landsboro Ave at Landsboro, stop 20a",
                        "Aberdeen Pde at Boondall station"
                    ],
                    "944: Boondall - Padua": [
                        "Aberdeen Pde at Boondall station",
                        "Landsboro Ave at Landsboro, stop 20a",
                        "Roscommon Rd near Landsboro Ave, stop 20",
                        "Roscommon Rd at Roscommon East, stop 19/64",
                        "Sandgate Rd at Boondall School, stop 20",
                        "Sandgate Rd near Roghan Rd, stop 22/23",
                        "Roghan Rd at Roghan East near Sovereign Pl",
                        "Roghan Rd near Lindeman St",
                        "Muller Rd at Boondall West near Hayman St",
                        "Muller Rd near Bambrook St, stop 61",
                        "Muller Rd at Taigum, stop 60",
                        "Beams Rd at Taigum Shopping Centre",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd at Caravan Park, stop 49",
                        "Handford Rd at St Flannans School",
                        "Handford Rd at Handford - Battersby, stop 49",
                        "Handford Rd at Kolberg Street, stop 47A",
                        "Handford Rd at Zillmere station",
                        "Murphy Rd at Dunsford Street, stop 45",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Robinson Rd West, stop 43",
                        "Murphy Rd at Butt Street",
                        "Ellison Rd near Navarre St",
                        "Ellison Rd near Piccadilly St",
                        "Ellison Rd near Jeenly St",
                        "Ellison Rd near Marmont St",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Mylne Street, stop 44",
                        "Hamilton Rd at Chermside East near Pfingst Rd",
                        "Hamilton Rd at Unmack Street, stop 50",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Playfield Street, stop 37a",
                        "Chermside Shopping Centre interchange A",
                        "Pfingst Rd near Hamilton Rd, stop 49",
                        "Pfingst Rd near Gumbrae St, stop 48",
                        "Pfingst Rd near Wirega St, stop 47",
                        "Pfingst Rd near Highcrest Ave, stop 46",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near White St, stop 44",
                        "White St at Wavell State High, stop E",
                        "Rode Rd near Telopia Ave, stop 46",
                        "Padua College - Jardine St Stop A"
                    ],
                    "945: St Anthonys - Carseldine": [
                        "Padua College - Jardine St Stop A",
                        "Clifford St at Jardine Street, stop 32",
                        "Moree St near Dorrigo St, stop 40",
                        "Webster Rd near Koolewong St, stop 32",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Rode Rd at Webster Road, stop 37",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Hamilton Rd at Maundrell Tce, stop 43a",
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Webster Rd at Milburn Street, stop 40",
                        "Webster Rd at Ronmack Street, stop 41",
                        "Webster Rd at Chermside Markets, stop 43",
                        "Webster Rd at Ellison West, stop 44",
                        "Kirby Rd at Kirby South, stop 45",
                        "Kirby Rd at Ailsa Street, stop 46/47",
                        "Kirby Rd near Robinson Rd, stop 48",
                        "Kirby Rd at Aspley East, stop 50",
                        "Kirby Rd at Funnell Street, stop 52",
                        "Kirby Rd near Zillmere Rd, stop 52a",
                        "Ridgmont St near Trevorlea St",
                        "Handford Rd at Zillmere station",
                        "Handford Rd at Kolberg Street, stop 47a",
                        "Handford Rd at Handford - Battersby, stop 48",
                        "Handford Rd at St Flannans School",
                        "Beams Rd at St Flannans",
                        "Beams Rd at Golden Downs",
                        "Beams Rd at Carseldine Campus"
                    ],
                    "946: Mitchelton - Kedron High": [
                        "Mitchelton Rail station",
                        "Brookside Shopping Centre station, platform A",
                        "Griffith St at Burwood Street, stop 20/6",
                        "Griffith St at Brook Street, stop 19/5",
                        "Griffith St near South Pine Rd, stop 18/4",
                        "Stafford Rd at Cutbush Rd, stop 5",
                        "Stafford Rd at Mountbridge Street, stop 6",
                        "Trouts Rd near Leach St, stop 7",
                        "Trouts Rd near Castling St, stop 8",
                        "Trouts Rd at Trouts - Redwood, stop 40",
                        "Trouts Rd at Redgrave Street, stop 41",
                        "Garland St near Heflin St",
                        "Flockton St near Palmer St",
                        "Disney St near Bogart St",
                        "Trouts Rd at Disney Street, stop 42",
                        "Redwood St at Lalor Street",
                        "Redwood St at Falkirk Street",
                        "Redwood St at Farrant Street",
                        "Jarvis St near Appleby Rd",
                        "Wilgarning St at Kingaroy Street, stop 3",
                        "Wilgarning St at Mumbil St",
                        "Wilgarning St near Webster Rd",
                        "Moree St at View Street, stop 42",
                        "Moree St at Dawn Street, stop 43",
                        "Padua College - Jardine St Stop A",
                        "Clifford St at Leiper Street, stop 31",
                        "Clifford St near Stafford Rd, stop 30",
                        "Stafford Rd at Stafford Central",
                        "Stafford Rd at Turner Road, stop 29",
                        "Stafford Rd at Beaconsfield Terrace, stop 28a",
                        "Stafford Rd at Clarence Road, stop 27",
                        "Park Rd near Kedron Park Rd, stop 27",
                        "Park Rd at Gorman Street, stop 28",
                        "Gorman St at Kedron Park High School"
                    ],
                    "947: Kedron High - McDowall": [
                        "Gorman St at Kedron Park High School",
                        "Park Rd at Rose Street, stop 29",
                        "Park Rd at Gorman Street, stop 28",
                        "Park Rd near Kedron Park Rd, stop 27",
                        "Kedron Park Rd near Lutwyche Rd, stop 26/25",
                        "Lutwyche Rd at Leckie Road, stop 25",
                        "Gympie Rd at Cremorne Rd",
                        "Strathmore St near Caithness St",
                        "Strathmore St near Connolly St",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Padua College - Jardine St Stop A",
                        "Clifford St at Jardine Street, stop 32",
                        "Moree St near Dorrigo St, stop 40",
                        "Minimine St near Canonbar St, stop 31",
                        "Minimine St at Barokee Street, stop 32",
                        "Minimine St at Dunedoo Street, stop 33",
                        "Appleby Rd at Stafford North, stop 34a",
                        "Appleby Rd at Allowrie Street, stop 35",
                        "Redwood St at Farrant Street",
                        "Redwood St at Falkirk Street",
                        "Redwood St at Gunn Street",
                        "Redwood St at Lalor Street",
                        "Trouts Rd at Redgrave Street, stop 41",
                        "Trouts Rd at Disney Street, stop 42",
                        "Trouts Rd at Flockton Street, stop 43",
                        "Parton St at Costello Place, stop 44",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Voigt Street, stop 46",
                        "Brynner St at Macnee Street, stop 48",
                        "Hoffman St at Brynner St, stop 49",
                        "Hoffman St at Ifield St, stop 48",
                        "Ifield St at Brando Street, stop 47"
                    ],
                    "948: Kedron High - Maundrell Tce": [
                        "Gorman St at Kedron Park High School",
                        "Park Rd at Rose Street, stop 29",
                        "Park Rd at Gorman Street, stop 28",
                        "Park Rd near Kedron Park Rd, stop 27",
                        "Kedron Park Rd near Lutwyche Rd, stop 26/25",
                        "Stafford Rd at Clarence Road, stop 27",
                        "Stafford Rd at Beaconsfield Terrace, stop 28a",
                        "Stafford Rd at Turner Road, stop 29",
                        "Stafford Rd at Stafford Central",
                        "Clifford St near Stafford Rd, stop 30",
                        "Clifford St at Leiper Street, stop 31",
                        "Moree St at Dawn St, stop 43",
                        "Moree St at View Street, stop 42",
                        "Clifford St at Dorrigo Street, stop 33",
                        "Bayview St near Mawson St, stop 34",
                        "Mawson St at Wattle Street, stop 35",
                        "Webster Rd at Wilgarning Street",
                        "Minimine St near Canonbar St, stop 31",
                        "Minimine St at Barokee Street, stop 32",
                        "Minimine St at Dunedoo Street, stop 33",
                        "Appleby Rd at Stafford North, stop 34a",
                        "Appleby Rd at Allowrie Street, stop 35",
                        "Stafford Heights South, Appleby Road",
                        "Appleby Rd at Ringrose Street, stop 38",
                        "Appleby Rd at Kitchener Road, stop 39",
                        "Appleby Rd at Maryland Street, stop 40",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Hamilton Rd at Maundrell Tce, stop 43a"
                    ],
                    "950: Kedron High - Enoggera": [
                        "Gorman St at Kedron Park High School",
                        "Park Rd at Rose Street, stop 29",
                        "Park Rd at Gorman Street, stop 28",
                        "Park Rd near Kedron Park Rd, stop 27",
                        "Kedron Park Rd near Lutwyche Rd, stop 26/25",
                        "Stafford Rd at Clarence Road, stop 27",
                        "Stafford Rd at Beaconsfield Terrace, stop 28a",
                        "Stafford Rd at Turner Road, stop 29",
                        "Padua College - Turner St Stop B",
                        "Moree St at Dawn St, stop 43",
                        "Moree St at View Street, stop 42",
                        "Clifford St at Jardine Street, stop 32",
                        "Clifford St at Leiper Street, stop 31",
                        "Clifford St near Stafford Rd, stop 30",
                        "Stafford Rd at Webster Rd, stop 30",
                        "Webster Rd at Sayers Street, stop 30",
                        "Webster Rd at Lindley Street, stop 29",
                        "Stafford City",
                        "Stafford Rd near Windorah Street, stop 31",
                        "Stafford Rd at Victor Street, stop 32",
                        "Stafford Rd at Shand Street, stop 33",
                        "Stafford Rd at MacNaughton Street, stop 34",
                        "Stafford Rd at Cockle Street, stop 35",
                        "Kidgell St at Midson Street, stop 36",
                        "Kidgell St at Boles Street, stop 37",
                        "Armfield St at Kidgell Street, stop 38",
                        "Armfield St at Ferricks Street, stop 39",
                        "Trouts Rd near Castling St, stop 8",
                        "Trouts Rd near Midson St, stop 7",
                        "Stafford Rd at Mountbridge Street, stop 6",
                        "Stafford Rd at Cutbush Rd, stop 5",
                        "Griffith St at Everton Park, stop 4/18",
                        "Griffith St at Brook Street, stop 5/19",
                        "Griffith St at Burwood Street, stop 6/20",
                        "Brookside Shopping Centre station, platform C",
                        "Mitchelton Rail station",
                        "Samford Rd at Gaythorne RSL, stop 33",
                        "Samford Rd at Gaythorne station, stop 32",
                        "Samford Rd at Norman Terrace, stop 31",
                        "Samford Rd at Wardell Street, stop 30",
                        "Wardell St at Enoggera near Samford Rd",
                        "South Pine Rd at Marcellin Stop 34"
                    ],
                    "951: Mitchelton - Albany Village": [
                        "Mitchelton Rail station",
                        "Brookside Shopping Centre station, platform A",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at White Street, stop 38",
                        "South Pine Rd at Nitawill Street, stop 3",
                        "South Pine Rd at Pullen Road, stop 40",
                        "Old Northern Rd at Everton Junction",
                        "Old Northern Rd at Everton Park North",
                        "Old Northern Rd at Everton Hills near Rode Rd",
                        "Old Northern Rd at Chinook",
                        "Old Northern Rd at Hamilton Road",
                        "Old Northern Rd at Allamanda Crescent",
                        "Old Northern Rd at The Boulevard",
                        "Old Northern Rd at Keong Road",
                        "Old Northern Rd at Albany Creek High",
                        "Old Northern Rd near Albany Forest Dr",
                        "Old Northern Rd at Leisure Centre",
                        "Old Northern Rd at Retirement Village",
                        "Albany Creek Rd at Hylacola",
                        "Albany Creek Rd near Old Northern Rd",
                        "Wruck Cr at Albany Village"
                    ],
                    "952: Mitchelton station - Eatons Hill": [
                        "Mitchelton Rail station",
                        "Brookside Shopping Centre station, platform A",
                        "Jinker Track near Allamanda Cr",
                        "Thiess Dr at Challinor",
                        "Thiess Dr at Jagora",
                        "Thiess Dr near Mahogany Dr",
                        "Thiess Dr at Narrabeen",
                        "Albany Forest Dr at Explorer",
                        "Albany Forest Dr at Dove",
                        "Morgan Rd at Morgan",
                        "Faheys Rd West at Kingfisher",
                        "Flamingo Dr near Garganey St",
                        "South Pine Rd at Hylacola",
                        "South Pine Rd at Bunya Park",
                        "Queen Elizabeth Dr at Eatons Hill",
                        "Queen Elizabeth Dr at Hero Street",
                        "Queen Elizabeth Dr at Corso Street",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "Queen Elizabeth Dr at Eatonvale",
                        "Saraband Dr near Talisman Ct",
                        "Saraband Dr near Grenada Dr",
                        "Saraband Drive near Pascali Crescent"
                    ],
                    "953: Albany Creek SHS - Eatons Hill": [
                        "Old Northern Rd near Albany Forest Dr",
                        "Old Northern Rd at Leisure Centre",
                        "Old Northern Rd at Retirement Village",
                        "Albany Creek Rd at Hylacola",
                        "Albany Creek Rd near Old Northern Rd",
                        "Wruck Cr at Albany Village",
                        "South Pine Rd at Hylacola",
                        "South Pine Rd at Bunya Park",
                        "Queen Elizabeth Dr at Eatons Hill",
                        "Marylin Tce at Eatons Hill State School",
                        "Queen Elizabeth Dr at Hero Street",
                        "Queen Elizabeth Dr at Corso Street",
                        "Queen Elizabeth Dr at Saraband Dr",
                        "Saraband Dr near Talisman Ct",
                        "Saraband Dr near Grenada Dr",
                        "Saraband Drive near Pascali Crescent"
                    ],
                    "955: Gregory Tce - Aspley via Everton Park": [
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Stewart Rd at Ashgrove, stop 46",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "Wardell St at Dorrington near Stark St",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St at Enoggera near Samford Rd",
                        "South Pine Rd at Marcellin Stop 34",
                        "South Pine Rd at Everton Park, stop 37",
                        "Old Northern Rd at Everton Junction",
                        "Old Northern Rd at Everton Park North",
                        "Old Northern Rd at Everton Hills near Rode Rd",
                        "Beckett Rd at McDowall North",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at Paramount Chase",
                        "Beckett Rd at Bridgeman near Saturn Cr",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Bridgeman Downs",
                        "Graham Rd at Pinnaroo",
                        "Albany Creek Rd at Bangalow Street",
                        "Albany Creek Rd at Aspley Bowl",
                        "Aspley Hypermarket"
                    ],
                    "956: Bracken Ridge - Padua College": [
                        "Denham St at Childs Street, stop 33",
                        "Denham St near Phillips St, stop 32",
                        "Phillips St at Tomah Street",
                        "Enbrook St near Appledore St",
                        "Enbrook St near Mustang St",
                        "Mustang St near Telegraph Rd",
                        "Lemke Rd at Sandgate AFC Ground",
                        "Handford Rd at Songbird Way",
                        "Handford Rd at Handford - Roghan",
                        "Handford Rd at Symes Grove, stop 49",
                        "Handford Rd at Liberty Dr",
                        "Handford Rd at St Flannans School",
                        "Handford Rd at Handford - Battersby, stop 49",
                        "Handford Rd at Kolberg Street, stop 47A",
                        "Handford Rd at Zillmere station",
                        "Ridgmont St near Trevorlea St",
                        "Hutton Rd near Summerfield St",
                        "Kirby Rd at Funnell Street, stop 52",
                        "Kirby Rd at Aspley East, stop 50",
                        "Robinson Rd near Cornish Place, stop 50",
                        "Robinson Rd at Lerida Street, stop 52A",
                        "Robinson Rd at Priscilla Street, stop 53",
                        "Murphy Rd at Butt Street",
                        "Ellison Rd near Marathon St",
                        "Ellison Rd near Boulter St",
                        "Webster Rd at Ellison West, stop 44",
                        "Webster Rd at Chermside Markets",
                        "Webster Rd at Ronmack Street, stop 41",
                        "Webster Rd at Milburn Street, stop 40/3",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Webster Rd at Somerset Hills, stop 36",
                        "Mawson St near Webster Rd, stop 35",
                        "Mawson St near Glenhaven St, stop 34",
                        "Scott St near Oates St",
                        "Turner Rd at Hinkler Street, stop 44",
                        "Padua College - Jardine St Stop A"
                    ],
                    "957: McDowall - Wavell High": [
                        "Beckett Rd at Bridgeman Downs",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Bridgeman near Althorp Rd",
                        "Saturn Cr near Galaxy St",
                        "Galaxy St near Voyager Cct",
                        "Galaxy St near Halleys Cr",
                        "Streisand Dr near Thurman Ct",
                        "Beckett Rd near Althorp Rd",
                        "Beckett Rd at Paramount Chase",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Rode Rd at Trouts Road",
                        "Hamilton Rd at Trouts Rd, stop 46",
                        "Hamilton Rd at Backford Street, stop 45",
                        "Hamilton Rd at Delan Street, stop 44a",
                        "Hamilton Rd at Maundrell Tce, stop 43a",
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Farnell Street, stop 39",
                        "Chermside Shopping Centre interchange F",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Unmack Street, stop 50",
                        "Pfingst Rd near Hamilton Rd, stop 49",
                        "Pfingst Rd near Gumbrae St, stop 48",
                        "Pfingst Rd near Wirega St, stop 47",
                        "Pfingst Rd near Highcrest Ave, stop 46",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near White St, stop 44",
                        "White St at Wavell State High, stop E"
                    ],
                    "958: Craigslea - Albany Creek": [
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Maundrell Tce at Craigslea, stop 44/15",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Maundrell Tce at Risdon Street, stop 42",
                        "Rode Rd at Stafford Heights near Maundrell Tce",
                        "Rode Rd near Chuter St",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Voigt Street, stop 46",
                        "Rode Rd at McDowall near Metro St",
                        "Beckett Rd at McDowall North",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at Paramount Chase",
                        "Saturn Cr near Galaxy St",
                        "Galaxy St near Voyager Cct",
                        "Galaxy St near Halleys Cr",
                        "Streisand Dr near Thurman Ct",
                        "Beckett Rd at Bridgeman near Saturn Cr",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Bridgeman Downs",
                        "Albany Creek Rd at Pinnaroo",
                        "Keong Rd at Preston Point",
                        "Keong Rd at Leitchs Road",
                        "Albany Creek Rd at Albany Creek State School",
                        "Wruck Cr at Albany Village"
                    ],
                    "959: Craigslea High - Carseldine station": [
                        "Maundrell Tce at St Gerards, stop 46",
                        "Hamilton Rd at Maundrell Tce, stop 43a",
                        "Hamilton Rd at Pullford St, stop 42/41",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Ashworth St near Blenheim St",
                        "Chingford St near Lupton St",
                        "Chingford St near Cherston St",
                        "Maundrell Tce at Stafford Heights",
                        "Maundrell Tce at Kinnerton Street, stop 43",
                        "Maundrell Tce at Craigslea, stop 44",
                        "Maundrell Tce at St Gerards, stop 45/46",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Gympie Rd at Gayford Street, stop 44",
                        "Gympie Rd at Brickfield Street, stop 45",
                        "Graham Rd at Gympie Rd, stop 56a",
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Graham Rd at Nemira Street, stop 48",
                        "Champagne St near Marsala St, stop 60",
                        "Sauterne St near Claret St, stop 61",
                        "Riesling St near Marsala St, stop 62",
                        "Hawbridge St near Quantum St, stop 63",
                        "Graham Rd at Carseldine West near Kentia St",
                        "Ridley Rd at Ridley Road South",
                        "Ridley Rd near Dimboola St",
                        "Ridley Rd near Centurion St",
                        "Beams Rd near Tintara St",
                        "Beams Rd at Bangalore Street",
                        "Beams Rd at Carseldine Campus",
                        "Carseldine station"
                    ],
                    "962: Aspley High - Bracken Ridge": [
                        "Zillmere Rd at Aspley State High",
                        "Zillmere Rd at Aspley High School",
                        "Dorville Rd at Denver East",
                        "Dorville Rd at Dorville North",
                        "Balcara Ave near Allira Cr",
                        "Balcara Ave at Beams - Balcara",
                        "Beams Rd at Carseldine Campus",
                        "Beams Rd at Bangalore Street",
                        "Lacey Rd near Macaranga Cr",
                        "Lacey Rd near Highbridge Cct",
                        "Telegraph Rd near Langer Pl",
                        "Telegraph Rd near Mustang St",
                        "Mustang St near Telegraph Rd",
                        "Enbrook St near Mustang St",
                        "Enbrook St near Appledore St",
                        "Phillips St at Enbrook Street",
                        "Phillips St at St Josephs",
                        "Barbour Rd near Phillips St",
                        "Norris Rd near Barbour Rd",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Norris Rd at Greenore Street, stop 45",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Gawain East, stop 42",
                        "Barrett St at Bracken Ridge Library, stop 37",
                        "Barrett St at McKeering-Barrett",
                        "Denham St at Childs Street, stop 33",
                        "Denham St near Phillips St, stop 32",
                        "Denham St at Warra, stop 31"
                    ],
                    "963: Aspley High - Taigum Shopping Centre": [
                        "Zillmere Rd at Aspley High School",
                        "Zillmere Rd at Aspley State High",
                        "Ridgmont St near Trevorlea St",
                        "Murphy Rd at Dunsford Street, stop 45",
                        "Murphy Rd at Zillmere School, stop 44",
                        "Murphy Rd at Robinson Rd West, stop 43",
                        "Robinson Rd West near Fisher Pde",
                        "Robinson Rd at Bassano Street",
                        "Newman Rd near Delta St, stop 52",
                        "Newman Rd at Newman North, stop 52a",
                        "Zillmere Rd at Zillmere South",
                        "Zillmere Rd near Halcomb St",
                        "Handford Rd at Zillmere station",
                        "Handford Rd at Kolberg Street, stop 47a",
                        "Handford Rd at Handford - Battersby, stop 48",
                        "Handford Rd at St Flannans School",
                        "Beams Rd at Caravan Park, stop 49",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd near Church Rd, stop 51",
                        "Taigum Shopping Centre, stop 52/57"
                    ],
                    "964: Bracken Ridge - Aspley High": [
                        "Mustang St near Telegraph Rd",
                        "Enbrook St near Mustang St",
                        "Enbrook St near Appledore St",
                        "Phillips St at Enbrook Street",
                        "Phillips St at St Josephs",
                        "Barbour Rd near Phillips St",
                        "Barbour Rd at Caulfield Street, stop 47A",
                        "Wickfield St near Rosa Cr, stop 47",
                        "Wickfield St near Sophy Cr, stop 48",
                        "Wickfield St at Rosa Crescent, stop 49",
                        "Killare St near Wickfield St, stop 50",
                        "Ballynde St near Bungowla St, stop 51",
                        "Ballynde St at Toormore Street, stop 52",
                        "Ballynde St near Portumna Street, stop 53",
                        "Ballynde St at Glenealy Street, stop 54",
                        "Norris Rd at Norris - Bracken Ridge",
                        "Norris Rd near Gawain Rd",
                        "Norris Rd at Greenore Street",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Norris Rd near Barbour Rd",
                        "Norris Rd near Barbour Rd, stop 46",
                        "Norris Rd at Bracken Ridge Plaza",
                        "Telegraph Rd near Langer Pl",
                        "Lacey Rd near Highbridge Cct",
                        "Lacey Rd near Macaranga Cr",
                        "Beams Rd at Bangalore Street",
                        "Dorville Rd at Denver East",
                        "Zillmere Rd at Aspley High School"
                    ],
                    "966: Zillmere - Wavell High": [
                        "Zillmere Rd at Zillmere South",
                        "Church Rd at Church Road South",
                        "Church Rd at Church-Battersby",
                        "Church Rd near Keyatta St",
                        "Taigum Shopping Centre, stop 52/57",
                        "Tedman St at Fahey Street, stop 57",
                        "Tedman St at Hodgson Street, stop 57",
                        "Macansh St near Gledson St, stop 56",
                        "Percy St near Ewing St, stop 55",
                        "Lovegrove St, stop 54",
                        "Newman Rd at Newman North, stop 52a",
                        "Newman Rd near Delta St, stop 52",
                        "Railway Pde at Geebung station",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung School, stop 48",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Mylne Street, stop 44",
                        "Hamilton Rd at Chermside East near Pfingst Rd",
                        "Pfingst Rd near Hamilton Rd, stop 49",
                        "Pfingst Rd near Gumbrae St, stop 48",
                        "Pfingst Rd near Wirega St, stop 47",
                        "Pfingst Rd near Highcrest Ave, stop 46",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near White St, stop 44",
                        "White St at Wavell State High, stop E",
                        "Wavell State High Oval Stop",
                        "Newman Rd at Geebung station, stop 51",
                        "Railway Pde near Bayview Tce",
                        "Lovegrove St - 54"
                    ],
                    "968: Nudgee College - Wavell High": [
                        "Piccadilly St near Sandra St",
                        "Piccadilly St near Haymarket St",
                        "Copperfield St near Ossian St",
                        "Newman Rd at Geebung station, stop 51",
                        "Sandgate Rd at Virginia",
                        "Sandgate Rd at Boondall South Stop 15",
                        "Sandgate Rd at Nudgee College, stop 17",
                        "Groth Rd near Garozzo St",
                        "Beams Rd near Groth Rd",
                        "Beams Rd near Muller Rd",
                        "Beams Rd at Taigum Shopping Centre",
                        "Taigum Shopping Centre, stop 52/57",
                        "Tedman St at Fahey Street, stop 57",
                        "Tedman St at Hodgson Street, stop 57",
                        "Macansh St near Gledson St, stop 56",
                        "Percy St near Ewing St, stop 55",
                        "Lovegrove St, stop 54",
                        "Newman Rd at Newman North, stop 52a",
                        "Newman Rd near Delta St, stop 52",
                        "Railway Pde at Geebung station",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung School, stop 48",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Mylne Street, stop 44",
                        "Hamilton Rd at Chermside East near Pfingst Rd",
                        "Pfingst Rd near Hamilton Rd, stop 49",
                        "Pfingst Rd near Gumbrae St, stop 48",
                        "Pfingst Rd near Wirega St, stop 47",
                        "Pfingst Rd near Highcrest Ave, stop 46",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "White St at Wavell State High, stop E"
                    ],
                    "970: Wavell High - Chermside": [
                        "Wavell State High Oval Stop",
                        "Pfingst Rd at Brae Street, stop 43",
                        "Pfingst Rd at Wavell State High School, stop 43",
                        "Pfingst Rd near Taylor St, stop 44",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near Gurley St, stop 46",
                        "Pfingst Rd near Calga St, stop 47",
                        "Pfingst Rd near Miller St, stop 48",
                        "Pfingst Rd near Norla St, stop 49",
                        "Hamilton Rd at Chermside East near Newman Rd",
                        "Spence Rd near Hamilton Rd, stop 42",
                        "Spence Rd at Gardenia Street, stop 41",
                        "Spence Rd near Highlands St, stop 40/39",
                        "Spence Rd near Rode Rd, stop 38",
                        "Rode Rd near Deloraine St, stop 37A",
                        "Shaw Rd at Westwood Street, stop 36",
                        "Shaw Rd near Villeroy St, stop 39",
                        "Shaw Rd near Sylvan Ave, stop 38",
                        "Buckland Rd near Shaw Rd, stop 34",
                        "Buckland Rd at Imbros Street, stop 35/36",
                        "Buckland Rd at Bishop Street, stop 37",
                        "Buckland Rd at Park Road, stop 38",
                        "Park Rd near Boyd Road, stop 39",
                        "Park Rd at Windsor Street, stop 40",
                        "Rode Rd near Kinmond Ave, stop 41",
                        "Rode Rd near Sugarloaf St, stop 42/43",
                        "Bilsen Rd near Joppa Lane, stop 45",
                        "Bilsen Rd at Rilatt Street, stop 46",
                        "Bilsen Rd near Hamilton Rd, stop 47",
                        "Bilsen Rd at Halcyon Street, stop 48",
                        "Bilsen Rd at Kuppa Street, stop 49",
                        "Bilsen Rd near Main Ave, stop 50",
                        "Beor St at Unmack Street, stop 43",
                        "Beor St near Corrie St, stop 42",
                        "Corrie St near Hodgkinson St, stop 41",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Playfield Street, stop 37a",
                        "Chermside interchange"
                    ],
                    "971: Wavell High - Toombul": [
                        "Wavell State High Oval Stop",
                        "Edinburgh Castle Rd at Zeehan Street, stop 42",
                        "Edinburgh Castle Rd at Deloraine Street, stop 41",
                        "Edinburgh Castle Rd near Shaw Rd, stop 40",
                        "Rode Rd near Bayview Tce, stop 42/43",
                        "Rode Rd near Eliza Ln",
                        "Rode Rd near Sandgate Rd",
                        "Sandgate Rd at Nundah, stop 3",
                        "Sandgate Rd at Nundah, stop 2",
                        "Sandgate Rd near Buckland Rd, stop 1",
                        "Toombul Shopping Centre station, platform D"
                    ],
                    "972: Wavell High - Geebung Station": [
                        "Railway Pde at Geebung station",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung School, stop 48",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Mylne Street, stop 44",
                        "Hamilton Rd at Chermside East near Pfingst Rd",
                        "Pfingst Rd near Hamilton Rd, stop 49",
                        "Pfingst Rd near Gumbrae St, stop 48",
                        "Pfingst Rd near Wirega St, stop 47",
                        "Pfingst Rd near Highcrest Ave, stop 46",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near White St, stop 44",
                        "White St at Wavell State High, stop E",
                        "Wavell State High Oval Stop",
                        "Newman Rd at Geebung station, stop 51"
                    ],
                    "973: Wavell High - Trouts Rd": [
                        "Trouts Rd near Leach St, stop 7",
                        "Trouts Rd near Castling St, stop 8",
                        "Trouts Rd at Trouts - Redwood, stop 40",
                        "Trouts Rd at Redgrave Street, stop 41",
                        "Trouts Rd at Disney Street, stop 42",
                        "Trouts Rd at Flockton Street, stop 43",
                        "Parton St at Costello Place, stop 44",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Voigt Street, stop 46",
                        "Rode Rd at McDowall near Metro St",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Brynner St at Macnee Street, stop 48",
                        "Hoffman St at Brynner St, stop 49",
                        "Hoffman St at Ifield St, stop 48",
                        "Ifield St at Brando Street, stop 47",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd near Tyrone St",
                        "Coleridge St near Rutherford St",
                        "Appleby Rd at Maryland Street, stop 40",
                        "Rode Rd at Stafford Heights near Cranbourne St",
                        "Rode Rd at Cherston St",
                        "Rode Rd at Webster Road, stop 37",
                        "Rode Rd at Rode Road Hospital, stop 36",
                        "Rode Rd near Gympie Rd",
                        "White St at Wavell State High, stop C",
                        "White St at Wavell State High, stop E",
                        "Rode Rd near Telopia Ave, stop 46",
                        "Rode Rd near Davenport St",
                        "Ashworth St near Blenheim St",
                        "Chingford St near Lupton St",
                        "Chingford St near Cherston St",
                        "Bamber St near Cranbourne St",
                        "Rode Rd at Stafford Heights near Maundrell Tce",
                        "Rode Rd near Chuter St",
                        "Rode Rd near Cilento St, stop 44a",
                        "Trouts Rd at Flockton St, stop 43",
                        "Trouts Rd at Redwood St, stop 40",
                        "Trouts Rd near Midson St, stop 7"
                    ],
                    "974: Wavell High - Geebung - Taigum - Carseldine": [
                        "Wavell State High Oval Stop",
                        "Pfingst Rd near Gurley St, stop 46",
                        "Newman Rd at Geebung School, stop 49",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung station, stop 51",
                        "Railway Pde near Bayview Tce",
                        "Newman Rd near Delta St, stop 52",
                        "Newman Rd at Newman North, stop 52a",
                        "Zillmere Rd at Zillmere South",
                        "Church Rd at Church Road South",
                        "Church Rd at Church-Battersby",
                        "Church Rd near Keyatta St",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd at Caravan Park, stop 49",
                        "Beams Rd at St Flannans",
                        "Beams Rd at Golden Downs",
                        "Carseldine station"
                    ],
                    "975: Wavell High - Boondall station": [
                        "Wavell State High Oval Stop",
                        "Muller Rd at Taigum, stop 60a",
                        "Muller Rd near Bambrook St, stop 61",
                        "Muller Rd at Boondall West near Futuna St",
                        "Roghan Rd near Lindeman St",
                        "Roghan Rd at Roghan East",
                        "Sandgate Rd near Carlyle Rd, stop 22/21",
                        "Sandgate Rd at Boondall School, stop 20/21",
                        "Roscommon Rd at Roscommon East, stop 64/19",
                        "Roscommon Rd near Landsboro Ave, stop 20",
                        "Landsboro Ave at Landsboro, stop 20a",
                        "Aberdeen Pde at Boondall station"
                    ],
                    "976: Sandgate High - Chermside": [
                        "Braun St at Sandgate High, stop 27",
                        "Braun St at Smith Street, stop 26",
                        "Braun St at Burralong Street, stop 25",
                        "Landsboro Ave at Landsboro, stop 20a",
                        "Roscommon Rd near Landsboro Ave, stop 20",
                        "Roscommon Rd at Roscommon East, stop 19/64",
                        "Sandgate Rd near Roscommon Rd, stop 19",
                        "Sandgate Rd at Sues Corner, stop 18",
                        "Sandgate Rd at Nudgee College, stop 17",
                        "Newman Rd at Newman North, stop 52a",
                        "Newman Rd near Delta St, stop 52",
                        "Railway Pde at Geebung station",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung School, stop 48",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Mylne Street, stop 44",
                        "Hamilton Rd at Lochrae Street, stop 43",
                        "Spence Rd near Hamilton Rd, stop 42",
                        "Spence Rd at Gardenia Street, stop 41",
                        "Spence Rd near Highlands St, stop 40/39",
                        "Spence Rd near Rode Rd, stop 38",
                        "Pfingst Rd near Gurley St, stop 46",
                        "Pfingst Rd near Calga St, stop 47",
                        "Pfingst Rd near Miller St, stop 48",
                        "Pfingst Rd near Norla St, stop 49",
                        "Hamilton Rd at Unmack Street, stop 50",
                        "Hamilton Rd at Corrie Street, stop 51",
                        "Hamilton Rd at Chermside RSL, stop 53",
                        "Hamilton Rd at Playfield Street, stop 37a",
                        "Chermside interchange"
                    ],
                    "977: Carseldine - Toombul": [
                        "Carseldine station east",
                        "Beams Rd at Holy Spirit College",
                        "Beams Rd at St Flannans",
                        "Beams Rd at Caravan Park, stop 49",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd near Church Rd, stop 51",
                        "Taigum Shopping Centre, stop 52/57",
                        "Beams Rd near Muller Rd",
                        "Beams Rd near Groth Rd",
                        "Sandgate Rd at Nudgee College, stop 17",
                        "Sandgate Rd at Boondall South, stop 15",
                        "Sandgate Rd near Radley St",
                        "Sandgate Rd at Virginia",
                        "Sandgate Rd at Pritchard Road",
                        "Sandgate Rd at Virginia School, stop 21/20",
                        "Sandgate Rd at Royal Street, stop 19a",
                        "Sandgate Rd at Goss Road",
                        "Sandgate Rd near Flower St, stop 7",
                        "Sandgate Rd at Nundah North, stop 6",
                        "Sandgate Rd near Robinson Rd, stop 5",
                        "Sandgate Rd at Nundah - Rode Road, stop 4",
                        "Sandgate Rd at Nundah, stop 3",
                        "Sandgate Rd at Nundah, stop 2",
                        "Sandgate Rd near Buckland Rd, stop 1",
                        "Toombul Interchange"
                    ],
                    "978: Aspley - Nudgee College - Wavell High": [
                        "Aspley Hypermarket station, platform B",
                        "Gympie Rd at Gayford Street, stop 44",
                        "Gympie Rd at Brickfield Street, stop 45",
                        "Graham Rd at Gympie Rd, stop 56a",
                        "Graham Rd at Carseldine Chateaus, stop 4",
                        "Graham Rd at Nemira Street, stop 48",
                        "Graham Rd at Carseldine West near Kentia St",
                        "Ridley Rd at Ridley Road South",
                        "Ridley Rd near Dimboola St",
                        "Ridley Rd near Centurion St",
                        "Beams Rd near Tintara St",
                        "Beams Rd at Bangalore Street",
                        "Beams Rd at Carseldine Campus",
                        "Carseldine station",
                        "Beams Rd at Holy Spirit College",
                        "Beams Rd at St Flannans",
                        "Beams Rd at Caravan Park, stop 49",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd near Church Rd, stop 51",
                        "Taigum Shopping Centre, stop 52/57",
                        "Beams Rd near Muller Rd",
                        "Beams Rd near Groth Rd",
                        "Sandgate Rd at Nudgee College, stop 17",
                        "Newman Rd at Newman North, stop 52a",
                        "Newman Rd near Delta St, stop 52",
                        "Railway Pde at Geebung station",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung School, stop 48",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Mylne Street, stop 44",
                        "Hamilton Rd at Chermside East near Pfingst Rd",
                        "Pfingst Rd near Gumbrae St, stop 48",
                        "Pfingst Rd near Wirega St, stop 47",
                        "Pfingst Rd near Highcrest Ave, stop 46",
                        "Pfingst Rd near Rode Rd, stop 45",
                        "Pfingst Rd near White St, stop 44",
                        "White St at Wavell State High, stop E"
                    ],
                    "979: Stafford Heights - Aspley High": [
                        "Rode Rd near Chuter St",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd at Cilento Street, stop 44a",
                        "Rode Rd at Trouts Road",
                        "Rode Rd at Voigt Street, stop 46",
                        "Rode Rd at McDowall near Metro St",
                        "Beckett Rd at McDowall North",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at Paramount Chase",
                        "Beckett Rd at Bridgeman near Saturn Cr",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Darien Street",
                        "Albany Creek Rd at Bangalow Street",
                        "Albany Creek Rd at Aspley Bowl",
                        "Aspley Hypermarket station, platform C",
                        "Robinson Rd near Cornish Place, stop 50",
                        "Robinson Rd at Lerida Street, stop 52A",
                        "Robinson Rd at Priscilla Street, stop 53",
                        "Robinson Rd West near Fisher Pde",
                        "Robinson Rd at Bassano Street",
                        "Newman Rd near Delta St, stop 52",
                        "Newman Rd at Newman North, stop 52a",
                        "Zillmere Rd at Zillmere South",
                        "Zillmere Rd near Halcomb St",
                        "Zillmere Rd near Handford Rd",
                        "Ridgmont St near Trevorlea St",
                        "Zillmere Rd at Aspley High School",
                        "Dorville Rd at Denver East",
                        "Beams Rd at Carseldine Campus",
                        "Beams Rd at Holy Spirit College",
                        "Beams Rd at Golden Downs",
                        "Zillmere Rd at Aspley State High",
                        "Robinson Rd West at Fisher Parade",
                        "Albany Creek Rd opp Aspley Hypermarket",
                        "Beckett Rd at Bridgeman Downs",
                        "Beckett Rd at Bridgeman near Althorp Rd",
                        "Beckett Rd near Althorp Rd",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Rode Rd near Cilento St, stop 44a",
                        "Rode Rd near Tyrone St"
                    ],
                    "980: Wavell High - Boondall station": [
                        "Wavell State High Oval Stop",
                        "Newman Rd at Geebung School, stop 49",
                        "Newman Rd near High St, stop 50",
                        "Newman Rd at Geebung station, stop 51",
                        "Railway Pde near Bayview Tce",
                        "Newman Rd near Delta St, stop 52",
                        "Newman Rd at Newman North, stop 52a",
                        "Muller Rd near Ewing St, stop 56",
                        "Muller Rd at Hirschfield Street, stop 59",
                        "Beams Rd near Muller Rd",
                        "Beams Rd near Groth Rd",
                        "Groth Rd near Leona St",
                        "Garozzo Rd near Sandgate Rd",
                        "Northumbria Rd near Boondall St",
                        "College Way near Frensham Cr",
                        "College Way near Lourdes Pl",
                        "College Way near Thoms Ave",
                        "College Way near Frawley St",
                        "Holme Ave near Roundabout",
                        "Aberdeen Pde at Boondall station"
                    ],
                    "982: Wavell High - Chermside": [
                        "White St at Wavell State High, stop E",
                        "Chermside interchange"
                    ],
                    "983: Wavell High - Chermside": [
                        "Pfingst Rd at Brae Street, stop 43",
                        "White St at Wavell State High, stop E",
                        "Chermside interchange"
                    ],
                    "984: Wavell State High - Geebung station": [
                        "Wavell State High Oval Stop",
                        "Pfingst Rd near Gurley St, stop 46",
                        "Pfingst Rd near Calga St, stop 47",
                        "Pfingst Rd near Miller St, stop 48",
                        "Pfingst Rd near Norla St, stop 49",
                        "Hamilton Rd at Chermside East near Newman Rd",
                        "Newman Rd at Mylne Street, stop 44",
                        "Newman Rd at Newman South, stop 45",
                        "Newman Rd at Abdale Street, stop 46",
                        "Newman Rd at Lauren Street, stop 47",
                        "Newman Rd at Newman - Ellison, stop 48",
                        "Ellison Rd at Marmont Street",
                        "Ellison Rd near Jeenly St",
                        "Piccadilly St near Sandra St",
                        "Piccadilly St near Haymarket St",
                        "Copperfield St near Ossian St",
                        "Newman Rd at Geebung station, stop 51"
                    ],
                    "985: Aviation High - Doomben station via Ascot": [
                        "Widdop St at Eliza Street, stop 37/43",
                        "Gellibrand St near Zillman Rd, stop 36/4",
                        "Zillman Rd at Junction Road, stop 35a/42",
                        "Gerler Rd at Zillman Road, stop 36/38",
                        "Gerler Rd at Doncaster Street, stop 39/40",
                        "Gerler Rd at TC Beirne Park, stop 40/39",
                        "Gerler Rd at Dorames Street, stop 37/36",
                        "Golden Sq at Bulli Street, stop 47",
                        "Bulli St at Webster Avenue, stop 46a",
                        "Pleystowe Cr near Nudgee Rd, stop 46",
                        "Nudgee Rd at Long Street, stop 35a/42",
                        "Nudgee Rd near Lilley St, stop 34",
                        "Nudgee Rd at Hampden Street, stop 33",
                        "Hampden St at St Ledger, stop 29",
                        "Silva St near Lamington Ave, stop 28",
                        "Lamington Ave at Doomben Rail, stop 27",
                        "Lamington Ave at Brassey Street, stop 26/31",
                        "Lancaster Rd at Norman Street, stop 25/15",
                        "Lancaster Rd at Napier Street, stop 24/14",
                        "Lancaster Rd at Ascot Rail, stop 24/13",
                        "Lancaster Rd at Kitchener Road, stop 25",
                        "Lancaster Rd at Ormond Street, stop 26",
                        "Upper Lancaster Rd near Wren Street, stop 25",
                        "Anthony St at Tower Street, stop 24",
                        "Anthony St at Ascot School, stop 23",
                        "Massey St near Crescent Rd",
                        "Oriel Rd near Stafford St, stop 27",
                        "Alexandra Rd at Oriel Road Stop 28",
                        "Alexandra Rd at Palm Avenue Stop 29",
                        "Alexandra Rd at Sefton Road Stop 30",
                        "Sefton Rd at Marie Street, stop 31",
                        "Zillman Rd at Hendra Rail, stop 32/8",
                        "Zillman Rd at Bowley Street, stop 33/34",
                        "Zillman Rd at Union Street, stop 35/6",
                        "Burilda St at Derby Street, stop 45",
                        "Manson St at Goodwood Street, stop 44",
                        "Newmarket St at Manson Road, stop 43",
                        "Newmarket St at Flemington Street, stop 42",
                        "Newmarket St near Gerler Rd, stop 41"
                    ],
                    "986: Wavell State High - Everton Park": [
                        "White St at Wavell State High, stop E",
                        "Rode Rd near Telopia Ave, stop 46",
                        "Rode Rd near Davenport St",
                        "Rode Rd at Rode Road Hospital, stop 36",
                        "Webster Rd at Webster - Rode, stop 37",
                        "Webster Rd at Prince Charles Hospital, stop 38",
                        "Webster Rd near Dundalli St, stop 39/23",
                        "Hamilton Rd at Birra Street, stop 40",
                        "Hamilton Rd at Pullford St, stop 41/42",
                        "Maundrell Tce at St Gerards, stop 45/46",
                        "Maundrell Tce at John Goss Reserve, stop 47",
                        "Maundrell Tce at Chermside West, stop 48",
                        "Maundrell Tce at Terrence Street, stop 49",
                        "Maundrell Tce at Horn Road, stop 50a",
                        "Maundrell Tce at Darwin Street, stop 50a",
                        "Maundrell Tce at Arell Street, stop 51",
                        "Maundrell Tce at Riordan Street, stop 52",
                        "Albany Creek Rd opp Aspley Hypermarket",
                        "Albany Creek Rd at Aspley Bowl",
                        "Albany Creek Rd at Bangalow Street",
                        "Beckett Rd at Bridgeman Downs",
                        "Beckett Rd at Darien Street",
                        "Beckett Rd at Casuarina",
                        "Beckett Rd at Bridgeman near Althorp Rd",
                        "Beckett Rd at Paramount Chase",
                        "Beckett Rd at McDowall Village",
                        "Beckett Rd at McDowall North near Savalas St",
                        "Old Northern Rd at Everton Hills near Rode Rd",
                        "Old Northern Rd at Everton Park North",
                        "Old Northern Rd at Deakin Street",
                        "South Pine Rd at Everton Junction, stop 40",
                        "South Pine Rd at Nitawill Street, stop 39",
                        "South Pine Rd at White Street, stop 38",
                        "Griffith St at Everton Park, stop 4/18"
                    ],
                    "987: Aviation High - Northgate station": [
                        "Widdop St at Eliza Street, stop 37/43",
                        "Gellibrand St near Zillman Rd, stop 36/4",
                        "Zillman Rd at Junction Road, stop 35a/42",
                        "Sandgate Rd at Eliza Street, stop 30",
                        "Sandgate Rd at Noble Street, stop 31",
                        "Toombul Shopping Centre station, platform D",
                        "Buckland Rd near Danby Lane, stop 1",
                        "Buckland Rd at Union Street, stop 2",
                        "Buckland Rd at Melton Road, stop 3",
                        "Buckland Rd at Hedley Avenue, stop 4",
                        "Hedley Ave near York St, stop 5",
                        "York St near Killeen St, stop 7",
                        "Amelia St near York St, stop 8",
                        "Amelia St near Little Jenner St, stop 9",
                        "Nellie St near Bligh St, stop 10",
                        "Nellie St near Melton Rd, stop 11",
                        "Melton Rd near New Ivo St, stop 12",
                        "Melton Rd at Elwyn Street, stop 14",
                        "Holland St at Northgate station"
                    ],
                    "988: Bracken Ridge High - Carseldine station": [
                        "Barfoot St at Bracken Ridge High School",
                        "Douglas St near Gordon St, stop 52",
                        "Barfoot St near Cedarwood St",
                        "Cramb St near McKeering St, stop 39",
                        "McKeering St at Shane Street, stop 38",
                        "Barrett St near Tallara St, stop 37",
                        "Bracken St at Bracken Ridge Library",
                        "Gawain Rd at Gawain East, stop 42",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Bracken Ridge Rd near Rinnicrew St",
                        "Ballynde St at Glenealy Street, stop 54",
                        "Ballynde St at Portumna Street, stop 53",
                        "Ballynde St at Toormore Street, stop 52",
                        "Ballynde St near Bungowla St, stop 51",
                        "Killare St near Wickfield Cr, stop 50",
                        "Wickfield St near Rosa Cr, stop 49",
                        "Barbour Rd near Wickfield St, stop 47",
                        "Barbour Rd near Phillips St",
                        "Phillips St at St Josephs",
                        "Warimoo St near Broders St",
                        "Denham St at Childs Street, stop 33",
                        "Denham St near Phillips St, stop 32",
                        "Phillips St at Tomah Street",
                        "Enbrook St near Appledore St",
                        "Enbrook St near Mustang St",
                        "Mustang St near Telegraph Rd",
                        "Norris Rd at Tasman Bvd hail 'n' ride",
                        "Norris Rd at Cape Arid Park",
                        "Carselgrove Ave near Roghan Rd",
                        "Carselgrove Ave near Carnarvon Cr",
                        "Carseldine station east"
                    ],
                    "990: Boondall - St John Fisher": [
                        "Muller Rd near Bambrook St, stop 61",
                        "Muller Rd at Boondall West near Futuna St",
                        "Roghan Rd at Lemke Rd",
                        "Handford Rd at Handford - Roghan",
                        "Handford Rd at Symes Grove, stop 49",
                        "Handford Rd at Liberty Dr",
                        "Handford Rd at St Flannans School",
                        "Handford Rd at Handford - Battersby, stop 49",
                        "Handford Rd at Kolberg Street, stop 47A",
                        "Handford Rd at Zillmere station",
                        "Zillmere Rd near Handford Rd",
                        "Zillmere Rd near Halcomb St",
                        "Church Rd at Church Road South",
                        "Church Rd at Church-Battersby",
                        "Church Rd near Keyatta St",
                        "Taigum Shopping Centre, stop 52/57",
                        "Beams Rd near Muller Rd",
                        "Groth Rd near Leona St",
                        "Garozzo Rd near Sandgate Rd",
                        "Northumbria Rd near Boondall St",
                        "College Way near Frensham Cr",
                        "College Way near Lourdes Pl",
                        "College Way near Thoms Ave",
                        "College Way near Frawley St",
                        "Holme Ave near Roundabout",
                        "Roscommon Rd near Landsboro Ave, stop 20",
                        "Roscommon Rd at Roscommon East, stop 19/64",
                        "Sandgate Rd at Boondall School, stop 20",
                        "Sandgate Rd near Roghan Rd, stop 22/23",
                        "Sandgate Rd at Iceworld, stop 23/24",
                        "Braun St at Burralong Street, stop 25",
                        "Braun St at Smith Street, stop 26",
                        "Braun St at Sandgate High, stop 27",
                        "Board St near Ibis Ave, stop 28",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St at Kift Street, stop 30",
                        "Rainbow St near Lunn St, stop 31",
                        "Rainbow St at Hancock Street, stop 32",
                        "Yundah St at Shorncliffe State School",
                        "Sandgate bus station, stop 1",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate, stop 34",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Deagon St near Southerden St, stop 37",
                        "Deagon Devn at Deagon Street, stop 38",
                        "Baskerville St at Sandgate North, stop 39",
                        "Baskerville St at Peace Park",
                        "Baskerville St at Nashville School",
                        "Douglas St near Sandown St, stop 51",
                        "Douglas St near Gordon St, stop 52",
                        "Barfoot St near Cedarwood St",
                        "Cedarwood St at Evergreen St",
                        "John Fisher Dr at St John Fisher College"
                    ],
                    "991: Bald Hills, St Patricks": [
                        "Coriander St near Kluver St, stop 60",
                        "Taragon St near Chervil St",
                        "Kluver St near Bracken Ridge Rd",
                        "Arnica Cr near Korina St, stop 57",
                        "Arnica Cr near Mantias Street, stop 56",
                        "Charlock Rd near Arnica Cr, stop 55",
                        "Charlock Rd near Gladdon St",
                        "Bracken Ridge Rd at Wetlands",
                        "Ballynde St at Glenealy Street, stop 54",
                        "Ballynde St at Portumna Street, stop 53",
                        "Ballynde St at Toormore Street, stop 52",
                        "Ballynde St near Bungowla St, stop 51",
                        "Killare St near Wickfield Cr, stop 50",
                        "Wickfield St near Rosa Cr, stop 49",
                        "Wickfield St near Sophy Cr, stop 48",
                        "Barbour Rd near Wickfield St, stop 47",
                        "Norris Rd near Barbour Rd",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Norris Rd at Greenore Street, stop 45",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Gawain East, stop 42",
                        "Tallara St near Tarwarri St, stop 36",
                        "Tomah Rd near Binburra St, stop 34",
                        "Warimoo St near Broders St",
                        "Phillips St at Enbrook Street",
                        "Enbrook St near Appledore St",
                        "Enbrook St near Mustang St",
                        "Mustang St near Telegraph Rd",
                        "Depot Rd at Quinlan Street South, stop 30",
                        "Depot Rd at Braun Street, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St at Kift Street, stop 30",
                        "Rainbow St near Lunn St, stop 31",
                        "Rainbow St at Hancock Street, stop 32",
                        "Yundah St at Shorncliffe State School",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St near Racecourse Rd, stop 29a",
                        "Tallara St near Tulee St, stop 36",
                        "Bracken St at Bracken Ridge Library",
                        "Norris Rd at Greenore Street",
                        "Barbour Rd at Caulfield Street, stop 47A",
                        "Wickfield St near Rosa Cr, stop 47",
                        "Wickfield St at Rosa Crescent, stop 49",
                        "Killare St near Wickfield St, stop 50",
                        "Ballynde St near Portumna Street, stop 53",
                        "Arnica Cr at Mantias Street, stop 56",
                        "Coriander St near Kluver St"
                    ],
                    "992: Boondall - St John Fisher - Bracken Ridge": [
                        "Beams Rd near Muller Rd",
                        "Beams Rd at Taigum Shopping Centre",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd at Caravan Park, stop 49",
                        "Beams Rd at St Flannans",
                        "Carseldine station east, stop 1",
                        "Carselgrove Ave near Carnarvon Cr",
                        "Carselgrove Ave near Roghan Rd",
                        "Norris Rd at Cape Arid Park",
                        "Norris Rd at Tasman Bvd hail 'n' ride",
                        "Telegraph Rd near Mustang St",
                        "Mustang St near Telegraph Rd",
                        "Enbrook St near Mustang St",
                        "Enbrook St near Appledore St",
                        "Phillips St near Tomah Rd",
                        "Denham St near Phillips St, stop 32",
                        "Denham St near Childs St, stop 33",
                        "Warimoo St near Broders St",
                        "Phillips St at St Josephs",
                        "Barbour Rd near Phillips St",
                        "Barbour Rd at Caulfield Street, stop 47A",
                        "Wickfield St near Rosa Cr, stop 47",
                        "Wickfield St near Sophy Cr, stop 48",
                        "Wickfield St at Rosa Crescent, stop 49",
                        "Killare St near Wickfield St, stop 50",
                        "Ballynde St near Bungowla St, stop 51",
                        "Ballynde St at Toormore Street, stop 52",
                        "Ballynde St near Portumna Street, stop 53",
                        "Ballynde St at Glenealy Street, stop 54",
                        "Norris Rd at Norris - Bracken Ridge",
                        "Norris Rd near Gawain Rd",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Gawain East, stop 42",
                        "Cramb St near McKeering St, stop 39",
                        "McKeering St at Shane Street, stop 38",
                        "Barrett St near Tallara St, stop 37",
                        "Bracken St at Bracken Ridge Library",
                        "John Fisher Dr at St John Fisher College",
                        "Barfoot St near Cedarwood St hail 'n' ride",
                        "Barfoot St at Bracken Ridge High School",
                        "Ballynde St at Portumna Street, stop 53",
                        "Killare St near Wickfield Cr, stop 50",
                        "Wickfield St near Rosa Cr, stop 49",
                        "Barbour Rd near Wickfield St, stop 47",
                        "Denham St at Childs Street, stop 33",
                        "Phillips St at Tomah Street",
                        "Carseldine station east",
                        "Beams Rd at Holy Spirit College",
                        "Beams Rd near Church Rd, stop 51",
                        "Taigum Shopping Centre, stop 52/57",
                        "Beams Rd near Groth Rd",
                        "Stanworth Rd near Roundabout",
                        "Aberdeen Pde at Boondall station"
                    ],
                    "993: Sandgate High - Bracken Ridge": [
                        "Braun St at Sandgate High, stop 27",
                        "Rainbow St at Hancock Street, stop 32",
                        "Yundah St at Shorncliffe State School",
                        "Sandgate station",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate, stop 34",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Deagon St near Southerden St, stop 37",
                        "Deagon Devn at Deagon Street, stop 38",
                        "Baskerville St at Sandgate North, stop 39",
                        "Baskerville St at Peace Park",
                        "Baskerville St at Nashville School",
                        "Douglas St near Sandown St, stop 51",
                        "Douglas St near Gordon St, stop 52",
                        "Cedarwood St at Evergreen St",
                        "Tallara St near Tarwarri St, stop 36",
                        "Tomah Rd near Binburra St, stop 34",
                        "Denham St at Childs Street, stop 33",
                        "Denham St near Phillips St, stop 32",
                        "Phillips St at Tomah Street",
                        "Enbrook St near Appledore St",
                        "Enbrook St near Mustang St",
                        "Mustang St near Telegraph Rd"
                    ],
                    "994: St John Fisher - Bracken Ridge TAFE": [
                        "John Fisher Dr at St John Fisher College",
                        "Barfoot St near Cedarwood St hail 'n' ride",
                        "Barfoot St at Bracken Ridge High School",
                        "Douglas St near Gordon St, stop 52",
                        "Douglas St near Sandown St, stop 51",
                        "Baskerville St at Nashville School",
                        "Baskerville St at Peace Park",
                        "Baskerville St at Sandgate North, stop 39",
                        "Deagon St near Albion St, stop 38",
                        "Deagon St near Brisbane St, stop 37",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St at Kift Street, stop 30",
                        "Board St near Racecourse Rd, stop 29a",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Braun St at Desmond Street, stop 27A",
                        "Braun St at Sandgate High, stop 27",
                        "Braun St at Smith Street, stop 26",
                        "Braun St at Burralong Street, stop 25",
                        "Sandgate Rd at Iceworld, stop 24",
                        "Sandgate Rd near Carlyle Rd, stop 22/21",
                        "Sandgate Rd at Boondall School, stop 20/21",
                        "Sandgate Rd near Roscommon Rd, stop 19",
                        "Beams Rd near Jalomy St, stop 25A",
                        "Beams Rd near Groth Rd",
                        "Beams Rd near Muller Rd",
                        "Beams Rd at Taigum Shopping Centre",
                        "Beams Rd at Bartholomew, stop 50",
                        "Beams Rd at Caravan Park, stop 49",
                        "Beams Rd at St Flannans",
                        "Carseldine station east, stop 1",
                        "Carselgrove Ave near Carnarvon Cr",
                        "Carselgrove Ave near Roghan Rd",
                        "Norris Rd at Cape Arid Park",
                        "Norris Rd at Tasman Bvd hail 'n' ride",
                        "Norris Rd at Bracken Ridge Plaza",
                        "Norris Rd near Barbour Rd, stop 46",
                        "Norris Rd near Barbour Rd",
                        "Norris Rd at Bracken Ridge TAFE"
                    ],
                    "995: Sandgate High - Carseldine station": [
                        "Braun St at Sandgate High, stop 27",
                        "Barfoot St near Cedarwood St hail 'n' ride",
                        "Gawain Rd at Gawain East, stop 42",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Norris Rd at Greenore Street",
                        "Norris Rd at Bracken Ridge TAFE",
                        "Norris Rd near Barbour Rd",
                        "Barbour Rd near Phillips St",
                        "Phillips St at St Josephs",
                        "Phillips St at Enbrook Street",
                        "Enbrook St near Appledore St",
                        "Enbrook St near Mustang St",
                        "Mustang St near Telegraph Rd",
                        "Norris Rd at Tasman Bvd hail 'n' ride",
                        "Norris Rd at Cape Arid Park",
                        "Carselgrove Ave near Roghan Rd",
                        "Carselgrove Ave near Carnarvon Cr",
                        "Carseldine station east, stop 1"
                    ],
                    "996: Sandgate High - Brighton": [
                        "Braun St at Sandgate High, stop 27",
                        "Board St near Ibis Ave, stop 28",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St at Kift Street, stop 30",
                        "Rainbow St near Lunn St, stop 31",
                        "Rainbow St at Hancock Street, stop 32",
                        "Sandgate Central, stop 33",
                        "Brighton Rd at Sandgate, stop 34",
                        "Sacred Heart School 35",
                        "Brighton Rd at Brighton Terrace, stop 36",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Deagon St near Southerden St, stop 37",
                        "Deagon Devn at Deagon Street, stop 38",
                        "Baskerville St at Sandgate North, stop 39",
                        "Paul St near Beaumetz St, stop 40",
                        "Ward St near Paul St, stop 41",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Princess St",
                        "Beaconsfield Tce near Duke St",
                        "North Rd at Bayview",
                        "North Rd at Brighton North near Prince St",
                        "North Rd at St Kieran",
                        "North Rd at Brighton School, stop 58",
                        "Lascelles St at Brighton, stop 56a",
                        "Lascelles St at Brighton South, stop 54a",
                        "Lascelles St near Mary Ellen St, stop 54",
                        "Lascelles St near Palina St, stop 53"
                    ],
                    "997: Brighton - Sandgate High": [
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Duke St",
                        "North Rd at Bayview",
                        "North Rd at Brighton North near Prince St",
                        "North Rd at St Kieran",
                        "North Rd at Brighton School, stop 58",
                        "Lascelles St at Brighton, stop 56a",
                        "Lascelles St at Brighton South, stop 54a",
                        "Lascelles St near Mary Ellen St, stop 54",
                        "Lascelles St near Palina St, stop 53",
                        "Douglas St near Gordon St, stop 52",
                        "Douglas St near Sandown St, stop 51",
                        "Nathan St near Sunwell St, stop 50",
                        "Nathan St near Saul St, stop 49",
                        "Nathan St near Speight St, stop 48",
                        "Nathan St near Queens Pde, stop 47",
                        "Queens Pde near Morcombe St, stop 46",
                        "Queens Pde near Northcote St, stop 45",
                        "Queens Pde near Gladstone St, stop 44",
                        "Kennedy St near Hamilton St, stop 42",
                        "Ward St near Paul St, stop 41",
                        "Paul St near Beaumetz St, stop 40",
                        "Baskerville St at Sandgate North, stop 39",
                        "Deagon St near Albion St, stop 38",
                        "Deagon St near Brisbane St, stop 37",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Brighton Rd near Seventh Ave, stop 35",
                        "Brighton Rd at Sandgate, stop 34",
                        "Brighton Rd at Sandgate Central, stop 34/33",
                        "Yundah St at Shorncliffe State School",
                        "Rainbow St at Sandgate station, stop 33",
                        "Rainbow St at Barclay Street, stop 31/34",
                        "Board St at Kift Street, stop 30",
                        "Board St near Racecourse Rd, stop 29a",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Depot Rd at Braun Street, stop 29",
                        "Depot Rd at Quinlan Street South, stop 30",
                        "Denham St at Warra",
                        "Phillips St at Tomah Street",
                        "Phillips St at Enbrook Street",
                        "Warimoo St near Broders St",
                        "Tomah Rd near Binburra St, stop 34",
                        "Tallara St near Tulee St, stop 36",
                        "Bracken St at Bracken Ridge Library",
                        "Gawain Rd at Gawain East, stop 42",
                        "Gawain Rd at Ettare Street, stop 42",
                        "Gawain Rd at Bracken Ridge, stop 43",
                        "Gawain Rd at Percivale Street, stop 44",
                        "Barfoot St near Cedarwood St hail 'n' ride",
                        "Barfoot St at Bracken Ridge High School"
                    ],
                    "998: Strathpine - Bracken Ridge": [
                        "Strathpine bus station, stop D",
                        "Strathpine Rd at Adair Street",
                        "Strathpine Rd near Bald Hills Rd",
                        "Bald Hills Rd near Godfrey St",
                        "Attunga St near Cambrian St",
                        "Seaton St at Feuerriegel Rd",
                        "Feuerriegel St at Juxon St",
                        "Hoyland St near Kluver St",
                        "Coriander St near Kluver St, stop 60",
                        "Taragon St near Chervil St",
                        "Kluver St near Bracken Ridge Rd",
                        "Arnica Cr near Korina St, stop 57",
                        "Arnica Cr near Mantias Street, stop 56",
                        "Charlock Rd near Arnica Cr, stop 55",
                        "Charlock Rd near Gladdon St",
                        "Bracken Ridge Rd at Wetlands",
                        "Norris Rd at Norris - Bracken Ridge",
                        "Norris Rd near Gawain Rd",
                        "Norris Rd at Greenore Street",
                        "Rinnicrew St near Bungowla St",
                        "Killare St near Wickfield Cr, stop 50",
                        "Wickfield St near Rosa Cr, stop 49",
                        "Wickfield St near Sophy Cr, stop 48",
                        "Barbour Rd near Wickfield St, stop 47",
                        "Barbour Rd near Phillips St",
                        "Phillips St at St Josephs",
                        "Warimoo St near Broders St",
                        "Tomah Rd near Binburra St, stop 34",
                        "Denham St at Childs Street, stop 33",
                        "Denham St near Phillips St, stop 32",
                        "Denham St at Warra, stop 31",
                        "Depot Rd at Quinlan Street South, stop 30",
                        "Depot Rd at Braun Street, stop 29",
                        "Barfoot St at Bracken Ridge High School",
                        "Douglas St near Gordon St, stop 52",
                        "Barfoot St near Cedarwood St",
                        "Norris Rd at Bracken Ridge Plaza",
                        "Norris Rd near Barbour Rd, stop 46",
                        "Barbour Rd at Caulfield Street, stop 47A",
                        "Wickfield St near Rosa Cr, stop 47",
                        "Wickfield St at Rosa Crescent, stop 49",
                        "Killare St near Wickfield St, stop 50",
                        "Ballynde St near Bungowla St, stop 51",
                        "Ballynde St at Toormore Street, stop 52",
                        "Ballynde St near Portumna Street, stop 53",
                        "Ballynde St at Glenealy Street, stop 54",
                        "Arnica Cr at Mantias Street, stop 56",
                        "Coriander St near Kluver St",
                        "Hoyland St near Dresden St",
                        "Strathpine Rd near Lucy St",
                        "Strathpine Rd at Adair St"
                    ],
                    "999: Kippa-Ring, Sandgate, Nudgee, Clayfield": [
                        "Boardman Rd at Susan Avenue",
                        "Boardman Rd at McGregor Street",
                        "Newport Drive near Griffith Rd",
                        "Newport Dr at Southern Cross Drive",
                        "Endeavour Esp at Dolphin Street",
                        "Oyster Point Esp at Michel Road",
                        "Thurecht Pde at Thurecht Park",
                        "Scarborough Rd at Fifth Avenue",
                        "Scarborough Rd at Jeays Street",
                        "Scarborough Rd at Anderson Street",
                        "Scarborough Rd at Southern Cross College",
                        "Scarborough Rd at Griffith Road",
                        "Scarborough Rd at Maryborough Terrace",
                        "Scarborough Rd at Eversleigh Road",
                        "Scarborough Rd at Shields Street",
                        "Scarborough Rd at Klinger Road",
                        "Scarborough Rd at Redcliffe Showgrounds",
                        "Recreation St at Redcliffe Hospital",
                        "Victoria Ave at Anzac Avenue",
                        "Victoria Ave at Bradley Park",
                        "Victoria Ave at Macdonnell Road",
                        "Victoria Ave at Barry Bolton Park",
                        "Victoria Ave at Duffield Road",
                        "Victoria Ave at Dunbar Street",
                        "Victoria Ave at King Street",
                        "Victoria Ave at Clifford Street",
                        "Hornibrook Esp at Victoria Avenue",
                        "Hornibrook Esp at Bells Beach",
                        "Hornibrook Esp at Pelican Park East",
                        "Hornibrook Esp at Pelican Park Central",
                        "Hornibrook Esp at Pelican Park",
                        "Hornibrook Esp at Clontarf Beach East",
                        "Hornibrook Esp at Clontarf Beach West",
                        "Hornibrook Hwy at Eventide Aged Home",
                        "Beaconsfield Tce near Duke St",
                        "Beaconsfield Tce near Shepherd St",
                        "Deagon St at Dowse Lagoon, stop 36",
                        "Board St at Kift Street, stop 30",
                        "Board St at Deagon Racecourse, stop 29",
                        "Board St near Ibis Ave, stop 28",
                        "Braun St at Desmond Street, stop 27A",
                        "Braun St at Sandgate High, stop 27",
                        "Braun St at Smith Street, stop 26",
                        "Braun St at Burralong Street, stop 25",
                        "Sandgate Rd at Iceworld, stop 24",
                        "Sandgate Rd near Carlyle Rd, stop 22/21",
                        "Sandgate Rd at Boondall School, stop 20/21",
                        "Sandgate Rd near Roscommon Rd, stop 19",
                        "Sandgate Rd at Sues Corner, stop 18",
                        "Sandgate Rd at Nudgee College, stop 17",
                        "Sandgate Rd at Boondall South, stop 15",
                        "Sandgate Rd near Radley St",
                        "Sandgate Rd at Virginia",
                        "Sandgate Rd at Pritchard Road",
                        "Sandgate Rd at Virginia School, stop 21/20",
                        "Sandgate Rd at Royal Street, stop 19a",
                        "Sandgate Rd at Goss Road",
                        "Sandgate Rd near Flower St, stop 7",
                        "Sandgate Rd at Nundah North, stop 6",
                        "Sandgate Rd near Robinson Rd, stop 5",
                        "Sandgate Rd at Nundah - Rode Road, stop 4",
                        "Sandgate Rd at Nundah, stop 3",
                        "Sandgate Rd at Toombul, stop 32",
                        "Sandgate Rd at Noble Street, stop 31",
                        "Sandgate Rd at Eliza Street, stop 30",
                        "Sandgate Rd at Collins Street, stop 28",
                        "Sandgate Rd at London Road",
                        "Sandgate Rd at Adelaide Street, stop 25",
                        "Sandgate Rd at Botany Street, stop 24",
                        "Sandgate Rd at Clayfield South, stop 23",
                        "Oriel Rd near Stafford St, stop 27",
                        "Oriel Rd near Wellington St hail 'n' ride",
                        "Sandgate Rd at Clayfield, stop 27",
                        "Sandgate Rd at Nundah, Rode Road stop 4",
                        "Sandgate Rd near Leighton St, stop 5",
                        "Sandgate Rd at Nundah North, stop 7/6",
                        "Sandgate Rd near Maddocks St, stop 7",
                        "Sandgate Rd near Maddocks St",
                        "Sandgate Rd at Goss Road, stop 8",
                        "Sandgate Rd at Virginia School, stop 21",
                        "Sandgate Rd near Ferric St",
                        "Sandgate Rd at Boondall South Stop 15",
                        "Sandgate Rd at Boondall School, stop 20",
                        "Sandgate Rd near Roghan Rd, stop 22/23",
                        "Sandgate Rd at Iceworld, stop 23/24",
                        "Braun St at Musgrave Street, stop 24a",
                        "Deagon St near Brisbane St, stop 37",
                        "Brighton Tce near Wakefield St",
                        "Brighton Tce near Tenth Ave",
                        "Brighton Tce near Twelfth Ave",
                        "Beaconsfield Tce near Seaview St",
                        "Beaconsfield Tce near Princess St",
                        "Hornibrook Hwy at Eventide",
                        "Hornibrook Hwy at Brighton Bayside Park",
                        "Hornibrook Esp near Donald St",
                        "Victoria Avenue near Hornibrook Esp",
                        "Newport Dr near Southern Cross Dr"
                    ],
                    "S700: Fig Tree Pocket - Indooroopilly": [
                        "Cubberla St near Thiesfield St",
                        "Gunnin St near Tandawanna Lane, stop 41",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41a",
                        "Fig Tree Pocket Rd near Botticelli St, stop 42A",
                        "Fig Tree Pocket Rd at Mandalay, stop 44",
                        "Kenny St near Ormsby St, stop 45a",
                        "Fig Tree Pocket Rd near Mactier St, stop 41",
                        "Fig Tree Pocket Rd at Cubberla Street, stop 40",
                        "Fig Tree Pocket Rd at Thiesfield Street, stop 38",
                        "Kenmore Road near Norman St",
                        "Fig Tree Pocket Rd near Kenmore Rd, stop 37",
                        "Fig Tree Pocket Rd near Sprenger St, stop 36",
                        "Sprenger Street near Terrigal St",
                        "Farnham Street near Oaklington",
                        "Fig Tree Pocket Rd at Kenmore Rugby Club - Stop 34",
                        "Fig Tree Pocket Rd near Jerrang St, stop 33",
                        "Jerrang St near Market St, stop 32",
                        "Jesmond Rd near Bunning St",
                        "Jainba Street near Jilba St",
                        "Kate St near Boundary Rd, stop 30",
                        "Witton Rd near Kate St, stop 29",
                        "Witton Rd near Rennies Rd, stop 28A",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly interchange"
                    ],
                    "S701: Seventeen Mile Rocks - Corinda High": [
                        "Seventeen Mile Rocks Rd at Edenbrooke, stop 72",
                        "Seventeen Mile Rocks Rd at Arygle Street, stop 73",
                        "Oldfield Rd near McPherson Rd, stop 57",
                        "Oldfield Rd at Oldfield Shops, stop 57a",
                        "Oldfield Rd at Homebush Cr, stop 57b",
                        "Northbrook St at Northbrook - Oldfield, stop 58",
                        "Northbrook St at Cityview Rd, stop 59",
                        "Avondale Rd at Avondale - Northbrook, stop 60",
                        "Radcliffe St near Buckle Ct, stop 59",
                        "Radcliffe St near GreenHill Ct, stop 58",
                        "Glen Ross Rd at Wanata Street, stop 54",
                        "Glen Ross Rd at Sinnamon Park",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Burrendah Rd near Bangalee St",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd at Jindalee State School",
                        "Curragundi Rd at Jindalee Place",
                        "Curragundi Rd near Moolingal St",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd near Timbarra Cr",
                        "Yallambee Rd near Capitol Dr",
                        "Yallambee Rd at Mt Ommaney",
                        "Endeavour St near Macarthur Ct",
                        "Endeavour St near Flinders Ct",
                        "Mount Ommaney Shopping Centre",
                        "Dandenong Rd at Jamboree",
                        "Dandenong Rd near Spinnaker St",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Horizon Dr near Badge St",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr near Gertrude McLeod Cr",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr near Dewsbury St",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr near Congo St",
                        "Horizon Dr at Westlake South near Buffalo St",
                        "Sumners Rd at Macfarlane Street",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Sumners Rd at Riverhills East near Macfarlane St",
                        "Sumners Rd at Tompkins Road",
                        "Sumners Rd at Brumby Circuit",
                        "Sumners Rd at Sumner Tavern",
                        "Westcombe St near Perivale St, stop 62",
                        "Manburgh Tce near Queensland Rd, stop 63",
                        "Darra Shops",
                        "Darra Station Rd near Warrender St, stop 65",
                        "Winslow St near Darra Station Rd, stop 66",
                        "Winslow St at Rowe Tce, stop 67/68",
                        "Harcourt Rd at Cardiff Road South, stop 61",
                        "Ashridge Rd at Oxley Mews",
                        "Seventeen Mile Rocks Rd at Pannard St",
                        "Canossa Private Hospital, stop 70",
                        "Seventeen Mile Rocks Rd at Kingsgate St, stop 69",
                        "Ardoyne Rd at Oxley station, stop 68",
                        "Ardoyne Rd near Sheffield St, stop 67",
                        "Cliveden Ave at Lyon Ave, stop 66",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Pratten St near Edmondson St, stop 64",
                        "Pratten St at Corinda High School, stop 63",
                        "Oxley Rd at Lynne Grove, stop 60",
                        "Oxley Rd near Hassall St",
                        "Clewley St near Oxley Rd, stop 59",
                        "Clara St at Clewley St, stop 60",
                        "Clara St at Clara - Nelson, stop 61",
                        "Clara St at Clara - Grey, stop 62",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Ardoyne Rd near Lyon Ave, stop 67",
                        "Ardoyne Rd at Oxley station, stop B",
                        "Ashridge Rd near Southern Cross Ave",
                        "Ashridge Rd near Cardiff Rd",
                        "Cardiff Rd at Cardiff Road South, stop 61",
                        "Railway Pde at Darra Railway Parade, stop 62",
                        "Manburgh Tce at Darra station, stop B",
                        "Westcombe St near Gravel Pit Rd, stop 62",
                        "Dandenong Rd near Horizon Dr",
                        "Horizon Dr at Tigris Street",
                        "Riverhills Rd near Horizon Dr",
                        "Riverhills Rd at Wirilda",
                        "Glen Ross Rd near Wanata St",
                        "Radcliffe St near Buckle Ct",
                        "Radcliffe St near Avondale Rd",
                        "Northbrook St at Kobble Ct",
                        "Northbrooke St near Allamanda Ct, stop 59",
                        "Northbrooke St near Drummond St, stop 58",
                        "Oldfield Rd at Oldfield - Homebush, stop 57B",
                        "McPherson Rd at McPherson Park, stop 56",
                        "McPherson Rd at McPherson Cityview, stop 56a",
                        "McPherson Rd at Malia St, stop 55",
                        "McPherson Rd at McPherson South, stop 55A",
                        "Glen Ross Rd at Bellwood St, stop 54",
                        "Glen Ross Rd near Dove Tree Cr, stop 52",
                        "Glen Ross Rd at St Amand Street, stop 53"
                    ],
                    "S702: Milpera State High - Yeerongpilly station": [
                        "Wilkie St at Yeerongpilly station",
                        "Oxley Rd at Milpera, stop 51"
                    ],
                    "S703: Kenmore High - Sumner Park": [
                        "Sumners Rd at Spine St",
                        "Sumners Rd at Sumner Tavern",
                        "Sumners Rd at Brumby Circuit",
                        "Sumners Rd at Tompkins Road",
                        "Sumners Rd at Macfarlane Street",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Horizon Dr at Tigris Street",
                        "Horizon Dr at Westlake South near Riverhills Rd",
                        "Horizon Dr at Westlake near Nisbet St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr near Gertrude McLeod Cr",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Dandenong Rd near Spinnaker St",
                        "Dandenong Rd at Jamboree",
                        "Mount Ommaney Shopping Centre",
                        "Arrabri Ave at Mt Ommaney South near Bowles St",
                        "Arrabri Ave at Explorer",
                        "Yallambee Rd at Mt Ommaney",
                        "Yallambee Rd near Capitol Dr",
                        "Curragundi Rd near Yallambee Rd",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd near Yarrimbah St",
                        "Curragundi Rd at Jindalee Place",
                        "Burrendah Rd at Jindalee State School",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd near Mankinna St",
                        "Burrendah Rd at Jindalee park 'n' ride",
                        "Fig Tree Pocket Rd at Kenmore Rugby Club - Stop 34",
                        "Fig Tree Pocket Rd near Jerrang St, stop 33",
                        "Fig Tree Pocket Rd near Bredden St, stop 32A",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd near Marshall Lane, stop 34",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd near Private Rd, stop 36",
                        "Brookfield Rd at Kenmore Village, stop 36",
                        "Brookfield Rd near Private Rd, stop 36A",
                        "Mabb St at Kenmore High School, Zone C",
                        "Moggill Rd at Kenmore Village",
                        "Moggill Rd at Kenmore Churches, stop 35",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Bob Lynne Street, stop 32a",
                        "Fig Tree Pocket Rd near Henry St, stop 32A",
                        "Fig Tree Pocket Rd near Fawkner St, stop 33",
                        "Fig Tree Pocket Rd near Winking St, stop 33A",
                        "Fig Tree Pocket Rd near Kenmore Rugby Club Stop 34",
                        "Sinnamon Rd at Windermere",
                        "Goggs Rd at Windermere Village Shopping",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Burrendah Rd near Bangalee St",
                        "Curragundi Rd near Moolingal St",
                        "Curragundi Rd near Timbarra Cr",
                        "Bounty St at Explorer",
                        "Arrabri Ave near Blaxland Ct",
                        "Arrabri Ave near Abel Smith Cr",
                        "Horizon Dr near Badge St",
                        "Horizon Dr near Dewsbury St",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr near Congo St",
                        "Horizon Dr at Westlake South near Buffalo St",
                        "Sumners Rd at Riverhills East near Macfarlane St"
                    ],
                    "S704: St Peters Lutheran - Moggill": [
                        "Lambert Rd - 26",
                        "Lambert Rd near Martin Lane, stop 27/36",
                        "Lambert Rd at Central Ave, stop 35",
                        "Central Ave at Forest Lodge, stop 34",
                        "Central Ave at Holy Family, stop 33",
                        "Ward St near Central Ave",
                        "York St near Prince St, stop 29",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Kennewell Park, stop 29",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Fig Tree Pocket Road, stop 31",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd near Marshall Lane, stop 34",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd near Private Rd, stop 36",
                        "Moggill Rd at Kenmore Central, stop 35",
                        "Moggill Rd at Kenmore park 'n' ride",
                        "Moggill Rd at Rafting Ground Park",
                        "Moggill Rd near Pullenvale Rd",
                        "Moggill Rd at Diggers Rest",
                        "Moggill Rd at QCAT",
                        "Moggill Rd near Bainbridge Dr",
                        "Moggill Rd near Grandview Rd",
                        "Moggill Rd at Grandview Road",
                        "Moggill Rd near Scrubtree St",
                        "Moggill Rd at Mt Crosby Road",
                        "Moggill Rd near Pinjarra Rd",
                        "Moggill Rd at Sugars Road",
                        "Moggill Rd at Moggill Cemetery",
                        "Moggill Rd at Bellbowrie",
                        "Montanus Dr at Montanus East",
                        "Montanus Dr at Kangaroo Gully",
                        "Kangaroo Gully Rd at Bellbowrie Chase",
                        "Church Rd near Pine County Pl",
                        "Pioneer Cr at Pioneer West",
                        "Pioneer Cr at Pioneer East",
                        "Moggill Rd at Moggill"
                    ],
                    "S706: Indooroopilly - Kenmore High": [
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Market St near Moggill Rd, stop 28",
                        "Witton Rd near Market St, stop 28A",
                        "Witton Rd near Kate St, stop 29",
                        "Kate St near Boundary Rd, stop 30",
                        "Jerrang St near Jainba St, stop 31",
                        "Jerrang St at Market St, stop 32",
                        "Fig Tree Pocket Rd near Bredden St, stop 32A",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd near Marshall Lane, stop 34",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd near Private Rd, stop 36",
                        "Brookfield Rd at Kenmore Village, stop 36",
                        "Brookfield Rd near Private Rd, stop 36A",
                        "Mabb St at Kenmore High School, Zone A"
                    ],
                    "S709: Kenmore High - Indooroopilly": [
                        "Mabb St at Kenmore High School, Zone B",
                        "Moggill Rd at Kenmore Village",
                        "Moggill Rd at Kenmore Churches, stop 35",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Bob Lynne Street, stop 32a",
                        "Moggill Rd at Fig Tree Pocket Road, stop 31",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Kennewell Park, stop 29",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly interchange"
                    ],
                    "S710: Toowong Primary - Indooroopilly": [
                        "Quinn St near Ascog Tce",
                        "Ascog Tce at Norwood Street, stop 19",
                        "Woodstock Rd near Pioneer St, stop 20",
                        "Elizabeth St at Lodge St, stop 21",
                        "Elizabeth St at Ivy St, stop 22",
                        "Soudan St near Orchard St, stop 24",
                        "Orchard St near Bywong St, stop 25",
                        "Exmouth St near Camp St, stop 26",
                        "Camp St near Market St, stop 27",
                        "Market St near Duke St, stop 28",
                        "Orchard St at Lower Orchard St, stop 27/26",
                        "Orchard St at Upper Orchard St, stop 25",
                        "Soudan St near Bent St, stop 24",
                        "Ivy St near Mount St, stop 23",
                        "Dean St at Elizabeth St, stop 19/18",
                        "Dean St at Toowong Depot, stop 17",
                        "Birdwood Tce at Stuartholme, stop 31",
                        "Stuartholme Rd at Stuartholme College, stop 32",
                        "Indooroopilly interchange"
                    ],
                    "S713: Kenmore - Mandalay": [
                        "Mabb St at Kenmore High School, Zone A",
                        "Moggill Rd at Kenmore Central, stop 35",
                        "Kenmore Rd at OLR, stop 38/39",
                        "Gilruth Rd near Kenmore Rd, stop 40",
                        "Gilruth Rd near Acworth St, stop 39",
                        "Gilruth Rd near Cornhill St, stop 38",
                        "Gilruth Rd near Sophia St, stop 37",
                        "Marshall Lane near Gilruth Rd, stop 36",
                        "Marshall Lane near Kowhai St, stop 35",
                        "Marshall Lane near Wongabel St, stop 34",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Bob Lynne Street, stop 32a",
                        "Chapel Hill Rd near Neptune St, stop 1",
                        "Chapel Hill Rd near Ludlow St, stop 2",
                        "Chapel Hill Rd near Ludlow St, stop 3",
                        "Chapel Hill Rd near Fuelling St, stop 4",
                        "Chapel Hill Rd near Fleming Rd, stop 5",
                        "Burbong St at Burbong West",
                        "Burbong St near Merrilyn St, stop 7",
                        "Burbong St at Burbong East",
                        "Burbong St near Moggill Rd, stop 9c",
                        "Market St near Moggill Rd, stop 28",
                        "Witton Rd near Market St, stop 28A",
                        "Witton Rd near Kate St, stop 29",
                        "Kate St near Boundary Rd, stop 30",
                        "Jerrang St near Jainba St, stop 31",
                        "Jerrang St at Market St, stop 32",
                        "Fig Tree Pocket Rd near Fawkner St, stop 33",
                        "Fig Tree Pocket Rd near Winking St, stop 33A",
                        "Fig Tree Pocket Rd near Kenmore Rugby Club Stop 34",
                        "Fig Tree Pocket Rd near Aylesbury St, stop 35",
                        "Fig Tree Pocket Rd near Sprenger St, stop 36",
                        "Fig Tree Pocket Rd near Kenmore Rd, stop 37",
                        "Fig Tree Pocket Rd at Thiesfield Street, stop 38",
                        "Fig Tree Pocket Rd at Cubberla Street, stop 40",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41a",
                        "Fig Tree Pocket Rd near Botticelli St, stop 42A",
                        "Fig Tree Pocket Rd at Mandalay, stop 44"
                    ],
                    "S714: Taringa - Indooroopilly State School": [
                        "Stanley Tce at Harrys Road, stop 18",
                        "Stanley Tce at Mossman Street, stop 19",
                        "Stanley Tce at Moorak Street, stop 20",
                        "Stanley Tce at Bywong Street, stop 21",
                        "Stanley Tce at Camp Street, stop 22",
                        "Stanley Tce at Gower Street, stop 23",
                        "Hillsdon Rd near Stanley Tce, stop 24",
                        "Hillsdon Rd near Gregory St, stop 24a",
                        "Hillsdon Rd at Hillsdon Shops, stop 25",
                        "Waverley Rd near Hillsdon Rd, stop 26",
                        "Waverley Rd at Taringa Parade, stop 27",
                        "Waverley Rd near Taringa Pde, stop 29",
                        "Coverdale St near Waverley Rd, stop 30",
                        "Coverdale Terminus, stop 31",
                        "Manchester Tce near Waverley Rd, stop 24",
                        "Stanley St near Payne St, stop 26",
                        "Disraeli St near Stanley St, stop 27",
                        "Disraeli St at Gordon Terrace, stop 28",
                        "Taringa Pde at Indooroopilly State School",
                        "Station Rd at Indooroopilly Shopping Ctr, stop D",
                        "Central Ave at Holy Family, stop 33",
                        "Central Ave at Forest Lodge, stop 34",
                        "Central Ave near Lambert Rd, stop 35",
                        "Lambert Rd near Carnarvon Rd, stop 36/27",
                        "Carnarvon Rd near Lambert Rd",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Payne St near Woolley St, stop 25"
                    ],
                    "S715: Indooroopilly High - Indooroopilly": [
                        "Carnarvon Rd near Lambert Rd",
                        "Ward St near Central Ave",
                        "York St near Prince St, stop 29",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly interchange"
                    ],
                    "S716: Indooroopilly - Duke St": [
                        "Market St near Duke St, stop 28",
                        "Orchard St at Lower Orchard St, stop 27/26",
                        "Orchard St at Upper Orchard St, stop 25",
                        "Soudan St near Bent St, stop 24",
                        "Ivy St near Mount St, stop 23",
                        "Dean St at Woodstock Rd, stop 19/21",
                        "Woodstock Rd near Miskin St, stop 20",
                        "Ascog Tce at Norwood Street, stop 19",
                        "Ascog Tce at Quinn Street, stop 17",
                        "Ascog Tce near Jephson St, stop 16",
                        "Sherwood Rd at Jephson St, stop 22/15",
                        "Benson St at Toowong, stop 14",
                        "Brisbane St at Kayes Rocks, stop 15",
                        "Josling St near Herbert St, stop 16",
                        "Josling St at Mayne Street, stop 17",
                        "Josling St at Perrin Park, stop 18",
                        "Gailey Rd at Gailey Park, stop 18",
                        "Gailey Rd at Gailey North, stop 19",
                        "Indooroopilly Rd near McCaul St, stop 23",
                        "Lambert Rd near Indooroopilly Rd, stop 24",
                        "Lambert Rd near Bowaga St, stop 25",
                        "Lambert Rd - 26",
                        "Lambert Rd near Carnarvon Rd, stop 36/27",
                        "Lambert Rd near Nawarra St, stop 25",
                        "Indooroopilly Rd near Iona Tce, stop 23A",
                        "Gailey Rd at Gailey Fiveways, stop 20",
                        "Josling St near Mayne Street, stop 17",
                        "Sherwood Rd at Jephson St, stop 15/22",
                        "Woodstock Rd near Pioneer St, stop 20",
                        "Elizabeth St at Lodge St, stop 21",
                        "Elizabeth St at Ivy St, stop 22",
                        "Soudan St near Orchard St, stop 24",
                        "Orchard St near Bywong St, stop 25",
                        "Exmouth St near Camp St, stop 26",
                        "Camp St near Market St, stop 27"
                    ],
                    "S718: St Peters Lutheran - Russell & Moggill Rds": [
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Burbong St near Moggill Rd",
                        "Burbong St at Burbong East",
                        "Burbong St near Merrilyn St, stop 7",
                        "Burbong St at Burbong West",
                        "Burbong St near Talasea St",
                        "Fleming Rd at Chapel Crest",
                        "Fleming Rd at Chapel Woods",
                        "Tillbrook St near Chatburn St",
                        "Greenford St at Merri Merri Park",
                        "Tillbrook St near Halmore Pl",
                        "Marmindie St near Fleming Rd",
                        "Marmindie St near Chapel Hill Rd",
                        "Russell Tce near Jenkinson St",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Central Ave at Holy Family, stop 33",
                        "Central Ave at Forest Lodge, stop 34",
                        "Central Ave near Lambert Rd, stop 35",
                        "Lambert Rd near Carnarvon Rd, stop 36/27",
                        "Carnarvon Rd near Lambert Rd",
                        "Lambert Rd - 26",
                        "Lambert Rd near Martin Lane, stop 27/36",
                        "Lambert Rd at Central Ave, stop 35",
                        "Ward St near Central Ave",
                        "York St near Prince St, stop 29",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25"
                    ],
                    "S722: St Peters Lutheran - Mandalay": [
                        "Fig Tree Pocket Rd near Botticelli St, stop 42A",
                        "Fig Tree Pocket Rd at Mandalay, stop 44",
                        "Kenny St near Ormsby St, stop 45a",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41a",
                        "Fig Tree Pocket Rd near Mactier St, stop 41",
                        "Fig Tree Pocket Rd at Cubberla Street, stop 40",
                        "Fig Tree Pocket Rd at Thiesfield Street, stop 38",
                        "Kenmore Rd at Norman Street",
                        "Kenmore Rd at Sunset Road, stop 45",
                        "Kenmore Rd at Kenmore South, stop 44",
                        "Kenmore Rd near Piari St, stop 43",
                        "Gem Rd at Wyndarra near Rialanna St",
                        "Gem Rd near Wyndarra St",
                        "Gem Rd at Annabel Street",
                        "Sunset Rd at Sunset West",
                        "Sunset Rd near West Ct",
                        "Sunset Rd near Moonlight St, stop 46",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Gilruth Rd near Kenmore Rd, stop 40",
                        "Gilruth Rd near Acworth St, stop 39",
                        "Gilruth Rd near Cornhill St, stop 38",
                        "Gilruth Rd near Sophia St, stop 37",
                        "Marshall Lane near Gilruth Rd, stop 36",
                        "Marshall Lane near Kowhai St, stop 35",
                        "Marshall Lane near Wongabel St, stop 34",
                        "Moggill Rd at Marshall Lane, stop 32",
                        "Moggill Rd at Bob Lynne Street, stop 32a",
                        "Fig Tree Pocket Rd near Henry St, stop 32A",
                        "Jerrang St near Market St, stop 32",
                        "Jerrang St near Jainba St, stop 31",
                        "Kate St near Boundary Rd, stop 30",
                        "Witton Rd near Kate St, stop 29",
                        "Witton Rd near Rennies Rd, stop 28A",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Lambert Rd near Central Ave, stop 35",
                        "Lambert Rd near Carnarvon Rd, stop 36/27",
                        "Carnarvon Rd near Lambert Rd",
                        "Central Ave at Holy Family, stop 33",
                        "Lambert Rd - 26",
                        "Ward St near Central Ave",
                        "York St near Prince St, stop 29",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Market St near Moggill Rd, stop 28",
                        "Witton Rd near Market St, stop 28A",
                        "Jerrang St at Market St, stop 32",
                        "Fig Tree Pocket Rd near Bredden St, stop 32A",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Gilruth Rd near Marshall Lane, stop 36",
                        "Kenmore Road near Norman St",
                        "Fig Tree Pocket Rd near Kenmore Rd, stop 37",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41"
                    ],
                    "S725: Kenmore High - Indooroopilly": [
                        "Indooroopilly Shopping Centre station, stop A",
                        "Burbong St at Burbong West",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Burbong St near Talasea St",
                        "Burbong St near Moggill Rd",
                        "Fleming Rd at Chapel Crest",
                        "Fleming Rd at Chapel Woods",
                        "Burbong St at Burbong East",
                        "Burbong St near Merrilyn St, stop 7",
                        "Tillbrook St near Chatburn St",
                        "Greenford St at Merri Merri Park",
                        "Bielby Rd at Bielby Rise",
                        "Mukurta St near Binyara St",
                        "Dillingen St near Ironbark Rd",
                        "Ironbark Rd near Birchley St",
                        "Goolman St at Chapel Hill School",
                        "Goolman St near Juberra St",
                        "Bielby Rd near Goolman St",
                        "Bielby Rd at Kenmore Woods",
                        "Moggill Rd near Marshall Lane, stop 34",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd near Private Rd, stop 36",
                        "Brookfield Rd at Kenmore Village, stop 36",
                        "Brookfield Rd near Private Rd, stop 36A",
                        "Mabb St at Kenmore High School, Zone C",
                        "Moggill Rd at Kenmore Village",
                        "Moggill Rd at Kenmore Churches, stop 35",
                        "Goolman St at Bielby Road",
                        "Goolman St near Keil Pl",
                        "Dillingen St near Diamantina St",
                        "Tillbrook St near Halmore Pl",
                        "Burbong St near Moggill Rd, stop 9c",
                        "Moggill Rd at Indooroopilly School, stop 16",
                        "Indooroopilly interchange"
                    ],
                    "S726: St Lucia - Qld Academy of Maths,Science and Tech": [
                        "UQ Chancellor's Place, zone C",
                        "Carmody Rd near Boomerang Rd, stop 24",
                        "Carmody Rd at Munro Street, stop 22",
                        "Carmody Rd near Baty St, stop 21",
                        "Swann Rd at Hutton Lane, stop 21",
                        "Swann Rd at Bonvale Lane, stop 21",
                        "Gailey Rd at Gailey Fiveways, stop 20",
                        "Gailey Rd at Gailey North, stop 19",
                        "Gailey Rd at Gailey Park, stop 18",
                        "Indooroopilly Rd at Jack Cook Park, stop 18/19",
                        "Westerham St near Indooroopilly Rd, stop 22",
                        "Westerham St at Sundridge Street, stop 23",
                        "Oxford Tce near Lucinda St, stop 22/16",
                        "Ada St district stop hail 'n' ride",
                        "Whitmore St district stop hail 'n' ride",
                        "Moggill Rd at BBC, stop 16",
                        "Sherwood Rd at Kensington Terrace, stop 21",
                        "Sherwood Rd at Toowong West, stop 22",
                        "Elizabeth St at Lodge St, stop 21",
                        "Elizabeth St at Ivy St, stop 22",
                        "Soudan St near Orchard St, stop 24",
                        "Orchard St near Bywong St, stop 25",
                        "QLD Academy of Science Maths Tech",
                        "Orchard St at Upper Orchard St, stop 25",
                        "Soudan St near Bent St, stop 24",
                        "Ivy St near Mount St, stop 23",
                        "Dean St at Woodstock Rd, stop 19/21",
                        "Sherwood Rd at Toowong West, stop 20",
                        "Dean St at Dovercourt Rd, stop 20a",
                        "Jephson St at Toowong",
                        "Oxford Tce near Lucinda St, stop 16/22",
                        "Swann Rd at Hutton Lane, stop 22",
                        "Carmody Rd near Raven St, stop 21",
                        "UQ Chancellor's Place, zone E"
                    ],
                    "S730: Kenmore High - Fig Tree Pocket": [
                        "Mabb St at Kenmore High School, Zone C",
                        "Moggill Rd at Kenmore Central, stop 35",
                        "Kenmore Rd at OLR, stop 38/39",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Kenmore Rd near Gem Rd, stop 43",
                        "Kenmore Rd at Kenmore South, stop 44",
                        "Kenmore Rd at Sunset Road",
                        "Kenmore Rd at Norman Street",
                        "Kenmore Road near Norman St",
                        "Fig Tree Pocket Rd near Kenmore Rd, stop 37",
                        "Fig Tree Pocket Rd at Thiesfield Street, stop 38",
                        "Fig Tree Pocket Rd at Cubberla Street, stop 40",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41",
                        "Fig Tree Pocket Rd near Serene Pl, stop 41a",
                        "Fig Tree Pocket Rd near Botticelli St, stop 42A",
                        "Fig Tree Pocket Rd at Mandalay, stop 44"
                    ],
                    "S731: Centenary Pool - Indooroopilly": [
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "College Rd near Countess St, stop 3b",
                        "Roma St at Upper Roma Street, stop 3",
                        "Milton Rd at Suncorp, stop 3/4",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Milton Rd at Milton, stop 7",
                        "Milton Rd at Milton - Torwood, stop 8",
                        "Milton Rd at Hobbs Street, stop 9",
                        "Milton Rd at Auchenflower Shops, stop 10",
                        "Milton Rd at Park Avenue, stop 11",
                        "Milton Rd at Markwell Street, stop 12",
                        "Jephson St at Toowong",
                        "Moggill Rd at BBC, stop 16",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly interchange"
                    ],
                    "S732: Gregory Tce - Indooroopilly": [
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "College Rd near Countess St, stop 3b",
                        "Roma St at Upper Roma Street, stop 3",
                        "Milton Rd at Suncorp, stop 3/4",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Milton Rd at Milton, stop 7",
                        "Milton Rd at Milton - Torwood, stop 8",
                        "Milton Rd at Hobbs Street, stop 9",
                        "Milton Rd at Auchenflower Shops, stop 10",
                        "Milton Rd at Park Avenue, stop 11",
                        "Milton Rd at Markwell Street, stop 12",
                        "Jephson St at Toowong",
                        "Moggill Rd at BBC, stop 16",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly interchange"
                    ],
                    "S733: Gregory Tce - Brookfield": [
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "College Rd near Countess St, stop 3b",
                        "Countess St at Normanby Fiveways",
                        "Roma Street Stop 124 at Roma Street station",
                        "Ann Street Stop 12 at City Hall",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Regatta",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at BBC, stop 16",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Kennewell Park, stop 29",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Fig Tree Pocket Road, stop 31",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd near Marshall Lane, stop 34",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd near Private Rd, stop 36",
                        "Brookfield Rd at Kenmore Village, stop 36",
                        "Brookfield Rd near Private Rd, stop 36A",
                        "Brookfield Rd at Kenmore West, stop 37",
                        "Brookfield Rd at Iona, stop 38",
                        "Brookfield Rd at Friary, stop 39",
                        "Brookfield Rd at Gap Creek Road, stop 40",
                        "Greentrees Ave near Brookfield Rd, stop 41",
                        "Greentrees Ave at Greentrees East, stop 42",
                        "Greentrees Ave at Greentrees West, stop 42a",
                        "Brookfield Rd at Jacaranda Avenue, stop 43",
                        "Brookfield Rd at Boscombe Road, stop 45",
                        "Brookfield Rd at Brookfield, stop 46",
                        "Brookfield Rd at Brookfield - Upper Brookfield",
                        "Rafting Ground Rd at Rafting Ground West",
                        "Rafting Ground Rd at Rees Way",
                        "Winrock St near Rafting Ground Rd",
                        "Kailua St near Tangy St"
                    ],
                    "S734: Centenary Pool - Fig Tree Pocket": [
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "College Rd near Countess St, stop 3b",
                        "Countess St at Normanby Fiveways",
                        "Roma Street Stop 124 at Roma Street station",
                        "Ann Street Stop 12 at City Hall",
                        "Coronation Dr at Cribb Street, stop 4",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Regatta",
                        "High St at Toowong, stop 14A",
                        "Moggill Rd at BBC, stop 16",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Kennewell Park, stop 29",
                        "Moggill Rd at Alkira, stop 30",
                        "Moggill Rd at Fig Tree Pocket Road, stop 31",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Marshall Lane near Wongabel St, stop 34",
                        "Marshall Lane near Kowhai St, stop 35",
                        "Gilruth Rd near Marshall Lane, stop 36",
                        "Gilruth Rd near Sophia St, stop 37",
                        "Gilruth Rd near Cornhill St, stop 38",
                        "Gilruth Rd near Acworth St, stop 39",
                        "Gilruth Rd near Kenmore Rd, stop 40",
                        "Kenmore Rd at Kenmore, stop 41",
                        "Kenmore Rd at Rannoch Street, stop 42",
                        "Gem Rd at Wyndarra near Rialanna St",
                        "Gem Rd near Wyndarra St",
                        "Gem Rd at Annabel Street",
                        "Sunset Rd at Sunset West",
                        "Sunset Rd near West Ct",
                        "Sunset Rd near Moonlight St, stop 46",
                        "Kenmore Rd at Norman Street",
                        "Kenmore Road near Norman St",
                        "Fig Tree Pocket Rd near Kenmore Rd, stop 37",
                        "Fig Tree Pocket Rd near Sprenger St, stop 36",
                        "Fig Tree Pocket Rd near Aylesbury St, stop 35",
                        "Fig Tree Pocket Rd at Kenmore Rugby Club - Stop 34"
                    ],
                    "S735: Wickham Tce - Indooroopilly": [
                        "Wickham Tce near Dark St, stop 3a",
                        "Indooroopilly interchange"
                    ],
                    "S736: Wickham Tce - Kailua St": [
                        "Wickham Tce near Dark St, stop 3a",
                        "College Rd near Countess St, stop 3b",
                        "Milton Rd at Milton Rail station, stop 5/6",
                        "Milton Rd at Milton, stop 7",
                        "Milton Rd at Milton - Torwood, stop 8",
                        "Milton Rd at Hobbs Street, stop 9",
                        "Milton Rd at Auchenflower Shops, stop 10",
                        "Milton Rd at Park Avenue, stop 11",
                        "Milton Rd at Markwell Street, stop 12",
                        "Jephson St at Toowong",
                        "Moggill Rd at BBC, stop 16",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Market St near Moggill Rd, stop 28",
                        "Witton Rd near Market St, stop 28A",
                        "Witton Rd near Kate St, stop 29",
                        "Kate St near Boundary Rd, stop 30",
                        "Jerrang St near Jainba St, stop 31",
                        "Jerrang St at Market St, stop 32",
                        "Fig Tree Pocket Rd near Bredden St, stop 32A",
                        "Moggill Rd at Bredden Street, stop 32",
                        "Moggill Rd at Marshall Lane, stop 33",
                        "Moggill Rd near Marshall Lane, stop 34",
                        "Moggill Rd at Kenmore Churches, stop 34",
                        "Moggill Rd near Private Rd, stop 36",
                        "Brookfield Rd at Kenmore Village, stop 36",
                        "Brookfield Rd near Private Rd, stop 36A",
                        "Brookfield Rd at Kenmore West, stop 37",
                        "Brookfield Rd at Iona, stop 38",
                        "Brookfield Rd at Friary, stop 39",
                        "Brookfield Rd at Gap Creek Road, stop 40",
                        "Greentrees Ave near Brookfield Rd, stop 41",
                        "Greentrees Ave at Greentrees East, stop 42",
                        "Greentrees Ave at Greentrees West, stop 42a",
                        "Brookfield Rd at Jacaranda Avenue, stop 43",
                        "Brookfield Rd at Boscombe Road, stop 45",
                        "Brookfield Rd at Brookfield, stop 46",
                        "Brookfield Rd at Brookfield - Upper Brookfield",
                        "Rafting Ground Rd at Rafting Ground West",
                        "Rafting Ground Rd at Rees Way",
                        "Winrock St near Rafting Ground Rd",
                        "Kailua St near Tangy St"
                    ],
                    "S739: Gregory Tce - Royal Pde": [
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "College Rd near Countess St, stop 3b",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Musgrave Rd at St Brigid's - Red Hill, stop 5",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Waterworks Rd at Mannion Street, stop 9",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Waterworks Rd at Whitta Street, stop 12",
                        "Waterworks Rd at Mossvale Street, stop 13",
                        "Waterworks Rd at Boon Street, stop 14",
                        "Waterworks Rd at St Finbarr's - Ashgrove, stop 16",
                        "Waterworks Rd at Ashgrove, stop 17",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Waterworks Rd at Girraween Grove, stop 21/22",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Royal Pde near Gresham St, stop 26"
                    ],
                    "S740: Waterworks Rd - Centenary Pool": [
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Kaloma Rd at Kaloma - Harward, stop 38",
                        "Kaloma Rd at Woorama Rd, stop 39",
                        "Kaloma Rd at Hilder Road School, stop 40",
                        "Hilder Rd at Kaloma - Hilder, stop 41",
                        "Hilder Rd at Wittonga Park, stop 42",
                        "Petmar St at Petmar Street North, stop 43",
                        "Petmar St at Petmar Street South, stop 44",
                        "Waterworks Rd at Petmar St, stop 45",
                        "Waterworks Rd at Hilder Rd, stop 46",
                        "School Rd at Bogunda St, stop 45",
                        "School Rd at Woongarra St, stop 44",
                        "Payne Rd at Glen Rd, stop 44a",
                        "Payne Rd at Kays Rd, stop 44b",
                        "Payne Rd at Dillon Rd, stop 44c",
                        "Payne Rd at Glen Rd, stop 44d",
                        "Payne Rd at Payne - DAguilar, stop 43",
                        "Payne Rd at Gymea St, stop 42",
                        "Payne Rd at Whitehead Rd, stop 41",
                        "Whitehead Rd near Fairearth St, stop 40",
                        "Pindari St near Palana St, stop 39",
                        "Devonhill St near Paraka St, stop 38",
                        "Devonhill St at Koorong St, stop 37",
                        "Bombala St at Glenbrae Street, stop 36",
                        "Grenoble St at Woodside St, stop 35",
                        "Grenoble St at Paten Rd, stop 34",
                        "Paten Rd at Paten Park, stop 33a",
                        "Payne Rd at Paten Rd, stop 33",
                        "Payne Rd at Glenmore St, stop 32",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Kilmaine Street, stop 29",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Glory St at West Ashgrove, stop 24",
                        "Waterworks Rd at Myagh Road, stop 23/22",
                        "Waterworks Rd at Girraween Grove, stop 21",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Waterworks Rd at Ashgrove, stop 17",
                        "Waterworks Rd at St Finbarr's - Ashgrove, stop 16",
                        "Waterworks Rd at Woodland Street, stop 15",
                        "Waterworks Rd at Boon Street, stop 14",
                        "Waterworks Rd at Mossvale Street, stop 13",
                        "Waterworks Rd at Whitta Street, stop 12",
                        "Waterworks Rd at Glenrosa Road, stop 11",
                        "Waterworks Rd at Cairns Street, stop 10",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Musgrave Rd at Normanby Hotel, stop 4",
                        "College Rd near Kelvin Grove Rd, stop 3b",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "College Rd near Countess St, stop 3b",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Musgrave Rd at St Brigid's - Red Hill, stop 5",
                        "Waterworks Rd at Mannion Street, stop 9",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Waterworks Rd at Girraween Grove, stop 21/22",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Payne Rd at Payne - Glenmore, stop 32",
                        "Grenoble St at Grenoble - Woodside, stop 35",
                        "Glenbrae St near Bombala St, stop 36",
                        "Koorong St at Devonhill St, stop 37",
                        "Payne Rd at Payne - Gymea, stop 42",
                        "Waterworks Rd at Hilder Road, stop 46",
                        "Kaloma Rd at Hilder Rd, stop 41",
                        "Kaloma Rd at Harward St, stop 38",
                        "Waterworks Rd at Settlement Road, stop 36"
                    ],
                    "S742: The Gap State High - Brookside": [
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Settlement Rd near Kaloma Rd",
                        "Settlement Rd near Tingward St",
                        "Great Western Shopping Centre",
                        "Mungarie St near Keryn Pl",
                        "Mungarie St at Cobalt St",
                        "Cobalt St at Balvenie St",
                        "Cobalt St at Kindilan Place",
                        "Cobalt St at Onyx St",
                        "Samford Rd at Cobalt St",
                        "Camoola St at Bowyer St, stop 36a",
                        "Camoola St near Avington St, stop 37",
                        "Eidsvold St near Camoola St, stop 36",
                        "Eidsvold St at Welford St, stop 35",
                        "Eidsvold St at Calen St, stop 34",
                        "Glenmorgan St near Keperra St, stop 33",
                        "Keperra St at Samford Rd",
                        "Samford Rd at Blackbutt St",
                        "Blackbutt St near Alpine St, stop 31",
                        "Blackbutt St at Keperra station, stop 30",
                        "Gilston St at Gilston Center, stop 29",
                        "Gilston St at Gilston I, stop 27A",
                        "Gilston St near Samford Rd, stop 27",
                        "Samford Rd at Samford - Dawson, stop 26",
                        "Samford Rd at Melrick St, stop 25",
                        "Samford Rd at Crestway Street, stop 24",
                        "Samford Rd at Fenwick Park, stop 23/22",
                        "Blackwood St at Mitchelton, stop 34",
                        "Ruby Rd near McConahgy St, stop 35",
                        "Brookside Shopping Centre station, platform B"
                    ],
                    "S744: QASMT - Roma Street": [
                        "Roma Street busway, platform 2",
                        "King George Square, 2b",
                        "Cultural Centre station, platform 3",
                        "Coronation Dr at Auchenflower, stop 7",
                        "Coronation Dr at Wesley Hospital, stop 9",
                        "Coronation Dr at Regatta",
                        "Sherwood Rd at Jephson St, stop 15/22",
                        "Sherwood Rd at Kensington Terrace, stop 21",
                        "Sherwood Rd at Toowong West, stop 22",
                        "Elizabeth St at Lodge St, stop 21",
                        "Elizabeth St at Ivy St, stop 22",
                        "Soudan St near Orchard St, stop 24",
                        "Orchard St near Bywong St, stop 25",
                        "QLD Academy of Science Maths Tech",
                        "Orchard St at Upper Orchard St, stop 25",
                        "Soudan St near Bent St, stop 24",
                        "Ivy St near Mount St, stop 23",
                        "Dean St at Woodstock Rd, stop 19/21",
                        "Sherwood Rd at Toowong West, stop 20",
                        "Dean St at Dovercourt Rd, stop 20a",
                        "Sherwood Rd at Jephson St, stop 22/15",
                        "Coronation Dr at Regatta, stop 12",
                        "Coronation Dr at Chasely Street, stop 8",
                        "Coronation Dr at Park Road, stop 6",
                        "Coronation Dr at Cribb Street, stop 5/4",
                        "Cultural Centre station, platform 1",
                        "King George Square, 1b",
                        "Roma Street busway station"
                    ],
                    "S746: Kelvin Grove - City": [
                        "Kelvin Grove Rd at School Street, stop 13",
                        "Kelvin Grove Rd near McCaskie Park, stop 12",
                        "Normanby station, platform 1",
                        "Roma Street busway, platform 2",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 22 near City Hall"
                    ],
                    "S747: Kelvin Grove - Brookside": [
                        "Kelvin Grove Rd at Victoria Street, stop 12",
                        "Kelvin Grove Rd near Prospect Tce, stop 13",
                        "Kelvin Grove Rd at Moy Street, stop 14",
                        "Kelvin Grove Rd at Guildford Street, stop 15",
                        "Kelvin Grove Rd at Windsor Road, stop 16",
                        "Enoggera Rd at Thurlow Street, stop 17",
                        "Enoggera Rd at St Ambroses, stop 18",
                        "Enoggera Rd at Newmarket, stop 20",
                        "Enoggera Rd at Ashgrove Avenue, stop 20a",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Enoggera Rd at Banks Street, stop 22",
                        "Enoggera Rd at Sedgley Park, stop 23",
                        "Enoggera Rd at Beaufort Street, stop 24",
                        "Enoggera Rd at Lloyd Street, stop 25",
                        "Samford Rd at Alderley Junction, stop 26",
                        "Samford Rd at Musgrave Terrace, stop 27",
                        "Samford Rd at Camborne Street, stop 28",
                        "Samford Rd at Bond Street, stop 29",
                        "Samford Rd at Wardell Street, stop 30",
                        "Samford Rd at Norman Terrace, stop 31",
                        "Samford Rd at Gaythorne station, stop 32",
                        "Samford Rd at Gaythorne RSL, stop 33",
                        "Blackwood St at Mitchelton, stop 34",
                        "Ruby Rd near McConahgy St, stop 35",
                        "Brookside Shopping Centre"
                    ],
                    "S750: Gap Village - Hilder Rd": [
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Kaloma Rd at Kaloma - Harward, stop 38",
                        "Kaloma Rd at Woorama Rd, stop 39",
                        "Kaloma Rd at Hilder Road School, stop 40",
                        "Hilder Rd at Kaloma - Hilder, stop 41",
                        "Hilder Rd at Wittonga Park, stop 42",
                        "Petmar St at Petmar Street North, stop 43",
                        "Petmar St at Petmar Street South, stop 44",
                        "Waterworks Rd at Petmar St, stop 45",
                        "Waterworks Rd at Hilder Rd, stop 46"
                    ],
                    "S758: Corinda High - Inala": [
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Rd at Oxley School, stop 65",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Freeman Rd near Hampton St",
                        "Balsa St at Begonia St, stop 71",
                        "Balsa St at Apricot St, stop 70",
                        "Balsa St at Ebony St, stop 68",
                        "Balsa St at Biota St, stop 67",
                        "Azalea St at Balsa St, stop 66",
                        "Azalea St at Barberry St, stop 65",
                        "Azalea St at Eugenia St, stop 64",
                        "Azalea St at Tecoma St, stop 63",
                        "Poinciana St at Poinciana - Azalea, stop 62",
                        "Poinciana St at Punica St, stop 61",
                        "Poinciana St at Laburnum St, stop 60",
                        "Hydrangea St near Frangipani St, stop 59",
                        "Poinsettia St at Gannett Street, stop 78/79",
                        "Brolga St near Jabiru St, stop 73",
                        "Clipper St near Pelican St, stop 72",
                        "Andromeda St near Capricorn St, stop 71",
                        "Polaris St near Monoceros St, stop 70",
                        "Monoceros St near Ursa St, stop 69",
                        "Monoceros St near Archerfield Rd, stop 68",
                        "Archerfield Rd near Argo St, stop 64",
                        "Centaurus St near Crater St, stop 66",
                        "Centaurus St near Apus St, stop 65",
                        "Bootes St District Stop f/side Aldebaran St",
                        "Virgo St near Bellatrix St, stop 63",
                        "Delphinus St near Eridanus St, stop 62",
                        "Eridanus St near Draco St, stop 61",
                        "Eridanus St near Mira St, stop 60"
                    ],
                    "S759: Glenala State High - Inala Plaza": [
                        "Glenala Rd at Glenala High",
                        "Glenala Rd at Glenala East, stop 71",
                        "Akama Rd at Akama Central Stop 73",
                        "Akama Rd at Akama South Stop 74",
                        "Durella St at Durella East, stop 75",
                        "Durella St at Durella West, stop 76",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Inala station, platform B"
                    ],
                    "S760: Ashgrove - Brookside": [
                        "Amarina Ave at Mount Saint Michaels School",
                        "Stewart Rd near Celia St, stop 43",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "Wardell St at Dorrington near Stark St",
                        "Wardell St near Banks St, stop 32",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St near Edith St, stop 30a",
                        "Wardell St at Lloyd - Wardell, stop 30A",
                        "Enoggera interchange, platform C",
                        "Wardell St at Enoggera near Samford Rd",
                        "South Pine Rd at Marcellin Stop 34",
                        "South Pine Rd at Southpine-Elkhorn Stop 35",
                        "South Pine Rd at South Pine North, stop 36",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at White Street, stop 38",
                        "South Pine Rd at Nitawill Street, stop 3",
                        "South Pine Rd at Pullen Road, stop 40",
                        "Old Northern Rd at Everton Junction",
                        "Deakin St near Barton St",
                        "Barton St at South Pine Bend, stop 42",
                        "South Pine Rd at South Pine Bend, stop 43",
                        "South Pine Rd near Lily St, stop 44",
                        "South Pine Rd at Queens Rd, stop 45",
                        "South Pine Rd at Buckland Rd Stop 46",
                        "Camelia Ave at Camelia - Mirbelia, stop 47",
                        "Camelia Ave at Camelia - Nymphaea, stop 48",
                        "Camelia Ave at Violet St, stop 49",
                        "Camelia Ave at Galeola Street, stop 50",
                        "Pullen Rd at Hornby Street, stop 51A",
                        "Osborne Rd at Osborne North, stop 51",
                        "Osborne Rd near Northmore St, stop 52",
                        "Brookside Shopping Centre"
                    ],
                    "S762: Corinda High, Corinda Primary, Forest Lake": [
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Rd at Oxley School, stop 65",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Freeman Rd near Hampton St",
                        "Freeman Rd near Yulan St",
                        "Freeman Rd near Deodar St",
                        "Freeman Rd near Eugenia St",
                        "Freeman Rd near C J Greenfield Park",
                        "Freeman Rd near Firth St",
                        "Archerfield Rd near Freeman Rd, stop 71",
                        "Archerfield Rd near Littleton Rd",
                        "Archerfield Rd at McEwan Park",
                        "Pine Rd near Orchard Rd",
                        "Pine Rd at Lions",
                        "Garden Rd at Progress Corner",
                        "Garden Rd at Government Road",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Lochwood Ave at Broadwater Way",
                        "Lochwood Ave at Jindabyne Cct",
                        "Woogaroo St near Waterford Rd"
                    ],
                    "S766: St Josephs - Inala": [
                        "Blunder Rd near Rosella St, stop 60A",
                        "Blunder Rd at Flamingo Street Stop 60b",
                        "Wallaroo Way near Brushtail Cr, stop 61",
                        "Blunder Rd at Doolandella North, stop 61a",
                        "Lorikeet St at Lorikeet East, stop 62",
                        "Lorikeet St at Wedgetail St, stop 63a",
                        "Lorikeet St at Kiwi Street, stop 64",
                        "Rosella St near Heron St, stop 65",
                        "Grebe St near Bellbird St, stop 66",
                        "Skylark St at Skylark Shops, stop 67",
                        "Skylark St at Skylark South, stop 68",
                        "Sittella St at Sittella East, stop 69",
                        "Sittella St at Sittella West, stop 70",
                        "Shelduck St near Swallow St, stop 71",
                        "Partridge St at Partridge North, stop 72",
                        "Inala station, platform D",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Hyacinth St, stop 77",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Durella St at Durella West, stop 76",
                        "Durella St at Durella East, stop 75",
                        "Akama Rd at Akama South Stop 74",
                        "Akama Rd at Akama Central Stop 73",
                        "Glenala Rd at Glenala High",
                        "Glenala Rd at Glenala East, stop 71",
                        "Blunder Rd at Glenala Rd, stop 71a",
                        "Blunder Rd at Forest Place South, stop 70",
                        "Blunder Rd at Forest Place North, stop 69",
                        "Blunder Rd at Freeman Rd, stop 68",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Oxley Rd at Oxley School, stop 65",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Station Rd at Englefield East, stop 64a",
                        "Oxley Station Rd at Davies Street, stop 63a",
                        "Oxley station, stop A",
                        "Cook St near Oxley Rd, stop 62a",
                        "Oxley Rd at Nixon Park, stop 62",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Lynne Grove, stop 60",
                        "Oxley Rd near Hassall St",
                        "Clewley St near Oxley Rd, stop 59",
                        "Clara St at Clewley St, stop 60",
                        "Clara St at Clara - Nelson, stop 61",
                        "Clara St at Clara - Grey, stop 62",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Cook St at Nixon Park, stop 62",
                        "Cook St near Lincoln St, stop 62a",
                        "Englefield Rd at Idriess Street",
                        "Englefield Rd at Lucock Street",
                        "Englefield Rd at Englefield West",
                        "Avalon St near Englefield Rd",
                        "Avalon St near Valance St",
                        "Douglas St at Douglas St South",
                        "Rudd St at Police Academy",
                        "Hampton St near Highfield St hail 'n' ride",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Shelduck St near Swallow St",
                        "Sittella St near Petrel St",
                        "Sittella St near Plover St",
                        "Skylark St near Finch St",
                        "Skylark St near Bittern St",
                        "Grebe St near Bellbird St",
                        "Lorikeet St near Spoonbill St, stop 62",
                        "Blunder Rd at Lorikeet St",
                        "Blunder Road near Rosella St"
                    ],
                    "S767: The Gap High School - Upper Kedron": [
                        "Canvey Rd near Brockman",
                        "Canvey Rd near Kingfisher Dr",
                        "Canvey Rd near Wagtail St",
                        "Canvey Rd near Incline St",
                        "Charolais Cr at Wyellan Pl",
                        "Charolais Cr near Kirralee Cr",
                        "Cemetery Rd at Cemetery - Upper Kedron",
                        "McAlroy Rd at McAlroy - Upper Kedron",
                        "McGregor Way at Glencoe Cl",
                        "McGregor Way near McAlroy Rd",
                        "McGinn Rd at McAlroy Rd",
                        "McGinn Rd at Archdale Rd",
                        "McGinn Rd at Ferny Grove High School",
                        "Samford Rd near Tramway St",
                        "Samford Rd near Warrong St",
                        "Samford Rd near Cobalt St",
                        "Cobalt St at Onyx St",
                        "Cobalt St at Kindilan Place",
                        "Cobalt St at Balvenie St",
                        "Cobalt St at Mungarie St",
                        "Mungarie St near Keryn Pl",
                        "Settlement Rd near Tingward St",
                        "Settlement Rd at Kaloma Rd",
                        "Kaloma Rd at Kaloma - Harward, stop 38",
                        "Kaloma Rd at Woorama Rd, stop 39",
                        "Kaloma Rd at Hilder Road School, stop 40",
                        "Hilder Rd at Kaloma - Hilder, stop 41",
                        "Hilder Rd at Wittonga Park, stop 42",
                        "Petmar St at Petmar Street North, stop 43",
                        "Petmar St at Petmar Street South, stop 44",
                        "Waterworks Rd at Petmar St, stop 45",
                        "Waterworks Rd at Hilder Rd, stop 46",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at Hilder Road, stop 46",
                        "Kaloma Rd at Hilder Rd, stop 41",
                        "Kaloma Rd at Harward St, stop 38",
                        "Settlement Rd near Kaloma Rd",
                        "Mungarie St at Cobalt St",
                        "Samford Rd at Cobalt St",
                        "Samford Rd near Claverton St",
                        "Tramway St near Arbor St",
                        "Ferny Grove station, stop D",
                        "Archdale Rd near Ballylin St",
                        "McGinn Rd near Hogarth Rd",
                        "McAlroy Rd near McGinn Rd"
                    ],
                    "S768: Corinda High - Inala": [
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Rd at Oxley School, stop 65",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Freeman Rd near Hampton St",
                        "Freeman Rd near Yulan St",
                        "Balsa St at Begonia St, stop 71",
                        "Balsa St at Apricot St, stop 70",
                        "Balsa St at Ebony St, stop 68",
                        "Balsa St at Biota St, stop 67",
                        "Azalea St at Balsa St, stop 66",
                        "Azalea St at Barberry St, stop 65",
                        "Azalea St at Eugenia St, stop 64",
                        "Azalea St at Tecoma St, stop 63",
                        "Poinciana St at Poinciana - Azalea, stop 62",
                        "Poinciana St at Punica St, stop 61",
                        "Poinciana St at Laburnum St, stop 60",
                        "Lilac St at Saint Marks Primary School",
                        "Poinsettia St at Gannett Street, stop 78/79",
                        "Partridge St at Partridge North, stop 72",
                        "Shelduck St near Swallow St",
                        "Sittella St near Petrel St",
                        "Sittella St near Plover St",
                        "Skylark St near Finch St",
                        "Skylark St near Bittern St",
                        "Grebe St near Bellbird St",
                        "Lorikeet St near Spoonbill St, stop 62"
                    ],
                    "S769: Corinda High - Inala": [
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Rd at Oxley School, stop 65",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Freeman Rd near Hampton St",
                        "Hampton St near Highfield St hail 'n' ride",
                        "Glenala Rd at Glenala High",
                        "Glenala Rd at Glenala East, stop 71",
                        "Akama Rd at Akama Central Stop 73",
                        "Akama Rd at Akama South Stop 74",
                        "Durella St at Durella East, stop 75",
                        "Durella St at Durella West, stop 76",
                        "Lilac St at Saint Marks Primary School",
                        "Poinsettia St at Gannett Street, stop 78/79",
                        "Brolga St near Jabiru St, stop 73",
                        "Clipper St near Pelican St, stop 72",
                        "Andromeda St near Capricorn St, stop 71",
                        "Polaris St near Monoceros St, stop 70",
                        "Monoceros St near Ursa St, stop 69",
                        "Monoceros St near Archerfield Rd, stop 68",
                        "Archerfield Rd near Argo St, stop 64",
                        "Centaurus St near Crater St, stop 66",
                        "Centaurus St near Apus St, stop 65",
                        "Bootes St District Stop f/side Aldebaran St",
                        "Virgo St near Bellatrix St, stop 63",
                        "Delphinus St near Eridanus St, stop 62",
                        "Eridanus St near Draco St, stop 61",
                        "Eridanus St near Mira St, stop 60"
                    ],
                    "S770: Corinda High - Forest Lake": [
                        "College Ave near Oxley Place",
                        "College Ave at Halifax Court",
                        "College Ave at Hillbrook",
                        "College Ave at St John's Anglican College",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Forest Lake Bvd at St Johns Anglican College",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Government Rd near Flower Pl",
                        "Government Rd near Archerfield Rd, stop 75",
                        "Archerfield Rd at Court House",
                        "Archerfield Rd at McEwan Park",
                        "Archerfield Rd near Littleton Rd",
                        "Archerfield Rd near Freeman Rd, stop 71",
                        "Freeman Rd near Firth St",
                        "Freeman Rd near C J Greenfield Park",
                        "Freeman Rd near Eugenia St",
                        "Freeman Rd near Deodar St",
                        "Freeman Rd near Yulan St",
                        "Rudd St at Police Academy",
                        "Douglas St at Douglas St South",
                        "Douglas St at Douglas St Central",
                        "Douglas St at Douglas Street North",
                        "Englefield Rd at Englefield West",
                        "Englefield Rd at Lucock Street",
                        "Englefield Rd at Idriess Street",
                        "Oxley Station Rd at Englefield East, stop 64a",
                        "Oxley Rd at Nixon Park, stop 62",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Rd at Oxley School, stop 65",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Freeman Rd near Hampton St",
                        "Government Rd near Rudyard St, stop 75",
                        "Joseph Banks Ave near Leichhardt Cct"
                    ],
                    "S771: Brisbane Boys College - Enoggera": [
                        "Moggill Rd at BBC, stop 16",
                        "Sherwood Rd at Kensington Terrace, stop 21",
                        "Sherwood Rd at Toowong West, stop 22",
                        "Elizabeth St at Lodge St, stop 21",
                        "Elizabeth St at Ivy St, stop 22",
                        "Soudan St near Orchard St, stop 24",
                        "Orchard St near Bywong St, stop 25",
                        "Exmouth St near Camp St, stop 26",
                        "Camp St near Market St, stop 27",
                        "Market St near Duke St, stop 28",
                        "Orchard St at Lower Orchard St, stop 27/26",
                        "Orchard St at Upper Orchard St, stop 25",
                        "Soudan St near Bent St, stop 24",
                        "Ivy St near Mount St, stop 23",
                        "Dean St at Elizabeth St, stop 19/18",
                        "Dean St at Toowong Depot, stop 17",
                        "Birdwood Tce at Stuartholme, stop 31",
                        "Stuartholme Rd at Rainworth near Leworthy St",
                        "Simpsons Rd at The Drive, stop 17",
                        "Simpsons Rd at Greer Street, stop 17a",
                        "Simpsons Rd at Bardon, stop 16",
                        "Jubilee Tce near Effie St",
                        "Jubilee Tce at Ithaca near Fletcher Pde",
                        "Stewart Rd at Ashgrove, stop 46",
                        "Stewart Rd near Devoy St, stop 44",
                        "Stewart Rd near Celia St, stop 43",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "Wardell St at Dorrington near Stark St",
                        "Wardell St near Banks St, stop 32",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St near Edith St, stop 30a",
                        "Wardell St at Lloyd - Wardell, stop 30A",
                        "Enoggera interchange, platform C"
                    ],
                    "S772: St Ignatius - Riverhills West": [
                        "Carnarvon Rd near Lambert Rd",
                        "Ward St near Central Ave",
                        "Central Ave at Holy Family, stop 33",
                        "Central Ave at Newcross Street, stop 32",
                        "Central Ave at Rennie Street, stop 31",
                        "Central Ave near Clarence Rd, stop 30",
                        "York St near Prince St, stop 29",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly Shopping Centre station, stop A",
                        "Moggill Rd at Rylatt Street, stop 25",
                        "Moggill Rd at Indooroopilly School, stop 27",
                        "Moggill Rd at Chapel Hill, stop 28",
                        "Moggill Rd at Kennewell Park, stop 29",
                        "Moggill Rd at Alkira, stop 30",
                        "Fig Tree Pocket Rd near Henry St, stop 32A",
                        "Fig Tree Pocket Rd near Fawkner St, stop 33",
                        "Fig Tree Pocket Rd near Winking St, stop 33A",
                        "Fig Tree Pocket Rd near Kenmore Rugby Club Stop 34",
                        "Sinnamon Rd at Windermere",
                        "Goggs Rd at Windermere Village Shopping",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Burrendah Rd near Bangalee St",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd at Jindalee State School",
                        "Curragundi Rd at Jindalee Place",
                        "Curragundi Rd near Moolingal St",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd near Timbarra Cr",
                        "Yallambee Rd near Capitol Dr",
                        "Yallambee Rd at Mt Ommaney",
                        "Bounty St at Explorer",
                        "Arrabri Ave near Blaxland Ct",
                        "Arrabri Ave at Mt Ommaney South near Bowles St",
                        "Arrabri Ave near Abel Smith Cr",
                        "Mount Ommaney Shopping Centre",
                        "Dandenong Rd at Jamboree",
                        "Dandenong Rd near Spinnaker St",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Horizon Dr near Badge St",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr near Gertrude McLeod Cr",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr near Dewsbury St",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr near Congo St",
                        "Horizon Dr at Westlake South near Buffalo St",
                        "Horizon Dr at Tigris Street",
                        "Sumners Rd at Riverhills East near Macfarlane St",
                        "Sumners Rd at Macfarlane Street",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills West near Rufus St"
                    ],
                    "S773: Marist Brothers College - Ashgrove Ave": [
                        "Moola Rd at Marist Brothers",
                        "Frasers Rd near Nimmo Rd, stop 37",
                        "Canberra Dr near Frasers Rd, stop 36",
                        "Canberra Dr near Tweed St, stop 35",
                        "Victoria St near Ashbourne St, stop 33",
                        "Wardell St near Banks St, stop 32",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St near Edith St, stop 30a",
                        "Wardell St at Lloyd - Wardell, stop 30A",
                        "Enoggera interchange, platform C",
                        "Wardell St at Glenalva Terrace, stop 1/30",
                        "Lloyd St at Lloyd - North, stop 30",
                        "Lloyd St near Girton St, stop 29",
                        "Cole St at Cole - Lloyd, stop 28",
                        "Cole St near Elfreda St, stop 27",
                        "Bowral St at Goskar Avenue, stop 29",
                        "Bowral St near Milford St, stop 28",
                        "Banks St at Gifford Street, stop 27",
                        "Banks St near Lexington St, stop 26",
                        "Banks St at Banks Bend, stop 25",
                        "Banks St at Banks View, stop 24",
                        "Banks St at Banks - Laurence, stop 23",
                        "Banks St at Banks - School, stop 22",
                        "Enoggera Rd at Terang Street, stop 21",
                        "Ashgrove Ave near Caravan Park, stop 20",
                        "Ashgrove Ave near Vaux St, stop 21",
                        "Ashgrove Ave near Raleigh Pde, stop 23",
                        "Ashgrove Ave near Gailey St, stop 24",
                        "Ashgrove Ave near Bott St, stop 25",
                        "Ashgrove Ave near Crawford St, stop 26"
                    ],
                    "S774: Everton Park - Brookside": [
                        "Trouts Rd near Midson St, stop 7",
                        "Stafford Rd at Mountbridge Street, stop 6",
                        "Stafford Rd at Cutbush Rd, stop 5",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at White Street, stop 38",
                        "South Pine Rd at Nitawill Street, stop 3",
                        "South Pine Rd at Pullen Road, stop 40",
                        "Old Northern Rd at Everton Junction",
                        "Deakin St near Barton St",
                        "Barton St at South Pine Bend, stop 42",
                        "South Pine Rd at South Pine Bend, stop 43",
                        "South Pine Rd near Lily St, stop 44",
                        "South Pine Rd at Queens Rd, stop 45",
                        "South Pine Rd at Buckland Rd Stop 46",
                        "Camelia Ave at Camelia - Mirbelia, stop 47",
                        "Camelia Ave at Camelia - Nymphaea, stop 48",
                        "Camelia Ave at Violet St, stop 49",
                        "Camelia Ave at Galeola Street, stop 50",
                        "Pullen Rd at Hornby Street, stop 51A",
                        "Osborne Rd at Osborne North, stop 51",
                        "Osborne Rd near Northmore St, stop 52",
                        "Brookside Shopping Centre"
                    ],
                    "S775: Bardon - Kelvin Grove High": [
                        "Leworthy St near Nestor Ave, stop 20",
                        "Leworthy St at Leworthy Shops, stop 19",
                        "Sixth Ave at Stokes St, stop 20/18",
                        "Boundary Rd at St Mary's - Rainworth, stop 17",
                        "Boundary Rd at Rainworth School, stop 16",
                        "Boundary Rd near Brown St, stop 15",
                        "Rainworth Rd at Norm Buchan Park West, stop 14",
                        "Rainworth Rd at Norm Buchan Park Central, stop 13",
                        "Rainworth Rd at Norm Buchan Park East, stop 12",
                        "Elizabeth St at Murruba St, stop 11",
                        "Elizabeth St at Nash Street, stop 10",
                        "Baroona Rd at Rosalie Shops, stop 9",
                        "Heussler Tce at Heussler - Fernberg, stop 8",
                        "Heussler Tce at Heussler - Park, stop 7",
                        "Heussler Tce near Patrick St, stop 6",
                        "Heussler Tce at Heussler - Suncorp, stop 5",
                        "Given Tce at Paddington, stop 5",
                        "Given Tce at Paddo Tavern, stop 6",
                        "Given Tce at Great George, stop 7",
                        "Latrobe Tce at Old Paddo Post Office, stop 8",
                        "Latrobe Tce at Old Ithaca Fire Station, stop 9",
                        "Latrobe Tce at Paddington Central, stop 10",
                        "Latrobe Tce at Trammies Corner, stop 11",
                        "Latrobe Tce at Gilday Street, stop 12",
                        "Latrobe Tce at Perrott Street , stop 13",
                        "MacGregor Tce near Tooth Ave, stop 14",
                        "MacGregor Tce at Bardon",
                        "Jubilee Tce near Effie St",
                        "Jubilee Tce at Ithaca near Fletcher Pde",
                        "Waterworks Rd at Ashgrove, stop 17",
                        "Waterworks Rd at St Finbarr's - Ashgrove, stop 16",
                        "Waterworks Rd at Woodland Street, stop 15",
                        "Waterworks Rd at Boon Street, stop 14",
                        "Waterworks Rd at Mossvale Street, stop 13",
                        "Waterworks Rd at Whitta Street, stop 12",
                        "Waterworks Rd at Glenrosa Road, stop 11",
                        "Waterworks Rd at Cairns Street, stop 10",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Musgrave Rd at Normanby Hotel, stop 4",
                        "College Rd near Kelvin Grove Rd, stop 3b",
                        "Brisbane Grammar Stop 4",
                        "Gregory Tce at Torrington Street, stop 5",
                        "Gregory Tce near Union St, stop 6",
                        "Gregory Tce at St Josephs, stop 7",
                        "Gregory Tce near Hill St, stop 8",
                        "Gregory Tce near Kennigo St, stop 9",
                        "Bowen Bridge Rd at Gregory Terrace, stop 7",
                        "Herston Rd near Bramston Tce",
                        "Lestrange Tce near Victoria Park Rd, stop 20",
                        "Lestrange Tce - 21 (Zone A)",
                        "Gregory Tce near Rogers St, stop 8",
                        "Gregory Tce near Brunswick St, stop 10",
                        "Gregory Tce near Park St, stop 9",
                        "Gregory Tce at Brisbane Grammar, stop 4",
                        "College Rd near Countess St, stop 3b",
                        "Musgrave Rd at Normanby Fiveways, stop 4",
                        "Musgrave Rd at St Brigid's - Red Hill, stop 5",
                        "Waterworks Rd at Mannion Street, stop 9",
                        "Waterworks Rd at Glenrosa Road, stop 10/11",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Jubilee Tce at Ithaca near The Esplanade",
                        "Jubilee Tce near Accession St, stop 19",
                        "MacGregor Tce at Bardon, stop 15",
                        "MacGregor St at Tooth Ave, stop 14",
                        "Latrobe Tce at Perrott Street, stop 13",
                        "Given Tce at Old Paddo Post Office, stop 8",
                        "Heussler Tce at Heussler, stop 6",
                        "Nash St near Elizabeth St, stop 10",
                        "Elizabeth St at Rosalie, stop 10a",
                        "Boundary Rd at Mackay Terrace, stop 18",
                        "Stuartholme Rd at Rainworth near Sixth Ave"
                    ],
                    "S776: Jindalee State School - Windermere": [
                        "Sinnamon Rd at Windermere",
                        "Sinnamon Rd at Windermere Estate stop 78",
                        "Windermere Ave at Ellerwood Place, stop 77",
                        "Seventeen Mile Rocks Rd at Mosman Court, stop 76",
                        "Rocks Riverside Park, stop 75",
                        "Seventeen Mile Rocks Rd at Arygle, stop 73",
                        "Seventeen Mile Rocks Rd at Edenbrooke, stop 72",
                        "Seventeen Mile Rocks Rd at Arygle Street, stop 73",
                        "Oldfield Rd near McPherson Rd, stop 57",
                        "McPherson Rd at McPherson Park, stop 56",
                        "McPherson Rd at McPherson Cityview, stop 56a",
                        "McPherson Rd at Malia St, stop 55",
                        "McPherson Rd at McPherson South, stop 55A",
                        "Glen Ross Rd at Bellwood St, stop 54",
                        "Glen Ross Rd near Dove Tree Cr, stop 52",
                        "Glen Ross Rd at St Amand Street, stop 53",
                        "Glen Ross Rd at Wanata Street, stop 54",
                        "Endeavour St at Southern Cross Transit",
                        "Yallambee Rd at Centenary High School",
                        "Burrendah Rd near Bangalee St",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd at Jindalee State School",
                        "Curragundi Rd at Jindalee Place",
                        "Curragundi Rd near Moolingal St",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd near Timbarra Cr",
                        "Yallambee Rd at Mt Ommaney",
                        "Endeavour St near Macarthur Ct",
                        "Endeavour St near Flinders Ct",
                        "Glen Ross Rd at Sinnamon Park",
                        "Glen Ross Rd near Wanata St",
                        "Glen Ross Rd at Saint Amand Street, stop 53",
                        "Glen Ross Rd near Dove Tree Cr, stop 54",
                        "Glen Ross Rd at Glen Ross - Bellwood, stop 54"
                    ],
                    "S777: Pallara - Forest Lake High": [
                        "Brookbent Rd near Ivory Cres",
                        "Pallara Ave near Pipet Cr",
                        "Pallara Ave at Gooderham Rd",
                        "Gooderham Rd at Brookbent Rd",
                        "Vied Rd near Landel St",
                        "Esky Rd near Kraft Rd",
                        "Ritchie Rd near Kraft Rd",
                        "Laxton Rd near Ritchie Rd",
                        "Laxton Rd near Bellerive St",
                        "Laxton Rd near Esky Rd",
                        "Van Dieren Rd near Esky Rd",
                        "Van Dieren Rd near Whitehaven St",
                        "Van Dieren Rd at Pallara District Sports Park",
                        "Richie Rd near Falkland St",
                        "Pallara State School",
                        "Parkwood Dr North near Beech St",
                        "Parkwood Dr near Coolibah St",
                        "Parkwood Dr at Parkwood Drive South",
                        "Parkwood Dr near Juniper St",
                        "Wadeville St at Wadeville West",
                        "Wadeville St Heathwood Rise",
                        "Forest Lake Bvd at Kensington Way",
                        "High St at Forest Lake High School",
                        "Stapylton Rd near Wadeville St",
                        "Parkwood Dr near Watergum St",
                        "Parkwood Dr near Acacia St",
                        "Parkwood Dr North near Laurel St",
                        "Ritchie Rd near Falkland St",
                        "Van Dieren near Prominence St",
                        "Van Dieren Rd near Morganite St",
                        "Van Dieran Rd near Esky Rd",
                        "Kraft Rd near Esky Rd",
                        "Vied St near Landel St",
                        "Gooderham Rd near Brookbent Rd"
                    ],
                    "S778: Forest Lake College - Inala": [
                        "High St at Forest Lake High School",
                        "Forest Lake Shops",
                        "College Ave at Hillbrook",
                        "College Ave at Halifax Court",
                        "Woodland Ave near Laricina Cct",
                        "Partridge St near Tang St",
                        "Inala Plaza"
                    ],
                    "S779: Forest Lake High - Richlands station": [
                        "Richlands bus station, stop A",
                        "Garden Rd at Government Road",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Forest Lake Bvd at Forest Lake, stop A",
                        "Forest Lake Bvd at Forest Lake Shops",
                        "High St at Forest Lake High School",
                        "Garden Rd at Progress Corner"
                    ],
                    "S780: Centenary High - Centenary Village": [
                        "Yallambee Rd at Centenary High School",
                        "Dandenong Rd near Spinnaker St",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Horizon Dr near Badge St",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr near Gertrude McLeod Cr",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr near Dewsbury St",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr near Congo St",
                        "Horizon Dr at Westlake South near Buffalo St",
                        "Horizon Dr at Tigris Street",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Sumners Rd at Riverhills East near Macfarlane St",
                        "Sumners Rd at Tompkins Road",
                        "Sumners Rd at Brumby Circuit",
                        "Sumners Rd at Sumner Tavern",
                        "Westcombe St near Perivale St, stop 62",
                        "Ashridge Rd near Chipley St",
                        "Cardiff Rd at Cardiff Road South, stop 61",
                        "Railway Pde at Darra Railway Parade, stop 62",
                        "Darra Shops",
                        "Kokoda St at Centenary Village",
                        "Kokoda St near Wau Rd",
                        "Wau Rd near Ramu St",
                        "Markham Street near Sanadanda St"
                    ],
                    "S781: Centenary High - Sumner Park": [
                        "Yallambee Rd at Centenary High School",
                        "Yallambee Rd at Mt Ommaney",
                        "Dandenong Rd at Jamboree",
                        "Dandenong Rd near Spinnaker St",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Horizon Dr near Badge St",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr near Gertrude McLeod Cr",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr near Dewsbury St",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr near Congo St",
                        "Horizon Dr at Westlake South near Buffalo St",
                        "Horizon Dr at Tigris Street",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Sumners Rd at Riverhills East near Macfarlane St",
                        "Sumners Rd at Tompkins Road",
                        "Sumners Rd at Brumby Circuit",
                        "Sumners Rd at Sumner Tavern",
                        "Sumners Rd at Spine St"
                    ],
                    "S782: Corinda - Sumner Park": [
                        "Sumners Rd at Spine St",
                        "Kokoda St at Centenary Village",
                        "Kokoda St near Wau Rd",
                        "Sumners Rd at Sumner Tavern",
                        "Wau Rd near Ramu St",
                        "Sumners Rd at Brumby Circuit",
                        "Markham Street near Sanadanda St",
                        "Sumners Rd at Tompkins Road",
                        "Sumners Rd at Macfarlane Street",
                        "Railway Pde at Darra station, stop A",
                        "Sumners Rd at Riverhills near Bogong St",
                        "Manburgh Tce at Darra station, stop B",
                        "Sumners Rd at Riverhills West near Rufus St",
                        "Westcombe St near Gravel Pit Rd, stop 62",
                        "Horizon Dr at Tigris Street",
                        "Horizon Dr at Westlake South near Riverhills Rd",
                        "Horizon Dr at Westlake near Nisbet St",
                        "Horizon Dr at Lake View",
                        "Horizon Dr at McLeod near Maribor St",
                        "Horizon Dr near Gertrude McLeod Cr",
                        "Horizon Dr at Middle Park near Riverhills Rd",
                        "Horizon Dr at Baden Powell",
                        "Horizon Dr at Jamboree Heights near Dandenong Rd",
                        "Dandenong Rd near Spinnaker St",
                        "Dandenong Rd at Jamboree",
                        "Mount Ommaney Shopping Centre",
                        "Dandenong Rd at Centenary Shopping Centre",
                        "Endeavour St at Southern Cross Transit",
                        "Yallambee Rd at Mt Ommaney",
                        "Yallambee Rd at Centenary High School",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Cliveden Ave at Lyon Ave, stop 66",
                        "Ardoyne Rd near Lyon Ave, stop 67",
                        "Ardoyne Rd at Oxley station, stop B",
                        "Seventeen Mile Rocks Rd at Kingsgate St, stop 69",
                        "Canossa Private Hospital, stop 70",
                        "Seventeen Mile Rocks Rd at Pannard St",
                        "Seventeen Mile Rocks Rd at Edenbrooke, stop 72",
                        "Seventeen Mile Rocks Rd at Arygle Street, stop 73",
                        "Rocks Riverside Park, stop 75",
                        "Seventeen Mile Rocks Rd at Mosman Court, stop 76",
                        "Sinnamon Village",
                        "Sinnamon Rd at Jindalee park 'n' ride",
                        "Burrendah Rd near Bangalee St",
                        "Burrendah Rd near Lanena St",
                        "Burrendah Rd at Jindalee State School",
                        "Curragundi Rd at Jindalee Place",
                        "Curragundi Rd near Moolingal St",
                        "Curragundi Rd at Jumbuck",
                        "Curragundi Rd near Timbarra Cr",
                        "Bounty St at Explorer",
                        "Arrabri Ave near Blaxland Ct",
                        "Arrabri Ave at Mt Ommaney South near Bowles St",
                        "Arrabri Ave near Abel Smith Cr",
                        "Horizon Dr near Badge St",
                        "Horizon Dr near Dewsbury St",
                        "Horizon Dr at Westlake near Tebera St",
                        "Horizon Dr near Congo St",
                        "Horizon Dr at Westlake South near Buffalo St",
                        "Sumners Rd at Riverhills East near Macfarlane St"
                    ],
                    "S783: St Finbarrs - Enoggera": [
                        "Enoggera interchange, platform D",
                        "Wardell St at Glenalva Terrace, stop 1/30",
                        "Wardell St at Enoggera South, stop 31",
                        "Wardell St near Yates Ave, stop 32",
                        "Wardell St at Dorrington near Stark St",
                        "Frasers Rd near Nimmo Rd, stop 37",
                        "Moola Rd at Marist Brothers",
                        "Tweed St near Victoria St",
                        "Glory St at West Ashgrove, stop 24",
                        "Glenlyon Dr near Marist Lane, stop 39C",
                        "Grevillea Rd near Glenlyon Dr, stop 39B",
                        "Girraween Gr near Oleander Dr, stop 39A",
                        "Frasers Rd near Tay St, stop 40",
                        "Arinya Rd near Mirrabooka Rd, stop 39",
                        "Arinya Rd near Moola Rd, stop 38",
                        "Wardell St near Banks St, stop 32",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St near Edith St, stop 30a",
                        "Wardell St at Lloyd - Wardell, stop 30A",
                        "Enoggera interchange, platform C"
                    ],
                    "S784: Marist College - Payne Rd": [
                        "Moola Rd at Marist Brothers",
                        "Amarina Ave at Mount Saint Michaels School",
                        "Grevillea Rd near Glenlyon Dr, stop 39B",
                        "Frasers Rd near Nimmo Rd, stop 37",
                        "Glenlyon Dr near Cypress Dr, stop 39c",
                        "Girraween Gr near Oleander Dr, stop 39A",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Settlement Rd at Gap Primary School, stop 36",
                        "Settlement Rd at Chaprowe Street, stop 37",
                        "Kaloma Rd at Kaloma - Harward, stop 38",
                        "Kaloma Rd at Woorama Rd, stop 39",
                        "Kaloma Rd at Hilder Road School, stop 40",
                        "Hilder Rd at Kaloma - Hilder, stop 41",
                        "Hilder Rd at Wittonga Park, stop 42",
                        "Petmar St at Petmar Street North, stop 43",
                        "Petmar St at Petmar Street South, stop 44",
                        "Waterworks Rd at Petmar St, stop 45",
                        "Waterworks Rd at Hilder Rd, stop 46",
                        "School Rd at Bogunda St, stop 45",
                        "School Rd at Woongarra St, stop 44",
                        "Payne Rd at Glen Rd, stop 44a",
                        "Payne Rd at Kays Rd, stop 44b",
                        "Payne Rd at Dillon Rd, stop 44c",
                        "Payne Rd at Glen Rd, stop 44d",
                        "Payne Rd at Payne - DAguilar, stop 43",
                        "Payne Rd at Gymea St, stop 42",
                        "Payne Rd at Whitehead Rd, stop 41",
                        "Whitehead Rd near Fairearth St, stop 40",
                        "Pindari St near Palana St, stop 39",
                        "Devonhill St near Paraka St, stop 38",
                        "Devonhill St at Koorong St, stop 37",
                        "Bombala St at Glenbrae Street, stop 36",
                        "Grenoble St at Woodside St, stop 35",
                        "Grenoble St at Paten Rd, stop 34",
                        "Paten Rd at Paten Park, stop 33a",
                        "Payne Rd at Paten Rd, stop 33",
                        "Payne Rd at Glenmore St, stop 32"
                    ],
                    "S785: Mt St Michaels - Enoggera": [
                        "Enoggera interchange, platform D",
                        "Wardell St at Enoggera South, stop 31",
                        "Wardell St near Yates Ave, stop 32",
                        "Wardell St at Dorrington near Stark St",
                        "Stewart Rd at Frasers Bridge, stop 42",
                        "Stewart Rd near Celia St, stop 43",
                        "Amarina Ave at Mount Saint Michaels School",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "Wardell St near Banks St, stop 32",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St near Edith St, stop 30a",
                        "Wardell St at Lloyd - Wardell, stop 30A"
                    ],
                    "S786: Bardon - The Gap High": [
                        "Carwoola St at Bardon, stop 22",
                        "Simpsons Rd at Bardon Treetops, stop 22a",
                        "Simpsons Rd at Bardon School, stop 21",
                        "Simpsons Rd at Bowman Park, stop 20",
                        "Leworthy St near Nestor Ave, stop 20",
                        "Leworthy St at Leworthy Shops, stop 19",
                        "Simpsons Rd at The Drive, stop 17",
                        "Simpsons Rd at Greer Street, stop 17a",
                        "Simpsons Rd at Bardon, stop 16",
                        "Coopers Camp Rd near Cecil Rd, stop 27",
                        "Coopers Camp Rd near Callum Lane, stop 28",
                        "Coopers Camp Rd at Coopers Camp Road, stop 29",
                        "Coopers Camp Rd at West Ashgrove",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Glory St at West Ashgrove, stop 24",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "School Rd at Bogunda St, stop 45",
                        "School Rd at Woongarra St, stop 44",
                        "Payne Rd at Glen Rd, stop 44a",
                        "Payne Rd at Kays Rd, stop 44b",
                        "Payne Rd at Dillon Rd, stop 44c",
                        "Payne Rd at Glen Rd, stop 44d",
                        "Payne Rd at Payne - DAguilar, stop 43",
                        "Payne Rd at Gymea St, stop 42",
                        "Payne Rd at Whitehead Rd, stop 41",
                        "Whitehead Rd near Fairearth St, stop 40",
                        "Pindari St near Palana St, stop 39",
                        "Devonhill St near Paraka St, stop 38",
                        "Devonhill St at Koorong St, stop 37",
                        "Bombala St at Glenbrae Street, stop 36",
                        "Grenoble St at Woodside St, stop 35",
                        "Grenoble St at Paten Rd, stop 34",
                        "Paten Rd at Paten Park, stop 33a",
                        "Payne Rd at Paten Rd, stop 33",
                        "Payne Rd at Glenmore St, stop 32",
                        "Waterworks Rd at Kilmaine Street, stop 29",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Coopers Camp Rd at West Ashgrove, stop 24",
                        "Coopers Camp Rd near Jaloon St, stop 36A",
                        "Lewin St near Empress Tce, stop 25",
                        "Lewin St near Coronation St, stop 24",
                        "Lewin St near Coronation St, stop 23/22",
                        "Fletcher Pde near Leslie St, stop 21",
                        "Leslie St near Glenda St, stop 20/19",
                        "Leslie St near Jubilee Tce, stop 18",
                        "Jubilee Tce near Effie St",
                        "Jubilee Tce near Accession St, stop 19",
                        "Simpsons Rd at Bardon, stop 16a",
                        "Simpsons Rd at Greer Street, stop 16",
                        "Chiswick Rd at Chiswick Road West, stop 19"
                    ],
                    "S787: Ashgrove - The Gap": [
                        "Moola Rd at Marist Brothers",
                        "Frasers Rd near Nimmo Rd, stop 37",
                        "Girraween Gr near Oleander Dr, stop 39A",
                        "Grevillea Rd near Glenlyon Dr, stop 39B",
                        "Glenlyon Dr near Cypress Dr, stop 39c",
                        "Waterworks Rd at Theale Terrace, stop 23",
                        "Waterworks Rd at West Ashgrove, stop 24",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Acton Street, stop 27",
                        "Waterworks Rd at Glenquarie Place, stop 29",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at Hilder Road, stop 46"
                    ],
                    "S788: Gap State School - City": [
                        "Waterworks Rd at Settlement Road, stop 36",
                        "Waterworks Rd at Gap Uniting Church, stop 35",
                        "Waterworks Rd at Gap High School, stop 34",
                        "Waterworks Rd at The Gap Village, stop 33",
                        "Waterworks Rd at Jevons Street, stop 32",
                        "Waterworks Rd at Payne Road, stop 31",
                        "Waterworks Rd at Cooinda Street, stop 30",
                        "Waterworks Rd at Kilmaine Street, stop 29",
                        "Waterworks Rd at Greenlanes Road, stop 28/27",
                        "Waterworks Rd at Firhill Street, stop 26",
                        "Waterworks Rd at Monoplane Street, stop 25",
                        "Glory St at West Ashgrove, stop 24",
                        "Waterworks Rd at Myagh Road, stop 23/22",
                        "Waterworks Rd at Girraween Grove, stop 21",
                        "Waterworks Rd at Hibiscus Avenue, stop 20",
                        "Waterworks Rd at Elimatta Drive, stop 19",
                        "Waterworks Rd at Ashgrove, stop 17",
                        "Waterworks Rd at St Finbarr's - Ashgrove, stop 16",
                        "Waterworks Rd at Woodland Street, stop 15",
                        "Waterworks Rd at Boon Street, stop 14",
                        "Waterworks Rd at Mossvale Street, stop 13",
                        "Waterworks Rd at Whitta Street, stop 12",
                        "Waterworks Rd at Glenrosa Road, stop 11",
                        "Waterworks Rd at Cairns Street, stop 10",
                        "Musgrave Rd at Red Hill Shops, stop 8",
                        "Musgrave Rd at Hammond Street, stop 7",
                        "Musgrave Rd at Upper Clifton Terrace, stop 5A",
                        "Musgrave Rd at Normanby Fiveways, stop 5",
                        "Musgrave Rd at Normanby Hotel, stop 4",
                        "Countess St at Normanby Fiveways",
                        "Roma Street Stop 125 at Transit Centre",
                        "Ann Street Stop 12 at City Hall",
                        "Adelaide Street Stop 23 near David Jones"
                    ],
                    "S789: Inala - Corinda Primary": [
                        "Inala station, platform E",
                        "Wadeville St at Wadeville West",
                        "Wadeville St Heathwood Rise",
                        "Inala Ave at Thrush Street, stop 57",
                        "Blunder Rd at Chain of Ponds Estate",
                        "Inala Ave at Sycamore Street, stop 58",
                        "Old Blunder Rd near Carolina Pde",
                        "Inala Ave at Skylark",
                        "Redhead St near Blunder Rd",
                        "Inala Ave at Avocet Ave, stop 59",
                        "Inala Ave at Sherrington Park",
                        "Rockfield Rd near Sunny St",
                        "Blunder Rd near Rosella St, stop 60A",
                        "Crossacres St near Rockfield St",
                        "Blunder Rd at Flamingo Street Stop 60b",
                        "Blunder Rd near Crossacres St",
                        "Wallaroo Way near Brushtail Cr, stop 61",
                        "Blunder Rd near Wallaroo Wy",
                        "Blunder Rd at Doolandella North, stop 61a",
                        "Blunder Rd near Brookside St",
                        "Blunder Rd at Lorikeet St",
                        "Blunder Road near Rosella St",
                        "Parkwood Dr near Juniper St",
                        "Blunder Rd at Durrang St",
                        "Parkwood Dr near Watergum St",
                        "Blunder Rd at Glenala Rd, stop 71a",
                        "Parkwood Dr near Acacia St",
                        "Blunder Rd at Forest Place South, stop 70",
                        "Parkwood Dr near Coolibah St",
                        "Blunder Rd at Forest Place North, stop 69",
                        "Parkwood Dr North near Laurel St",
                        "Blunder Rd at Freeman Rd, stop 68",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Oxley Rd at Oxley School, stop 65",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Station Rd at Englefield East, stop 64a",
                        "Oxley Station Rd at Davies Street, stop 63a",
                        "Oxley station, stop A",
                        "Cook St near Oxley Rd, stop 62a",
                        "Oxley Rd at Nixon Park, stop 62",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Cook St at Nixon Park, stop 62",
                        "Cook St near Lincoln St, stop 62a",
                        "Blunder Rd at Blunder - Freeman, stop 68",
                        "Blunder Rd near Inala Ave"
                    ],
                    "S790: Corinda High - Inala Plaza": [
                        "Inala station, platform D",
                        "Pratten St at Corinda High School, stop 63",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Inala Plaza"
                    ],
                    "S791: Corinda High - Inala Plaza - Forest Lake": [
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Rd at Oxley School, stop 65",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Freeman Rd near Hampton St",
                        "Rosemary St at Rosemary North, stop 71",
                        "Rosemary St at Rosemary - Fir, stop 73",
                        "Rosemary St at Holly St, stop 74",
                        "Rosemary St at Inala School, stop 75",
                        "Rosemary St at Rosemary South, stop 75A",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Inala Plaza",
                        "Partridge St at Partridge North, stop 72",
                        "Partridge St near Tang St",
                        "Woodland Ave near Joseph Banks Ave",
                        "College Ave at Halifax Court",
                        "College Ave at Hillbrook",
                        "College Ave at St John's Anglican College"
                    ],
                    "S792: Richlands - Corinda Primary": [
                        "Government Rd near Rudyard St, stop 75",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Forest Lake Bvd at Forest Lake, stop B",
                        "Lochwood Ave at Broadwater Way",
                        "Lochwood Ave at Jindabyne Cct",
                        "Woogaroo St near Waterford Rd",
                        "Government Rd near Flower Pl",
                        "Government Rd near Archerfield Rd, stop 75",
                        "Archerfield Rd at Court House",
                        "Archerfield Rd at McEwan Park",
                        "Archerfield Rd near Littleton Rd",
                        "Archerfield Rd near Freeman Rd, stop 71",
                        "Freeman Rd near Firth St",
                        "Freeman Rd near C J Greenfield Park",
                        "Freeman Rd near Eugenia St",
                        "Freeman Rd near Deodar St",
                        "Freeman Rd near Yulan St",
                        "Rudd St at Police Academy",
                        "Douglas St at Douglas St South",
                        "Douglas St at Douglas St Central",
                        "Douglas St at Douglas Street North",
                        "Englefield Rd at Englefield West",
                        "Englefield Rd at Lucock Street",
                        "Englefield Rd at Idriess Street",
                        "Oxley Station Rd at Englefield East, stop 64a",
                        "Oxley Rd at Nixon Park, stop 62",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65"
                    ],
                    "S793: Richlands - St Josephs - Corinda schools": [
                        "Government Rd near Archerfield Rd, stop 75",
                        "Poinsettia St near Archerfield Rd, stop 76",
                        "Eridanus St at Mira Street, stop 60",
                        "Eridanus St near Draco St, stop 61",
                        "Delphinus St near Altair St, stop 62",
                        "Virgo St near Bellatrix St, stop 63",
                        "Bootes St near Aldebaran St, stop 64",
                        "Centaurus St near Apus St, stop 65",
                        "Centaurus St at Centaurus West, stop 66",
                        "Archerfield Rd at Argo Street, stop 67",
                        "Monoceros St at Monoceros West, stop 68",
                        "Monoceros St at Hydra Street, stop 69",
                        "Polaris St near Monoceros St, stop 70",
                        "Andromeda St near Capricorn St, stop 71",
                        "Clipper St near Andromeda St, stop 72",
                        "Brolga St near Parakeet St, stop 73",
                        "Inala station, platform D",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Hyacinth St, stop 77",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Durella St at Durella West, stop 76",
                        "Durella St at Durella East, stop 75",
                        "Akama Rd at Akama South Stop 74",
                        "Akama Rd at Akama Central Stop 73",
                        "Glenala Rd at Glenala High",
                        "Glenala Rd at Glenala East, stop 71",
                        "Blunder Rd at Glenala Rd, stop 71a",
                        "Blunder Rd at Forest Place South, stop 70",
                        "Blunder Rd at Forest Place North, stop 69",
                        "Blunder Rd at Freeman Rd, stop 68",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Oxley Rd at Oxley School, stop 65",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Rd at Nixon Park, stop 62",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Lynne Grove, stop 60",
                        "Oxley Rd near Hassall St",
                        "Clewley St near Oxley Rd, stop 59",
                        "Clara St at Clewley St, stop 60",
                        "Clara St at Clara - Nelson, stop 61",
                        "Clara St at Clara - Grey, stop 62",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65"
                    ],
                    "S794: Richlands - St Josephs - Corinda schools": [
                        "Government Rd near Archerfield Rd, stop 75",
                        "Poinsettia St near Archerfield Rd, stop 76",
                        "Poinsettia St at Richlands Campus, stop 59/77",
                        "Hydrangea St near Frangipani St, stop 59",
                        "Poinciana St at Laburnum St, stop 60",
                        "Poinciana St at Punica St, stop 61",
                        "Poinciana St at Poinciana - Azalea, stop 62",
                        "Azalea St at Tecoma St, stop 63",
                        "Azalea St at Eugenia St, stop 64",
                        "Azalea St at Barberry St, stop 65",
                        "Azalea St at Balsa St, stop 66",
                        "Balsa St at Biota St, stop 67",
                        "Balsa St at Balsa - Ebony, stop 68",
                        "Balsa St at Clematis St, stop 69",
                        "Balsa St at Apricot St, stop 70",
                        "Balsa St at Begonia St, stop 71",
                        "Begonia St at Yulan St, stop 71a",
                        "Begonia St at Rosemary St, stop 72",
                        "Rosemary St at Rosemary North, stop 71",
                        "Rosemary St at Rosemary - Fir, stop 73",
                        "Rosemary St at Holly St, stop 74",
                        "Rosemary St at Inala School, stop 75",
                        "Rosemary St at Rosemary South, stop 75A",
                        "Serviceton Ave at Kev Hooper Park, stop 76",
                        "Serviceton Ave at Serviceton - Hyacinth, stop 77",
                        "Serviceton Ave at Viola Street, stop 78",
                        "Serviceton Ave at Inala Ave, stop 79",
                        "Inala station, platform D",
                        "Serviceton Ave at Hyacinth St, stop 77",
                        "Durella St at Durella West, stop 76",
                        "Durella St at Durella East, stop 75",
                        "Akama Rd at Akama South Stop 74",
                        "Akama Rd at Akama Central Stop 73",
                        "Glenala Rd at Glenala High",
                        "Glenala Rd at Glenala East, stop 71",
                        "Blunder Rd at Glenala Rd, stop 71a",
                        "Blunder Rd at Forest Place South, stop 70",
                        "Blunder Rd at Forest Place North, stop 69",
                        "Blunder Rd at Freeman Rd, stop 68",
                        "Blunder Rd at Oxley Ridge, stop 67",
                        "Blunder Rd at Blunder - Oxley, stop 66",
                        "Oxley Rd at Oxley School, stop 65",
                        "Oxley Rd at Bayford Street, stop 64",
                        "Oxley Station Rd at Englefield East, stop 64a",
                        "Oxley Station Rd at Davies Street, stop 63a",
                        "Oxley station, stop A",
                        "Cook St near Oxley Rd, stop 62a",
                        "Oxley Rd at Nixon Park, stop 62",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Lynne Grove, stop 60",
                        "Oxley Rd near Hassall St",
                        "Clewley St near Oxley Rd, stop 59",
                        "Clara St at Clewley St, stop 60",
                        "Clara St at Clara - Nelson, stop 61",
                        "Clara St at Clara - Grey, stop 62",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65"
                    ],
                    "S795: Corinda High - Corinda station": [
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Oxley Rd at Lynne Grove, stop 60",
                        "Oxley Rd near Hassall St",
                        "Browne St at Corinda station",
                        "Oxley Rd near Coyne St, stop 57",
                        "Oxley Rd at Sherwood, stop 56",
                        "Oxley Rd at Graceville Fiveways, stop 50",
                        "Graceville Ave at Oxley Rd, stop 48",
                        "Graceville Ave near Erroll St, stop 47",
                        "Graceville Ave near Erroll St, stop 46",
                        "Graceville Ave at Riverside Village, stop 45"
                    ],
                    "S797: Richlands - Corinda Primary": [
                        "Government Rd near Rudyard St, stop 75",
                        "Government Rd near Flower Pl",
                        "Forest Lake Bvd at Forest Lake, stop E",
                        "Forest Lake Bvd at Forest Lake, stop D",
                        "Forest Lake Bvd at Forest Lake, stop C",
                        "Joseph Banks Ave near Leichhardt Cct",
                        "College Ave near Oxley Place",
                        "College Ave at Halifax Court",
                        "College Ave at Hillbrook",
                        "College Ave at St John's Anglican College",
                        "Lochwood Ave at Broadwater Way",
                        "Lochwood Ave at Jindabyne Cct",
                        "Woogaroo St near Waterford Rd",
                        "Government Rd near Archerfield Rd, stop 75",
                        "Archerfield Rd at Court House",
                        "Archerfield Rd at McEwan Park",
                        "Archerfield Rd near Littleton Rd",
                        "Archerfield Rd near Freeman Rd, stop 71",
                        "Freeman Rd near Firth St",
                        "Freeman Rd near C J Greenfield Park",
                        "Freeman Rd near Eugenia St",
                        "Freeman Rd near Deodar St",
                        "Freeman Rd near Yulan St",
                        "Rudd St at Police Academy",
                        "Douglas St at Douglas St South",
                        "Douglas St at Douglas St Central",
                        "Douglas St at Douglas Street North",
                        "Englefield Rd at Englefield West",
                        "Englefield Rd at Lucock Street",
                        "Englefield Rd at Idriess Street",
                        "Oxley Station Rd at Englefield East, stop 64a",
                        "Oxley Rd at Nixon Park, stop 62",
                        "Oxley Rd at Cliveden Ave, stop 61",
                        "Pratten St at Corinda High School, stop 63",
                        "Pratten St near Brush Box Cl, stop 64",
                        "Cliveden Ave at Corinda Primary, stop 65"
                    ],
                    "S798: Marist Brothers - Indooroopilly": [
                        "Moola Rd at Marist Brothers",
                        "Frasers Rd near Nimmo Rd, stop 37",
                        "Frasers Rd near Tay St, stop 40",
                        "Stewart Rd at Frasers Bridge, stop 42",
                        "Stewart Rd near Celia St, stop 43",
                        "Stewart Rd at Ashgrove near Devoy St",
                        "Waterworks Rd at Kadanga Street, stop 18",
                        "Jubilee Tce at Ithaca near The Esplanade",
                        "Jubilee Tce near Effie St",
                        "Jubilee Tce near Accession St, stop 19",
                        "Simpsons Rd at Bardon, stop 16a",
                        "Simpsons Rd at Greer Street, stop 16",
                        "Simpsons Rd at The Drive, stop 17",
                        "Stuartholme Rd at Rainworth near Sixth Ave",
                        "Birdwood Tce at Stuartholme, stop 31",
                        "Leworthy St near Nestor Ave, stop 20",
                        "Mt Coot-tha Rd at Botanic Gardens, stop 17",
                        "Dean St at Toowong Depot, stop 17",
                        "Dean St near Elizabeth St, stop 18",
                        "Dean St at Woodstock Rd, stop 19/21",
                        "Sherwood Rd at Toowong West, stop 20",
                        "Dean St at Dovercourt Rd, stop 20a",
                        "Sherwood Rd at Kensington Terrace, stop 21",
                        "Jephson St at Toowong",
                        "Moggill Rd at BBC, stop 16",
                        "Morrow St near Beatrice St, stop 17/18",
                        "Moggill Rd at Taringa, stop 19",
                        "Moggill Rd at Stamford Road, stop 22/23",
                        "Indooroopilly interchange"
                    ],
                    "S799: Brisbane Boys College - Chermside": [
                        "Indooroopilly Shopping Centre station, stop C",
                        "Coonan St near Belgrave Rd, stop 21",
                        "Moggill Rd at Payne Street, stop 20",
                        "Walker St at Taringa, stop 19",
                        "Walker St at Frederick Street, stop 18",
                        "Moggill Rd at Morrow Street, stop 17",
                        "Moggill Rd at BBC, stop 16",
                        "Sherwood Rd at Kensington Terrace, stop 21",
                        "Sherwood Rd at Toowong West, stop 22",
                        "Dean St at Elizabeth St, stop 19/18",
                        "Dean St at Toowong Depot, stop 17",
                        "Birdwood Tce at Stuartholme, stop 31",
                        "Stuartholme Rd at Rainworth near Leworthy St",
                        "Simpsons Rd at The Drive, stop 17",
                        "Simpsons Rd at Greer Street, stop 17a",
                        "Simpsons Rd at Bardon, stop 16",
                        "Jubilee Tce near Effie St",
                        "Jubilee Tce at Ithaca near Fletcher Pde",
                        "Stewart Rd at Ashgrove, stop 46",
                        "Stewart Rd near Devoy St, stop 44",
                        "Stewart Rd near Celia St, stop 43",
                        "Stewart Rd at Frasers Bridge, stop 45",
                        "Frasers Rd near Nimmo Rd, stop 37",
                        "Moola Rd at Marist Brothers",
                        "Wardell St at Dorrington near Stark St",
                        "Wardell St near Banks St, stop 32",
                        "Wardell St at Enoggera South near Browns Dip Rd",
                        "Wardell St near Edith St, stop 30a",
                        "Wardell St at Lloyd - Wardell, stop 30A",
                        "Enoggera interchange, platform C",
                        "Wardell St at Enoggera near Samford Rd",
                        "Pickering St at Tunba Street",
                        "Pickering St at Pickering West",
                        "Pickering St at Pickering Rail",
                        "Samford Rd at Gaythorne RSL, stop 33",
                        "Blackwood St at Mitchelton, stop 34",
                        "Ruby Rd near McConahgy St, stop 35",
                        "Brookside Shopping Centre station, platform A",
                        "Griffith St at Burwood Street, stop 20/6",
                        "Griffith St at Brook Street, stop 19/5",
                        "Griffith St near South Pine Rd, stop 18/4",
                        "South Pine Rd at Everton Park, stop 37",
                        "South Pine Rd at White Street, stop 38",
                        "South Pine Rd at Nitawill Street, stop 3",
                        "South Pine Rd at Pullen Road, stop 40",
                        "Old Northern Rd at Everton Junction",
                        "Old Northern Rd at Everton Park North",
                        "Old Northern Rd at Everton Hills near Rode Rd",
                        "Rode Rd near Pleshette Pl",
                        "Rode Rd at McDowall near Brynner St",
                        "Rode Rd at Trouts Road",
                        "Rode Rd near Cilento St, stop 44a",
                        "Rode Rd at Downfall Creek",
                        "Rode Rd near Tyrone St",
                        "Rode Rd at Stafford Heights near Cranbourne St",
                        "Rode Rd at Cherston St",
                        "Rode Rd at Webster Road, stop 37",
                        "Rode Rd at Rode Road Hospital, stop 36",
                        "Hilltop Ave near Rainey St, stop 34b",
                        "Hilltop Ave at Ethel Street, stop 34c",
                        "Hilltop Ave at Prince Charles Hospital, stop 35",
                        "Wallace St near Farnell St",
                        "Wallace St at Davenport Street, stop 35a",
                        "Chermside interchange"
                    ]
                }
            },
            "train": {
                "stops": [
                    "Albion station",
                    "Alderley station",
                    "Altandi station",
                    "Ascot station",
                    "Auchenflower station",
                    "Bald Hills station",
                    "Banoon station",
                    "Banyo station",
                    "Beenleigh station",
                    "Beerburrum station",
                    "Beerwah station",
                    "Bethania station",
                    "Bindha station",
                    "Birkdale station",
                    "Boggo Road station",
                    "Boondall station",
                    "Booval station",
                    "Bowen Hills station",
                    "Bray Park station",
                    "Bundamba station",
                    "Buranda station",
                    "Burpengary station",
                    "Caboolture station",
                    "Cannon Hill station",
                    "Carseldine station",
                    "Central station",
                    "Chelmer station",
                    "Clayfield station",
                    "Cleveland station",
                    "Coomera station",
                    "Coopers Plains station",
                    "Cooran station",
                    "Cooroy station",
                    "Coorparoo station",
                    "Corinda station",
                    "Dakabin station",
                    "Darra station",
                    "Deagon station",
                    "Dinmore station",
                    "Domestic Airport station",
                    "Doomben station",
                    "Dutton Park station",
                    "Eagle Junction station",
                    "East Ipswich station",
                    "Ebbw Vale station",
                    "Edens Landing station",
                    "Elimbah station",
                    "Enoggera station",
                    "Eudlo station",
                    "Eumundi station",
                    "Fairfield station",
                    "Ferny Grove station",
                    "Fortitude Valley station",
                    "Fruitgrove station",
                    "Gailes station",
                    "Gaythorne station",
                    "Geebung station",
                    "Glass House Mountains station",
                    "Goodna station",
                    "Graceville station",
                    "Grovely station",
                    "Gympie North station",
                    "Helensvale station",
                    "Hemmant station",
                    "Hendra station",
                    "Holmview station",
                    "Hope Island station",
                    "Indooroopilly station",
                    "International Airport station",
                    "Ipswich station",
                    "Kallangur station",
                    "Karrabin station",
                    "Keperra station",
                    "Kingston station",
                    "Kippa-Ring station",
                    "Kuraby station",
                    "Landsborough station",
                    "Lawnton station",
                    "Lindum station",
                    "Loganlea station",
                    "Lota station",
                    "Mango Hill East station",
                    "Mango Hill station",
                    "Manly station",
                    "Milton station",
                    "Mitchelton station",
                    "Mooloolah station",
                    "Morayfield station",
                    "Morningside station",
                    "Murarrie station",
                    "Murrumba Downs station",
                    "Nambour station",
                    "Narangba station",
                    "Nerang station",
                    "Newmarket station",
                    "Norman Park station",
                    "North Boondall station",
                    "Northgate station",
                    "Nudgee station",
                    "Nundah station",
                    "Ormeau station",
                    "Ormiston station",
                    "Oxford Park station",
                    "Oxley station",
                    "Palmwoods station",
                    "Petrie station",
                    "Pimpama station",
                    "Pomona station",
                    "Redbank station",
                    "Richlands station",
                    "Riverview station",
                    "Robina station",
                    "Rocklea station",
                    "Roma Street station",
                    "Rosewood station",
                    "Rothwell station",
                    "Runcorn station",
                    "Salisbury station",
                    "Sandgate station",
                    "Sherwood station",
                    "South Bank station",
                    "South Brisbane station",
                    "Springfield Central station",
                    "Springfield station",
                    "Strathpine station",
                    "Sunnybank station",
                    "Sunshine station",
                    "Taringa station",
                    "Thagoona station",
                    "Thomas Street station",
                    "Thorneside station",
                    "Toombul station",
                    "Toowong station",
                    "Traveston station",
                    "Trinder Park station",
                    "Varsity Lakes station",
                    "Virginia station",
                    "Wacol station",
                    "Walloon station",
                    "Wellington Point station",
                    "Wilston station",
                    "Windsor station",
                    "Woodridge station",
                    "Wooloowin station",
                    "Woombye station",
                    "Wulkuraka station",
                    "Wynnum Central station",
                    "Wynnum North station",
                    "Wynnum station",
                    "Yandina station",
                    "Yeerongpilly station",
                    "Yeronga station",
                    "Zillmere station"
                ]
            }
        },
        "wbb": {
            "bus": {
                "routes": [
                    "600: City- Avenell Heights",
                    "601: City – Sugarland via Hospitals and Avoca",
                    "602: Sugarland – Avoca via Hospitals and City",
                    "603: Sugarland – Svensson Heights via Norville",
                    "604: Bundaberg Central – Kepnock (Loop)",
                    "605: City – Norville via Svensson Heights and Sugarland",
                    "606: City – Woongarra Village",
                    "607: City – North Bundaberg",
                    "608: Innes Park North – Sugarland via City and Bargara",
                    "609: City – Burnett Heads",
                    "610: Innes Park North – Sugarland via City and Bargara",
                    "621: Bundaberg – Moore Park Beach",
                    "622: Bundaberg – Elliott Heads and Innes Park",
                    "701: Town Centre to Fairfield",
                    "702: Town Centre to Newtown",
                    "703: Town Centre to Ulula",
                    "704: Town Centre to Granville",
                    "705: Maryborough to Hervey Bay",
                    "706: Town Centre to Tinana",
                    "707: Town Centre to Howard",
                    "710: Hervey Bay to Craignish and Dundo",
                    "711: Hervey Bay to Burrum Heads to Hervey Bay",
                    "713: Scarness Heights to Urraween",
                    "716: Pialba to Boat Harbour",
                    "717: Pialba to Urangan",
                    "718: Pialba to Urangan",
                    "720: Pialba to Eli Waters"
                ],
                "stops": {
                    "600: City- Avenell Heights": [
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Maryborough St at Bundaberg Central State School",
                        "Maryborough St at Hinkler Central",
                        "Maryborough St at Ruddell Street",
                        "Walker St at Targo Street",
                        "Water St near Beatrice St hail 'n' ride",
                        "Water St near Alice St hail 'n' ride",
                        "Hunter St at Sims Road",
                        "Gibson St at Dunn Road",
                        "Dunn Rd at Boreham Park",
                        "Dunn Rd at Blamey Street",
                        "Vandenberg St at Sinclair Street",
                        "McCarthy Rd at Walk Street",
                        "McCarthy Rd at Marcellos Street",
                        "McCarthy Rd near Bergin St hail 'n' ride",
                        "McCarthy Rd at Anderson Street",
                        "McCarthy Rd at Cawte Street",
                        "McCarthy Rd at Centennial Circuit",
                        "Elliott Heads Rd at Hay Street",
                        "Sims Rd at Auer Road",
                        "Sims Rd at Loney Street",
                        "Sims Rd at Redmond Street",
                        "Hunter St at Lloyd Street",
                        "Hurst St at Walkervale State School",
                        "Water St at Alice Street",
                        "Water St at Beatrice St",
                        "Maryborough St at Walker Street",
                        "Maryborough St at Bundaberg State High School",
                        "Bundaberg Plaza"
                    ],
                    "601: City – Sugarland via Hospitals and Avoca": [
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Maryborough St at Bundaberg Central State School",
                        "Maryborough St at Hinkler Central",
                        "Burrum St near Boreham Street",
                        "George St near Bingera St hail 'n' ride",
                        "Bingera St at Friendlies Hospital",
                        "Branyan St at Crofton Street",
                        "Mulgrave St at Woondooma Street",
                        "Branyan St at Bourbong Street",
                        "Bourbong St at Bundaberg Base Hospital",
                        "Bourbong St at Mater Hospital",
                        "Bourbong St at O'Connell Street",
                        "River Tce at Penny Street",
                        "River Tce at Palmer St",
                        "Duffy St at River Terrace",
                        "Duffy St at Avoca Street",
                        "Smiths Rd at Mayfair Place",
                        "Avoca Rd at Smiths Road",
                        "Dittmann Rd at Twyford Street",
                        "Twyford St near Argyle Gardens",
                        "Sugarland Plaza (Terminating Stop)"
                    ],
                    "602: Sugarland – Avoca via Hospitals and City": [
                        "Sugarland Plaza",
                        "Johnston St at Sugarland Gardens",
                        "Dittmann Rd at Twyford Street",
                        "Smiths Rd at Avoca Road",
                        "Smiths Rd at Loeskow Park",
                        "Avoca St at McCormack Street",
                        "Duffy St at Lewell Street",
                        "Duffy St at River Terrace",
                        "River Tce at Palmer Street",
                        "River Tce at Penny Street",
                        "Bourbong St at O'Connell Street",
                        "Bourbong St at Mater Hospital",
                        "Bourbong St at Bundaberg Base Hospital",
                        "Branyan St at Bourbong Street",
                        "Mulgrave St at Woondooma Street",
                        "Electra St at Branyan Street",
                        "Bingera St at Friendlies Hospital",
                        "Burrum St near George St hail 'n' ride",
                        "Bundaberg Plaza",
                        "Woongarra St at Library",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at City Centre"
                    ],
                    "603: Sugarland – Svensson Heights via Norville": [
                        "Sugarland Plaza",
                        "Warrell St at Johnston St",
                        "Watkin St at Moran Street",
                        "Williams Rd at Watkin Street",
                        "Dr Mays Rd at Gracehaven Aged Care",
                        "Parry St at Churchill St",
                        "Spence St at Child Street",
                        "Svensson St at Dexter Street",
                        "Page St at Alamein Street",
                        "Page St at Montgomery Street",
                        "Branyan St at Theodore Street",
                        "Branyan St at Coomber St",
                        "Faldt St at Bundaberg TAFE",
                        "Faldt St at Wynter Street",
                        "Faldt St at Mimnagh Street",
                        "Faldt St at Duncraigen Street",
                        "Faldt St at Halpin Street",
                        "Maynard St at Martens Oval",
                        "Maynard St at Leo Street",
                        "Maryborough St at Nott Street",
                        "Maryborough St at Walker Street",
                        "Maryborough St at Bundaberg State High School",
                        "Bundaberg Plaza",
                        "Woongarra St at Library",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at City Centre"
                    ],
                    "604: Bundaberg Central – Kepnock (Loop)": [
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Maryborough St at Hinkler Central",
                        "Maryborough St at Ruddell Street",
                        "Pitt St at Lamb Street",
                        "Pitt St at May Street",
                        "Pitt St near Alice Street",
                        "Pitt St at Hurst Street",
                        "Moncrieff St at Boundary Street",
                        "Moncrieff St at Livingstone Street",
                        "Elliott Heads Rd at Nixon Street",
                        "Elliott Heads Rd at Taylor Street",
                        "Churchward St at Peatey Street",
                        "Major Chapman St at Greenwood Street",
                        "Greenwood St at Kepnock Road",
                        "Jocumsen St at McVeigh Street",
                        "Lewis St at Sydney Street",
                        "Novakoski St at Fe Walker Street",
                        "Totten St at Miles Street",
                        "Totten St at Hargreaves Street",
                        "Burnett St at Hunter Street",
                        "Burnett St at Robert Street"
                    ],
                    "605: City – Norville via Svensson Heights and Sugarland": [
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Maryborough St at Bundaberg Central State School",
                        "Maryborough St at Hinkler Central",
                        "Maryborough St at Ruddell Street",
                        "Maynard St at Martens Oval",
                        "Faldt St at Halpin Street",
                        "Faldt St at Duncraigen Street",
                        "Faldt St at Mimnagh Street",
                        "Faldt St at Wynter St",
                        "Faldt St at Bundaberg TAFE",
                        "Branyan St at Joyce Street",
                        "Branyan St near Theodore St hail 'n' ride",
                        "Branyan St at Barnes Street",
                        "Page St at Montgomery Street",
                        "Page St at Alamein Street",
                        "Svensson St at Dexter St",
                        "Spence St at Child St",
                        "Churchill St at Parry St",
                        "Dr Mays Rd at Gracehaven Aged Care",
                        "Dr Mays Rd at Williams Street",
                        "Williams Rd at Watkin Street",
                        "Watkin St at Moran Street",
                        "Johnston St at Warrell St",
                        "Twyford St near Argyle Gardens",
                        "Sugarland Plaza (Terminating Stop)"
                    ],
                    "606: City – Woongarra Village": [
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Maryborough St at Bundaberg Central State School",
                        "Maryborough St at Hinkler Central",
                        "Maryborough St at Ruddell Street",
                        "Barolin St at Southside Central",
                        "Barolin St at IWC Centre",
                        "Blamey St at Vasey Street",
                        "Thomas Thomsen Dr at Broadmeadow Avenue",
                        "Thomas Thomsen Dr at Acacia Street",
                        "Thomas Thomsen Dr at Clearview Avenue",
                        "Wattle St at Sunset Drive",
                        "Searle St at Brooklyn Street",
                        "Searle St at Riedy Street",
                        "Goodwood Rd at Searle Street",
                        "Goodwood Rd at Wyllie Street",
                        "Goodwood Rd at Kellys Road",
                        "Heaps St at Barolin Street",
                        "Heaps St near McCrohon Street",
                        "Thabeban St at Barolin Street",
                        "Thabeban St near Barolin St hail 'n' ride",
                        "Maryborough St at Walker Street",
                        "Maryborough St at Bundaberg State High School",
                        "Bundaberg Plaza"
                    ],
                    "607: City – North Bundaberg": [
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Queen St near Gavin St hail 'n' ride",
                        "Barber St at Bundaberg North High School",
                        "King St near Loeskow St hail 'n' ride",
                        "Jefferis St near Bonney St hail 'n' ride",
                        "Jefferis St at Whittingtons Street",
                        "Cottell St at Queen Street",
                        "Queen St at Thygesen Street",
                        "Mount Perry Rd at Botanic Gardens",
                        "Walters St near Mt Perry Rd hail 'n' ride",
                        "Whittington St at Lakeview Drive",
                        "Rae St at Mount Perry Road",
                        "One Mile Rd near Mount Perry Rd hail 'n' ride",
                        "One Mile Rd near Cummins St hail 'n' ride",
                        "Hanbury Street at Brewer Street",
                        "Gavin St at Kolan Street",
                        "Queen St near Perry St hail 'n' ride",
                        "Quay St near Targo St hail 'n' ride"
                    ],
                    "608: Innes Park North – Sugarland via City and Bargara": [
                        "Woongarra Scenic Dr at Pandanus Crescent",
                        "Grevillea Ave near Cotton Tree Ct hail 'n' ride",
                        "21 Grevillea Ave hail 'n' ride",
                        "Poinciana Dr near Orlabah Ave hail 'n' ride",
                        "Orlabah Ave near Pacific Gardens Park",
                        "Rifle Range Rd near Woongarra Scenic Dr",
                        "Shoreline Cr at Bay Court",
                        "Shoreline Cr near Plymouth St hail 'n' ride",
                        "Plymouth St at Wilfred Street",
                        "Wearing Rd at Palm Lake Village",
                        "Wilfred St near Aqualine Ct hail 'n' ride",
                        "Wilfred St at Aqualine Court",
                        "Woongarra Scenic Dr at Bargara Lakes Drive",
                        "Woongarra Scenic Dr at Carlyle Gardens",
                        "Watsons Rd near Moodies Rd hail 'n' ride",
                        "Hughes Rd near Durdins Rd hail 'n' ride",
                        "Durdins Rd at Merchant Street",
                        "Durdins Rd at Trevors Road",
                        "Woongarra Scenic Dr near Dooley St hail 'n' ride",
                        "Woongarra Scenic Dr at Kelly's Beach",
                        "Miller St at The Causeway",
                        "Baxter St near Miller St hail 'n' ride",
                        "Garretts Way at Nielson Park",
                        "Holland St near Whalley St hail 'n' ride",
                        "Bauer St near Tanner Street",
                        "Croft St at Bauer St",
                        "Whalley St at Davidson St",
                        "Davidson St at Whalley St",
                        "Bargara Rd near Hughes Rd hail 'n' ride",
                        "Bargara Rd near Seaview Rd hail 'n' ride",
                        "Bargara Rd near Rehbein Ave hail 'n' ride",
                        "Bargara Rd at Kalkie State School",
                        "Bargara Rd near Coral Garden Drive",
                        "Bargara Rd at Meilene Street",
                        "Bargara Rd at Gahans Road",
                        "Bargara Rd at Olsen Street",
                        "Princess St at Cross Street",
                        "Bourbong St East near Kendall St hail 'n' ride",
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Maryborough St at Hinkler Central",
                        "Burrum St near Boreham Street",
                        "George St near Bingera St hail 'n' ride",
                        "Bingera St at Friendlies Hospital",
                        "Takalvan St at Powers Street",
                        "Takalvan St near Salter Oval hail 'n' ride",
                        "CQ University (Bundaberg)",
                        "Twyford St near Argyle Gardens",
                        "Sugarland Plaza (Terminating Stop)"
                    ],
                    "609: City – Burnett Heads": [
                        "Bundaberg Plaza",
                        "Woongarra St at Library",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at City Centre",
                        "Bourbong St E near Kendall St hail 'n' ride",
                        "Princess St at Cross Street",
                        "Bargara Rd near Olsen St hail 'n' ride",
                        "Bargara Rd at Bundaberg Brewed Drinks",
                        "Bargara Rd at Gahans Road",
                        "Bargara Rd at Meilene Street",
                        "Bargara Rd at Kalkie State School",
                        "Rowlands Rd near Powers Street",
                        "Marina Dr near Buss St hail 'n' ride",
                        "Marina Dr at Port Marina",
                        "Zunker St at Somerville Street",
                        "Zunker St at Jack Norgate Oval",
                        "Zunker St at Water Tower",
                        "Burnett Heads Rd near McKenzie St hail 'n' ride",
                        "Burnett Heads Rd at Burnett Heads State School",
                        "Campbell St at Moore Street",
                        "Shelley St near Dante St hail 'n' ride",
                        "Shell St at Shelley Street",
                        "Shell St near Sea Park Rd hail 'n' ride",
                        "Sea Park Rd at Kinch Street",
                        "Sea Park Rd near Mittelheusers Rd hail 'n' ride",
                        "Bargara Rd near Coral Garden Drive",
                        "Bargara Rd at Olsen Street",
                        "Bourbong St East near Kendall St hail 'n' ride"
                    ],
                    "610: Innes Park North – Sugarland via City and Bargara": [
                        "Sugarland Plaza",
                        "Twyford St near Argyle Gardens",
                        "CQ University (Bundaberg)",
                        "Sugarland Plaza (Terminating Stop)"
                    ],
                    "621: Bundaberg – Moore Park Beach": [
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Bundaberg Plaza",
                        "Queen St near Gavin St hail 'n' ride",
                        "Mount Perry Rd at Botanic Gardens",
                        "Mt Perry Rd near Rae St hail 'n' ride",
                        "Moore Park Rd near Mount Perry Rd hail 'n' ride",
                        "Murdochs Rd at Moore Park Beach shops",
                        "Murdochs Rd near Forest Way hail 'n' ride",
                        "Kingfisher Cr near Sylvan Dr hail 'n' ride",
                        "Sylvan Dr at Plum Tree Cr",
                        "Sylvan Dr at Ray Townson Park",
                        "Pacific Bvd near Tea Tree Ct hail 'n' ride",
                        "Park Dr at Moore Park Beach",
                        "Moore Park Rd near Gooburrum Rd hail 'n' ride",
                        "Mount Perry Rd at Wallace Drive",
                        "Mount Perry Rd near Young St hail 'n' ride",
                        "Queen St near Perry St hail 'n' ride"
                    ],
                    "622: Bundaberg – Elliott Heads and Innes Park": [
                        "Woongarra St at City Centre",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at Library",
                        "Maryborough St at Hinkler Central",
                        "Maryborough St at Ruddell Street",
                        "Totten St near Kepnock Rd hail 'n' ride",
                        "Baker St near Elliott Heads Rd hail 'n' ride",
                        "Elliott Heads Rd near Bells Rd hail 'n' ride",
                        "Innes Park Rd near Carla Rd hail 'n' ride",
                        "Esplanade at Esplanade Innes Park",
                        "Homestead Bvd at Peggy Drive",
                        "Back Hill Rd at Toppers Dr",
                        "Bisdee St at Tulipwood Place",
                        "Barolin Esp near Homestead Bvd hail 'n' ride",
                        "Barolin Esp at Mokera Street",
                        "Barolin Esp at Homestead Boulevard",
                        "Barolin Esp at Coral Cove Drive",
                        "Coral Cove Dr at Bisdee Street",
                        "Breusch Rd near Elliott Heads Rd hail 'n' ride",
                        "Corolla St near Esplanade hail 'n' ride",
                        "Bathurst St at Wondrock Street",
                        "Bathurst St at Moore Street",
                        "Lihs St at Elliott Heads Beach",
                        "Elliott Heads Rd near Riverview Rd hail 'n' ride",
                        "Maryborough St at Walker Street",
                        "Maryborough St at Bundaberg State High School",
                        "Bundaberg Plaza"
                    ],
                    "701: Town Centre to Fairfield": [
                        "Station Square Shopping Centre",
                        "Kent St at Maryborough High School hail 'n' ride",
                        "Kent Street at Pallas Street",
                        "Kent Street at Amity Street",
                        "Kent St at Yaralla Street",
                        "Kent St at Neptune Street",
                        "Kent St at Christensen Crescent",
                        "Jupiter St at Clayton Street",
                        "Stafford St at Alan Street",
                        "Stafford St at Croydon Street",
                        "Walker Street at Matthies Street",
                        "Walker Street at Price Street",
                        "Walker Street at Stevenson Street",
                        "Reed Avenue at Hunter Street",
                        "Dunn Street at Boys Avenue",
                        "Boys Ave near Dunn St hail 'n' ride",
                        "Boys Avenue at Bryant Street",
                        "Neptune St at Corser Avenue",
                        "Neptune St Maryborough Hospital",
                        "Walker St at Maryborough Hospital",
                        "Walker Street at Amity Street",
                        "Ariadne St near Milton St hail 'n' ride",
                        "Ariadne Street at Churchill Street",
                        "Churchill St at Ariadne Street",
                        "Churchill Street at Pallas Street",
                        "Pallas Street at Milton Street",
                        "Walker Street at Ferry Street",
                        "John St at St Marys Primary School",
                        "Kent St opp City Hall",
                        "Richmond Street at Kent Street",
                        "Maryborough Central Shopping Centre"
                    ],
                    "702: Town Centre to Newtown": [
                        "Woodstock Street at Cheapside Street",
                        "Ariadne St at Bedford Street",
                        "Thurecht Street at Bedford Street",
                        "Thurecht St at Victory Street",
                        "Victory Street at James Street",
                        "Cheapside St at Margaret Street",
                        "Pallas St at Margaret Street",
                        "Pallas Street at Robinson Street",
                        "Wilson St at Gaynor Street",
                        "Saltwater Creek Rd at Demaine St",
                        "Gaynor St at Salwater Creek Road",
                        "Grosvenor St at Treasure Street",
                        "Treasure Street at John Street",
                        "John Street at Doonvilla Avenue",
                        "John St at Saltwater Creek Road",
                        "John Street at Churchill Street",
                        "John St at St Marys Primary School",
                        "Kent St opp City Hall",
                        "Richmond Street at Kent Street",
                        "Maryborough Central Shopping Centre",
                        "Station Square Shopping Centre",
                        "John St at Maryborough Central School",
                        "John St Opp St St Mary's Primary School",
                        "Churchill Street at Goodwin Lane",
                        "Tooley Street at Ella Street",
                        "Tooley Street at Frank Street",
                        "Treasure Street at Waratah Street",
                        "Smith St at Iris Street",
                        "Smith St at Dawson Street",
                        "Moreton Street at John Street"
                    ],
                    "703: Town Centre to Ulula": [
                        "Station Square Shopping Centre",
                        "Kent St opp City Hall",
                        "Richmond Street at Kent Street",
                        "Maryborough Central Shopping Centre",
                        "Ann St near Lennox St hail 'n' ride",
                        "Ann Street at John Street South",
                        "Ann Street at Ferry Street",
                        "Ann Street at Tooley Street South",
                        "Ann Street at Pleasant Street",
                        "Cheapside St Sth at Alice Street",
                        "Cheapside St Sth at Richard Street",
                        "George St at Morning Street",
                        "George Street at Jupiter Street South",
                        "Jupiter Street at Alice Street",
                        "Alice Street Opp Sunbury State School",
                        "Alice St near Aldridge St hail 'n' ride",
                        "Maryborough Biggenden Rd near Royale St",
                        "Nagel Street at Copenhagen Street",
                        "Maryborough Biggenden Road at Gayndah Road",
                        "Jupiter St near Sunbury Preschool hail 'n' ride",
                        "Russell St at Raven Street",
                        "Kent Street at Russell Street",
                        "Jupiter St at Clayton Street",
                        "Stafford St at Alan Street",
                        "Stafford St at Croydon Street",
                        "Walker Street at Matthies Street",
                        "Walker Street at Price Street",
                        "Walker Street at Stevenson Street",
                        "Reed Avenue at Hunter Street",
                        "Dunn Street at Boys Avenue",
                        "Boys Ave near Jupter St hail 'n' ride",
                        "Walker St at Saint Clair Avenue",
                        "Walker St at Maryborough Hospital",
                        "North St near Maryborough West School HnR",
                        "Yaralla Street at Sussex Street",
                        "Sussex Street at Amity Street",
                        "Sussex St at Cheapside Street",
                        "Sussex St near Palmas St hail 'n' ride",
                        "Tooley Street at Wood Street",
                        "Kent St at Maryborough High School",
                        "John St at Maryborough Central School",
                        "John St Opp St St Mary's Primary School",
                        "Alice St at Senior Citizens Centre"
                    ],
                    "704: Town Centre to Granville": [
                        "Station Square Shopping Centre",
                        "Kent St opp City Hall",
                        "Richmond Street at Kent Street",
                        "Dundas Street at Odessa Street",
                        "Dundas Street at Cardigan Street",
                        "Cardigan Street at Cambridge Street",
                        "Cambridge St at Blackbourn Street",
                        "Cambridge St at Louis Street",
                        "Cambridge Street at Matthew Parade",
                        "Bushnell Street at Grevillea Drive",
                        "Jocelyn Parade at Hoffman Street",
                        "Hoffmann Street at Arnaud Street",
                        "Arnaud St at Cardigan Street",
                        "Cardigan St at Banana Street",
                        "Banana Street at Murray Street",
                        "Banana St at Dale Street",
                        "Wolseley Street at Banana Street",
                        "Steindl Street at Regent Street",
                        "Steindl Street at Odessa Street",
                        "Odessa Street at Arnaud Street",
                        "Odessa Street at Miramont Street",
                        "Maryborough Central Shopping Centre",
                        "Albert Street at Zante Street",
                        "Guava Street at Alice Street",
                        "Raglan St near Wolseley St hail 'n' ride"
                    ],
                    "705: Maryborough to Hervey Bay": [
                        "Kent St at City Hall",
                        "Station Square Shopping Centre",
                        "John St at Maryborough Central School",
                        "John St Opp St St Mary's Primary School",
                        "John Street at Churchill Street",
                        "Saltwater Creek Rd at Woodstock St",
                        "Saltwater Creek Rd at Demaine St",
                        "Saltwater Creek Rd at Airport Drive",
                        "Saltwater Crk Rd near Maryborough Sports Clb HnR",
                        "Hervey Bay Rd at Churchill Mine Rd hail 'n' ride",
                        "Hervey Bay Rd near Moes Rd hail 'n' ride",
                        "Hervey Bay Rd near Piggford Lane hail 'n' ride",
                        "Hervey Bay Rd near Nikenbah Dundowran Rd HnR",
                        "Hervey Bay Rd near Scrubhill Rd hail 'n' ride",
                        "Urraween Rd near Cooks Rd hail 'n' ride",
                        "Urraween Rd at Madsens Road",
                        "Hospitals, Nissan Street",
                        "Nissen Street at Caddy Avenue",
                        "Nissen Street at Boat Harbour Drive",
                        "Beach Road at Boat Harbour Drive",
                        "Old Maryborough Rd at Hervey Bay High",
                        "Old Maryborough Rd Opp University",
                        "Torquay Road, Opp RSL",
                        "Torquay Road at Bryant Street",
                        "Torquay Road at Neils St",
                        "Torquay Road at Zephyr Street",
                        "Esplanade at Scarness Caravan Park",
                        "Esplanade at Denmans Camp Road",
                        "Esplanade at Tavistock Street",
                        "Esplanade at Bideford Street",
                        "Esplanade at Fraser Street",
                        "Esplanade at Robert Street",
                        "Esplanade at Ann Street",
                        "Esplanade at Alexander Street",
                        "Esplanade at New Street",
                        "Esplanade at Elizabeth Street",
                        "Charlton Esp near Pier St hail 'n' ride",
                        "Pier Street East at Hibiscus Street",
                        "Pilot Street at Shell Street",
                        "Dayman Street at Hansen Street",
                        "Dayman Street at Pulgul Street",
                        "Buccaneer Drive at Miller Street",
                        "Miller Street at Pulgul Street",
                        "Pulgul Street at Boat Harbour Drive",
                        "Boat Harbour Drive at Hansen Street",
                        "Boat Harbour Drive at Riley Street",
                        "Boat Harbour Drive Opp Urangan Central",
                        "Boat Harbour Drive at Edith Street",
                        "Boat Harbour Drive at Robertson Street",
                        "Boat Harbour Drive at Robert Street",
                        "Boat Harbour Drive at Honiton Street",
                        "Boat Harbour Drive at Urangan Street",
                        "Boat Harbour Drive at Dartmouth Street",
                        "Denmans Camp Road at Totness St",
                        "Torquay Road at Gossner Street",
                        "Torquay Road at Down Street",
                        "Torquay Road at Stephenson Street",
                        "Torquay Road at Neils Street",
                        "Torquay Road at Bay Plaza",
                        "RSL, Torquay Rd",
                        "Main St at Pialba Place Shops",
                        "Old Maryborough Rd at Library/Uni",
                        "Old Maryborough Rd at Liuzzi St",
                        "Central Ave at Stockland Hervey Bay",
                        "Old Maryborough Rd near Newhaven St hail 'n' ride",
                        "Old Maryborough Road at Hastings Street",
                        "MBH-HB Rd opp Eli Waters Shopping Centre",
                        "Hervey Bay Rd near Lord St hail 'n' ride",
                        "Maryborough-Hervey Bay Road at Noble Road",
                        "Maryborough-Hervey Bay Rd at Dundathu",
                        "Saltwater Ck Rd near Maryborough Sports Club HnR",
                        "Saltwater Creek Rd at Maryborough Airport",
                        "Saltwater Creek Rd at Gaynor Street",
                        "Saltwater Creek Rd at Woodstock Street",
                        "Saltwater Creek Rd at Ashton Street",
                        "John St at St Marys Primary School",
                        "Kent St at Maryborough High School hail 'n' ride",
                        "Kent Street at Pallas Street",
                        "Neptune St Maryborough Hospital",
                        "Walker St at Maryborough Hospital",
                        "Walker Street at Amity Street",
                        "Kent St at Maryborough High School",
                        "Hervey Bay TAFE",
                        "Boat Harbour Dr at Fraser Shores Shops",
                        "Boat Harbour Dr near Nissen St hail 'n' ride",
                        "Nissen Street at Chancellor Drive",
                        "Nissen St near Fraser Shores Village hail 'n' ride",
                        "Nissen St at Hospital",
                        "Urraween Rd near Madsen Rd hail 'n' ride"
                    ],
                    "706: Town Centre to Tinana": [
                        "Kent St opp City Hall",
                        "Richmond Street at Kent Street",
                        "Maryborough Central Shopping Centre",
                        "Station Square Shopping Centre",
                        "Ann Street at John Street South",
                        "Ann Street at Ferry Street",
                        "Queen St near Queens Pl hail 'n' ride",
                        "Gympie Rd at Cran Street",
                        "Woongool Rd near Uhlmann St hail 'n' ride",
                        "High St near Groth St hail 'n' ride",
                        "Teddington Rd near Iindah Rd East hail 'n' ride",
                        "Gympie Rd at Oleander Drive",
                        "Kurrajong Way near Cedar Ct hail 'n' ride",
                        "Kurrajong Way near Tinana Greens hail 'n' ride",
                        "Walworth St near Gympie Rd hail 'n' ride",
                        "Gympie Rd near Walworth St hail 'n' ride",
                        "Gympie Rd near Eatonvale Rd hail 'n' ride",
                        "Taylor St near Mackay Dr hail 'n' ride",
                        "Ferry St near Queen St hail 'n' ride",
                        "Ellena Street at Tooley Street near Chelsea Village",
                        "Alice St at Senior Citizens Centre"
                    ],
                    "707: Town Centre to Howard": [
                        "Opp. Howard State School, William Street",
                        "Coal St near Watkins St hail 'n' ride",
                        "Steley Street opp Library",
                        "Torbanlea, Robertson Street at Crawford Street",
                        "Aldershot, Vaughan Street near Smelter Street",
                        "Walker Street at Matthies Street",
                        "Searle St near Aldridge State High School hail 'n' ride",
                        "Walker St at Saint Clair Avenue",
                        "Walker St at Maryborough Hospital",
                        "Walker Street at Amity Street",
                        "Ariadne St near Milton St hail 'n' ride",
                        "Ariadne Street at Churchill Street",
                        "Neptune St at Corser Avenue",
                        "Neptune St Maryborough Hospital",
                        "Walker Street at Ferry Street",
                        "John St at St Marys Primary School",
                        "Kent St at Maryborough High School hail 'n' ride",
                        "Lennox St at St Marys College hail 'n' ride",
                        "Ann Street at John Street South",
                        "Station Square Shopping Centre",
                        "Kent St opp City Hall",
                        "Richmond Street at Kent Street",
                        "Maryborough Central Shopping Centre",
                        "Kent Street at Pallas Street",
                        "Boys Ave near Jupter St hail 'n' ride",
                        "Bruce Hwy near Torbanlea Service Station HnR",
                        "Robertson St near Crawford St hail 'n' ride",
                        "Howard, Steley Street near William Street hail 'n' ride",
                        "Howard State School, William St",
                        "Walker Street at Price Street",
                        "Walker Street at Stevenson Street",
                        "Kent St at Maryborough High School"
                    ],
                    "710: Hervey Bay to Craignish and Dundo": [
                        "Torquay Road at Bay Plaza",
                        "Main St at Pialba Place Shops",
                        "Main Street at Rose St",
                        "Central Ave at Stockland Hervey Bay",
                        "Boat Harbour Dr at Fraser Shores Shops",
                        "Nissen Street at Chancellor Drive",
                        "Nissen St near Fraser Shores Village hail 'n' ride",
                        "Nissen St at Hospital",
                        "Urraween Rd near Madsen Rd hail 'n' ride",
                        "Urraween Rd near Cooks Rd hail 'n' ride",
                        "Urraween Rd near Scrub Hill Rd hail 'n' ride",
                        "Lower Mountain Rd at Dundowran Hall",
                        "Crawford Dr near Pedelty Lane hail 'n' ride",
                        "Karraschs Rd near Pialba Burrum Heads Rd HnR",
                        "Karraschs Rd at Broadway Drive",
                        "Craignish Rd near McCarthy Rd hail 'n' ride",
                        "Petersen Rd near Straits Outlook hail 'n' ride",
                        "Hamilton Dr near Castles Rd hail 'n' ride",
                        "Cedar Rd at Pacific Promenade",
                        "Straits Outlook near Estate St hail 'n' ride",
                        "Sawmill Rd at Annette Street",
                        "Sawmill Rd near Homebush Rd hail 'n' ride",
                        "Sawmill Rd near Ocean Park Dr hail 'n' ride",
                        "Sempfs Rd at Panorama Drive",
                        "Panorama Dr near Akarra Lagoons hail 'n' ride",
                        "Panorama Dr near Hennessy Dr hail 'n' ride",
                        "Ansons Rd near Hennessy Dr hail 'n' ride",
                        "Urraween Rd at Madsens Road",
                        "Hospitals, Nissan Street",
                        "Nissen Street at Caddy Avenue",
                        "Nissen Street at Boat Harbour Drive"
                    ],
                    "711: Hervey Bay to Burrum Heads to Hervey Bay": [
                        "Torquay Road at Bay Plaza",
                        "Main St at Pialba Place Shops",
                        "Main Street at Rose St",
                        "Central Ave at Stockland Hervey Bay",
                        "Boat Harbour Dr at Fraser Shores Shops",
                        "MBH-HB Rd opp Eli Waters Shopping Centre",
                        "Pialba Burrum Heads Rd near Valfern Ct HnR",
                        "Pialba Burrum Heads Rd at Mitchell Avenue",
                        "Pialba Burrum Heads Rd near Toogoom Rd HnR",
                        "Pialba Burrum Heads Rd near Belbi Creek Rd HnR",
                        "Burrum Heads Rd near Orchid Dr hail 'n' ride",
                        "Burrum Heads Road nr Ivor Drv",
                        "Ross St near Sunrise Cr hail 'n' ride",
                        "Riverview Dr near Sunrise Cr hail 'n' ride",
                        "Riverview Dr near Ross St hail 'n' ride",
                        "Ross St near Howard St hail 'n' ride",
                        "Burrum St near Ross St hail 'n' ride",
                        "Burrum St opp Burrum St (Shops)",
                        "Burrum Street at Torbanlea Street",
                        "Howard St at Burrum Heads Hall",
                        "Pialba Burrum Heads Rd near Burrum Heads Rd hail 'n' ride",
                        "Pialba Burum Heads Rd near Beelbi Creek Rd HnR",
                        "Pialba Burrum Heads Rd near Toogoom Rd hail'n'ride",
                        "Toogoom Rd at Delrose Court near Hall",
                        "Toogoom Rd near Lorikeet Ave hail 'n' ride",
                        "Mark Ave near Lorikeet Ave hail 'n' ride",
                        "Kingfisher Pde at Morris Rd hail 'n' ride",
                        "Kingfisher Pde near Sea Beach Way hail 'n' ride",
                        "Jeppeson Rd at Desmond Drive hail 'n' ride",
                        "O Regan Creek Rd near Yram Pl hail 'n' ride",
                        "O Regan Creek Rd near Carkeet Rd hail 'n' ride",
                        "Carkeet Rd near Porpita Cct hail 'n' ride",
                        "MBH-HB Rd at Eli Waters Shopping Centre"
                    ],
                    "713: Scarness Heights to Urraween": [
                        "Central Ave at Stockland Hervey Bay",
                        "Torquay Road at Bay Plaza",
                        "RSL, Torquay Rd",
                        "Main St at Pialba Place Shops",
                        "Main Street at Rose St",
                        "Boat Harbour Drive at Taylor Street",
                        "Boat Harbour Drive at McNally Street",
                        "Boat Harbour Drive at Queens Road",
                        "Hillcrest Avenue at Kululu Crescent",
                        "Kululu Crescent at Wuruma St",
                        "Kululu Crescent at Junjaree Street",
                        "Honeysuckle Ave at Kawungan School",
                        "Magnolia St at Honeysuckle Avenue",
                        "Oleander Rd near Denmans Camp Rd hail 'n' ride",
                        "Squire St near Marlin St hail 'n' ride",
                        "Doolong Road at Bream Street",
                        "Ian Ave near Doolong Road hail 'n'ride",
                        "Ian Avenue at Victor Drive",
                        "Julie Anne St near Nicholson Cct hail 'n' ride",
                        "Johnston Bvd near Andersen Ave hail 'n' ride",
                        "Hervey Bay TAFE",
                        "Hospitals, Nissan Street",
                        "Nissen Street at Caddy Avenue",
                        "Nissen Street at Boat Harbour Drive",
                        "Doolong Rd near Main St hail 'n' ride"
                    ],
                    "716: Pialba to Boat Harbour": [
                        "Central Ave at Stockland Hervey Bay",
                        "Beach Road at Boat Harbour Drive",
                        "Old Maryborough Rd at Hervey Bay High",
                        "Old Maryborough Rd Opp University",
                        "Torquay Road, Opp RSL",
                        "Torquay Road at Bryant Street",
                        "Torquay Road at Neils St",
                        "Torquay Road at Zephyr Street",
                        "Torquay Road at Queens Road",
                        "Torquay Road at Gossner St",
                        "Denmans Camp Rd at Senior Citzens Centre",
                        "Boat Harbour Drive at Macbel Court",
                        "Boat Harbour Drive at Urangan Street",
                        "Boat Harbour Drive at Honiton Street",
                        "Boat Harbour Drive at Robert Street",
                        "Boat Harbour Drive at Torquay Terrace",
                        "Boat Harbour Drive at Robertson Street",
                        "Boat Harbour Drive at Toni Street",
                        "Boat Harbour Drive at Elizabeth Street",
                        "Boat Harbour Drive at Riley Street",
                        "Boat Harbour Drive at Hansen Street",
                        "Boat Harbour Drive at Caringa Street",
                        "Boat Harbour Drive at Charlton Street",
                        "Buccaneer Drive at Miller Street",
                        "Miller Street at Pulgul Street",
                        "Pulgul Street at Dayman Street",
                        "King Street at Kent Street",
                        "Pier Street at Hibiscus Street",
                        "Charlton Esp near Pier St hail 'n' ride",
                        "Charlton Esp at Elizabeth Street",
                        "Esplanade at Margaret Street",
                        "Esplanade near Alexander St hail 'n' ride",
                        "Esplanade at Ann Street",
                        "Esplanade at Robert St",
                        "Esplanade at Fraser Street",
                        "Esplanade at Bideford Street",
                        "Esplanade at Tavistock Street",
                        "Esplanade at Denmans Camp Road",
                        "Esplanade at Queens Road",
                        "Torquay Road at Stephenson Street",
                        "Torquay Road at Neils Street",
                        "Torquay Road at Bay Plaza",
                        "RSL, Torquay Rd",
                        "Main St at Pialba Place Shops",
                        "Old Maryborough Rd at Library/Uni",
                        "Old Maryborough Rd at Liuzzi St"
                    ],
                    "717: Pialba to Urangan": [
                        "Central Ave at Stockland Hervey Bay",
                        "Main Street near Rose St",
                        "Torquay Road, Opp RSL",
                        "Torquay Road at Bryant Street",
                        "Torquay Road at Neils St",
                        "Torquay Road at Zephyr Street",
                        "Torquay Road at Queens Road",
                        "Torquay Road at Gossner St",
                        "Tavistock St near Torquay Tce hail 'n' ride",
                        "Tavistock St at Torbay Retirement Villiage",
                        "Colyton St near Madeleine St hail 'n' ride",
                        "Boat Harbour Drive at Toni Street",
                        "Boat Harbour Drive at Elizabeth Street",
                        "Aimee Drive at Twolyn Street",
                        "Pulgul St at Aimee Drive",
                        "Pulgul St near Boat Harbour Dr hail 'n' ride",
                        "Cypress St at Margaret Street",
                        "Cypress Street at Ann Street",
                        "Ann St near Cypress St hail 'n' ride",
                        "Truro St near Ann St hail 'n' ride",
                        "Truro St near Robert St hail 'n' ride",
                        "Truro Street at Fraser Street",
                        "Torquay Tce near Tavistock St hail 'n' ride",
                        "Torquay Tce at Torquay State School",
                        "Torquay Road at Gossner Street",
                        "Torquay Road at Down Street",
                        "Torquay Road at Stephenson Street",
                        "Torquay Road at Neils Street",
                        "Torquay Road at Bay Plaza",
                        "RSL, Torquay Rd",
                        "Main St at Pialba Place Shops",
                        "Main Street at Rose St"
                    ],
                    "718: Pialba to Urangan": [
                        "Central Ave at Stockland Hervey Bay",
                        "Main Street near Rose St",
                        "Torquay Road, Opp RSL",
                        "Torquay Road at Bryant Street",
                        "Torquay Road at Neils St",
                        "Torquay Road at Zephyr Street",
                        "Torquay Road at Queens Road",
                        "Torquay Road at Gossner St",
                        "Torquay Terrace at Tavistock Street",
                        "Torquay Terrace at Bideford St",
                        "Fraser Street at Truro Street",
                        "Truro Street at Robert Street",
                        "Truro Street at Ann Street",
                        "Ann Street at Cypress Street",
                        "Cypress St near Ann St hail 'n' ride",
                        "Cypress Street at Margaret Street",
                        "Cypress St near Margaret St hail 'n' ride",
                        "Pulgul Street at Boat Harbour Drive",
                        "Aimee Drive at Seaspray Court",
                        "Boat Harbour Drive Opp Urangan Central",
                        "Robertson Street at Hammon Street",
                        "Southerden St near Honiton St hail 'n' ride",
                        "Tavistock Street at Moonlight Avenue",
                        "Tavistock Street at Exeter Street",
                        "Tavistock St at Torquay Pre School",
                        "Tavistock St at Torquay State School",
                        "Torquay Tce at Torquay State School",
                        "Torquay Road at Gossner Street",
                        "Torquay Road at Down Street",
                        "Torquay Road at Stephenson Street",
                        "Torquay Road at Neils Street",
                        "Torquay Road at Bay Plaza",
                        "RSL, Torquay Rd",
                        "Main St at Pialba Place Shops",
                        "Main Street at Rose St"
                    ],
                    "720: Pialba to Eli Waters": [
                        "Central Ave at Stockland Hervey Bay",
                        "Torquay Road at Bay Plaza",
                        "RSL, Torquay Rd",
                        "Main St at Pialba Place Shops",
                        "Main Street at Rose St",
                        "Hervey Bay TAFE",
                        "Hospitals, Nissan Street",
                        "Nissen Street at Caddy Avenue",
                        "Caddy Ave near Gumtree Dr hail 'n' ride",
                        "Bunker Ave near Fairway Dr hail 'n' ride",
                        "Ibis Boulevard at Lake View Court",
                        "Bowerbird Ave near Ibis Bvd hail 'n' ride",
                        "Bowerbird Av near Thornbill",
                        "Ibis Bvd near Wattlebird Lane hail 'n' ride",
                        "Ibis Boulevard at Wattlebird Lane"
                    ]
                }
            },
            "schoolbus": {
                "routes": [
                    "650: Thabeban, Avenell Heights, Kepnock, City",
                    "651: Belle Eden, Gahans Rd, East, City, Shalom",
                    "652: St Marys, Kepnock SHS, Shalom",
                    "653: Shalom, Bundaberg SHS, St Josephs, Bargara",
                    "654: Bargara, Kepnock, Shalom College",
                    "655: Kepnock SHS, Bargara, Bargara North",
                    "656: Kepnock SHS, Bargara South",
                    "658: Burnett Heads, Kepnock SHS",
                    "661: Gin Gin, North SHS, Bundaberg SHS, Shalom",
                    "662: Sandy Hook, Branyan, Bundaberg SHS, Shalom",
                    "663: St Lukes Anglican, City, Avoca, Kensington",
                    "664: Avoca, West SS, Bundaberg SHS",
                    "667: Arcadia Park, Branyan, BSHS, Kepnock, BCC",
                    "670: Nolans Pocket",
                    "671: South Kolan",
                    "672: Sharon",
                    "673: Tantitha",
                    "674: Booyan",
                    "675: Moore Park Beach, Gooburrum, and Tantitha",
                    "676: Moore Park Beach",
                    "677: Riverview and Coral Cove",
                    "678: Innes Park",
                    "680: Dahls Road, Innes Park North",
                    "681: Riverview and Coral Cove",
                    "682: Bargara, Innes Park North, and Coral Cove",
                    "758: 758 School",
                    "763: 763 School",
                    "769: 769 School",
                    "770: 770 School",
                    "772: 772 School",
                    "773: 773 School",
                    "774: 774 School",
                    "775: 775 School",
                    "776: 776 School",
                    "777: 777 School",
                    "778: 778 School",
                    "779: 779 School",
                    "780: 780 School",
                    "781: 781 School",
                    "783: 783 School",
                    "784: 784 School",
                    "785: 785 School",
                    "786: 786 School",
                    "787: 787 School",
                    "788: 788 School",
                    "789: 789 School",
                    "790: 790 School",
                    "797: 797 School",
                    "800: 800 School",
                    "801: 801 School",
                    "802: 802 School",
                    "805: 805 School"
                ],
                "stops": {
                    "650: Thabeban, Avenell Heights, Kepnock, City": [
                        "Thabeban St near Barolin St hail 'n' ride",
                        "Blamey St at Vasey Street",
                        "Thomas Thomsen Dr at Broadmeadow Avenue",
                        "Thomas Thomsen Dr at Clearview Avenue",
                        "Wattle St at Sunset Drive",
                        "Searle St at Brooklyn Street",
                        "Goodwood Rd at Searle Street",
                        "Thabeban State School",
                        "McCarthy Rd near Goodwood Rd hail 'n' ride",
                        "McCarthy Rd near Frank Gilbert Dr hail 'n' ride",
                        "St Marys Catholic School",
                        "McCarthy Rd at Anderson Street",
                        "Elliott Heads Rd near Rattray St hail 'n' ride",
                        "Kepnock Rd near Elliott Heads Rd hail 'n' ride",
                        "Totten St near Kepnock Rd hail 'n' ride",
                        "Novakoski St near Kepnock Rd hail 'n' ride",
                        "Walker St near Maryborough St hail 'n' ride",
                        "Maryborough St near Ruddell St hail 'n' ride",
                        "Maryborough St at Bundaberg Central State School",
                        "Woondooma St near Barolin St hail 'n' ride",
                        "Tantitha St naer Woongarra St hail 'n' ride",
                        "Woongarra St at Library",
                        "Bundaberg North State School",
                        "North Bundaberg State High School",
                        "Bundaberg Gin Gin Rd near Queen St hail 'n' ride",
                        "Maryborough St at Post Office hail 'n' ride",
                        "Maryborough St at Hinkler Central",
                        "Maryborough St at Ruddell Street",
                        "Kepnock State High School",
                        "Anderson St near Hay St hail 'n' ride",
                        "Cole St near McGill Cr hail 'n' ride",
                        "Blamey St near Vasey St hail 'n' ride"
                    ],
                    "651: Belle Eden, Gahans Rd, East, City, Shalom": [
                        "Row St near Elliott Heads Rd hail 'n' ride",
                        "Greathead Rd near Lomandra Dr hail 'n' ride",
                        "Sienna Bvd near Bundaberg Ring Rd hail 'n' ride",
                        "Sergiacomi Dr near Torrisi Pl hail 'n' ride",
                        "Coral Garden Dr near Telegraph Rd hail 'n' ride",
                        "Bargara Rd near Coral Garden Drive",
                        "Bargara Rd at Meilene Street",
                        "Swan Dr near Seymore Ave hail 'n' ride",
                        "Bargara Rd at Gahans Road",
                        "Schulte St near Leivesley St hail 'n' ride",
                        "Telegraph Rd near Leivesley St hail 'n' ride",
                        "Bundaberg East State School",
                        "Bourbong St East near Kendall St hail 'n' ride",
                        "Maryborough St at Bundaberg Central State School",
                        "Maryborough St at Hinkler Central",
                        "Maryborough St near Ruddell St hail 'n' ride",
                        "Walker St near Maryborough St hail 'n' ride",
                        "Barolin St at Southside Central",
                        "Maynard St near Barolin St hail 'n' ride",
                        "Maynard St at Martens Oval",
                        "Maynard St near Fleming St hail 'n' ride",
                        "Brother Hogan Dr near Fitzgerald St hail 'n' ride",
                        "Shalom College",
                        "Fitzgerald St near McDonald Ct hail 'n' ride",
                        "Branyan St near Montgomery St hail 'n' ride",
                        "Branyan St at Theodore Street",
                        "Branyan St at Coomber St",
                        "George St at St Patricks State School HnR",
                        "Branyan St at Joyce Street",
                        "Maynard St near Maryborough St hail 'n' ride",
                        "Maryborough St at Walker Street",
                        "Maryborough St at Bundaberg State High School",
                        "Woongarra St at Library",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St at City Centre",
                        "Woongarra St near Walla St hail 'n' ride",
                        "Bourbong St E near Kendall St hail 'n' ride",
                        "Elliott Heads Rd near Robertson St hail 'n' ride"
                    ],
                    "652: St Marys, Kepnock SHS, Shalom": [
                        "Woongarra Scenic Dr at Rifle Range Road",
                        "Woongarra Scenic Dr at Pandanus Crescent",
                        "Kepnock State High School",
                        "Bundaberg Christian School",
                        "Bargara Rd near Hughes Rd hail 'n' ride",
                        "Bargara Rd near Davidson St hail 'n' ride",
                        "Davidson St at Whalley St",
                        "Bauer St at Croft St",
                        "Bauer St near Grimwood St hail 'n' ride",
                        "Bauer St at Holland Street",
                        "Esplanade at Esplanade Bargara",
                        "Baxter St near Miller St hail 'n' ride",
                        "Miller St near The Causeway hail 'n' ride",
                        "Woongarra Scenic Dr at Kelly's Beach",
                        "Durdins Rd at Trevors Road",
                        "Durdins Rd at Judith Street",
                        "Hughes Rd near Durdins Rd hail 'n' ride",
                        "Watsons Rd near Isaac St hail 'n' ride",
                        "Watsons Rd near Moodies Rd hail 'n' ride",
                        "Woongarra Scenic Dr near Watsons Rd hail 'n' ride",
                        "Woongarra Scenic Dr at Carlyle Gardens",
                        "Woongarra Scenic Dr near Bargara Lakes Dr HnR",
                        "Wilfred St near Woongarra Scenic Dr hail 'n' ride",
                        "Moodies Rd near Woongarra Scenic Dr hail 'n' ride",
                        "Rifle Range Rd near Kathleen Dr hail 'n' ride",
                        "Windermere Rd near Rifle Range Rd hail 'n' ride",
                        "Windermere Rd near Burnett Heads Rd hail 'n' ride",
                        "Fe Walker St near Bundaberg Ring Rd hail 'n' ride",
                        "Fe Walker St near Link Rd hail 'n' ride",
                        "Novakoski St near Fe Walker hail 'n' ride",
                        "Novakoski St near Kepnock Rd hail 'n' ride",
                        "Elliott Heads Rd at Taylor Street",
                        "Elliott Heads Rd near Anderson St hail 'n' ride",
                        "Anderson St near Hay St hail 'n' ride",
                        "St Marys Catholic School",
                        "Cole St near McGill Cr hail 'n' ride",
                        "Vandenberg St near Sinclair St hail 'n' ride",
                        "Blamey St near Grigor St hail 'n' ride",
                        "Sims Rd at Loney Street",
                        "Sims Rd at Redmond Street",
                        "Barolin St at IWC Centre",
                        "Maynard St near Barolin St hail 'n' ride",
                        "Maynard St at Martens Oval",
                        "Maynard St near Fleming St hail 'n' ride",
                        "Brother Hogan Dr near Fitzgerald St hail 'n' ride",
                        "Shalom College",
                        "Sims Rd near Aldridge St hail 'n' ride",
                        "Dunn Rd at Blamey Street",
                        "Vandenberg St at Sinclair Street",
                        "McCarthy Rd at Walk Street",
                        "McCarthy Rd near Frank Gilbert Dr hail 'n' ride",
                        "McCarthy Rd at Anderson Street",
                        "Elliott Heads Rd near Rattray St hail 'n' ride",
                        "Kepnock Rd near Elliott Heads Rd hail 'n' ride",
                        "Poinciana Dr near Orlabah Ave",
                        "Woongarra Scenic Dr near Shoreline Cr HnR",
                        "Wearing Rd at Palm Lake Village",
                        "Wilfred St near Aqualine Ct hail 'n' ride",
                        "Woongarra Scenic Dr at Bargara Lakes Drive",
                        "Miller St at The Causeway",
                        "Esplanade near Miller St hail 'n' ride",
                        "Holland St at Clarke Street",
                        "Garretts Way at Nielson Park",
                        "Ocean Esp near Clarke St hail 'n' ride",
                        "Holland St near Whalley St hail 'n' ride",
                        "Bauer St near Tanner Street"
                    ],
                    "653: Shalom, Bundaberg SHS, St Josephs, Bargara": [
                        "Shalom College",
                        "Maynard St at Martens Oval",
                        "Maryborough St at Nott Street",
                        "Maryborough St at Walker Street",
                        "Maryborough St near Ruddell St hail 'n' ride",
                        "Woongarra St at Library",
                        "Woongarra St at Holy Rosary Church",
                        "Woongarra St near Walla St hail 'n' ride",
                        "Bourbong St E near Kendall St hail 'n' ride",
                        "Princess St at Cross Street",
                        "St Lukes Anglican School",
                        "Bargara Rd at Kalkie State School",
                        "Davidson St at Whalley St",
                        "Bauer St at Holland Street",
                        "Garretts Way at Nielson Park",
                        "Esplanade at Esplanade Bargara",
                        "Baxter St near Miller St hail 'n' ride",
                        "Plymouth St at Wilfred Street",
                        "Shoreline Cr near Bay Ct hail 'n' ride",
                        "Woongarra Scenic Dr near Carbeen St hail 'n' ride",
                        "Grevillea Ave near Cotton Tree Ct hail 'n' ride"
                    ],
                    "654: Bargara, Kepnock, Shalom College": [
                        "Woongarra Scenic Dr near Logan Rd hail 'n' ride",
                        "Poinciana Dr near Orlabah Ave hail 'n' ride",
                        "Orlabah Ave near Pacific Gardens Park",
                        "Moodies Rd near Woongarra Scenic Dr hail 'n' ride",
                        "Landsborough St near Explorers Way hail 'n' ride",
                        "Fierro Dr near Panoramic Way hail 'n' ride",
                        "Watsons Rd near Moodies Rd hail 'n' ride",
                        "Hughes Rd near Durdins Rd hail 'n' ride",
                        "Durdins Rd at Merchant Street",
                        "Woongarra Scenic Dr near Dooley St hail 'n' ride",
                        "Woongarra Scenic Dr at Kelly's Beach",
                        "Fairway Dr near Blain St hail 'n' ride",
                        "Fairway Dr near Sorrento Dr hail 'n' ride",
                        "Davidson St at Whalley St",
                        "Bargara Rd near Potters Rd hail 'n' ride",
                        "Carl Rehbein Ave near Bargara Rd hail 'n' ride",
                        "Windermere Rd near Burnett Heads Rd hail 'n' ride",
                        "Novakoski St near Fe Walker hail 'n' ride",
                        "Novakoski St near Kepnock Rd hail 'n' ride",
                        "Elliott Heads Rd at Taylor Street",
                        "St Marys Catholic School",
                        "McCarthy Rd near Newitt St hail 'n' ride",
                        "Fitzgerald St at Shalom College",
                        "Shalom College",
                        "Fitzgerald St near McDonald Ct hail 'n' ride",
                        "McCarthy Rd near Goodwood Rd hail 'n' ride",
                        "McCarthy Rd near Frank Gilbert Dr hail 'n' ride",
                        "Elliott Heads Rd near Rattray St hail 'n' ride",
                        "Kepnock Rd near Elliott Heads Rd hail 'n' ride",
                        "Kepnock State High School",
                        "Hummock Rd near Windermere Rd hail 'n' ride",
                        "Croft St at Bauer St",
                        "Durdins Rd at Trevors Road",
                        "Orlabah Ave near Balengera Ct hail 'n' ride",
                        "Poinciana Dr near Orlabah Ave",
                        "Carbeen St near Woongarra Scenic Dr hail 'n' ride",
                        "Woongarra Scenic Dr at Pandanus Crescent"
                    ],
                    "655: Kepnock SHS, Bargara, Bargara North": [
                        "Rifle Range Rd near Kathleen Dr hail 'n' ride",
                        "Moodies Rd near Woongarra Scenic Dr hail 'n' ride",
                        "Firefly St near Panoramic Way hail 'n' ride",
                        "Fierro Dr near Panoramic Way hail 'n' ride",
                        "Watsons Rd near Moodies Rd hail 'n' ride",
                        "Hughes Rd near Durdins Rd hail 'n' ride",
                        "Durdins Rd at Merchant Street",
                        "Durdins Rd at Trevors Road",
                        "Woongarra Scenic Dr near Dooley St hail 'n' ride",
                        "Woongarra Scenic Dr at Kelly's Beach",
                        "Miller St at The Causeway",
                        "Baxter St near Miller St hail 'n' ride",
                        "Esplanade near Bauer St hail 'n' ride",
                        "Holland St at Clarke Street",
                        "Holland St near McCavanagh St hail 'n' ride",
                        "Garretts Way at Nielson Park",
                        "Ocean Esp near Clarke St hail 'n' ride",
                        "Holland St near Whalley St hail 'n' ride",
                        "Bauer St near Tanner Street",
                        "Davidson St at Whalley St",
                        "Bargara State School",
                        "Bargara Rd near Rehbein Ave hail 'n' ride",
                        "Novakoski St near Fe Walker hail 'n' ride",
                        "Novakoski St near Kepnock Rd hail 'n' ride",
                        "Kepnock State High School",
                        "Bargara Rd near Hughes Rd hail 'n' ride",
                        "Hughes Rd near Blain St hail 'n' ride",
                        "Fairway Dr near Blain St hail 'n' ride",
                        "Fairway Dr near Sorrento Dr hail 'n' ride",
                        "Bargara Rd near Davidson St hail 'n' ride",
                        "Bauer St near Grimwood St hail 'n' ride"
                    ],
                    "656: Kepnock SHS, Bargara South": [
                        "383 Windermere Rd hail 'n' ride",
                        "Woongarra Scenic Dr at Pandanus Crescent",
                        "Poinciana Dr near Orlabah Ave hail 'n' ride",
                        "Woongarra Scenic Dr near Shoreline Cr HnR",
                        "Shoreline Cr at Bay Court",
                        "Shoreline Cr near Plymouth St hail 'n' ride",
                        "Plymouth St at Wilfred Street",
                        "Woongarra Scenic Dr at Bargara Lakes Drive",
                        "Woongarra Scenic Dr at Carlyle Gardens",
                        "Watsons Rd near Woongarra Scenic Dr hail 'n' ride",
                        "Watsons Rd near Moodies Rd hail 'n' ride",
                        "Hughes Rd near Durdins Rd hail 'n' ride",
                        "Bargara Rd near Potters Rd hail 'n' ride",
                        "Bargara State School",
                        "Kepnock State High School",
                        "Rifle Range Rd near Kathleen Dr hail 'n' ride",
                        "Durdins Rd at Judith Street",
                        "Seaview Rd at Watsons Rd hail 'n' ride"
                    ],
                    "658: Burnett Heads, Kepnock SHS": [
                        "Bargara State School",
                        "Grange Rd near Portmans Rd hail 'n' ride",
                        "Port Rd near Burnett Heads Rd hail 'n' ride",
                        "Port Rd near Hoffmans Rd hail 'n' ride",
                        "Rowlands Rd near Powers Street",
                        "Zunker St at Somerville Street",
                        "Burnett Heads Rd at Burnett Heads State School",
                        "Campbell St at Moore Street",
                        "Shell St near Sea Park Rd hail 'n' ride",
                        "Sea Park Rd at Kinch Street",
                        "Bargara Rd at Kalkie State School",
                        "Bargara Rd at Meilene Street",
                        "Fe Walker St near Link Rd hail 'n' ride",
                        "Novakoski St near Fe Walker hail 'n' ride",
                        "Kepnock State High School",
                        "Burnett Heads Rd near Port Rd hail 'n' ride",
                        "Sea Park Rd near Mittelheusers Rd hail 'n' ride",
                        "Zunker St near Paul Mittelheuser St hail 'n' ride",
                        "Rowlands St near Powers St hail 'n' ride"
                    ],
                    "661: Gin Gin, North SHS, Bundaberg SHS, Shalom": [
                        "Walker St near Mulgrave St hail 'n' ride",
                        "Mulgrave St near Walker St hail 'n' ride",
                        "Bundaberg Gin Gin Rd near Bucca Rd hail 'n' ride",
                        "South Kolan State School",
                        "Mt Perry Rd near Moore Park Rd hail 'n' ride",
                        "Walters St near Mt Perry Rd hail 'n' ride",
                        "Lakeview Dr near Whittington St hail 'n' ride",
                        "Marks Rd near McKenzie St hail 'n' ride",
                        "Barber St at Bundaberg North High School",
                        "King St near Loeskow St hail 'n' ride",
                        "Jefferis St near Bonney St hail 'n' ride",
                        "Whittingtons Rd near Fairymead Rd hail 'n' ride",
                        "Queen St at Thygesen Street",
                        "Maryborough St at Ruddell Street",
                        "Faldt St at Bundaberg TAFE",
                        "Faldt St at Mimnagh Street",
                        "Branyan St near Theodore St hail 'n' ride",
                        "Shalom College",
                        "Branyan St at Theodore Street",
                        "Faldt St near Brand St hail 'n' ride",
                        "Maryborough St near Ruddell St hail 'n' ride",
                        "Maryborough St at Bundaberg Central State School",
                        "Woondooma St near Barolin St hail 'n' ride",
                        "Woongarra St at Library",
                        "Jefferis St near Lucke Ct hail 'n' ride",
                        "Bonney St near Fairymead Rd hail 'n' ride",
                        "Hinkler Ave near Mt Perry Rd hail 'n' ride",
                        "North Bundaberg State High School",
                        "Bundaberg North State School",
                        "Whittington St at Lakeview Drive",
                        "Sharon State School hail 'n' ride",
                        "Gin Gin Rd near Hill End Rd hail 'n' ride"
                    ],
                    "662: Sandy Hook, Branyan, Bundaberg SHS, Shalom": [
                        "Daveys Dr near near Slalom Cr hail 'n' ride",
                        "Branyan State School",
                        "Twyford St at Avoca State School hail 'n' ride",
                        "Johnston St near Heidke Rd hail 'n' ride",
                        "Warrell St at Johnston St",
                        "Walker St near Adams St hail 'n' ride",
                        "Powers St near Crofton St hail 'n' ride",
                        "George St at St Patricks State School HnR",
                        "Maryborough St at Walker Street",
                        "Maryborough St at Bundaberg State High School",
                        "Branyan St at Joyce Street",
                        "Branyan St near Montgomery St hail 'n' ride",
                        "Shalom College",
                        "Branyan St at Theodore Street",
                        "Faldt St near Brand St hail 'n' ride",
                        "Faldt St at Bundaberg TAFE",
                        "Burrum St near Boreham Street",
                        "George St at West State School hail 'n' ride",
                        "Takalvan St near Grimwood St hail 'n' ride",
                        "Takalvan St near Salter Oval hail 'n' ride",
                        "Johnston St at Warrell St"
                    ],
                    "663: St Lukes Anglican, City, Avoca, Kensington": [
                        "Price St near Erindale Ave hail 'n' ride",
                        "33 Black Beauty Ct hail 'n' ride",
                        "Black Beauty Ct near Hero Pl hail 'n' ride",
                        "Crow St near Low St hail 'n' ride",
                        "Cummins Rd near Childers Rd hail 'n' ride",
                        "Samuels Rd near Hutchins St hail 'n' ride",
                        "Cummins Rd near Glenview Cr hail 'n' ride",
                        "Branyan State School",
                        "Avoca St at McCormack Street",
                        "Walker St near Adams St hail 'n' ride",
                        "Powers St near Crofton St hail 'n' ride",
                        "Woondooma St near Powers St hail 'n' ride",
                        "Branyan St at Crofton Street",
                        "Walker St near Branyan St hail 'n' ride",
                        "Maryborough St near Ruddell St hail 'n' ride",
                        "Bundaberg Plaza",
                        "Woondooma St near Barolin St hail 'n' ride",
                        "Walla St near Woondooma St hail 'n' ride",
                        "Walla St at St Johns School hail 'n' ride",
                        "St Johns Lutheran Primary School hail 'n' ride",
                        "Princess St at Cross Street",
                        "St Lukes Anglican School",
                        "Bundaberg East State School",
                        "Telegraph Rd near Leivesley St hail 'n' ride",
                        "Woongarra St near Walla St hail 'n' ride",
                        "Woongarra St at Holy Rosary Church",
                        "Griffith St near Ruddell St hail 'n' ride",
                        "Burrum St near Woondooma St hail 'n' ride",
                        "George St near Mulgrave St hail 'n' ride",
                        "George St at West State School hail 'n' ride",
                        "Takalvan St near Grimwood St hail 'n' ride",
                        "White St near Avoca St hail 'n' ride",
                        "Avoca St near Scott St hail 'n' ride",
                        "Twyford St at Avoca State School hail 'n' ride",
                        "Twyford St near Argyle Gardens",
                        "Cummins Rd near Branyan Dr hail 'n' ride",
                        "Bundaberg Ring Rd near Childers Rd hail 'n' ride"
                    ],
                    "664: Avoca, West SS, Bundaberg SHS": [
                        "Twyford St at Avoca State School hail 'n' ride",
                        "Smiths Rd at Mayfair Place",
                        "Avoca Rd near Gate Way St hail 'n' ride",
                        "Avoca Rd at Smiths Road",
                        "Kendalls Rd near Glenview Cr hail 'n' ride",
                        "Maryborough St near Ruddell St hail 'n' ride",
                        "Maryborough St at Bundaberg State High School",
                        "George St at West State School hail 'n' ride",
                        "Takalvan St near Grimwood St hail 'n' ride",
                        "White St near Avoca St hail 'n' ride",
                        "Fitzgerald St at Shalom College"
                    ],
                    "667: Arcadia Park, Branyan, BSHS, Kepnock, BCC": [
                        "Bonna Rd near Childers Rd hail 'n' ride",
                        "Mark Rd near Bonna Rd hail 'n' ride",
                        "Evergreen Dr near Narooma Dr hail 'n' ride",
                        "Arcadia Dr near near Ferny Dale Cr hail 'n' ride",
                        "Branyan State School",
                        "Avoca Rd near Cordelia St hail 'n' ride",
                        "Avoca Rd near Gate Way St hail 'n' ride",
                        "Avoca St at McCormack Street",
                        "Maryborough St at Bundaberg State High School",
                        "McIlwraith St near Watson St hail 'n' ride",
                        "Totten St near Kepnock Rd hail 'n' ride",
                        "Kepnock State High School",
                        "Bundaberg Christian School",
                        "Kepnock Rd near Novakoski St hail 'n' ride",
                        "Maryborough St at Ruddell Street",
                        "Avoca St near Scott St hail 'n' ride",
                        "Avoca Rd at Smiths Road"
                    ],
                    "670: Nolans Pocket": [
                        "555 Gin Gin Rd hail 'n' ride",
                        "1027 Gin Gin Rd hail 'n' ride",
                        "Fantail Cres hail 'n' ride",
                        "Gin Gin Rd near Woods Rd hail 'n' ride",
                        "Gin Gin Rd near Kurths Rd hail 'n' ride",
                        "Gin Gin Rd near Weir Rd hail 'n' ride",
                        "Platypus Dr near Koala Ct hail 'n' ride",
                        "Gin Gin Rd near Jensen St hail 'n' ride",
                        "1932 Gin Gin Rd hail 'n' ride",
                        "Gin Gin Rd near Bingera Siding Rd hail 'n' ride",
                        "53 Davis Rd hail 'n' ride",
                        "Davis Rd near Workmans Rd hail 'n' ride",
                        "Workmans Rd near Ghost Gum Rd hail 'n' ride",
                        "Ghost Gum Rd near Workmans Rd hail 'n' ride",
                        "Ghost Gum Rd near Sharondale Dr hail 'n' ride",
                        "Pleasant Dr near Grahams Rd hail 'n' ride",
                        "Pleasant Dr near Rustic Rd hail 'n' ride",
                        "Rustic Rd near Pleasant Dr hail 'n' ride",
                        "Grahams Rd near Willis St hail 'n' ride",
                        "Sharon Rd near Grahams Rd hail 'n' ride",
                        "Sharon Rd near Gin Gin Road hail 'n' ride",
                        "Sharon State School hail 'n' ride",
                        "Gin Gin Rd at Sharon Hall hail 'n' ride",
                        "Old Gin Gin Rd at Oakwood Caravan Park HnR",
                        "Oakwood State School",
                        "Gin Gin Rd near One Mile Rd hail 'n' ride",
                        "Bundaberg North State School",
                        "North Bundaberg State High School (Barber St)",
                        "North Bundaberg State High School",
                        "Mount Perry Rd at Botanic Gardens",
                        "Mt Perry Rd near Rae St hail 'n' ride",
                        "Ghost Gum Rd near Arel Ct hail 'n' ride",
                        "Davis Rd near Gin Gin Rd hail 'n' ride",
                        "Gin Gin Rd at Pindari Park hail 'n' ride",
                        "Gin Gin Rd near Hill End Rd hail 'n' ride"
                    ],
                    "671: South Kolan": [
                        "555 Gin Gin Rd hail 'n' ride",
                        "247 Birthamba Rd hail 'n' ride",
                        "411 Birthamba Rd hail 'n' ride",
                        "Bluegum Rd near Birthamba Rd hail 'n' ride",
                        "Bluegum Rd near Crosswells Rd hail 'n' ride",
                        "Billabong Way near Corella Ct hail 'n' ride",
                        "Billabong Way near Kestrel Rd hail 'n' ride",
                        "47 Billabong Way hail 'n' ride",
                        "66 Billabong Way hail 'n' ride",
                        "Billabong Way near Bluegum Rd hail 'n' ride",
                        "Birthamba Rd at Rural Fire Service hail 'n' ride",
                        "Birthamba Rd near Keoghs Rd hail 'n' ride",
                        "Birthamba Rd near Paynes Rd hail 'n' ride",
                        "Ruths Rd near Birthamba Rd hail 'n' ride",
                        "Ruths Rd near Koolboo Rd hail 'n' ride",
                        "Koolboo Rd near Gin Gin Rd hail 'n' ride",
                        "Gin Gin Rd near Morten Jensen Rd hail 'n' ride",
                        "Gin Gin Rd near Hill End Rd hail 'n' ride",
                        "Gin Gin Rd near Jensen St hail 'n' ride",
                        "1932 Gin Gin Rd hail 'n' ride",
                        "Gin Gin Rd near Bingera Siding Rd hail 'n' ride",
                        "Gin Gin Rd at Pindari Park hail 'n' ride",
                        "Gin Gin Rd near Henricksens Rd hail 'n' ride",
                        "Sharon State School hail 'n' ride",
                        "Gin Gin Rd at Sharon Hall hail 'n' ride",
                        "Old Gin Gin Rd at Oakwood Caravan Park HnR",
                        "Oakwood State School",
                        "Gin Gin Rd near One Mile Rd hail 'n' ride",
                        "Mt Perry Rd near Moore Park Rd hail 'n' ride",
                        "Mount Perry Rd at Wallace Drive",
                        "Mount Perry Rd near Young St hail 'n' ride",
                        "Bundaberg North State School",
                        "North Bundaberg State High School",
                        "Bundaberg Gin Gin Rd near Queen St hail 'n' ride",
                        "Queen St near Perry St hail 'n' ride",
                        "Maryborough St at Post Office hail 'n' ride",
                        "Woondooma St near Barolin St hail 'n' ride",
                        "Woongarra St at City Centre",
                        "Woongarra St near Walla St hail 'n' ride",
                        "Walla St near Woondooma St hail 'n' ride",
                        "Walla St at St Johns School hail 'n' ride",
                        "Elliott Heads Rd at Nixon Street",
                        "Kepnock Rd near Elliott Heads Rd hail 'n' ride",
                        "Kepnock State High School",
                        "Bundaberg Christian School",
                        "Wongarra State School",
                        "Fe Walker St near Bundaberg Ring Rd hail 'n' ride",
                        "Kepnock Rd near Novakoski St hail 'n' ride",
                        "St Johns School (Walla St)",
                        "Woongarra St at Library",
                        "Mount Perry Rd at Botanic Gardens",
                        "Raines Rd near Ten Mile Rd hail 'n' ride",
                        "Ten Mile Rd near James Rd hail 'n' ride",
                        "1018 Ten Mile Rd hail 'n' ride"
                    ],
                    "672: Sharon": [
                        "Bundaberg North State School",
                        "Mount Perry Rd at Botanic Gardens",
                        "Davis Rd near Gin Gin Rd hail 'n' ride",
                        "53 Davis Rd hail 'n' ride",
                        "Workmans Rd near Ghost Gum Rd hail 'n' ride",
                        "Ghost Gum Rd near Workmans Rd hail 'n' ride",
                        "Ghost Gum Rd near Sharondale Dr hail 'n' ride",
                        "Pleasant Dr near Grahams Rd hail 'n' ride",
                        "Pleasant Dr near Rustic Rd hail 'n' ride",
                        "Rustic Rd near Pleasant Dr hail 'n' ride",
                        "Grahams Rd near Willis St hail 'n' ride",
                        "Sharon Rd near Grahams Rd hail 'n' ride",
                        "Sharon Rd near Gin Gin Road hail 'n' ride",
                        "Sharon State School hail 'n' ride",
                        "Old Gin Gin Rd at Oakwood Caravan Park HnR",
                        "Oakwood State School",
                        "Gin Gin Rd near One Mile Rd hail 'n' ride",
                        "North Bundaberg State High School",
                        "Mt Perry Rd near Rae St hail 'n' ride",
                        "555 Gin Gin Rd hail 'n' ride",
                        "1027 Gin Gin Rd hail 'n' ride",
                        "Ghost Gum Rd near Arel Ct hail 'n' ride",
                        "Davis Rd near Workmans Rd hail 'n' ride",
                        "Gin Gin Rd near Henricksens Rd hail 'n' ride",
                        "Gin Gin Rd at Sharon Hall hail 'n' ride",
                        "Mt Perry Rd near Moore Park Rd hail 'n' ride",
                        "Mount Perry Rd at Wallace Drive"
                    ],
                    "673: Tantitha": [
                        "North Bundaberg State High School",
                        "Jefferis St near Bonney St hail 'n' ride",
                        "Jefferis St near Brighton Cl hail 'n' ride",
                        "Jefferis St near Lucke Ct hail 'n' ride",
                        "Jefferis St at Whittingtons Street",
                        "Foster Dr near Comino Ct hail 'n' ride",
                        "Foster Dr near Fairymead Rd hail 'n' ride",
                        "Tantitha Rd near Fairymead Rd hail 'n' ride",
                        "Tantitha Rd near Paddy Melon Pl hail 'n' ride",
                        "Melaleuca Rd near Lorikeet St hail 'n' ride",
                        "Melaleuca Rd near Cockatoo Cr hail 'n' ride",
                        "Cockatoo Cr near Melaleuca Rd hail 'n' ride",
                        "13 Cockatoo Cr hail 'n' ride",
                        "Cockatoo Cr near Echidna Ct hail 'n' ride",
                        "Currawong Rd near Melaleuca Rd hail 'n' ride",
                        "Currawong Rd near Turtle Dove Pl hail 'n' ride",
                        "Currawong Rd near Sugar Glider Ct hail 'n' ride",
                        "Currawong Rd near Billabong Dr hail 'n' ride",
                        "153 Tantitha Rd hail 'n' ride",
                        "201 Tantitha Rd hail 'n' ride",
                        "279 Tantitha Rd hail 'n' ride",
                        "Zorzan Dr near Tantitha Rd hail 'n' ride",
                        "21 Zorzan Dr hail 'n' ride",
                        "Belluna Cr near Treviso St hail 'n' ride",
                        "Goodburrum Rd near Tantitha Rd hail 'n' ride",
                        "Gooburrum Rd near Whites Rd hail 'n' ride",
                        "Gooburrum Primary School",
                        "Moore Park Rd near Sergiacomi St hail 'n' ride",
                        "Bundaberg North State School",
                        "Mount Perry Rd at Botanic Gardens",
                        "Mt Perry Rd near Rae St hail 'n' ride",
                        "Moore Park Rd near Mount Perry Rd hail 'n' ride",
                        "Moore Park Rd near Martins Rd hail 'n' ride"
                    ],
                    "674: Booyan": [
                        "Murdochs Rd at Moore Park Beach shops",
                        "Murdochs Rd near Ibis Way hail 'n' ride",
                        "Murdochs Rd near Forest Way hail 'n' ride",
                        "Murdochs Rd near Palmview Dr hail 'n' ride",
                        "Malvern Dr near Regency Rd hail 'n' ride",
                        "Malvern Dr near Monarch Ave hail 'n' ride",
                        "Malvern Dr near Empress Dr hail 'n' ride",
                        "Malvern Dr near Heron Cl hail 'n' ride",
                        "Malvern Dr near Sea Eagle Cl hail 'n' ride",
                        "Malvern Dr near Robin Cl hail 'n' ride",
                        "Malvern Dr near Whistler Cl hail 'n' ride",
                        "Isaac Moore Dr near Wagtail Cl hail 'n' ride",
                        "Isaac Moore Dr near Hannah Ct hail 'n' ride",
                        "Isaac Moore Dr near Tammy Rd hail 'n' ride",
                        "Isaac Moore Dr near Dorron Ct hail 'n' ride",
                        "Booyan Rd near Tammy Rd hail 'n' ride",
                        "Booyan Rd near Stewarts Rd hail 'n' ride",
                        "463 Booyan Rd hail 'n' ride",
                        "286 Booyan Rd hail 'n' ride",
                        "220 Booyan Rd hail 'n' ride",
                        "Moore Park Rd near Booyan Rd hail 'n' ride",
                        "Moore Park Rd near Gooburrum Rd hail 'n' ride",
                        "Moore Park Rd near Eardleys Rd hail 'n' ride",
                        "713 Moore Park Rd hail 'n' ride",
                        "Moore Park Rd near Pashleys Rd hail 'n' ride",
                        "909 Moore Park Rd hail 'n' ride",
                        "955 Moore Park Rd hail 'n' ride",
                        "1019 Moore Park Rd hail 'n' ride",
                        "1083 Moore Park Rd hail 'n' ride",
                        "Moore Park Rd near Hoods Rd hail 'n' ride",
                        "1227 Moore Park Rd hail 'n' ride",
                        "1267 Moore Park Rd hail 'n' ride",
                        "1285 Moore Park Rd hail 'n' ride",
                        "Moore Park Rd near Sergiacomi St hail 'n' ride",
                        "Moore Park Rd near Martins Rd hail 'n' ride",
                        "Mount Perry Rd near Young St hail 'n' ride",
                        "North Bundaberg State High School",
                        "Bundaberg North State School",
                        "Gooburrum Primary School (Moore Park Rd)",
                        "Opp 1285 Moore Park Rd hail 'n' ride",
                        "Opp 1267 Moore Park Rd hail 'n' ride",
                        "Opp 1227 Moore Park Rd hail 'n' ride",
                        "Opp 1083 Moore Park Rd hail 'n' ride",
                        "Opp 955 Moore Park Rd hail 'n' ride",
                        "Opp 909 Moore Park Rd hail 'n' ride",
                        "Moore Park Rd near Zahns Rd hail 'n' ride",
                        "Opp 713 Moore Park Rd hail 'n' ride"
                    ],
                    "675: Moore Park Beach, Gooburrum, and Tantitha": [
                        "Murdochs Rd at Moore Park Beach shops",
                        "Murdochs Rd near Ibis Way hail 'n' ride",
                        "Murdochs Rd near Forest Way hail 'n' ride",
                        "Murdochs Rd near Palmview Dr hail 'n' ride",
                        "Malvern Dr near Empress Dr hail 'n' ride",
                        "Kingfisher Cr near Sylvan Dr hail 'n' ride",
                        "26 Kingfisher Cr hail 'n' ride",
                        "6 Kingfisher Cr hail 'n' ride",
                        "Sylvan Dr near Kingfisher Cr hail 'n' ride",
                        "Sylvan Dr near Lillypilly Pl hail 'n' ride",
                        "Sylvan Dr near Plum Tree Cr hail 'n' ride",
                        "226 Sylvan Dr hail 'n' ride",
                        "Sylvan Dr at Plum Tree Cr",
                        "Sylvan Dr near Sandpiper Gr hail 'n' ride",
                        "Sylvan Dr at Ray Townson Park",
                        "Sylvan Dr near Kurrawa Ct hail 'n' ride",
                        "Palm View Dr near Sylvan Dr hail 'n' ride",
                        "Pacific Bvd near Tea Tree Ct hail 'n' ride",
                        "Park Dr at Moore Park Beach",
                        "Moore Park Rd near Lassig St hail 'n' ride",
                        "Moore Park Rd near Gengers Rd hail 'n' ride",
                        "Moore Park Rd near Fairydale Rd hail 'n' ride",
                        "391 Moore Park Rd hail 'n' ride",
                        "Moore Park Rd near Booyan Rd hail 'n' ride",
                        "Moore Park Rd near Gooburrum Rd hail 'n' ride",
                        "Moore Park Rd near Eardleys Rd hail 'n' ride",
                        "Moore Park Rd near Pashleys Rd hail 'n' ride",
                        "Moore Park Rd near Zahns Rd hail 'n' ride",
                        "Moore Park Rd near Hoods Rd hail 'n' ride",
                        "1285 Moore Park Rd hail 'n' ride",
                        "Gooburrum Primary School",
                        "Gooburrum Rd near Whites Rd hail 'n' ride",
                        "Goodburrum Rd near Tantitha Rd hail 'n' ride",
                        "Zorzan Dr near Tantitha Rd hail 'n' ride",
                        "21 Zorzan Dr hail 'n' ride",
                        "Belluna Cr near Treviso St hail 'n' ride",
                        "276 Tantitha Rd hail 'n' ride",
                        "Opp 201 Tantitha Rd hail 'n' ride",
                        "152 Tantitha Rd hail 'n' ride",
                        "Melaleuca Rd near Lorikeet St hail 'n' ride",
                        "Melaleuca Rd near Cockatoo Cr hail 'n' ride",
                        "13 Cockatoo Cr hail 'n' ride",
                        "Cockatoo Cr near Echidna Ct hail 'n' ride",
                        "Currawong Rd near Melaleuca Rd hail 'n' ride",
                        "Currawong Rd near Turtle Dove Pl hail 'n' ride",
                        "Currawong Rd near Sugar Glider Ct hail 'n' ride",
                        "Currawong Rd near Billabong Dr hail 'n' ride",
                        "Tantitha Rd near Paddy Melon Pl hail 'n' ride",
                        "Tantitha Rd near Fairymead Rd hail 'n' ride",
                        "Foster Dr near Comino Ct hail 'n' ride",
                        "Jefferis St near Lucke Ct hail 'n' ride",
                        "Jefferis St near Brighton Cl hail 'n' ride",
                        "Jefferis St near Peek St hail 'n' ride",
                        "Loeskow St near Jefferis St hail 'n' ride",
                        "Hinkler Ave near Sauer St hail 'n' ride",
                        "Hinkler Ave near Mt Perry Rd hail 'n' ride",
                        "Bundaberg North State School",
                        "North Bundaberg State High School",
                        "Branyan St at Crofton Street",
                        "George St at St Patricks State School HnR",
                        "George St at West State School hail 'n' ride",
                        "Walker St near Adams St hail 'n' ride",
                        "Branyan St at Joyce Street",
                        "Branyan St at Barnes Street",
                        "Branyan St near Montgomery St hail 'n' ride",
                        "Shalom College",
                        "Branyan St at Coomber St",
                        "George St near Mulgrave St hail 'n' ride",
                        "Barber St at Bundaberg North High School",
                        "King St near Loeskow St hail 'n' ride",
                        "Jefferis St near Bonney St hail 'n' ride",
                        "Jefferis St at Whittingtons Street",
                        "153 Tantitha Rd hail 'n' ride",
                        "201 Tantitha Rd hail 'n' ride",
                        "279 Tantitha Rd hail 'n' ride",
                        "Opp 1285 Moore Park Rd hail 'n' ride",
                        "Moore Park Rd near Norton Rd hail 'n' ride"
                    ],
                    "676: Moore Park Beach": [
                        "Murdochs Rd at Moore Park Beach shops",
                        "Murdochs Rd near Ibis Way hail 'n' ride",
                        "Malvern Dr near Regency Rd hail 'n' ride",
                        "Malvern Dr near Monarch Ave hail 'n' ride",
                        "Sylvan Dr near Kingfisher Cr hail 'n' ride",
                        "Sylvan Dr near Lillypilly Pl hail 'n' ride",
                        "Sylvan Dr near Plum Tree Cr hail 'n' ride",
                        "226 Sylvan Dr hail 'n' ride",
                        "Sylvan Dr at Plum Tree Cr",
                        "Sylvan Dr near Sandpiper Gr hail 'n' ride",
                        "Sylvan Dr at Ray Townson Park",
                        "Sylvan Dr near Kurrawa Ct hail 'n' ride",
                        "Palm View Dr near Sylvan Dr hail 'n' ride",
                        "Pacific Bvd near Tea Tree Ct hail 'n' ride",
                        "Park Dr at Moore Park Beach",
                        "Moore Park Rd near Lassig St hail 'n' ride",
                        "Moore Park Rd near Gengers Rd hail 'n' ride",
                        "Moore Park Rd near Fairydale Rd hail 'n' ride",
                        "391 Moore Park Rd hail 'n' ride",
                        "Moore Park Rd near Booyan Rd hail 'n' ride",
                        "Moore Park Rd near Gooburrum Rd hail 'n' ride",
                        "Bundaberg North State School",
                        "North Bundaberg State High School",
                        "Maryborough St near Ruddell St hail 'n' ride",
                        "St Marys Catholic School",
                        "Maryborough St at Bundaberg State High School",
                        "Bundaberg Plaza"
                    ],
                    "677: Riverview and Coral Cove": [
                        "Elliott Heads State School",
                        "Corolla St near Esplanade hail 'n' ride",
                        "Bathurst St at Wondrock Street",
                        "Bathurst St at Moore Street",
                        "Bathurst St near Benett St hail 'n' ride",
                        "Saunders St near Lihs St hail 'n' ride",
                        "Elliott Heads Rd near Riverview Rd hail 'n' ride",
                        "Wongarra State School",
                        "Elliott Heads Rd near Bells Rd hail 'n' ride",
                        "Elliott Heads Rd near Chards Rd hail 'n' ride",
                        "Row St near Elliott Heads Rd hail 'n' ride",
                        "Greathead Rd near Lomandra Dr hail 'n' ride",
                        "Kepnock Rd near Greathead Rd hail 'n' ride",
                        "Kepnock Rd near Novakoski St hail 'n' ride",
                        "Totten St near Kepnock Rd hail 'n' ride",
                        "Kepnock State High School",
                        "St Lukes Anglican School",
                        "St Johns Lutheran Primary School hail 'n' ride",
                        "Kepnock Rd near Elliott Heads Rd hail 'n' ride",
                        "Breusch Rd near Elliott Heads Rd hail 'n' ride"
                    ],
                    "678: Innes Park": [
                        "Bundaberg Christian School",
                        "Wongarra State School",
                        "Kleins Rd near Elliott Heads Rd hail 'n' ride",
                        "Elliott Heads Rd near Hummock Rd hail 'n' ride",
                        "Innes Park Rd near Spinnaker Bvd hail 'n' ride",
                        "Homestead Bvd near Barolin Esp hail 'n' ride",
                        "Back Hill Rd at Toppers Dr",
                        "Bisdee St at Tulipwood Place",
                        "Innes Park Rd near Iluka St hail 'n' ride",
                        "Lady Musgrave Dr near Fraser Ave hail 'n' ride",
                        "Fraser Ave near Lady Musgrave Dr hail 'n' ride",
                        "Innes Park Rd near Mary Fox St hail 'n' ride"
                    ],
                    "680: Dahls Road, Innes Park North": [
                        "Dahls Rd near Three Chain Rd hail 'n' ride",
                        "Wallace Rd near Wawoon Rd hail 'n' ride",
                        "Back Springfield Rd near Wallace Rd hail 'n' ride",
                        "225 Back Springfield Rd hail 'n' ride",
                        "Back Springfield Rd near Hummock Rd hail 'n' ride",
                        "Hummock Rd near Behnkes Rd hail 'n' ride",
                        "Elliott Heads Rd near Hummock Rd hail 'n' ride",
                        "Spinnaker Bvd near Compass Ave hail 'n' ride",
                        "Spinnaker Bvd near Mermaid Dr hail 'n' ride",
                        "Spinnaker Bvd near Whitesails Ct hail 'n' ride",
                        "Watchbell St near Nautilus Dr hail 'n' ride",
                        "Nautilus Dr near Clipper Ct hail 'n' ride",
                        "Back Windermere Rd near Tara St hail 'n' ride",
                        "Kathleen Dr near Woongarra Scenic Dr hail 'n' ride",
                        "Woongarra Scenic Dr near Carbeen St hail 'n' ride",
                        "Woongarra Scenic Dr at Pandanus Crescent",
                        "Palm St near Logan Rd hail 'n' ride",
                        "Cedar St near Woongarra Scenic Dr hail 'n' ride",
                        "Woongarra Scenic Dr near Cedar St hail 'n' ride",
                        "Grevillea Ave near Cotton Tree Ct hail 'n' ride",
                        "21 Grevillea Ave hail 'n' ride",
                        "Grevillea Ave near Carbeen St hail 'n' ride",
                        "Poinciana Dr near Orlabah Ave hail 'n' ride",
                        "61 Back Windermere Rd hail 'n' ride",
                        "Innes Park Rd near Spinnaker Bvd hail 'n' ride",
                        "Wongarra State School",
                        "Elliott Heads Rd near Bells Rd hail 'n' ride",
                        "Elliott Heads Rd near Chards Rd hail 'n' ride",
                        "Elliott Heads Rd near Faithful Cr hail 'n' ride",
                        "Baker St at Elliott Heads Rd",
                        "Baker St near Churchwood St hail 'n' ride",
                        "Baker St near Wyllie St hail 'n' ride",
                        "Totten St near Kepnock Rd hail 'n' ride",
                        "Rasmussen St near Novakoski St hail 'n' ride",
                        "Novakoski St near Kepnock Rd hail 'n' ride",
                        "Walker St at Targo Street",
                        "Maryborough St at Walker Street",
                        "Maryborough St at Bundaberg State High School",
                        "Shalom College",
                        "Maryborough St at Ruddell Street",
                        "Maynard St at Martens Oval",
                        "Maynard St near Fleming St hail 'n' ride",
                        "Fitzgerald St near Thabeban St hail 'n' ride",
                        "Thabeban St at Barolin Street",
                        "Thabeban St near Barolin St hail 'n' ride",
                        "McCarthy Rd near Goodwood Rd hail 'n' ride",
                        "McCarthy Rd at Walk Street",
                        "McCarthy Rd near Frank Gilbert Dr hail 'n' ride",
                        "St Marys Catholic School",
                        "McCarthy Rd at Marcellos Street",
                        "McCarthy Rd near Bergin St hail 'n' ride",
                        "McCarthy Rd at Anderson Street",
                        "Kepnock State High School",
                        "Baker St near Elliott Heads Rd hail 'n' ride",
                        "Elliott Heads Rd near Row St hail 'n' ride",
                        "Elliott Heads Rd near Robertson St hail 'n' ride"
                    ],
                    "681: Riverview and Coral Cove": [
                        "Riverview Rd near Three Chain Rd hail 'n' ride",
                        "Riverview Rd near Sheehans Rd hail 'n' ride",
                        "Riverview Rd near McIntosh Ave hail 'n' ride",
                        "Peagam St near Mitchell St hail 'n' ride",
                        "Mitchell St near Allana Ct hail 'n' ride",
                        "268 Riverview Rd hail 'n' ride",
                        "71 Harts Rd hail 'n' ride",
                        "Harts Rd near Elliott Heads Rd hail 'n' ride",
                        "Barolin Esp near Admiralty Pl hail 'n' ride",
                        "Homestead Bvd at Peggy Drive",
                        "Homestead Bvd near Barolin Esp hail 'n' ride",
                        "Barolin Esp at Coral Cove Drive",
                        "Coral Cove Dr at Bisdee Street",
                        "Innes Park Rd near Spinnaker Bvd hail 'n' ride",
                        "Wongarra State School",
                        "Sienna Bvd near Bundaberg Ring Rd hail 'n' ride",
                        "Sienna Bvd near Belle Eden Dr hail 'n' ride",
                        "Palermo Ave near Messina Way hail 'n' ride",
                        "Palermo Ave near Montepaone Ave hail 'n' ride",
                        "Gum Nut Dr near Beech Links Dr hail 'n' ride",
                        "Bundaberg Ring Rd near Sienna Bvd hail 'n' ride",
                        "Elliott Heads Rd near Bells Rd hail 'n' ride",
                        "St Marys Catholic School",
                        "George St at St Patricks State School HnR",
                        "Branyan St near Montgomery St hail 'n' ride",
                        "Shalom College",
                        "McCarthy Rd near Goodwood Rd hail 'n' ride",
                        "McCarthy Rd near Frank Gilbert Dr hail 'n' ride",
                        "McCarthy Rd at Anderson Street",
                        "McCarthy Rd at Cawte Street",
                        "Homestead Bvd at Back Hill Place",
                        "Riverview Rd at Farmways Caravan Park HnR"
                    ],
                    "682: Bargara, Innes Park North, and Coral Cove": [
                        "Innes Park Rd near Spinnaker Bvd hail 'n' ride",
                        "Barolin Esp near Admiralty Pl hail 'n' ride",
                        "Mokera St near Arunda St hail 'n' ride",
                        "Homestead Bvd at Peggy Drive",
                        "Back Hill Rd at Toppers Dr",
                        "Bisdee St at Tulipwood Place",
                        "Amaroo Cr near Iluka St hail 'n' ride",
                        "Badilla St near Vesta St hail 'n' ride",
                        "Innes Park Rd near Iluka St hail 'n' ride",
                        "Lady Musgrave Dr near Fraser Ave hail 'n' ride",
                        "Fraser Ave near Lady Musgrave Dr hail 'n' ride",
                        "Innes Park Rd near Mary Fox St hail 'n' ride",
                        "Back Windermere Rd near Tara St hail 'n' ride",
                        "Kathleen Dr near Woongarra Scenic Dr hail 'n' ride",
                        "Woongarra Scenic Dr near Carbeen St hail 'n' ride",
                        "Woongarra Scenic Dr at Pandanus Crescent",
                        "Palm St near Logan Rd hail 'n' ride",
                        "Cedar St near Woongarra Scenic Dr hail 'n' ride",
                        "Woongarra Scenic Dr near Cedar St hail 'n' ride",
                        "Grevillea Ave near Cotton Tree Ct hail 'n' ride",
                        "Grevillea Ave near Carbeen St hail 'n' ride",
                        "Poinciana Dr near Orlabah Ave hail 'n' ride",
                        "Hughes Rd near Vaschina Lane hail 'n' ride",
                        "Bargara Rd near Hughes Rd hail 'n' ride",
                        "Bargara State School",
                        "Bargara Rd at Kalkie State School",
                        "Bargara Rd near Coral Garden Drive",
                        "St Lukes Anglican School",
                        "Bargara Rd at Meilene Street",
                        "Bargara Rd nr Coral Garden Dr hail 'n' ride",
                        "Bargara Rd near Rehbein Ave hail 'n' ride",
                        "Bargara Rd near Potters Rd hail 'n' ride",
                        "Hughes Rd near Blain St hail 'n' ride",
                        "Hughes Rd near Durdins Rd hail 'n' ride",
                        "Rifle Range Rd near Kathleen Dr hail 'n' ride",
                        "21 Grevillea Ave hail 'n' ride",
                        "61 Back Windermere Rd hail 'n' ride",
                        "Innes Park Rd near Carla Rd hail 'n' ride",
                        "Esplanade at Esplanade Innes Park",
                        "Bisdee Rd near Tulipwood Pl hail 'n' ride",
                        "Back Hill Rd near Toppers Dr hail 'n' ride",
                        "Homestead Bvd near Peggy Dr hail 'n' ride",
                        "Barolin Esp at Mokera Street",
                        "Barolin Esp at Homestead Boulevard",
                        "Barolin Esp at Coral Cove Drive",
                        "Coral Cove Dr at Bisdee Street",
                        "Spinnaker Bvd near Compass Ave hail 'n' ride",
                        "Spinnaker Bvd near Mermaid Dr hail 'n' ride",
                        "Spinnaker Bvd near Whitesails Ct hail 'n' ride",
                        "Watchbell St near Nautilus Dr hail 'n' ride",
                        "Nautilus Dr near Clipper Ct hail 'n' ride",
                        "Wongarra State School"
                    ],
                    "758: 758 School": [
                        "Hervey Bay High School",
                        "Old Maryborough Rd at Hervey Bay High",
                        "Old Maryborough Rd Opp University",
                        "Torquay Road, Opp RSL",
                        "Torquay Road at Bryant Street",
                        "Torquay Road at Neils St",
                        "Boat Harbour Drive at McNally Street",
                        "Hillcrest Avenue at Kululu Crescent",
                        "Kululu Crescent at Junjaree Street",
                        "Oleander Rd near Denmans Camp Rd hail 'n' ride",
                        "Colyton St near Madeleine St hail 'n' ride",
                        "Urangan State High School",
                        "Bideford St near Exeter St hail 'n' ride",
                        "Tavistock St at Torquay State School",
                        "Torquay Tce at Torquay State School",
                        "Torquay Road at Gossner Street",
                        "East St near Queens Rd hail 'n' ride"
                    ],
                    "763: 763 School": [
                        "Ann St near Banks Ct hail 'n' ride",
                        "Elizabeth St near Shell St hail 'n' ride",
                        "Pulgul St near Dayman St hail 'n' ride",
                        "Edward St near Herbert St hail 'n' ride",
                        "Hansen St near Boat Harbour Rd hail 'n' ride",
                        "Boat Harbour Drive at Caringa Street",
                        "Aimee Drive at Seaspray Court",
                        "Twolyn St near Aimee Dr hail 'n' ride",
                        "Connock St near Bellero St hail 'n' ride",
                        "Robertson Street at Hammon Street",
                        "Urangan State High School",
                        "Honiton St near Colyton St hail 'n' ride",
                        "Southerden St near Honiton St hail 'n' ride",
                        "Boat Harbour Drive at Robert Street",
                        "Truro St near Alexander St hail 'n' ride",
                        "Pulgul Street at Boat Harbour Drive",
                        "Sandy Strait State School"
                    ],
                    "769: 769 School": [
                        "Boat Harbour Dr near Winbirra Way hail 'n' ride",
                        "Denmans Camp Rd near Boat Harbour Dr hail 'n' ride",
                        "Exeter St near Barry St hail 'n' ride",
                        "Exeter St near Robert St hail 'n' ride",
                        "Emerald Park Way near Zircon St hail 'n' ride",
                        "Moonstone Dr near Ringtail Way hail 'n' ride",
                        "Stringybark Dr near Trill Ct hail 'n' ride",
                        "Senorita Pde near Walkers Rd hail 'n' ride",
                        "Senor Ave near Walkers Rd hail 'n' ride",
                        "Ronaldo Way near Jordan Cl hail 'n' ride",
                        "Milo St near Dalbaya Ct hail 'n' ride",
                        "Rosewood Ave near Milo St hail 'n' ride",
                        "Honiton St near Colyton St hail 'n' ride",
                        "Boundary Rd near Washington Dr hail 'n' ride",
                        "Bideford St near Vicki Pde hail 'n' ride",
                        "Denmans Camp Rd near Colyton St hail 'n' ride",
                        "Poiciana Cres near Frangipanni Ave hail 'n' ride",
                        "Frangipanni Ave near Grevillea St hail 'n' ride",
                        "Honeysuckle Ave near Melaleuca Cres hail 'n' ride",
                        "MacKay Dr near Gallery Ct hail 'n' ride",
                        "McLiver St near Main St hail 'n' ride",
                        "Boat Harbour Dr near Central Ave hail 'n' ride",
                        "Beach Road at Boat Harbour Drive",
                        "Old Maryborough Rd near Newhaven St hail 'n' ride",
                        "Old Maryborough Road at Hastings Street",
                        "Old Maryborough Rd near Tooth St hail 'n' ride",
                        "Ibis Boulevard at Lake View Court",
                        "Bowerbird Ave near Ibis Bvd hail 'n' ride",
                        "Yongala Ave near Endeavour Way hail 'n' ride",
                        "Ibis Bvd near Wattlebird Lane hail 'n' ride",
                        "Ibis Boulevard at Wattlebird Lane",
                        "Xavier Catholic College",
                        "Yarrilee State School",
                        "St James Lutheran College"
                    ],
                    "770: 770 School": [
                        "Torquay Road, Opp RSL",
                        "Torquay Road at Bryant Street",
                        "Torquay Road at Neils St",
                        "Torquay Road at Zephyr Street",
                        "Torquay Road at Queens Road",
                        "Torquay Road at Gossner St",
                        "Torquay Terrace at Tavistock Street",
                        "Truro Street at Robert Street",
                        "Truro Street at Ann Street",
                        "Ann St near Banks Ct hail 'n' ride",
                        "Elizabeth St near King St hail 'n' ride",
                        "Urungan Point Primary School",
                        "Pulgul Street at Boat Harbour Drive",
                        "Ladbroke Cres near Pulgul St hail 'n' ride",
                        "Ladbroke Cres near Lucyanne Ct hail 'n' ride",
                        "Vanda St near Elizabeth St hail 'n' ride",
                        "Park St near Verden Dr hail 'n' ride",
                        "Boat Harbour Drive at Robert Street",
                        "Boat Harbour Drive at Honiton Street",
                        "Boat Harbour Drive at Urangan Street",
                        "Boat Harbour Dr near Bideford St hail 'n' ride",
                        "Boat Harbour Drive at Dartmouth Street",
                        "Denmans Camp Rd near Boat Harbour Dr hail 'n' ride",
                        "Queens Rd near Boat Harbour Dr hail 'n' ride",
                        "Boat Harbour Dr near McNally St hail 'n' ride",
                        "Boat Harbour Dr near Central Ave hail 'n' ride",
                        "Boat Harbour Dr at Fraser Shores Shops",
                        "Boat Harbour Dr near Nissen St hail 'n' ride",
                        "MBH-HB Rd opp Eli Waters Shopping Centre",
                        "Xavier Catholic College",
                        "Yarrilee State School"
                    ],
                    "772: 772 School": [
                        "Lower Mountain Rd at Dundowran Hall",
                        "Carls Rd near Plantation St hail 'n' ride",
                        "Karraschs Rd near Hummock View Dr hail 'n' ride",
                        "Sawmill Rd at Annette Street",
                        "Jimille St near Carolyn St hail 'n' ride",
                        "Palm Way near Jimilee St hail 'n' ride",
                        "Sawmill Rd near Sempfs Rd hail 'n' ride",
                        "Ocean Park Dr near Homebush Rd hail 'n' ride",
                        "Sawmill Rd near Ocean Park Dr hail 'n' ride",
                        "Sempfs Rd at Palm Way",
                        "Watervale Rd near Sempfs Rd hail 'n' ride",
                        "Panorama Dr near Hennessy Dr hail 'n' ride",
                        "Ansons Rd near Hennessy Dr hail 'n' ride",
                        "Xavier Catholic College",
                        "Blaxland Rd near Wentworth Ave hail 'n' ride",
                        "Urraween Rd near Cooks Rd hail 'n' ride",
                        "St James Lutheran College",
                        "Bayside Christian College",
                        "Urraween Rd at Madsens Road",
                        "Hospitals, Nissan Street",
                        "Nissen Street at Caddy Avenue",
                        "Nissen Street at Boat Harbour Drive",
                        "Nissen St near Old Maryborough hail 'n' ride",
                        "Newhaven St near Old Maryborough Rd hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School"
                    ],
                    "773: 773 School": [
                        "Lower Mountain Rd at Dundowran Hall",
                        "Carls Rd near Plantation St hail 'n' ride",
                        "Crawford Dr near Pedelty Lane",
                        "Crawford Dr near Pedelty Lane hail 'n' ride",
                        "Karraschs Rd near Pialba Burrum Heads Rd HnR",
                        "Karraschs Rd at Broadway Drive",
                        "Craignish Rd near McCarthy Rd hail 'n' ride",
                        "Petersen Rd near Straits Outlook hail 'n' ride",
                        "Castles Rd near Pialba Burrum Heads Rd HnR",
                        "Castles Rd near Dublin Rd hail 'n' ride",
                        "Craignish Rd near Homes Rd hail 'n' ride",
                        "Green Acres Rd near Purser Rd hail 'n' ride",
                        "Lower Mountain Rd near Dundowran Rd hail 'n' ride",
                        "Citrus Dr near Lower Mountain Rd hail 'n' ride",
                        "Urraween Rd near Cooks Rd hail 'n' ride",
                        "St James Lutheran College",
                        "Bayside Christian College",
                        "Hervey Bay TAFE",
                        "McLiver St near Main St hail 'n' ride",
                        "Kawungan State School",
                        "Honeysuckle Ave at Kawungan School",
                        "Denmans Camp Rd near Boat Harbour Dr hail 'n' ride",
                        "Boat Harbour Drive at Macbel Court",
                        "Tavistock St at Torquay Pre School",
                        "Tavistock St at Torquay State School",
                        "Torquay Terrace at Tavistock Street",
                        "Boat Harbour Drive at Urangan Street",
                        "Boat Harbour Drive at Honiton Street",
                        "Urangan State High School",
                        "Sandy Strait State School",
                        "Star of the Sea Catholic Primary School HnR"
                    ],
                    "774: 774 School": [
                        "Pialba Burrum Heads Rd near Valfern Ct HnR",
                        "Petersen Rd near Pialba Burrum Heads Rd HnR",
                        "Straits Outlook near Osprey Dr hail 'n' ride",
                        "Straits Outlook near Outlook Dr hail 'n' ride",
                        "Estate St near Petersen Rd hail 'n' ride",
                        "Cedar Rd at Pacific Promenade",
                        "Hamilton Dr near Loats Ct hail 'n' ride",
                        "Castles Rd near Hamilton Dr hail 'n' ride",
                        "Sawmill Rd at Annette Street",
                        "Sawmill Rd near Homebush Rd hail 'n' ride",
                        "Sempfs Rd at Palm Way",
                        "Ansons Rd near Sempfs Rd hail 'n' ride",
                        "Urraween Rd near Curtis Dr hail 'n' ride",
                        "St James Lutheran College",
                        "Bayside Christian College",
                        "Urraween Rd at Madsens Road",
                        "Hervey Bay TAFE",
                        "MacKay Dr near Gallery Ct hail 'n' ride",
                        "Davis Dr near Royal Dr hail 'n' ride",
                        "Kawungan State School",
                        "Honeysuckle Ave at Kawungan School",
                        "Denmans Camp Rd near Boat Harbour Dr hail 'n' ride",
                        "Boat Harbour Drive at Macbel Court",
                        "Tavistock St at Torquay Pre School",
                        "Tavistock St at Torquay State School",
                        "Torquay Terrace at Tavistock Street",
                        "Boat Harbour Drive at Urangan Street",
                        "Boat Harbour Drive at Honiton Street",
                        "Urangan State High School",
                        "Sandy Strait State School",
                        "Star of the Sea Catholic Primary School HnR"
                    ],
                    "775: 775 School": [
                        "Citrus Dr near Lower Mountain Rd hail 'n' ride",
                        "Drury Lane near Citrus Dr hail 'n' ride",
                        "Pialba Burrum Heads Rd near Valfern Ct HnR",
                        "Sempfs Rd near Ansons Rd hail 'n' ride",
                        "Sawmill Rd near Sempfs Rd hail 'n' ride",
                        "Homebush Rd near Flora Ct hail 'n' ride",
                        "Ocean Park Dr near Homebush Rd hail 'n' ride",
                        "Sawmill Rd near Ocean Park Dr hail 'n' ride",
                        "Sempfs Rd at Palm Way",
                        "Sempfs Rd at Panorama Drive",
                        "Panorama Dr near Akarra Lagoons hail 'n' ride",
                        "Panorama Dr near Hennessy Dr hail 'n' ride",
                        "Ansons Rd near Hennessy Dr hail 'n' ride",
                        "Yarrilee State School",
                        "Xavier Catholic College",
                        "MBH-HB Rd at Eli Waters Shopping Centre",
                        "Ibis Boulevard at Lake View Court",
                        "Bowerbird Ave near Ibis Bvd hail 'n' ride",
                        "Ibis Bvd near Endeavour Way hail 'n' ride",
                        "Yongala Ave near Endeavour Way hail 'n' ride",
                        "Ibis Bvd near Wattlebird Lane hail 'n' ride",
                        "Ibis Boulevard at Wattlebird Lane",
                        "Caddy Ave near Fairway Dr hail 'n' ride",
                        "Caddy Ave near Hook Way hail 'n' ride",
                        "Caddy Ave near Gumtree Dr hail 'n' ride",
                        "Nissen Street at Boat Harbour Drive",
                        "Boat Harbour Dr near Nissen St hail 'n' ride",
                        "Beach Road at Boat Harbour Drive",
                        "Newhaven St near Old Maryborough Rd hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School"
                    ],
                    "776: 776 School": [
                        "Lower Mountain Rd at Dundowran Hall",
                        "Carls Rd near Plantation St hail 'n' ride",
                        "Crawford Dr near Pedelty Lane",
                        "Karraschs Rd near Pialba Burrum Heads Rd HnR",
                        "Karraschs Rd at Broadway Drive",
                        "Craignish Rd near McCarthy Rd hail 'n' ride",
                        "Petersen Rd near Pialba Burrum Heads Rd HnR",
                        "Straits Outlook near Peterson Rd hail 'n' ride",
                        "Straits Outlook near Osprey Dr hail 'n' ride",
                        "Straits Outlook near Outlook Dr hail 'n' ride",
                        "Estate St near Petersen Rd hail 'n' ride",
                        "Castles Rd near Dublin Rd hail 'n' ride",
                        "Craignish Rd near Homes Rd hail 'n' ride",
                        "Green Acres Rd near Purser Rd hail 'n' ride",
                        "Lower Mountain Rd near Dundowran Rd hail 'n' ride",
                        "Lower Mountain Rd near Industrial Ave HnR",
                        "Citrus Dr near Lower Mountain Rd hail 'n' ride",
                        "Urraween Rd near Curtis Dr hail 'n' ride",
                        "Yarrilee State School",
                        "Xavier Catholic College",
                        "MBH-HB Rd at Eli Waters Shopping Centre",
                        "Old Maryborough Rd near Hastings St hail 'n' ride",
                        "Newhaven St near Old Maryborough Rd hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School"
                    ],
                    "777: 777 School": [
                        "Lower Mountain Rd at Dundowran Hall",
                        "Pialba Burrum Heads Rd near Crawford Dr HnR",
                        "Pialba Burrum Heads Rd near Karraschs Rd HnR",
                        "Petersen Rd near Pialba Burrum Heads Rd HnR",
                        "Cedar Rd at Pacific Promenade",
                        "Hamilton Dr near Loats Ct hail 'n' ride",
                        "Castles Rd near Hamilton Dr hail 'n' ride",
                        "Pialba Burrum Heads Rd at Mitchell Avenue",
                        "Yarrilee State School",
                        "Xavier Catholic College",
                        "Old Maryborough Rd near Hastings St hail 'n' ride",
                        "Newhaven St near Old Maryborough Rd hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School"
                    ],
                    "778: 778 School": [
                        "Lower Mountain Rd at Dundowran Hall",
                        "Carls Rd near Plantation St hail 'n' ride",
                        "Karraschs Rd near Hummock View Dr hail 'n' ride",
                        "Sawmill Rd at Annette Street",
                        "Jimille St near Carolyn St hail 'n' ride",
                        "Palm Way near Jimilee St hail 'n' ride",
                        "Sempfs Rd at Panorama Drive",
                        "Eagle Beach Pde near Hawke Cl hail 'n' ride",
                        "Eagle Beach Pde near Dundowran Beach Esp HnR",
                        "Sempfs Rd near Ansons Rd hail 'n' ride",
                        "Blue Lagoon Way near Cockatiel Ct hail 'n' ride",
                        "Ansons Rd near Hennessy Dr hail 'n' ride",
                        "Yarrilee State School",
                        "Xavier Catholic College",
                        "MBH-HB Rd at Eli Waters Shopping Centre",
                        "Old Maryborough Rd near Hastings St hail 'n' ride",
                        "Newhaven St near Old Maryborough Rd hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School"
                    ],
                    "779: 779 School": [
                        "Lower Mountain Rd at Dundowran Hall",
                        "Green Acres Rd near Dundoran Rd hail 'n' ride",
                        "Purser Rd near Green Acres Rd hail 'n' ride",
                        "Carls Rd near Plantation St hail 'n' ride",
                        "Crawford Dr near Pedelty Lane hail 'n' ride",
                        "Karraschs Rd at Broadway Drive",
                        "Karraschs Rd near Hummock View Dr hail 'n' ride",
                        "Pialba Burrum Heads Rd near Karraschs Rd HnR",
                        "Mal Campbell Dr near Rural View Ct hail 'n' ride",
                        "Hamilton Dr near Castles Rd hail 'n' ride",
                        "Cedar Rd at Pacific Promenade",
                        "Straits Outlook near Estate St hail 'n' ride",
                        "Straits Outlook near Outlook Dr hail 'n' ride",
                        "Osprey Dr near Straits Outlook hail 'n' ride",
                        "Sawmill Rd at Annette Street",
                        "Sawmill Rd near Henks Ct hail 'n' ride",
                        "Jimille St near Carolyn St hail 'n' ride",
                        "Palm Way near Jimilee St hail 'n' ride",
                        "Sawmill Rd near Sempfs Rd hail 'n' ride",
                        "Homebush Rd near Flora Ct hail 'n' ride",
                        "Ocean Park Dr near Homebush Rd hail 'n' ride",
                        "Sawmill Rd near Ocean Park Dr hail 'n' ride",
                        "Sempfs Rd at Palm Way",
                        "Sempfs Rd at Panorama Drive",
                        "Blue Lagoon Way near Cockatiel Ct hail 'n' ride",
                        "Ansons Rd near Hennessy Dr hail 'n' ride",
                        "Lower Mountain Rd near Dundowran Rd hail 'n' ride",
                        "Lower Mountain Rd near Industrial Ave HnR",
                        "Citrus Dr near Lower Mountain Rd hail 'n' ride",
                        "Urraween Rd near Curtis Dr hail 'n' ride",
                        "Urraween Rd near Cooks Rd hail 'n' ride",
                        "Urraween Rd at Madsens Road",
                        "Urraween Rd near Main St hail 'n' ride",
                        "Kawungan Way near Doolong Rd hail 'n' ride",
                        "Rassmussens Rd near Kawungun Dr hail 'n' ride",
                        "Teresa St near Ridge View Ct hail 'n' ride",
                        "Bayridge Heights Dr near Sandy View Dr HnR",
                        "Fraser Coast Anglican College",
                        "Halcyon Dr near Relaxed Pl hail 'n' ride",
                        "Halcyon Dr near Calm Ct hail 'n' ride",
                        "Denmans Camp Rd near Beth St hail 'n' ride",
                        "Boundary Rd near Washington Dr hail 'n' ride",
                        "Honiton St near Colyton St hail 'n' ride",
                        "Urangan State High School",
                        "Sandy Strait State School"
                    ],
                    "780: 780 School": [
                        "Pialba Burrum Heads Rd near Castle Rd HnR",
                        "Toogoom Rd near Old Toogoom Rd hail 'n' ride",
                        "School Bus Rd near Old Toogoom Rd hail 'n' ride",
                        "Beelbi Creek Rd near School Bus Rd hail 'n' ride",
                        "Pialba Burum Heads Rd near Beelbi Creek Rd HnR",
                        "Pialba Burrum Heads Rd near Toogoom Rd hail'n'ride",
                        "Oreagon Creek Rd near Toogoom Rd hail 'n' ride",
                        "Jeppesen Rd near O'Regan Creek Rd hail 'n' ride",
                        "Tree View Rd near Jeppeson Rd hail 'n' ride",
                        "Kingfisher Pde near Silverleaf Tce hail 'n' ride",
                        "Kingfisher Pde near Morris Rd hail 'n' ride",
                        "Northshore Ave near Helm St hail 'n' ride",
                        "Mark Ave near Lorikeet Ave hail 'n' ride",
                        "Toogoom Rd near Lorikeet Ave hail 'n' ride",
                        "Toogoom Rd near Pialba Burrum Heads Rd HnR",
                        "Torbanlea State Primary School"
                    ],
                    "781: 781 School": [
                        "Burrum Heads Rd near Pialba Burrum Heads Rd HnR",
                        "Burrum Heads Rd near Orchid Dr hail 'n' ride",
                        "Ivor Dr near Burrum Heads Rd hail 'n' ride",
                        "Ivor Dr near Louise Dr hail 'n' ride",
                        "Riverview Dr near Sunrise Cr hail 'n' ride",
                        "Riverview Dr near Ross St hail 'n' ride",
                        "Ross St near Howard St hail 'n' ride",
                        "Burrum St near Ross St hail 'n' ride",
                        "Burrum Street at Torbanlea Street",
                        "Howard St at Burrum Heads Hall",
                        "Sirenia Dr near Orchid Dr hail 'n' ride",
                        "Barramundi Dr near Majestic Ct hail 'n' ride",
                        "Beach Dr near Bentwood St hail 'n' ride",
                        "Orchid Dr near Lakeside Dr hail 'n' ride",
                        "Southfork Cct near Oakes Dr hail 'n' ride",
                        "Burrum Heads Rd near Drouin Cr hail 'n' ride",
                        "Burgowan Rd near Burrum Heads Rd hail 'n' ride",
                        "Government Rd near Knowland St hail 'n' ride",
                        "Olivers Rd near Knowland St hail 'n' ride",
                        "Blythe St near Wallsend St hail 'n' ride",
                        "Torbanlea State Primary School",
                        "Howard, Steley Street near William Street hail 'n' ride",
                        "William St near Burrum St hail 'n' ride",
                        "Howard State School, William St"
                    ],
                    "783: 783 School": [
                        "Pialba Burrum Heads Rd near Castle Rd HnR",
                        "ORegan Creek Rd near Ries Rd hail 'n' ride",
                        "O Regan Creek Rd near Carkeet Rd hail 'n' ride",
                        "O Regan Creek Rd near Yram Pl hail 'n' ride",
                        "Jeppesen Rd near O'Regan Creek Rd hail 'n' ride",
                        "Jeppeson Rd at Desmond Drive",
                        "Kingfisher Pde near Silverleaf Tce hail 'n' ride",
                        "Kingfisher Pde near Morris Rd hail 'n' ride",
                        "Mark Ave near Lorikeet Ave hail 'n' ride",
                        "Toogoom Rd near Lorikeet Ave hail 'n' ride",
                        "Pialba Burrum Heads Rd near Toogoom Rd HnR",
                        "Pialba Burrum Heads Rd near Gilles Rd HnR",
                        "Burrum Heads Rd near Pialba Burrum Heads Rd HnR",
                        "Blue Gum Dr near Dreamtime Ave hail 'n' ride",
                        "Burgowan Rd near Burrum Heads Rd hail 'n' ride",
                        "Melinda Rd near Joynsons Rd hail 'n' ride",
                        "Melinda Rd near Nicholas Rd hail 'n' ride",
                        "Joynsons Rd near Roberts Rd hail 'n' ride",
                        "Torbanlea State Primary School"
                    ],
                    "784: 784 School": [
                        "Toogoom Rd near Pialba Burrum Heads Rd HnR",
                        "Toogoom Rd near Old Toogoom Rd hail 'n' ride",
                        "Torbanlea Pialba Rd near Old Toogoom Rd HnR",
                        "Torbanlea Pialba Rd near Edbarjudcar Rd HnR",
                        "Torbanlea Pialba Rd near Toogoom Cane Rd HnR",
                        "Sanctuary Hills Rd near Mungomery Rd hail 'n' ride",
                        "Sanctuary Hills Rd near Torbanlea Pialba Rd HnR",
                        "Booral Rd near Maryborough Hervey Bay Rd HnR",
                        "Booral Rd near Moorabinda Dr hail 'n' ride",
                        "Booral Rd near Vanderwolf Rd hail 'n' ride",
                        "St James Lutheran College",
                        "Bayside Christian College",
                        "Hervey Bay TAFE",
                        "Main Street near Rose St",
                        "Old Maryborough Rd at Library/Uni",
                        "Charles St near Watson St hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School",
                        "Old Maryborough Rd near Newhaven St hail 'n' ride",
                        "Old Maryborough Road at Hastings Street",
                        "Old Maryborough Rd near Tooth St hail 'n' ride",
                        "MBH-HB Rd opp Eli Waters Shopping Centre",
                        "Yarrilee State School"
                    ],
                    "785: 785 School": [
                        "Burrum Heads Rd near Pialba Burrum Heads Rd HnR",
                        "Sirenia Dr near Orchid Dr hail 'n' ride",
                        "Barramundi Dr near Majestic Ct hail 'n' ride",
                        "Beach Dr near Bentwood St hail 'n' ride",
                        "Orchid Dr near Lakeside Dr hail 'n' ride",
                        "Burrum Heads Rd near Orchid Dr hail 'n' ride",
                        "Ivor Dr near Burrum Heads Rd hail 'n' ride",
                        "Ivor Dr near Louise Dr hail 'n' ride",
                        "Riverview Dr near Sunrise Cr hail 'n' ride",
                        "Riverview Dr near Ross St hail 'n' ride",
                        "Howard St near Burrum Heads Rd hail 'n' ride",
                        "Burrum Street at Torbanlea Street",
                        "Dudley St near Burrum St hail 'n' ride",
                        "Howard St at Burrum Heads Hall",
                        "Pialba Burrum Heads Rd near Burrum Heads Rd hail 'n' ride",
                        "Xavier Catholic College",
                        "Old Maryborough Rd near Hastings St hail 'n' ride",
                        "Newhaven St near Old Maryborough Rd hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School"
                    ],
                    "786: 786 School": [
                        "Belbi Creek Rd near Pialba Burrum Heads Rd HnR",
                        "Beelbi Creek Rd near Nobbs Rd hail 'n' ride",
                        "Beelbi Creek Rd near School Bus Rd hail 'n' ride",
                        "Toogoom Rd near Old Toogoom Rd hail 'n' ride",
                        "Toogoom Rd near Pialba Burrum Heads Rd HnR",
                        "Toogoom Rd at Delrose Court near Hall",
                        "Toogoom Rd near Lorikeet Ave hail 'n' ride",
                        "Mark Ave near Lorikeet Ave hail 'n' ride",
                        "Kingfisher Pde at Morris Rd hail 'n' ride",
                        "Kingfisher Pde near Sea Beach Way hail 'n' ride",
                        "Jeppeson Rd at Desmond Drive hail 'n' ride",
                        "O Regan Creek Rd near Yram Pl hail 'n' ride",
                        "O Regan Creek Rd near Carkeet Rd hail 'n' ride",
                        "Xavier Catholic College",
                        "MBH-HB Rd at Eli Waters Shopping Centre",
                        "Old Maryborough Rd near Hastings St hail 'n' ride",
                        "Newhaven St near Old Maryborough Rd hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School",
                        "Beach Road at Boat Harbour Drive",
                        "Boat Harbour Drive at Taylor Street",
                        "Boat Harbour Drive at McNally Street",
                        "Boat Harbour Drive at Queens Road",
                        "Boat Harbour Drive at Macbel Court",
                        "Boat Harbour Drive at Urangan Street",
                        "Boat Harbour Drive at Honiton Street",
                        "Urangan State High School",
                        "Sandy Strait State School",
                        "Star of the Sea Catholic Primary School HnR"
                    ],
                    "787: 787 School": [
                        "Burgowan Rd near Burrum Heads Rd hail 'n' ride",
                        "Howard, Steley Street near William Street hail 'n' ride",
                        "William St near Burrum St hail 'n' ride",
                        "Burrum River Rd near Bruce Hwy hail 'n' ride",
                        "Joynsons Rd near Roberts Rd hail 'n' ride",
                        "Melinda Rd near Joynsons Rd hail 'n' ride",
                        "Melinda Rd near Nicholas Rd hail 'n' ride",
                        "Government Rd near Knowland St hail 'n' ride",
                        "Olivers Rd near Knowland St hail 'n' ride",
                        "Blythe St near Wallsend St hail 'n' ride",
                        "Torbanlea, Robertson Street at Crawford Street",
                        "Union St near Robertson St hail 'n' ride",
                        "Gympie St near Hunter St hail 'n' ride",
                        "Torbanlea Pialba Rd near Simmons Rd hail 'n' ride",
                        "Hervey Bay Rd near Nikenbah Dundowran Rd HnR",
                        "Urraween Rd near Cooks Rd hail 'n' ride",
                        "St James Lutheran College",
                        "Bayside Christian College",
                        "Urraween Rd at Madsens Road",
                        "Hervey Bay TAFE",
                        "Main Street near Rose St",
                        "Old Maryborough Rd at Library/Uni",
                        "Charles St near Watson St hail 'n' ride",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School",
                        "Old Maryborough Rd near Newhaven St hail 'n' ride",
                        "Old Maryborough Road at Hastings Street",
                        "Old Maryborough Rd near Tooth St hail 'n' ride",
                        "Xavier Catholic College",
                        "Yarrilee State School"
                    ],
                    "788: 788 School": [
                        "Bruce Hwy at Service Centre hail 'n' ride",
                        "Herrenberg St near Colton Rd hail 'n' ride",
                        "Vaughan St near Lenthall St",
                        "Marshal Rd near Gold St hail 'n' ride",
                        "Aldershot, Vaughan Street near Smelter Street",
                        "Aldershot St near Lenthall St hail 'n' ride",
                        "Walker Street at Matthies Street",
                        "Searle St near Aldridge State High School hail 'n' ride",
                        "Bruce Hwy near Fluerty Rd hail 'n' ride",
                        "Colton Rd near Aldershot St hail 'n' ride",
                        "Jupiter St near Sunbury Preschool hail 'n' ride"
                    ],
                    "789: 789 School": [
                        "Burrum Heads Rd near Keith St hail 'n' ride",
                        "Southfork Cct near Oakes Dr hail 'n' ride",
                        "Blue Gum Dr near Dreamtime Ave hail 'n' ride",
                        "Pialba Burrum Heads Rd near Burrum Heads Rd hail 'n' ride",
                        "Pialba Burrum Heads Rd near Gilles Rd HnR",
                        "Pialba Burum Heads Rd near Beelbi Creek Rd HnR",
                        "Pialba Burrum Heads Rd near Toogoom Rd hail'n'ride",
                        "Oreagon Creek Rd near Toogoom Rd hail 'n' ride",
                        "O Regan Creek Rd near Yram Pl hail 'n' ride",
                        "O Regan Creek Rd near Carkeet Rd hail 'n' ride",
                        "ORegan Creek Rd near Ries Rd hail 'n' ride",
                        "Carkeet Rd near Porpita Cct hail 'n' ride",
                        "Xavier Catholic College",
                        "Caddy Ave near Fairway Dr hail 'n' ride",
                        "Caddy Ave near Hook Way hail 'n' ride",
                        "Caddy Ave near Gumtree Dr hail 'n' ride",
                        "Nissen Street at Chancellor Drive",
                        "Nissen St near Fraser Shores Village hail 'n' ride",
                        "Bayside Christian College",
                        "Urraween Rd at Madsens Road",
                        "Hervey Bay TAFE",
                        "Urraween Rd near Main St hail 'n' ride",
                        "Kawungan Way near Doolong Rd hail 'n' ride",
                        "Parakeet Cct near Corella St hail 'n' ride",
                        "Fraser Coast Anglican College",
                        "Squire St near Doolong Rd hail 'n' ride",
                        "Honeysuckle Ave at Kawungan School",
                        "Kawungan State School"
                    ],
                    "790: 790 School": [
                        "Teddington Rd near Five Mile Rd hail 'n' ride",
                        "Philip Dr hail 'n' ride",
                        "Five Mile Rd near Teddington Rd hail 'n' ride",
                        "Nerada Rd near Five Mile Rd E hail 'n' ride",
                        "Parke Primary School hail 'n' ride",
                        "Nerada Rd near Madison Way hail 'n' ride",
                        "Springvale Rd near Woongool Rd hail 'n' ride",
                        "Tinana State School",
                        "Gympie Rd at Oleander Drive",
                        "Gympie Rd near Walworth St hail 'n' ride",
                        "Gympie Rd near Eatonvale Rd hail 'n' ride",
                        "Gympie Rd at Cran Street",
                        "Ferry St near Queen St hail 'n' ride",
                        "Queen St near Lennox St hail 'n' ride",
                        "Lennox St near St Marys College hail 'n' ride",
                        "John St at St Marys Primary School",
                        "Maryborough Central School (John St)",
                        "Maryborough High School (Kent St)",
                        "Kent Street at Pallas Street",
                        "Kent Street at Amity Street",
                        "Kent St at Yaralla Street",
                        "Kent St at Neptune Street",
                        "Kent St at Christensen Crescent",
                        "Jupiter St at Clayton Street",
                        "Aldridge High School"
                    ],
                    "797: 797 School": [
                        "Bidwill Rd near Pallant Rd hail 'n' ride",
                        "Oxford St near Carnaby St hail 'n' ride",
                        "Oxford St near Carnby St hail 'n' ride",
                        "Cambridge St near Odessa St hail 'n' ride",
                        "Odessa Street at Miramont Street",
                        "Granville State School",
                        "Kent St at City Hall",
                        "Maryborough High School",
                        "Kent St at Christensen Crescent",
                        "Aldridge High School"
                    ],
                    "800: 800 School": [
                        "Doolong Rd near Bream St hail 'n' ride",
                        "Snapper St near Squire St hail 'n' ride",
                        "Gilston Rd near Goolong Rd hail 'n' ride",
                        "Pinehurst Dr near Gilston Rd hail 'n' ride",
                        "Carrick Way near Doolong Rd hail 'n' ride",
                        "Doolong Road at Bream Street",
                        "Ian Ave near Doolong Road hail 'n'ride",
                        "Ian Avenue at Victor Drive",
                        "Kavui St near Buvusi St hail 'n' ride",
                        "Main St near Johnston Bvd hail 'n' ride",
                        "Johnston Bvd near Julie Anne St hail 'n' ride",
                        "Maike Dr near Doss Ct hail 'n' ride",
                        "Hervey Bay TAFE",
                        "Hospitals, Nissan Street",
                        "Nissen Street at Caddy Avenue",
                        "Caddy Ave near Gumtree Dr hail 'n' ride",
                        "Bunker Ave near Fairway Dr hail 'n' ride",
                        "Xavier Catholic College",
                        "Yarrilee State School"
                    ],
                    "801: 801 School": [
                        "Toogoom Rd at Delrose Court near Hall",
                        "Toogoom Rd near Lorikeet Ave hail 'n' ride",
                        "Mark Ave near Lorikeet Ave hail 'n' ride",
                        "Helm St near Northshore Ave hail 'n' ride",
                        "Jeppeson Rd at Desmond Drive hail 'n' ride",
                        "O Regan Creek Rd near Yram Pl hail 'n' ride",
                        "Petersen Rd near Straits Outlook hail 'n' ride",
                        "Castles Rd near Pialba Burrum Heads Rd HnR",
                        "Xavier Catholic College",
                        "Yarrilee State School",
                        "Pantlins Lane near Urraween Rd hail 'n' ride",
                        "St James Lutheran College",
                        "Nissen St at Hospital",
                        "Hervey Bay TAFE",
                        "Old Maryborough Rd at Library/Uni",
                        "Beach Rd near Pialba School hail 'n' ride",
                        "Hervey Bay High School"
                    ],
                    "802: 802 School": [
                        "Central Ave at Stockland Hervey Bay",
                        "Boat Harbour Dr at Fraser Shores Shops",
                        "Boat Harbour Dr near Nissen St hail 'n' ride",
                        "Yarrilee State School",
                        "Xavier Catholic College",
                        "Ibis Boulevard at Lake View Court",
                        "Bowerbird Ave near Ibis Bvd hail 'n' ride",
                        "Yongala Ave near Endeavour Way hail 'n' ride",
                        "Ibis Bvd near Wattlebird Lane hail 'n' ride",
                        "Caddy Ave near Hook Way hail 'n' ride",
                        "Caddy Ave near Gumtree Dr hail 'n' ride",
                        "Nissen St near Fraser Shores Village hail 'n' ride",
                        "St James Lutheran College",
                        "Urraween Rd at Madsens Road",
                        "Urraween Rd near Main St hail 'n' ride",
                        "Squire St near Doolong Rd hail 'n' ride",
                        "Honeysuckle Ave at Kawungan School",
                        "Denmans Camp Rd near Boat Harbour Dr hail 'n' ride",
                        "Boat Harbour Drive at Macbel Court",
                        "Tavistock St at Torquay Pre School",
                        "Tavistock St at Torquay State School",
                        "Torquay Terrace at Tavistock Street",
                        "Boat Harbour Drive at Urangan Street",
                        "Boat Harbour Drive at Honiton Street",
                        "Urangan State High School",
                        "Sandy Strait State School",
                        "Star of the Sea Catholic Primary School HnR"
                    ],
                    "805: 805 School": [
                        "Tree View Rd near Jeppeson Rd hail 'n' ride",
                        "Kingfisher Pde near Sea Beach Way hail 'n' ride",
                        "Periwinkle Cres near Beacomber Way HnR",
                        "Xavier Catholic College",
                        "Urraween Rd near Cooks Rd hail 'n' ride",
                        "St James Lutheran College",
                        "Bayside Christian College",
                        "Hervey Bay TAFE",
                        "Old Maryborough Rd at Library/Uni",
                        "Hervey Bay High School"
                    ]
                }
            }
        }
    };

    // Select a set of route data according to the sample area from the project.
    let project = User.projectInfo();
    //console.log(`Filtering route data for ${project.sample_area_id}`);
    let defaultArea = 'seqts';
    let routeData = areaData[project.sample_area_id] || areaData[defaultArea];
    return routeData;
}]);

// This file was auto-generated. Do not hand edit.
